// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5JUbL":[function(require,module,exports) {
var _webCAutocomplete = require("./brick_impls/web_c_autocomplete");
var _webCdAutocomplete = require("./brick_impls/web_cd_autocomplete");
var _webCBrickLinker = require("./brick_impls/web_c_brick_linker");
var _webCButton = require("./brick_impls/web_c_button");
var _webCChart = require("./brick_impls/web_c_chart");
var _webCCheckbox = require("./brick_impls/web_c_checkbox");
var _webCDaterange = require("./brick_impls/web_c_daterange");
var _webCDatetime = require("./brick_impls/web_c_datetime");
var _webCEditorCode = require("./brick_impls/web_c_editor_code");
var _webCEditorCodeDiff = require("./brick_impls/web_c_editor_code_diff");
var _webCEditorRichtext = require("./brick_impls/web_c_editor_richtext");
var _webCExport = require("./brick_impls/web_c_export");
var _webCFiledownload = require("./brick_impls/web_c_filedownload");
var _webCFileupload = require("./brick_impls/web_c_fileupload");
var _webCFramedComposition = require("./brick_impls/web_c_framed_composition");
var _webCGauge = require("./brick_impls/web_c_gauge");
var _webCHtml = require("./brick_impls/web_c_html");
var _webCHyperlink = require("./brick_impls/web_c_hyperlink");
var _webCImage = require("./brick_impls/web_c_image");
var _webCInput = require("./brick_impls/web_c_input");
var _webCJitGenerator = require("./brick_impls/web_c_jit_generator");
var _webCMarkdown = require("./brick_impls/web_c_markdown");
var _webCMultiselect = require("./brick_impls/web_c_multiselect");
var _webCNotifier = require("./brick_impls/web_c_notifier");
var _webCPager = require("./brick_impls/web_c_pager");
var _webCRadio = require("./brick_impls/web_c_radio");
var _webCRangeslider = require("./brick_impls/web_c_rangeslider");
var _webCSelect = require("./brick_impls/web_c_select");
var _webCSwitch = require("./brick_impls/web_c_switch");
var _webCTemplateForm = require("./brick_impls/web_c_template_form");
var _webCTextarea = require("./brick_impls/web_c_textarea");
var _webCVisualDebugger = require("./brick_impls/web_c_visual_debugger");
var _webCcExpander = require("./brick_impls/web_cc_expander");
var _webCcFlexbox = require("./brick_impls/web_cc_flexbox");
var _webCcLayoutGrid = require("./brick_impls/web_cc_layout_grid");
var _webCcPopout = require("./brick_impls/web_cc_popout");
var _webCcPosition = require("./brick_impls/web_cc_position");
var _webCcResizablePanes = require("./brick_impls/web_cc_resizable_panes");
var _webCcSwitchpanel = require("./brick_impls/web_cc_switchpanel");
var _webCcTokenfield = require("./brick_impls/web_cc_tokenfield");
var _webCcUnit = require("./brick_impls/web_cc_unit");
var _webCcUse = require("./brick_impls/web_cc_use");
var _webCciModal = require("./brick_impls/web_cci_modal");
var _webCdLayoutGrid = require("./brick_impls/web_cd_layout_grid");
var _webCdDragndropContainer = require("./brick_impls/web_cd_dragndrop_container");
var _webCdFlexbox = require("./brick_impls/web_cd_flexbox");
var _webCdPivotTable = require("./brick_impls/web_cd_pivot_table");
var _webCdTable = require("./brick_impls/web_cd_table");
var _webCdTree = require("./brick_impls/web_cd_tree");
var _webCiData = require("./brick_impls/web_ci_data");
var _webCiDatatransform = require("./brick_impls/web_ci_datatransform");
var _webCiFetch = require("./brick_impls/web_ci_fetch");
var _webCiFunnel = require("./brick_impls/web_ci_funnel");
var _webCiGlobalEvent = require("./brick_impls/web_ci_global_event");
var _webCiPeriodic = require("./brick_impls/web_ci_periodic");
var _webCiRedirect = require("./brick_impls/web_ci_redirect");
var _webCiScriptJs = require("./brick_impls/web_ci_script_js");
var _webCiSnapshot = require("./brick_impls/web_ci_snapshot");
var _webScUse = require("./brick_impls/web_sc_use");
var _webCompositionReader = require("./web_composition_reader");
var _webCompositionLoader = require("./web_composition_loader");

},{"./brick_impls/web_c_autocomplete":"7r8VS","./brick_impls/web_cd_autocomplete":"hQLGA","./brick_impls/web_c_brick_linker":"cXW4f","./brick_impls/web_c_button":"8h4wx","./brick_impls/web_c_chart":"9Gr5M","./brick_impls/web_c_checkbox":"j5kEl","./brick_impls/web_c_daterange":"78LeB","./brick_impls/web_c_datetime":"rIvyj","./brick_impls/web_c_editor_code":"bbDMD","./brick_impls/web_c_editor_code_diff":"8Zujt","./brick_impls/web_c_editor_richtext":"aVPAC","./brick_impls/web_c_export":"amToG","./brick_impls/web_c_filedownload":"ilsqV","./brick_impls/web_c_fileupload":"aBJSe","./brick_impls/web_c_framed_composition":"kbXe0","./brick_impls/web_c_gauge":"cV8oI","./brick_impls/web_c_html":"6tI3Z","./brick_impls/web_c_hyperlink":"iKwdc","./brick_impls/web_c_image":"1PuGo","./brick_impls/web_c_input":"bDC5J","./brick_impls/web_c_jit_generator":"a5SwO","./brick_impls/web_c_markdown":"8p6oy","./brick_impls/web_c_multiselect":"fgu1o","./brick_impls/web_c_notifier":"5TUqm","./brick_impls/web_c_pager":"2D4vt","./brick_impls/web_c_radio":"4cEni","./brick_impls/web_c_rangeslider":"364SY","./brick_impls/web_c_select":"eiHGl","./brick_impls/web_c_switch":"5E9ry","./brick_impls/web_c_template_form":"a5XRF","./brick_impls/web_c_textarea":"5wENA","./brick_impls/web_c_visual_debugger":"C4QyY","./brick_impls/web_cc_expander":"61dfA","./brick_impls/web_cc_flexbox":"kDYD7","./brick_impls/web_cc_layout_grid":"aUP3l","./brick_impls/web_cc_popout":"lRt3A","./brick_impls/web_cc_position":"h0JNy","./brick_impls/web_cc_resizable_panes":"4KGZb","./brick_impls/web_cc_switchpanel":"2p53T","./brick_impls/web_cc_tokenfield":"2rkCL","./brick_impls/web_cc_unit":"8yVw4","./brick_impls/web_cc_use":"5Oc3T","./brick_impls/web_cci_modal":"1Y5rz","./brick_impls/web_cd_layout_grid":"6RDfR","./brick_impls/web_cd_dragndrop_container":"iSGY7","./brick_impls/web_cd_flexbox":"6MmWV","./brick_impls/web_cd_pivot_table":"lsvi1","./brick_impls/web_cd_table":"7dh2R","./brick_impls/web_cd_tree":"2aSoD","./brick_impls/web_ci_data":"2SrO9","./brick_impls/web_ci_datatransform":"7G3Z2","./brick_impls/web_ci_fetch":"72vRO","./brick_impls/web_ci_funnel":"aZEcl","./brick_impls/web_ci_global_event":"lffyJ","./brick_impls/web_ci_periodic":"4PVne","./brick_impls/web_ci_redirect":"g6h51","./brick_impls/web_ci_script_js":"7lIyg","./brick_impls/web_ci_snapshot":"8G8Gh","./brick_impls/web_sc_use":"eJkQR","./web_composition_reader":"jcIod","./web_composition_loader":"hLQKi"}],"7r8VS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_autocomplete_webcomponent", ()=>c_autocomplete_webcomponent);
parcelHelpers.export(exports, "web_c_autocomplete", ()=>web_c_autocomplete);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPopout = require("../controls/cb_popout");
var _cbWebUtil = require("../controls/cb_web_util");
class c_autocomplete_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var nsid = this.getAttribute("nsid");
            this.ci = new web_c_autocomplete(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-autocomplete", c_autocomplete_webcomponent);
class web_c_autocomplete extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var id, style, v, input_element, self, container, _$input, _$input1;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg;
                    if (!_this.initialised) {
                        id = _this.brick_id;
                        style = "";
                        if (cfg.style) {
                            for(var v in cfg.style)style += v + ":" + cfg.style[v] + ";";
                            style = ` style="${style}"`;
                        }
                        _this.element.innerHTML = `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("form-element-container c-autocomplete-container", cfg, "container")} id="${_this.brick_id}$container">
                    <label ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(`form-element-label c-autocomplete-label${cfg.label ? "" : " hidden"}`, cfg, "label")} for="${_this.brick_id}">${cfg.label || ""}</label>
                    <div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("form-element c-autocomplete-input no_click_close", cfg, "input")} id="${_this.brick_id}$select" contenteditable="true" placeholder="${cfg.placeholder}"></div>
                    <div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("c-autocomplete-x hidden", cfg, "x")} onclick="c_autocomplete_x('${_this.brick_id}')"></div>
                </div><div class="c-input-validation-message" id="${_this.brick_id}$validation" style="display:none"></div><div id="${_this.brick_id}_loader" class="loader"></div>`;
                        _this.popout = new (0, _cbPopout.cb_popout)(id, true, cfg, "autocomplete", true, true, function() {
                            if (self.search && self.search != self.last_emitted_search) {
                                self.last_emitted_search = self.search;
                                self.cb_emit({
                                    "@search": self.search
                                });
                            }
                        }, function() {});
                        _this.popout.setDropHtml("<span class='light-text'>Start typing...</span>");
                        _this.popout.init(true);
                        _this.popout.setLabel(cfg.label);
                        _this.initialised = true;
                        input_element = document.getElementById(`${_this.brick_id}$select`);
                        self = _this;
                        input_element.addEventListener("input", function() {
                            self.search = this.innerText;
                            var debounce_ms = self.cfg.debounce_ms;
                            if (debounce_ms !== 0 && !debounce_ms || isNaN(debounce_ms)) debounce_ms = 600;
                            self.show_x(self.search != "");
                            if (self.search != self.last_emitted_search) {
                                self.last_emitted_search = self.search;
                                self.search_id++;
                                var this_search_id = self.search_id;
                                setTimeout(function() {
                                    if (self.search_id == this_search_id) self.cb_emit({
                                        "@search": self.search
                                    });
                                }, debounce_ms);
                            }
                        });
                        input_element.addEventListener("keydown", function(e) {
                            var items_container = document.getElementById(self.brick_id + "$items");
                            if (e.keyCode == 40 || e.keyCode == 38) {
                                e.preventDefault();
                                if (e.keyCode == 40) {
                                    if (self.selected_idx >= self.num_items - 1) return;
                                    self.selected_idx++;
                                }
                                if (e.keyCode == 38) {
                                    if (self.selected_idx <= 0) return;
                                    self.selected_idx--;
                                }
                                if (items_container) {
                                    var sel = items_container.querySelector(".c-select-item-selected");
                                    if (sel) sel.classList.remove("c-select-item-selected");
                                    var items = items_container.querySelectorAll(".c-select-item");
                                    if (items) {
                                        var new_sel = items[self.selected_idx];
                                        if (new_sel) {
                                            new_sel.classList.add("c-select-item-selected");
                                            new_sel.scrollIntoView();
                                        }
                                    }
                                }
                            } else if (e.keyCode == 13) {
                                e.preventDefault();
                                if (self.popout && self.popout.isOpen()) {
                                    self.selectOption(self.options[self.selected_idx]);
                                    self.popout.closeSelect();
                                }
                            } else if (e.keyCode == 27) {
                                if (self.popout && self.popout.isOpen()) self.popout.closeSelect();
                            }
                        });
                        _this.value_path = cfg.value_path || "";
                        _this.label_path = cfg.label_path || "";
                        _this.group_path = cfg.group_path || "";
                        _this.match_condition = cfg.match_condition || "contains";
                        if (cfg.value === undefined || cfg.value === null) cfg.value = "";
                        if (_this.value === undefined || _this.value === null) _this.value = "";
                    } else {
                        container = document.getElementById(_this.brick_id + "$container");
                        if (container && container.children[0]) {
                            container.children[0].innerHTML = cfg.label || "";
                            if (cfg.label) container.children[0].classList.remove("hidden");
                            else container.children[0].classList.add("hidden");
                        }
                        if (container) {
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container.firstElementChild, cfg, "label");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container.children[1], cfg, "input");
                        }
                    }
                    _this.disabled = Boolean(cfg.disabled);
                    if (_this.popout) _this.popout.disabled = _this.disabled;
                    _$input = document.getElementById(_this.brick_id + "$select");
                    if (_$input) {
                        _$input.spellcheck = false;
                        _$input.setAttribute("contenteditable", "" + !_this.disabled);
                        if (_this.disabled) _$input.classList.add("c-autocomplete-disabled");
                    }
                    _this.value = cfg.value;
                    _this.setDisplayValue(cfg.value_label);
                    _this.search = cfg.value_label;
                    _this.snapshot.cfg.value = cfg.value;
                    _this.snapshot.cfg.value_label = cfg.value_label;
                    if (!cfg || !cfg.dont_send_initial) return [
                        2,
                        {
                            "@": {
                                value: _this.value,
                                label: cfg.value_label
                            }
                        }
                    ];
                } else if (input == "data") {
                    _this.options = cfg || [];
                    _this.refreshSearch(_this.search === null ? "" : _this.search);
                    if (cfg && _this.popout && !_this.popout.isOpen()) _this.popout.openPopout(_this.popout);
                } else if (input == "clear") {
                    if (cfg) _this.clear(false);
                } else if (input == "focus") {
                    if (cfg) {
                        _$input1 = document.getElementById(_this.brick_id + "$select");
                        if (_$input1) _$input1.focus();
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    setDisplayValue(label) {
        if (label === undefined || label === null) label = "";
        this.show_x(label != "");
        var input = document.getElementById(this.brick_id + "$select");
        if (input) input.innerHTML = label;
        this.clearValidation();
        this.refreshSearch(label);
    }
    clear() {
        var focus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        this.show_x(false);
        this.refreshSearch("");
        var input = document.getElementById(this.brick_id + "$select");
        if (input) {
            input.innerHTML = "";
            if (focus) input.focus();
        }
        this.value = "";
        delete this.snapshot.cfg.value;
        delete this.snapshot.cfg.value_label;
        this.clearValidation();
        this.cb_emit({
            "@": null,
            "@option_object": null,
            "@search": "",
            "@user_changed": null
        });
    }
    selectOption(option) {
        var value = option;
        var label = option;
        if (this.value_path) {
            value = (0, _cbutil.drill)(this.value_path, option);
            label = value;
        }
        if (this.label_path) label = (0, _cbutil.drill)(this.label_path, option);
        this.value = value;
        this.setDisplayValue(label);
        this.snapshot.cfg.value = value;
        this.snapshot.cfg.value_label = label;
        if (this.popout) this.popout.closeSelect();
        this.cb_emit({
            "@": {
                value,
                label
            },
            "@user_changed": {
                value,
                label
            },
            "@option_object": option
        });
    }
    refreshSearch(search) {
        if (!this.cfg) return;
        this.search = String(search || "");
        this.selected_idx = -1;
        this.num_items = 0;
        var list_html = `<div class="select-items" id="${this.brick_id}$items">`;
        var lowercase_search = this.search.toLowerCase();
        var i = 0;
        var group = "";
        var items = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var option = _step.value;
                var value = option;
                var label = option;
                if (this.value_path) {
                    value = (0, _cbutil.drill)(this.value_path, option);
                    label = value;
                }
                if (this.label_path) label = (0, _cbutil.drill)(this.label_path, option);
                var indexof = (label + "").toLowerCase().indexOf(lowercase_search);
                if (this.search === "" || this.match_condition == "contains" && indexof != -1 || this.match_condition == "startswith" && indexof == 0) {
                    if (this.group_path) {
                        var this_group = (0, _cbutil.drill)(this.group_path, option);
                        if (this_group != group) list_html += `<div class="c-autocomplete-group">${this_group}</div>`;
                        group = this_group;
                    }
                    if (this.selected_idx == -1) this.selected_idx = i;
                    list_html += `<div onclick="c_autocomplete_callback(event, '${this.brick_id}',${i})" class="c-select-item${i == this.selected_idx ? " c-select-item-selected" : ""}">${label}</div>`;
                    this.num_items++;
                }
                i++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (this.popout) this.popout.setDropHtml(list_html + "</div>");
    }
    show_x(show) {
        var container = document.getElementById(this.brick_id + "$container");
        if (container) {
            var x = container.querySelector(".c-autocomplete-x");
            if (x) {
                if (show) x.classList.remove("hidden");
                else x.classList.add("hidden");
            }
        }
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_snapshot() {
        return this.snapshot;
    }
    cb_status(status) {
        if (status == "") {
            var input = document.getElementById(`${this.brick_id}$select`);
            if (input) input.classList.remove("required");
            var items = document.getElementById(`${this.brick_id}$items`);
            if (items) items.classList.remove("loading");
        } else if (status == "loading") {
            var items1 = document.getElementById(`${this.brick_id}$items`);
            if (items1) {
                items1.innerHTML = "";
                items1.classList.add("loading");
            }
        }
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.cfg.validation) {
            var select = document.getElementById(`${this.brick_id}$select`);
            if (select) {
                var value = this.value;
                if (this.cfg.validation.required && (value === "" || value === null || value === undefined)) {
                    validates = false;
                    validation_message = (this.cfg.label || this.cfg.placeholder || "Value") + " is a required field";
                }
            }
        }
        if (validates) this.clearValidation();
        else {
            var validation_message_container = document.getElementById(`${this.brick_id}$validation`);
            var select1 = document.getElementById(`${this.brick_id}$select`);
            if (select1) select1.classList.add("c-input-validation-failed");
            if (validation_message_container) {
                validation_message_container.innerHTML = validation_message;
                validation_message_container.style.display = "block";
            }
        }
        return validates;
    }
    clearValidation() {
        var input_wrap = document.getElementById(`${this.brick_id}$wrap`);
        if (input_wrap) input_wrap.classList.remove("c-input-validation-failed");
        var validation_message_container = document.getElementById(`${this.brick_id}$validation`);
        if (validation_message_container) {
            validation_message_container.style.display = "none";
            validation_message_container.innerHTML = "";
        }
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.options = [];
        this.cfg = null;
        this.value_path = "";
        this.label_path = "";
        this.group_path = "";
        this.match_condition = "contains";
        this.search = null;
        this.disabled = false;
        this.popout = null;
        this.set_value = false;
        this.selected_idx = 0;
        this.num_items = 0;
        this.last_emitted_search = null;
        this.snapshot = {
            cfg: {}
        };
        this.search_id = 0;
        this.element = element;
        if (!window.c_autocomplete_callback) window.c_autocomplete_callback = function(event, ac_id, idx) {
            event.stopPropagation();
            var ac = window.codebricks_context.bricks[ac_id];
            var option = ac.options[idx];
            ac.selectOption(option);
            ac.popout.closeSelect();
        };
        if (!window.c_autocomplete_x) window.c_autocomplete_x = function(ac_id) {
            var ac = window.codebricks_context.bricks[ac_id];
            ac.clear();
        };
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_popout":"8UNLF","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"f9EWQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_async_to_generator", ()=>_async_to_generator);
parcelHelpers.export(exports, "_", ()=>_async_to_generator);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lGPoz":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"aYhQI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>(0, _tslib.__generator));
parcelHelpers.export(exports, "_ts_generator", ()=>(0, _tslib.__generator));
var _tslib = require("tslib");

},{"tslib":"5EfH5","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5EfH5":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"1DxvQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrefabNameJoin", ()=>PrefabNameJoin);
parcelHelpers.export(exports, "DC_JOIN", ()=>DC_JOIN);
parcelHelpers.export(exports, "drill", ()=>drill);
parcelHelpers.export(exports, "DrillGet", ()=>DrillGet);
parcelHelpers.export(exports, "DrillSet", ()=>DrillSet);
//handles square bracket paths
parcelHelpers.export(exports, "DrillSet2", ()=>DrillSet2);
parcelHelpers.export(exports, "DrillGet2", ()=>DrillGet2);
parcelHelpers.export(exports, "GetPathsData", ()=>GetPathsData);
parcelHelpers.export(exports, "MergePath_d", ()=>MergePath_d);
parcelHelpers.export(exports, "EscapeHtml", ()=>EscapeHtml);
parcelHelpers.export(exports, "ValueFromSchema", ()=>ValueFromSchema);
parcelHelpers.export(exports, "ValueToSchema", ()=>ValueToSchema);
parcelHelpers.export(exports, "OutputSchemaToNodes", ()=>OutputSchemaToNodes);
parcelHelpers.export(exports, "StripValuesFromSchema", ()=>StripValuesFromSchema);
parcelHelpers.export(exports, "ObjectDeepMerge", ()=>ObjectDeepMerge);
parcelHelpers.export(exports, "Clone", ()=>Clone);
parcelHelpers.export(exports, "CloneMerge", ()=>CloneMerge);
parcelHelpers.export(exports, "CloneLimit", ()=>CloneLimit);
parcelHelpers.export(exports, "RegisterSOCallback", ()=>RegisterSOCallback);
parcelHelpers.export(exports, "FindBrick", ()=>FindBrick);
parcelHelpers.export(exports, "FindBrickContainer", ()=>FindBrickContainer);
parcelHelpers.export(exports, "SplitGetLast", ()=>SplitGetLast);
parcelHelpers.export(exports, "array_move", ()=>array_move);
parcelHelpers.export(exports, "IterateCompositionBricks", ()=>IterateCompositionBricks);
parcelHelpers.export(exports, "EscapeRegExp", ()=>EscapeRegExp);
parcelHelpers.export(exports, "createBrickInfoTree", ()=>createBrickInfoTree);
parcelHelpers.export(exports, "RecuresePrependBrickInfoTree", ()=>RecuresePrependBrickInfoTree);
parcelHelpers.export(exports, "isVisible", ()=>isVisible);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var PrefabNameJoin = "\xbb";
var DC_JOIN = "#";
function drill(path, data) {
    var tparts = path.split(".");
    var v = data;
    var res = v;
    var done = false;
    for(var _i = 0, tparts_1 = tparts; _i < tparts_1.length; _i++){
        var p = tparts_1[_i];
        if (done) {
            res = undefined;
            break;
        }
        if (v && v[p] !== undefined) {
            if (typeof v[p] == "object" && v[p] !== null) v = v[p];
            else {
                res = v[p];
                done = true;
            }
        } else {
            res = undefined;
            done = true;
        }
    }
    if (!done) res = v;
    return res;
}
function DrillGet(tparts, data) {
    var v = data;
    var res = v;
    var done = false;
    for(var _i = 0, tparts_2 = tparts; _i < tparts_2.length; _i++){
        var p = tparts_2[_i];
        if (done) {
            res = undefined;
            break;
        }
        if (v && v[p] !== undefined) {
            if (typeof v[p] == "object" && v[p] !== null) v = v[p];
            else {
                res = v[p];
                done = true;
            }
        } else {
            res = undefined;
            done = true;
        }
    }
    if (!done) res = v;
    return res;
}
function DrillSet(dest_data, path, source_data) {
    var s = path.split(".");
    var d = dest_data || {};
    for(var p = 0; p < s.length; p++)if (p == s.length - 1) d[s[p]] = source_data;
    else {
        if (d[s[p]] === undefined) d[s[p]] = {};
        d = d[s[p]];
    }
    return dest_data;
}
function DrillSet2(dest_data, path, source_data) {
    // Create destination object if it doesn't exist
    var d = dest_data || {};
    // Parse the path string to handle both dot notation and bracket notation
    var segments = parsePath(path);
    // Store a reference to the original object
    var original = d;
    // Navigate through the path
    for(var i = 0; i < segments.length - 1; i++){
        var segment = segments[i];
        var nextSegment = segments[i + 1];
        var isNextSegmentArrayIndex = !isNaN(Number(nextSegment));
        // If current value is null or undefined, replace it with appropriate container
        if (d[segment] === undefined || d[segment] === null) d[segment] = isNextSegmentArrayIndex ? [] : {};
        // Move to the next level
        d = d[segment];
        // If the next container isn't an object or array, make it one
        if (typeof d !== "object" || d === null) d = isNextSegmentArrayIndex ? [] : {};
    }
    // Set the value at the final segment
    if (segments.length > 0) {
        var lastSegment = segments[segments.length - 1];
        d[lastSegment] = source_data;
    }
    return original;
}
function DrillGet2(source_data, path, defaultValue) {
    if (defaultValue === void 0) defaultValue = "";
    // If source data is null or undefined, return the default value
    if (source_data == null) return defaultValue;
    // Parse the path into segments
    var segments = parsePath(path);
    // Start with the source data
    var current = source_data;
    // Navigate through each segment
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        // Check if the current object has the property
        if (current == null || !Object.prototype.hasOwnProperty.call(current, segment)) return defaultValue;
        // Move to the next level
        current = current[segment];
    }
    // If we reach here, we've successfully navigated the entire path
    // Return the value or default if it's null/undefined
    return current === undefined || current === null ? defaultValue : current;
}
/**
 * Parse a path string into segments handling:
 * - Simple dot notation: a.b.c
 * - Bracket notation for properties with special characters: a["example.com"]
 * - Array indices: a[0].b
 */ function parsePath(path) {
    var segments = [];
    var currentSegment = "";
    var inBracket = false;
    var inQuotes = false;
    for(var i = 0; i < path.length; i++){
        var char = path[i];
        if (char === "." && !inBracket && !inQuotes) {
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = "";
            }
        } else if (char === "[" && !inBracket && !inQuotes) {
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = "";
            }
            inBracket = true;
        } else if (char === "]" && inBracket) {
            inBracket = false;
            inQuotes = false;
            if (currentSegment) {
                // If it's a number, convert it to a number
                var parsed = Number(currentSegment);
                segments.push(isNaN(parsed) ? currentSegment : String(parsed));
                currentSegment = "";
            }
        } else if ((char === '"' || char === "'") && inBracket) // Toggle quote state, but don't include quotes in the segment
        inQuotes = !inQuotes;
        else if (inBracket && !inQuotes && (char === " " || char === '"' || char === "'")) continue;
        else currentSegment += char;
    }
    // Add the last segment if there is one
    if (currentSegment) segments.push(currentSegment);
    return segments;
}
function GetPathsData(paths, data, target) {
    if (paths) for(var p in paths){
        if (paths[p] === 1) target[p] = data[p];
        else if (data[p] !== undefined && data[p] !== null) {
            target[p] = target[p] || {};
            GetPathsData(paths[p], data[p], target[p]);
        }
    }
}
function MergePath_d(tparts, from, into) {
    var from_at = from;
    var into_at = into.d;
    if (tparts.length == 1) {
        into.d = from;
        return;
    }
    for(var t = 1; t < tparts.length; t++){
        var tpart = tparts[t];
        if (from_at === undefined) return;
        if (t == tparts.length - 1) into_at[tpart] = from_at[tpart];
        else {
            into_at[tpart] = into_at[tpart] || {};
            into_at = into_at[tpart];
            if (!from_at) return; //error path not found
            from_at = from_at[tpart];
        }
    }
}
function EscapeHtml(text) {
    if (text && typeof text == "string") {
        var map = {
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#039;"
        };
        return text.replace(/[<>"']/g, function(m) {
            return map[m];
        });
    } else return text;
}
function ValueFromSchema(schema) {
    var ret = {};
    for(var key in schema){
        if (schema[key].value) ret[key] = schema[key].value;
        else if (schema[key].properties) ret[key] = ValueFromSchemaValue(schema[key]);
    }
    return ret;
}
function ValueToSchema(value) {
    var ret = {};
    if (value) for(var key in value)ret[key] = {
        value: value[key]
    };
    return ret;
}
function ValueFromSchemaValue(schemavalue) {
    if (schemavalue.value) return schemavalue.value;
    else if (schemavalue.properties && schemavalue.type == "object") {
        var ret = {};
        for(var p in schemavalue.properties)ret[p] = ValueFromSchemaValue(schemavalue.properties[p]);
        return ret;
    } else if (schemavalue.default !== undefined) return schemavalue.default;
    else return "";
}
function OutputSchemaToNodes(output_schema) {
    var ret = {};
    if (output_schema) {
        var type = output_schema.type;
        if (type == "object") {
            var properties = output_schema["properties"];
            for(var p in properties)ret[p] = properties[p].desc;
        }
    }
    return ret;
}
function StripValuesFromSchema(schema) {
    var ret = {};
    for(var key in schema){
        if (schema[key].value) delete schema[key].value;
        else if (schema[key].properties) for(var p in schema[key].properties)StripValuesFromSchema(schema[key].properties[p]);
    }
    return ret;
}
function ObjectDeepMerge(into, from) {
    //console.log(" enter "+JSON.stringify(into)+" <- "+ JSON.stringify(from));
    if (Array.isArray(from)) {
        //console.log(" array ");
        into = from;
        return into;
    }
    if (typeof from == "object" && from !== null && typeof into == "object" && into !== null) {
        for(var k2 in from)//console.log(" "+k2+" in "+JSON.stringify(from));
        if (from[k2] !== undefined) {
            if (typeof from[k2] == "object" && from[k2]) //console.log( "recurse "+k2+" "+JSON.stringify(into[k2])+"<-"+ JSON.stringify(from[k2]));
            into[k2] = ObjectDeepMerge(into[k2] || {}, from[k2]);
            else //console.log(" assign "+k2+" "+into[k2]+"="+from[k2]);
            into[k2] = from[k2];
        }
    } else //console.log(" direct "+into+"="+from);
    into = from;
    //console.log(" return "+JSON.stringify(into));
    return into;
}
function Clone(source) {
    if (typeof source != "object" || source === null) return source;
    if (source instanceof RegExp) {
        var copy = new RegExp(source.source, source.flags);
        copy.lastIndex = source.lastIndex;
        return source;
    }
    if (Array.isArray(source)) {
        if (source.length == 0) return source; //Some arrays look like the are len 0, but have values? If we don't do this they do not clone right.
        var clone_1 = [];
        for(var i = 0; i < source.length; i++)clone_1.push(Clone(source[i]));
        return clone_1;
    }
    var clone = {};
    for(var k in source)clone[k] = Clone(source[k]);
    return clone;
}
function CloneMerge(source, target) {
    var clone = Clone(target || {});
    ObjectDeepMerge(clone, source);
    return clone;
}
function CloneLimit(source, max_array, max_object) {
    var clone_2, i_1, clone, i, k;
    return Clone(source); //For now the limiting is too annoying in the debugger
}
function RegisterSOCallback(id, output, callback) {
    window.so_callbacks = window.so_callbacks || {};
    window.so_callbacks[id + "_brick"] = window.so_callbacks[id + "_brick"] || {};
    window.so_callbacks[id + "_brick"][output] = [];
    window.so_callbacks[id + "_brick"][output].push(callback);
}
function FindBrick(from, name) {
    if (from.name == name) return from;
    if (from.contains) for(var _i = 0, _a = from.contains; _i < _a.length; _i++){
        var child = _a[_i];
        var found = FindBrick(child, name);
        if (found) return found;
    }
    return null;
}
function FindBrickContainer(from, brick_name) {
    if (from.contains) for(var _i = 0, _a = from.contains; _i < _a.length; _i++){
        var child = _a[_i];
        if (child.name == brick_name) return from;
        var found = FindBrickContainer(child, brick_name);
        if (found) return found;
    }
    return null;
}
function SplitGetLast(val, splitter) {
    var s = val.split(splitter);
    return s[s.length - 1];
}
function array_move(arr, old_index, new_index) {
    while(old_index < 0)old_index += arr.length;
    while(new_index < 0)new_index += arr.length;
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while(k--)arr.push(undefined);
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing purposes
}
function IterateCompositionBricks(composition, fn) {
    return __awaiter(this, void 0, void 0, function() {
        var _i, _a, child;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        fn(composition)
                    ];
                case 1:
                    _b.sent();
                    if (!composition.contains) return [
                        3 /*break*/ ,
                        5
                    ];
                    _i = 0, _a = composition.contains;
                    _b.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [
                        3 /*break*/ ,
                        5
                    ];
                    child = _a[_i];
                    return [
                        4 /*yield*/ ,
                        IterateCompositionBricks(child, fn)
                    ];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    _i++;
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function EscapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function createBrickInfoTree(runner) {
    var _a;
    if (runner) {
        var root_brick_id = "cb" + runner.cid + "_" + ((_a = runner.compos) === null || _a === void 0 ? void 0 : _a.name);
        var root_ci = runner.context.bricks[root_brick_id];
        var brick_info_tree = createBrickInfoTreeRecurse(root_ci, null);
        return brick_info_tree;
    }
}
function createBrickInfoTreeRecurse(ci, dci) {
    var ret = {
        blueprint: {
            name: ci.blueprint.name,
            type: ci.blueprint.type,
            ins: ci.blueprint.ins,
            cement: ci.blueprint.cement,
            targets: {},
            contains: []
        },
        parsed_ins: ci.parsed_ins,
        contains: [],
        debug_ios: ci.debug_ios,
        dci: dci
    };
    if (ci.debug_ios && ci.debug_ios.last_outs && ci.debug_ios.last_outs["@brick_info_tree"]) //splice in brick_info_tree from server sc-container
    ret.contains = Clone(ci.debug_ios.last_outs["@brick_info_tree"].contains);
    else if (ci.blueprint.contains) for(var _i = 0, _a = ci.blueprint.contains; _i < _a.length; _i++){
        var child_blueprint = _a[_i];
        var child_brick_ids = ci.context.composition_runners[ci.cid].get_brick_ids(child_blueprint.name, ci.dc);
        var i = child_brick_ids.length > 1 ? 0 : null;
        for(var _b = 0, child_brick_ids_1 = child_brick_ids; _b < child_brick_ids_1.length; _b++){
            var child_brick_id = child_brick_ids_1[_b];
            var child_brick = ci.context.bricks[child_brick_id];
            if (child_brick) ret.contains.push(createBrickInfoTreeRecurse(child_brick, i));
            if (i !== null) i++;
        }
    }
    return ret;
}
function RecuresePrependBrickInfoTree(brick_info, pre) {
    if (brick_info) {
        brick_info.blueprint.name = pre + PrefabNameJoin + brick_info.blueprint.name;
        if (brick_info.contains) for(var _i = 0, _a = brick_info.contains; _i < _a.length; _i++){
            var b = _a[_i];
            RecuresePrependBrickInfoTree(b, pre);
        }
    }
}
function isVisible(elem) {
    if (!(elem instanceof Element)) throw Error("DomUtil: elem is not an element.");
    var style = getComputedStyle(elem);
    if (style.display === "none") return false;
    if (style.visibility !== "visible") return false;
    if (style.opacity < 0.1) return false;
    //@ts-expect-error
    if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width === 0) return false;
    var elemCenter = {
        //@ts-expect-error
        x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
        //@ts-expect-error
        y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
    };
    if (elemCenter.x < 0) return false;
    if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
    if (elemCenter.y < 0) return false;
    if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
    var pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
    do {
        if (pointContainer === elem) return true;
    //@ts-expect-error
    }while (pointContainer = pointContainer.parentNode);
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"junyG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeBrick", ()=>CodeBrick);
var _cbcompositionRunner = require("./CBCompositionRunner");
var _cbutil = require("./CBUtil");
var _leafResolver = require("./LeafResolver");
var _linkMapper = require("./LinkMapper");
var _templateUtil = require("./TemplateUtil");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var CodeBrick = /** @class */ function() {
    function CodeBrick(context, cid, name, dc, idx, container_id, standalone_ins) {
        if (standalone_ins === void 0) standalone_ins = "";
        this.unresolved = {};
        this.debug_ios = {}; //For debugging only
        this.dc = "";
        this.loadings = 0;
        if (!cid) {
            this.context = context;
            this.cid = cid;
            this.blueprint = {
                name: name,
                type: "",
                ins: standalone_ins ? JSON.parse(standalone_ins) : {},
                cement: {},
                contains: [],
                targets: {}
            };
            this.brick_id = "";
            this.ci_idx = -1;
            this.container_brick_id = "";
            this.idx = 0;
            this.run_list_name = "";
            return;
        }
        this.context = context;
        this.cid = cid;
        this.blueprint = this.context.blueprints[this.cid][name];
        this.container_brick_id = container_id;
        this.idx = idx;
        this.dc = dc || "";
        this.context.ci_idx++;
        this.ci_idx = this.context.ci_idx;
        this.brick_id = "cb" + this.cid + "_" + this.blueprint.name;
        this.parsed_ins = this.blueprint.parsed_ins;
        if (this.dc && this.blueprint.parsed_ins) this.parsed_ins = (0, _cbutil.Clone)(this.blueprint.parsed_ins);
        //xc-use are in a different run list, because they should only run internals when they resolve. This run list is run from inside the xc-use cb_event.
        this.run_list_name = this.blueprint.nsid || "";
        if (dc) {
            var dcs = dc.split((0, _cbutil.DC_JOIN));
            this.context.dc_tree[this.cid][this.blueprint.name] = this.context.dc_tree[this.cid][this.blueprint.name] || {};
            var at_dc = this.context.dc_tree[this.cid][this.blueprint.name];
            for(var di = 1; di < dcs.length; di++){
                var d = dcs[di];
                at_dc[(0, _cbutil.DC_JOIN) + d] = at_dc[(0, _cbutil.DC_JOIN) + d] || {};
                at_dc = at_dc[(0, _cbutil.DC_JOIN) + d];
            }
            for(var i = dc.length - 1; i >= 0; i--)if (dc[i] == (0, _cbutil.DC_JOIN)) {
                this.run_list_name = dc.substring(0, i);
                break;
            }
        // + " run_list_name "+this.run_list_name);
        //console.log(" dc_tree: "+JSON.stringify(this.context.dc_tree[this.cid]));
        }
        this.brick_id += dc || "";
        var run_list = this.context.composition_runners[this.cid].run_list;
        run_list[this.run_list_name] = run_list[this.run_list_name] || {};
        run_list[this.run_list_name][this.brick_id] = run_list[this.run_list_name][this.brick_id] || {};
        var has_in = false;
        for(var input in this.blueprint.ins)if (input != "_cement") {
            run_list[this.run_list_name][this.brick_id][input] = true;
            has_in = true;
        }
        if (!has_in) run_list[this.run_list_name][this.brick_id]["default"] = true;
        //Delete this else buttons in grids can fire again when grid is recreated organization/bulkmonitor. Should only apply to dc bricks
        var base_nsid = this.blueprint.nsid || "";
        var s = this.blueprint.name.split((0, _cbutil.PrefabNameJoin));
        var bpn = s[s.length - 1];
        if (this.context.composition_runners[this.cid].nsods[base_nsid] && this.context.composition_runners[this.cid].nsods[base_nsid][bpn]) delete this.context.composition_runners[this.cid].nsods[base_nsid][bpn];
        this.context.bricks[this.brick_id] = this;
    }
    CodeBrick.prototype.IsInsLeafFiring = function(input, path) {
        if (this.parsed_ins && this.parsed_ins[input] && this.parsed_ins[input].leaves) for(var _i = 0, _a = this.parsed_ins[input].leaves; _i < _a.length; _i++){
            var leaf = _a[_i];
            if (leaf.path.join(".") == path) return leaf.firing;
        }
        return false;
    };
    CodeBrick.prototype.destructor = function() {
    //delete this.context.bricks[this.brick_id];
    };
    CodeBrick.prototype.init_cement = function() {
        var _a;
        var input = "_cement";
        var cements = {};
        var base_nsid = this.blueprint.nsid || ""; // no this break menu active hilight: + (this.dc || "");
        var base_ns = {};
        if (this.cid) {
            this.context.composition_runners[this.cid].nsods[base_nsid] = this.context.composition_runners[this.cid].nsods[base_nsid] || (this.context.composition_runners[this.cid].nsods["$"] != undefined ? Object.create(this.context.composition_runners[this.cid].nsods["$"]) : {});
            base_ns = this.context.composition_runners[this.cid].nsods[base_nsid];
        }
        if (this.blueprint.contains) for(var c = 0; c < this.blueprint.contains.length; c++){
            var child = this.blueprint.contains[c];
            var cement_res = child.cement; //ins[input] || {};
            if (child.parsed_ins && this.cid) {
                //Get the cement
                var in_leaves = child.parsed_ins[input];
                if (in_leaves) {
                    var unresolved = [];
                    // if(this.blueprint.name.indexOf("Subscribe") != -1) {
                    //      console.log("debug");
                    // }
                    cement_res = (0, _leafResolver.LeafResolver).Resolve(in_leaves, child.ins[input], base_ns, this.context.composition_runners[this.cid].run_id, "", "@", (_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options, unresolved);
                    this.unresolved["_cement"] = unresolved;
                    if (cement_res === undefined) //console.log("CEMENT did not resolve "+this.brick_id+" cement " + JSON.stringify(child.ins[input]) + " unresolved "+JSON.stringify(unresolved) + " child.cement "+JSON.stringify(child.cement));
                    cement_res = JSON.parse((0, _templateUtil.TemplateUtil).RemoveDoubleCurlyTags(JSON.stringify(child.cement)));
                }
            }
            cements[c] = cement_res;
        }
        this.cb_initial_cement(cements); //needs to render even if no childs
    };
    CodeBrick.prototype.cb_emit = function(data, dc, no_event) {
        if (dc === void 0) dc = undefined;
        if (no_event === void 0) no_event = false;
        return __awaiter(this, void 0, void 0, function() {
            var output, callbacks, _i, callbacks_1, cb, emit, output, info, debug_log;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!data) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (this.cid == undefined) {
                            for(output in data)if (window.so_callbacks && window.so_callbacks[this.brick_id] && window.so_callbacks[this.brick_id][output]) {
                                callbacks = window.so_callbacks[this.brick_id][output];
                                for(_i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
                                    cb = callbacks_1[_i];
                                    cb(data[output]);
                                }
                            }
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!this.blueprint.targets) return [
                            2 /*return*/ 
                        ];
                        this.add_status("");
                        this.context.composition_runners[this.cid].run_id = this.context.composition_runners[this.cid].seq + 1;
                        emit = null;
                        if (this.context.composition_runners[this.cid].debugging_enabled) {
                            emit = {
                                emitter: this.brick_id,
                                emit_data: data,
                                events: []
                            };
                            this.context.debug_log.emits.push(emit);
                            //console.log("cb_emit "+this.brick_id +" "+JSON.stringify(data));
                            if (data) for(output in data){
                                this.context.last_emit_data[this.cid][this.blueprint.name] = this.context.last_emit_data[this.cid][this.blueprint.name] || {};
                                this.context.last_emit_data[this.cid][this.blueprint.name].brick_type = this.blueprint.type;
                                this.context.last_emit_data[this.cid][this.blueprint.name].outputs = this.context.last_emit_data[this.cid][this.blueprint.name].outputs || {};
                                this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output] = this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output] || {};
                                this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output].data = (0, _cbutil.CloneLimit)(data[output], 3, 20);
                            }
                        }
                        info = {
                            source_brick_id: this.brick_id,
                            source: this.blueprint.name,
                            dc: dc || this.dc,
                            no_event: no_event
                        };
                        return [
                            4 /*yield*/ ,
                            this.send_data(data, info, emit)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.context.composition_runners[this.cid].run_deferred_emits()
                        ];
                    case 2:
                        _a.sent();
                        if (this.context.composition_runners[this.cid].debugging_enabled) {
                            debug_log = this.context.debug_log;
                            if (this.context.composition_runners[this.cid].save_debug_log_callback) {
                                (0, _cbutil.ObjectDeepMerge)(debug_log.last_emit_data, this.context.last_emit_data["_1"]);
                                this.context.last_emit_data["_1"] = debug_log.last_emit_data;
                                this.context.composition_runners[this.cid].RunDebugLogCallback();
                            }
                        }
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CodeBrick.prototype.cb_emit_deferred = function(data, dc) {
        if (dc === void 0) dc = undefined;
        this.context.composition_runners[this.cid].deferred_emits[this.brick_id] = {
            data: data,
            dc: dc
        };
    };
    //source_data is here just for deug loggin purposes
    //async run(input: string, source: string, source_output: string, source_idx: number, source_data: any, debuglog: EmitLog | null, source_brick_id: string) {
    CodeBrick.prototype.run = function(input, info, source_data, debuglog) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var run_list, cfg, source_nsod, nsid, unresolved, in_leaves, debug_event, container, row_id, s, emit_data;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        //console.log("run2 "+this.brick_id+" input "+input+ " source "+source+ " source_output " + source_output + " source_idx "+ source_idx);
                        if (this.context.composition_runners[this.cid].seq > this.context.composition_runners[this.cid].run_id + (0, _cbcompositionRunner.CBCompositionRunner).MAX_ITERATIONS_PER_EMIT) {
                            console.error("MAX_ITERATIONS_PER_EMIT " + (0, _cbcompositionRunner.CBCompositionRunner).MAX_ITERATIONS_PER_EMIT + " hit. Stopping execution. [" + info.source_brick_id + "." + info.source_output + "->" + this.brick_id + "." + input + "]");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        run_list = this.context.composition_runners[this.cid].run_list;
                        if (info.source == "") {
                            if (!run_list[this.run_list_name][this.brick_id] || !run_list[this.run_list_name][this.brick_id][input]) return [
                                2 /*return*/ 
                            ]; //Already ran in init phase
                        }
                        if (run_list[this.run_list_name][this.brick_id]) {
                            delete run_list[this.run_list_name][this.brick_id][input];
                            if (Object.keys(run_list[this.run_list_name][this.brick_id]).length == 0) delete run_list[this.run_list_name][this.brick_id];
                        }
                        this.blueprint.ins = this.blueprint.ins || {};
                        cfg = this.blueprint.ins[input];
                        if (cfg === undefined) cfg = {};
                        nsid = (this.blueprint.nsid || "") + (this.dc || "");
                        unresolved = [];
                        if (this.parsed_ins) {
                            in_leaves = this.parsed_ins[input];
                            if (in_leaves) {
                                //console.log("nsid "+nsid + " "+this.blueprint.name + " ("+this.blueprint.type+") nsod " + this.blueprint.nsod);
                                //this.context.composition_runners[this.cid].nsods[nsid] = this.context.composition_runners[this.cid].nsods[nsid] || (this.context.composition_runners[this.cid].nsods[""] != undefined ? Object.create(this.context.composition_runners[this.cid].nsods[""]) : {});
                                this.context.composition_runners[this.cid].nsods[nsid] = this.context.composition_runners[this.cid].nsods[nsid] || (this.context.composition_runners[this.cid].nsods["$"] != undefined ? Object.create(this.context.composition_runners[this.cid].nsods["$"]) : {});
                                source_nsod = this.context.composition_runners[this.cid].nsods[nsid];
                                // if(this.blueprint.name.indexOf("Subscribe") != -1) {
                                // // // // // // // // // if(this.brick_id == "cb_0_ch_ContractType-chart") {//attachmentuploader-GetAttachments") {
                                //     console.log("debug "+this.blueprint.name + " source "+ info.source);
                                // }
                                cfg = (0, _leafResolver.LeafResolver).Resolve(in_leaves, this.blueprint.ins[input], source_nsod, this.context.composition_runners[this.cid].run_id, info.source, info.source_output, (_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options, unresolved);
                                // if(this.blueprint.name.indexOf("fetch_solutionobjects") != -1) {
                                //     console.log("resolved "+(cfg===undefined?"NO":"YES")+" " +this.blueprint.name + " source "+ info.source);
                                // }
                                this.unresolved[input] = unresolved;
                            }
                        }
                        debug_event = undefined;
                        if (debuglog) {
                            //console.log("debug logging "+source+" -> "+this.brick_id +" debuglog.emitter "+debuglog.emitter);
                            debug_event = {
                                source: info.source,
                                output: info.source_output,
                                dest_name: this.blueprint.name,
                                input: input,
                                resolved: cfg !== undefined,
                                source_brick_id: debuglog.emitter == "INIT" ? "" : info.source_brick_id,
                                source_data: source_data,
                                dest: this.brick_id,
                                cfg: cfg
                            };
                            // if(!info.loop_list) {
                            //     info.loop_list = [debug_event];
                            // }
                            // else {
                            //     for(let d = info.loop_list.length - 1; d >= 0; d--) {
                            //         let event = info.loop_list[d];
                            //         if(event.source_brick_id && event.source_brick_id == debug_event.source_brick_id && event.dest == debug_event.dest && event.input == debug_event.input) {
                            //             console.error("LOOP: " + event.source_brick_id +"["+d+"] of " + info.loop_list.length + " == " + debug_event.source_brick_id);
                            //             for(let e = d; e < info.loop_list.length; e++) {
                            //                 console.error(info.loop_list[e].source_brick_id+"."+info.loop_list[e].output+"->"+info.loop_list[e].dest+"."+info.loop_list[e].input);
                            //             }
                            //             console.error(debug_event.dest+"."+input);
                            //             return;
                            //         }
                            //     }
                            //     info.loop_list.push(debug_event);
                            // }
                            debuglog.events.push(debug_event);
                        }
                        if (info.no_event) return [
                            2 /*return*/ 
                        ];
                        if (!(cfg !== undefined)) return [
                            3 /*break*/ ,
                            5
                        ];
                        // if(debuglog) {
                        //     if(this.brick_id.indexOf(PrefabNameJoin) == -1 && info.source_brick_id && this.parsed_ins && this.parsed_ins[input]?.has_tags 
                        //         && (!this.dc) //only show where all dc numbers are 0
                        //     ) {
                        //     // // //console.log("RESOLVED - "+this.brick_id+" input "+input+" source " + info.source_brick_id + " " + JSON.stringify(this.blueprint.ins[input]) +" -> "+JSON.stringify(cfg));
                        // if((<any>window) && (<any>window).codebricks_context && (<any>window).codebricks_context.logevents) {
                        //     if(this.brick_id.indexOf(PrefabNameJoin) == -1 && info.source_brick_id && this.parsed_ins && this.parsed_ins[input]?.has_tags 
                        //         && (!this.dc)
                        //     )   {
                        //    console.log((info.source_brick_id || "INIT") + "->" + this.brick_id+" input "+input + " " + JSON.stringify(cfg));
                        //     }
                        // }
                        //     }
                        // }
                        if (this.context.composition_runners[this.cid].debugging_enabled) {
                            this.debug_ios = this.debug_ios || {};
                            this.debug_ios.last_ins = this.debug_ios.last_ins || {};
                            this.debug_ios.last_ins[input] = cfg;
                        }
                        if (!(input == "_cement")) return [
                            3 /*break*/ ,
                            1
                        ];
                        container = this.context.bricks[this.container_brick_id];
                        row_id = 0;
                        if (this.dc) {
                            s = this.dc.split((0, _cbutil.DC_JOIN));
                            row_id = Number(s[s.length - 1]);
                        }
                        container.cb_update_cement(this.idx, cfg, row_id);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        // if(this.blueprint.name == "billperiod") {
                        // //if(this.brick_id == "cb_0_attachmentuploader-GetAttachments") {
                        //     console.log("debug");
                        // }
                        info.debug_event = debug_event;
                        return [
                            4 /*yield*/ ,
                            this.cb_event(input, cfg, info)
                        ];
                    case 2:
                        emit_data = _b.sent();
                        //console.log("emit_data " +this.brick_id +": "+JSON.stringify(emit_data));
                        if (debug_event) debug_event.out_data = emit_data;
                        info.source_brick_id = this.brick_id;
                        if (this.blueprint.name == info.source && this.blueprint.type != "c-jit-generator") //console.log("Potential infinite loop averted; "+this.blueprint.name+" received event from "+this.blueprint.name+", handled but not forwarded");
                        return [
                            2 /*return*/ ,
                            false
                        ]; //prevent infinite loop. If the component is it's own source, then dont emit.
                        return [
                            4 /*yield*/ ,
                            this.send_data(emit_data, info, debuglog)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        //console.log("UNRESOLVED - "+this.brick_id+" input "+input +" source " + info.source  + " nsod "+JSON.stringify(source_nsod));
                        // if(this.dc) {
                        //     console.log("run2 unresolved - "+this.brick_id+" input "+input +" source " + source  + " cfg: " + JSON.stringify(this.blueprint.ins[input]) + " unresolved "+JSON.stringify(this.unresolved[input]));          
                        // }
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CodeBrick.prototype.send_data = function(emit_object, info, debuglog) {
        return __awaiter(this, void 0, void 0, function() {
            var oname, oname_nests, output, targets, emitted, dc, source_idx, dcs, promises, output, output_targets, output_info, dest_name, target_blueprint, target_blueprint_nsid, target_blueprint_ns, target_blueprint_1, target_blueprint_nsid_1, target_blueprint_ns_1, targets_2, _i, targets_1, target, target_ci, dest_input;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        oname = this.blueprint.name_nso || this.blueprint.name;
                        oname_nests = oname.split((0, _cbutil.PrefabNameJoin));
                        oname = oname_nests[oname_nests.length - 1];
                        if (emit_object && this.context.composition_runners[this.cid].debugging_enabled) for(output in emit_object){
                            if (emit_object[output] === undefined) continue;
                            if (output != "@debug_log") {
                                this.context.last_emit_data[this.cid][this.blueprint.name] = this.context.last_emit_data[this.cid][this.blueprint.name] || {};
                                this.context.last_emit_data[this.cid][this.blueprint.name].brick_type = this.blueprint.type;
                                this.context.last_emit_data[this.cid][this.blueprint.name].outputs = this.context.last_emit_data[this.cid][this.blueprint.name].outputs || {};
                                this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output] = this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output] || {};
                                this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output].data = (0, _cbutil.CloneLimit)(emit_object[output], 3, 20);
                                this.debug_ios = this.debug_ios || {};
                                this.debug_ios.last_outs = this.debug_ios.last_outs || {};
                                this.debug_ios.last_outs[output] = this.context.last_emit_data[this.cid][this.blueprint.name].outputs[output].data;
                            }
                        }
                        targets = this.blueprint.targets;
                        if (this.blueprint.name_nso) //we have to also adopt the targets of name_nso, we are in effect impersonating it, sending as it.
                        targets = this.context.blueprints[this.cid][this.blueprint.name_nso].targets;
                        emitted = false;
                        if (!targets) return [
                            3 /*break*/ ,
                            2
                        ];
                        dc = info.dc || this.dc;
                        source_idx = 0;
                        if (dc) {
                            dcs = this.dc.split((0, _cbutil.DC_JOIN));
                            source_idx = Number(dcs[dcs.length - 1]);
                        }
                        promises = [];
                        for(output in emit_object){
                            if (emit_object[output] === undefined) continue;
                            output_targets = targets[output];
                            output_info = (0, _cbutil.Clone)(info);
                            output_info.source_idx = source_idx;
                            output_info.source_output = output;
                            output_info.source = oname;
                            for(dest_name in output_targets){
                                target_blueprint = this.context.blueprints[this.cid][dest_name];
                                target_blueprint_nsid = target_blueprint.nsid || "";
                                this.context.composition_runners[this.cid].nsods[target_blueprint_nsid] = this.context.composition_runners[this.cid].nsods[target_blueprint_nsid] || (this.context.composition_runners[this.cid].nsods["$"] != undefined ? Object.create(this.context.composition_runners[this.cid].nsods["$"]) : {});
                                target_blueprint_ns = this.context.composition_runners[this.cid].nsods[target_blueprint_nsid];
                                if (!target_blueprint_ns.hasOwnProperty(oname)) target_blueprint_ns[oname] = {};
                                target_blueprint_ns[oname][output] = {
                                    d: emit_object[output],
                                    r: this.context.composition_runners[this.cid].run_id,
                                    s: ++this.context.composition_runners[this.cid].seq
                                };
                                if (dc) {
                                    target_blueprint_1 = this.context.blueprints[this.cid][dest_name];
                                    target_blueprint_nsid_1 = (target_blueprint_1.nsid || "") + (this.dc || "");
                                    this.context.composition_runners[this.cid].nsods[target_blueprint_nsid_1] = this.context.composition_runners[this.cid].nsods[target_blueprint_nsid_1] || (this.context.composition_runners[this.cid].nsods["$"] != undefined ? Object.create(this.context.composition_runners[this.cid].nsods["$"]) : {});
                                    target_blueprint_ns_1 = this.context.composition_runners[this.cid].nsods[target_blueprint_nsid_1];
                                    if (!target_blueprint_ns_1.hasOwnProperty(oname)) target_blueprint_ns_1[oname] = {};
                                    target_blueprint_ns_1[oname][output] = {
                                        d: emit_object[output],
                                        r: this.context.composition_runners[this.cid].run_id,
                                        s: this.context.composition_runners[this.cid].seq
                                    };
                                }
                                targets_2 = this.context.composition_runners[this.cid].get_brick_ids(dest_name, dc);
                                for(_i = 0, targets_1 = targets_2; _i < targets_1.length; _i++){
                                    target = targets_1[_i];
                                    target_ci = this.context.bricks[target];
                                    if (target_ci) for(dest_input in output_targets[dest_name])//console.log(this.brick_id+" IS MAKING "+target+" RUN");
                                    promises.push(target_ci.run(dest_input, output_info, emit_object[output], debuglog));
                                // else {
                                //     console.log(target+" NOT FOUND (source "+this.brick_id+")");
                                // }
                                }
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            emitted
                        ];
                }
            });
        });
    };
    CodeBrick.prototype.flush_dynamic = function() {
        return __awaiter(this, void 0, void 0, function() {
            var b, brick, s;
            return __generator(this, function(_a) {
                //console.log(this.brick_id+" flush_dynamic");
                if (this.context.bricks) for(b in this.context.bricks){
                    brick = this.context.bricks[b];
                    if (brick.dc) {
                        s = brick.dc.split((0, _cbutil.DC_JOIN));
                        if (s[s.length - 2] == this.blueprint.name) {
                            if (this.dc) {
                                if (!brick.dc.includes(this.dc)) continue;
                            }
                            //console.log(" " +this.brick_id+" DELETE "+b+" brick.dc "+brick.dc);
                            brick.cb_unload();
                            delete this.context.bricks[b];
                        //delete this.context.composition_runners[this.cid].nsods[brick.dc]; these don't change anything because brick is just recreated in nsods[""] on first row
                        //delete this.context.composition_runners[this.cid].nsods[""][brick.blueprint.name];
                        }
                    }
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CodeBrick.prototype.send_dynamic_initialisation_events = function(dc_data) {
        var _a;
        return __awaiter(this, void 0, Promise, function() {
            var nsid, s, dc_root, oname, oname_nests, targets, base_nsid, base_ns, cements_to_update, output, output_targets, i, child_dc, dest_name, target_blueprint, target_nsid, target_ns, input, child_brick_id, cci, in_leaves, unresolved, cement_res, emit, info, _i, cements_to_update_1, cto;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.blueprint.contains || this.blueprint.contains.length == 0 || !dc_data) return [
                            2 /*return*/ 
                        ];
                        //we have to clear all nsods directly under this dc so they don't keep data between loads or pages
                        for(nsid in this.context.composition_runners[this.cid].nsods){
                            s = nsid.split((0, _cbutil.DC_JOIN), 2);
                            if (s[1] == this.blueprint.name) delete this.context.composition_runners[this.cid].nsods[nsid];
                        }
                        this.context.composition_runners[this.cid].run_id = this.context.composition_runners[this.cid].seq + 1;
                        dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
                        oname = this.blueprint.name_nso || this.blueprint.name;
                        oname_nests = oname.split((0, _cbutil.PrefabNameJoin));
                        oname = oname_nests[oname_nests.length - 1];
                        targets = this.blueprint.targets;
                        if (this.blueprint.name_nso) //we have to also adopt the targets of name_nso, we are in effect impersonating it, sending as it.
                        targets = this.context.blueprints[this.cid][this.blueprint.name_nso].targets;
                        base_nsid = (this.blueprint.nsid || "") + (this.dc || "");
                        this.context.composition_runners[this.cid].nsods[base_nsid] = this.context.composition_runners[this.cid].nsods[base_nsid] || {};
                        base_ns = this.context.composition_runners[this.cid].nsods[base_nsid];
                        cements_to_update = [];
                        output = "@";
                        if (targets) {
                            output_targets = targets[output];
                            for(i = 0; i < dc_data.length; i++){
                                child_dc = dc_root + (0, _cbutil.DC_JOIN) + i;
                                for(dest_name in output_targets){
                                    target_blueprint = this.context.blueprints[this.cid][dest_name];
                                    if (target_blueprint) {
                                        target_nsid = (target_blueprint.nsid || "") + child_dc;
                                        this.context.composition_runners[this.cid].nsods[target_nsid] = this.context.composition_runners[this.cid].nsods[target_nsid] || Object.create(base_ns);
                                        target_ns = this.context.composition_runners[this.cid].nsods[target_nsid];
                                        //We have to use hasOwnProperty, alse we will use and overwrite the parent's property
                                        if (!target_ns.hasOwnProperty(oname)) {
                                            if (base_ns[oname]) target_ns[oname] = Object.create(base_ns[oname]);
                                            else target_ns[oname] = {};
                                        }
                                        if (!target_ns[oname].hasOwnProperty(output)) {
                                            if (base_ns[oname] && base_ns[oname][output]) target_ns[oname][output] = Object.create(base_ns[oname][output]);
                                        }
                                        target_ns[oname][output] = {
                                            d: dc_data[i],
                                            r: this.context.composition_runners[this.cid].run_id,
                                            s: ++this.context.composition_runners[this.cid].seq
                                        };
                                        for(input in output_targets[dest_name])if (input == "_cement" && target_blueprint && target_blueprint.parsed_ins) {
                                            child_brick_id = "cb" + this.cid + "_" + target_blueprint.name + child_dc;
                                            cci = this.context.bricks[child_brick_id];
                                            if (cci.container_brick_id == this.brick_id) {
                                                in_leaves = target_blueprint.parsed_ins[input];
                                                if (in_leaves) {
                                                    unresolved = [];
                                                    cement_res = (0, _leafResolver.LeafResolver).Resolve(in_leaves, target_blueprint.ins[input], target_ns, this.context.composition_runners[this.cid].run_id, "", "@", (_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options, unresolved);
                                                    if (cement_res !== undefined) cements_to_update.push({
                                                        child_idx: cci.idx,
                                                        cement: cement_res,
                                                        row_idx: i
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (dc_data.length > 0 && this.context.composition_runners[this.cid].debugging_enabled) {
                            this.context.last_emit_data[this.cid][this.blueprint.name] = this.context.last_emit_data[this.cid][this.blueprint.name] || {};
                            this.context.last_emit_data[this.cid][this.blueprint.name].brick_type = this.blueprint.type;
                            this.context.last_emit_data[this.cid][this.blueprint.name].outputs = this.context.last_emit_data[this.cid][this.blueprint.name].outputs || {};
                            this.context.last_emit_data[this.cid][this.blueprint.name].outputs["@"] = this.context.last_emit_data[this.cid][this.blueprint.name].outputs["@"] || {};
                            this.context.last_emit_data[this.cid][this.blueprint.name].outputs["@"].data = (0, _cbutil.CloneLimit)(dc_data[0], 3, 20);
                        // this.context.last_emit_data[this.cid][this.blueprint.name] = this.context.last_emit_data[this.cid][this.blueprint.name] || {};
                        // this.context.last_emit_data[this.cid][this.blueprint.name]["@"] = dc_data[0];
                        }
                        emit = null;
                        if (this.context.composition_runners[this.cid].debugging_enabled) {
                            emit = {
                                emitter: this.brick_id,
                                emit_data: dc_data,
                                events: []
                            };
                            this.context.debug_log.emits.push(emit);
                        }
                        info = {
                            source_idx: 0,
                            source: "",
                            source_output: "@",
                            dc_data_len: dc_data.length
                        };
                        return [
                            4 /*yield*/ ,
                            this.context.composition_runners[this.cid].run_init_passes(info, dc_root, emit)
                        ];
                    case 1:
                        _b.sent();
                        //await this.context.composition_runners[this.cid].run_init_passes("", "@", "", emit);
                        for(_i = 0, cements_to_update_1 = cements_to_update; _i < cements_to_update_1.length; _i++){
                            cto = cements_to_update_1[_i];
                            this.cb_update_cement(cto.child_idx, cto.cement, cto.row_idx);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CodeBrick.prototype.emit_state = function(state) {
        //console.log("emit_state \""+state+"\" from "+this.brick_id);
        var targets = this.blueprint.targets;
        if (this.blueprint.name_nso) //we have to also adopt the targets of name_nso, we are in effect impersonating it, sending as it.
        targets = this.context.blueprints[this.cid][this.blueprint.name_nso].targets;
        if (targets) for(var output in targets){
            // if(output != "@") {
            //     continue;
            // }
            var dests = targets[output];
            //console.log(" emit_state output "+output+" dests "+JSON.stringify(dests));
            for(var destid in dests){
                var is_unit_outs = false;
                for(var input in dests[destid])if (input == "unit_outs") {
                    is_unit_outs = true;
                    break;
                }
                if (is_unit_outs) continue;
                //console.log("0 getTargets (emit_state) OF "+destid+", dc "+this.dc);
                var dest_brick_ids = this.context.composition_runners[this.cid].get_brick_ids(destid, this.dc);
                for(var _i = 0, dest_brick_ids_1 = dest_brick_ids; _i < dest_brick_ids_1.length; _i++){
                    var dest_brick_id = dest_brick_ids_1[_i];
                    var ci = this.context.bricks[dest_brick_id];
                    if (ci) // if(ci.blueprint.name == "ch_Total") {
                    //     console.log(" emit_state "+state+" from "+this.brick_id+" to "+dest_brick_id);
                    // }
                    ci.add_status(state);
                }
            }
        }
    };
    CodeBrick.prototype.validate_sources = function(form_container, log) {
        if (log === void 0) log = false;
        var validates = true;
        if (!form_container) {
            if (this.blueprint.parsed_ins) {
                this.sources = [];
                (0, _linkMapper.LinkMapper).GetSources(this.blueprint.parsed_ins, this.cid, this.blueprint.nsid || "", this.sources);
            }
            if (this.sources) for(var _i = 0, _a = this.sources; _i < _a.length; _i++){
                var source = _a[_i];
                var source_brick_ids = this.context.composition_runners[this.cid].get_brick_ids(source, this.dc);
                for(var _b = 0, source_brick_ids_1 = source_brick_ids; _b < source_brick_ids_1.length; _b++){
                    var source_brick_id = source_brick_ids_1[_b];
                    var ci = this.context.bricks[source_brick_id];
                    if (ci) {
                        if (!ci.cb_validate()) {
                            if (this.brick_id.startsWith("cb_1_")) console.log(this.brick_id + ": Validation of " + ci.brick_id + " failed");
                            validates = false;
                        }
                    }
                }
            }
        }
        return validates;
    };
    CodeBrick.prototype.form_value_submit = function() {
        //To be called by form elements that act as data inputs (for example inputs) when the enter key enter is pressed on them.
        //This will trigger validation checks on all the form elements and submit the form if success.
        if (this.blueprint.targets) {
            var out_dests = this.blueprint.targets;
            for(var output in out_dests)for(var dest in out_dests[output]){
                var dest_brick_ids = this.context.composition_runners[this.cid].get_brick_ids(dest, this.dc);
                for(var _i = 0, dest_brick_ids_2 = dest_brick_ids; _i < dest_brick_ids_2.length; _i++){
                    var dest_brick_id = dest_brick_ids_2[_i];
                    var ci = this.context.bricks[dest_brick_id];
                    if (ci) {
                        if (ci.validate_sources("")) ci.cb_trigger_submit();
                    }
                }
            }
        }
    };
    CodeBrick.prototype.add_status = function(status) {
        if (status == "loading") {
            if (this.loadings <= 0) this.cb_status("loading");
            this.loadings++;
        } else if (status == "") {
            if (this.loadings <= 1) this.cb_status("");
            this.loadings--;
        }
    };
    CodeBrick.prototype.cb_trigger_submit = function() {
    //Override this when needed
    //For being called by the system on for example a button when enter is pressed on an input connected to it.
    };
    CodeBrick.prototype.cb_validate = function() {
        //Override this then needed.
        //The implementation should check if the input validates, 
        // if it does not, it should show the graphical indication that validation failed, 
        // and return false.
        return true;
    };
    CodeBrick.prototype.cb_unload = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return CodeBrick;
}();

},{"./CBCompositionRunner":"lpTA2","./CBUtil":"1DxvQ","./LeafResolver":"kBHWQ","./LinkMapper":"bvAzp","./TemplateUtil":"ebZ29","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lpTA2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CBCompositionRunner", ()=>CBCompositionRunner);
var _cbformattingJs = require("./CBFormatting.js");
var _cbutil = require("./CBUtil");
var _leafParser = require("./LeafParser");
var _linkMapper = require("./LinkMapper");
var _templateUtilJs = require("./TemplateUtil.js");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var CBCompositionRunner = /** @class */ function() {
    function CBCompositionRunner(composition, context, //get_debug_log_callback: (() => Promise<DebugLog | null>),
    save_debug_log_callback) {
        this.cid = "_";
        this.cn_out_data = {};
        this.reverse_link_map = null;
        this.nsods = {};
        this.run_id = 0;
        this.seq = 0;
        this.run_list = {};
        this.debugging_enabled = false;
        this.deferred_emits = {};
        this.busy_saving_debug_log = false;
        this.composition = composition;
        this.context = context;
        //this.get_debug_log_callback = get_debug_log_callback;
        this.save_debug_log_callback = save_debug_log_callback;
    }
    CBCompositionRunner.init_context = function(context) {
        context.cb_cnid = context.cb_cnid || 0;
        context.bricks = context.bricks || {};
        context.composition_runners = context.composition_runners || {};
        context.compositions = context.compositions || {};
        context.blueprints = context.blueprints || {};
        context.ci_idx = context.ci_idx || 0;
        context.dc_tree = context.dc_tree || {};
        context.debug_log = {
            emits: [],
            last_emit_data: {}
        };
        context.last_emit_data = context.last_emit_data || {};
        context.status = function(brick_id, indent, done_names) {
            var _a;
            if (indent === void 0) indent = "";
            if (done_names === void 0) done_names = {};
            // if(name === undefined || done_names[name]) {
            //     console.log("Status hit circular structure on "+name+" STOPPING");
            //     return;
            // }
            done_names[brick_id] = true;
            var found = false;
            for(var c in context.bricks){
                var ci = context.bricks[c];
                if (!ci.blueprint.name) continue;
                if (ci.brick_id == brick_id) {
                    found = true;
                    console.log("Found " + ci.brick_id);
                    console.log(indent + " - last ins: " + JSON.stringify((_a = ci.debug_ios) === null || _a === void 0 ? void 0 : _a.last_ins));
                    for(var input in ci.blueprint.ins)if (ci.unresolved[input] && ci.unresolved[input].length > 0) {
                        console.log(indent + "input " + input + " Unresolved - waiting for:");
                        for(var _i = 0, _b = ci.unresolved[input]; _i < _b.length; _i++){
                            var u = _b[_i];
                            if (!u) continue;
                            console.log(indent + " " + u);
                        //let u2 = u.split(".")[0];
                        //console.log(context.status(u2, indent+'  ', done_names));
                        }
                    } else console.log(indent + " - input " + input + " Resolved;");
                    var cid = "_" + ci.brick_id.split("_")[1];
                    var last_emit_data = context.last_emit_data[cid][ci.blueprint.name];
                    console.log(indent + "last_emit_data: " + JSON.stringify(last_emit_data));
                }
            }
            if (!found) console.log(indent + " Could not find " + name);
        };
    };
    CBCompositionRunner.prototype.init_composition = function(compos, args_object, reuse_cid) {
        if (reuse_cid === void 0) reuse_cid = null;
        if (reuse_cid) {
            if (this.context.bricks) {
                var pf = "cb" + reuse_cid + "_";
                for(var b in this.context.bricks)if (b.startsWith(pf)) delete this.context.bricks[b];
            }
        }
        CBCompositionRunner.init_context(this.context);
        compos.composition = this.composition;
        this.compos = compos;
        if (reuse_cid) this.cid = reuse_cid;
        else {
            this.cid = "_" + this.context.cb_cnid;
            this.context.cb_cnid++;
        }
        this.context.composition_runners[this.cid] = this;
        this.context.compositions[this.cid] = this.compos;
        this.context.blueprints[this.cid] = {};
        this.context.dc_tree[this.cid] = {};
        this.context.last_emit_data[this.cid] = this.context.last_emit_data[this.cid] || {};
        this.nsods = {};
        if (this.compos.prep) this.nsods = this.compos.prep.nsods || {};
        this.nsods[""] = this.nsods[""] || (this.nsods["$"] != undefined ? Object.create(this.nsods["$"]) : {});
        this.register_component(this.context.blueprints[this.cid], compos, args_object);
        //create link_map
        (0, _linkMapper.LinkMapper).Map(this.context.blueprints[this.cid]);
    };
    CBCompositionRunner.prototype.register_component = function(blueprints, ci, args_object) {
        blueprints[ci.name] = ci;
        ci.parsed_ins = {};
        ci.parsed_ins = (0, _leafParser.LeafParser).Parse(ci.ins);
        if (ci.type == "cc-use") {
            ci.ins = ci.ins || {};
            ci.ins.args = args_object;
        }
        if (ci.contains) for(var _i = 0, _a = ci.contains; _i < _a.length; _i++){
            var loc = _a[_i];
            if (loc) this.register_component(blueprints, loc, args_object);
        }
    };
    CBCompositionRunner.prototype.get_brick_ids = function(brick_name, dc) {
        //console.log("1 getTargets destname "+destname+" source_dc "+source_dc);
        var ret = [];
        if (this.context.dc_tree[this.cid][brick_name]) {
            var dcs = dc.split((0, _cbutil.DC_JOIN));
            var tree_at = this.context.dc_tree[this.cid][brick_name];
            var at_dc = "";
            for(var d = 1; d < dcs.length; d++){
                var dcpart = (0, _cbutil.DC_JOIN) + dcs[d];
                if (tree_at[dcpart]) {
                    tree_at = tree_at[dcpart];
                    at_dc += dcpart;
                } else break;
            }
            this.getChildTargets(tree_at, at_dc, brick_name, ret);
            return ret;
        } else {
            ret.push("cb" + this.cid + "_" + brick_name);
            return ret;
        }
    };
    CBCompositionRunner.prototype.getChildTargets = function(tree_at, at_dc, destname, ret) {
        var has_childs = false;
        for(var d in tree_at){
            this.getChildTargets(tree_at[d], at_dc + d, destname, ret);
            has_childs = true;
        }
        if (!has_childs) {
            var brick_id = "cb" + this.cid + "_" + destname + at_dc;
            ret.push(brick_id);
        }
    };
    CBCompositionRunner.prototype.getTargetsRecurse = function(tree_at, at_dc, at_dc_part, ret) {
        for(var d in tree_at[at_dc_part]){
            var brick_id = "cb" + this.cid + "_" + at_dc + d;
            if (this.context.bricks[brick_id]) ret.push(brick_id);
            else if (tree_at[at_dc_part]) this.getTargetsRecurse(tree_at[at_dc_part], at_dc + d, d, ret);
        }
    };
    CBCompositionRunner.prototype.getDcFrombrick_id = function(brick_id) {
        var dci = brick_id.indexOf((0, _cbutil.DC_JOIN));
        if (dci == -1) return "";
        return brick_id.substr(dci);
    };
    CBCompositionRunner.prototype.send_initialisation_events = function(init_odata, source, source_output) {
        if (source === void 0) source = "";
        if (source_output === void 0) source_output = "@";
        return __awaiter(this, void 0, Promise, function() {
            var source_1, output, emit, info;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.compos && this.compos.system_options && this.compos.system_options.locale) (0, _cbformattingJs.setLocale)(this.compos.system_options.locale);
                        if (this.compos && (this.compos.type == "cc-unit" || this.compos.type == "sc-unit" || this.compos.type == "sc-container")) {
                            if (init_odata) for(source_1 in init_odata){
                                this.nsods[""][source_1] = this.nsods[""][source_1] || {};
                                for(output in init_odata[source_1]){
                                    this.nsods[""][source_1][output] = this.nsods[""][source_1][output] || {};
                                    (0, _cbutil.ObjectDeepMerge)(this.nsods[""][source_1][output], {
                                        r: 0,
                                        s: 0,
                                        d: init_odata[source_1][output]
                                    });
                                }
                            }
                        }
                        emit = null;
                        if (this.debugging_enabled) {
                            emit = {
                                emitter: "INIT",
                                emit_data: null,
                                events: []
                            };
                            this.context.debug_log.emits.push(emit);
                        // if(this.get_debug_log_callback) {
                        //     let saved_debug_log = await this.get_debug_log_callback();
                        //     if(saved_debug_log) {
                        //         this.context.last_emit_data[this.cid] = saved_debug_log.last_emit_data;
                        //     }
                        // }
                        //if(this.compos && this.compos.debug_log) {
                        //this.context.last_emit_data[this.cid] = this.compos.debug_log.last_emit_data;
                        //}
                        }
                        info = {
                            source_idx: 0,
                            source: source,
                            source_output: source_output
                        };
                        return [
                            4 /*yield*/ ,
                            this.run_init_passes(info, "", emit)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.run_deferred_emits()
                        ];
                    case 2:
                        _a.sent();
                        if (this.debugging_enabled) {
                            this.context.debug_log.last_emit_data = this.context.last_emit_data[this.cid];
                            if (this.save_debug_log_callback) this.RunDebugLogCallback();
                        }
                        if (this.compos != null) return [
                            2 /*return*/ ,
                            this.context.composition_runners[this.cid].cn_out_data
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CBCompositionRunner.prototype.run_deferred_emits = function() {
        return __awaiter(this, void 0, void 0, function() {
            var demits, _a, _b, _c, _i, brickid, brick, de;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        demits = this.deferred_emits;
                        this.deferred_emits = {};
                        if (!demits) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = demits;
                        _b = [];
                        for(_c in _a)_b.push(_c);
                        _i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _c = _b[_i];
                        if (!(_c in _a)) return [
                            3 /*break*/ ,
                            3
                        ];
                        brickid = _c;
                        brick = this.context.bricks[brickid];
                        de = demits[brickid];
                        return [
                            4 /*yield*/ ,
                            brick.cb_emit(de.data, de.dc)
                        ];
                    case 2:
                        _d.sent();
                        brick.cb_status("deferred_emit_complete");
                        _d.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CBCompositionRunner.prototype.RunDebugLogCallback = function() {
        return __awaiter(this, void 0, void 0, function() {
            var self_1;
            return __generator(this, function(_a) {
                if (this.save_debug_log_callback) {
                    self_1 = this;
                    //prevent multiple calls from overwriting each other, causing corrupted json
                    //The idea is that if there are multiple calls close together, they will all update context.debug_log
                    //Then afterwards (when the setTimeout runs, it will send the upated value, guarded by busy_saving_debug_log to prevent concurrent writes)
                    setTimeout(function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!self_1.save_debug_log_callback) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        if (!!self_1.busy_saving_debug_log) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        self_1.busy_saving_debug_log = true;
                                        return [
                                            4 /*yield*/ ,
                                            self_1.save_debug_log_callback(self_1.context.debug_log)
                                        ];
                                    case 1:
                                        _a.sent();
                                        self_1.busy_saving_debug_log = false;
                                        _a.label = 2;
                                    case 2:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }, 300);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CBCompositionRunner.prototype.run_init_passes = function(info, run_list_name, debuglog) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // if(debuglog) {
                        //     console.log("run_init_passes "+debuglog.emitter);
                        // }
                        return [
                            4 /*yield*/ ,
                            this.run_pass(true, info, run_list_name, debuglog)
                        ];
                    case 1:
                        // if(debuglog) {
                        //     console.log("run_init_passes "+debuglog.emitter);
                        // }
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.run_pass(false, info, run_list_name, debuglog)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //async run_pass(only_readies: boolean, source: string, source_output: string, run_list_name: string, debuglog: EmitLog | null) {
    CBCompositionRunner.prototype.run_pass = function(only_readies, info, run_list_name, debuglog) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var promises, brick_id, ci, input, input_ready, source_data, dc_parts, dc_idx, output_info, resolveds, _i, resolveds_1, r;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        promises = [];
                        //console.log("run_pass "+only_readies);
                        for(brick_id in this.run_list[run_list_name]){
                            ci = this.context.bricks[brick_id];
                            if (ci) {
                                for(input in this.run_list[run_list_name][brick_id])if (this.run_list[run_list_name][brick_id][input]) {
                                    input_ready = !only_readies || this.InputReady(ci, input);
                                    if (input_ready) {
                                        source_data = null;
                                        if (ci.dc && debuglog && debuglog.emit_data && Array.isArray(debuglog.emit_data)) {
                                            dc_parts = ci.dc.split((0, _cbutil.DC_JOIN));
                                            dc_idx = Number(dc_parts[dc_parts.length - 1]);
                                            source_data = debuglog.emit_data[dc_idx];
                                        }
                                        output_info = (0, _cbutil.Clone)(info);
                                        //run it
                                        if (output_info.source && ci.blueprint.name == ((_a = this.compos) === null || _a === void 0 ? void 0 : _a.name)) //io
                                        promises.push(ci.run(input, output_info, source_data, debuglog));
                                        else {
                                            output_info.source = "";
                                            output_info.source_output = "@";
                                            promises.push(ci.run(input, output_info, source_data, debuglog));
                                        }
                                    }
                                }
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        resolveds = _b.sent();
                        for(_i = 0, resolveds_1 = resolveds; _i < resolveds_1.length; _i++){
                            r = resolveds_1[_i];
                            if (r) return [
                                2 /*return*/ ,
                                true
                            ];
                        }
                        return [
                            2 /*return*/ ,
                            false
                        ];
                }
            });
        });
    };
    CBCompositionRunner.prototype.InputReady = function(ci, input) {
        if (ci.parsed_ins && ci.parsed_ins[input]) {
            var leaves = ci.parsed_ins[input];
            if (leaves.has_tags) for(var _i = 0, _a = leaves.leaves; _i < _a.length; _i++){
                var leaf = _a[_i];
                for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                    var part = _c[_b];
                    if (part.tag) {
                        if (!this.TagItemReady(ci, part.tag)) return false;
                    }
                }
            }
        }
        return true;
    };
    CBCompositionRunner.prototype.TagItemReady = function(ci, ti) {
        if (ti.type[0] == "p") {
            var s = ti.slice.split(".");
            var source = s[0];
            if (source[0] == "$") return true;
            var nsod = this.nsods[(ci.blueprint.nsid || "") + (ci.dc || "")];
            if (nsod === undefined) return false;
            var output = "@";
            if (s.length > 1 && s[1][0] == "@") output = s[1];
            //the nsod will have the original source name as in the tag (thats what nsod are for)
            if (nsod[source] && nsod[source][output]) return true;
            else return false;
        } else if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
            var i = _a[_i];
            var ready = this.TagItemReady(ci, i);
            if (!ready) return false;
            if (i.type == ",") return ready; // This is for the {{,a}} scenario see "Pre resolve.docx"
        }
        return true;
    };
    CBCompositionRunner.prototype.set_cn_out_data = function(output, value) {
        this.cn_out_data["@" + output] = value;
        if (this.context_codebrick) {
            var emit_obj = {};
            emit_obj["@" + output] = value;
            this.context_codebrick.cb_emit(emit_obj);
        }
    };
    CBCompositionRunner.prototype.print_unresolved = function() {
        console.log("Unresolved:");
        for(var c in this.context.bricks){
            var ci = this.context.bricks[c];
            if (ci.cid != this.cid) continue;
            if (ci.parsed_ins) for(var input in ci.parsed_ins){
                var in_leaves = ci.parsed_ins[input];
                for(var _i = 0, _a = in_leaves.leaves; _i < _a.length; _i++){
                    var leaf = _a[_i];
                    for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                        var part = _c[_b];
                        if (part.tag) {
                            if (part.tag.val === undefined) console.log(" " + ci.brick_id + " input " + input + " tag " + (0, _templateUtilJs.TemplateUtil).UnParseTagItem(part.tag));
                        }
                    }
                }
            }
        }
    };
    CBCompositionRunner.MAX_ITERATIONS_PER_EMIT = 100000;
    return CBCompositionRunner;
}();

},{"./CBFormatting.js":"TabN7","./CBUtil":"1DxvQ","./LeafParser":"lA6Nf","./LinkMapper":"bvAzp","./TemplateUtil.js":"ebZ29","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"TabN7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "codebricks_format", ()=>codebricks_format);
parcelHelpers.export(exports, "setLocale", ()=>setLocale);
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function codebricks_format(value, format, system_options, dont_format_numbers) {
    if (dont_format_numbers === void 0) dont_format_numbers = false;
    try {
        if (format) {
            var base_type = format;
            var base_param_str = "";
            var chain_str = "";
            var open_bracket = 0;
            var is_regexp = false;
            var is_money = false;
            var is_boolean = false;
            for(var i = 0; i < format.length; i++){
                if (format[i] == "(") open_bracket = i;
                else if (open_bracket && format[i] == ")") {
                    base_param_str = format.substring(open_bracket + 1, i);
                    base_type = format.substring(0, open_bracket);
                    chain_str = format.substring(i + 1);
                    break;
                } else if (open_bracket == 0 && format[i] == ".") {
                    base_type = format.substring(0, i);
                    chain_str = format.substring(i + 1);
                    break;
                }
            }
            base_type = base_type.toLowerCase();
            if (value === null || value === undefined || value === "") return {
                value: value,
                type: base_type
            };
            base_param_str = TrimQuotes(base_param_str);
            var formatted_value = value;
            if (base_type == "date") {
                if (system_options.locale) setLocale(system_options.locale);
                if (typeof value == "string") {
                    value.trim();
                    //@ts-expect-error
                    if (!isNaN(value)) value = Number(value);
                }
                if (typeof value == "string" && value.endsWith("Z")) {
                    value = (0, _sugarDefault.default).Date.create(value, {
                        setUTC: true
                    });
                    var timezone_offset = value.getTimezoneOffset();
                    if (system_options.timezone_offset !== undefined) timezone_offset = system_options.timezone_offset;
                    value = (0, _sugarDefault.default).Date.addMinutes(value, -timezone_offset);
                } else value = (0, _sugarDefault.default).Date.create(value);
            } else if (base_type == "datefromutc") {
                if (system_options.locale) setLocale(system_options.locale);
                //let prevalue = value;
                if (typeof value == "string") {
                    value.trim();
                    //@ts-expect-error
                    if (!isNaN(value)) value = Number(value);
                }
                if (typeof value == "string" && value.endsWith("Z")) value = (0, _sugarDefault.default).Date.create(value, {
                    setUTC: true
                });
                else value = (0, _sugarDefault.default).Date.create(value);
                //let startdate = value;
                //console.log("startdate "+startdate);
                //let startstring = Sugar.Date.format(value, "{short} {HH}:{mm}");
                var timezone_offset = value.getTimezoneOffset();
                if (system_options.timezone_offset !== undefined) timezone_offset = system_options.timezone_offset;
                value = (0, _sugarDefault.default).Date.addMinutes(value, -timezone_offset);
                //console.log("date datefromutc "+prevalue+": "+startstring+" ("+startdate+")->"+Sugar.Date.format(value, "{short} {HH}:{mm}")+" ("+value+") timezone_offset "+timezone_offset + " system_options "+JSON.stringify(system_options));
                base_type = "date";
            } else if (base_type == "datetoutc") {
                if (system_options.locale) setLocale(system_options.locale);
                //let prevalue = value;
                if (typeof value == "string") {
                    value.trim();
                    //@ts-expect-error
                    if (!isNaN(value)) value = Number(value);
                }
                if (typeof value == "string" && value.endsWith("Z")) value = (0, _sugarDefault.default).Date.create(value, {
                    setUTC: true
                });
                else value = (0, _sugarDefault.default).Date.create(value);
                //let startdate = value;
                //let startstring = Sugar.Date.format(value, "{short} {HH}:{mm}");
                var timezone_offset = value.getTimezoneOffset();
                if (system_options.timezone_offset !== undefined) timezone_offset = system_options.timezone_offset;
                //value = Sugar.Date.create(value, {setUTC: true});
                value = (0, _sugarDefault.default).Date.addMinutes(value, timezone_offset);
                //console.log("date datetoutc "+prevalue+": "+startstring+" ("+startdate+")->"+Sugar.Date.format(value, "{short} {HH}:{mm}")+" ("+value+") timezone_offset "+timezone_offset + " system_options "+JSON.stringify(system_options));
                base_type = "date";
            } else if (base_type == "number") {
                if (!isNaN(value)) value = Number(value);
            } else if (base_type == "string") value = value + "";
            else if (base_type == "object" || base_type == "array") ;
            else if (base_type == "regexp") {
                value = value + "";
                is_regexp = true;
            } else if (base_type == "money") {
                is_money = true;
                base_type = "number";
            } else if (base_type == "bool") is_boolean = true;
            else //Don't allow execing functions on other types!
            return {
                value: value,
                type: base_type
            };
            if (base_type == "number") {
                if (system_options && system_options.dec_sep) (0, _sugarDefault.default).Number.setOption("decimal", system_options.dec_sep);
                if (system_options && system_options.thousands_sep) (0, _sugarDefault.default).Number.setOption("thousands", system_options.thousands_sep);
            }
            if (chain_str) {
                var chain = getChainFromStr(chain_str); //chain_str.split(".");
                formatted_value = ExecChain(value, chain, 0, is_regexp);
            } else formatted_value = value;
            //Final format:
            if (typeof formatted_value == "object") {
                if (formatted_value._sugar_utc !== undefined) {
                    if (open_bracket && base_param_str) formatted_value = (0, _sugarDefault.default).Date.format(formatted_value, base_param_str);
                    else formatted_value = (0, _sugarDefault.default).Date.format(formatted_value, system_options.date_format);
                }
            } else if (typeof formatted_value == "number") {
                if (base_type != "number" && dont_format_numbers) return {
                    value: formatted_value,
                    type: "number"
                };
                if (open_bracket && base_param_str !== "" && !isNaN(base_param_str)) formatted_value = (0, _sugarDefault.default).Number.format(formatted_value, Number(base_param_str));
                else {
                    var dec_places = system_options.dec_places;
                    if (dec_places === "" || dec_places === null || dec_places === undefined) dec_places = 2;
                    formatted_value = (0, _sugarDefault.default).Number.format(formatted_value, dec_places);
                }
            } else if (typeof formatted_value == "boolean") {
                if (is_boolean) formatted_value = formatted_value == true ? "Yes" : "No";
            }
            if (is_money && system_options.currency_symbol && formatted_value !== "") {
                if (dont_format_numbers) return {
                    value: value,
                    type: "number"
                };
                formatted_value = system_options.currency_symbol + " " + formatted_value;
            }
            return {
                value: formatted_value,
                type: base_type
            };
        } else {
            if (value !== null && !isNaN(value)) return {
                value: value,
                type: "number"
            }; //The tables will text-align:right number, this is the use of the type.
        }
    } catch (err) {
        console.error("Format Error: value " + value + " format " + format + " error: " + err + "; " + err.stack);
    }
    return {
        value: value,
        type: format
    };
}
function TrimQuotes(str) {
    if (str) {
        if (str[0] == "'" || str[0] == '"') return str.substring(1, str.length - 1);
        else if (!isNaN(Number(str))) return Number(str);
    }
    return str;
}
function ExecChain(initial_value, chain, chain_idx, is_regexp) {
    for(var f = chain_idx; f < chain.length; f++){
        initial_value = ExecFuncStr(initial_value, chain[f], is_regexp);
        is_regexp = false;
    }
    return initial_value;
}
function ExecFuncStr(initial_value, func_str, is_regexp) {
    var _a, _b, _c, _d, _e, _f;
    var params_start = func_str.indexOf("(");
    if (params_start > 1) {
        var param_str = func_str.substring(params_start + 1, func_str.length - 1);
        var parray = [];
        if (param_str !== "") parray = param_str.split(",").map(function(item) {
            return TrimQuotes(item.trim());
        });
        var func_name = func_str.substring(0, params_start);
        if (typeof initial_value == "object") {
            if (Array.isArray(initial_value)) {
                if (func_name == "toJSON") return JSON.stringify(initial_value);
                else if (func_name == "toPrettyJSON") return JSON.stringify(initial_value, null, 2);
                ////@ts-expect-error
                // if(!Sugar.Array[func_name]) {
                //     console.error("Formatting function " +func_name+ "() does not exist on Sugar.Array");
                //     return initial_value;
                // }
                //@ts-expect-error
                return (_a = (0, _sugarDefault.default).Array(initial_value))[func_name].apply(_a, parray).raw; //works for Sugar.Array([]).includes("")
            } else if (initial_value._sugar_utc !== undefined) {
                func_name;
                //@ts-expect-error
                return (_b = (0, _sugarDefault.default).Date)[func_name].apply(_b, __spreadArray([
                    initial_value
                ], parray, false));
            } else {
                if (func_name == "toJSON") return JSON.stringify(initial_value);
                else if (func_name == "toPrettyJSON") return JSON.stringify(initial_value, null, 2);
                //@ts-expect-error
                return (_c = (0, _sugarDefault.default).Object)[func_name].apply(_c, __spreadArray([
                    initial_value
                ], parray, false));
            }
        } else if (typeof initial_value == "string") {
            if (is_regexp) //@ts-expect-error
            return (_d = (0, _sugarDefault.default).RegExp)[func_name].apply(_d, __spreadArray([
                initial_value
            ], parray, false));
            else {
                if (func_name == "toLowerCase") return initial_value.toLowerCase();
                else if (func_name == "toUpperCase") return initial_value.toUpperCase();
                //@ts-expect-error
                return (_e = (0, _sugarDefault.default).String)[func_name].apply(_e, __spreadArray([
                    initial_value
                ], parray, false));
            }
        } else if (typeof initial_value == "number") {
            if (func_name == "mult") return initial_value * Number(parray[0]);
            else if (func_name == "toYesNo") return initial_value > 0 ? "Yes" : "No";
            //@ts-expect-error
            return (_f = (0, _sugarDefault.default).Number)[func_name].apply(_f, __spreadArray([
                initial_value
            ], parray, false));
        } else if (typeof initial_value == "boolean") {
            if (func_name == "toYesNo") return initial_value == true ? "Yes" : "No";
        }
    }
    return initial_value;
}
function getChainFromStr(chain_str) {
    //we can't just split on . because for example Number.mutl(0.1)
    var state = 0;
    var ret = [];
    var start = 0;
    for(var i = 0; i < chain_str.length; i++){
        var c = chain_str[i];
        if (c == "." && state == 0) {
            ret.push(chain_str.substring(start, i));
            start = i + 1;
        } else if (c == "(") state++;
        else if (c == ")") state--;
    }
    ret.push(chain_str.substring(start));
    return ret;
}
function setLocale(locale) {
    if (!locale) return;
    if (locale == "en-ZA") {
        var all = (0, _sugarDefault.default).Date.getAllLocaleCodes();
        if (!all.includes(locale)) {
            var locale_obj = Object.create((0, _sugarDefault.default).Date.getLocale("en")); //Clone(Sugar.Date.getLocale("en"));
            locale_obj.code = locale;
            locale_obj.short = "{yyyy}/{MM}/{dd}";
            (0, _sugarDefault.default).Date.addLocale(locale, locale_obj);
        }
    } else if (locale == "en-UK") {
        var all = (0, _sugarDefault.default).Date.getAllLocaleCodes();
        if (!all.includes(locale)) {
            var locale_obj = Object.create((0, _sugarDefault.default).Date.getLocale("en")); // Clone(Sugar.Date.getLocale("en"));
            locale_obj.code = locale;
            locale_obj.short = "{yyyy}-{MM}-{dd}";
            (0, _sugarDefault.default).Date.addLocale(locale, locale_obj);
        }
    }
    (0, _sugarDefault.default).Date.setLocale(locale);
}

},{"sugar":"7Uk8O","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"7Uk8O":[function(require,module,exports) {
"use strict";
require("70ca58b9d4877822");
require("22f89092d89b2441");
require("631a7f4f11beaea0");
require("3c38c0cf754d15ba");
require("8e40910dc292fb9a");
require("dc687b4e05417e73");
require("e023cd4b499bbb67");
require("81fcadce30e95c38");
require("cc5f66a51329f4f9");
module.exports = require("28d13b61bb3316");

},{"70ca58b9d4877822":"fHNEq","22f89092d89b2441":"1pjGL","631a7f4f11beaea0":"834Wz","3c38c0cf754d15ba":"5D1h4","8e40910dc292fb9a":"77ZcU","dc687b4e05417e73":"9Lgs0","e023cd4b499bbb67":"gbc7W","81fcadce30e95c38":"3V9dM","cc5f66a51329f4f9":"6d7XO","28d13b61bb3316":"dZZfL"}],"fHNEq":[function(require,module,exports) {
"use strict";
// Instance Methods
require("cc09d00dab9fe993");
require("d791c8c95d12bb1a");
require("cb5327e06064daa7");
require("96e25ee572141c52");
require("cba79318c85695e3");
require("1e117688ba6f7d8d");
require("615c544b97583949");
require("4d7a95dae6d5ab5b");
require("950e1505829ea5e6");
require("de83d4adb9f93885");
require("97c0212df6ab5ef3");
require("a75394d96be50c90");
require("80e0b2b6451b7c88");
require("2b46c31e9139cbb");
require("65b5d19ca00cbb8");
require("c2aaaed9ca362ffa");
require("3619c1f49dfdc6");
require("6dd3c3785f02f9ae");
require("1d38ccd9f80a7e88");
require("6b3f9653e8128de0");
require("1fc3cc51f64f0083");
require("b0bd009e48d737fc");
require("5327712118889a50");
require("494e41d4411d7a40");
require("ceb2c6f324792c3");
require("57b7402e5b3a7365");
require("76ba1ce7033cd2ed");
require("855cb688c99c006d");
require("dfeee19d5e2d4ea5");
require("bc4442b5d6c0af6");
require("61723c34c79da8d0");
require("51c3be4ab69b65c0");
require("a4f8408e6321aacd");
require("4861c9d66c2a7c5");
require("39677ad59837afd4");
require("81f68958f9a14682");
require("c139dda44ff08335");
require("51e8b66fa8839bad");
require("8f5e89c9acdf4815");
require("a9ac7e6bfcd1784b");
require("5b4d60b4b6754384");
require("416084179eb20175");
require("a57fa75d4e536b9f");
require("7caf1a94ab0d7b17");
module.exports = require("8300e83c5f88b88c");

},{"cc09d00dab9fe993":"b4IwE","d791c8c95d12bb1a":"dYSbm","cb5327e06064daa7":"9HBfU","96e25ee572141c52":"6sKyh","cba79318c85695e3":"cFFLP","1e117688ba6f7d8d":"dolUN","615c544b97583949":"7FelE","4d7a95dae6d5ab5b":"dU1GP","950e1505829ea5e6":"3Xf9D","de83d4adb9f93885":"5v1f4","97c0212df6ab5ef3":"03zWG","a75394d96be50c90":"jhoDm","80e0b2b6451b7c88":"649xU","2b46c31e9139cbb":"7M1ZS","65b5d19ca00cbb8":"dmeNj","c2aaaed9ca362ffa":"3o9t5","3619c1f49dfdc6":"cHVBw","6dd3c3785f02f9ae":"37Udv","1d38ccd9f80a7e88":"k5H2K","6b3f9653e8128de0":"eXrHR","1fc3cc51f64f0083":"5sY5x","b0bd009e48d737fc":"8zOEG","5327712118889a50":"9e17D","494e41d4411d7a40":"jn9lF","ceb2c6f324792c3":"dc8If","57b7402e5b3a7365":"9MfUj","76ba1ce7033cd2ed":"e4N9o","855cb688c99c006d":"7RyVd","dfeee19d5e2d4ea5":"eK4U3","bc4442b5d6c0af6":"kmbZe","61723c34c79da8d0":"5GWKU","51c3be4ab69b65c0":"11mev","a4f8408e6321aacd":"hVxWi","4861c9d66c2a7c5":"dL8J6","39677ad59837afd4":"4tWEs","81f68958f9a14682":"dUX9R","c139dda44ff08335":"3ux2T","51e8b66fa8839bad":"6GQ1V","8f5e89c9acdf4815":"lnzWu","a9ac7e6bfcd1784b":"kMYtv","5b4d60b4b6754384":"gQks3","416084179eb20175":"75BLD","a57fa75d4e536b9f":"g5DqP","7caf1a94ab0d7b17":"b2qoN","8300e83c5f88b88c":"dZZfL"}],"b4IwE":[function(require,module,exports) {
"use strict";
var Sugar = require("8d315968df362ae4"), getEntriesForIndexes = require("6c2a176c12e24dc3");
Sugar.String.defineInstance({
    "at": function(str, index, loop) {
        return getEntriesForIndexes(str, index, loop, true);
    }
});
module.exports = Sugar.String.at;

},{"8d315968df362ae4":"dZZfL","6c2a176c12e24dc3":"8OkFj"}],"dZZfL":[function(require,module,exports) {
var global = arguments[3];
/*
 *  Sugar v2.0.6
 *
 *  Freely distributable and licensed under the MIT-style license.
 *  Copyright (c) Andrew Plummer
 *  https://sugarjs.com/
 *
 * ---------------------------- */ (function() {
    "use strict";
    /***
   * @module Core
   * @description Core functionality including the ability to define methods and
   *              extend onto natives.
   *
   ***/ // The global to export.
    var Sugar;
    // The name of Sugar in the global namespace.
    var SUGAR_GLOBAL = "Sugar";
    // Natives available on initialization. Letting Object go first to ensure its
    // global is set by the time the rest are checking for chainable Object methods.
    var NATIVE_NAMES = "Object Number String Array Date RegExp Function";
    // Static method flag
    var STATIC = 0x1;
    // Instance method flag
    var INSTANCE = 0x2;
    // IE8 has a broken defineProperty but no defineProperties so this saves a try/catch.
    var PROPERTY_DESCRIPTOR_SUPPORT = !!(Object.defineProperty && Object.defineProperties);
    var globalContext = getGlobal();
    // Whether object instance methods can be mapped to the prototype.
    var allowObjectPrototype = false;
    // A map from Array to SugarArray.
    var namespacesByName = {};
    // A map from [object Object] to namespace.
    var namespacesByClassString = {};
    // Defining properties.
    // istanbul ignore next
    var defineProperty = PROPERTY_DESCRIPTOR_SUPPORT ? Object.defineProperty : definePropertyShim;
    // A default chainable class for unknown types.
    var DefaultChainable = getNewChainableClass("Chainable");
    // Global methods
    function getGlobal() {
        // Get global context by keyword here to avoid issues with libraries
        // that can potentially alter this script's context object.
        return testGlobal(typeof global !== "undefined" && global) || testGlobal(typeof window !== "undefined" && window);
    }
    function testGlobal(obj) {
        // Note that Rhino uses a different "global" keyword so perform an
        // extra check here to ensure that it's actually the global object.
        return obj && obj.Object === Object ? obj : null;
    }
    function setupGlobal() {
        Sugar = globalContext[SUGAR_GLOBAL];
        // istanbul ignore if
        if (Sugar) // Reuse already defined Sugar global object.
        return;
        Sugar = function(arg) {
            forEachProperty(Sugar, function(sugarNamespace, name) {
                // Although only the only enumerable properties on the global
                // object are Sugar namespaces, environments that can't set
                // non-enumerable properties will step through the utility methods
                // as well here, so use this check to only allow true namespaces.
                if (hasOwn(namespacesByName, name)) sugarNamespace.extend(arg);
            });
            return Sugar;
        };
        // istanbul ignore else
        if (0, module.exports) // Node or webpack environment
        module.exports = Sugar;
        else // Unwrapped browser environment
        try {
            globalContext[SUGAR_GLOBAL] = Sugar;
        } catch (e) {
        // Contexts such as QML have a read-only global context.
        }
        forEachProperty(NATIVE_NAMES.split(" "), function(name) {
            createNamespace(name);
        });
        setGlobalProperties();
    }
    /***
   * @method createNamespace(name)
   * @returns SugarNamespace
   * @namespace Sugar
   * @short Creates a new Sugar namespace.
   * @extra This method is for plugin developers who want to define methods to be
   *        used with natives that Sugar does not handle by default. The new
   *        namespace will appear on the `Sugar` global with all the methods of
   *        normal namespaces, including the ability to define new methods. When
   *        extended, any defined methods will be mapped to `name` in the global
   *        context.
   *
   * @example
   *
   *   Sugar.createNamespace('Boolean');
   *
   * @param {string} name - The namespace name.
   *
   ***/ function createNamespace(name) {
        // Is the current namespace Object?
        var isObject = name === "Object";
        // A Sugar namespace is also a chainable class: Sugar.Array, etc.
        var sugarNamespace = getNewChainableClass(name, true);
        /***
     * @method extend([opts])
     * @returns Sugar
     * @namespace Sugar
     * @short Extends Sugar defined methods onto natives.
     * @extra This method can be called on individual namespaces like
     *        `Sugar.Array` or on the `Sugar` global itself, in which case
     *        [opts] will be forwarded to each `extend` call. For more,
     *        see `extending`.
     *
     * @options
     *
     *   methods           An array of method names to explicitly extend.
     *
     *   except            An array of method names or global namespaces (`Array`,
     *                     `String`) to explicitly exclude. Namespaces should be the
     *                     actual global objects, not strings.
     *
     *   namespaces        An array of global namespaces (`Array`, `String`) to
     *                     explicitly extend. Namespaces should be the actual
     *                     global objects, not strings.
     *
     *   enhance           A shortcut to disallow all "enhance" flags at once
     *                     (flags listed below). For more, see `enhanced methods`.
     *                     Default is `true`.
     *
     *   enhanceString     A boolean allowing String enhancements. Default is `true`.
     *
     *   enhanceArray      A boolean allowing Array enhancements. Default is `true`.
     *
     *   objectPrototype   A boolean allowing Sugar to extend Object.prototype
     *                     with instance methods. This option is off by default
     *                     and should generally not be used except with caution.
     *                     For more, see `object methods`.
     *
     * @example
     *
     *   Sugar.Array.extend();
     *   Sugar.extend();
     *
     * @option {Array<string>} [methods]
     * @option {Array<string|NativeConstructor>} [except]
     * @option {Array<NativeConstructor>} [namespaces]
     * @option {boolean} [enhance]
     * @option {boolean} [enhanceString]
     * @option {boolean} [enhanceArray]
     * @option {boolean} [objectPrototype]
     * @param {ExtendOptions} [opts]
     *
     ***
     * @method extend([opts])
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Extends Sugar defined methods for a specific namespace onto natives.
     * @param {ExtendOptions} [opts]
     *
     ***/ var extend = function extend(opts) {
            var nativeClass = globalContext[name], nativeProto = nativeClass.prototype;
            var staticMethods = {}, instanceMethods = {}, methodsByName;
            function objectRestricted(name, target) {
                return isObject && target === nativeProto && (!allowObjectPrototype || name === "get" || name === "set");
            }
            function arrayOptionExists(field, val) {
                var arr = opts[field];
                if (arr) for(var i = 0, el; el = arr[i]; i++){
                    if (el === val) return true;
                }
                return false;
            }
            function arrayOptionExcludes(field, val) {
                return opts[field] && !arrayOptionExists(field, val);
            }
            function disallowedByFlags(methodName, target, flags) {
                // Disallowing methods by flag currently only applies if methods already
                // exist to avoid enhancing native methods, as aliases should still be
                // extended (i.e. Array#all should still be extended even if Array#every
                // is being disallowed by a flag).
                if (!target[methodName] || !flags) return false;
                for(var i = 0; i < flags.length; i++){
                    if (opts[flags[i]] === false) return true;
                }
            }
            function namespaceIsExcepted() {
                return arrayOptionExists("except", nativeClass) || arrayOptionExcludes("namespaces", nativeClass);
            }
            function methodIsExcepted(methodName) {
                return arrayOptionExists("except", methodName);
            }
            function canExtend(methodName, method, target) {
                return !objectRestricted(methodName, target) && !disallowedByFlags(methodName, target, method.flags) && !methodIsExcepted(methodName);
            }
            opts = opts || {};
            methodsByName = opts.methods;
            if (namespaceIsExcepted()) return;
            else if (isObject && typeof opts.objectPrototype === "boolean") // Store "objectPrototype" flag for future reference.
            allowObjectPrototype = opts.objectPrototype;
            forEachProperty(methodsByName || sugarNamespace, function(method, methodName) {
                if (methodsByName) {
                    // If we have method names passed in an array,
                    // then we need to flip the key and value here
                    // and find the method in the Sugar namespace.
                    methodName = method;
                    method = sugarNamespace[methodName];
                }
                if (hasOwn(method, "instance") && canExtend(methodName, method, nativeProto)) instanceMethods[methodName] = method.instance;
                if (hasOwn(method, "static") && canExtend(methodName, method, nativeClass)) staticMethods[methodName] = method;
            });
            // Accessing the extend target each time instead of holding a reference as
            // it may have been overwritten (for example Date by Sinon). Also need to
            // access through the global to allow extension of user-defined namespaces.
            extendNative(nativeClass, staticMethods);
            extendNative(nativeProto, instanceMethods);
            if (!methodsByName) // If there are no method names passed, then
            // all methods in the namespace will be extended
            // to the native. This includes all future defined
            // methods, so add a flag here to check later.
            setProperty(sugarNamespace, "active", true);
            return sugarNamespace;
        };
        function defineWithOptionCollect(methodName, instance, args) {
            setProperty(sugarNamespace, methodName, function(arg1, arg2, arg3) {
                var opts = collectDefineOptions(arg1, arg2, arg3);
                defineMethods(sugarNamespace, opts.methods, instance, args, opts.last);
                return sugarNamespace;
            });
        }
        /***
     * @method defineStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods on the namespace that can later be extended
     *        onto the native globals.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. If `extend` was previously called
     *        with no arguments, the method will be immediately mapped to its
     *        native when defined.
     *
     * @example
     *
     *   Sugar.Number.defineStatic({
     *     isOdd: function (num) {
     *       return num % 2 === 1;
     *     }
     *   });
     *
     * @signature defineStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineStatic", STATIC);
        /***
     * @method defineInstance(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines methods on the namespace that can later be extended as
     *        instance methods onto the native prototype.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. All functions should accept the
     *        native for which they are mapped as their first argument, and should
     *        never refer to `this`. If `extend` was previously called with no
     *        arguments, the method will be immediately mapped to its native when
     *        defined.
     *
     *        Methods cannot accept more than 4 arguments in addition to the
     *        native (5 arguments total). Any additional arguments will not be
     *        mapped. If the method needs to accept unlimited arguments, use
     *        `defineInstanceWithArguments`. Otherwise if more options are
     *        required, use an options object instead.
     *
     * @example
     *
     *   Sugar.Number.defineInstance({
     *     square: function (num) {
     *       return num * num;
     *     }
     *   });
     *
     * @signature defineInstance(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineInstance", INSTANCE);
        /***
     * @method defineInstanceAndStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short A shortcut to define both static and instance methods on the namespace.
     * @extra This method is intended for use with `Object` instance methods. Sugar
     *        will not map any methods to `Object.prototype` by default, so defining
     *        instance methods as static helps facilitate their proper use.
     *
     * @example
     *
     *   Sugar.Object.defineInstanceAndStatic({
     *     isAwesome: function (obj) {
     *       // check if obj is awesome!
     *     }
     *   });
     *
     * @signature defineInstanceAndStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineInstanceAndStatic", INSTANCE | STATIC);
        /***
     * @method defineStaticWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that collect arguments.
     * @extra This method is identical to `defineStatic`, except that when defined
     *        methods are called, they will collect any arguments past `n - 1`,
     *        where `n` is the number of arguments that the method accepts.
     *        Collected arguments will be passed to the method in an array
     *        as the last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineStaticWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineStaticWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineStaticWithArguments", STATIC, true);
        /***
     * @method defineInstanceWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that collect arguments.
     * @extra This method is identical to `defineInstance`, except that when
     *        defined methods are called, they will collect any arguments past
     *        `n - 1`, where `n` is the number of arguments that the method
     *        accepts. Collected arguments will be passed to the method as the
     *        last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineInstanceWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineInstanceWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineInstanceWithArguments", INSTANCE, true);
        /***
     * @method defineStaticPolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that are mapped onto the native if they do
     *        not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. Note that polyfill methods will
     *        be immediately mapped onto their native prototype regardless of the
     *        use of `extend`.
     *
     * @example
     *
     *   Sugar.Object.defineStaticPolyfill({
     *     keys: function (obj) {
     *       // get keys!
     *     }
     *   });
     *
     * @signature defineStaticPolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ setProperty(sugarNamespace, "defineStaticPolyfill", function(arg1, arg2, arg3) {
            var opts = collectDefineOptions(arg1, arg2, arg3);
            extendNative(globalContext[name], opts.methods, true, opts.last);
            return sugarNamespace;
        });
        /***
     * @method defineInstancePolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that are mapped onto the native prototype
     *        if they do not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. This method differs from
     *        `defineInstance` as there is no static signature (as the method
     *        is mapped as-is to the native), so it should refer to its `this`
     *        object. Note that polyfill methods will be immediately mapped onto
     *        their native prototype regardless of the use of `extend`.
     *
     * @example
     *
     *   Sugar.Array.defineInstancePolyfill({
     *     indexOf: function (arr, el) {
     *       // index finding code here!
     *     }
     *   });
     *
     * @signature defineInstancePolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ setProperty(sugarNamespace, "defineInstancePolyfill", function(arg1, arg2, arg3) {
            var opts = collectDefineOptions(arg1, arg2, arg3);
            extendNative(globalContext[name].prototype, opts.methods, true, opts.last);
            // Map instance polyfills to chainable as well.
            forEachProperty(opts.methods, function(fn, methodName) {
                defineChainableMethod(sugarNamespace, methodName, fn);
            });
            return sugarNamespace;
        });
        /***
     * @method alias(toName, from)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Aliases one Sugar method to another.
     *
     * @example
     *
     *   Sugar.Array.alias('all', 'every');
     *
     * @signature alias(toName, fn)
     * @param {string} toName - Name for new method.
     * @param {string|Function} from - Method to alias, or string shortcut.
     ***/ setProperty(sugarNamespace, "alias", function(name, source) {
            var method = typeof source === "string" ? sugarNamespace[source] : source;
            setMethod(sugarNamespace, name, method);
            return sugarNamespace;
        });
        // Each namespace can extend only itself through its .extend method.
        setProperty(sugarNamespace, "extend", extend);
        // Cache the class to namespace relationship for later use.
        namespacesByName[name] = sugarNamespace;
        namespacesByClassString["[object " + name + "]"] = sugarNamespace;
        mapNativeToChainable(name);
        mapObjectChainablesToNamespace(sugarNamespace);
        // Export
        return Sugar[name] = sugarNamespace;
    }
    function setGlobalProperties() {
        setProperty(Sugar, "VERSION", "2.0.6");
        setProperty(Sugar, "extend", Sugar);
        setProperty(Sugar, "toString", toString);
        setProperty(Sugar, "createNamespace", createNamespace);
        setProperty(Sugar, "util", {
            "hasOwn": hasOwn,
            "getOwn": getOwn,
            "setProperty": setProperty,
            "classToString": classToString,
            "defineProperty": defineProperty,
            "forEachProperty": forEachProperty,
            "mapNativeToChainable": mapNativeToChainable
        });
    }
    function toString() {
        return SUGAR_GLOBAL;
    }
    // Defining Methods
    function defineMethods(sugarNamespace, methods, type, args, flags) {
        forEachProperty(methods, function(method, methodName) {
            var instanceMethod, staticMethod = method;
            if (args) staticMethod = wrapMethodWithArguments(method);
            if (flags) staticMethod.flags = flags;
            // A method may define its own custom implementation, so
            // make sure that's not the case before creating one.
            if (type & INSTANCE && !method.instance) {
                instanceMethod = wrapInstanceMethod(method, args);
                setProperty(staticMethod, "instance", instanceMethod);
            }
            if (type & STATIC) setProperty(staticMethod, "static", true);
            setMethod(sugarNamespace, methodName, staticMethod);
            if (sugarNamespace.active) // If the namespace has been activated (.extend has been called),
            // then map this method as well.
            sugarNamespace.extend(methodName);
        });
    }
    function collectDefineOptions(arg1, arg2, arg3) {
        var methods, last;
        if (typeof arg1 === "string") {
            methods = {};
            methods[arg1] = arg2;
            last = arg3;
        } else {
            methods = arg1;
            last = arg2;
        }
        return {
            last: last,
            methods: methods
        };
    }
    function wrapInstanceMethod(fn, args) {
        return args ? wrapMethodWithArguments(fn, true) : wrapInstanceMethodFixed(fn);
    }
    function wrapMethodWithArguments(fn, instance) {
        // Functions accepting enumerated arguments will always have "args" as the
        // last argument, so subtract one from the function length to get the point
        // at which to start collecting arguments. If this is an instance method on
        // a prototype, then "this" will be pushed into the arguments array so start
        // collecting 1 argument earlier.
        var startCollect = fn.length - 1 - (instance ? 1 : 0);
        return function() {
            var args = [], collectedArgs = [], len;
            if (instance) args.push(this);
            len = Math.max(arguments.length, startCollect);
            // Optimized: no leaking arguments
            for(var i = 0; i < len; i++)if (i < startCollect) args.push(arguments[i]);
            else collectedArgs.push(arguments[i]);
            args.push(collectedArgs);
            return fn.apply(this, args);
        };
    }
    function wrapInstanceMethodFixed(fn) {
        switch(fn.length){
            // Wrapped instance methods will always be passed the instance
            // as the first argument, but requiring the argument to be defined
            // may cause confusion here, so return the same wrapped function regardless.
            case 0:
            case 1:
                return function() {
                    return fn(this);
                };
            case 2:
                return function(a) {
                    return fn(this, a);
                };
            case 3:
                return function(a, b) {
                    return fn(this, a, b);
                };
            case 4:
                return function(a, b, c) {
                    return fn(this, a, b, c);
                };
            case 5:
                return function(a, b, c, d) {
                    return fn(this, a, b, c, d);
                };
        }
    }
    // Method helpers
    function extendNative(target, source, polyfill, override) {
        forEachProperty(source, function(method, name) {
            if (polyfill && !override && target[name]) // Method exists, so bail.
            return;
            setProperty(target, name, method);
        });
    }
    function setMethod(sugarNamespace, methodName, method) {
        sugarNamespace[methodName] = method;
        if (method.instance) defineChainableMethod(sugarNamespace, methodName, method.instance, true);
    }
    // Chainables
    function getNewChainableClass(name) {
        var fn = function SugarChainable(obj, arg) {
            if (!(this instanceof fn)) return new fn(obj, arg);
            if (this.constructor !== fn) // Allow modules to define their own constructors.
            obj = this.constructor.apply(obj, arguments);
            this.raw = obj;
        };
        setProperty(fn, "toString", function() {
            return SUGAR_GLOBAL + name;
        });
        setProperty(fn.prototype, "valueOf", function() {
            return this.raw;
        });
        return fn;
    }
    function defineChainableMethod(sugarNamespace, methodName, fn) {
        var wrapped = wrapWithChainableResult(fn), existing, collision, dcp;
        dcp = DefaultChainable.prototype;
        existing = dcp[methodName];
        // If the method was previously defined on the default chainable, then a
        // collision exists, so set the method to a disambiguation function that will
        // lazily evaluate the object and find it's associated chainable. An extra
        // check is required to avoid false positives from Object inherited methods.
        collision = existing && existing !== Object.prototype[methodName];
        // The disambiguation function is only required once.
        if (!existing || !existing.disambiguate) dcp[methodName] = collision ? disambiguateMethod(methodName) : wrapped;
        // The target chainable always receives the wrapped method. Additionally,
        // if the target chainable is Sugar.Object, then map the wrapped method
        // to all other namespaces as well if they do not define their own method
        // of the same name. This way, a Sugar.Number will have methods like
        // isEqual that can be called on any object without having to traverse up
        // the prototype chain and perform disambiguation, which costs cycles.
        // Note that the "if" block below actually does nothing on init as Object
        // goes first and no other namespaces exist yet. However it needs to be
        // here as Object instance methods defined later also need to be mapped
        // back onto existing namespaces.
        sugarNamespace.prototype[methodName] = wrapped;
        if (sugarNamespace === Sugar.Object) mapObjectChainableToAllNamespaces(methodName, wrapped);
    }
    function mapObjectChainablesToNamespace(sugarNamespace) {
        forEachProperty(Sugar.Object && Sugar.Object.prototype, function(val, methodName) {
            if (typeof val === "function") setObjectChainableOnNamespace(sugarNamespace, methodName, val);
        });
    }
    function mapObjectChainableToAllNamespaces(methodName, fn) {
        forEachProperty(namespacesByName, function(sugarNamespace) {
            setObjectChainableOnNamespace(sugarNamespace, methodName, fn);
        });
    }
    function setObjectChainableOnNamespace(sugarNamespace, methodName, fn) {
        var proto = sugarNamespace.prototype;
        if (!hasOwn(proto, methodName)) proto[methodName] = fn;
    }
    function wrapWithChainableResult(fn) {
        return function() {
            return new DefaultChainable(fn.apply(this.raw, arguments));
        };
    }
    function disambiguateMethod(methodName) {
        var fn = function fn() {
            var raw = this.raw, sugarNamespace;
            if (raw != null) // Find the Sugar namespace for this unknown.
            sugarNamespace = namespacesByClassString[classToString(raw)];
            if (!sugarNamespace) // If no sugarNamespace can be resolved, then default
            // back to Sugar.Object so that undefined and other
            // non-supported types can still have basic object
            // methods called on them, such as type checks.
            sugarNamespace = Sugar.Object;
            return new sugarNamespace(raw)[methodName].apply(this, arguments);
        };
        fn.disambiguate = true;
        return fn;
    }
    function mapNativeToChainable(name, methodNames) {
        var sugarNamespace = namespacesByName[name], nativeProto = globalContext[name].prototype;
        if (!methodNames && ownPropertyNames) methodNames = ownPropertyNames(nativeProto);
        forEachProperty(methodNames, function(methodName) {
            if (nativeMethodProhibited(methodName)) // Sugar chainables have their own constructors as well as "valueOf"
            // methods, so exclude them here. The __proto__ argument should be trapped
            // by the function check below, however simply accessing this property on
            // Object.prototype causes QML to segfault, so pre-emptively excluding it.
            return;
            try {
                var fn = nativeProto[methodName];
                if (typeof fn !== "function") // Bail on anything not a function.
                return;
            } catch (e) {
                // Function.prototype has properties that
                // will throw errors when accessed.
                return;
            }
            defineChainableMethod(sugarNamespace, methodName, fn);
        });
    }
    function nativeMethodProhibited(methodName) {
        return methodName === "constructor" || methodName === "valueOf" || methodName === "__proto__";
    }
    // Util
    // Internal references
    var ownPropertyNames = Object.getOwnPropertyNames, internalToString = Object.prototype.toString, internalHasOwnProperty = Object.prototype.hasOwnProperty;
    // Defining this as a variable here as the ES5 module
    // overwrites it to patch DONTENUM.
    var forEachProperty = function forEachProperty(obj, fn) {
        for(var key in obj){
            if (!hasOwn(obj, key)) continue;
            if (fn.call(obj, obj[key], key, obj) === false) break;
        }
    };
    // istanbul ignore next
    function definePropertyShim(obj, prop, descriptor) {
        obj[prop] = descriptor.value;
    }
    function setProperty(target, name, value, enumerable) {
        defineProperty(target, name, {
            value: value,
            enumerable: !!enumerable,
            configurable: true,
            writable: true
        });
    }
    // PERF: Attempts to speed this method up get very Heisenbergy. Quickly
    // returning based on typeof works for primitives, but slows down object
    // types. Even === checks on null and undefined (no typeof) will end up
    // basically breaking even. This seems to be as fast as it can go.
    function classToString(obj) {
        return internalToString.call(obj);
    }
    function hasOwn(obj, prop) {
        return !!obj && internalHasOwnProperty.call(obj, prop);
    }
    function getOwn(obj, prop) {
        if (hasOwn(obj, prop)) return obj[prop];
    }
    setupGlobal();
    /***
   * @module Common
   * @description Internal utility and common methods.
   ***/ // Flag allowing native methods to be enhanced.
    var ENHANCEMENTS_FLAG = "enhance";
    // For type checking, etc. Excludes object as this is more nuanced.
    var NATIVE_TYPES = "Boolean Number String Date RegExp Function Array Error Set Map";
    // Do strings have no keys?
    var NO_KEYS_IN_STRING_OBJECTS = !("0" in Object("a"));
    // Prefix for private properties.
    var PRIVATE_PROP_PREFIX = "_sugar_";
    // Matches 1..2 style ranges in properties.
    var PROPERTY_RANGE_REG = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;
    // WhiteSpace/LineTerminator as defined in ES5.1 plus Unicode characters in the Space, Separator category.
    var TRIM_CHARS = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF";
    // Regex for matching a formatted string.
    var STRING_FORMAT_REG = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;
    // Common chars
    var HALF_WIDTH_ZERO = 0x30, FULL_WIDTH_ZERO = 0xff10, HALF_WIDTH_PERIOD = ".", FULL_WIDTH_PERIOD = "\uFF0E", HALF_WIDTH_COMMA = ",", OPEN_BRACE = "{", CLOSE_BRACE = "}";
    // Namespace aliases
    var sugarObject = Sugar.Object, sugarArray = Sugar.Array, sugarDate = Sugar.Date, sugarString = Sugar.String, sugarNumber = Sugar.Number, sugarFunction = Sugar.Function, sugarRegExp = Sugar.RegExp;
    // Class checks
    var isSerializable, isBoolean, isNumber, isString, isDate, isRegExp, isFunction, isArray, isSet, isMap, isError;
    function buildClassChecks() {
        var knownTypes = {};
        function addCoreTypes() {
            var names = spaceSplit(NATIVE_TYPES);
            isBoolean = buildPrimitiveClassCheck(names[0]);
            isNumber = buildPrimitiveClassCheck(names[1]);
            isString = buildPrimitiveClassCheck(names[2]);
            isDate = buildClassCheck(names[3]);
            isRegExp = buildClassCheck(names[4]);
            // Wanted to enhance performance here by using simply "typeof"
            // but Firefox has two major issues that make this impossible,
            // one fixed, the other not, so perform a full class check here.
            //
            // 1. Regexes can be typeof "function" in FF < 3
            //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
            //
            // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
            //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
            isFunction = buildClassCheck(names[5]);
            // istanbul ignore next
            isArray = Array.isArray || buildClassCheck(names[6]);
            isError = buildClassCheck(names[7]);
            isSet = buildClassCheck(names[8], typeof Set !== "undefined" && Set);
            isMap = buildClassCheck(names[9], typeof Map !== "undefined" && Map);
            // Add core types as known so that they can be checked by value below,
            // notably excluding Functions and adding Arguments and Error.
            addKnownType("Arguments");
            addKnownType(names[0]);
            addKnownType(names[1]);
            addKnownType(names[2]);
            addKnownType(names[3]);
            addKnownType(names[4]);
            addKnownType(names[6]);
        }
        function addArrayTypes() {
            var types = "Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64";
            forEach(spaceSplit(types), function(str) {
                addKnownType(str + "Array");
            });
        }
        function addKnownType(className) {
            var str = "[object " + className + "]";
            knownTypes[str] = true;
        }
        function isKnownType(className) {
            return knownTypes[className];
        }
        function buildClassCheck(className, globalObject) {
            // istanbul ignore if
            if (globalObject && isClass(new globalObject, "Object")) return getConstructorClassCheck(globalObject);
            else return getToStringClassCheck(className);
        }
        // Map and Set may be [object Object] in certain IE environments.
        // In this case we need to perform a check using the constructor
        // instead of Object.prototype.toString.
        // istanbul ignore next
        function getConstructorClassCheck(obj) {
            var ctorStr = String(obj);
            return function(obj) {
                return String(obj.constructor) === ctorStr;
            };
        }
        function getToStringClassCheck(className) {
            return function(obj, str) {
                // perf: Returning up front on instanceof appears to be slower.
                return isClass(obj, className, str);
            };
        }
        function buildPrimitiveClassCheck(className) {
            var type = className.toLowerCase();
            return function(obj) {
                var t = typeof obj;
                return t === type || t === "object" && isClass(obj, className);
            };
        }
        addCoreTypes();
        addArrayTypes();
        isSerializable = function isSerializable(obj, className) {
            // Only known objects can be serialized. This notably excludes functions,
            // host objects, Symbols (which are matched by reference), and instances
            // of classes. The latter can arguably be matched by value, but
            // distinguishing between these and host objects -- which should never be
            // compared by value -- is very tricky so not dealing with it here.
            return isKnownType(className) || isPlainObject(obj, className);
        };
    }
    function isClass(obj, className, str) {
        if (!str) str = classToString(obj);
        return str === "[object " + className + "]";
    }
    // Wrapping the core's "define" methods to
    // save a few bytes in the minified script.
    function wrapNamespace(method) {
        return function(sugarNamespace, arg1, arg2) {
            sugarNamespace[method](arg1, arg2);
        };
    }
    // Method define aliases
    var alias = wrapNamespace("alias"), defineStatic = wrapNamespace("defineStatic"), defineInstance = wrapNamespace("defineInstance"), defineStaticPolyfill = wrapNamespace("defineStaticPolyfill"), defineInstancePolyfill = wrapNamespace("defineInstancePolyfill"), defineInstanceAndStatic = wrapNamespace("defineInstanceAndStatic"), defineInstanceWithArguments = wrapNamespace("defineInstanceWithArguments");
    function defineInstanceSimilar(sugarNamespace, set, fn, flags) {
        defineInstance(sugarNamespace, collectSimilarMethods(set, fn), flags);
    }
    function defineInstanceAndStaticSimilar(sugarNamespace, set, fn, flags) {
        defineInstanceAndStatic(sugarNamespace, collectSimilarMethods(set, fn), flags);
    }
    function collectSimilarMethods(set, fn) {
        var methods = {};
        if (isString(set)) set = spaceSplit(set);
        forEach(set, function(el, i) {
            fn(methods, el, i);
        });
        return methods;
    }
    // This song and dance is to fix methods to a different length
    // from what they actually accept in order to stay in line with
    // spec. Additionally passing argument length, as some methods
    // throw assertion errors based on this (undefined check is not
    // enough). Fortunately for now spec is such that passing 3
    // actual arguments covers all requirements. Note that passing
    // the argument length also forces the compiler to not rewrite
    // length of the compiled function.
    function fixArgumentLength(fn) {
        var staticFn = function staticFn(a) {
            var args = arguments;
            return fn(a, args[1], args[2], args.length - 1);
        };
        staticFn.instance = function(b) {
            var args = arguments;
            return fn(this, b, args[1], args.length);
        };
        return staticFn;
    }
    function defineAccessor(namespace, name, fn) {
        setProperty(namespace, name, fn);
    }
    function defineOptionsAccessor(namespace, defaults) {
        var obj = simpleClone(defaults);
        function getOption(name) {
            return obj[name];
        }
        function setOption(arg1, arg2) {
            var options;
            if (arguments.length === 1) options = arg1;
            else {
                options = {};
                options[arg1] = arg2;
            }
            forEachProperty(options, function(val, name) {
                if (val === null) val = defaults[name];
                obj[name] = val;
            });
        }
        defineAccessor(namespace, "getOption", getOption);
        defineAccessor(namespace, "setOption", setOption);
        return getOption;
    }
    // For methods defined directly on the prototype like Range
    function defineOnPrototype(ctor, methods) {
        var proto = ctor.prototype;
        forEachProperty(methods, function(val, key) {
            proto[key] = val;
        });
    }
    // Argument helpers
    function assertArgument(exists) {
        if (!exists) throw new TypeError("Argument required");
    }
    function assertCallable(obj) {
        if (!isFunction(obj)) throw new TypeError("Function is not callable");
    }
    function assertArray(obj) {
        if (!isArray(obj)) throw new TypeError("Array required");
    }
    function assertWritable(obj) {
        if (isPrimitive(obj)) // If strict mode is active then primitives will throw an
        // error when attempting to write properties. We can't be
        // sure if strict mode is available, so pre-emptively
        // throw an error here to ensure consistent behavior.
        throw new TypeError("Property cannot be written");
    }
    // Coerces an object to a positive integer.
    // Does not allow Infinity.
    function coercePositiveInteger(n) {
        n = +n || 0;
        if (n < 0 || !isNumber(n) || !isFinite(n)) throw new RangeError("Invalid number");
        return trunc(n);
    }
    // General helpers
    function isDefined(o) {
        return o !== undefined;
    }
    function isUndefined(o) {
        return o === undefined;
    }
    function privatePropertyAccessor(key) {
        var privateKey = PRIVATE_PROP_PREFIX + key;
        return function(obj, val) {
            if (arguments.length > 1) {
                setProperty(obj, privateKey, val);
                return obj;
            }
            return obj[privateKey];
        };
    }
    function setChainableConstructor(sugarNamespace, createFn) {
        sugarNamespace.prototype.constructor = function() {
            return createFn.apply(this, arguments);
        };
    }
    // Fuzzy matching helpers
    function getMatcher(f) {
        if (!isPrimitive(f)) {
            var className = classToString(f);
            if (isRegExp(f, className)) return regexMatcher(f);
            else if (isDate(f, className)) return dateMatcher(f);
            else if (isFunction(f, className)) return functionMatcher(f);
            else if (isPlainObject(f, className)) return fuzzyMatcher(f);
        }
        // Default is standard isEqual
        return defaultMatcher(f);
    }
    function fuzzyMatcher(obj) {
        var matchers = {};
        return function(el, i, arr) {
            var matched = true;
            if (!isObjectType(el)) return false;
            forEachProperty(obj, function(val, key) {
                matchers[key] = getOwn(matchers, key) || getMatcher(val);
                if (matchers[key].call(arr, el[key], i, arr) === false) matched = false;
                return matched;
            });
            return matched;
        };
    }
    function defaultMatcher(f) {
        return function(el) {
            return isEqual(el, f);
        };
    }
    function regexMatcher(reg) {
        reg = RegExp(reg);
        return function(el) {
            return reg.test(el);
        };
    }
    function dateMatcher(d) {
        var ms = d.getTime();
        return function(el) {
            return !!(el && el.getTime) && el.getTime() === ms;
        };
    }
    function functionMatcher(fn) {
        return function(el, i, arr) {
            // Return true up front if match by reference
            return el === fn || fn.call(arr, el, i, arr);
        };
    }
    // Object helpers
    function getKeys(obj) {
        return Object.keys(obj);
    }
    function deepHasProperty(obj, key, any) {
        return handleDeepProperty(obj, key, any, true);
    }
    function deepGetProperty(obj, key, any) {
        return handleDeepProperty(obj, key, any, false);
    }
    function deepSetProperty(obj, key, val) {
        handleDeepProperty(obj, key, false, false, true, false, val);
        return obj;
    }
    function handleDeepProperty(obj, key, any, has, fill, fillLast, val) {
        var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
        ns = obj;
        if (key == null) return;
        if (isObjectType(key)) // Allow array and array-like accessors
        bs = [
            key
        ];
        else {
            key = String(key);
            if (key.indexOf("..") !== -1) return handleArrayIndexRange(obj, key, any, val);
            bs = key.split("[");
        }
        set = isDefined(val);
        for(var i = 0, blen = bs.length; i < blen; i++){
            ps = bs[i];
            if (isString(ps)) ps = periodSplit(ps);
            for(var j = 0, plen = ps.length; j < plen; j++){
                key = ps[j];
                // Is this the last key?
                isLast = i === blen - 1 && j === plen - 1;
                // Index of the closing ]
                cbi = key.indexOf("]");
                // Is the key an array index?
                isIndex = cbi !== -1;
                // Is this array push syntax "[]"?
                isPush = set && cbi === 0;
                // If the bracket split was successful and this is the last element
                // in the dot split, then we know the next key will be an array index.
                nextIsIndex = blen > 1 && j === plen - 1;
                if (isPush) // Set the index to the end of the array
                key = ns.length;
                else if (isIndex) // Remove the closing ]
                key = key.slice(0, -1);
                // If the array index is less than 0, then
                // add its length to allow negative indexes.
                if (isIndex && key < 0) key = +key + ns.length;
                // Bracket keys may look like users[5] or just [5], so the leading
                // characters are optional. We can enter the namespace if this is the
                // 2nd part, if there is only 1 part, or if there is an explicit key.
                if (i || key || blen === 1) {
                    // TODO: need to be sure this check handles ''.length when
                    // we refactor.
                    exists = any ? key in Object(ns) : hasOwn(ns, key);
                    // Non-existent namespaces are only filled if they are intermediate
                    // (not at the end) or explicitly filling the last.
                    if (fill && (!isLast || fillLast) && !exists) {
                        // For our purposes, last only needs to be an array.
                        ns = ns[key] = nextIsIndex || fillLast && isLast ? [] : {};
                        continue;
                    }
                    if (has) {
                        if (isLast || !exists) return exists;
                    } else if (set && isLast) {
                        assertWritable(ns);
                        ns[key] = val;
                    }
                    ns = exists ? ns[key] : undefined;
                }
            }
        }
        return ns;
    }
    // Get object property with support for 0..1 style range notation.
    function handleArrayIndexRange(obj, key, any, val) {
        var match, start, end, leading, trailing, arr, set;
        match = key.match(PROPERTY_RANGE_REG);
        if (!match) return;
        set = isDefined(val);
        leading = match[1];
        if (leading) arr = handleDeepProperty(obj, leading, any, false, set ? true : false, true);
        else arr = obj;
        assertArray(arr);
        trailing = match[4];
        start = match[2] ? +match[2] : 0;
        end = match[3] ? +match[3] : arr.length;
        // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
        // pushes the index from -1 to 0, then set it to the full length of the
        // array, otherwise it will return nothing.
        end = end === -1 ? arr.length : end + 1;
        if (set) for(var i = start; i < end; i++)handleDeepProperty(arr, i + trailing, any, false, true, false, val);
        else {
            arr = arr.slice(start, end);
            // If there are trailing properties, then they need to be mapped for each
            // element in the array.
            if (trailing) {
                if (trailing.charAt(0) === HALF_WIDTH_PERIOD) // Need to chomp the period if one is trailing after the range. We
                // can't do this at the regex level because it will be required if
                // we're setting the value as it needs to be concatentated together
                // with the array index to be set.
                trailing = trailing.slice(1);
                return map(arr, function(el) {
                    return handleDeepProperty(el, trailing);
                });
            }
        }
        return arr;
    }
    function getOwnKey(obj, key) {
        if (hasOwn(obj, key)) return key;
    }
    function hasProperty(obj, prop) {
        return !isPrimitive(obj) && prop in obj;
    }
    function isObjectType(obj, type) {
        return !!obj && (type || typeof obj) === "object";
    }
    function isPrimitive(obj, type) {
        type = type || typeof obj;
        return obj == null || type === "string" || type === "number" || type === "boolean";
    }
    function isPlainObject(obj, className) {
        return isObjectType(obj) && isClass(obj, "Object", className) && hasValidPlainObjectPrototype(obj) && hasOwnEnumeratedProperties(obj);
    }
    function hasValidPlainObjectPrototype(obj) {
        var hasToString = "toString" in obj;
        var hasConstructor = "constructor" in obj;
        // An object created with Object.create(null) has no methods in the
        // prototype chain, so check if any are missing. The additional hasToString
        // check is for false positives on some host objects in old IE which have
        // toString but no constructor. If the object has an inherited constructor,
        // then check if it is Object (the "isPrototypeOf" tapdance here is a more
        // robust way of ensuring this if the global has been hijacked). Note that
        // accessing the constructor directly (without "in" or "hasOwnProperty")
        // will throw a permissions error in IE8 on cross-domain windows.
        return !hasConstructor && !hasToString || hasConstructor && !hasOwn(obj, "constructor") && hasOwn(obj.constructor.prototype, "isPrototypeOf");
    }
    function hasOwnEnumeratedProperties(obj) {
        // Plain objects are generally defined as having enumerated properties
        // all their own, however in early IE environments without defineProperty,
        // there may also be enumerated methods in the prototype chain, so check
        // for both of these cases.
        var objectProto = Object.prototype;
        for(var key in obj){
            var val = obj[key];
            if (!hasOwn(obj, key) && val !== objectProto[key]) return false;
        }
        return true;
    }
    function simpleRepeat(n, fn) {
        for(var i = 0; i < n; i++)fn(i);
    }
    function simpleClone(obj) {
        return simpleMerge({}, obj);
    }
    // TODO: Use Object.assign here going forward.
    function simpleMerge(target, source) {
        forEachProperty(source, function(val, key) {
            target[key] = val;
        });
        return target;
    }
    // Make primtives types like strings into objects.
    function coercePrimitiveToObject(obj) {
        if (isPrimitive(obj)) obj = Object(obj);
        // istanbul ignore next
        if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) forceStringCoercion(obj);
        return obj;
    }
    // Force strings to have their indexes set in
    // environments that don't do this automatically.
    // istanbul ignore next
    function forceStringCoercion(obj) {
        var i = 0, chr;
        while(chr = obj.charAt(i))obj[i++] = chr;
    }
    // Equality helpers
    // Perf
    function isEqual(a, b, stack) {
        var aClass, bClass;
        if (a === b) // Return quickly up front when matched by reference,
        // but be careful about 0 !== -0.
        return a !== 0 || 1 / a === 1 / b;
        aClass = classToString(a);
        bClass = classToString(b);
        if (aClass !== bClass) return false;
        if (isSerializable(a, aClass) && isSerializable(b, bClass)) return objectIsEqual(a, b, aClass, stack);
        else if (isSet(a, aClass) && isSet(b, bClass)) return a.size === b.size && isEqual(setToArray(a), setToArray(b), stack);
        else if (isMap(a, aClass) && isMap(b, bClass)) return a.size === b.size && isEqual(mapToArray(a), mapToArray(b), stack);
        else if (isError(a, aClass) && isError(b, bClass)) return a.toString() === b.toString();
        return false;
    }
    // Perf
    function objectIsEqual(a, b, aClass, stack) {
        var aType = typeof a, bType = typeof b, propsEqual, count;
        if (aType !== bType) return false;
        if (isObjectType(a.valueOf())) {
            if (a.length !== b.length) // perf: Quickly returning up front for arrays.
            return false;
            count = 0;
            propsEqual = true;
            iterateWithCyclicCheck(a, false, stack, function(key, val, cyc, stack) {
                if (!cyc && (!(key in b) || !isEqual(val, b[key], stack))) propsEqual = false;
                count++;
                return propsEqual;
            });
            if (!propsEqual || count !== getKeys(b).length) return false;
        }
        // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
        return a.valueOf().toString() === b.valueOf().toString();
    }
    // Serializes an object in a way that will provide a token unique
    // to the type, class, and value of an object. Host objects, class
    // instances etc, are not serializable, and are held in an array
    // of references that will return the index as a unique identifier
    // for the object. This array is passed from outside so that the
    // calling function can decide when to dispose of this array.
    function serializeInternal(obj, refs, stack) {
        var type = typeof obj, sign = "", className, value, ref;
        // Return up front on
        if (1 / obj === -Infinity) sign = "-";
        // Return quickly for primitives to save cycles
        if (isPrimitive(obj, type) && !isRealNaN(obj)) return type + sign + obj;
        className = classToString(obj);
        if (!isSerializable(obj, className)) {
            ref = indexOf(refs, obj);
            if (ref === -1) {
                ref = refs.length;
                refs.push(obj);
            }
            return ref;
        } else if (isObjectType(obj)) value = serializeDeep(obj, refs, stack) + obj.toString();
        else if (obj.valueOf) value = obj.valueOf();
        return type + className + sign + value;
    }
    function serializeDeep(obj, refs, stack) {
        var result = "";
        iterateWithCyclicCheck(obj, true, stack, function(key, val, cyc, stack) {
            result += cyc ? "CYC" : key + serializeInternal(val, refs, stack);
        });
        return result;
    }
    function iterateWithCyclicCheck(obj, sortedKeys, stack, fn) {
        function next(val, key) {
            var cyc = false;
            // Allowing a step into the structure before triggering this check to save
            // cycles on standard JSON structures and also to try as hard as possible to
            // catch basic properties that may have been modified.
            if (stack.length > 1) {
                var i = stack.length;
                while(i--)if (stack[i] === val) cyc = true;
            }
            stack.push(val);
            fn(key, val, cyc, stack);
            stack.pop();
        }
        function iterateWithSortedKeys() {
            // Sorted keys is required for serialization, where object order
            // does not matter but stringified order does.
            var arr = getKeys(obj).sort(), key;
            for(var i = 0; i < arr.length; i++){
                key = arr[i];
                next(obj[key], arr[i]);
            }
        }
        // This method for checking for cyclic structures was egregiously stolen from
        // the ingenious method by @kitcambridge from the Underscore script:
        // https://github.com/documentcloud/underscore/issues/240
        if (!stack) stack = [];
        if (sortedKeys) iterateWithSortedKeys();
        else forEachProperty(obj, next);
    }
    // Array helpers
    function isArrayIndex(n) {
        return n >>> 0 == n && n != 0xFFFFFFFF;
    }
    function iterateOverSparseArray(arr, fn, fromIndex, loop) {
        var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
        for(var i = 0, len = indexes.length; i < len; i++){
            index = indexes[i];
            fn.call(arr, arr[index], index, arr);
        }
        return arr;
    }
    // It's unclear whether or not sparse arrays qualify as "simple enumerables".
    // If they are not, however, the wrapping function will be deoptimized, so
    // isolate here (also to share between es5 and array modules).
    function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
        var indexes = [], i;
        for(i in arr)// istanbul ignore next
        if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) indexes.push(+i);
        indexes.sort(function(a, b) {
            var aLoop = a > fromIndex;
            var bLoop = b > fromIndex;
            // This block cannot be reached unless ES5 methods are being shimmed.
            // istanbul ignore if
            if (aLoop !== bLoop) return aLoop ? -1 : 1;
            return a - b;
        });
        return indexes;
    }
    function getEntriesForIndexes(obj, find, loop, isString) {
        var result, length = obj.length;
        if (!isArray(find)) return entryAtIndex(obj, find, length, loop, isString);
        result = new Array(find.length);
        forEach(find, function(index, i) {
            result[i] = entryAtIndex(obj, index, length, loop, isString);
        });
        return result;
    }
    function getNormalizedIndex(index, length, loop) {
        if (index && loop) index = index % length;
        if (index < 0) index = length + index;
        return index;
    }
    function entryAtIndex(obj, index, length, loop, isString) {
        index = getNormalizedIndex(index, length, loop);
        return isString ? obj.charAt(index) : obj[index];
    }
    function mapWithShortcuts(el, f, context, mapArgs) {
        if (!f) return el;
        else if (f.apply) return f.apply(context, mapArgs);
        else if (isArray(f)) return map(f, function(m) {
            return mapWithShortcuts(el, m, context, mapArgs);
        });
        else if (isFunction(el[f])) return el[f].call(el);
        else return deepGetProperty(el, f, true);
    }
    function spaceSplit(str) {
        return str.split(" ");
    }
    function commaSplit(str) {
        return str.split(HALF_WIDTH_COMMA);
    }
    function periodSplit(str) {
        return str.split(HALF_WIDTH_PERIOD);
    }
    function forEach(arr, fn) {
        for(var i = 0, len = arr.length; i < len; i++){
            if (!(i in arr)) return iterateOverSparseArray(arr, fn, i);
            fn(arr[i], i);
        }
    }
    function filter(arr, fn) {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var el = arr[i];
            if (i in arr && fn(el, i)) result.push(el);
        }
        return result;
    }
    function map(arr, fn) {
        // perf: Not using fixed array len here as it may be sparse.
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (i in arr) result.push(fn(arr[i], i));
        return result;
    }
    function indexOf(arr, el) {
        for(var i = 0, len = arr.length; i < len; i++){
            if (i in arr && arr[i] === el) return i;
        }
        return -1;
    }
    // Number helpers
    // istanbul ignore next
    var trunc = Math.trunc || function(n) {
        if (n === 0 || !isFinite(n)) return n;
        return n < 0 ? ceil(n) : floor(n);
    };
    function isRealNaN(obj) {
        // This is only true of NaN
        return obj != null && obj !== obj;
    }
    function withPrecision(val, precision, fn) {
        var multiplier = pow(10, abs(precision || 0));
        fn = fn || round;
        if (precision < 0) multiplier = 1 / multiplier;
        return fn(val * multiplier) / multiplier;
    }
    function padNumber(num, place, sign, base, replacement) {
        var str = abs(num).toString(base || 10);
        str = repeatString(replacement || "0", place - str.replace(/\.\d+/, "").length) + str;
        if (sign || num < 0) str = (num < 0 ? "-" : "+") + str;
        return str;
    }
    function getOrdinalSuffix(num) {
        if (num >= 11 && num <= 13) return "th";
        else switch(num % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }
    // Fullwidth number helpers
    var fullWidthNumberReg, fullWidthNumberMap, fullWidthNumbers;
    function buildFullWidthNumber() {
        var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA, fwn = "";
        fullWidthNumberMap = {};
        for(var i = 0, digit; i <= 9; i++){
            digit = chr(i + FULL_WIDTH_ZERO);
            fwn += digit;
            fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
        }
        fullWidthNumberMap[hwc] = "";
        fullWidthNumberMap[fwp] = hwp;
        // Mapping this to itself to capture it easily
        // in stringToNumber to detect decimals later.
        fullWidthNumberMap[hwp] = hwp;
        fullWidthNumberReg = allCharsReg(fwn + fwp + hwc + hwp);
        fullWidthNumbers = fwn;
    }
    // Takes into account full-width characters, commas, and decimals.
    function stringToNumber(str, base) {
        var sanitized, isDecimal;
        sanitized = str.replace(fullWidthNumberReg, function(chr) {
            var replacement = getOwn(fullWidthNumberMap, chr);
            if (replacement === HALF_WIDTH_PERIOD) isDecimal = true;
            return replacement;
        });
        return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
    }
    // Math aliases
    var abs = Math.abs, pow = Math.pow, min = Math.min, max = Math.max, ceil = Math.ceil, floor = Math.floor, round = Math.round;
    // String helpers
    var chr = String.fromCharCode;
    function trim(str) {
        return str.trim();
    }
    function repeatString(str, num) {
        var result = "";
        str = str.toString();
        while(num > 0){
            if (num & 1) result += str;
            if (num >>= 1) str += str;
        }
        return result;
    }
    function simpleCapitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    function createFormatMatcher(bracketMatcher, percentMatcher, precheck) {
        var reg = STRING_FORMAT_REG;
        var compileMemoized = memoizeFunction(compile);
        function getToken(format, match) {
            var get, token, literal, fn;
            var bKey = match[2];
            var pLit = match[3];
            var pKey = match[5];
            if (match[4] && percentMatcher) {
                token = pKey;
                get = percentMatcher;
            } else if (bKey) {
                token = bKey;
                get = bracketMatcher;
            } else if (pLit && percentMatcher) literal = pLit;
            else literal = match[1] || match[0];
            if (get) {
                assertPassesPrecheck(precheck, bKey, pKey);
                fn = function fn(obj, opt) {
                    return get(obj, token, opt);
                };
            }
            format.push(fn || getLiteral(literal));
        }
        function getSubstring(format, str, start, end) {
            if (end > start) {
                var sub = str.slice(start, end);
                assertNoUnmatched(sub, OPEN_BRACE);
                assertNoUnmatched(sub, CLOSE_BRACE);
                format.push(function() {
                    return sub;
                });
            }
        }
        function getLiteral(str) {
            return function() {
                return str;
            };
        }
        function assertPassesPrecheck(precheck, bt, pt) {
            if (precheck && !precheck(bt, pt)) throw new TypeError("Invalid token " + (bt || pt) + " in format string");
        }
        function assertNoUnmatched(str, chr) {
            if (str.indexOf(chr) !== -1) throw new TypeError("Unmatched " + chr + " in format string");
        }
        function compile(str) {
            var format = [], lastIndex = 0, match;
            reg.lastIndex = 0;
            while(match = reg.exec(str)){
                getSubstring(format, str, lastIndex, match.index);
                getToken(format, match);
                lastIndex = reg.lastIndex;
            }
            getSubstring(format, str, lastIndex, str.length);
            return format;
        }
        return function(str, obj, opt) {
            var format = compileMemoized(str), result = "";
            for(var i = 0; i < format.length; i++)result += format[i](obj, opt);
            return result;
        };
    }
    // Inflection helper
    var Inflections = {};
    function getAcronym(str) {
        // istanbul ignore next
        return Inflections.acronyms && Inflections.acronyms.find(str);
    }
    function getHumanWord(str) {
        // istanbul ignore next
        return Inflections.human && Inflections.human.find(str);
    }
    function runHumanRules(str) {
        // istanbul ignore next
        return Inflections.human && Inflections.human.runRules(str) || str;
    }
    // RegExp helpers
    function allCharsReg(src) {
        return RegExp("[" + src + "]", "g");
    }
    function getRegExpFlags(reg, add) {
        var flags = "";
        add = add || "";
        function checkFlag(prop, flag) {
            if (prop || add.indexOf(flag) > -1) flags += flag;
        }
        checkFlag(reg.global, "g");
        checkFlag(reg.ignoreCase, "i");
        checkFlag(reg.multiline, "m");
        checkFlag(reg.sticky, "y");
        return flags;
    }
    function escapeRegExp(str) {
        if (!isString(str)) str = String(str);
        return str.replace(/([\\/'*+?|()[\]{}.^$-])/g, "\\$1");
    }
    // Date helpers
    var _utc = privatePropertyAccessor("utc");
    function callDateGet(d, method) {
        return d["get" + (_utc(d) ? "UTC" : "") + method]();
    }
    function callDateSet(d, method, value, safe) {
        // "Safe" denotes not setting the date if the value is the same as what is
        // currently set. In theory this should be a noop, however it will cause
        // timezone shifts when in the middle of a DST fallback. This is unavoidable
        // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
        // November 1st, 2015 in northern hemisphere timezones that follow DST),
        // however when advancing or rewinding dates this can throw off calculations
        // so avoiding this unintentional shifting on an opt-in basis.
        if (safe && value === callDateGet(d, method, value)) return;
        d["set" + (_utc(d) ? "UTC" : "") + method](value);
    }
    // Memoization helpers
    var INTERNAL_MEMOIZE_LIMIT = 1000;
    // Note that attemps to consolidate this with Function#memoize
    // ended up clunky as that is also serializing arguments. Separating
    // these implementations turned out to be simpler.
    function memoizeFunction(fn) {
        var memo = {}, counter = 0;
        return function(key) {
            if (hasOwn(memo, key)) return memo[key];
            // istanbul ignore if
            if (counter === INTERNAL_MEMOIZE_LIMIT) {
                memo = {};
                counter = 0;
            }
            counter++;
            return memo[key] = fn(key);
        };
    }
    // ES6 helpers
    function setToArray(set) {
        var arr = new Array(set.size), i = 0;
        set.forEach(function(val) {
            arr[i++] = val;
        });
        return arr;
    }
    function mapToArray(map) {
        var arr = new Array(map.size), i = 0;
        map.forEach(function(val, key) {
            arr[i++] = [
                key,
                val
            ];
        });
        return arr;
    }
    buildClassChecks();
    buildFullWidthNumber();
    /***
   * @module ES5
   * @description Functions and polyfill methods that fix ES5 functionality. This
   *              module is excluded from default builds, and can be included if
   *              you need legacy browser support (IE8 and below).
   *
   ***/ // Non-enumerable properties on Object.prototype. In early JScript implementations
    // (< IE9) these will shadow object properties and break for..in loops.
    var DONT_ENUM_PROPS = [
        "valueOf",
        "toString",
        "constructor",
        "isPrototypeOf",
        "hasOwnProperty",
        "toLocaleString",
        "propertyIsEnumerable"
    ];
    /***
   * @fix
   * @short Fixes DontEnum bug for iteration methods in < IE9.
   ***/ function buildDontEnumFix() {
        if (!({
            toString: 1
        }).propertyIsEnumerable("toString")) {
            var forEachEnumerableProperty = forEachProperty;
            forEachProperty = function forEachProperty(obj, fn) {
                forEachEnumerableProperty(obj, fn);
                for(var i = 0, key; key = DONT_ENUM_PROPS[i]; i++)if (hasOwn(obj, key)) {
                    if (fn.call(obj, obj[key], key, obj) === false) break;
                }
            };
        }
    }
    /***
   * @fix
   * @short Adds native methods to chainables in < IE9.
   ***/ function buildChainableNativeMethodsFix() {
        if (!Object.getOwnPropertyNames) defineNativeMethodsOnChainable();
    }
    // Polyfilled methods will automatically be added to the chainable prototype.
    // However, Object.getOwnPropertyNames cannot be shimmed for non-enumerable
    // properties, so if it does not exist, then the only way to access native
    // methods previous to ES5 is to provide them as a list of tokens here.
    function defineNativeMethodsOnChainable() {
        var nativeTokens = {
            "Function": "apply,call",
            "RegExp": "compile,exec,test",
            "Number": "toExponential,toFixed,toLocaleString,toPrecision",
            "Object": "hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString",
            "Array": "concat,join,pop,push,reverse,shift,slice,sort,splice,toLocaleString,unshift",
            "Date": "getTime,getTimezoneOffset,setTime,toDateString,toGMTString,toLocaleDateString,toLocaleString,toLocaleTimeString,toTimeString,toUTCString",
            "String": "anchor,big,blink,bold,charAt,charCodeAt,concat,fixed,fontcolor,fontsize,indexOf,italics,lastIndexOf,link,localeCompare,match,replace,search,slice,small,split,strike,sub,substr,substring,sup,toLocaleLowerCase,toLocaleUpperCase,toLowerCase,toUpperCase"
        };
        var dateTokens = "FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds".split(",");
        function addDateTokens(prefix, arr) {
            for(var i = 0; i < dateTokens.length; i++)arr.push(prefix + dateTokens[i]);
        }
        forEachProperty(nativeTokens, function(str, name) {
            var tokens = str.split(",");
            if (name === "Date") {
                addDateTokens("get", tokens);
                addDateTokens("set", tokens);
                addDateTokens("getUTC", tokens);
                addDateTokens("setUTC", tokens);
            }
            tokens.push("toString");
            mapNativeToChainable(name, tokens);
        });
    }
    buildDontEnumFix();
    buildChainableNativeMethodsFix();
    /*** @namespace Object ***/ function assertNonNull(obj) {
        if (obj == null) throw new TypeError("Object required");
    }
    defineStaticPolyfill(sugarObject, {
        "keys": function(obj) {
            var keys = [];
            assertNonNull(obj);
            forEachProperty(coercePrimitiveToObject(obj), function(val, key) {
                keys.push(key);
            });
            return keys;
        }
    });
    /*** @namespace Array ***/ function arrayIndexOf(arr, search, fromIndex, fromRight) {
        var length = arr.length, defaultFromIndex, index, increment;
        increment = fromRight ? -1 : 1;
        defaultFromIndex = fromRight ? length - 1 : 0;
        fromIndex = trunc(fromIndex);
        if (!fromIndex && fromIndex !== 0) fromIndex = defaultFromIndex;
        if (fromIndex < 0) fromIndex = length + fromIndex;
        if (!fromRight && fromIndex < 0 || fromRight && fromIndex >= length) fromIndex = defaultFromIndex;
        index = fromIndex;
        while(fromRight && index >= 0 || !fromRight && index < length){
            if (!(index in arr)) return sparseIndexOf(arr, search, fromIndex, fromRight);
            if (isArrayIndex(index) && arr[index] === search) return index;
            index += increment;
        }
        return -1;
    }
    function sparseIndexOf(arr, search, fromIndex, fromRight) {
        var indexes = getSparseArrayIndexes(arr, fromIndex, false, fromRight), index;
        indexes.sort(function(a, b) {
            return fromRight ? b - a : a - b;
        });
        while((index = indexes.shift()) !== undefined){
            if (arr[index] === search) return +index;
        }
        return -1;
    }
    function arrayReduce(arr, fn, initialValue, fromRight) {
        var length = arr.length, count = 0, defined = isDefined(initialValue), result, index;
        assertCallable(fn);
        if (length == 0 && !defined) throw new TypeError("Reduce called on empty array with no initial value");
        else if (defined) result = initialValue;
        else {
            result = arr[fromRight ? length - 1 : count];
            count++;
        }
        while(count < length){
            index = fromRight ? length - count - 1 : count;
            if (index in arr) result = fn(result, arr[index], index, arr);
            count++;
        }
        return result;
    }
    defineStaticPolyfill(sugarArray, {
        /***
     *
     * @method isArray(obj)
     * @returns Boolean
     * @polyfill ES5
     * @static
     * @short Returns true if `obj` is an Array.
     *
     * @example
     *
     *   Array.isArray(3)        -> false
     *   Array.isArray(true)     -> false
     *   Array.isArray('wasabi') -> false
     *   Array.isArray([1,2,3])  -> true
     *
     ***/ "isArray": function(obj) {
            return isArray(obj);
        }
    });
    defineInstancePolyfill(sugarArray, {
        "every": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0;
            assertCallable(fn);
            while(index < length){
                if (index in this && !fn.call(context, this[index], index, this)) return false;
                index++;
            }
            return true;
        },
        "some": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0;
            assertCallable(fn);
            while(index < length){
                if (index in this && fn.call(context, this[index], index, this)) return true;
                index++;
            }
            return false;
        },
        "map": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0, result = new Array(length);
            assertCallable(fn);
            while(index < length){
                if (index in this) result[index] = fn.call(context, this[index], index, this);
                index++;
            }
            return result;
        },
        "filter": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0, result = [];
            assertCallable(fn);
            while(index < length){
                if (index in this && fn.call(context, this[index], index, this)) result.push(this[index]);
                index++;
            }
            return result;
        },
        /***
     * @method indexOf(search, [fromIndex] = 0)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array and returns the first index where `search` occurs,
     *        or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This
     *        method performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *        For such functionality, use the `findIndex` method instead.
     *
     * @example
     *
     *   [1,2,3].indexOf(3) -> 1
     *   [1,2,3].indexOf(7) -> -1
     *
     ***/ "indexOf": function(search) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, fromIndex = arguments[1];
            if (isString(this)) return this.indexOf(search, fromIndex);
            return arrayIndexOf(this, search, fromIndex);
        },
        /***
     * @method lastIndexOf(search, [fromIndex] = array.length - 1)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array from the end and returns the first index where
     *        `search` occurs, or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This method
     *        performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *
     * @example
     *
     *   [1,2,1].lastIndexOf(1) -> 2
     *   [1,2,1].lastIndexOf(7) -> -1
     *
     ***/ "lastIndexOf": function(search) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, fromIndex = arguments[1];
            if (isString(this)) return this.lastIndexOf(search, fromIndex);
            return arrayIndexOf(this, search, fromIndex, true);
        },
        /***
     * @method forEach([eachFn], [context])
     * @polyfill ES5
     * @short Iterates over the array, calling [eachFn] on each loop.
     * @extra [context] becomes the `this` object.
     *
     * @callback eachFn
     *
     *   el   The element of the current iteration.
     *   i    The index of the current iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   ['a','b','c'].forEach(function(a) {
     *     // Called 3 times: 'a','b','c'
     *   });
     *
     ***/ "forEach": function(eachFn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0;
            assertCallable(eachFn);
            while(index < length){
                if (index in this) eachFn.call(context, this[index], index, this);
                index++;
            }
        },
        /***
     * @method reduce(reduceFn, [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Reduces the array to a single result.
     * @extra This operation is sometimes called "accumulation", as it takes the
     *        result of the last iteration of `reduceFn` and passes it as the first
     *        argument to the next iteration, "accumulating" that value as it goes.
     *        The return value of this method will be the return value of the final
     *        iteration of `reduceFn`. If [init] is passed, it will be the initial
     *        "accumulator" (the first argument). If [init] is not passed, then it
     *        will take the first element in the array, and `reduceFn` will not be
     *        called for that element.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator". Either [init], the result of the last iteration
     *        of `reduceFn`, or the first element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 1 - 2 - 3
     *   });
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 100 - 1 - 2 - 3
     *   }, 100);
     *
     ***/ "reduce": function(reduceFn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            return arrayReduce(this, reduceFn, context);
        },
        /***
     * @method reduceRight([reduceFn], [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Similar to `Array#reduce`, but operates on the elements in reverse.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator", either [init], the result of the last iteration
     *        of `reduceFn`, or the last element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 3 - 2 - 1
     *   });
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 100 - 3 - 2 - 1
     *   }, 100);
     *
     *
     ***/ "reduceRight": function(reduceFn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            return arrayReduce(this, reduceFn, context, true);
        }
    });
    /*** @namespace String ***/ var TRIM_REG = RegExp("^[" + TRIM_CHARS + "]+|[" + TRIM_CHARS + "]+$", "g");
    defineInstancePolyfill(sugarString, {
        /***
     * @method trim()
     * @returns String
     * @polyfill ES5
     * @short Removes leading and trailing whitespace from the string.
     * @extra Whitespace is defined as line breaks, tabs, and any character in the
     *        "Space, Separator" Unicode category, conforming to the the ES5 spec.
     *
     * @example
     *
     *   '   wasabi   '.trim()      -> 'wasabi'
     *   '   wasabi   '.trimLeft()  -> 'wasabi   '
     *   '   wasabi   '.trimRight() -> '   wasabi'
     *
     ***/ "trim": function() {
            return this.toString().replace(TRIM_REG, "");
        }
    });
    /*** @namespace Function ***/ defineInstancePolyfill(sugarFunction, {
        /***
     * @method bind(context, [arg1], ...)
     * @returns Function
     * @polyfill ES5
     * @short Binds `context` as the `this` object for the function when it is
     *        called. Also allows currying an unlimited number of parameters.
     * @extra "currying" means setting parameters ([arg1], [arg2], etc.) ahead of
     *        time so that they are passed when the function is called later. If
     *        you pass additional parameters when the function is actually called,
     *        they will be added to the end of the curried parameters.
     *
     * @example
     *
     *   logThis.bind('woof')()   -> logs 'woof' as its this object
     *   addArgs.bind(1, 2, 3)()  -> returns 5 with 1 as the this object
     *   addArgs.bind(1)(2, 3, 4) -> returns 9
     *
     ***/ "bind": function(context) {
            // Optimized: no leaking arguments
            var boundArgs = [];
            for(var $i = 1, $len = arguments.length; $i < $len; $i++)boundArgs.push(arguments[$i]);
            var fn = this, bound;
            assertCallable(this);
            bound = function bound() {
                // Optimized: no leaking arguments
                var args = [];
                for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
                return fn.apply(fn.prototype && this instanceof fn ? this : context, boundArgs.concat(args));
            };
            bound.prototype = this.prototype;
            return bound;
        }
    });
    /*** @namespace Date ***/ defineStaticPolyfill(sugarDate, {
        /***
     * @method now()
     * @returns String
     * @polyfill ES5
     * @static
     * @short Returns the current time as a Unix timestamp.
     * @extra The number of milliseconds since January 1st, 1970 00:00:00 (UTC).
     *
     * @example
     *
     *   Date.now() -> ex. 1311938296231
     *
     ***/ "now": function() {
            return new Date().getTime();
        }
    });
    function hasISOSupport() {
        var d = new Date(Date.UTC(2000, 0));
        return !!d.toISOString && d.toISOString() === "2000-01-01T00:00:00.000Z";
    }
    defineInstancePolyfill(sugarDate, {
        /***
     * @method toISOString()
     * @returns String
     * @polyfill ES5
     * @short Formats the string to ISO8601 format.
     * @extra This will always format as UTC time.
     *
     * @example
     *
     *   Date.create().toISOString() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/ "toISOString": function() {
            return padNumber(this.getUTCFullYear(), 4) + "-" + padNumber(this.getUTCMonth() + 1, 2) + "-" + padNumber(this.getUTCDate(), 2) + "T" + padNumber(this.getUTCHours(), 2) + ":" + padNumber(this.getUTCMinutes(), 2) + ":" + padNumber(this.getUTCSeconds(), 2) + "." + padNumber(this.getUTCMilliseconds(), 3) + "Z";
        },
        /***
     * @method toJSON([key])
     * @returns String
     * @polyfill ES5
     * @short Returns a JSON representation of the date.
     * @extra This is effectively an alias for `toISOString`. Will always return
     *        the date in UTC time. [key] is ignored.
     *
     * @example
     *
     *   Date.create().toJSON() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/ "toJSON": function(key) {
            // Force compiler to respect argument length.
            var argLen = arguments.length;
            return this.toISOString(key);
        }
    }, !hasISOSupport());
}).call(this);

},{}],"8OkFj":[function(require,module,exports) {
"use strict";
var forEach = require("b313e941b068666d"), classChecks = require("14fd8c1653465f66"), entryAtIndex = require("e98dc37a6b8c40f5");
var isArray = classChecks.isArray;
function getEntriesForIndexes(obj, find, loop, isString) {
    var result, length = obj.length;
    if (!isArray(find)) return entryAtIndex(obj, find, length, loop, isString);
    result = new Array(find.length);
    forEach(find, function(index, i) {
        result[i] = entryAtIndex(obj, index, length, loop, isString);
    });
    return result;
}
module.exports = getEntriesForIndexes;

},{"b313e941b068666d":"JJnv7","14fd8c1653465f66":"MTXUY","e98dc37a6b8c40f5":"0294t"}],"JJnv7":[function(require,module,exports) {
"use strict";
var iterateOverSparseArray = require("ba7effe4821d7630");
function forEach(arr, fn) {
    for(var i = 0, len = arr.length; i < len; i++){
        if (!(i in arr)) return iterateOverSparseArray(arr, fn, i);
        fn(arr[i], i);
    }
}
module.exports = forEach;

},{"ba7effe4821d7630":"8WdwW"}],"8WdwW":[function(require,module,exports) {
"use strict";
var getSparseArrayIndexes = require("2ead1849ddcaa9d0");
function iterateOverSparseArray(arr, fn, fromIndex, loop) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
    for(var i = 0, len = indexes.length; i < len; i++){
        index = indexes[i];
        fn.call(arr, arr[index], index, arr);
    }
    return arr;
}
module.exports = iterateOverSparseArray;

},{"2ead1849ddcaa9d0":"4meUc"}],"4meUc":[function(require,module,exports) {
"use strict";
var isArrayIndex = require("b245c3731761618f");
function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
    var indexes = [], i;
    for(i in arr)// istanbul ignore next
    if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) indexes.push(+i);
    indexes.sort(function(a, b) {
        var aLoop = a > fromIndex;
        var bLoop = b > fromIndex;
        // This block cannot be reached unless ES5 methods are being shimmed.
        // istanbul ignore if
        if (aLoop !== bLoop) return aLoop ? -1 : 1;
        return a - b;
    });
    return indexes;
}
module.exports = getSparseArrayIndexes;

},{"b245c3731761618f":"lvBp0"}],"lvBp0":[function(require,module,exports) {
"use strict";
function isArrayIndex(n) {
    return n >>> 0 == n && n != 0xFFFFFFFF;
}
module.exports = isArrayIndex;

},{}],"MTXUY":[function(require,module,exports) {
"use strict";
var NATIVE_TYPES = require("491c491b769ce143"), forEach = require("a800bc487a32ddc2"), isClass = require("8e5aefc0e6f57b9"), spaceSplit = require("4d9de43e1587c552"), isPlainObject = require("f52f2b3292aa3a28");
var isSerializable, isBoolean, isNumber, isString, isDate, isRegExp, isFunction, isArray, isSet, isMap, isError;
function buildClassChecks() {
    var knownTypes = {};
    function addCoreTypes() {
        var names = spaceSplit(NATIVE_TYPES);
        isBoolean = buildPrimitiveClassCheck(names[0]);
        isNumber = buildPrimitiveClassCheck(names[1]);
        isString = buildPrimitiveClassCheck(names[2]);
        isDate = buildClassCheck(names[3]);
        isRegExp = buildClassCheck(names[4]);
        // Wanted to enhance performance here by using simply "typeof"
        // but Firefox has two major issues that make this impossible,
        // one fixed, the other not, so perform a full class check here.
        //
        // 1. Regexes can be typeof "function" in FF < 3
        //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
        //
        // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
        //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
        isFunction = buildClassCheck(names[5]);
        // istanbul ignore next
        isArray = Array.isArray || buildClassCheck(names[6]);
        isError = buildClassCheck(names[7]);
        isSet = buildClassCheck(names[8], typeof Set !== "undefined" && Set);
        isMap = buildClassCheck(names[9], typeof Map !== "undefined" && Map);
        // Add core types as known so that they can be checked by value below,
        // notably excluding Functions and adding Arguments and Error.
        addKnownType("Arguments");
        addKnownType(names[0]);
        addKnownType(names[1]);
        addKnownType(names[2]);
        addKnownType(names[3]);
        addKnownType(names[4]);
        addKnownType(names[6]);
    }
    function addArrayTypes() {
        var types = "Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64";
        forEach(spaceSplit(types), function(str) {
            addKnownType(str + "Array");
        });
    }
    function addKnownType(className) {
        var str = "[object " + className + "]";
        knownTypes[str] = true;
    }
    function isKnownType(className) {
        return knownTypes[className];
    }
    function buildClassCheck(className, globalObject) {
        // istanbul ignore if
        if (globalObject && isClass(new globalObject, "Object")) return getConstructorClassCheck(globalObject);
        else return getToStringClassCheck(className);
    }
    // Map and Set may be [object Object] in certain IE environments.
    // In this case we need to perform a check using the constructor
    // instead of Object.prototype.toString.
    // istanbul ignore next
    function getConstructorClassCheck(obj) {
        var ctorStr = String(obj);
        return function(obj) {
            return String(obj.constructor) === ctorStr;
        };
    }
    function getToStringClassCheck(className) {
        return function(obj, str) {
            // perf: Returning up front on instanceof appears to be slower.
            return isClass(obj, className, str);
        };
    }
    function buildPrimitiveClassCheck(className) {
        var type = className.toLowerCase();
        return function(obj) {
            var t = typeof obj;
            return t === type || t === "object" && isClass(obj, className);
        };
    }
    addCoreTypes();
    addArrayTypes();
    isSerializable = function isSerializable(obj, className) {
        // Only known objects can be serialized. This notably excludes functions,
        // host objects, Symbols (which are matched by reference), and instances
        // of classes. The latter can arguably be matched by value, but
        // distinguishing between these and host objects -- which should never be
        // compared by value -- is very tricky so not dealing with it here.
        return isKnownType(className) || isPlainObject(obj, className);
    };
}
buildClassChecks();
module.exports = {
    isSerializable: isSerializable,
    isBoolean: isBoolean,
    isNumber: isNumber,
    isString: isString,
    isDate: isDate,
    isRegExp: isRegExp,
    isFunction: isFunction,
    isArray: isArray,
    isSet: isSet,
    isMap: isMap,
    isError: isError
};

},{"491c491b769ce143":"3L5fN","a800bc487a32ddc2":"JJnv7","8e5aefc0e6f57b9":"c8GTU","4d9de43e1587c552":"cGrLA","f52f2b3292aa3a28":"dxNeT"}],"3L5fN":[function(require,module,exports) {
"use strict";
module.exports = "Boolean Number String Date RegExp Function Array Error Set Map";

},{}],"c8GTU":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("4e933fd1f95639a6");
var classToString = coreUtilityAliases.classToString;
function isClass(obj, className, str) {
    if (!str) str = classToString(obj);
    return str === "[object " + className + "]";
}
module.exports = isClass;

},{"4e933fd1f95639a6":"8ZxTV"}],"8ZxTV":[function(require,module,exports) {
"use strict";
var Sugar = require("25a72c2e367d5986");
module.exports = {
    hasOwn: Sugar.util.hasOwn,
    getOwn: Sugar.util.getOwn,
    setProperty: Sugar.util.setProperty,
    classToString: Sugar.util.classToString,
    defineProperty: Sugar.util.defineProperty,
    forEachProperty: Sugar.util.forEachProperty,
    mapNativeToChainable: Sugar.util.mapNativeToChainable
};

},{"25a72c2e367d5986":"dZZfL"}],"cGrLA":[function(require,module,exports) {
"use strict";
function spaceSplit(str) {
    return str.split(" ");
}
module.exports = spaceSplit;

},{}],"dxNeT":[function(require,module,exports) {
"use strict";
var isClass = require("43ec1c282cf08d59"), isObjectType = require("92d51d62e07694c"), hasOwnEnumeratedProperties = require("66db72b1c22a9c26"), hasValidPlainObjectPrototype = require("94aa273aa819b7e3");
function isPlainObject(obj, className) {
    return isObjectType(obj) && isClass(obj, "Object", className) && hasValidPlainObjectPrototype(obj) && hasOwnEnumeratedProperties(obj);
}
module.exports = isPlainObject;

},{"43ec1c282cf08d59":"c8GTU","92d51d62e07694c":"1dImj","66db72b1c22a9c26":"dwQxr","94aa273aa819b7e3":"1vjJt"}],"1dImj":[function(require,module,exports) {
"use strict";
function isObjectType(obj, type) {
    return !!obj && (type || typeof obj) === "object";
}
module.exports = isObjectType;

},{}],"dwQxr":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("ea6b6d8d47941e02");
var hasOwn = coreUtilityAliases.hasOwn;
function hasOwnEnumeratedProperties(obj) {
    // Plain objects are generally defined as having enumerated properties
    // all their own, however in early IE environments without defineProperty,
    // there may also be enumerated methods in the prototype chain, so check
    // for both of these cases.
    var objectProto = Object.prototype;
    for(var key in obj){
        var val = obj[key];
        if (!hasOwn(obj, key) && val !== objectProto[key]) return false;
    }
    return true;
}
module.exports = hasOwnEnumeratedProperties;

},{"ea6b6d8d47941e02":"8ZxTV"}],"1vjJt":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("8a881b323042e8c9");
var hasOwn = coreUtilityAliases.hasOwn;
function hasValidPlainObjectPrototype(obj) {
    var hasToString = "toString" in obj;
    var hasConstructor = "constructor" in obj;
    // An object created with Object.create(null) has no methods in the
    // prototype chain, so check if any are missing. The additional hasToString
    // check is for false positives on some host objects in old IE which have
    // toString but no constructor. If the object has an inherited constructor,
    // then check if it is Object (the "isPrototypeOf" tapdance here is a more
    // robust way of ensuring this if the global has been hijacked). Note that
    // accessing the constructor directly (without "in" or "hasOwnProperty")
    // will throw a permissions error in IE8 on cross-domain windows.
    return !hasConstructor && !hasToString || hasConstructor && !hasOwn(obj, "constructor") && hasOwn(obj.constructor.prototype, "isPrototypeOf");
}
module.exports = hasValidPlainObjectPrototype;

},{"8a881b323042e8c9":"8ZxTV"}],"0294t":[function(require,module,exports) {
"use strict";
var getNormalizedIndex = require("eca862a70b1beef");
function entryAtIndex(obj, index, length, loop, isString) {
    index = getNormalizedIndex(index, length, loop);
    return isString ? obj.charAt(index) : obj[index];
}
module.exports = entryAtIndex;

},{"eca862a70b1beef":"66puZ"}],"66puZ":[function(require,module,exports) {
"use strict";
function getNormalizedIndex(index, length, loop) {
    if (index && loop) index = index % length;
    if (index < 0) index = length + index;
    return index;
}
module.exports = getNormalizedIndex;

},{}],"dYSbm":[function(require,module,exports) {
"use strict";
var Sugar = require("5a93b25765952686"), stringCamelize = require("37dc4b40f87f5e85");
Sugar.String.defineInstance({
    "camelize": function(str, upper) {
        return stringCamelize(str, upper);
    }
});
module.exports = Sugar.String.camelize;

},{"5a93b25765952686":"dZZfL","37dc4b40f87f5e85":"koTBP"}],"koTBP":[function(require,module,exports) {
"use strict";
var CAMELIZE_REG = require("b77a304d244f2b99"), getAcronym = require("ccc72f60f5ca93c6"), stringUnderscore = require("2d53a3d01dea41fa"), stringCapitalize = require("aad04568c15dda08");
function stringCamelize(str, upper) {
    str = stringUnderscore(str);
    return str.replace(CAMELIZE_REG, function(match, pre, word, index) {
        var cap = upper !== false || index > 0, acronym;
        acronym = getAcronym(word);
        // istanbul ignore if
        if (acronym && cap) return acronym;
        return cap ? stringCapitalize(word, true) : word;
    });
}
module.exports = stringCamelize;

},{"b77a304d244f2b99":"169PX","ccc72f60f5ca93c6":"fbYl3","2d53a3d01dea41fa":"bmwzU","aad04568c15dda08":"4AS2H"}],"169PX":[function(require,module,exports) {
"use strict";
module.exports = /(^|_)([^_]+)/g;

},{}],"fbYl3":[function(require,module,exports) {
"use strict";
var Inflections = require("9c6e479d7293510f");
function getAcronym(str) {
    // istanbul ignore next
    return Inflections.acronyms && Inflections.acronyms.find(str);
}
module.exports = getAcronym;

},{"9c6e479d7293510f":"aNtOu"}],"aNtOu":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"bmwzU":[function(require,module,exports) {
"use strict";
var Inflections = require("f052f1bd3ff2546e");
function stringUnderscore(str) {
    var areg = Inflections.acronyms && Inflections.acronyms.reg;
    // istanbul ignore if
    if (areg) str = str.replace(areg, function(acronym, index) {
        return (index > 0 ? "_" : "") + acronym.toLowerCase();
    });
    return str.replace(/[-\s]+/g, "_").replace(/([A-Z\d]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").toLowerCase();
}
module.exports = stringUnderscore;

},{"f052f1bd3ff2546e":"aNtOu"}],"4AS2H":[function(require,module,exports) {
"use strict";
var CAPITALIZE_REG = require("84c5d9dd9bc8f694"), simpleCapitalize = require("56867879186c1065");
function stringCapitalize(str, downcase, all) {
    if (downcase) str = str.toLowerCase();
    return all ? str.replace(CAPITALIZE_REG, simpleCapitalize) : simpleCapitalize(str);
}
module.exports = stringCapitalize;

},{"84c5d9dd9bc8f694":"hvo8Z","56867879186c1065":"4Ffkr"}],"hvo8Z":[function(require,module,exports) {
"use strict";
module.exports = /[^\u0000-\u0040\u005B-\u0060\u007B-\u007F]+('s)?/g;

},{}],"4Ffkr":[function(require,module,exports) {
"use strict";
function simpleCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = simpleCapitalize;

},{}],"9HBfU":[function(require,module,exports) {
"use strict";
var Sugar = require("bddfe3d46beaffdb"), stringCapitalize = require("718c55cd3a7c74b3");
Sugar.String.defineInstance({
    "capitalize": function(str, lower, all) {
        return stringCapitalize(str, lower, all);
    }
});
module.exports = Sugar.String.capitalize;

},{"bddfe3d46beaffdb":"dZZfL","718c55cd3a7c74b3":"4AS2H"}],"6sKyh":[function(require,module,exports) {
"use strict";
var Sugar = require("a85f25d17be89e17"), stringEach = require("87c900082d83c82");
Sugar.String.defineInstance({
    "chars": function(str, search, eachCharFn) {
        return stringEach(str, search, eachCharFn);
    }
});
module.exports = Sugar.String.chars;

},{"a85f25d17be89e17":"dZZfL","87c900082d83c82":"uBLqS"}],"uBLqS":[function(require,module,exports) {
"use strict";
var isDefined = require("fee3c633040ba5a0"), classChecks = require("3b369f6ca111d447"), escapeRegExp = require("65e9b15f45d96247"), getRegExpFlags = require("7783c1024fd463aa"), runGlobalMatch = require("7350fc5c9ec50d8f");
var isString = classChecks.isString, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction;
function stringEach(str, search, fn) {
    var chunks, chunk, reg, result = [];
    if (isFunction(search)) {
        fn = search;
        reg = /[\s\S]/g;
    } else if (!search) reg = /[\s\S]/g;
    else if (isString(search)) reg = RegExp(escapeRegExp(search), "gi");
    else if (isRegExp(search)) reg = RegExp(search.source, getRegExpFlags(search, "g"));
    // Getting the entire array of chunks up front as we need to
    // pass this into the callback function as an argument.
    chunks = runGlobalMatch(str, reg);
    if (chunks) for(var i = 0, len = chunks.length, r; i < len; i++){
        chunk = chunks[i];
        result[i] = chunk;
        if (fn) {
            r = fn.call(str, chunk, i, chunks);
            if (r === false) break;
            else if (isDefined(r)) result[i] = r;
        }
    }
    return result;
}
module.exports = stringEach;

},{"fee3c633040ba5a0":"4cOOJ","3b369f6ca111d447":"MTXUY","65e9b15f45d96247":"6dbXB","7783c1024fd463aa":"8qWd6","7350fc5c9ec50d8f":"e190J"}],"4cOOJ":[function(require,module,exports) {
"use strict";
function isDefined(o) {
    return o !== undefined;
}
module.exports = isDefined;

},{}],"6dbXB":[function(require,module,exports) {
"use strict";
var classChecks = require("29a3a0fb0d5ce1ea");
var isString = classChecks.isString;
function escapeRegExp(str) {
    if (!isString(str)) str = String(str);
    return str.replace(/([\\/'*+?|()[\]{}.^$-])/g, "\\$1");
}
module.exports = escapeRegExp;

},{"29a3a0fb0d5ce1ea":"MTXUY"}],"8qWd6":[function(require,module,exports) {
"use strict";
function getRegExpFlags(reg, add) {
    var flags = "";
    add = add || "";
    function checkFlag(prop, flag) {
        if (prop || add.indexOf(flag) > -1) flags += flag;
    }
    checkFlag(reg.global, "g");
    checkFlag(reg.ignoreCase, "i");
    checkFlag(reg.multiline, "m");
    checkFlag(reg.sticky, "y");
    return flags;
}
module.exports = getRegExpFlags;

},{}],"e190J":[function(require,module,exports) {
"use strict";
function runGlobalMatch(str, reg) {
    var result = [], match, lastLastIndex;
    while((match = reg.exec(str)) != null){
        if (reg.lastIndex === lastLastIndex) reg.lastIndex += 1;
        else result.push(match[0]);
        lastLastIndex = reg.lastIndex;
    }
    return result;
}
module.exports = runGlobalMatch;

},{}],"cFFLP":[function(require,module,exports) {
"use strict";
var Sugar = require("a7d202f9b193f800"), stringCodes = require("d3d8c34364ab1aa");
Sugar.String.defineInstance({
    "codes": function(str, eachCodeFn) {
        return stringCodes(str, eachCodeFn);
    }
});
module.exports = Sugar.String.codes;

},{"a7d202f9b193f800":"dZZfL","d3d8c34364ab1aa":"fqoaX"}],"fqoaX":[function(require,module,exports) {
"use strict";
function stringCodes(str, fn) {
    var codes = new Array(str.length), i, len;
    for(i = 0, len = str.length; i < len; i++){
        var code = str.charCodeAt(i);
        codes[i] = code;
        if (fn) fn.call(str, code, i, str);
    }
    return codes;
}
module.exports = stringCodes;

},{}],"dolUN":[function(require,module,exports) {
"use strict";
var Sugar = require("ba67eafda2c9c14d"), trim = require("7956cdb31badf3b6");
Sugar.String.defineInstance({
    "compact": function(str) {
        return trim(str).replace(/([\r\n\s　])+/g, function(match, whitespace) {
            return whitespace === "\u3000" ? whitespace : " ";
        });
    }
});
module.exports = Sugar.String.compact;

},{"ba67eafda2c9c14d":"dZZfL","7956cdb31badf3b6":"2PiXk"}],"2PiXk":[function(require,module,exports) {
"use strict";
function trim(str) {
    return str.trim();
}
module.exports = trim;

},{}],"7FelE":[function(require,module,exports) {
"use strict";
var Sugar = require("7b5f1962cf7cf347"), stringUnderscore = require("f667cb75ef13ecc");
Sugar.String.defineInstance({
    "dasherize": function(str) {
        return stringUnderscore(str).replace(/_/g, "-");
    }
});
module.exports = Sugar.String.dasherize;

},{"7b5f1962cf7cf347":"dZZfL","f667cb75ef13ecc":"bmwzU"}],"dU1GP":[function(require,module,exports) {
"use strict";
var Sugar = require("37816ba242f6560f"), base64 = require("2e665867e5cf2989");
var decodeBase64 = base64.decodeBase64;
Sugar.String.defineInstance({
    "decodeBase64": function(str) {
        return decodeBase64(str);
    }
});
module.exports = Sugar.String.decodeBase64;

},{"37816ba242f6560f":"dZZfL","2e665867e5cf2989":"j5n9p"}],"j5n9p":[function(require,module,exports) {
var Buffer = require("1b9ebebfb9d0538f").Buffer;
"use strict";
var chr = require("217f53187b080cb0");
var encodeBase64, decodeBase64;
function buildBase64() {
    var encodeAscii, decodeAscii;
    // istanbul ignore next
    function catchEncodingError(fn) {
        return function(str) {
            try {
                return fn(str);
            } catch (e) {
                return "";
            }
        };
    }
    // istanbul ignore if
    if (typeof Buffer !== "undefined") {
        encodeBase64 = function encodeBase64(str) {
            return Buffer.from(str).toString("base64");
        };
        decodeBase64 = function decodeBase64(str) {
            return Buffer.from(str, "base64").toString("utf8");
        };
        return;
    }
    // istanbul ignore if
    if (typeof btoa !== "undefined") {
        encodeAscii = catchEncodingError(btoa);
        decodeAscii = catchEncodingError(atob);
    } else {
        var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var base64reg = /[^A-Za-z0-9\+\/\=]/g;
        encodeAscii = function encodeAscii(str) {
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            do {
                chr1 = str.charCodeAt(i++);
                chr2 = str.charCodeAt(i++);
                chr3 = str.charCodeAt(i++);
                enc1 = chr1 >> 2;
                enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                enc4 = chr3 & 63;
                if (isNaN(chr2)) enc3 = enc4 = 64;
                else if (isNaN(chr3)) enc4 = 64;
                output += key.charAt(enc1);
                output += key.charAt(enc2);
                output += key.charAt(enc3);
                output += key.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            }while (i < str.length);
            return output;
        };
        decodeAscii = function decodeAscii(input) {
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            if (input.match(base64reg)) return "";
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            do {
                enc1 = key.indexOf(input.charAt(i++));
                enc2 = key.indexOf(input.charAt(i++));
                enc3 = key.indexOf(input.charAt(i++));
                enc4 = key.indexOf(input.charAt(i++));
                chr1 = enc1 << 2 | enc2 >> 4;
                chr2 = (enc2 & 15) << 4 | enc3 >> 2;
                chr3 = (enc3 & 3) << 6 | enc4;
                output = output + chr(chr1);
                if (enc3 != 64) output = output + chr(chr2);
                if (enc4 != 64) output = output + chr(chr3);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            }while (i < input.length);
            return output;
        };
    }
    encodeBase64 = function encodeBase64(str) {
        return encodeAscii(unescape(encodeURIComponent(str)));
    };
    decodeBase64 = function decodeBase64(str) {
        return decodeURIComponent(escape(decodeAscii(str)));
    };
}
buildBase64();
module.exports = {
    encodeBase64: encodeBase64,
    decodeBase64: decodeBase64
};

},{"1b9ebebfb9d0538f":"dGCV2","217f53187b080cb0":"3I3iN"}],"dGCV2":[function(require,module,exports) {
"use strict";

},{}],"3I3iN":[function(require,module,exports) {
"use strict";
module.exports = String.fromCharCode;

},{}],"3Xf9D":[function(require,module,exports) {
"use strict";
var Sugar = require("ceccc3c177d0d1b1"), base64 = require("80ad62f589c38021");
var encodeBase64 = base64.encodeBase64;
Sugar.String.defineInstance({
    "encodeBase64": function(str) {
        return encodeBase64(str);
    }
});
module.exports = Sugar.String.encodeBase64;

},{"ceccc3c177d0d1b1":"dZZfL","80ad62f589c38021":"j5n9p"}],"5v1f4":[function(require,module,exports) {
"use strict";
var Sugar = require("73dee6f7ce76874f"), HTML_ESCAPE_REG = require("d5f7c09fea6fa1d4"), HTMLToEntityMap = require("e5d21ace45bc52b9"), coreUtilityAliases = require("5ffa3aacfd5010e2");
var getOwn = coreUtilityAliases.getOwn;
Sugar.String.defineInstance({
    "escapeHTML": function(str) {
        return str.replace(HTML_ESCAPE_REG, function(chr) {
            return getOwn(HTMLToEntityMap, chr);
        });
    }
});
module.exports = Sugar.String.escapeHTML;

},{"73dee6f7ce76874f":"dZZfL","d5f7c09fea6fa1d4":"848gv","e5d21ace45bc52b9":"eF3B8","5ffa3aacfd5010e2":"8ZxTV"}],"848gv":[function(require,module,exports) {
"use strict";
module.exports = /[&<>]/g;

},{}],"eF3B8":[function(require,module,exports) {
"use strict";
var HTMLFromEntityMap = require("b7ffdc265d5f7917"), coreUtilityAliases = require("ff2b08e55d4b21f");
var forEachProperty = coreUtilityAliases.forEachProperty;
var HTMLToEntityMap;
function buildEntities() {
    HTMLToEntityMap = {};
    forEachProperty(HTMLFromEntityMap, function(val, key) {
        HTMLToEntityMap[val] = "&" + key + ";";
    });
}
buildEntities();
module.exports = HTMLToEntityMap;

},{"b7ffdc265d5f7917":"3w3Ej","ff2b08e55d4b21f":"8ZxTV"}],"3w3Ej":[function(require,module,exports) {
"use strict";
var HTMLFromEntityMap = {
    "lt": "<",
    "gt": ">",
    "amp": "&",
    "nbsp": " ",
    "quot": '"',
    "apos": "'"
};
module.exports = HTMLFromEntityMap;

},{}],"03zWG":[function(require,module,exports) {
"use strict";
var Sugar = require("5b137eeca4d35369");
Sugar.String.defineInstance({
    "escapeURL": function(str, param) {
        return param ? encodeURIComponent(str) : encodeURI(str);
    }
});
module.exports = Sugar.String.escapeURL;

},{"5b137eeca4d35369":"dZZfL"}],"jhoDm":[function(require,module,exports) {
"use strict";
var Sugar = require("41623326711e3875"), isUndefined = require("4dd87a421cfd93ad");
Sugar.String.defineInstance({
    "first": function(str, num) {
        if (isUndefined(num)) num = 1;
        return str.substr(0, num);
    }
});
module.exports = Sugar.String.first;

},{"41623326711e3875":"dZZfL","4dd87a421cfd93ad":"6oRAa"}],"6oRAa":[function(require,module,exports) {
"use strict";
function isUndefined(o) {
    return o === undefined;
}
module.exports = isUndefined;

},{}],"649xU":[function(require,module,exports) {
"use strict";
var Sugar = require("35caf0a6ca21f165"), stringEach = require("558bd28de8dfeb8e");
Sugar.String.defineInstance({
    "forEach": function(str, search, eachFn) {
        return stringEach(str, search, eachFn);
    }
});
module.exports = Sugar.String.forEach;

},{"35caf0a6ca21f165":"dZZfL","558bd28de8dfeb8e":"uBLqS"}],"7M1ZS":[function(require,module,exports) {
"use strict";
var Sugar = require("bd3b4150026fec8c"), isObjectType = require("5d05b9b4644d28cf"), stringFormatMatcher = require("89642b82034f2261");
Sugar.String.defineInstanceWithArguments({
    "format": function(str, args) {
        var arg1 = args[0] && args[0].valueOf();
        // Unwrap if a single object is passed in.
        if (args.length === 1 && isObjectType(arg1)) args = arg1;
        return stringFormatMatcher(str, args);
    }
});
module.exports = Sugar.String.format;

},{"bd3b4150026fec8c":"dZZfL","5d05b9b4644d28cf":"1dImj","89642b82034f2261":"jol9E"}],"jol9E":[function(require,module,exports) {
"use strict";
var deepGetProperty = require("c7b9c1b5d3437a8f"), createFormatMatcher = require("9e5cc1f72f685b55");
module.exports = createFormatMatcher(deepGetProperty);

},{"c7b9c1b5d3437a8f":"4GhMu","9e5cc1f72f685b55":"jOe0l"}],"4GhMu":[function(require,module,exports) {
"use strict";
var handleDeepProperty = require("b796dc38ef6d44b4");
function deepGetProperty(obj, key, any) {
    return handleDeepProperty(obj, key, any, false);
}
module.exports = deepGetProperty;

},{"b796dc38ef6d44b4":"G37fv"}],"G37fv":[function(require,module,exports) {
"use strict";
var PROPERTY_RANGE_REG = require("b35b35247d3ce10"), CommonChars = require("7a3c3b1b6e3699e"), map = require("5ba4dd7ae67a7b1c"), isDefined = require("b33980e178f84696"), classChecks = require("3db7ea8350f5f913"), periodSplit = require("2f330ffa15e55efc"), assertArray = require("3cf4b8af5f02bd9b"), isObjectType = require("a7457a20a87af60a"), assertWritable = require("5a3c816e37dc9ecb"), coreUtilityAliases = require("4daab2c9ba045f63");
var isString = classChecks.isString, hasOwn = coreUtilityAliases.hasOwn, HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;
function handleDeepProperty(obj, key, any, has, fill, fillLast, val) {
    var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
    ns = obj;
    if (key == null) return;
    if (isObjectType(key)) // Allow array and array-like accessors
    bs = [
        key
    ];
    else {
        key = String(key);
        if (key.indexOf("..") !== -1) return handleArrayIndexRange(obj, key, any, val);
        bs = key.split("[");
    }
    set = isDefined(val);
    for(var i = 0, blen = bs.length; i < blen; i++){
        ps = bs[i];
        if (isString(ps)) ps = periodSplit(ps);
        for(var j = 0, plen = ps.length; j < plen; j++){
            key = ps[j];
            // Is this the last key?
            isLast = i === blen - 1 && j === plen - 1;
            // Index of the closing ]
            cbi = key.indexOf("]");
            // Is the key an array index?
            isIndex = cbi !== -1;
            // Is this array push syntax "[]"?
            isPush = set && cbi === 0;
            // If the bracket split was successful and this is the last element
            // in the dot split, then we know the next key will be an array index.
            nextIsIndex = blen > 1 && j === plen - 1;
            if (isPush) // Set the index to the end of the array
            key = ns.length;
            else if (isIndex) // Remove the closing ]
            key = key.slice(0, -1);
            // If the array index is less than 0, then
            // add its length to allow negative indexes.
            if (isIndex && key < 0) key = +key + ns.length;
            // Bracket keys may look like users[5] or just [5], so the leading
            // characters are optional. We can enter the namespace if this is the
            // 2nd part, if there is only 1 part, or if there is an explicit key.
            if (i || key || blen === 1) {
                // TODO: need to be sure this check handles ''.length when
                // we refactor.
                exists = any ? key in Object(ns) : hasOwn(ns, key);
                // Non-existent namespaces are only filled if they are intermediate
                // (not at the end) or explicitly filling the last.
                if (fill && (!isLast || fillLast) && !exists) {
                    // For our purposes, last only needs to be an array.
                    ns = ns[key] = nextIsIndex || fillLast && isLast ? [] : {};
                    continue;
                }
                if (has) {
                    if (isLast || !exists) return exists;
                } else if (set && isLast) {
                    assertWritable(ns);
                    ns[key] = val;
                }
                ns = exists ? ns[key] : undefined;
            }
        }
    }
    return ns;
}
function handleArrayIndexRange(obj, key, any, val) {
    var match, start, end, leading, trailing, arr, set;
    match = key.match(PROPERTY_RANGE_REG);
    if (!match) return;
    set = isDefined(val);
    leading = match[1];
    if (leading) arr = handleDeepProperty(obj, leading, any, false, set ? true : false, true);
    else arr = obj;
    assertArray(arr);
    trailing = match[4];
    start = match[2] ? +match[2] : 0;
    end = match[3] ? +match[3] : arr.length;
    // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
    // pushes the index from -1 to 0, then set it to the full length of the
    // array, otherwise it will return nothing.
    end = end === -1 ? arr.length : end + 1;
    if (set) for(var i = start; i < end; i++)handleDeepProperty(arr, i + trailing, any, false, true, false, val);
    else {
        arr = arr.slice(start, end);
        // If there are trailing properties, then they need to be mapped for each
        // element in the array.
        if (trailing) {
            if (trailing.charAt(0) === HALF_WIDTH_PERIOD) // Need to chomp the period if one is trailing after the range. We
            // can't do this at the regex level because it will be required if
            // we're setting the value as it needs to be concatentated together
            // with the array index to be set.
            trailing = trailing.slice(1);
            return map(arr, function(el) {
                return handleDeepProperty(el, trailing);
            });
        }
    }
    return arr;
}
module.exports = handleDeepProperty;

},{"b35b35247d3ce10":"kqTF5","7a3c3b1b6e3699e":"9C1NQ","5ba4dd7ae67a7b1c":"7WglA","b33980e178f84696":"4cOOJ","3db7ea8350f5f913":"MTXUY","2f330ffa15e55efc":"j3jYr","3cf4b8af5f02bd9b":"hqQ4W","a7457a20a87af60a":"1dImj","5a3c816e37dc9ecb":"hKFZQ","4daab2c9ba045f63":"8ZxTV"}],"kqTF5":[function(require,module,exports) {
"use strict";
module.exports = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;

},{}],"9C1NQ":[function(require,module,exports) {
"use strict";
module.exports = {
    HALF_WIDTH_ZERO: 0x30,
    FULL_WIDTH_ZERO: 0xff10,
    HALF_WIDTH_PERIOD: ".",
    FULL_WIDTH_PERIOD: "\uFF0E",
    HALF_WIDTH_COMMA: ",",
    OPEN_BRACE: "{",
    CLOSE_BRACE: "}"
};

},{}],"7WglA":[function(require,module,exports) {
"use strict";
function map(arr, fn) {
    // perf: Not using fixed array len here as it may be sparse.
    var result = [];
    for(var i = 0, len = arr.length; i < len; i++)if (i in arr) result.push(fn(arr[i], i));
    return result;
}
module.exports = map;

},{}],"j3jYr":[function(require,module,exports) {
"use strict";
var CommonChars = require("728462489542a74c");
var HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;
function periodSplit(str) {
    return str.split(HALF_WIDTH_PERIOD);
}
module.exports = periodSplit;

},{"728462489542a74c":"9C1NQ"}],"hqQ4W":[function(require,module,exports) {
"use strict";
var classChecks = require("46b9dd5370c6cfcf");
var isArray = classChecks.isArray;
function assertArray(obj) {
    if (!isArray(obj)) throw new TypeError("Array required");
}
module.exports = assertArray;

},{"46b9dd5370c6cfcf":"MTXUY"}],"hKFZQ":[function(require,module,exports) {
"use strict";
var isPrimitive = require("cd7aee48c1d3631f");
function assertWritable(obj) {
    if (isPrimitive(obj)) // If strict mode is active then primitives will throw an
    // error when attempting to write properties. We can't be
    // sure if strict mode is available, so pre-emptively
    // throw an error here to ensure consistent behavior.
    throw new TypeError("Property cannot be written");
}
module.exports = assertWritable;

},{"cd7aee48c1d3631f":"j6hv6"}],"j6hv6":[function(require,module,exports) {
"use strict";
function isPrimitive(obj, type) {
    type = type || typeof obj;
    return obj == null || type === "string" || type === "number" || type === "boolean";
}
module.exports = isPrimitive;

},{}],"jOe0l":[function(require,module,exports) {
"use strict";
var STRING_FORMAT_REG = require("7ea2cecf92f44ab4"), CommonChars = require("7cbe80edd5e5abde"), memoizeFunction = require("3fc5afc31bf7b7cb");
var OPEN_BRACE = CommonChars.OPEN_BRACE, CLOSE_BRACE = CommonChars.CLOSE_BRACE;
function createFormatMatcher(bracketMatcher, percentMatcher, precheck) {
    var reg = STRING_FORMAT_REG;
    var compileMemoized = memoizeFunction(compile);
    function getToken(format, match) {
        var get, token, literal, fn;
        var bKey = match[2];
        var pLit = match[3];
        var pKey = match[5];
        if (match[4] && percentMatcher) {
            token = pKey;
            get = percentMatcher;
        } else if (bKey) {
            token = bKey;
            get = bracketMatcher;
        } else if (pLit && percentMatcher) literal = pLit;
        else literal = match[1] || match[0];
        if (get) {
            assertPassesPrecheck(precheck, bKey, pKey);
            fn = function fn(obj, opt) {
                return get(obj, token, opt);
            };
        }
        format.push(fn || getLiteral(literal));
    }
    function getSubstring(format, str, start, end) {
        if (end > start) {
            var sub = str.slice(start, end);
            assertNoUnmatched(sub, OPEN_BRACE);
            assertNoUnmatched(sub, CLOSE_BRACE);
            format.push(function() {
                return sub;
            });
        }
    }
    function getLiteral(str) {
        return function() {
            return str;
        };
    }
    function assertPassesPrecheck(precheck, bt, pt) {
        if (precheck && !precheck(bt, pt)) throw new TypeError("Invalid token " + (bt || pt) + " in format string");
    }
    function assertNoUnmatched(str, chr) {
        if (str.indexOf(chr) !== -1) throw new TypeError("Unmatched " + chr + " in format string");
    }
    function compile(str) {
        var format = [], lastIndex = 0, match;
        reg.lastIndex = 0;
        while(match = reg.exec(str)){
            getSubstring(format, str, lastIndex, match.index);
            getToken(format, match);
            lastIndex = reg.lastIndex;
        }
        getSubstring(format, str, lastIndex, str.length);
        return format;
    }
    return function(str, obj, opt) {
        var format = compileMemoized(str), result = "";
        for(var i = 0; i < format.length; i++)result += format[i](obj, opt);
        return result;
    };
}
module.exports = createFormatMatcher;

},{"7ea2cecf92f44ab4":"h9Y0j","7cbe80edd5e5abde":"9C1NQ","3fc5afc31bf7b7cb":"6Ev2v"}],"h9Y0j":[function(require,module,exports) {
"use strict";
module.exports = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;

},{}],"6Ev2v":[function(require,module,exports) {
"use strict";
var INTERNAL_MEMOIZE_LIMIT = require("34e61f3e77a44333"), coreUtilityAliases = require("67033e4869ec8f95");
var hasOwn = coreUtilityAliases.hasOwn;
function memoizeFunction(fn) {
    var memo = {}, counter = 0;
    return function(key) {
        if (hasOwn(memo, key)) return memo[key];
        // istanbul ignore if
        if (counter === INTERNAL_MEMOIZE_LIMIT) {
            memo = {};
            counter = 0;
        }
        counter++;
        return memo[key] = fn(key);
    };
}
module.exports = memoizeFunction;

},{"34e61f3e77a44333":"fwqd1","67033e4869ec8f95":"8ZxTV"}],"fwqd1":[function(require,module,exports) {
"use strict";
module.exports = 1000;

},{}],"dmeNj":[function(require,module,exports) {
"use strict";
var Sugar = require("d9f9679296084030"), numberOrIndex = require("cbcff09834f6c6c5");
Sugar.String.defineInstance({
    "from": function(str, from) {
        return str.slice(numberOrIndex(str, from, true));
    }
});
module.exports = Sugar.String.from;

},{"d9f9679296084030":"dZZfL","cbcff09834f6c6c5":"3xLUz"}],"3xLUz":[function(require,module,exports) {
"use strict";
var classChecks = require("5eb23772c0617b22");
var isString = classChecks.isString;
function numberOrIndex(str, n, from) {
    if (isString(n)) {
        n = str.indexOf(n);
        if (n === -1) n = from ? str.length : 0;
    }
    return n;
}
module.exports = numberOrIndex;

},{"5eb23772c0617b22":"MTXUY"}],"3o9t5":[function(require,module,exports) {
"use strict";
var Sugar = require("87de586c7d4e0b3e"), ENHANCEMENTS_FLAG = require("513a2c8040bbaf39"), STRING_ENHANCEMENTS_FLAG = require("979884c35b3d3d9b"), fixArgumentLength = require("a0325ebc980f249b"), callIncludesWithRegexSupport = require("d3b1dee67c05d204");
Sugar.String.defineInstance({
    "includes": fixArgumentLength(callIncludesWithRegexSupport)
}, [
    ENHANCEMENTS_FLAG,
    STRING_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.String.includes;

},{"87de586c7d4e0b3e":"dZZfL","513a2c8040bbaf39":"1fjNl","979884c35b3d3d9b":"amHsX","a0325ebc980f249b":"lHgf7","d3b1dee67c05d204":"2n4iK"}],"1fjNl":[function(require,module,exports) {
"use strict";
module.exports = "enhance";

},{}],"amHsX":[function(require,module,exports) {
"use strict";
module.exports = "enhanceString";

},{}],"lHgf7":[function(require,module,exports) {
"use strict";
function fixArgumentLength(fn) {
    var staticFn = function staticFn(a) {
        var args = arguments;
        return fn(a, args[1], args[2], args.length - 1);
    };
    staticFn.instance = function(b) {
        var args = arguments;
        return fn(this, b, args[1], args.length);
    };
    return staticFn;
}
module.exports = fixArgumentLength;

},{}],"2n4iK":[function(require,module,exports) {
"use strict";
var classChecks = require("beb359aa8899611"), nativeIncludes = require("9c2d235965cc96a2");
var isRegExp = classChecks.isRegExp;
function callIncludesWithRegexSupport(str, search, position) {
    if (!isRegExp(search)) return nativeIncludes.call(str, search, position);
    if (position) str = str.slice(position);
    return search.test(str);
}
module.exports = callIncludesWithRegexSupport;

},{"beb359aa8899611":"MTXUY","9c2d235965cc96a2":"8FwNr"}],"8FwNr":[function(require,module,exports) {
"use strict";
module.exports = String.prototype.includes;

},{}],"cHVBw":[function(require,module,exports) {
"use strict";
var Sugar = require("a3ae236fefe0455e"), isUndefined = require("f50e0abf1c9e619");
Sugar.String.defineInstance({
    "insert": function(str, substr, index) {
        index = isUndefined(index) ? str.length : index;
        return str.slice(0, index) + substr + str.slice(index);
    }
});
module.exports = Sugar.String.insert;

},{"a3ae236fefe0455e":"dZZfL","f50e0abf1c9e619":"6oRAa"}],"37Udv":[function(require,module,exports) {
"use strict";
var Sugar = require("6ec38f0384f958e1"), trim = require("9983de6068b0eea6");
Sugar.String.defineInstance({
    "isBlank": function(str) {
        return trim(str).length === 0;
    }
});
module.exports = Sugar.String.isBlank;

},{"6ec38f0384f958e1":"dZZfL","9983de6068b0eea6":"2PiXk"}],"k5H2K":[function(require,module,exports) {
"use strict";
var Sugar = require("5cbf507ac27a61a2");
Sugar.String.defineInstance({
    "isEmpty": function(str) {
        return str.length === 0;
    }
});
module.exports = Sugar.String.isEmpty;

},{"5cbf507ac27a61a2":"dZZfL"}],"eXrHR":[function(require,module,exports) {
"use strict";
var Sugar = require("6ce2261158506bbb"), isUndefined = require("3d40069224901984");
Sugar.String.defineInstance({
    "last": function(str, num) {
        if (isUndefined(num)) num = 1;
        var start = str.length - num < 0 ? 0 : str.length - num;
        return str.substr(start);
    }
});
module.exports = Sugar.String.last;

},{"6ce2261158506bbb":"dZZfL","3d40069224901984":"6oRAa"}],"5sY5x":[function(require,module,exports) {
"use strict";
var Sugar = require("188da65dd677569c"), trim = require("fa6337bb478dccfb"), stringEach = require("a4f6e2f6a218e6d0");
Sugar.String.defineInstance({
    "lines": function(str, eachLineFn) {
        return stringEach(trim(str), /^.*$/gm, eachLineFn);
    }
});
module.exports = Sugar.String.lines;

},{"188da65dd677569c":"dZZfL","fa6337bb478dccfb":"2PiXk","a4f6e2f6a218e6d0":"uBLqS"}],"8zOEG":[function(require,module,exports) {
"use strict";
var Sugar = require("d9f6cd2964fa17bb"), padString = require("db470b8ee79ed564"), mathAliases = require("9ce955214bd296be"), coercePositiveInteger = require("4d6b6b525ceb2ea9");
var max = mathAliases.max, ceil = mathAliases.ceil, floor = mathAliases.floor;
Sugar.String.defineInstance({
    "pad": function(str, num, padding) {
        var half, front, back;
        num = coercePositiveInteger(num);
        half = max(0, num - str.length) / 2;
        front = floor(half);
        back = ceil(half);
        return padString(front, padding) + str + padString(back, padding);
    }
});
module.exports = Sugar.String.pad;

},{"d9f6cd2964fa17bb":"dZZfL","db470b8ee79ed564":"jPqdK","9ce955214bd296be":"f1S5P","4d6b6b525ceb2ea9":"eBp8T"}],"jPqdK":[function(require,module,exports) {
"use strict";
var isDefined = require("20574a6b8a454961"), repeatString = require("eff0a75dc0ad534");
function padString(num, padding) {
    return repeatString(isDefined(padding) ? padding : " ", num);
}
module.exports = padString;

},{"20574a6b8a454961":"4cOOJ","eff0a75dc0ad534":"g8ZYR"}],"g8ZYR":[function(require,module,exports) {
"use strict";
function repeatString(str, num) {
    var result = "";
    str = str.toString();
    while(num > 0){
        if (num & 1) result += str;
        if (num >>= 1) str += str;
    }
    return result;
}
module.exports = repeatString;

},{}],"f1S5P":[function(require,module,exports) {
"use strict";
module.exports = {
    abs: Math.abs,
    pow: Math.pow,
    min: Math.min,
    max: Math.max,
    ceil: Math.ceil,
    floor: Math.floor,
    round: Math.round
};

},{}],"eBp8T":[function(require,module,exports) {
"use strict";
var trunc = require("ab16dbe17f17a5c6"), classChecks = require("49ede6472423841f");
var isNumber = classChecks.isNumber;
function coercePositiveInteger(n) {
    n = +n || 0;
    if (n < 0 || !isNumber(n) || !isFinite(n)) throw new RangeError("Invalid number");
    return trunc(n);
}
module.exports = coercePositiveInteger;

},{"ab16dbe17f17a5c6":"898n5","49ede6472423841f":"MTXUY"}],"898n5":[function(require,module,exports) {
"use strict";
var mathAliases = require("77f5602ddc7ce029");
var ceil = mathAliases.ceil, floor = mathAliases.floor;
var trunc = Math.trunc || function(n) {
    if (n === 0 || !isFinite(n)) return n;
    return n < 0 ? ceil(n) : floor(n);
};
module.exports = trunc;

},{"77f5602ddc7ce029":"f1S5P"}],"9e17D":[function(require,module,exports) {
"use strict";
var Sugar = require("6e40fa70a8b25678"), padString = require("8275f1d850abc188"), mathAliases = require("a6357c8ee7bc3afc"), coercePositiveInteger = require("20702af9dea3dc7d");
var max = mathAliases.max;
Sugar.String.defineInstance({
    "padLeft": function(str, num, padding) {
        num = coercePositiveInteger(num);
        return padString(max(0, num - str.length), padding) + str;
    }
});
module.exports = Sugar.String.padLeft;

},{"6e40fa70a8b25678":"dZZfL","8275f1d850abc188":"jPqdK","a6357c8ee7bc3afc":"f1S5P","20702af9dea3dc7d":"eBp8T"}],"jn9lF":[function(require,module,exports) {
"use strict";
var Sugar = require("2f0f428933a4e5b1"), padString = require("c0ffc48e32fca1e4"), mathAliases = require("f582b010cd43634f"), coercePositiveInteger = require("d3e82fff2f1c83bd");
var max = mathAliases.max;
Sugar.String.defineInstance({
    "padRight": function(str, num, padding) {
        num = coercePositiveInteger(num);
        return str + padString(max(0, num - str.length), padding);
    }
});
module.exports = Sugar.String.padRight;

},{"2f0f428933a4e5b1":"dZZfL","c0ffc48e32fca1e4":"jPqdK","f582b010cd43634f":"f1S5P","d3e82fff2f1c83bd":"eBp8T"}],"dc8If":[function(require,module,exports) {
"use strict";
var Sugar = require("9fa4b161c821558d"), stringParameterize = require("c7f8d03313a7708f");
Sugar.String.defineInstance({
    "parameterize": function(str, separator) {
        return stringParameterize(str, separator);
    }
});
module.exports = Sugar.String.parameterize;

},{"9fa4b161c821558d":"dZZfL","c7f8d03313a7708f":"exZW2"}],"exZW2":[function(require,module,exports) {
"use strict";
var escapeRegExp = require("60caaa922dff644");
function stringParameterize(str, separator) {
    if (separator === undefined) separator = "-";
    str = str.replace(/[^a-z0-9\-_]+/gi, separator);
    if (separator) {
        var reg = RegExp("^{s}+|{s}+$|({s}){s}+".split("{s}").join(escapeRegExp(separator)), "g");
        str = str.replace(reg, "$1");
    }
    return encodeURI(str.toLowerCase());
}
module.exports = stringParameterize;

},{"60caaa922dff644":"6dbXB"}],"9MfUj":[function(require,module,exports) {
"use strict";
var Sugar = require("9b72c468ac75c0ad");
Sugar.String.defineInstance({
    "remove": function(str, f) {
        return str.replace(f, "");
    }
});
module.exports = Sugar.String.remove;

},{"9b72c468ac75c0ad":"dZZfL"}],"e4N9o":[function(require,module,exports) {
"use strict";
var Sugar = require("6fc06128267b642"), stringReplaceAll = require("124ff9f5911e1480");
Sugar.String.defineInstance({
    "removeAll": function(str, f) {
        return stringReplaceAll(str, f);
    }
});
module.exports = Sugar.String.removeAll;

},{"6fc06128267b642":"dZZfL","124ff9f5911e1480":"aI1pY"}],"aI1pY":[function(require,module,exports) {
"use strict";
var classChecks = require("6bbaa578be9fdb1b"), escapeRegExp = require("f937f4e440fe73a5"), getRegExpFlags = require("952206e20b8444d6");
var isString = classChecks.isString;
function stringReplaceAll(str, f, replace) {
    var i = 0, tokens;
    if (isString(f)) f = RegExp(escapeRegExp(f), "g");
    else if (f && !f.global) f = RegExp(f.source, getRegExpFlags(f, "g"));
    if (!replace) replace = "";
    else {
        tokens = replace;
        replace = function replace() {
            var t = tokens[i++];
            return t != null ? t : "";
        };
    }
    return str.replace(f, replace);
}
module.exports = stringReplaceAll;

},{"6bbaa578be9fdb1b":"MTXUY","f937f4e440fe73a5":"6dbXB","952206e20b8444d6":"8qWd6"}],"7RyVd":[function(require,module,exports) {
"use strict";
var Sugar = require("960f2d1aa041ff0b"), replaceTags = require("2c16ec8693f111cc");
Sugar.String.defineInstance({
    "removeTags": function(str, tag, replace) {
        return replaceTags(str, tag, replace, false);
    }
});
module.exports = Sugar.String.removeTags;

},{"960f2d1aa041ff0b":"dZZfL","2c16ec8693f111cc":"9kLbY"}],"9kLbY":[function(require,module,exports) {
"use strict";
var map = require("ff17268ef325d54e"), classChecks = require("34db12eabb799b87"), escapeRegExp = require("c270ea6458bee7ed"), runTagReplacements = require("3dd6338355e657d7");
var isString = classChecks.isString;
function replaceTags(str, find, replacement, strip) {
    var tags = isString(find) ? [
        find
    ] : find, reg, src;
    tags = map(tags || [], function(t) {
        return escapeRegExp(t);
    }).join("|");
    src = tags.replace("all", "") || "[^\\s>]+";
    src = "<(\\/)?(" + src + ")(\\s+[^<>]*?)?\\s*(\\/)?>";
    reg = RegExp(src, "gi");
    return runTagReplacements(str.toString(), reg, strip, replacement);
}
module.exports = replaceTags;

},{"ff17268ef325d54e":"7WglA","34db12eabb799b87":"MTXUY","c270ea6458bee7ed":"6dbXB","3dd6338355e657d7":"lAcBm"}],"lAcBm":[function(require,module,exports) {
"use strict";
var tagIsVoid = require("b57833e09fb96a11"), classChecks = require("dc4e59c27b47fcbc");
var isString = classChecks.isString;
function runTagReplacements(str, reg, strip, replacement, fullString) {
    var match;
    var result = "";
    var currentIndex = 0;
    var openTagName;
    var openTagAttributes;
    var openTagCount = 0;
    function processTag(index, tagName, attributes, tagLength, isVoid) {
        var content = str.slice(currentIndex, index), s = "", r = "";
        if (isString(replacement)) r = replacement;
        else if (replacement) r = replacement.call(fullString, tagName, content, attributes, fullString) || "";
        if (strip) s = r;
        else content = r;
        if (content) content = runTagReplacements(content, reg, strip, replacement, fullString);
        result += s + content + (isVoid ? "" : s);
        currentIndex = index + (tagLength || 0);
    }
    fullString = fullString || str;
    reg = RegExp(reg.source, "gi");
    while(match = reg.exec(str)){
        var tagName = match[2];
        var attributes = (match[3] || "").slice(1);
        var isClosingTag = !!match[1];
        var isSelfClosing = !!match[4];
        var tagLength = match[0].length;
        var isVoid = tagIsVoid(tagName);
        var isOpeningTag = !isClosingTag && !isSelfClosing && !isVoid;
        var isSameAsCurrent = tagName === openTagName;
        if (!openTagName) {
            result += str.slice(currentIndex, match.index);
            currentIndex = match.index;
        }
        if (isOpeningTag) {
            if (!openTagName) {
                openTagName = tagName;
                openTagAttributes = attributes;
                openTagCount++;
                currentIndex += tagLength;
            } else if (isSameAsCurrent) openTagCount++;
        } else if (isClosingTag && isSameAsCurrent) {
            openTagCount--;
            if (openTagCount === 0) {
                processTag(match.index, openTagName, openTagAttributes, tagLength, isVoid);
                openTagName = null;
                openTagAttributes = null;
            }
        } else if (!openTagName) processTag(match.index, tagName, attributes, tagLength, isVoid);
    }
    if (openTagName) processTag(str.length, openTagName, openTagAttributes);
    result += str.slice(currentIndex);
    return result;
}
module.exports = runTagReplacements;

},{"b57833e09fb96a11":"dbnVn","dc4e59c27b47fcbc":"MTXUY"}],"dbnVn":[function(require,module,exports) {
"use strict";
var HTML_VOID_ELEMENTS = require("90d93c827ca57eae"), indexOf = require("5d0a6fce20527a82");
function tagIsVoid(tag) {
    return indexOf(HTML_VOID_ELEMENTS, tag.toLowerCase()) !== -1;
}
module.exports = tagIsVoid;

},{"90d93c827ca57eae":"cm2ID","5d0a6fce20527a82":"6IUmj"}],"cm2ID":[function(require,module,exports) {
"use strict";
var HTML_VOID_ELEMENTS = [
    "area",
    "base",
    "br",
    "col",
    "command",
    "embed",
    "hr",
    "img",
    "input",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
];
module.exports = HTML_VOID_ELEMENTS;

},{}],"6IUmj":[function(require,module,exports) {
"use strict";
function indexOf(arr, el) {
    for(var i = 0, len = arr.length; i < len; i++){
        if (i in arr && arr[i] === el) return i;
    }
    return -1;
}
module.exports = indexOf;

},{}],"eK4U3":[function(require,module,exports) {
"use strict";
var Sugar = require("9238355c3bdb0f35"), stringReplaceAll = require("abba4c1c887d16da");
Sugar.String.defineInstanceWithArguments({
    "replaceAll": function(str, f, args) {
        return stringReplaceAll(str, f, args);
    }
});
module.exports = Sugar.String.replaceAll;

},{"9238355c3bdb0f35":"dZZfL","abba4c1c887d16da":"aI1pY"}],"kmbZe":[function(require,module,exports) {
"use strict";
var Sugar = require("105c7477313b4439"), reverseString = require("b9f63f7a64cd9ea8");
Sugar.String.defineInstance({
    "reverse": function(str) {
        return reverseString(str);
    }
});
module.exports = Sugar.String.reverse;

},{"105c7477313b4439":"dZZfL","b9f63f7a64cd9ea8":"7PxXQ"}],"7PxXQ":[function(require,module,exports) {
"use strict";
function reverseString(str) {
    return str.split("").reverse().join("");
}
module.exports = reverseString;

},{}],"5GWKU":[function(require,module,exports) {
"use strict";
var Sugar = require("9f793bb3b2f47a78"), chr = require("9711cde41a43392c"), stringCodes = require("3063b34e2081134e");
Sugar.String.defineInstance({
    "shift": function(str, n) {
        var result = "";
        n = n || 0;
        stringCodes(str, function(c) {
            result += chr(c + n);
        });
        return result;
    }
});
module.exports = Sugar.String.shift;

},{"9f793bb3b2f47a78":"dZZfL","9711cde41a43392c":"3I3iN","3063b34e2081134e":"fqoaX"}],"11mev":[function(require,module,exports) {
"use strict";
var Sugar = require("ded8b71c5a76501"), stringSpacify = require("c95106fb88387650");
Sugar.String.defineInstance({
    "spacify": function(str) {
        return stringSpacify(str);
    }
});
module.exports = Sugar.String.spacify;

},{"ded8b71c5a76501":"dZZfL","c95106fb88387650":"9ZJNN"}],"9ZJNN":[function(require,module,exports) {
"use strict";
var stringUnderscore = require("fce443a8e10df54d");
function stringSpacify(str) {
    return stringUnderscore(str).replace(/_/g, " ");
}
module.exports = stringSpacify;

},{"fce443a8e10df54d":"bmwzU"}],"hVxWi":[function(require,module,exports) {
"use strict";
var Sugar = require("c6efa3502431ed8c"), replaceTags = require("7e250f25542e32e2");
Sugar.String.defineInstance({
    "stripTags": function(str, tag, replace) {
        return replaceTags(str, tag, replace, true);
    }
});
module.exports = Sugar.String.stripTags;

},{"c6efa3502431ed8c":"dZZfL","7e250f25542e32e2":"9kLbY"}],"dL8J6":[function(require,module,exports) {
"use strict";
var Sugar = require("1ade2a1b22db28b5"), stringTitleize = require("3e8cd367d8f70d20");
Sugar.String.defineInstance({
    "titleize": function(str) {
        return stringTitleize(str);
    }
});
module.exports = Sugar.String.titleize;

},{"1ade2a1b22db28b5":"dZZfL","3e8cd367d8f70d20":"l9Isd"}],"l9Isd":[function(require,module,exports) {
"use strict";
var DOWNCASED_WORDS = require("ee193263be579dd7"), indexOf = require("acdecb0a19f9638f"), eachWord = require("53a3e37af1aee389"), getAcronym = require("a9a450ba68dfc031"), getHumanWord = require("4ae8a8da0f233237"), runHumanRules = require("20a20541757f6323"), stringSpacify = require("928d34af5c272c24"), stringCapitalize = require("57dd02bb652405e7");
function stringTitleize(str) {
    var fullStopPunctuation = /[.:;!]$/, lastHadPunctuation;
    str = runHumanRules(str);
    str = stringSpacify(str);
    return eachWord(str, function(word, index, words) {
        word = getHumanWord(word) || word;
        word = getAcronym(word) || word;
        var hasPunctuation, isFirstOrLast;
        var first = index == 0, last = index == words.length - 1;
        hasPunctuation = fullStopPunctuation.test(word);
        isFirstOrLast = first || last || hasPunctuation || lastHadPunctuation;
        lastHadPunctuation = hasPunctuation;
        if (isFirstOrLast || indexOf(DOWNCASED_WORDS, word) === -1) return stringCapitalize(word, false, true);
        else return word;
    }).join(" ");
}
module.exports = stringTitleize;

},{"ee193263be579dd7":"l6Xfm","acdecb0a19f9638f":"6IUmj","53a3e37af1aee389":"8n8wd","a9a450ba68dfc031":"fbYl3","4ae8a8da0f233237":"7DWv0","20a20541757f6323":"689PU","928d34af5c272c24":"9ZJNN","57dd02bb652405e7":"4AS2H"}],"l6Xfm":[function(require,module,exports) {
"use strict";
var DOWNCASED_WORDS = [
    "and",
    "or",
    "nor",
    "a",
    "an",
    "the",
    "so",
    "but",
    "to",
    "of",
    "at",
    "by",
    "from",
    "into",
    "on",
    "onto",
    "off",
    "out",
    "in",
    "over",
    "with",
    "for"
];
module.exports = DOWNCASED_WORDS;

},{}],"8n8wd":[function(require,module,exports) {
"use strict";
var trim = require("fa4fab41bf979bc0"), stringEach = require("8973ec15c9f4d54e");
function eachWord(str, fn) {
    return stringEach(trim(str), /\S+/g, fn);
}
module.exports = eachWord;

},{"fa4fab41bf979bc0":"2PiXk","8973ec15c9f4d54e":"uBLqS"}],"7DWv0":[function(require,module,exports) {
"use strict";
var Inflections = require("2702488cb5676b59");
function getHumanWord(str) {
    // istanbul ignore next
    return Inflections.human && Inflections.human.find(str);
}
module.exports = getHumanWord;

},{"2702488cb5676b59":"aNtOu"}],"689PU":[function(require,module,exports) {
"use strict";
var Inflections = require("9896e792a4db770e");
function runHumanRules(str) {
    // istanbul ignore next
    return Inflections.human && Inflections.human.runRules(str) || str;
}
module.exports = runHumanRules;

},{"9896e792a4db770e":"aNtOu"}],"4tWEs":[function(require,module,exports) {
"use strict";
var Sugar = require("7278db2343fe651a"), isUndefined = require("2a189ba174f752b0"), numberOrIndex = require("7e4ade4b682ab17b");
Sugar.String.defineInstance({
    "to": function(str, to) {
        if (isUndefined(to)) to = str.length;
        return str.slice(0, numberOrIndex(str, to));
    }
});
module.exports = Sugar.String.to;

},{"7278db2343fe651a":"dZZfL","2a189ba174f752b0":"6oRAa","7e4ade4b682ab17b":"3xLUz"}],"dUX9R":[function(require,module,exports) {
"use strict";
var Sugar = require("2df35e78c137974b"), stringToNumber = require("b88d271e4a06c273");
Sugar.String.defineInstance({
    "toNumber": function(str, base) {
        return stringToNumber(str, base);
    }
});
module.exports = Sugar.String.toNumber;

},{"2df35e78c137974b":"dZZfL","b88d271e4a06c273":"3jdZa"}],"3jdZa":[function(require,module,exports) {
"use strict";
var CommonChars = require("f1c99d3b9d8e6dc2"), coreUtilityAliases = require("c4fd3d0daccad01f"), fullwidthNumberHelpers = require("3d5fbc1507b88ec");
var fullWidthNumberReg = fullwidthNumberHelpers.fullWidthNumberReg, fullWidthNumberMap = fullwidthNumberHelpers.fullWidthNumberMap, getOwn = coreUtilityAliases.getOwn, HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;
function stringToNumber(str, base) {
    var sanitized, isDecimal;
    sanitized = str.replace(fullWidthNumberReg, function(chr) {
        var replacement = getOwn(fullWidthNumberMap, chr);
        if (replacement === HALF_WIDTH_PERIOD) isDecimal = true;
        return replacement;
    });
    return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
}
module.exports = stringToNumber;

},{"f1c99d3b9d8e6dc2":"9C1NQ","c4fd3d0daccad01f":"8ZxTV","3d5fbc1507b88ec":"b0eEs"}],"b0eEs":[function(require,module,exports) {
"use strict";
var CommonChars = require("abac857dfaf8df9a"), chr = require("a8434b5c6a0a59b0"), allCharsReg = require("fec0d64638a1bdcb");
var HALF_WIDTH_ZERO = CommonChars.HALF_WIDTH_ZERO, FULL_WIDTH_ZERO = CommonChars.FULL_WIDTH_ZERO, HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD, FULL_WIDTH_PERIOD = CommonChars.FULL_WIDTH_PERIOD, HALF_WIDTH_COMMA = CommonChars.HALF_WIDTH_COMMA;
var fullWidthNumberReg, fullWidthNumberMap, fullWidthNumbers;
function buildFullWidthNumber() {
    var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA, fwn = "";
    fullWidthNumberMap = {};
    for(var i = 0, digit; i <= 9; i++){
        digit = chr(i + FULL_WIDTH_ZERO);
        fwn += digit;
        fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
    }
    fullWidthNumberMap[hwc] = "";
    fullWidthNumberMap[fwp] = hwp;
    // Mapping this to itself to capture it easily
    // in stringToNumber to detect decimals later.
    fullWidthNumberMap[hwp] = hwp;
    fullWidthNumberReg = allCharsReg(fwn + fwp + hwc + hwp);
    fullWidthNumbers = fwn;
}
buildFullWidthNumber();
module.exports = {
    fullWidthNumberReg: fullWidthNumberReg,
    fullWidthNumberMap: fullWidthNumberMap,
    fullWidthNumbers: fullWidthNumbers
};

},{"abac857dfaf8df9a":"9C1NQ","a8434b5c6a0a59b0":"3I3iN","fec0d64638a1bdcb":"6iZCN"}],"6iZCN":[function(require,module,exports) {
"use strict";
function allCharsReg(src) {
    return RegExp("[" + src + "]", "g");
}
module.exports = allCharsReg;

},{}],"3ux2T":[function(require,module,exports) {
"use strict";
var Sugar = require("2fa2caaab58d9f78"), LEFT_TRIM_REG = require("b496e86832a687f4");
Sugar.String.defineInstance({
    "trimLeft": function(str) {
        return str.replace(LEFT_TRIM_REG, "");
    }
});
module.exports = Sugar.String.trimLeft;

},{"2fa2caaab58d9f78":"dZZfL","b496e86832a687f4":"f1Gqd"}],"f1Gqd":[function(require,module,exports) {
"use strict";
var TRIM_CHARS = require("c8b499c2841fea1f");
module.exports = RegExp("^[" + TRIM_CHARS + "]+");

},{"c8b499c2841fea1f":"iOgqk"}],"iOgqk":[function(require,module,exports) {
"use strict";
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF";

},{}],"6GQ1V":[function(require,module,exports) {
"use strict";
var Sugar = require("8ba380826c440d83"), RIGHT_TRIM_REG = require("f5be033610ae96b0");
Sugar.String.defineInstance({
    "trimRight": function(str) {
        return str.replace(RIGHT_TRIM_REG, "");
    }
});
module.exports = Sugar.String.trimRight;

},{"8ba380826c440d83":"dZZfL","f5be033610ae96b0":"jBkFv"}],"jBkFv":[function(require,module,exports) {
"use strict";
var TRIM_CHARS = require("1c3d1e70bba914c8");
module.exports = RegExp("[" + TRIM_CHARS + "]+$");

},{"1c3d1e70bba914c8":"iOgqk"}],"lnzWu":[function(require,module,exports) {
"use strict";
var Sugar = require("8279db88adf455b9"), truncateString = require("a6f16d2b12eba024");
Sugar.String.defineInstance({
    "truncate": function(str, length, from, ellipsis) {
        return truncateString(str, length, from, ellipsis);
    }
});
module.exports = Sugar.String.truncate;

},{"8279db88adf455b9":"dZZfL","a6f16d2b12eba024":"fIcQS"}],"fIcQS":[function(require,module,exports) {
"use strict";
var isUndefined = require("c7ad5a6ce2e83ff0"), mathAliases = require("17b3b689b0d99f52"), truncateOnWord = require("b2f280e512270548");
var ceil = mathAliases.ceil, floor = mathAliases.floor;
function truncateString(str, length, from, ellipsis, split) {
    var str1, str2, len1, len2;
    if (str.length <= length) return str.toString();
    ellipsis = isUndefined(ellipsis) ? "..." : ellipsis;
    switch(from){
        case "left":
            str2 = split ? truncateOnWord(str, length, true) : str.slice(str.length - length);
            return ellipsis + str2;
        case "middle":
            len1 = ceil(length / 2);
            len2 = floor(length / 2);
            str1 = split ? truncateOnWord(str, len1) : str.slice(0, len1);
            str2 = split ? truncateOnWord(str, len2, true) : str.slice(str.length - len2);
            return str1 + ellipsis + str2;
        default:
            str1 = split ? truncateOnWord(str, length) : str.slice(0, length);
            return str1 + ellipsis;
    }
}
module.exports = truncateString;

},{"c7ad5a6ce2e83ff0":"6oRAa","17b3b689b0d99f52":"f1S5P","b2f280e512270548":"f0trP"}],"f0trP":[function(require,module,exports) {
"use strict";
var TRUNC_REG = require("c5b044e24724239"), filter = require("e90ebaf7b01fa8cb"), reverseString = require("d9b2d045be91bb01");
function truncateOnWord(str, limit, fromLeft) {
    if (fromLeft) return reverseString(truncateOnWord(reverseString(str), limit));
    var words = str.split(TRUNC_REG);
    var count = 0;
    return filter(words, function(word) {
        count += word.length;
        return count <= limit;
    }).join("");
}
module.exports = truncateOnWord;

},{"c5b044e24724239":"6qD9m","e90ebaf7b01fa8cb":"j8KnV","d9b2d045be91bb01":"7PxXQ"}],"6qD9m":[function(require,module,exports) {
"use strict";
var TRIM_CHARS = require("f1eaba982e8a4f38");
module.exports = RegExp("(?=[" + TRIM_CHARS + "])");

},{"f1eaba982e8a4f38":"iOgqk"}],"j8KnV":[function(require,module,exports) {
"use strict";
function filter(arr, fn) {
    var result = [];
    for(var i = 0, len = arr.length; i < len; i++){
        var el = arr[i];
        if (i in arr && fn(el, i)) result.push(el);
    }
    return result;
}
module.exports = filter;

},{}],"kMYtv":[function(require,module,exports) {
"use strict";
var Sugar = require("d5885445a2c1b560"), truncateString = require("e219c5287085f251");
Sugar.String.defineInstance({
    "truncateOnWord": function(str, length, from, ellipsis) {
        return truncateString(str, length, from, ellipsis, true);
    }
});
module.exports = Sugar.String.truncateOnWord;

},{"d5885445a2c1b560":"dZZfL","e219c5287085f251":"fIcQS"}],"gQks3":[function(require,module,exports) {
"use strict";
var Sugar = require("ba8ac707fc7f99f8"), stringUnderscore = require("6c406920ce52f36");
Sugar.String.defineInstance({
    "underscore": function(str) {
        return stringUnderscore(str);
    }
});
module.exports = Sugar.String.underscore;

},{"ba8ac707fc7f99f8":"dZZfL","6c406920ce52f36":"bmwzU"}],"75BLD":[function(require,module,exports) {
"use strict";
var Sugar = require("82e120bc2137f9c9"), unescapeHTML = require("5c6b923aeafd8449");
Sugar.String.defineInstance({
    "unescapeHTML": function(str) {
        return unescapeHTML(str);
    }
});
module.exports = Sugar.String.unescapeHTML;

},{"82e120bc2137f9c9":"dZZfL","5c6b923aeafd8449":"l9hkr"}],"l9hkr":[function(require,module,exports) {
"use strict";
var HTML_ENTITY_REG = require("bda59bf93f37a896"), HTMLFromEntityMap = require("16d0d99b368bffff"), chr = require("966a5ba3fd9c2e23");
function unescapeHTML(str) {
    return str.replace(HTML_ENTITY_REG, function(full, hex, code) {
        var special = HTMLFromEntityMap[code];
        return special || chr(hex ? parseInt(code, 16) : +code);
    });
}
module.exports = unescapeHTML;

},{"bda59bf93f37a896":"fXcI1","16d0d99b368bffff":"3w3Ej","966a5ba3fd9c2e23":"3I3iN"}],"fXcI1":[function(require,module,exports) {
"use strict";
module.exports = /&#?(x)?([\w\d]{0,5});/gi;

},{}],"g5DqP":[function(require,module,exports) {
"use strict";
var Sugar = require("c9bb12e0714d6ae8");
Sugar.String.defineInstance({
    "unescapeURL": function(str, param) {
        return param ? decodeURI(str) : decodeURIComponent(str);
    }
});
module.exports = Sugar.String.unescapeURL;

},{"c9bb12e0714d6ae8":"dZZfL"}],"b2qoN":[function(require,module,exports) {
"use strict";
var Sugar = require("53ccb90538e20af3"), trim = require("1d0a1ba0911bfca1"), stringEach = require("e04d4fa8305f2d02");
Sugar.String.defineInstance({
    "words": function(str, eachWordFn) {
        return stringEach(trim(str), /\S+/g, eachWordFn);
    }
});
module.exports = Sugar.String.words;

},{"53ccb90538e20af3":"dZZfL","1d0a1ba0911bfca1":"2PiXk","e04d4fa8305f2d02":"uBLqS"}],"1pjGL":[function(require,module,exports) {
"use strict";
// Static Methods
require("b98fa2efa091d31a");
// Instance Methods
require("6f6ab32edca5b67a");
require("c60e525daf76db43");
require("fa4fa087b9b79f88");
require("d329c536a8de9369");
require("97580d8fe70349eb");
require("320470b0099eab9a");
require("c339d7d8c805e73d");
require("5960ef10d4623d37");
require("cf32f66f4a747b2f");
require("df50e6dab837be70");
require("54666501407cf0bd");
require("5144daad155ec21");
require("66f0625a103d6b93");
require("b53cfdae6f0c69");
require("c89d47b521ecba76");
require("6f5628acf45e989f");
require("e1fc4549b557ccd8");
require("be4884f3ea2001bf");
require("e56b1b94e9d46574");
require("92694d8b4d6a079a");
require("c078ad561b35426c");
require("892fcfd9f99032e9");
require("9920dd8f1ff0b119");
require("3c61bf7956e17fcc");
require("abda3fc66cfc2625");
require("452ad4c0e34ef0aa");
require("1fc5c8a8ff312477");
require("9ebedc78c829ca21");
// Accessors
require("9ccbe61d3c39c005");
require("69cb6a94b3a3b201");
module.exports = require("687839c407108bb4");

},{"b98fa2efa091d31a":"49ckh","6f6ab32edca5b67a":"43SVN","c60e525daf76db43":"1TXjF","fa4fa087b9b79f88":"3Vd4n","d329c536a8de9369":"gb8ad","97580d8fe70349eb":"1m6D7","320470b0099eab9a":"ldsfK","c339d7d8c805e73d":"krukX","5960ef10d4623d37":"3wAlV","cf32f66f4a747b2f":"4HWcU","df50e6dab837be70":"3kR2u","54666501407cf0bd":"jb2R0","5144daad155ec21":"6mzAR","66f0625a103d6b93":"QGAw5","b53cfdae6f0c69":"bi1Db","c89d47b521ecba76":"5UUo0","6f5628acf45e989f":"laMEQ","e1fc4549b557ccd8":"2WWU1","be4884f3ea2001bf":"5bNfu","e56b1b94e9d46574":"ht0Jl","92694d8b4d6a079a":"hLAhK","c078ad561b35426c":"2ZZjK","892fcfd9f99032e9":"bzzgI","9920dd8f1ff0b119":"cXFUL","3c61bf7956e17fcc":"7xhUR","abda3fc66cfc2625":"a4Ewf","452ad4c0e34ef0aa":"gVvq0","1fc5c8a8ff312477":"9xiNM","9ebedc78c829ca21":"jXcX5","9ccbe61d3c39c005":"hJ0BB","69cb6a94b3a3b201":"jC58B","687839c407108bb4":"dZZfL"}],"49ckh":[function(require,module,exports) {
"use strict";
var Sugar = require("788d93d2d8da70a"), trunc = require("1d5f103cf1e7add1"), mathAliases = require("f999e962f4f3f3c1"), isUndefined = require("91f232ba8cb84cc2");
var min = mathAliases.min, max = mathAliases.max;
Sugar.Number.defineStatic({
    "random": function(n1, n2) {
        var minNum, maxNum;
        if (arguments.length == 1) n2 = n1, n1 = 0;
        minNum = min(n1 || 0, isUndefined(n2) ? 1 : n2);
        maxNum = max(n1 || 0, isUndefined(n2) ? 1 : n2) + 1;
        return trunc(Math.random() * (maxNum - minNum) + minNum);
    }
});
module.exports = Sugar.Number.random;

},{"788d93d2d8da70a":"dZZfL","1d5f103cf1e7add1":"898n5","f999e962f4f3f3c1":"f1S5P","91f232ba8cb84cc2":"6oRAa"}],"43SVN":[function(require,module,exports) {
"use strict";
var Sugar = require("871b26b5046758a"), AbbreviationUnits = require("edc07ad24489969f"), abbreviateNumber = require("78c7095aabe17d5e");
var BASIC_UNITS = AbbreviationUnits.BASIC_UNITS;
Sugar.Number.defineInstance({
    "abbr": function(n, precision) {
        return abbreviateNumber(n, precision, BASIC_UNITS);
    }
});
module.exports = Sugar.Number.abbr;

},{"871b26b5046758a":"dZZfL","edc07ad24489969f":"7x7iN","78c7095aabe17d5e":"aQ1SH"}],"7x7iN":[function(require,module,exports) {
"use strict";
module.exports = {
    BASIC_UNITS: "|kmbt",
    MEMORY_UNITS: "|KMGTPE",
    MEMORY_BINARY_UNITS: "|,Ki,Mi,Gi,Ti,Pi,Ei",
    METRIC_UNITS_SHORT: "n\u03BCm|k",
    METRIC_UNITS_FULL: "yzafpn\u03BCm|KMGTPEZY"
};

},{}],"aQ1SH":[function(require,module,exports) {
"use strict";
var commaSplit = require("398cd2a0a426ad6c"), mathAliases = require("97fa686cd57334fa"), numberFormat = require("8b5de66338b4a49b"), withPrecision = require("b705630544b20208");
var abs = mathAliases.abs, pow = mathAliases.pow, min = mathAliases.min, max = mathAliases.max, floor = mathAliases.floor;
function abbreviateNumber(num, precision, ustr, bytes) {
    var fixed = num.toFixed(20), decimalPlace = fixed.search(/\./), numeralPlace = fixed.search(/[1-9]/), significant = decimalPlace - numeralPlace, units, unit, mid, i, divisor;
    if (significant > 0) significant -= 1;
    units = commaSplit(ustr);
    if (units.length === 1) units = ustr.split("");
    mid = units.indexOf("|");
    if (mid === -1) // Skipping the placeholder means the units should start from zero,
    // otherwise assume they end at zero.
    mid = units[0] === "_" ? 0 : units.length;
    i = max(min(floor(significant / 3), units.length - mid - 1), -mid);
    unit = units[i + mid];
    while(unit === "_"){
        i += i < 0 ? -1 : 1;
        unit = units[i + mid];
    }
    if (unit === "|") unit = "";
    if (significant < -9) precision = abs(significant) - 9;
    divisor = bytes ? pow(2, 10 * i) : pow(10, i * 3);
    return numberFormat(withPrecision(num / divisor, precision || 0)) + unit;
}
module.exports = abbreviateNumber;

},{"398cd2a0a426ad6c":"ld65V","97fa686cd57334fa":"f1S5P","8b5de66338b4a49b":"kcCKt","b705630544b20208":"g1bJd"}],"ld65V":[function(require,module,exports) {
"use strict";
var CommonChars = require("b11e729b0b16693e");
var HALF_WIDTH_COMMA = CommonChars.HALF_WIDTH_COMMA;
function commaSplit(str) {
    return str.split(HALF_WIDTH_COMMA);
}
module.exports = commaSplit;

},{"b11e729b0b16693e":"9C1NQ"}],"kcCKt":[function(require,module,exports) {
"use strict";
var classChecks = require("b2806e5ebfa44bb5"), mathAliases = require("47b38f45f8a93bbb"), periodSplit = require("aa0d83b7fd29b5ed"), repeatString = require("d6d23d543af2d1e5"), withPrecision = require("eb4d56767964bb2b"), _numberOptions = require("bfee8d2f1efd1bcc");
var isNumber = classChecks.isNumber, max = mathAliases.max;
function numberFormat(num, place) {
    var result = "", thousands, decimal, fraction, integer, split, str;
    decimal = _numberOptions("decimal");
    thousands = _numberOptions("thousands");
    if (isNumber(place)) str = withPrecision(num, place || 0).toFixed(max(place, 0));
    else str = num.toString();
    str = str.replace(/^-/, "");
    split = periodSplit(str);
    integer = split[0];
    fraction = split[1];
    if (/e/.test(str)) result = str;
    else for(var i = integer.length; i > 0; i -= 3){
        if (i < integer.length) result = thousands + result;
        result = integer.slice(max(0, i - 3), i) + result;
    }
    if (fraction) result += decimal + repeatString("0", (place || 0) - fraction.length) + fraction;
    return (num < 0 ? "-" : "") + result;
}
module.exports = numberFormat;

},{"b2806e5ebfa44bb5":"MTXUY","47b38f45f8a93bbb":"f1S5P","aa0d83b7fd29b5ed":"j3jYr","d6d23d543af2d1e5":"g8ZYR","eb4d56767964bb2b":"g1bJd","bfee8d2f1efd1bcc":"97Hi8"}],"g1bJd":[function(require,module,exports) {
"use strict";
var mathAliases = require("f2d7179fe65a075");
var abs = mathAliases.abs, pow = mathAliases.pow, round = mathAliases.round;
function withPrecision(val, precision, fn) {
    var multiplier = pow(10, abs(precision || 0));
    fn = fn || round;
    if (precision < 0) multiplier = 1 / multiplier;
    return fn(val * multiplier) / multiplier;
}
module.exports = withPrecision;

},{"f2d7179fe65a075":"f1S5P"}],"97Hi8":[function(require,module,exports) {
"use strict";
var NUMBER_OPTIONS = require("fe916b10dfdf1359"), namespaceAliases = require("ed424bb2b9a4fa"), defineOptionsAccessor = require("d63c07ba51cafd7b");
var sugarNumber = namespaceAliases.sugarNumber;
module.exports = defineOptionsAccessor(sugarNumber, NUMBER_OPTIONS);

},{"fe916b10dfdf1359":"33bne","ed424bb2b9a4fa":"4onj1","d63c07ba51cafd7b":"cfSYO"}],"33bne":[function(require,module,exports) {
"use strict";
var CommonChars = require("874e217b829854e3");
var HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD, HALF_WIDTH_COMMA = CommonChars.HALF_WIDTH_COMMA;
var NUMBER_OPTIONS = {
    "decimal": HALF_WIDTH_PERIOD,
    "thousands": HALF_WIDTH_COMMA
};
module.exports = NUMBER_OPTIONS;

},{"874e217b829854e3":"9C1NQ"}],"4onj1":[function(require,module,exports) {
"use strict";
var Sugar = require("8c8997ae0b7732cf");
module.exports = {
    sugarObject: Sugar.Object,
    sugarArray: Sugar.Array,
    sugarDate: Sugar.Date,
    sugarString: Sugar.String,
    sugarNumber: Sugar.Number,
    sugarFunction: Sugar.Function,
    sugarRegExp: Sugar.RegExp
};

},{"8c8997ae0b7732cf":"dZZfL"}],"cfSYO":[function(require,module,exports) {
"use strict";
var simpleClone = require("7b06350fe6231de3"), defineAccessor = require("74f82bcc63a542ef"), coreUtilityAliases = require("7afb85be9dee1ee3");
var forEachProperty = coreUtilityAliases.forEachProperty;
function defineOptionsAccessor(namespace, defaults) {
    var obj = simpleClone(defaults);
    function getOption(name) {
        return obj[name];
    }
    function setOption(arg1, arg2) {
        var options;
        if (arguments.length === 1) options = arg1;
        else {
            options = {};
            options[arg1] = arg2;
        }
        forEachProperty(options, function(val, name) {
            if (val === null) val = defaults[name];
            obj[name] = val;
        });
    }
    defineAccessor(namespace, "getOption", getOption);
    defineAccessor(namespace, "setOption", setOption);
    return getOption;
}
module.exports = defineOptionsAccessor;

},{"7b06350fe6231de3":"glUlC","74f82bcc63a542ef":"9cK0M","7afb85be9dee1ee3":"8ZxTV"}],"glUlC":[function(require,module,exports) {
"use strict";
var simpleMerge = require("c6b1d9fa1bc291c7");
function simpleClone(obj) {
    return simpleMerge({}, obj);
}
module.exports = simpleClone;

},{"c6b1d9fa1bc291c7":"e4HRg"}],"e4HRg":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("aa34cf74139195c");
var forEachProperty = coreUtilityAliases.forEachProperty;
function simpleMerge(target, source) {
    forEachProperty(source, function(val, key) {
        target[key] = val;
    });
    return target;
}
module.exports = simpleMerge;

},{"aa34cf74139195c":"8ZxTV"}],"9cK0M":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("2a97a2893b3ef178");
var setProperty = coreUtilityAliases.setProperty;
function defineAccessor(namespace, name, fn) {
    setProperty(namespace, name, fn);
}
module.exports = defineAccessor;

},{"2a97a2893b3ef178":"8ZxTV"}],"1TXjF":[function(require,module,exports) {
"use strict";
var Sugar = require("e69261e14809dde6");
require("9a410da49a0e75a8");
module.exports = Sugar.Number.abs;

},{"e69261e14809dde6":"dZZfL","9a410da49a0e75a8":"C0LHD"}],"C0LHD":[function(require,module,exports) {
"use strict";
var buildMathAliases = require("ecb15728870d250c");
buildMathAliases();

},{"ecb15728870d250c":"gKieG"}],"gKieG":[function(require,module,exports) {
"use strict";
var namespaceAliases = require("1708d2e5f50eba90"), defineInstanceSimilar = require("993ed92917687a47");
var sugarNumber = namespaceAliases.sugarNumber;
function buildMathAliases() {
    defineInstanceSimilar(sugarNumber, "abs pow sin asin cos acos tan atan exp pow sqrt", function(methods, name) {
        methods[name] = function(n, arg) {
            // Note that .valueOf() here is only required due to a
            // very strange bug in iOS7 that only occurs occasionally
            // in which Math.abs() called on non-primitive numbers
            // returns a completely different number (Issue #400)
            return Math[name](n.valueOf(), arg);
        };
    });
}
module.exports = buildMathAliases;

},{"1708d2e5f50eba90":"4onj1","993ed92917687a47":"6ztHL"}],"6ztHL":[function(require,module,exports) {
"use strict";
var methodDefineAliases = require("c28db1d49134f0a"), collectSimilarMethods = require("534a7131efc76ab0");
var defineInstance = methodDefineAliases.defineInstance;
function defineInstanceSimilar(sugarNamespace, set, fn, flags) {
    defineInstance(sugarNamespace, collectSimilarMethods(set, fn), flags);
}
module.exports = defineInstanceSimilar;

},{"c28db1d49134f0a":"c4yD8","534a7131efc76ab0":"aUTtI"}],"c4yD8":[function(require,module,exports) {
"use strict";
var wrapNamespace = require("e5a65bdd62834c31");
module.exports = {
    alias: wrapNamespace("alias"),
    defineStatic: wrapNamespace("defineStatic"),
    defineInstance: wrapNamespace("defineInstance"),
    defineStaticPolyfill: wrapNamespace("defineStaticPolyfill"),
    defineInstancePolyfill: wrapNamespace("defineInstancePolyfill"),
    defineInstanceAndStatic: wrapNamespace("defineInstanceAndStatic"),
    defineInstanceWithArguments: wrapNamespace("defineInstanceWithArguments")
};

},{"e5a65bdd62834c31":"af2mr"}],"af2mr":[function(require,module,exports) {
"use strict";
function wrapNamespace(method) {
    return function(sugarNamespace, arg1, arg2) {
        sugarNamespace[method](arg1, arg2);
    };
}
module.exports = wrapNamespace;

},{}],"aUTtI":[function(require,module,exports) {
"use strict";
var forEach = require("9128c0a15354adc8"), spaceSplit = require("bfc97b07867884d"), classChecks = require("a0498cfae82e674e");
var isString = classChecks.isString;
function collectSimilarMethods(set, fn) {
    var methods = {};
    if (isString(set)) set = spaceSplit(set);
    forEach(set, function(el, i) {
        fn(methods, el, i);
    });
    return methods;
}
module.exports = collectSimilarMethods;

},{"9128c0a15354adc8":"JJnv7","bfc97b07867884d":"cGrLA","a0498cfae82e674e":"MTXUY"}],"3Vd4n":[function(require,module,exports) {
"use strict";
var Sugar = require("44311e6068852ab2");
require("46a5816468ceeca");
module.exports = Sugar.Number.acos;

},{"44311e6068852ab2":"dZZfL","46a5816468ceeca":"C0LHD"}],"gb8ad":[function(require,module,exports) {
"use strict";
var Sugar = require("d73bb5abb1e982a9");
require("cc233e411ba97d98");
module.exports = Sugar.Number.asin;

},{"d73bb5abb1e982a9":"dZZfL","cc233e411ba97d98":"C0LHD"}],"1m6D7":[function(require,module,exports) {
"use strict";
var Sugar = require("718bd5ad612cd1a6");
require("6b8edfd44f4b4caa");
module.exports = Sugar.Number.atan;

},{"718bd5ad612cd1a6":"dZZfL","6b8edfd44f4b4caa":"C0LHD"}],"ldsfK":[function(require,module,exports) {
"use strict";
var Sugar = require("2f2866765fcae54d"), AbbreviationUnits = require("4bd734e41ab3bf32"), abbreviateNumber = require("501fea8c65cc471b");
var MEMORY_UNITS = AbbreviationUnits.MEMORY_UNITS, MEMORY_BINARY_UNITS = AbbreviationUnits.MEMORY_BINARY_UNITS;
Sugar.Number.defineInstance({
    "bytes": function(n, precision, binary, units) {
        if (units === "binary" || !units && binary) units = MEMORY_BINARY_UNITS;
        else if (units === "si" || !units) units = MEMORY_UNITS;
        return abbreviateNumber(n, precision, units, binary) + "B";
    }
});
module.exports = Sugar.Number.bytes;

},{"2f2866765fcae54d":"dZZfL","4bd734e41ab3bf32":"7x7iN","501fea8c65cc471b":"aQ1SH"}],"krukX":[function(require,module,exports) {
"use strict";
var Sugar = require("67bbdd5d67e8398c"), mathAliases = require("2053d991f6505bc3"), createRoundingFunction = require("eaaf74936bbde3b4");
var ceil = mathAliases.ceil;
Sugar.Number.defineInstance({
    "ceil": createRoundingFunction(ceil)
});
module.exports = Sugar.Number.ceil;

},{"67bbdd5d67e8398c":"dZZfL","2053d991f6505bc3":"f1S5P","eaaf74936bbde3b4":"gDECK"}],"gDECK":[function(require,module,exports) {
"use strict";
var withPrecision = require("5930799b9565d9b7");
function createRoundingFunction(fn) {
    return function(n, precision) {
        return precision ? withPrecision(n, precision, fn) : fn(n);
    };
}
module.exports = createRoundingFunction;

},{"5930799b9565d9b7":"g1bJd"}],"3wAlV":[function(require,module,exports) {
"use strict";
var Sugar = require("d2a4bf75a1b81956"), chr = require("7f036ff8728dad71");
Sugar.Number.defineInstance({
    "chr": function(n) {
        return chr(n);
    }
});
module.exports = Sugar.Number.chr;

},{"d2a4bf75a1b81956":"dZZfL","7f036ff8728dad71":"3I3iN"}],"4HWcU":[function(require,module,exports) {
"use strict";
var Sugar = require("8269fd9756e446dc");
require("4b50d44f3f881101");
module.exports = Sugar.Number.cos;

},{"8269fd9756e446dc":"dZZfL","4b50d44f3f881101":"C0LHD"}],"3kR2u":[function(require,module,exports) {
"use strict";
var Sugar = require("ec011885602afbca");
require("9b2553450b203f86");
module.exports = Sugar.Number.exp;

},{"ec011885602afbca":"dZZfL","9b2553450b203f86":"C0LHD"}],"jb2R0":[function(require,module,exports) {
"use strict";
var Sugar = require("b7cd8ee0ab695ff7"), mathAliases = require("895e0deabcaea023"), createRoundingFunction = require("b4a137fdd818d898");
var floor = mathAliases.floor;
Sugar.Number.defineInstance({
    "floor": createRoundingFunction(floor)
});
module.exports = Sugar.Number.floor;

},{"b7cd8ee0ab695ff7":"dZZfL","895e0deabcaea023":"f1S5P","b4a137fdd818d898":"gDECK"}],"6mzAR":[function(require,module,exports) {
"use strict";
var Sugar = require("f9df4a0a9b82ed87"), numberFormat = require("d7684a4902f2fab5");
Sugar.Number.defineInstance({
    "format": function(n, place) {
        return numberFormat(n, place);
    }
});
module.exports = Sugar.Number.format;

},{"f9df4a0a9b82ed87":"dZZfL","d7684a4902f2fab5":"kcCKt"}],"QGAw5":[function(require,module,exports) {
"use strict";
var Sugar = require("b32619b1b3c8bcc5"), padNumber = require("5d084c516500432b");
Sugar.Number.defineInstance({
    "hex": function(n, pad) {
        return padNumber(n, pad || 1, false, 16);
    }
});
module.exports = Sugar.Number.hex;

},{"b32619b1b3c8bcc5":"dZZfL","5d084c516500432b":"6KIGK"}],"6KIGK":[function(require,module,exports) {
"use strict";
var mathAliases = require("a686d4ad5adb0c32"), repeatString = require("d5a76b10d60db2ad");
var abs = mathAliases.abs;
function padNumber(num, place, sign, base, replacement) {
    var str = abs(num).toString(base || 10);
    str = repeatString(replacement || "0", place - str.replace(/\.\d+/, "").length) + str;
    if (sign || num < 0) str = (num < 0 ? "-" : "+") + str;
    return str;
}
module.exports = padNumber;

},{"a686d4ad5adb0c32":"f1S5P","d5a76b10d60db2ad":"g8ZYR"}],"bi1Db":[function(require,module,exports) {
"use strict";
var Sugar = require("ac23a1cc45ea1084"), isMultipleOf = require("a90fc88147e36c28");
Sugar.Number.defineInstance({
    "isEven": function(n) {
        return isMultipleOf(n, 2);
    }
});
module.exports = Sugar.Number.isEven;

},{"ac23a1cc45ea1084":"dZZfL","a90fc88147e36c28":"edIRe"}],"edIRe":[function(require,module,exports) {
"use strict";
function isMultipleOf(n1, n2) {
    return n1 % n2 === 0;
}
module.exports = isMultipleOf;

},{}],"5UUo0":[function(require,module,exports) {
"use strict";
var Sugar = require("ed56b5e99a77bf0d"), isInteger = require("5df9c0775628478a");
Sugar.Number.defineInstance({
    "isInteger": function(n) {
        return isInteger(n);
    }
});
module.exports = Sugar.Number.isInteger;

},{"ed56b5e99a77bf0d":"dZZfL","5df9c0775628478a":"jad6f"}],"jad6f":[function(require,module,exports) {
"use strict";
function isInteger(n) {
    return n % 1 === 0;
}
module.exports = isInteger;

},{}],"laMEQ":[function(require,module,exports) {
"use strict";
var Sugar = require("24e7f933ef505d3e"), isMultipleOf = require("cce22ff3f3d562df");
Sugar.Number.defineInstance({
    "isMultipleOf": function(n, num) {
        return isMultipleOf(n, num);
    }
});
module.exports = Sugar.Number.isMultipleOf;

},{"24e7f933ef505d3e":"dZZfL","cce22ff3f3d562df":"edIRe"}],"2WWU1":[function(require,module,exports) {
"use strict";
var Sugar = require("2168bf4b1d7614ce"), isInteger = require("faabcc3e7eb1992b"), isMultipleOf = require("5b5b3f32874daaf9");
Sugar.Number.defineInstance({
    "isOdd": function(n) {
        return isInteger(n) && !isMultipleOf(n, 2);
    }
});
module.exports = Sugar.Number.isOdd;

},{"2168bf4b1d7614ce":"dZZfL","faabcc3e7eb1992b":"jad6f","5b5b3f32874daaf9":"edIRe"}],"5bNfu":[function(require,module,exports) {
"use strict";
var Sugar = require("3fc45a7ac3f7972a");
Sugar.Number.defineInstance({
    "log": function(n, base) {
        return Math.log(n) / (base ? Math.log(base) : 1);
    }
});
module.exports = Sugar.Number.log;

},{"3fc45a7ac3f7972a":"dZZfL"}],"ht0Jl":[function(require,module,exports) {
"use strict";
var Sugar = require("e66c11296f8bb1bf"), AbbreviationUnits = require("99c5da117d7e62e6"), abbreviateNumber = require("a63458e933fe0c49");
var METRIC_UNITS_SHORT = AbbreviationUnits.METRIC_UNITS_SHORT, METRIC_UNITS_FULL = AbbreviationUnits.METRIC_UNITS_FULL;
Sugar.Number.defineInstance({
    "metric": function(n, precision, units) {
        if (units === "all") units = METRIC_UNITS_FULL;
        else if (!units) units = METRIC_UNITS_SHORT;
        return abbreviateNumber(n, precision, units);
    }
});
module.exports = Sugar.Number.metric;

},{"e66c11296f8bb1bf":"dZZfL","99c5da117d7e62e6":"7x7iN","a63458e933fe0c49":"aQ1SH"}],"hLAhK":[function(require,module,exports) {
"use strict";
var Sugar = require("f4434849dc1f98f8"), mathAliases = require("12882b9500f577b3"), getOrdinalSuffix = require("29125ee978ea73a7");
var abs = mathAliases.abs;
Sugar.Number.defineInstance({
    "ordinalize": function(n) {
        var num = abs(n), last = +num.toString().slice(-2);
        return n + getOrdinalSuffix(last);
    }
});
module.exports = Sugar.Number.ordinalize;

},{"f4434849dc1f98f8":"dZZfL","12882b9500f577b3":"f1S5P","29125ee978ea73a7":"5cY7Z"}],"5cY7Z":[function(require,module,exports) {
"use strict";
function getOrdinalSuffix(num) {
    if (num >= 11 && num <= 13) return "th";
    else switch(num % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}
module.exports = getOrdinalSuffix;

},{}],"2ZZjK":[function(require,module,exports) {
"use strict";
var Sugar = require("efbc318975828411"), padNumber = require("77b0415df0b69764");
Sugar.Number.defineInstance({
    "pad": function(n, place, sign, base) {
        return padNumber(n, place, sign, base);
    }
});
module.exports = Sugar.Number.pad;

},{"efbc318975828411":"dZZfL","77b0415df0b69764":"6KIGK"}],"bzzgI":[function(require,module,exports) {
"use strict";
var Sugar = require("ecd837734b5205b0");
require("23dcedc7560622bb");
module.exports = Sugar.Number.pow;

},{"ecd837734b5205b0":"dZZfL","23dcedc7560622bb":"C0LHD"}],"cXFUL":[function(require,module,exports) {
"use strict";
var Sugar = require("c60b63bdbb5acbd8"), mathAliases = require("d80a156450eb7f4f"), createRoundingFunction = require("56f166721b12ba35");
var round = mathAliases.round;
Sugar.Number.defineInstance({
    "round": createRoundingFunction(round)
});
module.exports = Sugar.Number.round;

},{"c60b63bdbb5acbd8":"dZZfL","d80a156450eb7f4f":"f1S5P","56f166721b12ba35":"gDECK"}],"7xhUR":[function(require,module,exports) {
"use strict";
var Sugar = require("6f38f974105e11c8");
require("60d0dae878df1805");
module.exports = Sugar.Number.sin;

},{"6f38f974105e11c8":"dZZfL","60d0dae878df1805":"C0LHD"}],"a4Ewf":[function(require,module,exports) {
"use strict";
var Sugar = require("8ec47aae1aeaf969");
require("c2b566ff3b27abc0");
module.exports = Sugar.Number.sqrt;

},{"8ec47aae1aeaf969":"dZZfL","c2b566ff3b27abc0":"C0LHD"}],"gVvq0":[function(require,module,exports) {
"use strict";
var Sugar = require("1e5d4103afc227b8");
require("8b66a9699e98d0c1");
module.exports = Sugar.Number.tan;

},{"1e5d4103afc227b8":"dZZfL","8b66a9699e98d0c1":"C0LHD"}],"9xiNM":[function(require,module,exports) {
"use strict";
var Sugar = require("6a2cba7dbbca9458"), isDefined = require("8a053a7ce9b8a90f");
Sugar.Number.defineInstance({
    "times": function(n, indexMapFn) {
        var arr, result;
        for(var i = 0; i < n; i++){
            result = indexMapFn.call(n, i);
            if (isDefined(result)) {
                if (!arr) arr = [];
                arr.push(result);
            }
        }
        return arr;
    }
});
module.exports = Sugar.Number.times;

},{"6a2cba7dbbca9458":"dZZfL","8a053a7ce9b8a90f":"4cOOJ"}],"jXcX5":[function(require,module,exports) {
"use strict";
var Sugar = require("cbc708168bc049df");
Sugar.Number.defineInstance({
    "toNumber": function(n) {
        return n.valueOf();
    }
});
module.exports = Sugar.Number.toNumber;

},{"cbc708168bc049df":"dZZfL"}],"hJ0BB":[function(require,module,exports) {
"use strict";
var Sugar = require("d110ec13342dce3b"), _numberOptions = require("10085f407e7e6b8e");
module.exports = Sugar.Number.getOption;

},{"d110ec13342dce3b":"dZZfL","10085f407e7e6b8e":"97Hi8"}],"jC58B":[function(require,module,exports) {
"use strict";
var Sugar = require("12e54349381ac55f"), _numberOptions = require("c9ef54894a3fd42e");
module.exports = Sugar.Number.setOption;

},{"12e54349381ac55f":"dZZfL","c9ef54894a3fd42e":"97Hi8"}],"834Wz":[function(require,module,exports) {
"use strict";
// Static Methods
require("543e274c507d3f2e");
require("9977b830d04f1275");
// Instance Methods
require("67bf778ed7362f08");
require("bff111aa031c9ae5");
require("40f666976fae660b");
require("4ef81b5147823a4f");
require("2b1b33ee67ec5903");
require("4b155f4b516497b5");
require("d80b8b60be097aab");
require("597af6f6865489d7");
require("463c41f411888615");
require("6c14c05efa66d627");
require("6acac9482dfbffb6");
require("3382215baf0a95c9");
require("9f4ccd030e02ec8d");
require("24d39e0e6b7baebd");
require("ee6fd25497d36071");
require("a1009472baa8f5be");
require("101e39ada853a8e3");
require("fce36e71c716a4d");
require("825a6fb35ff1635");
require("7f4e78d9b0d954f");
require("c55b6781690c83a");
require("5ad81b25dac2b4a4");
require("439261dff33f287c");
require("4a799847fb82ad6f");
require("207eb0cf122a1114");
require("2bb7363a22067746");
// Aliases
require("25511bbb196689a9");
// Accessors
require("dda4bd114bdcf46a");
require("90445eb91bdf0674");
module.exports = require("d31617bdaa7389d1");

},{"543e274c507d3f2e":"3Qqf4","9977b830d04f1275":"1YXhj","67bf778ed7362f08":"gDCN4","bff111aa031c9ae5":"cyHON","40f666976fae660b":"9kvhe","4ef81b5147823a4f":"aGJba","2b1b33ee67ec5903":"fpdBa","4b155f4b516497b5":"em5r9","d80b8b60be097aab":"lLxrs","597af6f6865489d7":"gNHXU","463c41f411888615":"gi6u5","6c14c05efa66d627":"j5wOi","6acac9482dfbffb6":"ibJgj","3382215baf0a95c9":"iEeny","9f4ccd030e02ec8d":"eluR3","24d39e0e6b7baebd":"gEmX7","ee6fd25497d36071":"fBOBf","a1009472baa8f5be":"agTgw","101e39ada853a8e3":"ht3tS","fce36e71c716a4d":"O5tJD","825a6fb35ff1635":"vxvuS","7f4e78d9b0d954f":"cmG0D","c55b6781690c83a":"66AST","5ad81b25dac2b4a4":"7WMmv","439261dff33f287c":"3zPdN","4a799847fb82ad6f":"9bBzJ","207eb0cf122a1114":"1YZfy","2bb7363a22067746":"joLbD","25511bbb196689a9":"hOTCS","dda4bd114bdcf46a":"6qOG2","90445eb91bdf0674":"kKRU4","d31617bdaa7389d1":"dZZfL"}],"3Qqf4":[function(require,module,exports) {
"use strict";
var Sugar = require("3fa049e2e281c944"), coercePositiveInteger = require("15876b36d5d0f8bf");
Sugar.Array.defineStatic({
    "construct": function(n, indexMapFn) {
        n = coercePositiveInteger(n);
        return Array.from(new Array(n), function(el, i) {
            return indexMapFn && indexMapFn(i);
        });
    }
});
module.exports = Sugar.Array.construct;

},{"3fa049e2e281c944":"dZZfL","15876b36d5d0f8bf":"eBp8T"}],"1YXhj":[function(require,module,exports) {
"use strict";
var Sugar = require("3931836ead696cb3"), arrayCreate = require("9b99b678e0000eb6");
require("20ddb72ea99ffc38");
Sugar.Array.defineStatic({
    "create": function(obj, clone) {
        return arrayCreate(obj, clone);
    }
});
module.exports = Sugar.Array.create;

},{"3931836ead696cb3":"dZZfL","9b99b678e0000eb6":"lpu28","20ddb72ea99ffc38":"7k3Eq"}],"lpu28":[function(require,module,exports) {
"use strict";
var isDefined = require("ee8385397143cd06"), arrayClone = require("878b4db3eb6606d0"), classChecks = require("5faf0ffdde88f35a"), isObjectType = require("f6fee48d98015a01"), isArrayOrInherited = require("b58504e3c768bc74");
var isString = classChecks.isString;
function arrayCreate(obj, clone) {
    var arr;
    if (isArrayOrInherited(obj)) arr = clone ? arrayClone(obj) : obj;
    else if (isObjectType(obj) || isString(obj)) arr = Array.from(obj);
    else if (isDefined(obj)) arr = [
        obj
    ];
    return arr || [];
}
module.exports = arrayCreate;

},{"ee8385397143cd06":"4cOOJ","878b4db3eb6606d0":"8C83v","5faf0ffdde88f35a":"MTXUY","f6fee48d98015a01":"1dImj","b58504e3c768bc74":"4CebP"}],"8C83v":[function(require,module,exports) {
"use strict";
var forEach = require("a61043eadccdd7c2");
function arrayClone(arr) {
    var clone = new Array(arr.length);
    forEach(arr, function(el, i) {
        clone[i] = el;
    });
    return clone;
}
module.exports = arrayClone;

},{"a61043eadccdd7c2":"JJnv7"}],"4CebP":[function(require,module,exports) {
"use strict";
var classChecks = require("a3cbadd45d04622c");
var isArray = classChecks.isArray;
function isArrayOrInherited(obj) {
    return obj && obj.constructor && isArray(obj.constructor.prototype);
}
module.exports = isArrayOrInherited;

},{"a3cbadd45d04622c":"MTXUY"}],"7k3Eq":[function(require,module,exports) {
"use strict";
var setArrayChainableConstructor = require("c14d9596fe3f7430");
setArrayChainableConstructor();

},{"c14d9596fe3f7430":"9nlPW"}],"9nlPW":[function(require,module,exports) {
"use strict";
var arrayCreate = require("63040dd20605c5a6"), namespaceAliases = require("5743a7e7a9758071"), setChainableConstructor = require("902887bf2b7cbe2a");
var sugarArray = namespaceAliases.sugarArray;
function setArrayChainableConstructor() {
    setChainableConstructor(sugarArray, arrayCreate);
}
module.exports = setArrayChainableConstructor;

},{"63040dd20605c5a6":"lpu28","5743a7e7a9758071":"4onj1","902887bf2b7cbe2a":"8qaLp"}],"8qaLp":[function(require,module,exports) {
"use strict";
function setChainableConstructor(sugarNamespace, createFn) {
    sugarNamespace.prototype.constructor = function() {
        return createFn.apply(this, arguments);
    };
}
module.exports = setChainableConstructor;

},{}],"gDCN4":[function(require,module,exports) {
"use strict";
var Sugar = require("3c7fb1404b99895e"), arrayClone = require("3b7845b38fcb7442"), arrayAppend = require("562d67888ed6714b");
Sugar.Array.defineInstance({
    "add": function(arr, item, index) {
        return arrayAppend(arrayClone(arr), item, index);
    }
});
module.exports = Sugar.Array.add;

},{"3c7fb1404b99895e":"dZZfL","3b7845b38fcb7442":"8C83v","562d67888ed6714b":"ZUqwz"}],"ZUqwz":[function(require,module,exports) {
"use strict";
var isDefined = require("9ce366f04fcb50ca");
function arrayAppend(arr, el, index) {
    var spliceArgs;
    index = +index;
    if (isNaN(index)) index = arr.length;
    spliceArgs = [
        index,
        0
    ];
    if (isDefined(el)) spliceArgs = spliceArgs.concat(el);
    arr.splice.apply(arr, spliceArgs);
    return arr;
}
module.exports = arrayAppend;

},{"9ce366f04fcb50ca":"4cOOJ"}],"cyHON":[function(require,module,exports) {
"use strict";
var Sugar = require("4df0d1eea5138d39"), arrayAppend = require("2a220b9210e69eba");
Sugar.Array.defineInstance({
    "append": function(arr, item, index) {
        return arrayAppend(arr, item, index);
    }
});
module.exports = Sugar.Array.append;

},{"4df0d1eea5138d39":"dZZfL","2a220b9210e69eba":"ZUqwz"}],"9kvhe":[function(require,module,exports) {
"use strict";
var Sugar = require("2c855ec9effd679d"), getEntriesForIndexes = require("335aaeca8b7a311a");
Sugar.Array.defineInstance({
    "at": function(arr, index, loop) {
        return getEntriesForIndexes(arr, index, loop);
    }
});
module.exports = Sugar.Array.at;

},{"2c855ec9effd679d":"dZZfL","335aaeca8b7a311a":"8OkFj"}],"aGJba":[function(require,module,exports) {
"use strict";
var Sugar = require("2808c428d4c4c248"), arrayClone = require("60a6d6c608f48b02");
Sugar.Array.defineInstance({
    "clone": function(arr) {
        return arrayClone(arr);
    }
});
module.exports = Sugar.Array.clone;

},{"2808c428d4c4c248":"dZZfL","60a6d6c608f48b02":"8C83v"}],"fpdBa":[function(require,module,exports) {
"use strict";
var Sugar = require("9ac610eb18feeb0b"), arrayCompact = require("237869bd23ba947c");
Sugar.Array.defineInstance({
    "compact": function(arr, all) {
        return arrayCompact(arr, all);
    }
});
module.exports = Sugar.Array.compact;

},{"9ac610eb18feeb0b":"dZZfL","237869bd23ba947c":"iVIjN"}],"iVIjN":[function(require,module,exports) {
"use strict";
var filter = require("61b926b01491d65c");
function arrayCompact(arr, all) {
    return filter(arr, function(el) {
        return el || !all && el != null && el.valueOf() === el.valueOf();
    });
}
module.exports = arrayCompact;

},{"61b926b01491d65c":"j8KnV"}],"em5r9":[function(require,module,exports) {
"use strict";
var Sugar = require("c2c9e5a14b137e58"), arrayExclude = require("b60b55e9e4fad25f");
Sugar.Array.defineInstance({
    "exclude": function(arr, f) {
        return arrayExclude(arr, f);
    }
});
module.exports = Sugar.Array.exclude;

},{"c2c9e5a14b137e58":"dZZfL","b60b55e9e4fad25f":"5xLMt"}],"5xLMt":[function(require,module,exports) {
"use strict";
var getMatcher = require("23d6eb97db464efd");
function arrayExclude(arr, f) {
    var result = [], matcher = getMatcher(f);
    for(var i = 0; i < arr.length; i++)if (!matcher(arr[i], i, arr)) result.push(arr[i]);
    return result;
}
module.exports = arrayExclude;

},{"23d6eb97db464efd":"fDwIk"}],"fDwIk":[function(require,module,exports) {
"use strict";
var isPrimitive = require("3c862e6f8dbbd213"), classChecks = require("74a6b3d5fbc26a1a"), dateMatcher = require("54540ca1194030c7"), regexMatcher = require("d618ce91bb1d3e9f"), isObjectType = require("8ce87d06b3a243b2"), isPlainObject = require("1bf37028443ed32d"), defaultMatcher = require("a593c3a76c71eb62"), functionMatcher = require("838b5aa85ea19432"), coreUtilityAliases = require("95ee6a5a425f1f9c");
var getOwn = coreUtilityAliases.getOwn, classToString = coreUtilityAliases.classToString, forEachProperty = coreUtilityAliases.forEachProperty, isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction;
function getMatcher(f) {
    if (!isPrimitive(f)) {
        var className = classToString(f);
        if (isRegExp(f, className)) return regexMatcher(f);
        else if (isDate(f, className)) return dateMatcher(f);
        else if (isFunction(f, className)) return functionMatcher(f);
        else if (isPlainObject(f, className)) return fuzzyMatcher(f);
    }
    // Default is standard isEqual
    return defaultMatcher(f);
}
function fuzzyMatcher(obj) {
    var matchers = {};
    return function(el, i, arr) {
        var matched = true;
        if (!isObjectType(el)) return false;
        forEachProperty(obj, function(val, key) {
            matchers[key] = getOwn(matchers, key) || getMatcher(val);
            if (matchers[key].call(arr, el[key], i, arr) === false) matched = false;
            return matched;
        });
        return matched;
    };
}
module.exports = getMatcher;

},{"3c862e6f8dbbd213":"j6hv6","74a6b3d5fbc26a1a":"MTXUY","54540ca1194030c7":"d8Ajh","d618ce91bb1d3e9f":"9Myy5","8ce87d06b3a243b2":"1dImj","1bf37028443ed32d":"dxNeT","a593c3a76c71eb62":"3Dv4t","838b5aa85ea19432":"c7xFl","95ee6a5a425f1f9c":"8ZxTV"}],"d8Ajh":[function(require,module,exports) {
"use strict";
function dateMatcher(d) {
    var ms = d.getTime();
    return function(el) {
        return !!(el && el.getTime) && el.getTime() === ms;
    };
}
module.exports = dateMatcher;

},{}],"9Myy5":[function(require,module,exports) {
"use strict";
function regexMatcher(reg) {
    reg = RegExp(reg);
    return function(el) {
        return reg.test(el);
    };
}
module.exports = regexMatcher;

},{}],"3Dv4t":[function(require,module,exports) {
"use strict";
var isEqual = require("70b9c7bb8bb61a6e");
function defaultMatcher(f) {
    return function(el) {
        return isEqual(el, f);
    };
}
module.exports = defaultMatcher;

},{"70b9c7bb8bb61a6e":"eYWKz"}],"eYWKz":[function(require,module,exports) {
"use strict";
var getKeys = require("af7c62441dad2fc5"), setToArray = require("58b42cf8c3be42c8"), mapToArray = require("2951b4682e9be1c9"), classChecks = require("2702bb17ee107fa7"), isObjectType = require("8f4f06a2842ada73"), coreUtilityAliases = require("6c083695d42808f8"), iterateWithCyclicCheck = require("4c72215bfd26375c");
var classToString = coreUtilityAliases.classToString, isSerializable = classChecks.isSerializable, isSet = classChecks.isSet, isMap = classChecks.isMap, isError = classChecks.isError;
function isEqual(a, b, stack) {
    var aClass, bClass;
    if (a === b) // Return quickly up front when matched by reference,
    // but be careful about 0 !== -0.
    return a !== 0 || 1 / a === 1 / b;
    aClass = classToString(a);
    bClass = classToString(b);
    if (aClass !== bClass) return false;
    if (isSerializable(a, aClass) && isSerializable(b, bClass)) return objectIsEqual(a, b, aClass, stack);
    else if (isSet(a, aClass) && isSet(b, bClass)) return a.size === b.size && isEqual(setToArray(a), setToArray(b), stack);
    else if (isMap(a, aClass) && isMap(b, bClass)) return a.size === b.size && isEqual(mapToArray(a), mapToArray(b), stack);
    else if (isError(a, aClass) && isError(b, bClass)) return a.toString() === b.toString();
    return false;
}
function objectIsEqual(a, b, aClass, stack) {
    var aType = typeof a, bType = typeof b, propsEqual, count;
    if (aType !== bType) return false;
    if (isObjectType(a.valueOf())) {
        if (a.length !== b.length) // perf: Quickly returning up front for arrays.
        return false;
        count = 0;
        propsEqual = true;
        iterateWithCyclicCheck(a, false, stack, function(key, val, cyc, stack) {
            if (!cyc && (!(key in b) || !isEqual(val, b[key], stack))) propsEqual = false;
            count++;
            return propsEqual;
        });
        if (!propsEqual || count !== getKeys(b).length) return false;
    }
    // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
    return a.valueOf().toString() === b.valueOf().toString();
}
module.exports = isEqual;

},{"af7c62441dad2fc5":"dSIGU","58b42cf8c3be42c8":"aTmb9","2951b4682e9be1c9":"a47L0","2702bb17ee107fa7":"MTXUY","8f4f06a2842ada73":"1dImj","6c083695d42808f8":"8ZxTV","4c72215bfd26375c":"isnQt"}],"dSIGU":[function(require,module,exports) {
"use strict";
function getKeys(obj) {
    return Object.keys(obj);
}
module.exports = getKeys;

},{}],"aTmb9":[function(require,module,exports) {
"use strict";
function setToArray(set) {
    var arr = new Array(set.size), i = 0;
    set.forEach(function(val) {
        arr[i++] = val;
    });
    return arr;
}
module.exports = setToArray;

},{}],"a47L0":[function(require,module,exports) {
"use strict";
function mapToArray(map) {
    var arr = new Array(map.size), i = 0;
    map.forEach(function(val, key) {
        arr[i++] = [
            key,
            val
        ];
    });
    return arr;
}
module.exports = mapToArray;

},{}],"isnQt":[function(require,module,exports) {
"use strict";
var getKeys = require("3c4107a9614f5178"), coreUtilityAliases = require("c040d5aea20f92f1");
var forEachProperty = coreUtilityAliases.forEachProperty;
function iterateWithCyclicCheck(obj, sortedKeys, stack, fn) {
    function next(val, key) {
        var cyc = false;
        // Allowing a step into the structure before triggering this check to save
        // cycles on standard JSON structures and also to try as hard as possible to
        // catch basic properties that may have been modified.
        if (stack.length > 1) {
            var i = stack.length;
            while(i--)if (stack[i] === val) cyc = true;
        }
        stack.push(val);
        fn(key, val, cyc, stack);
        stack.pop();
    }
    function iterateWithSortedKeys() {
        // Sorted keys is required for serialization, where object order
        // does not matter but stringified order does.
        var arr = getKeys(obj).sort(), key;
        for(var i = 0; i < arr.length; i++){
            key = arr[i];
            next(obj[key], arr[i]);
        }
    }
    // This method for checking for cyclic structures was egregiously stolen from
    // the ingenious method by @kitcambridge from the Underscore script:
    // https://github.com/documentcloud/underscore/issues/240
    if (!stack) stack = [];
    if (sortedKeys) iterateWithSortedKeys();
    else forEachProperty(obj, next);
}
module.exports = iterateWithCyclicCheck;

},{"3c4107a9614f5178":"dSIGU","c040d5aea20f92f1":"8ZxTV"}],"c7xFl":[function(require,module,exports) {
"use strict";
function functionMatcher(fn) {
    return function(el, i, arr) {
        // Return true up front if match by reference
        return el === fn || fn.call(arr, el, i, arr);
    };
}
module.exports = functionMatcher;

},{}],"lLxrs":[function(require,module,exports) {
"use strict";
var Sugar = require("1154b5b4676098c5"), isUndefined = require("def001fdd6714f9a");
Sugar.Array.defineInstance({
    "first": function(arr, num) {
        if (isUndefined(num)) return arr[0];
        if (num < 0) num = 0;
        return arr.slice(0, num);
    }
});
module.exports = Sugar.Array.first;

},{"1154b5b4676098c5":"dZZfL","def001fdd6714f9a":"6oRAa"}],"gNHXU":[function(require,module,exports) {
"use strict";
var Sugar = require("d8408f36f7bb6e5"), arrayFlatten = require("e2eee6324b52bd28");
Sugar.Array.defineInstance({
    "flatten": function(arr, limit) {
        return arrayFlatten(arr, limit);
    }
});
module.exports = Sugar.Array.flatten;

},{"d8408f36f7bb6e5":"dZZfL","e2eee6324b52bd28":"hCEyw"}],"hCEyw":[function(require,module,exports) {
"use strict";
var forEach = require("7a0ede4f5e48c6c5"), classChecks = require("a1935f1f603b9a79");
var isArray = classChecks.isArray;
function arrayFlatten(arr, level, current) {
    var result = [];
    level = level || Infinity;
    current = current || 0;
    forEach(arr, function(el) {
        if (isArray(el) && current < level) result = result.concat(arrayFlatten(el, level, current + 1));
        else result.push(el);
    });
    return result;
}
module.exports = arrayFlatten;

},{"7a0ede4f5e48c6c5":"JJnv7","a1935f1f603b9a79":"MTXUY"}],"gi6u5":[function(require,module,exports) {
"use strict";
var Sugar = require("45bba7d48ba95062");
Sugar.Array.defineInstance({
    "from": function(arr, num) {
        return arr.slice(num);
    }
});
module.exports = Sugar.Array.from;

},{"45bba7d48ba95062":"dZZfL"}],"j5wOi":[function(require,module,exports) {
"use strict";
var Sugar = require("9a06d999457d9fce"), arrayGroupBy = require("627fa2f13493fe01");
Sugar.Array.defineInstance({
    "groupBy": function(arr, map, groupFn) {
        return arrayGroupBy(arr, map, groupFn);
    }
});
module.exports = Sugar.Array.groupBy;

},{"9a06d999457d9fce":"dZZfL","627fa2f13493fe01":"fOD8h"}],"fOD8h":[function(require,module,exports) {
"use strict";
var forEach = require("c20afefc25dd258b"), mapWithShortcuts = require("bb1da7bd5b090d8d"), coreUtilityAliases = require("bdc8230e8dde0196");
var hasOwn = coreUtilityAliases.hasOwn, forEachProperty = coreUtilityAliases.forEachProperty;
function arrayGroupBy(arr, map, fn) {
    var result = {}, key;
    forEach(arr, function(el, i) {
        key = mapWithShortcuts(el, map, arr, [
            el,
            i,
            arr
        ]);
        if (!hasOwn(result, key)) result[key] = [];
        result[key].push(el);
    });
    if (fn) forEachProperty(result, fn);
    return result;
}
module.exports = arrayGroupBy;

},{"c20afefc25dd258b":"JJnv7","bb1da7bd5b090d8d":"2Ykp4","bdc8230e8dde0196":"8ZxTV"}],"2Ykp4":[function(require,module,exports) {
"use strict";
var map = require("7a5ede11e63f4865"), classChecks = require("db6b38001f9a5044"), deepGetProperty = require("a11e4ad394bb96d0");
var isFunction = classChecks.isFunction, isArray = classChecks.isArray;
function mapWithShortcuts(el, f, context, mapArgs) {
    if (!f) return el;
    else if (f.apply) return f.apply(context, mapArgs);
    else if (isArray(f)) return map(f, function(m) {
        return mapWithShortcuts(el, m, context, mapArgs);
    });
    else if (isFunction(el[f])) return el[f].call(el);
    else return deepGetProperty(el, f, true);
}
module.exports = mapWithShortcuts;

},{"7a5ede11e63f4865":"7WglA","db6b38001f9a5044":"MTXUY","a11e4ad394bb96d0":"4GhMu"}],"ibJgj":[function(require,module,exports) {
"use strict";
var Sugar = require("11a7937217032bce"), isDefined = require("5acdd0010fa40308"), mathAliases = require("c223f645ea8b2c05"), simpleRepeat = require("3e28b54ec1abff01");
var ceil = mathAliases.ceil;
Sugar.Array.defineInstance({
    "inGroups": function(arr, num, padding) {
        var pad = isDefined(padding);
        var result = new Array(num);
        var divisor = ceil(arr.length / num);
        simpleRepeat(num, function(i) {
            var index = i * divisor;
            var group = arr.slice(index, index + divisor);
            if (pad && group.length < divisor) simpleRepeat(divisor - group.length, function() {
                group.push(padding);
            });
            result[i] = group;
        });
        return result;
    }
});
module.exports = Sugar.Array.inGroups;

},{"11a7937217032bce":"dZZfL","5acdd0010fa40308":"4cOOJ","c223f645ea8b2c05":"f1S5P","3e28b54ec1abff01":"kKd76"}],"kKd76":[function(require,module,exports) {
"use strict";
function simpleRepeat(n, fn) {
    for(var i = 0; i < n; i++)fn(i);
}
module.exports = simpleRepeat;

},{}],"iEeny":[function(require,module,exports) {
"use strict";
var Sugar = require("7af6ef667bcef54e"), isUndefined = require("b55ee5945c7c2ed1"), mathAliases = require("57c7c8749038d893"), simpleRepeat = require("b254f5a811bcfd21");
var ceil = mathAliases.ceil;
Sugar.Array.defineInstance({
    "inGroupsOf": function(arr, num, padding) {
        var result = [], len = arr.length, group;
        if (len === 0 || num === 0) return arr;
        if (isUndefined(num)) num = 1;
        if (isUndefined(padding)) padding = null;
        simpleRepeat(ceil(len / num), function(i) {
            group = arr.slice(num * i, num * i + num);
            while(group.length < num)group.push(padding);
            result.push(group);
        });
        return result;
    }
});
module.exports = Sugar.Array.inGroupsOf;

},{"7af6ef667bcef54e":"dZZfL","b55ee5945c7c2ed1":"6oRAa","57c7c8749038d893":"f1S5P","b254f5a811bcfd21":"kKd76"}],"eluR3":[function(require,module,exports) {
"use strict";
var Sugar = require("1c5df4e0f8133989"), arrayIntersectOrSubtract = require("8e60ca1a9873d7a2");
Sugar.Array.defineInstance({
    "intersect": function(arr1, arr2) {
        return arrayIntersectOrSubtract(arr1, arr2, false);
    }
});
module.exports = Sugar.Array.intersect;

},{"1c5df4e0f8133989":"dZZfL","8e60ca1a9873d7a2":"6fTRF"}],"6fTRF":[function(require,module,exports) {
"use strict";
var forEach = require("e56c78bc27ff8ad2"), arrayWrap = require("b809403c4d891047"), classChecks = require("5f8f2ddf823f93f3"), serializeInternal = require("23e769cc6335e9a2"), coreUtilityAliases = require("d662ed68fff446bf");
var isArray = classChecks.isArray, hasOwn = coreUtilityAliases.hasOwn;
function arrayIntersectOrSubtract(arr1, arr2, subtract) {
    var result = [], obj = {}, refs = [];
    if (!isArray(arr2)) arr2 = arrayWrap(arr2);
    forEach(arr2, function(el) {
        obj[serializeInternal(el, refs)] = true;
    });
    forEach(arr1, function(el) {
        var key = serializeInternal(el, refs);
        if (hasOwn(obj, key) !== subtract) {
            delete obj[key];
            result.push(el);
        }
    });
    return result;
}
module.exports = arrayIntersectOrSubtract;

},{"e56c78bc27ff8ad2":"JJnv7","b809403c4d891047":"clFwf","5f8f2ddf823f93f3":"MTXUY","23e769cc6335e9a2":"3qH6r","d662ed68fff446bf":"8ZxTV"}],"clFwf":[function(require,module,exports) {
"use strict";
function arrayWrap(obj) {
    var arr = [];
    arr.push(obj);
    return arr;
}
module.exports = arrayWrap;

},{}],"3qH6r":[function(require,module,exports) {
"use strict";
var indexOf = require("553c6b1e06273000"), isRealNaN = require("381edde7e9043870"), isPrimitive = require("339978f81fd2798"), classChecks = require("42f49c2a4f971c13"), isObjectType = require("6065c10ef1e6fbfb"), coreUtilityAliases = require("1165f5d0f9a7ca16"), iterateWithCyclicCheck = require("5d7cd2040706507f");
var classToString = coreUtilityAliases.classToString, isSerializable = classChecks.isSerializable;
function serializeInternal(obj, refs, stack) {
    var type = typeof obj, sign = "", className, value, ref;
    // Return up front on
    if (1 / obj === -Infinity) sign = "-";
    // Return quickly for primitives to save cycles
    if (isPrimitive(obj, type) && !isRealNaN(obj)) return type + sign + obj;
    className = classToString(obj);
    if (!isSerializable(obj, className)) {
        ref = indexOf(refs, obj);
        if (ref === -1) {
            ref = refs.length;
            refs.push(obj);
        }
        return ref;
    } else if (isObjectType(obj)) value = serializeDeep(obj, refs, stack) + obj.toString();
    else if (obj.valueOf) value = obj.valueOf();
    return type + className + sign + value;
}
function serializeDeep(obj, refs, stack) {
    var result = "";
    iterateWithCyclicCheck(obj, true, stack, function(key, val, cyc, stack) {
        result += cyc ? "CYC" : key + serializeInternal(val, refs, stack);
    });
    return result;
}
module.exports = serializeInternal;

},{"553c6b1e06273000":"6IUmj","381edde7e9043870":"3UzhB","339978f81fd2798":"j6hv6","42f49c2a4f971c13":"MTXUY","6065c10ef1e6fbfb":"1dImj","1165f5d0f9a7ca16":"8ZxTV","5d7cd2040706507f":"isnQt"}],"3UzhB":[function(require,module,exports) {
"use strict";
function isRealNaN(obj) {
    // This is only true of NaN
    return obj != null && obj !== obj;
}
module.exports = isRealNaN;

},{}],"gEmX7":[function(require,module,exports) {
"use strict";
var Sugar = require("a9f382543c49817e");
Sugar.Array.defineInstance({
    "isEmpty": function(arr) {
        return arr.length === 0;
    }
});
module.exports = Sugar.Array.isEmpty;

},{"a9f382543c49817e":"dZZfL"}],"fBOBf":[function(require,module,exports) {
"use strict";
var Sugar = require("428fdc58ca90ad90"), isEqual = require("37169d22008ce8ec");
Sugar.Array.defineInstance({
    "isEqual": function(a, b) {
        return isEqual(a, b);
    }
});
module.exports = Sugar.Array.isEqual;

},{"428fdc58ca90ad90":"dZZfL","37169d22008ce8ec":"eYWKz"}],"agTgw":[function(require,module,exports) {
"use strict";
var Sugar = require("b9a8c6172dc50ed9"), isUndefined = require("3f1b53188448ca5d");
Sugar.Array.defineInstance({
    "last": function(arr, num) {
        if (isUndefined(num)) return arr[arr.length - 1];
        var start = arr.length - num < 0 ? 0 : arr.length - num;
        return arr.slice(start);
    }
});
module.exports = Sugar.Array.last;

},{"b9a8c6172dc50ed9":"dZZfL","3f1b53188448ca5d":"6oRAa"}],"ht3tS":[function(require,module,exports) {
"use strict";
var Sugar = require("b51008f5fb51bb70"), arrayRemove = require("417fabe265a5ae4c");
Sugar.Array.defineInstance({
    "remove": function(arr, f) {
        return arrayRemove(arr, f);
    }
});
module.exports = Sugar.Array.remove;

},{"b51008f5fb51bb70":"dZZfL","417fabe265a5ae4c":"lGJwS"}],"lGJwS":[function(require,module,exports) {
"use strict";
var getMatcher = require("b86ec48cf1ca74a7");
function arrayRemove(arr, f) {
    var matcher = getMatcher(f), i = 0;
    while(i < arr.length)if (matcher(arr[i], i, arr)) arr.splice(i, 1);
    else i++;
    return arr;
}
module.exports = arrayRemove;

},{"b86ec48cf1ca74a7":"fDwIk"}],"O5tJD":[function(require,module,exports) {
"use strict";
var Sugar = require("d0ed6a1fcb93f7c9"), isUndefined = require("6e75295cacb2001a");
Sugar.Array.defineInstance({
    "removeAt": function(arr, start, end) {
        if (isUndefined(start)) return arr;
        if (isUndefined(end)) end = start;
        arr.splice(start, end - start + 1);
        return arr;
    }
});
module.exports = Sugar.Array.removeAt;

},{"d0ed6a1fcb93f7c9":"dZZfL","6e75295cacb2001a":"6oRAa"}],"vxvuS":[function(require,module,exports) {
"use strict";
var Sugar = require("4a936b15557ae843"), trunc = require("a4330c1da3c2b100"), arrayClone = require("3abd611546ba29f8"), classChecks = require("a1c46501e7fe69a5"), isUndefined = require("1b8a97fbada1dcce"), mathAliases = require("3d7b160fda62fd9d");
var isBoolean = classChecks.isBoolean, min = mathAliases.min;
Sugar.Array.defineInstance({
    "sample": function(arr, arg1, arg2) {
        var result = [], num, remove, single;
        if (isBoolean(arg1)) remove = arg1;
        else {
            num = arg1;
            remove = arg2;
        }
        if (isUndefined(num)) {
            num = 1;
            single = true;
        }
        if (!remove) arr = arrayClone(arr);
        num = min(num, arr.length);
        for(var i = 0, index; i < num; i++){
            index = trunc(Math.random() * arr.length);
            result.push(arr[index]);
            arr.splice(index, 1);
        }
        return single ? result[0] : result;
    }
});
module.exports = Sugar.Array.sample;

},{"4a936b15557ae843":"dZZfL","a4330c1da3c2b100":"898n5","3abd611546ba29f8":"8C83v","a1c46501e7fe69a5":"MTXUY","1b8a97fbada1dcce":"6oRAa","3d7b160fda62fd9d":"f1S5P"}],"cmG0D":[function(require,module,exports) {
"use strict";
var Sugar = require("9d0351febd1fbf34"), arrayShuffle = require("e669c6cac2bbd894");
Sugar.Array.defineInstance({
    "shuffle": function(arr) {
        return arrayShuffle(arr);
    }
});
module.exports = Sugar.Array.shuffle;

},{"9d0351febd1fbf34":"dZZfL","e669c6cac2bbd894":"hPNq2"}],"hPNq2":[function(require,module,exports) {
"use strict";
var arrayClone = require("1dc3d624ad619d2a");
function arrayShuffle(arr) {
    arr = arrayClone(arr);
    var i = arr.length, j, x;
    while(i){
        j = Math.random() * i | 0;
        x = arr[--i];
        arr[i] = arr[j];
        arr[j] = x;
    }
    return arr;
}
module.exports = arrayShuffle;

},{"1dc3d624ad619d2a":"8C83v"}],"66AST":[function(require,module,exports) {
"use strict";
var Sugar = require("26ba6bfca781a70d"), compareValue = require("f2483b2e785f9242"), mapWithShortcuts = require("45e7c778eb1cf041");
Sugar.Array.defineInstance({
    "sortBy": function(arr, map, desc) {
        arr.sort(function(a, b) {
            var aProperty = mapWithShortcuts(a, map, arr, [
                a
            ]);
            var bProperty = mapWithShortcuts(b, map, arr, [
                b
            ]);
            return compareValue(aProperty, bProperty) * (desc ? -1 : 1);
        });
        return arr;
    }
});
module.exports = Sugar.Array.sortBy;

},{"26ba6bfca781a70d":"dZZfL","f2483b2e785f9242":"hqeVP","45e7c778eb1cf041":"2Ykp4"}],"hqeVP":[function(require,module,exports) {
"use strict";
var ARRAY_OPTIONS = require("65e5d13a3dc2995d"), classChecks = require("cd81d3c39f35386b");
var isString = classChecks.isString, isArray = classChecks.isArray, _arrayOptions = ARRAY_OPTIONS._arrayOptions;
function compareValue(aVal, bVal) {
    var cmp, i, collate;
    if (isString(aVal) && isString(bVal)) {
        collate = _arrayOptions("sortCollate");
        return collate(aVal, bVal);
    } else if (isArray(aVal) && isArray(bVal)) {
        if (aVal.length < bVal.length) return -1;
        else if (aVal.length > bVal.length) return 1;
        else {
            for(i = 0; i < aVal.length; i++){
                cmp = compareValue(aVal[i], bVal[i]);
                if (cmp !== 0) return cmp;
            }
            return 0;
        }
    }
    return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
}
module.exports = compareValue;

},{"65e5d13a3dc2995d":"hXTq0","cd81d3c39f35386b":"MTXUY"}],"hXTq0":[function(require,module,exports) {
"use strict";
var getSortOrder = require("fb04de595b7cc0b6"), codeIsNumeral = require("8d2b047f544803da"), stringToNumber = require("3ffd77c037723a72"), namespaceAliases = require("beaedbf568652573"), getSortOrderIndex = require("6b91def9fe536c64"), getSortEquivalents = require("68554f878220fa0e"), defineOptionsAccessor = require("3b0cfc47d5ca934b"), getCollationCharacter = require("f78257e202e11b0b"), getCollationReadyString = require("5da7d8e6d34e530a");
var sugarArray = namespaceAliases.sugarArray;
var ARRAY_OPTIONS = {
    "sortIgnore": null,
    "sortNatural": true,
    "sortIgnoreCase": true,
    "sortOrder": getSortOrder(),
    "sortCollate": collateStrings,
    "sortEquivalents": getSortEquivalents()
};
var _arrayOptions = defineOptionsAccessor(sugarArray, ARRAY_OPTIONS);
function collateStrings(a, b) {
    var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0, tiebreaker = 0;
    var sortOrder = _arrayOptions("sortOrder");
    var sortIgnore = _arrayOptions("sortIgnore");
    var sortNatural = _arrayOptions("sortNatural");
    var sortIgnoreCase = _arrayOptions("sortIgnoreCase");
    var sortEquivalents = _arrayOptions("sortEquivalents");
    a = getCollationReadyString(a, sortIgnore, sortIgnoreCase);
    b = getCollationReadyString(b, sortIgnore, sortIgnoreCase);
    do {
        aChar = getCollationCharacter(a, index, sortEquivalents);
        bChar = getCollationCharacter(b, index, sortEquivalents);
        aValue = getSortOrderIndex(aChar, sortOrder);
        bValue = getSortOrderIndex(bChar, sortOrder);
        if (aValue === -1 || bValue === -1) {
            aValue = a.charCodeAt(index) || null;
            bValue = b.charCodeAt(index) || null;
            if (sortNatural && codeIsNumeral(aValue) && codeIsNumeral(bValue)) {
                aValue = stringToNumber(a.slice(index));
                bValue = stringToNumber(b.slice(index));
            }
        } else {
            aEquiv = aChar !== a.charAt(index);
            bEquiv = bChar !== b.charAt(index);
            if (aEquiv !== bEquiv && tiebreaker === 0) tiebreaker = aEquiv - bEquiv;
        }
        index += 1;
    }while (aValue != null && bValue != null && aValue === bValue);
    if (aValue === bValue) return tiebreaker;
    return aValue - bValue;
}
module.exports = {
    ARRAY_OPTIONS: ARRAY_OPTIONS,
    _arrayOptions: _arrayOptions
};

},{"fb04de595b7cc0b6":"cbocv","8d2b047f544803da":"lMP0k","3ffd77c037723a72":"3jdZa","beaedbf568652573":"4onj1","6b91def9fe536c64":"de86I","68554f878220fa0e":"lytGr","3b0cfc47d5ca934b":"cfSYO","f78257e202e11b0b":"3ljpp","5da7d8e6d34e530a":"bbhMz"}],"cbocv":[function(require,module,exports) {
"use strict";
var map = require("a7ebc7f04759647b");
function getSortOrder() {
    var order = "A\xc1\xc0\xc2\xc3\u0104BC\u0106\u010C\xc7D\u010E\xd0E\xc9\xc8\u011A\xca\xcb\u0118FG\u011EH\u0131I\xcd\xcc\u0130\xce\xcfJKL\u0141MN\u0143\u0147\xd1O\xd3\xd2\xd4PQR\u0158S\u015A\u0160\u015ET\u0164U\xda\xd9\u016E\xdb\xdcVWXY\xddZ\u0179\u017B\u017D\xde\xc6\u0152\xd8\xd5\xc5\xc4\xd6";
    return map(order.split(""), function(str) {
        return str + str.toLowerCase();
    }).join("");
}
module.exports = getSortOrder;

},{"a7ebc7f04759647b":"7WglA"}],"lMP0k":[function(require,module,exports) {
"use strict";
var HALF_WIDTH_NINE = require("eac606069cb90d77"), FULL_WIDTH_NINE = require("dca5c0fb1111747d"), CommonChars = require("9bca182f8c63c23b");
var HALF_WIDTH_ZERO = CommonChars.HALF_WIDTH_ZERO, FULL_WIDTH_ZERO = CommonChars.FULL_WIDTH_ZERO;
function codeIsNumeral(code) {
    return code >= HALF_WIDTH_ZERO && code <= HALF_WIDTH_NINE || code >= FULL_WIDTH_ZERO && code <= FULL_WIDTH_NINE;
}
module.exports = codeIsNumeral;

},{"eac606069cb90d77":"eZEsQ","dca5c0fb1111747d":"j0Hik","9bca182f8c63c23b":"9C1NQ"}],"eZEsQ":[function(require,module,exports) {
"use strict";
module.exports = 0x39;

},{}],"j0Hik":[function(require,module,exports) {
"use strict";
module.exports = 0xff19;

},{}],"de86I":[function(require,module,exports) {
"use strict";
function getSortOrderIndex(chr, sortOrder) {
    if (!chr) return null;
    else return sortOrder.indexOf(chr);
}
module.exports = getSortOrderIndex;

},{}],"lytGr":[function(require,module,exports) {
"use strict";
var forEach = require("284daa8a418b2512"), spaceSplit = require("45351fe787a89aa9");
function getSortEquivalents() {
    var equivalents = {};
    forEach(spaceSplit("A\xc1\xc0\xc2\xc3\xc4 C\xc7 E\xc9\xc8\xca\xcb I\xcd\xcc\u0130\xce\xcf O\xd3\xd2\xd4\xd5\xd6 S\xdf U\xda\xd9\xdb\xdc"), function(set) {
        var first = set.charAt(0);
        forEach(set.slice(1).split(""), function(chr) {
            equivalents[chr] = first;
            equivalents[chr.toLowerCase()] = first.toLowerCase();
        });
    });
    return equivalents;
}
module.exports = getSortEquivalents;

},{"284daa8a418b2512":"JJnv7","45351fe787a89aa9":"cGrLA"}],"3ljpp":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("d65c4bed929603d3");
var getOwn = coreUtilityAliases.getOwn;
function getCollationCharacter(str, index, sortEquivalents) {
    var chr = str.charAt(index);
    return getOwn(sortEquivalents, chr) || chr;
}
module.exports = getCollationCharacter;

},{"d65c4bed929603d3":"8ZxTV"}],"bbhMz":[function(require,module,exports) {
"use strict";
function getCollationReadyString(str, sortIgnore, sortIgnoreCase) {
    if (sortIgnoreCase) str = str.toLowerCase();
    if (sortIgnore) str = str.replace(sortIgnore, "");
    return str;
}
module.exports = getCollationReadyString;

},{}],"7WMmv":[function(require,module,exports) {
"use strict";
var Sugar = require("8892c6a8c272af42"), arrayIntersectOrSubtract = require("24bb37144a374d44");
Sugar.Array.defineInstance({
    "subtract": function(arr, item) {
        return arrayIntersectOrSubtract(arr, item, true);
    }
});
module.exports = Sugar.Array.subtract;

},{"8892c6a8c272af42":"dZZfL","24bb37144a374d44":"6fTRF"}],"3zPdN":[function(require,module,exports) {
"use strict";
var Sugar = require("cc27542048aa86e"), isUndefined = require("b0d4ac2fa93a37ac");
Sugar.Array.defineInstance({
    "to": function(arr, num) {
        if (isUndefined(num)) num = arr.length;
        return arr.slice(0, num);
    }
});
module.exports = Sugar.Array.to;

},{"cc27542048aa86e":"dZZfL","b0d4ac2fa93a37ac":"6oRAa"}],"9bBzJ":[function(require,module,exports) {
"use strict";
var Sugar = require("75f4f8042b2841ba"), arrayUnique = require("6ecbc6ff68af6848"), arrayConcat = require("22fe24f0a7019c6a");
Sugar.Array.defineInstance({
    "union": function(arr1, arr2) {
        return arrayUnique(arrayConcat(arr1, arr2));
    }
});
module.exports = Sugar.Array.union;

},{"75f4f8042b2841ba":"dZZfL","6ecbc6ff68af6848":"1dqiM","22fe24f0a7019c6a":"cTAzV"}],"1dqiM":[function(require,module,exports) {
"use strict";
var forEach = require("b512ae97abb25d9e"), mapWithShortcuts = require("9ba6d911eb9701f"), serializeInternal = require("3bae3acdfc2e591d"), coreUtilityAliases = require("8203276f8c7800db");
var hasOwn = coreUtilityAliases.hasOwn;
function arrayUnique(arr, map) {
    var result = [], obj = {}, refs = [];
    forEach(arr, function(el, i) {
        var transformed = map ? mapWithShortcuts(el, map, arr, [
            el,
            i,
            arr
        ]) : el;
        var key = serializeInternal(transformed, refs);
        if (!hasOwn(obj, key)) {
            result.push(el);
            obj[key] = true;
        }
    });
    return result;
}
module.exports = arrayUnique;

},{"b512ae97abb25d9e":"JJnv7","9ba6d911eb9701f":"2Ykp4","3bae3acdfc2e591d":"3qH6r","8203276f8c7800db":"8ZxTV"}],"cTAzV":[function(require,module,exports) {
"use strict";
var HAS_CONCAT_BUG = require("c8fc7f28504122a3"), arraySafeConcat = require("b2869085675a7924");
function arrayConcat(arr1, arr2) {
    // istanbul ignore if
    if (HAS_CONCAT_BUG) return arraySafeConcat(arr1, arr2);
    return arr1.concat(arr2);
}
module.exports = arrayConcat;

},{"c8fc7f28504122a3":"iw46S","b2869085675a7924":"kKnm0"}],"iw46S":[function(require,module,exports) {
"use strict";
module.exports = !("0" in [].concat(undefined).concat());

},{}],"kKnm0":[function(require,module,exports) {
"use strict";
var forEach = require("49af294d1cd00992"), arrayClone = require("f8a246435b843700"), classChecks = require("159a30fa5ccfe046");
var isArray = classChecks.isArray;
function arraySafeConcat(arr, arg) {
    var result = arrayClone(arr), len = result.length, arr2;
    arr2 = isArray(arg) ? arg : [
        arg
    ];
    result.length += arr2.length;
    forEach(arr2, function(el, i) {
        result[len + i] = el;
    });
    return result;
}
module.exports = arraySafeConcat;

},{"49af294d1cd00992":"JJnv7","f8a246435b843700":"8C83v","159a30fa5ccfe046":"MTXUY"}],"1YZfy":[function(require,module,exports) {
"use strict";
var Sugar = require("9ffb327b5644d28c"), arrayUnique = require("1e69661c79a3782e");
Sugar.Array.defineInstance({
    "unique": function(arr, map) {
        return arrayUnique(arr, map);
    }
});
module.exports = Sugar.Array.unique;

},{"9ffb327b5644d28c":"dZZfL","1e69661c79a3782e":"1dqiM"}],"joLbD":[function(require,module,exports) {
"use strict";
var Sugar = require("365ae8481de1f475"), map = require("c77486b08989deb2");
Sugar.Array.defineInstanceWithArguments({
    "zip": function(arr, args) {
        return map(arr, function(el, i) {
            return [
                el
            ].concat(map(args, function(k) {
                return i in k ? k[i] : null;
            }));
        });
    }
});
module.exports = Sugar.Array.zip;

},{"365ae8481de1f475":"dZZfL","c77486b08989deb2":"7WglA"}],"hOTCS":[function(require,module,exports) {
"use strict";
var Sugar = require("22682f6c761b0d4d"), append = require("608ed334a01ebb4");
Sugar.Array.alias("insert", "append");
module.exports = Sugar.Array.insert;

},{"22682f6c761b0d4d":"dZZfL","608ed334a01ebb4":"cyHON"}],"6qOG2":[function(require,module,exports) {
"use strict";
var Sugar = require("949fe36872b053ff"), ARRAY_OPTIONS = require("3c70f3dd90ce10b6");
var _arrayOptions = ARRAY_OPTIONS._arrayOptions;
module.exports = Sugar.Array.getOption;

},{"949fe36872b053ff":"dZZfL","3c70f3dd90ce10b6":"hXTq0"}],"kKRU4":[function(require,module,exports) {
"use strict";
var Sugar = require("5d94ead98c84f672"), ARRAY_OPTIONS = require("3eb1172a044c1cd8");
var _arrayOptions = ARRAY_OPTIONS._arrayOptions;
module.exports = Sugar.Array.setOption;

},{"5d94ead98c84f672":"dZZfL","3eb1172a044c1cd8":"hXTq0"}],"5D1h4":[function(require,module,exports) {
"use strict";
// Static Methods
require("5245f8261e6a6df3");
require("f32e011bf90e6c2a");
require("5b722971f87377c9");
require("6973463c3664743e");
require("ee9357c09edd40be");
require("5f6160368d28252e");
require("28732a96326f841f");
require("e1217dace575c0c0");
require("d4993167b48b2b0");
require("7fc12d0d662a8a46");
require("47d3524bc8d91955");
require("8604401d6e530ae2");
require("f1c4966bd724a86e");
require("fa931c9881659ba4");
require("6ae03d038e6873bc");
require("e2f35e64948f5543");
// Instance Methods
require("acdf6bd0045fd7cc");
require("ece4b87f3871fd97");
require("5f6a161718318e");
require("3d2d11626fb5690f");
require("6a15ddd692084c98");
require("6b24b3493b242ca6");
require("3e368e76c46704ed");
require("63faf71a53f57e92");
require("9bba12042efbcd4f");
require("ea2600150a3c91c0");
require("132fde5749b6dace");
require("af47ecc960b06a25");
require("30d47351f107e1e0");
require("9fd18e685a1683d4");
require("5bd11b180bd2f3bd");
require("7eb45f84c75c2534");
require("b1c2dff66d13ddf8");
require("cf121d5d0cff3efb");
require("27ed2ea626cc431d");
require("f9d26bff92575722");
require("e0ac9bcc55df6f5e");
require("e02012c0e3eb159a");
require("415e92697da526f8");
require("b1e1f154ca5898a");
module.exports = require("7949d88a6b240a1a");

},{"5245f8261e6a6df3":"czD9E","f32e011bf90e6c2a":"fwjFz","5b722971f87377c9":"7T72j","6973463c3664743e":"ie0xC","ee9357c09edd40be":"lISSV","5f6160368d28252e":"hxKU7","28732a96326f841f":"1jJb6","e1217dace575c0c0":"4S1xA","d4993167b48b2b0":"cSDB9","7fc12d0d662a8a46":"efe1m","47d3524bc8d91955":"74Lhn","8604401d6e530ae2":"8qhE7","f1c4966bd724a86e":"8mkPy","fa931c9881659ba4":"fIsKR","6ae03d038e6873bc":"aycve","e2f35e64948f5543":"g3j35","acdf6bd0045fd7cc":"hUH9S","ece4b87f3871fd97":"1FUM4","5f6a161718318e":"1BnC9","3d2d11626fb5690f":"kHebJ","6a15ddd692084c98":"e73qH","6b24b3493b242ca6":"hWJV8","3e368e76c46704ed":"5wnzN","63faf71a53f57e92":"1vQhv","9bba12042efbcd4f":"4Yfr4","ea2600150a3c91c0":"l7Erm","132fde5749b6dace":"EJ8yQ","af47ecc960b06a25":"hANnw","30d47351f107e1e0":"85PRW","9fd18e685a1683d4":"jyyZD","5bd11b180bd2f3bd":"bWDuy","7eb45f84c75c2534":"iRZQ0","b1c2dff66d13ddf8":"k7Fbf","cf121d5d0cff3efb":"72Xou","27ed2ea626cc431d":"fa1Ey","f9d26bff92575722":"ubIhS","e0ac9bcc55df6f5e":"lhSw7","e02012c0e3eb159a":"97R38","415e92697da526f8":"2T9qG","b1e1f154ca5898a":"5788v","7949d88a6b240a1a":"dZZfL"}],"czD9E":[function(require,module,exports) {
"use strict";
var Sugar = require("772fb99f7e61664c"), average = require("c9bfa223a15743f8");
Sugar.Object.defineInstanceAndStatic({
    "average": function(obj, map) {
        return average(obj, map);
    }
});
module.exports = Sugar.Object.average;

},{"772fb99f7e61664c":"dZZfL","c9bfa223a15743f8":"3ygqI"}],"3ygqI":[function(require,module,exports) {
"use strict";
var enumerateWithMapping = require("60ef0e7c53a8febb");
function average(obj, map) {
    var sum = 0, count = 0;
    enumerateWithMapping(obj, map, function(val) {
        sum += val;
        count++;
    });
    // Prevent divide by 0
    return sum / (count || 1);
}
module.exports = average;

},{"60ef0e7c53a8febb":"7o6NV"}],"7o6NV":[function(require,module,exports) {
"use strict";
var classChecks = require("d693c640f2e2bb70"), isArrayIndex = require("7e79a981523a047b"), mapWithShortcuts = require("262221a9b397f4f6"), coreUtilityAliases = require("bdcd2d1149e71fc9");
var isArray = classChecks.isArray, forEachProperty = coreUtilityAliases.forEachProperty;
function enumerateWithMapping(obj, map, fn) {
    var arrayIndexes = isArray(obj);
    forEachProperty(obj, function(val, key) {
        if (arrayIndexes) {
            if (!isArrayIndex(key)) return;
            key = +key;
        }
        var mapped = mapWithShortcuts(val, map, obj, [
            val,
            key,
            obj
        ]);
        fn(mapped, key);
    });
}
module.exports = enumerateWithMapping;

},{"d693c640f2e2bb70":"MTXUY","7e79a981523a047b":"lvBp0","262221a9b397f4f6":"2Ykp4","bdcd2d1149e71fc9":"8ZxTV"}],"fwjFz":[function(require,module,exports) {
"use strict";
var Sugar = require("6edf552f512eb234"), objectCount = require("44cf81f3f0be88b3");
Sugar.Object.defineInstanceAndStatic({
    "count": function(obj, f) {
        return objectCount(obj, f);
    }
});
module.exports = Sugar.Object.count;

},{"6edf552f512eb234":"dZZfL","44cf81f3f0be88b3":"8Mb9s"}],"8Mb9s":[function(require,module,exports) {
"use strict";
var getMatcher = require("32e214da048b4b37"), coreUtilityAliases = require("510fe85288915bbb");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectCount(obj, f) {
    var matcher = getMatcher(f), count = 0;
    forEachProperty(obj, function(val, key) {
        if (matcher(val, key, obj)) count++;
    });
    return count;
}
module.exports = objectCount;

},{"32e214da048b4b37":"fDwIk","510fe85288915bbb":"8ZxTV"}],"7T72j":[function(require,module,exports) {
"use strict";
var Sugar = require("5310d56e4eb99353"), objectMatchers = require("438d0b15a6279d2c");
var objectEvery = objectMatchers.objectEvery;
Sugar.Object.defineInstanceAndStatic({
    "every": objectEvery
});
module.exports = Sugar.Object.every;

},{"5310d56e4eb99353":"dZZfL","438d0b15a6279d2c":"9ySrD"}],"9ySrD":[function(require,module,exports) {
"use strict";
var wrapObjectMatcher = require("f7b315f170d24e20");
module.exports = {
    objectSome: wrapObjectMatcher("some"),
    objectFind: wrapObjectMatcher("find"),
    objectEvery: wrapObjectMatcher("every")
};

},{"f7b315f170d24e20":"2crDT"}],"2crDT":[function(require,module,exports) {
"use strict";
var getKeys = require("77234efc0098f8b"), getMatcher = require("6b7c354c043f4da6");
function wrapObjectMatcher(name) {
    var nativeFn = Array.prototype[name];
    return function(obj, f) {
        var matcher = getMatcher(f);
        return nativeFn.call(getKeys(obj), function(key) {
            return matcher(obj[key], key, obj);
        });
    };
}
module.exports = wrapObjectMatcher;

},{"77234efc0098f8b":"dSIGU","6b7c354c043f4da6":"fDwIk"}],"ie0xC":[function(require,module,exports) {
"use strict";
var Sugar = require("cb5fc01768d080b8"), objectFilter = require("21a90d4bc177c5cb");
Sugar.Object.defineInstanceAndStatic({
    "filter": function(obj, f) {
        return objectFilter(obj, f);
    }
});
module.exports = Sugar.Object.filter;

},{"cb5fc01768d080b8":"dZZfL","21a90d4bc177c5cb":"1D59y"}],"1D59y":[function(require,module,exports) {
"use strict";
var getMatcher = require("3a3c357f4310c429"), coreUtilityAliases = require("95c3ad7381462b68");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectFilter(obj, f) {
    var matcher = getMatcher(f), result = {};
    forEachProperty(obj, function(val, key) {
        if (matcher(val, key, obj)) result[key] = val;
    });
    return result;
}
module.exports = objectFilter;

},{"3a3c357f4310c429":"fDwIk","95c3ad7381462b68":"8ZxTV"}],"lISSV":[function(require,module,exports) {
"use strict";
var Sugar = require("8da9356de5216629"), objectMatchers = require("3216b61962fcfab5");
var objectFind = objectMatchers.objectFind;
Sugar.Object.defineInstanceAndStatic({
    "find": objectFind
});
module.exports = Sugar.Object.find;

},{"8da9356de5216629":"dZZfL","3216b61962fcfab5":"9ySrD"}],"hxKU7":[function(require,module,exports) {
"use strict";
var Sugar = require("54893d5aa6f38a44"), objectForEach = require("c01e6b358c65f634");
Sugar.Object.defineInstanceAndStatic({
    "forEach": function(obj, eachFn) {
        return objectForEach(obj, eachFn);
    }
});
module.exports = Sugar.Object.forEach;

},{"54893d5aa6f38a44":"dZZfL","c01e6b358c65f634":"f1Syp"}],"f1Syp":[function(require,module,exports) {
"use strict";
var assertCallable = require("56155ce3e9f8ab0b"), coreUtilityAliases = require("c051ecb079ce1c47");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectForEach(obj, fn) {
    assertCallable(fn);
    forEachProperty(obj, function(val, key) {
        fn(val, key, obj);
    });
    return obj;
}
module.exports = objectForEach;

},{"56155ce3e9f8ab0b":"fSAFz","c051ecb079ce1c47":"8ZxTV"}],"fSAFz":[function(require,module,exports) {
"use strict";
var classChecks = require("906aeb6609c2e719");
var isFunction = classChecks.isFunction;
function assertCallable(obj) {
    if (!isFunction(obj)) throw new TypeError("Function is not callable");
}
module.exports = assertCallable;

},{"906aeb6609c2e719":"MTXUY"}],"1jJb6":[function(require,module,exports) {
"use strict";
var Sugar = require("97da7aaecd7e354b"), getLeastOrMost = require("f1bb13bd326780ed");
Sugar.Object.defineInstanceAndStatic({
    "least": function(obj, all, map) {
        return getLeastOrMost(obj, all, map, false, true);
    }
});
module.exports = Sugar.Object.least;

},{"97da7aaecd7e354b":"dZZfL","f1bb13bd326780ed":"C26U2"}],"C26U2":[function(require,module,exports) {
"use strict";
var classChecks = require("400567415fb30f66"), getMinOrMax = require("5ea744ff6722d916"), serializeInternal = require("2f39c22f28a6d361"), coreUtilityAliases = require("305002641a8acb8a"), enumerateWithMapping = require("236f849716d90aeb"), getReducedMinMaxResult = require("2b935a49995f49cf");
var isBoolean = classChecks.isBoolean, getOwn = coreUtilityAliases.getOwn, forEachProperty = coreUtilityAliases.forEachProperty;
function getLeastOrMost(obj, arg1, arg2, most, asObject) {
    var group = {}, refs = [], minMaxResult, result, all, map;
    if (isBoolean(arg1)) {
        all = arg1;
        map = arg2;
    } else map = arg1;
    enumerateWithMapping(obj, map, function(val, key) {
        var groupKey = serializeInternal(val, refs);
        var arr = getOwn(group, groupKey) || [];
        arr.push(asObject ? key : obj[key]);
        group[groupKey] = arr;
    });
    minMaxResult = getMinOrMax(group, !!all, "length", most, true);
    if (all) {
        result = [];
        // Flatten result
        forEachProperty(minMaxResult, function(val) {
            result = result.concat(val);
        });
    } else result = getOwn(group, minMaxResult);
    return getReducedMinMaxResult(result, obj, all, asObject);
}
module.exports = getLeastOrMost;

},{"400567415fb30f66":"MTXUY","5ea744ff6722d916":"djJB7","2f39c22f28a6d361":"3qH6r","305002641a8acb8a":"8ZxTV","236f849716d90aeb":"7o6NV","2b935a49995f49cf":"gg0at"}],"djJB7":[function(require,module,exports) {
"use strict";
var classChecks = require("13e07f69231d7e71"), isUndefined = require("5941b529e66518c"), enumerateWithMapping = require("4233d960657ba83f"), getReducedMinMaxResult = require("f03c822e7526052f");
var isBoolean = classChecks.isBoolean;
function getMinOrMax(obj, arg1, arg2, max, asObject) {
    var result = [], pushVal, edge, all, map;
    if (isBoolean(arg1)) {
        all = arg1;
        map = arg2;
    } else map = arg1;
    enumerateWithMapping(obj, map, function(val, key) {
        if (isUndefined(val)) throw new TypeError("Cannot compare with undefined");
        pushVal = asObject ? key : obj[key];
        if (val === edge) result.push(pushVal);
        else if (isUndefined(edge) || max && val > edge || !max && val < edge) {
            result = [
                pushVal
            ];
            edge = val;
        }
    });
    return getReducedMinMaxResult(result, obj, all, asObject);
}
module.exports = getMinOrMax;

},{"13e07f69231d7e71":"MTXUY","5941b529e66518c":"6oRAa","4233d960657ba83f":"7o6NV","f03c822e7526052f":"gg0at"}],"gg0at":[function(require,module,exports) {
"use strict";
function getReducedMinMaxResult(result, obj, all, asObject) {
    if (asObject && all) // The method has returned an array of keys so use this array
    // to build up the resulting object in the form we want it in.
    return result.reduce(function(o, key) {
        o[key] = obj[key];
        return o;
    }, {});
    else if (result && !all) result = result[0];
    return result;
}
module.exports = getReducedMinMaxResult;

},{}],"4S1xA":[function(require,module,exports) {
"use strict";
var Sugar = require("589d03999f295a0a"), objectMap = require("8b155eb7674689bd");
Sugar.Object.defineInstanceAndStatic({
    "map": function(obj, map) {
        return objectMap(obj, map);
    }
});
module.exports = Sugar.Object.map;

},{"589d03999f295a0a":"dZZfL","8b155eb7674689bd":"aehv1"}],"aehv1":[function(require,module,exports) {
"use strict";
var mapWithShortcuts = require("dfe5ca130b9f406d"), coreUtilityAliases = require("95e6d15f021ac5e3");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectMap(obj, map) {
    var result = {};
    forEachProperty(obj, function(val, key) {
        result[key] = mapWithShortcuts(val, map, obj, [
            val,
            key,
            obj
        ]);
    });
    return result;
}
module.exports = objectMap;

},{"dfe5ca130b9f406d":"2Ykp4","95e6d15f021ac5e3":"8ZxTV"}],"cSDB9":[function(require,module,exports) {
"use strict";
var Sugar = require("286fa487810474be"), getMinOrMax = require("563d07f138207340");
Sugar.Object.defineInstanceAndStatic({
    "max": function(obj, all, map) {
        return getMinOrMax(obj, all, map, true, true);
    }
});
module.exports = Sugar.Object.max;

},{"286fa487810474be":"dZZfL","563d07f138207340":"djJB7"}],"efe1m":[function(require,module,exports) {
"use strict";
var Sugar = require("3a8c7656242b75c5"), median = require("73cd527488490af");
Sugar.Object.defineInstanceAndStatic({
    "median": function(obj, map) {
        return median(obj, map);
    }
});
module.exports = Sugar.Object.median;

},{"3a8c7656242b75c5":"dZZfL","73cd527488490af":"eO57G"}],"eO57G":[function(require,module,exports) {
"use strict";
var trunc = require("1beb57d66b0ce0d1"), enumerateWithMapping = require("d903b02c92016285");
function median(obj, map) {
    var result = [], middle, len;
    enumerateWithMapping(obj, map, function(val) {
        result.push(val);
    });
    len = result.length;
    if (!len) return 0;
    result.sort(function(a, b) {
        // IE7 will throw errors on non-numbers!
        return (a || 0) - (b || 0);
    });
    middle = trunc(len / 2);
    return len % 2 ? result[middle] : (result[middle - 1] + result[middle]) / 2;
}
module.exports = median;

},{"1beb57d66b0ce0d1":"898n5","d903b02c92016285":"7o6NV"}],"74Lhn":[function(require,module,exports) {
"use strict";
var Sugar = require("1de04971cc1d2c15"), getMinOrMax = require("d35633e9521906a7");
Sugar.Object.defineInstanceAndStatic({
    "min": function(obj, all, map) {
        return getMinOrMax(obj, all, map, false, true);
    }
});
module.exports = Sugar.Object.min;

},{"1de04971cc1d2c15":"dZZfL","d35633e9521906a7":"djJB7"}],"8qhE7":[function(require,module,exports) {
"use strict";
var Sugar = require("c78a34a8b4e33966"), getLeastOrMost = require("b0cb107043290c8");
Sugar.Object.defineInstanceAndStatic({
    "most": function(obj, all, map) {
        return getLeastOrMost(obj, all, map, true, true);
    }
});
module.exports = Sugar.Object.most;

},{"c78a34a8b4e33966":"dZZfL","b0cb107043290c8":"C26U2"}],"8mkPy":[function(require,module,exports) {
"use strict";
var Sugar = require("5f4019eab4d74e94"), objectNone = require("e7ec3d4b19066faa");
Sugar.Object.defineInstanceAndStatic({
    "none": function(obj, f) {
        return objectNone(obj, f);
    }
});
module.exports = Sugar.Object.none;

},{"5f4019eab4d74e94":"dZZfL","e7ec3d4b19066faa":"4Uafs"}],"4Uafs":[function(require,module,exports) {
"use strict";
var objectMatchers = require("bcaa1a4aa8b07b43");
var objectSome = objectMatchers.objectSome;
function objectNone(obj, f) {
    return !objectSome(obj, f);
}
module.exports = objectNone;

},{"bcaa1a4aa8b07b43":"9ySrD"}],"fIsKR":[function(require,module,exports) {
"use strict";
var Sugar = require("a693500c5b0a6abf"), objectReduce = require("b0f92d74a7248a69");
Sugar.Object.defineInstanceAndStatic({
    "reduce": function(obj, fn, init) {
        return objectReduce(obj, fn, init);
    }
});
module.exports = Sugar.Object.reduce;

},{"a693500c5b0a6abf":"dZZfL","b0f92d74a7248a69":"9CxEh"}],"9CxEh":[function(require,module,exports) {
"use strict";
var isDefined = require("3209ca582a4cd5fc"), coreUtilityAliases = require("30c9a51730d289d2");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectReduce(obj, fn, acc) {
    var init = isDefined(acc);
    forEachProperty(obj, function(val, key) {
        if (!init) {
            acc = val;
            init = true;
            return;
        }
        acc = fn(acc, val, key, obj);
    });
    return acc;
}
module.exports = objectReduce;

},{"3209ca582a4cd5fc":"4cOOJ","30c9a51730d289d2":"8ZxTV"}],"aycve":[function(require,module,exports) {
"use strict";
var Sugar = require("406fd7ddd7182bd5"), objectMatchers = require("e5e098f7022c1c8a");
var objectSome = objectMatchers.objectSome;
Sugar.Object.defineInstanceAndStatic({
    "some": objectSome
});
module.exports = Sugar.Object.some;

},{"406fd7ddd7182bd5":"dZZfL","e5e098f7022c1c8a":"9ySrD"}],"g3j35":[function(require,module,exports) {
"use strict";
var Sugar = require("696df950d36a9303"), sum = require("12f9fc702482a68a");
Sugar.Object.defineInstanceAndStatic({
    "sum": function(obj, map) {
        return sum(obj, map);
    }
});
module.exports = Sugar.Object.sum;

},{"696df950d36a9303":"dZZfL","12f9fc702482a68a":"dl8W9"}],"dl8W9":[function(require,module,exports) {
"use strict";
var enumerateWithMapping = require("3a6a2c5bb81a88d1");
function sum(obj, map) {
    var _$sum = 0;
    enumerateWithMapping(obj, map, function(val) {
        _$sum += val;
    });
    return _$sum;
}
module.exports = sum;

},{"3a6a2c5bb81a88d1":"7o6NV"}],"hUH9S":[function(require,module,exports) {
"use strict";
var Sugar = require("32cbadde6adce697"), average = require("83b2690f91e7cd59");
Sugar.Array.defineInstance({
    "average": function(arr, map) {
        return average(arr, map);
    }
});
module.exports = Sugar.Array.average;

},{"32cbadde6adce697":"dZZfL","83b2690f91e7cd59":"3ygqI"}],"1FUM4":[function(require,module,exports) {
"use strict";
var Sugar = require("3cc9168d659d7b20"), arrayCount = require("908ef95e6108fffc"), fixArgumentLength = require("a8845c43c9f1ff6f");
Sugar.Array.defineInstance({
    "count": fixArgumentLength(arrayCount)
});
module.exports = Sugar.Array.count;

},{"3cc9168d659d7b20":"dZZfL","908ef95e6108fffc":"5HmVu","a8845c43c9f1ff6f":"lHgf7"}],"5HmVu":[function(require,module,exports) {
"use strict";
var isUndefined = require("5e0960aacf85d02a"), enhancedMatcherMethods = require("ec26f94f562d95c4");
var enhancedFilter = enhancedMatcherMethods.enhancedFilter;
function arrayCount(arr, f) {
    if (isUndefined(f)) return arr.length;
    return enhancedFilter.apply(this, arguments).length;
}
module.exports = arrayCount;

},{"5e0960aacf85d02a":"6oRAa","ec26f94f562d95c4":"kzhGM"}],"kzhGM":[function(require,module,exports) {
"use strict";
var buildEnhancedMatching = require("f585626d8d1a6698");
module.exports = {
    enhancedFind: buildEnhancedMatching("find"),
    enhancedSome: buildEnhancedMatching("some"),
    enhancedEvery: buildEnhancedMatching("every"),
    enhancedFilter: buildEnhancedMatching("filter"),
    enhancedFindIndex: buildEnhancedMatching("findIndex")
};

},{"f585626d8d1a6698":"cNmWk"}],"cNmWk":[function(require,module,exports) {
"use strict";
var enhancedMatching = require("b1c93c6ce197a2c7"), wrapNativeArrayMethod = require("db907085a94c5587");
function buildEnhancedMatching(name) {
    return wrapNativeArrayMethod(name, enhancedMatching);
}
module.exports = buildEnhancedMatching;

},{"b1c93c6ce197a2c7":"9YaWM","db907085a94c5587":"7UgHe"}],"9YaWM":[function(require,module,exports) {
"use strict";
var getMatcher = require("a81772d143df159d"), classChecks = require("c14c9f2015fc9f83");
var isFunction = classChecks.isFunction;
function enhancedMatching(f) {
    var matcher;
    if (isFunction(f)) return f;
    matcher = getMatcher(f);
    return function(el, i, arr) {
        return matcher(el, i, arr);
    };
}
module.exports = enhancedMatching;

},{"a81772d143df159d":"fDwIk","c14c9f2015fc9f83":"MTXUY"}],"7UgHe":[function(require,module,exports) {
"use strict";
var assertArgument = require("6d8044e3c3fe5620");
function wrapNativeArrayMethod(methodName, wrapper) {
    var nativeFn = Array.prototype[methodName];
    return function(arr, f, context, argsLen) {
        var args = new Array(2);
        assertArgument(argsLen > 0);
        args[0] = wrapper(f, context);
        args[1] = context;
        return nativeFn.apply(arr, args);
    };
}
module.exports = wrapNativeArrayMethod;

},{"6d8044e3c3fe5620":"jMYT7"}],"jMYT7":[function(require,module,exports) {
"use strict";
function assertArgument(exists) {
    if (!exists) throw new TypeError("Argument required");
}
module.exports = assertArgument;

},{}],"1BnC9":[function(require,module,exports) {
"use strict";
var Sugar = require("3462f0033fa6d4bb"), ENHANCEMENTS_FLAG = require("d3c87a4ee831d00b"), ARRAY_ENHANCEMENTS_FLAG = require("d4dfb46b2a908038"), fixArgumentLength = require("2fe9566e0bf7eee7"), enhancedMatcherMethods = require("2a9aeb42ef3b87ed");
var enhancedEvery = enhancedMatcherMethods.enhancedEvery;
Sugar.Array.defineInstance({
    "every": fixArgumentLength(enhancedEvery)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.every;

},{"3462f0033fa6d4bb":"dZZfL","d3c87a4ee831d00b":"1fjNl","d4dfb46b2a908038":"7iq4z","2fe9566e0bf7eee7":"lHgf7","2a9aeb42ef3b87ed":"kzhGM"}],"7iq4z":[function(require,module,exports) {
"use strict";
module.exports = "enhanceArray";

},{}],"kHebJ":[function(require,module,exports) {
"use strict";
var Sugar = require("e7a9a71902ea09dc");
require("7d61c88dc7c37471");
module.exports = Sugar.Array.everyFromIndex;

},{"e7a9a71902ea09dc":"dZZfL","7d61c88dc7c37471":"dy7DC"}],"dy7DC":[function(require,module,exports) {
"use strict";
var buildFromIndexMethods = require("7e73f18aa5f87286");
buildFromIndexMethods();

},{"7e73f18aa5f87286":"5RIuI"}],"5RIuI":[function(require,module,exports) {
"use strict";
var forEach = require("92271c30674098f4"), spaceSplit = require("b23a39f37c73a202"), classChecks = require("d9a84aba6bc2a479"), mathAliases = require("16112713a0b99e5c"), assertArgument = require("88963d923b2efdaa"), enhancedMapping = require("b510e6887189d937"), namespaceAliases = require("e24cd23db0f367e3"), enhancedMatching = require("64c3c750e8c3d4e6"), getNormalizedIndex = require("add96fb4619ec90c"), coreUtilityAliases = require("f99628b87fbfed46"), methodDefineAliases = require("28dbdf3b512dca59");
var forEachProperty = coreUtilityAliases.forEachProperty, defineInstanceWithArguments = methodDefineAliases.defineInstanceWithArguments, sugarArray = namespaceAliases.sugarArray, min = mathAliases.min, max = mathAliases.max, isBoolean = classChecks.isBoolean;
function buildFromIndexMethods() {
    var methods = {
        "forEach": {
            base: forEachAsNative
        },
        "map": {
            wrapper: enhancedMapping
        },
        "some every": {
            wrapper: enhancedMatching
        },
        "findIndex": {
            wrapper: enhancedMatching,
            result: indexResult
        },
        "reduce": {
            apply: applyReduce
        },
        "filter find": {
            wrapper: enhancedMatching
        },
        "reduceRight": {
            apply: applyReduce,
            slice: sliceArrayFromRight,
            clamp: clampStartIndexFromRight
        }
    };
    forEachProperty(methods, function(opts, key) {
        forEach(spaceSplit(key), function(baseName) {
            var methodName = baseName + "FromIndex";
            var fn = createFromIndexWithOptions(baseName, opts);
            defineInstanceWithArguments(sugarArray, methodName, fn);
        });
    });
    function forEachAsNative(fn) {
        forEach(this, fn);
    }
    // Methods like filter and find have a direct association between the value
    // returned by the callback and the element of the current iteration. This
    // means that when looping, array elements must match the actual index for
    // which they are being called, so the array must be sliced. This is not the
    // case for methods like forEach and map, which either do not use return
    // values or use them in a way that simply getting the element at a shifted
    // index will not affect the final return value. However, these methods will
    // still fail on sparse arrays, so always slicing them here. For example, if
    // "forEachFromIndex" were to be called on [1,,2] from index 1, although the
    // actual index 1 would itself would be skipped, when the array loops back to
    // index 0, shifting it by adding 1 would result in the element for that
    // iteration being undefined. For shifting to work, all gaps in the array
    // between the actual index and the shifted index would have to be accounted
    // for. This is infeasible and is easily solved by simply slicing the actual
    // array instead so that gaps align. Note also that in the case of forEach,
    // we are using the internal function which handles sparse arrays in a way
    // that does not increment the index, and so is highly optimized compared to
    // the others here, which are simply going through the native implementation.
    function sliceArrayFromLeft(arr, startIndex, loop) {
        var result = arr;
        if (startIndex) {
            result = arr.slice(startIndex);
            if (loop) result = result.concat(arr.slice(0, startIndex));
        }
        return result;
    }
    // When iterating from the right, indexes are effectively shifted by 1.
    // For example, iterating from the right from index 2 in an array of 3
    // should also include the last element in the array. This matches the
    // "lastIndexOf" method which also iterates from the right.
    function sliceArrayFromRight(arr, startIndex, loop) {
        if (!loop) {
            startIndex += 1;
            arr = arr.slice(0, max(0, startIndex));
        }
        return arr;
    }
    function clampStartIndex(startIndex, len) {
        return min(len, max(0, startIndex));
    }
    // As indexes are shifted by 1 when starting from the right, clamping has to
    // go down to -1 to accommodate the full range of the sliced array.
    function clampStartIndexFromRight(startIndex, len) {
        return min(len, max(-1, startIndex));
    }
    function applyReduce(arr, startIndex, fn, context, len, loop) {
        return function(acc, val, i) {
            i = getNormalizedIndex(i + startIndex, len, loop);
            return fn.call(arr, acc, val, i, arr);
        };
    }
    function applyEach(arr, startIndex, fn, context, len, loop) {
        return function(el, i) {
            i = getNormalizedIndex(i + startIndex, len, loop);
            return fn.call(context, arr[i], i, arr);
        };
    }
    function indexResult(result, startIndex, len) {
        if (result !== -1) result = (result + startIndex) % len;
        return result;
    }
    function createFromIndexWithOptions(methodName, opts) {
        var baseFn = opts.base || Array.prototype[methodName], applyCallback = opts.apply || applyEach, sliceArray = opts.slice || sliceArrayFromLeft, clampIndex = opts.clamp || clampStartIndex, getResult = opts.result, wrapper = opts.wrapper;
        return function(arr, startIndex, args) {
            var callArgs = [], argIndex = 0, lastArg, result, len, loop, fn;
            len = arr.length;
            if (isBoolean(args[0])) loop = args[argIndex++];
            fn = args[argIndex++];
            lastArg = args[argIndex];
            if (startIndex < 0) startIndex += len;
            startIndex = clampIndex(startIndex, len);
            assertArgument(args.length);
            fn = wrapper ? wrapper(fn, lastArg) : fn;
            callArgs.push(applyCallback(arr, startIndex, fn, lastArg, len, loop));
            if (lastArg) callArgs.push(lastArg);
            result = baseFn.apply(sliceArray(arr, startIndex, loop), callArgs);
            if (getResult) result = getResult(result, startIndex, len);
            return result;
        };
    }
}
module.exports = buildFromIndexMethods;

},{"92271c30674098f4":"JJnv7","b23a39f37c73a202":"cGrLA","d9a84aba6bc2a479":"MTXUY","16112713a0b99e5c":"f1S5P","88963d923b2efdaa":"jMYT7","b510e6887189d937":"7mDXR","e24cd23db0f367e3":"4onj1","64c3c750e8c3d4e6":"9YaWM","add96fb4619ec90c":"66puZ","f99628b87fbfed46":"8ZxTV","28dbdf3b512dca59":"c4yD8"}],"7mDXR":[function(require,module,exports) {
"use strict";
var classChecks = require("1ec2ccfde9e32fce"), mapWithShortcuts = require("7a03a052776f41cc");
var isFunction = classChecks.isFunction;
function enhancedMapping(map, context) {
    if (isFunction(map)) return map;
    else if (map) return function(el, i, arr) {
        return mapWithShortcuts(el, map, context, [
            el,
            i,
            arr
        ]);
    };
}
module.exports = enhancedMapping;

},{"1ec2ccfde9e32fce":"MTXUY","7a03a052776f41cc":"2Ykp4"}],"e73qH":[function(require,module,exports) {
"use strict";
var Sugar = require("616fa565d83a6778"), ENHANCEMENTS_FLAG = require("7f8edc175dde6c92"), ARRAY_ENHANCEMENTS_FLAG = require("44abbe66e2cdb595"), fixArgumentLength = require("d667a83d8a1ff734"), enhancedMatcherMethods = require("4f8868ca1e165c23");
var enhancedFilter = enhancedMatcherMethods.enhancedFilter;
Sugar.Array.defineInstance({
    "filter": fixArgumentLength(enhancedFilter)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.filter;

},{"616fa565d83a6778":"dZZfL","7f8edc175dde6c92":"1fjNl","44abbe66e2cdb595":"7iq4z","d667a83d8a1ff734":"lHgf7","4f8868ca1e165c23":"kzhGM"}],"hWJV8":[function(require,module,exports) {
"use strict";
var Sugar = require("76ce3cdd214b9782");
require("6cc983f6cc21d49d");
module.exports = Sugar.Array.filterFromIndex;

},{"76ce3cdd214b9782":"dZZfL","6cc983f6cc21d49d":"dy7DC"}],"5wnzN":[function(require,module,exports) {
"use strict";
var Sugar = require("5c6851e5b34e6126"), ENHANCEMENTS_FLAG = require("d7044a7b3176bff1"), ARRAY_ENHANCEMENTS_FLAG = require("5e1ee8e844c8cd17"), fixArgumentLength = require("82085a1cdf8fc9cc"), enhancedMatcherMethods = require("d5f705403e67204f");
var enhancedFind = enhancedMatcherMethods.enhancedFind;
Sugar.Array.defineInstance({
    "find": fixArgumentLength(enhancedFind)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.find;

},{"5c6851e5b34e6126":"dZZfL","d7044a7b3176bff1":"1fjNl","5e1ee8e844c8cd17":"7iq4z","82085a1cdf8fc9cc":"lHgf7","d5f705403e67204f":"kzhGM"}],"1vQhv":[function(require,module,exports) {
"use strict";
var Sugar = require("3790e81c68b32167");
require("53a3f46f615c3fbe");
module.exports = Sugar.Array.findFromIndex;

},{"3790e81c68b32167":"dZZfL","53a3f46f615c3fbe":"dy7DC"}],"4Yfr4":[function(require,module,exports) {
"use strict";
var Sugar = require("eeaa37fd0dae8e05"), ENHANCEMENTS_FLAG = require("459ad528994b218f"), ARRAY_ENHANCEMENTS_FLAG = require("408dd792ee37267c"), fixArgumentLength = require("5da0488e2502c5b8"), enhancedMatcherMethods = require("f6a6b852996cbbc1");
var enhancedFindIndex = enhancedMatcherMethods.enhancedFindIndex;
Sugar.Array.defineInstance({
    "findIndex": fixArgumentLength(enhancedFindIndex)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.findIndex;

},{"eeaa37fd0dae8e05":"dZZfL","459ad528994b218f":"1fjNl","408dd792ee37267c":"7iq4z","5da0488e2502c5b8":"lHgf7","f6a6b852996cbbc1":"kzhGM"}],"l7Erm":[function(require,module,exports) {
"use strict";
var Sugar = require("1d58100f7acbf178");
require("e18201bbd18909e8");
module.exports = Sugar.Array.findIndexFromIndex;

},{"1d58100f7acbf178":"dZZfL","e18201bbd18909e8":"dy7DC"}],"EJ8yQ":[function(require,module,exports) {
"use strict";
var Sugar = require("7e31b4c34747c8e4");
require("f2f7b154aa2c469e");
module.exports = Sugar.Array.forEachFromIndex;

},{"7e31b4c34747c8e4":"dZZfL","f2f7b154aa2c469e":"dy7DC"}],"hANnw":[function(require,module,exports) {
"use strict";
var Sugar = require("fd8d8d2a0007f37c"), getLeastOrMost = require("8ee200ec7472e2b3");
Sugar.Array.defineInstance({
    "least": function(arr, all, map) {
        return getLeastOrMost(arr, all, map);
    }
});
module.exports = Sugar.Array.least;

},{"fd8d8d2a0007f37c":"dZZfL","8ee200ec7472e2b3":"C26U2"}],"85PRW":[function(require,module,exports) {
"use strict";
var Sugar = require("4a6b738e21d14382"), ENHANCEMENTS_FLAG = require("ed613ddb5f9a96d6"), ARRAY_ENHANCEMENTS_FLAG = require("3a4abf9e3bf0f75e"), enhancedMap = require("8ea6d6fddc862fbc"), fixArgumentLength = require("16f8772801ab12e1");
Sugar.Array.defineInstance({
    "map": fixArgumentLength(enhancedMap)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.map;

},{"4a6b738e21d14382":"dZZfL","ed613ddb5f9a96d6":"1fjNl","3a4abf9e3bf0f75e":"7iq4z","8ea6d6fddc862fbc":"43MFO","16f8772801ab12e1":"lHgf7"}],"43MFO":[function(require,module,exports) {
"use strict";
var buildEnhancedMapping = require("d97ca689262ad618");
module.exports = buildEnhancedMapping("map");

},{"d97ca689262ad618":"cEBVV"}],"cEBVV":[function(require,module,exports) {
"use strict";
var enhancedMapping = require("ba56b8d789b695d8"), wrapNativeArrayMethod = require("d1fcdd31c824ceb1");
function buildEnhancedMapping(name) {
    return wrapNativeArrayMethod(name, enhancedMapping);
}
module.exports = buildEnhancedMapping;

},{"ba56b8d789b695d8":"7mDXR","d1fcdd31c824ceb1":"7UgHe"}],"jyyZD":[function(require,module,exports) {
"use strict";
var Sugar = require("9cd17d7a9beea302");
require("6cb89cb758a20383");
module.exports = Sugar.Array.mapFromIndex;

},{"9cd17d7a9beea302":"dZZfL","6cb89cb758a20383":"dy7DC"}],"bWDuy":[function(require,module,exports) {
"use strict";
var Sugar = require("1ab6ae393988dea5"), getMinOrMax = require("647f62985b99c6ff");
Sugar.Array.defineInstance({
    "max": function(arr, all, map) {
        return getMinOrMax(arr, all, map, true);
    }
});
module.exports = Sugar.Array.max;

},{"1ab6ae393988dea5":"dZZfL","647f62985b99c6ff":"djJB7"}],"iRZQ0":[function(require,module,exports) {
"use strict";
var Sugar = require("bb7efc3fa89b98d2"), median = require("6edc4fc0f31f5d95");
Sugar.Array.defineInstance({
    "median": function(arr, map) {
        return median(arr, map);
    }
});
module.exports = Sugar.Array.median;

},{"bb7efc3fa89b98d2":"dZZfL","6edc4fc0f31f5d95":"eO57G"}],"k7Fbf":[function(require,module,exports) {
"use strict";
var Sugar = require("841916b95e5b35e9"), getMinOrMax = require("d6f7edc9d9438b4a");
Sugar.Array.defineInstance({
    "min": function(arr, all, map) {
        return getMinOrMax(arr, all, map);
    }
});
module.exports = Sugar.Array.min;

},{"841916b95e5b35e9":"dZZfL","d6f7edc9d9438b4a":"djJB7"}],"72Xou":[function(require,module,exports) {
"use strict";
var Sugar = require("c0521b2d2fb58e8d"), getLeastOrMost = require("b9566ce25eb14609");
Sugar.Array.defineInstance({
    "most": function(arr, all, map) {
        return getLeastOrMost(arr, all, map, true);
    }
});
module.exports = Sugar.Array.most;

},{"c0521b2d2fb58e8d":"dZZfL","b9566ce25eb14609":"C26U2"}],"fa1Ey":[function(require,module,exports) {
"use strict";
var Sugar = require("6bc3fcab12577891"), arrayNone = require("eb23b46246bd9bfa"), fixArgumentLength = require("5e13bb97a9756080");
Sugar.Array.defineInstance({
    "none": fixArgumentLength(arrayNone)
});
module.exports = Sugar.Array.none;

},{"6bc3fcab12577891":"dZZfL","eb23b46246bd9bfa":"53tRs","5e13bb97a9756080":"lHgf7"}],"53tRs":[function(require,module,exports) {
"use strict";
var enhancedMatcherMethods = require("d992d4b8a45c5017");
var enhancedSome = enhancedMatcherMethods.enhancedSome;
function arrayNone() {
    return !enhancedSome.apply(this, arguments);
}
module.exports = arrayNone;

},{"d992d4b8a45c5017":"kzhGM"}],"ubIhS":[function(require,module,exports) {
"use strict";
var Sugar = require("ee8260cdfd646ca3");
require("bf63753c0150a7f5");
module.exports = Sugar.Array.reduceFromIndex;

},{"ee8260cdfd646ca3":"dZZfL","bf63753c0150a7f5":"dy7DC"}],"lhSw7":[function(require,module,exports) {
"use strict";
var Sugar = require("ef58459b72fe39ce");
require("cb49c2a270ec12ab");
module.exports = Sugar.Array.reduceRightFromIndex;

},{"ef58459b72fe39ce":"dZZfL","cb49c2a270ec12ab":"dy7DC"}],"97R38":[function(require,module,exports) {
"use strict";
var Sugar = require("1289a7d55ec2ff96"), ENHANCEMENTS_FLAG = require("3f513a6f647f7ef1"), ARRAY_ENHANCEMENTS_FLAG = require("a7ff2f4e2600b457"), fixArgumentLength = require("947c5081afa0fdfb"), enhancedMatcherMethods = require("42baed114e6392e1");
var enhancedSome = enhancedMatcherMethods.enhancedSome;
Sugar.Array.defineInstance({
    "some": fixArgumentLength(enhancedSome)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.some;

},{"1289a7d55ec2ff96":"dZZfL","3f513a6f647f7ef1":"1fjNl","a7ff2f4e2600b457":"7iq4z","947c5081afa0fdfb":"lHgf7","42baed114e6392e1":"kzhGM"}],"2T9qG":[function(require,module,exports) {
"use strict";
var Sugar = require("fd8187d3a3584176");
require("d6c0b707e7c8fcb2");
module.exports = Sugar.Array.someFromIndex;

},{"fd8187d3a3584176":"dZZfL","d6c0b707e7c8fcb2":"dy7DC"}],"5788v":[function(require,module,exports) {
"use strict";
var Sugar = require("2d508b7954735a9"), sum = require("f80116bc258af18");
Sugar.Array.defineInstance({
    "sum": function(arr, map) {
        return sum(arr, map);
    }
});
module.exports = Sugar.Array.sum;

},{"2d508b7954735a9":"dZZfL","f80116bc258af18":"dl8W9"}],"77ZcU":[function(require,module,exports) {
"use strict";
// Static Methods
require("ad32480af3faf741");
require("52902a51c53c44ca");
require("4805eba1b6f37086");
require("d63bc5a6650a355");
require("d97ce8fc806b5e44");
require("15ebc05c9f5e0977");
require("82e9a1183e35f332");
require("2278fcc77641f8ed");
require("f0d3725de3d0652e");
require("48abe3ae65405218");
require("d3c490b18629b7b2");
require("3a8945729f97dc56");
require("f76d0d2d5926c210");
require("15dfcc338841dcad");
require("65a362e6b6202842");
require("40608d3c43bd1f57");
require("a512b3342b6e0634");
require("ec88686ac7882ffe");
require("e203695970fa9b60");
require("6e5cfb48f98fe76a");
require("1e238920fe639029");
require("63b5189facdce1f9");
require("6c15563161c3b4e2");
require("770a0b3c35252d24");
require("fd486e73de08bc15");
require("d280278526ed4066");
require("2b9ec6bdfc4fa90c");
require("e4856f81a29f1088");
require("3955fe8a8a89a6aa");
require("fc61fb3ddfa94d80");
require("e85985ba07724773");
require("626af214144e3733");
require("65de02c141a10f04");
require("e166e9ff886bd016");
require("74043550005a9ce");
// Instance Methods
require("530e290d3f46edba");
module.exports = require("abc3e077bd90574");

},{"ad32480af3faf741":"dJtZi","52902a51c53c44ca":"2vAVG","4805eba1b6f37086":"k0doH","d63bc5a6650a355":"lRpPX","d97ce8fc806b5e44":"ev76C","15ebc05c9f5e0977":"9c34e","82e9a1183e35f332":"d6ApH","2278fcc77641f8ed":"fBGK6","f0d3725de3d0652e":"8tkhG","48abe3ae65405218":"3nSCh","d3c490b18629b7b2":"hr4g6","3a8945729f97dc56":"7MeNR","f76d0d2d5926c210":"1TdNV","15dfcc338841dcad":"7aYDy","65a362e6b6202842":"SQ8Pc","40608d3c43bd1f57":"71DXI","a512b3342b6e0634":"4J1Uk","ec88686ac7882ffe":"8KvQF","e203695970fa9b60":"cpAVs","6e5cfb48f98fe76a":"24Dt0","1e238920fe639029":"9Iu8R","63b5189facdce1f9":"3sVIw","6c15563161c3b4e2":"fiv4D","770a0b3c35252d24":"i1vZe","fd486e73de08bc15":"btH4A","d280278526ed4066":"jrhzR","2b9ec6bdfc4fa90c":"9JR47","e4856f81a29f1088":"1bxz0","3955fe8a8a89a6aa":"23F3M","fc61fb3ddfa94d80":"16Do0","e85985ba07724773":"lYlbu","626af214144e3733":"9Xu8Z","65de02c141a10f04":"7xBOo","e166e9ff886bd016":"ePvDt","74043550005a9ce":"cduv5","530e290d3f46edba":"l0Yqg","abc3e077bd90574":"dZZfL"}],"dJtZi":[function(require,module,exports) {
"use strict";
var Sugar = require("dd83cf6b66712cb8"), clone = require("a36079fa3bfbcd97"), mergeWithOptions = require("f0858c6136c638c2");
Sugar.Object.defineInstanceAndStatic({
    "add": function(obj1, obj2, opts) {
        return mergeWithOptions(clone(obj1), obj2, opts);
    }
});
module.exports = Sugar.Object.add;

},{"dd83cf6b66712cb8":"dZZfL","a36079fa3bfbcd97":"6OXT9","f0858c6136c638c2":"1X6rH"}],"6OXT9":[function(require,module,exports) {
"use strict";
var objectMerge = require("7b945d90e145659f"), getNewObjectForMerge = require("3f2031a23aeb679b");
function clone(source, deep) {
    var target = getNewObjectForMerge(source);
    return objectMerge(target, source, deep, true, true, true);
}
module.exports = clone;

},{"7b945d90e145659f":"imZ5q","3f2031a23aeb679b":"4q5JO"}],"imZ5q":[function(require,module,exports) {
"use strict";
var Sugar = require("fb7a3c1db07d9ec4"), isDefined = require("3715410b58484f88"), classChecks = require("f27f36c13617e97d"), isPrimitive = require("dae678d940c6ed4b"), isUndefined = require("d62b4a0f89f9e93e"), isObjectType = require("606dbc5830cddaa9"), coreUtilityAliases = require("796679a29eef8c73"), getOwnPropertyNames = require("99273630fa173997"), getNewObjectForMerge = require("dcd354541eba03a9"), iterateOverProperties = require("da5c0bbb3ae0c2ad"), coercePrimitiveToObject = require("95b8cb6865569de3"), mergeByPropertyDescriptor = require("2cbdbde8645e05cf");
var isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction, getOwn = coreUtilityAliases.getOwn;
function objectMerge(target, source, deep, resolve, hidden, descriptor) {
    var resolveByFunction = isFunction(resolve), resolveConflicts = resolve !== false;
    if (isUndefined(target)) target = getNewObjectForMerge(source);
    else if (resolveConflicts && isDate(target) && isDate(source)) // A date's timestamp is a property that can only be reached through its
    // methods, so actively set it up front if both are dates.
    target.setTime(source.getTime());
    if (isPrimitive(target)) // Will not merge into a primitive type, so simply override.
    return source;
    // If the source object is a primitive
    // type then coerce it into an object.
    if (isPrimitive(source)) source = coercePrimitiveToObject(source);
    iterateOverProperties(hidden, source, function(val, key) {
        var sourceVal, targetVal, resolved, goDeep, result;
        sourceVal = source[key];
        // We are iterating over properties of the source, so hasOwnProperty on
        // it is guaranteed to always be true. However, the target may happen to
        // have properties in its prototype chain that should not be considered
        // as conflicts.
        targetVal = getOwn(target, key);
        if (resolveByFunction) {
            result = resolve(key, targetVal, sourceVal, target, source);
            if (isUndefined(result)) // Result is undefined so do not merge this property.
            return;
            else if (isDefined(result) && result !== Sugar) {
                // If the source returns anything except undefined, then the conflict
                // has been resolved, so don't continue traversing into the object. If
                // the returned value is the Sugar global object, then allowing Sugar
                // to resolve the conflict, so continue on.
                sourceVal = result;
                resolved = true;
            }
        } else if (isUndefined(sourceVal)) // Will not merge undefined.
        return;
        // Regex properties are read-only, so intentionally disallowing deep
        // merging for now. Instead merge by reference even if deep.
        goDeep = !resolved && deep && isObjectType(sourceVal) && !isRegExp(sourceVal);
        if (!goDeep && !resolveConflicts && isDefined(targetVal)) return;
        if (goDeep) sourceVal = objectMerge(targetVal, sourceVal, deep, resolve, hidden, descriptor);
        // getOwnPropertyNames is standing in as
        // a test for property descriptor support
        if (getOwnPropertyNames && descriptor) mergeByPropertyDescriptor(target, source, key, sourceVal);
        else target[key] = sourceVal;
    });
    return target;
}
module.exports = objectMerge;

},{"fb7a3c1db07d9ec4":"dZZfL","3715410b58484f88":"4cOOJ","f27f36c13617e97d":"MTXUY","dae678d940c6ed4b":"j6hv6","d62b4a0f89f9e93e":"6oRAa","606dbc5830cddaa9":"1dImj","796679a29eef8c73":"8ZxTV","99273630fa173997":"728D9","dcd354541eba03a9":"4q5JO","da5c0bbb3ae0c2ad":"lOulJ","95b8cb6865569de3":"dhfEN","2cbdbde8645e05cf":"2J2aj"}],"728D9":[function(require,module,exports) {
"use strict";
module.exports = Object.getOwnPropertyNames;

},{}],"4q5JO":[function(require,module,exports) {
"use strict";
var classChecks = require("b3f81914b1a77a76"), isPrimitive = require("fa16f98a456e3f2"), isPlainObject = require("5ef78aa41fb04b87"), getRegExpFlags = require("f6c5a70122304e7a"), coreUtilityAliases = require("a220007217d372f2");
var classToString = coreUtilityAliases.classToString, isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isArray = classChecks.isArray;
function getNewObjectForMerge(source) {
    var klass = classToString(source);
    // Primitive types, dates, and regexes have no "empty" state. If they exist
    // at all, then they have an associated value. As we are only creating new
    // objects when they don't exist in the target, these values can come alone
    // for the ride when created.
    if (isArray(source, klass)) return [];
    else if (isPlainObject(source, klass)) return {};
    else if (isDate(source, klass)) return new Date(source.getTime());
    else if (isRegExp(source, klass)) return RegExp(source.source, getRegExpFlags(source));
    else if (isPrimitive(source && source.valueOf())) return source;
    // If the object is not of a known type, then simply merging its
    // properties into a plain object will result in something different
    // (it will not respond to instanceof operator etc). Similarly we don't
    // want to call a constructor here as we can't know for sure what the
    // original constructor was called with (Events etc), so throw an
    // error here instead. Non-standard types can be handled if either they
    // already exist and simply have their properties merged, if the merge
    // is not deep so their references will simply be copied over, or if a
    // resolve function is used to assist the merge.
    throw new TypeError("Must be a basic data type");
}
module.exports = getNewObjectForMerge;

},{"b3f81914b1a77a76":"MTXUY","fa16f98a456e3f2":"j6hv6","5ef78aa41fb04b87":"dxNeT","f6c5a70122304e7a":"8qWd6","a220007217d372f2":"8ZxTV"}],"lOulJ":[function(require,module,exports) {
"use strict";
var iterateOverKeys = require("f86ac81bbf5ca864"), coreUtilityAliases = require("9c12d3fc288a7872"), getOwnPropertyNames = require("efc0d470043a89c1"), getOwnPropertySymbols = require("ac923c081b6cc3d7");
var forEachProperty = coreUtilityAliases.forEachProperty;
function iterateOverProperties(hidden, obj, fn) {
    if (getOwnPropertyNames && hidden) iterateOverKeys(getOwnPropertyNames, obj, fn, hidden);
    else forEachProperty(obj, fn);
    if (getOwnPropertySymbols) iterateOverKeys(getOwnPropertySymbols, obj, fn, hidden);
}
module.exports = iterateOverProperties;

},{"f86ac81bbf5ca864":"koKQI","9c12d3fc288a7872":"8ZxTV","efc0d470043a89c1":"728D9","ac923c081b6cc3d7":"ciu6r"}],"koKQI":[function(require,module,exports) {
"use strict";
var getOwnPropertyDescriptor = require("568f2b7d44e8d92e");
function iterateOverKeys(getFn, obj, fn, hidden) {
    var keys = getFn(obj), desc;
    for(var i = 0, key; key = keys[i]; i++){
        desc = getOwnPropertyDescriptor(obj, key);
        if (desc.enumerable || hidden) fn(obj[key], key);
    }
}
module.exports = iterateOverKeys;

},{"568f2b7d44e8d92e":"eoUkA"}],"eoUkA":[function(require,module,exports) {
"use strict";
module.exports = Object.getOwnPropertyDescriptor;

},{}],"ciu6r":[function(require,module,exports) {
"use strict";
module.exports = Object.getOwnPropertySymbols;

},{}],"dhfEN":[function(require,module,exports) {
"use strict";
var NO_KEYS_IN_STRING_OBJECTS = require("ff86c0a0b673641c"), isPrimitive = require("7b8b5f40db0ef400"), classChecks = require("e3edcaa1c4949aeb"), forceStringCoercion = require("a5fb54a316e5e75");
var isString = classChecks.isString;
function coercePrimitiveToObject(obj) {
    if (isPrimitive(obj)) obj = Object(obj);
    // istanbul ignore next
    if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) forceStringCoercion(obj);
    return obj;
}
module.exports = coercePrimitiveToObject;

},{"ff86c0a0b673641c":"8xb9P","7b8b5f40db0ef400":"j6hv6","e3edcaa1c4949aeb":"MTXUY","a5fb54a316e5e75":"ecIMq"}],"8xb9P":[function(require,module,exports) {
"use strict";
module.exports = !("0" in Object("a"));

},{}],"ecIMq":[function(require,module,exports) {
"use strict";
function forceStringCoercion(obj) {
    var i = 0, chr;
    while(chr = obj.charAt(i))obj[i++] = chr;
}
module.exports = forceStringCoercion;

},{}],"2J2aj":[function(require,module,exports) {
"use strict";
var isDefined = require("8112f04b39d1c6d1"), coreUtilityAliases = require("ef304e8f27c0c6be"), getOwnPropertyDescriptor = require("337db02707c17d43");
var defineProperty = coreUtilityAliases.defineProperty;
function mergeByPropertyDescriptor(target, source, prop, sourceVal) {
    var descriptor = getOwnPropertyDescriptor(source, prop);
    if (isDefined(descriptor.value)) descriptor.value = sourceVal;
    defineProperty(target, prop, descriptor);
}
module.exports = mergeByPropertyDescriptor;

},{"8112f04b39d1c6d1":"4cOOJ","ef304e8f27c0c6be":"8ZxTV","337db02707c17d43":"eoUkA"}],"1X6rH":[function(require,module,exports) {
"use strict";
var objectMerge = require("271a76c9471044d3");
function mergeWithOptions(target, source, opts) {
    opts = opts || {};
    return objectMerge(target, source, opts.deep, opts.resolve, opts.hidden, opts.descriptor);
}
module.exports = mergeWithOptions;

},{"271a76c9471044d3":"imZ5q"}],"2vAVG":[function(require,module,exports) {
"use strict";
var Sugar = require("1d09f4f74a556073"), clone = require("5b6e1c6281f12562"), mergeAll = require("1a1ce346a685d4bf");
Sugar.Object.defineInstanceAndStatic({
    "addAll": function(obj, sources, opts) {
        return mergeAll(clone(obj), sources, opts);
    }
});
module.exports = Sugar.Object.addAll;

},{"1d09f4f74a556073":"dZZfL","5b6e1c6281f12562":"6OXT9","1a1ce346a685d4bf":"l5OSu"}],"l5OSu":[function(require,module,exports) {
"use strict";
var forEach = require("7406219b2dd18f3f"), classChecks = require("50d97a1bcf592756"), mergeWithOptions = require("eba7863439d8d5a1");
var isArray = classChecks.isArray;
function mergeAll(target, sources, opts) {
    if (!isArray(sources)) sources = [
        sources
    ];
    forEach(sources, function(source) {
        return mergeWithOptions(target, source, opts);
    });
    return target;
}
module.exports = mergeAll;

},{"7406219b2dd18f3f":"JJnv7","50d97a1bcf592756":"MTXUY","eba7863439d8d5a1":"1X6rH"}],"k0doH":[function(require,module,exports) {
"use strict";
var Sugar = require("fb931fda990e045"), clone = require("60a8d3fbab615c87");
Sugar.Object.defineInstanceAndStatic({
    "clone": function(obj, deep) {
        return clone(obj, deep);
    }
});
module.exports = Sugar.Object.clone;

},{"fb931fda990e045":"dZZfL","60a8d3fbab615c87":"6OXT9"}],"lRpPX":[function(require,module,exports) {
"use strict";
var Sugar = require("6e2252274315dd9c"), defaults = require("df5cc70a0f795c59");
Sugar.Object.defineInstanceAndStatic({
    "defaults": function(target, sources, opts) {
        return defaults(target, sources, opts);
    }
});
module.exports = Sugar.Object.defaults;

},{"6e2252274315dd9c":"dZZfL","df5cc70a0f795c59":"jkOXx"}],"jkOXx":[function(require,module,exports) {
"use strict";
var mergeAll = require("8582f0301f50ca4e");
function defaults(target, sources, opts) {
    opts = opts || {};
    opts.resolve = opts.resolve || false;
    return mergeAll(target, sources, opts);
}
module.exports = defaults;

},{"8582f0301f50ca4e":"l5OSu"}],"ev76C":[function(require,module,exports) {
"use strict";
var Sugar = require("917817c8098ca80"), objectExclude = require("fe86dd075dcd7396");
Sugar.Object.defineInstanceAndStatic({
    "exclude": function(obj, f) {
        return objectExclude(obj, f);
    }
});
module.exports = Sugar.Object.exclude;

},{"917817c8098ca80":"dZZfL","fe86dd075dcd7396":"k338L"}],"k338L":[function(require,module,exports) {
"use strict";
var getMatcher = require("94dc56ad48911737"), coreUtilityAliases = require("4a231661508ad26d");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectExclude(obj, f) {
    var result = {};
    var matcher = getMatcher(f);
    forEachProperty(obj, function(val, key) {
        if (!matcher(val, key, obj)) result[key] = val;
    });
    return result;
}
module.exports = objectExclude;

},{"94dc56ad48911737":"fDwIk","4a231661508ad26d":"8ZxTV"}],"9c34e":[function(require,module,exports) {
"use strict";
var Sugar = require("8fc951b6ad4cde5a"), fromQueryStringWithOptions = require("16ba9fa4b5b2f0b3");
Sugar.Object.defineStatic({
    "fromQueryString": function(obj, options) {
        return fromQueryStringWithOptions(obj, options);
    }
});
module.exports = Sugar.Object.fromQueryString;

},{"8fc951b6ad4cde5a":"dZZfL","16ba9fa4b5b2f0b3":"c6zwq"}],"c6zwq":[function(require,module,exports) {
"use strict";
var forEach = require("837e91fdc6ab57eb"), parseQueryComponent = require("bb992b828600dd39");
function fromQueryStringWithOptions(obj, opts) {
    var str = String(obj || "").replace(/^.*?\?/, ""), result = {}, auto;
    opts = opts || {};
    if (str) forEach(str.split("&"), function(p) {
        var split = p.split("=");
        var key = decodeURIComponent(split[0]);
        var val = split.length === 2 ? decodeURIComponent(split[1]) : "";
        auto = opts.auto !== false;
        parseQueryComponent(result, key, val, opts.deep, auto, opts.separator, opts.transform);
    });
    return result;
}
module.exports = fromQueryStringWithOptions;

},{"837e91fdc6ab57eb":"JJnv7","bb992b828600dd39":"9qEPp"}],"9qEPp":[function(require,module,exports) {
"use strict";
var DEEP_QUERY_STRING_REG = require("f83432691fb7b6d0"), setQueryProperty = require("59f297315c15d19d"), mapQuerySeparatorToKeys = require("fc9441a24c7487e"), parseDeepQueryComponent = require("47716e6bbe74c3fd");
function parseQueryComponent(obj, key, val, deep, auto, separator, transform) {
    var match;
    if (separator) {
        key = mapQuerySeparatorToKeys(key, separator);
        deep = true;
    }
    if (deep === true && (match = key.match(DEEP_QUERY_STRING_REG))) parseDeepQueryComponent(obj, match, val, deep, auto, separator, transform);
    else setQueryProperty(obj, key, val, auto, transform);
}
module.exports = parseQueryComponent;

},{"f83432691fb7b6d0":"j98Qc","59f297315c15d19d":"jQIGg","fc9441a24c7487e":"dMUd4","47716e6bbe74c3fd":"fXYHP"}],"j98Qc":[function(require,module,exports) {
"use strict";
module.exports = /^(.+?)(\[.*\])$/;

},{}],"jQIGg":[function(require,module,exports) {
"use strict";
var isDefined = require("453ecc3c43dbe9f7"), getQueryValueAuto = require("51fd8bb0efc4da62");
function setQueryProperty(obj, key, val, auto, transform) {
    var fnValue;
    if (transform) fnValue = transform(val, key, obj);
    if (isDefined(fnValue)) val = fnValue;
    else if (auto) val = getQueryValueAuto(obj, key, val);
    obj[key] = val;
}
module.exports = setQueryProperty;

},{"453ecc3c43dbe9f7":"4cOOJ","51fd8bb0efc4da62":"kOBQA"}],"kOBQA":[function(require,module,exports) {
"use strict";
var classChecks = require("4c385b6fe0acf246"), stringIsDecimal = require("edb98dfc433b144"), coreUtilityAliases = require("1b74e3d6f0399725");
var getOwn = coreUtilityAliases.getOwn, isArray = classChecks.isArray;
function getQueryValueAuto(obj, key, val) {
    if (!val) return null;
    else if (val === "true") return true;
    else if (val === "false") return false;
    var num = +val;
    if (!isNaN(num) && stringIsDecimal(val)) return num;
    var existing = getOwn(obj, key);
    if (val && existing) return isArray(existing) ? existing.concat(val) : [
        existing,
        val
    ];
    return val;
}
module.exports = getQueryValueAuto;

},{"4c385b6fe0acf246":"MTXUY","edb98dfc433b144":"iC7zD","1b74e3d6f0399725":"8ZxTV"}],"iC7zD":[function(require,module,exports) {
"use strict";
var NON_DECIMAL_REG = require("df316f9d25cf1cf");
function stringIsDecimal(str) {
    return str !== "" && !NON_DECIMAL_REG.test(str);
}
module.exports = stringIsDecimal;

},{"df316f9d25cf1cf":"hmByd"}],"hmByd":[function(require,module,exports) {
"use strict";
module.exports = /[^\d.-]/;

},{}],"dMUd4":[function(require,module,exports) {
"use strict";
function mapQuerySeparatorToKeys(key, separator) {
    var split = key.split(separator), result = split[0];
    for(var i = 1, len = split.length; i < len; i++)result += "[" + split[i] + "]";
    return result;
}
module.exports = mapQuerySeparatorToKeys;

},{}],"fXYHP":[function(require,module,exports) {
"use strict";
var forEach = require("dcf6f151a3311cb9"), setQueryProperty = require("2003afcb78f25fac"), coreUtilityAliases = require("8816562658c172f7");
var hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn;
function parseDeepQueryComponent(obj, match, val, deep, auto, separator, transform) {
    var key = match[1];
    var inner = match[2].slice(1, -1).split("][");
    forEach(inner, function(k) {
        if (!hasOwn(obj, key)) obj[key] = k ? {} : [];
        obj = getOwn(obj, key);
        key = k ? k : obj.length.toString();
    });
    setQueryProperty(obj, key, val, auto, transform);
}
module.exports = parseDeepQueryComponent;

},{"dcf6f151a3311cb9":"JJnv7","2003afcb78f25fac":"jQIGg","8816562658c172f7":"8ZxTV"}],"d6ApH":[function(require,module,exports) {
"use strict";
var Sugar = require("ad8f54135a0b03e0"), deepGetProperty = require("5125fcd004bd75aa");
Sugar.Object.defineInstanceAndStatic({
    "get": function(obj, key, any) {
        return deepGetProperty(obj, key, any);
    }
});
module.exports = Sugar.Object.get;

},{"ad8f54135a0b03e0":"dZZfL","5125fcd004bd75aa":"4GhMu"}],"fBGK6":[function(require,module,exports) {
"use strict";
var Sugar = require("7f0d673f9a91e167"), deepHasProperty = require("7e1f2cc681fde988");
Sugar.Object.defineInstanceAndStatic({
    "has": function(obj, key, any) {
        return deepHasProperty(obj, key, any);
    }
});
module.exports = Sugar.Object.has;

},{"7f0d673f9a91e167":"dZZfL","7e1f2cc681fde988":"l44nO"}],"l44nO":[function(require,module,exports) {
"use strict";
var handleDeepProperty = require("1cc263e7f17c6d74");
function deepHasProperty(obj, key, any) {
    return handleDeepProperty(obj, key, any, true);
}
module.exports = deepHasProperty;

},{"1cc263e7f17c6d74":"G37fv"}],"8tkhG":[function(require,module,exports) {
"use strict";
var Sugar = require("5606ed9f4c495aca"), objectIntersectOrSubtract = require("31735df20f4c899f");
Sugar.Object.defineInstanceAndStatic({
    "intersect": function(obj1, obj2) {
        return objectIntersectOrSubtract(obj1, obj2, false);
    }
});
module.exports = Sugar.Object.intersect;

},{"5606ed9f4c495aca":"dZZfL","31735df20f4c899f":"4z4yr"}],"4z4yr":[function(require,module,exports) {
"use strict";
var isEqual = require("664da2f03f9ce346"), objectMerge = require("727263ff85c4d540"), isObjectType = require("71d482242d386109"), coercePrimitiveToObject = require("4b9b44efcc4a1544");
function objectIntersectOrSubtract(obj1, obj2, subtract) {
    if (!isObjectType(obj1)) return subtract ? obj1 : {};
    obj2 = coercePrimitiveToObject(obj2);
    function resolve(key, val, val1) {
        var exists = key in obj2 && isEqual(val1, obj2[key]);
        if (exists !== subtract) return val1;
    }
    return objectMerge({}, obj1, false, resolve);
}
module.exports = objectIntersectOrSubtract;

},{"664da2f03f9ce346":"eYWKz","727263ff85c4d540":"imZ5q","71d482242d386109":"1dImj","4b9b44efcc4a1544":"dhfEN"}],"3nSCh":[function(require,module,exports) {
"use strict";
var Sugar = require("56a3e9d931a871d0"), coreUtilityAliases = require("cabb51a5212f99f7");
var hasOwn = coreUtilityAliases.hasOwn, forEachProperty = coreUtilityAliases.forEachProperty;
Sugar.Object.defineInstanceAndStatic({
    "invert": function(obj, multi) {
        var result = {};
        multi = multi === true;
        forEachProperty(obj, function(val, key) {
            if (hasOwn(result, val) && multi) result[val].push(key);
            else if (multi) result[val] = [
                key
            ];
            else result[val] = key;
        });
        return result;
    }
});
module.exports = Sugar.Object.invert;

},{"56a3e9d931a871d0":"dZZfL","cabb51a5212f99f7":"8ZxTV"}],"hr4g6":[function(require,module,exports) {
"use strict";
var Sugar = require("168aefe03f869d43"), isArguments = require("25f49f27a7b2593f");
Sugar.Object.defineInstanceAndStatic({
    "isArguments": function(obj) {
        return isArguments(obj);
    }
});
module.exports = Sugar.Object.isArguments;

},{"168aefe03f869d43":"dZZfL","25f49f27a7b2593f":"2bXMM"}],"2bXMM":[function(require,module,exports) {
"use strict";
var hasProperty = require("ef1b90f204115fac"), coreUtilityAliases = require("ec1aed671349f1ce");
var classToString = coreUtilityAliases.classToString;
function isArguments(obj, className) {
    className = className || classToString(obj);
    // .callee exists on Arguments objects in < IE8
    return hasProperty(obj, "length") && (className === "[object Arguments]" || !!obj.callee);
}
module.exports = isArguments;

},{"ef1b90f204115fac":"k0Jkn","ec1aed671349f1ce":"8ZxTV"}],"k0Jkn":[function(require,module,exports) {
"use strict";
var isPrimitive = require("10355758f81ee789");
function hasProperty(obj, prop) {
    return !isPrimitive(obj) && prop in obj;
}
module.exports = hasProperty;

},{"10355758f81ee789":"j6hv6"}],"7MeNR":[function(require,module,exports) {
"use strict";
var Sugar = require("995f2dcd4521d485");
require("300330e631f2b9e9");
module.exports = Sugar.Object.isArray;

},{"995f2dcd4521d485":"dZZfL","300330e631f2b9e9":"ihh3l"}],"ihh3l":[function(require,module,exports) {
"use strict";
var buildClassCheckMethods = require("1711a7363f1ec653");
buildClassCheckMethods();

},{"1711a7363f1ec653":"e61Xj"}],"e61Xj":[function(require,module,exports) {
"use strict";
var NATIVE_TYPES = require("fc46ac910a4a02f1"), classChecks = require("635ff08bb81901c7"), namespaceAliases = require("95f224d7429c553"), defineInstanceAndStaticSimilar = require("e2671508929b084d");
var isBoolean = classChecks.isBoolean, isNumber = classChecks.isNumber, isString = classChecks.isString, isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction, isArray = classChecks.isArray, isSet = classChecks.isSet, isMap = classChecks.isMap, isError = classChecks.isError, sugarObject = namespaceAliases.sugarObject;
function buildClassCheckMethods() {
    var checks = [
        isBoolean,
        isNumber,
        isString,
        isDate,
        isRegExp,
        isFunction,
        isArray,
        isError,
        isSet,
        isMap
    ];
    defineInstanceAndStaticSimilar(sugarObject, NATIVE_TYPES, function(methods, name, i) {
        methods["is" + name] = checks[i];
    });
}
module.exports = buildClassCheckMethods;

},{"fc46ac910a4a02f1":"3L5fN","635ff08bb81901c7":"MTXUY","95f224d7429c553":"4onj1","e2671508929b084d":"ccvo3"}],"ccvo3":[function(require,module,exports) {
"use strict";
var methodDefineAliases = require("551244fac4ed015d"), collectSimilarMethods = require("e56bc717c785d345");
var defineInstanceAndStatic = methodDefineAliases.defineInstanceAndStatic;
function defineInstanceAndStaticSimilar(sugarNamespace, set, fn, flags) {
    defineInstanceAndStatic(sugarNamespace, collectSimilarMethods(set, fn), flags);
}
module.exports = defineInstanceAndStaticSimilar;

},{"551244fac4ed015d":"c4yD8","e56bc717c785d345":"aUTtI"}],"1TdNV":[function(require,module,exports) {
"use strict";
var Sugar = require("d3b6aece23edd865");
require("9deba08999e1dce0");
module.exports = Sugar.Object.isBoolean;

},{"d3b6aece23edd865":"dZZfL","9deba08999e1dce0":"ihh3l"}],"7aYDy":[function(require,module,exports) {
"use strict";
var Sugar = require("afbca9b11d17d584");
require("a0be4cd59f6f7156");
module.exports = Sugar.Object.isDate;

},{"afbca9b11d17d584":"dZZfL","a0be4cd59f6f7156":"ihh3l"}],"SQ8Pc":[function(require,module,exports) {
"use strict";
var Sugar = require("ae7479d19bb719a3"), objectSize = require("ea53d33ca39d41b2");
Sugar.Object.defineInstanceAndStatic({
    "isEmpty": function(obj) {
        return objectSize(obj) === 0;
    }
});
module.exports = Sugar.Object.isEmpty;

},{"ae7479d19bb719a3":"dZZfL","ea53d33ca39d41b2":"cxgab"}],"cxgab":[function(require,module,exports) {
"use strict";
var getKeysWithObjectCoercion = require("e17be5c6f45ca136");
function objectSize(obj) {
    return getKeysWithObjectCoercion(obj).length;
}
module.exports = objectSize;

},{"e17be5c6f45ca136":"egRwf"}],"egRwf":[function(require,module,exports) {
"use strict";
var getKeys = require("6ef9641aea470b83"), coercePrimitiveToObject = require("bda85f2faff33739");
function getKeysWithObjectCoercion(obj) {
    return getKeys(coercePrimitiveToObject(obj));
}
module.exports = getKeysWithObjectCoercion;

},{"6ef9641aea470b83":"dSIGU","bda85f2faff33739":"dhfEN"}],"71DXI":[function(require,module,exports) {
"use strict";
var Sugar = require("d67bc9fadd0de888"), isEqual = require("51187c990f595c1e");
Sugar.Object.defineInstanceAndStatic({
    "isEqual": function(obj1, obj2) {
        return isEqual(obj1, obj2);
    }
});
module.exports = Sugar.Object.isEqual;

},{"d67bc9fadd0de888":"dZZfL","51187c990f595c1e":"eYWKz"}],"4J1Uk":[function(require,module,exports) {
"use strict";
var Sugar = require("6d75f5489089978d");
require("77b00098f8dccd1");
module.exports = Sugar.Object.isError;

},{"6d75f5489089978d":"dZZfL","77b00098f8dccd1":"ihh3l"}],"8KvQF":[function(require,module,exports) {
"use strict";
var Sugar = require("a35df4077d52617a");
require("ca2525c2d8167b8e");
module.exports = Sugar.Object.isFunction;

},{"a35df4077d52617a":"dZZfL","ca2525c2d8167b8e":"ihh3l"}],"cpAVs":[function(require,module,exports) {
"use strict";
var Sugar = require("cd8b470f12fdcb1d");
require("aa8ca14ee6d75cce");
module.exports = Sugar.Object.isMap;

},{"cd8b470f12fdcb1d":"dZZfL","aa8ca14ee6d75cce":"ihh3l"}],"24Dt0":[function(require,module,exports) {
"use strict";
var Sugar = require("f7f2681c753048da");
require("a82271f6ed478d7b");
module.exports = Sugar.Object.isNumber;

},{"f7f2681c753048da":"dZZfL","a82271f6ed478d7b":"ihh3l"}],"9Iu8R":[function(require,module,exports) {
"use strict";
var Sugar = require("9ad5d65c8deae681"), isPlainObject = require("9715323fe48b0c32");
Sugar.Object.defineInstanceAndStatic({
    "isObject": function(obj) {
        return isPlainObject(obj);
    }
});
module.exports = Sugar.Object.isObject;

},{"9ad5d65c8deae681":"dZZfL","9715323fe48b0c32":"dxNeT"}],"3sVIw":[function(require,module,exports) {
"use strict";
var Sugar = require("ed9dab11761a6958");
require("3217d61dc752e4c3");
module.exports = Sugar.Object.isRegExp;

},{"ed9dab11761a6958":"dZZfL","3217d61dc752e4c3":"ihh3l"}],"fiv4D":[function(require,module,exports) {
"use strict";
var Sugar = require("b8527b5dc858290a");
require("7dd6b6b8bd40753d");
module.exports = Sugar.Object.isSet;

},{"b8527b5dc858290a":"dZZfL","7dd6b6b8bd40753d":"ihh3l"}],"i1vZe":[function(require,module,exports) {
"use strict";
var Sugar = require("b6e87f99924ebf4b");
require("ded9ca1e49db0d3d");
module.exports = Sugar.Object.isString;

},{"b6e87f99924ebf4b":"dZZfL","ded9ca1e49db0d3d":"ihh3l"}],"btH4A":[function(require,module,exports) {
"use strict";
var Sugar = require("5d2c5f98c27c68be"), mergeWithOptions = require("9ea8a22e1925f76f");
Sugar.Object.defineInstanceAndStatic({
    "merge": function(target, source, opts) {
        return mergeWithOptions(target, source, opts);
    }
});
module.exports = Sugar.Object.merge;

},{"5d2c5f98c27c68be":"dZZfL","9ea8a22e1925f76f":"1X6rH"}],"jrhzR":[function(require,module,exports) {
"use strict";
var Sugar = require("b295db6bb882d076"), mergeAll = require("7b2782fb8a67193b");
Sugar.Object.defineInstanceAndStatic({
    "mergeAll": function(target, sources, opts) {
        return mergeAll(target, sources, opts);
    }
});
module.exports = Sugar.Object.mergeAll;

},{"b295db6bb882d076":"dZZfL","7b2782fb8a67193b":"l5OSu"}],"9JR47":[function(require,module,exports) {
"use strict";
var Sugar = require("12899057c14f6c2e"), objectReject = require("6c536818ea361c29");
Sugar.Object.defineInstanceAndStatic({
    "reject": function(obj, f) {
        return objectReject(obj, f);
    }
});
module.exports = Sugar.Object.reject;

},{"12899057c14f6c2e":"dZZfL","6c536818ea361c29":"fdmCE"}],"fdmCE":[function(require,module,exports) {
"use strict";
var selectFromObject = require("3a55e1371847d4e6");
function objectReject(obj, f) {
    return selectFromObject(obj, f, false);
}
module.exports = objectReject;

},{"3a55e1371847d4e6":"j5m3V"}],"j5m3V":[function(require,module,exports) {
"use strict";
var matchInObject = require("ed3a97561bb85a32"), coreUtilityAliases = require("c662d85c270ccde1");
var forEachProperty = coreUtilityAliases.forEachProperty;
function selectFromObject(obj, f, select) {
    var match, result = {};
    f = [].concat(f);
    forEachProperty(obj, function(val, key) {
        match = false;
        for(var i = 0; i < f.length; i++)if (matchInObject(f[i], key)) match = true;
        if (match === select) result[key] = val;
    });
    return result;
}
module.exports = selectFromObject;

},{"ed3a97561bb85a32":"lh0dw","c662d85c270ccde1":"8ZxTV"}],"lh0dw":[function(require,module,exports) {
"use strict";
var classChecks = require("7752d51636cfb988"), isObjectType = require("b0894dffbe5fc2a4");
var isRegExp = classChecks.isRegExp;
function matchInObject(match, key) {
    if (isRegExp(match)) return match.test(key);
    else if (isObjectType(match)) return key in match;
    else return key === String(match);
}
module.exports = matchInObject;

},{"7752d51636cfb988":"MTXUY","b0894dffbe5fc2a4":"1dImj"}],"1bxz0":[function(require,module,exports) {
"use strict";
var Sugar = require("c0bffc898daedbf3"), objectRemove = require("246cd3fa97553715");
Sugar.Object.defineInstanceAndStatic({
    "remove": function(obj, f) {
        return objectRemove(obj, f);
    }
});
module.exports = Sugar.Object.remove;

},{"c0bffc898daedbf3":"dZZfL","246cd3fa97553715":"9sCFg"}],"9sCFg":[function(require,module,exports) {
"use strict";
var getMatcher = require("ee93ddcf7bd74b73"), coreUtilityAliases = require("787c8356bd98e491");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectRemove(obj, f) {
    var matcher = getMatcher(f);
    forEachProperty(obj, function(val, key) {
        if (matcher(val, key, obj)) delete obj[key];
    });
    return obj;
}
module.exports = objectRemove;

},{"ee93ddcf7bd74b73":"fDwIk","787c8356bd98e491":"8ZxTV"}],"23F3M":[function(require,module,exports) {
"use strict";
var Sugar = require("c4adc1e58bb72cd1"), objectSelect = require("25ff3bab4aef3c81");
Sugar.Object.defineInstanceAndStatic({
    "select": function(obj, f) {
        return objectSelect(obj, f);
    }
});
module.exports = Sugar.Object.select;

},{"c4adc1e58bb72cd1":"dZZfL","25ff3bab4aef3c81":"aZ80e"}],"aZ80e":[function(require,module,exports) {
"use strict";
var selectFromObject = require("407c4b7d2648ee0d");
function objectSelect(obj, f) {
    return selectFromObject(obj, f, true);
}
module.exports = objectSelect;

},{"407c4b7d2648ee0d":"j5m3V"}],"16Do0":[function(require,module,exports) {
"use strict";
var Sugar = require("b30957ca3ab9749c"), deepSetProperty = require("c2ba9044031d6572");
Sugar.Object.defineInstanceAndStatic({
    "set": function(obj, key, val) {
        return deepSetProperty(obj, key, val);
    }
});
module.exports = Sugar.Object.set;

},{"b30957ca3ab9749c":"dZZfL","c2ba9044031d6572":"iux8O"}],"iux8O":[function(require,module,exports) {
"use strict";
var handleDeepProperty = require("34378d15d4dea372");
function deepSetProperty(obj, key, val) {
    handleDeepProperty(obj, key, false, false, true, false, val);
    return obj;
}
module.exports = deepSetProperty;

},{"34378d15d4dea372":"G37fv"}],"lYlbu":[function(require,module,exports) {
"use strict";
var Sugar = require("3636c6d7aface83d"), objectSize = require("1533f56fbcee5ede");
Sugar.Object.defineInstanceAndStatic({
    "size": function(obj) {
        return objectSize(obj);
    }
});
module.exports = Sugar.Object.size;

},{"3636c6d7aface83d":"dZZfL","1533f56fbcee5ede":"cxgab"}],"9Xu8Z":[function(require,module,exports) {
"use strict";
var Sugar = require("45894bab00646631"), objectIntersectOrSubtract = require("f9912c5aa33c4a4e");
Sugar.Object.defineInstanceAndStatic({
    "subtract": function(obj1, obj2) {
        return objectIntersectOrSubtract(obj1, obj2, true);
    }
});
module.exports = Sugar.Object.subtract;

},{"45894bab00646631":"dZZfL","f9912c5aa33c4a4e":"4z4yr"}],"7xBOo":[function(require,module,exports) {
"use strict";
var Sugar = require("74ca6b7f4dc81a1f"), tap = require("aff5cabdd1ef3ac8");
Sugar.Object.defineInstanceAndStatic({
    "tap": function(obj, arg) {
        return tap(obj, arg);
    }
});
module.exports = Sugar.Object.tap;

},{"74ca6b7f4dc81a1f":"dZZfL","aff5cabdd1ef3ac8":"68DyG"}],"68DyG":[function(require,module,exports) {
"use strict";
var classChecks = require("81753d405ac7f6b4");
var isFunction = classChecks.isFunction;
function tap(obj, arg) {
    var fn = arg;
    if (!isFunction(arg)) fn = function fn() {
        if (arg) obj[arg]();
    };
    fn.call(obj, obj);
    return obj;
}
module.exports = tap;

},{"81753d405ac7f6b4":"MTXUY"}],"ePvDt":[function(require,module,exports) {
"use strict";
var Sugar = require("99e294a825168ce0"), toQueryStringWithOptions = require("2d418ad2e5b926a9");
Sugar.Object.defineInstanceAndStatic({
    "toQueryString": function(obj, options) {
        return toQueryStringWithOptions(obj, options);
    }
});
module.exports = Sugar.Object.toQueryString;

},{"99e294a825168ce0":"dZZfL","2d418ad2e5b926a9":"84JjE"}],"84JjE":[function(require,module,exports) {
"use strict";
var isUndefined = require("94c014716c11150b"), toQueryString = require("8b4cbcae6e968fb1");
function toQueryStringWithOptions(obj, opts) {
    opts = opts || {};
    if (isUndefined(opts.separator)) opts.separator = "_";
    return toQueryString(obj, opts.deep, opts.transform, opts.prefix || "", opts.separator);
}
module.exports = toQueryStringWithOptions;

},{"94c014716c11150b":"6oRAa","8b4cbcae6e968fb1":"91xmG"}],"91xmG":[function(require,module,exports) {
"use strict";
var classChecks = require("a839aefaebe4b068"), isObjectType = require("7934bc94c279de"), internalToString = require("faea26cf72725cee"), coreUtilityAliases = require("df0751303bf1ecb8"), getURIComponentValue = require("46e9e2e394333a5d"), sanitizeURIComponent = require("c35d1adf90e09881");
var isArray = classChecks.isArray, forEachProperty = coreUtilityAliases.forEachProperty;
function toQueryString(obj, deep, transform, prefix, separator) {
    if (isArray(obj)) return collectArrayAsQueryString(obj, deep, transform, prefix, separator);
    else if (isObjectType(obj) && obj.toString === internalToString) return collectObjectAsQueryString(obj, deep, transform, prefix, separator);
    else if (prefix) return getURIComponentValue(obj, prefix, transform);
    return "";
}
function collectArrayAsQueryString(arr, deep, transform, prefix, separator) {
    var el, qc, key, result = [];
    // Intentionally treating sparse arrays as dense here by avoiding map,
    // otherwise indexes will shift during the process of serialization.
    for(var i = 0, len = arr.length; i < len; i++){
        el = arr[i];
        key = prefix + (prefix && deep ? "[]" : "");
        if (!key && !isObjectType(el)) // If there is no key, then the values of the array should be
        // considered as null keys, so use them instead;
        qc = sanitizeURIComponent(el);
        else qc = toQueryString(el, deep, transform, key, separator);
        result.push(qc);
    }
    return result.join("&");
}
function collectObjectAsQueryString(obj, deep, transform, prefix, separator) {
    var result = [];
    forEachProperty(obj, function(val, key) {
        var fullKey;
        if (prefix && deep) fullKey = prefix + "[" + key + "]";
        else if (prefix) fullKey = prefix + separator + key;
        else fullKey = key;
        result.push(toQueryString(val, deep, transform, fullKey, separator));
    });
    return result.join("&");
}
module.exports = toQueryString;

},{"a839aefaebe4b068":"MTXUY","7934bc94c279de":"1dImj","faea26cf72725cee":"d4e7i","df0751303bf1ecb8":"8ZxTV","46e9e2e394333a5d":"bz3Ln","c35d1adf90e09881":"iMPGJ"}],"d4e7i":[function(require,module,exports) {
"use strict";
module.exports = Object.prototype.toString;

},{}],"bz3Ln":[function(require,module,exports) {
"use strict";
var classChecks = require("8f63d27aaf4d4369"), sanitizeURIComponent = require("930e939a50e685c1");
var isDate = classChecks.isDate;
function getURIComponentValue(obj, prefix, transform) {
    var value;
    if (transform) value = transform(obj, prefix);
    else if (isDate(obj)) value = obj.getTime();
    else value = obj;
    return sanitizeURIComponent(prefix) + "=" + sanitizeURIComponent(value);
}
module.exports = getURIComponentValue;

},{"8f63d27aaf4d4369":"MTXUY","930e939a50e685c1":"iMPGJ"}],"iMPGJ":[function(require,module,exports) {
"use strict";
function sanitizeURIComponent(obj) {
    // undefined, null, and NaN are represented as a blank string,
    // while false and 0 are stringified.
    return !obj && obj !== false && obj !== 0 ? "" : encodeURIComponent(obj);
}
module.exports = sanitizeURIComponent;

},{}],"cduv5":[function(require,module,exports) {
"use strict";
var Sugar = require("84a85ea433ed0822"), getValues = require("56e89c60bd40b5ed");
Sugar.Object.defineInstanceAndStatic({
    "values": function(obj) {
        return getValues(obj);
    }
});
module.exports = Sugar.Object.values;

},{"84a85ea433ed0822":"dZZfL","56e89c60bd40b5ed":"6pOs8"}],"6pOs8":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("c25fbf18a6438022");
var forEachProperty = coreUtilityAliases.forEachProperty;
function getValues(obj) {
    var values = [];
    forEachProperty(obj, function(val) {
        values.push(val);
    });
    return values;
}
module.exports = getValues;

},{"c25fbf18a6438022":"8ZxTV"}],"l0Yqg":[function(require,module,exports) {
"use strict";
var Sugar = require("a6686231860a9920"), getKeys = require("5a3ad4dc98c10d6f");
Sugar.Object.defineInstance({
    "keys": function(obj) {
        return getKeys(obj);
    }
});
module.exports = Sugar.Object.keys;

},{"a6686231860a9920":"dZZfL","5a3ad4dc98c10d6f":"dSIGU"}],"9Lgs0":[function(require,module,exports) {
"use strict";
// Static Methods
require("806b7a59776ba878");
require("ccda1cf9b47e42ad");
require("4f9fd342c895f5b5");
require("c92ff7a03ede8c69");
require("a02f29fac8b58f5e");
require("f677270a265ad3c6");
require("18ee60cdca29b3f3");
// Instance Methods
require("dd3c7a0fdddd5c86");
require("4faa9f6eb081cf71");
require("206434db5aef736b");
require("75bcf722c07b4972");
require("46bfb30296e2e8fe");
require("7e36b538b8c0a22b");
require("237c9a9a72b8d91f");
require("4a2598c9b8a4c432");
require("1d450b0c20c4cd46");
require("13efcaf0620efb56");
require("1ded417f7a5e5aab");
require("ffecddc8560ae424");
require("ec8b4379f57f6ea3");
require("e909455d6190ac7");
require("d417409fe0b0453e");
require("23177fbc2c82221a");
require("9f10561f73fc0469");
require("3f97e70ff03b6967");
require("a47d1d1631a95caa");
require("6c1527f094f25d0b");
require("4905c3818c31289b");
require("2020a559b7c63ef5");
require("54c2da09ada8300c");
require("ec27ba9ef163130c");
require("2588e6e37abfdd4");
require("e2ee99bb55e1b543");
require("70773b04681141ca");
require("3c4873a7ee008971");
require("b62da8b53863ce07");
require("22c5cfd61997ec99");
require("b4e86cd8e3e3e314");
require("5874602a394fff03");
require("1a02240687abe671");
require("70f0c63a26920aa7");
require("19942a8c387e33b5");
require("ec728e4af5e49d4b");
require("1d7899c618892089");
require("b395ad3887349a85");
require("22f58639eae1ae10");
require("c8d57437515579b1");
require("ca7a47a068e82229");
require("1e80bf7c161b560a");
require("c083231a32efabec");
require("f31e924b230ad30e");
require("4752973aef594b2e");
require("701848bf7e63dcc7");
require("b861356af46c4a30");
require("e84d12d0684cef3e");
require("b0d6d60819349af3");
require("e32afb7b7e697389");
require("6628e12f9e1825bc");
require("27b981e89ca16fdc");
require("3daad3a26a576724");
require("97b8055c2ac41cc1");
require("2535f7c73eb6852d");
require("99f6234de4dbd2c5");
require("3cbb49e636a24bb2");
require("b8c77d98495290ed");
require("3b9a44c4dd627371");
require("f5ef8cf15973a0d9");
require("54aa498a7c18f4f8");
require("32747b109b575431");
require("57d41768e0c81af");
require("eee973178f5e978b");
require("51f6e4ad06b03601");
require("3918947d29c2f3ae");
require("34dcccab3e97de9f");
require("eb2dc8c8ea51c235");
require("1b661fe9d57edebe");
require("cbfc083f3e724b73");
require("91bb07dd11e1bcfc");
require("a2968160b258eef2");
require("b428536f24e44871");
require("1296ac84a31e4472");
require("11f9ee87a1419cc7");
require("15fa87dd94e89a77");
require("c6098c0fb2c4118a");
require("fa0eebb45515c2a4");
require("ca657f30589710fd");
require("dd71e2911e307b49");
require("7a5ebfaae0cdbef4");
require("9762ce205e4d53b");
require("964be09b1ce729df");
require("d8b787ecd572ba64");
require("f5c013b9f02f28ec");
require("cf6716226b82dcf1");
require("30bce48a348cad7d");
require("b1d813f0f25de7ef");
require("295a0ffd6c5c4601");
require("aeec2bad982c1411");
require("d9037c08d3ceaef1");
require("74cc28612f616dbf");
require("7d0b3839b62dbde2");
require("ca40df9d734ab8b1");
require("82f683f19cf92c4f");
require("caa3d8e934613240");
require("f30f7f08bd8d273");
require("2235bb4af1a5afbc");
require("2b6496e724737818");
require("abda8c3c9f87ec8f");
require("6a67267316ee62e5");
require("3793e6cd3d8b49a5");
require("79fdc2a531fd0b5b");
require("79930c5769f207d4");
require("a00ff9f687420494");
require("e4b1b229890538ab");
require("f8856e89de31c32a");
require("889a8591da3e0aae");
require("f4b22975beb50a93");
require("e34f4f0338cb0ee6");
require("1107eee95d36b3a3");
require("461bbbe45cdfae8f");
require("b6af2695f8c36e4c");
require("b10afcfd331b175c");
require("b326fd159fc9e844");
require("ac9177bb57068121");
require("7ce4f928b1cae0ec");
require("94f211226723912a");
require("2d06732b61b456a0");
require("3706891c0cf67797");
require("6fa535ac9656aa09");
require("3d66b3d5ce4d314f");
require("a9d1b98b59d80e64");
require("fa7d6d7d5920c0bb");
require("e61298244085c58f");
require("85d61cb2ad3b4bb9");
require("cd4e5c5b38c902f0");
require("4f48cc30f88d447a");
require("2592a75324cc89b9");
require("853cdadab5399097");
require("f8c94a995ae9d862");
require("ce03fbf2d394addf");
require("660cf04203e32039");
require("874bc1d368c7ba14");
require("b266882828ac083");
require("c852734335ed0236");
require("dd6d18602ca4510c");
require("db4e95d074a59533");
require("e4ce0fafd4cff6e8");
require("cafc6fdce54019a0");
require("fb9989ac34a52265");
require("39cedf78f769067d");
require("d587d445a91df445");
require("146a373a1a5bd949");
require("2cdfcd9abd422b9c");
require("e5668773ff019840");
require("3384c06bb42ea9b5");
require("f50db3b44ea7d79");
require("533d61486c702a9e");
require("c9029fe56dacb7c");
require("255660455627de5f");
require("f283fa51b846778f");
require("6550b0eea7f16241");
require("cbd6818539b443c6");
require("8df15435fac582b8");
require("b67e653c01487087");
require("db8d0d900a9fd695");
require("9370528d6e919e82");
require("b6b27d993adffbde");
require("733cf9c915081d2f");
require("9aa8f91a6f7a9b22");
require("4a8ca9c6eb5d987a");
require("52d47a7e9622b8ac");
require("adfcf4f6d2007db3");
require("25d0e1321c4799a8");
require("d7558cabfdddac4f");
require("a26457bee2be1809");
require("671873bbd1c4136");
require("220141f8faed80b3");
require("e096e4be8a4c482a");
require("62f6ccb0927c07cd");
require("f3236b1a2c644708");
require("2f2b1d526b42f304");
require("32627c10c3c9022");
require("832d7bd1943e48c9");
require("46856ababd23d093");
require("f12f25c5e0d11c3e");
require("a8bdc0bf81edd6f6");
require("93a4a8bd45dd51c");
// Accessors
require("838ba58f429cece2");
require("1102721abf5b90b8");
module.exports = require("f237b65b37958023");

},{"806b7a59776ba878":"dR4g9","ccda1cf9b47e42ad":"8SOdC","4f9fd342c895f5b5":"38rYf","c92ff7a03ede8c69":"d9A6Y","a02f29fac8b58f5e":"hiuS9","f677270a265ad3c6":"giNAu","18ee60cdca29b3f3":"hn2X9","dd3c7a0fdddd5c86":"7Kd5u","4faa9f6eb081cf71":"lD0L4","206434db5aef736b":"8lhZI","75bcf722c07b4972":"5LEDJ","46bfb30296e2e8fe":"2rnAP","7e36b538b8c0a22b":"azJny","237c9a9a72b8d91f":"bk9Ke","4a2598c9b8a4c432":"8BoSB","1d450b0c20c4cd46":"gLeXn","13efcaf0620efb56":"9uJUj","1ded417f7a5e5aab":"hyQPL","ffecddc8560ae424":"efUGG","ec8b4379f57f6ea3":"jxWDF","e909455d6190ac7":"6tL8L","d417409fe0b0453e":"5PcPT","23177fbc2c82221a":"hbcDG","9f10561f73fc0469":"cBv9k","3f97e70ff03b6967":"c3id1","a47d1d1631a95caa":"8Pbth","6c1527f094f25d0b":"7gARQ","4905c3818c31289b":"1kD6A","2020a559b7c63ef5":"dYuVG","54c2da09ada8300c":"hpYck","ec27ba9ef163130c":"8WyEQ","2588e6e37abfdd4":"fBkP1","e2ee99bb55e1b543":"gvlku","70773b04681141ca":"deJnO","3c4873a7ee008971":"dBLTd","b62da8b53863ce07":"gxcP3","22c5cfd61997ec99":"kcG72","b4e86cd8e3e3e314":"2ezBG","5874602a394fff03":"4uQ3P","1a02240687abe671":"lNvt1","70f0c63a26920aa7":"9PeMw","19942a8c387e33b5":"kgvpk","ec728e4af5e49d4b":"hEFZH","1d7899c618892089":"bT5iG","b395ad3887349a85":"fi4kJ","22f58639eae1ae10":"lffwN","c8d57437515579b1":"bK5pn","ca7a47a068e82229":"ihc0C","1e80bf7c161b560a":"aYiYT","c083231a32efabec":"iemEr","f31e924b230ad30e":"Cnfom","4752973aef594b2e":"bIgUx","701848bf7e63dcc7":"jOf42","b861356af46c4a30":"3hCGW","e84d12d0684cef3e":"8Xw3v","b0d6d60819349af3":"8Mh1L","e32afb7b7e697389":"7nn55","6628e12f9e1825bc":"lT0VK","27b981e89ca16fdc":"1fGCW","3daad3a26a576724":"lV67C","97b8055c2ac41cc1":"4qiSo","2535f7c73eb6852d":"eEODV","99f6234de4dbd2c5":"akQMc","3cbb49e636a24bb2":"lOZN6","b8c77d98495290ed":"fpAIo","3b9a44c4dd627371":"34ueM","f5ef8cf15973a0d9":"1Oa5J","54aa498a7c18f4f8":"8bI9x","32747b109b575431":"bZFJz","57d41768e0c81af":"8WE4h","eee973178f5e978b":"gZkBi","51f6e4ad06b03601":"hx8Q4","3918947d29c2f3ae":"7tgvS","34dcccab3e97de9f":"hvb0B","eb2dc8c8ea51c235":"1KrrZ","1b661fe9d57edebe":"eqane","cbfc083f3e724b73":"hwZmt","91bb07dd11e1bcfc":"8w3Vu","a2968160b258eef2":"90yN1","b428536f24e44871":"lGzuN","1296ac84a31e4472":"dlAUD","11f9ee87a1419cc7":"iS2Lc","15fa87dd94e89a77":"lSWB2","c6098c0fb2c4118a":"1hHaG","fa0eebb45515c2a4":"a5047","ca657f30589710fd":"bLaMt","dd71e2911e307b49":"abLxj","7a5ebfaae0cdbef4":"9VVRp","9762ce205e4d53b":"k7uWf","964be09b1ce729df":"cgA8Q","d8b787ecd572ba64":"l9wlA","f5c013b9f02f28ec":"9NR07","cf6716226b82dcf1":"2qnld","30bce48a348cad7d":"1dmpx","b1d813f0f25de7ef":"dtUXN","295a0ffd6c5c4601":"fZgNz","aeec2bad982c1411":"7RGKd","d9037c08d3ceaef1":"blyWU","74cc28612f616dbf":"24f6i","7d0b3839b62dbde2":"bK22v","ca40df9d734ab8b1":"haSy4","82f683f19cf92c4f":"1uUtT","caa3d8e934613240":"eQMIn","f30f7f08bd8d273":"kZLLI","2235bb4af1a5afbc":"hItwG","2b6496e724737818":"jfPB2","abda8c3c9f87ec8f":"hP5Yz","6a67267316ee62e5":"iliJa","3793e6cd3d8b49a5":"e5aju","79fdc2a531fd0b5b":"eq4SV","79930c5769f207d4":"iFhOJ","a00ff9f687420494":"1bnXR","e4b1b229890538ab":"9yl5u","f8856e89de31c32a":"bDGyV","889a8591da3e0aae":"hyoFo","f4b22975beb50a93":"asbZS","e34f4f0338cb0ee6":"9Fhr4","1107eee95d36b3a3":"llLL0","461bbbe45cdfae8f":"4Ts2m","b6af2695f8c36e4c":"eYNOf","b10afcfd331b175c":"audGq","b326fd159fc9e844":"63eay","ac9177bb57068121":"co8I3","7ce4f928b1cae0ec":"bMXpT","94f211226723912a":"fUO92","2d06732b61b456a0":"1VNdY","3706891c0cf67797":"kqr40","6fa535ac9656aa09":"eHuRb","3d66b3d5ce4d314f":"lq88x","a9d1b98b59d80e64":"3OSRM","fa7d6d7d5920c0bb":"beqKQ","e61298244085c58f":"4gisX","85d61cb2ad3b4bb9":"9u5NL","cd4e5c5b38c902f0":"3UAZb","4f48cc30f88d447a":"7fMNv","2592a75324cc89b9":"cZtJY","853cdadab5399097":"gy1wN","f8c94a995ae9d862":"lSo3y","ce03fbf2d394addf":"evm0x","660cf04203e32039":"01KKF","874bc1d368c7ba14":"lSlkk","b266882828ac083":"bgJdS","c852734335ed0236":"dUKln","dd6d18602ca4510c":"kv9v3","db4e95d074a59533":"i0Tha","e4ce0fafd4cff6e8":"11mcF","cafc6fdce54019a0":"5tJ2C","fb9989ac34a52265":"9Ltmj","39cedf78f769067d":"lySHR","d587d445a91df445":"3xaDE","146a373a1a5bd949":"jpnGA","2cdfcd9abd422b9c":"hLSOf","e5668773ff019840":"3hENp","3384c06bb42ea9b5":"6QwUr","f50db3b44ea7d79":"eadMP","533d61486c702a9e":"b44aT","c9029fe56dacb7c":"kTtS0","255660455627de5f":"4ctfN","f283fa51b846778f":"d84Pn","6550b0eea7f16241":"jc2wq","cbd6818539b443c6":"etwmK","8df15435fac582b8":"hGBGH","b67e653c01487087":"jO4OY","db8d0d900a9fd695":"aVCRT","9370528d6e919e82":"94VJH","b6b27d993adffbde":"kdzno","733cf9c915081d2f":"2qgWX","9aa8f91a6f7a9b22":"8J9Ci","4a8ca9c6eb5d987a":"ktc0Y","52d47a7e9622b8ac":"0vBId","adfcf4f6d2007db3":"kEF3E","25d0e1321c4799a8":"6BqIw","d7558cabfdddac4f":"aQGZx","a26457bee2be1809":"cWxPq","671873bbd1c4136":"gEJVI","220141f8faed80b3":"75va7","e096e4be8a4c482a":"60lJF","62f6ccb0927c07cd":"eMvX3","f3236b1a2c644708":"bmUNB","2f2b1d526b42f304":"dFwec","32627c10c3c9022":"iAFjW","832d7bd1943e48c9":"cwFvs","46856ababd23d093":"7S7gC","f12f25c5e0d11c3e":"17rMQ","a8bdc0bf81edd6f6":"2lKiS","93a4a8bd45dd51c":"49icm","838ba58f429cece2":"1TpQ6","1102721abf5b90b8":"kZTiz","f237b65b37958023":"dZZfL"}],"dR4g9":[function(require,module,exports) {
"use strict";
var Sugar = require("878ed930fbf9db82"), LocaleHelpers = require("1e6a6edc4d33939");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "addLocale": function(code, set) {
        return localeManager.add(code, set);
    }
});
module.exports = Sugar.Date.addLocale;

},{"878ed930fbf9db82":"dZZfL","1e6a6edc4d33939":"hlra3"}],"hlra3":[function(require,module,exports) {
"use strict";
var LazyLoadedLocales = require("2cf62aa30dee6e54"), AmericanEnglishDefinition = require("4ed529db5fbbe244"), getNewLocale = require("d2204d7d9253474b");
var English, localeManager;
function buildLocales() {
    function LocaleManager(loc) {
        this.locales = {};
        this.add(loc);
    }
    LocaleManager.prototype = {
        get: function get(code, fallback) {
            var loc = this.locales[code];
            if (!loc && LazyLoadedLocales[code]) loc = this.add(code, LazyLoadedLocales[code]);
            else if (!loc && code) loc = this.locales[code.slice(0, 2)];
            return loc || fallback === false ? loc : this.current;
        },
        getAll: function getAll() {
            return this.locales;
        },
        set: function set(code) {
            var loc = this.get(code, false);
            if (!loc) throw new TypeError("Invalid Locale: " + code);
            return this.current = loc;
        },
        add: function add(code, def) {
            if (!def) {
                def = code;
                code = def.code;
            } else def.code = code;
            var loc = def.compiledFormats ? def : getNewLocale(def);
            this.locales[code] = loc;
            if (!this.current) this.current = loc;
            return loc;
        },
        remove: function remove(code) {
            if (this.current.code === code) this.current = this.get("en");
            return delete this.locales[code];
        }
    };
    // Sorry about this guys...
    English = getNewLocale(AmericanEnglishDefinition);
    localeManager = new LocaleManager(English);
}
buildLocales();
module.exports = {
    English: English,
    localeManager: localeManager
};

},{"2cf62aa30dee6e54":"jh5Iq","4ed529db5fbbe244":"866GK","d2204d7d9253474b":"jWVl5"}],"jh5Iq":[function(require,module,exports) {
"use strict";
var BritishEnglishDefinition = require("1e5801287ca7f267"), AmericanEnglishDefinition = require("2792a24e1acae932"), CanadianEnglishDefinition = require("f4a36693b197f63a");
var LazyLoadedLocales = {
    "en-US": AmericanEnglishDefinition,
    "en-GB": BritishEnglishDefinition,
    "en-AU": BritishEnglishDefinition,
    "en-CA": CanadianEnglishDefinition
};
module.exports = LazyLoadedLocales;

},{"1e5801287ca7f267":"idnmv","2792a24e1acae932":"866GK","f4a36693b197f63a":"iorR6"}],"idnmv":[function(require,module,exports) {
"use strict";
var getEnglishVariant = require("937d097f5cf24e93");
var BritishEnglishDefinition = getEnglishVariant({
    "short": "{dd}/{MM}/{yyyy}",
    "medium": "{d} {Month} {yyyy}",
    "long": "{d} {Month} {yyyy} {H}:{mm}",
    "full": "{Weekday}, {d} {Month}, {yyyy} {time}",
    "stamp": "{Dow} {d} {Mon} {yyyy} {time}"
});
module.exports = BritishEnglishDefinition;

},{"937d097f5cf24e93":"lWpdu"}],"lWpdu":[function(require,module,exports) {
"use strict";
var EnglishLocaleBaseDefinition = require("c537e1624eaaa3b2"), simpleMerge = require("6f5e50cd9652af7d"), simpleClone = require("8360c09f0928a9eb");
function getEnglishVariant(v) {
    return simpleMerge(simpleClone(EnglishLocaleBaseDefinition), v);
}
module.exports = getEnglishVariant;

},{"c537e1624eaaa3b2":"68VFc","6f5e50cd9652af7d":"e4HRg","8360c09f0928a9eb":"glUlC"}],"68VFc":[function(require,module,exports) {
"use strict";
var EnglishLocaleBaseDefinition = {
    "code": "en",
    "plural": true,
    "timeMarkers": "at",
    "ampm": "AM|A.M.|a,PM|P.M.|p",
    "units": "millisecond:|s,second:|s,minute:|s,hour:|s,day:|s,week:|s,month:|s,year:|s",
    "months": "Jan:uary|,Feb:ruary|,Mar:ch|,Apr:il|,May,Jun:e|,Jul:y|,Aug:ust|,Sep:tember|t|,Oct:ober|,Nov:ember|,Dec:ember|",
    "weekdays": "Sun:day|,Mon:day|,Tue:sday|,Wed:nesday|,Thu:rsday|,Fri:day|,Sat:urday|+weekend",
    "numerals": "zero,one|first,two|second,three|third,four:|th,five|fifth,six:|th,seven:|th,eight:|h,nin:e|th,ten:|th",
    "articles": "a,an,the",
    "tokens": "the,st|nd|rd|th,of|in,a|an,on",
    "time": "{H}:{mm}",
    "past": "{num} {unit} {sign}",
    "future": "{num} {unit} {sign}",
    "duration": "{num} {unit}",
    "modifiers": [
        {
            "name": "half",
            "src": "half",
            "value": .5
        },
        {
            "name": "midday",
            "src": "noon",
            "value": 12
        },
        {
            "name": "midday",
            "src": "midnight",
            "value": 24
        },
        {
            "name": "day",
            "src": "yesterday",
            "value": -1
        },
        {
            "name": "day",
            "src": "today|tonight",
            "value": 0
        },
        {
            "name": "day",
            "src": "tomorrow",
            "value": 1
        },
        {
            "name": "sign",
            "src": "ago|before",
            "value": -1
        },
        {
            "name": "sign",
            "src": "from now|after|from|in|later",
            "value": 1
        },
        {
            "name": "edge",
            "src": "first day|first|beginning",
            "value": -2
        },
        {
            "name": "edge",
            "src": "last day",
            "value": 1
        },
        {
            "name": "edge",
            "src": "end|last",
            "value": 2
        },
        {
            "name": "shift",
            "src": "last",
            "value": -1
        },
        {
            "name": "shift",
            "src": "the|this",
            "value": 0
        },
        {
            "name": "shift",
            "src": "next",
            "value": 1
        }
    ],
    "parse": [
        "(?:just)? now",
        "{shift} {unit:5-7}",
        "{months?} {year}",
        "{midday} {4?} {day|weekday}",
        "{months},?[-.\\/\\s]?{year?}",
        "{edge} of (?:day)? {day|weekday}",
        "{0} {num}{1?} {weekday} {2} {months},? {year?}",
        "{shift?} {day?} {weekday?} (?:at)? {midday}",
        "{sign?} {3?} {half} {3?} {unit:3-4|unit:7} {sign?}",
        "{0?} {edge} {weekday?} {2} {shift?} {unit:4-7?} {months?},? {year?}"
    ],
    "timeParse": [
        "{day|weekday}",
        "{shift} {unit:5?} {weekday}",
        "{0?} {date}{1?} {2?} {months?}",
        "{weekday} {2?} {shift} {unit:5}",
        "{0?} {num} {2?} {months}\\.?,? {year?}",
        "{num?} {unit:4-5} {sign} {day|weekday}",
        "{0|months} {date?}{1?} of {shift} {unit:6-7}",
        "{0?} {num}{1?} {weekday} of {shift} {unit:6}",
        "{year?}[-.\\/\\s]?{months}[-.\\/\\s]{date}",
        "{date}[-.\\/\\s]{months}(?:[-.\\/\\s]{year|yy})?",
        "{weekday?}\\.?,? {months}\\.?,? {date}{1?},? {year?}",
        "{weekday?}\\.?,? {date} {months} {year}"
    ],
    "timeFrontParse": [
        "{sign} {num} {unit}",
        "{num} {unit} {sign}",
        "{4?} {day|weekday}"
    ]
};
module.exports = EnglishLocaleBaseDefinition;

},{}],"866GK":[function(require,module,exports) {
"use strict";
var getEnglishVariant = require("44ef3269ee14b275");
var AmericanEnglishDefinition = getEnglishVariant({
    "mdy": true,
    "firstDayOfWeek": 0,
    "firstDayOfWeekYear": 1,
    "short": "{MM}/{dd}/{yyyy}",
    "medium": "{Month} {d}, {yyyy}",
    "long": "{Month} {d}, {yyyy} {time}",
    "full": "{Weekday}, {Month} {d}, {yyyy} {time}",
    "stamp": "{Dow} {Mon} {d} {yyyy} {time}",
    "time": "{h}:{mm} {TT}"
});
module.exports = AmericanEnglishDefinition;

},{"44ef3269ee14b275":"lWpdu"}],"iorR6":[function(require,module,exports) {
"use strict";
var getEnglishVariant = require("4949852a95180a58");
var CanadianEnglishDefinition = getEnglishVariant({
    "short": "{yyyy}-{MM}-{dd}",
    "medium": "{d} {Month}, {yyyy}",
    "long": "{d} {Month}, {yyyy} {H}:{mm}",
    "full": "{Weekday}, {d} {Month}, {yyyy} {time}",
    "stamp": "{Dow} {d} {Mon} {yyyy} {time}"
});
module.exports = CanadianEnglishDefinition;

},{"4949852a95180a58":"lWpdu"}],"jWVl5":[function(require,module,exports) {
"use strict";
var LOCALE_ARRAY_FIELDS = require("bdf4fbd619dbc461"), ISODefaults = require("d6833d22e43d3687"), CoreParsingTokens = require("91e88fec44df3cf4"), CoreParsingFormats = require("d5a50d01f96c8df0"), LocalizedParsingTokens = require("7ed1c535eda0933b"), map = require("611f5ee79afc947d"), filter = require("85d05ce17aeacfd9"), forEach = require("e784310f8213f412"), isDefined = require("1cb26c833d2c5d8e"), commaSplit = require("4bce8f21a7c890a5"), classChecks = require("5711a8ac9114482d"), mathAliases = require("d9de64f4dbdbc166"), isUndefined = require("5b54b23d2cbc5559"), simpleMerge = require("6f8cfb2bea9892b8"), getOrdinalSuffix = require("fb3943766e4f0d95"), getArrayWithOffset = require("8dda811c1bdd60fd"), getRegNonCapturing = require("2879bc1c57795f4f"), coreUtilityAliases = require("5b0d3b3736207fbc"), iterateOverDateUnits = require("89c4138af1038e"), arrayToRegAlternates = require("f953f827a23913e2"), fullwidthNumberHelpers = require("9981a6fd05e6d24f"), getAdjustedUnitForNumber = require("4ef24f6a18265858"), getParsingTokenWithSuffix = require("b4618acd1a62dace");
var hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn, forEachProperty = coreUtilityAliases.forEachProperty, fullWidthNumberMap = fullwidthNumberHelpers.fullWidthNumberMap, fullWidthNumbers = fullwidthNumberHelpers.fullWidthNumbers, pow = mathAliases.pow, max = mathAliases.max, ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR, isString = classChecks.isString, isFunction = classChecks.isFunction;
function getNewLocale(def) {
    function Locale(def) {
        this.init(def);
    }
    Locale.prototype = {
        getMonthName: function getMonthName(n, alternate) {
            if (this.monthSuffix) return n + 1 + this.monthSuffix;
            return getArrayWithOffset(this.months, n, alternate, 12);
        },
        getWeekdayName: function getWeekdayName(n, alternate) {
            return getArrayWithOffset(this.weekdays, n, alternate, 7);
        },
        // TODO: rename to parse in next major version
        parseValue: function parseValue(str, param) {
            var map = this[param + "Map"];
            if (hasOwn(map, str)) return map[str];
            return this.parseNumber(str, param);
        },
        // TODO: analyze performance of parsing first vs checking
        // numeralMap first.
        parseNumber: function parseNumber(str, param) {
            var val;
            // Simple numerals such as "one" are mapped directly in
            // the numeral map so catch up front if there is a match.
            if (hasOwn(this.numeralMap, str)) val = this.numeralMap[str];
            // TODO: perf test isNaN vs other methods
            if (isNaN(val)) val = this.parseRegularNumerals(str);
            if (isNaN(val)) val = this.parseIrregularNumerals(str);
            if (param === "month") // Months are the only numeric date field
            // whose value is not the same as its number.
            val -= 1;
            return val;
        },
        // TODO: perf test returning up front if no regular decimals exist
        parseRegularNumerals: function parseRegularNumerals(str) {
            // Allow decimals as commas and the minus-sign as per ISO-8601.
            str = str.replace(/^−/, "-").replace(/,/, ".");
            // The unary plus operator here shows better performance and handles
            // every format that parseFloat does with the exception of trailing
            // characters, which are guaranteed not to be in our string at this point.
            return +str;
        },
        parseIrregularNumerals: function parseIrregularNumerals(str) {
            var place = 1, num = 0, lastWasPlace, isPlace, numeral, digit, arr;
            // Note that "numerals" that need to be converted through this method are
            // all considered to be single characters in order to handle CJK. This
            // method is by no means unique to CJK, but the complexity of handling
            // inflections in non-CJK languages adds too much overhead for not enough
            // value, so avoiding for now.
            arr = str.split("");
            for(var i = arr.length - 1; numeral = arr[i]; i--){
                digit = getOwn(this.numeralMap, numeral);
                if (isUndefined(digit)) digit = getOwn(fullWidthNumberMap, numeral) || 0;
                isPlace = digit > 0 && digit % 10 === 0;
                if (isPlace) {
                    if (lastWasPlace) num += place;
                    if (i) place = digit;
                    else num += digit;
                } else {
                    num += digit * place;
                    place *= 10;
                }
                lastWasPlace = isPlace;
            }
            return num;
        },
        getOrdinal: function getOrdinal(n) {
            var suffix = this.ordinalSuffix;
            return suffix || getOrdinalSuffix(n);
        },
        getRelativeFormat: function getRelativeFormat(adu, type) {
            return this.convertAdjustedToFormat(adu, type);
        },
        getDuration: function getDuration(ms) {
            return this.convertAdjustedToFormat(getAdjustedUnitForNumber(max(0, ms)), "duration");
        },
        getFirstDayOfWeek: function getFirstDayOfWeek() {
            var val = this.firstDayOfWeek;
            return isDefined(val) ? val : ISO_FIRST_DAY_OF_WEEK;
        },
        getFirstDayOfWeekYear: function getFirstDayOfWeekYear() {
            return this.firstDayOfWeekYear || ISO_FIRST_DAY_OF_WEEK_YEAR;
        },
        convertAdjustedToFormat: function convertAdjustedToFormat(adu, type) {
            var sign, unit, mult, num = adu[0], u = adu[1], ms = adu[2], format = this[type] || this.relative;
            if (isFunction(format)) return format.call(this, num, u, ms, type);
            mult = !this.plural || num === 1 ? 0 : 1;
            unit = this.units[mult * 8 + u] || this.units[u];
            sign = this[ms > 0 ? "fromNow" : "ago"];
            return format.replace(/\{(.*?)\}/g, function(full, match) {
                switch(match){
                    case "num":
                        return num;
                    case "unit":
                        return unit;
                    case "sign":
                        return sign;
                }
            });
        },
        cacheFormat: function cacheFormat(dif, i) {
            this.compiledFormats.splice(i, 1);
            this.compiledFormats.unshift(dif);
        },
        addFormat: function addFormat(format) {
            var loc = this, src, to;
            function getTokenSrc(token) {
                var suffix, src, tmp, opt = token.match(/\?$/), nc = token.match(/^(\d+)\??$/), slice = token.match(/(\d)(?:-(\d))?/), param = token.replace(/[^a-z]+$/i, "");
                // Allowing alias tokens such as {time}
                if (tmp = getOwn(loc.parsingAliases, param)) {
                    src = formatToSrc(tmp);
                    if (opt) src = getRegNonCapturing(src, true);
                    return src;
                }
                if (nc) src = loc.tokens[nc[1]];
                else if (tmp = getOwn(CoreParsingTokens, param)) {
                    src = tmp.src;
                    param = tmp.param || param;
                } else {
                    tmp = getOwn(loc.parsingTokens, param) || getOwn(loc, param);
                    // Both the "months" array and the "month" parsing token can be accessed
                    // by either {month} or {months}, falling back as necessary, however
                    // regardless of whether or not a fallback occurs, the final field to
                    // be passed to addRawFormat must be normalized as singular.
                    param = param.replace(/s$/, "");
                    if (!tmp) tmp = getOwn(loc.parsingTokens, param) || getOwn(loc, param + "s");
                    if (isString(tmp)) {
                        src = tmp;
                        suffix = loc[param + "Suffix"];
                    } else {
                        // This is a hack to temporarily disallow parsing of single character
                        // weekdays until the format can be changed to allow for this.
                        if (param === "weekday" && loc.code === "ko") tmp = filter(tmp, function(str) {
                            return str.length > 1;
                        });
                        if (slice) tmp = filter(tmp, function(m, i) {
                            var mod = i % (loc.units ? 8 : tmp.length);
                            return mod >= slice[1] && mod <= (slice[2] || slice[1]);
                        });
                        src = arrayToRegAlternates(tmp);
                    }
                }
                if (!src) return "";
                if (nc) // Non-capturing tokens like {0}
                src = getRegNonCapturing(src);
                else {
                    // Capturing group and add to parsed tokens
                    to.push(param);
                    src = "(" + src + ")";
                }
                if (suffix) // Date/time suffixes such as those in CJK
                src = getParsingTokenWithSuffix(param, src, suffix);
                if (opt) src += "?";
                return src;
            }
            function formatToSrc(str) {
                // Make spaces optional
                str = str.replace(/ /g, " ?");
                str = str.replace(/\{([^,]+?)\}/g, function(match, token) {
                    var tokens = token.split("|");
                    if (tokens.length > 1) return getRegNonCapturing(map(tokens, getTokenSrc).join("|"));
                    else return getTokenSrc(token);
                });
                return str;
            }
            function parseInputFormat() {
                to = [];
                src = formatToSrc(format);
            }
            parseInputFormat();
            loc.addRawFormat(src, to);
        },
        addRawFormat: function addRawFormat(format, to) {
            this.compiledFormats.unshift({
                reg: RegExp("^ *" + format + " *$", "i"),
                to: to
            });
        },
        init: function init(def) {
            var loc = this;
            // -- Initialization helpers
            function initFormats() {
                loc.compiledFormats = [];
                loc.parsingAliases = {};
                loc.parsingTokens = {};
            }
            function initDefinition() {
                simpleMerge(loc, def);
            }
            function initArrayFields() {
                forEach(LOCALE_ARRAY_FIELDS, function(name) {
                    var val = loc[name];
                    if (isString(val)) loc[name] = commaSplit(val);
                    else if (!val) loc[name] = [];
                });
            }
            // -- Value array build helpers
            function buildValueArray(name, mod, map, fn) {
                var field = name, all = [], setMap;
                if (!loc[field]) field += "s";
                if (!map) {
                    map = {};
                    setMap = true;
                }
                forAllAlternates(field, function(alt, j, i) {
                    var idx = j * mod + i, val;
                    val = fn ? fn(i) : i;
                    map[alt] = val;
                    map[alt.toLowerCase()] = val;
                    all[idx] = alt;
                });
                loc[field] = all;
                if (setMap) loc[name + "Map"] = map;
            }
            function forAllAlternates(field, fn) {
                forEach(loc[field], function(str, i) {
                    forEachAlternate(str, function(alt, j) {
                        fn(alt, j, i);
                    });
                });
            }
            function forEachAlternate(str, fn) {
                var arr = map(str.split("+"), function(split) {
                    return split.replace(/(.+):(.+)$/, function(full, base, suffixes) {
                        return map(suffixes.split("|"), function(suffix) {
                            return base + suffix;
                        }).join("|");
                    });
                }).join("|");
                forEach(arr.split("|"), fn);
            }
            function buildNumerals() {
                var map = {};
                buildValueArray("numeral", 10, map);
                buildValueArray("article", 1, map, function() {
                    return 1;
                });
                buildValueArray("placeholder", 4, map, function(n) {
                    return pow(10, n + 1);
                });
                loc.numeralMap = map;
            }
            function buildTimeFormats() {
                loc.parsingAliases["time"] = getTimeFormat();
                loc.parsingAliases["tzOffset"] = getTZOffsetFormat();
            }
            function getTimeFormat(standalone) {
                var src, sep;
                sep = getTimeSeparatorSrc(standalone);
                if (loc.ampmFront) // "ampmFront" exists mostly for CJK locales, which also presume that
                // time suffixes exist, allowing this to be a simpler regex.
                src = "{ampm?} {hour} (?:{minute} (?::?{second})?)?";
                else if (loc.ampm.length) src = "{hour}(?:" + sep + "{minute?}(?:" + sep + "{second?})? {ampm?}| {ampm})";
                else src = "{hour}(?:" + sep + "{minute?}(?:" + sep + "{second?})?)";
                return src;
            }
            function getTimeSeparatorSrc() {
                if (loc.timeSeparator) return "[:" + loc.timeSeparator + "]";
                else return ":";
            }
            function getTZOffsetFormat() {
                return "(?:{Z}|{GMT?}(?:{tzHour}(?::?{tzMinute}(?: \\([\\w\\s]+\\))?)?)?)?";
            }
            function buildParsingTokens() {
                forEachProperty(LocalizedParsingTokens, function(token, name) {
                    var src = token.base ? getCoreTokensForBase(token.base) : token.src, arr;
                    if (token.requiresNumerals || loc.numeralUnits) src += getNumeralSrc();
                    arr = loc[name + "s"];
                    if (arr && arr.length) src += "|" + arrayToRegAlternates(arr);
                    loc.parsingTokens[name] = src;
                });
            }
            function getCoreTokensForBase(base) {
                return map(base.split("|"), function(key) {
                    return CoreParsingTokens[key].src;
                }).join("|");
            }
            function getNumeralSrc() {
                var all, src = "";
                all = loc.numerals.concat(loc.placeholders).concat(loc.articles);
                if (loc.allowsFullWidth) all = all.concat(fullWidthNumbers.split(""));
                if (all.length) src = "|(?:" + arrayToRegAlternates(all) + ")+";
                return src;
            }
            function buildTimeSuffixes() {
                iterateOverDateUnits(function(unit, i) {
                    var token = loc.timeSuffixes[i];
                    if (token) loc[(unit.alias || unit.name) + "Suffix"] = token;
                });
            }
            function buildModifiers() {
                forEach(loc.modifiers, function(modifier) {
                    var name = modifier.name, mapKey = name + "Map", map;
                    map = loc[mapKey] || {};
                    forEachAlternate(modifier.src, function(alt, j) {
                        var token = getOwn(loc.parsingTokens, name), val = modifier.value;
                        map[alt] = val;
                        loc.parsingTokens[name] = token ? token + "|" + alt : alt;
                        if (modifier.name === "sign" && j === 0) // Hooking in here to set the first "fromNow" or "ago" modifier
                        // directly on the locale, so that it can be reused in the
                        // relative format.
                        loc[val === 1 ? "fromNow" : "ago"] = alt;
                    });
                    loc[mapKey] = map;
                });
            }
            // -- Format adding helpers
            function addCoreFormats() {
                forEach(CoreParsingFormats, function(df) {
                    var src = df.src;
                    if (df.localeCheck && !df.localeCheck(loc)) return;
                    if (df.mdy && loc.mdy) // Use the mm/dd/yyyy variant if it
                    // exists and the locale requires it
                    src = df.mdy;
                    if (df.time) {
                        // Core formats that allow time require the time
                        // reg on both sides, so add both versions here.
                        loc.addFormat(getFormatWithTime(src, true));
                        loc.addFormat(getFormatWithTime(src));
                    } else loc.addFormat(src);
                });
                loc.addFormat("{time}");
            }
            function addLocaleFormats() {
                addFormatSet("parse");
                addFormatSet("timeParse", true);
                addFormatSet("timeFrontParse", true, true);
            }
            function addFormatSet(field, allowTime, timeFront) {
                forEach(loc[field], function(format) {
                    if (allowTime) format = getFormatWithTime(format, timeFront);
                    loc.addFormat(format);
                });
            }
            function getFormatWithTime(baseFormat, timeBefore) {
                if (timeBefore) return getTimeBefore() + baseFormat;
                return baseFormat + getTimeAfter();
            }
            function getTimeBefore() {
                return getRegNonCapturing("{time}[,\\s\\u3000]", true);
            }
            function getTimeAfter() {
                var markers = ",?[\\s\\u3000]", localized;
                localized = arrayToRegAlternates(loc.timeMarkers);
                if (localized) markers += "| (?:" + localized + ") ";
                markers = getRegNonCapturing(markers, loc.timeMarkerOptional);
                return getRegNonCapturing(markers + "{time}{tzOffset}", true);
            }
            initFormats();
            initDefinition();
            initArrayFields();
            buildValueArray("month", 12);
            buildValueArray("weekday", 7);
            buildValueArray("unit", 8);
            buildValueArray("ampm", 2);
            buildNumerals();
            buildTimeFormats();
            buildParsingTokens();
            buildTimeSuffixes();
            buildModifiers();
            // The order of these formats is important. Order is reversed so formats
            // that are initialized later will take precedence. Generally, this means
            // that more specific formats should come later.
            addCoreFormats();
            addLocaleFormats();
        }
    };
    return new Locale(def);
}
module.exports = getNewLocale;

},{"bdf4fbd619dbc461":"i2kiS","d6833d22e43d3687":"8oT1W","91e88fec44df3cf4":"3MdHv","d5a50d01f96c8df0":"clmFD","7ed1c535eda0933b":"2piqR","611f5ee79afc947d":"7WglA","85d05ce17aeacfd9":"j8KnV","e784310f8213f412":"JJnv7","1cb26c833d2c5d8e":"4cOOJ","4bce8f21a7c890a5":"ld65V","5711a8ac9114482d":"MTXUY","d9de64f4dbdbc166":"f1S5P","5b54b23d2cbc5559":"6oRAa","6f8cfb2bea9892b8":"e4HRg","fb3943766e4f0d95":"5cY7Z","8dda811c1bdd60fd":"9Yxdq","2879bc1c57795f4f":"b0yLe","5b0d3b3736207fbc":"8ZxTV","89c4138af1038e":"fuekz","f953f827a23913e2":"1IUQy","9981a6fd05e6d24f":"b0eEs","4ef24f6a18265858":"hJv6s","b4618acd1a62dace":"1NIra"}],"i2kiS":[function(require,module,exports) {
"use strict";
var LOCALE_ARRAY_FIELDS = [
    "months",
    "weekdays",
    "units",
    "numerals",
    "placeholders",
    "articles",
    "tokens",
    "timeMarkers",
    "ampm",
    "timeSuffixes",
    "parse",
    "timeParse",
    "timeFrontParse",
    "modifiers"
];
module.exports = LOCALE_ARRAY_FIELDS;

},{}],"8oT1W":[function(require,module,exports) {
"use strict";
module.exports = {
    ISO_FIRST_DAY_OF_WEEK: 1,
    ISO_FIRST_DAY_OF_WEEK_YEAR: 4
};

},{}],"3MdHv":[function(require,module,exports) {
"use strict";
var CoreParsingTokens = {
    "yyyy": {
        param: "year",
        src: "[-\u2212+]?\\d{4,6}"
    },
    "yy": {
        param: "year",
        src: "\\d{2}"
    },
    "y": {
        param: "year",
        src: "\\d"
    },
    "ayy": {
        param: "year",
        src: "'\\d{2}"
    },
    "MM": {
        param: "month",
        src: "(?:1[012]|0?[1-9])"
    },
    "dd": {
        param: "date",
        src: "(?:3[01]|[12][0-9]|0?[1-9])"
    },
    "hh": {
        param: "hour",
        src: "(?:2[0-4]|[01]?[0-9])"
    },
    "mm": {
        param: "minute",
        src: "[0-5]\\d"
    },
    "ss": {
        param: "second",
        src: "[0-5]\\d(?:[,.]\\d+)?"
    },
    "tzHour": {
        src: "[-\u2212+](?:2[0-4]|[01]?[0-9])"
    },
    "tzMinute": {
        src: "[0-5]\\d"
    },
    "iyyyy": {
        param: "year",
        src: "(?:[-\u2212+]?\\d{4}|[-\u2212+]\\d{5,6})"
    },
    "ihh": {
        param: "hour",
        src: "(?:2[0-4]|[01][0-9])(?:[,.]\\d+)?"
    },
    "imm": {
        param: "minute",
        src: "[0-5]\\d(?:[,.]\\d+)?"
    },
    "GMT": {
        param: "utc",
        src: "GMT"
    },
    "Z": {
        param: "utc",
        src: "Z"
    },
    "timestamp": {
        src: "\\d+"
    }
};
module.exports = CoreParsingTokens;

},{}],"clmFD":[function(require,module,exports) {
"use strict";
var CoreParsingFormats = [
    {
        // 12-1978
        // 08-1978 (MDY)
        src: "{MM}[-.\\/]{yyyy}"
    },
    {
        // 12/08/1978
        // 08/12/1978 (MDY)
        time: true,
        src: "{dd}[-\\/]{MM}(?:[-\\/]{yyyy|yy|y})?",
        mdy: "{MM}[-\\/]{dd}(?:[-\\/]{yyyy|yy|y})?"
    },
    {
        // 12.08.1978
        // 08.12.1978 (MDY)
        time: true,
        src: "{dd}\\.{MM}(?:\\.{yyyy|yy|y})?",
        mdy: "{MM}\\.{dd}(?:\\.{yyyy|yy|y})?",
        localeCheck: function localeCheck(loc) {
            // Do not allow this format if the locale
            // uses a period as a time separator.
            return loc.timeSeparator !== ".";
        }
    },
    {
        // 1975-08-25
        time: true,
        src: "{yyyy}[-.\\/]{MM}(?:[-.\\/]{dd})?"
    },
    {
        // .NET JSON
        src: "\\\\/Date\\({timestamp}(?:[-+]\\d{4,4})?\\)\\\\/"
    },
    {
        // ISO-8601
        src: "{iyyyy}(?:-?{MM}(?:-?{dd}(?:T{ihh}(?::?{imm}(?::?{ss})?)?)?)?)?{tzOffset?}"
    }
];
module.exports = CoreParsingFormats;

},{}],"2piqR":[function(require,module,exports) {
"use strict";
var LocalizedParsingTokens = {
    "year": {
        base: "yyyy|ayy",
        requiresSuffix: true
    },
    "month": {
        base: "MM",
        requiresSuffix: true
    },
    "date": {
        base: "dd",
        requiresSuffix: true
    },
    "hour": {
        base: "hh",
        requiresSuffixOr: ":"
    },
    "minute": {
        base: "mm"
    },
    "second": {
        base: "ss"
    },
    "num": {
        src: "\\d+",
        requiresNumerals: true
    }
};
module.exports = LocalizedParsingTokens;

},{}],"9Yxdq":[function(require,module,exports) {
"use strict";
function getArrayWithOffset(arr, n, alternate, offset) {
    var val;
    if (alternate > 1) val = arr[n + (alternate - 1) * offset];
    return val || arr[n];
}
module.exports = getArrayWithOffset;

},{}],"b0yLe":[function(require,module,exports) {
"use strict";
function getRegNonCapturing(src, opt) {
    if (src.length > 1) src = "(?:" + src + ")";
    if (opt) src += "?";
    return src;
}
module.exports = getRegNonCapturing;

},{}],"fuekz":[function(require,module,exports) {
"use strict";
var DateUnits = require("aeebc3c9ac7d3e24"), DateUnitIndexes = require("7f973577ecb69f0c"), isUndefined = require("9c20aabe81ba3350");
var YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function iterateOverDateUnits(fn, startIndex, endIndex) {
    endIndex = endIndex || 0;
    if (isUndefined(startIndex)) startIndex = YEAR_INDEX;
    for(var index = startIndex; index >= endIndex; index--){
        if (fn(DateUnits[index], index) === false) break;
    }
}
module.exports = iterateOverDateUnits;

},{"aeebc3c9ac7d3e24":"kFuUz","7f973577ecb69f0c":"ZayzA","9c20aabe81ba3350":"6oRAa"}],"kFuUz":[function(require,module,exports) {
"use strict";
var getDaysInMonth = require("6679d43949098467");
var DateUnits = [
    {
        name: "millisecond",
        method: "Milliseconds",
        multiplier: 1,
        start: 0,
        end: 999
    },
    {
        name: "second",
        method: "Seconds",
        multiplier: 1000,
        start: 0,
        end: 59
    },
    {
        name: "minute",
        method: "Minutes",
        multiplier: 60000,
        start: 0,
        end: 59
    },
    {
        name: "hour",
        method: "Hours",
        multiplier: 3600000,
        start: 0,
        end: 23
    },
    {
        name: "day",
        alias: "date",
        method: "Date",
        ambiguous: true,
        multiplier: 86400000,
        start: 1,
        end: function end(d) {
            return getDaysInMonth(d);
        }
    },
    {
        name: "week",
        method: "ISOWeek",
        ambiguous: true,
        multiplier: 604800000
    },
    {
        name: "month",
        method: "Month",
        ambiguous: true,
        multiplier: 2629800000,
        start: 0,
        end: 11
    },
    {
        name: "year",
        method: "FullYear",
        ambiguous: true,
        multiplier: 31557600000,
        start: 0
    }
];
module.exports = DateUnits;

},{"6679d43949098467":"kZCiZ"}],"kZCiZ":[function(require,module,exports) {
"use strict";
var getYear = require("1dd3195221660cf5"), getMonth = require("70dd94a1e6a2ea3d"), callDateGet = require("cdd17ffc5f7fee5b");
function getDaysInMonth(d) {
    return 32 - callDateGet(new Date(getYear(d), getMonth(d), 32), "Date");
}
module.exports = getDaysInMonth;

},{"1dd3195221660cf5":"id9WV","70dd94a1e6a2ea3d":"8e21l","cdd17ffc5f7fee5b":"5mOF6"}],"id9WV":[function(require,module,exports) {
"use strict";
var callDateGet = require("9b144579b1c85c65");
function getYear(d) {
    return callDateGet(d, "FullYear");
}
module.exports = getYear;

},{"9b144579b1c85c65":"5mOF6"}],"5mOF6":[function(require,module,exports) {
"use strict";
var _utc = require("6c06f3fe4831f3a0");
function callDateGet(d, method) {
    return d["get" + (_utc(d) ? "UTC" : "") + method]();
}
module.exports = callDateGet;

},{"6c06f3fe4831f3a0":"01lmY"}],"01lmY":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("d96b14efdc14f265");
module.exports = privatePropertyAccessor("utc");

},{"d96b14efdc14f265":"iz2DQ"}],"iz2DQ":[function(require,module,exports) {
"use strict";
var PRIVATE_PROP_PREFIX = require("86155793bd37efe6"), coreUtilityAliases = require("945beebe7e0477b6");
var setProperty = coreUtilityAliases.setProperty;
function privatePropertyAccessor(key) {
    var privateKey = PRIVATE_PROP_PREFIX + key;
    return function(obj, val) {
        if (arguments.length > 1) {
            setProperty(obj, privateKey, val);
            return obj;
        }
        return obj[privateKey];
    };
}
module.exports = privatePropertyAccessor;

},{"86155793bd37efe6":"7xLjL","945beebe7e0477b6":"8ZxTV"}],"7xLjL":[function(require,module,exports) {
"use strict";
module.exports = "_sugar_";

},{}],"8e21l":[function(require,module,exports) {
"use strict";
var callDateGet = require("ae485896e1037875");
function getMonth(d) {
    return callDateGet(d, "Month");
}
module.exports = getMonth;

},{"ae485896e1037875":"5mOF6"}],"ZayzA":[function(require,module,exports) {
"use strict";
module.exports = {
    HOURS_INDEX: 3,
    DAY_INDEX: 4,
    WEEK_INDEX: 5,
    MONTH_INDEX: 6,
    YEAR_INDEX: 7
};

},{}],"1IUQy":[function(require,module,exports) {
"use strict";
var map = require("d25ae011d4d97b31"), escapeRegExp = require("5f7b041cd7942be6");
function arrayToRegAlternates(arr) {
    var joined = arr.join("");
    if (!arr || !arr.length) return "";
    if (joined.length === arr.length) return "[" + joined + "]";
    // map handles sparse arrays so no need to compact the array here.
    return map(arr, escapeRegExp).join("|");
}
module.exports = arrayToRegAlternates;

},{"d25ae011d4d97b31":"7WglA","5f7b041cd7942be6":"6dbXB"}],"hJv6s":[function(require,module,exports) {
"use strict";
var trunc = require("b1b816191ea9b379"), withPrecision = require("4f0bc151301b0618"), getAdjustedUnit = require("c5e2cc7e99b92ba9");
function getAdjustedUnitForNumber(ms) {
    return getAdjustedUnit(ms, function(unit) {
        return trunc(withPrecision(ms / unit.multiplier, 1));
    });
}
module.exports = getAdjustedUnitForNumber;

},{"b1b816191ea9b379":"898n5","4f0bc151301b0618":"g1bJd","c5e2cc7e99b92ba9":"6UPEG"}],"6UPEG":[function(require,module,exports) {
"use strict";
var mathAliases = require("a32b7da360f422b9"), iterateOverDateUnits = require("61258a705149b26f");
var abs = mathAliases.abs;
function getAdjustedUnit(ms, fn) {
    var unitIndex = 0, value = 0;
    iterateOverDateUnits(function(unit, i) {
        value = abs(fn(unit));
        if (value >= 1) {
            unitIndex = i;
            return false;
        }
    });
    return [
        value,
        unitIndex,
        ms
    ];
}
module.exports = getAdjustedUnit;

},{"a32b7da360f422b9":"f1S5P","61258a705149b26f":"fuekz"}],"1NIra":[function(require,module,exports) {
"use strict";
var LocalizedParsingTokens = require("9258ac5f5e9e1988"), getRegNonCapturing = require("b4bca515ce09a30a");
function getParsingTokenWithSuffix(field, src, suffix) {
    var token = LocalizedParsingTokens[field];
    if (token.requiresSuffix) src = getRegNonCapturing(src + getRegNonCapturing(suffix));
    else if (token.requiresSuffixOr) src += getRegNonCapturing(token.requiresSuffixOr + "|" + suffix);
    else src += getRegNonCapturing(suffix, true);
    return src;
}
module.exports = getParsingTokenWithSuffix;

},{"9258ac5f5e9e1988":"2piqR","b4bca515ce09a30a":"b0yLe"}],"8SOdC":[function(require,module,exports) {
"use strict";
var Sugar = require("f8dd3606fc7e0a74"), createDate = require("92e9aeebbe5e13c5");
require("a4f4f241960a08ee");
Sugar.Date.defineStatic({
    "create": function(d, options) {
        return createDate(d, options);
    }
});
module.exports = Sugar.Date.create;

},{"f8dd3606fc7e0a74":"dZZfL","92e9aeebbe5e13c5":"4SmZz","a4f4f241960a08ee":"1XCfR"}],"4SmZz":[function(require,module,exports) {
"use strict";
var getExtendedDate = require("4b36a5b65289fe06");
function createDate(d, options, forceClone) {
    return getExtendedDate(null, d, options, forceClone).date;
}
module.exports = createDate;

},{"4b36a5b65289fe06":"eirnu"}],"eirnu":[function(require,module,exports) {
"use strict";
var MINUTES = require("c2a39e68daee2ff"), ABBREVIATED_YEAR_REG = require("dc8765fb1ef82656"), LocaleHelpers = require("c57858ddfbf0a88e"), DateUnitIndexes = require("ffc8e8ec8331fb74"), _utc = require("dde4a4c8d46e1da0"), trunc = require("bfa5eaeda64ca28a"), forEach = require("b089fdc72f8862db"), tzOffset = require("86408445d8287be6"), isDefined = require("ab5d1f8f30f90e3a"), resetTime = require("e664ad6581e7e20e"), getNewDate = require("c4e32d4c3983c93c"), updateDate = require("7716f3f41115baac"), setWeekday = require("ad83dfc9ad6e18cb"), simpleMerge = require("d12319af15404934"), advanceDate = require("e0a6558680e7f473"), isUndefined = require("d8d85a292c333597"), classChecks = require("cb2b1fb627ee4e31"), dateIsValid = require("251cfc6b0cfd13a7"), simpleClone = require("2b37e9266cef0986"), isObjectType = require("c8980e957e2a5419"), moveToEndOfUnit = require("fcbde43e06d7075c"), deleteDateParam = require("1c35601b8fe6dd64"), coreUtilityAliases = require("98be77f5ff9eacdb"), moveToBeginningOfUnit = require("4a29e7a9327863b7"), iterateOverDateParams = require("6651811681039a67"), getYearFromAbbreviation = require("5a94d67002c935c4"), iterateOverHigherDateParams = require("184bec055f40dcbf");
var isNumber = classChecks.isNumber, isString = classChecks.isString, isDate = classChecks.isDate, getOwn = coreUtilityAliases.getOwn, English = LocaleHelpers.English, localeManager = LocaleHelpers.localeManager, DAY_INDEX = DateUnitIndexes.DAY_INDEX, WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX, YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function getExtendedDate(contextDate, d, opt, forceClone) {
    // Locals
    var date, set, loc, afterCallbacks, relative, weekdayDir;
    // Options
    var optPrefer, optLocale, optFromUTC, optSetUTC, optParams, optClone;
    afterCallbacks = [];
    setupOptions(opt);
    function setupOptions(opt) {
        opt = isString(opt) ? {
            locale: opt
        } : opt || {};
        optPrefer = +!!getOwn(opt, "future") - +!!getOwn(opt, "past");
        optLocale = getOwn(opt, "locale");
        optFromUTC = getOwn(opt, "fromUTC");
        optSetUTC = getOwn(opt, "setUTC");
        optParams = getOwn(opt, "params");
        optClone = getOwn(opt, "clone");
    }
    function parseFormatValues(match, dif) {
        var set = optParams || {};
        forEach(dif.to, function(param, i) {
            var str = match[i + 1], val;
            if (!str) return;
            val = parseIrregular(str, param);
            if (isUndefined(val)) val = loc.parseValue(str, param);
            set[param] = val;
        });
        return set;
    }
    function parseIrregular(str, param) {
        if (param === "utc") return 1;
        else if (param === "year") {
            var match = str.match(ABBREVIATED_YEAR_REG);
            if (match) return getYearFromAbbreviation(match[1], date, optPrefer);
        }
    }
    // Force the UTC flags to be true if the source date
    // date is UTC, as they will be overwritten later.
    function cloneDateByFlag(d, clone) {
        if (_utc(d) && !isDefined(optFromUTC)) optFromUTC = true;
        if (_utc(d) && !isDefined(optSetUTC)) optSetUTC = true;
        if (clone) d = new Date(d.getTime());
        return d;
    }
    function afterDateSet(fn) {
        afterCallbacks.push(fn);
    }
    function fireCallbacks() {
        forEach(afterCallbacks, function(fn) {
            fn.call();
        });
    }
    function parseStringDate(str) {
        str = str.toLowerCase();
        // The act of getting the locale will initialize
        // if it is missing and add the required formats.
        loc = localeManager.get(optLocale);
        for(var i = 0, dif, match; dif = loc.compiledFormats[i]; i++){
            match = str.match(dif.reg);
            if (match) {
                // Note that caching the format will modify the compiledFormats array
                // which is not a good idea to do inside its for loop, however we
                // know at this point that we have a matched format and that we will
                // break out below, so simpler to do it here.
                loc.cacheFormat(dif, i);
                set = parseFormatValues(match, dif);
                if (isDefined(set.timestamp)) {
                    date.setTime(set.timestamp);
                    break;
                }
                if (isDefined(set.ampm)) handleAmpm(set.ampm);
                if (set.utc || isDefined(set.tzHour)) handleTimezoneOffset(set.tzHour, set.tzMinute);
                if (isDefined(set.shift) && isUndefined(set.unit)) // "next january", "next monday", etc
                handleUnitlessShift();
                if (isDefined(set.num) && isUndefined(set.unit)) // "the second of January", etc
                handleUnitlessNum(set.num);
                if (set.midday) // "noon" and "midnight"
                handleMidday(set.midday);
                if (isDefined(set.day)) // Relative day localizations such as "today" and "tomorrow".
                handleRelativeDay(set.day);
                if (isDefined(set.unit)) // "3 days ago", etc
                handleRelativeUnit(set.unit);
                if (set.edge) // "the end of January", etc
                handleEdge(set.edge, set);
                break;
            }
        }
        if (!set) {
            // TODO: remove in next major version
            // Fall back to native parsing
            date = new Date(str);
            if (optFromUTC && dateIsValid(date)) // Falling back to system date here which cannot be parsed as UTC,
            // so if we're forcing UTC then simply add the offset.
            date.setTime(date.getTime() + tzOffset(date) * MINUTES);
        } else if (relative) updateDate(date, set, false, 1);
        else updateDate(date, set, true, 0, optPrefer, weekdayDir, contextDate);
        fireCallbacks();
        return date;
    }
    function handleAmpm(ampm) {
        if (ampm === 1 && set.hour < 12) // If the time is 1pm-11pm advance the time by 12 hours.
        set.hour += 12;
        else if (ampm === 0 && set.hour === 12) // If it is 12:00am then set the hour to 0.
        set.hour = 0;
    }
    function handleTimezoneOffset(tzHour, tzMinute) {
        // Adjust for timezone offset
        _utc(date, true);
        // Sign is parsed as part of the hour, so flip
        // the minutes if it's negative.
        if (tzHour < 0) tzMinute *= -1;
        var offset = tzHour * 60 + (tzMinute || 0);
        if (offset) set.minute = (set.minute || 0) - offset;
    }
    function handleUnitlessShift() {
        if (isDefined(set.month)) // "next January"
        set.unit = YEAR_INDEX;
        else if (isDefined(set.weekday)) // "next Monday"
        set.unit = WEEK_INDEX;
    }
    function handleUnitlessNum(num) {
        if (isDefined(set.weekday)) // "The second Tuesday of March"
        setOrdinalWeekday(num);
        else if (isDefined(set.month)) // "The second of March"
        set.date = set.num;
    }
    function handleMidday(hour) {
        set.hour = hour % 24;
        if (hour > 23) // If the date has hours past 24, we need to prevent it from traversing
        // into a new day as that would make it being part of a new week in
        // ambiguous dates such as "Monday".
        afterDateSet(function() {
            advanceDate(date, "date", trunc(hour / 24));
        });
    }
    function handleRelativeDay() {
        resetTime(date);
        if (isUndefined(set.unit)) {
            set.unit = DAY_INDEX;
            set.num = set.day;
            delete set.day;
        }
    }
    function handleRelativeUnit(unitIndex) {
        var num;
        if (isDefined(set.num)) num = set.num;
        else if (isDefined(set.edge) && isUndefined(set.shift)) num = 0;
        else num = 1;
        // If a weekday is defined, there are 3 possible formats being applied:
        //
        // 1. "the day after monday": unit is days
        // 2. "next monday": short for "next week monday", unit is weeks
        // 3. "the 2nd monday of next month": unit is months
        //
        // In the first case, we need to set the weekday up front, as the day is
        // relative to it. The second case also needs to be handled up front for
        // formats like "next monday at midnight" which will have its weekday reset
        // if not set up front. The last case will set up the params necessary to
        // shift the weekday and allow separateAbsoluteUnits below to handle setting
        // it after the date has been shifted.
        if (isDefined(set.weekday)) {
            if (unitIndex === MONTH_INDEX) {
                setOrdinalWeekday(num);
                num = 1;
            } else {
                updateDate(date, {
                    weekday: set.weekday
                }, true);
                delete set.weekday;
            }
        }
        if (set.half) // Allow localized "half" as a standalone colloquialism. Purposely avoiding
        // the locale number system to reduce complexity. The units "month" and
        // "week" are purposely excluded in the English date formats below, as
        // "half a week" and "half a month" are meaningless as exact dates.
        num *= set.half;
        if (isDefined(set.shift)) // Shift and unit, ie "next month", "last week", etc.
        num *= set.shift;
        else if (set.sign) // Unit and sign, ie "months ago", "weeks from now", etc.
        num *= set.sign;
        if (isDefined(set.day)) {
            // "the day after tomorrow"
            num += set.day;
            delete set.day;
        }
        // Formats like "the 15th of last month" or "6:30pm of next week"
        // contain absolute units in addition to relative ones, so separate
        // them here, remove them from the params, and set up a callback to
        // set them after the relative ones have been set.
        separateAbsoluteUnits(unitIndex);
        // Finally shift the unit.
        set[English.units[unitIndex]] = num;
        relative = true;
    }
    function handleEdge(edge, params) {
        var edgeIndex = params.unit, weekdayOfMonth;
        if (!edgeIndex) // If we have "the end of January", then we need to find the unit index.
        iterateOverHigherDateParams(params, function(unitName, val, unit, i) {
            if (unitName === "weekday" && isDefined(params.month)) // If both a month and weekday exist, then we have a format like
            // "the last tuesday in November, 2012", where the "last" is still
            // relative to the end of the month, so prevent the unit "weekday"
            // from taking over.
            return;
            edgeIndex = i;
        });
        if (edgeIndex === MONTH_INDEX && isDefined(params.weekday)) {
            // If a weekday in a month exists (as described above),
            // then set it up to be set after the date has been shifted.
            weekdayOfMonth = params.weekday;
            delete params.weekday;
        }
        afterDateSet(function() {
            var stopIndex;
            // "edge" values that are at the very edge are "2" so the beginning of the
            // year is -2 and the end of the year is 2. Conversely, the "last day" is
            // actually 00:00am so it is 1. -1 is reserved but unused for now.
            if (edge < 0) moveToBeginningOfUnit(date, edgeIndex, optLocale);
            else if (edge > 0) {
                if (edge === 1) {
                    stopIndex = DAY_INDEX;
                    moveToBeginningOfUnit(date, DAY_INDEX);
                }
                moveToEndOfUnit(date, edgeIndex, optLocale, stopIndex);
            }
            if (isDefined(weekdayOfMonth)) {
                setWeekday(date, weekdayOfMonth, -edge);
                resetTime(date);
            }
        });
        if (edgeIndex === MONTH_INDEX) params.specificity = DAY_INDEX;
        else params.specificity = edgeIndex - 1;
    }
    function setOrdinalWeekday(num) {
        // If we have "the 2nd Tuesday of June", then pass the "weekdayDir"
        // flag along to updateDate so that the date does not accidentally traverse
        // into the previous month. This needs to be independent of the "prefer"
        // flag because we are only ensuring that the weekday is in the future, not
        // the entire date.
        set.weekday = 7 * (num - 1) + set.weekday;
        set.date = 1;
        weekdayDir = 1;
    }
    function separateAbsoluteUnits(unitIndex) {
        var params;
        iterateOverDateParams(set, function(name, val, unit, i) {
            // If there is a time unit set that is more specific than
            // the matched unit we have a string like "5:30am in 2 minutes",
            // which is meaningless, so invalidate the date...
            if (i >= unitIndex) {
                date.setTime(NaN);
                return false;
            } else if (i < unitIndex) {
                // ...otherwise set the params to set the absolute date
                // as a callback after the relative date has been set.
                params = params || {};
                params[name] = val;
                deleteDateParam(set, name);
            }
        });
        if (params) {
            afterDateSet(function() {
                updateDate(date, params, true, 0, false, weekdayDir);
                if (optParams) simpleMerge(optParams, params);
            });
            if (set.edge) {
                // "the end of March of next year"
                handleEdge(set.edge, params);
                delete set.edge;
            }
        }
    }
    if (contextDate && d) // If a context date is passed ("get" and "unitsFromNow"),
    // then use it as the starting point.
    date = cloneDateByFlag(contextDate, true);
    else date = getNewDate();
    _utc(date, optFromUTC);
    if (isString(d)) date = parseStringDate(d);
    else if (isDate(d)) date = cloneDateByFlag(d, optClone || forceClone);
    else if (isObjectType(d)) {
        set = simpleClone(d);
        updateDate(date, set, true);
    } else if (isNumber(d) || d === null) date.setTime(d);
    // A date created by parsing a string presumes that the format *itself* is
    // UTC, but not that the date, once created, should be manipulated as such. In
    // other words, if you are creating a date object from a server time
    // "2012-11-15T12:00:00Z", in the majority of cases you are using it to create
    // a date that will, after creation, be manipulated as local, so reset the utc
    // flag here unless "setUTC" is also set.
    _utc(date, !!optSetUTC);
    return {
        set: set,
        date: date
    };
}
module.exports = getExtendedDate;

},{"c2a39e68daee2ff":"iDlFg","dc8765fb1ef82656":"88sTZ","c57858ddfbf0a88e":"hlra3","ffc8e8ec8331fb74":"ZayzA","dde4a4c8d46e1da0":"01lmY","bfa5eaeda64ca28a":"898n5","b089fdc72f8862db":"JJnv7","86408445d8287be6":"7uIyU","ab5d1f8f30f90e3a":"4cOOJ","e664ad6581e7e20e":"1RhqH","c4e32d4c3983c93c":"bARv2","7716f3f41115baac":"9gLzt","ad83dfc9ad6e18cb":"a9tBU","d12319af15404934":"e4HRg","e0a6558680e7f473":"58alG","d8d85a292c333597":"6oRAa","cb2b1fb627ee4e31":"MTXUY","251cfc6b0cfd13a7":"iVwwI","2b37e9266cef0986":"glUlC","c8980e957e2a5419":"1dImj","fcbde43e06d7075c":"3fWCU","1c35601b8fe6dd64":"8v9mR","98be77f5ff9eacdb":"8ZxTV","4a29e7a9327863b7":"fpOPw","6651811681039a67":"gjSqr","5a94d67002c935c4":"8wPit","184bec055f40dcbf":"59zuW"}],"iDlFg":[function(require,module,exports) {
"use strict";
module.exports = 60000;

},{}],"88sTZ":[function(require,module,exports) {
"use strict";
module.exports = /^'?(\d{1,2})$/;

},{}],"7uIyU":[function(require,module,exports) {
"use strict";
function tzOffset(d) {
    return d.getTimezoneOffset();
}
module.exports = tzOffset;

},{}],"1RhqH":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("433a326a0bad8d59"), setUnitAndLowerToEdge = require("dca1397e3c970a1f");
var HOURS_INDEX = DateUnitIndexes.HOURS_INDEX;
function resetTime(d) {
    return setUnitAndLowerToEdge(d, HOURS_INDEX);
}
module.exports = resetTime;

},{"433a326a0bad8d59":"ZayzA","dca1397e3c970a1f":"fGenX"}],"fGenX":[function(require,module,exports) {
"use strict";
var isDefined = require("b8a37b67d6692c2b"), classChecks = require("5e2dfff5f0d36932"), callDateSet = require("6d591be38df4fad"), walkUnitDown = require("11722b4d2b2efbf3");
var isFunction = classChecks.isFunction;
function setUnitAndLowerToEdge(d, startIndex, stopIndex, end) {
    walkUnitDown(startIndex, function(unit, i) {
        var val = end ? unit.end : unit.start;
        if (isFunction(val)) val = val(d);
        callDateSet(d, unit.method, val);
        return !isDefined(stopIndex) || i > stopIndex;
    });
    return d;
}
module.exports = setUnitAndLowerToEdge;

},{"b8a37b67d6692c2b":"4cOOJ","5e2dfff5f0d36932":"MTXUY","6d591be38df4fad":"9L8cf","11722b4d2b2efbf3":"66gTa"}],"9L8cf":[function(require,module,exports) {
"use strict";
var _utc = require("5946ff7f0d6478c6"), callDateGet = require("491e60896be8309c");
function callDateSet(d, method, value, safe) {
    // "Safe" denotes not setting the date if the value is the same as what is
    // currently set. In theory this should be a noop, however it will cause
    // timezone shifts when in the middle of a DST fallback. This is unavoidable
    // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
    // November 1st, 2015 in northern hemisphere timezones that follow DST),
    // however when advancing or rewinding dates this can throw off calculations
    // so avoiding this unintentional shifting on an opt-in basis.
    if (safe && value === callDateGet(d, method, value)) return;
    d["set" + (_utc(d) ? "UTC" : "") + method](value);
}
module.exports = callDateSet;

},{"5946ff7f0d6478c6":"01lmY","491e60896be8309c":"5mOF6"}],"66gTa":[function(require,module,exports) {
"use strict";
var DateUnits = require("13ca9a53f0b10d37"), getLowerUnitIndex = require("a6c583e83613ee7a");
function walkUnitDown(unitIndex, fn) {
    while(unitIndex >= 0){
        if (fn(DateUnits[unitIndex], unitIndex) === false) break;
        unitIndex = getLowerUnitIndex(unitIndex);
    }
}
module.exports = walkUnitDown;

},{"13ca9a53f0b10d37":"kFuUz","a6c583e83613ee7a":"34E6v"}],"34E6v":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("30c60fa19c6016da");
var HOURS_INDEX = DateUnitIndexes.HOURS_INDEX, DAY_INDEX = DateUnitIndexes.DAY_INDEX, WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function getLowerUnitIndex(index) {
    if (index === MONTH_INDEX) return DAY_INDEX;
    else if (index === WEEK_INDEX) return HOURS_INDEX;
    return index - 1;
}
module.exports = getLowerUnitIndex;

},{"30c60fa19c6016da":"ZayzA"}],"bARv2":[function(require,module,exports) {
"use strict";
var _dateOptions = require("bcdffa539a3d5cda");
function getNewDate() {
    return _dateOptions("newDateInternal")();
}
module.exports = getNewDate;

},{"bcdffa539a3d5cda":"c2zac"}],"c2zac":[function(require,module,exports) {
"use strict";
var DATE_OPTIONS = require("d1dad8331ea16d9e"), namespaceAliases = require("74ff73320436ce81"), defineOptionsAccessor = require("30f07716bdc9e858");
var sugarDate = namespaceAliases.sugarDate;
module.exports = defineOptionsAccessor(sugarDate, DATE_OPTIONS);

},{"d1dad8331ea16d9e":"jqZv3","74ff73320436ce81":"4onj1","30f07716bdc9e858":"cfSYO"}],"jqZv3":[function(require,module,exports) {
"use strict";
var defaultNewDate = require("53bc74790a88b744");
var DATE_OPTIONS = {
    "newDateInternal": defaultNewDate
};
module.exports = DATE_OPTIONS;

},{"53bc74790a88b744":"3jW1C"}],"3jW1C":[function(require,module,exports) {
"use strict";
function defaultNewDate() {
    return new Date;
}
module.exports = defaultNewDate;

},{}],"9gLzt":[function(require,module,exports) {
"use strict";
var DateUnits = require("8c36322f44861a20"), DateUnitIndexes = require("21b936d13cbca135"), trunc = require("4381f58739325cbf"), setDate = require("c69f390ca3cf8497"), getDate = require("1185ceed0d221e76"), getMonth = require("adbd0f7eb8e3637e"), getNewDate = require("62efc7777f3b72b6"), setWeekday = require("b12203ddb050b929"), mathAliases = require("b422d3f3f5de59b4"), callDateGet = require("d2d40dacac094a7e"), classChecks = require("2fd82b8b0e825aba"), resetLowerUnits = require("e507fdf07a06b34d"), getLowerUnitIndex = require("e3d3dffec3c8a5db"), getHigherUnitIndex = require("51c1d7c496dc1403"), callDateSetWithWeek = require("68ffebb2906c7444"), iterateOverDateParams = require("72195ead9ae4357d");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX, WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX, YEAR_INDEX = DateUnitIndexes.YEAR_INDEX, round = mathAliases.round, isNumber = classChecks.isNumber;
function updateDate(d, params, reset, advance, prefer, weekdayDir, contextDate) {
    var upperUnitIndex;
    function setUpperUnit(unitName, unitIndex) {
        if (prefer && !upperUnitIndex) {
            if (unitName === "weekday") upperUnitIndex = WEEK_INDEX;
            else upperUnitIndex = getHigherUnitIndex(unitIndex);
        }
    }
    function setSpecificity(unitIndex) {
        // Other functions may preemptively set the specificity before arriving
        // here so concede to them if they have already set more specific units.
        if (unitIndex > params.specificity) return;
        params.specificity = unitIndex;
    }
    function canDisambiguate() {
        if (!upperUnitIndex || upperUnitIndex > YEAR_INDEX) return;
        switch(prefer){
            case -1:
                return d >= (contextDate || getNewDate());
            case 1:
                return d <= (contextDate || getNewDate());
        }
    }
    function disambiguateHigherUnit() {
        var unit = DateUnits[upperUnitIndex];
        advance = prefer;
        setUnit(unit.name, 1, unit, upperUnitIndex);
    }
    function handleFraction(unit, unitIndex, fraction) {
        if (unitIndex) {
            var lowerUnit = DateUnits[getLowerUnitIndex(unitIndex)];
            var val = round(unit.multiplier / lowerUnit.multiplier * fraction);
            params[lowerUnit.name] = val;
        }
    }
    function monthHasShifted(d, targetMonth) {
        if (targetMonth < 0) targetMonth = targetMonth % 12 + 12;
        return targetMonth % 12 !== getMonth(d);
    }
    function setUnit(unitName, value, unit, unitIndex) {
        var method = unit.method, checkMonth, fraction;
        setUpperUnit(unitName, unitIndex);
        setSpecificity(unitIndex);
        fraction = value % 1;
        if (fraction) {
            handleFraction(unit, unitIndex, fraction);
            value = trunc(value);
        }
        if (unitName === "weekday") {
            if (!advance) // Weekdays are always considered absolute units so simply set them
            // here even if it is an "advance" operation. This is to help avoid
            // ambiguous meanings in "advance" as well as to neatly allow formats
            // like "Wednesday of next week" without more complex logic.
            setWeekday(d, value, weekdayDir);
            return;
        }
        checkMonth = unitIndex === MONTH_INDEX && getDate(d) > 28;
        // If we are advancing or rewinding, then we need we need to set the
        // absolute time if the unit is "hours" or less. This is due to the fact
        // that setting by method is ambiguous during DST shifts. For example,
        // 1:00am on November 1st 2015 occurs twice in North American timezones
        // with DST, the second time being after the clocks are rolled back at
        // 2:00am. When springing forward this is automatically handled as there
        // is no 2:00am so the date automatically jumps to 3:00am. However, when
        // rolling back, setHours(2) will always choose the first "2am" even if
        // the date is currently set to the second, causing unintended jumps.
        // This ambiguity is unavoidable when setting dates as the notation is
        // ambiguous. However when advancing, we clearly want the resulting date
        // to be an acutal hour ahead, which can only be accomplished by setting
        // the absolute time. Conversely, any unit higher than "hours" MUST use
        // the internal set methods, as they are ambiguous as absolute units of
        // time. Years may be 365 or 366 days depending on leap years, months are
        // all over the place, and even days may be 23-25 hours depending on DST
        // shifts. Finally, note that the kind of jumping described above will
        // occur when calling ANY "set" method on the date and will occur even if
        // the value being set is identical to the one currently set (i.e.
        // setHours(2) on a date at 2am may not be a noop). This is precarious,
        // so avoiding this situation in callDateSet by checking up front that
        // the value is not the same before setting.
        if (advance && !unit.ambiguous) {
            d.setTime(d.getTime() + value * advance * unit.multiplier);
            return;
        } else if (advance) {
            if (unitIndex === WEEK_INDEX) {
                value *= 7;
                method = DateUnits[DAY_INDEX].method;
            }
            value = value * advance + callDateGet(d, method);
        }
        callDateSetWithWeek(d, method, value, advance);
        if (checkMonth && monthHasShifted(d, value)) // As we are setting the units in reverse order, there is a chance that
        // our date may accidentally traverse into a new month, such as setting
        // { month: 1, date 15 } on January 31st. Check for this here and reset
        // the date to the last day of the previous month if this has happened.
        setDate(d, 0);
    }
    if (isNumber(params) && advance) // If param is a number and advancing, the number is in milliseconds.
    params = {
        millisecond: params
    };
    else if (isNumber(params)) {
        // Otherwise just set the timestamp and return.
        d.setTime(params);
        return d;
    }
    iterateOverDateParams(params, setUnit);
    if (reset && params.specificity) resetLowerUnits(d, params.specificity);
    // If past or future is preferred, then the process of "disambiguation" will
    // ensure that an ambiguous time/date ("4pm", "thursday", "June", etc.) will
    // be in the past or future. Weeks are only considered ambiguous if there is
    // a weekday, i.e. "thursday" is an ambiguous week, but "the 4th" is an
    // ambiguous month.
    if (canDisambiguate()) disambiguateHigherUnit();
    return d;
}
module.exports = updateDate;

},{"8c36322f44861a20":"kFuUz","21b936d13cbca135":"ZayzA","4381f58739325cbf":"898n5","c69f390ca3cf8497":"euZpm","1185ceed0d221e76":"5ATC1","adbd0f7eb8e3637e":"8e21l","62efc7777f3b72b6":"bARv2","b12203ddb050b929":"a9tBU","b422d3f3f5de59b4":"f1S5P","d2d40dacac094a7e":"5mOF6","2fd82b8b0e825aba":"MTXUY","e507fdf07a06b34d":"d8ade","e3d3dffec3c8a5db":"34E6v","51c1d7c496dc1403":"79ion","68ffebb2906c7444":"facp8","72195ead9ae4357d":"gjSqr"}],"euZpm":[function(require,module,exports) {
"use strict";
var callDateSet = require("87d9d74f135f96f4");
function setDate(d, val) {
    callDateSet(d, "Date", val);
}
module.exports = setDate;

},{"87d9d74f135f96f4":"9L8cf"}],"5ATC1":[function(require,module,exports) {
"use strict";
var callDateGet = require("6aa23d15298b11");
function getDate(d) {
    return callDateGet(d, "Date");
}
module.exports = getDate;

},{"6aa23d15298b11":"5mOF6"}],"a9tBU":[function(require,module,exports) {
"use strict";
var setDate = require("9969fb0e10f74ecb"), getDate = require("47b522f0523a7d86"), getWeekday = require("eae724a17d2446f"), classChecks = require("f02ebbc0a1de7494"), mathAliases = require("8a343d1ec1e58b1b");
var isNumber = classChecks.isNumber, abs = mathAliases.abs;
function setWeekday(d, dow, dir) {
    if (!isNumber(dow)) return;
    var currentWeekday = getWeekday(d);
    if (dir) {
        // Allow a "direction" parameter to determine whether a weekday can
        // be set beyond the current weekday in either direction.
        var ndir = dir > 0 ? 1 : -1;
        var offset = dow % 7 - currentWeekday;
        if (offset && offset / abs(offset) !== ndir) dow += 7 * ndir;
    }
    setDate(d, getDate(d) + dow - currentWeekday);
    return d.getTime();
}
module.exports = setWeekday;

},{"9969fb0e10f74ecb":"euZpm","47b522f0523a7d86":"5ATC1","eae724a17d2446f":"F9hrY","f02ebbc0a1de7494":"MTXUY","8a343d1ec1e58b1b":"f1S5P"}],"F9hrY":[function(require,module,exports) {
"use strict";
var callDateGet = require("7ecfd8c748264d67");
function getWeekday(d) {
    return callDateGet(d, "Day");
}
module.exports = getWeekday;

},{"7ecfd8c748264d67":"5mOF6"}],"d8ade":[function(require,module,exports) {
"use strict";
var getLowerUnitIndex = require("ffbfcfa4cc343419"), setUnitAndLowerToEdge = require("99a94de38ee497e7");
function resetLowerUnits(d, unitIndex) {
    return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex));
}
module.exports = resetLowerUnits;

},{"ffbfcfa4cc343419":"34E6v","99a94de38ee497e7":"fGenX"}],"79ion":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("63d395a2c471f66f");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function getHigherUnitIndex(index) {
    return index === DAY_INDEX ? MONTH_INDEX : index + 1;
}
module.exports = getHigherUnitIndex;

},{"63d395a2c471f66f":"ZayzA"}],"facp8":[function(require,module,exports) {
"use strict";
var callDateSet = require("db5058545eb9d733"), setISOWeekNumber = require("23e66b5ebd8095b5");
function callDateSetWithWeek(d, method, value, safe) {
    if (method === "ISOWeek") setISOWeekNumber(d, value);
    else callDateSet(d, method, value, safe);
}
module.exports = callDateSetWithWeek;

},{"db5058545eb9d733":"9L8cf","23e66b5ebd8095b5":"8Ah5E"}],"8Ah5E":[function(require,module,exports) {
"use strict";
var ISODefaults = require("f6e0033ac364a101"), getDate = require("92e7caba527b1043"), setDate = require("5affe44df36b55be"), setYear = require("5e64db2f5fe4edb3"), getYear = require("3b0d650c3055844c"), getMonth = require("288604bdbbdd0b22"), setMonth = require("c9e9dda90e5f81ce"), cloneDate = require("ee34ead873ba6a41"), getWeekday = require("e481ec4deedf5d29"), setWeekday = require("fb6f3c470e5efa83"), classChecks = require("37a74a21400cb84f"), moveToFirstDayOfWeekYear = require("31f1f960f1a27382");
var isNumber = classChecks.isNumber, ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR;
function setISOWeekNumber(d, num) {
    if (isNumber(num)) {
        // Intentionally avoiding updateDate here to prevent circular dependencies.
        var isoWeek = cloneDate(d), dow = getWeekday(d);
        moveToFirstDayOfWeekYear(isoWeek, ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR);
        setDate(isoWeek, getDate(isoWeek) + 7 * (num - 1));
        setYear(d, getYear(isoWeek));
        setMonth(d, getMonth(isoWeek));
        setDate(d, getDate(isoWeek));
        setWeekday(d, dow || 7);
    }
    return d.getTime();
}
module.exports = setISOWeekNumber;

},{"f6e0033ac364a101":"8oT1W","92e7caba527b1043":"5ATC1","5affe44df36b55be":"euZpm","5e64db2f5fe4edb3":"6gPHx","3b0d650c3055844c":"id9WV","288604bdbbdd0b22":"8e21l","c9e9dda90e5f81ce":"bGuBj","ee34ead873ba6a41":"lvF4j","e481ec4deedf5d29":"F9hrY","fb6f3c470e5efa83":"a9tBU","37a74a21400cb84f":"MTXUY","31f1f960f1a27382":"3F5wL"}],"6gPHx":[function(require,module,exports) {
"use strict";
var callDateSet = require("e3f4869d0595c329");
function setYear(d, val) {
    callDateSet(d, "FullYear", val);
}
module.exports = setYear;

},{"e3f4869d0595c329":"9L8cf"}],"bGuBj":[function(require,module,exports) {
"use strict";
var callDateSet = require("70979d71f10adf4f");
function setMonth(d, val) {
    callDateSet(d, "Month", val);
}
module.exports = setMonth;

},{"70979d71f10adf4f":"9L8cf"}],"lvF4j":[function(require,module,exports) {
"use strict";
var _utc = require("eec806cdbd31e1e3");
function cloneDate(d) {
    // Rhino environments have a bug where new Date(d) truncates
    // milliseconds so need to call getTime() here.
    var clone = new Date(d.getTime());
    _utc(clone, !!_utc(d));
    return clone;
}
module.exports = cloneDate;

},{"eec806cdbd31e1e3":"01lmY"}],"3F5wL":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("82aac8c07d002fc5"), setDate = require("c2e94bfc69ab790b"), setUnitAndLowerToEdge = require("5d16b16b1c07be58"), moveToBeginningOfWeek = require("c29c2ba03847528c");
var MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function moveToFirstDayOfWeekYear(d, firstDayOfWeek, firstDayOfWeekYear) {
    setUnitAndLowerToEdge(d, MONTH_INDEX);
    setDate(d, firstDayOfWeekYear);
    moveToBeginningOfWeek(d, firstDayOfWeek);
}
module.exports = moveToFirstDayOfWeekYear;

},{"82aac8c07d002fc5":"ZayzA","c2e94bfc69ab790b":"euZpm","5d16b16b1c07be58":"fGenX","c29c2ba03847528c":"dcxiC"}],"dcxiC":[function(require,module,exports) {
"use strict";
var setWeekday = require("94325bd88789aee5"), getWeekday = require("e74a79cee3b8db05"), mathAliases = require("c2c275250a0ba5d3");
var floor = mathAliases.floor;
function moveToBeginningOfWeek(d, firstDayOfWeek) {
    setWeekday(d, floor((getWeekday(d) - firstDayOfWeek) / 7) * 7 + firstDayOfWeek);
    return d;
}
module.exports = moveToBeginningOfWeek;

},{"94325bd88789aee5":"a9tBU","e74a79cee3b8db05":"F9hrY","c2c275250a0ba5d3":"f1S5P"}],"gjSqr":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("b1445e9a0a624c6"), isDefined = require("884db964f6f59560"), getDateParam = require("994d91db7d65bb4c"), iterateOverDateUnits = require("e908c96e4f94a42f");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
function iterateOverDateParams(params, fn, startIndex, endIndex) {
    function run(name, unit, i) {
        var val = getDateParam(params, name);
        if (isDefined(val)) fn(name, val, unit, i);
    }
    iterateOverDateUnits(function(unit, i) {
        var result = run(unit.name, unit, i);
        if (result !== false && i === DAY_INDEX) // Check for "weekday", which has a distinct meaning
        // in the context of setting a date, but has the same
        // meaning as "day" as a unit of time.
        result = run("weekday", unit, i);
        return result;
    }, startIndex, endIndex);
}
module.exports = iterateOverDateParams;

},{"b1445e9a0a624c6":"ZayzA","884db964f6f59560":"4cOOJ","994d91db7d65bb4c":"OXq2u","e908c96e4f94a42f":"fuekz"}],"OXq2u":[function(require,module,exports) {
"use strict";
var getDateParamKey = require("b865ab90824bf878"), coreUtilityAliases = require("e97efaf7712bed1e");
var getOwn = coreUtilityAliases.getOwn;
function getDateParam(params, key) {
    return getOwn(params, getDateParamKey(params, key));
}
module.exports = getDateParam;

},{"b865ab90824bf878":"4ydQb","e97efaf7712bed1e":"8ZxTV"}],"4ydQb":[function(require,module,exports) {
"use strict";
var getOwnKey = require("182c96182ac9a592");
function getDateParamKey(params, key) {
    return getOwnKey(params, key) || getOwnKey(params, key + "s") || key === "day" && getOwnKey(params, "date");
}
module.exports = getDateParamKey;

},{"182c96182ac9a592":"iry9b"}],"iry9b":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("43bcd87533c51d4a");
var hasOwn = coreUtilityAliases.hasOwn;
function getOwnKey(obj, key) {
    if (hasOwn(obj, key)) return key;
}
module.exports = getOwnKey;

},{"43bcd87533c51d4a":"8ZxTV"}],"58alG":[function(require,module,exports) {
"use strict";
var updateDate = require("4d8e0c5ec7296107");
function advanceDate(d, unit, num, reset) {
    var set = {};
    set[unit] = num;
    return updateDate(d, set, reset, 1);
}
module.exports = advanceDate;

},{"4d8e0c5ec7296107":"9gLzt"}],"iVwwI":[function(require,module,exports) {
"use strict";
function dateIsValid(d) {
    return !isNaN(d.getTime());
}
module.exports = dateIsValid;

},{}],"3fWCU":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("5d29110c40086822"), DateUnitIndexes = require("1f12f091bc71dd19"), moveToEndOfWeek = require("14059dcf1dc4860b"), getLowerUnitIndex = require("872219fea7e0ccd"), setUnitAndLowerToEdge = require("4bede295dbddd5c");
var WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, localeManager = LocaleHelpers.localeManager;
function moveToEndOfUnit(d, unitIndex, localeCode, stopIndex) {
    if (unitIndex === WEEK_INDEX) moveToEndOfWeek(d, localeManager.get(localeCode).getFirstDayOfWeek());
    return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex), stopIndex, true);
}
module.exports = moveToEndOfUnit;

},{"5d29110c40086822":"hlra3","1f12f091bc71dd19":"ZayzA","14059dcf1dc4860b":"9ajiG","872219fea7e0ccd":"34E6v","4bede295dbddd5c":"fGenX"}],"9ajiG":[function(require,module,exports) {
"use strict";
var setWeekday = require("37fbb8e8dfcf9386"), getWeekday = require("ee1859fd972e2610"), mathAliases = require("bd73a7da082c021c");
var ceil = mathAliases.ceil;
function moveToEndOfWeek(d, firstDayOfWeek) {
    var target = firstDayOfWeek - 1;
    setWeekday(d, ceil((getWeekday(d) - target) / 7) * 7 + target);
    return d;
}
module.exports = moveToEndOfWeek;

},{"37fbb8e8dfcf9386":"a9tBU","ee1859fd972e2610":"F9hrY","bd73a7da082c021c":"f1S5P"}],"8v9mR":[function(require,module,exports) {
"use strict";
var getDateParamKey = require("45e019cd2b0261ed");
function deleteDateParam(params, key) {
    delete params[getDateParamKey(params, key)];
}
module.exports = deleteDateParam;

},{"45e019cd2b0261ed":"4ydQb"}],"fpOPw":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("3c9e466299d7184a"), DateUnitIndexes = require("82c44cac2b45135e"), getLowerUnitIndex = require("b31e307a1f4cb520"), moveToBeginningOfWeek = require("e823423f2cb0071d"), setUnitAndLowerToEdge = require("1deee0a665b0e444");
var WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, localeManager = LocaleHelpers.localeManager;
function moveToBeginningOfUnit(d, unitIndex, localeCode) {
    if (unitIndex === WEEK_INDEX) moveToBeginningOfWeek(d, localeManager.get(localeCode).getFirstDayOfWeek());
    return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex));
}
module.exports = moveToBeginningOfUnit;

},{"3c9e466299d7184a":"hlra3","82c44cac2b45135e":"ZayzA","b31e307a1f4cb520":"34E6v","e823423f2cb0071d":"dcxiC","1deee0a665b0e444":"fGenX"}],"8wPit":[function(require,module,exports) {
"use strict";
var getYear = require("1bdb95e120d47606"), mathAliases = require("35a8ebecd818d624");
var abs = mathAliases.abs;
function getYearFromAbbreviation(str, d, prefer) {
    // Following IETF here, adding 1900 or 2000 depending on the last two digits.
    // Note that this makes no accordance for what should happen after 2050, but
    // intentionally ignoring this for now. https://www.ietf.org/rfc/rfc2822.txt
    var val = +str, delta;
    val += val < 50 ? 2000 : 1900;
    if (prefer) {
        delta = val - getYear(d);
        if (delta / abs(delta) !== prefer) val += prefer * 100;
    }
    return val;
}
module.exports = getYearFromAbbreviation;

},{"1bdb95e120d47606":"id9WV","35a8ebecd818d624":"f1S5P"}],"59zuW":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("a523d5d9bef6705c"), iterateOverDateParams = require("910f0caa862c7dff");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX, YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function iterateOverHigherDateParams(params, fn) {
    iterateOverDateParams(params, fn, YEAR_INDEX, DAY_INDEX);
}
module.exports = iterateOverHigherDateParams;

},{"a523d5d9bef6705c":"ZayzA","910f0caa862c7dff":"gjSqr"}],"1XCfR":[function(require,module,exports) {
"use strict";
var setDateChainableConstructor = require("690fde748cb0d437");
setDateChainableConstructor();

},{"690fde748cb0d437":"68Hv3"}],"68Hv3":[function(require,module,exports) {
"use strict";
var createDate = require("36ad67761ce3cf0f"), namespaceAliases = require("4f86a8509b557305"), setChainableConstructor = require("f0cb1c56ab74403c");
var sugarDate = namespaceAliases.sugarDate;
function setDateChainableConstructor() {
    setChainableConstructor(sugarDate, createDate);
}
module.exports = setDateChainableConstructor;

},{"36ad67761ce3cf0f":"4SmZz","4f86a8509b557305":"4onj1","f0cb1c56ab74403c":"8qaLp"}],"38rYf":[function(require,module,exports) {
"use strict";
var Sugar = require("1260c77a3d0bed16"), LocaleHelpers = require("7c1eb3d03465b3f"), getKeys = require("f8ddb626cd11e9db");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "getAllLocaleCodes": function() {
        return getKeys(localeManager.getAll());
    }
});
module.exports = Sugar.Date.getAllLocaleCodes;

},{"1260c77a3d0bed16":"dZZfL","7c1eb3d03465b3f":"hlra3","f8ddb626cd11e9db":"dSIGU"}],"d9A6Y":[function(require,module,exports) {
"use strict";
var Sugar = require("72bf31f6dfa109d0"), LocaleHelpers = require("c0d7890d767ea887");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "getAllLocales": function() {
        return localeManager.getAll();
    }
});
module.exports = Sugar.Date.getAllLocales;

},{"72bf31f6dfa109d0":"dZZfL","c0d7890d767ea887":"hlra3"}],"hiuS9":[function(require,module,exports) {
"use strict";
var Sugar = require("617e5b7ad31e2cb8"), LocaleHelpers = require("8360e65830512582");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "getLocale": function(code) {
        return localeManager.get(code, !code);
    }
});
module.exports = Sugar.Date.getLocale;

},{"617e5b7ad31e2cb8":"dZZfL","8360e65830512582":"hlra3"}],"giNAu":[function(require,module,exports) {
"use strict";
var Sugar = require("f37fed0bcaaa16d4"), LocaleHelpers = require("bf5e578a0c0fdf31");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "removeLocale": function(code) {
        return localeManager.remove(code);
    }
});
module.exports = Sugar.Date.removeLocale;

},{"f37fed0bcaaa16d4":"dZZfL","bf5e578a0c0fdf31":"hlra3"}],"hn2X9":[function(require,module,exports) {
"use strict";
var Sugar = require("b5bfb0ea238239c9"), LocaleHelpers = require("db74cae8c72fa542");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "setLocale": function(code) {
        return localeManager.set(code);
    }
});
module.exports = Sugar.Date.setLocale;

},{"b5bfb0ea238239c9":"dZZfL","db74cae8c72fa542":"hlra3"}],"7Kd5u":[function(require,module,exports) {
"use strict";
var Sugar = require("65eb92c035918cb2");
require("1c4d586aa93f42ce");
module.exports = Sugar.Number.day;

},{"65eb92c035918cb2":"dZZfL","1c4d586aa93f42ce":"jy5Fr"}],"jy5Fr":[function(require,module,exports) {
"use strict";
var buildNumberUnitMethods = require("93b677283f1d4dd4");
buildNumberUnitMethods();

},{"93b677283f1d4dd4":"4SyZQ"}],"4SyZQ":[function(require,module,exports) {
"use strict";
var DateUnits = require("972956401f066699"), createDate = require("e8861f6c68d16f8a"), mathAliases = require("e6176fc400aa646c"), advanceDate = require("68e127b4940c2766"), namespaceAliases = require("5234f1c4b7d24512"), defineInstanceSimilar = require("c56d6dee6a3cc140");
var sugarNumber = namespaceAliases.sugarNumber, round = mathAliases.round;
function buildNumberUnitMethods() {
    defineInstanceSimilar(sugarNumber, DateUnits, function(methods, unit) {
        var name = unit.name, base, after, before;
        base = function base(n) {
            return round(n * unit.multiplier);
        };
        after = function after(n, d, options) {
            return advanceDate(createDate(d, options, true), name, n);
        };
        before = function before(n, d, options) {
            return advanceDate(createDate(d, options, true), name, -n);
        };
        methods[name] = base;
        methods[name + "s"] = base;
        methods[name + "Before"] = before;
        methods[name + "sBefore"] = before;
        methods[name + "Ago"] = before;
        methods[name + "sAgo"] = before;
        methods[name + "After"] = after;
        methods[name + "sAfter"] = after;
        methods[name + "FromNow"] = after;
        methods[name + "sFromNow"] = after;
    });
}
module.exports = buildNumberUnitMethods;

},{"972956401f066699":"kFuUz","e8861f6c68d16f8a":"4SmZz","e6176fc400aa646c":"f1S5P","68e127b4940c2766":"58alG","5234f1c4b7d24512":"4onj1","c56d6dee6a3cc140":"6ztHL"}],"lD0L4":[function(require,module,exports) {
"use strict";
var Sugar = require("496a013523018ac2");
require("9f69c70796c27009");
module.exports = Sugar.Number.dayAfter;

},{"496a013523018ac2":"dZZfL","9f69c70796c27009":"jy5Fr"}],"8lhZI":[function(require,module,exports) {
"use strict";
var Sugar = require("9aec7c933250f423");
require("e01fc2695e1d38a5");
module.exports = Sugar.Number.dayAgo;

},{"9aec7c933250f423":"dZZfL","e01fc2695e1d38a5":"jy5Fr"}],"5LEDJ":[function(require,module,exports) {
"use strict";
var Sugar = require("3361736530e55e9");
require("9e5c377c2a7b6e3a");
module.exports = Sugar.Number.dayBefore;

},{"3361736530e55e9":"dZZfL","9e5c377c2a7b6e3a":"jy5Fr"}],"2rnAP":[function(require,module,exports) {
"use strict";
var Sugar = require("b59f15d3823f2c5b");
require("c2b6a1109cc3effc");
module.exports = Sugar.Number.dayFromNow;

},{"b59f15d3823f2c5b":"dZZfL","c2b6a1109cc3effc":"jy5Fr"}],"azJny":[function(require,module,exports) {
"use strict";
var Sugar = require("57be816e5d22728");
require("581630703afc3db5");
module.exports = Sugar.Number.days;

},{"57be816e5d22728":"dZZfL","581630703afc3db5":"jy5Fr"}],"bk9Ke":[function(require,module,exports) {
"use strict";
var Sugar = require("f5554620df154025");
require("3ca9e41fac7fd7b0");
module.exports = Sugar.Number.daysAfter;

},{"f5554620df154025":"dZZfL","3ca9e41fac7fd7b0":"jy5Fr"}],"8BoSB":[function(require,module,exports) {
"use strict";
var Sugar = require("3e8346940d567a1c");
require("73fbdc0a173e4398");
module.exports = Sugar.Number.daysAgo;

},{"3e8346940d567a1c":"dZZfL","73fbdc0a173e4398":"jy5Fr"}],"gLeXn":[function(require,module,exports) {
"use strict";
var Sugar = require("87557263ac442aea");
require("8e2b883cf859d665");
module.exports = Sugar.Number.daysBefore;

},{"87557263ac442aea":"dZZfL","8e2b883cf859d665":"jy5Fr"}],"9uJUj":[function(require,module,exports) {
"use strict";
var Sugar = require("cc5e6f12a1f2655");
require("e47b1438413b3d73");
module.exports = Sugar.Number.daysFromNow;

},{"cc5e6f12a1f2655":"dZZfL","e47b1438413b3d73":"jy5Fr"}],"hyQPL":[function(require,module,exports) {
"use strict";
var Sugar = require("e81db6ab36f8bbc6"), LocaleHelpers = require("7c8bfbab1befe454");
var localeManager = LocaleHelpers.localeManager;
Sugar.Number.defineInstance({
    "duration": function(n, localeCode) {
        return localeManager.get(localeCode).getDuration(n);
    }
});
module.exports = Sugar.Number.duration;

},{"e81db6ab36f8bbc6":"dZZfL","7c8bfbab1befe454":"hlra3"}],"efUGG":[function(require,module,exports) {
"use strict";
var Sugar = require("2ced1f0180f9046c");
require("130bf6f23a714ce6");
module.exports = Sugar.Number.hour;

},{"2ced1f0180f9046c":"dZZfL","130bf6f23a714ce6":"jy5Fr"}],"jxWDF":[function(require,module,exports) {
"use strict";
var Sugar = require("91728bc48a4f17c");
require("705465c260771f9a");
module.exports = Sugar.Number.hourAfter;

},{"91728bc48a4f17c":"dZZfL","705465c260771f9a":"jy5Fr"}],"6tL8L":[function(require,module,exports) {
"use strict";
var Sugar = require("770e332e5fc85e36");
require("ebc55af01817b585");
module.exports = Sugar.Number.hourAgo;

},{"770e332e5fc85e36":"dZZfL","ebc55af01817b585":"jy5Fr"}],"5PcPT":[function(require,module,exports) {
"use strict";
var Sugar = require("437f30cedd58b68a");
require("a60ef6dae74ba3de");
module.exports = Sugar.Number.hourBefore;

},{"437f30cedd58b68a":"dZZfL","a60ef6dae74ba3de":"jy5Fr"}],"hbcDG":[function(require,module,exports) {
"use strict";
var Sugar = require("9d29068a63ad8307");
require("2e24490c4264e9cd");
module.exports = Sugar.Number.hourFromNow;

},{"9d29068a63ad8307":"dZZfL","2e24490c4264e9cd":"jy5Fr"}],"cBv9k":[function(require,module,exports) {
"use strict";
var Sugar = require("1fb527045409bf17");
require("43cd1a52bea0f590");
module.exports = Sugar.Number.hours;

},{"1fb527045409bf17":"dZZfL","43cd1a52bea0f590":"jy5Fr"}],"c3id1":[function(require,module,exports) {
"use strict";
var Sugar = require("aec5812415130dcb");
require("c86830a415f368a3");
module.exports = Sugar.Number.hoursAfter;

},{"aec5812415130dcb":"dZZfL","c86830a415f368a3":"jy5Fr"}],"8Pbth":[function(require,module,exports) {
"use strict";
var Sugar = require("5aa6b901135cf577");
require("6011c59994471fda");
module.exports = Sugar.Number.hoursAgo;

},{"5aa6b901135cf577":"dZZfL","6011c59994471fda":"jy5Fr"}],"7gARQ":[function(require,module,exports) {
"use strict";
var Sugar = require("278028068ad1c9ef");
require("85650be273b0bb65");
module.exports = Sugar.Number.hoursBefore;

},{"278028068ad1c9ef":"dZZfL","85650be273b0bb65":"jy5Fr"}],"1kD6A":[function(require,module,exports) {
"use strict";
var Sugar = require("c15b684ff28e2050");
require("f649c9c14630e090");
module.exports = Sugar.Number.hoursFromNow;

},{"c15b684ff28e2050":"dZZfL","f649c9c14630e090":"jy5Fr"}],"dYuVG":[function(require,module,exports) {
"use strict";
var Sugar = require("85d6138d0702613a");
require("f71d5aca8a6619d7");
module.exports = Sugar.Number.millisecond;

},{"85d6138d0702613a":"dZZfL","f71d5aca8a6619d7":"jy5Fr"}],"hpYck":[function(require,module,exports) {
"use strict";
var Sugar = require("cb6cfb6877123719");
require("1cefc33894e884f3");
module.exports = Sugar.Number.millisecondAfter;

},{"cb6cfb6877123719":"dZZfL","1cefc33894e884f3":"jy5Fr"}],"8WyEQ":[function(require,module,exports) {
"use strict";
var Sugar = require("dbd3e767469a7a73");
require("e5c22ee758e4461e");
module.exports = Sugar.Number.millisecondAgo;

},{"dbd3e767469a7a73":"dZZfL","e5c22ee758e4461e":"jy5Fr"}],"fBkP1":[function(require,module,exports) {
"use strict";
var Sugar = require("81dd1df3a270cdc0");
require("cef9956ba6f14d46");
module.exports = Sugar.Number.millisecondBefore;

},{"81dd1df3a270cdc0":"dZZfL","cef9956ba6f14d46":"jy5Fr"}],"gvlku":[function(require,module,exports) {
"use strict";
var Sugar = require("83a1e42f8e389cf6");
require("87bed8c7b099e5fe");
module.exports = Sugar.Number.millisecondFromNow;

},{"83a1e42f8e389cf6":"dZZfL","87bed8c7b099e5fe":"jy5Fr"}],"deJnO":[function(require,module,exports) {
"use strict";
var Sugar = require("77a417d392bb97a5");
require("6371be09879e2474");
module.exports = Sugar.Number.milliseconds;

},{"77a417d392bb97a5":"dZZfL","6371be09879e2474":"jy5Fr"}],"dBLTd":[function(require,module,exports) {
"use strict";
var Sugar = require("d9822a409574396c");
require("c473cea4ba7bab79");
module.exports = Sugar.Number.millisecondsAfter;

},{"d9822a409574396c":"dZZfL","c473cea4ba7bab79":"jy5Fr"}],"gxcP3":[function(require,module,exports) {
"use strict";
var Sugar = require("751e02432693c54b");
require("645bc6942fdaf8c9");
module.exports = Sugar.Number.millisecondsAgo;

},{"751e02432693c54b":"dZZfL","645bc6942fdaf8c9":"jy5Fr"}],"kcG72":[function(require,module,exports) {
"use strict";
var Sugar = require("a4ceffca96da204e");
require("81f5f5404b88918");
module.exports = Sugar.Number.millisecondsBefore;

},{"a4ceffca96da204e":"dZZfL","81f5f5404b88918":"jy5Fr"}],"2ezBG":[function(require,module,exports) {
"use strict";
var Sugar = require("70dc2c38ecb7ac72");
require("c72f24e0b9788796");
module.exports = Sugar.Number.millisecondsFromNow;

},{"70dc2c38ecb7ac72":"dZZfL","c72f24e0b9788796":"jy5Fr"}],"4uQ3P":[function(require,module,exports) {
"use strict";
var Sugar = require("46fc51c3cd8340a8");
require("347af1ac68704070");
module.exports = Sugar.Number.minute;

},{"46fc51c3cd8340a8":"dZZfL","347af1ac68704070":"jy5Fr"}],"lNvt1":[function(require,module,exports) {
"use strict";
var Sugar = require("940071e41e54eb0f");
require("bd05bce1648bc36b");
module.exports = Sugar.Number.minuteAfter;

},{"940071e41e54eb0f":"dZZfL","bd05bce1648bc36b":"jy5Fr"}],"9PeMw":[function(require,module,exports) {
"use strict";
var Sugar = require("9c9dd687192f1786");
require("33147a43ccca9a8c");
module.exports = Sugar.Number.minuteAgo;

},{"9c9dd687192f1786":"dZZfL","33147a43ccca9a8c":"jy5Fr"}],"kgvpk":[function(require,module,exports) {
"use strict";
var Sugar = require("8b0386d231c137ee");
require("4a4f97ef6d752082");
module.exports = Sugar.Number.minuteBefore;

},{"8b0386d231c137ee":"dZZfL","4a4f97ef6d752082":"jy5Fr"}],"hEFZH":[function(require,module,exports) {
"use strict";
var Sugar = require("c9f5767104941845");
require("bfc369e72b084755");
module.exports = Sugar.Number.minuteFromNow;

},{"c9f5767104941845":"dZZfL","bfc369e72b084755":"jy5Fr"}],"bT5iG":[function(require,module,exports) {
"use strict";
var Sugar = require("8c4a870817c8a544");
require("6e025c763011f9f6");
module.exports = Sugar.Number.minutes;

},{"8c4a870817c8a544":"dZZfL","6e025c763011f9f6":"jy5Fr"}],"fi4kJ":[function(require,module,exports) {
"use strict";
var Sugar = require("9d0263e618a66917");
require("9c5f5f9d00311c49");
module.exports = Sugar.Number.minutesAfter;

},{"9d0263e618a66917":"dZZfL","9c5f5f9d00311c49":"jy5Fr"}],"lffwN":[function(require,module,exports) {
"use strict";
var Sugar = require("88383b1c2fb18b");
require("d2ccbd555828ae6d");
module.exports = Sugar.Number.minutesAgo;

},{"88383b1c2fb18b":"dZZfL","d2ccbd555828ae6d":"jy5Fr"}],"bK5pn":[function(require,module,exports) {
"use strict";
var Sugar = require("bc25f89f79976d95");
require("f6faab2e3a95db09");
module.exports = Sugar.Number.minutesBefore;

},{"bc25f89f79976d95":"dZZfL","f6faab2e3a95db09":"jy5Fr"}],"ihc0C":[function(require,module,exports) {
"use strict";
var Sugar = require("447af5f31fcb0c20");
require("f3b874e0cbb5441e");
module.exports = Sugar.Number.minutesFromNow;

},{"447af5f31fcb0c20":"dZZfL","f3b874e0cbb5441e":"jy5Fr"}],"aYiYT":[function(require,module,exports) {
"use strict";
var Sugar = require("a4f991dc08a84120");
require("b04aa15cff3e1864");
module.exports = Sugar.Number.month;

},{"a4f991dc08a84120":"dZZfL","b04aa15cff3e1864":"jy5Fr"}],"iemEr":[function(require,module,exports) {
"use strict";
var Sugar = require("66373bd87eac4395");
require("bc8774919a9338cc");
module.exports = Sugar.Number.monthAfter;

},{"66373bd87eac4395":"dZZfL","bc8774919a9338cc":"jy5Fr"}],"Cnfom":[function(require,module,exports) {
"use strict";
var Sugar = require("b3b8c660f5651be2");
require("e1b57c04878fc79e");
module.exports = Sugar.Number.monthAgo;

},{"b3b8c660f5651be2":"dZZfL","e1b57c04878fc79e":"jy5Fr"}],"bIgUx":[function(require,module,exports) {
"use strict";
var Sugar = require("bb3bd0a947e847ac");
require("bcb07c4d8f72bc1b");
module.exports = Sugar.Number.monthBefore;

},{"bb3bd0a947e847ac":"dZZfL","bcb07c4d8f72bc1b":"jy5Fr"}],"jOf42":[function(require,module,exports) {
"use strict";
var Sugar = require("631070dea5f55f52");
require("aa23cf16fd7a404d");
module.exports = Sugar.Number.monthFromNow;

},{"631070dea5f55f52":"dZZfL","aa23cf16fd7a404d":"jy5Fr"}],"3hCGW":[function(require,module,exports) {
"use strict";
var Sugar = require("c69b6dfafff46f9c");
require("1cf5d250aab81a97");
module.exports = Sugar.Number.months;

},{"c69b6dfafff46f9c":"dZZfL","1cf5d250aab81a97":"jy5Fr"}],"8Xw3v":[function(require,module,exports) {
"use strict";
var Sugar = require("f989abf9dc10ea7a");
require("c9f339e69b33b00");
module.exports = Sugar.Number.monthsAfter;

},{"f989abf9dc10ea7a":"dZZfL","c9f339e69b33b00":"jy5Fr"}],"8Mh1L":[function(require,module,exports) {
"use strict";
var Sugar = require("c6e139dddb9416cb");
require("637603ea18f2520b");
module.exports = Sugar.Number.monthsAgo;

},{"c6e139dddb9416cb":"dZZfL","637603ea18f2520b":"jy5Fr"}],"7nn55":[function(require,module,exports) {
"use strict";
var Sugar = require("94e409738a00e32a");
require("1a67a9ef22286e39");
module.exports = Sugar.Number.monthsBefore;

},{"94e409738a00e32a":"dZZfL","1a67a9ef22286e39":"jy5Fr"}],"lT0VK":[function(require,module,exports) {
"use strict";
var Sugar = require("6897a583a883544b");
require("89f41981f41c55d3");
module.exports = Sugar.Number.monthsFromNow;

},{"6897a583a883544b":"dZZfL","89f41981f41c55d3":"jy5Fr"}],"1fGCW":[function(require,module,exports) {
"use strict";
var Sugar = require("2b2a82a5418cfff0");
require("e01cd0b9976be3df");
module.exports = Sugar.Number.second;

},{"2b2a82a5418cfff0":"dZZfL","e01cd0b9976be3df":"jy5Fr"}],"lV67C":[function(require,module,exports) {
"use strict";
var Sugar = require("45e4680c6618ce61");
require("e9d09f7a6a04dfe");
module.exports = Sugar.Number.secondAfter;

},{"45e4680c6618ce61":"dZZfL","e9d09f7a6a04dfe":"jy5Fr"}],"4qiSo":[function(require,module,exports) {
"use strict";
var Sugar = require("98dd97a3b8dfcb58");
require("7739dd165379e8c4");
module.exports = Sugar.Number.secondAgo;

},{"98dd97a3b8dfcb58":"dZZfL","7739dd165379e8c4":"jy5Fr"}],"eEODV":[function(require,module,exports) {
"use strict";
var Sugar = require("19d625a3fd4f691e");
require("d7a86ceaa7730e91");
module.exports = Sugar.Number.secondBefore;

},{"19d625a3fd4f691e":"dZZfL","d7a86ceaa7730e91":"jy5Fr"}],"akQMc":[function(require,module,exports) {
"use strict";
var Sugar = require("77d7db259811af9d");
require("68ea29315ee9db20");
module.exports = Sugar.Number.secondFromNow;

},{"77d7db259811af9d":"dZZfL","68ea29315ee9db20":"jy5Fr"}],"lOZN6":[function(require,module,exports) {
"use strict";
var Sugar = require("a3fcd2ec9f1f0e13");
require("4b2cbeb455b8fa9b");
module.exports = Sugar.Number.seconds;

},{"a3fcd2ec9f1f0e13":"dZZfL","4b2cbeb455b8fa9b":"jy5Fr"}],"fpAIo":[function(require,module,exports) {
"use strict";
var Sugar = require("6162ca65982b2761");
require("a3a86083cfb53551");
module.exports = Sugar.Number.secondsAfter;

},{"6162ca65982b2761":"dZZfL","a3a86083cfb53551":"jy5Fr"}],"34ueM":[function(require,module,exports) {
"use strict";
var Sugar = require("bc53262f288a05ef");
require("5b389bd672899514");
module.exports = Sugar.Number.secondsAgo;

},{"bc53262f288a05ef":"dZZfL","5b389bd672899514":"jy5Fr"}],"1Oa5J":[function(require,module,exports) {
"use strict";
var Sugar = require("63835ec6a5a3b8b3");
require("5e70884cf277b483");
module.exports = Sugar.Number.secondsBefore;

},{"63835ec6a5a3b8b3":"dZZfL","5e70884cf277b483":"jy5Fr"}],"8bI9x":[function(require,module,exports) {
"use strict";
var Sugar = require("610265819e213c66");
require("ae090e9200ed80b4");
module.exports = Sugar.Number.secondsFromNow;

},{"610265819e213c66":"dZZfL","ae090e9200ed80b4":"jy5Fr"}],"bZFJz":[function(require,module,exports) {
"use strict";
var Sugar = require("40df8232ab6837a2");
require("e90cd6332ab19c43");
module.exports = Sugar.Number.week;

},{"40df8232ab6837a2":"dZZfL","e90cd6332ab19c43":"jy5Fr"}],"8WE4h":[function(require,module,exports) {
"use strict";
var Sugar = require("e9c066e46f565ed5");
require("63e4bdc2cb50ed39");
module.exports = Sugar.Number.weekAfter;

},{"e9c066e46f565ed5":"dZZfL","63e4bdc2cb50ed39":"jy5Fr"}],"gZkBi":[function(require,module,exports) {
"use strict";
var Sugar = require("6131a9280789540f");
require("17cf8c0de10ee71b");
module.exports = Sugar.Number.weekAgo;

},{"6131a9280789540f":"dZZfL","17cf8c0de10ee71b":"jy5Fr"}],"hx8Q4":[function(require,module,exports) {
"use strict";
var Sugar = require("436bbc0014d912f3");
require("da16be8ab9b1e051");
module.exports = Sugar.Number.weekBefore;

},{"436bbc0014d912f3":"dZZfL","da16be8ab9b1e051":"jy5Fr"}],"7tgvS":[function(require,module,exports) {
"use strict";
var Sugar = require("bbc89bde0a03a156");
require("ba26959bc2ff8a14");
module.exports = Sugar.Number.weekFromNow;

},{"bbc89bde0a03a156":"dZZfL","ba26959bc2ff8a14":"jy5Fr"}],"hvb0B":[function(require,module,exports) {
"use strict";
var Sugar = require("eb9c44e56d08af30");
require("cac882b00802698");
module.exports = Sugar.Number.weeks;

},{"eb9c44e56d08af30":"dZZfL","cac882b00802698":"jy5Fr"}],"1KrrZ":[function(require,module,exports) {
"use strict";
var Sugar = require("50b1577076ad68f2");
require("e031840b34a85aa4");
module.exports = Sugar.Number.weeksAfter;

},{"50b1577076ad68f2":"dZZfL","e031840b34a85aa4":"jy5Fr"}],"eqane":[function(require,module,exports) {
"use strict";
var Sugar = require("5747323cb4129621");
require("184913e1cd323130");
module.exports = Sugar.Number.weeksAgo;

},{"5747323cb4129621":"dZZfL","184913e1cd323130":"jy5Fr"}],"hwZmt":[function(require,module,exports) {
"use strict";
var Sugar = require("3c4186434a2d45bd");
require("28b0b4ec1f13bc95");
module.exports = Sugar.Number.weeksBefore;

},{"3c4186434a2d45bd":"dZZfL","28b0b4ec1f13bc95":"jy5Fr"}],"8w3Vu":[function(require,module,exports) {
"use strict";
var Sugar = require("4b8d967ec18b10da");
require("38ab3591dab58ae1");
module.exports = Sugar.Number.weeksFromNow;

},{"4b8d967ec18b10da":"dZZfL","38ab3591dab58ae1":"jy5Fr"}],"90yN1":[function(require,module,exports) {
"use strict";
var Sugar = require("d20e1bcaea33a073");
require("b925d89937aa9bc1");
module.exports = Sugar.Number.year;

},{"d20e1bcaea33a073":"dZZfL","b925d89937aa9bc1":"jy5Fr"}],"lGzuN":[function(require,module,exports) {
"use strict";
var Sugar = require("8af3670636f02d1f");
require("938ca5a5493239cd");
module.exports = Sugar.Number.yearAfter;

},{"8af3670636f02d1f":"dZZfL","938ca5a5493239cd":"jy5Fr"}],"dlAUD":[function(require,module,exports) {
"use strict";
var Sugar = require("cdfa913d34dd8874");
require("e527bb54b26ab4ed");
module.exports = Sugar.Number.yearAgo;

},{"cdfa913d34dd8874":"dZZfL","e527bb54b26ab4ed":"jy5Fr"}],"iS2Lc":[function(require,module,exports) {
"use strict";
var Sugar = require("2b8c7b2b8b677b61");
require("343fadc0f44aa570");
module.exports = Sugar.Number.yearBefore;

},{"2b8c7b2b8b677b61":"dZZfL","343fadc0f44aa570":"jy5Fr"}],"lSWB2":[function(require,module,exports) {
"use strict";
var Sugar = require("499533744bbfbdc2");
require("1d0542bc7301e5eb");
module.exports = Sugar.Number.yearFromNow;

},{"499533744bbfbdc2":"dZZfL","1d0542bc7301e5eb":"jy5Fr"}],"1hHaG":[function(require,module,exports) {
"use strict";
var Sugar = require("dab56de0325bb699");
require("55737312885be93d");
module.exports = Sugar.Number.years;

},{"dab56de0325bb699":"dZZfL","55737312885be93d":"jy5Fr"}],"a5047":[function(require,module,exports) {
"use strict";
var Sugar = require("7b94e12b3d5160cb");
require("42a2c4b511ba5d15");
module.exports = Sugar.Number.yearsAfter;

},{"7b94e12b3d5160cb":"dZZfL","42a2c4b511ba5d15":"jy5Fr"}],"bLaMt":[function(require,module,exports) {
"use strict";
var Sugar = require("728ba2f8c20e1200");
require("5f410bebe9a0cdef");
module.exports = Sugar.Number.yearsAgo;

},{"728ba2f8c20e1200":"dZZfL","5f410bebe9a0cdef":"jy5Fr"}],"abLxj":[function(require,module,exports) {
"use strict";
var Sugar = require("50bb226b90060b89");
require("1bea1461af84fedb");
module.exports = Sugar.Number.yearsBefore;

},{"50bb226b90060b89":"dZZfL","1bea1461af84fedb":"jy5Fr"}],"9VVRp":[function(require,module,exports) {
"use strict";
var Sugar = require("16e6c9a4bdf24014");
require("473afb7f65534ce6");
module.exports = Sugar.Number.yearsFromNow;

},{"16e6c9a4bdf24014":"dZZfL","473afb7f65534ce6":"jy5Fr"}],"k7uWf":[function(require,module,exports) {
"use strict";
var Sugar = require("68b7c5722d253d94");
require("42fee9cec11f0d3d");
module.exports = Sugar.Date.addDays;

},{"68b7c5722d253d94":"dZZfL","42fee9cec11f0d3d":"e859g"}],"e859g":[function(require,module,exports) {
"use strict";
var buildDateUnitMethods = require("a92963c4a7e46c5c");
buildDateUnitMethods();

},{"a92963c4a7e46c5c":"lej7d"}],"lej7d":[function(require,module,exports) {
"use strict";
var DateUnits = require("464b9096db0e4620"), DateUnitIndexes = require("6ae71857a10cd158"), forEach = require("85a6d24e2cc94f5"), createDate = require("976fcb6d8fddf32e"), compareDate = require("d9acdc440d012604"), advanceDate = require("ab42458b189ee4f7"), moveToEndOfUnit = require("76be28f76439606a"), namespaceAliases = require("94c48ae059c7b57e"), simpleCapitalize = require("cff50e09187a3a14"), moveToBeginningOfUnit = require("e35c7bea0ad85968"), defineInstanceSimilar = require("7cb84e8105d6ece0"), getTimeDistanceForUnit = require("7dd98b160f6e644a");
var sugarDate = namespaceAliases.sugarDate, HOURS_INDEX = DateUnitIndexes.HOURS_INDEX, DAY_INDEX = DateUnitIndexes.DAY_INDEX;
function buildDateUnitMethods() {
    defineInstanceSimilar(sugarDate, DateUnits, function(methods, unit, index) {
        var name = unit.name, caps = simpleCapitalize(name);
        if (index > DAY_INDEX) forEach([
            "Last",
            "This",
            "Next"
        ], function(shift) {
            methods["is" + shift + caps] = function(d, localeCode) {
                return compareDate(d, shift + " " + name, 0, localeCode, {
                    locale: "en"
                });
            };
        });
        if (index > HOURS_INDEX) {
            methods["beginningOf" + caps] = function(d, localeCode) {
                return moveToBeginningOfUnit(d, index, localeCode);
            };
            methods["endOf" + caps] = function(d, localeCode) {
                return moveToEndOfUnit(d, index, localeCode);
            };
        }
        methods["add" + caps + "s"] = function(d, num, reset) {
            return advanceDate(d, name, num, reset);
        };
        var since = function since(date, d, options) {
            return getTimeDistanceForUnit(date, createDate(d, options, true), unit);
        };
        var until = function until(date, d, options) {
            return getTimeDistanceForUnit(createDate(d, options, true), date, unit);
        };
        methods[name + "sAgo"] = methods[name + "sUntil"] = until;
        methods[name + "sSince"] = methods[name + "sFromNow"] = since;
    });
}
module.exports = buildDateUnitMethods;

},{"464b9096db0e4620":"kFuUz","6ae71857a10cd158":"ZayzA","85a6d24e2cc94f5":"JJnv7","976fcb6d8fddf32e":"4SmZz","d9acdc440d012604":"lA7t7","ab42458b189ee4f7":"58alG","76be28f76439606a":"3fWCU","94c48ae059c7b57e":"4onj1","cff50e09187a3a14":"4Ffkr","e35c7bea0ad85968":"fpOPw","7cb84e8105d6ece0":"6ztHL","7dd98b160f6e644a":"6xSB2"}],"lA7t7":[function(require,module,exports) {
"use strict";
var MINUTES = require("2c11627e81587d26"), DateUnits = require("3220a217cc3f4ea8"), DateUnitIndexes = require("68428f66927c4bcc"), _utc = require("fc254a3ca45fb8d5"), tzOffset = require("aff011d2a0bbe40a"), cloneDate = require("23b2bf3cffbe752b"), isDefined = require("769d1c51874b34fb"), advanceDate = require("d97ea0a3c0165197"), dateIsValid = require("60bb37743453bc7f"), moveToEndOfUnit = require("4e0144a3fd3b22f"), getExtendedDate = require("97ac1577e952014a"), moveToBeginningOfUnit = require("8a96d25bbcb4915f");
var MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function compareDate(date, d, margin, localeCode, options) {
    var loMargin = 0, hiMargin = 0, timezoneShift, compareEdges, override, min, max, p, t;
    function getTimezoneShift() {
        // If there is any specificity in the date then we're implicitly not
        // checking absolute time, so ignore timezone shifts.
        if (p.set && p.set.specificity) return 0;
        return (tzOffset(p.date) - tzOffset(date)) * MINUTES;
    }
    function addSpecificUnit() {
        var unit = DateUnits[p.set.specificity];
        return advanceDate(cloneDate(p.date), unit.name, 1).getTime() - 1;
    }
    if (_utc(date)) {
        options = options || {};
        options.fromUTC = true;
        options.setUTC = true;
    }
    p = getExtendedDate(null, d, options, true);
    if (margin > 0) {
        loMargin = hiMargin = margin;
        override = true;
    }
    if (!dateIsValid(p.date)) return false;
    if (p.set && p.set.specificity) {
        if (isDefined(p.set.edge) || isDefined(p.set.shift)) {
            compareEdges = true;
            moveToBeginningOfUnit(p.date, p.set.specificity, localeCode);
        }
        if (compareEdges || p.set.specificity === MONTH_INDEX) max = moveToEndOfUnit(cloneDate(p.date), p.set.specificity, localeCode).getTime();
        else max = addSpecificUnit();
        if (!override && isDefined(p.set.sign) && p.set.specificity) {
            // If the time is relative, there can occasionally be an disparity between
            // the relative date and "now", which it is being compared to, so set an
            // extra margin to account for this.
            loMargin = 50;
            hiMargin = -50;
        }
    }
    t = date.getTime();
    min = p.date.getTime();
    max = max || min;
    timezoneShift = getTimezoneShift();
    // istanbul ignore if
    if (timezoneShift) {
        min -= timezoneShift;
        max -= timezoneShift;
    }
    return t >= min - loMargin && t <= max + hiMargin;
}
module.exports = compareDate;

},{"2c11627e81587d26":"iDlFg","3220a217cc3f4ea8":"kFuUz","68428f66927c4bcc":"ZayzA","fc254a3ca45fb8d5":"01lmY","aff011d2a0bbe40a":"7uIyU","23b2bf3cffbe752b":"lvF4j","769d1c51874b34fb":"4cOOJ","d97ea0a3c0165197":"58alG","60bb37743453bc7f":"iVwwI","4e0144a3fd3b22f":"3fWCU","97ac1577e952014a":"eirnu","8a96d25bbcb4915f":"fpOPw"}],"6xSB2":[function(require,module,exports) {
"use strict";
var trunc = require("8add0fb85606e9f8"), cloneDate = require("6f421e1fdfd61180"), advanceDate = require("4189cf87edbb46c2");
function getTimeDistanceForUnit(d1, d2, unit) {
    var fwd = d2 > d1, num, tmp;
    if (!fwd) {
        tmp = d2;
        d2 = d1;
        d1 = tmp;
    }
    num = d2 - d1;
    if (unit.multiplier > 1) num = trunc(num / unit.multiplier);
    // For higher order with potential ambiguity, use the numeric calculation
    // as a starting point, then iterate until we pass the target date. Decrement
    // starting point by 1 to prevent overshooting the date due to inconsistencies
    // in ambiguous units numerically. For example, calculating the number of days
    // from the beginning of the year to August 5th at 11:59:59 by doing a simple
    // d2 - d1 will produce different results depending on whether or not a
    // timezone shift was encountered due to DST, however that should not have an
    // effect on our calculation here, so subtract by 1 to ensure that the
    // starting point has not already overshot our target date.
    if (unit.ambiguous) {
        d1 = cloneDate(d1);
        if (num) {
            num -= 1;
            advanceDate(d1, unit.name, num);
        }
        while(d1 < d2){
            advanceDate(d1, unit.name, 1);
            if (d1 > d2) break;
            num += 1;
        }
    }
    return fwd ? -num : num;
}
module.exports = getTimeDistanceForUnit;

},{"8add0fb85606e9f8":"898n5","6f421e1fdfd61180":"lvF4j","4189cf87edbb46c2":"58alG"}],"cgA8Q":[function(require,module,exports) {
"use strict";
var Sugar = require("bc21e2c227b7bf7b");
require("10c8cd9fd9ba898f");
module.exports = Sugar.Date.addHours;

},{"bc21e2c227b7bf7b":"dZZfL","10c8cd9fd9ba898f":"e859g"}],"l9wlA":[function(require,module,exports) {
"use strict";
var Sugar = require("873fe33549b10328");
require("673ae21f96713d1a");
module.exports = Sugar.Date.addMilliseconds;

},{"873fe33549b10328":"dZZfL","673ae21f96713d1a":"e859g"}],"9NR07":[function(require,module,exports) {
"use strict";
var Sugar = require("96f399194ff53370");
require("171f5e37a61b8be1");
module.exports = Sugar.Date.addMinutes;

},{"96f399194ff53370":"dZZfL","171f5e37a61b8be1":"e859g"}],"2qnld":[function(require,module,exports) {
"use strict";
var Sugar = require("1872c4dc054fb6ca");
require("58037b93e79a6bd7");
module.exports = Sugar.Date.addMonths;

},{"1872c4dc054fb6ca":"dZZfL","58037b93e79a6bd7":"e859g"}],"1dmpx":[function(require,module,exports) {
"use strict";
var Sugar = require("3929d85c8d236c56");
require("971e15ed728d0a1b");
module.exports = Sugar.Date.addSeconds;

},{"3929d85c8d236c56":"dZZfL","971e15ed728d0a1b":"e859g"}],"dtUXN":[function(require,module,exports) {
"use strict";
var Sugar = require("f9070455f9126f07");
require("a2de26a852b6b966");
module.exports = Sugar.Date.addWeeks;

},{"f9070455f9126f07":"dZZfL","a2de26a852b6b966":"e859g"}],"fZgNz":[function(require,module,exports) {
"use strict";
var Sugar = require("ab20468afb49ef64");
require("5699dafd299b4bc7");
module.exports = Sugar.Date.addYears;

},{"ab20468afb49ef64":"dZZfL","5699dafd299b4bc7":"e859g"}],"7RGKd":[function(require,module,exports) {
"use strict";
var Sugar = require("d07505793d0f6c01"), advanceDateWithArgs = require("668341adee3298d9");
Sugar.Date.defineInstanceWithArguments({
    "advance": function(d, args) {
        return advanceDateWithArgs(d, args, 1);
    }
});
module.exports = Sugar.Date.advance;

},{"d07505793d0f6c01":"dZZfL","668341adee3298d9":"gJnUh"}],"gJnUh":[function(require,module,exports) {
"use strict";
var updateDate = require("250aa91eaf9012d3"), collectUpdateDateArguments = require("abfc1df6f068f2bd");
function advanceDateWithArgs(d, args, dir) {
    args = collectUpdateDateArguments(args, true);
    return updateDate(d, args[0], args[1], dir);
}
module.exports = advanceDateWithArgs;

},{"250aa91eaf9012d3":"9gLzt","abfc1df6f068f2bd":"fymhQ"}],"fymhQ":[function(require,module,exports) {
"use strict";
var classChecks = require("f4305875fa9fe57"), simpleClone = require("7f2259f18112d226"), isObjectType = require("4c043dc14eb5e03e"), getDateParamsFromString = require("918b3a457395b342"), collectDateParamsFromArguments = require("306f1988d2627ce8");
var isNumber = classChecks.isNumber, isString = classChecks.isString;
function collectUpdateDateArguments(args, allowDuration) {
    var arg1 = args[0], arg2 = args[1], params, reset;
    if (allowDuration && isString(arg1)) {
        params = getDateParamsFromString(arg1);
        reset = arg2;
    } else if (isNumber(arg1) && isNumber(arg2)) params = collectDateParamsFromArguments(args);
    else {
        params = isObjectType(arg1) ? simpleClone(arg1) : arg1;
        reset = arg2;
    }
    return [
        params,
        reset
    ];
}
module.exports = collectUpdateDateArguments;

},{"f4305875fa9fe57":"MTXUY","7f2259f18112d226":"glUlC","4c043dc14eb5e03e":"1dImj","918b3a457395b342":"fdDdP","306f1988d2627ce8":"6B88Q"}],"fdDdP":[function(require,module,exports) {
"use strict";
var isUndefined = require("29598ce8ff1748cf");
function getDateParamsFromString(str) {
    var match, num, params = {};
    match = str.match(/^(-?\d*[\d.]\d*)?\s?(\w+?)s?$/i);
    if (match) {
        if (isUndefined(num)) num = match[1] ? +match[1] : 1;
        params[match[2].toLowerCase()] = num;
    }
    return params;
}
module.exports = getDateParamsFromString;

},{"29598ce8ff1748cf":"6oRAa"}],"6B88Q":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("908226d7c3b0baed"), isDefined = require("993e1d542a5ed70c"), walkUnitDown = require("54eefa52332929a0");
var YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function collectDateParamsFromArguments(args) {
    var params = {}, index = 0;
    walkUnitDown(YEAR_INDEX, function(unit) {
        var arg = args[index++];
        if (isDefined(arg)) params[unit.name] = arg;
    });
    return params;
}
module.exports = collectDateParamsFromArguments;

},{"908226d7c3b0baed":"ZayzA","993e1d542a5ed70c":"4cOOJ","54eefa52332929a0":"66gTa"}],"blyWU":[function(require,module,exports) {
"use strict";
var Sugar = require("bb6b75f25fe2f249");
require("b16dcbaa06e11e23");
module.exports = Sugar.Date.beginningOfDay;

},{"bb6b75f25fe2f249":"dZZfL","b16dcbaa06e11e23":"e859g"}],"24f6i":[function(require,module,exports) {
"use strict";
var Sugar = require("48492b7aa31a2d36"), resetTime = require("2a2295b009a5b6f4"), getWeekday = require("48ad51b62b17ce84"), setWeekday = require("78fb83cb81b7a30");
Sugar.Date.defineInstance({
    "beginningOfISOWeek": function(date) {
        var day = getWeekday(date);
        if (day === 0) day = -6;
        else if (day !== 1) day = 1;
        setWeekday(date, day);
        return resetTime(date);
    }
});
module.exports = Sugar.Date.beginningOfISOWeek;

},{"48492b7aa31a2d36":"dZZfL","2a2295b009a5b6f4":"1RhqH","48ad51b62b17ce84":"F9hrY","78fb83cb81b7a30":"a9tBU"}],"bK22v":[function(require,module,exports) {
"use strict";
var Sugar = require("c9e685d4b31a32f5");
require("88df81928f2e19a0");
module.exports = Sugar.Date.beginningOfMonth;

},{"c9e685d4b31a32f5":"dZZfL","88df81928f2e19a0":"e859g"}],"haSy4":[function(require,module,exports) {
"use strict";
var Sugar = require("7b08895303cd9289");
require("e557b69483887284");
module.exports = Sugar.Date.beginningOfWeek;

},{"7b08895303cd9289":"dZZfL","e557b69483887284":"e859g"}],"1uUtT":[function(require,module,exports) {
"use strict";
var Sugar = require("c91dbc27a53667e6");
require("53cb5652b726a16f");
module.exports = Sugar.Date.beginningOfYear;

},{"c91dbc27a53667e6":"dZZfL","53cb5652b726a16f":"e859g"}],"eQMIn":[function(require,module,exports) {
"use strict";
var Sugar = require("6ec91d927112dd63"), cloneDate = require("a08c56e55b2a5b0b");
Sugar.Date.defineInstance({
    "clone": function(date) {
        return cloneDate(date);
    }
});
module.exports = Sugar.Date.clone;

},{"6ec91d927112dd63":"dZZfL","a08c56e55b2a5b0b":"lvF4j"}],"kZLLI":[function(require,module,exports) {
"use strict";
var Sugar = require("576fbbc764bf2f25");
require("29b696c545dd7c62");
module.exports = Sugar.Date.daysAgo;

},{"576fbbc764bf2f25":"dZZfL","29b696c545dd7c62":"e859g"}],"hItwG":[function(require,module,exports) {
"use strict";
var Sugar = require("7d9123f74d12282b");
require("8d465421da4ba395");
module.exports = Sugar.Date.daysFromNow;

},{"7d9123f74d12282b":"dZZfL","8d465421da4ba395":"e859g"}],"jfPB2":[function(require,module,exports) {
"use strict";
var Sugar = require("65f4884fe5a5402d"), getDaysInMonth = require("31751e895bd7a682");
Sugar.Date.defineInstance({
    "daysInMonth": function(date) {
        return getDaysInMonth(date);
    }
});
module.exports = Sugar.Date.daysInMonth;

},{"65f4884fe5a5402d":"dZZfL","31751e895bd7a682":"kZCiZ"}],"hP5Yz":[function(require,module,exports) {
"use strict";
var Sugar = require("b63c3c43c7e156c8");
require("80f1d7962b8d1a89");
module.exports = Sugar.Date.daysSince;

},{"b63c3c43c7e156c8":"dZZfL","80f1d7962b8d1a89":"e859g"}],"iliJa":[function(require,module,exports) {
"use strict";
var Sugar = require("af34c1c74deabea1");
require("9df6d67507c8a857");
module.exports = Sugar.Date.daysUntil;

},{"af34c1c74deabea1":"dZZfL","9df6d67507c8a857":"e859g"}],"e5aju":[function(require,module,exports) {
"use strict";
var Sugar = require("db56c0d9cd8cb9c5");
require("17360f6f42133679");
module.exports = Sugar.Date.endOfDay;

},{"db56c0d9cd8cb9c5":"dZZfL","17360f6f42133679":"e859g"}],"eq4SV":[function(require,module,exports) {
"use strict";
var Sugar = require("bb4657cb3ee69fe5"), DateUnitIndexes = require("17c739cf7890e19"), getWeekday = require("7f1d70be761be5c6"), setWeekday = require("2d9c7c3ea55ae681"), moveToEndOfUnit = require("3c2cc3e14ef2e9c5");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
Sugar.Date.defineInstance({
    "endOfISOWeek": function(date) {
        if (getWeekday(date) !== 0) setWeekday(date, 7);
        return moveToEndOfUnit(date, DAY_INDEX);
    }
});
module.exports = Sugar.Date.endOfISOWeek;

},{"bb4657cb3ee69fe5":"dZZfL","17c739cf7890e19":"ZayzA","7f1d70be761be5c6":"F9hrY","2d9c7c3ea55ae681":"a9tBU","3c2cc3e14ef2e9c5":"3fWCU"}],"iFhOJ":[function(require,module,exports) {
"use strict";
var Sugar = require("c1ab0e4978354b21");
require("49370164ef177311");
module.exports = Sugar.Date.endOfMonth;

},{"c1ab0e4978354b21":"dZZfL","49370164ef177311":"e859g"}],"1bnXR":[function(require,module,exports) {
"use strict";
var Sugar = require("1feade9dd9c278c0");
require("8160a95d79854402");
module.exports = Sugar.Date.endOfWeek;

},{"1feade9dd9c278c0":"dZZfL","8160a95d79854402":"e859g"}],"9yl5u":[function(require,module,exports) {
"use strict";
var Sugar = require("2a8f3e349d5459f");
require("e8207a92ab61d743");
module.exports = Sugar.Date.endOfYear;

},{"2a8f3e349d5459f":"dZZfL","e8207a92ab61d743":"e859g"}],"bDGyV":[function(require,module,exports) {
"use strict";
var Sugar = require("ff5860a21ac13fef"), dateFormat = require("48a57121496469da");
Sugar.Date.defineInstance({
    "format": function(date, f, localeCode) {
        return dateFormat(date, f, localeCode);
    }
});
module.exports = Sugar.Date.format;

},{"ff5860a21ac13fef":"dZZfL","48a57121496469da":"djDGA"}],"djDGA":[function(require,module,exports) {
"use strict";
var CoreOutputFormats = require("3fbf9739ffe91868"), formattingTokens = require("9b748322e8cceb07"), assertDateIsValid = require("6456526b607413f3");
var dateFormatMatcher = formattingTokens.dateFormatMatcher;
function dateFormat(d, format, localeCode) {
    assertDateIsValid(d);
    format = CoreOutputFormats[format] || format || "{long}";
    return dateFormatMatcher(format, d, localeCode);
}
module.exports = dateFormat;

},{"3fbf9739ffe91868":"347Rj","9b748322e8cceb07":"fDZEX","6456526b607413f3":"luGoB"}],"347Rj":[function(require,module,exports) {
"use strict";
var CoreOutputFormats = {
    "ISO8601": "{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{SSS}{Z}",
    "RFC1123": "{Dow}, {dd} {Mon} {yyyy} {HH}:{mm}:{ss} {ZZ}",
    "RFC1036": "{Weekday}, {dd}-{Mon}-{yy} {HH}:{mm}:{ss} {ZZ}"
};
module.exports = CoreOutputFormats;

},{}],"fDZEX":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("77baa75b5f547377"), FormatTokensBase = require("fde0e5dbfb6c3ae6"), CoreOutputFormats = require("467c35b607bd72aa"), forEach = require("1418d965d09ee664"), padNumber = require("333dc5eaabd24e6c"), spaceSplit = require("aa60a3bd269162c"), namespaceAliases = require("637f89115de28ae5"), coreUtilityAliases = require("ef7c2e71f423cf6e"), createFormatMatcher = require("13333081aaee63c8"), defineInstanceSimilar = require("147365d2711f4e00");
var localeManager = LocaleHelpers.localeManager, hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn, forEachProperty = coreUtilityAliases.forEachProperty, sugarDate = namespaceAliases.sugarDate;
var ldmlTokens, strfTokens;
function buildDateFormatTokens() {
    function addFormats(target, tokens, fn) {
        if (tokens) forEach(spaceSplit(tokens), function(token) {
            target[token] = fn;
        });
    }
    function buildLowercase(get) {
        return function(d, localeCode) {
            return get(d, localeCode).toLowerCase();
        };
    }
    function buildOrdinal(get) {
        return function(d, localeCode) {
            var n = get(d, localeCode);
            return n + localeManager.get(localeCode).getOrdinal(n);
        };
    }
    function buildPadded(get, padding) {
        return function(d, localeCode) {
            return padNumber(get(d, localeCode), padding);
        };
    }
    function buildTwoDigits(get) {
        return function(d, localeCode) {
            return get(d, localeCode) % 100;
        };
    }
    function buildAlias(alias) {
        return function(d, localeCode) {
            return dateFormatMatcher(alias, d, localeCode);
        };
    }
    function buildAlternates(f) {
        for(var n = 1; n <= 5; n++)buildAlternate(f, n);
    }
    function buildAlternate(f, n) {
        var alternate = function alternate(d, localeCode) {
            return f.get(d, localeCode, n);
        };
        addFormats(ldmlTokens, f.ldml + n, alternate);
        if (f.lowerToken) ldmlTokens[f.lowerToken + n] = buildLowercase(alternate);
    }
    function getIdentityFormat(name) {
        return function(d, localeCode) {
            var loc = localeManager.get(localeCode);
            return dateFormatMatcher(loc[name], d, localeCode);
        };
    }
    ldmlTokens = {};
    strfTokens = {};
    forEach(FormatTokensBase, function(f) {
        var get = f.get, getPadded;
        if (f.lowerToken) ldmlTokens[f.lowerToken] = buildLowercase(get);
        if (f.ordinalToken) ldmlTokens[f.ordinalToken] = buildOrdinal(get, f);
        if (f.ldmlPaddedToken) ldmlTokens[f.ldmlPaddedToken] = buildPadded(get, f.ldmlPaddedToken.length);
        if (f.ldmlTwoDigitToken) ldmlTokens[f.ldmlTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
        if (f.strfTwoDigitToken) strfTokens[f.strfTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
        if (f.strfPadding) getPadded = buildPadded(get, f.strfPadding);
        if (f.alias) get = buildAlias(f.alias);
        if (f.allowAlternates) buildAlternates(f);
        addFormats(ldmlTokens, f.ldml, get);
        addFormats(strfTokens, f.strf, getPadded || get);
    });
    forEachProperty(CoreOutputFormats, function(src, name) {
        addFormats(ldmlTokens, name, buildAlias(src));
    });
    defineInstanceSimilar(sugarDate, "short medium long full", function(methods, name) {
        var fn = getIdentityFormat(name);
        addFormats(ldmlTokens, name, fn);
        methods[name] = fn;
    });
    addFormats(ldmlTokens, "time", getIdentityFormat("time"));
    addFormats(ldmlTokens, "stamp", getIdentityFormat("stamp"));
}
var dateFormatMatcher;
function buildDateFormatMatcher() {
    function getLdml(d, token, localeCode) {
        return getOwn(ldmlTokens, token)(d, localeCode);
    }
    function getStrf(d, token, localeCode) {
        return getOwn(strfTokens, token)(d, localeCode);
    }
    function checkDateToken(ldml, strf) {
        return hasOwn(ldmlTokens, ldml) || hasOwn(strfTokens, strf);
    }
    // Format matcher for LDML or STRF tokens.
    dateFormatMatcher = createFormatMatcher(getLdml, getStrf, checkDateToken);
}
buildDateFormatTokens();
buildDateFormatMatcher();
module.exports = {
    ldmlTokens: ldmlTokens,
    strfTokens: strfTokens,
    dateFormatMatcher: dateFormatMatcher
};

},{"77baa75b5f547377":"hlra3","fde0e5dbfb6c3ae6":"e9QS1","467c35b607bd72aa":"347Rj","1418d965d09ee664":"JJnv7","333dc5eaabd24e6c":"6KIGK","aa60a3bd269162c":"cGrLA","637f89115de28ae5":"4onj1","ef7c2e71f423cf6e":"8ZxTV","13333081aaee63c8":"jOe0l","147365d2711f4e00":"6ztHL"}],"e9QS1":[function(require,module,exports) {
"use strict";
var TIMEZONE_ABBREVIATION_REG = require("5cb27033cb4eafcb"), LocaleHelpers = require("a6ce34fe66994f8d"), DateUnitIndexes = require("fccaa9500801448d"), trunc = require("8e44e42c559e0b98"), getDate = require("162254f571a6a349"), getYear = require("8febf6e42779595f"), getHours = require("7d26feb39167c5e3"), getMonth = require("cbdedc7bcfb2a799"), cloneDate = require("46c9bd689bc5d5c6"), padNumber = require("4f37795390c81292"), getWeekday = require("ef298a33b07d14dd"), callDateGet = require("bb27f07ff32a47f8"), mathAliases = require("9534fd38135bab40"), getWeekYear = require("a40477ac5f288862"), getUTCOffset = require("daba7279c6770aa7"), getDaysSince = require("d508dc2a1aaef9ee"), getWeekNumber = require("389d31d6653e7dfe"), getMeridiemToken = require("118d1d5adb2b0773"), setUnitAndLowerToEdge = require("ba4abec1e8a6ae86");
var localeManager = LocaleHelpers.localeManager, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX, ceil = mathAliases.ceil;
var FormatTokensBase = [
    {
        ldml: "Dow",
        strf: "a",
        lowerToken: "dow",
        get: function get(d, localeCode) {
            return localeManager.get(localeCode).getWeekdayName(getWeekday(d), 2);
        }
    },
    {
        ldml: "Weekday",
        strf: "A",
        lowerToken: "weekday",
        allowAlternates: true,
        get: function get(d, localeCode, alternate) {
            return localeManager.get(localeCode).getWeekdayName(getWeekday(d), alternate);
        }
    },
    {
        ldml: "Mon",
        strf: "b h",
        lowerToken: "mon",
        get: function get(d, localeCode) {
            return localeManager.get(localeCode).getMonthName(getMonth(d), 2);
        }
    },
    {
        ldml: "Month",
        strf: "B",
        lowerToken: "month",
        allowAlternates: true,
        get: function get(d, localeCode, alternate) {
            return localeManager.get(localeCode).getMonthName(getMonth(d), alternate);
        }
    },
    {
        strf: "C",
        get: function get(d) {
            return getYear(d).toString().slice(0, 2);
        }
    },
    {
        ldml: "d date day",
        strf: "d",
        strfPadding: 2,
        ldmlPaddedToken: "dd",
        ordinalToken: "do",
        get: function get(d) {
            return getDate(d);
        }
    },
    {
        strf: "e",
        get: function get(d) {
            return padNumber(getDate(d), 2, false, 10, " ");
        }
    },
    {
        ldml: "H 24hr",
        strf: "H",
        strfPadding: 2,
        ldmlPaddedToken: "HH",
        get: function get(d) {
            return getHours(d);
        }
    },
    {
        ldml: "h hours 12hr",
        strf: "I",
        strfPadding: 2,
        ldmlPaddedToken: "hh",
        get: function get(d) {
            return getHours(d) % 12 || 12;
        }
    },
    {
        ldml: "D",
        strf: "j",
        strfPadding: 3,
        ldmlPaddedToken: "DDD",
        get: function get(d) {
            var s = setUnitAndLowerToEdge(cloneDate(d), MONTH_INDEX);
            return getDaysSince(d, s) + 1;
        }
    },
    {
        ldml: "M",
        strf: "m",
        strfPadding: 2,
        ordinalToken: "Mo",
        ldmlPaddedToken: "MM",
        get: function get(d) {
            return getMonth(d) + 1;
        }
    },
    {
        ldml: "m minutes",
        strf: "M",
        strfPadding: 2,
        ldmlPaddedToken: "mm",
        get: function get(d) {
            return callDateGet(d, "Minutes");
        }
    },
    {
        ldml: "Q",
        get: function get(d) {
            return ceil((getMonth(d) + 1) / 3);
        }
    },
    {
        ldml: "TT",
        strf: "p",
        get: function get(d, localeCode) {
            return getMeridiemToken(d, localeCode);
        }
    },
    {
        ldml: "tt",
        strf: "P",
        get: function get(d, localeCode) {
            return getMeridiemToken(d, localeCode).toLowerCase();
        }
    },
    {
        ldml: "T",
        lowerToken: "t",
        get: function get(d, localeCode) {
            return getMeridiemToken(d, localeCode).charAt(0);
        }
    },
    {
        ldml: "s seconds",
        strf: "S",
        strfPadding: 2,
        ldmlPaddedToken: "ss",
        get: function get(d) {
            return callDateGet(d, "Seconds");
        }
    },
    {
        ldml: "S ms",
        strfPadding: 3,
        ldmlPaddedToken: "SSS",
        get: function get(d) {
            return callDateGet(d, "Milliseconds");
        }
    },
    {
        ldml: "e",
        strf: "u",
        ordinalToken: "eo",
        get: function get(d) {
            return getWeekday(d) || 7;
        }
    },
    {
        strf: "U",
        strfPadding: 2,
        get: function get(d) {
            // Sunday first, 0-53
            return getWeekNumber(d, false, 0);
        }
    },
    {
        ldml: "W",
        strf: "V",
        strfPadding: 2,
        ordinalToken: "Wo",
        ldmlPaddedToken: "WW",
        get: function get(d) {
            // Monday first, 1-53 (ISO8601)
            return getWeekNumber(d, true);
        }
    },
    {
        strf: "w",
        get: function get(d) {
            return getWeekday(d);
        }
    },
    {
        ldml: "w",
        ordinalToken: "wo",
        ldmlPaddedToken: "ww",
        get: function get(d, localeCode) {
            // Locale dependent, 1-53
            var loc = localeManager.get(localeCode), dow = loc.getFirstDayOfWeek(localeCode), doy = loc.getFirstDayOfWeekYear(localeCode);
            return getWeekNumber(d, true, dow, doy);
        }
    },
    {
        strf: "W",
        strfPadding: 2,
        get: function get(d) {
            // Monday first, 0-53
            return getWeekNumber(d, false);
        }
    },
    {
        ldmlPaddedToken: "gggg",
        ldmlTwoDigitToken: "gg",
        get: function get(d, localeCode) {
            return getWeekYear(d, localeCode);
        }
    },
    {
        strf: "G",
        strfPadding: 4,
        strfTwoDigitToken: "g",
        ldmlPaddedToken: "GGGG",
        ldmlTwoDigitToken: "GG",
        get: function get(d, localeCode) {
            return getWeekYear(d, localeCode, true);
        }
    },
    {
        ldml: "year",
        ldmlPaddedToken: "yyyy",
        ldmlTwoDigitToken: "yy",
        strf: "Y",
        strfPadding: 4,
        strfTwoDigitToken: "y",
        get: function get(d) {
            return getYear(d);
        }
    },
    {
        ldml: "ZZ",
        strf: "z",
        get: function get(d) {
            return getUTCOffset(d);
        }
    },
    {
        ldml: "X",
        get: function get(d) {
            return trunc(d.getTime() / 1000);
        }
    },
    {
        ldml: "x",
        get: function get(d) {
            return d.getTime();
        }
    },
    {
        ldml: "Z",
        get: function get(d) {
            return getUTCOffset(d, true);
        }
    },
    {
        ldml: "z",
        strf: "Z",
        get: function get(d) {
            // Note that this is not accurate in all browsing environments!
            // https://github.com/moment/moment/issues/162
            // It will continue to be supported for Node and usage with the
            // understanding that it may be blank.
            var match = d.toString().match(TIMEZONE_ABBREVIATION_REG);
            // istanbul ignore next
            return match ? match[1] : "";
        }
    },
    {
        strf: "D",
        alias: "%m/%d/%y"
    },
    {
        strf: "F",
        alias: "%Y-%m-%d"
    },
    {
        strf: "r",
        alias: "%I:%M:%S %p"
    },
    {
        strf: "R",
        alias: "%H:%M"
    },
    {
        strf: "T",
        alias: "%H:%M:%S"
    },
    {
        strf: "x",
        alias: "{short}"
    },
    {
        strf: "X",
        alias: "{time}"
    },
    {
        strf: "c",
        alias: "{stamp}"
    }
];
module.exports = FormatTokensBase;

},{"5cb27033cb4eafcb":"2arh7","a6ce34fe66994f8d":"hlra3","fccaa9500801448d":"ZayzA","8e44e42c559e0b98":"898n5","162254f571a6a349":"5ATC1","8febf6e42779595f":"id9WV","7d26feb39167c5e3":"2cPoN","cbdedc7bcfb2a799":"8e21l","46c9bd689bc5d5c6":"lvF4j","4f37795390c81292":"6KIGK","ef298a33b07d14dd":"F9hrY","bb27f07ff32a47f8":"5mOF6","9534fd38135bab40":"f1S5P","a40477ac5f288862":"SrdJK","daba7279c6770aa7":"dG1nY","d508dc2a1aaef9ee":"cTEnZ","389d31d6653e7dfe":"45ziU","118d1d5adb2b0773":"0132t","ba4abec1e8a6ae86":"fGenX"}],"2arh7":[function(require,module,exports) {
"use strict";
module.exports = /\(([-+]\d{2,4}|\w{3,5})\)$/;

},{}],"2cPoN":[function(require,module,exports) {
"use strict";
var callDateGet = require("9ef7b0ebf56913cc");
function getHours(d) {
    return callDateGet(d, "Hours");
}
module.exports = getHours;

},{"9ef7b0ebf56913cc":"5mOF6"}],"SrdJK":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("32bbdb6842624e3c"), getYear = require("1fd0b17488ddaaef"), getMonth = require("33d89fce1adcc7ac"), getWeekNumber = require("565e4d36af3ef177");
var localeManager = LocaleHelpers.localeManager;
function getWeekYear(d, localeCode, iso) {
    var year, month, firstDayOfWeek, firstDayOfWeekYear, week, loc;
    year = getYear(d);
    month = getMonth(d);
    if (month === 0 || month === 11) {
        if (!iso) {
            loc = localeManager.get(localeCode);
            firstDayOfWeek = loc.getFirstDayOfWeek(localeCode);
            firstDayOfWeekYear = loc.getFirstDayOfWeekYear(localeCode);
        }
        week = getWeekNumber(d, false, firstDayOfWeek, firstDayOfWeekYear);
        if (month === 0 && week === 0) year -= 1;
        else if (month === 11 && week === 1) year += 1;
    }
    return year;
}
module.exports = getWeekYear;

},{"32bbdb6842624e3c":"hlra3","1fd0b17488ddaaef":"id9WV","33d89fce1adcc7ac":"8e21l","565e4d36af3ef177":"45ziU"}],"45ziU":[function(require,module,exports) {
"use strict";
var ISODefaults = require("10b59bf6ea9c39bd"), setDate = require("c02f2e5616ff8c46"), getDate = require("1c7791adf2850905"), cloneDate = require("80d8b1fd25f4e18e"), isUndefined = require("60d9994b9a4ecfad"), moveToEndOfWeek = require("3915bbd4cada43aa"), moveToBeginningOfWeek = require("5a5d75906c5efd16"), moveToFirstDayOfWeekYear = require("29ace207512435f5");
var ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR;
function getWeekNumber(d, allowPrevious, firstDayOfWeek, firstDayOfWeekYear) {
    var isoWeek, n = 0;
    if (isUndefined(firstDayOfWeek)) firstDayOfWeek = ISO_FIRST_DAY_OF_WEEK;
    if (isUndefined(firstDayOfWeekYear)) firstDayOfWeekYear = ISO_FIRST_DAY_OF_WEEK_YEAR;
    // Moving to the end of the week allows for forward year traversal, ie
    // Dec 29 2014 is actually week 01 of 2015.
    isoWeek = moveToEndOfWeek(cloneDate(d), firstDayOfWeek);
    moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
    if (allowPrevious && d < isoWeek) {
        // If the date is still before the start of the year, then it should be
        // the last week of the previous year, ie Jan 1 2016 is actually week 53
        // of 2015, so move to the beginning of the week to traverse the year.
        isoWeek = moveToBeginningOfWeek(cloneDate(d), firstDayOfWeek);
        moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
    }
    while(isoWeek <= d){
        // Doing a very simple walk to get the week number.
        setDate(isoWeek, getDate(isoWeek) + 7);
        n++;
    }
    return n;
}
module.exports = getWeekNumber;

},{"10b59bf6ea9c39bd":"8oT1W","c02f2e5616ff8c46":"euZpm","1c7791adf2850905":"5ATC1","80d8b1fd25f4e18e":"lvF4j","60d9994b9a4ecfad":"6oRAa","3915bbd4cada43aa":"9ajiG","5a5d75906c5efd16":"dcxiC","29ace207512435f5":"3F5wL"}],"dG1nY":[function(require,module,exports) {
"use strict";
var _utc = require("75dbdb2991e8e266"), trunc = require("5372532999a7638e"), tzOffset = require("6258d7c7df091f6a"), padNumber = require("9f0c9d7d2b941025"), mathAliases = require("d46103fc0cdab1e5");
var abs = mathAliases.abs;
function getUTCOffset(d, iso) {
    var offset = _utc(d) ? 0 : tzOffset(d), hours, mins, colon;
    colon = iso === true ? ":" : "";
    if (!offset && iso) return "Z";
    hours = padNumber(trunc(-offset / 60), 2, true);
    mins = padNumber(abs(offset % 60), 2);
    return hours + colon + mins;
}
module.exports = getUTCOffset;

},{"75dbdb2991e8e266":"01lmY","5372532999a7638e":"898n5","6258d7c7df091f6a":"7uIyU","9f0c9d7d2b941025":"6KIGK","d46103fc0cdab1e5":"f1S5P"}],"cTEnZ":[function(require,module,exports) {
"use strict";
var DateUnits = require("3852985b41873642"), DateUnitIndexes = require("c97b53ff5931161c"), getTimeDistanceForUnit = require("be8df42658f2b6ab");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
function getDaysSince(d1, d2) {
    return getTimeDistanceForUnit(d1, d2, DateUnits[DAY_INDEX]);
}
module.exports = getDaysSince;

},{"3852985b41873642":"kFuUz","c97b53ff5931161c":"ZayzA","be8df42658f2b6ab":"6xSB2"}],"0132t":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("6c10ae54ed803764"), trunc = require("575b229f9635cf16"), getHours = require("67645f7105bec78d");
var localeManager = LocaleHelpers.localeManager;
function getMeridiemToken(d, localeCode) {
    var hours = getHours(d);
    return localeManager.get(localeCode).ampm[trunc(hours / 12)] || "";
}
module.exports = getMeridiemToken;

},{"6c10ae54ed803764":"hlra3","575b229f9635cf16":"898n5","67645f7105bec78d":"2cPoN"}],"luGoB":[function(require,module,exports) {
"use strict";
var dateIsValid = require("64b6a190682b4a2a");
function assertDateIsValid(d) {
    if (!dateIsValid(d)) throw new TypeError("Date is not valid");
}
module.exports = assertDateIsValid;

},{"64b6a190682b4a2a":"iVwwI"}],"hyoFo":[function(require,module,exports) {
"use strict";
var Sugar = require("57ddb2c41e297852"), createDateWithContext = require("3de4c99485d8b786");
Sugar.Date.defineInstance({
    "get": function(date, d, options) {
        return createDateWithContext(date, d, options);
    }
});
module.exports = Sugar.Date.get;

},{"57ddb2c41e297852":"dZZfL","3de4c99485d8b786":"hlVrm"}],"hlVrm":[function(require,module,exports) {
"use strict";
var getExtendedDate = require("ca57ce83e4254b22");
function createDateWithContext(contextDate, d, options, forceClone) {
    return getExtendedDate(contextDate, d, options, forceClone).date;
}
module.exports = createDateWithContext;

},{"ca57ce83e4254b22":"eirnu"}],"asbZS":[function(require,module,exports) {
"use strict";
var Sugar = require("c412df942e42cc9a"), getWeekNumber = require("c4d4932b5817f981");
Sugar.Date.defineInstance({
    "getISOWeek": function(date) {
        return getWeekNumber(date, true);
    }
});
module.exports = Sugar.Date.getISOWeek;

},{"c412df942e42cc9a":"dZZfL","c4d4932b5817f981":"45ziU"}],"9Fhr4":[function(require,module,exports) {
"use strict";
var Sugar = require("62c0bf0db3c3f859"), getUTCOffset = require("372446518b403315");
Sugar.Date.defineInstance({
    "getUTCOffset": function(date, iso) {
        return getUTCOffset(date, iso);
    }
});
module.exports = Sugar.Date.getUTCOffset;

},{"62c0bf0db3c3f859":"dZZfL","372446518b403315":"dG1nY"}],"llLL0":[function(require,module,exports) {
"use strict";
var Sugar = require("8fc6614ab9267b5e");
Sugar.Date.defineInstance({
    "getUTCWeekday": function(date) {
        return date.getUTCDay();
    }
});
module.exports = Sugar.Date.getUTCWeekday;

},{"8fc6614ab9267b5e":"dZZfL"}],"4Ts2m":[function(require,module,exports) {
"use strict";
var Sugar = require("ccaecc6f315dce59"), getWeekday = require("73855cf861a086a9");
Sugar.Date.defineInstance({
    "getWeekday": function(date) {
        return getWeekday(date);
    }
});
module.exports = Sugar.Date.getWeekday;

},{"ccaecc6f315dce59":"dZZfL","73855cf861a086a9":"F9hrY"}],"eYNOf":[function(require,module,exports) {
"use strict";
var Sugar = require("c3869e947c98e31");
require("f6d825d16eede399");
module.exports = Sugar.Date.hoursAgo;

},{"c3869e947c98e31":"dZZfL","f6d825d16eede399":"e859g"}],"audGq":[function(require,module,exports) {
"use strict";
var Sugar = require("4f64bb4b9817bc0d");
require("7716f7625306c780");
module.exports = Sugar.Date.hoursFromNow;

},{"4f64bb4b9817bc0d":"dZZfL","7716f7625306c780":"e859g"}],"63eay":[function(require,module,exports) {
"use strict";
var Sugar = require("7a28fbd0ba908afd");
require("ea74a0dbe1bc93b");
module.exports = Sugar.Date.hoursSince;

},{"7a28fbd0ba908afd":"dZZfL","ea74a0dbe1bc93b":"e859g"}],"co8I3":[function(require,module,exports) {
"use strict";
var Sugar = require("cf665d43566bbab0");
require("13a7c0895b3b4320");
module.exports = Sugar.Date.hoursUntil;

},{"cf665d43566bbab0":"dZZfL","13a7c0895b3b4320":"e859g"}],"bMXpT":[function(require,module,exports) {
"use strict";
var Sugar = require("fd5563bf652ba08f"), fullCompareDate = require("575f35153418b49e");
Sugar.Date.defineInstance({
    "is": function(date, d, margin) {
        return fullCompareDate(date, d, margin);
    }
});
module.exports = Sugar.Date.is;

},{"fd5563bf652ba08f":"dZZfL","575f35153418b49e":"jJh8V"}],"jJh8V":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("e8c743c82ad15b58"), trim = require("a1641d07971150fe"), getMonth = require("982c8b062124914"), isDefined = require("5f886ed4ef8c1dd9"), getNewDate = require("887011c2a462cf85"), compareDay = require("efd6df9467ab1f38"), getWeekday = require("47e6961e559a90a"), dateIsValid = require("50a7428d2f3c8901"), classChecks = require("25dd53cb720e25f6"), compareDate = require("8422085c442612c4");
var isString = classChecks.isString, English = LocaleHelpers.English;
function fullCompareDate(date, d, margin) {
    var tmp;
    if (!dateIsValid(date)) return;
    if (isString(d)) {
        d = trim(d).toLowerCase();
        switch(true){
            case d === "future":
                return date.getTime() > getNewDate().getTime();
            case d === "past":
                return date.getTime() < getNewDate().getTime();
            case d === "today":
                return compareDay(date);
            case d === "tomorrow":
                return compareDay(date, 1);
            case d === "yesterday":
                return compareDay(date, -1);
            case d === "weekday":
                return getWeekday(date) > 0 && getWeekday(date) < 6;
            case d === "weekend":
                return getWeekday(date) === 0 || getWeekday(date) === 6;
            case isDefined(tmp = English.weekdayMap[d]):
                return getWeekday(date) === tmp;
            case isDefined(tmp = English.monthMap[d]):
                return getMonth(date) === tmp;
        }
    }
    return compareDate(date, d, margin);
}
module.exports = fullCompareDate;

},{"e8c743c82ad15b58":"hlra3","a1641d07971150fe":"2PiXk","982c8b062124914":"8e21l","5f886ed4ef8c1dd9":"4cOOJ","887011c2a462cf85":"bARv2","efd6df9467ab1f38":"6SME7","47e6961e559a90a":"F9hrY","50a7428d2f3c8901":"iVwwI","25dd53cb720e25f6":"MTXUY","8422085c442612c4":"lA7t7"}],"6SME7":[function(require,module,exports) {
"use strict";
var setDate = require("1519355ee5db19a7"), getDate = require("19cda6169a876a29"), getYear = require("b49ae3aa64c9eac4"), getMonth = require("48a9ee4b10ad07be"), getNewDate = require("b4dc3028c0ecc115");
function compareDay(d, shift) {
    var comp = getNewDate();
    if (shift) setDate(comp, getDate(comp) + shift);
    return getYear(d) === getYear(comp) && getMonth(d) === getMonth(comp) && getDate(d) === getDate(comp);
}
module.exports = compareDay;

},{"1519355ee5db19a7":"euZpm","19cda6169a876a29":"5ATC1","b49ae3aa64c9eac4":"id9WV","48a9ee4b10ad07be":"8e21l","b4dc3028c0ecc115":"bARv2"}],"fUO92":[function(require,module,exports) {
"use strict";
var Sugar = require("eac6883dfb83bbce"), createDate = require("589273babdb63aed");
Sugar.Date.defineInstance({
    "isAfter": function(date, d, margin) {
        return date.getTime() > createDate(d).getTime() - (margin || 0);
    }
});
module.exports = Sugar.Date.isAfter;

},{"eac6883dfb83bbce":"dZZfL","589273babdb63aed":"4SmZz"}],"1VNdY":[function(require,module,exports) {
"use strict";
var Sugar = require("f599300d702752af"), createDate = require("248ce76f627f06f7");
Sugar.Date.defineInstance({
    "isBefore": function(date, d, margin) {
        return date.getTime() < createDate(d).getTime() + (margin || 0);
    }
});
module.exports = Sugar.Date.isBefore;

},{"f599300d702752af":"dZZfL","248ce76f627f06f7":"4SmZz"}],"kqr40":[function(require,module,exports) {
"use strict";
var Sugar = require("e3e5f8321475a638"), createDate = require("96e1db34491fe424"), mathAliases = require("98a7811f522b019f");
var min = mathAliases.min, max = mathAliases.max;
Sugar.Date.defineInstance({
    "isBetween": function(date, d1, d2, margin) {
        var t = date.getTime();
        var t1 = createDate(d1).getTime();
        var t2 = createDate(d2).getTime();
        var lo = min(t1, t2);
        var hi = max(t1, t2);
        margin = margin || 0;
        return lo - margin <= t && hi + margin >= t;
    }
});
module.exports = Sugar.Date.isBetween;

},{"e3e5f8321475a638":"dZZfL","96e1db34491fe424":"4SmZz","98a7811f522b019f":"f1S5P"}],"eHuRb":[function(require,module,exports) {
"use strict";
var Sugar = require("b8ecb6bdf0e44abf");
require("99ef311bf1270b4e");
module.exports = Sugar.Date.isFriday;

},{"b8ecb6bdf0e44abf":"dZZfL","99ef311bf1270b4e":"4FjYA"}],"4FjYA":[function(require,module,exports) {
"use strict";
var buildRelativeAliases = require("aabb7f1b0644ff34");
buildRelativeAliases();

},{"aabb7f1b0644ff34":"5AmxV"}],"5AmxV":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("a9b6facacfeed035"), spaceSplit = require("1f9f3caec56dab31"), fullCompareDate = require("e84e96cce8e17ce2"), namespaceAliases = require("884dddd25bc82c98"), defineInstanceSimilar = require("b38419c79ac13e42");
var English = LocaleHelpers.English, sugarDate = namespaceAliases.sugarDate;
function buildRelativeAliases() {
    var special = spaceSplit("Today Yesterday Tomorrow Weekday Weekend Future Past");
    var weekdays = English.weekdays.slice(0, 7);
    var months = English.months.slice(0, 12);
    var together = special.concat(weekdays).concat(months);
    defineInstanceSimilar(sugarDate, together, function(methods, name) {
        methods["is" + name] = function(d) {
            return fullCompareDate(d, name);
        };
    });
}
module.exports = buildRelativeAliases;

},{"a9b6facacfeed035":"hlra3","1f9f3caec56dab31":"cGrLA","e84e96cce8e17ce2":"jJh8V","884dddd25bc82c98":"4onj1","b38419c79ac13e42":"6ztHL"}],"lq88x":[function(require,module,exports) {
"use strict";
var Sugar = require("f36e01786bdaa11e");
require("b49060c55b4125");
module.exports = Sugar.Date.isFuture;

},{"f36e01786bdaa11e":"dZZfL","b49060c55b4125":"4FjYA"}],"3OSRM":[function(require,module,exports) {
"use strict";
var Sugar = require("4394097c662be7c6");
require("ace3aa91c7aeacbd");
module.exports = Sugar.Date.isLastMonth;

},{"4394097c662be7c6":"dZZfL","ace3aa91c7aeacbd":"e859g"}],"beqKQ":[function(require,module,exports) {
"use strict";
var Sugar = require("700781359ce5524d");
require("42e247cc755b9329");
module.exports = Sugar.Date.isLastWeek;

},{"700781359ce5524d":"dZZfL","42e247cc755b9329":"e859g"}],"4gisX":[function(require,module,exports) {
"use strict";
var Sugar = require("cf0b2fdfa35b6b6b");
require("72f4c2daf8627b46");
module.exports = Sugar.Date.isLastYear;

},{"cf0b2fdfa35b6b6b":"dZZfL","72f4c2daf8627b46":"e859g"}],"9u5NL":[function(require,module,exports) {
"use strict";
var Sugar = require("508c993f4920b8b"), getYear = require("56d7d80b15696826");
Sugar.Date.defineInstance({
    "isLeapYear": function(date) {
        var year = getYear(date);
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
});
module.exports = Sugar.Date.isLeapYear;

},{"508c993f4920b8b":"dZZfL","56d7d80b15696826":"id9WV"}],"3UAZb":[function(require,module,exports) {
"use strict";
var Sugar = require("349f8c234cd4b378");
require("7e2148aeb0329715");
module.exports = Sugar.Date.isMonday;

},{"349f8c234cd4b378":"dZZfL","7e2148aeb0329715":"4FjYA"}],"7fMNv":[function(require,module,exports) {
"use strict";
var Sugar = require("69fb3b02ebd7048a");
require("211706840dda2722");
module.exports = Sugar.Date.isNextMonth;

},{"69fb3b02ebd7048a":"dZZfL","211706840dda2722":"e859g"}],"cZtJY":[function(require,module,exports) {
"use strict";
var Sugar = require("cf4ca4dd5fe7df7d");
require("1d5ef93e9b362b1b");
module.exports = Sugar.Date.isNextWeek;

},{"cf4ca4dd5fe7df7d":"dZZfL","1d5ef93e9b362b1b":"e859g"}],"gy1wN":[function(require,module,exports) {
"use strict";
var Sugar = require("ef8eeae167f13174");
require("c4abc525c6b0d761");
module.exports = Sugar.Date.isNextYear;

},{"ef8eeae167f13174":"dZZfL","c4abc525c6b0d761":"e859g"}],"lSo3y":[function(require,module,exports) {
"use strict";
var Sugar = require("187d4fc4250245ad");
require("cbb826c1c154280f");
module.exports = Sugar.Date.isPast;

},{"187d4fc4250245ad":"dZZfL","cbb826c1c154280f":"4FjYA"}],"evm0x":[function(require,module,exports) {
"use strict";
var Sugar = require("f2056cb2c175d783");
require("68085c57020f4af0");
module.exports = Sugar.Date.isSaturday;

},{"f2056cb2c175d783":"dZZfL","68085c57020f4af0":"4FjYA"}],"01KKF":[function(require,module,exports) {
"use strict";
var Sugar = require("ae70292f78faf482");
require("78d80f610496a39c");
module.exports = Sugar.Date.isSunday;

},{"ae70292f78faf482":"dZZfL","78d80f610496a39c":"4FjYA"}],"lSlkk":[function(require,module,exports) {
"use strict";
var Sugar = require("cc41951a9c0466c0");
require("759103248217ae8e");
module.exports = Sugar.Date.isThisMonth;

},{"cc41951a9c0466c0":"dZZfL","759103248217ae8e":"e859g"}],"bgJdS":[function(require,module,exports) {
"use strict";
var Sugar = require("715717d06a0d177");
require("2132e617b95b6fee");
module.exports = Sugar.Date.isThisWeek;

},{"715717d06a0d177":"dZZfL","2132e617b95b6fee":"e859g"}],"dUKln":[function(require,module,exports) {
"use strict";
var Sugar = require("4b39a427fd6d2f8");
require("ec769305fa1666fd");
module.exports = Sugar.Date.isThisYear;

},{"4b39a427fd6d2f8":"dZZfL","ec769305fa1666fd":"e859g"}],"kv9v3":[function(require,module,exports) {
"use strict";
var Sugar = require("8332e89ff98a2934");
require("90adb43c1c8e7262");
module.exports = Sugar.Date.isThursday;

},{"8332e89ff98a2934":"dZZfL","90adb43c1c8e7262":"4FjYA"}],"i0Tha":[function(require,module,exports) {
"use strict";
var Sugar = require("72afced5eafcf85a");
require("f8c03bc161345221");
module.exports = Sugar.Date.isToday;

},{"72afced5eafcf85a":"dZZfL","f8c03bc161345221":"4FjYA"}],"11mcF":[function(require,module,exports) {
"use strict";
var Sugar = require("aca5fd69d82c967f");
require("31a72f850c2cd664");
module.exports = Sugar.Date.isTomorrow;

},{"aca5fd69d82c967f":"dZZfL","31a72f850c2cd664":"4FjYA"}],"5tJ2C":[function(require,module,exports) {
"use strict";
var Sugar = require("2e5b1fef74575287");
require("130449b4952ff44c");
module.exports = Sugar.Date.isTuesday;

},{"2e5b1fef74575287":"dZZfL","130449b4952ff44c":"4FjYA"}],"9Ltmj":[function(require,module,exports) {
"use strict";
var Sugar = require("12ef78a85ba64bbe"), isUTC = require("a597f0c0aa3625f6");
Sugar.Date.defineInstance({
    "isUTC": function(date) {
        return isUTC(date);
    }
});
module.exports = Sugar.Date.isUTC;

},{"12ef78a85ba64bbe":"dZZfL","a597f0c0aa3625f6":"qgMEM"}],"qgMEM":[function(require,module,exports) {
"use strict";
var _utc = require("24f445eeee51ae56"), tzOffset = require("6a9b8a6ad8194d68");
function isUTC(d) {
    return !!_utc(d) || tzOffset(d) === 0;
}
module.exports = isUTC;

},{"24f445eeee51ae56":"01lmY","6a9b8a6ad8194d68":"7uIyU"}],"lySHR":[function(require,module,exports) {
"use strict";
var Sugar = require("dbf497a2e3e1eda5"), dateIsValid = require("1b05fd5ddbd795ad");
Sugar.Date.defineInstance({
    "isValid": function(date) {
        return dateIsValid(date);
    }
});
module.exports = Sugar.Date.isValid;

},{"dbf497a2e3e1eda5":"dZZfL","1b05fd5ddbd795ad":"iVwwI"}],"3xaDE":[function(require,module,exports) {
"use strict";
var Sugar = require("8d56ae887489a561");
require("6e76fdd3818a699c");
module.exports = Sugar.Date.isWednesday;

},{"8d56ae887489a561":"dZZfL","6e76fdd3818a699c":"4FjYA"}],"jpnGA":[function(require,module,exports) {
"use strict";
var Sugar = require("d2bc07500dd93005");
require("fb118157ba55a5a3");
module.exports = Sugar.Date.isWeekday;

},{"d2bc07500dd93005":"dZZfL","fb118157ba55a5a3":"4FjYA"}],"hLSOf":[function(require,module,exports) {
"use strict";
var Sugar = require("65c1e55b0286eb50");
require("e29a093e668f39b5");
module.exports = Sugar.Date.isWeekend;

},{"65c1e55b0286eb50":"dZZfL","e29a093e668f39b5":"4FjYA"}],"3hENp":[function(require,module,exports) {
"use strict";
var Sugar = require("6d34b65e182a0e13");
require("48582a1528583fb6");
module.exports = Sugar.Date.isYesterday;

},{"6d34b65e182a0e13":"dZZfL","48582a1528583fb6":"4FjYA"}],"6QwUr":[function(require,module,exports) {
"use strict";
var Sugar = require("ad57a80781d789fd");
Sugar.Date.defineInstance({
    "iso": function(date) {
        return date.toISOString();
    }
});
module.exports = Sugar.Date.iso;

},{"ad57a80781d789fd":"dZZfL"}],"eadMP":[function(require,module,exports) {
"use strict";
var Sugar = require("e64cce900daf7974");
require("9cedf7726517390c");
module.exports = Sugar.Date.millisecondsAgo;

},{"e64cce900daf7974":"dZZfL","9cedf7726517390c":"e859g"}],"b44aT":[function(require,module,exports) {
"use strict";
var Sugar = require("19a78ac329e60df");
require("318d02e2e60fdae3");
module.exports = Sugar.Date.millisecondsFromNow;

},{"19a78ac329e60df":"dZZfL","318d02e2e60fdae3":"e859g"}],"kTtS0":[function(require,module,exports) {
"use strict";
var Sugar = require("fd66fe7af5f6b9c");
require("f86406e8102fc07e");
module.exports = Sugar.Date.millisecondsSince;

},{"fd66fe7af5f6b9c":"dZZfL","f86406e8102fc07e":"e859g"}],"4ctfN":[function(require,module,exports) {
"use strict";
var Sugar = require("2b7a2ef84a846b67");
require("97560185b6ad5222");
module.exports = Sugar.Date.millisecondsUntil;

},{"2b7a2ef84a846b67":"dZZfL","97560185b6ad5222":"e859g"}],"d84Pn":[function(require,module,exports) {
"use strict";
var Sugar = require("b32041c42cea83cb");
require("fdb14fefcbaa0a26");
module.exports = Sugar.Date.minutesAgo;

},{"b32041c42cea83cb":"dZZfL","fdb14fefcbaa0a26":"e859g"}],"jc2wq":[function(require,module,exports) {
"use strict";
var Sugar = require("38292447e326d81b");
require("da39a524cf35636c");
module.exports = Sugar.Date.minutesFromNow;

},{"38292447e326d81b":"dZZfL","da39a524cf35636c":"e859g"}],"etwmK":[function(require,module,exports) {
"use strict";
var Sugar = require("b28227a8f72880ad");
require("c294a94da2484ed");
module.exports = Sugar.Date.minutesSince;

},{"b28227a8f72880ad":"dZZfL","c294a94da2484ed":"e859g"}],"hGBGH":[function(require,module,exports) {
"use strict";
var Sugar = require("c67fe9d495c95950");
require("6dca8ffa7c6b874f");
module.exports = Sugar.Date.minutesUntil;

},{"c67fe9d495c95950":"dZZfL","6dca8ffa7c6b874f":"e859g"}],"jO4OY":[function(require,module,exports) {
"use strict";
var Sugar = require("c3598223a904307a");
require("a06c2f866b332c6c");
module.exports = Sugar.Date.monthsAgo;

},{"c3598223a904307a":"dZZfL","a06c2f866b332c6c":"e859g"}],"aVCRT":[function(require,module,exports) {
"use strict";
var Sugar = require("d85b6a158064f8fa");
require("afee3facf3d04258");
module.exports = Sugar.Date.monthsFromNow;

},{"d85b6a158064f8fa":"dZZfL","afee3facf3d04258":"e859g"}],"94VJH":[function(require,module,exports) {
"use strict";
var Sugar = require("d162f3ac247ce6fd");
require("9f8776c36d8bf0a9");
module.exports = Sugar.Date.monthsSince;

},{"d162f3ac247ce6fd":"dZZfL","9f8776c36d8bf0a9":"e859g"}],"kdzno":[function(require,module,exports) {
"use strict";
var Sugar = require("cb18fa00f9ac19af");
require("f0c97483681e6dfa");
module.exports = Sugar.Date.monthsUntil;

},{"cb18fa00f9ac19af":"dZZfL","f0c97483681e6dfa":"e859g"}],"2qgWX":[function(require,module,exports) {
"use strict";
var Sugar = require("d52f630dfe6302da"), dateRelative = require("f6b28bf20af7bb0f");
Sugar.Date.defineInstance({
    "relative": function(date, localeCode, relativeFn) {
        return dateRelative(date, null, localeCode, relativeFn);
    }
});
module.exports = Sugar.Date.relative;

},{"d52f630dfe6302da":"dZZfL","f6b28bf20af7bb0f":"i3p9w"}],"i3p9w":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("30724827015a71a1"), dateFormat = require("b9a9f04d0cbaa828"), classChecks = require("d66f9b0458150626"), assertDateIsValid = require("6bbbf77288aae69d"), getAdjustedUnitForDate = require("86eb64ba68705185");
var isFunction = classChecks.isFunction, localeManager = LocaleHelpers.localeManager;
function dateRelative(d, dRelative, arg1, arg2) {
    var adu, format, type, localeCode, fn;
    assertDateIsValid(d);
    if (isFunction(arg1)) fn = arg1;
    else {
        localeCode = arg1;
        fn = arg2;
    }
    adu = getAdjustedUnitForDate(d, dRelative);
    if (fn) {
        format = fn.apply(d, adu.concat(localeManager.get(localeCode)));
        if (format) return dateFormat(d, format, localeCode);
    }
    // Adjust up if time is in ms, as this doesn't
    // look very good for a standard relative date.
    if (adu[1] === 0) {
        adu[1] = 1;
        adu[0] = 1;
    }
    if (dRelative) type = "duration";
    else if (adu[2] > 0) type = "future";
    else type = "past";
    return localeManager.get(localeCode).getRelativeFormat(adu, type);
}
module.exports = dateRelative;

},{"30724827015a71a1":"hlra3","b9a9f04d0cbaa828":"djDGA","d66f9b0458150626":"MTXUY","6bbbf77288aae69d":"luGoB","86eb64ba68705185":"fml1Z"}],"fml1Z":[function(require,module,exports) {
"use strict";
var getNewDate = require("1b4092bb990a69df"), mathAliases = require("b331ec7ea86c9e58"), getAdjustedUnit = require("97060a0eb462cb0e"), getTimeDistanceForUnit = require("a50e829724f2fb14");
var abs = mathAliases.abs;
function getAdjustedUnitForDate(d, dRelative) {
    var ms;
    if (!dRelative) {
        dRelative = getNewDate();
        if (d > dRelative) // If our date is greater than the one that we got from getNewDate, it
        // means that we are finding the unit for a date that is in the future
        // relative to now. However, often the incoming date was created in
        // the same cycle as our comparison, but our "now" date will have been
        // created an instant after it, creating situations where "5 minutes from
        // now" becomes "4 minutes from now" in the same tick. To prevent this,
        // subtract a buffer of 10ms to compensate.
        dRelative = new Date(dRelative.getTime() - 10);
    }
    ms = d - dRelative;
    return getAdjustedUnit(ms, function(u) {
        return abs(getTimeDistanceForUnit(d, dRelative, u));
    });
}
module.exports = getAdjustedUnitForDate;

},{"1b4092bb990a69df":"bARv2","b331ec7ea86c9e58":"f1S5P","97060a0eb462cb0e":"6UPEG","a50e829724f2fb14":"6xSB2"}],"8J9Ci":[function(require,module,exports) {
"use strict";
var Sugar = require("747c3eb90c68f4e7"), createDate = require("59fe490ebad1cc4b"), dateRelative = require("15a9caf3fdf99489");
Sugar.Date.defineInstance({
    "relativeTo": function(date, d, localeCode) {
        return dateRelative(date, createDate(d), localeCode);
    }
});
module.exports = Sugar.Date.relativeTo;

},{"747c3eb90c68f4e7":"dZZfL","59fe490ebad1cc4b":"4SmZz","15a9caf3fdf99489":"i3p9w"}],"ktc0Y":[function(require,module,exports) {
"use strict";
var Sugar = require("b47cb0ac9a1677fa"), DateUnitIndexes = require("e320bc298ed90e53"), moveToBeginningOfUnit = require("3484c014209c3890"), getUnitIndexForParamName = require("653cf4e73f6af914");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
Sugar.Date.defineInstance({
    "reset": function(date, unit, localeCode) {
        var unitIndex = unit ? getUnitIndexForParamName(unit) : DAY_INDEX;
        moveToBeginningOfUnit(date, unitIndex, localeCode);
        return date;
    }
});
module.exports = Sugar.Date.reset;

},{"b47cb0ac9a1677fa":"dZZfL","e320bc298ed90e53":"ZayzA","3484c014209c3890":"fpOPw","653cf4e73f6af914":"ey2W5"}],"ey2W5":[function(require,module,exports) {
"use strict";
var iterateOverDateParams = require("894263bd24e3f999");
function getUnitIndexForParamName(name) {
    var params = {}, unitIndex;
    params[name] = 1;
    iterateOverDateParams(params, function(name, val, unit, i) {
        unitIndex = i;
        return false;
    });
    return unitIndex;
}
module.exports = getUnitIndexForParamName;

},{"894263bd24e3f999":"gjSqr"}],"0vBId":[function(require,module,exports) {
"use strict";
var Sugar = require("d6671d21307c0a12"), advanceDateWithArgs = require("17684d2ed42f4ffc");
Sugar.Date.defineInstanceWithArguments({
    "rewind": function(d, args) {
        return advanceDateWithArgs(d, args, -1);
    }
});
module.exports = Sugar.Date.rewind;

},{"d6671d21307c0a12":"dZZfL","17684d2ed42f4ffc":"gJnUh"}],"kEF3E":[function(require,module,exports) {
"use strict";
var Sugar = require("dabd9f21ecebc873");
require("86af38715165ae0a");
module.exports = Sugar.Date.secondsAgo;

},{"dabd9f21ecebc873":"dZZfL","86af38715165ae0a":"e859g"}],"6BqIw":[function(require,module,exports) {
"use strict";
var Sugar = require("b855408e9e54f4c7");
require("a7c2e1a2c139cdf3");
module.exports = Sugar.Date.secondsFromNow;

},{"b855408e9e54f4c7":"dZZfL","a7c2e1a2c139cdf3":"e859g"}],"aQGZx":[function(require,module,exports) {
"use strict";
var Sugar = require("9f2e6bcdf0e5ce73");
require("926a686d95878810");
module.exports = Sugar.Date.secondsSince;

},{"9f2e6bcdf0e5ce73":"dZZfL","926a686d95878810":"e859g"}],"cWxPq":[function(require,module,exports) {
"use strict";
var Sugar = require("ae4befb4ebf95bf6");
require("fa8fb9bbd7741925");
module.exports = Sugar.Date.secondsUntil;

},{"ae4befb4ebf95bf6":"dZZfL","fa8fb9bbd7741925":"e859g"}],"gEJVI":[function(require,module,exports) {
"use strict";
var Sugar = require("7b2c1abeae68ee8e"), updateDate = require("319e14b94281b616"), collectUpdateDateArguments = require("13a427c4e6ab54b2");
Sugar.Date.defineInstanceWithArguments({
    "set": function(d, args) {
        args = collectUpdateDateArguments(args);
        return updateDate(d, args[0], args[1]);
    }
});
module.exports = Sugar.Date.set;

},{"7b2c1abeae68ee8e":"dZZfL","319e14b94281b616":"9gLzt","13a427c4e6ab54b2":"fymhQ"}],"75va7":[function(require,module,exports) {
"use strict";
var Sugar = require("67da7ab9a3db329b"), setISOWeekNumber = require("87478f1ddca120d5");
Sugar.Date.defineInstance({
    "setISOWeek": function(date, num) {
        return setISOWeekNumber(date, num);
    }
});
module.exports = Sugar.Date.setISOWeek;

},{"67da7ab9a3db329b":"dZZfL","87478f1ddca120d5":"8Ah5E"}],"60lJF":[function(require,module,exports) {
"use strict";
var Sugar = require("541fa6d43438042"), _utc = require("5722d7340b41f4df");
Sugar.Date.defineInstance({
    "setUTC": function(date, on) {
        return _utc(date, on);
    }
});
module.exports = Sugar.Date.setUTC;

},{"541fa6d43438042":"dZZfL","5722d7340b41f4df":"01lmY"}],"eMvX3":[function(require,module,exports) {
"use strict";
var Sugar = require("b76a72e3acf0af28"), setWeekday = require("f74fee70f8c9c8a3");
Sugar.Date.defineInstance({
    "setWeekday": function(date, dow) {
        return setWeekday(date, dow);
    }
});
module.exports = Sugar.Date.setWeekday;

},{"b76a72e3acf0af28":"dZZfL","f74fee70f8c9c8a3":"a9tBU"}],"bmUNB":[function(require,module,exports) {
"use strict";
var Sugar = require("40dfda0cfe377af0");
require("6add1b7259ef281b");
module.exports = Sugar.Date.weeksAgo;

},{"40dfda0cfe377af0":"dZZfL","6add1b7259ef281b":"e859g"}],"dFwec":[function(require,module,exports) {
"use strict";
var Sugar = require("ae372d9c75d0f5f2");
require("6c26d75bd037c1fd");
module.exports = Sugar.Date.weeksFromNow;

},{"ae372d9c75d0f5f2":"dZZfL","6c26d75bd037c1fd":"e859g"}],"iAFjW":[function(require,module,exports) {
"use strict";
var Sugar = require("e62e8b36a362bc94");
require("603d733bdaebb098");
module.exports = Sugar.Date.weeksSince;

},{"e62e8b36a362bc94":"dZZfL","603d733bdaebb098":"e859g"}],"cwFvs":[function(require,module,exports) {
"use strict";
var Sugar = require("3c21e4e90c4fb132");
require("e2fe5ba10fcdc1ec");
module.exports = Sugar.Date.weeksUntil;

},{"3c21e4e90c4fb132":"dZZfL","e2fe5ba10fcdc1ec":"e859g"}],"7S7gC":[function(require,module,exports) {
"use strict";
var Sugar = require("b4c0f750a8423b97");
require("cc77325f9ff068d3");
module.exports = Sugar.Date.yearsAgo;

},{"b4c0f750a8423b97":"dZZfL","cc77325f9ff068d3":"e859g"}],"17rMQ":[function(require,module,exports) {
"use strict";
var Sugar = require("ee516d97b382eb9e");
require("17439b949a927ce5");
module.exports = Sugar.Date.yearsFromNow;

},{"ee516d97b382eb9e":"dZZfL","17439b949a927ce5":"e859g"}],"2lKiS":[function(require,module,exports) {
"use strict";
var Sugar = require("499dd6d0edd3340d");
require("5285ad3b5bac9f2b");
module.exports = Sugar.Date.yearsSince;

},{"499dd6d0edd3340d":"dZZfL","5285ad3b5bac9f2b":"e859g"}],"49icm":[function(require,module,exports) {
"use strict";
var Sugar = require("9059799ee4fe3411");
require("1e4001e3ebc3b3d7");
module.exports = Sugar.Date.yearsUntil;

},{"9059799ee4fe3411":"dZZfL","1e4001e3ebc3b3d7":"e859g"}],"1TpQ6":[function(require,module,exports) {
"use strict";
var Sugar = require("a4ea08f0b7ac95b1"), _dateOptions = require("1ca8998535a2ba26");
module.exports = Sugar.Date.getOption;

},{"a4ea08f0b7ac95b1":"dZZfL","1ca8998535a2ba26":"c2zac"}],"kZTiz":[function(require,module,exports) {
"use strict";
var Sugar = require("6e67a0b00fa23d9e"), _dateOptions = require("75fdd163ef255f90");
module.exports = Sugar.Date.setOption;

},{"6e67a0b00fa23d9e":"dZZfL","75fdd163ef255f90":"c2zac"}],"gbc7W":[function(require,module,exports) {
"use strict";
// Static Methods
require("cd8ca25492a3b235");
require("bd1b144854ecc256");
require("69552495f90b252d");
// Instance Methods
require("7a078f9177841948");
require("669ad8444b6d259e");
require("8f8a83f3ade8449e");
// Prototype Methods
require("5f35e262f6898428");
require("5889581739bda55d");
require("5a410277347c1ab0");
require("af0f28a08604eb69");
require("fdb7a68a976f1619");
require("c697cc5fe106f6d2");
require("a689dd293b5e84df");
require("76c77d11de16357c");
require("4f6aac5a0d65f2f9");
require("920a405bfeb475a6");
require("cd6f96c68caefc04");
require("ac766b2032fbfb27");
require("edec7e7044e3f952");
require("3284482b7550c63b");
require("b08152e1f2c92c38");
require("e3e9da9aa077a82b");
require("773733ace29f6ca2");
require("480bfc874cfe30ec");
// Aliases
require("a4f9ec470b4f28f5");
module.exports = require("8e73f3c02c31cce6");

},{"cd8ca25492a3b235":"knH1G","bd1b144854ecc256":"9sBCE","69552495f90b252d":"hxXpH","7a078f9177841948":"47SBn","669ad8444b6d259e":"c2yJG","8f8a83f3ade8449e":"doDzs","5f35e262f6898428":"7YcIv","5889581739bda55d":"aau1C","5a410277347c1ab0":"gSEV1","af0f28a08604eb69":"4dK88","fdb7a68a976f1619":"gD8nf","c697cc5fe106f6d2":"fb61k","a689dd293b5e84df":"jKhzn","76c77d11de16357c":"aDrbd","4f6aac5a0d65f2f9":"ZrXbl","920a405bfeb475a6":"is5Bd","cd6f96c68caefc04":"8DzBr","ac766b2032fbfb27":"gmzVY","edec7e7044e3f952":"jlI9d","3284482b7550c63b":"beJi0","b08152e1f2c92c38":"jZtwE","e3e9da9aa077a82b":"aHbel","773733ace29f6ca2":"j483n","480bfc874cfe30ec":"kma5H","a4f9ec470b4f28f5":"fyZDl","8e73f3c02c31cce6":"dZZfL"}],"knH1G":[function(require,module,exports) {
"use strict";
var Sugar = require("ef19625c63694d9b"), DateRangeConstructor = require("aeaaf28bb19435a8");
Sugar.Date.defineStatic({
    "range": DateRangeConstructor
});
module.exports = Sugar.Date.range;

},{"ef19625c63694d9b":"dZZfL","aeaaf28bb19435a8":"81iis"}],"81iis":[function(require,module,exports) {
"use strict";
var Range = require("d3fc07bf28115c67"), classChecks = require("d7beccb4a6a4c01f"), getDateForRange = require("25e30c3d7d2737ba"), createDateRangeFromString = require("14980e0e5a770e2a");
var isString = classChecks.isString;
var DateRangeConstructor = function DateRangeConstructor(start, end) {
    if (arguments.length === 1 && isString(start)) return createDateRangeFromString(start);
    return new Range(getDateForRange(start), getDateForRange(end));
};
module.exports = DateRangeConstructor;

},{"d3fc07bf28115c67":"j0g1z","d7beccb4a6a4c01f":"MTXUY","25e30c3d7d2737ba":"cvRD4","14980e0e5a770e2a":"4BEFN"}],"j0g1z":[function(require,module,exports) {
"use strict";
var cloneRangeMember = require("e0a337d2a2d82dd1");
function Range(start, end) {
    this.start = cloneRangeMember(start);
    this.end = cloneRangeMember(end);
}
module.exports = Range;

},{"e0a337d2a2d82dd1":"ianlT"}],"ianlT":[function(require,module,exports) {
"use strict";
var classChecks = require("59f1af25d2733ae6"), getRangeMemberPrimitiveValue = require("66282d90c9b17c4c");
var isDate = classChecks.isDate;
function cloneRangeMember(m) {
    if (isDate(m)) return new Date(m.getTime());
    else return getRangeMemberPrimitiveValue(m);
}
module.exports = cloneRangeMember;

},{"59f1af25d2733ae6":"MTXUY","66282d90c9b17c4c":"bVhvd"}],"bVhvd":[function(require,module,exports) {
"use strict";
var classChecks = require("c4b9f1df509a6173");
var isDate = classChecks.isDate;
function getRangeMemberPrimitiveValue(m) {
    if (m == null) return m;
    return isDate(m) ? m.getTime() : m.valueOf();
}
module.exports = getRangeMemberPrimitiveValue;

},{"c4b9f1df509a6173":"MTXUY"}],"cvRD4":[function(require,module,exports) {
"use strict";
var classChecks = require("7bfe4be8c227747f"), namespaceAliases = require("67f4bcb8a3e8a7e");
var isDate = classChecks.isDate, sugarDate = namespaceAliases.sugarDate;
function getDateForRange(d) {
    if (isDate(d)) return d;
    else if (d == null) return new Date();
    else if (sugarDate.create) return sugarDate.create(d);
    return new Date(d);
}
module.exports = getDateForRange;

},{"7bfe4be8c227747f":"MTXUY","67f4bcb8a3e8a7e":"4onj1"}],"4BEFN":[function(require,module,exports) {
"use strict";
var Range = require("3cb9e34400784a7"), DurationTextFormats = require("87ff48da0bd29390"), incrementDate = require("3e2123a683145c6f"), getDateForRange = require("b3fd12006e8d4578"), namespaceAliases = require("bbeb1c100f970af7"), getDateIncrementObject = require("34a5cfe7419d4a16");
var sugarDate = namespaceAliases.sugarDate, RANGE_REG_FROM_TO = DurationTextFormats.RANGE_REG_FROM_TO, RANGE_REG_REAR_DURATION = DurationTextFormats.RANGE_REG_REAR_DURATION, RANGE_REG_FRONT_DURATION = DurationTextFormats.RANGE_REG_FRONT_DURATION;
function createDateRangeFromString(str) {
    var match, datetime, duration, dio, start, end;
    if (sugarDate.get && (match = str.match(RANGE_REG_FROM_TO))) {
        start = getDateForRange(match[1].replace("from", "at"));
        end = sugarDate.get(start, match[2]);
        return new Range(start, end);
    }
    if (match = str.match(RANGE_REG_FRONT_DURATION)) {
        duration = match[1];
        datetime = match[2];
    }
    if (match = str.match(RANGE_REG_REAR_DURATION)) {
        datetime = match[1];
        duration = match[2];
    }
    if (datetime && duration) {
        start = getDateForRange(datetime);
        dio = getDateIncrementObject(duration);
        end = incrementDate(start, dio[0], dio[1]);
    } else start = str;
    return new Range(getDateForRange(start), getDateForRange(end));
}
module.exports = createDateRangeFromString;

},{"3cb9e34400784a7":"j0g1z","87ff48da0bd29390":"jBI38","3e2123a683145c6f":"dnU58","b3fd12006e8d4578":"cvRD4","bbeb1c100f970af7":"4onj1","34a5cfe7419d4a16":"3ayxi"}],"jBI38":[function(require,module,exports) {
"use strict";
var FULL_CAPTURED_DURATION = require("5306bce1434368d4");
module.exports = {
    RANGE_REG_FROM_TO: /(?:from)?\s*(.+)\s+(?:to|until)\s+(.+)$/i,
    RANGE_REG_REAR_DURATION: RegExp("(.+)\\s*for\\s*" + FULL_CAPTURED_DURATION, "i"),
    RANGE_REG_FRONT_DURATION: RegExp("(?:for)?\\s*" + FULL_CAPTURED_DURATION + "\\s*(?:starting)?\\s(?:at\\s)?(.+)", "i")
};

},{"5306bce1434368d4":"cI8m4"}],"cI8m4":[function(require,module,exports) {
"use strict";
var DURATION_UNITS = require("14f1a6b909974799");
module.exports = "((?:\\d+)?\\s*(?:" + DURATION_UNITS + "))s?";

},{"14f1a6b909974799":"acWLc"}],"acWLc":[function(require,module,exports) {
"use strict";
module.exports = "year|month|week|day|hour|minute|second|millisecond";

},{}],"dnU58":[function(require,module,exports) {
"use strict";
var MULTIPLIERS = require("cf0b939a4d1b8889"), callDateSet = require("28b5a17783cb85d5"), callDateGet = require("8b9b64886ffe62dd");
function incrementDate(src, amount, unit) {
    var mult = MULTIPLIERS[unit], d;
    if (mult) d = new Date(src.getTime() + amount * mult);
    else {
        d = new Date(src);
        callDateSet(d, unit, callDateGet(src, unit) + amount);
    }
    return d;
}
module.exports = incrementDate;

},{"cf0b939a4d1b8889":"f53tB","28b5a17783cb85d5":"9L8cf","8b9b64886ffe62dd":"5mOF6"}],"f53tB":[function(require,module,exports) {
"use strict";
var MULTIPLIERS = {
    "Hours": 3600000,
    "Minutes": 60000,
    "Seconds": 1000,
    "Milliseconds": 1
};
module.exports = MULTIPLIERS;

},{}],"3ayxi":[function(require,module,exports) {
"use strict";
var DURATION_REG = require("728ab9bf295f172e"), classChecks = require("5159fa882967e20d"), simpleCapitalize = require("47e421a2d4d7b6c5");
var isNumber = classChecks.isNumber;
function getDateIncrementObject(amt) {
    var match, val, unit;
    if (isNumber(amt)) return [
        amt,
        "Milliseconds"
    ];
    match = amt.match(DURATION_REG);
    val = +match[1] || 1;
    unit = simpleCapitalize(match[2].toLowerCase());
    if (unit.match(/hour|minute|second/i)) unit += "s";
    else if (unit === "Year") unit = "FullYear";
    else if (unit === "Week") {
        unit = "Date";
        val *= 7;
    } else if (unit === "Day") unit = "Date";
    return [
        val,
        unit
    ];
}
module.exports = getDateIncrementObject;

},{"728ab9bf295f172e":"lgeO2","5159fa882967e20d":"MTXUY","47e421a2d4d7b6c5":"4Ffkr"}],"lgeO2":[function(require,module,exports) {
"use strict";
var DURATION_UNITS = require("6766f6bc3a8f0c60");
module.exports = RegExp("(\\d+)?\\s*(" + DURATION_UNITS + ")s?", "i");

},{"6766f6bc3a8f0c60":"acWLc"}],"9sBCE":[function(require,module,exports) {
"use strict";
var Sugar = require("f484a11682ccb4d4"), PrimitiveRangeConstructor = require("46c260bc19761858");
Sugar.Number.defineStatic({
    "range": PrimitiveRangeConstructor
});
module.exports = Sugar.Number.range;

},{"f484a11682ccb4d4":"dZZfL","46c260bc19761858":"4Vdyw"}],"4Vdyw":[function(require,module,exports) {
"use strict";
var Range = require("af8fe41823b14410");
var PrimitiveRangeConstructor = function PrimitiveRangeConstructor(start, end) {
    return new Range(start, end);
};
module.exports = PrimitiveRangeConstructor;

},{"af8fe41823b14410":"j0g1z"}],"hxXpH":[function(require,module,exports) {
"use strict";
var Sugar = require("50025236fd0fea0c"), PrimitiveRangeConstructor = require("4c6ebfece086645e");
Sugar.String.defineStatic({
    "range": PrimitiveRangeConstructor
});
module.exports = Sugar.String.range;

},{"50025236fd0fea0c":"dZZfL","4c6ebfece086645e":"4Vdyw"}],"47SBn":[function(require,module,exports) {
"use strict";
var Sugar = require("4d6cf70707ddd9f1"), Range = require("e6f3ea5d25f4c2cf"), rangeClamp = require("571c5896c9aededc");
Sugar.Number.defineInstance({
    "cap": function(n, max) {
        return rangeClamp(new Range(undefined, max), n);
    }
});
module.exports = Sugar.Number.cap;

},{"4d6cf70707ddd9f1":"dZZfL","e6f3ea5d25f4c2cf":"j0g1z","571c5896c9aededc":"3TD4C"}],"3TD4C":[function(require,module,exports) {
"use strict";
var cloneRangeMember = require("c87d1929ac01d6e5");
function rangeClamp(range, obj) {
    var clamped, start = range.start, end = range.end, min = end < start ? end : start, max = start > end ? start : end;
    if (obj < min) clamped = min;
    else if (obj > max) clamped = max;
    else clamped = obj;
    return cloneRangeMember(clamped);
}
module.exports = rangeClamp;

},{"c87d1929ac01d6e5":"ianlT"}],"c2yJG":[function(require,module,exports) {
"use strict";
var Sugar = require("554aac55c9a5c178"), Range = require("48c27b6e41482b30"), rangeClamp = require("6f947c835a3cf539");
Sugar.Number.defineInstance({
    "clamp": function(n, start, end) {
        return rangeClamp(new Range(start, end), n);
    }
});
module.exports = Sugar.Number.clamp;

},{"554aac55c9a5c178":"dZZfL","48c27b6e41482b30":"j0g1z","6f947c835a3cf539":"3TD4C"}],"doDzs":[function(require,module,exports) {
"use strict";
var Sugar = require("1174bcf35ba43082"), Range = require("cc1fd8774a1a9463"), rangeEvery = require("7c7d54a150e041dc");
Sugar.Number.defineInstance({
    "upto": function(n, num, step, everyFn) {
        return rangeEvery(new Range(n, num), step, false, everyFn);
    }
});
module.exports = Sugar.Number.upto;

},{"1174bcf35ba43082":"dZZfL","cc1fd8774a1a9463":"j0g1z","7c7d54a150e041dc":"jXZRV"}],"jXZRV":[function(require,module,exports) {
"use strict";
var classChecks = require("5b30c174a81f221f"), rangeIsValid = require("68db6e7c0d4c733b"), incrementDate = require("e6c9859bfe5ed5c3"), incrementNumber = require("a6d48b8dcf44fe20"), incrementString = require("1b290d58e8764826"), getGreaterPrecision = require("5e469447993290b0"), getDateIncrementObject = require("252cc3d694e9fac2");
var isNumber = classChecks.isNumber, isString = classChecks.isString, isDate = classChecks.isDate, isFunction = classChecks.isFunction;
function rangeEvery(range, step, countOnly, fn) {
    var increment, precision, dio, unit, start = range.start, end = range.end, inverse = end < start, current = start, index = 0, result = [];
    if (!rangeIsValid(range)) return countOnly ? NaN : [];
    if (isFunction(step)) {
        fn = step;
        step = null;
    }
    step = step || 1;
    if (isNumber(start)) {
        precision = getGreaterPrecision(start, step);
        increment = function increment() {
            return incrementNumber(current, step, precision);
        };
    } else if (isString(start)) increment = function increment() {
        return incrementString(current, step);
    };
    else if (isDate(start)) {
        dio = getDateIncrementObject(step);
        step = dio[0];
        unit = dio[1];
        increment = function increment() {
            return incrementDate(current, step, unit);
        };
    }
    // Avoiding infinite loops
    if (inverse && step > 0) step *= -1;
    while(inverse ? current >= end : current <= end){
        if (!countOnly) result.push(current);
        if (fn) fn(current, index, range);
        current = increment();
        index++;
    }
    return countOnly ? index - 1 : result;
}
module.exports = rangeEvery;

},{"5b30c174a81f221f":"MTXUY","68db6e7c0d4c733b":"4wzjk","e6c9859bfe5ed5c3":"dnU58","a6d48b8dcf44fe20":"iVATH","1b290d58e8764826":"jWthX","5e469447993290b0":"icSz4","252cc3d694e9fac2":"3ayxi"}],"4wzjk":[function(require,module,exports) {
"use strict";
var isValidRangeMember = require("4f599a1e6fb1d61b");
function rangeIsValid(range) {
    return isValidRangeMember(range.start) && isValidRangeMember(range.end) && typeof range.start === typeof range.end;
}
module.exports = rangeIsValid;

},{"4f599a1e6fb1d61b":"8EiiR"}],"8EiiR":[function(require,module,exports) {
"use strict";
var valueIsNotInfinite = require("3870d5e8f34ec32b"), getRangeMemberPrimitiveValue = require("c68d42a6e236a4e5");
function isValidRangeMember(m) {
    var val = getRangeMemberPrimitiveValue(m);
    return (!!val || val === 0) && valueIsNotInfinite(m);
}
module.exports = isValidRangeMember;

},{"3870d5e8f34ec32b":"gxhee","c68d42a6e236a4e5":"bVhvd"}],"gxhee":[function(require,module,exports) {
"use strict";
function valueIsNotInfinite(m) {
    return m !== -Infinity && m !== Infinity;
}
module.exports = valueIsNotInfinite;

},{}],"iVATH":[function(require,module,exports) {
"use strict";
var withPrecision = require("816132951420549a");
function incrementNumber(current, amount, precision) {
    return withPrecision(current + amount, precision);
}
module.exports = incrementNumber;

},{"816132951420549a":"g1bJd"}],"jWthX":[function(require,module,exports) {
"use strict";
var chr = require("37a6c6354748bd2e");
function incrementString(current, amount) {
    return chr(current.charCodeAt(0) + amount);
}
module.exports = incrementString;

},{"37a6c6354748bd2e":"3I3iN"}],"icSz4":[function(require,module,exports) {
"use strict";
var mathAliases = require("f511d331d04c69a"), getPrecision = require("c94aa05373a0f04e");
var max = mathAliases.max;
function getGreaterPrecision(n1, n2) {
    return max(getPrecision(n1), getPrecision(n2));
}
module.exports = getGreaterPrecision;

},{"f511d331d04c69a":"f1S5P","c94aa05373a0f04e":"6p3Cq"}],"6p3Cq":[function(require,module,exports) {
"use strict";
var periodSplit = require("da7bcf588cb69c5e");
function getPrecision(n) {
    var split = periodSplit(n.toString());
    return split[1] ? split[1].length : 0;
}
module.exports = getPrecision;

},{"da7bcf588cb69c5e":"j3jYr"}],"7YcIv":[function(require,module,exports) {
"use strict";
var Range = require("61c796eb9acc3263"), rangeClamp = require("317ee0d61627e419"), defineOnPrototype = require("b583f98d9a4176bc");
defineOnPrototype(Range, {
    "clamp": function(el) {
        return rangeClamp(this, el);
    }
}); // This package does not export anything as it is
 // simply defining "clamp" on Range.prototype.

},{"61c796eb9acc3263":"j0g1z","317ee0d61627e419":"3TD4C","b583f98d9a4176bc":"7S3Q5"}],"7S3Q5":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("644cee2db7af7933");
var forEachProperty = coreUtilityAliases.forEachProperty;
function defineOnPrototype(ctor, methods) {
    var proto = ctor.prototype;
    forEachProperty(methods, function(val, key) {
        proto[key] = val;
    });
}
module.exports = defineOnPrototype;

},{"644cee2db7af7933":"8ZxTV"}],"aau1C":[function(require,module,exports) {
"use strict";
var Range = require("2220c66815b43819"), defineOnPrototype = require("e367b9ac4dcb624f");
defineOnPrototype(Range, {
    "clone": function() {
        return new Range(this.start, this.end);
    }
}); // This package does not export anything as it is
 // simply defining "clone" on Range.prototype.

},{"2220c66815b43819":"j0g1z","e367b9ac4dcb624f":"7S3Q5"}],"gSEV1":[function(require,module,exports) {
"use strict";
var Range = require("9b7960080bd883f5"), defineOnPrototype = require("446561f86e8d841f");
defineOnPrototype(Range, {
    "contains": function(el) {
        if (el == null) return false;
        if (el.start && el.end) return el.start >= this.start && el.start <= this.end && el.end >= this.start && el.end <= this.end;
        else return el >= this.start && el <= this.end;
    }
}); // This package does not export anything as it is
 // simply defining "contains" on Range.prototype.

},{"9b7960080bd883f5":"j0g1z","446561f86e8d841f":"7S3Q5"}],"4dK88":[function(require,module,exports) {
"use strict";
require("ac50a57ebf649bc0"); // This package does not export anything as it is
 // simply defining "days" on Range.prototype.

},{"ac50a57ebf649bc0":"idBmF"}],"idBmF":[function(require,module,exports) {
"use strict";
var buildDateRangeUnits = require("116ec2fb264a3a57");
buildDateRangeUnits();

},{"116ec2fb264a3a57":"dzbFh"}],"dzbFh":[function(require,module,exports) {
"use strict";
var MULTIPLIERS = require("d67af94ea64ac16b"), DURATION_UNITS = require("21c56d7f343285d5"), Range = require("f3684abbda0eb742"), trunc = require("ea08a09501c759e7"), forEach = require("3d8a2e9eb7caf542"), rangeEvery = require("9924a6e4f269aee"), simpleCapitalize = require("b51c0c74e1fa45f5"), defineOnPrototype = require("a7824b40f79d5551");
function buildDateRangeUnits() {
    var methods = {};
    forEach(DURATION_UNITS.split("|"), function(unit, i) {
        var name = unit + "s", mult, fn;
        if (i < 4) fn = function fn() {
            return rangeEvery(this, unit, true);
        };
        else {
            mult = MULTIPLIERS[simpleCapitalize(name)];
            fn = function fn() {
                return trunc((this.end - this.start) / mult);
            };
        }
        methods[name] = fn;
    });
    defineOnPrototype(Range, methods);
}
module.exports = buildDateRangeUnits;

},{"d67af94ea64ac16b":"f53tB","21c56d7f343285d5":"acWLc","f3684abbda0eb742":"j0g1z","ea08a09501c759e7":"898n5","3d8a2e9eb7caf542":"JJnv7","9924a6e4f269aee":"jXZRV","b51c0c74e1fa45f5":"4Ffkr","a7824b40f79d5551":"7S3Q5"}],"gD8nf":[function(require,module,exports) {
"use strict";
var Range = require("6b077e31c1f8655c"), rangeEvery = require("7025ee4adb7596c3"), defineOnPrototype = require("684901ac837d99e6");
defineOnPrototype(Range, {
    "every": function(amount, everyFn) {
        return rangeEvery(this, amount, false, everyFn);
    }
}); // This package does not export anything as it is
 // simply defining "every" on Range.prototype.

},{"6b077e31c1f8655c":"j0g1z","7025ee4adb7596c3":"jXZRV","684901ac837d99e6":"7S3Q5"}],"fb61k":[function(require,module,exports) {
"use strict";
require("3fa8b0923422c10c"); // This package does not export anything as it is
 // simply defining "hours" on Range.prototype.

},{"3fa8b0923422c10c":"idBmF"}],"jKhzn":[function(require,module,exports) {
"use strict";
var Range = require("fc35c1aef9ba075a"), defineOnPrototype = require("8d581d1ff02ff2e");
defineOnPrototype(Range, {
    "intersect": function(range) {
        if (range.start > this.end || range.end < this.start) return new Range(NaN, NaN);
        return new Range(this.start > range.start ? this.start : range.start, this.end < range.end ? this.end : range.end);
    }
}); // This package does not export anything as it is
 // simply defining "intersect" on Range.prototype.

},{"fc35c1aef9ba075a":"j0g1z","8d581d1ff02ff2e":"7S3Q5"}],"aDrbd":[function(require,module,exports) {
"use strict";
var Range = require("3f2e6cff9dcf009a"), rangeIsValid = require("60e36a11cab0d6e2"), defineOnPrototype = require("d1417cfb2325457b");
defineOnPrototype(Range, {
    "isValid": function() {
        return rangeIsValid(this);
    }
}); // This package does not export anything as it is
 // simply defining "isValid" on Range.prototype.

},{"3f2e6cff9dcf009a":"j0g1z","60e36a11cab0d6e2":"4wzjk","d1417cfb2325457b":"7S3Q5"}],"ZrXbl":[function(require,module,exports) {
"use strict";
require("da27aff6e2199aea"); // This package does not export anything as it is
 // simply defining "milliseconds" on Range.prototype.

},{"da27aff6e2199aea":"idBmF"}],"is5Bd":[function(require,module,exports) {
"use strict";
require("69e522066c250515"); // This package does not export anything as it is
 // simply defining "minutes" on Range.prototype.

},{"69e522066c250515":"idBmF"}],"8DzBr":[function(require,module,exports) {
"use strict";
require("91793eec60e20b86"); // This package does not export anything as it is
 // simply defining "months" on Range.prototype.

},{"91793eec60e20b86":"idBmF"}],"gmzVY":[function(require,module,exports) {
"use strict";
require("61117f2bb22dd56f"); // This package does not export anything as it is
 // simply defining "seconds" on Range.prototype.

},{"61117f2bb22dd56f":"idBmF"}],"jlI9d":[function(require,module,exports) {
"use strict";
var Range = require("b74d5be945c7c8c7"), mathAliases = require("7c138705ca5f7764"), rangeIsValid = require("ebe9ed7237637a7"), defineOnPrototype = require("b6f2b115421c50b3"), getRangeMemberNumericValue = require("b1b1d3d9b373e75d");
var abs = mathAliases.abs;
defineOnPrototype(Range, {
    "span": function() {
        var n = getRangeMemberNumericValue(this.end) - getRangeMemberNumericValue(this.start);
        return rangeIsValid(this) ? abs(n) + 1 : NaN;
    }
}); // This package does not export anything as it is
 // simply defining "span" on Range.prototype.

},{"b74d5be945c7c8c7":"j0g1z","7c138705ca5f7764":"f1S5P","ebe9ed7237637a7":"4wzjk","b6f2b115421c50b3":"7S3Q5","b1b1d3d9b373e75d":"VkVmI"}],"VkVmI":[function(require,module,exports) {
"use strict";
var classChecks = require("6ce2aecf35cdf9b6");
var isString = classChecks.isString;
function getRangeMemberNumericValue(m) {
    return isString(m) ? m.charCodeAt(0) : m;
}
module.exports = getRangeMemberNumericValue;

},{"6ce2aecf35cdf9b6":"MTXUY"}],"beJi0":[function(require,module,exports) {
"use strict";
var Range = require("c82529919f276de3"), rangeEvery = require("1ad65baef784351c"), defineOnPrototype = require("c7174fb8bd57b7f1");
defineOnPrototype(Range, {
    "toArray": function() {
        return rangeEvery(this);
    }
}); // This package does not export anything as it is
 // simply defining "toArray" on Range.prototype.

},{"c82529919f276de3":"j0g1z","1ad65baef784351c":"jXZRV","c7174fb8bd57b7f1":"7S3Q5"}],"jZtwE":[function(require,module,exports) {
"use strict";
var Range = require("860d14c9bb897e91"), rangeIsValid = require("80d5e35c090ebd1"), defineOnPrototype = require("9426c96ba6a21028");
defineOnPrototype(Range, {
    "toString": function() {
        return rangeIsValid(this) ? this.start + ".." + this.end : "Invalid Range";
    }
}); // This package does not export anything as it is
 // simply defining "toString" on Range.prototype.

},{"860d14c9bb897e91":"j0g1z","80d5e35c090ebd1":"4wzjk","9426c96ba6a21028":"7S3Q5"}],"aHbel":[function(require,module,exports) {
"use strict";
var Range = require("782fcc7bf2adc209"), defineOnPrototype = require("4f9d12ed5dda0eb1");
defineOnPrototype(Range, {
    "union": function(range) {
        return new Range(this.start < range.start ? this.start : range.start, this.end > range.end ? this.end : range.end);
    }
}); // This package does not export anything as it is
 // simply defining "union" on Range.prototype.

},{"782fcc7bf2adc209":"j0g1z","4f9d12ed5dda0eb1":"7S3Q5"}],"j483n":[function(require,module,exports) {
"use strict";
require("a6314c9b338e4c61"); // This package does not export anything as it is
 // simply defining "weeks" on Range.prototype.

},{"a6314c9b338e4c61":"idBmF"}],"kma5H":[function(require,module,exports) {
"use strict";
require("e28c992fceae47e0"); // This package does not export anything as it is
 // simply defining "years" on Range.prototype.

},{"e28c992fceae47e0":"idBmF"}],"fyZDl":[function(require,module,exports) {
"use strict";
var Sugar = require("22b2f8c2d8e87d49"), upto = require("7c8ffdd0b0be783c");
Sugar.Number.alias("downto", "upto");
module.exports = Sugar.Number.downto;

},{"22b2f8c2d8e87d49":"dZZfL","7c8ffdd0b0be783c":"doDzs"}],"3V9dM":[function(require,module,exports) {
"use strict";
// Instance Methods
require("13c11bdce2e03bc8");
require("f03d18abaa3f3bb7");
require("9e2570f750fd95f6");
require("c4c11922a35fa06");
require("403211e25c497a9d");
require("f7b3fd8739820aa1");
require("85c57b6547a4e2cc");
require("43989fe1251bb5e9");
require("758b6fc7577f0ee1");
require("80f17d18e2ccf584");
require("4272b482e3ddabbf");
module.exports = require("6ff919376d459d39");

},{"13c11bdce2e03bc8":"29W8H","f03d18abaa3f3bb7":"kcW4P","9e2570f750fd95f6":"5lAW7","c4c11922a35fa06":"hpOHw","403211e25c497a9d":"dIxqT","f7b3fd8739820aa1":"aWfj8","85c57b6547a4e2cc":"ad24R","43989fe1251bb5e9":"dT070","758b6fc7577f0ee1":"7YjKl","80f17d18e2ccf584":"k26ME","4272b482e3ddabbf":"8yEfv","6ff919376d459d39":"dZZfL"}],"29W8H":[function(require,module,exports) {
"use strict";
var Sugar = require("1ea6f8187ffea5a3"), coercePositiveInteger = require("5e66f4f05ba3e271");
Sugar.Function.defineInstance({
    "after": function(fn, num) {
        var count = 0, collectedArgs = [];
        num = coercePositiveInteger(num);
        return function() {
            // Optimized: no leaking arguments
            var args = [];
            for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
            collectedArgs.push(args);
            count++;
            if (count >= num) return fn.call(this, collectedArgs);
        };
    }
});
module.exports = Sugar.Function.after;

},{"1ea6f8187ffea5a3":"dZZfL","5e66f4f05ba3e271":"eBp8T"}],"kcW4P":[function(require,module,exports) {
"use strict";
var Sugar = require("6886bc3b6ab1d970"), cancelFunction = require("ab554da3bfdbd927");
Sugar.Function.defineInstance({
    "cancel": function(fn) {
        return cancelFunction(fn);
    }
});
module.exports = Sugar.Function.cancel;

},{"6886bc3b6ab1d970":"dZZfL","ab554da3bfdbd927":"gb6Qq"}],"gb6Qq":[function(require,module,exports) {
"use strict";
var _timers = require("b5e4df90968fcff8"), _canceled = require("c1d951c1307c14c1"), classChecks = require("b6dd559b79fc8bf1");
var isArray = classChecks.isArray;
function cancelFunction(fn) {
    var timers = _timers(fn), timer;
    if (isArray(timers)) while(timer = timers.shift())clearTimeout(timer);
    _canceled(fn, true);
    return fn;
}
module.exports = cancelFunction;

},{"b5e4df90968fcff8":"3DLpG","c1d951c1307c14c1":"bV7VF","b6dd559b79fc8bf1":"MTXUY"}],"3DLpG":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("419baac9548e011");
module.exports = privatePropertyAccessor("timers");

},{"419baac9548e011":"iz2DQ"}],"bV7VF":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("545bdc06e84e9b80");
module.exports = privatePropertyAccessor("canceled");

},{"545bdc06e84e9b80":"iz2DQ"}],"5lAW7":[function(require,module,exports) {
"use strict";
var Sugar = require("22b12edf82b87fcd"), setDelay = require("d4e273b253f83c1e"), cancelFunction = require("1089d22323b9fcfa");
Sugar.Function.defineInstance({
    "debounce": function(fn, ms) {
        function debounced() {
            // Optimized: no leaking arguments
            var args = [];
            for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
            cancelFunction(debounced);
            setDelay(debounced, ms, fn, this, args);
        }
        return debounced;
    }
});
module.exports = Sugar.Function.debounce;

},{"22b12edf82b87fcd":"dZZfL","d4e273b253f83c1e":"cKYfi","1089d22323b9fcfa":"gb6Qq"}],"cKYfi":[function(require,module,exports) {
"use strict";
var _timers = require("7830b6e29a14a6a3"), _canceled = require("4929c059299fcff0"), coercePositiveInteger = require("835992f2d49de2bb");
function setDelay(fn, ms, after, scope, args) {
    // Delay of infinity is never called of course...
    ms = coercePositiveInteger(ms || 0);
    if (!_timers(fn)) _timers(fn, []);
    // This is a workaround for <= IE8, which apparently has the
    // ability to call timeouts in the queue on the same tick (ms?)
    // even if functionally they have already been cleared.
    _canceled(fn, false);
    _timers(fn).push(setTimeout(function() {
        if (!_canceled(fn)) after.apply(scope, args || []);
    }, ms));
}
module.exports = setDelay;

},{"7830b6e29a14a6a3":"3DLpG","4929c059299fcff0":"bV7VF","835992f2d49de2bb":"eBp8T"}],"hpOHw":[function(require,module,exports) {
"use strict";
var Sugar = require("b6a37a1b003742f0"), setDelay = require("3ba871f0eb64c0e5");
Sugar.Function.defineInstanceWithArguments({
    "delay": function(fn, ms, args) {
        setDelay(fn, ms, fn, fn, args);
        return fn;
    }
});
module.exports = Sugar.Function.delay;

},{"b6a37a1b003742f0":"dZZfL","3ba871f0eb64c0e5":"cKYfi"}],"dIxqT":[function(require,module,exports) {
"use strict";
var Sugar = require("5bcfac2eb7b3f315"), setDelay = require("d25032224121add6");
Sugar.Function.defineInstanceWithArguments({
    "every": function(fn, ms, args) {
        function execute() {
            // Set the delay first here, so that cancel
            // can be called within the executing function.
            setDelay(fn, ms, execute);
            fn.apply(fn, args);
        }
        setDelay(fn, ms, execute);
        return fn;
    }
});
module.exports = Sugar.Function.every;

},{"5bcfac2eb7b3f315":"dZZfL","d25032224121add6":"cKYfi"}],"aWfj8":[function(require,module,exports) {
"use strict";
var Sugar = require("626934fb242e7410"), createLazyFunction = require("7652a3d03601bac2");
Sugar.Function.defineInstance({
    "lazy": function(fn, ms, immediate, limit) {
        return createLazyFunction(fn, ms, immediate, limit);
    }
});
module.exports = Sugar.Function.lazy;

},{"626934fb242e7410":"dZZfL","7652a3d03601bac2":"eCIDv"}],"eCIDv":[function(require,module,exports) {
"use strict";
var setDelay = require("b578bc8216492632"), mathAliases = require("ad4c02c62241d8f3");
var max = mathAliases.max, ceil = mathAliases.ceil, round = mathAliases.round;
function createLazyFunction(fn, ms, immediate, limit) {
    var queue = [], locked = false, execute, rounded, perExecution, result;
    ms = ms || 1;
    limit = limit || Infinity;
    rounded = ceil(ms);
    perExecution = round(rounded / ms) || 1;
    execute = function() {
        var queueLength = queue.length, maxPerRound;
        if (queueLength == 0) return;
        // Allow fractions of a millisecond by calling
        // multiple times per actual timeout execution
        maxPerRound = max(queueLength - perExecution, 0);
        while(queueLength > maxPerRound){
            // Getting uber-meta here...
            result = Function.prototype.apply.apply(fn, queue.shift());
            queueLength--;
        }
        setDelay(lazy, rounded, function() {
            locked = false;
            execute();
        });
    };
    function lazy() {
        // If the execution has locked and it's immediate, then
        // allow 1 less in the queue as 1 call has already taken place.
        if (queue.length < limit - (locked && immediate ? 1 : 0)) {
            // Optimized: no leaking arguments
            var args = [];
            for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
            queue.push([
                this,
                args
            ]);
        }
        if (!locked) {
            locked = true;
            if (immediate) execute();
            else setDelay(lazy, rounded, execute);
        }
        // Return the memoized result
        return result;
    }
    return lazy;
}
module.exports = createLazyFunction;

},{"b578bc8216492632":"cKYfi","ad4c02c62241d8f3":"f1S5P"}],"ad24R":[function(require,module,exports) {
"use strict";
var Sugar = require("85f6faa2c2d09d47"), _lock = require("fe6501a2216717a"), _partial = require("4e9a8968fb19aa20"), classChecks = require("c16047db992d9147"), mathAliases = require("e8590204051e2d39");
var isNumber = classChecks.isNumber, min = mathAliases.min;
Sugar.Function.defineInstance({
    "lock": function(fn, n) {
        var lockedFn;
        if (_partial(fn)) {
            _lock(fn, isNumber(n) ? n : null);
            return fn;
        }
        lockedFn = function() {
            arguments.length = min(_lock(lockedFn), arguments.length);
            return fn.apply(this, arguments);
        };
        _lock(lockedFn, isNumber(n) ? n : fn.length);
        return lockedFn;
    }
});
module.exports = Sugar.Function.lock;

},{"85f6faa2c2d09d47":"dZZfL","fe6501a2216717a":"iDx3l","4e9a8968fb19aa20":"hKEQs","c16047db992d9147":"MTXUY","e8590204051e2d39":"f1S5P"}],"iDx3l":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("80d85a54ad8f2e53");
module.exports = privatePropertyAccessor("lock");

},{"80d85a54ad8f2e53":"iz2DQ"}],"hKEQs":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("9ca02cacc08a55ce");
module.exports = privatePropertyAccessor("partial");

},{"9ca02cacc08a55ce":"iz2DQ"}],"dT070":[function(require,module,exports) {
"use strict";
var Sugar = require("f2729f41f4891aa0"), classChecks = require("c95bc69d9d29a893"), deepGetProperty = require("962052bc1e37782e"), collectArguments = require("112e3e5885f19ed7"), createHashedMemoizeFunction = require("9e7931c516cd6ef7");
var isNumber = classChecks.isNumber, isString = classChecks.isString;
Sugar.Function.defineInstance({
    "memoize": function(fn, arg1, arg2) {
        var hashFn, limit, prop;
        if (isNumber(arg1)) limit = arg1;
        else {
            hashFn = arg1;
            limit = arg2;
        }
        if (isString(hashFn)) {
            prop = hashFn;
            hashFn = function hashFn(obj) {
                return deepGetProperty(obj, prop);
            };
        } else if (!hashFn) hashFn = collectArguments;
        return createHashedMemoizeFunction(fn, hashFn, limit);
    }
});
module.exports = Sugar.Function.memoize;

},{"f2729f41f4891aa0":"dZZfL","c95bc69d9d29a893":"MTXUY","962052bc1e37782e":"4GhMu","112e3e5885f19ed7":"vP7A9","9e7931c516cd6ef7":"7k7bW"}],"vP7A9":[function(require,module,exports) {
"use strict";
function collectArguments() {
    var args = arguments, i = args.length, arr = new Array(i);
    while(i--)arr[i] = args[i];
    return arr;
}
module.exports = collectArguments;

},{}],"7k7bW":[function(require,module,exports) {
"use strict";
var serializeInternal = require("f588d3988b3c9db7"), coreUtilityAliases = require("6d8904ba3abc83e8");
var hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn;
function createHashedMemoizeFunction(fn, hashFn, limit) {
    var map = {}, refs = [], counter = 0;
    return function() {
        var hashObj = hashFn.apply(this, arguments);
        var key = serializeInternal(hashObj, refs);
        if (hasOwn(map, key)) return getOwn(map, key);
        if (counter === limit) {
            map = {};
            refs = [];
            counter = 0;
        }
        counter++;
        return map[key] = fn.apply(this, arguments);
    };
}
module.exports = createHashedMemoizeFunction;

},{"f588d3988b3c9db7":"3qH6r","6d8904ba3abc83e8":"8ZxTV"}],"7YjKl":[function(require,module,exports) {
"use strict";
var Sugar = require("5b80191d992a11cd");
Sugar.Function.defineInstance({
    "once": function(fn) {
        var called = false, val;
        return function() {
            if (called) return val;
            called = true;
            return val = fn.apply(this, arguments);
        };
    }
});
module.exports = Sugar.Function.once;

},{"5b80191d992a11cd":"dZZfL"}],"k26ME":[function(require,module,exports) {
"use strict";
var Sugar = require("9875cca682fe4092"), _lock = require("cef70f09ee4ac13c"), _partial = require("3993159639d6415e"), isDefined = require("a4622230e4094c74"), classChecks = require("8c3eb51c950abc5"), mathAliases = require("e1d0bb72b4ebd5d0"), isObjectType = require("35266dc375c7cb80"), createInstanceFromPrototype = require("a16a37f697750e8f");
var isNumber = classChecks.isNumber, min = mathAliases.min;
Sugar.Function.defineInstanceWithArguments({
    "partial": function(fn, curriedArgs) {
        var curriedLen = curriedArgs.length;
        var partialFn = function partialFn1() {
            var argIndex = 0, applyArgs = [], self = this, lock = _lock(partialFn), result, i;
            for(i = 0; i < curriedLen; i++){
                var arg = curriedArgs[i];
                if (isDefined(arg)) applyArgs[i] = arg;
                else applyArgs[i] = arguments[argIndex++];
            }
            for(i = argIndex; i < arguments.length; i++)applyArgs.push(arguments[i]);
            if (lock === null) lock = curriedLen;
            if (isNumber(lock)) applyArgs.length = min(applyArgs.length, lock);
            // If the bound "this" object is an instance of the partialed
            // function, then "new" was used, so preserve the prototype
            // so that constructor functions can also be partialed.
            if (self instanceof partialFn) {
                self = createInstanceFromPrototype(fn.prototype);
                result = fn.apply(self, applyArgs);
                // An explicit return value is allowed from constructors
                // as long as they are of "object" type, so return the
                // correct result here accordingly.
                return isObjectType(result) ? result : self;
            }
            return fn.apply(self, applyArgs);
        };
        _partial(partialFn, true);
        return partialFn;
    }
});
module.exports = Sugar.Function.partial;

},{"9875cca682fe4092":"dZZfL","cef70f09ee4ac13c":"iDx3l","3993159639d6415e":"hKEQs","a4622230e4094c74":"4cOOJ","8c3eb51c950abc5":"MTXUY","e1d0bb72b4ebd5d0":"f1S5P","35266dc375c7cb80":"1dImj","a16a37f697750e8f":"lOu5B"}],"lOu5B":[function(require,module,exports) {
"use strict";
var createInstanceFromPrototype = Object.create || function(prototype) {
    var ctor = function ctor() {};
    ctor.prototype = prototype;
    return new ctor;
};
module.exports = createInstanceFromPrototype;

},{}],"8yEfv":[function(require,module,exports) {
"use strict";
var Sugar = require("88440570bb4570d1"), createLazyFunction = require("d012ce930f131c33");
Sugar.Function.defineInstance({
    "throttle": function(fn, ms) {
        return createLazyFunction(fn, ms, true, 1);
    }
});
module.exports = Sugar.Function.throttle;

},{"88440570bb4570d1":"dZZfL","d012ce930f131c33":"eCIDv"}],"6d7XO":[function(require,module,exports) {
"use strict";
// Static Methods
require("9443a01639752129");
// Instance Methods
require("7066c8495ac5583d");
require("ece438b4dd098b80");
require("4b69fc7e74559774");
require("9780029ea3b6da3e");
module.exports = require("5828fc7d1788f3a");

},{"9443a01639752129":"hWuZu","7066c8495ac5583d":"3AknL","ece438b4dd098b80":"dTKkM","4b69fc7e74559774":"ii1ur","9780029ea3b6da3e":"irZTL","5828fc7d1788f3a":"dZZfL"}],"hWuZu":[function(require,module,exports) {
"use strict";
var Sugar = require("72410d65a0442f4d"), escapeRegExp = require("ac27081b45ee042e");
Sugar.RegExp.defineStatic({
    "escape": function(str) {
        return escapeRegExp(str);
    }
});
module.exports = Sugar.RegExp.escape;

},{"72410d65a0442f4d":"dZZfL","ac27081b45ee042e":"6dbXB"}],"3AknL":[function(require,module,exports) {
"use strict";
var Sugar = require("aba4576c3d3b89d2"), getRegExpFlags = require("48aa76339ad542e1");
Sugar.RegExp.defineInstance({
    "addFlags": function(r, flags) {
        return RegExp(r.source, getRegExpFlags(r, flags));
    }
});
module.exports = Sugar.RegExp.addFlags;

},{"aba4576c3d3b89d2":"dZZfL","48aa76339ad542e1":"8qWd6"}],"dTKkM":[function(require,module,exports) {
"use strict";
var Sugar = require("e68d19300c18ecb"), getRegExpFlags = require("c4c9d78a2fa0bb7a");
Sugar.RegExp.defineInstance({
    "getFlags": function(r) {
        return getRegExpFlags(r);
    }
});
module.exports = Sugar.RegExp.getFlags;

},{"e68d19300c18ecb":"dZZfL","c4c9d78a2fa0bb7a":"8qWd6"}],"ii1ur":[function(require,module,exports) {
"use strict";
var Sugar = require("9d15f6b3301d2faf"), allCharsReg = require("f6a1c74df7dfa183"), getRegExpFlags = require("89d8e61f24b84b2a");
Sugar.RegExp.defineInstance({
    "removeFlags": function(r, flags) {
        var reg = allCharsReg(flags);
        return RegExp(r.source, getRegExpFlags(r).replace(reg, ""));
    }
});
module.exports = Sugar.RegExp.removeFlags;

},{"9d15f6b3301d2faf":"dZZfL","f6a1c74df7dfa183":"6iZCN","89d8e61f24b84b2a":"8qWd6"}],"irZTL":[function(require,module,exports) {
"use strict";
var Sugar = require("94cb2213d069f0b");
Sugar.RegExp.defineInstance({
    "setFlags": function(r, flags) {
        return RegExp(r.source, flags);
    }
});
module.exports = Sugar.RegExp.setFlags;

},{"94cb2213d069f0b":"dZZfL"}],"lA6Nf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LeafParser", ()=>LeafParser);
var _tagItemParser = require("./TagItemParser");
var LeafParser = /** @class */ function() {
    function LeafParser() {}
    LeafParser.Parse = function(ins) {
        var ret = {};
        if (ins) for(var input in ins){
            var input_leaves = [];
            var path = [];
            var has_tags = LeafParser.ParseRecurse(ins[input], path, input_leaves);
            if (input_leaves.length > 0) ret[input] = {
                leaves: input_leaves,
                has_tags: has_tags,
                has_ran: false
            };
        }
        return ret;
    };
    LeafParser.ParseRecurse = function(val, path, leaves) {
        if (typeof val == "string") {
            var pl = LeafParser.ParseString(val);
            if (pl.has_tags) {
                leaves.push({
                    path: path,
                    parts: pl.tparts,
                    firing: false
                });
                return true;
            }
            return false;
        } else if (Array.isArray(val)) {
            var has_tags = false;
            for(var i = 0; i < val.length; i++){
                var split_path = [];
                for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
                    var p = path_1[_i];
                    split_path.push(p);
                }
                split_path.push("" + i);
                if (this.ParseRecurse(val[i], split_path, leaves)) has_tags = true;
            }
            return has_tags;
        } else if (typeof val == "object") {
            var has_tags = false;
            for(var prop in val){
                var split_path = [];
                for(var _a = 0, path_2 = path; _a < path_2.length; _a++){
                    var p = path_2[_a];
                    split_path.push(p);
                }
                split_path.push(prop);
                if (this.ParseRecurse(val[prop], split_path, leaves)) has_tags = true;
            }
            return has_tags;
        }
        return false;
    };
    LeafParser.ParseString = function(tstr) {
        var i = 0;
        var start = 0;
        var ret = {
            has_tags: false,
            tparts: []
        };
        while(i < tstr.length)if (tstr[i] == "{") {
            i++;
            if (tstr[i] == "{") {
                if (i - 1 > start) ret.tparts.push({
                    tag: null,
                    str: tstr.substring(start, i - 1)
                });
                i++;
                var pass_i = {
                    i: i
                };
                var tag_item = (0, _tagItemParser.TagItemParser).ParseTagItem(tstr, pass_i, "}}");
                ret.tparts.push({
                    tag: tag_item,
                    str: null
                });
                ret.has_tags = true;
                i = pass_i.i;
                start = i;
            }
        } else i++;
        if (start <= tstr.length - 1) ret.tparts.push({
            tag: null,
            str: tstr.substring(start)
        });
        return ret;
    };
    return LeafParser;
}();

},{"./TagItemParser":"4SXYw","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"4SXYw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagItemParser", ()=>TagItemParser);
var TagItemParser = /** @class */ function() {
    function TagItemParser() {}
    TagItemParser.ParseTagItem = function(tstr, pass_i, closing) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (pass_i === void 0) pass_i = {
            i: 0
        };
        if (closing === void 0) closing = "}}";
        var i = pass_i.i;
        var ret = {
            type: "{",
            items: []
        };
        var section = {
            type: ",",
            items: []
        };
        (_a = ret.items) === null || _a === void 0 || _a.push(section);
        var prov_term = null;
        while(i < tstr.length){
            while(i < tstr.length && (tstr[i] == " " || tstr[i] == "\n" || tstr[i] == "\r" || tstr[i] == "*")){
                if (tstr[i] == "*" && ((_b = ret.items) === null || _b === void 0 ? void 0 : _b.length) == 1 && ((_c = ret.items[0].items) === null || _c === void 0 ? void 0 : _c.length) == 0 && ret.type.length == 1) ret.type += "*"; //volatile
                i++;
            }
            var is_end = true;
            for(var e = 0; e < closing.length; e++)if (tstr[i + e] != closing[e]) {
                is_end = false;
                break;
            }
            if (is_end) {
                i += closing.length;
                if (section.items) {
                    if (section.items.length == 0 || section.items[((_d = section.items) === null || _d === void 0 ? void 0 : _d.length) - 1].type == "?" || section.items[((_e = section.items) === null || _e === void 0 ? void 0 : _e.length) - 1].type == "~") //This is ,}} or ?}}
                    (_f = section.items) === null || _f === void 0 || _f.push({
                        type: "s",
                        slice: "",
                        val: ""
                    });
                }
                break;
            }
            if (tstr[i] == "(") {
                i++;
                var pi = {
                    i: i
                };
                var subitem = TagItemParser.ParseTagItem(tstr, pi, ")");
                (_g = section.items) === null || _g === void 0 || _g.push(subitem);
                i = pi.i;
            } else if (tstr[i] == ",") {
                if (section && section.items && (section.items.length == 0 || section.items[((_h = section.items) === null || _h === void 0 ? void 0 : _h.length) - 1].type == "?" || section.items[((_j = section.items) === null || _j === void 0 ? void 0 : _j.length) - 1].type == "~")) //This is ,}} or ?}}
                (_k = section.items) === null || _k === void 0 || _k.push({
                    type: "s",
                    slice: "",
                    val: ""
                });
                section = {
                    type: ",",
                    items: []
                };
                (_l = ret.items) === null || _l === void 0 || _l.push(section);
                i++;
            } else if (tstr[i] == ";") {
                var opening = "{";
                if (closing == ")") opening = "(";
                i++;
                //skip whitespace
                while(i < tstr.length && (tstr[i] == " " || tstr[i] == "\n" || tstr[i] == "\r"))i++;
                var format = TagItemParser.ReadBlock(tstr, i, opening);
                var section_1 = {
                    type: ";",
                    slice: format
                };
                (_m = ret.items) === null || _m === void 0 || _m.push(section_1);
                i += format.length;
            } else if (tstr[i] == "=" || tstr[i] == "!" || tstr[i] == "<" || tstr[i] == ">" || tstr[i] == "?" || tstr[i] == "~" || tstr[i] == ":" || tstr[i] == "+" || tstr[i] == "|" || tstr[i] == "&" || tstr[i] == "(" || tstr[i] == ")" || tstr[i] == "-" && prov_term != null && (prov_term.type == "p" || prov_term.type == "n")) {
                var t = tstr[i];
                var added = false;
                if (prov_term) {
                    if (t == "=") {
                        if (prov_term.type == "=") added = true; //= -> ==             
                        else if (prov_term.type == "!") added = true; //! -> !=
                        else if (prov_term.type == "<") {
                            prov_term.type = "<=";
                            added = true;
                        } else if (prov_term.type == ">") {
                            prov_term.type = ">=";
                            added = true;
                        }
                    } else if (t == "|" && prov_term.type == "|") added = true; //| -> ||     
                    else if (t == "&" && prov_term.type == "&") added = true; //& -> &&     
                }
                if (!added) {
                    prov_term = {
                        type: t
                    };
                    (_o = section.items) === null || _o === void 0 || _o.push(prov_term);
                }
                i++;
            } else if (tstr[i] == "'" || tstr[i] == '"') {
                var t = tstr[i];
                var ti = i + 1;
                i++;
                while(i < tstr.length && tstr[i] != t)i++;
                var val = tstr.substring(ti, i);
                prov_term = {
                    type: "s",
                    slice: val,
                    val: val
                };
                (_p = section.items) === null || _p === void 0 || _p.push(prov_term);
                i++;
            } else if (tstr[i] >= "0" && tstr[i] <= "9" || tstr[i] == "-") {
                var ti = i;
                i++;
                while(i < tstr.length && tstr[i] >= "0" && tstr[i] <= "9")i++;
                var slice = tstr.substring(ti, i);
                var val = Number(slice);
                if (isNaN(val)) {
                    ret.type = "error";
                    ret.slice = "Invalid number " + tstr.substring(ti, i) + " at position " + i + " in " + tstr;
                    return ret;
                }
                prov_term = {
                    type: "n",
                    slice: slice,
                    val: val
                };
                (_q = section.items) === null || _q === void 0 || _q.push(prov_term);
            } else if (i < tstr.length && tstr[i] != "}") {
                var ti = i;
                i++;
                //skip to end of word
                var wstate = "";
                while(i < tstr.length && (tstr[i] != "}" && tstr[i] != "=" && tstr[i] != "!" && tstr[i] != ">" && tstr[i] != "<" && tstr[i] != "?" && tstr[i] != "~" && tstr[i] != ":" && tstr[i] != "+" && tstr[i] != "-" && tstr[i] != "&" && tstr[i] != "|" && tstr[i] != ")" && tstr[i] != "," && tstr[i] != ";" && tstr[i] != "\n" && tstr[i] != "\r" && tstr[i] != " " || wstate == "[")){
                    if (tstr[i] == "[") wstate = "[";
                    if (tstr[i] == "]") wstate = "";
                    i++;
                }
                var val = tstr.substring(ti, i);
                prov_term = {
                    type: "p",
                    slice: val,
                    val: undefined
                };
                if (val == "true" || val == "false") {
                    prov_term.type = "b";
                    prov_term.slice = val;
                    prov_term.val = prov_term.slice == "true";
                } else if (val == "null") {
                    prov_term.type = "0";
                    prov_term.slice = val;
                    prov_term.val = null;
                }
                (_r = section.items) === null || _r === void 0 || _r.push(prov_term);
            } else i++; //If none matched due to malformed tag, don't inf loop
        }
        pass_i.i = i;
        return ret;
    };
    TagItemParser.ReadBlock = function(str, pos, block_open) {
        var open_close_obj = {};
        open_close_obj["'"] = {
            close: "'",
            allow_sub: false
        };
        open_close_obj['"'] = {
            close: '"',
            allow_sub: false
        };
        open_close_obj["("] = {
            close: ")",
            allow_sub: true
        };
        open_close_obj["{"] = {
            close: "}",
            allow_sub: true
        };
        var stack = [
            block_open
        ];
        for(var i = pos; i < str.length; i++){
            var state = open_close_obj[stack[stack.length - 1]];
            if (str[i] == state.close) {
                stack.pop();
                if (stack.length == 0) return str.substring(pos, i);
            } else if (state.allow_sub) {
                var oc = open_close_obj[str[i]];
                if (oc) stack.push(str[i]);
            }
        }
        return str.substring(pos);
    };
    return TagItemParser;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"bvAzp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkMapper", ()=>LinkMapper);
var _cbutil = require("./CBUtil");
var LinkMapper = /** @class */ function() {
    function LinkMapper() {}
    LinkMapper.Map = function(bricks) {
        for(var name in bricks){
            var brick = bricks[name];
            for(var input in brick.parsed_ins){
                var leaves = brick.parsed_ins[input];
                for(var _i = 0, _a = leaves.leaves; _i < _a.length; _i++){
                    var leaf = _a[_i];
                    for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                        var part = _c[_b];
                        if (part.tag) LinkMapper.MapTagItemRecurse(part.tag, bricks, name, input);
                    }
                }
            }
        }
    };
    LinkMapper.MapTagItemRecurse = function(ti, bricks, to_name, to_input) {
        if (ti.type[0] == "p") {
            var s = ti.slice.split(/[\.\[]/); //split on . or [
            var source = s[0];
            if (source[0] == "$") //We don't needt to map these. They will be picked up from nsod on init.
            return;
            var output = "@";
            if (s.length > 1 && s[1][0] == "@") output = s[1];
            var dest_brick = bricks[to_name];
            //this source is not namespaced. It is as written in the tag. 
            //We have to add the source or dest ns to the source or dest 
            var dest_in_ns = dest_brick.nsid || "";
            //dest name should already be correct. Already prefixed
            var source_name = (dest_in_ns == "" ? "" : dest_in_ns + (0, _cbutil.PrefabNameJoin)) + source;
            var source_brick = bricks[source_name];
            if (source_brick) {
                source_brick.targets = source_brick.targets || {};
                source_brick.targets[output] = source_brick.targets[output] || {};
                source_brick.targets[output][to_name] = source_brick.targets[output][to_name] || {};
                source_brick.targets[output][to_name][to_input] = 1;
            }
        }
        if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
            var item = _a[_i];
            LinkMapper.MapTagItemRecurse(item, bricks, to_name, to_input);
        }
    };
    LinkMapper.GetSources = function(ins_leaves, cid, nsid, out_sources) {
        for(var input in ins_leaves)for(var _i = 0, _a = ins_leaves[input].leaves; _i < _a.length; _i++){
            var leaf = _a[_i];
            for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                var part = _c[_b];
                if (part.tag) this.GetTagItemSources(part.tag, cid, nsid, out_sources);
            }
        }
    };
    LinkMapper.GetTagItemSources = function(ti, cid, nsid, out_sources) {
        var _a;
        if (ti.type[0] == "{") {
            if (((_a = ti.items) === null || _a === void 0 ? void 0 : _a.length) == 1) this.GetTagItemSources(ti.items[0], cid, nsid, out_sources);
            return;
        } else if (ti.type[0] == "p") {
            var s = ti.slice.split(".");
            var source = s[0];
            if (source[0] != "$") out_sources.push((nsid ? nsid + (0, _cbutil.PrefabNameJoin) : "") + source);
        }
        if (ti.items) for(var _i = 0, _b = ti.items; _i < _b.length; _i++){
            var item = _b[_i];
            this.GetTagItemSources(item, cid, nsid, out_sources);
        }
    };
    return LinkMapper;
}();

},{"./CBUtil":"1DxvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"ebZ29":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TemplateUtil", ()=>TemplateUtil);
var _leafResolver = require("./LeafResolver");
var _tagItemParser = require("./TagItemParser");
var TemplateUtil = /** @class */ function() {
    function TemplateUtil() {}
    TemplateUtil.ExtractDollars = function(template, keys) {
        if (keys === void 0) keys = [];
        var ret = keys;
        if (typeof template == "string") return TemplateUtil.ExtractDollarsFromString(template, ret);
        else if (typeof template == "object" && template !== null) for(var k in template)TemplateUtil.ExtractDollars(template[k], keys);
        return ret;
    };
    TemplateUtil.ExtractDollarsFromString = function(template_str, keys) {
        var state = "";
        var start = 0;
        var ret = keys;
        var hasKeys = {};
        for(var i = 0; i < template_str.length; i++){
            if (state == "" && template_str[i] == "{") state = "{";
            else if (state == "{") {
                if (template_str[i] == "{") state = "{{";
                else state = "";
            } else if (state == "{{") {
                if (template_str[i] == '"') state = '"';
                else if (template_str[i] == "'") state = "'";
                else if (template_str[i] == "$") {
                    state = "$";
                    start = i;
                } else if (template_str[i] == "}" && template_str[i + 1] == "}") state = "";
            } else if (state == "$") {
                if (template_str[i] >= "0" && template_str[i] <= "9" || template_str[i] >= "a" && template_str[i] <= "z" || template_str[i] >= "A" && template_str[i] <= "Z" || template_str[i] == "_" || template_str[i] == ".") ;
                else if (template_str[i] == "[") state = "$[";
                else {
                    var tpl = template_str.substring(start, i);
                    if (!hasKeys[tpl]) {
                        ret.push(tpl);
                        hasKeys[tpl] = true;
                    }
                    state = "{{";
                    i--;
                }
            } else if (state == "$[") {
                if (template_str[i] == "]") state = "$";
            } else if (state == '"') {
                if (template_str[i] == '"') state = "{{";
            } else if (state == "'") {
                if (template_str[i] == "'") state = "{{";
            }
        }
        return ret;
    };
    TemplateUtil.RedactNonTags = function(template) {
        var ret = {};
        if (typeof template == "string") {
            var tags = [];
            tags = TemplateUtil.ExtractTagsFromString(template, tags);
            // for(let t = tags.length - 1; t >= 0; t--) {
            //     if(tags[t].startsWith("{{$") || tags[t].indexOf("$app") != -1 || tags[t].indexOf("$session") != -1) {
            //         tags.splice(t, 1);
            //     }
            // }
            // ret = tags.join(' ');
            for(var t = tags.length - 1; t >= 0; t--){
                var ti = (0, _tagItemParser.TagItemParser).ParseTagItem(tags[t], {
                    i: 2
                }, "}}");
                if (ti.items) {
                    var tag_str = "{{";
                    for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
                        var section = _a[_i];
                        if (section.type == ";") {
                            tag_str += ";" + section.slice;
                            continue;
                        }
                        if (tag_str != "{{") tag_str += ",";
                        var section_has_dollar = false;
                        if (section.items) {
                            section_has_dollar = this.RecurseHasDollarPValues(section);
                            if (section_has_dollar) {
                                var ptags = [];
                                this.RecurseGatherNonDollarPValues(ptags, section);
                                tag_str += ptags.join("+");
                            } else tag_str += this.UnParseSection(section);
                        }
                    }
                    tag_str += "}}";
                    tags[t] = tag_str;
                // let has_dollar = false;
                // for(let tag of ti.items) {
                //     if(tag.type == "p") {
                //         if(tag.slice[0] == "$") {
                //             has_dollar = true;
                //             break;
                //         }
                //     }
                // }
                // if(has_dollar) {
                //     let ptags = [] as string[];
                //     for(let tag of ti.items) {
                //         if(tag.type == "p") {
                //             if(tag.slice[0] != "$") {
                //                 ptags.push(tag.slice);
                //             }
                //         }
                //     }
                //     tags[t] = "{{" + ptags.join(",") + "}}";
                // }
                }
            }
            ret = tags.join(" ");
        } else if (typeof template == "object" && template !== null) for(var k in template){
            var val = this.RedactNonTags(template[k]);
            if (val !== "") ret[k] = val;
        }
        return ret;
    };
    TemplateUtil.RecurseHasDollarPValues = function(ti) {
        if (ti.type[0] == "p") {
            if (ti.slice[0] == "$") return true;
        } else if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
            var item = _a[_i];
            if (TemplateUtil.RecurseHasDollarPValues(item)) return true;
        }
        return false;
    };
    TemplateUtil.RecurseGatherNonDollarPValues = function(p_values, ti) {
        if (ti.type[0] == "p") {
            if (ti.slice[0] != "$") p_values.push(ti.slice);
        } else if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
            var item = _a[_i];
            TemplateUtil.RecurseGatherNonDollarPValues(p_values, item);
        }
    };
    TemplateUtil.ExtractTags = function(template, tags) {
        if (tags === void 0) tags = [];
        var ret = tags;
        if (typeof template == "string") return TemplateUtil.ExtractTagsFromString(template, ret);
        else if (typeof template == "object" && template !== null) for(var k in template)TemplateUtil.ExtractTags(template[k], tags);
        return ret;
    };
    TemplateUtil.ExtractTagsFromString = function(template_str, tags) {
        var state = "";
        var start = 0;
        var ret = tags;
        for(var i = 0; i < template_str.length; i++){
            if (state == "" && template_str[i] == "{") state = "{";
            else if (state == "{") {
                if (template_str[i] == "{") {
                    state = "{{";
                    start = i - 1;
                } else state = "";
            } else if (state == "{{") {
                if (template_str[i] == '"') state = '"';
                else if (template_str[i] == "'") state = "'";
                else if (template_str[i] == "[") state = "[";
                else if (template_str[i] == "}" && template_str[i + 1] == "}") {
                    state = "";
                    var tpl = template_str.substring(start, i + 2);
                    ret.push(tpl);
                }
            } else if (state == '"') {
                if (template_str[i] == '"') state = "{{";
            } else if (state == "'") {
                if (template_str[i] == "'") state = "{{";
            } else if (state == "[") {
                if (template_str[i] == "]") state = "{{";
            }
        }
        return ret;
    };
    TemplateUtil.GetTermParts = function(term) {
        var parts = [];
        var part = "";
        var state = "";
        for(var i = 0; i < term.length; i++){
            if (state == "") {
                if (term[i] == ".") {
                    parts.push(part);
                    part = "";
                } else if (term[i] == "[") {
                    parts.push(part);
                    part = "";
                    state = "[";
                } else part += term[i];
            } else if (state == "[") {
                if (term[i] == "'") state = "'";
                else if (term[i] == '"') state = '"';
                else if (term[i] == "]") state = "";
                else part += term[i];
            } else if (state == "'") {
                if (term[i] == "'" && term[i + 1] == "]") {
                    i++;
                    state = "";
                } else part += term[i];
            } else if (state == '"') {
                if (term[i] == '"' && term[i + 1] == "]") {
                    i++;
                    state = "";
                } else part += term[i];
            }
        }
        parts.push(part);
        return parts;
    };
    TemplateUtil.ExtractKeys = function(template, keys) {
        if (keys === void 0) keys = [];
        var ret = keys;
        if (typeof template == "string") return TemplateUtil.ExtractKeysFromString(template, ret);
        else if (typeof template == "object" && template !== null) for(var k in template)TemplateUtil.ExtractKeys(template[k], keys);
        return ret;
    };
    TemplateUtil.ExtractKeysFromString = function(template_str, keys) {
        var state = "";
        var start = 0;
        var len = 0;
        var ret = keys;
        //let hasKeys = {} as { [key:string] : boolean };
        for(var i = 0; i < template_str.length; i++){
            if (state == "" && template_str[i] == "{") state = "{";
            else if (state == "{") {
                if (template_str[i] == "{") {
                    state = "{{";
                    start = i;
                } else state = "";
            } else if (state == "{{" && template_str[i] == "}" && template_str[i + 1] == "}") {
                state = "";
                len = i - start;
                var tpl = template_str.substr(start + 1, len - 1);
                //if(!hasKeys[tpl]) {
                ret.push(tpl);
            //    hasKeys[tpl] = true;
            //}
            }
        }
        return ret;
    };
    TemplateUtil.ExtractAndReplaceKeysFromString = function(template_str, keys, replacement) {
        var state = "";
        var start = 0;
        var len = 0;
        var ret = keys;
        var ret_str = "";
        var from = 0;
        for(var i = 0; i < template_str.length; i++){
            if (state == "" && template_str[i] == "{") state = "{";
            else if (state == "{") {
                if (template_str[i] == "{") {
                    state = "{{";
                    start = i;
                    ret_str += template_str.substring(from, start - 1) + replacement;
                } else state = "";
            } else if (state == "{{" && template_str[i] == "}" && template_str[i + 1] == "}") {
                state = "";
                len = i - start;
                from = i + 2;
                var tpl = template_str.substr(start + 1, len - 1);
                ret.push(tpl);
            }
        }
        if (from < template_str.length - 1) ret_str += template_str.substring(from, template_str.length);
        return ret_str;
    };
    TemplateUtil.PrefixPValues = function(leaves, prefix) {
        for(var input in leaves){
            var in_leaves = leaves[input];
            for(var _i = 0, _a = in_leaves.leaves; _i < _a.length; _i++){
                var leaf = _a[_i];
                for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                    var part = _c[_b];
                    if (part.tag) TemplateUtil.PrefixPValuesRecurse(part.tag, prefix);
                }
            }
        }
    };
    TemplateUtil.PrefixPValuesRecurse = function(ti, prefix) {
        if (ti.type[0] == "p") {
            if (ti.slice[0] != "$") ti.slice = prefix + ti.slice;
        } else if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
            var item = _a[_i];
            TemplateUtil.PrefixPValuesRecurse(item, prefix);
        }
    };
    TemplateUtil.UnParseInsLeaves = function(leaves) {
        var res_obj = {};
        for(var input in leaves){
            var in_leaves = leaves[input];
            var leaf_obj = {};
            for(var _i = 0, _a = in_leaves.leaves; _i < _a.length; _i++){
                var leaf = _a[_i];
                var leaf_val = "";
                for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                    var part = _c[_b];
                    if (part.tag) leaf_val += TemplateUtil.UnParseTagItem(part.tag) || "";
                    else if (part.str) leaf_val += part.str || "";
                }
                (0, _leafResolver.LeafResolver).SetPath(leaf.path, leaf_val, leaf_obj);
            }
            res_obj[input] = leaf_obj;
        }
        return res_obj;
    };
    TemplateUtil.UnParseTagItem = function(ti, is_bracket) {
        if (is_bracket === void 0) is_bracket = false;
        var ret = "";
        if (ti.type[0] == "{") {
            ret += is_bracket ? "(" : "{" + ti.type;
            var first = true;
            if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
                var section = _a[_i];
                if (first) first = false;
                else if (section.type == ";") ret += ";";
                else ret += ",";
                if (section.type[0] == "{") ret += TemplateUtil.UnParseTagItem(section);
                else if (section.type == ";") ret += section.slice;
                else ret += TemplateUtil.UnParseSection(section);
            }
            ret += is_bracket ? ")" : "}}";
            return ret;
        }
    };
    TemplateUtil.UnParseSection = function(section) {
        var res = "";
        if (section.items) for(var t = 0; t < section.items.length; t++){
            var term = section.items[t];
            if (term.type == "p") res += term.slice;
            else if (term.type == "s") res += "'" + this.escapeHtml(term.slice) + "'";
            else if (term.type == "n" || term.type == "b") res += term.slice;
            else if (term.type == "0") res += "null";
            else if (term.type[0] == "{") res += TemplateUtil.UnParseTagItem(term, true);
            else if (term.type == "!") res += "!=";
            else res += term.type;
        }
        return res;
    };
    TemplateUtil.escapeHtml = function(unsafe) {
        if (unsafe && typeof unsafe == "string") return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        return unsafe;
    };
    TemplateUtil.TagHasDollar = function(tag) {
        if (tag.type == "p") {
            //If you change this, also change in RedactNonTags
            if (tag.slice && (tag.slice.startsWith("$") || tag.slice.indexOf("$app") != -1 || tag.slice.indexOf("$session") != -1)) return true;
        }
        if (tag.items) for(var _i = 0, _a = tag.items; _i < _a.length; _i++){
            var item = _a[_i];
            if (TemplateUtil.TagHasDollar(item)) return true;
        }
        return false;
    };
    TemplateUtil.PValuesFromInsLeaves = function(ins_leaves) {
        var ret = {};
        for(var input in ins_leaves){
            var in_leaves = ins_leaves[input];
            for(var _i = 0, _a = in_leaves.leaves; _i < _a.length; _i++){
                var leaf = _a[_i];
                leaf.firing = false;
                for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                    var part = _c[_b];
                    if (part.tag) this.RecurseTagItemsGetPValues(part.tag, ret);
                }
            }
        }
        return ret;
    };
    TemplateUtil.RecurseTagItemsGetPValues = function(ti, ret) {
        if (ti.type == "p") ret[ti.slice] = true;
        if (ti.items) for(var _i = 0, _a = ti.items; _i < _a.length; _i++){
            var it = _a[_i];
            this.RecurseTagItemsGetPValues(it, ret);
        }
    };
    TemplateUtil.RemoveDoubleCurlyTags = function(jsonString) {
        // Regular expression to match content between {{ and }}
        // Using a character set with [\s\S] instead of dot+s flag for backwards compatibility
        // This matches any character including newlines
        var tagRegex = /\{\{[\s\S]*?\}\}/g;
        // Replace all matches with an empty string
        var cleanedString = jsonString.replace(tagRegex, "");
        return cleanedString;
    };
    return TemplateUtil;
}();

},{"./LeafResolver":"kBHWQ","./TagItemParser":"4SXYw","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"kBHWQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LeafResolver", ()=>LeafResolver);
var _cbutil = require("./CBUtil");
var _tagItemResolver = require("./TagItemResolver");
var LeafResolver = /** @class */ function() {
    function LeafResolver() {}
    LeafResolver.Resolve = function(in_leaves, template_input_obj, nsod, run_id, source, source_output, system_options, unresolved_out) {
        if (in_leaves == undefined || !in_leaves.has_tags) return template_input_obj;
        var resolver = new (0, _tagItemResolver.TagItemResolver)(nsod, run_id, source, source_output, system_options);
        var res_obj = undefined;
        if (typeof template_input_obj == "object") res_obj = (0, _cbutil.Clone)(template_input_obj);
        var all_resolved = true;
        var firing = false;
        for(var _i = 0, _a = in_leaves.leaves; _i < _a.length; _i++){
            var leaf = _a[_i];
            var leaf_val = void 0;
            leaf.firing = false;
            for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                var part = _c[_b];
                if (part.tag) {
                    var mode = source == "" ? 0 : 1;
                    var init_val = undefined; //this is from the tag_val send by sc-use
                    if (!in_leaves.has_ran && mode == 1 && part.tag.val === undefined) {
                        init_val = resolver.ResolveTag(part.tag, 0, unresolved_out); //It has never ran, so init phase first
                        if (part.tag.firing) firing = true;
                    }
                    var tag_val = resolver.ResolveTag(part.tag, mode, unresolved_out);
                    if (tag_val === undefined && init_val !== undefined) tag_val = init_val;
                    if (part.tag.firing) {
                        firing = true;
                        leaf.firing = true;
                    }
                    if (tag_val === undefined) all_resolved = false;
                    else if (leaf_val === undefined) leaf_val = tag_val;
                    else leaf_val = "" + (leaf_val || "") + tag_val;
                } else if (part.str) leaf_val = "" + (leaf_val || "") + (part.str || "");
            }
            if (res_obj !== undefined) LeafResolver.SetPath(leaf.path, leaf_val, res_obj);
            else res_obj = leaf_val; //cfg is a string, so it is the leaf
        }
        in_leaves.has_ran = true;
        if (!all_resolved || !firing) return undefined;
        return res_obj;
    };
    LeafResolver.SetPath = function(path, value, dest_obj) {
        if (path.length == 0) return value;
        if (typeof dest_obj != "object") dest_obj = {};
        var ret = dest_obj || {};
        for(var p = 0; p < path.length; p++)if (p == path.length - 1) ret[path[p]] = value;
        else {
            ret[path[p]] = ret[path[p]] || {};
            ret = ret[path[p]];
        }
    };
    return LeafResolver;
}();

},{"./CBUtil":"1DxvQ","./TagItemResolver":"jXjc1","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jXjc1":[function(require,module,exports) {
/*

Mode 1 Rules – “propagation”
1.	Populate and mark all terms
2.	Only evaluate sections that contain source. The rest stays as is.
3.	If evaluated section does not resolve, section undefined.
4.	If no evaluated sections in the tag resolve, the tag should return undefined.
Mode 0 rules – “initialisation”
1.	Populate and mark all terms
2.	Evaluate all sections, until a section resolves.
3.	The tag value is the value of that section, else if no sections resolve, undefined
Common rules
1.	A section resolves only if all terms resolve.
2.	Additionally, if you have ? without : the condition also has to resolve

The insleaves should indicate if it has run or not.
If it has not, it has to run all tags.
Else it can stop at the first tag that does not resolve.


*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagItemResolver", ()=>TagItemResolver);
var _cbformatting = require("./CBFormatting");
var _templateUtil = require("./TemplateUtil");
var TagItemResolver = /** @class */ function() {
    function TagItemResolver(seq_out_data, current_run_id, source, source_output, system_options) {
        this.seq_out_data = seq_out_data;
        this.current_run_id = current_run_id;
        this.source = source;
        this.source_output = source_output;
        this.system_options = system_options;
    }
    TagItemResolver.prototype.ResolveTag = function(tag, mode, unresolved_out) {
        tag.contains_source = false; //the source changes, so we cant keep this
        if (tag.type[0] == "{") {
            var volatile = tag.type[1] == "*"; //Note volatile applies to entire tag
            if (volatile && tag.run_id != this.current_run_id) tag.val = undefined;
            tag.run_id = this.current_run_id;
            if (tag.items) {
                for(var _i = 0, _a = tag.items; _i < _a.length; _i++){
                    var section = _a[_i];
                    if (section.type != ";") this.ResolveSection(section, mode, volatile, unresolved_out);
                    if (section.contains_source) tag.contains_source = true;
                }
                var resolve_section = undefined;
                var format_section = undefined;
                if (mode == 2) mode = tag.contains_source ? 1 : 0;
                for(var _b = 0, _c = tag.items; _b < _c.length; _b++){
                    var section = _c[_b];
                    if (section.type == ";") format_section = section;
                    else if (resolve_section === undefined) {
                        if (mode == 0) {
                            if (section.val !== undefined) resolve_section = section;
                        } else if (mode == 1) {
                            if (section.contains_source) {
                                tag.contains_source = true;
                                if (section.val !== undefined) resolve_section = section;
                            }
                        }
                    }
                }
                if (resolve_section) {
                    tag.val = resolve_section.val;
                    if (format_section) tag.val = (0, _cbformatting.codebricks_format)(tag.val, format_section.slice, this.system_options, true).value;
                    tag.firing = true;
                    return tag.val;
                } else {
                    tag.firing = false;
                    return tag.val;
                // if(mode == 0) {
                //     return undefined; //This tag did not resolve in mode 0 This should be the same as tag.val, which should also be undefined here.
                // }
                // if(mode == 1) {
                //     if(tag.contains_source) {
                //         return undefined; //Don't propage if hit
                //     }
                //     else {
                //         //This is a tag unrelated to this event. Just return its prev value
                //         return tag.val;
                //     }
                // }
                }
            }
        }
    };
    TagItemResolver.prototype.ResolveSection = function(section, mode, volatile, unresolved_out) {
        //section.val = undefined; -> We don't set to undefined, we leave as undefined
        var coerce_to_bool = false;
        section.contains_source = false;
        var has_unresolved_term = false;
        if (section.items) {
            //get the term values
            section.contains_source = false;
            //let no_non_static = true;
            //let has_static = false;
            for(var _i = 0, _a = section.items; _i < _a.length; _i++){
                var term = _a[_i];
                if (term.type == "p") {
                    this.ResolveTerm(term, mode, volatile, unresolved_out);
                    if (term.val === undefined) {
                        section.val = undefined;
                        has_unresolved_term = true;
                    }
                } else if (term.type == "{") {
                    this.ResolveTag(term, 2, unresolved_out);
                    if (term.val === undefined) {
                        section.val = undefined;
                        has_unresolved_term = true;
                    }
                } else if (term.type == "~") {
                    if (!section.contains_source) {
                        section.val = undefined;
                        return;
                    }
                } else if (term.val !== undefined) term.static = true;
                if (term.contains_source) section.contains_source = true;
            }
            if (has_unresolved_term) return;
            var state = "";
            for(var t = 0; t < section.items.length; t++){
                var term = section.items[t];
                if (term.type == "|") {
                    if (section.val) return;
                    coerce_to_bool = true;
                }
                if (term.type == "&") {
                    if (!section.val) return;
                    coerce_to_bool = true;
                }
                term.type;
                if (term.val !== undefined) {
                    if (state == "" || state == "|" || state == "&") {
                        state = "v";
                        section.val = term.val;
                    } else if (state == "v") {
                        //2 v's in a row? Error
                        //section.val = undefined;
                        console.error("Template error: 2 values with no operator: " + JSON.stringify(section));
                        break;
                    } else if (state == "=") section.val = section.val == term.val;
                    else if (state == "!") section.val = section.val != term.val;
                    else if (state == ">") section.val = section.val > term.val;
                    else if (state == "<") section.val = section.val < term.val;
                    else if (state == ">=") section.val = section.val >= term.val;
                    else if (state == "<=") section.val = section.val <= term.val;
                    else if (state == "+") {
                        if (section.val === undefined) section.val = term.val;
                        section.val = section.val + term.val;
                    } else if (state == "-") {
                        if (section.val === undefined) section.val = -term.val;
                        section.val = section.val - term.val;
                    } else if (state == "?" || state == "~") {
                        var choice_value = section.val;
                        //first value 1st:2nd
                        var first_value = term.val;
                        if (t + 2 < section.items.length && section.items[t + 1].type == ":") {
                            //Second value
                            var second_term = section.items[t + 2];
                            var second_value = undefined;
                            if (second_term !== undefined) second_value = second_term.val;
                            //section.val = ((choice_value == true) ? first_value : second_value);
                            section.val = choice_value ? first_value : second_value;
                            t += 2;
                        } else if (first_value !== undefined) {
                            //This is for a==b?c
                            if (choice_value) section.val = first_value;
                            else {
                                section.val = undefined;
                                return;
                            }
                        } else section.val = "";
                    }
                } else state = term.type;
            }
        }
        if (coerce_to_bool) section.val = section.val == true;
    };
    TagItemResolver.prototype.ResolveTerm = function(term, mode, volatile, unresolved_out) {
        var tv = term.slice;
        var tparts = (0, _templateUtil.TemplateUtil).GetTermParts(tv); //tv.split('.');
        //convert a to a.@, and a.b to a.@.b, but leave a.@o, for template output including default (omitted @)
        if (tparts.length == 1) {
            tparts.push("@");
            tparts.push("d"); //add the d because seq_out_data has the seq_obj inserted, and the data is under d
        } else if (tparts[1][0] != "@") tparts.splice(1, 0, "@", "d");
        else tparts.splice(2, 0, "d");
        term.contains_source = tparts[0] == this.source && tparts[1] == this.source_output;
        term.static = tparts[0][0] == "$"; //These are pre populated into seq_out_data, so we count them as available
        if (this.seq_out_data[tparts[0]] && this.seq_out_data[tparts[0]][tparts[1]]) {
            var seq_obj = this.seq_out_data[tparts[0]][tparts[1]];
            term.val = ""; //This is for when the value in the seq_out_data is undefined, it should still resolve if the output has emitted, so should not be undefined, but ''
            if (volatile) //volatile means it must be from the same run id to resolve.
            {
                if (seq_obj.r != this.current_run_id) {
                    term.val = undefined; //For volatile we do clear. -> We don't set to undefined, we leave as undefined. If it previously resolved, it should keep that value.
                    unresolved_out.push(tv);
                    return;
                }
            }
            var v = this.seq_out_data;
            var res = v;
            var done = false;
            for(var _i = 0, tparts_1 = tparts; _i < tparts_1.length; _i++){
                var p = tparts_1[_i];
                if (done) {
                    res = undefined;
                    break;
                }
                if (v && v[p] !== undefined) {
                    if (v[p] !== null || typeof v[p] == "object") v = v[p];
                    else {
                        res = v[p];
                        done = true;
                    }
                } else {
                    res = undefined;
                    done = true;
                }
            }
            if (!done) res = v;
            if (res !== undefined) term.val = res;
            else unresolved_out.push(tv);
        } else //term.val = undefined; -> We don't set to undefined, we leave as undefined
        unresolved_out.push(tv);
    };
    return TagItemResolver;
}();

},{"./CBFormatting":"TabN7","./TemplateUtil":"ebZ29","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8UNLF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cb_popout", ()=>cb_popout);
var _cbWebUtil = require("./cb_web_util");
class cb_popout {
    init() {
        var no_keyboard = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var self = this;
        var select = document.getElementById(this.id + "$select");
        if (select) {
            select.tabIndex = 0;
            if (!this.initialized) select.addEventListener("click", function(e) {
                if (self.isOpen()) self.closeSelect();
                else if (!self.disabled) self.openPopout(self);
            });
        }
        this.initialized = true;
    }
    setLabel(value) {
        var label = document.getElementById(this.id + "$label");
        if (label) {
            if (value !== undefined && value !== "") {
                label.classList.remove("hidden");
                label.innerHTML = value;
            } else label.classList.add("hidden");
        }
    }
    setDisplayValue(value) {
        var select = document.getElementById(this.id + "$select");
        if (select) select.innerHTML = value;
    }
    setDropHtml(html) {
        var select = document.getElementById(this.id + "$drop");
        if (select) select.innerHTML = html;
    }
    setNoWindowClickClose(no_close) {
        var select = document.getElementById(this.id + "$select");
        if (select) {
            if (no_close) select.setAttribute("no_window_click_close", "true");
            else select.removeAttribute("no_window_click_close");
        }
    }
    static getRect(element) {
        var rect = element.getBoundingClientRect();
        var x = rect.x;
        var y = rect.y;
        y += window.scrollY;
        x += window.scrollX;
        return {
            x: x,
            y: y,
            w: rect.width,
            h: rect.height
        };
    }
    openPopout(cb_popout_object) {
        var id = cb_popout_object.id;
        window.cb_popout_global = window.cb_popout_global || {
            cb_popouts_by_id: {},
            scroll: [],
            pop_idx: 0,
            open_id_stack: [],
            window_click_handler: function window_click_handler(e) {
                var cb_popout_global = window.cb_popout_global;
                var max_iterations = 10;
                while(cb_popout_global.open_id !== undefined){
                    max_iterations--;
                    if (max_iterations <= 0) break;
                    var select = document.getElementById(cb_popout_global.open_id + "$select");
                    if (select && select.contains(e.target)) return;
                    if (select && select.getAttribute("no_window_click_close")) return;
                    if (!cb_popout_global.open_drop_guard) {
                        var open_drop = document.getElementById(cb_popout_global.open_id + "$drop");
                        if (open_drop && select) {
                            if (select.classList.contains("no_click_close")) {
                                if (open_drop.contains(e.target)) return;
                            }
                            cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id].call_closed_callback();
                            cb_popout_global.open_id_stack.pop();
                            cb_popout_global.open_id = cb_popout_global.open_id_stack[cb_popout_global.open_id_stack.length - 1];
                            open_drop.classList.remove("popover_show");
                            open_drop.style.removeProperty("transition");
                        }
                    }
                }
            },
            mouse_wheel_handler: function mouse_wheel_handler(evt) {
                if (cb_popout_global.open_id !== undefined) {
                    var elements_under_mouse = document.querySelectorAll(":hover");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements_under_mouse[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var elem = _step.value;
                            if (elem.classList.contains("select-items")) {
                                var cs = getComputedStyle(elem);
                                if (cs.height < cs.maxHeight) evt.preventDefault();
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var open_drop = document.getElementById(cb_popout_global.open_id + "$drop");
                    if (open_drop) {
                        if (cb_popout_global.open_id !== undefined) cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id].call_closed_callback();
                        cb_popout_global.open_id_stack.pop();
                        cb_popout_global.open_id = cb_popout_global.open_id_stack[cb_popout_global.open_id_stack.length - 1];
                        open_drop.classList.remove("popover_show");
                        open_drop.style.removeProperty("transition");
                    }
                }
            },
            check_drop_moved: function check_drop_moved(popidx) {
                var cb_popout_global = window.cb_popout_global;
                if (popidx != cb_popout_global.pop_idx) return;
                if (cb_popout_global.open_id !== undefined) {
                    var _$cb_popout_object = cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id];
                    var select = document.getElementById(cb_popout_global.open_id + "$select");
                    var on_drop = false;
                    var elements_under_mouse = document.querySelectorAll(":hover");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements_under_mouse[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var e = _step.value;
                            if (e.classList.contains("c-select-dropdown")) {
                                on_drop = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (select && _$cb_popout_object.open_offset != null) {
                        var offset = cb_popout.getRect(select);
                        if (on_drop || _$cb_popout_object.open_offset.x == offset.x && _$cb_popout_object.open_offset.y == offset.y) setTimeout(cb_popout_global.check_drop_moved.bind(null, popidx), 101);
                        else {
                            if (cb_popout_global.open_id !== undefined) cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id].call_closed_callback();
                            var drop = document.getElementById(cb_popout_global.open_id + "$drop");
                            cb_popout_global.open_id_stack.pop();
                            cb_popout_global.open_id = cb_popout_global.open_id_stack[cb_popout_global.open_id_stack.length - 1];
                            if (drop) {
                                drop.classList.remove("popover_show");
                                drop.style.removeProperty("transition");
                            }
                        }
                    }
                }
            }
        };
        var cb_popout_global = window.cb_popout_global;
        cb_popout_global.cb_popouts_by_id[cb_popout_object.id] = cb_popout_object;
        if (!cb_popout_global.initialized) {
            window.addEventListener("click", cb_popout_global.window_click_handler);
            cb_popout_global.initialized = true;
            var body = document.querySelector("body");
            if (body) {
                body.addEventListener("mousewheel", cb_popout_global.mouse_wheel_handler, {
                    passive: false
                });
                body.addEventListener("touchmove", cb_popout_global.mouse_wheel_handler, {
                    passive: false
                });
            }
        }
        if (cb_popout_global.open_id !== undefined && cb_popout_global.open_id != id) {
            var open_drop = document.getElementById(cb_popout_global.open_id + "$drop");
            if (open_drop) {
                var inside = false;
                var launcher = document.getElementById(this.id + "$select");
                if (launcher) {
                    var max_iterations = 100;
                    while(launcher.parentElement){
                        max_iterations--;
                        if (max_iterations <= 0) break;
                        if (launcher.parentElement.id == cb_popout_global.open_id + "$drop") {
                            inside = true;
                            break;
                        }
                        launcher = launcher.parentElement;
                    }
                }
                if (!inside) {
                    open_drop.classList.remove("popover_show");
                    open_drop.style.removeProperty("transition");
                }
            }
        }
        cb_popout_global.open_id_stack.push(id);
        cb_popout_global.open_id = id;
        this.position_popout(true);
        cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id].call_opened_callback();
    }
    position_popout() {
        var newpop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var cb_popout_global = window.cb_popout_global;
        var cb_popout_object = cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id];
        var new_drop = document.getElementById(cb_popout_global.open_id + "$drop");
        if (new_drop) {
            cb_popout_global.open_drop_guard = true;
            setTimeout(()=>cb_popout_global.open_drop_guard = false, 100);
            var select = document.getElementById(cb_popout_global.open_id + "$select");
            if (select) {
                var height = select.offsetHeight;
                if (this.match_width) {
                    var width = select.offsetWidth;
                    new_drop.style.minWidth = width + "px";
                }
                var offset = cb_popout.getRect(select);
                cb_popout_object.open_offset = {
                    x: offset.x,
                    y: offset.y
                };
                var use_top_offset = offset.y + height;
                var use_offset_x = offset.x;
                var drop_computed_style = getComputedStyle(new_drop);
                var dropWidth = Number(drop_computed_style.width.replace("px", ""));
                var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                if (offset.x + dropWidth > screenWidth) use_offset_x = offset.x - dropWidth + offset.w;
                new_drop.style.top = use_top_offset + "px";
                new_drop.style.left = use_offset_x + "px";
                var the_drop = new_drop;
                if (newpop) setTimeout(function() {
                    the_drop.classList.add("popover_show");
                    the_drop.style.transition = getComputedStyle(the_drop).transition;
                    the_drop.scrollTo(0, 0);
                    var dropHeight = the_drop.offsetHeight;
                    var screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                    var exceed_screen_bottom = use_top_offset + dropHeight + height > screenHeight + window.scrollY;
                    var exceed_screen_top = screenHeight - use_top_offset - dropHeight - height < 0;
                    var below_mid_Screen = use_top_offset > screenHeight / 2;
                    var use_bottom_offset = 0;
                    if (exceed_screen_bottom && !exceed_screen_top || exceed_screen_bottom && exceed_screen_top && below_mid_Screen) {
                        use_bottom_offset = screenHeight - (use_top_offset - height);
                        the_drop.style.bottom = use_bottom_offset + "px";
                        the_drop.style.removeProperty("top");
                    } else {
                        the_drop.style.removeProperty("bottom");
                        the_drop.style.top = use_top_offset + "px";
                    }
                    cb_popout_global.pop_idx++;
                    setTimeout(cb_popout_global.check_drop_moved.bind(null, cb_popout_global.pop_idx), 100);
                }, 1);
            }
        }
    }
    call_opened_callback() {
        this.open_callback();
    }
    call_closed_callback() {
        this.close_callback();
    }
    closeSelect() {
        var cb_popout_global = window.cb_popout_global;
        if (cb_popout_global) {
            var open_drop = document.getElementById(cb_popout_global.open_id + "$drop");
            if (open_drop) {
                cb_popout_global.cb_popouts_by_id[cb_popout_global.open_id].call_closed_callback();
                cb_popout_global.open_id_stack.pop();
                cb_popout_global.open_id = cb_popout_global.open_id_stack[cb_popout_global.open_id_stack.length - 1];
                open_drop.classList.remove("popover_show");
                open_drop.style.removeProperty("transition");
                var select = document.getElementById(this.id + "$select");
                if (select) select.focus();
            } else {
                var open_dops = document.querySelectorAll("." + this.typename + "-drop.popover_show");
                for(var i = 0; i < open_dops.length; i++){
                    var open_drop1 = open_dops[i];
                    open_drop1.classList.remove("popover_show");
                    open_drop1.style.removeProperty("transition");
                }
            }
        }
    }
    isOpen() {
        var cb_popout_global = window.cb_popout_global;
        if (!cb_popout_global) return false;
        return cb_popout_global.open_id === this.id;
    }
    constructor(id, no_click_close, settings, typename, match_width, only_the_drop, open_callback, close_callback){
        this.open = false;
        this.initialized = false;
        this.mouse_is_over = false;
        this.open_offset = null;
        this.keyboard_selected = 0;
        this.match_width = false;
        this.typename = "";
        this.disabled = false;
        this.id = id;
        var container = only_the_drop ? true : document.getElementById(id);
        this.match_width = match_width;
        this.open_callback = open_callback;
        this.close_callback = close_callback;
        this.typename = typename;
        if (container) {
            var label = "";
            var classes = "";
            var styles = "";
            if (settings) {
                var cfg = settings;
                label = cfg.label;
                if (label && label[0] == "{") label = "";
            }
            if (!only_the_drop) {
                var html = "";
                html = `<label for="${this.id}$select" class="form-element-label c-select-label ${typename}-label ${(label || "") == "" ? "hidden" : ""}" id="${this.id + "$label"}">${label || ""}</label>`;
                html += `<div id="${this.id}$select" class="form-element c-select ${typename}-select ${classes}${no_click_close ? " no_click_close" : ""}" style="${styles}" tabindex="0"></div>`;
                container.innerHTML = html;
                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, settings, "container");
            }
            var dropdown_html = `<div id="${this.id}$drop" ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(`popover ${typename}-drop`, settings, "drop")}>
                    <div id="${this.id}$items" tabindex="0">
                    </div>
                </div>`;
            window.document.body.insertAdjacentHTML("beforeend", dropdown_html);
        }
    }
}

},{"./cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jCKPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CBWebUtil", ()=>CBWebUtil);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
class CBWebUtil {
    static UnFocus() {
        document.body.click();
        document.querySelector("[tabindex]").focus();
    }
    static focusNextElement(reverse, activeElem) {
        activeElem = activeElem instanceof HTMLElement ? activeElem : document.activeElement;
        var queryString = [
            'a:not([disabled]):not([tabindex="-1"])',
            'button:not([disabled]):not([tabindex="-1"])',
            'input:not([disabled]):not([tabindex="-1"])',
            'select:not([disabled]):not([tabindex="-1"])',
            '[tabindex]:not([disabled]):not([tabindex="-1"])'
        ].join(","), queryResult = Array.prototype.filter.call(document.querySelectorAll(queryString), (elem)=>{
            return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem === activeElem;
        }), indexedList = queryResult.slice().filter((elem)=>{
            return elem.tabIndex == -1 ? false : true;
        }).sort((a, b)=>{
            return a.tabIndex != 0 && b.tabIndex != 0 ? a.tabIndex < b.tabIndex ? -1 : b.tabIndex < a.tabIndex ? 1 : 0 : a.tabIndex != 0 ? -1 : b.tabIndex != 0 ? 1 : 0;
        }), focusable = [].concat(indexedList, queryResult.filter((elem)=>{
            return elem.tabIndex == -1 ? true : false;
        }));
        return reverse ? focusable[focusable.indexOf(activeElem) - 1] || focusable[focusable.length - 1] : focusable[focusable.indexOf(activeElem) + 1] || focusable[0];
    }
    static escapeHtml(unsafe) {
        if (unsafe && typeof unsafe == "string") return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        return unsafe;
    }
    static unescapeHtml(unsafe) {
        if (unsafe && typeof unsafe == "string") return unsafe.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#039;/g, "'");
        return unsafe;
    }
    static BrickHtml(blueprint, container_brick, idx) {
        var dc = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", classes = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
        var prefix = blueprint.type.split("-")[0];
        if (prefix.indexOf("i") != -1 || prefix[0] == "s") classes += " child-hidden";
        var attrs = "";
        if (window.codebricks_context.visual_editing) {
            attrs = ` class="${classes}" editor-info="${blueprint.name} (${blueprint.type})"`;
            var brick_name = blueprint.name;
            var brick_type = blueprint.type;
            setTimeout(function() {
                window.codebricks_context.visual_brick_endow(brick_name, brick_type, true);
            }, 0);
        } else attrs = ` ${classes ? ` class="${classes}"` : ""}`;
        var use_dc = dc || container_brick.dc || "";
        var brick = `<${blueprint.type}${attrs} cid="${container_brick.cid}" dc="${use_dc}" name="${blueprint.name}" idx="${idx}" container_id="${container_brick.brick_id}"></${blueprint.type}>`;
        return brick;
    }
    static PostRequest(url, post_body) {
        return (0, _asyncToGenerator._)(function() {
            var res_data, method, options, res, body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        method = "POST";
                        options = {
                            method
                        };
                        options.body = JSON.stringify(post_body);
                        options.credentials = "include";
                        options.headers = {
                            "Content-Type": "application/json"
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        if (body === "") return [
                            2
                        ];
                        try {
                            res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        return [
                            2,
                            res_data
                        ];
                }
            });
        })();
    }
    static GetRequest(url) {
        return (0, _asyncToGenerator._)(function() {
            var res_data, method, options, res, body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        method = "GET";
                        options = {
                            method
                        };
                        options.credentials = "include";
                        options.headers = {
                            "Content-Type": "application/json"
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        if (body === "") return [
                            2
                        ];
                        try {
                            res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        return [
                            2,
                            res_data
                        ];
                }
            });
        })();
    }
    static GetElementStylesString(default_style, cfg, specifier) {
        var style = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        var ret = "";
        var style_val = null;
        if (cfg) {
            style_val = cfg["styles"];
            if (style_val && specifier) style_val = style_val[specifier];
        } else if (!style) {
            if (default_style && default_style != " ") ret += ` class="${default_style}"`;
            return ret;
        }
        var classes = default_style;
        var styles = [];
        var addedStyles = [];
        if (style_val) for(var prop in style_val){
            var val = style_val[prop];
            if (prop == "classes") {
                if (Array.isArray(val)) classes += " " + val.join(" ");
                else if (typeof val == "string") classes += " " + val;
            } else if (prop[0] == "(") {
                val = val.replaceAll("{", "");
                val = val.replaceAll("}", "");
                prop = prop.substring(1, prop.length - 1);
                var pairs = CBWebUtil.SplitByMultipleSeparators(val, [
                    "\n",
                    "\r",
                    ";"
                ]);
                var css = pairs.join(";") + ";";
                addedStyles.push({
                    selector: prop,
                    styles: css
                });
            } else styles.push(prop + ":" + val);
        }
        if (styles.length > 0 || style) addedStyles.push({
            selector: "",
            styles: (style ? style + ";" : "") + styles.join(";")
        });
        if (addedStyles.length > 0) {
            var inline_classes = window.inlineClassProcessor.rulesToStyles(addedStyles);
            classes += (classes ? " " : "") + inline_classes.join(" ");
        }
        if (classes && classes != " ") ret += ` class="${classes}"`;
        return ret;
    }
    static ApplyElementStyles(element, cfg, specifier) {
        if (!element || !cfg) return;
        var style_val = cfg["styles"];
        if (style_val && specifier) style_val = style_val[specifier];
        if (!style_val) return;
        var addedStyles = [];
        var styldx = Number(element.getAttribute("styldx"));
        var updating = true;
        if (!styldx) {
            updating = false;
            window.codebricks_context.styldx = window.codebricks_context.styldx || 1;
            window.codebricks_context.styldx_classes = window.codebricks_context.styldx_classes || {};
            styldx = window.codebricks_context.styldx++;
            element.setAttribute("styldx", String(styldx));
            window.codebricks_context.styldx_classes[styldx] = [];
            for(var c = element.classList.length - 1; c >= 0; c--)if (element.classList[c] && element.classList[c].startsWith("inline-class-")) element.classList.remove(element.classList[c]);
        }
        var current_classes = [];
        var inline_styles = [];
        for(var prop in style_val){
            var val = style_val[prop];
            if (prop == "classes") {
                if (Array.isArray(val)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = val[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var cl = _step.value;
                            if (cl && typeof cl == "string") {
                                var clt = cl.trim();
                                if (clt) {
                                    current_classes.push(clt);
                                    element.classList.add(clt);
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else if (typeof val == "string") {
                    var classes = val.split(" ");
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = classes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var cl1 = _step1.value;
                            if (cl1) {
                                current_classes.push(cl1);
                                element.classList.add(cl1);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } else if (prop[0] == "(") {
                val = val.replaceAll("{", "");
                val = val.replaceAll("}", "");
                prop = prop.substring(1, prop.length - 1);
                var pairs = CBWebUtil.SplitByMultipleSeparators(val, [
                    "\n",
                    "\r",
                    ";"
                ]);
                var css = pairs.join(";") + ";";
                addedStyles.push({
                    selector: prop,
                    styles: css
                });
            } else inline_styles.push(`${prop}:${val}`);
        }
        if (inline_styles.length > 0) addedStyles.push({
            selector: "",
            styles: inline_styles.join(";")
        });
        if (addedStyles.length > 0) {
            var added_inline_classes = window.inlineClassProcessor.processNode(element, addedStyles);
            current_classes = current_classes.concat(added_inline_classes);
        }
        if (updating) {
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = window.codebricks_context.styldx_classes[styldx][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var cl2 = _step2.value;
                    if (!current_classes.includes(cl2)) element.classList.remove(cl2);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        window.codebricks_context.styldx_classes[styldx] = current_classes;
    }
    static ApplyElementIdStyles(id, cfg, specifier) {
        var element = document.getElementById(id);
        if (element) CBWebUtil.ApplyElementStyles(element, cfg, specifier);
    }
    static SplitByMultipleSeparators(str, separators) {
        if (separators.length === 0) return [
            str
        ];
        var escapedSeparators = separators.map((s)=>s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
        var regex = new RegExp(escapedSeparators.join("|"), "g");
        return str.split(regex).filter(Boolean);
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"hQLGA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_autocomplete_webcomponent", ()=>cd_autocomplete_webcomponent);
parcelHelpers.export(exports, "web_cd_autocomplete", ()=>web_cd_autocomplete);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPopout = require("../controls/cb_popout");
var _cbWebUtil = require("../controls/cb_web_util");
class cd_autocomplete_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var nsid = this.getAttribute("nsid");
            this.ci = new web_cd_autocomplete(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-autocomplete", cd_autocomplete_webcomponent);
class web_cd_autocomplete extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var id, style, v, input_element, self, container, _$input, _$input1;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg;
                    if (!_this.initialised) {
                        id = _this.brick_id;
                        style = "";
                        if (cfg.style) {
                            for(var v in cfg.style)style += v + ":" + cfg.style[v] + ";";
                            style = ` style="${style}"`;
                        }
                        _this.element.innerHTML = `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("form-element-container c-autocomplete-container", cfg, "container")} id="${_this.brick_id}$container">
                    <label ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(`form-element-label c-autocomplete-label${cfg.label ? "" : " hidden"}`, cfg, "label")} for="${_this.brick_id}">${cfg.label || ""}</label>
                    <div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("form-element c-autocomplete-input no_click_close", cfg, "input")} id="${_this.brick_id}$select" contenteditable="true" placeholder="${cfg.placeholder}"></div>
                    <div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("c-autocomplete-x hidden", cfg, "x")} onclick="c_autocomplete_x('${_this.brick_id}')"></div>
                </div><div class="c-input-validation-message" id="${_this.brick_id}$validation" style="display:none"></div><div id="${_this.brick_id}_loader" class="loader"></div>`;
                        _this.popout = new (0, _cbPopout.cb_popout)(id, true, cfg, "autocomplete", true, true, function() {
                            self.selected_idx = 0;
                            if ((self.search || cfg.search_on_open) && (self.search || "") !== self.last_emitted_search) {
                                self.last_emitted_search = self.search || "";
                                self.cb_emit({
                                    "@search": self.search || ""
                                });
                            }
                        }, function() {});
                        _this.popout.setDropHtml("<span class='light-text'>Start typing...</span>");
                        _this.popout.init(true);
                        _this.popout.setLabel(cfg.label);
                        _this.initialised = true;
                        input_element = document.getElementById(`${_this.brick_id}$select`);
                        self = _this;
                        input_element.addEventListener("input", function() {
                            self.search = this.innerText;
                            var debounce_ms = self.cfg.debounce_ms;
                            if (debounce_ms !== 0 && !debounce_ms || isNaN(debounce_ms)) debounce_ms = 600;
                            self.show_x(self.search != "");
                            if (self.search != self.last_emitted_search) {
                                self.last_emitted_search = self.search;
                                self.search_id++;
                                var this_search_id = self.search_id;
                                setTimeout(function() {
                                    if (self.search_id == this_search_id) self.cb_emit({
                                        "@search": self.search
                                    });
                                }, debounce_ms);
                            }
                        });
                        input_element.addEventListener("keydown", function(e) {
                            var items_container = document.getElementById(self.brick_id + "$items");
                            if (e.keyCode == 40 || e.keyCode == 38) {
                                e.preventDefault();
                                if (e.keyCode == 40) {
                                    if (self.selected_idx >= self.num_items - 1) {
                                        self.selected_idx = self.num_items - 1;
                                        return;
                                    }
                                    self.selected_idx++;
                                    if (items_container) {
                                        var items = items_container.querySelectorAll(".c-select-item");
                                        var new_sel = items[self.selected_idx];
                                        if (!new_sel) self.selected_idx++;
                                    }
                                }
                                if (e.keyCode == 38) {
                                    if (self.selected_idx <= 0) {
                                        self.selected_idx = 0;
                                        return;
                                    }
                                    self.selected_idx--;
                                    if (items_container) {
                                        var items1 = items_container.querySelectorAll(".c-select-item");
                                        var new_sel1 = items1[self.selected_idx];
                                        if (!new_sel1) self.selected_idx--;
                                    }
                                }
                                if (items_container) {
                                    var sel = items_container.querySelector(".c-select-item-selected");
                                    if (sel) sel.classList.remove("c-select-item-selected");
                                    var items2 = items_container.querySelectorAll(".c-select-item");
                                    if (items2) {
                                        var new_sel2 = items2[self.selected_idx];
                                        if (new_sel2) {
                                            new_sel2.classList.add("c-select-item-selected");
                                            new_sel2.scrollIntoView();
                                        }
                                    }
                                }
                            } else if (e.keyCode == 13) {
                                e.preventDefault();
                                if (self.popout && self.popout.isOpen()) {
                                    self.selectOption(self.local_filtered_options[self.selected_idx]);
                                    self.popout.closeSelect();
                                }
                            } else if (e.keyCode == 27) {
                                if (self.popout && self.popout.isOpen()) self.popout.closeSelect();
                            }
                        });
                        _this.value_path = cfg.value_path || "";
                        _this.label_path = cfg.label_path || "";
                        _this.group_path = cfg.group_path || "";
                        _this.match_condition = cfg.match_condition || "contains";
                        if (cfg.value === undefined || cfg.value === null) cfg.value = "";
                        if (_this.value === undefined || _this.value === null) _this.value = "";
                    } else {
                        container = document.getElementById(_this.brick_id + "$container");
                        if (container && container.children[0]) {
                            container.children[0].innerHTML = cfg.label || "";
                            if (cfg.label) container.children[0].classList.remove("hidden");
                            else container.children[0].classList.add("hidden");
                        }
                        if (container) {
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container.firstElementChild, cfg, "label");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container.children[1], cfg, "input");
                        }
                    }
                    _this.disabled = Boolean(cfg.disabled);
                    if (_this.popout) _this.popout.disabled = _this.disabled;
                    _$input = document.getElementById(_this.brick_id + "$select");
                    if (_$input) {
                        _$input.spellcheck = false;
                        _$input.setAttribute("contenteditable", "" + !_this.disabled);
                        if (_this.disabled) _$input.classList.add("c-autocomplete-disabled");
                    }
                    _this.value = cfg.value;
                    _this.setDisplayValue(cfg.value_label);
                    _this.search = cfg.value_label;
                    _this.snapshot.cfg.value = cfg.value;
                    _this.snapshot.cfg.value_label = cfg.value_label;
                    if (!cfg || !cfg.dont_send_initial) return [
                        2,
                        {
                            "@": {
                                value: _this.value,
                                label: cfg.value_label
                            }
                        }
                    ];
                } else if (input == "data") {
                    _this.options = cfg || [];
                    _this.refreshSearch(_this.search === null ? "" : _this.search);
                    if (cfg && _this.popout && !_this.popout.isOpen()) _this.popout.openPopout(_this.popout);
                } else if (input == "clear") {
                    if (cfg) _this.clear(false);
                } else if (input == "focus") {
                    if (cfg) {
                        _$input1 = document.getElementById(_this.brick_id + "$select");
                        if (_$input1) _$input1.focus();
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    setDisplayValue(label) {
        if (label === undefined || label === null) label = "";
        this.show_x(label != "");
        var input = document.getElementById(this.brick_id + "$select");
        if (input) input.innerHTML = label;
        this.clearValidation();
        this.refreshSearch(label);
    }
    clear() {
        var focus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        this.show_x(false);
        this.refreshSearch("");
        var input = document.getElementById(this.brick_id + "$select");
        if (input) {
            input.innerHTML = "";
            if (focus) input.focus();
        }
        this.value = "";
        delete this.snapshot.cfg.value;
        delete this.snapshot.cfg.value_label;
        this.clearValidation();
        this.cb_emit({
            "@": null,
            "@option_object": null,
            "@search": "",
            "@user_changed": null
        });
    }
    selectOption(option) {
        var value = option;
        var label = option;
        if (this.value_path) {
            value = (0, _cbutil.drill)(this.value_path, option);
            label = value;
        }
        if (this.label_path) label = (0, _cbutil.drill)(this.label_path, option);
        this.value = value;
        this.setDisplayValue(label);
        this.snapshot.cfg.value = value;
        this.snapshot.cfg.value_label = label;
        if (this.popout) this.popout.closeSelect();
        this.cb_emit({
            "@": {
                value,
                label
            },
            "@user_changed": {
                value,
                label
            },
            "@option_object": option
        });
    }
    refreshSearch(search) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var list_html, lowercase_search, i, group, items, row_idx, dc_data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, option, value, label, indexof, this_group, dc_root, child_dc, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, sub, cement, cement_child_id, brick, hidden, prefix;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this.cfg) return [
                            2
                        ];
                        _this.search = String(search || "");
                        _this.selected_idx = -1;
                        _this.num_items = 0;
                        list_html = `<div class="select-items" id="${_this.brick_id}$items">`;
                        lowercase_search = _this.search.toLowerCase();
                        i = 0;
                        group = "";
                        items = 0;
                        row_idx = 0;
                        dc_data = [];
                        _this.local_filtered_options = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.options[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                option = _step.value;
                                value = option;
                                label = option;
                                if (_this.value_path) {
                                    value = (0, _cbutil.drill)(_this.value_path, option);
                                    label = value;
                                }
                                if (_this.label_path) label = (0, _cbutil.drill)(_this.label_path, option);
                                indexof = (label + "").toLowerCase().indexOf(lowercase_search);
                                if (_this.search === "" || _this.match_condition == "contains" && indexof != -1 || _this.match_condition == "startswith" && indexof == 0) {
                                    dc_data.push(option);
                                    _this.local_filtered_options.push(option);
                                    if (_this.group_path) {
                                        this_group = (0, _cbutil.drill)(_this.group_path, option);
                                        if (this_group != group) list_html += `<div class="c-autocomplete-group">${this_group}</div>`;
                                        group = this_group;
                                    }
                                    if (_this.selected_idx == -1) _this.selected_idx = i;
                                    if (_this.blueprint.contains && _this.blueprint.contains.length > 0) {
                                        dc_root = (_this.dc || "") + ((0, _cbutil.DC_JOIN) + _this.blueprint.name);
                                        child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
                                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(_iterator1 = _this.blueprint.contains[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                sub = _step1.value;
                                                cement = _this.cements[i] || sub.cement;
                                                cement_child_id = _this.brick_id + "$" + row_idx + "$" + i;
                                                brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, _this, i, child_dc);
                                                if (cement) {
                                                    hidden = cement.hidden ? ` hidden` : "";
                                                    prefix = sub.type.split("-")[0];
                                                    if (prefix.indexOf("i") == -1 && prefix[0] != "s") list_html += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(hidden, cement, "")} id="${cement_child_id}" class="c-select-item${i == _this.selected_idx ? " c-select-item-selected" : ""}">${brick}</div>`;
                                                    else list_html += `<div style="position:absolute" class="c-select-item${i == _this.selected_idx ? " c-select-item-selected" : ""}">` + brick + `</div>`;
                                                } else list_html += brick;
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        row_idx++;
                                    } else list_html += `<div onclick="c_autocomplete_callback(event, '${_this.brick_id}',${i})" class="c-select-item${i == _this.selected_idx ? " c-select-item-selected" : ""}">${label}</div>`;
                                    _this.num_items++;
                                }
                                i++;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (_this.popout) _this.popout.setDropHtml(list_html + "</div>");
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(dc_data)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    show_x(show) {
        var container = document.getElementById(this.brick_id + "$container");
        if (container) {
            var x = container.querySelector(".c-autocomplete-x");
            if (x) {
                if (show) x.classList.remove("hidden");
                else x.classList.add("hidden");
            }
        }
    }
    cb_initial_cement(cements) {
        this.cements = cements;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var cement_child_id = this.brick_id + "$" + row_idx + "$" + child_idx;
        var child = document.getElementById(cement_child_id);
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        }
    }
    cb_snapshot() {
        return this.snapshot;
    }
    cb_status(status) {
        if (status == "") {
            var input = document.getElementById(`${this.brick_id}$select`);
            if (input) input.classList.remove("required");
            var items = document.getElementById(`${this.brick_id}$items`);
            if (items) items.classList.remove("loading");
        } else if (status == "loading") {
            var items1 = document.getElementById(`${this.brick_id}$items`);
            if (items1) {
                items1.innerHTML = "";
                items1.classList.add("loading");
            }
        }
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.cfg.validation) {
            var select = document.getElementById(`${this.brick_id}$select`);
            if (select) {
                var value = this.value;
                if (this.cfg.validation.required && (value === "" || value === null || value === undefined)) {
                    validates = false;
                    validation_message = (this.cfg.label || this.cfg.placeholder || "Value") + " is a required field";
                }
            }
        }
        if (validates) this.clearValidation();
        else {
            var validation_message_container = document.getElementById(`${this.brick_id}$validation`);
            var select1 = document.getElementById(`${this.brick_id}$select`);
            if (select1) select1.classList.add("c-input-validation-failed");
            if (validation_message_container) {
                validation_message_container.innerHTML = validation_message;
                validation_message_container.style.display = "block";
            }
        }
        return validates;
    }
    clearValidation() {
        var input_wrap = document.getElementById(`${this.brick_id}$wrap`);
        if (input_wrap) input_wrap.classList.remove("c-input-validation-failed");
        var validation_message_container = document.getElementById(`${this.brick_id}$validation`);
        if (validation_message_container) {
            validation_message_container.style.display = "none";
            validation_message_container.innerHTML = "";
        }
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.options = [];
        this.local_filtered_options = [];
        this.cfg = null;
        this.value_path = "";
        this.label_path = "";
        this.group_path = "";
        this.match_condition = "contains";
        this.search = null;
        this.disabled = false;
        this.popout = null;
        this.set_value = false;
        this.selected_idx = 0;
        this.num_items = 0;
        this.last_emitted_search = null;
        this.snapshot = {
            cfg: {}
        };
        this.search_id = 0;
        this.cements = {};
        this.element = element;
        if (!window.c_autocomplete_callback) window.c_autocomplete_callback = function(event, ac_id, idx) {
            event.stopPropagation();
            var ac = window.codebricks_context.bricks[ac_id];
            var option = ac.options[idx];
            ac.selectOption(option);
            ac.popout.closeSelect();
        };
        if (!window.c_autocomplete_x) window.c_autocomplete_x = function(ac_id) {
            var ac = window.codebricks_context.bricks[ac_id];
            ac.clear();
        };
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_popout":"8UNLF","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"cXW4f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_brick_linker_webcomponent", ()=>c_brick_linker_webcomponent);
parcelHelpers.export(exports, "web_c_brick_linker", ()=>web_c_brick_linker);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _leafParser = require("../../codebricks-runtime/LeafParser");
var _templateUtil = require("../../codebricks-runtime/TemplateUtil");
class c_brick_linker_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_brick_linker(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-brick-linker", c_brick_linker_webcomponent);
class web_c_brick_linker extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, cs, html;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.compos = cfg.composition_tree;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = cfg.component_specs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            cs = _step.value;
                            _this.component_specs[cs.name] = cs.spec;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _this.register_brick_by_name(_this.compos);
                    if (_this.compos) {
                        _this.link_idx = 0;
                        _this.links_by_source = {};
                        _this.links_by_dest = {};
                        html = _this.draw_composition(cfg.composition_tree);
                        _this.element.innerHTML = html;
                    }
                } else if (input == "clear_lines") _this.DeleteAllLines();
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    draw_composition(composition) {
        if (!this.compos) return "";
        this.active_links = [];
        this.extract_links(this.compos.name);
        var html;
        html = this.draw_recurse(composition, true, 0);
        return html;
    }
    register_brick_by_name(brick) {
        brick.parsed_ins = {};
        brick.parsed_ins = (0, _leafParser.LeafParser).Parse(brick.ins);
        this.bricks_by_name[brick.name] = brick;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (brick.contains) try {
            for(var _iterator = brick.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                this.register_brick_by_name(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    draw_recurse(brick, alternate, level) {
        var ret = "";
        var indent_px = 10;
        ret += `<div class="linker-row" onclick="open_brick_modal('${brick.name}')">`;
        ret += `<div class="linker-element" style="padding-left:${indent_px * level}px"><div class="linker-brick-heading">${brick.name}<span> (${brick.type})</span></div></div>`;
        ret += this.get_active_links_tds(null, null, false) + `</div>`;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (this.links_by_source[brick.name]) try {
            for(var _iterator = this.links_by_source[brick.name][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var link = _step.value;
                if (!link.dest_name) continue;
                var remove = false;
                if (this.active_links[link.idx] == null) this.active_links[link.idx] = link;
                else remove = true;
                ret += `<div class="linker-row" onclick="open_brick_modal('${link.dest_name}')"><div class="linker-element" style="padding-left:${indent_px * (level + 2)}px"><div class="linker-brick-out">${link.output}${link.output_path}</div>`;
                ret += `<div class="linker-arrow-right"></div><div class="linker-hline" style="background-color:${link.color}"></div>`;
                ret += `</div>` + this.get_active_links_tds(link, null, remove) + `</div>`;
                if (remove) this.active_links[link.idx] = null;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (this.links_by_dest[brick.name]) try {
            for(var _iterator1 = this.links_by_dest[brick.name][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var link1 = _step1.value;
                if (!link1.source_name) continue;
                var remove1 = false;
                if (this.active_links[link1.idx] == null) this.active_links[link1.idx] = link1;
                else remove1 = true;
                ret += `<div class="linker-row" onclick="open_brick_modal('${link1.dest_name}')"><div class="linker-element" style="padding-left:${indent_px * (level + 2)}px"><div class="linker-brick-in">${link1.input}${link1.input_path}</div>`;
                ret += `<div class="linker-arrow-left" ></div><div class="linker-hline" style="background-color:${link1.color}"></div>`;
                ret += `</div>` + this.get_active_links_tds(null, link1, remove1) + `</div>`;
                if (remove1) this.active_links[link1.idx] = null;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        if (brick.contains) try {
            for(var _iterator2 = brick.contains[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var child = _step2.value;
                ret += this.draw_recurse(child, !alternate, level + 1);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return ret;
    }
    get_active_links_tds(source, dest, remove) {
        var ret = "";
        var source_end = 0;
        var source_color = "blue";
        if (source) for(var l = 0; l < this.active_links.length; l++){
            var link = this.active_links[l];
            if (link && link == source) {
                source_end = l;
                source_color = link.color;
            }
        }
        var dest_end = 0;
        var dest_color = "blue";
        if (dest) for(var l1 = 0; l1 < this.active_links.length; l1++){
            var link1 = this.active_links[l1];
            if (link1 && link1 == dest) {
                dest_end = l1;
                dest_color = link1.color;
            }
        }
        for(var l2 = 0; l2 < this.active_links.length; l2++){
            var link2 = this.active_links[l2];
            if (link2) {
                if (l2 < source_end) ret += `<div class="linker-v" style="border-color:${link2.color}"><div class="linker-h" style="background-color:${source_color}"></div></div>`;
                else if (l2 > 0 && (l2 == source_end || l2 == dest_end)) {
                    if (remove) ret += `<div class="linker-u" style="border-color:${link2.color}"></div>`;
                    else ret += `<div class="linker-d" style="border-color:${link2.color}"></div>`;
                } else if (l2 < dest_end) ret += `<div class="linker-v" style="border-color:${link2.color}"><div class="linker-h" style="background-color:${dest_color}"></div></div>`;
                else ret += `<div class="linker-v" style="border-color:${link2.color}"></div>`;
            } else {
                if (l2 < source_end) ret += `<div class="linker-connection"><div class="linker-h" style="background-color:${source_color}"></div></div>`;
                else if (l2 < 0 && (l2 == source_end || l2 == dest_end)) {
                    if (remove) ret += `<div class="linker-u" style="border-color:${link2.color}"></div>`;
                    else ret += `<div class="linker-d" style="border-color:${link2.color}"></div>`;
                } else if (l2 < dest_end) ret += `<div class="linker-connection"><div class="linker-h" style="background-color:${dest_color}"></div></div>`;
                else ret += `<div class="linker-connection"></div>`;
            }
        }
        return ret;
    }
    extract_links(name) {
        var blueprint = this.bricks_by_name[name];
        var links = [];
        if (blueprint.parsed_ins && blueprint.parsed_ins) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            for(var input in blueprint.parsed_ins)try {
                for(var _iterator = blueprint.parsed_ins[input].leaves[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var leaf = _step.value;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (leaf.parts) try {
                        for(var _iterator1 = leaf.parts[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var part = _step1.value;
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            if (part.tag && part.tag.items) try {
                                for(var _iterator2 = part.tag.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var item = _step2.value;
                                    this.get_source_tagitems(item, links, input, leaf.path);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var dest_name = name;
        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
        try {
            for(var _iterator3 = links[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                var link = _step3.value;
                var term_parts = (0, _templateUtil.TemplateUtil).GetTermParts(link.ti.slice);
                var source_name = term_parts[0];
                var output = "@";
                var drill_start = 1;
                if (source_name[0] == "$") continue;
                if (term_parts.length > 1 && term_parts[1][0] == "@") {
                    output = term_parts[0];
                    drill_start = 2;
                }
                var drill = "";
                for(var d = drill_start; d < term_parts.length; d++)drill += "." + term_parts[d];
                var path_str = "";
                if (link.path.length > 0) path_str = "." + link.path.join(".");
                var link_obj = {
                    source_name: source_name,
                    output: output,
                    output_path: drill,
                    dest_name: dest_name,
                    input: link.input,
                    input_path: path_str,
                    idx: ++this.link_idx,
                    color: this.generateColor(this.link_idx)
                };
                this.links_by_source[source_name] = this.links_by_source[source_name] || [];
                this.links_by_source[source_name].push(link_obj);
                this.links_by_dest[dest_name] = this.links_by_dest[dest_name] || [];
                this.links_by_dest[dest_name].push(link_obj);
                this.active_links.push(null);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                }
            } finally{
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
        if (blueprint.contains) try {
            for(var _iterator4 = blueprint.contains[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                var child = _step4.value;
                this.extract_links(child.name);
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                }
            } finally{
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }
    get_source_tagitems(ti, links, input, path) {
        if (ti.type == "p") links.push({
            ti,
            input,
            path
        });
        if (ti.type == "{" || ti.type == ",") {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (ti.items) try {
                for(var _iterator = ti.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    this.get_source_tagitems(c, links, input, path);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    DrawLine(from, to, options) {}
    DeleteAllLines() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                line.remove();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.lines = [];
    }
    generateColor(index) {
        index = index % 20;
        var hue = index * 137.508 % 360;
        var saturation = 85;
        var lightness = 60;
        var chroma = (1 - Math.abs(2 * lightness / 100 - 1)) * saturation / 100;
        var huePrime = hue / 60;
        var x = chroma * (1 - Math.abs(huePrime % 2 - 1));
        var m = lightness / 100 - chroma / 2;
        var r, g, b;
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (huePrime >= 0 && huePrime < 1) ref = [
            chroma,
            x,
            0
        ], r = ref[0], g = ref[1], b = ref[2], ref;
        else if (huePrime >= 1 && huePrime < 2) ref1 = [
            x,
            chroma,
            0
        ], r = ref1[0], g = ref1[1], b = ref1[2], ref1;
        else if (huePrime >= 2 && huePrime < 3) ref2 = [
            0,
            chroma,
            x
        ], r = ref2[0], g = ref2[1], b = ref2[2], ref2;
        else if (huePrime >= 3 && huePrime < 4) ref3 = [
            0,
            x,
            chroma
        ], r = ref3[0], g = ref3[1], b = ref3[2], ref3;
        else if (huePrime >= 4 && huePrime < 5) ref4 = [
            x,
            0,
            chroma
        ], r = ref4[0], g = ref4[1], b = ref4[2], ref4;
        else ref5 = [
            chroma,
            0,
            x
        ], r = ref5[0], g = ref5[1], b = ref5[2], ref5;
        var toHex = (c)=>Math.round((c + m) * 255).toString(16).padStart(2, "0");
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialized = false;
        this.component_specs = {};
        this.bricks_by_name = {};
        this.lines = [];
        this.links_by_source = {};
        this.links_by_dest = {};
        this.link_idx = 0;
        this.active_links = [];
        this.get_Scrolls = function() {
            var getComputedStyle = document.body && document.body.currentStyle ? function getComputedStyle(elem) {
                return elem.currentStyle;
            } : function(elem) {
                return document.defaultView.getComputedStyle(elem, null);
            };
            function getActualCss(elem, style) {
                return getComputedStyle(elem)[style];
            }
            function isXScrollable(elem) {
                return elem.offsetWidth < elem.scrollWidth && autoOrScroll(getActualCss(elem, "overflow-x"));
            }
            function isYScrollable(elem) {
                return elem.offsetHeight < elem.scrollHeight && autoOrScroll(getActualCss(elem, "overflow-y"));
            }
            function autoOrScroll(text) {
                return text == "scroll" || text == "auto";
            }
            function hasScroller(elem) {
                return isYScrollable(elem) || isXScrollable(elem);
            }
            return function ElemenetsWithScrolls() {
                return [].filter.call(document.querySelectorAll("*"), hasScroller);
            };
        }();
        this.element = element;
        window.open_brick_modal = function(brick_name) {
            var tree_container = document.getElementById("cb_0_brick_tree-component_tree_container");
            if (tree_container) {
                var brick_button = tree_container.querySelector(`[label="${brick_name}"]`);
                if (brick_button) brick_button.click();
            }
        };
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../codebricks-runtime/LeafParser":"lA6Nf","../../codebricks-runtime/TemplateUtil":"ebZ29","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8h4wx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_button_webcomponent", ()=>c_button_webcomponent);
parcelHelpers.export(exports, "web_c_button", ()=>web_c_button);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _cbWebUtil = require("../controls/cb_web_util");
class c_button_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_button(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-button", c_button_webcomponent);
class web_c_button extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "data") _this.outdata = cfg;
                else if (input == "cfg") _this.setDisplay(cfg);
                return [
                    2
                ];
            });
        })();
    }
    setDisplay(cfg) {
        this.cfg = cfg;
        if (!this.initialised) {
            var tooltip = "";
            if (cfg.tooltip && cfg.tooltip.text) tooltip = ` tooltip="${cfg.tooltip.text}"`;
            this.element.innerHTML = `<button id="${this.brick_id}" class="btn btn-primary c-button" label="${cfg.label || ""}"${tooltip}></button>`;
            var self = this;
            var btn = document.getElementById(`${this.brick_id}`);
            if (btn) {
                btn.addEventListener("click", function() {
                    var _ref = (0, _asyncToGenerator._)(function(e) {
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (window.cb_popout_global && window.cb_popout_global.window_click_handler) window.cb_popout_global.window_click_handler(e);
                                    if (!self.validate_sources("")) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        self.cb_emit({
                                            "@": self.outdata
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    if (self.brick_id.startsWith("cb_1_")) console.log(self.brick_id + " validate_sources not validated - so no button event sent.");
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
                if (cfg.tooltip && cfg.tooltip.text || this.tooltip) {
                    (0, _cbTooltip.cb_tooltip).set_tooltip(btn);
                    this.tooltip = cfg.tooltip.text;
                }
            }
            this.initialised = true;
        }
        var btn1 = document.getElementById(`${this.brick_id}`);
        if (btn1) {
            if (cfg.style) for(var v in cfg.style)btn1.style.setProperty(v, cfg.style[v]);
            if (cfg.tooltip && cfg.tooltip.text || this.tooltip) {
                btn1.setAttribute("tooltip", cfg.tooltip.text);
                (0, _cbTooltip.cb_tooltip).set_tooltip(btn1);
                this.tooltip = cfg.tooltip.text;
            }
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(btn1, cfg, "button");
            if (cfg.nativeoptions && cfg.nativeoptions.html) {
                if (cfg.nativeoptions.html.attributes) for(var attribute in cfg.nativeoptions.html.attributes)btn1.setAttribute(attribute, cfg.nativeoptions.html.attributes[attribute]);
            }
            if (cfg.hidden) btn1.classList.add("hidden");
            else btn1.classList.remove("hidden");
            if (cfg.disabled) btn1.disabled = true;
            else btn1.disabled = false;
            if (cfg.no_loader) this.no_loader = true;
            else this.no_loader = false;
            var icon_left = "";
            if (cfg.icon_left) {
                if (cfg.icon_left[0] == "<") icon_left = cfg.icon_left;
                else icon_left = `<img class="c-button-icon-left" src="${cfg.icon_left}"/> `;
            }
            var icon_center = "";
            if (cfg.icon_center) {
                if (cfg.icon_center[0] == "<") icon_center = cfg.icon_center;
                else icon_center = `<img class="c-button-icon-center" src="${cfg.icon_center}"/> `;
            }
            var icon_right = "";
            if (cfg.icon_right) {
                if (cfg.icon_right[0] == "<") icon_right = cfg.icon_right;
                else icon_right = ` <img class="c-button-icon-right" src="${cfg.icon_right}"/>`;
            }
            btn1.innerHTML = `${icon_left}${icon_center}${cfg.label || ""}${icon_right}`;
        }
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var button;
            return (0, _tsGenerator._)(this, function(_state) {
                button = document.getElementById(_this.brick_id);
                if (status == "loading" && !_this.no_loader) {
                    if (button) {
                        button.classList.add("loader");
                        button.classList.add("btn-loader-loading");
                        button.disabled = true;
                    }
                } else if (button) {
                    button.classList.remove("btn-loader-loading");
                    button.classList.remove("loader");
                    button.disabled = false;
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_trigger_submit() {
        var btn = document.getElementById(`${this.brick_id}`);
        if (btn) {
            if (!(0, _cbutil.isVisible)(btn)) return;
            btn.click();
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.outdata = {};
        this.style_classes = [];
        this.initialised = false;
        this.no_loader = false;
        this.cfg = {};
        this.tooltip = "";
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"wtPnN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cb_tooltip", ()=>cb_tooltip);
class cb_tooltip {
    static set_tooltips() {
        var parent_element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var tooltip_elements = (parent_element || document).querySelectorAll("[tooltip]");
        for(var t = 0; t < tooltip_elements.length; t++)cb_tooltip.set_tooltip(tooltip_elements[t]);
    }
    static set_tooltip(tooltip_element) {
        var te = tooltip_element;
        var has_tooltip_handler = te.getAttribute("has_tooltip_handler");
        if (has_tooltip_handler) return;
        if (!window.codebricks_context.has_tooltip) {
            var tooltip_pop = `<div id="cb_tooltip" class="tooltip-pop hidden"></div><div id="cb_tooltip_arrow" class="tooltip-arrow hidden"></div>`;
            window.document.body.insertAdjacentHTML("beforeend", tooltip_pop);
            window.codebricks_context.has_tooltip = true;
        }
        te.addEventListener("mouseenter", function(event) {
            var new_drop = document.getElementById("cb_tooltip");
            var new_arrow = document.getElementById("cb_tooltip_arrow");
            if (new_drop == null || new_arrow == null) return;
            var tooltip = this.getAttribute("tooltip");
            if (tooltip == "" || tooltip == null) return;
            te.classList.add("tooltip");
            new_drop.innerHTML = tooltip;
            var width = this.offsetWidth;
            var offset = cb_tooltip.getRect(this);
            new_drop.classList.remove("hidden");
            new_arrow.classList.remove("hidden");
            var drop_computed_style = getComputedStyle(new_drop);
            var dropHeight = Number(drop_computed_style.height.replace("px", ""));
            var use_top_offset = offset.y - dropHeight;
            var dropWidth = Number(drop_computed_style.width.replace("px", ""));
            var use_offset_x = offset.x + width / 2 - dropWidth / 2;
            var arrow_height = 4;
            new_arrow.style.top = offset.y - arrow_height - 1 + "px";
            new_arrow.style.left = offset.x + width / 2 + "px";
            var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (offset.x + dropWidth / 2 > screenWidth) use_offset_x = offset.x - dropWidth + offset.w;
            else if (use_offset_x - dropWidth / 2 < 0) use_offset_x = 0;
            new_drop.style.top = use_top_offset - arrow_height - 1 + "px";
            new_drop.style.left = use_offset_x + "px";
        });
        te.addEventListener("mouseleave", function(event) {
            cb_tooltip.hide();
            te.classList.remove("tooltip");
        });
        te.setAttribute("has_tooltip_handler", "true");
    }
    static hide() {
        var new_drop = document.getElementById("cb_tooltip");
        var new_arrow = document.getElementById("cb_tooltip_arrow");
        if (new_drop == null || new_arrow == null) return;
        var tooltip_elements = document.querySelectorAll(".tooltip");
        for(var t = 0; t < tooltip_elements.length; t++)tooltip_elements[t].classList.remove("tooltip");
        new_drop.classList.add("hidden");
        new_arrow.classList.add("hidden");
    }
    static getRect(element) {
        var rect = element.getBoundingClientRect();
        var x = rect.x;
        var y = rect.y;
        y += window.scrollY;
        x += window.scrollX;
        return {
            x: x,
            y: y,
            w: rect.width,
            h: rect.height
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"9Gr5M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_chart_webcomponent", ()=>c_chart_webcomponent);
parcelHelpers.export(exports, "web_c_chart", ()=>web_c_chart);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _util = require("../../shared-funcs/Util");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbformatting = require("../../codebricks-runtime/CBFormatting");
var _auto = require("chart.js/auto");
var _chartjsPluginDatalabels = require("chartjs-plugin-datalabels");
var _chartjsPluginDatalabelsDefault = parcelHelpers.interopDefault(_chartjsPluginDatalabels);
var _cbWebUtil = require("../controls/cb_web_util");
(0, _auto.Chart).register((0, _chartjsPluginDatalabelsDefault.default));
class c_chart_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_chart(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-chart", c_chart_webcomponent);
class web_c_chart extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _a, self, title_container, data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, cf, r, row, newRow, prop, container, keys, type, canvas, data1, chartconfig, types, _loop, keys1, x_col, k, labels, datasets, i, options, keys2, labels1, values, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, row1, dataset, color_offset, i1, clr_i, options1, empty_element;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg;
                    self = _this;
                    title_container = document.getElementById(self.brick_id + "$title");
                    if (title_container) {
                        if (cfg.title) {
                            title_container.innerHTML = "<h2>" + cfg.title + "</h2>";
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(title_container.firstElementChild, cfg, "title");
                        } else title_container.innerHTML = "";
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(title_container.parentElement, cfg, "container");
                    }
                    self.cfg.formatted_data = self.cfg.data;
                    if (cfg.column_formats && cfg.column_formats.length > 0) {
                        data = (0, _cbutil.Clone)(self.cfg.data);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = cfg.column_formats[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                cf = _step.value;
                                for(r = 0; r < data.length; r++){
                                    row = data[r];
                                    if (cf.format) row[cf.column] = (0, _cbformatting.codebricks_format)(row[cf.column], cf.format, ((_a = _this.context.composition_runners[_this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value;
                                    if (cf.hidden) delete row[cf.column];
                                    if (cf.rename) {
                                        newRow = {};
                                        for(var prop in row)if (prop == cf.column) newRow[cf.rename] = row[prop];
                                        else newRow[prop] = row[prop];
                                        data[r] = newRow;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        self.cfg.formatted_data = data;
                    }
                    container = document.getElementById(_this.brick_id + "$chartcontainer");
                    if (cfg.height) {
                        if (container) {
                            container.style.height = cfg.height;
                            if (cfg.charttype == "pie" || cfg.charttype == "donut" || cfg.charttype == "doughnut") container.style.maxWidth = cfg.height;
                            else if (cfg.charttype == "bar") {
                                if (cfg.data) {
                                    if (cfg.data.count > 0) {
                                        keys = Object.keys(self.cfg.formatted_data[0]);
                                        container.style.height = 40 * (keys.length - 1) * cfg.data.length + "px";
                                    }
                                }
                            } else container.style.removeProperty("max-width");
                        }
                    }
                    (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "chart");
                    type = self.cfg.charttype;
                    canvas = document.getElementById(_this.brick_id);
                    data1 = self.cfg.formatted_data || [];
                    _this.unformatted_data = cfg.data;
                    if (canvas) {
                        chartconfig = {};
                        types = type.split(",");
                        type = types[0].trim();
                        if (type == "bar" || type == "column" || type == "line") {
                            if (type == "column") type = "bar";
                            if (data1 && data1.length > 0 && _this.unformatted_data) {
                                _loop = function(i) {
                                    if (i == x_col) return "continue";
                                    var dataset = {
                                        label: keys1[i],
                                        data: data1.map((row)=>row[keys1[i]])
                                    };
                                    if (types.length > 0) {
                                        dataset.type = types[i] == "column" ? "bar" : types[i] || type;
                                        dataset.order = keys1.length - i;
                                    }
                                    if (cfg.color_per_bar) {
                                        if (cfg.colors) {
                                            var color_offset = 0;
                                            dataset.backgroundColor = [];
                                            for(var i1 = 0; i1 < data1.length; i1++)if (cfg.colors[i1]) {
                                                var clr_i = i1 + color_offset;
                                                if (clr_i >= cfg.colors.length) clr_i = clr_i % cfg.colors.length;
                                                dataset.backgroundColor.push(cfg.colors[clr_i]);
                                            }
                                        }
                                    } else if (cfg.colors && cfg.colors[i - 1]) dataset.borderColor = cfg.colors[i - 1], dataset.backgroundColor = cfg.colors[i - 1];
                                    datasets.push(dataset);
                                };
                                keys1 = Object.keys(data1[0]);
                                x_col = 0;
                                if (cfg.x_axis_column) {
                                    for(k = 0; k < keys1.length; k++)if (keys1[k] == cfg.x_axis_column) {
                                        x_col = k;
                                        break;
                                    }
                                }
                                labels = data1.map((row)=>row[keys1[x_col]]);
                                datasets = [];
                                for(i = 0; i < keys1.length; i++)_loop(i);
                                options = {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        datalabels: {
                                            display: function display(context) {
                                                return context.dataset.data[context.dataIndex] >= 1;
                                            },
                                            formatter: function formatter(value) {
                                                var _a, _b;
                                                if (typeof value === "number") return (0, _cbformatting.codebricks_format)(value, self.cfg.data_label_format || "Number(0)", ((_a = self.context.composition_runners[self.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value;
                                                else if (self.cfg.data_label_format) return (0, _cbformatting.codebricks_format)(value, self.cfg.data_label_format, ((_b = self.context.composition_runners[self.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value;
                                                return value;
                                            }
                                        }
                                    }
                                };
                                if (self.cfg.charttype == "bar") options.indexAxis = "y";
                                if (cfg.legend) {
                                    if (cfg.legend != "none") {
                                        options.plugins.legend = options.plugins.legend || {};
                                        options.plugins.legend.display = true;
                                        options.plugins.legend.position = cfg.legend;
                                    }
                                }
                                chartconfig = {
                                    type: type,
                                    data: {
                                        labels: labels,
                                        datasets: datasets
                                    },
                                    options: options
                                };
                            }
                        } else if ((type == "pie" || type == "donut" || type == "doughnut") && data1 && data1.length > 0) {
                            keys2 = Object.keys(data1[0]);
                            labels1 = [];
                            values = [];
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = data1[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    row1 = _step1.value;
                                    labels1.push(row1[keys2[0]]);
                                    values.push(row1[keys2[1]]);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            dataset = {
                                label: "",
                                data: values
                            };
                            color_offset = 0;
                            if (cfg.colors) {
                                dataset.backgroundColor = [];
                                for(i1 = 0; i1 < data1.length; i1++)if (cfg.colors[i1]) {
                                    clr_i = i1 + color_offset;
                                    if (clr_i >= cfg.colors.length) clr_i = clr_i % cfg.colors.length;
                                    dataset.backgroundColor.push(cfg.colors[clr_i]);
                                }
                            }
                            options1 = {
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    datalabels: {
                                        display: function display(context) {
                                            return context.dataset.data[context.dataIndex] !== 0;
                                        },
                                        formatter: function formatter(value) {
                                            if (typeof value === "number") return value.toLocaleString();
                                            return value;
                                        }
                                    }
                                }
                            };
                            if (cfg.legend) {
                                if (cfg.legend != "none" && options1 && options1.plugins && options1.plugins.legend) {
                                    options1.plugins.legend.display = true;
                                    options1.plugins.legend.position = cfg.legend;
                                }
                            }
                            chartconfig = {
                                type: "doughnut",
                                data: {
                                    labels: labels1,
                                    datasets: [
                                        dataset
                                    ]
                                },
                                options: options1
                            };
                        }
                        if (_this.cfg.nativeoptions && _this.cfg.nativeoptions.chartjs) {
                            if (_this.cfg.nativeoptions.chartjs && _this.cfg.nativeoptions.chartjs.options && _this.cfg.nativeoptions.chartjs.options.plugins && _this.cfg.nativeoptions.chartjs.options.plugins.datalabels && _this.cfg.nativeoptions.chartjs.options.plugins.datalabels.display) delete _this.cfg.nativeoptions.chartjs.options.plugins.datalabels.display;
                            chartconfig = (0, _cbutil.ObjectDeepMerge)(chartconfig, _this.cfg.nativeoptions.chartjs);
                        }
                        if (_this.chart) _this.chart.destroy();
                        _this.chart = new (0, _auto.Chart)(canvas, chartconfig);
                        if (_this.initial) canvas.onclick = (evt)=>{
                            var res = self.chart.getElementsAtEventForMode(evt, "nearest", {
                                intersect: true
                            }, true);
                            if (res.length === 0) return;
                            var bar_data = self.unformatted_data[res[0].index];
                            self.cb_emit({
                                "@": self.chart.data.labels[res[0].index],
                                "@option_object": bar_data,
                                "@index": res[0].index
                            });
                        };
                        _this.initial = false;
                        if (container) {
                            empty_element = document.getElementById(_this.brick_id + "$empty");
                            if (empty_element) {
                                empty_element.innerHTML = cfg.no_data_message || "No Results";
                                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(empty_element, cfg, "empty");
                                if (!cfg.data || cfg.data.length == 0) {
                                    container.classList.add("hidden");
                                    empty_element.classList.remove("hidden");
                                } else {
                                    empty_element.classList.add("hidden");
                                    container.classList.remove("hidden");
                                }
                            }
                        }
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id + "$chartcontainer");
        if (container) {
            if (status == "loading") container.classList.add("chart-loading");
            else container.classList.remove("chart-loading");
        }
    }
    transformDataIntoOptions(options, data) {
        if (data && data.length > 0) {
            if (options.chart.type == "bar") {
                var categories = [];
                var series_data = {};
                var keys = Object.keys(data[0]);
                for(var i = 1; i < keys.length; i++)series_data[keys[i]] = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var row = _step.value;
                        categories.push(row[keys[0]]);
                        for(var i1 = 1; i1 < keys.length; i1++)series_data[keys[i1]].push(row[keys[i1]]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var series = [];
                for(var i2 = 1; i2 < keys.length; i2++)series.push({
                    name: (0, _util.Prettyfy)(keys[i2]),
                    data: series_data[keys[i2]]
                });
                options.series = series;
                options.xaxis.categories = categories;
            } else if (options.chart.type == "pie" || options.chart.type == "donut") {
                var series1 = [];
                var labels = [];
                var keys1 = Object.keys(data[0]);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = data[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var row1 = _step1.value;
                        labels.push((0, _util.Prettyfy)(row1[keys1[0]]));
                        series1.push(row1[keys1[1]]);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                options.series = series1;
                options.labels = labels;
                options.chart.width = 400;
            }
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initial = true;
        this.element = element;
        var html = `<div class="c-chart-container"><div id="${this.brick_id}$title" class="c-chart-title"></div><div class='c-chart' id="${this.brick_id}$chartcontainer"><canvas id="${this.brick_id}"></canvas></div><div id="${this.brick_id}$empty" class="empty-state c-chart-empty hidden"></div></div>`;
        this.element.innerHTML = html;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../shared-funcs/Util":"jh939","../../codebricks-runtime/CodeBrick":"junyG","../../codebricks-runtime/CBFormatting":"TabN7","chart.js/auto":"Q5qgv","chartjs-plugin-datalabels":"3NiGM","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jh939":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Prettyfy", ()=>Prettyfy);
function Prettyfy(str) {
    if (str === undefined || str === null) return "";
    return (str + "")// insert a space between lower & upper
    .replace(/([a-z])([A-Z])/g, "$1 $2")// space before last upper in a sequence followed by lower
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")// uppercase the first character
    .replace(/^./, function(str) {
        return str.toUpperCase();
    }).trim();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"Q5qgv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _chartJs = require("../dist/chart.js");
parcelHelpers.exportAll(_chartJs, exports);
(0, _chartJs.Chart).register(...(0, _chartJs.registerables));
exports.default = (0, _chartJs.Chart);

},{"../dist/chart.js":"i71Mg","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"i71Mg":[function(require,module,exports) {
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Animations", ()=>Animations);
parcelHelpers.export(exports, "ArcElement", ()=>ArcElement);
parcelHelpers.export(exports, "BarController", ()=>BarController);
parcelHelpers.export(exports, "BarElement", ()=>BarElement);
parcelHelpers.export(exports, "BasePlatform", ()=>BasePlatform);
parcelHelpers.export(exports, "BasicPlatform", ()=>BasicPlatform);
parcelHelpers.export(exports, "BubbleController", ()=>BubbleController);
parcelHelpers.export(exports, "CategoryScale", ()=>CategoryScale);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Colors", ()=>plugin_colors);
parcelHelpers.export(exports, "DatasetController", ()=>DatasetController);
parcelHelpers.export(exports, "Decimation", ()=>plugin_decimation);
parcelHelpers.export(exports, "DomPlatform", ()=>DomPlatform);
parcelHelpers.export(exports, "DoughnutController", ()=>DoughnutController);
parcelHelpers.export(exports, "Element", ()=>Element);
parcelHelpers.export(exports, "Filler", ()=>index);
parcelHelpers.export(exports, "Interaction", ()=>Interaction);
parcelHelpers.export(exports, "Legend", ()=>plugin_legend);
parcelHelpers.export(exports, "LineController", ()=>LineController);
parcelHelpers.export(exports, "LineElement", ()=>LineElement);
parcelHelpers.export(exports, "LinearScale", ()=>LinearScale);
parcelHelpers.export(exports, "LogarithmicScale", ()=>LogarithmicScale);
parcelHelpers.export(exports, "PieController", ()=>PieController);
parcelHelpers.export(exports, "PointElement", ()=>PointElement);
parcelHelpers.export(exports, "PolarAreaController", ()=>PolarAreaController);
parcelHelpers.export(exports, "RadarController", ()=>RadarController);
parcelHelpers.export(exports, "RadialLinearScale", ()=>RadialLinearScale);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "ScatterController", ()=>ScatterController);
parcelHelpers.export(exports, "SubTitle", ()=>plugin_subtitle);
parcelHelpers.export(exports, "Ticks", ()=>(0, _helpersSegmentJs.aL));
parcelHelpers.export(exports, "TimeScale", ()=>TimeScale);
parcelHelpers.export(exports, "TimeSeriesScale", ()=>TimeSeriesScale);
parcelHelpers.export(exports, "Title", ()=>plugin_title);
parcelHelpers.export(exports, "Tooltip", ()=>plugin_tooltip);
parcelHelpers.export(exports, "_adapters", ()=>adapters);
parcelHelpers.export(exports, "_detectPlatform", ()=>_detectPlatform);
parcelHelpers.export(exports, "animator", ()=>animator);
parcelHelpers.export(exports, "controllers", ()=>controllers);
parcelHelpers.export(exports, "defaults", ()=>(0, _helpersSegmentJs.d));
parcelHelpers.export(exports, "elements", ()=>elements);
parcelHelpers.export(exports, "layouts", ()=>layouts);
parcelHelpers.export(exports, "plugins", ()=>plugins);
parcelHelpers.export(exports, "registerables", ()=>registerables);
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "scales", ()=>scales);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _helpersSegmentJs = require("./chunks/helpers.segment.js");
var _color = require("@kurkle/color");
class Animator {
    _notify(chart, anims, date, type) {
        var callbacks = anims.listeners[type];
        var numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, _helpersSegmentJs.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update() {
        var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
        var remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            var items = anims.items;
            var i = items.length - 1;
            var draw = false;
            var item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        var charts = this._charts;
        var anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        var anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        var anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        var anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        var items = anims.items;
        var i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
}
var animator = /* #__PURE__ */ new Animator();
var transparent = "transparent";
var interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        var c0 = (0, _helpersSegmentJs.c)(from || transparent);
        var c1 = c0.valid && (0, _helpersSegmentJs.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            var currentValue = this._target[this._prop];
            var elapsed = date - this._start;
            var remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, _helpersSegmentJs.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, _helpersSegmentJs.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        var elapsed = date - this._start;
        var duration = this._duration;
        var prop = this._prop;
        var from = this._from;
        var loop = this._loop;
        var to = this._to;
        var factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        var promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        var method = resolved ? "res" : "rej";
        var promises = this._promises || [];
        for(var i = 0; i < promises.length; i++)promises[i][method]();
    }
    constructor(cfg, target, prop, to){
        var currentValue = target[prop];
        to = (0, _helpersSegmentJs.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        var from = (0, _helpersSegmentJs.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = (0, _helpersSegmentJs.e)[cfg.easing] || (0, _helpersSegmentJs.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
}
class Animations {
    configure(config) {
        if (!(0, _helpersSegmentJs.i)(config)) return;
        var animationOptions = Object.keys((0, _helpersSegmentJs.d).animation);
        var animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            var cfg = config[key];
            if (!(0, _helpersSegmentJs.i)(cfg)) return;
            var resolved = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = animationOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var option = _step.value;
                    resolved[option] = cfg[option];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            ((0, _helpersSegmentJs.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        var newOptions = values.options;
        var options = resolveTargetOptions(target, newOptions);
        if (!options) return [];
        var animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        var animatedProps = this._properties;
        var animations = [];
        var running = target.$animations || (target.$animations = {});
        var props = Object.keys(values);
        var date = Date.now();
        var i;
        for(i = props.length - 1; i >= 0; --i){
            var prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            var value = values[prop];
            var animation = running[prop];
            var cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        var animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
}
function awaitAll(animations, properties) {
    var running = [];
    var keys = Object.keys(properties);
    for(var i = 0; i < keys.length; i++){
        var anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    var options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    var opts = scale && scale.options || {};
    var reverse = opts.reverse;
    var min = opts.min === undefined ? allowedOverflow : 0;
    var max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    var x = scaleClip(xScale, allowedOverflow);
    var y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    var t, r, b, l;
    if ((0, _helpersSegmentJs.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    var keys = [];
    var metasets = chart._getSortedDatasetMetas(filterVisible);
    var i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var keys = stack.keys;
    var singleMode = options.mode === "single";
    var i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, _helpersSegmentJs.g)(otherValue) && (singleMode || value === 0 || (0, _helpersSegmentJs.s)(value) === (0, _helpersSegmentJs.s)(otherValue))) value += otherValue;
    }
    return value;
}
function convertObjectDataToArray(data) {
    var keys = Object.keys(data);
    var adata = new Array(keys.length);
    var i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    var stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    var _scale_getUserBounds = scale.getUserBounds(), min = _scale_getUserBounds.min, max = _scale_getUserBounds.max, minDefined = _scale_getUserBounds.minDefined, maxDefined = _scale_getUserBounds.maxDefined;
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    var subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = vScale.getMatchingVisibleMetas(type).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var meta = _step.value;
            var value = stack[meta.index];
            if (positive && value > 0 || !positive && value < 0) return meta.index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function updateStacks(controller, parsed) {
    var chart = controller.chart, meta = controller._cachedMeta;
    var stacks = chart._stacks || (chart._stacks = {});
    var iScale = meta.iScale, vScale = meta.vScale, datasetIndex = meta.index;
    var iAxis = iScale.axis;
    var vAxis = vScale.axis;
    var key = getStackKey(iScale, vScale, meta);
    var ilen = parsed.length;
    var stack;
    for(var i = 0; i < ilen; ++i){
        var item = parsed[i];
        var index = item[iAxis], value = item[vAxis];
        var itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        var visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    var scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return (0, _helpersSegmentJs.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: "default",
        type: "dataset"
    });
}
function createDataContext(parent, index, element) {
    return (0, _helpersSegmentJs.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: "default",
        type: "data"
    });
}
function clearStacks(meta, items) {
    var datasetIndex = meta.controller.index;
    var axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var parsed = _step.value;
            var stacks = parsed._stacks;
            if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
            delete stacks[axis][datasetIndex];
            if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
var cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
var createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
    initialize() {
        var meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        var chart = this.chart;
        var meta = this._cachedMeta;
        var dataset = this.getDataset();
        var chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        var xid = meta.xAxisID = (0, _helpersSegmentJs.v)(dataset.xAxisID, getFirstScaleId(chart, "x"));
        var yid = meta.yAxisID = (0, _helpersSegmentJs.v)(dataset.yAxisID, getFirstScaleId(chart, "y"));
        var rid = meta.rAxisID = (0, _helpersSegmentJs.v)(dataset.rAxisID, getFirstScaleId(chart, "r"));
        var indexAxis = meta.indexAxis;
        var iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        var vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        var meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        var meta = this._cachedMeta;
        if (this._data) (0, _helpersSegmentJs.u)(this._data, this);
        if (meta._stacked) clearStacks(meta);
    }
    _dataCheck() {
        var dataset = this.getDataset();
        var data = dataset.data || (dataset.data = []);
        var _data = this._data;
        if ((0, _helpersSegmentJs.i)(data)) this._data = convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, _helpersSegmentJs.u)(_data, this);
                var meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, _helpersSegmentJs.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        var meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        var meta = this._cachedMeta;
        var dataset = this.getDataset();
        var stackChanged = false;
        this._dataCheck();
        var oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) updateStacks(this, meta._parsed);
    }
    configure() {
        var config = this.chart.config;
        var scopeKeys = config.datasetScopeKeys(this._type);
        var scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        var _this = this, meta = _this._cachedMeta, data = _this._data;
        var iScale = meta.iScale, _stacked = meta._stacked;
        var iAxis = iScale.axis;
        var sorted = start === 0 && count === data.length ? true : meta._sorted;
        var prev = start > 0 && meta._parsed[start - 1];
        var i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, _helpersSegmentJs.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, _helpersSegmentJs.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            var isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        var iScale = meta.iScale, vScale = meta.vScale;
        var iAxis = iScale.axis;
        var vAxis = vScale.axis;
        var labels = iScale.getLabels();
        var singleScale = iScale === vScale;
        var parsed = new Array(count);
        var i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        var xScale = meta.xScale, yScale = meta.yScale;
        var parsed = new Array(count);
        var i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        var xScale = meta.xScale, yScale = meta.yScale;
        var _this__parsing = this._parsing, _this__parsing_xAxisKey = _this__parsing.xAxisKey, xAxisKey = _this__parsing_xAxisKey === void 0 ? "x" : _this__parsing_xAxisKey, _this__parsing_yAxisKey = _this__parsing.yAxisKey, yAxisKey = _this__parsing_yAxisKey === void 0 ? "y" : _this__parsing_yAxisKey;
        var parsed = new Array(count);
        var i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, _helpersSegmentJs.f)(item, xAxisKey), index),
                y: yScale.parse((0, _helpersSegmentJs.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        var chart = this.chart;
        var meta = this._cachedMeta;
        var value = parsed[scale.axis];
        var stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        var parsedValue = parsed[scale.axis];
        var value = parsedValue === null ? NaN : parsedValue;
        var values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        var meta = this._cachedMeta;
        var _parsed = meta._parsed;
        var sorted = meta._sorted && scale === meta.iScale;
        var ilen = _parsed.length;
        var otherScale = this._getOtherScale(scale);
        var stack = createStack(canStack, meta, this.chart);
        var range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        var _getUserBounds = getUserBounds(otherScale), otherMin = _getUserBounds.min, otherMax = _getUserBounds.max;
        var i, parsed;
        function _skip() {
            parsed = _parsed[i];
            var otherValue = parsed[otherScale.axis];
            return !(0, _helpersSegmentJs.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        var parsed = this._cachedMeta._parsed;
        var values = [];
        var i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, _helpersSegmentJs.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        var meta = this._cachedMeta;
        var iScale = meta.iScale;
        var vScale = meta.vScale;
        var parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        var meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = toClip((0, _helpersSegmentJs.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        var ctx = this._ctx;
        var chart = this.chart;
        var meta = this._cachedMeta;
        var elements = meta.data || [];
        var area = chart.chartArea;
        var active = [];
        var start = this._drawStart || 0;
        var count = this._drawCount || elements.length - start;
        var drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        var i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            var element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        var mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        var dataset = this.getDataset();
        var context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            var element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType) {
        var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default", index = arguments.length > 2 ? arguments[2] : void 0;
        var active = mode === "active";
        var cache = this._cachedDataOpts;
        var cacheKey = elementType + "-" + mode;
        var cached = cache[cacheKey];
        var sharing = this.enableOptionSharing && (0, _helpersSegmentJs.h)(index);
        if (cached) return cloneIfNotShared(cached, sharing);
        var config = this.chart.config;
        var scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        var prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        var names = Object.keys((0, _helpersSegmentJs.d).elements[elementType]);
        var context = ()=>this.getContext(index, active, mode);
        var values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        var chart = this.chart;
        var cache = this._cachedDataOpts;
        var cacheKey = `animation-${transition}`;
        var cached = cache[cacheKey];
        if (cached) return cached;
        var options;
        if (chart.options.animation !== false) {
            var config = this.chart.config;
            var scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        var animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        var firstOpts = this.resolveDataElementOptions(start, mode);
        var previouslySharedOptions = this._sharedOptions;
        var sharedOptions = this.getSharedOptions(firstOpts);
        var includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        var options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        var element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        var element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        var data = this._data;
        var elements = this._cachedMeta.data;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this._syncList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 3), method = _step_value[0], arg1 = _step_value[1], arg2 = _step_value[2];
                this[method](arg1, arg2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this._syncList = [];
        var numMeta = elements.length;
        var numData = data.length;
        var count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count) {
        var resetNewElements = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var meta = this._cachedMeta;
        var data = meta.data;
        var end = start + count;
        var i;
        var move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        var meta = this._cachedMeta;
        if (this._parsing) {
            var removed = meta._parsed.splice(start, count);
            if (meta._stacked) clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            var _args = (0, _slicedToArray._)(args, 3), method = _args[0], arg1 = _args[1], arg2 = _args[2];
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        var count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        var newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
}
(0, _defineProperty._)(DatasetController, "defaults", {});
(0, _defineProperty._)(DatasetController, "datasetElementType", null);
(0, _defineProperty._)(DatasetController, "dataElementType", null);
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        var visibleMetas = scale.getMatchingVisibleMetas(type);
        var values = [];
        for(var i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, _helpersSegmentJs._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    var scale = meta.iScale;
    var values = getAllScaleValues(scale, meta.type);
    var min = scale._length;
    var i, ilen, curr, prev;
    var updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, _helpersSegmentJs.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    var thickness = options.barThickness;
    var size, ratio;
    if ((0, _helpersSegmentJs.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    var pixels = ruler.pixels;
    var curr = pixels[index];
    var prev = index > 0 ? pixels[index - 1] : null;
    var next = index < pixels.length - 1 ? pixels[index + 1] : null;
    var percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    var start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    var size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    var startValue = vScale.parse(entry[0], i);
    var endValue = vScale.parse(entry[1], i);
    var min = Math.min(startValue, endValue);
    var max = Math.max(startValue, endValue);
    var barStart = min;
    var barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, _helpersSegmentJs.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    var iScale = meta.iScale;
    var vScale = meta.vScale;
    var labels = iScale.getLabels();
    var singleScale = iScale === vScale;
    var parsed = [];
    var i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, _helpersSegmentJs.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    var reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    var edge = options.borderSkipped;
    var res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    var _borderProps = borderProps(properties), start = _borderProps.start, end = _borderProps.end, reverse = _borderProps.reverse, top = _borderProps.top, bottom = _borderProps.bottom;
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function setInflateAmount(properties, param, ratio) {
    var inflateAmount = param.inflateAmount;
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        var iScale = meta.iScale, vScale = meta.vScale;
        var _this__parsing = this._parsing, _this__parsing_xAxisKey = _this__parsing.xAxisKey, xAxisKey = _this__parsing_xAxisKey === void 0 ? "x" : _this__parsing_xAxisKey, _this__parsing_yAxisKey = _this__parsing.yAxisKey, yAxisKey = _this__parsing_yAxisKey === void 0 ? "y" : _this__parsing_yAxisKey;
        var iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        var vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        var parsed = [];
        var i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, _helpersSegmentJs.f)(obj, iAxisKey), i);
            parsed.push(parseValue((0, _helpersSegmentJs.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        var custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        var meta = this._cachedMeta;
        var iScale = meta.iScale, vScale = meta.vScale;
        var parsed = this.getParsed(index);
        var custom = parsed._custom;
        var value = isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        var meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        var meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        var reset = mode === "reset";
        var _this = this, index = _this.index, vScale = _this._cachedMeta.vScale;
        var base = vScale.getBasePixel();
        var horizontal = vScale.isHorizontal();
        var ruler = this._getRuler();
        var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
        for(var i = start; i < start + count; i++){
            var parsed = this.getParsed(i);
            var vpixels = reset || (0, _helpersSegmentJs.k)(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            var ipixels = this._calculateBarIndexPixels(i, ruler);
            var stack = (parsed._stacks || {})[vScale.axis];
            var properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            var options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        var iScale = this._cachedMeta.iScale;
        var metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        var stacked = iScale.options.stacked;
        var stacks = [];
        var skipNull = (meta)=>{
            var parsed = meta.controller.getParsed(dataIndex);
            var val = parsed && parsed[meta.vScale.axis];
            if ((0, _helpersSegmentJs.k)(val) || isNaN(val)) return true;
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = metasets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var meta = _step.value;
                if (dataIndex !== undefined && skipNull(meta)) continue;
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        var stacks = this._getStacks(datasetIndex, dataIndex);
        var index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        var opts = this.options;
        var meta = this._cachedMeta;
        var iScale = meta.iScale;
        var pixels = [];
        var i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        var barThickness = opts.barThickness;
        var min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        var _this = this, _this__cachedMeta = _this._cachedMeta, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, datasetIndex = _this__cachedMeta.index, _this_options = _this.options, baseValue = _this_options.base, minBarLength = _this_options.minBarLength;
        var actualBase = baseValue || 0;
        var parsed = this.getParsed(index);
        var custom = parsed._custom;
        var floating = isFloatBar(custom);
        var value = parsed[vScale.axis];
        var start = 0;
        var length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        var head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, _helpersSegmentJs.s)(value) !== (0, _helpersSegmentJs.s)(custom.barEnd)) start = 0;
            start += value;
        }
        var startValue = !(0, _helpersSegmentJs.k)(baseValue) && !floating ? baseValue : start;
        var base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            var startPixel = vScale.getPixelForDecimal(0);
            var endPixel = vScale.getPixelForDecimal(1);
            var min = Math.min(startPixel, endPixel);
            var max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            var halfGrid = (0, _helpersSegmentJs.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        var scale = ruler.scale;
        var options = this.options;
        var skipNull = options.skipNull;
        var maxBarThickness = (0, _helpersSegmentJs.v)(options.maxBarThickness, Infinity);
        var center, size;
        if (ruler.grouped) {
            var stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            var range = options.barThickness === "flex" ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
            var stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        var meta = this._cachedMeta;
        var vScale = meta.vScale;
        var rects = meta.data;
        var ilen = rects.length;
        var i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
(0, _defineProperty._)(BarController, "id", "bar");
(0, _defineProperty._)(BarController, "defaults", {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
});
(0, _defineProperty._)(BarController, "overrides", {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
});
class BubbleController extends DatasetController {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        var parsed = super.parsePrimitiveData(meta, data, start, count);
        for(var i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        var parsed = super.parseArrayData(meta, data, start, count);
        for(var i = 0; i < parsed.length; i++){
            var item = data[start + i];
            parsed[i]._custom = (0, _helpersSegmentJs.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        var parsed = super.parseObjectData(meta, data, start, count);
        for(var i = 0; i < parsed.length; i++){
            var item = data[start + i];
            parsed[i]._custom = (0, _helpersSegmentJs.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        var data = this._cachedMeta.data;
        var max = 0;
        for(var i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        var meta = this._cachedMeta;
        var labels = this.chart.data.labels || [];
        var xScale = meta.xScale, yScale = meta.yScale;
        var parsed = this.getParsed(index);
        var x = xScale.getLabelForValue(parsed.x);
        var y = yScale.getLabelForValue(parsed.y);
        var r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        var points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        var reset = mode === "reset";
        var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale;
        var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
        var iAxis = iScale.axis;
        var vAxis = vScale.axis;
        for(var i = start; i < start + count; i++){
            var point = points[i];
            var parsed = !reset && this.getParsed(i);
            var properties = {};
            var iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            var vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        var parsed = this.getParsed(index);
        var values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        var radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, _helpersSegmentJs.v)(parsed && parsed._custom, radius);
        return values;
    }
}
(0, _defineProperty._)(BubbleController, "id", "bubble");
(0, _defineProperty._)(BubbleController, "defaults", {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
});
(0, _defineProperty._)(BubbleController, "overrides", {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
});
function getRatioAndOffset(rotation, circumference, cutout) {
    var ratioX = 1;
    var ratioY = 1;
    var offsetX = 0;
    var offsetY = 0;
    if (circumference < (0, _helpersSegmentJs.T)) {
        var startAngle = rotation;
        var endAngle = startAngle + circumference;
        var startX = Math.cos(startAngle);
        var startY = Math.sin(startAngle);
        var endX = Math.cos(endAngle);
        var endY = Math.sin(endAngle);
        var calcMax = (angle, a, b)=>(0, _helpersSegmentJs.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        var calcMin = (angle, a, b)=>(0, _helpersSegmentJs.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        var maxX = calcMax(0, startX, endX);
        var maxY = calcMax((0, _helpersSegmentJs.H), startY, endY);
        var minX = calcMin((0, _helpersSegmentJs.P), startX, endX);
        var minY = calcMin((0, _helpersSegmentJs.P) + (0, _helpersSegmentJs.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    linkScales() {}
    parse(start, count) {
        var data = this.getDataset().data;
        var meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            var getter = (i)=>+data[i];
            if ((0, _helpersSegmentJs.i)(data[start])) {
                var _this__parsing = this._parsing, _this__parsing_key = _this__parsing.key, key = _this__parsing_key === void 0 ? "value" : _this__parsing_key;
                getter = (i)=>+(0, _helpersSegmentJs.f)(data[i], key);
            }
            var i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, _helpersSegmentJs.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, _helpersSegmentJs.t)(this.options.circumference);
    }
    _getRotationExtents() {
        var min = (0, _helpersSegmentJs.T);
        var max = -(0, _helpersSegmentJs.T);
        for(var i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            var controller = this.chart.getDatasetMeta(i).controller;
            var rotation = controller._getRotation();
            var circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        var chart = this.chart;
        var chartArea = chart.chartArea;
        var meta = this._cachedMeta;
        var arcs = meta.data;
        var spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        var maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        var cutout = Math.min((0, _helpersSegmentJs.m)(this.options.cutout, maxSize), 1);
        var chartWeight = this._getRingWeight(this.index);
        var _this__getRotationExtents = this._getRotationExtents(), circumference = _this__getRotationExtents.circumference, rotation = _this__getRotationExtents.rotation;
        var _getRatioAndOffset = getRatioAndOffset(rotation, circumference, cutout), ratioX = _getRatioAndOffset.ratioX, ratioY = _getRatioAndOffset.ratioY, offsetX = _getRatioAndOffset.offsetX, offsetY = _getRatioAndOffset.offsetY;
        var maxWidth = (chartArea.width - spacing) / ratioX;
        var maxHeight = (chartArea.height - spacing) / ratioY;
        var maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        var outerRadius = (0, _helpersSegmentJs.n)(this.options.radius, maxRadius);
        var innerRadius = Math.max(outerRadius * cutout, 0);
        var radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        var opts = this.options;
        var meta = this._cachedMeta;
        var circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, _helpersSegmentJs.T));
    }
    updateElements(arcs, start, count, mode) {
        var reset = mode === "reset";
        var chart = this.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var centerX = (chartArea.left + chartArea.right) / 2;
        var centerY = (chartArea.top + chartArea.bottom) / 2;
        var animateScale = reset && animationOpts.animateScale;
        var innerRadius = animateScale ? 0 : this.innerRadius;
        var outerRadius = animateScale ? 0 : this.outerRadius;
        var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
        var startAngle = this._getRotation();
        var i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            var circumference = this._circumference(i, reset);
            var arc = arcs[i];
            var properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        var meta = this._cachedMeta;
        var metaData = meta.data;
        var total = 0;
        var i;
        for(i = 0; i < metaData.length; i++){
            var value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        var total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, _helpersSegmentJs.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        var meta = this._cachedMeta;
        var chart = this.chart;
        var labels = chart.data.labels || [];
        var value = (0, _helpersSegmentJs.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value
        };
    }
    getMaxBorderWidth(arcs) {
        var max = 0;
        var chart = this.chart;
        var i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        var max = 0;
        for(var i = 0, ilen = arcs.length; i < ilen; ++i){
            var options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        var ringWeightOffset = 0;
        for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, _helpersSegmentJs.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
}
(0, _defineProperty._)(DoughnutController, "id", "doughnut");
(0, _defineProperty._)(DoughnutController, "defaults", {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
});
(0, _defineProperty._)(DoughnutController, "descriptors", {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
});
(0, _defineProperty._)(DoughnutController, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, pointStyle = _chart_legend_options_labels.pointStyle, color = _chart_legend_options_labels.color;
                        return data.labels.map((label, i)=>{
                            var meta = chart.getDatasetMeta(0);
                            var style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    }
});
class LineController extends DatasetController {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        var meta = this._cachedMeta;
        var line = meta.dataset, tmp = meta.data, points = tmp === void 0 ? [] : tmp, _dataset = meta._dataset;
        var animationsDisabled = this.chart._animationsDisabled;
        var _$_getStartAndCountOfVisiblePoints = (0, _helpersSegmentJs.q)(meta, points, animationsDisabled), start = _$_getStartAndCountOfVisiblePoints.start, count = _$_getStartAndCountOfVisiblePoints.count;
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersSegmentJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        var options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        var reset = mode === "reset";
        var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, _dataset = _this__cachedMeta._dataset;
        var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
        var iAxis = iScale.axis;
        var vAxis = vScale.axis;
        var _this_options = this.options, spanGaps = _this_options.spanGaps, segment = _this_options.segment;
        var maxGapLength = (0, _helpersSegmentJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        var directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        var end = start + count;
        var pointsCount = points.length;
        var prevParsed = start > 0 && this.getParsed(start - 1);
        for(var i = 0; i < pointsCount; ++i){
            var point = points[i];
            var properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            var parsed = this.getParsed(i);
            var nullData = (0, _helpersSegmentJs.k)(parsed[vAxis]);
            var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        var meta = this._cachedMeta;
        var dataset = meta.dataset;
        var border = dataset.options && dataset.options.borderWidth || 0;
        var data = meta.data || [];
        if (!data.length) return border;
        var firstPoint = data[0].size(this.resolveDataElementOptions(0));
        var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        var meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
(0, _defineProperty._)(LineController, "id", "line");
(0, _defineProperty._)(LineController, "defaults", {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
});
(0, _defineProperty._)(LineController, "overrides", {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
});
class PolarAreaController extends DatasetController {
    getLabelAndValue(index) {
        var meta = this._cachedMeta;
        var chart = this.chart;
        var labels = chart.data.labels || [];
        var value = (0, _helpersSegmentJs.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersSegmentJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        var arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        var meta = this._cachedMeta;
        var range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            var parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        var chart = this.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        var outerRadius = Math.max(minSize / 2, 0);
        var innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        var radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        var reset = mode === "reset";
        var chart = this.chart;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var scale = this._cachedMeta.rScale;
        var centerX = scale.xCenter;
        var centerY = scale.yCenter;
        var datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, _helpersSegmentJs.P);
        var angle = datasetStartAngle;
        var i;
        var defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            var arc = arcs[i];
            var startAngle = angle;
            var endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            var outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            var properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        var meta = this._cachedMeta;
        var count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, _helpersSegmentJs.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
}
(0, _defineProperty._)(PolarAreaController, "id", "polarArea");
(0, _defineProperty._)(PolarAreaController, "defaults", {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
});
(0, _defineProperty._)(PolarAreaController, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, pointStyle = _chart_legend_options_labels.pointStyle, color = _chart_legend_options_labels.color;
                        return data.labels.map((label, i)=>{
                            var meta = chart.getDatasetMeta(0);
                            var style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
});
class PieController extends DoughnutController {
}
(0, _defineProperty._)(PieController, "id", "pie");
(0, _defineProperty._)(PieController, "defaults", {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
});
class RadarController extends DatasetController {
    getLabelAndValue(index) {
        var vScale = this._cachedMeta.vScale;
        var parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersSegmentJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        var meta = this._cachedMeta;
        var line = meta.dataset;
        var points = meta.data || [];
        var labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            var options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            var properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        var scale = this._cachedMeta.rScale;
        var reset = mode === "reset";
        for(var i = start; i < start + count; i++){
            var point = points[i];
            var options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            var pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            var properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
(0, _defineProperty._)(RadarController, "id", "radar");
(0, _defineProperty._)(RadarController, "defaults", {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
});
(0, _defineProperty._)(RadarController, "overrides", {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
});
class ScatterController extends DatasetController {
    getLabelAndValue(index) {
        var meta = this._cachedMeta;
        var labels = this.chart.data.labels || [];
        var xScale = meta.xScale, yScale = meta.yScale;
        var parsed = this.getParsed(index);
        var x = xScale.getLabelForValue(parsed.x);
        var y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        var meta = this._cachedMeta;
        var tmp = meta.data, points = tmp === void 0 ? [] : tmp;
        var animationsDisabled = this.chart._animationsDisabled;
        var _$_getStartAndCountOfVisiblePoints = (0, _helpersSegmentJs.q)(meta, points, animationsDisabled), start = _$_getStartAndCountOfVisiblePoints.start, count = _$_getStartAndCountOfVisiblePoints.count;
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersSegmentJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            var line = meta.dataset, _dataset = meta._dataset;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            var options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        var showLine = this.options.showLine;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        var reset = mode === "reset";
        var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, _dataset = _this__cachedMeta._dataset;
        var firstOpts = this.resolveDataElementOptions(start, mode);
        var sharedOptions = this.getSharedOptions(firstOpts);
        var includeOptions = this.includeOptions(mode, sharedOptions);
        var iAxis = iScale.axis;
        var vAxis = vScale.axis;
        var _this_options = this.options, spanGaps = _this_options.spanGaps, segment = _this_options.segment;
        var maxGapLength = (0, _helpersSegmentJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        var directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        var prevParsed = start > 0 && this.getParsed(start - 1);
        for(var i = start; i < start + count; ++i){
            var point = points[i];
            var parsed = this.getParsed(i);
            var properties = directUpdate ? point : {};
            var nullData = (0, _helpersSegmentJs.k)(parsed[vAxis]);
            var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        var meta = this._cachedMeta;
        var data = meta.data || [];
        if (!this.options.showLine) {
            var max = 0;
            for(var i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        var dataset = meta.dataset;
        var border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        var firstPoint = data[0].size(this.resolveDataElementOptions(0));
        var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
(0, _defineProperty._)(ScatterController, "id", "scatter");
(0, _defineProperty._)(ScatterController, "defaults", {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
});
(0, _defineProperty._)(ScatterController, "overrides", {
    interaction: {
        mode: "point"
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
});
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
    constructor(options){
        (0, _defineProperty._)(this, "options", void 0);
        this.options = options || {};
    }
}
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    var controller = metaset.controller, data = metaset.data, _sorted = metaset._sorted;
    var iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        var lookupMethod = iScale._reversePixels ? (0, _helpersSegmentJs.A) : (0, _helpersSegmentJs.B);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            var el = data[0];
            var range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                var start = lookupMethod(data, axis, value - range);
                var end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    var metasets = chart.getSortedVisibleDatasetMetas();
    var value = position[axis];
    for(var i = 0, ilen = metasets.length; i < ilen; ++i){
        var _metasets_i = metasets[i], index = _metasets_i.index, data = _metasets_i.data;
        var _binarySearch = binarySearch(metasets[i], axis, value, intersect), lo = _binarySearch.lo, hi = _binarySearch.hi;
        for(var j = lo; j <= hi; ++j){
            var element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    var useX = axis.indexOf("x") !== -1;
    var useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    var items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    var evaluationFunc = function evaluationFunc(element, datasetIndex, index) {
        if (!includeInvisible && !(0, _helpersSegmentJs.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element,
            datasetIndex,
            index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    var items = [];
    function evaluationFunc(element, datasetIndex, index) {
        var _element_getProps = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition), startAngle = _element_getProps.startAngle, endAngle = _element_getProps.endAngle;
        var angle = (0, _helpersSegmentJs.D)(element, {
            x: position.x,
            y: position.y
        }).angle;
        if ((0, _helpersSegmentJs.p)(angle, startAngle, endAngle)) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    var items = [];
    var distanceMetric = getDistanceMetricForAxis(axis);
    var minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        var inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        var center = element.getCenterPoint(useFinalPosition);
        var pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    var items = [];
    var rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    var intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            var position = (0, _helpersSegmentJs.z)(e, chart);
            var axis = options.axis || "x";
            var includeInvisible = options.includeInvisible || false;
            var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            var elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                var index = items[0].index;
                var element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element,
                    datasetIndex: meta.index,
                    index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            var position = (0, _helpersSegmentJs.z)(e, chart);
            var axis = options.axis || "xy";
            var includeInvisible = options.includeInvisible || false;
            var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                var datasetIndex = items[0].datasetIndex;
                var data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(var i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            var position = (0, _helpersSegmentJs.z)(e, chart);
            var axis = options.axis || "xy";
            var includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            var position = (0, _helpersSegmentJs.z)(e, chart);
            var axis = options.axis || "xy";
            var includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            var position = (0, _helpersSegmentJs.z)(e, chart);
            return getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            var position = (0, _helpersSegmentJs.z)(e, chart);
            return getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
var STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    var layoutBoxes = [];
    var i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        var ref, ref1, ref2;
        ref = box, pos = ref.position, ref1 = ref.options, stack = ref1.stack, ref2 = ref1.stackWeight, stackWeight = ref2 === void 0 ? 1 : ref2, ref1, ref;
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    var stacks = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layouts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var wrap = _step.value;
            var stack = wrap.stack, pos = wrap.pos, stackWeight = wrap.stackWeight;
            if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
            var _stack = stacks[stack] || (stacks[stack] = {
                count: 0,
                placed: 0,
                weight: 0,
                size: 0
            });
            _stack.count++;
            _stack.weight += stackWeight;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    var stacks = buildStacks(layouts);
    var vBoxMaxWidth = params.vBoxMaxWidth, hBoxMaxHeight = params.hBoxMaxHeight;
    var i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        var fullSize = layout.box.fullSize;
        var stack = stacks[layout.stack];
        var factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    var layoutBoxes = wrapBoxes(boxes);
    var fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    var left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
    var right = sortByWeight(filterByPosition(layoutBoxes, "right"));
    var top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
    var bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
    var centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
    var centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    var pos = layout.pos, box = layout.box;
    var maxPadding = chartArea.maxPadding;
    if (!(0, _helpersSegmentJs.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        var stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    var newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
    var newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    var widthChanged = newWidth !== chartArea.w;
    var heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    var maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
    var maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        var margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    var refitBoxes = [];
    var i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        var _updateDims = updateDims(chartArea, params, layout, stacks), same = _updateDims.same, other = _updateDims.other;
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    var userPadding = params.padding;
    var x = chartArea.x, y = chartArea.y;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = boxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var layout = _step.value;
            var box = layout.box;
            var stack = stacks[layout.stack] || {
                count: 1,
                placed: 0,
                weight: 1
            };
            var weight = layout.stackWeight / stack.weight || 1;
            if (layout.horizontal) {
                var width = chartArea.w * weight;
                var height = stack.size || box.height;
                if ((0, _helpersSegmentJs.h)(stack.start)) y = stack.start;
                if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
                else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
                stack.start = y;
                stack.placed += width;
                y = box.bottom;
            } else {
                var height1 = chartArea.h * weight;
                var width1 = stack.size || box.width;
                if ((0, _helpersSegmentJs.h)(stack.start)) x = stack.start;
                if (box.fullSize) setBoxDims(box, x, userPadding.top, width1, params.outerHeight - userPadding.bottom - userPadding.top);
                else setBoxDims(box, x, chartArea.top + stack.placed, width1, height1);
                stack.start = x;
                stack.placed += height1;
                x = box.right;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        var padding = (0, _helpersSegmentJs.E)(chart.options.layout.padding);
        var availableWidth = Math.max(width - padding.width, 0);
        var availableHeight = Math.max(height - padding.height, 0);
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        (0, _helpersSegmentJs.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        var visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        var params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        var maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, _helpersSegmentJs.E)(minPadding));
        var chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        var stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, _helpersSegmentJs.F)(boxes.chartArea, (layout)=>{
            var box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
var EXPANDO_KEY = "$chartjs";
var EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
var isNullOrEmpty = (value)=>value === null || value === "";
function initCanvas(canvas, aspectRatio) {
    var style = canvas.style;
    var renderHeight = canvas.getAttribute("height");
    var renderWidth = canvas.getAttribute("width");
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if (isNullOrEmpty(renderWidth)) {
        var displayWidth = (0, _helpersSegmentJs.J)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            var displayHeight = (0, _helpersSegmentJs.J)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
var eventListenerOptions = (0, _helpersSegmentJs.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    var type = EVENT_TYPES[event.type] || event.type;
    var _getRelativePosition = (0, _helpersSegmentJs.z)(event, chart), x = _getRelativePosition.x, y = _getRelativePosition.y;
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nodeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (node === canvas || node.contains(canvas)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function createAttachObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var observer = new MutationObserver((entries)=>{
        var trigger = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                trigger = trigger || nodeListContains(entry.addedNodes, canvas);
                trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var observer = new MutationObserver((entries)=>{
        var trigger = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                trigger = trigger || nodeListContains(entry.removedNodes, canvas);
                trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
var drpListeningCharts = new Map();
var oldDevicePixelRatio = 0;
function onWindowResize() {
    var dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener("resize", onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener("resize", onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var container = canvas && (0, _helpersSegmentJs.I)(canvas);
    if (!container) return;
    var resize = (0, _helpersSegmentJs.L)((width, height)=>{
        var w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    var observer = new ResizeObserver((entries)=>{
        var entry = entries[0];
        var width = entry.contentRect.width;
        var height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    var canvas = chart.canvas;
    var proxy = (0, _helpersSegmentJs.L)((event)=>{
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
class DomPlatform extends BasePlatform {
    acquireContext(canvas, aspectRatio) {
        var context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        var canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) return false;
        var initial = canvas[EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            var value = initial[prop];
            if ((0, _helpersSegmentJs.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        var style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        var proxies = chart.$proxies || (chart.$proxies = {});
        var handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        var handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        var proxies = chart.$proxies || (chart.$proxies = {});
        var proxy = proxies[type];
        if (!proxy) return;
        var handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        var handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, _helpersSegmentJs.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        var container = (0, _helpersSegmentJs.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function _detectPlatform(canvas) {
    if (!(0, _helpersSegmentJs.M)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
class Element {
    tooltipPosition(useFinalPosition) {
        var _this_getProps = this.getProps([
            "x",
            "y"
        ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
        return {
            x,
            y
        };
    }
    hasValue() {
        return (0, _helpersSegmentJs.x)(this.x) && (0, _helpersSegmentJs.x)(this.y);
    }
    getProps(props, final) {
        var anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        var ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
    constructor(){
        (0, _defineProperty._)(this, "x", void 0);
        (0, _defineProperty._)(this, "y", void 0);
        (0, _defineProperty._)(this, "active", false);
        (0, _defineProperty._)(this, "options", void 0);
        (0, _defineProperty._)(this, "$animations", void 0);
    }
}
(0, _defineProperty._)(Element, "defaults", {});
(0, _defineProperty._)(Element, "defaultRoutes", undefined);
function autoSkip(scale, ticks) {
    var tickOpts = scale.options.ticks;
    var determinedMaxTicks = determineMaxTicks(scale);
    var ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    var numMajorIndices = majorIndices.length;
    var first = majorIndices[0];
    var last = majorIndices[numMajorIndices - 1];
    var newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    var spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        var i, ilen;
        var avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, _helpersSegmentJs.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, _helpersSegmentJs.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    var offset = scale.options.offset;
    var tickLength = scale._tickSize();
    var maxScale = scale._length / tickLength + (offset ? 0 : 1);
    var maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    var evenMajorSpacing = getEvenSpacing(majorIndices);
    var spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    var factors = (0, _helpersSegmentJs.N)(evenMajorSpacing);
    for(var i = 0, ilen = factors.length - 1; i < ilen; i++){
        var factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    var result = [];
    var i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    var count = 0;
    var next = majorIndices[0];
    var i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    var start = (0, _helpersSegmentJs.v)(majorStart, 0);
    var end = Math.min((0, _helpersSegmentJs.v)(majorEnd, ticks.length), ticks.length);
    var count = 0;
    var length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    var len = arr.length;
    var i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
var reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
var offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
var getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
    var result = [];
    var increment = arr.length / numItems;
    var len = arr.length;
    var i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    var length = scale.ticks.length;
    var validIndex = Math.min(index, length - 1);
    var start = scale._startPixel;
    var end = scale._endPixel;
    var epsilon = 1e-6;
    var lineValue = scale.getPixelForTick(validIndex);
    var offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, _helpersSegmentJs.F)(caches, (cache)=>{
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    var font = (0, _helpersSegmentJs.a0)(options.font, fallback);
    var padding = (0, _helpersSegmentJs.E)(options.padding);
    var lines = (0, _helpersSegmentJs.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, _helpersSegmentJs.j)(parent, {
        scale,
        type: "scale"
    });
}
function createTickContext(parent, index, tick) {
    return (0, _helpersSegmentJs.j)(parent, {
        tick,
        index,
        type: "tick"
    });
}
function titleAlign(align, position, reverse) {
    var ret = (0, _helpersSegmentJs.a1)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    var top = scale.top, left = scale.left, bottom = scale.bottom, right = scale.right, chart = scale.chart;
    var chartArea = chart.chartArea, scales = chart.scales;
    var rotation = 0;
    var maxWidth, titleX, titleY;
    var height = bottom - top;
    var width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, _helpersSegmentJs.a2)(align, left, right);
        if ((0, _helpersSegmentJs.i)(position)) {
            var positionAxisID = Object.keys(position)[0];
            var value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, _helpersSegmentJs.i)(position)) {
            var positionAxisID1 = Object.keys(position)[0];
            var value1 = position[positionAxisID1];
            titleX = scales[positionAxisID1].getPixelForValue(value1) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, _helpersSegmentJs.a2)(align, bottom, top);
        rotation = position === "left" ? -(0, _helpersSegmentJs.H) : (0, _helpersSegmentJs.H);
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        var _this = this, _userMin = _this._userMin, _userMax = _this._userMax, _suggestedMin = _this._suggestedMin, _suggestedMax = _this._suggestedMax;
        _userMin = (0, _helpersSegmentJs.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, _helpersSegmentJs.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, _helpersSegmentJs.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, _helpersSegmentJs.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, _helpersSegmentJs.O)(_userMin, _suggestedMin),
            max: (0, _helpersSegmentJs.O)(_userMax, _suggestedMax),
            minDefined: (0, _helpersSegmentJs.g)(_userMin),
            maxDefined: (0, _helpersSegmentJs.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        var _this_getUserBounds = this.getUserBounds(), min = _this_getUserBounds.min, max = _this_getUserBounds.max, minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
        var range;
        if (minDefined && maxDefined) return {
            min,
            max
        };
        var metas = this.getMatchingVisibleMetas();
        for(var i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, _helpersSegmentJs.O)(min, (0, _helpersSegmentJs.O)(max, min)),
            max: (0, _helpersSegmentJs.O)(max, (0, _helpersSegmentJs.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        var data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems() {
        var chartArea = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.chart.chartArea;
        var items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, _helpersSegmentJs.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        var _this_options = this.options, beginAtZero = _this_options.beginAtZero, grace = _this_options.grace, tickOpts = _this_options.ticks;
        var sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, _helpersSegmentJs.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        var samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        var reversePixels = this.options.reverse;
        var startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, _helpersSegmentJs.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, _helpersSegmentJs.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, _helpersSegmentJs.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, _helpersSegmentJs.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, _helpersSegmentJs.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        var tickOpts = this.options.ticks;
        var i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, _helpersSegmentJs.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, _helpersSegmentJs.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, _helpersSegmentJs.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        var options = this.options;
        var tickOpts = options.ticks;
        var numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        var minRotation = tickOpts.minRotation || 0;
        var maxRotation = tickOpts.maxRotation;
        var labelRotation = minRotation;
        var tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        var labelSizes = this._getLabelSizes();
        var maxLabelWidth = labelSizes.widest.width;
        var maxLabelHeight = labelSizes.highest.height;
        var maxWidth = (0, _helpersSegmentJs.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, _helpersSegmentJs.U)(Math.min(Math.asin((0, _helpersSegmentJs.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, _helpersSegmentJs.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, _helpersSegmentJs.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, _helpersSegmentJs.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, _helpersSegmentJs.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        var minSize = {
            width: 0,
            height: 0
        };
        var _this = this, chart = _this.chart, _this_options = _this.options, tickOpts = _this_options.ticks, titleOpts = _this_options.title, gridOpts = _this_options.grid;
        var display = this._isVisible();
        var isHorizontal = this.isHorizontal();
        if (display) {
            var titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                var _this__getLabelSizes = this._getLabelSizes(), first = _this__getLabelSizes.first, last = _this__getLabelSizes.last, widest = _this__getLabelSizes.widest, highest = _this__getLabelSizes.highest;
                var tickPadding = tickOpts.padding * 2;
                var angleRadians = (0, _helpersSegmentJs.t)(this.labelRotation);
                var cos = Math.cos(angleRadians);
                var sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    var labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    var labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        var _this_options = this.options, _this_options_ticks = _this_options.ticks, align = _this_options_ticks.align, padding = _this_options_ticks.padding, position = _this_options.position;
        var isRotated = this.labelRotation !== 0;
        var labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            var offsetLeft = this.getPixelForTick(0) - this.left;
            var offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            var paddingLeft = 0;
            var paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            var paddingTop = last.height / 2;
            var paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, _helpersSegmentJs.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        var _this_options = this.options, axis = _this_options.axis, position = _this_options.position;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, _helpersSegmentJs.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        var labelSizes = this._labelSizes;
        if (!labelSizes) {
            var sampleSize = this.options.ticks.sampleSize;
            var ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        var _this = this, ctx = _this.ctx, caches = _this._longestTextCache;
        var widths = [];
        var heights = [];
        var increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, _helpersSegmentJs.k)(label) && !(0, _helpersSegmentJs.b)(label)) {
                width = (0, _helpersSegmentJs.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, _helpersSegmentJs.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, _helpersSegmentJs.k)(nestedLabel) && !(0, _helpersSegmentJs.b)(nestedLabel)) {
                    width = (0, _helpersSegmentJs.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        var widest = widths.indexOf(widestLabelSize);
        var highest = heights.indexOf(highestLabelSize);
        var valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        var ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        var pixel = this._startPixel + decimal * this._length;
        return (0, _helpersSegmentJs.W)(this._alignToPixels ? (0, _helpersSegmentJs.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        var decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        var _this = this, min = _this.min, max = _this.max;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        var ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            var tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        var optionTicks = this.options.ticks;
        var rot = (0, _helpersSegmentJs.t)(this.labelRotation);
        var cos = Math.abs(Math.cos(rot));
        var sin = Math.abs(Math.sin(rot));
        var labelSizes = this._getLabelSizes();
        var padding = optionTicks.autoSkipPadding || 0;
        var w = labelSizes ? labelSizes.widest.width + padding : 0;
        var h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        var display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        var axis = this.axis;
        var chart = this.chart;
        var options = this.options;
        var grid = options.grid, position = options.position, border = options.border;
        var offset = grid.offset;
        var isHorizontal = this.isHorizontal();
        var ticks = this.ticks;
        var ticksLength = ticks.length + (offset ? 1 : 0);
        var tl = getTickMarkLength(grid);
        var items = [];
        var borderOpts = border.setContext(this.getContext());
        var axisWidth = borderOpts.display ? borderOpts.width : 0;
        var axisHalfWidth = axisWidth / 2;
        var alignBorderValue = function alignBorderValue(pixel) {
            return (0, _helpersSegmentJs.X)(chart, pixel, axisWidth);
        };
        var borderValue, i, lineValue, alignedLineValue;
        var tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, _helpersSegmentJs.i)(position)) {
                var positionAxisID = Object.keys(position)[0];
                var value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, _helpersSegmentJs.i)(position)) {
                var positionAxisID1 = Object.keys(position)[0];
                var value1 = position[positionAxisID1];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID1].getPixelForValue(value1));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        var limit = (0, _helpersSegmentJs.v)(options.ticks.maxTicksLimit, ticksLength);
        var step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            var context = this.getContext(i);
            var optsAtIndex = grid.setContext(context);
            var optsAtIndexBorder = border.setContext(context);
            var lineWidth = optsAtIndex.lineWidth;
            var lineColor = optsAtIndex.color;
            var borderDash = optsAtIndexBorder.dash || [];
            var borderDashOffset = optsAtIndexBorder.dashOffset;
            var tickWidth = optsAtIndex.tickWidth;
            var tickColor = optsAtIndex.tickColor;
            var tickBorderDash = optsAtIndex.tickBorderDash || [];
            var tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, _helpersSegmentJs.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        var axis = this.axis;
        var options = this.options;
        var position = options.position, optionTicks = options.ticks;
        var isHorizontal = this.isHorizontal();
        var ticks = this.ticks;
        var align = optionTicks.align, crossAlign = optionTicks.crossAlign, padding = optionTicks.padding, mirror = optionTicks.mirror;
        var tl = getTickMarkLength(options.grid);
        var tickAndPadding = tl + padding;
        var hTickAndPadding = mirror ? -padding : tickAndPadding;
        var rotation = -(0, _helpersSegmentJs.t)(this.labelRotation);
        var items = [];
        var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        var textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            var ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            var ret1 = this._getYAxisLabelAlignment(tl);
            textAlign = ret1.textAlign;
            x = ret1.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, _helpersSegmentJs.i)(position)) {
                var positionAxisID = Object.keys(position)[0];
                var value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, _helpersSegmentJs.i)(position)) {
                var positionAxisID1 = Object.keys(position)[0];
                var value1 = position[positionAxisID1];
                x = this.chart.scales[positionAxisID1].getPixelForValue(value1);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        var labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            var optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, _helpersSegmentJs.b)(label) ? label.length : 1;
            var halfCount = lineCount / 2;
            var color = optsAtIndex.color;
            var strokeColor = optsAtIndex.textStrokeColor;
            var strokeWidth = optsAtIndex.textStrokeWidth;
            var tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            var backdrop = void 0;
            if (optsAtIndex.showLabelBackdrop) {
                var labelPadding = (0, _helpersSegmentJs.E)(optsAtIndex.backdropPadding);
                var height = labelSizes.heights[i];
                var width = labelSizes.widths[i];
                var top = textOffset - labelPadding.top;
                var left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                    case "inner":
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        var _this_options = this.options, position = _this_options.position, ticks = _this_options.ticks;
        var rotation = -(0, _helpersSegmentJs.t)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        var align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        var _this_options = this.options, position = _this_options.position, _this_options_ticks = _this_options.ticks, crossAlign = _this_options_ticks.crossAlign, mirror = _this_options_ticks.mirror, padding = _this_options_ticks.padding;
        var labelSizes = this._getLabelSizes();
        var tickAndPadding = tl + padding;
        var widest = labelSizes.widest.width;
        var textAlign;
        var x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign,
            x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        var chart = this.chart;
        var position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        var _this = this, ctx = _this.ctx, backgroundColor = _this.options.backgroundColor, left = _this.left, top = _this.top, width = _this.width, height = _this.height;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        var grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        var ticks = this.ticks;
        var index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            var opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        var grid = this.options.grid;
        var ctx = this.ctx;
        var items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        var i, ilen;
        var drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            var item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        var _this = this, chart = _this.chart, ctx = _this.ctx, _this_options = _this.options, border = _this_options.border, grid = _this_options.grid;
        var borderOpts = border.setContext(this.getContext());
        var axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        var lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        var borderValue = this._borderValue;
        var x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, _helpersSegmentJs.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, _helpersSegmentJs.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, _helpersSegmentJs.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, _helpersSegmentJs.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        var optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        var ctx = this.ctx;
        var area = this._computeLabelArea();
        if (area) (0, _helpersSegmentJs.Y)(ctx, area);
        var items = this.getLabelItems(chartArea);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var renderTextOptions = item.options;
                var tickFont = item.font;
                var label = item.label;
                var y = item.textOffset;
                (0, _helpersSegmentJs.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (area) (0, _helpersSegmentJs.$)(ctx);
    }
    drawTitle() {
        var _this = this, ctx = _this.ctx, _this_options = _this.options, position = _this_options.position, title = _this_options.title, reverse = _this_options.reverse;
        if (!title.display) return;
        var font = (0, _helpersSegmentJs.a0)(title.font);
        var padding = (0, _helpersSegmentJs.E)(title.padding);
        var align = title.align;
        var offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, _helpersSegmentJs.i)(position)) {
            offset += padding.bottom;
            if ((0, _helpersSegmentJs.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        var _titleArgs = titleArgs(this, offset, position, align), titleX = _titleArgs.titleX, titleY = _titleArgs.titleY, maxWidth = _titleArgs.maxWidth, rotation = _titleArgs.rotation;
        (0, _helpersSegmentJs.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        var opts = this.options;
        var tz = opts.ticks && opts.ticks.z || 0;
        var gz = (0, _helpersSegmentJs.v)(opts.grid && opts.grid.z, -1);
        var bz = (0, _helpersSegmentJs.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        var metas = this.chart.getSortedVisibleDatasetMetas();
        var axisID = this.axis + "AxisID";
        var result = [];
        var i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            var meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        var opts = this.options.ticks.setContext(this.getContext(index));
        return (0, _helpersSegmentJs.a0)(opts.font);
    }
    _maxDigits() {
        var fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
}
class TypedRegistry {
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        var proto = Object.getPrototypeOf(item);
        var parentScope;
        if (isIChartComponent(proto)) parentScope = this.register(proto);
        var items = this.items;
        var id = item.id;
        var scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) (0, _helpersSegmentJs.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        var items = this.items;
        var id = item.id;
        var scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, _helpersSegmentJs.d)[scope]) {
            delete (0, _helpersSegmentJs.d)[scope][id];
            if (this.override) delete (0, _helpersSegmentJs.a3)[id];
        }
    }
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
}
function registerDefaults(item, scope, parentScope) {
    var itemDefaults = (0, _helpersSegmentJs.a4)(Object.create(null), [
        parentScope ? (0, _helpersSegmentJs.d).get(parentScope) : {},
        (0, _helpersSegmentJs.d).get(scope),
        item.defaults
    ]);
    (0, _helpersSegmentJs.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, _helpersSegmentJs.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        var propertyParts = property.split(".");
        var sourceName = propertyParts.pop();
        var sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        var parts = routes[property].split(".");
        var targetName = parts.pop();
        var targetScope = parts.join(".");
        (0, _helpersSegmentJs.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class Registry {
    add() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("register", args);
    }
    remove() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("unregister", args);
    }
    addControllers() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("register", args, this.controllers);
    }
    addElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("register", args, this.elements);
    }
    addPlugins() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("register", args, this.plugins);
    }
    addScales() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("unregister", args, this.controllers);
    }
    removeElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("unregister", args, this.elements);
    }
    removePlugins() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("unregister", args, this.plugins);
    }
    removeScales() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            var reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, _helpersSegmentJs.F)(arg, (item)=>{
                var itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        var camelMethod = (0, _helpersSegmentJs.a5)(method);
        (0, _helpersSegmentJs.Q)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, _helpersSegmentJs.Q)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(var i = 0; i < this._typedRegistries.length; i++){
            var reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        var item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, "datasets", true);
        this.elements = new TypedRegistry(Element, "elements");
        this.plugins = new TypedRegistry(Object, "plugins");
        this.scales = new TypedRegistry(Scale, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
}
var registry = /* #__PURE__ */ new Registry();
class PluginService {
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        var descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        var result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = descriptors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var descriptor = _step.value;
                var plugin = descriptor.plugin;
                var method = plugin[hook];
                var params = [
                    chart,
                    args,
                    descriptor.options
                ];
                if ((0, _helpersSegmentJs.Q)(method, params, plugin) === false && args.cancelable) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    }
    invalidate() {
        if (!(0, _helpersSegmentJs.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        var descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        var config = chart && chart.config;
        var options = (0, _helpersSegmentJs.v)(config.options && config.options.plugins, {});
        var plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        var previousDescriptors = this._oldCache || [];
        var descriptors = this._cache;
        var diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
    constructor(){
        this._init = [];
    }
}
function allPlugins(config) {
    var localIds = {};
    var plugins = [];
    var keys = Object.keys(registry.plugins.items);
    for(var i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    var local = config.plugins || [];
    for(var i1 = 0; i1 < local.length; i1++){
        var plugin = local[i1];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, param, options, all) {
    var plugins = param.plugins, localIds = param.localIds;
    var result = [];
    var context = chart.getContext();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            var id = plugin.id;
            var opts = getOpts(options[id], all);
            if (opts === null) continue;
            result.push({
                plugin,
                options: pluginOpts(chart.config, {
                    plugin,
                    local: localIds[id]
                }, opts, context)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function pluginOpts(config, param, opts, context) {
    var plugin = param.plugin, local = param.local;
    var keys = config.pluginScopeKeys(plugin);
    var scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    var datasetDefaults = (0, _helpersSegmentJs.d).datasets[type] || {};
    var datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    var axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function determineAxis(id) {
    for(var _len = arguments.length, scaleOptions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        scaleOptions[_key - 1] = arguments[_key];
    }
    if (idMatchesAxis(id)) return id;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scaleOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var opts = _step.value;
            var axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
            if (axis) return axis;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        var boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return getAxisFromDataset(id, "x", boundDs[0]) || getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    var chartDefaults = (0, _helpersSegmentJs.a3)[config.type] || {
        scales: {}
    };
    var configScales = options.scales || {};
    var chartIndexAxis = getIndexAxis(config.type, options);
    var scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        var scaleConf = configScales[id];
        if (!(0, _helpersSegmentJs.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        var axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, _helpersSegmentJs.d).scales[scaleConf.type]);
        var defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        var defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, _helpersSegmentJs.ab)(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        var type = dataset.type || config.type;
        var indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        var datasetDefaults = (0, _helpersSegmentJs.a3)[type] || {};
        var defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            var axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            var id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, _helpersSegmentJs.ab)(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        var scale = scales[key];
        (0, _helpersSegmentJs.ab)(scale, [
            (0, _helpersSegmentJs.d).scales[scale.type],
            (0, _helpersSegmentJs.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    var options = config.options || (config.options = {});
    options.plugins = (0, _helpersSegmentJs.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
var keyCache = new Map();
var keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    var keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
var addIfFound = (set, obj, key)=>{
    var opts = (0, _helpersSegmentJs.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class Config {
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        var config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        var id = plugin.id;
        var type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        var _scopeCache = this._scopeCache;
        var cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        var _this = this, options = _this.options, type = _this.type;
        var cache = this._cachedScopes(mainScope, resetCache);
        var cached = cache.get(keyLists);
        if (cached) return cached;
        var scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.a3)[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.d), key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.a6), key));
        });
        var array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if (keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        var _this = this, options = _this.options, type = _this.type;
        return [
            options,
            (0, _helpersSegmentJs.a3)[type] || {},
            (0, _helpersSegmentJs.d).datasets[type] || {},
            {
                type
            },
            (0, _helpersSegmentJs.d),
            (0, _helpersSegmentJs.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context) {
        var prefixes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
            ""
        ];
        var result = {
            $shared: true
        };
        var _getResolver = getResolver(this._resolverCache, scopes, prefixes), resolver = _getResolver.resolver, subPrefixes = _getResolver.subPrefixes;
        var options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = (0, _helpersSegmentJs.a7)(context) ? context() : context;
            var subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, _helpersSegmentJs.a8)(resolver, context, subResolver);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var prop = _step.value;
                result[prop] = options[prop];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }
    createResolver(scopes, context) {
        var prefixes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
            ""
        ], descriptorDefaults = arguments.length > 3 ? arguments[3] : void 0;
        var resolver = getResolver(this._resolverCache, scopes, prefixes).resolver;
        return (0, _helpersSegmentJs.i)(context) ? (0, _helpersSegmentJs.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    var cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    var cacheKey = prefixes.join();
    var cached = cache.get(cacheKey);
    if (!cached) {
        var resolver = (0, _helpersSegmentJs.a9)(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
var hasFunction = (value)=>(0, _helpersSegmentJs.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, _helpersSegmentJs.a7)(value[key]));
function needContext(proxy, names) {
    var _$_descriptors = (0, _helpersSegmentJs.aa)(proxy), isScriptable = _$_descriptors.isScriptable, isIndexable = _$_descriptors.isIndexable;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            var scriptable = isScriptable(prop);
            var indexable = isIndexable(prop);
            var value = (indexable || scriptable) && proxy[prop];
            if (scriptable && ((0, _helpersSegmentJs.a7)(value) || hasFunction(value)) || indexable && (0, _helpersSegmentJs.b)(value)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var version = "4.4.2";
var KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    var chart = context.chart;
    var animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, _helpersSegmentJs.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    var chart = context.chart;
    var animationOptions = chart.options.animation;
    (0, _helpersSegmentJs.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, _helpersSegmentJs.M)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
var instances = {};
var getChart = (key)=>{
    var canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    var keys = Object.keys(obj);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var intKey = +key;
            if (intKey >= start) {
                var value = obj[key];
                delete obj[key];
                if (move > 0 || intKey > start) obj[intKey + move] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    var xScale = meta.xScale, yScale = meta.yScale;
    if (xScale && yScale) return {
        left: getSizeForArea(xScale, chartArea, "left"),
        right: getSizeForArea(xScale, chartArea, "right"),
        top: getSizeForArea(yScale, chartArea, "top"),
        bottom: getSizeForArea(yScale, chartArea, "bottom")
    };
    return chartArea;
}
class Chart {
    static register() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        registry.remove(...items);
        invalidatePlugins();
    }
    get aspectRatio() {
        var _this = this, _this_options = _this.options, aspectRatio = _this_options.aspectRatio, maintainAspectRatio = _this_options.maintainAspectRatio, width = _this.width, height = _this.height, _aspectRatio = _this._aspectRatio;
        if (!(0, _helpersSegmentJs.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, _helpersSegmentJs.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, _helpersSegmentJs.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width,
            height
        };
    }
    _resize(width, height) {
        var options = this.options;
        var canvas = this.canvas;
        var aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        var newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        var newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        var mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, _helpersSegmentJs.ae)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, _helpersSegmentJs.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        var options = this.options;
        var scalesOptions = options.scales || {};
        (0, _helpersSegmentJs.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        var options = this.options;
        var scaleOpts = options.scales;
        var scales = this.scales;
        var updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        var items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            var scaleOptions = scaleOpts[id];
            var axis = determineAxis(id, scaleOptions);
            var isRadial = axis === "r";
            var isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, _helpersSegmentJs.F)(items, (item)=>{
            var scaleOptions = item.options;
            var id = scaleOptions.id;
            var axis = determineAxis(id, scaleOptions);
            var scaleType = (0, _helpersSegmentJs.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            var scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                var scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, _helpersSegmentJs.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, _helpersSegmentJs.F)(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        var metasets = this._metasets;
        var numData = this.data.datasets.length;
        var numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(var i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        var _this = this, metasets = _this._metasets, datasets = _this.data.datasets;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        var newControllers = [];
        var datasets = this.data.datasets;
        var i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            var dataset = datasets[i];
            var meta = this.getDatasetMeta(i);
            var type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                var ControllerClass = registry.getController(type);
                var _defaults_datasets_type = (0, _helpersSegmentJs.d).datasets[type], datasetElementType = _defaults_datasets_type.datasetElementType, dataElementType = _defaults_datasets_type.dataElementType;
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, _helpersSegmentJs.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        var config = this.config;
        config.update();
        var options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        var animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode,
            cancelable: true
        }) === false) return;
        var newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        var minPadding = 0;
        for(var i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            var controller = this.getDatasetMeta(i).controller;
            var reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, _helpersSegmentJs.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode
        });
        this._layers.sort(compare2Level("z", "_idx"));
        var _this = this, _active = _this._active, _lastEvent = _this._lastEvent;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, _helpersSegmentJs.F)(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        var options = this.options;
        var existingEvents = new Set(Object.keys(this._listeners));
        var newEvents = new Set(options.events);
        if (!(0, _helpersSegmentJs.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        var _hiddenIndices = this._hiddenIndices;
        var changes = this._getUniformDataChanges() || [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _step.value, method = _step_value.method, start = _step_value.start, count = _step_value.count;
                var move = method === "_removeElements" ? -count : count;
                moveNumericKeys(_hiddenIndices, start, move);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    _getUniformDataChanges() {
        var _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        var datasetCount = this.data.datasets.length;
        var makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        var changeSet = makeSet(0);
        for(var i = 1; i < datasetCount; i++){
            if (!(0, _helpersSegmentJs.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        layouts.update(this, this.width, this.height, minPadding);
        var area = this.chartArea;
        var noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, _helpersSegmentJs.F)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode,
            cancelable: true
        }) === false) return;
        for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(var i1 = 0, ilen1 = this.data.datasets.length; i1 < ilen1; ++i1)this._updateDataset(i1, (0, _helpersSegmentJs.a7)(mode) ? mode({
            datasetIndex: i1
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode
        });
    }
    _updateDataset(index, mode) {
        var meta = this.getDatasetMeta(index);
        var args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) animator.start(this);
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        var i;
        if (this._resizeBeforeDraw) {
            var _this__resizeBeforeDraw = this._resizeBeforeDraw, width = _this__resizeBeforeDraw.width, height = _this__resizeBeforeDraw.height;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        var layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        var metasets = this._sortedMetasets;
        var result = [];
        var i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            var meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        var metasets = this.getSortedVisibleDatasetMetas();
        for(var i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        var ctx = this.ctx;
        var clip = meta._clip;
        var useClip = !clip.disabled;
        var area = getDatasetArea(meta, this.chartArea);
        var args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, _helpersSegmentJs.Y)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, _helpersSegmentJs.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, _helpersSegmentJs.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        var method = Interaction.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        var dataset = this.data.datasets[datasetIndex];
        var metasets = this._metasets;
        var meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, _helpersSegmentJs.j)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        var dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        var meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        var meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        var mode = visible ? "show" : "hide";
        var meta = this.getDatasetMeta(datasetIndex);
        var anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, _helpersSegmentJs.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        var meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        var i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        var _this = this, canvas = _this.canvas, ctx = _this.ctx;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, _helpersSegmentJs.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        var listeners = this._listeners;
        var platform = this.platform;
        var _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        var listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, _helpersSegmentJs.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        var listeners = this._responsiveListeners;
        var platform = this.platform;
        var _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        var _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        var listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        var detached;
        var attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, _helpersSegmentJs.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, _helpersSegmentJs.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        var prefix = enabled ? "set" : "remove";
        var meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            var controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        var lastActive = this._active || [];
        var active = activeElements.map((param)=>{
            var datasetIndex = param.datasetIndex, index = param.index;
            var meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        var changed = !(0, _helpersSegmentJs.ah)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        var hoverOptions = this.options.hover;
        var diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        var deactivated = diff(lastActive, active);
        var activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        var args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        var eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        var changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        var _this = this, tmp = _this._active, lastActive = tmp === void 0 ? [] : tmp, options = _this.options;
        var useFinalPosition = replay;
        var active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        var isClick = (0, _helpersSegmentJs.ai)(e);
        var lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, _helpersSegmentJs.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, _helpersSegmentJs.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        var changed = !(0, _helpersSegmentJs.ah)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        var hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
    constructor(item, userConfig){
        var config = this.config = new Config(userConfig);
        var initialCanvas = getCanvas(item);
        var existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        var options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        var context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        this.id = (0, _helpersSegmentJs.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, _helpersSegmentJs.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, "complete", onAnimationsComplete);
        animator.listen(this, "progress", onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
}
(0, _defineProperty._)(Chart, "defaults", (0, _helpersSegmentJs.d));
(0, _defineProperty._)(Chart, "instances", instances);
(0, _defineProperty._)(Chart, "overrides", (0, _helpersSegmentJs.a3));
(0, _defineProperty._)(Chart, "registry", registry);
(0, _defineProperty._)(Chart, "version", version);
(0, _defineProperty._)(Chart, "getChart", getChart);
function invalidatePlugins() {
    return (0, _helpersSegmentJs.F)(Chart.instances, (chart)=>chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
    var startAngle = element.startAngle, pixelMargin = element.pixelMargin, x = element.x, y = element.y, outerRadius = element.outerRadius, innerRadius = element.innerRadius;
    var angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, _helpersSegmentJs.H), startAngle - (0, _helpersSegmentJs.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, _helpersSegmentJs.ak)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    var o = toRadiusCorners(arc.options.borderRadius);
    var halfThickness = (outerRadius - innerRadius) / 2;
    var innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    var computeOuterLimit = (val)=>{
        var outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, _helpersSegmentJs.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, _helpersSegmentJs.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, _helpersSegmentJs.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    var x = element.x, y = element.y, start = element.startAngle, pixelMargin = element.pixelMargin, innerR = element.innerRadius;
    var outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    var innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    var spacingOffset = 0;
    var alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        var noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        var noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        var avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        var adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    var beta = Math.max(0.001, alpha * outerRadius - offset / (0, _helpersSegmentJs.P)) / outerRadius;
    var angleOffset = (alpha - beta) / 2;
    var startAngle = start + angleOffset + spacingOffset;
    var endAngle = end - angleOffset - spacingOffset;
    var _parseBorderRadius$1 = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle), outerStart = _parseBorderRadius$1.outerStart, outerEnd = _parseBorderRadius$1.outerEnd, innerStart = _parseBorderRadius$1.innerStart, innerEnd = _parseBorderRadius$1.innerEnd;
    var outerStartAdjustedRadius = outerRadius - outerStart;
    var outerEndAdjustedRadius = outerRadius - outerEnd;
    var outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    var outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    var innerStartAdjustedRadius = innerRadius + innerStart;
    var innerEndAdjustedRadius = innerRadius + innerEnd;
    var innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    var innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        var outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            var pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, _helpersSegmentJs.H));
        }
        // The line from point 3 to point 4
        var p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            var pCenter1 = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter1.x, pCenter1.y, innerEnd, endAngle + (0, _helpersSegmentJs.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        var innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            var pCenter2 = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter2.x, pCenter2.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, _helpersSegmentJs.H));
        }
        // The line from point 7 to point 8
        var p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            var pCenter3 = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter3.x, pCenter3.y, outerStart, startAngle - (0, _helpersSegmentJs.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        var outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        var outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        var outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        var outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    var fullCircles = element.fullCircles, startAngle = element.startAngle, circumference = element.circumference;
    var endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(var i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    var fullCircles = element.fullCircles, startAngle = element.startAngle, circumference = element.circumference, options = element.options;
    var borderWidth = options.borderWidth, borderJoinStyle = options.borderJoinStyle, borderDash = options.borderDash, borderDashOffset = options.borderDashOffset;
    var inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    var endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(var i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    inRange(chartX, chartY, useFinalPosition) {
        var point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        var _getAngleFromPoint = (0, _helpersSegmentJs.D)(point, {
            x: chartX,
            y: chartY
        }), angle = _getAngleFromPoint.angle, distance = _getAngleFromPoint.distance;
        var _this_getProps = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition), startAngle = _this_getProps.startAngle, endAngle = _this_getProps.endAngle, innerRadius = _this_getProps.innerRadius, outerRadius = _this_getProps.outerRadius, circumference = _this_getProps.circumference;
        var rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        var _circumference = (0, _helpersSegmentJs.v)(circumference, endAngle - startAngle);
        var betweenAngles = _circumference >= (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.p)(angle, startAngle, endAngle);
        var withinRadius = (0, _helpersSegmentJs.aj)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        var _this_getProps = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y, startAngle = _this_getProps.startAngle, endAngle = _this_getProps.endAngle, innerRadius = _this_getProps.innerRadius, outerRadius = _this_getProps.outerRadius;
        var _this_options = this.options, offset = _this_options.offset, spacing = _this_options.spacing;
        var halfAngle = (startAngle + endAngle) / 2;
        var halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        var _this = this, options = _this.options, circumference = _this.circumference;
        var offset = (options.offset || 0) / 4;
        var spacing = (options.spacing || 0) / 2;
        var circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, _helpersSegmentJs.T) ? Math.floor(circumference / (0, _helpersSegmentJs.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        var halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        var fix = 1 - Math.sin(Math.min((0, _helpersSegmentJs.P), circumference || 0));
        var radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
    constructor(cfg){
        super();
        (0, _defineProperty._)(this, "circumference", void 0);
        (0, _defineProperty._)(this, "endAngle", void 0);
        (0, _defineProperty._)(this, "fullCircles", void 0);
        (0, _defineProperty._)(this, "innerRadius", void 0);
        (0, _defineProperty._)(this, "outerRadius", void 0);
        (0, _defineProperty._)(this, "pixelMargin", void 0);
        (0, _defineProperty._)(this, "startAngle", void 0);
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, _defineProperty._)(ArcElement, "id", "arc");
(0, _defineProperty._)(ArcElement, "defaults", {
    borderAlign: "center",
    borderColor: "#fff",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
});
(0, _defineProperty._)(ArcElement, "defaultRoutes", {
    backgroundColor: "backgroundColor"
});
(0, _defineProperty._)(ArcElement, "descriptors", {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash"
});
function setStyle(ctx, options) {
    var style = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : options;
    ctx.lineCap = (0, _helpersSegmentJs.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, _helpersSegmentJs.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, _helpersSegmentJs.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, _helpersSegmentJs.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, _helpersSegmentJs.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, _helpersSegmentJs.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, _helpersSegmentJs.ar;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, _helpersSegmentJs.as;
    return lineTo;
}
function pathVars(points, segment) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var count = points.length;
    var tmp = params.start, paramsStart = tmp === void 0 ? 0 : tmp, tmp1 = params.end, paramsEnd = tmp1 === void 0 ? count - 1 : tmp1;
    var segmentStart = segment.start, segmentEnd = segment.end;
    var start = Math.max(paramsStart, segmentStart);
    var end = Math.min(paramsEnd, segmentEnd);
    var outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    var points = line.points, options = line.options;
    var _pathVars = pathVars(points, segment, params), count = _pathVars.count, start = _pathVars.start, loop = _pathVars.loop, ilen = _pathVars.ilen;
    var lineMethod = getLineMethod(options);
    var _ref = params || {}, _ref_move = _ref.move, move = _ref_move === void 0 ? true : _ref_move, reverse = _ref.reverse;
    var i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    var points = line.points;
    var _pathVars = pathVars(points, segment, params), count = _pathVars.count, start = _pathVars.start, ilen = _pathVars.ilen;
    var _ref = params || {}, _ref_move = _ref.move, move = _ref_move === void 0 ? true : _ref_move, reverse = _ref.reverse;
    var avgX = 0;
    var countX = 0;
    var i, point, prevX, minY, maxY, lastY;
    var pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    var drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        var x = point.x;
        var y = point.y;
        var truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    var opts = line.options;
    var borderDash = opts.borderDash && opts.borderDash.length;
    var useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, _helpersSegmentJs.ao;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, _helpersSegmentJs.ap;
    return 0, _helpersSegmentJs.aq;
}
function strokePathWithCache(ctx, line, start, count) {
    var path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    var segments = line.segments, options = line.options;
    var segmentMethod = _getSegmentMethod(line);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            setStyle(ctx, options, segment.style);
            ctx.beginPath();
            if (segmentMethod(ctx, line, segment, {
                start,
                end: start + count - 1
            })) ctx.closePath();
            ctx.stroke();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var usePath2D = typeof Path2D === "function";
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
class LineElement extends Element {
    updateControlPoints(chartArea, indexAxis) {
        var options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            var loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, _helpersSegmentJs.al)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, _helpersSegmentJs.am)(this, this.options.segment));
    }
    first() {
        var segments = this.segments;
        var points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        var segments = this.segments;
        var points = this.points;
        var count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        var options = this.options;
        var value = point[property];
        var points = this.points;
        var segments = (0, _helpersSegmentJs.an)(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        var result = [];
        var _interpolate = _getInterpolationMethod(options);
        var i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            var _segments_i = segments[i], start = _segments_i.start, end = _segments_i.end;
            var p1 = points[start];
            var p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            var t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            var interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        var segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        var segments = this.segments;
        var segmentMethod = _getSegmentMethod(this);
        var loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var segment = _step.value;
                loop &= segmentMethod(ctx, this, segment, {
                    start,
                    end: start + count - 1
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        var options = this.options || {};
        var points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, _defineProperty._)(LineElement, "id", "line");
(0, _defineProperty._)(LineElement, "defaults", {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
});
(0, _defineProperty._)(LineElement, "defaultRoutes", {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
});
(0, _defineProperty._)(LineElement, "descriptors", {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
});
function inRange$1(el, pos, axis, useFinalPosition) {
    var options = el.options;
    var _el_getProps = el.getProps([
        axis
    ], useFinalPosition), value = _el_getProps[axis];
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    inRange(mouseX, mouseY, useFinalPosition) {
        var options = this.options;
        var _this_getProps = this.getProps([
            "x",
            "y"
        ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        var _this_getProps = this.getProps([
            "x",
            "y"
        ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        var radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        var borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        var options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, _helpersSegmentJs.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, _helpersSegmentJs.at)(ctx, options, this.x, this.y);
    }
    getRange() {
        var options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
    constructor(cfg){
        super();
        (0, _defineProperty._)(this, "parsed", void 0);
        (0, _defineProperty._)(this, "skip", void 0);
        (0, _defineProperty._)(this, "stop", void 0);
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, _defineProperty._)(PointElement, "id", "point");
/**
   * @type {any}
   */ (0, _defineProperty._)(PointElement, "defaults", {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
});
/**
   * @type {any}
   */ (0, _defineProperty._)(PointElement, "defaultRoutes", {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
});
function getBarBounds(bar, useFinalPosition) {
    var _bar_getProps = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition), x = _bar_getProps.x, y = _bar_getProps.y, base = _bar_getProps.base, width = _bar_getProps.width, height = _bar_getProps.height;
    var left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, _helpersSegmentJs.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    var value = bar.options.borderWidth;
    var skip = bar.borderSkipped;
    var o = (0, _helpersSegmentJs.av)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    var enableBorderRadius = bar.getProps([
        "enableBorderRadius"
    ]).enableBorderRadius;
    var value = bar.options.borderRadius;
    var o = (0, _helpersSegmentJs.aw)(value);
    var maxR = Math.min(maxW, maxH);
    var skip = bar.borderSkipped;
    var enableBorder = enableBorderRadius || (0, _helpersSegmentJs.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    var bounds = getBarBounds(bar);
    var width = bounds.right - bounds.left;
    var height = bounds.bottom - bounds.top;
    var border = parseBorderWidth(bar, width / 2, height / 2);
    var radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    var skipX = x === null;
    var skipY = y === null;
    var skipBoth = skipX && skipY;
    var bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, _helpersSegmentJs.aj)(x, bounds.left, bounds.right)) && (skipY || (0, _helpersSegmentJs.aj)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount) {
    var refRect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var x = rect.x !== refRect.x ? -amount : 0;
    var y = rect.y !== refRect.y ? -amount : 0;
    var w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    var h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    draw(ctx) {
        var _this = this, inflateAmount = _this.inflateAmount, _this_options = _this.options, borderColor = _this_options.borderColor, backgroundColor = _this_options.backgroundColor;
        var _boundingRects = boundingRects(this), inner = _boundingRects.inner, outer = _boundingRects.outer;
        var addRectPath = hasRadius(outer.radius) ? (0, _helpersSegmentJs.au) : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        var _this_getProps = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y, base = _this_getProps.base, horizontal = _this_getProps.horizontal;
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, _defineProperty._)(BarElement, "id", "bar");
(0, _defineProperty._)(BarElement, "defaults", {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
});
(0, _defineProperty._)(BarElement, "defaultRoutes", {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
});
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
var BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
var BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    var i = 0;
    return (dataset, datasetIndex)=>{
        var controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    var k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var plugin_colors = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        var _chart_config = chart.config, datasets = _chart_config.data.datasets, chartOptions = _chart_config.options;
        var elements = chartOptions.elements;
        if (!options.forceOverride && (containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements))) return;
        var colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    var samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    var decimated = [];
    var bucketWidth = (count - 2) / (samples - 2);
    var sampledIndex = 0;
    var endIndex = start + count - 1;
    var a = start;
    var i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        var avgX = 0;
        var avgY = 0;
        var j = void 0;
        var avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        var avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        var avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        var rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        var rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        var _data_a = data[a], pointAx = _data_a.x, pointAy = _data_a.y;
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    var avgX = 0;
    var countX = 0;
    var i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    var decimated = [];
    var endIndex = start + count - 1;
    var xMin = data[start].x;
    var xMax = data[endIndex].x;
    var dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        var truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            var lastIndex = i - 1;
            if (!(0, _helpersSegmentJs.k)(minIndex) && !(0, _helpersSegmentJs.k)(maxIndex)) {
                var intermediateIndex1 = Math.min(minIndex, maxIndex);
                var intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, data[intermediateIndex1]), {
                    x: avgX
                }));
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, data[intermediateIndex2]), {
                    x: avgX
                }));
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        var data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    var pointCount = points.length;
    var start = 0;
    var count;
    var iScale = meta.iScale;
    var _iScale_getUserBounds = iScale.getUserBounds(), min = _iScale_getUserBounds.min, max = _iScale_getUserBounds.max, minDefined = _iScale_getUserBounds.minDefined, maxDefined = _iScale_getUserBounds.maxDefined;
    if (minDefined) start = (0, _helpersSegmentJs.S)((0, _helpersSegmentJs.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, _helpersSegmentJs.S)((0, _helpersSegmentJs.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        var availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            var _data = dataset._data, indexAxis = dataset.indexAxis;
            var meta = chart.getDatasetMeta(datasetIndex);
            var data = _data || dataset.data;
            if ((0, _helpersSegmentJs.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            var xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            var _getStartAndCountOfVisiblePointsSimplified = getStartAndCountOfVisiblePointsSimplified(meta, data), start = _getStartAndCountOfVisiblePointsSimplified.start, count = _getStartAndCountOfVisiblePointsSimplified.count;
            var threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, _helpersSegmentJs.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function get() {
                        return this._decimated;
                    },
                    set: function set(d) {
                        this._data = d;
                    }
                });
            }
            var decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    var segments = line.segments;
    var points = line.points;
    var tpoints = target.points;
    var parts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            end = _findSegmentEnd(start, end, points);
            var bounds = _getBounds(property, points[start], points[end], segment.loop);
            if (!target.segments) {
                parts.push({
                    source: segment,
                    target: bounds,
                    start: points[start],
                    end: points[end]
                });
                continue;
            }
            var targetSegments = (0, _helpersSegmentJs.an)(target, bounds);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = targetSegments[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var tgt = _step1.value;
                    var subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
                    var fillSources = (0, _helpersSegmentJs.ax)(segment, points, subBounds);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = fillSources[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var fillSource = _step2.value;
                            parts.push({
                                source: fillSource,
                                target: tgt,
                                start: {
                                    [property]: _getEdge(bounds, subBounds, "start", Math.max)
                                },
                                end: {
                                    [property]: _getEdge(bounds, subBounds, "end", Math.min)
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    var start = first[property];
    var end = last[property];
    if (property === "angle") {
        start = (0, _helpersSegmentJs.ay)(start);
        end = (0, _helpersSegmentJs.ay)(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    var _ref = boundary || {}, _ref_x = _ref.x, x = _ref_x === void 0 ? null : _ref_x, _ref_y = _ref.y, y = _ref_y === void 0 ? null : _ref_y;
    var linePoints = line.points;
    var points = [];
    line.segments.forEach((param)=>{
        var start = param.start, end = param.end;
        end = _findSegmentEnd(start, end, linePoints);
        var first = linePoints[start];
        var last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        var point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    var points = [];
    var _loop = false;
    if ((0, _helpersSegmentJs.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    var source = sources[index];
    var fill = source.fill;
    var visited = [
        index
    ];
    var target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, _helpersSegmentJs.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    var fill = parseFillOption(line);
    if ((0, _helpersSegmentJs.i)(fill)) return isNaN(fill.value) ? false : fill;
    var target = parseFloat(fill);
    if ((0, _helpersSegmentJs.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    var pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, _helpersSegmentJs.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    var value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, _helpersSegmentJs.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    var options = line.options;
    var fillOption = options.fill;
    var fill = (0, _helpersSegmentJs.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function _buildStackLine(source) {
    var scale = source.scale, index = source.index, line = source.line;
    var points = [];
    var segments = line.segments;
    var sourcePoints = line.points;
    var linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        for(var j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    var below = [];
    var metas = scale.getMatchingVisibleMetas("line");
    for(var i = 0; i < metas.length; i++){
        var meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    var postponed = [];
    for(var j = 0; j < linesBelow.length; j++){
        var line = linesBelow[j];
        var _findPoint = findPoint(line, sourcePoint, "x"), first = _findPoint.first, last = _findPoint.last, point = _findPoint.point;
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
    var point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    var pointValue = point[property];
    var segments = line.segments;
    var linePoints = line.points;
    var first = false;
    var last = false;
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        var firstValue = linePoints[segment.start][property];
        var lastValue = linePoints[segment.end][property];
        if ((0, _helpersSegmentJs.aj)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}
class simpleArc {
    pathSegment(ctx, bounds, opts) {
        var _this = this, x = _this.x, y = _this.y, radius = _this.radius;
        bounds = bounds || {
            start: 0,
            end: (0, _helpersSegmentJs.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        var _this = this, x = _this.x, y = _this.y, radius = _this.radius;
        var angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
}
function _getTarget(source) {
    var chart = source.chart, fill = source.fill, line = source.line;
    if ((0, _helpersSegmentJs.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === "stack") return _buildStackLine(source);
    if (fill === "shape") return true;
    var boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    var meta = chart.getDatasetMeta(index);
    var visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    var scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    var _source_scale = source.scale, scale = _source_scale === void 0 ? {} : _source_scale, fill = source.fill;
    var pixel = _getTargetPixel(fill, scale);
    if ((0, _helpersSegmentJs.g)(pixel)) {
        var horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    var scale = source.scale, fill = source.fill;
    var options = scale.options;
    var length = scale.getLabels().length;
    var start = options.reverse ? scale.max : scale.min;
    var value = _getTargetValue(fill, scale, start);
    var target = [];
    if (options.grid.circular) {
        var center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(var i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    var target = _getTarget(source);
    var line = source.line, scale = source.scale, axis = source.axis;
    var lineOpts = line.options;
    var fillOption = lineOpts.fill;
    var color = lineOpts.backgroundColor;
    var _ref = fillOption || {}, _ref_above = _ref.above, above = _ref_above === void 0 ? color : _ref_above, _ref_below = _ref.below, below = _ref_below === void 0 ? color : _ref_below;
    if (target && line.points.length) {
        (0, _helpersSegmentJs.Y)(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis
        });
        (0, _helpersSegmentJs.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    var line = cfg.line, target = cfg.target, above = cfg.above, below = cfg.below, area = cfg.area, scale = cfg.scale;
    var property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        clipVertical(ctx, target, area.top);
        fill(ctx, {
            line,
            target,
            color: above,
            scale,
            property
        });
        ctx.restore();
        ctx.save();
        clipVertical(ctx, target, area.bottom);
    }
    fill(ctx, {
        line,
        target,
        color: below,
        scale,
        property
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    var segments = target.segments, points = target.points;
    var first = true;
    var lineLoop = false;
    ctx.beginPath();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            var firstPoint = points[start];
            var lastPoint = points[_findSegmentEnd(start, end, points)];
            if (first) {
                ctx.moveTo(firstPoint.x, firstPoint.y);
                first = false;
            } else {
                ctx.lineTo(firstPoint.x, clipY);
                ctx.lineTo(firstPoint.x, firstPoint.y);
            }
            lineLoop = !!target.pathSegment(ctx, segment, {
                move: lineLoop
            });
            if (lineLoop) ctx.closePath();
            else ctx.lineTo(lastPoint.x, clipY);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    var line = cfg.line, target = cfg.target, property = cfg.property, color = cfg.color, scale = cfg.scale;
    var segments = _segments(line, target, property);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, src = _step_value.source, tgt = _step_value.target, start = _step_value.start, end = _step_value.end;
            var tmp = src.style, _ref = tmp === void 0 ? {} : tmp, _ref_backgroundColor = _ref.backgroundColor, backgroundColor = _ref_backgroundColor === void 0 ? color : _ref_backgroundColor;
            var notShape = target !== true;
            ctx.save();
            ctx.fillStyle = backgroundColor;
            clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
            ctx.beginPath();
            var lineLoop = !!line.pathSegment(ctx, src);
            var loop = void 0;
            if (notShape) {
                if (lineLoop) ctx.closePath();
                else interpolatedLineTo(ctx, target, end, property);
                var targetLoop = !!target.pathSegment(ctx, tgt, {
                    move: lineLoop,
                    reverse: true
                });
                loop = lineLoop && targetLoop;
                if (!loop) interpolatedLineTo(ctx, target, start, property);
            }
            ctx.closePath();
            ctx.fill(loop ? "evenodd" : "nonzero");
            ctx.restore();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function clipBounds(ctx, scale, bounds) {
    var _scale_chart_chartArea = scale.chart.chartArea, top = _scale_chart_chartArea.top, bottom = _scale_chart_chartArea.bottom;
    var _ref = bounds || {}, property = _ref.property, start = _ref.start, end = _ref.end;
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    var interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        var count = (chart.data.datasets || []).length;
        var sources = [];
        var meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        var draw = options.drawTime === "beforeDraw";
        var metasets = chart.getSortedVisibleDatasetMetas();
        var area = chart.chartArea;
        for(var i = metasets.length - 1; i >= 0; --i){
            var source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        var metasets = chart.getSortedVisibleDatasetMetas();
        for(var i = metasets.length - 1; i >= 0; --i){
            var source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        var source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
var getBoxSize = (labelOpts, fontSize)=>{
    var _labelOpts_boxHeight = labelOpts.boxHeight, boxHeight = _labelOpts_boxHeight === void 0 ? fontSize : _labelOpts_boxHeight, _labelOpts_boxWidth = labelOpts.boxWidth, boxWidth = _labelOpts_boxWidth === void 0 ? fontSize : _labelOpts_boxWidth;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
var itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        var labelOpts = this.options.labels || {};
        var legendItems = (0, _helpersSegmentJs.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        var _this = this, options = _this.options, ctx = _this.ctx;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        var labelOpts = options.labels;
        var labelFont = (0, _helpersSegmentJs.a0)(labelOpts.font);
        var fontSize = labelFont.size;
        var titleHeight = this._computeTitleHeight();
        var _getBoxSize = getBoxSize(labelOpts, fontSize), boxWidth = _getBoxSize.boxWidth, itemHeight = _getBoxSize.itemHeight;
        var width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        var _this = this, ctx = _this.ctx, maxWidth = _this.maxWidth, _this_options = _this.options, padding = _this_options.labels.padding;
        var hitboxes = this.legendHitBoxes = [];
        var lineWidths = this.lineWidths = [
            0
        ];
        var lineHeight = itemHeight + padding;
        var totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        var row = -1;
        var top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        var _this = this, ctx = _this.ctx, maxHeight = _this.maxHeight, _this_options = _this.options, padding = _this_options.labels.padding;
        var hitboxes = this.legendHitBoxes = [];
        var columnSizes = this.columnSizes = [];
        var heightLimit = maxHeight - titleHeight;
        var totalWidth = padding;
        var currentColWidth = 0;
        var currentColHeight = 0;
        var left = 0;
        var col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            var _calculateItemSize = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight), itemWidth = _calculateItemSize.itemWidth, itemHeight = _calculateItemSize.itemHeight;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        var titleHeight = this._computeTitleHeight();
        var _this = this, hitboxes = _this.legendHitBoxes, _this_options = _this.options, align = _this_options.align, padding = _this_options.labels.padding, rtl = _this_options.rtl;
        var rtlHelper = (0, _helpersSegmentJs.az)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            var row = 0;
            var left = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = hitboxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var hitbox = _step.value;
                    if (row !== hitbox.row) {
                        row = hitbox.row;
                        left = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                    }
                    hitbox.top += this.top + titleHeight + padding;
                    hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                    left += hitbox.width + padding;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else {
            var col = 0;
            var top = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = hitboxes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var hitbox1 = _step1.value;
                    if (hitbox1.col !== col) {
                        col = hitbox1.col;
                        top = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                    }
                    hitbox1.top = top;
                    hitbox1.left += this.left + padding;
                    hitbox1.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox1.left), hitbox1.width);
                    top += hitbox1.height + padding;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            var ctx = this.ctx;
            (0, _helpersSegmentJs.Y)(ctx, this);
            this._draw();
            (0, _helpersSegmentJs.$)(ctx);
        }
    }
    _draw() {
        var _this = this, opts = _this.options, columnSizes = _this.columnSizes, lineWidths = _this.lineWidths, ctx = _this.ctx;
        var align = opts.align, labelOpts = opts.labels;
        var defaultColor = (0, _helpersSegmentJs.d).color;
        var rtlHelper = (0, _helpersSegmentJs.az)(opts.rtl, this.left, this.width);
        var labelFont = (0, _helpersSegmentJs.a0)(labelOpts.font);
        var padding = labelOpts.padding;
        var fontSize = labelFont.size;
        var halfFontSize = fontSize / 2;
        var cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        var _getBoxSize = getBoxSize(labelOpts, fontSize), boxWidth = _getBoxSize.boxWidth, boxHeight = _getBoxSize.boxHeight, itemHeight = _getBoxSize.itemHeight;
        var drawLegendBox = function drawLegendBox(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            var lineWidth = (0, _helpersSegmentJs.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, _helpersSegmentJs.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, _helpersSegmentJs.v)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, _helpersSegmentJs.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, _helpersSegmentJs.v)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, _helpersSegmentJs.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, _helpersSegmentJs.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                var drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                var centerY = y + halfFontSize;
                (0, _helpersSegmentJs.aD)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                var yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                var xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                var borderRadius = (0, _helpersSegmentJs.aw)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, _helpersSegmentJs.au)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        var fillText = function fillText(x, y, legendItem) {
            (0, _helpersSegmentJs.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        var isHorizontal = this.isHorizontal();
        var titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, _helpersSegmentJs.aA)(this.ctx, opts.textDirection);
        var lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            var textWidth = ctx.measureText(legendItem.text).width;
            var textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            var width = boxWidth + halfFontSize + textWidth;
            var x = cursor.x;
            var y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            var realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, _helpersSegmentJs.aB)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                var fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, _helpersSegmentJs.aC)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        var opts = this.options;
        var titleOpts = opts.title;
        var titleFont = (0, _helpersSegmentJs.a0)(titleOpts.font);
        var titlePadding = (0, _helpersSegmentJs.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        var rtlHelper = (0, _helpersSegmentJs.az)(opts.rtl, this.left, this.width);
        var ctx = this.ctx;
        var position = titleOpts.position;
        var halfFontSize = titleFont.size / 2;
        var topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        var y;
        var left = this.left;
        var maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, _helpersSegmentJs.a2)(opts.align, left, this.right - maxWidth);
        } else {
            var maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, _helpersSegmentJs.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        var x = (0, _helpersSegmentJs.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, _helpersSegmentJs.a1)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, _helpersSegmentJs.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        var titleOpts = this.options.title;
        var titleFont = (0, _helpersSegmentJs.a0)(titleOpts.font);
        var titlePadding = (0, _helpersSegmentJs.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        var i, hitBox, lh;
        if ((0, _helpersSegmentJs.aj)(x, this.left, this.right) && (0, _helpersSegmentJs.aj)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, _helpersSegmentJs.aj)(x, hitBox.left, hitBox.left + hitBox.width) && (0, _helpersSegmentJs.aj)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        var opts = this.options;
        if (!isListened(e.type, opts)) return;
        var hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            var previous = this._hoveredItem;
            var sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, _helpersSegmentJs.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, _helpersSegmentJs.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, _helpersSegmentJs.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    var itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    var itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    var legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    var itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    var labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var plugin_legend = {
    id: "legend",
    _element: Legend,
    start (chart, _args, options) {
        var legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        var legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        var legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            var index = legendItem.datasetIndex;
            var ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                var datasets = chart.data.datasets;
                var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, usePointStyle = _chart_legend_options_labels.usePointStyle, pointStyle = _chart_legend_options_labels.pointStyle, textAlign = _chart_legend_options_labels.textAlign, color = _chart_legend_options_labels.color, useBorderRadius = _chart_legend_options_labels.useBorderRadius, borderRadius = _chart_legend_options_labels.borderRadius;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    var borderWidth = (0, _helpersSegmentJs.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class Title extends Element {
    update(maxWidth, maxHeight) {
        var opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        var lineCount = (0, _helpersSegmentJs.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, _helpersSegmentJs.E)(opts.padding);
        var textSize = lineCount * (0, _helpersSegmentJs.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        var pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        var _this = this, top = _this.top, left = _this.left, bottom = _this.bottom, right = _this.right, options = _this.options;
        var align = options.align;
        var rotation = 0;
        var maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, _helpersSegmentJs.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, _helpersSegmentJs.a2)(align, bottom, top);
                rotation = (0, _helpersSegmentJs.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, _helpersSegmentJs.a2)(align, top, bottom);
                rotation = (0, _helpersSegmentJs.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        var ctx = this.ctx;
        var opts = this.options;
        if (!opts.display) return;
        var fontOpts = (0, _helpersSegmentJs.a0)(opts.font);
        var lineHeight = fontOpts.lineHeight;
        var offset = lineHeight / 2 + this._padding.top;
        var _this__drawArgs = this._drawArgs(offset), titleX = _this__drawArgs.titleX, titleY = _this__drawArgs.titleY, maxWidth = _this__drawArgs.maxWidth, rotation = _this__drawArgs.rotation;
        (0, _helpersSegmentJs.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: (0, _helpersSegmentJs.a1)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function createTitle(chart, titleOpts) {
    var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: "title",
    _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        var titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        var title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
var map = new WeakMap();
var plugin_subtitle = {
    id: "subtitle",
    start (chart, _args, options) {
        var title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        var title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
var positioners = {
    average (items) {
        if (!items.length) return false;
        var i, len;
        var xSet = new Set();
        var y = 0;
        var count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            var el = items[i].element;
            if (el && el.hasValue()) {
                var pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        var xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            var el = items[i].element;
            if (el && el.hasValue()) {
                var center = el.getCenterPoint();
                var d = (0, _helpersSegmentJs.aE)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            var tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, _helpersSegmentJs.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function createTooltipItem(chart, item) {
    var element = item.element, datasetIndex = item.datasetIndex, index = item.index;
    var controller = chart.getDatasetMeta(datasetIndex).controller;
    var _controller_getLabelAndValue = controller.getLabelAndValue(index), label = _controller_getLabelAndValue.label, value = _controller_getLabelAndValue.value;
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
function getTooltipSize(tooltip, options) {
    var ctx = tooltip.chart.ctx;
    var body = tooltip.body, footer = tooltip.footer, title = tooltip.title;
    var boxWidth = options.boxWidth, boxHeight = options.boxHeight;
    var bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
    var titleFont = (0, _helpersSegmentJs.a0)(options.titleFont);
    var footerFont = (0, _helpersSegmentJs.a0)(options.footerFont);
    var titleLineCount = title.length;
    var footerLineCount = footer.length;
    var bodyLineItemCount = body.length;
    var padding = (0, _helpersSegmentJs.E)(options.padding);
    var height = padding.height;
    var width = 0;
    var combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        var bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    var widthPadding = 0;
    var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, _helpersSegmentJs.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, _helpersSegmentJs.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, _helpersSegmentJs.F)(body, (bodyItem)=>{
        (0, _helpersSegmentJs.F)(bodyItem.before, maxLineWidth);
        (0, _helpersSegmentJs.F)(bodyItem.lines, maxLineWidth);
        (0, _helpersSegmentJs.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, _helpersSegmentJs.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    var y = size.y, height = size.height;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    var x = size.x, width = size.width;
    var caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    var x = size.x, width = size.width;
    var chartWidth = chart.width, _chart_chartArea = chart.chartArea, left = _chart_chartArea.left, right = _chart_chartArea.right;
    var xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function determineAlignment(chart, options, size) {
    var yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    var x = size.x, width = size.width;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    var y = size.y, height = size.height;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    var caretSize = options.caretSize, caretPadding = options.caretPadding, cornerRadius = options.cornerRadius;
    var xAlign = alignment.xAlign, yAlign = alignment.yAlign;
    var paddingAndSize = caretSize + caretPadding;
    var _toTRBLCorners = (0, _helpersSegmentJs.aw)(cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
    var x = alignX(size, xAlign);
    var y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, _helpersSegmentJs.S)(x, 0, chart.width - size.width),
        y: (0, _helpersSegmentJs.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    var padding = (0, _helpersSegmentJs.E)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, _helpersSegmentJs.j)(parent, {
        tooltip,
        tooltipItems,
        type: "tooltip"
    });
}
function overrideCallbacks(callbacks, context) {
    var override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
var defaultCallbacks = {
    beforeTitle: (0, _helpersSegmentJs.aF),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            var item = tooltipItems[0];
            var labels = item.chart.data.labels;
            var labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, _helpersSegmentJs.aF),
    beforeBody: (0, _helpersSegmentJs.aF),
    beforeLabel: (0, _helpersSegmentJs.aF),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        var label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        var value = tooltipItem.formattedValue;
        if (!(0, _helpersSegmentJs.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, _helpersSegmentJs.aF),
    afterBody: (0, _helpersSegmentJs.aF),
    beforeFooter: (0, _helpersSegmentJs.aF),
    footer: (0, _helpersSegmentJs.aF),
    afterFooter: (0, _helpersSegmentJs.aF)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    var result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return defaultCallbacks[name].call(ctx, arg);
    return result;
}
class Tooltip extends Element {
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        var cached = this._cachedAnimations;
        if (cached) return cached;
        var chart = this.chart;
        var options = this.options.setContext(this.getContext());
        var opts = options.enabled && chart.options.animation && options.animations;
        var animations = new Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        var callbacks = options.callbacks;
        var beforeTitle = invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        var title = invokeCallbackWithFallback(callbacks, "title", this, context);
        var afterTitle = invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        var callbacks = options.callbacks;
        var bodyItems = [];
        (0, _helpersSegmentJs.F)(tooltipItems, (context)=>{
            var bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            var scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, "label", this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        var callbacks = options.callbacks;
        var beforeFooter = invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        var footer = invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        var afterFooter = invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        var active = this._active;
        var data = this.chart.data;
        var labelColors = [];
        var labelPointStyles = [];
        var labelTextColors = [];
        var tooltipItems = [];
        var i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, _helpersSegmentJs.F)(tooltipItems, (context)=>{
            var scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        var options = this.options.setContext(this.getContext());
        var active = this._active;
        var properties;
        var tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            var position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            var size = this._size = getTooltipSize(this, options);
            var positionAndSize = Object.assign({}, position, size);
            var alignment = determineAlignment(this.chart, options, positionAndSize);
            var backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        var caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        var _this = this, xAlign = _this.xAlign, yAlign = _this.yAlign;
        var caretSize = options.caretSize, cornerRadius = options.cornerRadius;
        var _toTRBLCorners = (0, _helpersSegmentJs.aw)(cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
        var ptX = tooltipPoint.x, ptY = tooltipPoint.y;
        var width = size.width, height = size.height;
        var x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        var title = this.title;
        var length = title.length;
        var titleFont, titleSpacing, i;
        if (length) {
            var rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, _helpersSegmentJs.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        var labelColor = this.labelColors[i];
        var labelPointStyle = this.labelPointStyles[i];
        var boxHeight = options.boxHeight, boxWidth = options.boxWidth;
        var bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
        var colorX = getAlignedX(this, "left", options);
        var rtlColorX = rtlHelper.x(colorX);
        var yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        var colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            var drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            var centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            var centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, _helpersSegmentJs.at)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, _helpersSegmentJs.at)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, _helpersSegmentJs.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            var outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            var innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            var borderRadius = (0, _helpersSegmentJs.aw)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, _helpersSegmentJs.au)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, _helpersSegmentJs.au)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        var body = this.body;
        var bodySpacing = options.bodySpacing, bodyAlign = options.bodyAlign, displayColors = options.displayColors, boxHeight = options.boxHeight, boxWidth = options.boxWidth, boxPadding = options.boxPadding;
        var bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
        var bodyLineHeight = bodyFont.lineHeight;
        var xLinePadding = 0;
        var rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
        var fillLineOfText = function fillLineOfText(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        var bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, _helpersSegmentJs.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, _helpersSegmentJs.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, _helpersSegmentJs.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, _helpersSegmentJs.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        var footer = this.footer;
        var length = footer.length;
        var footerFont, i;
        if (length) {
            var rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, _helpersSegmentJs.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        var _this = this, xAlign = _this.xAlign, yAlign = _this.yAlign;
        var x = pt.x, y = pt.y;
        var width = tooltipSize.width, height = tooltipSize.height;
        var _toTRBLCorners = (0, _helpersSegmentJs.aw)(options.cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        var chart = this.chart;
        var anims = this.$animations;
        var animX = anims && anims.x;
        var animY = anims && anims.y;
        if (animX || animY) {
            var position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            var size = this._size = getTooltipSize(this, options);
            var positionAndSize = Object.assign({}, position, this._size);
            var alignment = determineAlignment(chart, options, positionAndSize);
            var point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        var options = this.options.setContext(this.getContext());
        var opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        var tooltipSize = {
            width: this.width,
            height: this.height
        };
        var pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        var padding = (0, _helpersSegmentJs.E)(options.padding);
        var hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, _helpersSegmentJs.aA)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, _helpersSegmentJs.aC)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        var lastActive = this._active;
        var active = activeElements.map((param)=>{
            var datasetIndex = param.datasetIndex, index = param.index;
            var meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        var changed = !(0, _helpersSegmentJs.ah)(lastActive, active);
        var positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay) {
        var inChartArea = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        var options = this.options;
        var lastActive = this._active || [];
        var active = this._getActiveElements(e, lastActive, replay, inChartArea);
        var positionChanged = this._positionChanged(active, e);
        var changed = replay || !(0, _helpersSegmentJs.ah)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        var options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        var active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        var _this = this, caretX = _this.caretX, caretY = _this.caretY, options = _this.options;
        var position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
}
(0, _defineProperty._)(Tooltip, "positioners", positioners);
var plugin_tooltip = {
    id: "tooltip",
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart,
            options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        var tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            var args = {
                tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", (0, _objectSpreadProps._)((0, _objectSpread._)({}, args), {
                cancelable: true
            })) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            var useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
var addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    var first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    var last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
var validIndex = (index, max)=>index === null ? null : (0, _helpersSegmentJs.S)(Math.round(index), 0, max);
function _getLabelForValue(value) {
    var labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class CategoryScale extends Scale {
    init(scaleOptions) {
        var added = this._addedLabels;
        if (added.length) {
            var labels = this.getLabels();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = added[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, index = _step_value.index, label = _step_value.label;
                    if (labels[index] === label) labels.splice(index, 1);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, _helpersSegmentJs.k)(raw)) return null;
        var labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, _helpersSegmentJs.v)(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
        var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        var min = this.min;
        var max = this.max;
        var offset = this.options.offset;
        var ticks = [];
        var labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(var value = min; value <= max; value++)ticks.push({
            value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        var ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
}
(0, _defineProperty._)(CategoryScale, "id", "category");
(0, _defineProperty._)(CategoryScale, "defaults", {
    ticks: {
        callback: _getLabelForValue
    }
});
function generateTicks$1(generationOptions, dataRange) {
    var ticks = [];
    var MIN_SPACING = 1e-14;
    var bounds = generationOptions.bounds, step = generationOptions.step, min = generationOptions.min, max = generationOptions.max, precision = generationOptions.precision, count = generationOptions.count, maxTicks = generationOptions.maxTicks, maxDigits = generationOptions.maxDigits, includeBounds = generationOptions.includeBounds;
    var unit = step || 1;
    var maxSpaces = maxTicks - 1;
    var rmin = dataRange.min, rmax = dataRange.max;
    var minDefined = !(0, _helpersSegmentJs.k)(min);
    var maxDefined = !(0, _helpersSegmentJs.k)(max);
    var countDefined = !(0, _helpersSegmentJs.k)(count);
    var minSpacing = (rmax - rmin) / (maxDigits + 1);
    var spacing = (0, _helpersSegmentJs.aH)((rmax - rmin) / maxSpaces / unit) * unit;
    var factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, _helpersSegmentJs.aH)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, _helpersSegmentJs.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, _helpersSegmentJs.aI)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, _helpersSegmentJs.aJ)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    var decimalPlaces = Math.max((0, _helpersSegmentJs.aK)(spacing), (0, _helpersSegmentJs.aK)(niceMin));
    factor = Math.pow(10, (0, _helpersSegmentJs.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    var j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, _helpersSegmentJs.aJ)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        var tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, _helpersSegmentJs.aJ)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, param) {
    var horizontal = param.horizontal, minRotation = param.minRotation;
    var rad = (0, _helpersSegmentJs.t)(minRotation);
    var ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    var length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    parse(raw, index) {
        if ((0, _helpersSegmentJs.k)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        var beginAtZero = this.options.beginAtZero;
        var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
        var _this = this, min = _this.min, max = _this.max;
        var setMin = (v)=>min = minDefined ? min : v;
        var setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            var minSign = (0, _helpersSegmentJs.s)(min);
            var maxSign = (0, _helpersSegmentJs.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            var offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        var tickOpts = this.options.ticks;
        var maxTicksLimit = tickOpts.maxTicksLimit, stepSize = tickOpts.stepSize;
        var maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        var opts = this.options;
        var tickOpts = opts.ticks;
        var maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        var numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        var dataRange = this._range || this;
        var ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, _helpersSegmentJs.aG)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        var ticks = this.ticks;
        var start = this.min;
        var end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            var offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, _helpersSegmentJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
}
class LinearScale extends LinearScaleBase {
    determineDataLimits() {
        var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
        this.min = (0, _helpersSegmentJs.g)(min) ? min : 0;
        this.max = (0, _helpersSegmentJs.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        var horizontal = this.isHorizontal();
        var length = horizontal ? this.width : this.height;
        var minRotation = (0, _helpersSegmentJs.t)(this.options.ticks.minRotation);
        var ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        var tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
(0, _defineProperty._)(LinearScale, "id", "linear");
(0, _defineProperty._)(LinearScale, "defaults", {
    ticks: {
        callback: (0, _helpersSegmentJs.aL).formatters.numeric
    }
});
var log10Floor = (v)=>Math.floor((0, _helpersSegmentJs.aM)(v));
var changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    var remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    var rangeStep = Math.pow(10, rangeExp);
    var start = Math.floor(min / rangeStep);
    var end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    var range = max - min;
    var rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, param) {
    var min = param.min, max = param.max;
    min = (0, _helpersSegmentJs.O)(generationOptions.min, min);
    var ticks = [];
    var minExp = log10Floor(min);
    var exp = startExp(min, max);
    var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    var stepSize = Math.pow(10, exp);
    var base = minExp > exp ? Math.pow(10, minExp) : 0;
    var start = Math.round((min - base) * precision) / precision;
    var offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    var significand = Math.floor((start - offset) / Math.pow(10, exp));
    var value = (0, _helpersSegmentJs.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    var lastTick = (0, _helpersSegmentJs.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    parse(raw, index) {
        var value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, _helpersSegmentJs.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
        this.min = (0, _helpersSegmentJs.g)(min) ? Math.max(0, min) : null;
        this.max = (0, _helpersSegmentJs.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, _helpersSegmentJs.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
        var min = this.min;
        var max = this.max;
        var setMin = (v)=>min = minDefined ? min : v;
        var setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin(changeExponent(max, -1));
        if (max <= 0) setMax(changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        var opts = this.options;
        var generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        var ticks = generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, _helpersSegmentJs.aG)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, _helpersSegmentJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        var start = this.min;
        super.configure();
        this._startValue = (0, _helpersSegmentJs.aM)(start);
        this._valueRange = (0, _helpersSegmentJs.aM)(this.max) - (0, _helpersSegmentJs.aM)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, _helpersSegmentJs.aM)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        var decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
}
(0, _defineProperty._)(LogarithmicScale, "id", "logarithmic");
(0, _defineProperty._)(LogarithmicScale, "defaults", {
    ticks: {
        callback: (0, _helpersSegmentJs.aL).formatters.logarithmic,
        major: {
            enabled: true
        }
    }
});
function getTickBackdropHeight(opts) {
    var tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        var padding = (0, _helpersSegmentJs.E)(tickOpts.backdropPadding);
        return (0, _helpersSegmentJs.v)(tickOpts.font && tickOpts.font.size, (0, _helpersSegmentJs.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, _helpersSegmentJs.b)(label) ? label : [
        label
    ];
    return {
        w: (0, _helpersSegmentJs.aN)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    var orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    var limits = Object.assign({}, orig);
    var labelSizes = [];
    var padding = [];
    var valueCount = scale._pointLabels.length;
    var pointLabelOpts = scale.options.pointLabels;
    var additionalAngle = pointLabelOpts.centerPointLabels ? (0, _helpersSegmentJs.P) / valueCount : 0;
    for(var i = 0; i < valueCount; i++){
        var opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        var pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        var plFont = (0, _helpersSegmentJs.a0)(opts.font);
        var textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        var angleRadians = (0, _helpersSegmentJs.ay)(scale.getIndexAngle(i) + additionalAngle);
        var angle = Math.round((0, _helpersSegmentJs.U)(angleRadians));
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    var sin = Math.abs(Math.sin(angle));
    var cos = Math.abs(Math.cos(angle));
    var x = 0;
    var y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    var outerDistance = scale.drawingArea;
    var extra = itemOpts.extra, additionalAngle = itemOpts.additionalAngle, padding = itemOpts.padding, size = itemOpts.size;
    var pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    var angle = Math.round((0, _helpersSegmentJs.U)((0, _helpersSegmentJs.ay)(pointLabelPosition.angle + (0, _helpersSegmentJs.H))));
    var y = yForAngle(pointLabelPosition.y, size.h, angle);
    var textAlign = getTextAlignForAngle(angle);
    var left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    var left = item.left, top = item.top, right = item.right, bottom = item.bottom;
    var apexesInArea = (0, _helpersSegmentJs.C)({
        x: left,
        y: top
    }, area) || (0, _helpersSegmentJs.C)({
        x: left,
        y: bottom
    }, area) || (0, _helpersSegmentJs.C)({
        x: right,
        y: top
    }, area) || (0, _helpersSegmentJs.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    var items = [];
    var valueCount = scale._pointLabels.length;
    var opts = scale.options;
    var _opts_pointLabels = opts.pointLabels, centerPointLabels = _opts_pointLabels.centerPointLabels, display = _opts_pointLabels.display;
    var itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, _helpersSegmentJs.P) / valueCount : 0
    };
    var area;
    for(var i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        var item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    var left = item.left, top = item.top, right = item.right, bottom = item.bottom;
    var backdropColor = opts.backdropColor;
    if (!(0, _helpersSegmentJs.k)(backdropColor)) {
        var borderRadius = (0, _helpersSegmentJs.aw)(opts.borderRadius);
        var padding = (0, _helpersSegmentJs.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        var backdropLeft = left - padding.left;
        var backdropTop = top - padding.top;
        var backdropWidth = right - left + padding.width;
        var backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, _helpersSegmentJs.au)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    var ctx = scale.ctx, pointLabels = scale.options.pointLabels;
    for(var i = labelCount - 1; i >= 0; i--){
        var item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        var optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        var plFont = (0, _helpersSegmentJs.a0)(optsAtIndex.font);
        var x = item.x, y = item.y, textAlign = item.textAlign;
        (0, _helpersSegmentJs.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    var ctx = scale.ctx;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, _helpersSegmentJs.T));
    else {
        var pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(var i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    var ctx = scale.ctx;
    var circular = gridLineOpts.circular;
    var color = gridLineOpts.color, lineWidth = gridLineOpts.lineWidth;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, _helpersSegmentJs.j)(parent, {
        label,
        index,
        type: "pointLabel"
    });
}
class RadialLinearScale extends LinearScaleBase {
    setDimensions() {
        var padding = this._padding = (0, _helpersSegmentJs.E)(getTickBackdropHeight(this.options) / 2);
        var w = this.width = this.maxWidth - padding.width;
        var h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        var _this_getMinMax = this.getMinMax(false), min = _this_getMinMax.min, max = _this_getMinMax.max;
        this.min = (0, _helpersSegmentJs.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, _helpersSegmentJs.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            var label = (0, _helpersSegmentJs.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        var opts = this.options;
        if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        var angleMultiplier = (0, _helpersSegmentJs.T) / (this._pointLabels.length || 1);
        var startAngle = this.options.startAngle || 0;
        return (0, _helpersSegmentJs.ay)(index * angleMultiplier + (0, _helpersSegmentJs.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, _helpersSegmentJs.k)(value)) return NaN;
        var scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, _helpersSegmentJs.k)(distance)) return NaN;
        var scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        var pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            var pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter) {
        var additionalAngle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var angle = this.getIndexAngle(index) - (0, _helpersSegmentJs.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        var _this__pointLabelItems_index = this._pointLabelItems[index], left = _this__pointLabelItems_index.left, top = _this__pointLabelItems_index.top, right = _this__pointLabelItems_index.right, bottom = _this__pointLabelItems_index.bottom;
        return {
            left,
            top,
            right,
            bottom
        };
    }
    drawBackground() {
        var _this_options = this.options, backgroundColor = _this_options.backgroundColor, circular = _this_options.grid.circular;
        if (backgroundColor) {
            var ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        var ctx = this.ctx;
        var opts = this.options;
        var angleLines = opts.angleLines, grid = opts.grid, border = opts.border;
        var labelCount = this._pointLabels.length;
        var i, offset, position;
        if (opts.pointLabels.display) drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                var context = this.getContext(index);
                var optsAtIndex = grid.setContext(context);
                var optsAtIndexBorder = border.setContext(context);
                drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                var optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                var color = optsAtIndex.color, lineWidth = optsAtIndex.lineWidth;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        var ctx = this.ctx;
        var opts = this.options;
        var tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        var startAngle = this.getIndexAngle(0);
        var offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            var optsAtIndex = tickOpts.setContext(this.getContext(index));
            var tickFont = (0, _helpersSegmentJs.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                var padding = (0, _helpersSegmentJs.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, _helpersSegmentJs.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
}
(0, _defineProperty._)(RadialLinearScale, "id", "radialLinear");
(0, _defineProperty._)(RadialLinearScale, "defaults", {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: (0, _helpersSegmentJs.aL).formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
});
(0, _defineProperty._)(RadialLinearScale, "defaultRoutes", {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
});
(0, _defineProperty._)(RadialLinearScale, "descriptors", {
    angleLines: {
        _fallback: "grid"
    }
});
var INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
var UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, _helpersSegmentJs.k)(input)) return null;
    var adapter = scale._adapter;
    var _scale__parseOpts = scale._parseOpts, parser = _scale__parseOpts.parser, round = _scale__parseOpts.round, isoWeekday = _scale__parseOpts.isoWeekday;
    var value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, _helpersSegmentJs.g)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, _helpersSegmentJs.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    var ilen = UNITS.length;
    for(var i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        var interval = INTERVALS[UNITS[i]];
        var factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(var i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        var unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        var _$_lookup = (0, _helpersSegmentJs.aP)(timestamps, time), lo = _$_lookup.lo, hi = _$_lookup.hi;
        var timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    var adapter = scale._adapter;
    var first = +adapter.startOf(ticks[0].value, majorUnit);
    var last = ticks[ticks.length - 1].value;
    var major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    var ticks = [];
    var map = {};
    var ilen = values.length;
    var i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    init(scaleOpts) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var time = scaleOpts.time || (scaleOpts.time = {});
        var adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, _helpersSegmentJs.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        var options = this.options;
        var adapter = this._adapter;
        var unit = options.time.unit || "day";
        var _this_getUserBounds = this.getUserBounds(), min = _this_getUserBounds.min, max = _this_getUserBounds.max, minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, _helpersSegmentJs.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, _helpersSegmentJs.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        var arr = this.getLabelTimestamps();
        var min = Number.POSITIVE_INFINITY;
        var max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
    buildTicks() {
        var options = this.options;
        var timeOpts = options.time;
        var tickOpts = options.ticks;
        var timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        var min = this.min;
        var max = this.max;
        var ticks = (0, _helpersSegmentJs.aO)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets() {
        var timestamps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var start = 0;
        var end = 0;
        var first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        var limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, _helpersSegmentJs.S)(start, 0, limit);
        end = (0, _helpersSegmentJs.S)(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        var adapter = this._adapter;
        var min = this.min;
        var max = this.max;
        var options = this.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        var stepSize = (0, _helpersSegmentJs.v)(options.ticks.stepSize, 1);
        var weekday = minor === "week" ? timeOpts.isoWeekday : false;
        var hasWeekday = (0, _helpersSegmentJs.x)(weekday) || weekday === true;
        var ticks = {};
        var first = min;
        var time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        var timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        var adapter = this._adapter;
        var timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        var options = this.options;
        var formats = options.time.displayFormats;
        var unit = this._unit;
        var fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        var options = this.options;
        var formatter = options.ticks.callback;
        if (formatter) return (0, _helpersSegmentJs.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        var formats = options.time.displayFormats;
        var unit = this._unit;
        var majorUnit = this._majorUnit;
        var minorFormat = unit && formats[unit];
        var majorFormat = majorUnit && formats[majorUnit];
        var tick = ticks[index];
        var major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        var i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        var offsets = this._offsets;
        var pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        var offsets = this._offsets;
        var pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        var ticksOpts = this.options.ticks;
        var tickLabelWidth = this.ctx.measureText(label).width;
        var angle = (0, _helpersSegmentJs.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        var cosRotation = Math.cos(angle);
        var sinRotation = Math.sin(angle);
        var tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        var timeOpts = this.options.time;
        var displayFormats = timeOpts.displayFormats;
        var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        var exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        var size = this._getLabelSize(exampleLabel);
        var capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        var timestamps = this._cache.data || [];
        var i, ilen;
        if (timestamps.length) return timestamps;
        var metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        var timestamps = this._cache.labels || [];
        var i, ilen;
        if (timestamps.length) return timestamps;
        var labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, _helpersSegmentJs._)(values.sort(sorter));
    }
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
}
(0, _defineProperty._)(TimeScale, "id", "time");
(0, _defineProperty._)(TimeScale, "defaults", {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        callback: false,
        major: {
            enabled: false
        }
    }
});
function interpolate(table, val, reverse) {
    var lo = 0;
    var hi = table.length - 1;
    var prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        var ref;
        if (val >= table[lo].pos && val <= table[hi].pos) ref = (0, _helpersSegmentJs.B)(table, "pos", val), lo = ref.lo, hi = ref.hi, ref;
        var ref1;
        ref1 = table[lo], prevSource = ref1.pos, prevTarget = ref1.time, ref1;
        var ref2;
        ref2 = table[hi], nextSource = ref2.pos, nextTarget = ref2.time, ref2;
    } else {
        var ref3;
        if (val >= table[lo].time && val <= table[hi].time) ref3 = (0, _helpersSegmentJs.B)(table, "time", val), lo = ref3.lo, hi = ref3.hi, ref3;
        var ref4;
        ref4 = table[lo], prevSource = ref4.time, prevTarget = ref4.pos, ref4;
        var ref5;
        ref5 = table[hi], nextSource = ref5.time, nextTarget = ref5.pos, ref5;
    }
    var span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    initOffsets() {
        var timestamps = this._getTimestampsForTable();
        var table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        var _this = this, min = _this.min, max = _this.max;
        var items = [];
        var table = [];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        var min = this.min;
        var max = this.max;
        var timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        var timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        var data = this.getDataTimestamps();
        var label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        var offsets = this._offsets;
        var decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
}
(0, _defineProperty._)(TimeSeriesScale, "id", "timeseries");
(0, _defineProperty._)(TimeSeriesScale, "defaults", TimeScale.defaults);
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
var registerables = [
    controllers,
    elements,
    plugins,
    scales
];

},{"@swc/helpers/_/_define_property":"8uLqc","@swc/helpers/_/_object_spread":"jB3kB","@swc/helpers/_/_object_spread_props":"14Y0l","@swc/helpers/_/_sliced_to_array":"cdERl","./chunks/helpers.segment.js":"3AXRv","@kurkle/color":"doBck","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8uLqc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_define_property", ()=>_define_property);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jB3kB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_spread", ()=>_object_spread);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._define_property)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"8uLqc","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"14Y0l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_spread_props", ()=>_object_spread_props);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"cdERl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_sliced_to_array", ()=>_sliced_to_array);
parcelHelpers.export(exports, "_", ()=>_sliced_to_array);
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._array_with_holes)(arr) || (0, _iterableToArrayLimitJs._iterable_to_array_limit)(arr, i) || (0, _unsupportedIterableToArrayJs._unsupported_iterable_to_array)(arr, i) || (0, _nonIterableRestJs._non_iterable_rest)();
}

},{"./_array_with_holes.js":"50yI4","./_iterable_to_array_limit.js":"0k2mX","./_non_iterable_rest.js":"9V9Aj","./_unsupported_iterable_to_array.js":"j8BNY","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"50yI4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_array_with_holes", ()=>_array_with_holes);
parcelHelpers.export(exports, "_", ()=>_array_with_holes);
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"0k2mX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_iterable_to_array_limit", ()=>_iterable_to_array_limit);
parcelHelpers.export(exports, "_", ()=>_iterable_to_array_limit);
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"9V9Aj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_non_iterable_rest", ()=>_non_iterable_rest);
parcelHelpers.export(exports, "_", ()=>_non_iterable_rest);
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"j8BNY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_unsupported_iterable_to_array", ()=>_unsupported_iterable_to_array);
parcelHelpers.export(exports, "_", ()=>_unsupported_iterable_to_array);
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._array_like_to_array)(o, minLen);
}

},{"./_array_like_to_array.js":"b0Rrd","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"b0Rrd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_array_like_to_array", ()=>_array_like_to_array);
parcelHelpers.export(exports, "_", ()=>_array_like_to_array);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"3AXRv":[function(require,module,exports) {
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>unclipArea);
parcelHelpers.export(exports, "A", ()=>_rlookupByKey);
parcelHelpers.export(exports, "B", ()=>_lookupByKey);
parcelHelpers.export(exports, "C", ()=>_isPointInArea);
parcelHelpers.export(exports, "D", ()=>getAngleFromPoint);
parcelHelpers.export(exports, "E", ()=>toPadding);
parcelHelpers.export(exports, "F", ()=>each);
parcelHelpers.export(exports, "G", ()=>getMaximumSize);
parcelHelpers.export(exports, "H", ()=>HALF_PI);
parcelHelpers.export(exports, "I", ()=>_getParentNode);
parcelHelpers.export(exports, "J", ()=>readUsedSize);
parcelHelpers.export(exports, "K", ()=>supportsEventListenerOptions);
parcelHelpers.export(exports, "L", ()=>throttled);
parcelHelpers.export(exports, "M", ()=>_isDomSupported);
parcelHelpers.export(exports, "N", ()=>_factorize);
parcelHelpers.export(exports, "O", ()=>finiteOrDefault);
parcelHelpers.export(exports, "P", ()=>PI);
parcelHelpers.export(exports, "Q", ()=>callback);
parcelHelpers.export(exports, "R", ()=>_addGrace);
parcelHelpers.export(exports, "S", ()=>_limitValue);
parcelHelpers.export(exports, "T", ()=>TAU);
parcelHelpers.export(exports, "U", ()=>toDegrees);
parcelHelpers.export(exports, "V", ()=>_measureText);
parcelHelpers.export(exports, "W", ()=>_int16Range);
parcelHelpers.export(exports, "X", ()=>_alignPixel);
parcelHelpers.export(exports, "Y", ()=>clipArea);
parcelHelpers.export(exports, "Z", ()=>renderText);
parcelHelpers.export(exports, "_", ()=>_arrayUnique);
parcelHelpers.export(exports, "a", ()=>resolve);
parcelHelpers.export(exports, "a$", ()=>fontString);
parcelHelpers.export(exports, "a0", ()=>toFont);
parcelHelpers.export(exports, "a1", ()=>_toLeftRightCenter);
parcelHelpers.export(exports, "a2", ()=>_alignStartEnd);
parcelHelpers.export(exports, "a3", ()=>overrides);
parcelHelpers.export(exports, "a4", ()=>merge);
parcelHelpers.export(exports, "a5", ()=>_capitalize);
parcelHelpers.export(exports, "a6", ()=>descriptors);
parcelHelpers.export(exports, "a7", ()=>isFunction);
parcelHelpers.export(exports, "a8", ()=>_attachContext);
parcelHelpers.export(exports, "a9", ()=>_createResolver);
parcelHelpers.export(exports, "aA", ()=>overrideTextDirection);
parcelHelpers.export(exports, "aB", ()=>_textX);
parcelHelpers.export(exports, "aC", ()=>restoreTextDirection);
parcelHelpers.export(exports, "aD", ()=>drawPointLegend);
parcelHelpers.export(exports, "aE", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "aF", ()=>noop);
parcelHelpers.export(exports, "aG", ()=>_setMinAndMaxByKey);
parcelHelpers.export(exports, "aH", ()=>niceNum);
parcelHelpers.export(exports, "aI", ()=>almostWhole);
parcelHelpers.export(exports, "aJ", ()=>almostEquals);
parcelHelpers.export(exports, "aK", ()=>_decimalPlaces);
parcelHelpers.export(exports, "aL", ()=>Ticks);
parcelHelpers.export(exports, "aM", ()=>log10);
parcelHelpers.export(exports, "aN", ()=>_longestText);
parcelHelpers.export(exports, "aO", ()=>_filterBetween);
parcelHelpers.export(exports, "aP", ()=>_lookup);
parcelHelpers.export(exports, "aQ", ()=>isPatternOrGradient);
parcelHelpers.export(exports, "aR", ()=>getHoverColor);
parcelHelpers.export(exports, "aS", ()=>clone);
parcelHelpers.export(exports, "aT", ()=>_merger);
parcelHelpers.export(exports, "aU", ()=>_mergerIf);
parcelHelpers.export(exports, "aV", ()=>_deprecated);
parcelHelpers.export(exports, "aW", ()=>_splitKey);
parcelHelpers.export(exports, "aX", ()=>toFontString);
parcelHelpers.export(exports, "aY", ()=>splineCurve);
parcelHelpers.export(exports, "aZ", ()=>splineCurveMonotone);
parcelHelpers.export(exports, "a_", ()=>getStyle);
parcelHelpers.export(exports, "aa", ()=>_descriptors);
parcelHelpers.export(exports, "ab", ()=>mergeIf);
parcelHelpers.export(exports, "ac", ()=>uid);
parcelHelpers.export(exports, "ad", ()=>debounce);
parcelHelpers.export(exports, "ae", ()=>retinaScale);
parcelHelpers.export(exports, "af", ()=>clearCanvas);
parcelHelpers.export(exports, "ag", ()=>setsEqual);
parcelHelpers.export(exports, "ah", ()=>_elementsEqual);
parcelHelpers.export(exports, "ai", ()=>_isClickEvent);
parcelHelpers.export(exports, "aj", ()=>_isBetween);
parcelHelpers.export(exports, "ak", ()=>_readValueToProps);
parcelHelpers.export(exports, "al", ()=>_updateBezierControlPoints);
parcelHelpers.export(exports, "am", ()=>_computeSegments);
parcelHelpers.export(exports, "an", ()=>_boundSegments);
parcelHelpers.export(exports, "ao", ()=>_steppedInterpolation);
parcelHelpers.export(exports, "ap", ()=>_bezierInterpolation);
parcelHelpers.export(exports, "aq", ()=>_pointInLine);
parcelHelpers.export(exports, "ar", ()=>_steppedLineTo);
parcelHelpers.export(exports, "as", ()=>_bezierCurveTo);
parcelHelpers.export(exports, "at", ()=>drawPoint);
parcelHelpers.export(exports, "au", ()=>addRoundedRectPath);
parcelHelpers.export(exports, "av", ()=>toTRBL);
parcelHelpers.export(exports, "aw", ()=>toTRBLCorners);
parcelHelpers.export(exports, "ax", ()=>_boundSegment);
parcelHelpers.export(exports, "ay", ()=>_normalizeAngle);
parcelHelpers.export(exports, "az", ()=>getRtlAdapter);
parcelHelpers.export(exports, "b", ()=>isArray);
parcelHelpers.export(exports, "b0", ()=>toLineHeight);
parcelHelpers.export(exports, "b1", ()=>PITAU);
parcelHelpers.export(exports, "b2", ()=>INFINITY);
parcelHelpers.export(exports, "b3", ()=>RAD_PER_DEG);
parcelHelpers.export(exports, "b4", ()=>QUARTER_PI);
parcelHelpers.export(exports, "b5", ()=>TWO_THIRDS_PI);
parcelHelpers.export(exports, "b6", ()=>_angleDiff);
parcelHelpers.export(exports, "c", ()=>color);
parcelHelpers.export(exports, "d", ()=>defaults);
parcelHelpers.export(exports, "e", ()=>effects);
parcelHelpers.export(exports, "f", ()=>resolveObjectKey);
parcelHelpers.export(exports, "g", ()=>isNumberFinite);
parcelHelpers.export(exports, "h", ()=>defined);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "j", ()=>createContext);
parcelHelpers.export(exports, "k", ()=>isNullOrUndef);
parcelHelpers.export(exports, "l", ()=>listenArrayEvents);
parcelHelpers.export(exports, "m", ()=>toPercentage);
parcelHelpers.export(exports, "n", ()=>toDimension);
parcelHelpers.export(exports, "o", ()=>formatNumber);
parcelHelpers.export(exports, "p", ()=>_angleBetween);
parcelHelpers.export(exports, "q", ()=>_getStartAndCountOfVisiblePoints);
parcelHelpers.export(exports, "r", ()=>requestAnimFrame);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toRadians);
parcelHelpers.export(exports, "u", ()=>unlistenArrayEvents);
parcelHelpers.export(exports, "v", ()=>valueOrDefault);
parcelHelpers.export(exports, "w", ()=>_scaleRangesChanged);
parcelHelpers.export(exports, "x", ()=>isNumber);
parcelHelpers.export(exports, "y", ()=>_parseObjectDataRadialScale);
parcelHelpers.export(exports, "z", ()=>getRelativePosition);
var _color = require("@kurkle/color");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ var uid = (()=>{
    var id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || typeof value === "undefined";
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    var type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
var toPercentage = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
var toDimension = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function each(loopable, fn, thisArg, reverse) {
    var i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    var i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) return source.map(clone);
    if (isObject(source)) {
        var target = Object.create(null);
        var keys = Object.keys(source);
        var klen = keys.length;
        var k = 0;
        for(; k < klen; ++k)target[keys[k]] = clone(source[keys[k]]);
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) return;
    var tval = target[key];
    var sval = source[key];
    if (isObject(tval) && isObject(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
    else target[key] = clone(sval);
}
function merge(target, source, options) {
    var sources = isArray(source) ? source : [
        source
    ];
    var ilen = sources.length;
    if (!isObject(target)) return target;
    options = options || {};
    var merger = options.merger || _merger;
    var current;
    for(var i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) continue;
        var keys = Object.keys(current);
        for(var k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) return;
    var tval = target[key];
    var sval = source[key];
    if (isObject(tval) && isObject(sval)) mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = clone(sval);
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
var keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    var parts = key.split(".");
    var keys = [];
    var tmp = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            tmp += part;
            if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
            else {
                keys.push(tmp);
                tmp = "";
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    var keys = _splitKey(key);
    return (obj)=>{
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                if (k === "") break;
                obj = obj && obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    var resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var defined = (value)=>typeof value !== "undefined";
var isFunction = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
var setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!b.has(item)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ var PI = Math.PI;
var TAU = 2 * PI;
var PITAU = TAU + PI;
var INFINITY = Number.POSITIVE_INFINITY;
var RAD_PER_DEG = PI / 180;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;
var log10 = Math.log10;
var sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    var roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    var niceRange = Math.pow(10, Math.floor(log10(range)));
    var fraction = range / niceRange;
    var niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    var result = [];
    var sqrt = Math.sqrt(value);
    var i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    var rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    var i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) return;
    var e = 1;
    var p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    var distanceFromXCenter = anglePoint.x - centrePoint.x;
    var distanceFromYCenter = anglePoint.y - centrePoint.y;
    var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    var a = _normalizeAngle(angle);
    var s = _normalizeAngle(start);
    var e = _normalizeAngle(end);
    var angleToStart = _normalizeAngle(s - a);
    var angleToEnd = _normalizeAngle(e - a);
    var startToAngle = _normalizeAngle(a - s);
    var endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end) {
    var epsilon = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1e-6;
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    var hi = table.length - 1;
    var lo = 0;
    var mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ var _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        var ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ var _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    var start = 0;
    var end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
var arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        var method = "_onData" + _capitalize(key);
        var base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value () {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    var stub = array._chartjs;
    if (!stub) return;
    var listeners = stub.listeners;
    var index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    var set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ var requestAnimFrame = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    var argsToUse = [];
    var ticking = false;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ var _toLeftRightCenter = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ var _alignStartEnd = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ var _textX = (align, left, right, rtl)=>{
    var check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    var pointCount = points.length;
    var start = 0;
    var count = pointCount;
    if (meta._sorted) {
        var iScale = meta.iScale, _parsed = meta._parsed;
        var axis = iScale.axis;
        var _iScale_getUserBounds = iScale.getUserBounds(), min = _iScale_getUserBounds.min, max = _iScale_getUserBounds.max, minDefined = _iScale_getUserBounds.minDefined, maxDefined = _iScale_getUserBounds.maxDefined;
        if (minDefined) start = _limitValue(Math.min(_lookupByKey(_parsed, axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = _limitValue(Math.max(_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    var xScale = meta.xScale, yScale = meta.yScale, _scaleRanges = meta._scaleRanges;
    var newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    var changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
var atEdge = (t)=>t === 0 || t === 1;
var elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
var elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        var s = 0.1125;
        var p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        var s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        var m = 7.5625;
        var d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
    if (value && typeof value === "object") {
        var type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value).saturate(0.5).darken(0.1).hexString();
}
var numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
var colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: colors
        },
        numbers: {
            type: "number",
            properties: numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
var intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    var cacheKey = locale + JSON.stringify(options);
    var formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}
var formatters = {
    values (value) {
        return isArray(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        var locale = this.chart.options.locale;
        var notation;
        var delta = tickValue;
        if (ticks.length > 1) {
            var maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = calculateDelta(tickValue, ticks);
        }
        var logDelta = log10(Math.abs(delta));
        var numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        var options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        var remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function calculateDelta(tickValue, ticks) {
    var delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var Ticks = {
    formatters
};
function applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
var overrides = Object.create(null);
var descriptors = Object.create(null);
function getScope$1(node, key) {
    if (!key) return node;
    var keys = key.split(".");
    for(var i = 0, n = keys.length; i < n; ++i){
        var k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === "string") return merge(getScope$1(root, scope), values);
    return merge(getScope$1(root, ""), scope);
}
class Defaults {
    set(scope, values) {
        return set(this, scope, values);
    }
    get(scope) {
        return getScope$1(this, scope);
    }
    describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        var scopeObject = getScope$1(this, scope);
        var targetScopeObject = getScope$1(this, targetScope);
        var privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    var local = this[privateName];
                    var target = targetScopeObject[targetName];
                    if (isObject(local)) return Object.assign({}, target, local);
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    var textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    var data = cache.data = cache.data || {};
    var gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    var longest = 0;
    var ilen = arrayOfThings.length;
    var i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) longest = _measureText(ctx, data, gc, longest, thing);
        else if (isArray(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    var gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    var devicePixelRatio = chart.currentDevicePixelRatio;
    var halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    var type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    var style = options.pointStyle;
    var rotation = options.rotation;
    var radius = options.radius;
    var rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            else ctx.arc(x, y, radius, 0, TAU);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += QUARTER_PI;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        var midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ var metrics = ctx.measureText(line);
        var left = x - metrics.actualBoundingBoxLeft;
        var right = x + metrics.actualBoundingBoxRight;
        var top = y - metrics.actualBoundingBoxAscent;
        var bottom = y + metrics.actualBoundingBoxDescent;
        var yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    var oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font) {
    var opts = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var lines = isArray(text) ? text : [
        text
    ];
    var stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    var i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    var x = rect.x, y = rect.y, w = rect.w, h = rect.h, radius = rect.radius;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
var LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
var FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    var matches = ("" + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
var numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    var ret = {};
    var objProps = isObject(props);
    var keys = objProps ? Object.keys(props) : props;
    var read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            ret[prop] = numberOrZero(read(prop));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    var obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    var size = valueOrDefault(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    var style = valueOrDefault(options.style, fallback.style);
    if (style && !("" + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    var font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ""
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    var cacheable = true;
    var i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    var min = minmax.min, max = minmax.max;
    var change = toDimension(grace, (max - min) / 2);
    var keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes) {
    var prefixes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        ""
    ], rootScopes = arguments.length > 2 ? arguments[2] : void 0, fallback = arguments.length > 3 ? arguments[3] : void 0, getTarget = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : ()=>scopes[0];
    var finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = _resolve("_fallback", scopes);
    var cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            var storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    var cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy) {
    var defaults = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        scriptable: true,
        indexable: true
    };
    var _proxy__scriptable = proxy._scriptable, _scriptable = _proxy__scriptable === void 0 ? defaults.scriptable : _proxy__scriptable, _proxy__indexable = proxy._indexable, _indexable = _proxy__indexable === void 0 ? defaults.indexable : _proxy__indexable, _proxy__allKeys = proxy._allKeys, _allKeys = _proxy__allKeys === void 0 ? defaults.allKeys : _proxy__allKeys;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
var readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
var needsSubResolver = (prop, value)=>isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    var value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, descriptors = target._descriptors;
    var value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) value = _resolveScriptable(prop, value, target, receiver);
    if (isArray(value) && value.length) value = _resolveArray(prop, value, target, descriptors.isIndexable);
    if (needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, _stack = target._stack;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    var value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, descriptors = target._descriptors;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        var arr = value;
        var scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var resolver = createSubResolver(scopes, _proxy, prop, item);
                value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
var getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parentScopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var parent = _step.value;
            var scope = getScope(key, parent);
            if (scope) {
                set.add(scope);
                var fallback = resolveFallback(scope._fallback, key, value);
                if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
                // The fallback will resume to that new scope.
                return fallback;
            } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
            // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
            return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    var rootScopes = resolver._rootScopes;
    var fallback = resolveFallback(resolver._fallback, prop, value);
    var allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    var set = new Set();
    set.add(value);
    var key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return _createResolver(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = addScopes(set, allScopes, key, fallback, item);
    return key;
}
function subGetTarget(resolver, prop, value) {
    var parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    var target = parent[prop];
    if (isArray(target) && isObject(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    var value;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prefix = _step.value;
            value = _resolve(readKey(prefix, prop), scopes);
            if (typeof value !== "undefined") return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function _resolve(key, scopes) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var scope = _step.value;
            if (!scope) continue;
            var value = scope[key];
            if (typeof value !== "undefined") return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function getKeysFromAllScopes(target) {
    var keys = target._keys;
    if (!keys) keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    var set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = scopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var scope = _step.value;
            try {
                for(var _iterator1 = Object.keys(scope).filter((k)=>!k.startsWith("_"))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var key = _step1.value;
                    set.add(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    var iScale = meta.iScale;
    var _this__parsing = this._parsing, _this__parsing_key = _this__parsing.key, key = _this__parsing_key === void 0 ? "r" : _this__parsing_key;
    var parsed = new Array(count);
    var i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}
var EPSILON = Number.EPSILON || 1e-14;
var getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
var getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    var previous = firstPoint.skip ? middlePoint : firstPoint;
    var current = middlePoint;
    var next = afterPoint.skip ? middlePoint : afterPoint;
    var d01 = distanceBetweenPoints(current, previous);
    var d12 = distanceBetweenPoints(next, current);
    var s01 = d01 / (d01 + d12);
    var s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    var fa = t * s01; // scaling factor for triangle Ta
    var fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    var pointsLen = points.length;
    var alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    var pointAfter = getPoint(points, 0);
    for(var i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK) {
    var indexAxis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x";
    var valueAxis = getValueAxis(indexAxis);
    var pointsLen = points.length;
    var delta, pointBefore, pointCurrent;
    var pointAfter = getPoint(points, 0);
    for(var i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        var iPixel = pointCurrent[indexAxis];
        var vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points) {
    var indexAxis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
    var valueAxis = getValueAxis(indexAxis);
    var pointsLen = points.length;
    var deltaK = Array(pointsLen).fill(0);
    var mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    var i, pointBefore, pointCurrent;
    var pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            var slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    var i, ilen, point, inArea, inAreaPrev;
    var inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    var i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") splineCurveMonotone(points, indexAxis);
    else {
        var prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function _isDomSupported() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function _getParentNode(domNode) {
    var parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    var valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
var getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
var positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function getPositionedStyle(styles, style, suffix) {
    var result = {};
    suffix = suffix ? "-" + suffix : "";
    for(var i = 0; i < 4; i++){
        var pos = positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
var useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    var touches = e.touches;
    var source = touches && touches.length ? touches[0] : e;
    var offsetX = source.offsetX, offsetY = source.offsetY;
    var box = false;
    var x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        var rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ("native" in event) return event;
    var canvas = chart.canvas, currentDevicePixelRatio = chart.currentDevicePixelRatio;
    var style = getComputedStyle(canvas);
    var borderBox = style.boxSizing === "border-box";
    var paddings = getPositionedStyle(style, "padding");
    var borders = getPositionedStyle(style, "border", "width");
    var _getCanvasPosition = getCanvasPosition(event, canvas), x = _getCanvasPosition.x, y = _getCanvasPosition.y, box = _getCanvasPosition.box;
    var xOffset = paddings.left + (box && borders.left);
    var yOffset = paddings.top + (box && borders.top);
    var width = chart.width, height = chart.height;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    var maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        var container = _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            var rect = container.getBoundingClientRect(); // this is the border box of the container
            var containerStyle = getComputedStyle(container);
            var containerBorder = getPositionedStyle(containerStyle, "border", "width");
            var containerPadding = getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
var round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    var style = getComputedStyle(canvas);
    var margins = getPositionedStyle(style, "margin");
    var maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
    var maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
    var containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    var width = containerSize.width, height = containerSize.height;
    if (style.boxSizing === "content-box") {
        var borders = getPositionedStyle(style, "border", "width");
        var paddings = getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
    var maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    var pixelRatio = forceRatio || 1;
    var deviceHeight = Math.floor(chart.height * pixelRatio);
    var deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    var canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
    var passiveSupported = false;
    try {
        var options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    var value = getStyle(element, property);
    var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    var cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    var cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    var a = _pointInLine(p1, cp1, t);
    var b = _pointInLine(cp1, cp2, t);
    var c = _pointInLine(cp2, p2, t);
    var d = _pointInLine(a, b, t);
    var e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}
var getRightToLeftAdapter = function getRightToLeftAdapter(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
var getLeftToRightAdapter = function getLeftToRightAdapter() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    var style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function propertyFn(property) {
    if (property === "angle") return {
        between: _angleBetween,
        compare: _angleDiff,
        normalize: _normalizeAngle
    };
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment(param) {
    var start = param.start, end = param.end, count = param.count, loop = param.loop, style = param.style;
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    var property = bounds.property, startBound = bounds.start, endBound = bounds.end;
    var _propertyFn = propertyFn(property), between = _propertyFn.between, normalize = _propertyFn.normalize;
    var count = points.length;
    var start = segment.start, end = segment.end, loop = segment.loop;
    var i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
function _boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    var property = bounds.property, startBound = bounds.start, endBound = bounds.end;
    var count = points.length;
    var _propertyFn = propertyFn(property), compare = _propertyFn.compare, between = _propertyFn.between, normalize = _propertyFn.normalize;
    var _getSegment = getSegment(segment, points, bounds), start = _getSegment.start, end = _getSegment.end, loop = _getSegment.loop, style = _getSegment.style;
    var result = [];
    var inside = false;
    var subStart = null;
    var value, point, prevValue;
    var startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    var endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    var shouldStart = ()=>inside || startIsBefore();
    var shouldStop = ()=>!inside || endIsBefore();
    for(var i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push(normalizeSegment({
        start: subStart,
        end,
        loop,
        count,
        style
    }));
    return result;
}
function _boundSegments(line, bounds) {
    var result = [];
    var segments = line.segments;
    for(var i = 0; i < segments.length; i++){
        var sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
    var start = 0;
    var end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start,
        end
    };
}
function solidSegments(points, start, max, loop) {
    var count = points.length;
    var result = [];
    var last = start;
    var prev = points[start];
    var end;
    for(end = start + 1; end <= max; ++end){
        var cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop
    });
    return result;
}
function _computeSegments(line, segmentOptions) {
    var points = line.points;
    var spanGaps = line.options.spanGaps;
    var count = points.length;
    if (!count) return [];
    var loop = !!line._loop;
    var _findStartAndEnd = findStartAndEnd(points, count, loop, spanGaps), start = _findStartAndEnd.start, end = _findStartAndEnd.end;
    if (spanGaps === true) return splitByStyles(line, [
        {
            start,
            end,
            loop
        }
    ], points, segmentOptions);
    var max = end < start ? end + count : end;
    var completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
    var chartContext = line._chart.getContext();
    var baseStyle = readStyle(line.options);
    var datasetIndex = line._datasetIndex, spanGaps = line.options.spanGaps;
    var count = points.length;
    var result = [];
    var prevStyle = baseStyle;
    var start = segments[0].start;
    var i = start;
    function addStyle(s, e, l, st) {
        var dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            start = spanGaps ? start : segment.start;
            var prev = points[start % count];
            var style = void 0;
            for(i = start + 1; i <= segment.end; i++){
                var pt = points[i % count];
                style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                    type: "segment",
                    p0: prev,
                    p1: pt,
                    p0DataIndex: (i - 1) % count,
                    p1DataIndex: i % count,
                    datasetIndex
                })));
                if (styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
                prev = pt;
                prevStyle = style;
            }
            if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    var cache = [];
    var replacer = function replacer(key, value) {
        if (!isPatternOrGradient(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

},{"@kurkle/color":"doBck","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"doBck":[function(require,module,exports) {
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "b2n", ()=>b2n);
parcelHelpers.export(exports, "b2p", ()=>b2p);
parcelHelpers.export(exports, "default", ()=>index_esm);
parcelHelpers.export(exports, "hexParse", ()=>hexParse);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "hsl2rgb", ()=>hsl2rgb);
parcelHelpers.export(exports, "hslString", ()=>hslString);
parcelHelpers.export(exports, "hsv2rgb", ()=>hsv2rgb);
parcelHelpers.export(exports, "hueParse", ()=>hueParse);
parcelHelpers.export(exports, "hwb2rgb", ()=>hwb2rgb);
parcelHelpers.export(exports, "lim", ()=>lim);
parcelHelpers.export(exports, "n2b", ()=>n2b);
parcelHelpers.export(exports, "n2p", ()=>n2p);
parcelHelpers.export(exports, "nameParse", ()=>nameParse);
parcelHelpers.export(exports, "p2b", ()=>p2b);
parcelHelpers.export(exports, "rgb2hsl", ()=>rgb2hsl);
parcelHelpers.export(exports, "rgbParse", ()=>rgbParse);
parcelHelpers.export(exports, "rgbString", ()=>rgbString);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "round", ()=>round);
function round(v) {
    return v + 0.5 | 0;
}
var lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function p2b(v) {
    return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
    return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
    return lim(round(v * 255), 0, 255);
}
function b2n(v) {
    return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
    return lim(round(v * 100), 0, 100);
}
var map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
var hex = [
    ..."0123456789ABCDEF"
];
var h1 = (b)=>hex[b & 0xF];
var h2 = (b)=>hex[(b & 0xF0) >> 4] + hex[b & 0xF];
var eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
var isShort = (v)=>eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & map$1[str[1]] * 17,
            g: 255 & map$1[str[2]] * 17,
            b: 255 & map$1[str[3]] * 17,
            a: len === 5 ? map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: map$1[str[1]] << 4 | map$1[str[2]],
            g: map$1[str[3]] << 4 | map$1[str[4]],
            b: map$1[str[5]] << 4 | map$1[str[6]],
            a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
        };
    }
    return ret;
}
var alpha = (a, f)=>a < 255 ? f(a) : "";
function hexString(v) {
    var f = isShort(v) ? h1 : h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
var HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
    var a = s * Math.min(l, 1 - l);
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function hsv2rgbn(h, s, v) {
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 60) % 6;
        return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    };
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function hwb2rgbn(h, w, b) {
    var rgb = hsl2rgbn(h, 1, 0.5);
    var i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function rgb2hsl(v) {
    var range = 255;
    var r = v.r / range;
    var g = v.g / range;
    var b = v.b / range;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var l = (max + min) / 2;
    var h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
    return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
    return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
    return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
    return (h % 360 + 360) % 360;
}
function hueParse(str) {
    var m = HUE_RE.exec(str);
    var a = 255;
    var v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
    var h = hue(+m[2]);
    var p1 = +m[3] / 100;
    var p2 = +m[4] / 100;
    if (m[1] === "hwb") v = hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = hsv2rgb(h, p1, p2);
    else v = hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function rotate(v, deg) {
    var h = rgb2hsl(v);
    h[0] = hue(h[0] + deg);
    h = hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function hslString(v) {
    if (!v) return;
    var a = rgb2hsl(v);
    var h = a[0];
    var s = n2p(a[1]);
    var l = n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
var map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
var names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function unpack() {
    var unpacked = {};
    var keys = Object.keys(names$1);
    var tkeys = Object.keys(map);
    var i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, map[k]);
        }
        k = parseInt(names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
var names;
function nameParse(str) {
    if (!names) {
        names = unpack();
        names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    var a = names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
var RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
    var m = RGB_RE.exec(str);
    var a = 255;
    var r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        var v = +m[7];
        a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
    g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
    b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
var to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
var from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
    var r = from(b2n(rgb1.r));
    var g = from(b2n(rgb1.g));
    var b = from(b2n(rgb1.b));
    return {
        r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
        g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
        b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function modHSL(v, i, ratio) {
    if (v) {
        var tmp = rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = n2b(input[3]);
        }
    } else {
        v = clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = n2b(v.a);
    }
    return v;
}
function functionParse(str) {
    if (str.charAt(0) === "r") return rgbParse(str);
    return hueParse(str);
}
class Color {
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = clone(this._rgb);
        if (v) v.a = b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = fromObject(obj);
    }
    rgbString() {
        return this._valid ? rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            var c1 = this.rgb;
            var c2 = color.rgb;
            var w2;
            var p = weight === w2 ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = c1.a - c2.a;
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = n2b(a);
        return this;
    }
    clearer(ratio) {
        var rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        var rgb = this._rgb;
        var val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        var rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        var v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        rotate(this._rgb, deg);
        return this;
    }
    constructor(input){
        if (input instanceof Color) return input;
        var type = typeof input;
        var v;
        if (type === "object") v = fromObject(input);
        else if (type === "string") v = hexParse(input) || nameParse(input) || functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
}
function index_esm(input) {
    return new Color(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"3NiGM":[function(require,module,exports) {
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>plugin);
var _helpers = require("chart.js/helpers");
var _chartJs = require("chart.js");
var devicePixelRatio = function() {
    if (typeof window !== "undefined") {
        if (window.devicePixelRatio) return window.devicePixelRatio;
        // devicePixelRatio is undefined on IE10
        // https://stackoverflow.com/a/20204180/8837887
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
        var screen = window.screen;
        if (screen) return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
    return 1;
}();
var utils = {
    // @todo move this in Chart.helpers.toTextLines
    toTextLines: function toTextLines(inputs) {
        var lines = [];
        var input;
        inputs = [].concat(inputs);
        while(inputs.length){
            input = inputs.pop();
            if (typeof input === "string") lines.unshift.apply(lines, input.split("\n"));
            else if (Array.isArray(input)) inputs.push.apply(inputs, input);
            else if (!(0, _helpers.isNullOrUndef)(inputs)) lines.unshift("" + input);
        }
        return lines;
    },
    // @todo move this in Chart.helpers.canvas.textSize
    // @todo cache calls of measureText if font doesn't change?!
    textSize: function textSize(ctx, lines, font) {
        var items = [].concat(lines);
        var ilen = items.length;
        var prev = ctx.font;
        var width = 0;
        var i;
        ctx.font = font.string;
        for(i = 0; i < ilen; ++i)width = Math.max(ctx.measureText(items[i]).width, width);
        ctx.font = prev;
        return {
            height: ilen * font.lineHeight,
            width: width
        };
    },
    /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */ bound: function bound(min, value, max) {
        return Math.max(min, Math.min(value, max));
    },
    /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */ arrayDiff: function arrayDiff(a0, a1) {
        var prev = a0.slice();
        var updates = [];
        var i, j, ilen, v;
        for(i = 0, ilen = a1.length; i < ilen; ++i){
            v = a1[i];
            j = prev.indexOf(v);
            if (j === -1) updates.push([
                v,
                1
            ]);
            else prev.splice(j, 1);
        }
        for(i = 0, ilen = prev.length; i < ilen; ++i)updates.push([
            prev[i],
            -1
        ]);
        return updates;
    },
    /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */ rasterize: function rasterize(v) {
        return Math.round(v * devicePixelRatio) / devicePixelRatio;
    }
};
function orient(point, origin) {
    var x0 = origin.x;
    var y0 = origin.y;
    if (x0 === null) return {
        x: 0,
        y: -1
    };
    if (y0 === null) return {
        x: 1,
        y: 0
    };
    var dx = point.x - x0;
    var dy = point.y - y0;
    var ln = Math.sqrt(dx * dx + dy * dy);
    return {
        x: ln ? dx / ln : 0,
        y: ln ? dy / ln : -1
    };
}
function aligned(x, y, vx, vy, align) {
    switch(align){
        case "center":
            vx = vy = 0;
            break;
        case "bottom":
            vx = 0;
            vy = 1;
            break;
        case "right":
            vx = 1;
            vy = 0;
            break;
        case "left":
            vx = -1;
            vy = 0;
            break;
        case "top":
            vx = 0;
            vy = -1;
            break;
        case "start":
            vx = -vx;
            vy = -vy;
            break;
        case "end":
            break;
        default:
            // clockwise rotation (in degree)
            align *= Math.PI / 180;
            vx = Math.cos(align);
            vy = Math.sin(align);
            break;
    }
    return {
        x: x,
        y: y,
        vx: vx,
        vy: vy
    };
}
// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm
var R_INSIDE = 0;
var R_LEFT = 1;
var R_RIGHT = 2;
var R_BOTTOM = 4;
var R_TOP = 8;
function region(x, y, rect) {
    var res = R_INSIDE;
    if (x < rect.left) res |= R_LEFT;
    else if (x > rect.right) res |= R_RIGHT;
    if (y < rect.top) res |= R_TOP;
    else if (y > rect.bottom) res |= R_BOTTOM;
    return res;
}
function clipped(segment, area) {
    var x0 = segment.x0;
    var y0 = segment.y0;
    var x1 = segment.x1;
    var y1 = segment.y1;
    var r0 = region(x0, y0, area);
    var r1 = region(x1, y1, area);
    var r, x, y;
    // eslint-disable-next-line no-constant-condition
    while(true){
        if (!(r0 | r1) || r0 & r1) break;
        // at least one point is outside
        r = r0 || r1;
        if (r & R_TOP) {
            x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
            y = area.top;
        } else if (r & R_BOTTOM) {
            x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
            y = area.bottom;
        } else if (r & R_RIGHT) {
            y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
            x = area.right;
        } else if (r & R_LEFT) {
            y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
            x = area.left;
        }
        if (r === r0) {
            x0 = x;
            y0 = y;
            r0 = region(x0, y0, area);
        } else {
            x1 = x;
            y1 = y;
            r1 = region(x1, y1, area);
        }
    }
    return {
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1
    };
}
function compute$1(range, config) {
    var anchor = config.anchor;
    var segment = range;
    var x, y;
    if (config.clamp) segment = clipped(segment, config.area);
    if (anchor === "start") {
        x = segment.x0;
        y = segment.y0;
    } else if (anchor === "end") {
        x = segment.x1;
        y = segment.y1;
    } else {
        x = (segment.x0 + segment.x1) / 2;
        y = (segment.y0 + segment.y1) / 2;
    }
    return aligned(x, y, range.vx, range.vy, config.align);
}
var positioners = {
    arc: function arc(el, config) {
        var angle = (el.startAngle + el.endAngle) / 2;
        var vx = Math.cos(angle);
        var vy = Math.sin(angle);
        var r0 = el.innerRadius;
        var r1 = el.outerRadius;
        return compute$1({
            x0: el.x + vx * r0,
            y0: el.y + vy * r0,
            x1: el.x + vx * r1,
            y1: el.y + vy * r1,
            vx: vx,
            vy: vy
        }, config);
    },
    point: function point(el, config) {
        var v = orient(el, config.origin);
        var rx = v.x * el.options.radius;
        var ry = v.y * el.options.radius;
        return compute$1({
            x0: el.x - rx,
            y0: el.y - ry,
            x1: el.x + rx,
            y1: el.y + ry,
            vx: v.x,
            vy: v.y
        }, config);
    },
    bar: function bar(el, config) {
        var v = orient(el, config.origin);
        var x = el.x;
        var y = el.y;
        var sx = 0;
        var sy = 0;
        if (el.horizontal) {
            x = Math.min(el.x, el.base);
            sx = Math.abs(el.base - el.x);
        } else {
            y = Math.min(el.y, el.base);
            sy = Math.abs(el.base - el.y);
        }
        return compute$1({
            x0: x,
            y0: y + sy,
            x1: x + sx,
            y1: y,
            vx: v.x,
            vy: v.y
        }, config);
    },
    fallback: function fallback(el, config) {
        var v = orient(el, config.origin);
        return compute$1({
            x0: el.x,
            y0: el.y,
            x1: el.x + (el.width || 0),
            y1: el.y + (el.height || 0),
            vx: v.x,
            vy: v.y
        }, config);
    }
};
var rasterize = utils.rasterize;
function boundingRects(model) {
    var borderWidth = model.borderWidth || 0;
    var padding = model.padding;
    var th = model.size.height;
    var tw = model.size.width;
    var tx = -tw / 2;
    var ty = -th / 2;
    return {
        frame: {
            x: tx - padding.left - borderWidth,
            y: ty - padding.top - borderWidth,
            w: tw + padding.width + borderWidth * 2,
            h: th + padding.height + borderWidth * 2
        },
        text: {
            x: tx,
            y: ty,
            w: tw,
            h: th
        }
    };
}
function getScaleOrigin(el, context) {
    var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;
    if (!scale) return null;
    if (scale.xCenter !== undefined && scale.yCenter !== undefined) return {
        x: scale.xCenter,
        y: scale.yCenter
    };
    var pixel = scale.getBasePixel();
    return el.horizontal ? {
        x: pixel,
        y: null
    } : {
        x: null,
        y: pixel
    };
}
function getPositioner(el) {
    if (el instanceof (0, _chartJs.ArcElement)) return positioners.arc;
    if (el instanceof (0, _chartJs.PointElement)) return positioners.point;
    if (el instanceof (0, _chartJs.BarElement)) return positioners.bar;
    return positioners.fallback;
}
function drawRoundedRect(ctx, x, y, w, h, radius) {
    var HALF_PI = Math.PI / 2;
    if (radius) {
        var r = Math.min(radius, h / 2, w / 2);
        var left = x + r;
        var top = y + r;
        var right = x + w - r;
        var bottom = y + h - r;
        ctx.moveTo(x, top);
        if (left < right && top < bottom) {
            ctx.arc(left, top, r, -Math.PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, Math.PI);
        } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, Math.PI + HALF_PI);
        } else if (top < bottom) {
            ctx.arc(left, top, r, -Math.PI, 0);
            ctx.arc(left, bottom, r, 0, Math.PI);
        } else ctx.arc(left, top, r, -Math.PI, Math.PI);
        ctx.closePath();
        ctx.moveTo(x, y);
    } else ctx.rect(x, y, w, h);
}
function drawFrame(ctx, rect, model) {
    var bgColor = model.backgroundColor;
    var borderColor = model.borderColor;
    var borderWidth = model.borderWidth;
    if (!bgColor && (!borderColor || !borderWidth)) return;
    ctx.beginPath();
    drawRoundedRect(ctx, rasterize(rect.x) + borderWidth / 2, rasterize(rect.y) + borderWidth / 2, rasterize(rect.w) - borderWidth, rasterize(rect.h) - borderWidth, model.borderRadius);
    ctx.closePath();
    if (bgColor) {
        ctx.fillStyle = bgColor;
        ctx.fill();
    }
    if (borderColor && borderWidth) {
        ctx.strokeStyle = borderColor;
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = "miter";
        ctx.stroke();
    }
}
function textGeometry(rect, align, font) {
    var h = font.lineHeight;
    var w = rect.w;
    var x = rect.x;
    var y = rect.y + h / 2;
    if (align === "center") x += w / 2;
    else if (align === "end" || align === "right") x += w;
    return {
        h: h,
        w: w,
        x: x,
        y: y
    };
}
function drawTextLine(ctx, text, cfg) {
    var shadow = ctx.shadowBlur;
    var stroked = cfg.stroked;
    var x = rasterize(cfg.x);
    var y = rasterize(cfg.y);
    var w = rasterize(cfg.w);
    if (stroked) ctx.strokeText(text, x, y, w);
    if (cfg.filled) {
        if (shadow && stroked) // Prevent drawing shadow on both the text stroke and fill, so
        // if the text is stroked, remove the shadow for the text fill.
        ctx.shadowBlur = 0;
        ctx.fillText(text, x, y, w);
        if (shadow && stroked) ctx.shadowBlur = shadow;
    }
}
function drawText(ctx, lines, rect, model) {
    var align = model.textAlign;
    var color = model.color;
    var filled = !!color;
    var font = model.font;
    var ilen = lines.length;
    var strokeColor = model.textStrokeColor;
    var strokeWidth = model.textStrokeWidth;
    var stroked = strokeColor && strokeWidth;
    var i;
    if (!ilen || !filled && !stroked) return;
    // Adjust coordinates based on text alignment and line height
    rect = textGeometry(rect, align, font);
    ctx.font = font.string;
    ctx.textAlign = align;
    ctx.textBaseline = "middle";
    ctx.shadowBlur = model.textShadowBlur;
    ctx.shadowColor = model.textShadowColor;
    if (filled) ctx.fillStyle = color;
    if (stroked) {
        ctx.lineJoin = "round";
        ctx.lineWidth = strokeWidth;
        ctx.strokeStyle = strokeColor;
    }
    for(i = 0, ilen = lines.length; i < ilen; ++i)drawTextLine(ctx, lines[i], {
        stroked: stroked,
        filled: filled,
        w: rect.w,
        x: rect.x,
        y: rect.y + rect.h * i
    });
}
var Label = function Label(config, ctx, el, index) {
    var me = this;
    me._config = config;
    me._index = index;
    me._model = null;
    me._rects = null;
    me._ctx = ctx;
    me._el = el;
};
(0, _helpers.merge)(Label.prototype, {
    /**
   * @private
   */ _modelize: function _modelize(display, lines, config, context) {
        var me = this;
        var index = me._index;
        var font = (0, _helpers.toFont)((0, _helpers.resolve)([
            config.font,
            {}
        ], context, index));
        var color = (0, _helpers.resolve)([
            config.color,
            (0, _chartJs.defaults).color
        ], context, index);
        return {
            align: (0, _helpers.resolve)([
                config.align,
                "center"
            ], context, index),
            anchor: (0, _helpers.resolve)([
                config.anchor,
                "center"
            ], context, index),
            area: context.chart.chartArea,
            backgroundColor: (0, _helpers.resolve)([
                config.backgroundColor,
                null
            ], context, index),
            borderColor: (0, _helpers.resolve)([
                config.borderColor,
                null
            ], context, index),
            borderRadius: (0, _helpers.resolve)([
                config.borderRadius,
                0
            ], context, index),
            borderWidth: (0, _helpers.resolve)([
                config.borderWidth,
                0
            ], context, index),
            clamp: (0, _helpers.resolve)([
                config.clamp,
                false
            ], context, index),
            clip: (0, _helpers.resolve)([
                config.clip,
                false
            ], context, index),
            color: color,
            display: display,
            font: font,
            lines: lines,
            offset: (0, _helpers.resolve)([
                config.offset,
                4
            ], context, index),
            opacity: (0, _helpers.resolve)([
                config.opacity,
                1
            ], context, index),
            origin: getScaleOrigin(me._el, context),
            padding: (0, _helpers.toPadding)((0, _helpers.resolve)([
                config.padding,
                4
            ], context, index)),
            positioner: getPositioner(me._el),
            rotation: (0, _helpers.resolve)([
                config.rotation,
                0
            ], context, index) * (Math.PI / 180),
            size: utils.textSize(me._ctx, lines, font),
            textAlign: (0, _helpers.resolve)([
                config.textAlign,
                "start"
            ], context, index),
            textShadowBlur: (0, _helpers.resolve)([
                config.textShadowBlur,
                0
            ], context, index),
            textShadowColor: (0, _helpers.resolve)([
                config.textShadowColor,
                color
            ], context, index),
            textStrokeColor: (0, _helpers.resolve)([
                config.textStrokeColor,
                color
            ], context, index),
            textStrokeWidth: (0, _helpers.resolve)([
                config.textStrokeWidth,
                0
            ], context, index)
        };
    },
    update: function update(context) {
        var me = this;
        var model = null;
        var rects = null;
        var index = me._index;
        var config = me._config;
        var value, label, lines;
        // We first resolve the display option (separately) to avoid computing
        // other options in case the label is hidden (i.e. display: false).
        var display = (0, _helpers.resolve)([
            config.display,
            true
        ], context, index);
        if (display) {
            value = context.dataset.data[index];
            label = (0, _helpers.valueOrDefault)((0, _helpers.callback)(config.formatter, [
                value,
                context
            ]), value);
            lines = (0, _helpers.isNullOrUndef)(label) ? [] : utils.toTextLines(label);
            if (lines.length) {
                model = me._modelize(display, lines, config, context);
                rects = boundingRects(model);
            }
        }
        me._model = model;
        me._rects = rects;
    },
    geometry: function geometry() {
        return this._rects ? this._rects.frame : {};
    },
    rotation: function rotation() {
        return this._model ? this._model.rotation : 0;
    },
    visible: function visible() {
        return this._model && this._model.opacity;
    },
    model: function model() {
        return this._model;
    },
    draw: function draw(chart, center) {
        var me = this;
        var ctx = chart.ctx;
        var model = me._model;
        var rects = me._rects;
        var area;
        if (!this.visible()) return;
        ctx.save();
        if (model.clip) {
            area = model.area;
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        }
        ctx.globalAlpha = utils.bound(0, model.opacity, 1);
        ctx.translate(rasterize(center.x), rasterize(center.y));
        ctx.rotate(model.rotation);
        drawFrame(ctx, rects.frame, model);
        drawText(ctx, model.lines, rects.text, model);
        ctx.restore();
    }
});
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991; // eslint-disable-line es/no-number-maxsafeinteger
function rotated(point, center, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var cx = center.x;
    var cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
function projected(points, axis) {
    var min = MAX_INTEGER;
    var max = MIN_INTEGER;
    var origin = axis.origin;
    var i, pt, vx, vy, dp;
    for(i = 0; i < points.length; ++i){
        pt = points[i];
        vx = pt.x - origin.x;
        vy = pt.y - origin.y;
        dp = axis.vx * vx + axis.vy * vy;
        min = Math.min(min, dp);
        max = Math.max(max, dp);
    }
    return {
        min: min,
        max: max
    };
}
function toAxis(p0, p1) {
    var vx = p1.x - p0.x;
    var vy = p1.y - p0.y;
    var ln = Math.sqrt(vx * vx + vy * vy);
    return {
        vx: (p1.x - p0.x) / ln,
        vy: (p1.y - p0.y) / ln,
        origin: p0,
        ln: ln
    };
}
var HitBox = function HitBox() {
    this._rotation = 0;
    this._rect = {
        x: 0,
        y: 0,
        w: 0,
        h: 0
    };
};
(0, _helpers.merge)(HitBox.prototype, {
    center: function center() {
        var r = this._rect;
        return {
            x: r.x + r.w / 2,
            y: r.y + r.h / 2
        };
    },
    update: function update(center, rect, rotation) {
        this._rotation = rotation;
        this._rect = {
            x: rect.x + center.x,
            y: rect.y + center.y,
            w: rect.w,
            h: rect.h
        };
    },
    contains: function contains(point) {
        var me = this;
        var margin = 1;
        var rect = me._rect;
        point = rotated(point, me.center(), -me._rotation);
        return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
    },
    // Separating Axis Theorem
    // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
    intersects: function intersects(other) {
        var r0 = this._points();
        var r1 = other._points();
        var axes = [
            toAxis(r0[0], r0[1]),
            toAxis(r0[0], r0[3])
        ];
        var i, pr0, pr1;
        if (this._rotation !== other._rotation) // Only separate with r1 axis if the rotation is different,
        // else it's enough to separate r0 and r1 with r0 axis only!
        axes.push(toAxis(r1[0], r1[1]), toAxis(r1[0], r1[3]));
        for(i = 0; i < axes.length; ++i){
            pr0 = projected(r0, axes[i]);
            pr1 = projected(r1, axes[i]);
            if (pr0.max < pr1.min || pr1.max < pr0.min) return false;
        }
        return true;
    },
    /**
   * @private
   */ _points: function _points() {
        var me = this;
        var rect = me._rect;
        var angle = me._rotation;
        var center = me.center();
        return [
            rotated({
                x: rect.x,
                y: rect.y
            }, center, angle),
            rotated({
                x: rect.x + rect.w,
                y: rect.y
            }, center, angle),
            rotated({
                x: rect.x + rect.w,
                y: rect.y + rect.h
            }, center, angle),
            rotated({
                x: rect.x,
                y: rect.y + rect.h
            }, center, angle)
        ];
    }
});
function coordinates(el, model, geometry) {
    var point = model.positioner(el, model);
    var vx = point.vx;
    var vy = point.vy;
    if (!vx && !vy) // if aligned center, we don't want to offset the center point
    return {
        x: point.x,
        y: point.y
    };
    var w = geometry.w;
    var h = geometry.h;
    // take in account the label rotation
    var rotation = model.rotation;
    var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
    var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));
    // scale the unit vector (vx, vy) to get at least dx or dy equal to
    // w or h respectively (else we would calculate the distance to the
    // ellipse inscribed in the bounding rect)
    var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
    dx *= vx * vs;
    dy *= vy * vs;
    // finally, include the explicit offset
    dx += model.offset * vx;
    dy += model.offset * vy;
    return {
        x: point.x + dx,
        y: point.y + dy
    };
}
function collide(labels, collider) {
    var i, j, s0, s1;
    // IMPORTANT Iterate in the reverse order since items at the end of the
    // list have an higher weight/priority and thus should be less impacted
    // by the overlapping strategy.
    for(i = labels.length - 1; i >= 0; --i){
        s0 = labels[i].$layout;
        for(j = i - 1; j >= 0 && s0._visible; --j){
            s1 = labels[j].$layout;
            if (s1._visible && s0._box.intersects(s1._box)) collider(s0, s1);
        }
    }
    return labels;
}
function compute(labels) {
    var i, ilen, label, state, geometry, center, proxy;
    // Initialize labels for overlap detection
    for(i = 0, ilen = labels.length; i < ilen; ++i){
        label = labels[i];
        state = label.$layout;
        if (state._visible) {
            // Chart.js 3 removed el._model in favor of getProps(), making harder to
            // abstract reading values in positioners. Also, using string arrays to
            // read values (i.e. var {a,b,c} = el.getProps(["a","b","c"])) would make
            // positioners inefficient in the normal case (i.e. not the final values)
            // and the code a bit ugly, so let's use a Proxy instead.
            proxy = new Proxy(label._el, {
                get: (el, p)=>el.getProps([
                        p
                    ], true)[p]
            });
            geometry = label.geometry();
            center = coordinates(proxy, label.model(), geometry);
            state._box.update(center, geometry, label.rotation());
        }
    }
    // Auto hide overlapping labels
    return collide(labels, function(s0, s1) {
        var h0 = s0._hidable;
        var h1 = s1._hidable;
        if (h0 && h1 || h1) s1._visible = false;
        else if (h0) s0._visible = false;
    });
}
var layout = {
    prepare: function prepare(datasets) {
        var labels = [];
        var i, j, ilen, jlen, label;
        for(i = 0, ilen = datasets.length; i < ilen; ++i)for(j = 0, jlen = datasets[i].length; j < jlen; ++j){
            label = datasets[i][j];
            labels.push(label);
            label.$layout = {
                _box: new HitBox(),
                _hidable: false,
                _visible: true,
                _set: i,
                _idx: label._index
            };
        }
        // TODO New `z` option: labels with a higher z-index are drawn
        // of top of the ones with a lower index. Lowest z-index labels
        // are also discarded first when hiding overlapping labels.
        labels.sort(function(a, b) {
            var sa = a.$layout;
            var sb = b.$layout;
            return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
        });
        this.update(labels);
        return labels;
    },
    update: function update(labels) {
        var dirty = false;
        var i, ilen, label, model, state;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            model = label.model();
            state = label.$layout;
            state._hidable = model && model.display === "auto";
            state._visible = label.visible();
            dirty |= state._hidable;
        }
        if (dirty) compute(labels);
    },
    lookup: function lookup(labels, point) {
        var i, state;
        // IMPORTANT Iterate in the reverse order since items at the end of
        // the list have an higher z-index, thus should be picked first.
        for(i = labels.length - 1; i >= 0; --i){
            state = labels[i].$layout;
            if (state && state._visible && state._box.contains(point)) return labels[i];
        }
        return null;
    },
    draw: function draw(chart, labels) {
        var i, ilen, label, state, geometry, center;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            state = label.$layout;
            if (state._visible) {
                geometry = label.geometry();
                center = coordinates(label._el, label.model(), geometry);
                state._box.update(center, geometry, label.rotation());
                label.draw(chart, center);
            }
        }
    }
};
var formatter = function formatter(value) {
    if ((0, _helpers.isNullOrUndef)(value)) return null;
    var label = value;
    var keys, klen, k;
    if ((0, _helpers.isObject)(value)) {
        if (!(0, _helpers.isNullOrUndef)(value.label)) label = value.label;
        else if (!(0, _helpers.isNullOrUndef)(value.r)) label = value.r;
        else {
            label = "";
            keys = Object.keys(value);
            for(k = 0, klen = keys.length; k < klen; ++k)label += (k !== 0 ? ", " : "") + keys[k] + ": " + value[keys[k]];
        }
    }
    return "" + label;
};
/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */ var defaults = {
    align: "center",
    anchor: "center",
    backgroundColor: null,
    borderColor: null,
    borderRadius: 0,
    borderWidth: 0,
    clamp: false,
    clip: false,
    color: undefined,
    display: true,
    font: {
        family: undefined,
        lineHeight: 1.2,
        size: undefined,
        style: undefined,
        weight: null
    },
    formatter: formatter,
    labels: undefined,
    listeners: {},
    offset: 4,
    opacity: 1,
    padding: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
    },
    rotation: 0,
    textAlign: "start",
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    textShadowBlur: 0,
    textShadowColor: undefined
};
/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */ var EXPANDO_KEY = "$datalabels";
var DEFAULT_KEY = "$default";
function configure(dataset, options) {
    var override = dataset.datalabels;
    var listeners = {};
    var configs = [];
    var labels, keys;
    if (override === false) return null;
    if (override === true) override = {};
    options = (0, _helpers.merge)({}, [
        options,
        override
    ]);
    labels = options.labels || {};
    keys = Object.keys(labels);
    delete options.labels;
    if (keys.length) keys.forEach(function(key) {
        if (labels[key]) configs.push((0, _helpers.merge)({}, [
            options,
            labels[key],
            {
                _key: key
            }
        ]));
    });
    else // Default label if no "named" label defined.
    configs.push(options);
    // listeners: {<event-type>: {<label-key>: <fn>}}
    listeners = configs.reduce(function(target, config) {
        (0, _helpers.each)(config.listeners || {}, function(fn, event) {
            target[event] = target[event] || {};
            target[event][config._key || DEFAULT_KEY] = fn;
        });
        delete config.listeners;
        return target;
    }, {});
    return {
        labels: configs,
        listeners: listeners
    };
}
function dispatchEvent(chart, listeners, label, event) {
    if (!listeners) return;
    var context = label.$context;
    var groups = label.$groups;
    var callback$1;
    if (!listeners[groups._set]) return;
    callback$1 = listeners[groups._set][groups._key];
    if (!callback$1) return;
    if ((0, _helpers.callback)(callback$1, [
        context,
        event
    ]) === true) {
        // Users are allowed to tweak the given context by injecting values that can be
        // used in scriptable options to display labels differently based on the current
        // event (e.g. highlight an hovered label). That's why we update the label with
        // the output context and schedule a new chart render by setting it dirty.
        chart[EXPANDO_KEY]._dirty = true;
        label.update(context);
    }
}
function dispatchMoveEvents(chart, listeners, previous, label, event) {
    var enter, leave;
    if (!previous && !label) return;
    if (!previous) enter = true;
    else if (!label) leave = true;
    else if (previous !== label) leave = enter = true;
    if (leave) dispatchEvent(chart, listeners.leave, previous, event);
    if (enter) dispatchEvent(chart, listeners.enter, label, event);
}
function handleMoveEvents(chart, event) {
    var expando = chart[EXPANDO_KEY];
    var listeners = expando._listeners;
    var previous, label;
    if (!listeners.enter && !listeners.leave) return;
    if (event.type === "mousemove") label = layout.lookup(expando._labels, event);
    else if (event.type !== "mouseout") return;
    previous = expando._hovered;
    expando._hovered = label;
    dispatchMoveEvents(chart, listeners, previous, label, event);
}
function handleClickEvents(chart, event) {
    var expando = chart[EXPANDO_KEY];
    var handlers = expando._listeners.click;
    var label = handlers && layout.lookup(expando._labels, event);
    if (label) dispatchEvent(chart, handlers, label, event);
}
var plugin = {
    id: "datalabels",
    defaults: defaults,
    beforeInit: function beforeInit(chart) {
        chart[EXPANDO_KEY] = {
            _actives: []
        };
    },
    beforeUpdate: function beforeUpdate(chart) {
        var expando = chart[EXPANDO_KEY];
        expando._listened = false;
        expando._listeners = {}; // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
        expando._datasets = []; // per dataset labels: [Label[]]
        expando._labels = []; // layouted labels: Label[]
    },
    afterDatasetUpdate: function afterDatasetUpdate(chart, args, options) {
        var datasetIndex = args.index;
        var expando = chart[EXPANDO_KEY];
        var labels = expando._datasets[datasetIndex] = [];
        var visible = chart.isDatasetVisible(datasetIndex);
        var dataset = chart.data.datasets[datasetIndex];
        var config = configure(dataset, options);
        var elements = args.meta.data || [];
        var ctx = chart.ctx;
        var i, j, ilen, jlen, cfg, key, el, label;
        ctx.save();
        for(i = 0, ilen = elements.length; i < ilen; ++i){
            el = elements[i];
            el[EXPANDO_KEY] = [];
            if (visible && el && chart.getDataVisibility(i) && !el.skip) for(j = 0, jlen = config.labels.length; j < jlen; ++j){
                cfg = config.labels[j];
                key = cfg._key;
                label = new Label(cfg, ctx, el, i);
                label.$groups = {
                    _set: datasetIndex,
                    _key: key || DEFAULT_KEY
                };
                label.$context = {
                    active: false,
                    chart: chart,
                    dataIndex: i,
                    dataset: dataset,
                    datasetIndex: datasetIndex
                };
                label.update(label.$context);
                el[EXPANDO_KEY].push(label);
                labels.push(label);
            }
        }
        ctx.restore();
        // Store listeners at the chart level and per event type to optimize
        // cases where no listeners are registered for a specific event.
        (0, _helpers.merge)(expando._listeners, config.listeners, {
            merger: function merger(event, target, source) {
                target[event] = target[event] || {};
                target[event][args.index] = source[event];
                expando._listened = true;
            }
        });
    },
    afterUpdate: function afterUpdate(chart) {
        chart[EXPANDO_KEY]._labels = layout.prepare(chart[EXPANDO_KEY]._datasets);
    },
    // Draw labels on top of all dataset elements
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
    afterDatasetsDraw: function afterDatasetsDraw(chart) {
        layout.draw(chart, chart[EXPANDO_KEY]._labels);
    },
    beforeEvent: function beforeEvent(chart, args) {
        // If there is no listener registered for this chart, `listened` will be false,
        // meaning we can immediately ignore the incoming event and avoid useless extra
        // computation for users who don't implement label interactions.
        if (chart[EXPANDO_KEY]._listened) {
            var event = args.event;
            switch(event.type){
                case "mousemove":
                case "mouseout":
                    handleMoveEvents(chart, event);
                    break;
                case "click":
                    handleClickEvents(chart, event);
                    break;
            }
        }
    },
    afterEvent: function afterEvent(chart) {
        var expando = chart[EXPANDO_KEY];
        var previous = expando._actives;
        var actives = expando._actives = chart.getActiveElements();
        var updates = utils.arrayDiff(previous, actives);
        var i, ilen, j, jlen, update, label, labels;
        for(i = 0, ilen = updates.length; i < ilen; ++i){
            update = updates[i];
            if (update[1]) {
                labels = update[0].element[EXPANDO_KEY] || [];
                for(j = 0, jlen = labels.length; j < jlen; ++j){
                    label = labels[j];
                    label.$context.active = update[1] === 1;
                    label.update(label.$context);
                }
            }
        }
        if (expando._dirty || updates.length) {
            layout.update(expando._labels);
            chart.render();
        }
        delete expando._dirty;
    }
};

},{"chart.js/helpers":"8rmQn","chart.js":"i71Mg","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8rmQn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _helpersJs = require("../dist/helpers.js");
parcelHelpers.exportAll(_helpersJs, exports);

},{"../dist/helpers.js":"kiXkm","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"kiXkm":[function(require,module,exports) {
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HALF_PI", ()=>(0, _helpersSegmentJs.H));
parcelHelpers.export(exports, "INFINITY", ()=>(0, _helpersSegmentJs.b2));
parcelHelpers.export(exports, "PI", ()=>(0, _helpersSegmentJs.P));
parcelHelpers.export(exports, "PITAU", ()=>(0, _helpersSegmentJs.b1));
parcelHelpers.export(exports, "QUARTER_PI", ()=>(0, _helpersSegmentJs.b4));
parcelHelpers.export(exports, "RAD_PER_DEG", ()=>(0, _helpersSegmentJs.b3));
parcelHelpers.export(exports, "TAU", ()=>(0, _helpersSegmentJs.T));
parcelHelpers.export(exports, "TWO_THIRDS_PI", ()=>(0, _helpersSegmentJs.b5));
parcelHelpers.export(exports, "_addGrace", ()=>(0, _helpersSegmentJs.R));
parcelHelpers.export(exports, "_alignPixel", ()=>(0, _helpersSegmentJs.X));
parcelHelpers.export(exports, "_alignStartEnd", ()=>(0, _helpersSegmentJs.a2));
parcelHelpers.export(exports, "_angleBetween", ()=>(0, _helpersSegmentJs.p));
parcelHelpers.export(exports, "_angleDiff", ()=>(0, _helpersSegmentJs.b6));
parcelHelpers.export(exports, "_arrayUnique", ()=>(0, _helpersSegmentJs._));
parcelHelpers.export(exports, "_attachContext", ()=>(0, _helpersSegmentJs.a8));
parcelHelpers.export(exports, "_bezierCurveTo", ()=>(0, _helpersSegmentJs.as));
parcelHelpers.export(exports, "_bezierInterpolation", ()=>(0, _helpersSegmentJs.ap));
parcelHelpers.export(exports, "_boundSegment", ()=>(0, _helpersSegmentJs.ax));
parcelHelpers.export(exports, "_boundSegments", ()=>(0, _helpersSegmentJs.an));
parcelHelpers.export(exports, "_capitalize", ()=>(0, _helpersSegmentJs.a5));
parcelHelpers.export(exports, "_computeSegments", ()=>(0, _helpersSegmentJs.am));
parcelHelpers.export(exports, "_createResolver", ()=>(0, _helpersSegmentJs.a9));
parcelHelpers.export(exports, "_decimalPlaces", ()=>(0, _helpersSegmentJs.aK));
parcelHelpers.export(exports, "_deprecated", ()=>(0, _helpersSegmentJs.aV));
parcelHelpers.export(exports, "_descriptors", ()=>(0, _helpersSegmentJs.aa));
parcelHelpers.export(exports, "_elementsEqual", ()=>(0, _helpersSegmentJs.ah));
parcelHelpers.export(exports, "_factorize", ()=>(0, _helpersSegmentJs.N));
parcelHelpers.export(exports, "_filterBetween", ()=>(0, _helpersSegmentJs.aO));
parcelHelpers.export(exports, "_getParentNode", ()=>(0, _helpersSegmentJs.I));
parcelHelpers.export(exports, "_getStartAndCountOfVisiblePoints", ()=>(0, _helpersSegmentJs.q));
parcelHelpers.export(exports, "_int16Range", ()=>(0, _helpersSegmentJs.W));
parcelHelpers.export(exports, "_isBetween", ()=>(0, _helpersSegmentJs.aj));
parcelHelpers.export(exports, "_isClickEvent", ()=>(0, _helpersSegmentJs.ai));
parcelHelpers.export(exports, "_isDomSupported", ()=>(0, _helpersSegmentJs.M));
parcelHelpers.export(exports, "_isPointInArea", ()=>(0, _helpersSegmentJs.C));
parcelHelpers.export(exports, "_limitValue", ()=>(0, _helpersSegmentJs.S));
parcelHelpers.export(exports, "_longestText", ()=>(0, _helpersSegmentJs.aN));
parcelHelpers.export(exports, "_lookup", ()=>(0, _helpersSegmentJs.aP));
parcelHelpers.export(exports, "_lookupByKey", ()=>(0, _helpersSegmentJs.B));
parcelHelpers.export(exports, "_measureText", ()=>(0, _helpersSegmentJs.V));
parcelHelpers.export(exports, "_merger", ()=>(0, _helpersSegmentJs.aT));
parcelHelpers.export(exports, "_mergerIf", ()=>(0, _helpersSegmentJs.aU));
parcelHelpers.export(exports, "_normalizeAngle", ()=>(0, _helpersSegmentJs.ay));
parcelHelpers.export(exports, "_parseObjectDataRadialScale", ()=>(0, _helpersSegmentJs.y));
parcelHelpers.export(exports, "_pointInLine", ()=>(0, _helpersSegmentJs.aq));
parcelHelpers.export(exports, "_readValueToProps", ()=>(0, _helpersSegmentJs.ak));
parcelHelpers.export(exports, "_rlookupByKey", ()=>(0, _helpersSegmentJs.A));
parcelHelpers.export(exports, "_scaleRangesChanged", ()=>(0, _helpersSegmentJs.w));
parcelHelpers.export(exports, "_setMinAndMaxByKey", ()=>(0, _helpersSegmentJs.aG));
parcelHelpers.export(exports, "_splitKey", ()=>(0, _helpersSegmentJs.aW));
parcelHelpers.export(exports, "_steppedInterpolation", ()=>(0, _helpersSegmentJs.ao));
parcelHelpers.export(exports, "_steppedLineTo", ()=>(0, _helpersSegmentJs.ar));
parcelHelpers.export(exports, "_textX", ()=>(0, _helpersSegmentJs.aB));
parcelHelpers.export(exports, "_toLeftRightCenter", ()=>(0, _helpersSegmentJs.a1));
parcelHelpers.export(exports, "_updateBezierControlPoints", ()=>(0, _helpersSegmentJs.al));
parcelHelpers.export(exports, "addRoundedRectPath", ()=>(0, _helpersSegmentJs.au));
parcelHelpers.export(exports, "almostEquals", ()=>(0, _helpersSegmentJs.aJ));
parcelHelpers.export(exports, "almostWhole", ()=>(0, _helpersSegmentJs.aI));
parcelHelpers.export(exports, "callback", ()=>(0, _helpersSegmentJs.Q));
parcelHelpers.export(exports, "clearCanvas", ()=>(0, _helpersSegmentJs.af));
parcelHelpers.export(exports, "clipArea", ()=>(0, _helpersSegmentJs.Y));
parcelHelpers.export(exports, "clone", ()=>(0, _helpersSegmentJs.aS));
parcelHelpers.export(exports, "color", ()=>(0, _helpersSegmentJs.c));
parcelHelpers.export(exports, "createContext", ()=>(0, _helpersSegmentJs.j));
parcelHelpers.export(exports, "debounce", ()=>(0, _helpersSegmentJs.ad));
parcelHelpers.export(exports, "defined", ()=>(0, _helpersSegmentJs.h));
parcelHelpers.export(exports, "distanceBetweenPoints", ()=>(0, _helpersSegmentJs.aE));
parcelHelpers.export(exports, "drawPoint", ()=>(0, _helpersSegmentJs.at));
parcelHelpers.export(exports, "drawPointLegend", ()=>(0, _helpersSegmentJs.aD));
parcelHelpers.export(exports, "each", ()=>(0, _helpersSegmentJs.F));
parcelHelpers.export(exports, "easingEffects", ()=>(0, _helpersSegmentJs.e));
parcelHelpers.export(exports, "finiteOrDefault", ()=>(0, _helpersSegmentJs.O));
parcelHelpers.export(exports, "fontString", ()=>(0, _helpersSegmentJs.a$));
parcelHelpers.export(exports, "formatNumber", ()=>(0, _helpersSegmentJs.o));
parcelHelpers.export(exports, "getAngleFromPoint", ()=>(0, _helpersSegmentJs.D));
parcelHelpers.export(exports, "getHoverColor", ()=>(0, _helpersSegmentJs.aR));
parcelHelpers.export(exports, "getMaximumSize", ()=>(0, _helpersSegmentJs.G));
parcelHelpers.export(exports, "getRelativePosition", ()=>(0, _helpersSegmentJs.z));
parcelHelpers.export(exports, "getRtlAdapter", ()=>(0, _helpersSegmentJs.az));
parcelHelpers.export(exports, "getStyle", ()=>(0, _helpersSegmentJs.a_));
parcelHelpers.export(exports, "isArray", ()=>(0, _helpersSegmentJs.b));
parcelHelpers.export(exports, "isFinite", ()=>(0, _helpersSegmentJs.g));
parcelHelpers.export(exports, "isFunction", ()=>(0, _helpersSegmentJs.a7));
parcelHelpers.export(exports, "isNullOrUndef", ()=>(0, _helpersSegmentJs.k));
parcelHelpers.export(exports, "isNumber", ()=>(0, _helpersSegmentJs.x));
parcelHelpers.export(exports, "isObject", ()=>(0, _helpersSegmentJs.i));
parcelHelpers.export(exports, "isPatternOrGradient", ()=>(0, _helpersSegmentJs.aQ));
parcelHelpers.export(exports, "listenArrayEvents", ()=>(0, _helpersSegmentJs.l));
parcelHelpers.export(exports, "log10", ()=>(0, _helpersSegmentJs.aM));
parcelHelpers.export(exports, "merge", ()=>(0, _helpersSegmentJs.a4));
parcelHelpers.export(exports, "mergeIf", ()=>(0, _helpersSegmentJs.ab));
parcelHelpers.export(exports, "niceNum", ()=>(0, _helpersSegmentJs.aH));
parcelHelpers.export(exports, "noop", ()=>(0, _helpersSegmentJs.aF));
parcelHelpers.export(exports, "overrideTextDirection", ()=>(0, _helpersSegmentJs.aA));
parcelHelpers.export(exports, "readUsedSize", ()=>(0, _helpersSegmentJs.J));
parcelHelpers.export(exports, "renderText", ()=>(0, _helpersSegmentJs.Z));
parcelHelpers.export(exports, "requestAnimFrame", ()=>(0, _helpersSegmentJs.r));
parcelHelpers.export(exports, "resolve", ()=>(0, _helpersSegmentJs.a));
parcelHelpers.export(exports, "resolveObjectKey", ()=>(0, _helpersSegmentJs.f));
parcelHelpers.export(exports, "restoreTextDirection", ()=>(0, _helpersSegmentJs.aC));
parcelHelpers.export(exports, "retinaScale", ()=>(0, _helpersSegmentJs.ae));
parcelHelpers.export(exports, "setsEqual", ()=>(0, _helpersSegmentJs.ag));
parcelHelpers.export(exports, "sign", ()=>(0, _helpersSegmentJs.s));
parcelHelpers.export(exports, "splineCurve", ()=>(0, _helpersSegmentJs.aY));
parcelHelpers.export(exports, "splineCurveMonotone", ()=>(0, _helpersSegmentJs.aZ));
parcelHelpers.export(exports, "supportsEventListenerOptions", ()=>(0, _helpersSegmentJs.K));
parcelHelpers.export(exports, "throttled", ()=>(0, _helpersSegmentJs.L));
parcelHelpers.export(exports, "toDegrees", ()=>(0, _helpersSegmentJs.U));
parcelHelpers.export(exports, "toDimension", ()=>(0, _helpersSegmentJs.n));
parcelHelpers.export(exports, "toFont", ()=>(0, _helpersSegmentJs.a0));
parcelHelpers.export(exports, "toFontString", ()=>(0, _helpersSegmentJs.aX));
parcelHelpers.export(exports, "toLineHeight", ()=>(0, _helpersSegmentJs.b0));
parcelHelpers.export(exports, "toPadding", ()=>(0, _helpersSegmentJs.E));
parcelHelpers.export(exports, "toPercentage", ()=>(0, _helpersSegmentJs.m));
parcelHelpers.export(exports, "toRadians", ()=>(0, _helpersSegmentJs.t));
parcelHelpers.export(exports, "toTRBL", ()=>(0, _helpersSegmentJs.av));
parcelHelpers.export(exports, "toTRBLCorners", ()=>(0, _helpersSegmentJs.aw));
parcelHelpers.export(exports, "uid", ()=>(0, _helpersSegmentJs.ac));
parcelHelpers.export(exports, "unclipArea", ()=>(0, _helpersSegmentJs.$));
parcelHelpers.export(exports, "unlistenArrayEvents", ()=>(0, _helpersSegmentJs.u));
parcelHelpers.export(exports, "valueOrDefault", ()=>(0, _helpersSegmentJs.v));
var _helpersSegmentJs = require("./chunks/helpers.segment.js");
var _color = require("@kurkle/color");

},{"./chunks/helpers.segment.js":"3AXRv","@kurkle/color":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"j5kEl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_checkbox_webcomponent", ()=>c_checkbox_webcomponent);
parcelHelpers.export(exports, "web_c_checkbox", ()=>web_c_checkbox);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _cbWebUtil = require("../controls/cb_web_util");
class c_checkbox_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_checkbox(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-checkbox", c_checkbox_webcomponent);
class web_c_checkbox extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _$input, input_element, self, input_element1, container;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "value") {
                    if (cfg === "0" || cfg === "false") _this.value = false;
                    else _this.value = Boolean(cfg);
                    _$input = document.getElementById(`${_this.brick_id}`);
                    if (_$input) _$input.checked = _this.value ? true : false;
                    if (!cfg.dont_send_intial_value) return [
                        2,
                        {
                            "@": _this.value ? true : false
                        }
                    ];
                } else if (input == "cfg") {
                    if (!_this.initialised) {
                        _this.element.innerHTML = `<label class="c-checkbox-container" id="${_this.brick_id}$container" for="${_this.brick_id}" >  
                    <input type="checkbox" id="${_this.brick_id}" class="c-checkbox"/>
                    <span class="c-checkbox-checkmark"></span>
                    <span class="c-checkbox-label">${cfg.label || ""}</span>
                </label>`;
                        _this.initialised = true;
                        input_element = document.getElementById(`${_this.brick_id}`);
                        self = _this;
                        if (input_element) input_element.addEventListener("change", function(e) {
                            self.value = input_element.checked;
                            self.value_object = self.value_object || {};
                            self.value_object.checked = input_element.checked;
                            self.cb_emit({
                                "@": input_element.checked,
                                "@value_object": self.value_object,
                                "@user_changed": input_element.checked
                            });
                        });
                    }
                    input_element1 = document.getElementById(`${_this.brick_id}`);
                    container = document.getElementById(`${_this.brick_id}$container`);
                    if (input_element1 && container) {
                        input_element1.checked = _this.value ? true : false;
                        if (cfg.disabled) {
                            input_element1.disabled = true;
                            container.classList.add("c-checkbox-disabled");
                        } else {
                            input_element1.disabled = false;
                            container.classList.remove("c-checkbox-disabled");
                        }
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container.querySelector(".c-checkbox-label"), cfg, "label");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container.querySelector(".c-checkbox-checkmark"), cfg, "checkmark");
                    }
                    if (cfg.value_object) {
                        if (typeof cfg.value_object == "object") _this.value_object = cfg.value_object;
                        else console.error(_this.blueprint.name + ": c-checkbox value_object must be an object");
                    }
                    if (container) {
                        if (cfg.hidden) container.classList.add("hidden");
                        else container.classList.remove("hidden");
                        if (cfg.tooltip && cfg.tooltip.text) {
                            container.setAttribute("tooltip", cfg.tooltip.text);
                            (0, _cbTooltip.cb_tooltip).set_tooltip(container);
                        }
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "required") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) input.classList.add("required");
        } else if (status == "") {
            var input1 = document.getElementById(`${this.brick_id}`);
            if (input1) input1.classList.remove("required");
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = false;
        this.value_object = {};
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"78LeB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_daterange_webcomponent", ()=>c_daterange_webcomponent);
parcelHelpers.export(exports, "web_c_daterange", ()=>web_c_daterange);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPopout = require("../controls/cb_popout");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var _dateRange = require("../../shared-funcs/DateRange");
var _cbDatetimepicker = require("../controls/cb_datetimepicker");
var _cbformatting = require("../../codebricks-runtime/CBFormatting");
class c_daterange_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_daterange(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-daterange", c_daterange_webcomponent);
class web_c_daterange extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _a, _b, _c, values, presets_html, p, preset, max_days, preset_days, presets_element, self, p1, preset_button, emit_val;
            return (0, _tsGenerator._)(this, function(_state) {
                _this.cfg = cfg;
                _this.popout.setLabel(cfg.label);
                values = (0, _dateRange.DateRange).GetValues(cfg, (_a = _this.context.composition_runners[_this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options);
                _this.displayformat = values.displayformat;
                _this.outputformat = values.outputformat;
                _this.date1 = values.date1;
                _this.date2 = values.date2;
                _this.preset = values.preset;
                presets_html = "";
                if (cfg.presets) for(p = 0; p < cfg.presets.length; p++){
                    preset = cfg.presets[p];
                    if (_this.cfg.max_range) {
                        max_days = (0, _sugarDefault.default).Date.range("now for " + _this.cfg.max_range).days();
                        preset_days = (0, _sugarDefault.default).Date.range(preset.start + " to " + preset.end).days();
                        if (preset_days > max_days) continue;
                    }
                    presets_html += `<button class="c-datetime-preset" id="${_this.brick_id}$preset${p}">${cfg.presets[p].label}</button>`;
                }
                presets_element = document.getElementById(_this.brick_id + "$presets");
                if (presets_element) presets_element.innerHTML = presets_html;
                if (cfg.presets) {
                    self = _this;
                    for(p1 = 0; p1 < cfg.presets.length; p1++){
                        preset_button = document.getElementById(_this.brick_id + "$preset" + p1);
                        if (preset_button) preset_button.addEventListener("click", function(e) {
                            var p = Number(e.target.id.split("$preset")[1]);
                            var preset = self.cfg.presets[p];
                            self.date1 = (0, _sugarDefault.default).Date.create(preset.start);
                            self.date2 = (0, _sugarDefault.default).Date.create(preset.end);
                            self.set_start_end(preset.label);
                            self.popout.closeSelect();
                        });
                    }
                }
                _this.set_start_end(_this.preset);
                emit_val = {
                    start: (0, _cbformatting.codebricks_format)(_this.date1, _this.outputformat, ((_b = _this.context.composition_runners[_this.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value,
                    end: (0, _cbformatting.codebricks_format)(_this.date2, _this.outputformat, ((_c = _this.context.composition_runners[_this.cid].compos) === null || _c === void 0 ? void 0 : _c.system_options) || {}).value
                };
                return [
                    2,
                    {
                        "@": emit_val,
                        "@preset": _this.preset || emit_val.start + " - " + emit_val.end
                    }
                ];
            });
        })();
    }
    set_start_end(preset) {
        var _a, _b;
        this.datepicker1.init(this.date1);
        this.datepicker2.init(this.date2);
        if (preset && this.context.platform != "file") this.popout.setDisplayValue(preset);
        else this.popout.setDisplayValue((0, _cbformatting.codebricks_format)(this.date1, this.displayformat, ((_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value + " - " + (0, _cbformatting.codebricks_format)(this.date2, this.displayformat, ((_b = this.context.composition_runners[this.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value);
        var selection = document.getElementById(this.brick_id + "$selection");
        if (selection) {
            var days = (0, _sugarDefault.default).Date.range(this.date1, this.date2).days() + 1;
            var disp = days + " day" + (days == 1 ? "" : "s") + " selected";
            if (this.cfg.max_range) disp += " (Max range: " + this.cfg.max_range + ")";
            selection.innerHTML = disp;
        }
        this.preset = preset;
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "required") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) input.classList.add("required");
        } else if (status == "") {
            var input1 = document.getElementById(`${this.brick_id}`);
            if (input1) input1.classList.remove("required");
        }
    }
    cb_snapshot() {
        return this.snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.displayformat = "{short}";
        this.outputformat = "{short}";
        this.value = "";
        this.date1 = null;
        this.date2 = null;
        this.cfg = {};
        this.preset = "";
        this.snapshot = undefined;
        this.element = element;
        var self = this;
        this.element.innerHTML = `<div id="${this.brick_id}" class='form-element-container c-daterange-container no_click_close'></div>`;
        this.popout = new (0, _cbPopout.cb_popout)(this.brick_id, true, this.blueprint.ins.cfg, "c-daterange", false, false, function() {}, function() {
            var _a, _b;
            console.log("PRE " + self.date1);
            var emit_val = {
                start: (0, _cbformatting.codebricks_format)(self.date1, self.outputformat, ((_a = self.context.composition_runners[self.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value,
                end: (0, _cbformatting.codebricks_format)(self.date2, self.outputformat, ((_b = self.context.composition_runners[self.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value
            };
            console.log("POST " + self.date1);
            self.snapshot = self.snapshot || {};
            self.snapshot.cfg = self.snapshot.cfg || {};
            self.snapshot.cfg.value = self.preset || emit_val.start + " - " + emit_val.end;
            self.cb_emit({
                "@": emit_val,
                "@preset": self.preset || emit_val.start + " - " + emit_val.end
            });
        });
        var drop = document.getElementById(this.brick_id + "$drop");
        if (drop) {
            drop.innerHTML = `<div class="c-daterange-drop-inner">
                                <div>
                                    <div class="c-daterange-fromto">
                                        <div class="c-daterange-from">
                                            <div class="c-daterange-h">From</div>
                                            <div id="${this.brick_id}$picker1"></div>
                                        </div>
                                        
                                        <div class="c-daterange-to">
                                            <div class="c-daterange-h">To</div>
                                            <div id="${this.brick_id}$picker2"></div>
                                        </div>
                                    </div>
                                    <div class="c-daterange-selection" id="${this.brick_id}$selection"></div>
                                </div>
                                <div class="c-daterange-sidebar">
                                    <div class="c-daterange-presets-container" id="${this.brick_id}$presets"></div>
                                    <button class="btn-primary c-daterange-close" id="${this.brick_id}$close">Close</button>
                                </div>
                              </div>`;
            var close = document.getElementById(this.brick_id + "$close");
            if (close) close.addEventListener("click", function() {
                self.popout.closeSelect();
            });
        }
        var current_year = Number((0, _sugarDefault.default).Date.format((0, _sugarDefault.default).Date.create(), "{yyyy}"));
        this.datepicker1 = new (0, _cbDatetimepicker.cb_datetimepicker)(this.brick_id + "$picker1", true, true, true, false, false, current_year - 120, current_year + 50, function(value) {
            var _a, _b;
            self.date1 = value == "" ? (0, _sugarDefault.default).Date.create() : (0, _sugarDefault.default).Date.create(value);
            if ((0, _sugarDefault.default).Date.isBefore(self.date2, self.date1)) {
                self.date2 = (0, _sugarDefault.default).Date.create(self.date1.getTime());
                self.datepicker2.set_value(self.date2);
            }
            if (self.cfg.max_range) {
                var date_max = (0, _sugarDefault.default).Date.create(self.date1.getTime());
                date_max = (0, _sugarDefault.default).Date.advance(date_max, self.cfg.max_range);
                date_max = (0, _sugarDefault.default).Date.rewind(date_max, "1 day");
                if ((0, _sugarDefault.default).Date.isBefore(date_max, self.date2)) {
                    self.date2 = date_max;
                    self.datepicker2.set_value(self.date2);
                }
            }
            self.popout.setDisplayValue((0, _cbformatting.codebricks_format)(self.date1, self.displayformat, ((_a = self.context.composition_runners[self.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value + " - " + (0, _cbformatting.codebricks_format)(self.date2, self.displayformat, ((_b = self.context.composition_runners[self.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value);
            var selection = document.getElementById(self.brick_id + "$selection");
            if (selection) {
                var days = (0, _sugarDefault.default).Date.range(self.date1, self.date2).days() + 1;
                var disp = days + " day" + (days == 1 ? "" : "s") + " selected";
                if (self.cfg.max_range) disp += " (Max range: " + self.cfg.max_range + ")";
                selection.innerHTML = disp;
            }
            self.preset = "";
        });
        this.datepicker2 = new (0, _cbDatetimepicker.cb_datetimepicker)(this.brick_id + "$picker2", true, true, true, false, false, current_year - 120, current_year + 50, function(value) {
            var _a, _b;
            self.date2 = value == "" ? (0, _sugarDefault.default).Date.create() : (0, _sugarDefault.default).Date.create(value);
            if ((0, _sugarDefault.default).Date.isBefore(self.date2, self.date1)) {
                self.date1 = (0, _sugarDefault.default).Date.create(self.date2.getTime());
                self.datepicker1.set_value(self.date1);
            }
            if (self.cfg.max_range) {
                var date_min = (0, _sugarDefault.default).Date.create(self.date2.getTime());
                date_min = (0, _sugarDefault.default).Date.rewind(date_min, self.cfg.max_range);
                date_min = (0, _sugarDefault.default).Date.advance(date_min, "1 day");
                if ((0, _sugarDefault.default).Date.isAfter(date_min, self.date1)) {
                    self.date1 = date_min;
                    self.datepicker1.set_value(self.date1);
                }
            }
            self.popout.setDisplayValue((0, _cbformatting.codebricks_format)(self.date1, self.displayformat, ((_a = self.context.composition_runners[self.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value + " - " + (0, _cbformatting.codebricks_format)(self.date2, self.displayformat, ((_b = self.context.composition_runners[self.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value);
            var selection = document.getElementById(self.brick_id + "$selection");
            if (selection) {
                var days = (0, _sugarDefault.default).Date.range(self.date1, self.date2).days() + 1;
                var disp = days + " day" + (days == 1 ? "" : "s") + " selected";
                if (self.cfg.max_range) disp += " (Max range: " + self.cfg.max_range + ")";
                selection.innerHTML = disp;
            }
            self.preset = "";
        });
        this.popout.init();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_popout":"8UNLF","sugar":"gcIJ7","../../shared-funcs/DateRange":"1trlU","../controls/cb_datetimepicker":"ddnmR","../../codebricks-runtime/CBFormatting":"TabN7","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"gcIJ7":[function(require,module,exports) {
"use strict";
require("6dd0dbd7b8139e72");
require("a45f961ae9d20717");
require("27002167ab94c564");
require("3d4de5d5f0744f61");
require("79f4788cf7679bc8");
require("8b93658de1b4377e");
require("b12df8fa199c1ca1");
require("76454fbd1358c606");
require("915347d08de3fc44");
module.exports = require("af6f50cca600f980");

},{"6dd0dbd7b8139e72":"bzZ5X","a45f961ae9d20717":"lwb2J","27002167ab94c564":"3IsL1","3d4de5d5f0744f61":"aHgPY","79f4788cf7679bc8":"lzA4y","8b93658de1b4377e":"e9r6r","b12df8fa199c1ca1":"iV5en","76454fbd1358c606":"egKZI","915347d08de3fc44":"4ikmk","af6f50cca600f980":"eWYA2"}],"bzZ5X":[function(require,module,exports) {
"use strict";
// Instance Methods
require("3b88deb8503d5dfc");
require("b5fa85115b9e8765");
require("9ea2e29aa8c110d4");
require("cc39c020ddf93716");
require("ea09a7268a463910");
require("d8e641e47ede9827");
require("f768cb61645fd3a1");
require("9d85d321253630fa");
require("61e8dc34eaf40db2");
require("d167d8a779ab7faf");
require("7cdf5e27b06dd860");
require("8e581394e3f36b3c");
require("a80b78765592d710");
require("4c237752b94556a3");
require("a65ef03c27903c8");
require("ea10619f52b9fced");
require("ce6734aa1d55991c");
require("be2a65e651fe2fa");
require("7c09e850e855b83a");
require("a38e79a029a249aa");
require("ed3434ebb24b915c");
require("12df528f4008180a");
require("ae231d33a97cf671");
require("63140151cafcde9f");
require("de930147aedd332f");
require("5846c1e966170b05");
require("6d8c701e041b826b");
require("18cfba86f652f48c");
require("ebb46d2a69027c41");
require("acb55ecfcd623918");
require("6ded5974a935d98b");
require("c95bd8c5fad0fb66");
require("59838b360945a458");
require("f11492033986d5f7");
require("1501ea634bfb278a");
require("d97eabfb482facf9");
require("4a767a3f312c2030");
require("fccef14cab34852c");
require("26d0b96389ba8ffa");
require("4ad4ba91d27c4502");
require("1c29b90bceefb50b");
require("ee4676bf37b800e2");
require("f2a66817c357fe70");
require("314318183b13a51e");
module.exports = require("2418dc057151f703");

},{"3b88deb8503d5dfc":"ccycL","b5fa85115b9e8765":"30mld","9ea2e29aa8c110d4":"3UUWP","cc39c020ddf93716":"1l8wJ","ea09a7268a463910":"aVQnx","d8e641e47ede9827":"1GYI2","f768cb61645fd3a1":"5Cbi9","9d85d321253630fa":"a5glf","61e8dc34eaf40db2":"4FMbT","d167d8a779ab7faf":"4YEpQ","7cdf5e27b06dd860":"jZUys","8e581394e3f36b3c":"6YaUH","a80b78765592d710":"te15t","4c237752b94556a3":"kVDPG","a65ef03c27903c8":"lCRSp","ea10619f52b9fced":"4adAJ","ce6734aa1d55991c":"cS6WS","be2a65e651fe2fa":"h1ByG","7c09e850e855b83a":"q7Och","a38e79a029a249aa":"ccdL7","ed3434ebb24b915c":"hY83o","12df528f4008180a":"gzZd2","ae231d33a97cf671":"3t3PS","63140151cafcde9f":"1FwEq","de930147aedd332f":"eP4Tp","5846c1e966170b05":"5KVWj","6d8c701e041b826b":"fqQGq","18cfba86f652f48c":"k32Tk","ebb46d2a69027c41":"gUBLQ","acb55ecfcd623918":"kvpGg","6ded5974a935d98b":"6xC2I","c95bd8c5fad0fb66":"ky41R","59838b360945a458":"1IzAe","f11492033986d5f7":"i4SHV","1501ea634bfb278a":"gaKvx","d97eabfb482facf9":"2WucJ","4a767a3f312c2030":"66Eui","fccef14cab34852c":"6G95x","26d0b96389ba8ffa":"7AQUZ","4ad4ba91d27c4502":"8ilxn","1c29b90bceefb50b":"2mrtK","ee4676bf37b800e2":"3Pfm1","f2a66817c357fe70":"2iPFQ","314318183b13a51e":"4Ve8Z","2418dc057151f703":"eWYA2"}],"ccycL":[function(require,module,exports) {
"use strict";
var Sugar = require("36a017776552f9a8"), getEntriesForIndexes = require("fcfcc1e2dfb89e02");
Sugar.String.defineInstance({
    "at": function(str, index, loop) {
        return getEntriesForIndexes(str, index, loop, true);
    }
});
module.exports = Sugar.String.at;

},{"36a017776552f9a8":"eWYA2","fcfcc1e2dfb89e02":"1apCQ"}],"eWYA2":[function(require,module,exports) {
var global = arguments[3];
/*
 *  Sugar v2.0.6
 *
 *  Freely distributable and licensed under the MIT-style license.
 *  Copyright (c) Andrew Plummer
 *  https://sugarjs.com/
 *
 * ---------------------------- */ (function() {
    "use strict";
    /***
   * @module Core
   * @description Core functionality including the ability to define methods and
   *              extend onto natives.
   *
   ***/ // The global to export.
    var Sugar;
    // The name of Sugar in the global namespace.
    var SUGAR_GLOBAL = "Sugar";
    // Natives available on initialization. Letting Object go first to ensure its
    // global is set by the time the rest are checking for chainable Object methods.
    var NATIVE_NAMES = "Object Number String Array Date RegExp Function";
    // Static method flag
    var STATIC = 0x1;
    // Instance method flag
    var INSTANCE = 0x2;
    // IE8 has a broken defineProperty but no defineProperties so this saves a try/catch.
    var PROPERTY_DESCRIPTOR_SUPPORT = !!(Object.defineProperty && Object.defineProperties);
    var globalContext = getGlobal();
    // Whether object instance methods can be mapped to the prototype.
    var allowObjectPrototype = false;
    // A map from Array to SugarArray.
    var namespacesByName = {};
    // A map from [object Object] to namespace.
    var namespacesByClassString = {};
    // Defining properties.
    // istanbul ignore next
    var defineProperty = PROPERTY_DESCRIPTOR_SUPPORT ? Object.defineProperty : definePropertyShim;
    // A default chainable class for unknown types.
    var DefaultChainable = getNewChainableClass("Chainable");
    // Global methods
    function getGlobal() {
        // Get global context by keyword here to avoid issues with libraries
        // that can potentially alter this script's context object.
        return testGlobal(typeof global !== "undefined" && global) || testGlobal(typeof window !== "undefined" && window);
    }
    function testGlobal(obj) {
        // Note that Rhino uses a different "global" keyword so perform an
        // extra check here to ensure that it's actually the global object.
        return obj && obj.Object === Object ? obj : null;
    }
    function setupGlobal() {
        Sugar = globalContext[SUGAR_GLOBAL];
        // istanbul ignore if
        if (Sugar) // Reuse already defined Sugar global object.
        return;
        Sugar = function(arg) {
            forEachProperty(Sugar, function(sugarNamespace, name) {
                // Although only the only enumerable properties on the global
                // object are Sugar namespaces, environments that can't set
                // non-enumerable properties will step through the utility methods
                // as well here, so use this check to only allow true namespaces.
                if (hasOwn(namespacesByName, name)) sugarNamespace.extend(arg);
            });
            return Sugar;
        };
        // istanbul ignore else
        if (0, module.exports) // Node or webpack environment
        module.exports = Sugar;
        else // Unwrapped browser environment
        try {
            globalContext[SUGAR_GLOBAL] = Sugar;
        } catch (e) {
        // Contexts such as QML have a read-only global context.
        }
        forEachProperty(NATIVE_NAMES.split(" "), function(name) {
            createNamespace(name);
        });
        setGlobalProperties();
    }
    /***
   * @method createNamespace(name)
   * @returns SugarNamespace
   * @namespace Sugar
   * @short Creates a new Sugar namespace.
   * @extra This method is for plugin developers who want to define methods to be
   *        used with natives that Sugar does not handle by default. The new
   *        namespace will appear on the `Sugar` global with all the methods of
   *        normal namespaces, including the ability to define new methods. When
   *        extended, any defined methods will be mapped to `name` in the global
   *        context.
   *
   * @example
   *
   *   Sugar.createNamespace('Boolean');
   *
   * @param {string} name - The namespace name.
   *
   ***/ function createNamespace(name) {
        // Is the current namespace Object?
        var isObject = name === "Object";
        // A Sugar namespace is also a chainable class: Sugar.Array, etc.
        var sugarNamespace = getNewChainableClass(name, true);
        /***
     * @method extend([opts])
     * @returns Sugar
     * @namespace Sugar
     * @short Extends Sugar defined methods onto natives.
     * @extra This method can be called on individual namespaces like
     *        `Sugar.Array` or on the `Sugar` global itself, in which case
     *        [opts] will be forwarded to each `extend` call. For more,
     *        see `extending`.
     *
     * @options
     *
     *   methods           An array of method names to explicitly extend.
     *
     *   except            An array of method names or global namespaces (`Array`,
     *                     `String`) to explicitly exclude. Namespaces should be the
     *                     actual global objects, not strings.
     *
     *   namespaces        An array of global namespaces (`Array`, `String`) to
     *                     explicitly extend. Namespaces should be the actual
     *                     global objects, not strings.
     *
     *   enhance           A shortcut to disallow all "enhance" flags at once
     *                     (flags listed below). For more, see `enhanced methods`.
     *                     Default is `true`.
     *
     *   enhanceString     A boolean allowing String enhancements. Default is `true`.
     *
     *   enhanceArray      A boolean allowing Array enhancements. Default is `true`.
     *
     *   objectPrototype   A boolean allowing Sugar to extend Object.prototype
     *                     with instance methods. This option is off by default
     *                     and should generally not be used except with caution.
     *                     For more, see `object methods`.
     *
     * @example
     *
     *   Sugar.Array.extend();
     *   Sugar.extend();
     *
     * @option {Array<string>} [methods]
     * @option {Array<string|NativeConstructor>} [except]
     * @option {Array<NativeConstructor>} [namespaces]
     * @option {boolean} [enhance]
     * @option {boolean} [enhanceString]
     * @option {boolean} [enhanceArray]
     * @option {boolean} [objectPrototype]
     * @param {ExtendOptions} [opts]
     *
     ***
     * @method extend([opts])
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Extends Sugar defined methods for a specific namespace onto natives.
     * @param {ExtendOptions} [opts]
     *
     ***/ var extend = function extend(opts) {
            var nativeClass = globalContext[name], nativeProto = nativeClass.prototype;
            var staticMethods = {}, instanceMethods = {}, methodsByName;
            function objectRestricted(name, target) {
                return isObject && target === nativeProto && (!allowObjectPrototype || name === "get" || name === "set");
            }
            function arrayOptionExists(field, val) {
                var arr = opts[field];
                if (arr) for(var i = 0, el; el = arr[i]; i++){
                    if (el === val) return true;
                }
                return false;
            }
            function arrayOptionExcludes(field, val) {
                return opts[field] && !arrayOptionExists(field, val);
            }
            function disallowedByFlags(methodName, target, flags) {
                // Disallowing methods by flag currently only applies if methods already
                // exist to avoid enhancing native methods, as aliases should still be
                // extended (i.e. Array#all should still be extended even if Array#every
                // is being disallowed by a flag).
                if (!target[methodName] || !flags) return false;
                for(var i = 0; i < flags.length; i++){
                    if (opts[flags[i]] === false) return true;
                }
            }
            function namespaceIsExcepted() {
                return arrayOptionExists("except", nativeClass) || arrayOptionExcludes("namespaces", nativeClass);
            }
            function methodIsExcepted(methodName) {
                return arrayOptionExists("except", methodName);
            }
            function canExtend(methodName, method, target) {
                return !objectRestricted(methodName, target) && !disallowedByFlags(methodName, target, method.flags) && !methodIsExcepted(methodName);
            }
            opts = opts || {};
            methodsByName = opts.methods;
            if (namespaceIsExcepted()) return;
            else if (isObject && typeof opts.objectPrototype === "boolean") // Store "objectPrototype" flag for future reference.
            allowObjectPrototype = opts.objectPrototype;
            forEachProperty(methodsByName || sugarNamespace, function(method, methodName) {
                if (methodsByName) {
                    // If we have method names passed in an array,
                    // then we need to flip the key and value here
                    // and find the method in the Sugar namespace.
                    methodName = method;
                    method = sugarNamespace[methodName];
                }
                if (hasOwn(method, "instance") && canExtend(methodName, method, nativeProto)) instanceMethods[methodName] = method.instance;
                if (hasOwn(method, "static") && canExtend(methodName, method, nativeClass)) staticMethods[methodName] = method;
            });
            // Accessing the extend target each time instead of holding a reference as
            // it may have been overwritten (for example Date by Sinon). Also need to
            // access through the global to allow extension of user-defined namespaces.
            extendNative(nativeClass, staticMethods);
            extendNative(nativeProto, instanceMethods);
            if (!methodsByName) // If there are no method names passed, then
            // all methods in the namespace will be extended
            // to the native. This includes all future defined
            // methods, so add a flag here to check later.
            setProperty(sugarNamespace, "active", true);
            return sugarNamespace;
        };
        function defineWithOptionCollect(methodName, instance, args) {
            setProperty(sugarNamespace, methodName, function(arg1, arg2, arg3) {
                var opts = collectDefineOptions(arg1, arg2, arg3);
                defineMethods(sugarNamespace, opts.methods, instance, args, opts.last);
                return sugarNamespace;
            });
        }
        /***
     * @method defineStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods on the namespace that can later be extended
     *        onto the native globals.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. If `extend` was previously called
     *        with no arguments, the method will be immediately mapped to its
     *        native when defined.
     *
     * @example
     *
     *   Sugar.Number.defineStatic({
     *     isOdd: function (num) {
     *       return num % 2 === 1;
     *     }
     *   });
     *
     * @signature defineStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineStatic", STATIC);
        /***
     * @method defineInstance(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines methods on the namespace that can later be extended as
     *        instance methods onto the native prototype.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. All functions should accept the
     *        native for which they are mapped as their first argument, and should
     *        never refer to `this`. If `extend` was previously called with no
     *        arguments, the method will be immediately mapped to its native when
     *        defined.
     *
     *        Methods cannot accept more than 4 arguments in addition to the
     *        native (5 arguments total). Any additional arguments will not be
     *        mapped. If the method needs to accept unlimited arguments, use
     *        `defineInstanceWithArguments`. Otherwise if more options are
     *        required, use an options object instead.
     *
     * @example
     *
     *   Sugar.Number.defineInstance({
     *     square: function (num) {
     *       return num * num;
     *     }
     *   });
     *
     * @signature defineInstance(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineInstance", INSTANCE);
        /***
     * @method defineInstanceAndStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short A shortcut to define both static and instance methods on the namespace.
     * @extra This method is intended for use with `Object` instance methods. Sugar
     *        will not map any methods to `Object.prototype` by default, so defining
     *        instance methods as static helps facilitate their proper use.
     *
     * @example
     *
     *   Sugar.Object.defineInstanceAndStatic({
     *     isAwesome: function (obj) {
     *       // check if obj is awesome!
     *     }
     *   });
     *
     * @signature defineInstanceAndStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineInstanceAndStatic", INSTANCE | STATIC);
        /***
     * @method defineStaticWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that collect arguments.
     * @extra This method is identical to `defineStatic`, except that when defined
     *        methods are called, they will collect any arguments past `n - 1`,
     *        where `n` is the number of arguments that the method accepts.
     *        Collected arguments will be passed to the method in an array
     *        as the last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineStaticWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineStaticWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineStaticWithArguments", STATIC, true);
        /***
     * @method defineInstanceWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that collect arguments.
     * @extra This method is identical to `defineInstance`, except that when
     *        defined methods are called, they will collect any arguments past
     *        `n - 1`, where `n` is the number of arguments that the method
     *        accepts. Collected arguments will be passed to the method as the
     *        last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineInstanceWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineInstanceWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ defineWithOptionCollect("defineInstanceWithArguments", INSTANCE, true);
        /***
     * @method defineStaticPolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that are mapped onto the native if they do
     *        not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. Note that polyfill methods will
     *        be immediately mapped onto their native prototype regardless of the
     *        use of `extend`.
     *
     * @example
     *
     *   Sugar.Object.defineStaticPolyfill({
     *     keys: function (obj) {
     *       // get keys!
     *     }
     *   });
     *
     * @signature defineStaticPolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ setProperty(sugarNamespace, "defineStaticPolyfill", function(arg1, arg2, arg3) {
            var opts = collectDefineOptions(arg1, arg2, arg3);
            extendNative(globalContext[name], opts.methods, true, opts.last);
            return sugarNamespace;
        });
        /***
     * @method defineInstancePolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that are mapped onto the native prototype
     *        if they do not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. This method differs from
     *        `defineInstance` as there is no static signature (as the method
     *        is mapped as-is to the native), so it should refer to its `this`
     *        object. Note that polyfill methods will be immediately mapped onto
     *        their native prototype regardless of the use of `extend`.
     *
     * @example
     *
     *   Sugar.Array.defineInstancePolyfill({
     *     indexOf: function (arr, el) {
     *       // index finding code here!
     *     }
     *   });
     *
     * @signature defineInstancePolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/ setProperty(sugarNamespace, "defineInstancePolyfill", function(arg1, arg2, arg3) {
            var opts = collectDefineOptions(arg1, arg2, arg3);
            extendNative(globalContext[name].prototype, opts.methods, true, opts.last);
            // Map instance polyfills to chainable as well.
            forEachProperty(opts.methods, function(fn, methodName) {
                defineChainableMethod(sugarNamespace, methodName, fn);
            });
            return sugarNamespace;
        });
        /***
     * @method alias(toName, from)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Aliases one Sugar method to another.
     *
     * @example
     *
     *   Sugar.Array.alias('all', 'every');
     *
     * @signature alias(toName, fn)
     * @param {string} toName - Name for new method.
     * @param {string|Function} from - Method to alias, or string shortcut.
     ***/ setProperty(sugarNamespace, "alias", function(name, source) {
            var method = typeof source === "string" ? sugarNamespace[source] : source;
            setMethod(sugarNamespace, name, method);
            return sugarNamespace;
        });
        // Each namespace can extend only itself through its .extend method.
        setProperty(sugarNamespace, "extend", extend);
        // Cache the class to namespace relationship for later use.
        namespacesByName[name] = sugarNamespace;
        namespacesByClassString["[object " + name + "]"] = sugarNamespace;
        mapNativeToChainable(name);
        mapObjectChainablesToNamespace(sugarNamespace);
        // Export
        return Sugar[name] = sugarNamespace;
    }
    function setGlobalProperties() {
        setProperty(Sugar, "VERSION", "2.0.6");
        setProperty(Sugar, "extend", Sugar);
        setProperty(Sugar, "toString", toString);
        setProperty(Sugar, "createNamespace", createNamespace);
        setProperty(Sugar, "util", {
            "hasOwn": hasOwn,
            "getOwn": getOwn,
            "setProperty": setProperty,
            "classToString": classToString,
            "defineProperty": defineProperty,
            "forEachProperty": forEachProperty,
            "mapNativeToChainable": mapNativeToChainable
        });
    }
    function toString() {
        return SUGAR_GLOBAL;
    }
    // Defining Methods
    function defineMethods(sugarNamespace, methods, type, args, flags) {
        forEachProperty(methods, function(method, methodName) {
            var instanceMethod, staticMethod = method;
            if (args) staticMethod = wrapMethodWithArguments(method);
            if (flags) staticMethod.flags = flags;
            // A method may define its own custom implementation, so
            // make sure that's not the case before creating one.
            if (type & INSTANCE && !method.instance) {
                instanceMethod = wrapInstanceMethod(method, args);
                setProperty(staticMethod, "instance", instanceMethod);
            }
            if (type & STATIC) setProperty(staticMethod, "static", true);
            setMethod(sugarNamespace, methodName, staticMethod);
            if (sugarNamespace.active) // If the namespace has been activated (.extend has been called),
            // then map this method as well.
            sugarNamespace.extend(methodName);
        });
    }
    function collectDefineOptions(arg1, arg2, arg3) {
        var methods, last;
        if (typeof arg1 === "string") {
            methods = {};
            methods[arg1] = arg2;
            last = arg3;
        } else {
            methods = arg1;
            last = arg2;
        }
        return {
            last: last,
            methods: methods
        };
    }
    function wrapInstanceMethod(fn, args) {
        return args ? wrapMethodWithArguments(fn, true) : wrapInstanceMethodFixed(fn);
    }
    function wrapMethodWithArguments(fn, instance) {
        // Functions accepting enumerated arguments will always have "args" as the
        // last argument, so subtract one from the function length to get the point
        // at which to start collecting arguments. If this is an instance method on
        // a prototype, then "this" will be pushed into the arguments array so start
        // collecting 1 argument earlier.
        var startCollect = fn.length - 1 - (instance ? 1 : 0);
        return function() {
            var args = [], collectedArgs = [], len;
            if (instance) args.push(this);
            len = Math.max(arguments.length, startCollect);
            // Optimized: no leaking arguments
            for(var i = 0; i < len; i++)if (i < startCollect) args.push(arguments[i]);
            else collectedArgs.push(arguments[i]);
            args.push(collectedArgs);
            return fn.apply(this, args);
        };
    }
    function wrapInstanceMethodFixed(fn) {
        switch(fn.length){
            // Wrapped instance methods will always be passed the instance
            // as the first argument, but requiring the argument to be defined
            // may cause confusion here, so return the same wrapped function regardless.
            case 0:
            case 1:
                return function() {
                    return fn(this);
                };
            case 2:
                return function(a) {
                    return fn(this, a);
                };
            case 3:
                return function(a, b) {
                    return fn(this, a, b);
                };
            case 4:
                return function(a, b, c) {
                    return fn(this, a, b, c);
                };
            case 5:
                return function(a, b, c, d) {
                    return fn(this, a, b, c, d);
                };
        }
    }
    // Method helpers
    function extendNative(target, source, polyfill, override) {
        forEachProperty(source, function(method, name) {
            if (polyfill && !override && target[name]) // Method exists, so bail.
            return;
            setProperty(target, name, method);
        });
    }
    function setMethod(sugarNamespace, methodName, method) {
        sugarNamespace[methodName] = method;
        if (method.instance) defineChainableMethod(sugarNamespace, methodName, method.instance, true);
    }
    // Chainables
    function getNewChainableClass(name) {
        var fn = function SugarChainable(obj, arg) {
            if (!(this instanceof fn)) return new fn(obj, arg);
            if (this.constructor !== fn) // Allow modules to define their own constructors.
            obj = this.constructor.apply(obj, arguments);
            this.raw = obj;
        };
        setProperty(fn, "toString", function() {
            return SUGAR_GLOBAL + name;
        });
        setProperty(fn.prototype, "valueOf", function() {
            return this.raw;
        });
        return fn;
    }
    function defineChainableMethod(sugarNamespace, methodName, fn) {
        var wrapped = wrapWithChainableResult(fn), existing, collision, dcp;
        dcp = DefaultChainable.prototype;
        existing = dcp[methodName];
        // If the method was previously defined on the default chainable, then a
        // collision exists, so set the method to a disambiguation function that will
        // lazily evaluate the object and find it's associated chainable. An extra
        // check is required to avoid false positives from Object inherited methods.
        collision = existing && existing !== Object.prototype[methodName];
        // The disambiguation function is only required once.
        if (!existing || !existing.disambiguate) dcp[methodName] = collision ? disambiguateMethod(methodName) : wrapped;
        // The target chainable always receives the wrapped method. Additionally,
        // if the target chainable is Sugar.Object, then map the wrapped method
        // to all other namespaces as well if they do not define their own method
        // of the same name. This way, a Sugar.Number will have methods like
        // isEqual that can be called on any object without having to traverse up
        // the prototype chain and perform disambiguation, which costs cycles.
        // Note that the "if" block below actually does nothing on init as Object
        // goes first and no other namespaces exist yet. However it needs to be
        // here as Object instance methods defined later also need to be mapped
        // back onto existing namespaces.
        sugarNamespace.prototype[methodName] = wrapped;
        if (sugarNamespace === Sugar.Object) mapObjectChainableToAllNamespaces(methodName, wrapped);
    }
    function mapObjectChainablesToNamespace(sugarNamespace) {
        forEachProperty(Sugar.Object && Sugar.Object.prototype, function(val, methodName) {
            if (typeof val === "function") setObjectChainableOnNamespace(sugarNamespace, methodName, val);
        });
    }
    function mapObjectChainableToAllNamespaces(methodName, fn) {
        forEachProperty(namespacesByName, function(sugarNamespace) {
            setObjectChainableOnNamespace(sugarNamespace, methodName, fn);
        });
    }
    function setObjectChainableOnNamespace(sugarNamespace, methodName, fn) {
        var proto = sugarNamespace.prototype;
        if (!hasOwn(proto, methodName)) proto[methodName] = fn;
    }
    function wrapWithChainableResult(fn) {
        return function() {
            return new DefaultChainable(fn.apply(this.raw, arguments));
        };
    }
    function disambiguateMethod(methodName) {
        var fn = function fn() {
            var raw = this.raw, sugarNamespace;
            if (raw != null) // Find the Sugar namespace for this unknown.
            sugarNamespace = namespacesByClassString[classToString(raw)];
            if (!sugarNamespace) // If no sugarNamespace can be resolved, then default
            // back to Sugar.Object so that undefined and other
            // non-supported types can still have basic object
            // methods called on them, such as type checks.
            sugarNamespace = Sugar.Object;
            return new sugarNamespace(raw)[methodName].apply(this, arguments);
        };
        fn.disambiguate = true;
        return fn;
    }
    function mapNativeToChainable(name, methodNames) {
        var sugarNamespace = namespacesByName[name], nativeProto = globalContext[name].prototype;
        if (!methodNames && ownPropertyNames) methodNames = ownPropertyNames(nativeProto);
        forEachProperty(methodNames, function(methodName) {
            if (nativeMethodProhibited(methodName)) // Sugar chainables have their own constructors as well as "valueOf"
            // methods, so exclude them here. The __proto__ argument should be trapped
            // by the function check below, however simply accessing this property on
            // Object.prototype causes QML to segfault, so pre-emptively excluding it.
            return;
            try {
                var fn = nativeProto[methodName];
                if (typeof fn !== "function") // Bail on anything not a function.
                return;
            } catch (e) {
                // Function.prototype has properties that
                // will throw errors when accessed.
                return;
            }
            defineChainableMethod(sugarNamespace, methodName, fn);
        });
    }
    function nativeMethodProhibited(methodName) {
        return methodName === "constructor" || methodName === "valueOf" || methodName === "__proto__";
    }
    // Util
    // Internal references
    var ownPropertyNames = Object.getOwnPropertyNames, internalToString = Object.prototype.toString, internalHasOwnProperty = Object.prototype.hasOwnProperty;
    // Defining this as a variable here as the ES5 module
    // overwrites it to patch DONTENUM.
    var forEachProperty = function forEachProperty(obj, fn) {
        for(var key in obj){
            if (!hasOwn(obj, key)) continue;
            if (fn.call(obj, obj[key], key, obj) === false) break;
        }
    };
    // istanbul ignore next
    function definePropertyShim(obj, prop, descriptor) {
        obj[prop] = descriptor.value;
    }
    function setProperty(target, name, value, enumerable) {
        defineProperty(target, name, {
            value: value,
            enumerable: !!enumerable,
            configurable: true,
            writable: true
        });
    }
    // PERF: Attempts to speed this method up get very Heisenbergy. Quickly
    // returning based on typeof works for primitives, but slows down object
    // types. Even === checks on null and undefined (no typeof) will end up
    // basically breaking even. This seems to be as fast as it can go.
    function classToString(obj) {
        return internalToString.call(obj);
    }
    function hasOwn(obj, prop) {
        return !!obj && internalHasOwnProperty.call(obj, prop);
    }
    function getOwn(obj, prop) {
        if (hasOwn(obj, prop)) return obj[prop];
    }
    setupGlobal();
    /***
   * @module Common
   * @description Internal utility and common methods.
   ***/ // Flag allowing native methods to be enhanced.
    var ENHANCEMENTS_FLAG = "enhance";
    // For type checking, etc. Excludes object as this is more nuanced.
    var NATIVE_TYPES = "Boolean Number String Date RegExp Function Array Error Set Map";
    // Do strings have no keys?
    var NO_KEYS_IN_STRING_OBJECTS = !("0" in Object("a"));
    // Prefix for private properties.
    var PRIVATE_PROP_PREFIX = "_sugar_";
    // Matches 1..2 style ranges in properties.
    var PROPERTY_RANGE_REG = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;
    // WhiteSpace/LineTerminator as defined in ES5.1 plus Unicode characters in the Space, Separator category.
    var TRIM_CHARS = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF";
    // Regex for matching a formatted string.
    var STRING_FORMAT_REG = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;
    // Common chars
    var HALF_WIDTH_ZERO = 0x30, FULL_WIDTH_ZERO = 0xff10, HALF_WIDTH_PERIOD = ".", FULL_WIDTH_PERIOD = "\uFF0E", HALF_WIDTH_COMMA = ",", OPEN_BRACE = "{", CLOSE_BRACE = "}";
    // Namespace aliases
    var sugarObject = Sugar.Object, sugarArray = Sugar.Array, sugarDate = Sugar.Date, sugarString = Sugar.String, sugarNumber = Sugar.Number, sugarFunction = Sugar.Function, sugarRegExp = Sugar.RegExp;
    // Class checks
    var isSerializable, isBoolean, isNumber, isString, isDate, isRegExp, isFunction, isArray, isSet, isMap, isError;
    function buildClassChecks() {
        var knownTypes = {};
        function addCoreTypes() {
            var names = spaceSplit(NATIVE_TYPES);
            isBoolean = buildPrimitiveClassCheck(names[0]);
            isNumber = buildPrimitiveClassCheck(names[1]);
            isString = buildPrimitiveClassCheck(names[2]);
            isDate = buildClassCheck(names[3]);
            isRegExp = buildClassCheck(names[4]);
            // Wanted to enhance performance here by using simply "typeof"
            // but Firefox has two major issues that make this impossible,
            // one fixed, the other not, so perform a full class check here.
            //
            // 1. Regexes can be typeof "function" in FF < 3
            //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
            //
            // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
            //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
            isFunction = buildClassCheck(names[5]);
            // istanbul ignore next
            isArray = Array.isArray || buildClassCheck(names[6]);
            isError = buildClassCheck(names[7]);
            isSet = buildClassCheck(names[8], typeof Set !== "undefined" && Set);
            isMap = buildClassCheck(names[9], typeof Map !== "undefined" && Map);
            // Add core types as known so that they can be checked by value below,
            // notably excluding Functions and adding Arguments and Error.
            addKnownType("Arguments");
            addKnownType(names[0]);
            addKnownType(names[1]);
            addKnownType(names[2]);
            addKnownType(names[3]);
            addKnownType(names[4]);
            addKnownType(names[6]);
        }
        function addArrayTypes() {
            var types = "Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64";
            forEach(spaceSplit(types), function(str) {
                addKnownType(str + "Array");
            });
        }
        function addKnownType(className) {
            var str = "[object " + className + "]";
            knownTypes[str] = true;
        }
        function isKnownType(className) {
            return knownTypes[className];
        }
        function buildClassCheck(className, globalObject) {
            // istanbul ignore if
            if (globalObject && isClass(new globalObject, "Object")) return getConstructorClassCheck(globalObject);
            else return getToStringClassCheck(className);
        }
        // Map and Set may be [object Object] in certain IE environments.
        // In this case we need to perform a check using the constructor
        // instead of Object.prototype.toString.
        // istanbul ignore next
        function getConstructorClassCheck(obj) {
            var ctorStr = String(obj);
            return function(obj) {
                return String(obj.constructor) === ctorStr;
            };
        }
        function getToStringClassCheck(className) {
            return function(obj, str) {
                // perf: Returning up front on instanceof appears to be slower.
                return isClass(obj, className, str);
            };
        }
        function buildPrimitiveClassCheck(className) {
            var type = className.toLowerCase();
            return function(obj) {
                var t = typeof obj;
                return t === type || t === "object" && isClass(obj, className);
            };
        }
        addCoreTypes();
        addArrayTypes();
        isSerializable = function isSerializable(obj, className) {
            // Only known objects can be serialized. This notably excludes functions,
            // host objects, Symbols (which are matched by reference), and instances
            // of classes. The latter can arguably be matched by value, but
            // distinguishing between these and host objects -- which should never be
            // compared by value -- is very tricky so not dealing with it here.
            return isKnownType(className) || isPlainObject(obj, className);
        };
    }
    function isClass(obj, className, str) {
        if (!str) str = classToString(obj);
        return str === "[object " + className + "]";
    }
    // Wrapping the core's "define" methods to
    // save a few bytes in the minified script.
    function wrapNamespace(method) {
        return function(sugarNamespace, arg1, arg2) {
            sugarNamespace[method](arg1, arg2);
        };
    }
    // Method define aliases
    var alias = wrapNamespace("alias"), defineStatic = wrapNamespace("defineStatic"), defineInstance = wrapNamespace("defineInstance"), defineStaticPolyfill = wrapNamespace("defineStaticPolyfill"), defineInstancePolyfill = wrapNamespace("defineInstancePolyfill"), defineInstanceAndStatic = wrapNamespace("defineInstanceAndStatic"), defineInstanceWithArguments = wrapNamespace("defineInstanceWithArguments");
    function defineInstanceSimilar(sugarNamespace, set, fn, flags) {
        defineInstance(sugarNamespace, collectSimilarMethods(set, fn), flags);
    }
    function defineInstanceAndStaticSimilar(sugarNamespace, set, fn, flags) {
        defineInstanceAndStatic(sugarNamespace, collectSimilarMethods(set, fn), flags);
    }
    function collectSimilarMethods(set, fn) {
        var methods = {};
        if (isString(set)) set = spaceSplit(set);
        forEach(set, function(el, i) {
            fn(methods, el, i);
        });
        return methods;
    }
    // This song and dance is to fix methods to a different length
    // from what they actually accept in order to stay in line with
    // spec. Additionally passing argument length, as some methods
    // throw assertion errors based on this (undefined check is not
    // enough). Fortunately for now spec is such that passing 3
    // actual arguments covers all requirements. Note that passing
    // the argument length also forces the compiler to not rewrite
    // length of the compiled function.
    function fixArgumentLength(fn) {
        var staticFn = function staticFn(a) {
            var args = arguments;
            return fn(a, args[1], args[2], args.length - 1);
        };
        staticFn.instance = function(b) {
            var args = arguments;
            return fn(this, b, args[1], args.length);
        };
        return staticFn;
    }
    function defineAccessor(namespace, name, fn) {
        setProperty(namespace, name, fn);
    }
    function defineOptionsAccessor(namespace, defaults) {
        var obj = simpleClone(defaults);
        function getOption(name) {
            return obj[name];
        }
        function setOption(arg1, arg2) {
            var options;
            if (arguments.length === 1) options = arg1;
            else {
                options = {};
                options[arg1] = arg2;
            }
            forEachProperty(options, function(val, name) {
                if (val === null) val = defaults[name];
                obj[name] = val;
            });
        }
        defineAccessor(namespace, "getOption", getOption);
        defineAccessor(namespace, "setOption", setOption);
        return getOption;
    }
    // For methods defined directly on the prototype like Range
    function defineOnPrototype(ctor, methods) {
        var proto = ctor.prototype;
        forEachProperty(methods, function(val, key) {
            proto[key] = val;
        });
    }
    // Argument helpers
    function assertArgument(exists) {
        if (!exists) throw new TypeError("Argument required");
    }
    function assertCallable(obj) {
        if (!isFunction(obj)) throw new TypeError("Function is not callable");
    }
    function assertArray(obj) {
        if (!isArray(obj)) throw new TypeError("Array required");
    }
    function assertWritable(obj) {
        if (isPrimitive(obj)) // If strict mode is active then primitives will throw an
        // error when attempting to write properties. We can't be
        // sure if strict mode is available, so pre-emptively
        // throw an error here to ensure consistent behavior.
        throw new TypeError("Property cannot be written");
    }
    // Coerces an object to a positive integer.
    // Does not allow Infinity.
    function coercePositiveInteger(n) {
        n = +n || 0;
        if (n < 0 || !isNumber(n) || !isFinite(n)) throw new RangeError("Invalid number");
        return trunc(n);
    }
    // General helpers
    function isDefined(o) {
        return o !== undefined;
    }
    function isUndefined(o) {
        return o === undefined;
    }
    function privatePropertyAccessor(key) {
        var privateKey = PRIVATE_PROP_PREFIX + key;
        return function(obj, val) {
            if (arguments.length > 1) {
                setProperty(obj, privateKey, val);
                return obj;
            }
            return obj[privateKey];
        };
    }
    function setChainableConstructor(sugarNamespace, createFn) {
        sugarNamespace.prototype.constructor = function() {
            return createFn.apply(this, arguments);
        };
    }
    // Fuzzy matching helpers
    function getMatcher(f) {
        if (!isPrimitive(f)) {
            var className = classToString(f);
            if (isRegExp(f, className)) return regexMatcher(f);
            else if (isDate(f, className)) return dateMatcher(f);
            else if (isFunction(f, className)) return functionMatcher(f);
            else if (isPlainObject(f, className)) return fuzzyMatcher(f);
        }
        // Default is standard isEqual
        return defaultMatcher(f);
    }
    function fuzzyMatcher(obj) {
        var matchers = {};
        return function(el, i, arr) {
            var matched = true;
            if (!isObjectType(el)) return false;
            forEachProperty(obj, function(val, key) {
                matchers[key] = getOwn(matchers, key) || getMatcher(val);
                if (matchers[key].call(arr, el[key], i, arr) === false) matched = false;
                return matched;
            });
            return matched;
        };
    }
    function defaultMatcher(f) {
        return function(el) {
            return isEqual(el, f);
        };
    }
    function regexMatcher(reg) {
        reg = RegExp(reg);
        return function(el) {
            return reg.test(el);
        };
    }
    function dateMatcher(d) {
        var ms = d.getTime();
        return function(el) {
            return !!(el && el.getTime) && el.getTime() === ms;
        };
    }
    function functionMatcher(fn) {
        return function(el, i, arr) {
            // Return true up front if match by reference
            return el === fn || fn.call(arr, el, i, arr);
        };
    }
    // Object helpers
    function getKeys(obj) {
        return Object.keys(obj);
    }
    function deepHasProperty(obj, key, any) {
        return handleDeepProperty(obj, key, any, true);
    }
    function deepGetProperty(obj, key, any) {
        return handleDeepProperty(obj, key, any, false);
    }
    function deepSetProperty(obj, key, val) {
        handleDeepProperty(obj, key, false, false, true, false, val);
        return obj;
    }
    function handleDeepProperty(obj, key, any, has, fill, fillLast, val) {
        var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
        ns = obj;
        if (key == null) return;
        if (isObjectType(key)) // Allow array and array-like accessors
        bs = [
            key
        ];
        else {
            key = String(key);
            if (key.indexOf("..") !== -1) return handleArrayIndexRange(obj, key, any, val);
            bs = key.split("[");
        }
        set = isDefined(val);
        for(var i = 0, blen = bs.length; i < blen; i++){
            ps = bs[i];
            if (isString(ps)) ps = periodSplit(ps);
            for(var j = 0, plen = ps.length; j < plen; j++){
                key = ps[j];
                // Is this the last key?
                isLast = i === blen - 1 && j === plen - 1;
                // Index of the closing ]
                cbi = key.indexOf("]");
                // Is the key an array index?
                isIndex = cbi !== -1;
                // Is this array push syntax "[]"?
                isPush = set && cbi === 0;
                // If the bracket split was successful and this is the last element
                // in the dot split, then we know the next key will be an array index.
                nextIsIndex = blen > 1 && j === plen - 1;
                if (isPush) // Set the index to the end of the array
                key = ns.length;
                else if (isIndex) // Remove the closing ]
                key = key.slice(0, -1);
                // If the array index is less than 0, then
                // add its length to allow negative indexes.
                if (isIndex && key < 0) key = +key + ns.length;
                // Bracket keys may look like users[5] or just [5], so the leading
                // characters are optional. We can enter the namespace if this is the
                // 2nd part, if there is only 1 part, or if there is an explicit key.
                if (i || key || blen === 1) {
                    // TODO: need to be sure this check handles ''.length when
                    // we refactor.
                    exists = any ? key in Object(ns) : hasOwn(ns, key);
                    // Non-existent namespaces are only filled if they are intermediate
                    // (not at the end) or explicitly filling the last.
                    if (fill && (!isLast || fillLast) && !exists) {
                        // For our purposes, last only needs to be an array.
                        ns = ns[key] = nextIsIndex || fillLast && isLast ? [] : {};
                        continue;
                    }
                    if (has) {
                        if (isLast || !exists) return exists;
                    } else if (set && isLast) {
                        assertWritable(ns);
                        ns[key] = val;
                    }
                    ns = exists ? ns[key] : undefined;
                }
            }
        }
        return ns;
    }
    // Get object property with support for 0..1 style range notation.
    function handleArrayIndexRange(obj, key, any, val) {
        var match, start, end, leading, trailing, arr, set;
        match = key.match(PROPERTY_RANGE_REG);
        if (!match) return;
        set = isDefined(val);
        leading = match[1];
        if (leading) arr = handleDeepProperty(obj, leading, any, false, set ? true : false, true);
        else arr = obj;
        assertArray(arr);
        trailing = match[4];
        start = match[2] ? +match[2] : 0;
        end = match[3] ? +match[3] : arr.length;
        // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
        // pushes the index from -1 to 0, then set it to the full length of the
        // array, otherwise it will return nothing.
        end = end === -1 ? arr.length : end + 1;
        if (set) for(var i = start; i < end; i++)handleDeepProperty(arr, i + trailing, any, false, true, false, val);
        else {
            arr = arr.slice(start, end);
            // If there are trailing properties, then they need to be mapped for each
            // element in the array.
            if (trailing) {
                if (trailing.charAt(0) === HALF_WIDTH_PERIOD) // Need to chomp the period if one is trailing after the range. We
                // can't do this at the regex level because it will be required if
                // we're setting the value as it needs to be concatentated together
                // with the array index to be set.
                trailing = trailing.slice(1);
                return map(arr, function(el) {
                    return handleDeepProperty(el, trailing);
                });
            }
        }
        return arr;
    }
    function getOwnKey(obj, key) {
        if (hasOwn(obj, key)) return key;
    }
    function hasProperty(obj, prop) {
        return !isPrimitive(obj) && prop in obj;
    }
    function isObjectType(obj, type) {
        return !!obj && (type || typeof obj) === "object";
    }
    function isPrimitive(obj, type) {
        type = type || typeof obj;
        return obj == null || type === "string" || type === "number" || type === "boolean";
    }
    function isPlainObject(obj, className) {
        return isObjectType(obj) && isClass(obj, "Object", className) && hasValidPlainObjectPrototype(obj) && hasOwnEnumeratedProperties(obj);
    }
    function hasValidPlainObjectPrototype(obj) {
        var hasToString = "toString" in obj;
        var hasConstructor = "constructor" in obj;
        // An object created with Object.create(null) has no methods in the
        // prototype chain, so check if any are missing. The additional hasToString
        // check is for false positives on some host objects in old IE which have
        // toString but no constructor. If the object has an inherited constructor,
        // then check if it is Object (the "isPrototypeOf" tapdance here is a more
        // robust way of ensuring this if the global has been hijacked). Note that
        // accessing the constructor directly (without "in" or "hasOwnProperty")
        // will throw a permissions error in IE8 on cross-domain windows.
        return !hasConstructor && !hasToString || hasConstructor && !hasOwn(obj, "constructor") && hasOwn(obj.constructor.prototype, "isPrototypeOf");
    }
    function hasOwnEnumeratedProperties(obj) {
        // Plain objects are generally defined as having enumerated properties
        // all their own, however in early IE environments without defineProperty,
        // there may also be enumerated methods in the prototype chain, so check
        // for both of these cases.
        var objectProto = Object.prototype;
        for(var key in obj){
            var val = obj[key];
            if (!hasOwn(obj, key) && val !== objectProto[key]) return false;
        }
        return true;
    }
    function simpleRepeat(n, fn) {
        for(var i = 0; i < n; i++)fn(i);
    }
    function simpleClone(obj) {
        return simpleMerge({}, obj);
    }
    // TODO: Use Object.assign here going forward.
    function simpleMerge(target, source) {
        forEachProperty(source, function(val, key) {
            target[key] = val;
        });
        return target;
    }
    // Make primtives types like strings into objects.
    function coercePrimitiveToObject(obj) {
        if (isPrimitive(obj)) obj = Object(obj);
        // istanbul ignore next
        if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) forceStringCoercion(obj);
        return obj;
    }
    // Force strings to have their indexes set in
    // environments that don't do this automatically.
    // istanbul ignore next
    function forceStringCoercion(obj) {
        var i = 0, chr;
        while(chr = obj.charAt(i))obj[i++] = chr;
    }
    // Equality helpers
    // Perf
    function isEqual(a, b, stack) {
        var aClass, bClass;
        if (a === b) // Return quickly up front when matched by reference,
        // but be careful about 0 !== -0.
        return a !== 0 || 1 / a === 1 / b;
        aClass = classToString(a);
        bClass = classToString(b);
        if (aClass !== bClass) return false;
        if (isSerializable(a, aClass) && isSerializable(b, bClass)) return objectIsEqual(a, b, aClass, stack);
        else if (isSet(a, aClass) && isSet(b, bClass)) return a.size === b.size && isEqual(setToArray(a), setToArray(b), stack);
        else if (isMap(a, aClass) && isMap(b, bClass)) return a.size === b.size && isEqual(mapToArray(a), mapToArray(b), stack);
        else if (isError(a, aClass) && isError(b, bClass)) return a.toString() === b.toString();
        return false;
    }
    // Perf
    function objectIsEqual(a, b, aClass, stack) {
        var aType = typeof a, bType = typeof b, propsEqual, count;
        if (aType !== bType) return false;
        if (isObjectType(a.valueOf())) {
            if (a.length !== b.length) // perf: Quickly returning up front for arrays.
            return false;
            count = 0;
            propsEqual = true;
            iterateWithCyclicCheck(a, false, stack, function(key, val, cyc, stack) {
                if (!cyc && (!(key in b) || !isEqual(val, b[key], stack))) propsEqual = false;
                count++;
                return propsEqual;
            });
            if (!propsEqual || count !== getKeys(b).length) return false;
        }
        // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
        return a.valueOf().toString() === b.valueOf().toString();
    }
    // Serializes an object in a way that will provide a token unique
    // to the type, class, and value of an object. Host objects, class
    // instances etc, are not serializable, and are held in an array
    // of references that will return the index as a unique identifier
    // for the object. This array is passed from outside so that the
    // calling function can decide when to dispose of this array.
    function serializeInternal(obj, refs, stack) {
        var type = typeof obj, sign = "", className, value, ref;
        // Return up front on
        if (1 / obj === -Infinity) sign = "-";
        // Return quickly for primitives to save cycles
        if (isPrimitive(obj, type) && !isRealNaN(obj)) return type + sign + obj;
        className = classToString(obj);
        if (!isSerializable(obj, className)) {
            ref = indexOf(refs, obj);
            if (ref === -1) {
                ref = refs.length;
                refs.push(obj);
            }
            return ref;
        } else if (isObjectType(obj)) value = serializeDeep(obj, refs, stack) + obj.toString();
        else if (obj.valueOf) value = obj.valueOf();
        return type + className + sign + value;
    }
    function serializeDeep(obj, refs, stack) {
        var result = "";
        iterateWithCyclicCheck(obj, true, stack, function(key, val, cyc, stack) {
            result += cyc ? "CYC" : key + serializeInternal(val, refs, stack);
        });
        return result;
    }
    function iterateWithCyclicCheck(obj, sortedKeys, stack, fn) {
        function next(val, key) {
            var cyc = false;
            // Allowing a step into the structure before triggering this check to save
            // cycles on standard JSON structures and also to try as hard as possible to
            // catch basic properties that may have been modified.
            if (stack.length > 1) {
                var i = stack.length;
                while(i--)if (stack[i] === val) cyc = true;
            }
            stack.push(val);
            fn(key, val, cyc, stack);
            stack.pop();
        }
        function iterateWithSortedKeys() {
            // Sorted keys is required for serialization, where object order
            // does not matter but stringified order does.
            var arr = getKeys(obj).sort(), key;
            for(var i = 0; i < arr.length; i++){
                key = arr[i];
                next(obj[key], arr[i]);
            }
        }
        // This method for checking for cyclic structures was egregiously stolen from
        // the ingenious method by @kitcambridge from the Underscore script:
        // https://github.com/documentcloud/underscore/issues/240
        if (!stack) stack = [];
        if (sortedKeys) iterateWithSortedKeys();
        else forEachProperty(obj, next);
    }
    // Array helpers
    function isArrayIndex(n) {
        return n >>> 0 == n && n != 0xFFFFFFFF;
    }
    function iterateOverSparseArray(arr, fn, fromIndex, loop) {
        var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
        for(var i = 0, len = indexes.length; i < len; i++){
            index = indexes[i];
            fn.call(arr, arr[index], index, arr);
        }
        return arr;
    }
    // It's unclear whether or not sparse arrays qualify as "simple enumerables".
    // If they are not, however, the wrapping function will be deoptimized, so
    // isolate here (also to share between es5 and array modules).
    function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
        var indexes = [], i;
        for(i in arr)// istanbul ignore next
        if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) indexes.push(+i);
        indexes.sort(function(a, b) {
            var aLoop = a > fromIndex;
            var bLoop = b > fromIndex;
            // This block cannot be reached unless ES5 methods are being shimmed.
            // istanbul ignore if
            if (aLoop !== bLoop) return aLoop ? -1 : 1;
            return a - b;
        });
        return indexes;
    }
    function getEntriesForIndexes(obj, find, loop, isString) {
        var result, length = obj.length;
        if (!isArray(find)) return entryAtIndex(obj, find, length, loop, isString);
        result = new Array(find.length);
        forEach(find, function(index, i) {
            result[i] = entryAtIndex(obj, index, length, loop, isString);
        });
        return result;
    }
    function getNormalizedIndex(index, length, loop) {
        if (index && loop) index = index % length;
        if (index < 0) index = length + index;
        return index;
    }
    function entryAtIndex(obj, index, length, loop, isString) {
        index = getNormalizedIndex(index, length, loop);
        return isString ? obj.charAt(index) : obj[index];
    }
    function mapWithShortcuts(el, f, context, mapArgs) {
        if (!f) return el;
        else if (f.apply) return f.apply(context, mapArgs);
        else if (isArray(f)) return map(f, function(m) {
            return mapWithShortcuts(el, m, context, mapArgs);
        });
        else if (isFunction(el[f])) return el[f].call(el);
        else return deepGetProperty(el, f, true);
    }
    function spaceSplit(str) {
        return str.split(" ");
    }
    function commaSplit(str) {
        return str.split(HALF_WIDTH_COMMA);
    }
    function periodSplit(str) {
        return str.split(HALF_WIDTH_PERIOD);
    }
    function forEach(arr, fn) {
        for(var i = 0, len = arr.length; i < len; i++){
            if (!(i in arr)) return iterateOverSparseArray(arr, fn, i);
            fn(arr[i], i);
        }
    }
    function filter(arr, fn) {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var el = arr[i];
            if (i in arr && fn(el, i)) result.push(el);
        }
        return result;
    }
    function map(arr, fn) {
        // perf: Not using fixed array len here as it may be sparse.
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (i in arr) result.push(fn(arr[i], i));
        return result;
    }
    function indexOf(arr, el) {
        for(var i = 0, len = arr.length; i < len; i++){
            if (i in arr && arr[i] === el) return i;
        }
        return -1;
    }
    // Number helpers
    // istanbul ignore next
    var trunc = Math.trunc || function(n) {
        if (n === 0 || !isFinite(n)) return n;
        return n < 0 ? ceil(n) : floor(n);
    };
    function isRealNaN(obj) {
        // This is only true of NaN
        return obj != null && obj !== obj;
    }
    function withPrecision(val, precision, fn) {
        var multiplier = pow(10, abs(precision || 0));
        fn = fn || round;
        if (precision < 0) multiplier = 1 / multiplier;
        return fn(val * multiplier) / multiplier;
    }
    function padNumber(num, place, sign, base, replacement) {
        var str = abs(num).toString(base || 10);
        str = repeatString(replacement || "0", place - str.replace(/\.\d+/, "").length) + str;
        if (sign || num < 0) str = (num < 0 ? "-" : "+") + str;
        return str;
    }
    function getOrdinalSuffix(num) {
        if (num >= 11 && num <= 13) return "th";
        else switch(num % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }
    // Fullwidth number helpers
    var fullWidthNumberReg, fullWidthNumberMap, fullWidthNumbers;
    function buildFullWidthNumber() {
        var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA, fwn = "";
        fullWidthNumberMap = {};
        for(var i = 0, digit; i <= 9; i++){
            digit = chr(i + FULL_WIDTH_ZERO);
            fwn += digit;
            fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
        }
        fullWidthNumberMap[hwc] = "";
        fullWidthNumberMap[fwp] = hwp;
        // Mapping this to itself to capture it easily
        // in stringToNumber to detect decimals later.
        fullWidthNumberMap[hwp] = hwp;
        fullWidthNumberReg = allCharsReg(fwn + fwp + hwc + hwp);
        fullWidthNumbers = fwn;
    }
    // Takes into account full-width characters, commas, and decimals.
    function stringToNumber(str, base) {
        var sanitized, isDecimal;
        sanitized = str.replace(fullWidthNumberReg, function(chr) {
            var replacement = getOwn(fullWidthNumberMap, chr);
            if (replacement === HALF_WIDTH_PERIOD) isDecimal = true;
            return replacement;
        });
        return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
    }
    // Math aliases
    var abs = Math.abs, pow = Math.pow, min = Math.min, max = Math.max, ceil = Math.ceil, floor = Math.floor, round = Math.round;
    // String helpers
    var chr = String.fromCharCode;
    function trim(str) {
        return str.trim();
    }
    function repeatString(str, num) {
        var result = "";
        str = str.toString();
        while(num > 0){
            if (num & 1) result += str;
            if (num >>= 1) str += str;
        }
        return result;
    }
    function simpleCapitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    function createFormatMatcher(bracketMatcher, percentMatcher, precheck) {
        var reg = STRING_FORMAT_REG;
        var compileMemoized = memoizeFunction(compile);
        function getToken(format, match) {
            var get, token, literal, fn;
            var bKey = match[2];
            var pLit = match[3];
            var pKey = match[5];
            if (match[4] && percentMatcher) {
                token = pKey;
                get = percentMatcher;
            } else if (bKey) {
                token = bKey;
                get = bracketMatcher;
            } else if (pLit && percentMatcher) literal = pLit;
            else literal = match[1] || match[0];
            if (get) {
                assertPassesPrecheck(precheck, bKey, pKey);
                fn = function fn(obj, opt) {
                    return get(obj, token, opt);
                };
            }
            format.push(fn || getLiteral(literal));
        }
        function getSubstring(format, str, start, end) {
            if (end > start) {
                var sub = str.slice(start, end);
                assertNoUnmatched(sub, OPEN_BRACE);
                assertNoUnmatched(sub, CLOSE_BRACE);
                format.push(function() {
                    return sub;
                });
            }
        }
        function getLiteral(str) {
            return function() {
                return str;
            };
        }
        function assertPassesPrecheck(precheck, bt, pt) {
            if (precheck && !precheck(bt, pt)) throw new TypeError("Invalid token " + (bt || pt) + " in format string");
        }
        function assertNoUnmatched(str, chr) {
            if (str.indexOf(chr) !== -1) throw new TypeError("Unmatched " + chr + " in format string");
        }
        function compile(str) {
            var format = [], lastIndex = 0, match;
            reg.lastIndex = 0;
            while(match = reg.exec(str)){
                getSubstring(format, str, lastIndex, match.index);
                getToken(format, match);
                lastIndex = reg.lastIndex;
            }
            getSubstring(format, str, lastIndex, str.length);
            return format;
        }
        return function(str, obj, opt) {
            var format = compileMemoized(str), result = "";
            for(var i = 0; i < format.length; i++)result += format[i](obj, opt);
            return result;
        };
    }
    // Inflection helper
    var Inflections = {};
    function getAcronym(str) {
        // istanbul ignore next
        return Inflections.acronyms && Inflections.acronyms.find(str);
    }
    function getHumanWord(str) {
        // istanbul ignore next
        return Inflections.human && Inflections.human.find(str);
    }
    function runHumanRules(str) {
        // istanbul ignore next
        return Inflections.human && Inflections.human.runRules(str) || str;
    }
    // RegExp helpers
    function allCharsReg(src) {
        return RegExp("[" + src + "]", "g");
    }
    function getRegExpFlags(reg, add) {
        var flags = "";
        add = add || "";
        function checkFlag(prop, flag) {
            if (prop || add.indexOf(flag) > -1) flags += flag;
        }
        checkFlag(reg.global, "g");
        checkFlag(reg.ignoreCase, "i");
        checkFlag(reg.multiline, "m");
        checkFlag(reg.sticky, "y");
        return flags;
    }
    function escapeRegExp(str) {
        if (!isString(str)) str = String(str);
        return str.replace(/([\\/'*+?|()[\]{}.^$-])/g, "\\$1");
    }
    // Date helpers
    var _utc = privatePropertyAccessor("utc");
    function callDateGet(d, method) {
        return d["get" + (_utc(d) ? "UTC" : "") + method]();
    }
    function callDateSet(d, method, value, safe) {
        // "Safe" denotes not setting the date if the value is the same as what is
        // currently set. In theory this should be a noop, however it will cause
        // timezone shifts when in the middle of a DST fallback. This is unavoidable
        // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
        // November 1st, 2015 in northern hemisphere timezones that follow DST),
        // however when advancing or rewinding dates this can throw off calculations
        // so avoiding this unintentional shifting on an opt-in basis.
        if (safe && value === callDateGet(d, method, value)) return;
        d["set" + (_utc(d) ? "UTC" : "") + method](value);
    }
    // Memoization helpers
    var INTERNAL_MEMOIZE_LIMIT = 1000;
    // Note that attemps to consolidate this with Function#memoize
    // ended up clunky as that is also serializing arguments. Separating
    // these implementations turned out to be simpler.
    function memoizeFunction(fn) {
        var memo = {}, counter = 0;
        return function(key) {
            if (hasOwn(memo, key)) return memo[key];
            // istanbul ignore if
            if (counter === INTERNAL_MEMOIZE_LIMIT) {
                memo = {};
                counter = 0;
            }
            counter++;
            return memo[key] = fn(key);
        };
    }
    // ES6 helpers
    function setToArray(set) {
        var arr = new Array(set.size), i = 0;
        set.forEach(function(val) {
            arr[i++] = val;
        });
        return arr;
    }
    function mapToArray(map) {
        var arr = new Array(map.size), i = 0;
        map.forEach(function(val, key) {
            arr[i++] = [
                key,
                val
            ];
        });
        return arr;
    }
    buildClassChecks();
    buildFullWidthNumber();
    /***
   * @module ES5
   * @description Functions and polyfill methods that fix ES5 functionality. This
   *              module is excluded from default builds, and can be included if
   *              you need legacy browser support (IE8 and below).
   *
   ***/ // Non-enumerable properties on Object.prototype. In early JScript implementations
    // (< IE9) these will shadow object properties and break for..in loops.
    var DONT_ENUM_PROPS = [
        "valueOf",
        "toString",
        "constructor",
        "isPrototypeOf",
        "hasOwnProperty",
        "toLocaleString",
        "propertyIsEnumerable"
    ];
    /***
   * @fix
   * @short Fixes DontEnum bug for iteration methods in < IE9.
   ***/ function buildDontEnumFix() {
        if (!({
            toString: 1
        }).propertyIsEnumerable("toString")) {
            var forEachEnumerableProperty = forEachProperty;
            forEachProperty = function forEachProperty(obj, fn) {
                forEachEnumerableProperty(obj, fn);
                for(var i = 0, key; key = DONT_ENUM_PROPS[i]; i++)if (hasOwn(obj, key)) {
                    if (fn.call(obj, obj[key], key, obj) === false) break;
                }
            };
        }
    }
    /***
   * @fix
   * @short Adds native methods to chainables in < IE9.
   ***/ function buildChainableNativeMethodsFix() {
        if (!Object.getOwnPropertyNames) defineNativeMethodsOnChainable();
    }
    // Polyfilled methods will automatically be added to the chainable prototype.
    // However, Object.getOwnPropertyNames cannot be shimmed for non-enumerable
    // properties, so if it does not exist, then the only way to access native
    // methods previous to ES5 is to provide them as a list of tokens here.
    function defineNativeMethodsOnChainable() {
        var nativeTokens = {
            "Function": "apply,call",
            "RegExp": "compile,exec,test",
            "Number": "toExponential,toFixed,toLocaleString,toPrecision",
            "Object": "hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString",
            "Array": "concat,join,pop,push,reverse,shift,slice,sort,splice,toLocaleString,unshift",
            "Date": "getTime,getTimezoneOffset,setTime,toDateString,toGMTString,toLocaleDateString,toLocaleString,toLocaleTimeString,toTimeString,toUTCString",
            "String": "anchor,big,blink,bold,charAt,charCodeAt,concat,fixed,fontcolor,fontsize,indexOf,italics,lastIndexOf,link,localeCompare,match,replace,search,slice,small,split,strike,sub,substr,substring,sup,toLocaleLowerCase,toLocaleUpperCase,toLowerCase,toUpperCase"
        };
        var dateTokens = "FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds".split(",");
        function addDateTokens(prefix, arr) {
            for(var i = 0; i < dateTokens.length; i++)arr.push(prefix + dateTokens[i]);
        }
        forEachProperty(nativeTokens, function(str, name) {
            var tokens = str.split(",");
            if (name === "Date") {
                addDateTokens("get", tokens);
                addDateTokens("set", tokens);
                addDateTokens("getUTC", tokens);
                addDateTokens("setUTC", tokens);
            }
            tokens.push("toString");
            mapNativeToChainable(name, tokens);
        });
    }
    buildDontEnumFix();
    buildChainableNativeMethodsFix();
    /*** @namespace Object ***/ function assertNonNull(obj) {
        if (obj == null) throw new TypeError("Object required");
    }
    defineStaticPolyfill(sugarObject, {
        "keys": function(obj) {
            var keys = [];
            assertNonNull(obj);
            forEachProperty(coercePrimitiveToObject(obj), function(val, key) {
                keys.push(key);
            });
            return keys;
        }
    });
    /*** @namespace Array ***/ function arrayIndexOf(arr, search, fromIndex, fromRight) {
        var length = arr.length, defaultFromIndex, index, increment;
        increment = fromRight ? -1 : 1;
        defaultFromIndex = fromRight ? length - 1 : 0;
        fromIndex = trunc(fromIndex);
        if (!fromIndex && fromIndex !== 0) fromIndex = defaultFromIndex;
        if (fromIndex < 0) fromIndex = length + fromIndex;
        if (!fromRight && fromIndex < 0 || fromRight && fromIndex >= length) fromIndex = defaultFromIndex;
        index = fromIndex;
        while(fromRight && index >= 0 || !fromRight && index < length){
            if (!(index in arr)) return sparseIndexOf(arr, search, fromIndex, fromRight);
            if (isArrayIndex(index) && arr[index] === search) return index;
            index += increment;
        }
        return -1;
    }
    function sparseIndexOf(arr, search, fromIndex, fromRight) {
        var indexes = getSparseArrayIndexes(arr, fromIndex, false, fromRight), index;
        indexes.sort(function(a, b) {
            return fromRight ? b - a : a - b;
        });
        while((index = indexes.shift()) !== undefined){
            if (arr[index] === search) return +index;
        }
        return -1;
    }
    function arrayReduce(arr, fn, initialValue, fromRight) {
        var length = arr.length, count = 0, defined = isDefined(initialValue), result, index;
        assertCallable(fn);
        if (length == 0 && !defined) throw new TypeError("Reduce called on empty array with no initial value");
        else if (defined) result = initialValue;
        else {
            result = arr[fromRight ? length - 1 : count];
            count++;
        }
        while(count < length){
            index = fromRight ? length - count - 1 : count;
            if (index in arr) result = fn(result, arr[index], index, arr);
            count++;
        }
        return result;
    }
    defineStaticPolyfill(sugarArray, {
        /***
     *
     * @method isArray(obj)
     * @returns Boolean
     * @polyfill ES5
     * @static
     * @short Returns true if `obj` is an Array.
     *
     * @example
     *
     *   Array.isArray(3)        -> false
     *   Array.isArray(true)     -> false
     *   Array.isArray('wasabi') -> false
     *   Array.isArray([1,2,3])  -> true
     *
     ***/ "isArray": function(obj) {
            return isArray(obj);
        }
    });
    defineInstancePolyfill(sugarArray, {
        "every": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0;
            assertCallable(fn);
            while(index < length){
                if (index in this && !fn.call(context, this[index], index, this)) return false;
                index++;
            }
            return true;
        },
        "some": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0;
            assertCallable(fn);
            while(index < length){
                if (index in this && fn.call(context, this[index], index, this)) return true;
                index++;
            }
            return false;
        },
        "map": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0, result = new Array(length);
            assertCallable(fn);
            while(index < length){
                if (index in this) result[index] = fn.call(context, this[index], index, this);
                index++;
            }
            return result;
        },
        "filter": function(fn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0, result = [];
            assertCallable(fn);
            while(index < length){
                if (index in this && fn.call(context, this[index], index, this)) result.push(this[index]);
                index++;
            }
            return result;
        },
        /***
     * @method indexOf(search, [fromIndex] = 0)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array and returns the first index where `search` occurs,
     *        or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This
     *        method performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *        For such functionality, use the `findIndex` method instead.
     *
     * @example
     *
     *   [1,2,3].indexOf(3) -> 1
     *   [1,2,3].indexOf(7) -> -1
     *
     ***/ "indexOf": function(search) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, fromIndex = arguments[1];
            if (isString(this)) return this.indexOf(search, fromIndex);
            return arrayIndexOf(this, search, fromIndex);
        },
        /***
     * @method lastIndexOf(search, [fromIndex] = array.length - 1)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array from the end and returns the first index where
     *        `search` occurs, or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This method
     *        performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *
     * @example
     *
     *   [1,2,1].lastIndexOf(1) -> 2
     *   [1,2,1].lastIndexOf(7) -> -1
     *
     ***/ "lastIndexOf": function(search) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, fromIndex = arguments[1];
            if (isString(this)) return this.lastIndexOf(search, fromIndex);
            return arrayIndexOf(this, search, fromIndex, true);
        },
        /***
     * @method forEach([eachFn], [context])
     * @polyfill ES5
     * @short Iterates over the array, calling [eachFn] on each loop.
     * @extra [context] becomes the `this` object.
     *
     * @callback eachFn
     *
     *   el   The element of the current iteration.
     *   i    The index of the current iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   ['a','b','c'].forEach(function(a) {
     *     // Called 3 times: 'a','b','c'
     *   });
     *
     ***/ "forEach": function(eachFn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            var length = this.length, index = 0;
            assertCallable(eachFn);
            while(index < length){
                if (index in this) eachFn.call(context, this[index], index, this);
                index++;
            }
        },
        /***
     * @method reduce(reduceFn, [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Reduces the array to a single result.
     * @extra This operation is sometimes called "accumulation", as it takes the
     *        result of the last iteration of `reduceFn` and passes it as the first
     *        argument to the next iteration, "accumulating" that value as it goes.
     *        The return value of this method will be the return value of the final
     *        iteration of `reduceFn`. If [init] is passed, it will be the initial
     *        "accumulator" (the first argument). If [init] is not passed, then it
     *        will take the first element in the array, and `reduceFn` will not be
     *        called for that element.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator". Either [init], the result of the last iteration
     *        of `reduceFn`, or the first element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 1 - 2 - 3
     *   });
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 100 - 1 - 2 - 3
     *   }, 100);
     *
     ***/ "reduce": function(reduceFn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            return arrayReduce(this, reduceFn, context);
        },
        /***
     * @method reduceRight([reduceFn], [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Similar to `Array#reduce`, but operates on the elements in reverse.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator", either [init], the result of the last iteration
     *        of `reduceFn`, or the last element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 3 - 2 - 1
     *   });
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 100 - 3 - 2 - 1
     *   }, 100);
     *
     *
     ***/ "reduceRight": function(reduceFn) {
            // Force compiler to respect argument length.
            var argLen = arguments.length, context = arguments[1];
            return arrayReduce(this, reduceFn, context, true);
        }
    });
    /*** @namespace String ***/ var TRIM_REG = RegExp("^[" + TRIM_CHARS + "]+|[" + TRIM_CHARS + "]+$", "g");
    defineInstancePolyfill(sugarString, {
        /***
     * @method trim()
     * @returns String
     * @polyfill ES5
     * @short Removes leading and trailing whitespace from the string.
     * @extra Whitespace is defined as line breaks, tabs, and any character in the
     *        "Space, Separator" Unicode category, conforming to the the ES5 spec.
     *
     * @example
     *
     *   '   wasabi   '.trim()      -> 'wasabi'
     *   '   wasabi   '.trimLeft()  -> 'wasabi   '
     *   '   wasabi   '.trimRight() -> '   wasabi'
     *
     ***/ "trim": function() {
            return this.toString().replace(TRIM_REG, "");
        }
    });
    /*** @namespace Function ***/ defineInstancePolyfill(sugarFunction, {
        /***
     * @method bind(context, [arg1], ...)
     * @returns Function
     * @polyfill ES5
     * @short Binds `context` as the `this` object for the function when it is
     *        called. Also allows currying an unlimited number of parameters.
     * @extra "currying" means setting parameters ([arg1], [arg2], etc.) ahead of
     *        time so that they are passed when the function is called later. If
     *        you pass additional parameters when the function is actually called,
     *        they will be added to the end of the curried parameters.
     *
     * @example
     *
     *   logThis.bind('woof')()   -> logs 'woof' as its this object
     *   addArgs.bind(1, 2, 3)()  -> returns 5 with 1 as the this object
     *   addArgs.bind(1)(2, 3, 4) -> returns 9
     *
     ***/ "bind": function(context) {
            // Optimized: no leaking arguments
            var boundArgs = [];
            for(var $i = 1, $len = arguments.length; $i < $len; $i++)boundArgs.push(arguments[$i]);
            var fn = this, bound;
            assertCallable(this);
            bound = function bound() {
                // Optimized: no leaking arguments
                var args = [];
                for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
                return fn.apply(fn.prototype && this instanceof fn ? this : context, boundArgs.concat(args));
            };
            bound.prototype = this.prototype;
            return bound;
        }
    });
    /*** @namespace Date ***/ defineStaticPolyfill(sugarDate, {
        /***
     * @method now()
     * @returns String
     * @polyfill ES5
     * @static
     * @short Returns the current time as a Unix timestamp.
     * @extra The number of milliseconds since January 1st, 1970 00:00:00 (UTC).
     *
     * @example
     *
     *   Date.now() -> ex. 1311938296231
     *
     ***/ "now": function() {
            return new Date().getTime();
        }
    });
    function hasISOSupport() {
        var d = new Date(Date.UTC(2000, 0));
        return !!d.toISOString && d.toISOString() === "2000-01-01T00:00:00.000Z";
    }
    defineInstancePolyfill(sugarDate, {
        /***
     * @method toISOString()
     * @returns String
     * @polyfill ES5
     * @short Formats the string to ISO8601 format.
     * @extra This will always format as UTC time.
     *
     * @example
     *
     *   Date.create().toISOString() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/ "toISOString": function() {
            return padNumber(this.getUTCFullYear(), 4) + "-" + padNumber(this.getUTCMonth() + 1, 2) + "-" + padNumber(this.getUTCDate(), 2) + "T" + padNumber(this.getUTCHours(), 2) + ":" + padNumber(this.getUTCMinutes(), 2) + ":" + padNumber(this.getUTCSeconds(), 2) + "." + padNumber(this.getUTCMilliseconds(), 3) + "Z";
        },
        /***
     * @method toJSON([key])
     * @returns String
     * @polyfill ES5
     * @short Returns a JSON representation of the date.
     * @extra This is effectively an alias for `toISOString`. Will always return
     *        the date in UTC time. [key] is ignored.
     *
     * @example
     *
     *   Date.create().toJSON() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/ "toJSON": function(key) {
            // Force compiler to respect argument length.
            var argLen = arguments.length;
            return this.toISOString(key);
        }
    }, !hasISOSupport());
}).call(this);

},{}],"1apCQ":[function(require,module,exports) {
"use strict";
var forEach = require("58bb069967c592e6"), classChecks = require("a0e15706f6234741"), entryAtIndex = require("6e86a85ef569f110");
var isArray = classChecks.isArray;
function getEntriesForIndexes(obj, find, loop, isString) {
    var result, length = obj.length;
    if (!isArray(find)) return entryAtIndex(obj, find, length, loop, isString);
    result = new Array(find.length);
    forEach(find, function(index, i) {
        result[i] = entryAtIndex(obj, index, length, loop, isString);
    });
    return result;
}
module.exports = getEntriesForIndexes;

},{"58bb069967c592e6":"1n2CK","a0e15706f6234741":"lUOLF","6e86a85ef569f110":"jmuWL"}],"1n2CK":[function(require,module,exports) {
"use strict";
var iterateOverSparseArray = require("cfad6f6e957bc383");
function forEach(arr, fn) {
    for(var i = 0, len = arr.length; i < len; i++){
        if (!(i in arr)) return iterateOverSparseArray(arr, fn, i);
        fn(arr[i], i);
    }
}
module.exports = forEach;

},{"cfad6f6e957bc383":"9398D"}],"9398D":[function(require,module,exports) {
"use strict";
var getSparseArrayIndexes = require("d7369ed5a0eef465");
function iterateOverSparseArray(arr, fn, fromIndex, loop) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
    for(var i = 0, len = indexes.length; i < len; i++){
        index = indexes[i];
        fn.call(arr, arr[index], index, arr);
    }
    return arr;
}
module.exports = iterateOverSparseArray;

},{"d7369ed5a0eef465":"gKpo8"}],"gKpo8":[function(require,module,exports) {
"use strict";
var isArrayIndex = require("6a54c2ddfc0debf0");
function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
    var indexes = [], i;
    for(i in arr)// istanbul ignore next
    if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) indexes.push(+i);
    indexes.sort(function(a, b) {
        var aLoop = a > fromIndex;
        var bLoop = b > fromIndex;
        // This block cannot be reached unless ES5 methods are being shimmed.
        // istanbul ignore if
        if (aLoop !== bLoop) return aLoop ? -1 : 1;
        return a - b;
    });
    return indexes;
}
module.exports = getSparseArrayIndexes;

},{"6a54c2ddfc0debf0":"7uQbA"}],"7uQbA":[function(require,module,exports) {
"use strict";
function isArrayIndex(n) {
    return n >>> 0 == n && n != 0xFFFFFFFF;
}
module.exports = isArrayIndex;

},{}],"lUOLF":[function(require,module,exports) {
"use strict";
var NATIVE_TYPES = require("a8c57e6527c7a43b"), forEach = require("5c2af47f9e0144f0"), isClass = require("ac78f24e8a88adc2"), spaceSplit = require("587d4f3bd23887f3"), isPlainObject = require("4d82062e1a73a372");
var isSerializable, isBoolean, isNumber, isString, isDate, isRegExp, isFunction, isArray, isSet, isMap, isError;
function buildClassChecks() {
    var knownTypes = {};
    function addCoreTypes() {
        var names = spaceSplit(NATIVE_TYPES);
        isBoolean = buildPrimitiveClassCheck(names[0]);
        isNumber = buildPrimitiveClassCheck(names[1]);
        isString = buildPrimitiveClassCheck(names[2]);
        isDate = buildClassCheck(names[3]);
        isRegExp = buildClassCheck(names[4]);
        // Wanted to enhance performance here by using simply "typeof"
        // but Firefox has two major issues that make this impossible,
        // one fixed, the other not, so perform a full class check here.
        //
        // 1. Regexes can be typeof "function" in FF < 3
        //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
        //
        // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
        //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
        isFunction = buildClassCheck(names[5]);
        // istanbul ignore next
        isArray = Array.isArray || buildClassCheck(names[6]);
        isError = buildClassCheck(names[7]);
        isSet = buildClassCheck(names[8], typeof Set !== "undefined" && Set);
        isMap = buildClassCheck(names[9], typeof Map !== "undefined" && Map);
        // Add core types as known so that they can be checked by value below,
        // notably excluding Functions and adding Arguments and Error.
        addKnownType("Arguments");
        addKnownType(names[0]);
        addKnownType(names[1]);
        addKnownType(names[2]);
        addKnownType(names[3]);
        addKnownType(names[4]);
        addKnownType(names[6]);
    }
    function addArrayTypes() {
        var types = "Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64";
        forEach(spaceSplit(types), function(str) {
            addKnownType(str + "Array");
        });
    }
    function addKnownType(className) {
        var str = "[object " + className + "]";
        knownTypes[str] = true;
    }
    function isKnownType(className) {
        return knownTypes[className];
    }
    function buildClassCheck(className, globalObject) {
        // istanbul ignore if
        if (globalObject && isClass(new globalObject, "Object")) return getConstructorClassCheck(globalObject);
        else return getToStringClassCheck(className);
    }
    // Map and Set may be [object Object] in certain IE environments.
    // In this case we need to perform a check using the constructor
    // instead of Object.prototype.toString.
    // istanbul ignore next
    function getConstructorClassCheck(obj) {
        var ctorStr = String(obj);
        return function(obj) {
            return String(obj.constructor) === ctorStr;
        };
    }
    function getToStringClassCheck(className) {
        return function(obj, str) {
            // perf: Returning up front on instanceof appears to be slower.
            return isClass(obj, className, str);
        };
    }
    function buildPrimitiveClassCheck(className) {
        var type = className.toLowerCase();
        return function(obj) {
            var t = typeof obj;
            return t === type || t === "object" && isClass(obj, className);
        };
    }
    addCoreTypes();
    addArrayTypes();
    isSerializable = function isSerializable(obj, className) {
        // Only known objects can be serialized. This notably excludes functions,
        // host objects, Symbols (which are matched by reference), and instances
        // of classes. The latter can arguably be matched by value, but
        // distinguishing between these and host objects -- which should never be
        // compared by value -- is very tricky so not dealing with it here.
        return isKnownType(className) || isPlainObject(obj, className);
    };
}
buildClassChecks();
module.exports = {
    isSerializable: isSerializable,
    isBoolean: isBoolean,
    isNumber: isNumber,
    isString: isString,
    isDate: isDate,
    isRegExp: isRegExp,
    isFunction: isFunction,
    isArray: isArray,
    isSet: isSet,
    isMap: isMap,
    isError: isError
};

},{"a8c57e6527c7a43b":"iwfp4","5c2af47f9e0144f0":"1n2CK","ac78f24e8a88adc2":"h3AQK","587d4f3bd23887f3":"8g1bL","4d82062e1a73a372":"byAbX"}],"iwfp4":[function(require,module,exports) {
"use strict";
module.exports = "Boolean Number String Date RegExp Function Array Error Set Map";

},{}],"h3AQK":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("1c29a567ad2b00ac");
var classToString = coreUtilityAliases.classToString;
function isClass(obj, className, str) {
    if (!str) str = classToString(obj);
    return str === "[object " + className + "]";
}
module.exports = isClass;

},{"1c29a567ad2b00ac":"dU8Nu"}],"dU8Nu":[function(require,module,exports) {
"use strict";
var Sugar = require("6ae347a232732f43");
module.exports = {
    hasOwn: Sugar.util.hasOwn,
    getOwn: Sugar.util.getOwn,
    setProperty: Sugar.util.setProperty,
    classToString: Sugar.util.classToString,
    defineProperty: Sugar.util.defineProperty,
    forEachProperty: Sugar.util.forEachProperty,
    mapNativeToChainable: Sugar.util.mapNativeToChainable
};

},{"6ae347a232732f43":"eWYA2"}],"8g1bL":[function(require,module,exports) {
"use strict";
function spaceSplit(str) {
    return str.split(" ");
}
module.exports = spaceSplit;

},{}],"byAbX":[function(require,module,exports) {
"use strict";
var isClass = require("738d8bb0f8294494"), isObjectType = require("feb8f7b24262948"), hasOwnEnumeratedProperties = require("f3a85f365b14d789"), hasValidPlainObjectPrototype = require("b86e580b081f91ab");
function isPlainObject(obj, className) {
    return isObjectType(obj) && isClass(obj, "Object", className) && hasValidPlainObjectPrototype(obj) && hasOwnEnumeratedProperties(obj);
}
module.exports = isPlainObject;

},{"738d8bb0f8294494":"h3AQK","feb8f7b24262948":"l3TUh","f3a85f365b14d789":"6KUZC","b86e580b081f91ab":"1lP3T"}],"l3TUh":[function(require,module,exports) {
"use strict";
function isObjectType(obj, type) {
    return !!obj && (type || typeof obj) === "object";
}
module.exports = isObjectType;

},{}],"6KUZC":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("7d143b3671d97a4c");
var hasOwn = coreUtilityAliases.hasOwn;
function hasOwnEnumeratedProperties(obj) {
    // Plain objects are generally defined as having enumerated properties
    // all their own, however in early IE environments without defineProperty,
    // there may also be enumerated methods in the prototype chain, so check
    // for both of these cases.
    var objectProto = Object.prototype;
    for(var key in obj){
        var val = obj[key];
        if (!hasOwn(obj, key) && val !== objectProto[key]) return false;
    }
    return true;
}
module.exports = hasOwnEnumeratedProperties;

},{"7d143b3671d97a4c":"dU8Nu"}],"1lP3T":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("24192a271e4a586f");
var hasOwn = coreUtilityAliases.hasOwn;
function hasValidPlainObjectPrototype(obj) {
    var hasToString = "toString" in obj;
    var hasConstructor = "constructor" in obj;
    // An object created with Object.create(null) has no methods in the
    // prototype chain, so check if any are missing. The additional hasToString
    // check is for false positives on some host objects in old IE which have
    // toString but no constructor. If the object has an inherited constructor,
    // then check if it is Object (the "isPrototypeOf" tapdance here is a more
    // robust way of ensuring this if the global has been hijacked). Note that
    // accessing the constructor directly (without "in" or "hasOwnProperty")
    // will throw a permissions error in IE8 on cross-domain windows.
    return !hasConstructor && !hasToString || hasConstructor && !hasOwn(obj, "constructor") && hasOwn(obj.constructor.prototype, "isPrototypeOf");
}
module.exports = hasValidPlainObjectPrototype;

},{"24192a271e4a586f":"dU8Nu"}],"jmuWL":[function(require,module,exports) {
"use strict";
var getNormalizedIndex = require("cf7a5617c3964b2e");
function entryAtIndex(obj, index, length, loop, isString) {
    index = getNormalizedIndex(index, length, loop);
    return isString ? obj.charAt(index) : obj[index];
}
module.exports = entryAtIndex;

},{"cf7a5617c3964b2e":"2mIyX"}],"2mIyX":[function(require,module,exports) {
"use strict";
function getNormalizedIndex(index, length, loop) {
    if (index && loop) index = index % length;
    if (index < 0) index = length + index;
    return index;
}
module.exports = getNormalizedIndex;

},{}],"30mld":[function(require,module,exports) {
"use strict";
var Sugar = require("385dd5aaafe04df2"), stringCamelize = require("b11e952f06298e4b");
Sugar.String.defineInstance({
    "camelize": function(str, upper) {
        return stringCamelize(str, upper);
    }
});
module.exports = Sugar.String.camelize;

},{"385dd5aaafe04df2":"eWYA2","b11e952f06298e4b":"ggXAD"}],"ggXAD":[function(require,module,exports) {
"use strict";
var CAMELIZE_REG = require("850742c4099e66fe"), getAcronym = require("cad8163d13696815"), stringUnderscore = require("48038a4d95e6935"), stringCapitalize = require("3693523e7c7de55e");
function stringCamelize(str, upper) {
    str = stringUnderscore(str);
    return str.replace(CAMELIZE_REG, function(match, pre, word, index) {
        var cap = upper !== false || index > 0, acronym;
        acronym = getAcronym(word);
        // istanbul ignore if
        if (acronym && cap) return acronym;
        return cap ? stringCapitalize(word, true) : word;
    });
}
module.exports = stringCamelize;

},{"850742c4099e66fe":"kZxH9","cad8163d13696815":"ge9tJ","48038a4d95e6935":"5NGTb","3693523e7c7de55e":"e3ssf"}],"kZxH9":[function(require,module,exports) {
"use strict";
module.exports = /(^|_)([^_]+)/g;

},{}],"ge9tJ":[function(require,module,exports) {
"use strict";
var Inflections = require("3048323e6baf4f3e");
function getAcronym(str) {
    // istanbul ignore next
    return Inflections.acronyms && Inflections.acronyms.find(str);
}
module.exports = getAcronym;

},{"3048323e6baf4f3e":"4cxyp"}],"4cxyp":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"5NGTb":[function(require,module,exports) {
"use strict";
var Inflections = require("90e2e78a76b1dd59");
function stringUnderscore(str) {
    var areg = Inflections.acronyms && Inflections.acronyms.reg;
    // istanbul ignore if
    if (areg) str = str.replace(areg, function(acronym, index) {
        return (index > 0 ? "_" : "") + acronym.toLowerCase();
    });
    return str.replace(/[-\s]+/g, "_").replace(/([A-Z\d]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").toLowerCase();
}
module.exports = stringUnderscore;

},{"90e2e78a76b1dd59":"4cxyp"}],"e3ssf":[function(require,module,exports) {
"use strict";
var CAPITALIZE_REG = require("a93b3111ea5dba06"), simpleCapitalize = require("c669c6897236e10f");
function stringCapitalize(str, downcase, all) {
    if (downcase) str = str.toLowerCase();
    return all ? str.replace(CAPITALIZE_REG, simpleCapitalize) : simpleCapitalize(str);
}
module.exports = stringCapitalize;

},{"a93b3111ea5dba06":"dP9bk","c669c6897236e10f":"jYftQ"}],"dP9bk":[function(require,module,exports) {
"use strict";
module.exports = /[^\u0000-\u0040\u005B-\u0060\u007B-\u007F]+('s)?/g;

},{}],"jYftQ":[function(require,module,exports) {
"use strict";
function simpleCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = simpleCapitalize;

},{}],"3UUWP":[function(require,module,exports) {
"use strict";
var Sugar = require("694218e5fc93dcb"), stringCapitalize = require("4c99adfb6947f20e");
Sugar.String.defineInstance({
    "capitalize": function(str, lower, all) {
        return stringCapitalize(str, lower, all);
    }
});
module.exports = Sugar.String.capitalize;

},{"694218e5fc93dcb":"eWYA2","4c99adfb6947f20e":"e3ssf"}],"1l8wJ":[function(require,module,exports) {
"use strict";
var Sugar = require("bbe5c8aa83b1d433"), stringEach = require("92f811e9dc40ed94");
Sugar.String.defineInstance({
    "chars": function(str, search, eachCharFn) {
        return stringEach(str, search, eachCharFn);
    }
});
module.exports = Sugar.String.chars;

},{"bbe5c8aa83b1d433":"eWYA2","92f811e9dc40ed94":"l6k1y"}],"l6k1y":[function(require,module,exports) {
"use strict";
var isDefined = require("14cae75ad7bcdc38"), classChecks = require("3aee40cb7d155a17"), escapeRegExp = require("d300081b87f0df38"), getRegExpFlags = require("1c5b281a5dd443d9"), runGlobalMatch = require("7646d28de9c12a06");
var isString = classChecks.isString, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction;
function stringEach(str, search, fn) {
    var chunks, chunk, reg, result = [];
    if (isFunction(search)) {
        fn = search;
        reg = /[\s\S]/g;
    } else if (!search) reg = /[\s\S]/g;
    else if (isString(search)) reg = RegExp(escapeRegExp(search), "gi");
    else if (isRegExp(search)) reg = RegExp(search.source, getRegExpFlags(search, "g"));
    // Getting the entire array of chunks up front as we need to
    // pass this into the callback function as an argument.
    chunks = runGlobalMatch(str, reg);
    if (chunks) for(var i = 0, len = chunks.length, r; i < len; i++){
        chunk = chunks[i];
        result[i] = chunk;
        if (fn) {
            r = fn.call(str, chunk, i, chunks);
            if (r === false) break;
            else if (isDefined(r)) result[i] = r;
        }
    }
    return result;
}
module.exports = stringEach;

},{"14cae75ad7bcdc38":"6Ge6e","3aee40cb7d155a17":"lUOLF","d300081b87f0df38":"dWlXH","1c5b281a5dd443d9":"658bK","7646d28de9c12a06":"aZMnz"}],"6Ge6e":[function(require,module,exports) {
"use strict";
function isDefined(o) {
    return o !== undefined;
}
module.exports = isDefined;

},{}],"dWlXH":[function(require,module,exports) {
"use strict";
var classChecks = require("e4d48bef74ed832f");
var isString = classChecks.isString;
function escapeRegExp(str) {
    if (!isString(str)) str = String(str);
    return str.replace(/([\\/'*+?|()[\]{}.^$-])/g, "\\$1");
}
module.exports = escapeRegExp;

},{"e4d48bef74ed832f":"lUOLF"}],"658bK":[function(require,module,exports) {
"use strict";
function getRegExpFlags(reg, add) {
    var flags = "";
    add = add || "";
    function checkFlag(prop, flag) {
        if (prop || add.indexOf(flag) > -1) flags += flag;
    }
    checkFlag(reg.global, "g");
    checkFlag(reg.ignoreCase, "i");
    checkFlag(reg.multiline, "m");
    checkFlag(reg.sticky, "y");
    return flags;
}
module.exports = getRegExpFlags;

},{}],"aZMnz":[function(require,module,exports) {
"use strict";
function runGlobalMatch(str, reg) {
    var result = [], match, lastLastIndex;
    while((match = reg.exec(str)) != null){
        if (reg.lastIndex === lastLastIndex) reg.lastIndex += 1;
        else result.push(match[0]);
        lastLastIndex = reg.lastIndex;
    }
    return result;
}
module.exports = runGlobalMatch;

},{}],"aVQnx":[function(require,module,exports) {
"use strict";
var Sugar = require("77bdfeed2bf54144"), stringCodes = require("8e0cccc3bc4739d1");
Sugar.String.defineInstance({
    "codes": function(str, eachCodeFn) {
        return stringCodes(str, eachCodeFn);
    }
});
module.exports = Sugar.String.codes;

},{"77bdfeed2bf54144":"eWYA2","8e0cccc3bc4739d1":"9kWnD"}],"9kWnD":[function(require,module,exports) {
"use strict";
function stringCodes(str, fn) {
    var codes = new Array(str.length), i, len;
    for(i = 0, len = str.length; i < len; i++){
        var code = str.charCodeAt(i);
        codes[i] = code;
        if (fn) fn.call(str, code, i, str);
    }
    return codes;
}
module.exports = stringCodes;

},{}],"1GYI2":[function(require,module,exports) {
"use strict";
var Sugar = require("7881b7354da96627"), trim = require("38b5a4688048d749");
Sugar.String.defineInstance({
    "compact": function(str) {
        return trim(str).replace(/([\r\n\s　])+/g, function(match, whitespace) {
            return whitespace === "\u3000" ? whitespace : " ";
        });
    }
});
module.exports = Sugar.String.compact;

},{"7881b7354da96627":"eWYA2","38b5a4688048d749":"7k3lh"}],"7k3lh":[function(require,module,exports) {
"use strict";
function trim(str) {
    return str.trim();
}
module.exports = trim;

},{}],"5Cbi9":[function(require,module,exports) {
"use strict";
var Sugar = require("c248a5aefb8465d4"), stringUnderscore = require("bc74ac6f43f8e7fa");
Sugar.String.defineInstance({
    "dasherize": function(str) {
        return stringUnderscore(str).replace(/_/g, "-");
    }
});
module.exports = Sugar.String.dasherize;

},{"c248a5aefb8465d4":"eWYA2","bc74ac6f43f8e7fa":"5NGTb"}],"a5glf":[function(require,module,exports) {
"use strict";
var Sugar = require("306e1762719352f2"), base64 = require("353c3be5c25d2f2");
var decodeBase64 = base64.decodeBase64;
Sugar.String.defineInstance({
    "decodeBase64": function(str) {
        return decodeBase64(str);
    }
});
module.exports = Sugar.String.decodeBase64;

},{"306e1762719352f2":"eWYA2","353c3be5c25d2f2":"1TDNt"}],"1TDNt":[function(require,module,exports) {
var Buffer = require("c86db6afbd51cdd1").Buffer;
"use strict";
var chr = require("8155d36427c5fc18");
var encodeBase64, decodeBase64;
function buildBase64() {
    var encodeAscii, decodeAscii;
    // istanbul ignore next
    function catchEncodingError(fn) {
        return function(str) {
            try {
                return fn(str);
            } catch (e) {
                return "";
            }
        };
    }
    // istanbul ignore if
    if (typeof Buffer !== "undefined") {
        encodeBase64 = function encodeBase64(str) {
            return Buffer.from(str).toString("base64");
        };
        decodeBase64 = function decodeBase64(str) {
            return Buffer.from(str, "base64").toString("utf8");
        };
        return;
    }
    // istanbul ignore if
    if (typeof btoa !== "undefined") {
        encodeAscii = catchEncodingError(btoa);
        decodeAscii = catchEncodingError(atob);
    } else {
        var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var base64reg = /[^A-Za-z0-9\+\/\=]/g;
        encodeAscii = function encodeAscii(str) {
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            do {
                chr1 = str.charCodeAt(i++);
                chr2 = str.charCodeAt(i++);
                chr3 = str.charCodeAt(i++);
                enc1 = chr1 >> 2;
                enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                enc4 = chr3 & 63;
                if (isNaN(chr2)) enc3 = enc4 = 64;
                else if (isNaN(chr3)) enc4 = 64;
                output += key.charAt(enc1);
                output += key.charAt(enc2);
                output += key.charAt(enc3);
                output += key.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            }while (i < str.length);
            return output;
        };
        decodeAscii = function decodeAscii(input) {
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            if (input.match(base64reg)) return "";
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            do {
                enc1 = key.indexOf(input.charAt(i++));
                enc2 = key.indexOf(input.charAt(i++));
                enc3 = key.indexOf(input.charAt(i++));
                enc4 = key.indexOf(input.charAt(i++));
                chr1 = enc1 << 2 | enc2 >> 4;
                chr2 = (enc2 & 15) << 4 | enc3 >> 2;
                chr3 = (enc3 & 3) << 6 | enc4;
                output = output + chr(chr1);
                if (enc3 != 64) output = output + chr(chr2);
                if (enc4 != 64) output = output + chr(chr3);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            }while (i < input.length);
            return output;
        };
    }
    encodeBase64 = function encodeBase64(str) {
        return encodeAscii(unescape(encodeURIComponent(str)));
    };
    decodeBase64 = function decodeBase64(str) {
        return decodeURIComponent(escape(decodeAscii(str)));
    };
}
buildBase64();
module.exports = {
    encodeBase64: encodeBase64,
    decodeBase64: decodeBase64
};

},{"c86db6afbd51cdd1":"dGCV2","8155d36427c5fc18":"fFtOs"}],"fFtOs":[function(require,module,exports) {
"use strict";
module.exports = String.fromCharCode;

},{}],"4FMbT":[function(require,module,exports) {
"use strict";
var Sugar = require("440345dc90b84533"), base64 = require("e1dda1deab755b2a");
var encodeBase64 = base64.encodeBase64;
Sugar.String.defineInstance({
    "encodeBase64": function(str) {
        return encodeBase64(str);
    }
});
module.exports = Sugar.String.encodeBase64;

},{"440345dc90b84533":"eWYA2","e1dda1deab755b2a":"1TDNt"}],"4YEpQ":[function(require,module,exports) {
"use strict";
var Sugar = require("e26f15da6c5f2c1b"), HTML_ESCAPE_REG = require("28ebbe6a40fea35c"), HTMLToEntityMap = require("250e2bb609f09a7c"), coreUtilityAliases = require("fce966ad2dff0e75");
var getOwn = coreUtilityAliases.getOwn;
Sugar.String.defineInstance({
    "escapeHTML": function(str) {
        return str.replace(HTML_ESCAPE_REG, function(chr) {
            return getOwn(HTMLToEntityMap, chr);
        });
    }
});
module.exports = Sugar.String.escapeHTML;

},{"e26f15da6c5f2c1b":"eWYA2","28ebbe6a40fea35c":"hDVKO","250e2bb609f09a7c":"79xWz","fce966ad2dff0e75":"dU8Nu"}],"hDVKO":[function(require,module,exports) {
"use strict";
module.exports = /[&<>]/g;

},{}],"79xWz":[function(require,module,exports) {
"use strict";
var HTMLFromEntityMap = require("e40a0cc760edeb4"), coreUtilityAliases = require("276bdd20851f66ba");
var forEachProperty = coreUtilityAliases.forEachProperty;
var HTMLToEntityMap;
function buildEntities() {
    HTMLToEntityMap = {};
    forEachProperty(HTMLFromEntityMap, function(val, key) {
        HTMLToEntityMap[val] = "&" + key + ";";
    });
}
buildEntities();
module.exports = HTMLToEntityMap;

},{"e40a0cc760edeb4":"ZCuew","276bdd20851f66ba":"dU8Nu"}],"ZCuew":[function(require,module,exports) {
"use strict";
var HTMLFromEntityMap = {
    "lt": "<",
    "gt": ">",
    "amp": "&",
    "nbsp": " ",
    "quot": '"',
    "apos": "'"
};
module.exports = HTMLFromEntityMap;

},{}],"jZUys":[function(require,module,exports) {
"use strict";
var Sugar = require("381d600cf7fc0ad");
Sugar.String.defineInstance({
    "escapeURL": function(str, param) {
        return param ? encodeURIComponent(str) : encodeURI(str);
    }
});
module.exports = Sugar.String.escapeURL;

},{"381d600cf7fc0ad":"eWYA2"}],"6YaUH":[function(require,module,exports) {
"use strict";
var Sugar = require("ae955ff40d79d9e3"), isUndefined = require("f6bff4af06820e13");
Sugar.String.defineInstance({
    "first": function(str, num) {
        if (isUndefined(num)) num = 1;
        return str.substr(0, num);
    }
});
module.exports = Sugar.String.first;

},{"ae955ff40d79d9e3":"eWYA2","f6bff4af06820e13":"hnApm"}],"hnApm":[function(require,module,exports) {
"use strict";
function isUndefined(o) {
    return o === undefined;
}
module.exports = isUndefined;

},{}],"te15t":[function(require,module,exports) {
"use strict";
var Sugar = require("76a15e7af6d45d75"), stringEach = require("c79fb8447482fe40");
Sugar.String.defineInstance({
    "forEach": function(str, search, eachFn) {
        return stringEach(str, search, eachFn);
    }
});
module.exports = Sugar.String.forEach;

},{"76a15e7af6d45d75":"eWYA2","c79fb8447482fe40":"l6k1y"}],"kVDPG":[function(require,module,exports) {
"use strict";
var Sugar = require("47cc13afb4d1b924"), isObjectType = require("150f0041dec1d62a"), stringFormatMatcher = require("fb561efdaf7ea0a");
Sugar.String.defineInstanceWithArguments({
    "format": function(str, args) {
        var arg1 = args[0] && args[0].valueOf();
        // Unwrap if a single object is passed in.
        if (args.length === 1 && isObjectType(arg1)) args = arg1;
        return stringFormatMatcher(str, args);
    }
});
module.exports = Sugar.String.format;

},{"47cc13afb4d1b924":"eWYA2","150f0041dec1d62a":"l3TUh","fb561efdaf7ea0a":"5doHU"}],"5doHU":[function(require,module,exports) {
"use strict";
var deepGetProperty = require("28e1e74ed3fb5259"), createFormatMatcher = require("907e341668d0c07d");
module.exports = createFormatMatcher(deepGetProperty);

},{"28e1e74ed3fb5259":"fxfTs","907e341668d0c07d":"lcx4s"}],"fxfTs":[function(require,module,exports) {
"use strict";
var handleDeepProperty = require("1ef590ce5309aa27");
function deepGetProperty(obj, key, any) {
    return handleDeepProperty(obj, key, any, false);
}
module.exports = deepGetProperty;

},{"1ef590ce5309aa27":"6pPpG"}],"6pPpG":[function(require,module,exports) {
"use strict";
var PROPERTY_RANGE_REG = require("880bb3669b21c7e5"), CommonChars = require("d677b5407d8dd077"), map = require("c66cf20524d13bc2"), isDefined = require("565ff58cda9fcbee"), classChecks = require("b9ec04dabd75fa02"), periodSplit = require("c93417ac69f819bc"), assertArray = require("ed3b9ddbad44df8a"), isObjectType = require("676149ab5107e361"), assertWritable = require("8c7496b852411532"), coreUtilityAliases = require("281f863e31824eba");
var isString = classChecks.isString, hasOwn = coreUtilityAliases.hasOwn, HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;
function handleDeepProperty(obj, key, any, has, fill, fillLast, val) {
    var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
    ns = obj;
    if (key == null) return;
    if (isObjectType(key)) // Allow array and array-like accessors
    bs = [
        key
    ];
    else {
        key = String(key);
        if (key.indexOf("..") !== -1) return handleArrayIndexRange(obj, key, any, val);
        bs = key.split("[");
    }
    set = isDefined(val);
    for(var i = 0, blen = bs.length; i < blen; i++){
        ps = bs[i];
        if (isString(ps)) ps = periodSplit(ps);
        for(var j = 0, plen = ps.length; j < plen; j++){
            key = ps[j];
            // Is this the last key?
            isLast = i === blen - 1 && j === plen - 1;
            // Index of the closing ]
            cbi = key.indexOf("]");
            // Is the key an array index?
            isIndex = cbi !== -1;
            // Is this array push syntax "[]"?
            isPush = set && cbi === 0;
            // If the bracket split was successful and this is the last element
            // in the dot split, then we know the next key will be an array index.
            nextIsIndex = blen > 1 && j === plen - 1;
            if (isPush) // Set the index to the end of the array
            key = ns.length;
            else if (isIndex) // Remove the closing ]
            key = key.slice(0, -1);
            // If the array index is less than 0, then
            // add its length to allow negative indexes.
            if (isIndex && key < 0) key = +key + ns.length;
            // Bracket keys may look like users[5] or just [5], so the leading
            // characters are optional. We can enter the namespace if this is the
            // 2nd part, if there is only 1 part, or if there is an explicit key.
            if (i || key || blen === 1) {
                // TODO: need to be sure this check handles ''.length when
                // we refactor.
                exists = any ? key in Object(ns) : hasOwn(ns, key);
                // Non-existent namespaces are only filled if they are intermediate
                // (not at the end) or explicitly filling the last.
                if (fill && (!isLast || fillLast) && !exists) {
                    // For our purposes, last only needs to be an array.
                    ns = ns[key] = nextIsIndex || fillLast && isLast ? [] : {};
                    continue;
                }
                if (has) {
                    if (isLast || !exists) return exists;
                } else if (set && isLast) {
                    assertWritable(ns);
                    ns[key] = val;
                }
                ns = exists ? ns[key] : undefined;
            }
        }
    }
    return ns;
}
function handleArrayIndexRange(obj, key, any, val) {
    var match, start, end, leading, trailing, arr, set;
    match = key.match(PROPERTY_RANGE_REG);
    if (!match) return;
    set = isDefined(val);
    leading = match[1];
    if (leading) arr = handleDeepProperty(obj, leading, any, false, set ? true : false, true);
    else arr = obj;
    assertArray(arr);
    trailing = match[4];
    start = match[2] ? +match[2] : 0;
    end = match[3] ? +match[3] : arr.length;
    // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
    // pushes the index from -1 to 0, then set it to the full length of the
    // array, otherwise it will return nothing.
    end = end === -1 ? arr.length : end + 1;
    if (set) for(var i = start; i < end; i++)handleDeepProperty(arr, i + trailing, any, false, true, false, val);
    else {
        arr = arr.slice(start, end);
        // If there are trailing properties, then they need to be mapped for each
        // element in the array.
        if (trailing) {
            if (trailing.charAt(0) === HALF_WIDTH_PERIOD) // Need to chomp the period if one is trailing after the range. We
            // can't do this at the regex level because it will be required if
            // we're setting the value as it needs to be concatentated together
            // with the array index to be set.
            trailing = trailing.slice(1);
            return map(arr, function(el) {
                return handleDeepProperty(el, trailing);
            });
        }
    }
    return arr;
}
module.exports = handleDeepProperty;

},{"880bb3669b21c7e5":"fqSAq","d677b5407d8dd077":"ktIFO","c66cf20524d13bc2":"b19ZA","565ff58cda9fcbee":"6Ge6e","b9ec04dabd75fa02":"lUOLF","c93417ac69f819bc":"jncZt","ed3b9ddbad44df8a":"jQuqC","676149ab5107e361":"l3TUh","8c7496b852411532":"98iof","281f863e31824eba":"dU8Nu"}],"fqSAq":[function(require,module,exports) {
"use strict";
module.exports = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;

},{}],"ktIFO":[function(require,module,exports) {
"use strict";
module.exports = {
    HALF_WIDTH_ZERO: 0x30,
    FULL_WIDTH_ZERO: 0xff10,
    HALF_WIDTH_PERIOD: ".",
    FULL_WIDTH_PERIOD: "\uFF0E",
    HALF_WIDTH_COMMA: ",",
    OPEN_BRACE: "{",
    CLOSE_BRACE: "}"
};

},{}],"b19ZA":[function(require,module,exports) {
"use strict";
function map(arr, fn) {
    // perf: Not using fixed array len here as it may be sparse.
    var result = [];
    for(var i = 0, len = arr.length; i < len; i++)if (i in arr) result.push(fn(arr[i], i));
    return result;
}
module.exports = map;

},{}],"jncZt":[function(require,module,exports) {
"use strict";
var CommonChars = require("a4c1f8ce0d185c62");
var HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;
function periodSplit(str) {
    return str.split(HALF_WIDTH_PERIOD);
}
module.exports = periodSplit;

},{"a4c1f8ce0d185c62":"ktIFO"}],"jQuqC":[function(require,module,exports) {
"use strict";
var classChecks = require("3162e0bdb76030ff");
var isArray = classChecks.isArray;
function assertArray(obj) {
    if (!isArray(obj)) throw new TypeError("Array required");
}
module.exports = assertArray;

},{"3162e0bdb76030ff":"lUOLF"}],"98iof":[function(require,module,exports) {
"use strict";
var isPrimitive = require("c9521cdb23a2f6dd");
function assertWritable(obj) {
    if (isPrimitive(obj)) // If strict mode is active then primitives will throw an
    // error when attempting to write properties. We can't be
    // sure if strict mode is available, so pre-emptively
    // throw an error here to ensure consistent behavior.
    throw new TypeError("Property cannot be written");
}
module.exports = assertWritable;

},{"c9521cdb23a2f6dd":"jzeAF"}],"jzeAF":[function(require,module,exports) {
"use strict";
function isPrimitive(obj, type) {
    type = type || typeof obj;
    return obj == null || type === "string" || type === "number" || type === "boolean";
}
module.exports = isPrimitive;

},{}],"lcx4s":[function(require,module,exports) {
"use strict";
var STRING_FORMAT_REG = require("a057ccaa06f3f12f"), CommonChars = require("7423f017d695e600"), memoizeFunction = require("8bff908fea4874a2");
var OPEN_BRACE = CommonChars.OPEN_BRACE, CLOSE_BRACE = CommonChars.CLOSE_BRACE;
function createFormatMatcher(bracketMatcher, percentMatcher, precheck) {
    var reg = STRING_FORMAT_REG;
    var compileMemoized = memoizeFunction(compile);
    function getToken(format, match) {
        var get, token, literal, fn;
        var bKey = match[2];
        var pLit = match[3];
        var pKey = match[5];
        if (match[4] && percentMatcher) {
            token = pKey;
            get = percentMatcher;
        } else if (bKey) {
            token = bKey;
            get = bracketMatcher;
        } else if (pLit && percentMatcher) literal = pLit;
        else literal = match[1] || match[0];
        if (get) {
            assertPassesPrecheck(precheck, bKey, pKey);
            fn = function fn(obj, opt) {
                return get(obj, token, opt);
            };
        }
        format.push(fn || getLiteral(literal));
    }
    function getSubstring(format, str, start, end) {
        if (end > start) {
            var sub = str.slice(start, end);
            assertNoUnmatched(sub, OPEN_BRACE);
            assertNoUnmatched(sub, CLOSE_BRACE);
            format.push(function() {
                return sub;
            });
        }
    }
    function getLiteral(str) {
        return function() {
            return str;
        };
    }
    function assertPassesPrecheck(precheck, bt, pt) {
        if (precheck && !precheck(bt, pt)) throw new TypeError("Invalid token " + (bt || pt) + " in format string");
    }
    function assertNoUnmatched(str, chr) {
        if (str.indexOf(chr) !== -1) throw new TypeError("Unmatched " + chr + " in format string");
    }
    function compile(str) {
        var format = [], lastIndex = 0, match;
        reg.lastIndex = 0;
        while(match = reg.exec(str)){
            getSubstring(format, str, lastIndex, match.index);
            getToken(format, match);
            lastIndex = reg.lastIndex;
        }
        getSubstring(format, str, lastIndex, str.length);
        return format;
    }
    return function(str, obj, opt) {
        var format = compileMemoized(str), result = "";
        for(var i = 0; i < format.length; i++)result += format[i](obj, opt);
        return result;
    };
}
module.exports = createFormatMatcher;

},{"a057ccaa06f3f12f":"8rpq7","7423f017d695e600":"ktIFO","8bff908fea4874a2":"Sioio"}],"8rpq7":[function(require,module,exports) {
"use strict";
module.exports = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;

},{}],"Sioio":[function(require,module,exports) {
"use strict";
var INTERNAL_MEMOIZE_LIMIT = require("b5d57c7cf4e8ad80"), coreUtilityAliases = require("837bc2560101c8bf");
var hasOwn = coreUtilityAliases.hasOwn;
function memoizeFunction(fn) {
    var memo = {}, counter = 0;
    return function(key) {
        if (hasOwn(memo, key)) return memo[key];
        // istanbul ignore if
        if (counter === INTERNAL_MEMOIZE_LIMIT) {
            memo = {};
            counter = 0;
        }
        counter++;
        return memo[key] = fn(key);
    };
}
module.exports = memoizeFunction;

},{"b5d57c7cf4e8ad80":"jLeXm","837bc2560101c8bf":"dU8Nu"}],"jLeXm":[function(require,module,exports) {
"use strict";
module.exports = 1000;

},{}],"lCRSp":[function(require,module,exports) {
"use strict";
var Sugar = require("42ed9d1660aeeb90"), numberOrIndex = require("66c118d0a155a446");
Sugar.String.defineInstance({
    "from": function(str, from) {
        return str.slice(numberOrIndex(str, from, true));
    }
});
module.exports = Sugar.String.from;

},{"42ed9d1660aeeb90":"eWYA2","66c118d0a155a446":"kARMJ"}],"kARMJ":[function(require,module,exports) {
"use strict";
var classChecks = require("aefcc5a92da8090f");
var isString = classChecks.isString;
function numberOrIndex(str, n, from) {
    if (isString(n)) {
        n = str.indexOf(n);
        if (n === -1) n = from ? str.length : 0;
    }
    return n;
}
module.exports = numberOrIndex;

},{"aefcc5a92da8090f":"lUOLF"}],"4adAJ":[function(require,module,exports) {
"use strict";
var Sugar = require("d78bec676a8d62f2"), ENHANCEMENTS_FLAG = require("457e6e5aed22ef5d"), STRING_ENHANCEMENTS_FLAG = require("45ef2e524353fe3d"), fixArgumentLength = require("885dacd10e9d617a"), callIncludesWithRegexSupport = require("2d2025167e59d6e7");
Sugar.String.defineInstance({
    "includes": fixArgumentLength(callIncludesWithRegexSupport)
}, [
    ENHANCEMENTS_FLAG,
    STRING_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.String.includes;

},{"d78bec676a8d62f2":"eWYA2","457e6e5aed22ef5d":"g3Tpr","45ef2e524353fe3d":"9dTqG","885dacd10e9d617a":"kYocG","2d2025167e59d6e7":"bJMVu"}],"g3Tpr":[function(require,module,exports) {
"use strict";
module.exports = "enhance";

},{}],"9dTqG":[function(require,module,exports) {
"use strict";
module.exports = "enhanceString";

},{}],"kYocG":[function(require,module,exports) {
"use strict";
function fixArgumentLength(fn) {
    var staticFn = function staticFn(a) {
        var args = arguments;
        return fn(a, args[1], args[2], args.length - 1);
    };
    staticFn.instance = function(b) {
        var args = arguments;
        return fn(this, b, args[1], args.length);
    };
    return staticFn;
}
module.exports = fixArgumentLength;

},{}],"bJMVu":[function(require,module,exports) {
"use strict";
var classChecks = require("d432290c100ca658"), nativeIncludes = require("182f6d54c9335c92");
var isRegExp = classChecks.isRegExp;
function callIncludesWithRegexSupport(str, search, position) {
    if (!isRegExp(search)) return nativeIncludes.call(str, search, position);
    if (position) str = str.slice(position);
    return search.test(str);
}
module.exports = callIncludesWithRegexSupport;

},{"d432290c100ca658":"lUOLF","182f6d54c9335c92":"fzCc7"}],"fzCc7":[function(require,module,exports) {
"use strict";
module.exports = String.prototype.includes;

},{}],"cS6WS":[function(require,module,exports) {
"use strict";
var Sugar = require("45b8ccbb336516ba"), isUndefined = require("5961bba3e3f117f9");
Sugar.String.defineInstance({
    "insert": function(str, substr, index) {
        index = isUndefined(index) ? str.length : index;
        return str.slice(0, index) + substr + str.slice(index);
    }
});
module.exports = Sugar.String.insert;

},{"45b8ccbb336516ba":"eWYA2","5961bba3e3f117f9":"hnApm"}],"h1ByG":[function(require,module,exports) {
"use strict";
var Sugar = require("acbb56f418069384"), trim = require("cf3211b69e24e2c9");
Sugar.String.defineInstance({
    "isBlank": function(str) {
        return trim(str).length === 0;
    }
});
module.exports = Sugar.String.isBlank;

},{"acbb56f418069384":"eWYA2","cf3211b69e24e2c9":"7k3lh"}],"q7Och":[function(require,module,exports) {
"use strict";
var Sugar = require("7bcf25cbab622369");
Sugar.String.defineInstance({
    "isEmpty": function(str) {
        return str.length === 0;
    }
});
module.exports = Sugar.String.isEmpty;

},{"7bcf25cbab622369":"eWYA2"}],"ccdL7":[function(require,module,exports) {
"use strict";
var Sugar = require("75a7d243d5a96a65"), isUndefined = require("158a7390cc52dc0e");
Sugar.String.defineInstance({
    "last": function(str, num) {
        if (isUndefined(num)) num = 1;
        var start = str.length - num < 0 ? 0 : str.length - num;
        return str.substr(start);
    }
});
module.exports = Sugar.String.last;

},{"75a7d243d5a96a65":"eWYA2","158a7390cc52dc0e":"hnApm"}],"hY83o":[function(require,module,exports) {
"use strict";
var Sugar = require("9ecac58c99545e1"), trim = require("53cf2a167dfe8a14"), stringEach = require("37bfae64bcdf0a77");
Sugar.String.defineInstance({
    "lines": function(str, eachLineFn) {
        return stringEach(trim(str), /^.*$/gm, eachLineFn);
    }
});
module.exports = Sugar.String.lines;

},{"9ecac58c99545e1":"eWYA2","53cf2a167dfe8a14":"7k3lh","37bfae64bcdf0a77":"l6k1y"}],"gzZd2":[function(require,module,exports) {
"use strict";
var Sugar = require("a058a5334dbbec5d"), padString = require("63afc2aeb7a7cde7"), mathAliases = require("2981026683a94a7a"), coercePositiveInteger = require("6cf5f3781b79b947");
var max = mathAliases.max, ceil = mathAliases.ceil, floor = mathAliases.floor;
Sugar.String.defineInstance({
    "pad": function(str, num, padding) {
        var half, front, back;
        num = coercePositiveInteger(num);
        half = max(0, num - str.length) / 2;
        front = floor(half);
        back = ceil(half);
        return padString(front, padding) + str + padString(back, padding);
    }
});
module.exports = Sugar.String.pad;

},{"a058a5334dbbec5d":"eWYA2","63afc2aeb7a7cde7":"lj9Tz","2981026683a94a7a":"89tTN","6cf5f3781b79b947":"5NU91"}],"lj9Tz":[function(require,module,exports) {
"use strict";
var isDefined = require("96293ca1a66dd989"), repeatString = require("edc186ba59c1e00c");
function padString(num, padding) {
    return repeatString(isDefined(padding) ? padding : " ", num);
}
module.exports = padString;

},{"96293ca1a66dd989":"6Ge6e","edc186ba59c1e00c":"2Rx0m"}],"2Rx0m":[function(require,module,exports) {
"use strict";
function repeatString(str, num) {
    var result = "";
    str = str.toString();
    while(num > 0){
        if (num & 1) result += str;
        if (num >>= 1) str += str;
    }
    return result;
}
module.exports = repeatString;

},{}],"89tTN":[function(require,module,exports) {
"use strict";
module.exports = {
    abs: Math.abs,
    pow: Math.pow,
    min: Math.min,
    max: Math.max,
    ceil: Math.ceil,
    floor: Math.floor,
    round: Math.round
};

},{}],"5NU91":[function(require,module,exports) {
"use strict";
var trunc = require("3ae2d22542ddcb60"), classChecks = require("f38978cdb56d656b");
var isNumber = classChecks.isNumber;
function coercePositiveInteger(n) {
    n = +n || 0;
    if (n < 0 || !isNumber(n) || !isFinite(n)) throw new RangeError("Invalid number");
    return trunc(n);
}
module.exports = coercePositiveInteger;

},{"3ae2d22542ddcb60":"ePaYC","f38978cdb56d656b":"lUOLF"}],"ePaYC":[function(require,module,exports) {
"use strict";
var mathAliases = require("7d4b30936ec87de1");
var ceil = mathAliases.ceil, floor = mathAliases.floor;
var trunc = Math.trunc || function(n) {
    if (n === 0 || !isFinite(n)) return n;
    return n < 0 ? ceil(n) : floor(n);
};
module.exports = trunc;

},{"7d4b30936ec87de1":"89tTN"}],"3t3PS":[function(require,module,exports) {
"use strict";
var Sugar = require("5a68fde68982d30c"), padString = require("796d7ec07bf7b64e"), mathAliases = require("6257800a7c2ce5ba"), coercePositiveInteger = require("cef13700604185db");
var max = mathAliases.max;
Sugar.String.defineInstance({
    "padLeft": function(str, num, padding) {
        num = coercePositiveInteger(num);
        return padString(max(0, num - str.length), padding) + str;
    }
});
module.exports = Sugar.String.padLeft;

},{"5a68fde68982d30c":"eWYA2","796d7ec07bf7b64e":"lj9Tz","6257800a7c2ce5ba":"89tTN","cef13700604185db":"5NU91"}],"1FwEq":[function(require,module,exports) {
"use strict";
var Sugar = require("9c8174ca592bd6bf"), padString = require("3c85e6993c0b4be4"), mathAliases = require("e30eaa92fe1fbc23"), coercePositiveInteger = require("552dcaa0baa9c482");
var max = mathAliases.max;
Sugar.String.defineInstance({
    "padRight": function(str, num, padding) {
        num = coercePositiveInteger(num);
        return str + padString(max(0, num - str.length), padding);
    }
});
module.exports = Sugar.String.padRight;

},{"9c8174ca592bd6bf":"eWYA2","3c85e6993c0b4be4":"lj9Tz","e30eaa92fe1fbc23":"89tTN","552dcaa0baa9c482":"5NU91"}],"eP4Tp":[function(require,module,exports) {
"use strict";
var Sugar = require("a20343a9ac610389"), stringParameterize = require("66a2e52588daeab0");
Sugar.String.defineInstance({
    "parameterize": function(str, separator) {
        return stringParameterize(str, separator);
    }
});
module.exports = Sugar.String.parameterize;

},{"a20343a9ac610389":"eWYA2","66a2e52588daeab0":"iudnU"}],"iudnU":[function(require,module,exports) {
"use strict";
var escapeRegExp = require("63bba7f7a21ccc94");
function stringParameterize(str, separator) {
    if (separator === undefined) separator = "-";
    str = str.replace(/[^a-z0-9\-_]+/gi, separator);
    if (separator) {
        var reg = RegExp("^{s}+|{s}+$|({s}){s}+".split("{s}").join(escapeRegExp(separator)), "g");
        str = str.replace(reg, "$1");
    }
    return encodeURI(str.toLowerCase());
}
module.exports = stringParameterize;

},{"63bba7f7a21ccc94":"dWlXH"}],"5KVWj":[function(require,module,exports) {
"use strict";
var Sugar = require("9ebd16f81c31e4aa");
Sugar.String.defineInstance({
    "remove": function(str, f) {
        return str.replace(f, "");
    }
});
module.exports = Sugar.String.remove;

},{"9ebd16f81c31e4aa":"eWYA2"}],"fqQGq":[function(require,module,exports) {
"use strict";
var Sugar = require("c7f17e8f0044aaca"), stringReplaceAll = require("f5166c32aef2ba87");
Sugar.String.defineInstance({
    "removeAll": function(str, f) {
        return stringReplaceAll(str, f);
    }
});
module.exports = Sugar.String.removeAll;

},{"c7f17e8f0044aaca":"eWYA2","f5166c32aef2ba87":"2Ey3A"}],"2Ey3A":[function(require,module,exports) {
"use strict";
var classChecks = require("4cc720ecea23a7e5"), escapeRegExp = require("c75cfc65d3d11220"), getRegExpFlags = require("e764876d8eb16686");
var isString = classChecks.isString;
function stringReplaceAll(str, f, replace) {
    var i = 0, tokens;
    if (isString(f)) f = RegExp(escapeRegExp(f), "g");
    else if (f && !f.global) f = RegExp(f.source, getRegExpFlags(f, "g"));
    if (!replace) replace = "";
    else {
        tokens = replace;
        replace = function replace() {
            var t = tokens[i++];
            return t != null ? t : "";
        };
    }
    return str.replace(f, replace);
}
module.exports = stringReplaceAll;

},{"4cc720ecea23a7e5":"lUOLF","c75cfc65d3d11220":"dWlXH","e764876d8eb16686":"658bK"}],"k32Tk":[function(require,module,exports) {
"use strict";
var Sugar = require("83b870d7104f6707"), replaceTags = require("9c2955ae8579ff37");
Sugar.String.defineInstance({
    "removeTags": function(str, tag, replace) {
        return replaceTags(str, tag, replace, false);
    }
});
module.exports = Sugar.String.removeTags;

},{"83b870d7104f6707":"eWYA2","9c2955ae8579ff37":"bZFYj"}],"bZFYj":[function(require,module,exports) {
"use strict";
var map = require("f043cb7da67d83ba"), classChecks = require("7e4e963ca5cc7dad"), escapeRegExp = require("ced00c549b47a3dc"), runTagReplacements = require("4dd53763bf7b9755");
var isString = classChecks.isString;
function replaceTags(str, find, replacement, strip) {
    var tags = isString(find) ? [
        find
    ] : find, reg, src;
    tags = map(tags || [], function(t) {
        return escapeRegExp(t);
    }).join("|");
    src = tags.replace("all", "") || "[^\\s>]+";
    src = "<(\\/)?(" + src + ")(\\s+[^<>]*?)?\\s*(\\/)?>";
    reg = RegExp(src, "gi");
    return runTagReplacements(str.toString(), reg, strip, replacement);
}
module.exports = replaceTags;

},{"f043cb7da67d83ba":"b19ZA","7e4e963ca5cc7dad":"lUOLF","ced00c549b47a3dc":"dWlXH","4dd53763bf7b9755":"4j6as"}],"4j6as":[function(require,module,exports) {
"use strict";
var tagIsVoid = require("88fc0188656572e5"), classChecks = require("19a0552b2e3bba0e");
var isString = classChecks.isString;
function runTagReplacements(str, reg, strip, replacement, fullString) {
    var match;
    var result = "";
    var currentIndex = 0;
    var openTagName;
    var openTagAttributes;
    var openTagCount = 0;
    function processTag(index, tagName, attributes, tagLength, isVoid) {
        var content = str.slice(currentIndex, index), s = "", r = "";
        if (isString(replacement)) r = replacement;
        else if (replacement) r = replacement.call(fullString, tagName, content, attributes, fullString) || "";
        if (strip) s = r;
        else content = r;
        if (content) content = runTagReplacements(content, reg, strip, replacement, fullString);
        result += s + content + (isVoid ? "" : s);
        currentIndex = index + (tagLength || 0);
    }
    fullString = fullString || str;
    reg = RegExp(reg.source, "gi");
    while(match = reg.exec(str)){
        var tagName = match[2];
        var attributes = (match[3] || "").slice(1);
        var isClosingTag = !!match[1];
        var isSelfClosing = !!match[4];
        var tagLength = match[0].length;
        var isVoid = tagIsVoid(tagName);
        var isOpeningTag = !isClosingTag && !isSelfClosing && !isVoid;
        var isSameAsCurrent = tagName === openTagName;
        if (!openTagName) {
            result += str.slice(currentIndex, match.index);
            currentIndex = match.index;
        }
        if (isOpeningTag) {
            if (!openTagName) {
                openTagName = tagName;
                openTagAttributes = attributes;
                openTagCount++;
                currentIndex += tagLength;
            } else if (isSameAsCurrent) openTagCount++;
        } else if (isClosingTag && isSameAsCurrent) {
            openTagCount--;
            if (openTagCount === 0) {
                processTag(match.index, openTagName, openTagAttributes, tagLength, isVoid);
                openTagName = null;
                openTagAttributes = null;
            }
        } else if (!openTagName) processTag(match.index, tagName, attributes, tagLength, isVoid);
    }
    if (openTagName) processTag(str.length, openTagName, openTagAttributes);
    result += str.slice(currentIndex);
    return result;
}
module.exports = runTagReplacements;

},{"88fc0188656572e5":"jLzYU","19a0552b2e3bba0e":"lUOLF"}],"jLzYU":[function(require,module,exports) {
"use strict";
var HTML_VOID_ELEMENTS = require("8dbfc5f9fd3f1cc6"), indexOf = require("86f0b9ca27721742");
function tagIsVoid(tag) {
    return indexOf(HTML_VOID_ELEMENTS, tag.toLowerCase()) !== -1;
}
module.exports = tagIsVoid;

},{"8dbfc5f9fd3f1cc6":"aNb0z","86f0b9ca27721742":"6R6IE"}],"aNb0z":[function(require,module,exports) {
"use strict";
var HTML_VOID_ELEMENTS = [
    "area",
    "base",
    "br",
    "col",
    "command",
    "embed",
    "hr",
    "img",
    "input",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
];
module.exports = HTML_VOID_ELEMENTS;

},{}],"6R6IE":[function(require,module,exports) {
"use strict";
function indexOf(arr, el) {
    for(var i = 0, len = arr.length; i < len; i++){
        if (i in arr && arr[i] === el) return i;
    }
    return -1;
}
module.exports = indexOf;

},{}],"gUBLQ":[function(require,module,exports) {
"use strict";
var Sugar = require("5b3a1d8db997ee7"), stringReplaceAll = require("b76b66f59d34f799");
Sugar.String.defineInstanceWithArguments({
    "replaceAll": function(str, f, args) {
        return stringReplaceAll(str, f, args);
    }
});
module.exports = Sugar.String.replaceAll;

},{"5b3a1d8db997ee7":"eWYA2","b76b66f59d34f799":"2Ey3A"}],"kvpGg":[function(require,module,exports) {
"use strict";
var Sugar = require("c0c74ff12480d89b"), reverseString = require("b925fe4c6eabca6");
Sugar.String.defineInstance({
    "reverse": function(str) {
        return reverseString(str);
    }
});
module.exports = Sugar.String.reverse;

},{"c0c74ff12480d89b":"eWYA2","b925fe4c6eabca6":"lsg89"}],"lsg89":[function(require,module,exports) {
"use strict";
function reverseString(str) {
    return str.split("").reverse().join("");
}
module.exports = reverseString;

},{}],"6xC2I":[function(require,module,exports) {
"use strict";
var Sugar = require("4ba5cc5ddac72989"), chr = require("d4c1203fd82cc7b6"), stringCodes = require("d10cdae9a2371fcb");
Sugar.String.defineInstance({
    "shift": function(str, n) {
        var result = "";
        n = n || 0;
        stringCodes(str, function(c) {
            result += chr(c + n);
        });
        return result;
    }
});
module.exports = Sugar.String.shift;

},{"4ba5cc5ddac72989":"eWYA2","d4c1203fd82cc7b6":"fFtOs","d10cdae9a2371fcb":"9kWnD"}],"ky41R":[function(require,module,exports) {
"use strict";
var Sugar = require("31ada10a43de2dc5"), stringSpacify = require("e4fd1a97bac6bfe9");
Sugar.String.defineInstance({
    "spacify": function(str) {
        return stringSpacify(str);
    }
});
module.exports = Sugar.String.spacify;

},{"31ada10a43de2dc5":"eWYA2","e4fd1a97bac6bfe9":"4HZ2X"}],"4HZ2X":[function(require,module,exports) {
"use strict";
var stringUnderscore = require("78bc34c8af706e66");
function stringSpacify(str) {
    return stringUnderscore(str).replace(/_/g, " ");
}
module.exports = stringSpacify;

},{"78bc34c8af706e66":"5NGTb"}],"1IzAe":[function(require,module,exports) {
"use strict";
var Sugar = require("724941d9b19bc6ab"), replaceTags = require("3a86df8404125a8f");
Sugar.String.defineInstance({
    "stripTags": function(str, tag, replace) {
        return replaceTags(str, tag, replace, true);
    }
});
module.exports = Sugar.String.stripTags;

},{"724941d9b19bc6ab":"eWYA2","3a86df8404125a8f":"bZFYj"}],"i4SHV":[function(require,module,exports) {
"use strict";
var Sugar = require("9198511968f9be70"), stringTitleize = require("af2d962bf556ab71");
Sugar.String.defineInstance({
    "titleize": function(str) {
        return stringTitleize(str);
    }
});
module.exports = Sugar.String.titleize;

},{"9198511968f9be70":"eWYA2","af2d962bf556ab71":"g4m9H"}],"g4m9H":[function(require,module,exports) {
"use strict";
var DOWNCASED_WORDS = require("567c9e79a3cc67e6"), indexOf = require("ca92917e83db13f5"), eachWord = require("122448c9ed0978f5"), getAcronym = require("3383d9a4fc572c80"), getHumanWord = require("bcac4ce54e93275b"), runHumanRules = require("ad75c5be6bf8fb3d"), stringSpacify = require("65334304e6c0df21"), stringCapitalize = require("1997e7fa5465488b");
function stringTitleize(str) {
    var fullStopPunctuation = /[.:;!]$/, lastHadPunctuation;
    str = runHumanRules(str);
    str = stringSpacify(str);
    return eachWord(str, function(word, index, words) {
        word = getHumanWord(word) || word;
        word = getAcronym(word) || word;
        var hasPunctuation, isFirstOrLast;
        var first = index == 0, last = index == words.length - 1;
        hasPunctuation = fullStopPunctuation.test(word);
        isFirstOrLast = first || last || hasPunctuation || lastHadPunctuation;
        lastHadPunctuation = hasPunctuation;
        if (isFirstOrLast || indexOf(DOWNCASED_WORDS, word) === -1) return stringCapitalize(word, false, true);
        else return word;
    }).join(" ");
}
module.exports = stringTitleize;

},{"567c9e79a3cc67e6":"1yr7V","ca92917e83db13f5":"6R6IE","122448c9ed0978f5":"3gS6i","3383d9a4fc572c80":"ge9tJ","bcac4ce54e93275b":"5bSH5","ad75c5be6bf8fb3d":"aMkLk","65334304e6c0df21":"4HZ2X","1997e7fa5465488b":"e3ssf"}],"1yr7V":[function(require,module,exports) {
"use strict";
var DOWNCASED_WORDS = [
    "and",
    "or",
    "nor",
    "a",
    "an",
    "the",
    "so",
    "but",
    "to",
    "of",
    "at",
    "by",
    "from",
    "into",
    "on",
    "onto",
    "off",
    "out",
    "in",
    "over",
    "with",
    "for"
];
module.exports = DOWNCASED_WORDS;

},{}],"3gS6i":[function(require,module,exports) {
"use strict";
var trim = require("fbd9d2411fca698b"), stringEach = require("99643f470a0f6b81");
function eachWord(str, fn) {
    return stringEach(trim(str), /\S+/g, fn);
}
module.exports = eachWord;

},{"fbd9d2411fca698b":"7k3lh","99643f470a0f6b81":"l6k1y"}],"5bSH5":[function(require,module,exports) {
"use strict";
var Inflections = require("bde84a8d0452112c");
function getHumanWord(str) {
    // istanbul ignore next
    return Inflections.human && Inflections.human.find(str);
}
module.exports = getHumanWord;

},{"bde84a8d0452112c":"4cxyp"}],"aMkLk":[function(require,module,exports) {
"use strict";
var Inflections = require("1f3d9304ef337d3");
function runHumanRules(str) {
    // istanbul ignore next
    return Inflections.human && Inflections.human.runRules(str) || str;
}
module.exports = runHumanRules;

},{"1f3d9304ef337d3":"4cxyp"}],"gaKvx":[function(require,module,exports) {
"use strict";
var Sugar = require("fc26b8634511cd90"), isUndefined = require("153c396f89de1c18"), numberOrIndex = require("62a607ce5c6e0fbe");
Sugar.String.defineInstance({
    "to": function(str, to) {
        if (isUndefined(to)) to = str.length;
        return str.slice(0, numberOrIndex(str, to));
    }
});
module.exports = Sugar.String.to;

},{"fc26b8634511cd90":"eWYA2","153c396f89de1c18":"hnApm","62a607ce5c6e0fbe":"kARMJ"}],"2WucJ":[function(require,module,exports) {
"use strict";
var Sugar = require("e5c7136f49285052"), stringToNumber = require("eef8d95f7eb7df1d");
Sugar.String.defineInstance({
    "toNumber": function(str, base) {
        return stringToNumber(str, base);
    }
});
module.exports = Sugar.String.toNumber;

},{"e5c7136f49285052":"eWYA2","eef8d95f7eb7df1d":"bQshq"}],"bQshq":[function(require,module,exports) {
"use strict";
var CommonChars = require("db245650ce4350e4"), coreUtilityAliases = require("c509072e29b81b01"), fullwidthNumberHelpers = require("c0966441370b1121");
var fullWidthNumberReg = fullwidthNumberHelpers.fullWidthNumberReg, fullWidthNumberMap = fullwidthNumberHelpers.fullWidthNumberMap, getOwn = coreUtilityAliases.getOwn, HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;
function stringToNumber(str, base) {
    var sanitized, isDecimal;
    sanitized = str.replace(fullWidthNumberReg, function(chr) {
        var replacement = getOwn(fullWidthNumberMap, chr);
        if (replacement === HALF_WIDTH_PERIOD) isDecimal = true;
        return replacement;
    });
    return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
}
module.exports = stringToNumber;

},{"db245650ce4350e4":"ktIFO","c509072e29b81b01":"dU8Nu","c0966441370b1121":"429TR"}],"429TR":[function(require,module,exports) {
"use strict";
var CommonChars = require("b8279ad0aeb580fb"), chr = require("527da8c1b3eb2c34"), allCharsReg = require("89b9f0b1a9f06fcb");
var HALF_WIDTH_ZERO = CommonChars.HALF_WIDTH_ZERO, FULL_WIDTH_ZERO = CommonChars.FULL_WIDTH_ZERO, HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD, FULL_WIDTH_PERIOD = CommonChars.FULL_WIDTH_PERIOD, HALF_WIDTH_COMMA = CommonChars.HALF_WIDTH_COMMA;
var fullWidthNumberReg, fullWidthNumberMap, fullWidthNumbers;
function buildFullWidthNumber() {
    var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA, fwn = "";
    fullWidthNumberMap = {};
    for(var i = 0, digit; i <= 9; i++){
        digit = chr(i + FULL_WIDTH_ZERO);
        fwn += digit;
        fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
    }
    fullWidthNumberMap[hwc] = "";
    fullWidthNumberMap[fwp] = hwp;
    // Mapping this to itself to capture it easily
    // in stringToNumber to detect decimals later.
    fullWidthNumberMap[hwp] = hwp;
    fullWidthNumberReg = allCharsReg(fwn + fwp + hwc + hwp);
    fullWidthNumbers = fwn;
}
buildFullWidthNumber();
module.exports = {
    fullWidthNumberReg: fullWidthNumberReg,
    fullWidthNumberMap: fullWidthNumberMap,
    fullWidthNumbers: fullWidthNumbers
};

},{"b8279ad0aeb580fb":"ktIFO","527da8c1b3eb2c34":"fFtOs","89b9f0b1a9f06fcb":"gTjdM"}],"gTjdM":[function(require,module,exports) {
"use strict";
function allCharsReg(src) {
    return RegExp("[" + src + "]", "g");
}
module.exports = allCharsReg;

},{}],"66Eui":[function(require,module,exports) {
"use strict";
var Sugar = require("32d35b8dce67915c"), LEFT_TRIM_REG = require("261d65620d343547");
Sugar.String.defineInstance({
    "trimLeft": function(str) {
        return str.replace(LEFT_TRIM_REG, "");
    }
});
module.exports = Sugar.String.trimLeft;

},{"32d35b8dce67915c":"eWYA2","261d65620d343547":"8fGpT"}],"8fGpT":[function(require,module,exports) {
"use strict";
var TRIM_CHARS = require("9a67863c83efa7e0");
module.exports = RegExp("^[" + TRIM_CHARS + "]+");

},{"9a67863c83efa7e0":"1Adgj"}],"1Adgj":[function(require,module,exports) {
"use strict";
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF";

},{}],"6G95x":[function(require,module,exports) {
"use strict";
var Sugar = require("457690ccde01e309"), RIGHT_TRIM_REG = require("40c33b351e6c7c87");
Sugar.String.defineInstance({
    "trimRight": function(str) {
        return str.replace(RIGHT_TRIM_REG, "");
    }
});
module.exports = Sugar.String.trimRight;

},{"457690ccde01e309":"eWYA2","40c33b351e6c7c87":"fmHtt"}],"fmHtt":[function(require,module,exports) {
"use strict";
var TRIM_CHARS = require("9fb9e21ac1f1c136");
module.exports = RegExp("[" + TRIM_CHARS + "]+$");

},{"9fb9e21ac1f1c136":"1Adgj"}],"7AQUZ":[function(require,module,exports) {
"use strict";
var Sugar = require("cff6c702b9c3ce6a"), truncateString = require("9e3e861ba864734a");
Sugar.String.defineInstance({
    "truncate": function(str, length, from, ellipsis) {
        return truncateString(str, length, from, ellipsis);
    }
});
module.exports = Sugar.String.truncate;

},{"cff6c702b9c3ce6a":"eWYA2","9e3e861ba864734a":"48FM6"}],"48FM6":[function(require,module,exports) {
"use strict";
var isUndefined = require("f449864830228f01"), mathAliases = require("8fcd468c33874f10"), truncateOnWord = require("c0117d254cdd798a");
var ceil = mathAliases.ceil, floor = mathAliases.floor;
function truncateString(str, length, from, ellipsis, split) {
    var str1, str2, len1, len2;
    if (str.length <= length) return str.toString();
    ellipsis = isUndefined(ellipsis) ? "..." : ellipsis;
    switch(from){
        case "left":
            str2 = split ? truncateOnWord(str, length, true) : str.slice(str.length - length);
            return ellipsis + str2;
        case "middle":
            len1 = ceil(length / 2);
            len2 = floor(length / 2);
            str1 = split ? truncateOnWord(str, len1) : str.slice(0, len1);
            str2 = split ? truncateOnWord(str, len2, true) : str.slice(str.length - len2);
            return str1 + ellipsis + str2;
        default:
            str1 = split ? truncateOnWord(str, length) : str.slice(0, length);
            return str1 + ellipsis;
    }
}
module.exports = truncateString;

},{"f449864830228f01":"hnApm","8fcd468c33874f10":"89tTN","c0117d254cdd798a":"Yx3Hj"}],"Yx3Hj":[function(require,module,exports) {
"use strict";
var TRUNC_REG = require("bc297ff57b77ac79"), filter = require("bd814dae4345b2f"), reverseString = require("cdaef28cf4544cb3");
function truncateOnWord(str, limit, fromLeft) {
    if (fromLeft) return reverseString(truncateOnWord(reverseString(str), limit));
    var words = str.split(TRUNC_REG);
    var count = 0;
    return filter(words, function(word) {
        count += word.length;
        return count <= limit;
    }).join("");
}
module.exports = truncateOnWord;

},{"bc297ff57b77ac79":"3C5b1","bd814dae4345b2f":"3TIFw","cdaef28cf4544cb3":"lsg89"}],"3C5b1":[function(require,module,exports) {
"use strict";
var TRIM_CHARS = require("a094a9d059c4da39");
module.exports = RegExp("(?=[" + TRIM_CHARS + "])");

},{"a094a9d059c4da39":"1Adgj"}],"3TIFw":[function(require,module,exports) {
"use strict";
function filter(arr, fn) {
    var result = [];
    for(var i = 0, len = arr.length; i < len; i++){
        var el = arr[i];
        if (i in arr && fn(el, i)) result.push(el);
    }
    return result;
}
module.exports = filter;

},{}],"8ilxn":[function(require,module,exports) {
"use strict";
var Sugar = require("101c5a49e3332513"), truncateString = require("a02c08a9bb2f5552");
Sugar.String.defineInstance({
    "truncateOnWord": function(str, length, from, ellipsis) {
        return truncateString(str, length, from, ellipsis, true);
    }
});
module.exports = Sugar.String.truncateOnWord;

},{"101c5a49e3332513":"eWYA2","a02c08a9bb2f5552":"48FM6"}],"2mrtK":[function(require,module,exports) {
"use strict";
var Sugar = require("d378346ab037e9ee"), stringUnderscore = require("a2802b0dcdf77c27");
Sugar.String.defineInstance({
    "underscore": function(str) {
        return stringUnderscore(str);
    }
});
module.exports = Sugar.String.underscore;

},{"d378346ab037e9ee":"eWYA2","a2802b0dcdf77c27":"5NGTb"}],"3Pfm1":[function(require,module,exports) {
"use strict";
var Sugar = require("bb61bc425eaf31d5"), unescapeHTML = require("8407fb0577f8fb63");
Sugar.String.defineInstance({
    "unescapeHTML": function(str) {
        return unescapeHTML(str);
    }
});
module.exports = Sugar.String.unescapeHTML;

},{"bb61bc425eaf31d5":"eWYA2","8407fb0577f8fb63":"2mVgK"}],"2mVgK":[function(require,module,exports) {
"use strict";
var HTML_ENTITY_REG = require("b9186a2e704bfff9"), HTMLFromEntityMap = require("94d46f6d3792b699"), chr = require("c20100586bd1af09");
function unescapeHTML(str) {
    return str.replace(HTML_ENTITY_REG, function(full, hex, code) {
        var special = HTMLFromEntityMap[code];
        return special || chr(hex ? parseInt(code, 16) : +code);
    });
}
module.exports = unescapeHTML;

},{"b9186a2e704bfff9":"L4ajY","94d46f6d3792b699":"ZCuew","c20100586bd1af09":"fFtOs"}],"L4ajY":[function(require,module,exports) {
"use strict";
module.exports = /&#?(x)?([\w\d]{0,5});/gi;

},{}],"2iPFQ":[function(require,module,exports) {
"use strict";
var Sugar = require("32fe054a7cf6cf15");
Sugar.String.defineInstance({
    "unescapeURL": function(str, param) {
        return param ? decodeURI(str) : decodeURIComponent(str);
    }
});
module.exports = Sugar.String.unescapeURL;

},{"32fe054a7cf6cf15":"eWYA2"}],"4Ve8Z":[function(require,module,exports) {
"use strict";
var Sugar = require("7dcedcb79dc46828"), trim = require("3f9077422aa2d1e2"), stringEach = require("969cc229030a8b42");
Sugar.String.defineInstance({
    "words": function(str, eachWordFn) {
        return stringEach(trim(str), /\S+/g, eachWordFn);
    }
});
module.exports = Sugar.String.words;

},{"7dcedcb79dc46828":"eWYA2","3f9077422aa2d1e2":"7k3lh","969cc229030a8b42":"l6k1y"}],"lwb2J":[function(require,module,exports) {
"use strict";
// Static Methods
require("5f047b37736a32fa");
// Instance Methods
require("884d2a5c3fd571bb");
require("58cfe4e4916989f1");
require("f3bb77d50f4a2949");
require("1a8a3cdf74896cf7");
require("622cef30813e6400");
require("30de33b7376797e2");
require("9632a33a0b181fc4");
require("5a19139bc5c4b69b");
require("96678d71d532d168");
require("e73a7b277b9abcb2");
require("c846dbd6b530fecf");
require("2743348e13123fc8");
require("d7bac3af83e297f7");
require("b3badf29c12d3353");
require("6536e7ab46c5b120");
require("d659ffcfb4ee7f9f");
require("c99ed837acf4da9d");
require("1628cefa4bf5d518");
require("53beacaf2afad24d");
require("37b42859133172fe");
require("f7fcc77f36b5c3b4");
require("b4b18be92a4b96d");
require("106a22df75265436");
require("a545a96805e675c9");
require("fd537d1649b82cfd");
require("31e2ea9a9e7a7da4");
require("819eb3a68a31014d");
require("5d12ca79da52f761");
// Accessors
require("29b74baf8de0fb35");
require("e693692e5f770094");
module.exports = require("12ca1b9ec933320");

},{"5f047b37736a32fa":"aunlu","884d2a5c3fd571bb":"fiTkg","58cfe4e4916989f1":"jSOAB","f3bb77d50f4a2949":"toipl","1a8a3cdf74896cf7":"iW7pv","622cef30813e6400":"jUpa5","30de33b7376797e2":"eEUmM","9632a33a0b181fc4":"iOCte","5a19139bc5c4b69b":"jpyyW","96678d71d532d168":"1Spd4","e73a7b277b9abcb2":"5zTIU","c846dbd6b530fecf":"7eCWC","2743348e13123fc8":"kWebG","d7bac3af83e297f7":"bXRKA","b3badf29c12d3353":"izcgn","6536e7ab46c5b120":"lMO3R","d659ffcfb4ee7f9f":"cdWNw","c99ed837acf4da9d":"hIHFF","1628cefa4bf5d518":"8oxsz","53beacaf2afad24d":"iZKRt","37b42859133172fe":"5hgOs","f7fcc77f36b5c3b4":"fUcPq","b4b18be92a4b96d":"il8UD","106a22df75265436":"8FIrP","a545a96805e675c9":"9N8Zm","fd537d1649b82cfd":"fguSq","31e2ea9a9e7a7da4":"g9M5X","819eb3a68a31014d":"dELad","5d12ca79da52f761":"9Qmt5","29b74baf8de0fb35":"cO8yU","e693692e5f770094":"d4KpK","12ca1b9ec933320":"eWYA2"}],"aunlu":[function(require,module,exports) {
"use strict";
var Sugar = require("cca1649f7f80e402"), trunc = require("f0747504a7f2d4d3"), mathAliases = require("72841e52ac10d46d"), isUndefined = require("dd1cff86b6b3594d");
var min = mathAliases.min, max = mathAliases.max;
Sugar.Number.defineStatic({
    "random": function(n1, n2) {
        var minNum, maxNum;
        if (arguments.length == 1) n2 = n1, n1 = 0;
        minNum = min(n1 || 0, isUndefined(n2) ? 1 : n2);
        maxNum = max(n1 || 0, isUndefined(n2) ? 1 : n2) + 1;
        return trunc(Math.random() * (maxNum - minNum) + minNum);
    }
});
module.exports = Sugar.Number.random;

},{"cca1649f7f80e402":"eWYA2","f0747504a7f2d4d3":"ePaYC","72841e52ac10d46d":"89tTN","dd1cff86b6b3594d":"hnApm"}],"fiTkg":[function(require,module,exports) {
"use strict";
var Sugar = require("3c98043f6090370d"), AbbreviationUnits = require("cb04e47e7b8ff133"), abbreviateNumber = require("1244a6cec06199c");
var BASIC_UNITS = AbbreviationUnits.BASIC_UNITS;
Sugar.Number.defineInstance({
    "abbr": function(n, precision) {
        return abbreviateNumber(n, precision, BASIC_UNITS);
    }
});
module.exports = Sugar.Number.abbr;

},{"3c98043f6090370d":"eWYA2","cb04e47e7b8ff133":"eFZaZ","1244a6cec06199c":"jMfrT"}],"eFZaZ":[function(require,module,exports) {
"use strict";
module.exports = {
    BASIC_UNITS: "|kmbt",
    MEMORY_UNITS: "|KMGTPE",
    MEMORY_BINARY_UNITS: "|,Ki,Mi,Gi,Ti,Pi,Ei",
    METRIC_UNITS_SHORT: "n\u03BCm|k",
    METRIC_UNITS_FULL: "yzafpn\u03BCm|KMGTPEZY"
};

},{}],"jMfrT":[function(require,module,exports) {
"use strict";
var commaSplit = require("3316acf463e3f53d"), mathAliases = require("923bcf0db8268e51"), numberFormat = require("2fb605ee663b45b7"), withPrecision = require("e7eddeeed5c1b078");
var abs = mathAliases.abs, pow = mathAliases.pow, min = mathAliases.min, max = mathAliases.max, floor = mathAliases.floor;
function abbreviateNumber(num, precision, ustr, bytes) {
    var fixed = num.toFixed(20), decimalPlace = fixed.search(/\./), numeralPlace = fixed.search(/[1-9]/), significant = decimalPlace - numeralPlace, units, unit, mid, i, divisor;
    if (significant > 0) significant -= 1;
    units = commaSplit(ustr);
    if (units.length === 1) units = ustr.split("");
    mid = units.indexOf("|");
    if (mid === -1) // Skipping the placeholder means the units should start from zero,
    // otherwise assume they end at zero.
    mid = units[0] === "_" ? 0 : units.length;
    i = max(min(floor(significant / 3), units.length - mid - 1), -mid);
    unit = units[i + mid];
    while(unit === "_"){
        i += i < 0 ? -1 : 1;
        unit = units[i + mid];
    }
    if (unit === "|") unit = "";
    if (significant < -9) precision = abs(significant) - 9;
    divisor = bytes ? pow(2, 10 * i) : pow(10, i * 3);
    return numberFormat(withPrecision(num / divisor, precision || 0)) + unit;
}
module.exports = abbreviateNumber;

},{"3316acf463e3f53d":"1JJ8q","923bcf0db8268e51":"89tTN","2fb605ee663b45b7":"6v3fR","e7eddeeed5c1b078":"6JCWQ"}],"1JJ8q":[function(require,module,exports) {
"use strict";
var CommonChars = require("e9ab12fff67c2628");
var HALF_WIDTH_COMMA = CommonChars.HALF_WIDTH_COMMA;
function commaSplit(str) {
    return str.split(HALF_WIDTH_COMMA);
}
module.exports = commaSplit;

},{"e9ab12fff67c2628":"ktIFO"}],"6v3fR":[function(require,module,exports) {
"use strict";
var classChecks = require("2db2026fd8dc2b0"), mathAliases = require("a98c75ecb74dbaa9"), periodSplit = require("a271916bb11d3ad"), repeatString = require("aa2531263af9df79"), withPrecision = require("c37197eb633732e9"), _numberOptions = require("763d4cfa544057fa");
var isNumber = classChecks.isNumber, max = mathAliases.max;
function numberFormat(num, place) {
    var result = "", thousands, decimal, fraction, integer, split, str;
    decimal = _numberOptions("decimal");
    thousands = _numberOptions("thousands");
    if (isNumber(place)) str = withPrecision(num, place || 0).toFixed(max(place, 0));
    else str = num.toString();
    str = str.replace(/^-/, "");
    split = periodSplit(str);
    integer = split[0];
    fraction = split[1];
    if (/e/.test(str)) result = str;
    else for(var i = integer.length; i > 0; i -= 3){
        if (i < integer.length) result = thousands + result;
        result = integer.slice(max(0, i - 3), i) + result;
    }
    if (fraction) result += decimal + repeatString("0", (place || 0) - fraction.length) + fraction;
    return (num < 0 ? "-" : "") + result;
}
module.exports = numberFormat;

},{"2db2026fd8dc2b0":"lUOLF","a98c75ecb74dbaa9":"89tTN","a271916bb11d3ad":"jncZt","aa2531263af9df79":"2Rx0m","c37197eb633732e9":"6JCWQ","763d4cfa544057fa":"egUvr"}],"6JCWQ":[function(require,module,exports) {
"use strict";
var mathAliases = require("d15679bd756ba575");
var abs = mathAliases.abs, pow = mathAliases.pow, round = mathAliases.round;
function withPrecision(val, precision, fn) {
    var multiplier = pow(10, abs(precision || 0));
    fn = fn || round;
    if (precision < 0) multiplier = 1 / multiplier;
    return fn(val * multiplier) / multiplier;
}
module.exports = withPrecision;

},{"d15679bd756ba575":"89tTN"}],"egUvr":[function(require,module,exports) {
"use strict";
var NUMBER_OPTIONS = require("c6359322847bfac3"), namespaceAliases = require("d09633eea78739d5"), defineOptionsAccessor = require("cdb5ea692e86c365");
var sugarNumber = namespaceAliases.sugarNumber;
module.exports = defineOptionsAccessor(sugarNumber, NUMBER_OPTIONS);

},{"c6359322847bfac3":"1XoCm","d09633eea78739d5":"1TEpR","cdb5ea692e86c365":"5GDAt"}],"1XoCm":[function(require,module,exports) {
"use strict";
var CommonChars = require("91223d2834372927");
var HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD, HALF_WIDTH_COMMA = CommonChars.HALF_WIDTH_COMMA;
var NUMBER_OPTIONS = {
    "decimal": HALF_WIDTH_PERIOD,
    "thousands": HALF_WIDTH_COMMA
};
module.exports = NUMBER_OPTIONS;

},{"91223d2834372927":"ktIFO"}],"1TEpR":[function(require,module,exports) {
"use strict";
var Sugar = require("5a3a7a32d04ee6e1");
module.exports = {
    sugarObject: Sugar.Object,
    sugarArray: Sugar.Array,
    sugarDate: Sugar.Date,
    sugarString: Sugar.String,
    sugarNumber: Sugar.Number,
    sugarFunction: Sugar.Function,
    sugarRegExp: Sugar.RegExp
};

},{"5a3a7a32d04ee6e1":"eWYA2"}],"5GDAt":[function(require,module,exports) {
"use strict";
var simpleClone = require("30d79bd11a707bc0"), defineAccessor = require("dc8a331fa6b1f3c0"), coreUtilityAliases = require("199488070ce83977");
var forEachProperty = coreUtilityAliases.forEachProperty;
function defineOptionsAccessor(namespace, defaults) {
    var obj = simpleClone(defaults);
    function getOption(name) {
        return obj[name];
    }
    function setOption(arg1, arg2) {
        var options;
        if (arguments.length === 1) options = arg1;
        else {
            options = {};
            options[arg1] = arg2;
        }
        forEachProperty(options, function(val, name) {
            if (val === null) val = defaults[name];
            obj[name] = val;
        });
    }
    defineAccessor(namespace, "getOption", getOption);
    defineAccessor(namespace, "setOption", setOption);
    return getOption;
}
module.exports = defineOptionsAccessor;

},{"30d79bd11a707bc0":"5Aio4","dc8a331fa6b1f3c0":"lbpiM","199488070ce83977":"dU8Nu"}],"5Aio4":[function(require,module,exports) {
"use strict";
var simpleMerge = require("4fe09800fea8387b");
function simpleClone(obj) {
    return simpleMerge({}, obj);
}
module.exports = simpleClone;

},{"4fe09800fea8387b":"bkfA1"}],"bkfA1":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("78e2b6d6a75c3750");
var forEachProperty = coreUtilityAliases.forEachProperty;
function simpleMerge(target, source) {
    forEachProperty(source, function(val, key) {
        target[key] = val;
    });
    return target;
}
module.exports = simpleMerge;

},{"78e2b6d6a75c3750":"dU8Nu"}],"lbpiM":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("f138ad5dfa54935a");
var setProperty = coreUtilityAliases.setProperty;
function defineAccessor(namespace, name, fn) {
    setProperty(namespace, name, fn);
}
module.exports = defineAccessor;

},{"f138ad5dfa54935a":"dU8Nu"}],"jSOAB":[function(require,module,exports) {
"use strict";
var Sugar = require("c20a174dcff78e6f");
require("bc03884538a201c1");
module.exports = Sugar.Number.abs;

},{"c20a174dcff78e6f":"eWYA2","bc03884538a201c1":"lVYqJ"}],"lVYqJ":[function(require,module,exports) {
"use strict";
var buildMathAliases = require("43c111354c337f7");
buildMathAliases();

},{"43c111354c337f7":"fNhmu"}],"fNhmu":[function(require,module,exports) {
"use strict";
var namespaceAliases = require("cec76c4e862247d0"), defineInstanceSimilar = require("803ca18f454ebc92");
var sugarNumber = namespaceAliases.sugarNumber;
function buildMathAliases() {
    defineInstanceSimilar(sugarNumber, "abs pow sin asin cos acos tan atan exp pow sqrt", function(methods, name) {
        methods[name] = function(n, arg) {
            // Note that .valueOf() here is only required due to a
            // very strange bug in iOS7 that only occurs occasionally
            // in which Math.abs() called on non-primitive numbers
            // returns a completely different number (Issue #400)
            return Math[name](n.valueOf(), arg);
        };
    });
}
module.exports = buildMathAliases;

},{"cec76c4e862247d0":"1TEpR","803ca18f454ebc92":"BfBjK"}],"BfBjK":[function(require,module,exports) {
"use strict";
var methodDefineAliases = require("e784d1d4f59de7b8"), collectSimilarMethods = require("640f7044e8defcd2");
var defineInstance = methodDefineAliases.defineInstance;
function defineInstanceSimilar(sugarNamespace, set, fn, flags) {
    defineInstance(sugarNamespace, collectSimilarMethods(set, fn), flags);
}
module.exports = defineInstanceSimilar;

},{"e784d1d4f59de7b8":"l2cG2","640f7044e8defcd2":"bQRtP"}],"l2cG2":[function(require,module,exports) {
"use strict";
var wrapNamespace = require("9bc5629d69958f22");
module.exports = {
    alias: wrapNamespace("alias"),
    defineStatic: wrapNamespace("defineStatic"),
    defineInstance: wrapNamespace("defineInstance"),
    defineStaticPolyfill: wrapNamespace("defineStaticPolyfill"),
    defineInstancePolyfill: wrapNamespace("defineInstancePolyfill"),
    defineInstanceAndStatic: wrapNamespace("defineInstanceAndStatic"),
    defineInstanceWithArguments: wrapNamespace("defineInstanceWithArguments")
};

},{"9bc5629d69958f22":"5kfqV"}],"5kfqV":[function(require,module,exports) {
"use strict";
function wrapNamespace(method) {
    return function(sugarNamespace, arg1, arg2) {
        sugarNamespace[method](arg1, arg2);
    };
}
module.exports = wrapNamespace;

},{}],"bQRtP":[function(require,module,exports) {
"use strict";
var forEach = require("c6fe15552252bd1f"), spaceSplit = require("2801bf59e35bafd3"), classChecks = require("6e3c21102c03cbe3");
var isString = classChecks.isString;
function collectSimilarMethods(set, fn) {
    var methods = {};
    if (isString(set)) set = spaceSplit(set);
    forEach(set, function(el, i) {
        fn(methods, el, i);
    });
    return methods;
}
module.exports = collectSimilarMethods;

},{"c6fe15552252bd1f":"1n2CK","2801bf59e35bafd3":"8g1bL","6e3c21102c03cbe3":"lUOLF"}],"toipl":[function(require,module,exports) {
"use strict";
var Sugar = require("d52f21b98dc52c48");
require("3733970dc17fb767");
module.exports = Sugar.Number.acos;

},{"d52f21b98dc52c48":"eWYA2","3733970dc17fb767":"lVYqJ"}],"iW7pv":[function(require,module,exports) {
"use strict";
var Sugar = require("5bfc2b01addac5fb");
require("24d9e3074b8c986b");
module.exports = Sugar.Number.asin;

},{"5bfc2b01addac5fb":"eWYA2","24d9e3074b8c986b":"lVYqJ"}],"jUpa5":[function(require,module,exports) {
"use strict";
var Sugar = require("c1f459e592fd6634");
require("b89c50e61ca76f0b");
module.exports = Sugar.Number.atan;

},{"c1f459e592fd6634":"eWYA2","b89c50e61ca76f0b":"lVYqJ"}],"eEUmM":[function(require,module,exports) {
"use strict";
var Sugar = require("e1cc97ff5c3c5604"), AbbreviationUnits = require("947c91b1b2343cb"), abbreviateNumber = require("1272eaec23f52395");
var MEMORY_UNITS = AbbreviationUnits.MEMORY_UNITS, MEMORY_BINARY_UNITS = AbbreviationUnits.MEMORY_BINARY_UNITS;
Sugar.Number.defineInstance({
    "bytes": function(n, precision, binary, units) {
        if (units === "binary" || !units && binary) units = MEMORY_BINARY_UNITS;
        else if (units === "si" || !units) units = MEMORY_UNITS;
        return abbreviateNumber(n, precision, units, binary) + "B";
    }
});
module.exports = Sugar.Number.bytes;

},{"e1cc97ff5c3c5604":"eWYA2","947c91b1b2343cb":"eFZaZ","1272eaec23f52395":"jMfrT"}],"iOCte":[function(require,module,exports) {
"use strict";
var Sugar = require("36eae434789c317b"), mathAliases = require("adf5b171da166ade"), createRoundingFunction = require("f63f14d52542bb30");
var ceil = mathAliases.ceil;
Sugar.Number.defineInstance({
    "ceil": createRoundingFunction(ceil)
});
module.exports = Sugar.Number.ceil;

},{"36eae434789c317b":"eWYA2","adf5b171da166ade":"89tTN","f63f14d52542bb30":"apkKF"}],"apkKF":[function(require,module,exports) {
"use strict";
var withPrecision = require("425aca0cdd42ed6");
function createRoundingFunction(fn) {
    return function(n, precision) {
        return precision ? withPrecision(n, precision, fn) : fn(n);
    };
}
module.exports = createRoundingFunction;

},{"425aca0cdd42ed6":"6JCWQ"}],"jpyyW":[function(require,module,exports) {
"use strict";
var Sugar = require("9243660c676c6dd2"), chr = require("be81981b0dd2ea9a");
Sugar.Number.defineInstance({
    "chr": function(n) {
        return chr(n);
    }
});
module.exports = Sugar.Number.chr;

},{"9243660c676c6dd2":"eWYA2","be81981b0dd2ea9a":"fFtOs"}],"1Spd4":[function(require,module,exports) {
"use strict";
var Sugar = require("2787d46d350d091d");
require("8c7581565115d3a0");
module.exports = Sugar.Number.cos;

},{"2787d46d350d091d":"eWYA2","8c7581565115d3a0":"lVYqJ"}],"5zTIU":[function(require,module,exports) {
"use strict";
var Sugar = require("fa9bcadaf082dd5f");
require("99e5c084f633af06");
module.exports = Sugar.Number.exp;

},{"fa9bcadaf082dd5f":"eWYA2","99e5c084f633af06":"lVYqJ"}],"7eCWC":[function(require,module,exports) {
"use strict";
var Sugar = require("3253120205e15284"), mathAliases = require("1ab6f09be5694bc0"), createRoundingFunction = require("585263bddebff829");
var floor = mathAliases.floor;
Sugar.Number.defineInstance({
    "floor": createRoundingFunction(floor)
});
module.exports = Sugar.Number.floor;

},{"3253120205e15284":"eWYA2","1ab6f09be5694bc0":"89tTN","585263bddebff829":"apkKF"}],"kWebG":[function(require,module,exports) {
"use strict";
var Sugar = require("c79cddaee1b90117"), numberFormat = require("ab65e8ca536568a5");
Sugar.Number.defineInstance({
    "format": function(n, place) {
        return numberFormat(n, place);
    }
});
module.exports = Sugar.Number.format;

},{"c79cddaee1b90117":"eWYA2","ab65e8ca536568a5":"6v3fR"}],"bXRKA":[function(require,module,exports) {
"use strict";
var Sugar = require("8169defd0105cf70"), padNumber = require("4cb8d6d98a81c0ac");
Sugar.Number.defineInstance({
    "hex": function(n, pad) {
        return padNumber(n, pad || 1, false, 16);
    }
});
module.exports = Sugar.Number.hex;

},{"8169defd0105cf70":"eWYA2","4cb8d6d98a81c0ac":"6THs5"}],"6THs5":[function(require,module,exports) {
"use strict";
var mathAliases = require("3d632037e3279612"), repeatString = require("76c980c95c7e4db9");
var abs = mathAliases.abs;
function padNumber(num, place, sign, base, replacement) {
    var str = abs(num).toString(base || 10);
    str = repeatString(replacement || "0", place - str.replace(/\.\d+/, "").length) + str;
    if (sign || num < 0) str = (num < 0 ? "-" : "+") + str;
    return str;
}
module.exports = padNumber;

},{"3d632037e3279612":"89tTN","76c980c95c7e4db9":"2Rx0m"}],"izcgn":[function(require,module,exports) {
"use strict";
var Sugar = require("17c1f035f012a36"), isMultipleOf = require("161785c8aa71fe99");
Sugar.Number.defineInstance({
    "isEven": function(n) {
        return isMultipleOf(n, 2);
    }
});
module.exports = Sugar.Number.isEven;

},{"17c1f035f012a36":"eWYA2","161785c8aa71fe99":"lQo4g"}],"lQo4g":[function(require,module,exports) {
"use strict";
function isMultipleOf(n1, n2) {
    return n1 % n2 === 0;
}
module.exports = isMultipleOf;

},{}],"lMO3R":[function(require,module,exports) {
"use strict";
var Sugar = require("6c835076b42092b5"), isInteger = require("56a7633973c1671d");
Sugar.Number.defineInstance({
    "isInteger": function(n) {
        return isInteger(n);
    }
});
module.exports = Sugar.Number.isInteger;

},{"6c835076b42092b5":"eWYA2","56a7633973c1671d":"2e8d5"}],"2e8d5":[function(require,module,exports) {
"use strict";
function isInteger(n) {
    return n % 1 === 0;
}
module.exports = isInteger;

},{}],"cdWNw":[function(require,module,exports) {
"use strict";
var Sugar = require("20653c4465c56fe6"), isMultipleOf = require("a50e1ce1a085c652");
Sugar.Number.defineInstance({
    "isMultipleOf": function(n, num) {
        return isMultipleOf(n, num);
    }
});
module.exports = Sugar.Number.isMultipleOf;

},{"20653c4465c56fe6":"eWYA2","a50e1ce1a085c652":"lQo4g"}],"hIHFF":[function(require,module,exports) {
"use strict";
var Sugar = require("d4acc602b4d8a841"), isInteger = require("34c968d8d2ed9d71"), isMultipleOf = require("ff8c86e10325a99f");
Sugar.Number.defineInstance({
    "isOdd": function(n) {
        return isInteger(n) && !isMultipleOf(n, 2);
    }
});
module.exports = Sugar.Number.isOdd;

},{"d4acc602b4d8a841":"eWYA2","34c968d8d2ed9d71":"2e8d5","ff8c86e10325a99f":"lQo4g"}],"8oxsz":[function(require,module,exports) {
"use strict";
var Sugar = require("d1fb7360f83c2eaf");
Sugar.Number.defineInstance({
    "log": function(n, base) {
        return Math.log(n) / (base ? Math.log(base) : 1);
    }
});
module.exports = Sugar.Number.log;

},{"d1fb7360f83c2eaf":"eWYA2"}],"iZKRt":[function(require,module,exports) {
"use strict";
var Sugar = require("e7a70636f2343dd3"), AbbreviationUnits = require("1d9e043df72d19e1"), abbreviateNumber = require("817feb39ee40d733");
var METRIC_UNITS_SHORT = AbbreviationUnits.METRIC_UNITS_SHORT, METRIC_UNITS_FULL = AbbreviationUnits.METRIC_UNITS_FULL;
Sugar.Number.defineInstance({
    "metric": function(n, precision, units) {
        if (units === "all") units = METRIC_UNITS_FULL;
        else if (!units) units = METRIC_UNITS_SHORT;
        return abbreviateNumber(n, precision, units);
    }
});
module.exports = Sugar.Number.metric;

},{"e7a70636f2343dd3":"eWYA2","1d9e043df72d19e1":"eFZaZ","817feb39ee40d733":"jMfrT"}],"5hgOs":[function(require,module,exports) {
"use strict";
var Sugar = require("d9d52034fa6b82d5"), mathAliases = require("90677dbf8c454753"), getOrdinalSuffix = require("44c802291c69df93");
var abs = mathAliases.abs;
Sugar.Number.defineInstance({
    "ordinalize": function(n) {
        var num = abs(n), last = +num.toString().slice(-2);
        return n + getOrdinalSuffix(last);
    }
});
module.exports = Sugar.Number.ordinalize;

},{"d9d52034fa6b82d5":"eWYA2","90677dbf8c454753":"89tTN","44c802291c69df93":"4F9Cp"}],"4F9Cp":[function(require,module,exports) {
"use strict";
function getOrdinalSuffix(num) {
    if (num >= 11 && num <= 13) return "th";
    else switch(num % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}
module.exports = getOrdinalSuffix;

},{}],"fUcPq":[function(require,module,exports) {
"use strict";
var Sugar = require("951c09a212b3ded8"), padNumber = require("8ec014ca48ec20e1");
Sugar.Number.defineInstance({
    "pad": function(n, place, sign, base) {
        return padNumber(n, place, sign, base);
    }
});
module.exports = Sugar.Number.pad;

},{"951c09a212b3ded8":"eWYA2","8ec014ca48ec20e1":"6THs5"}],"il8UD":[function(require,module,exports) {
"use strict";
var Sugar = require("784062de993195f0");
require("62d159a13fd2513d");
module.exports = Sugar.Number.pow;

},{"784062de993195f0":"eWYA2","62d159a13fd2513d":"lVYqJ"}],"8FIrP":[function(require,module,exports) {
"use strict";
var Sugar = require("51f8009a73d98fa"), mathAliases = require("693af462535c7fda"), createRoundingFunction = require("8bd0576fe64f2ba3");
var round = mathAliases.round;
Sugar.Number.defineInstance({
    "round": createRoundingFunction(round)
});
module.exports = Sugar.Number.round;

},{"51f8009a73d98fa":"eWYA2","693af462535c7fda":"89tTN","8bd0576fe64f2ba3":"apkKF"}],"9N8Zm":[function(require,module,exports) {
"use strict";
var Sugar = require("cda0b5b76650fa40");
require("7a0d71919f61bb4");
module.exports = Sugar.Number.sin;

},{"cda0b5b76650fa40":"eWYA2","7a0d71919f61bb4":"lVYqJ"}],"fguSq":[function(require,module,exports) {
"use strict";
var Sugar = require("ec73d71f0e6bdeb0");
require("cc80ae68f49c5586");
module.exports = Sugar.Number.sqrt;

},{"ec73d71f0e6bdeb0":"eWYA2","cc80ae68f49c5586":"lVYqJ"}],"g9M5X":[function(require,module,exports) {
"use strict";
var Sugar = require("ffae23f067242004");
require("f920f2960ce4e03f");
module.exports = Sugar.Number.tan;

},{"ffae23f067242004":"eWYA2","f920f2960ce4e03f":"lVYqJ"}],"dELad":[function(require,module,exports) {
"use strict";
var Sugar = require("1e68f3bc84416dc6"), isDefined = require("52d0161d0e0271cb");
Sugar.Number.defineInstance({
    "times": function(n, indexMapFn) {
        var arr, result;
        for(var i = 0; i < n; i++){
            result = indexMapFn.call(n, i);
            if (isDefined(result)) {
                if (!arr) arr = [];
                arr.push(result);
            }
        }
        return arr;
    }
});
module.exports = Sugar.Number.times;

},{"1e68f3bc84416dc6":"eWYA2","52d0161d0e0271cb":"6Ge6e"}],"9Qmt5":[function(require,module,exports) {
"use strict";
var Sugar = require("11dc6a0c54de30c6");
Sugar.Number.defineInstance({
    "toNumber": function(n) {
        return n.valueOf();
    }
});
module.exports = Sugar.Number.toNumber;

},{"11dc6a0c54de30c6":"eWYA2"}],"cO8yU":[function(require,module,exports) {
"use strict";
var Sugar = require("4ae749ae3d70c795"), _numberOptions = require("1d98a291dfc882ac");
module.exports = Sugar.Number.getOption;

},{"4ae749ae3d70c795":"eWYA2","1d98a291dfc882ac":"egUvr"}],"d4KpK":[function(require,module,exports) {
"use strict";
var Sugar = require("a23324d8e03c135"), _numberOptions = require("23ca295c0c641e8a");
module.exports = Sugar.Number.setOption;

},{"a23324d8e03c135":"eWYA2","23ca295c0c641e8a":"egUvr"}],"3IsL1":[function(require,module,exports) {
"use strict";
// Static Methods
require("8fe643022fb8ea82");
require("60f4bedc8fba29fc");
// Instance Methods
require("d5e29e4d066d158f");
require("470a777bdd12b334");
require("d39817550c619f50");
require("aa47d3dc2d511939");
require("69557abfb46b631");
require("e4684339c8d9bdd7");
require("8ad93a17bc93f9ac");
require("1f38e02af0d77b5");
require("8c3145b9c022a4b9");
require("8870aef181987487");
require("2c1a468ddbc760c");
require("3a9afb86e6b61094");
require("6207dc558e49d2c9");
require("6dda906da4885595");
require("815912170c412978");
require("a15712270a23c587");
require("2ae3252bf2ff800a");
require("888de2d40e9add24");
require("e409a10530bfe90e");
require("544f3f57331a8fb6");
require("e84b511d04692fd5");
require("70a738a714ae64ff");
require("f4b0bdfd99fe0bf2");
require("a3cd7fa12166ec01");
require("a6b43efcaa401b43");
require("f8a7ed0074a0ea94");
// Aliases
require("be215d022192809c");
// Accessors
require("263533bfbca0f05f");
require("66453bcd6c265276");
module.exports = require("f0bdea80bf84ad90");

},{"8fe643022fb8ea82":"2lhP9","60f4bedc8fba29fc":"GLNIX","d5e29e4d066d158f":"67lx7","470a777bdd12b334":"8G7FT","d39817550c619f50":"fq5N2","aa47d3dc2d511939":"1PitT","69557abfb46b631":"9jWLk","e4684339c8d9bdd7":"3TeiC","8ad93a17bc93f9ac":"jSP5M","1f38e02af0d77b5":"hWqgO","8c3145b9c022a4b9":"9qt7Y","8870aef181987487":"5YeWP","2c1a468ddbc760c":"6Q22t","3a9afb86e6b61094":"1YaRM","6207dc558e49d2c9":"5fWHA","6dda906da4885595":"33kiT","815912170c412978":"iNhFF","a15712270a23c587":"2Cpoe","2ae3252bf2ff800a":"iEAsl","888de2d40e9add24":"1UoAh","e409a10530bfe90e":"2bqxG","544f3f57331a8fb6":"9NPzI","e84b511d04692fd5":"2qmFt","70a738a714ae64ff":"h5D36","f4b0bdfd99fe0bf2":"f3P2u","a3cd7fa12166ec01":"Ke0wL","a6b43efcaa401b43":"45OFm","f8a7ed0074a0ea94":"gJaay","be215d022192809c":"6LBFH","263533bfbca0f05f":"4K2vV","66453bcd6c265276":"l3jx5","f0bdea80bf84ad90":"eWYA2"}],"2lhP9":[function(require,module,exports) {
"use strict";
var Sugar = require("e7b576ce44826c0d"), coercePositiveInteger = require("295c0c3e37d5d7d1");
Sugar.Array.defineStatic({
    "construct": function(n, indexMapFn) {
        n = coercePositiveInteger(n);
        return Array.from(new Array(n), function(el, i) {
            return indexMapFn && indexMapFn(i);
        });
    }
});
module.exports = Sugar.Array.construct;

},{"e7b576ce44826c0d":"eWYA2","295c0c3e37d5d7d1":"5NU91"}],"GLNIX":[function(require,module,exports) {
"use strict";
var Sugar = require("dbdb4ecd16db1574"), arrayCreate = require("3d551f3def1ee000");
require("877b546fa46a5496");
Sugar.Array.defineStatic({
    "create": function(obj, clone) {
        return arrayCreate(obj, clone);
    }
});
module.exports = Sugar.Array.create;

},{"dbdb4ecd16db1574":"eWYA2","3d551f3def1ee000":"5PQIT","877b546fa46a5496":"cPQvd"}],"5PQIT":[function(require,module,exports) {
"use strict";
var isDefined = require("d795aeb1b67430e2"), arrayClone = require("b1c519aa6de918b3"), classChecks = require("9b91fb2e14a93bb0"), isObjectType = require("ecbdc754a77a1be0"), isArrayOrInherited = require("2b11f9276ad1b2b8");
var isString = classChecks.isString;
function arrayCreate(obj, clone) {
    var arr;
    if (isArrayOrInherited(obj)) arr = clone ? arrayClone(obj) : obj;
    else if (isObjectType(obj) || isString(obj)) arr = Array.from(obj);
    else if (isDefined(obj)) arr = [
        obj
    ];
    return arr || [];
}
module.exports = arrayCreate;

},{"d795aeb1b67430e2":"6Ge6e","b1c519aa6de918b3":"3sj18","9b91fb2e14a93bb0":"lUOLF","ecbdc754a77a1be0":"l3TUh","2b11f9276ad1b2b8":"kvuqR"}],"3sj18":[function(require,module,exports) {
"use strict";
var forEach = require("f5337ced0fa793d6");
function arrayClone(arr) {
    var clone = new Array(arr.length);
    forEach(arr, function(el, i) {
        clone[i] = el;
    });
    return clone;
}
module.exports = arrayClone;

},{"f5337ced0fa793d6":"1n2CK"}],"kvuqR":[function(require,module,exports) {
"use strict";
var classChecks = require("ded88fc1bd913856");
var isArray = classChecks.isArray;
function isArrayOrInherited(obj) {
    return obj && obj.constructor && isArray(obj.constructor.prototype);
}
module.exports = isArrayOrInherited;

},{"ded88fc1bd913856":"lUOLF"}],"cPQvd":[function(require,module,exports) {
"use strict";
var setArrayChainableConstructor = require("a396d776ccb381e3");
setArrayChainableConstructor();

},{"a396d776ccb381e3":"2HN3l"}],"2HN3l":[function(require,module,exports) {
"use strict";
var arrayCreate = require("6e3b05062ea07a1c"), namespaceAliases = require("43efa22d3cae1015"), setChainableConstructor = require("516670fcdb75f312");
var sugarArray = namespaceAliases.sugarArray;
function setArrayChainableConstructor() {
    setChainableConstructor(sugarArray, arrayCreate);
}
module.exports = setArrayChainableConstructor;

},{"6e3b05062ea07a1c":"5PQIT","43efa22d3cae1015":"1TEpR","516670fcdb75f312":"e8Ncr"}],"e8Ncr":[function(require,module,exports) {
"use strict";
function setChainableConstructor(sugarNamespace, createFn) {
    sugarNamespace.prototype.constructor = function() {
        return createFn.apply(this, arguments);
    };
}
module.exports = setChainableConstructor;

},{}],"67lx7":[function(require,module,exports) {
"use strict";
var Sugar = require("404b42c4d717e252"), arrayClone = require("46d97f33c9bac020"), arrayAppend = require("170012be21a7f135");
Sugar.Array.defineInstance({
    "add": function(arr, item, index) {
        return arrayAppend(arrayClone(arr), item, index);
    }
});
module.exports = Sugar.Array.add;

},{"404b42c4d717e252":"eWYA2","46d97f33c9bac020":"3sj18","170012be21a7f135":"8V97P"}],"8V97P":[function(require,module,exports) {
"use strict";
var isDefined = require("107cc0bde646d340");
function arrayAppend(arr, el, index) {
    var spliceArgs;
    index = +index;
    if (isNaN(index)) index = arr.length;
    spliceArgs = [
        index,
        0
    ];
    if (isDefined(el)) spliceArgs = spliceArgs.concat(el);
    arr.splice.apply(arr, spliceArgs);
    return arr;
}
module.exports = arrayAppend;

},{"107cc0bde646d340":"6Ge6e"}],"8G7FT":[function(require,module,exports) {
"use strict";
var Sugar = require("f5d5be922b45ba2e"), arrayAppend = require("dcaa52460b7c524");
Sugar.Array.defineInstance({
    "append": function(arr, item, index) {
        return arrayAppend(arr, item, index);
    }
});
module.exports = Sugar.Array.append;

},{"f5d5be922b45ba2e":"eWYA2","dcaa52460b7c524":"8V97P"}],"fq5N2":[function(require,module,exports) {
"use strict";
var Sugar = require("71ce0e5cfc3ca29"), getEntriesForIndexes = require("e67f86eb8bd5c6e0");
Sugar.Array.defineInstance({
    "at": function(arr, index, loop) {
        return getEntriesForIndexes(arr, index, loop);
    }
});
module.exports = Sugar.Array.at;

},{"71ce0e5cfc3ca29":"eWYA2","e67f86eb8bd5c6e0":"1apCQ"}],"1PitT":[function(require,module,exports) {
"use strict";
var Sugar = require("52ac611a97e86fc5"), arrayClone = require("96187ee8b5f0d31e");
Sugar.Array.defineInstance({
    "clone": function(arr) {
        return arrayClone(arr);
    }
});
module.exports = Sugar.Array.clone;

},{"52ac611a97e86fc5":"eWYA2","96187ee8b5f0d31e":"3sj18"}],"9jWLk":[function(require,module,exports) {
"use strict";
var Sugar = require("ffe06b48fbad8337"), arrayCompact = require("f0a81eb363b7416f");
Sugar.Array.defineInstance({
    "compact": function(arr, all) {
        return arrayCompact(arr, all);
    }
});
module.exports = Sugar.Array.compact;

},{"ffe06b48fbad8337":"eWYA2","f0a81eb363b7416f":"jPRg7"}],"jPRg7":[function(require,module,exports) {
"use strict";
var filter = require("e7d2d862c9faa282");
function arrayCompact(arr, all) {
    return filter(arr, function(el) {
        return el || !all && el != null && el.valueOf() === el.valueOf();
    });
}
module.exports = arrayCompact;

},{"e7d2d862c9faa282":"3TIFw"}],"3TeiC":[function(require,module,exports) {
"use strict";
var Sugar = require("81c06aafa236d13"), arrayExclude = require("d37cf671448f662");
Sugar.Array.defineInstance({
    "exclude": function(arr, f) {
        return arrayExclude(arr, f);
    }
});
module.exports = Sugar.Array.exclude;

},{"81c06aafa236d13":"eWYA2","d37cf671448f662":"bRGk5"}],"bRGk5":[function(require,module,exports) {
"use strict";
var getMatcher = require("1d3deb69fc45080d");
function arrayExclude(arr, f) {
    var result = [], matcher = getMatcher(f);
    for(var i = 0; i < arr.length; i++)if (!matcher(arr[i], i, arr)) result.push(arr[i]);
    return result;
}
module.exports = arrayExclude;

},{"1d3deb69fc45080d":"3InyL"}],"3InyL":[function(require,module,exports) {
"use strict";
var isPrimitive = require("21d0fd703e833035"), classChecks = require("b2654e682a671451"), dateMatcher = require("1e5b4b62f8c55789"), regexMatcher = require("6b8a8cbdb36c41f6"), isObjectType = require("582b0664dc83b322"), isPlainObject = require("5791c34d8446dea8"), defaultMatcher = require("e5b942440d334c57"), functionMatcher = require("a489aa3343d51ef8"), coreUtilityAliases = require("899c58b4b892d423");
var getOwn = coreUtilityAliases.getOwn, classToString = coreUtilityAliases.classToString, forEachProperty = coreUtilityAliases.forEachProperty, isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction;
function getMatcher(f) {
    if (!isPrimitive(f)) {
        var className = classToString(f);
        if (isRegExp(f, className)) return regexMatcher(f);
        else if (isDate(f, className)) return dateMatcher(f);
        else if (isFunction(f, className)) return functionMatcher(f);
        else if (isPlainObject(f, className)) return fuzzyMatcher(f);
    }
    // Default is standard isEqual
    return defaultMatcher(f);
}
function fuzzyMatcher(obj) {
    var matchers = {};
    return function(el, i, arr) {
        var matched = true;
        if (!isObjectType(el)) return false;
        forEachProperty(obj, function(val, key) {
            matchers[key] = getOwn(matchers, key) || getMatcher(val);
            if (matchers[key].call(arr, el[key], i, arr) === false) matched = false;
            return matched;
        });
        return matched;
    };
}
module.exports = getMatcher;

},{"21d0fd703e833035":"jzeAF","b2654e682a671451":"lUOLF","1e5b4b62f8c55789":"gca7I","6b8a8cbdb36c41f6":"juVL7","582b0664dc83b322":"l3TUh","5791c34d8446dea8":"byAbX","e5b942440d334c57":"4maht","a489aa3343d51ef8":"2VrXo","899c58b4b892d423":"dU8Nu"}],"gca7I":[function(require,module,exports) {
"use strict";
function dateMatcher(d) {
    var ms = d.getTime();
    return function(el) {
        return !!(el && el.getTime) && el.getTime() === ms;
    };
}
module.exports = dateMatcher;

},{}],"juVL7":[function(require,module,exports) {
"use strict";
function regexMatcher(reg) {
    reg = RegExp(reg);
    return function(el) {
        return reg.test(el);
    };
}
module.exports = regexMatcher;

},{}],"4maht":[function(require,module,exports) {
"use strict";
var isEqual = require("8301e26919940e92");
function defaultMatcher(f) {
    return function(el) {
        return isEqual(el, f);
    };
}
module.exports = defaultMatcher;

},{"8301e26919940e92":"jiWWj"}],"jiWWj":[function(require,module,exports) {
"use strict";
var getKeys = require("9eb647b47c515810"), setToArray = require("184d1b9ebf69fdfe"), mapToArray = require("b1f241e370f7b88a"), classChecks = require("eed5adfa9df01b29"), isObjectType = require("f114784279218344"), coreUtilityAliases = require("244b0b1bb60d5cc5"), iterateWithCyclicCheck = require("29923dd532fffa30");
var classToString = coreUtilityAliases.classToString, isSerializable = classChecks.isSerializable, isSet = classChecks.isSet, isMap = classChecks.isMap, isError = classChecks.isError;
function isEqual(a, b, stack) {
    var aClass, bClass;
    if (a === b) // Return quickly up front when matched by reference,
    // but be careful about 0 !== -0.
    return a !== 0 || 1 / a === 1 / b;
    aClass = classToString(a);
    bClass = classToString(b);
    if (aClass !== bClass) return false;
    if (isSerializable(a, aClass) && isSerializable(b, bClass)) return objectIsEqual(a, b, aClass, stack);
    else if (isSet(a, aClass) && isSet(b, bClass)) return a.size === b.size && isEqual(setToArray(a), setToArray(b), stack);
    else if (isMap(a, aClass) && isMap(b, bClass)) return a.size === b.size && isEqual(mapToArray(a), mapToArray(b), stack);
    else if (isError(a, aClass) && isError(b, bClass)) return a.toString() === b.toString();
    return false;
}
function objectIsEqual(a, b, aClass, stack) {
    var aType = typeof a, bType = typeof b, propsEqual, count;
    if (aType !== bType) return false;
    if (isObjectType(a.valueOf())) {
        if (a.length !== b.length) // perf: Quickly returning up front for arrays.
        return false;
        count = 0;
        propsEqual = true;
        iterateWithCyclicCheck(a, false, stack, function(key, val, cyc, stack) {
            if (!cyc && (!(key in b) || !isEqual(val, b[key], stack))) propsEqual = false;
            count++;
            return propsEqual;
        });
        if (!propsEqual || count !== getKeys(b).length) return false;
    }
    // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
    return a.valueOf().toString() === b.valueOf().toString();
}
module.exports = isEqual;

},{"9eb647b47c515810":"6cOTr","184d1b9ebf69fdfe":"3NbZW","b1f241e370f7b88a":"a9HOx","eed5adfa9df01b29":"lUOLF","f114784279218344":"l3TUh","244b0b1bb60d5cc5":"dU8Nu","29923dd532fffa30":"gr68M"}],"6cOTr":[function(require,module,exports) {
"use strict";
function getKeys(obj) {
    return Object.keys(obj);
}
module.exports = getKeys;

},{}],"3NbZW":[function(require,module,exports) {
"use strict";
function setToArray(set) {
    var arr = new Array(set.size), i = 0;
    set.forEach(function(val) {
        arr[i++] = val;
    });
    return arr;
}
module.exports = setToArray;

},{}],"a9HOx":[function(require,module,exports) {
"use strict";
function mapToArray(map) {
    var arr = new Array(map.size), i = 0;
    map.forEach(function(val, key) {
        arr[i++] = [
            key,
            val
        ];
    });
    return arr;
}
module.exports = mapToArray;

},{}],"gr68M":[function(require,module,exports) {
"use strict";
var getKeys = require("fd147feb2323c5b9"), coreUtilityAliases = require("6f980ee90124d552");
var forEachProperty = coreUtilityAliases.forEachProperty;
function iterateWithCyclicCheck(obj, sortedKeys, stack, fn) {
    function next(val, key) {
        var cyc = false;
        // Allowing a step into the structure before triggering this check to save
        // cycles on standard JSON structures and also to try as hard as possible to
        // catch basic properties that may have been modified.
        if (stack.length > 1) {
            var i = stack.length;
            while(i--)if (stack[i] === val) cyc = true;
        }
        stack.push(val);
        fn(key, val, cyc, stack);
        stack.pop();
    }
    function iterateWithSortedKeys() {
        // Sorted keys is required for serialization, where object order
        // does not matter but stringified order does.
        var arr = getKeys(obj).sort(), key;
        for(var i = 0; i < arr.length; i++){
            key = arr[i];
            next(obj[key], arr[i]);
        }
    }
    // This method for checking for cyclic structures was egregiously stolen from
    // the ingenious method by @kitcambridge from the Underscore script:
    // https://github.com/documentcloud/underscore/issues/240
    if (!stack) stack = [];
    if (sortedKeys) iterateWithSortedKeys();
    else forEachProperty(obj, next);
}
module.exports = iterateWithCyclicCheck;

},{"fd147feb2323c5b9":"6cOTr","6f980ee90124d552":"dU8Nu"}],"2VrXo":[function(require,module,exports) {
"use strict";
function functionMatcher(fn) {
    return function(el, i, arr) {
        // Return true up front if match by reference
        return el === fn || fn.call(arr, el, i, arr);
    };
}
module.exports = functionMatcher;

},{}],"jSP5M":[function(require,module,exports) {
"use strict";
var Sugar = require("59594af938326d16"), isUndefined = require("5c753143a3f46f10");
Sugar.Array.defineInstance({
    "first": function(arr, num) {
        if (isUndefined(num)) return arr[0];
        if (num < 0) num = 0;
        return arr.slice(0, num);
    }
});
module.exports = Sugar.Array.first;

},{"59594af938326d16":"eWYA2","5c753143a3f46f10":"hnApm"}],"hWqgO":[function(require,module,exports) {
"use strict";
var Sugar = require("a3791234fe4e4530"), arrayFlatten = require("f9a0a7bebc971431");
Sugar.Array.defineInstance({
    "flatten": function(arr, limit) {
        return arrayFlatten(arr, limit);
    }
});
module.exports = Sugar.Array.flatten;

},{"a3791234fe4e4530":"eWYA2","f9a0a7bebc971431":"d0jko"}],"d0jko":[function(require,module,exports) {
"use strict";
var forEach = require("d340675582a5862b"), classChecks = require("9226f7f04c267b17");
var isArray = classChecks.isArray;
function arrayFlatten(arr, level, current) {
    var result = [];
    level = level || Infinity;
    current = current || 0;
    forEach(arr, function(el) {
        if (isArray(el) && current < level) result = result.concat(arrayFlatten(el, level, current + 1));
        else result.push(el);
    });
    return result;
}
module.exports = arrayFlatten;

},{"d340675582a5862b":"1n2CK","9226f7f04c267b17":"lUOLF"}],"9qt7Y":[function(require,module,exports) {
"use strict";
var Sugar = require("ec78712cce30720f");
Sugar.Array.defineInstance({
    "from": function(arr, num) {
        return arr.slice(num);
    }
});
module.exports = Sugar.Array.from;

},{"ec78712cce30720f":"eWYA2"}],"5YeWP":[function(require,module,exports) {
"use strict";
var Sugar = require("ec1584c40172b6f7"), arrayGroupBy = require("db9f87341d1118f0");
Sugar.Array.defineInstance({
    "groupBy": function(arr, map, groupFn) {
        return arrayGroupBy(arr, map, groupFn);
    }
});
module.exports = Sugar.Array.groupBy;

},{"ec1584c40172b6f7":"eWYA2","db9f87341d1118f0":"8BdZh"}],"8BdZh":[function(require,module,exports) {
"use strict";
var forEach = require("3696c723303349b6"), mapWithShortcuts = require("b6883c4adc281929"), coreUtilityAliases = require("d6bb1f20d19d1615");
var hasOwn = coreUtilityAliases.hasOwn, forEachProperty = coreUtilityAliases.forEachProperty;
function arrayGroupBy(arr, map, fn) {
    var result = {}, key;
    forEach(arr, function(el, i) {
        key = mapWithShortcuts(el, map, arr, [
            el,
            i,
            arr
        ]);
        if (!hasOwn(result, key)) result[key] = [];
        result[key].push(el);
    });
    if (fn) forEachProperty(result, fn);
    return result;
}
module.exports = arrayGroupBy;

},{"3696c723303349b6":"1n2CK","b6883c4adc281929":"laRDC","d6bb1f20d19d1615":"dU8Nu"}],"laRDC":[function(require,module,exports) {
"use strict";
var map = require("79f3c2aafe7f4f15"), classChecks = require("8b039b10dc43e87f"), deepGetProperty = require("b506590406c9eab4");
var isFunction = classChecks.isFunction, isArray = classChecks.isArray;
function mapWithShortcuts(el, f, context, mapArgs) {
    if (!f) return el;
    else if (f.apply) return f.apply(context, mapArgs);
    else if (isArray(f)) return map(f, function(m) {
        return mapWithShortcuts(el, m, context, mapArgs);
    });
    else if (isFunction(el[f])) return el[f].call(el);
    else return deepGetProperty(el, f, true);
}
module.exports = mapWithShortcuts;

},{"79f3c2aafe7f4f15":"b19ZA","8b039b10dc43e87f":"lUOLF","b506590406c9eab4":"fxfTs"}],"6Q22t":[function(require,module,exports) {
"use strict";
var Sugar = require("f363a1247956d698"), isDefined = require("26af792085c9da76"), mathAliases = require("2b964a0c1077d590"), simpleRepeat = require("289c52b6527f928");
var ceil = mathAliases.ceil;
Sugar.Array.defineInstance({
    "inGroups": function(arr, num, padding) {
        var pad = isDefined(padding);
        var result = new Array(num);
        var divisor = ceil(arr.length / num);
        simpleRepeat(num, function(i) {
            var index = i * divisor;
            var group = arr.slice(index, index + divisor);
            if (pad && group.length < divisor) simpleRepeat(divisor - group.length, function() {
                group.push(padding);
            });
            result[i] = group;
        });
        return result;
    }
});
module.exports = Sugar.Array.inGroups;

},{"f363a1247956d698":"eWYA2","26af792085c9da76":"6Ge6e","2b964a0c1077d590":"89tTN","289c52b6527f928":"4vIGU"}],"4vIGU":[function(require,module,exports) {
"use strict";
function simpleRepeat(n, fn) {
    for(var i = 0; i < n; i++)fn(i);
}
module.exports = simpleRepeat;

},{}],"1YaRM":[function(require,module,exports) {
"use strict";
var Sugar = require("38b1e9e50c19493e"), isUndefined = require("68b95e8e3fe0d3dc"), mathAliases = require("a74de47ed7fd402f"), simpleRepeat = require("d326dde05c86e94d");
var ceil = mathAliases.ceil;
Sugar.Array.defineInstance({
    "inGroupsOf": function(arr, num, padding) {
        var result = [], len = arr.length, group;
        if (len === 0 || num === 0) return arr;
        if (isUndefined(num)) num = 1;
        if (isUndefined(padding)) padding = null;
        simpleRepeat(ceil(len / num), function(i) {
            group = arr.slice(num * i, num * i + num);
            while(group.length < num)group.push(padding);
            result.push(group);
        });
        return result;
    }
});
module.exports = Sugar.Array.inGroupsOf;

},{"38b1e9e50c19493e":"eWYA2","68b95e8e3fe0d3dc":"hnApm","a74de47ed7fd402f":"89tTN","d326dde05c86e94d":"4vIGU"}],"5fWHA":[function(require,module,exports) {
"use strict";
var Sugar = require("3ffcf55c3ac044a8"), arrayIntersectOrSubtract = require("67fe6b441ec02c6d");
Sugar.Array.defineInstance({
    "intersect": function(arr1, arr2) {
        return arrayIntersectOrSubtract(arr1, arr2, false);
    }
});
module.exports = Sugar.Array.intersect;

},{"3ffcf55c3ac044a8":"eWYA2","67fe6b441ec02c6d":"9Qpea"}],"9Qpea":[function(require,module,exports) {
"use strict";
var forEach = require("2141e17f7c1f3afa"), arrayWrap = require("836cedabcb60dbe8"), classChecks = require("db5886f353453432"), serializeInternal = require("b6d8a06f915314a0"), coreUtilityAliases = require("8d1306ffbd092b07");
var isArray = classChecks.isArray, hasOwn = coreUtilityAliases.hasOwn;
function arrayIntersectOrSubtract(arr1, arr2, subtract) {
    var result = [], obj = {}, refs = [];
    if (!isArray(arr2)) arr2 = arrayWrap(arr2);
    forEach(arr2, function(el) {
        obj[serializeInternal(el, refs)] = true;
    });
    forEach(arr1, function(el) {
        var key = serializeInternal(el, refs);
        if (hasOwn(obj, key) !== subtract) {
            delete obj[key];
            result.push(el);
        }
    });
    return result;
}
module.exports = arrayIntersectOrSubtract;

},{"2141e17f7c1f3afa":"1n2CK","836cedabcb60dbe8":"bI6E7","db5886f353453432":"lUOLF","b6d8a06f915314a0":"ffntQ","8d1306ffbd092b07":"dU8Nu"}],"bI6E7":[function(require,module,exports) {
"use strict";
function arrayWrap(obj) {
    var arr = [];
    arr.push(obj);
    return arr;
}
module.exports = arrayWrap;

},{}],"ffntQ":[function(require,module,exports) {
"use strict";
var indexOf = require("7e55fcd935579b26"), isRealNaN = require("3ae09ef6f4ef2910"), isPrimitive = require("fbe816506fac55c7"), classChecks = require("aa5135610dd2eb9"), isObjectType = require("e8a9b0edebce86fc"), coreUtilityAliases = require("74ab3a94650e1a9e"), iterateWithCyclicCheck = require("2d0448c93e251b9d");
var classToString = coreUtilityAliases.classToString, isSerializable = classChecks.isSerializable;
function serializeInternal(obj, refs, stack) {
    var type = typeof obj, sign = "", className, value, ref;
    // Return up front on
    if (1 / obj === -Infinity) sign = "-";
    // Return quickly for primitives to save cycles
    if (isPrimitive(obj, type) && !isRealNaN(obj)) return type + sign + obj;
    className = classToString(obj);
    if (!isSerializable(obj, className)) {
        ref = indexOf(refs, obj);
        if (ref === -1) {
            ref = refs.length;
            refs.push(obj);
        }
        return ref;
    } else if (isObjectType(obj)) value = serializeDeep(obj, refs, stack) + obj.toString();
    else if (obj.valueOf) value = obj.valueOf();
    return type + className + sign + value;
}
function serializeDeep(obj, refs, stack) {
    var result = "";
    iterateWithCyclicCheck(obj, true, stack, function(key, val, cyc, stack) {
        result += cyc ? "CYC" : key + serializeInternal(val, refs, stack);
    });
    return result;
}
module.exports = serializeInternal;

},{"7e55fcd935579b26":"6R6IE","3ae09ef6f4ef2910":"2GpwF","fbe816506fac55c7":"jzeAF","aa5135610dd2eb9":"lUOLF","e8a9b0edebce86fc":"l3TUh","74ab3a94650e1a9e":"dU8Nu","2d0448c93e251b9d":"gr68M"}],"2GpwF":[function(require,module,exports) {
"use strict";
function isRealNaN(obj) {
    // This is only true of NaN
    return obj != null && obj !== obj;
}
module.exports = isRealNaN;

},{}],"33kiT":[function(require,module,exports) {
"use strict";
var Sugar = require("679f76959924520");
Sugar.Array.defineInstance({
    "isEmpty": function(arr) {
        return arr.length === 0;
    }
});
module.exports = Sugar.Array.isEmpty;

},{"679f76959924520":"eWYA2"}],"iNhFF":[function(require,module,exports) {
"use strict";
var Sugar = require("b13c457e28f0d3ac"), isEqual = require("20dcf095f76f8949");
Sugar.Array.defineInstance({
    "isEqual": function(a, b) {
        return isEqual(a, b);
    }
});
module.exports = Sugar.Array.isEqual;

},{"b13c457e28f0d3ac":"eWYA2","20dcf095f76f8949":"jiWWj"}],"2Cpoe":[function(require,module,exports) {
"use strict";
var Sugar = require("9172ad7ce80c3bb6"), isUndefined = require("d9d9b1749e5f378");
Sugar.Array.defineInstance({
    "last": function(arr, num) {
        if (isUndefined(num)) return arr[arr.length - 1];
        var start = arr.length - num < 0 ? 0 : arr.length - num;
        return arr.slice(start);
    }
});
module.exports = Sugar.Array.last;

},{"9172ad7ce80c3bb6":"eWYA2","d9d9b1749e5f378":"hnApm"}],"iEAsl":[function(require,module,exports) {
"use strict";
var Sugar = require("da09283f88a4a2fc"), arrayRemove = require("38c3ec676f1cc15");
Sugar.Array.defineInstance({
    "remove": function(arr, f) {
        return arrayRemove(arr, f);
    }
});
module.exports = Sugar.Array.remove;

},{"da09283f88a4a2fc":"eWYA2","38c3ec676f1cc15":"626er"}],"626er":[function(require,module,exports) {
"use strict";
var getMatcher = require("5e7e1a9731a91ec8");
function arrayRemove(arr, f) {
    var matcher = getMatcher(f), i = 0;
    while(i < arr.length)if (matcher(arr[i], i, arr)) arr.splice(i, 1);
    else i++;
    return arr;
}
module.exports = arrayRemove;

},{"5e7e1a9731a91ec8":"3InyL"}],"1UoAh":[function(require,module,exports) {
"use strict";
var Sugar = require("155d23776c0660f1"), isUndefined = require("c24a34b5f4c2eb4b");
Sugar.Array.defineInstance({
    "removeAt": function(arr, start, end) {
        if (isUndefined(start)) return arr;
        if (isUndefined(end)) end = start;
        arr.splice(start, end - start + 1);
        return arr;
    }
});
module.exports = Sugar.Array.removeAt;

},{"155d23776c0660f1":"eWYA2","c24a34b5f4c2eb4b":"hnApm"}],"2bqxG":[function(require,module,exports) {
"use strict";
var Sugar = require("828394f653bf946b"), trunc = require("bafad6e31b63447c"), arrayClone = require("342a44b855c6c4a9"), classChecks = require("f02a9ed3ddb7e0d6"), isUndefined = require("c9463b961f926149"), mathAliases = require("51acb3680ff1c669");
var isBoolean = classChecks.isBoolean, min = mathAliases.min;
Sugar.Array.defineInstance({
    "sample": function(arr, arg1, arg2) {
        var result = [], num, remove, single;
        if (isBoolean(arg1)) remove = arg1;
        else {
            num = arg1;
            remove = arg2;
        }
        if (isUndefined(num)) {
            num = 1;
            single = true;
        }
        if (!remove) arr = arrayClone(arr);
        num = min(num, arr.length);
        for(var i = 0, index; i < num; i++){
            index = trunc(Math.random() * arr.length);
            result.push(arr[index]);
            arr.splice(index, 1);
        }
        return single ? result[0] : result;
    }
});
module.exports = Sugar.Array.sample;

},{"828394f653bf946b":"eWYA2","bafad6e31b63447c":"ePaYC","342a44b855c6c4a9":"3sj18","f02a9ed3ddb7e0d6":"lUOLF","c9463b961f926149":"hnApm","51acb3680ff1c669":"89tTN"}],"9NPzI":[function(require,module,exports) {
"use strict";
var Sugar = require("83b236e21ce91829"), arrayShuffle = require("14c7e2e797efa65d");
Sugar.Array.defineInstance({
    "shuffle": function(arr) {
        return arrayShuffle(arr);
    }
});
module.exports = Sugar.Array.shuffle;

},{"83b236e21ce91829":"eWYA2","14c7e2e797efa65d":"94ObW"}],"94ObW":[function(require,module,exports) {
"use strict";
var arrayClone = require("9097674b33c52dbe");
function arrayShuffle(arr) {
    arr = arrayClone(arr);
    var i = arr.length, j, x;
    while(i){
        j = Math.random() * i | 0;
        x = arr[--i];
        arr[i] = arr[j];
        arr[j] = x;
    }
    return arr;
}
module.exports = arrayShuffle;

},{"9097674b33c52dbe":"3sj18"}],"2qmFt":[function(require,module,exports) {
"use strict";
var Sugar = require("74a73d6735403634"), compareValue = require("895c69cd5e831e9b"), mapWithShortcuts = require("ac09ab3e58d71ca8");
Sugar.Array.defineInstance({
    "sortBy": function(arr, map, desc) {
        arr.sort(function(a, b) {
            var aProperty = mapWithShortcuts(a, map, arr, [
                a
            ]);
            var bProperty = mapWithShortcuts(b, map, arr, [
                b
            ]);
            return compareValue(aProperty, bProperty) * (desc ? -1 : 1);
        });
        return arr;
    }
});
module.exports = Sugar.Array.sortBy;

},{"74a73d6735403634":"eWYA2","895c69cd5e831e9b":"iXL2X","ac09ab3e58d71ca8":"laRDC"}],"iXL2X":[function(require,module,exports) {
"use strict";
var ARRAY_OPTIONS = require("260a79e763e3abc2"), classChecks = require("705dbb6374061f36");
var isString = classChecks.isString, isArray = classChecks.isArray, _arrayOptions = ARRAY_OPTIONS._arrayOptions;
function compareValue(aVal, bVal) {
    var cmp, i, collate;
    if (isString(aVal) && isString(bVal)) {
        collate = _arrayOptions("sortCollate");
        return collate(aVal, bVal);
    } else if (isArray(aVal) && isArray(bVal)) {
        if (aVal.length < bVal.length) return -1;
        else if (aVal.length > bVal.length) return 1;
        else {
            for(i = 0; i < aVal.length; i++){
                cmp = compareValue(aVal[i], bVal[i]);
                if (cmp !== 0) return cmp;
            }
            return 0;
        }
    }
    return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
}
module.exports = compareValue;

},{"260a79e763e3abc2":"i3Lyv","705dbb6374061f36":"lUOLF"}],"i3Lyv":[function(require,module,exports) {
"use strict";
var getSortOrder = require("ea9afea5aa2b3a6"), codeIsNumeral = require("b2d57e21429b4097"), stringToNumber = require("da1708fecda278dc"), namespaceAliases = require("f35652e079edff1b"), getSortOrderIndex = require("b71b7fdbf016ba79"), getSortEquivalents = require("de727b6b7f68c2eb"), defineOptionsAccessor = require("ecb194f644fe10ff"), getCollationCharacter = require("32981ac6c7e12106"), getCollationReadyString = require("fd7e5e91fdce040a");
var sugarArray = namespaceAliases.sugarArray;
var ARRAY_OPTIONS = {
    "sortIgnore": null,
    "sortNatural": true,
    "sortIgnoreCase": true,
    "sortOrder": getSortOrder(),
    "sortCollate": collateStrings,
    "sortEquivalents": getSortEquivalents()
};
var _arrayOptions = defineOptionsAccessor(sugarArray, ARRAY_OPTIONS);
function collateStrings(a, b) {
    var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0, tiebreaker = 0;
    var sortOrder = _arrayOptions("sortOrder");
    var sortIgnore = _arrayOptions("sortIgnore");
    var sortNatural = _arrayOptions("sortNatural");
    var sortIgnoreCase = _arrayOptions("sortIgnoreCase");
    var sortEquivalents = _arrayOptions("sortEquivalents");
    a = getCollationReadyString(a, sortIgnore, sortIgnoreCase);
    b = getCollationReadyString(b, sortIgnore, sortIgnoreCase);
    do {
        aChar = getCollationCharacter(a, index, sortEquivalents);
        bChar = getCollationCharacter(b, index, sortEquivalents);
        aValue = getSortOrderIndex(aChar, sortOrder);
        bValue = getSortOrderIndex(bChar, sortOrder);
        if (aValue === -1 || bValue === -1) {
            aValue = a.charCodeAt(index) || null;
            bValue = b.charCodeAt(index) || null;
            if (sortNatural && codeIsNumeral(aValue) && codeIsNumeral(bValue)) {
                aValue = stringToNumber(a.slice(index));
                bValue = stringToNumber(b.slice(index));
            }
        } else {
            aEquiv = aChar !== a.charAt(index);
            bEquiv = bChar !== b.charAt(index);
            if (aEquiv !== bEquiv && tiebreaker === 0) tiebreaker = aEquiv - bEquiv;
        }
        index += 1;
    }while (aValue != null && bValue != null && aValue === bValue);
    if (aValue === bValue) return tiebreaker;
    return aValue - bValue;
}
module.exports = {
    ARRAY_OPTIONS: ARRAY_OPTIONS,
    _arrayOptions: _arrayOptions
};

},{"ea9afea5aa2b3a6":"k3DjK","b2d57e21429b4097":"dW3US","da1708fecda278dc":"bQshq","f35652e079edff1b":"1TEpR","b71b7fdbf016ba79":"37RMv","de727b6b7f68c2eb":"4GJwt","ecb194f644fe10ff":"5GDAt","32981ac6c7e12106":"ewyTv","fd7e5e91fdce040a":"3YW4W"}],"k3DjK":[function(require,module,exports) {
"use strict";
var map = require("de54294b79100dc8");
function getSortOrder() {
    var order = "A\xc1\xc0\xc2\xc3\u0104BC\u0106\u010C\xc7D\u010E\xd0E\xc9\xc8\u011A\xca\xcb\u0118FG\u011EH\u0131I\xcd\xcc\u0130\xce\xcfJKL\u0141MN\u0143\u0147\xd1O\xd3\xd2\xd4PQR\u0158S\u015A\u0160\u015ET\u0164U\xda\xd9\u016E\xdb\xdcVWXY\xddZ\u0179\u017B\u017D\xde\xc6\u0152\xd8\xd5\xc5\xc4\xd6";
    return map(order.split(""), function(str) {
        return str + str.toLowerCase();
    }).join("");
}
module.exports = getSortOrder;

},{"de54294b79100dc8":"b19ZA"}],"dW3US":[function(require,module,exports) {
"use strict";
var HALF_WIDTH_NINE = require("28d459292abadfb5"), FULL_WIDTH_NINE = require("bd3c07235653c836"), CommonChars = require("f58ee06e3f5429da");
var HALF_WIDTH_ZERO = CommonChars.HALF_WIDTH_ZERO, FULL_WIDTH_ZERO = CommonChars.FULL_WIDTH_ZERO;
function codeIsNumeral(code) {
    return code >= HALF_WIDTH_ZERO && code <= HALF_WIDTH_NINE || code >= FULL_WIDTH_ZERO && code <= FULL_WIDTH_NINE;
}
module.exports = codeIsNumeral;

},{"28d459292abadfb5":"kQw7h","bd3c07235653c836":"7jeoW","f58ee06e3f5429da":"ktIFO"}],"kQw7h":[function(require,module,exports) {
"use strict";
module.exports = 0x39;

},{}],"7jeoW":[function(require,module,exports) {
"use strict";
module.exports = 0xff19;

},{}],"37RMv":[function(require,module,exports) {
"use strict";
function getSortOrderIndex(chr, sortOrder) {
    if (!chr) return null;
    else return sortOrder.indexOf(chr);
}
module.exports = getSortOrderIndex;

},{}],"4GJwt":[function(require,module,exports) {
"use strict";
var forEach = require("2e1dfe64fea35272"), spaceSplit = require("9b074a429ab79fcf");
function getSortEquivalents() {
    var equivalents = {};
    forEach(spaceSplit("A\xc1\xc0\xc2\xc3\xc4 C\xc7 E\xc9\xc8\xca\xcb I\xcd\xcc\u0130\xce\xcf O\xd3\xd2\xd4\xd5\xd6 S\xdf U\xda\xd9\xdb\xdc"), function(set) {
        var first = set.charAt(0);
        forEach(set.slice(1).split(""), function(chr) {
            equivalents[chr] = first;
            equivalents[chr.toLowerCase()] = first.toLowerCase();
        });
    });
    return equivalents;
}
module.exports = getSortEquivalents;

},{"2e1dfe64fea35272":"1n2CK","9b074a429ab79fcf":"8g1bL"}],"ewyTv":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("f853285d5b977e95");
var getOwn = coreUtilityAliases.getOwn;
function getCollationCharacter(str, index, sortEquivalents) {
    var chr = str.charAt(index);
    return getOwn(sortEquivalents, chr) || chr;
}
module.exports = getCollationCharacter;

},{"f853285d5b977e95":"dU8Nu"}],"3YW4W":[function(require,module,exports) {
"use strict";
function getCollationReadyString(str, sortIgnore, sortIgnoreCase) {
    if (sortIgnoreCase) str = str.toLowerCase();
    if (sortIgnore) str = str.replace(sortIgnore, "");
    return str;
}
module.exports = getCollationReadyString;

},{}],"h5D36":[function(require,module,exports) {
"use strict";
var Sugar = require("bc2692c6ed5f9bec"), arrayIntersectOrSubtract = require("53edbb8e58b8e8f6");
Sugar.Array.defineInstance({
    "subtract": function(arr, item) {
        return arrayIntersectOrSubtract(arr, item, true);
    }
});
module.exports = Sugar.Array.subtract;

},{"bc2692c6ed5f9bec":"eWYA2","53edbb8e58b8e8f6":"9Qpea"}],"f3P2u":[function(require,module,exports) {
"use strict";
var Sugar = require("c7b78e3b38a64501"), isUndefined = require("fb9b4287ec8994e5");
Sugar.Array.defineInstance({
    "to": function(arr, num) {
        if (isUndefined(num)) num = arr.length;
        return arr.slice(0, num);
    }
});
module.exports = Sugar.Array.to;

},{"c7b78e3b38a64501":"eWYA2","fb9b4287ec8994e5":"hnApm"}],"Ke0wL":[function(require,module,exports) {
"use strict";
var Sugar = require("c48e0a1502d8a4ca"), arrayUnique = require("ba474d6f24354f60"), arrayConcat = require("3284373adaf82899");
Sugar.Array.defineInstance({
    "union": function(arr1, arr2) {
        return arrayUnique(arrayConcat(arr1, arr2));
    }
});
module.exports = Sugar.Array.union;

},{"c48e0a1502d8a4ca":"eWYA2","ba474d6f24354f60":"kwate","3284373adaf82899":"inbzO"}],"kwate":[function(require,module,exports) {
"use strict";
var forEach = require("bf1d7e190c31f26f"), mapWithShortcuts = require("94ea5e4702a25cff"), serializeInternal = require("8c4cf2ce61a75a83"), coreUtilityAliases = require("f5f6547f2c8a343c");
var hasOwn = coreUtilityAliases.hasOwn;
function arrayUnique(arr, map) {
    var result = [], obj = {}, refs = [];
    forEach(arr, function(el, i) {
        var transformed = map ? mapWithShortcuts(el, map, arr, [
            el,
            i,
            arr
        ]) : el;
        var key = serializeInternal(transformed, refs);
        if (!hasOwn(obj, key)) {
            result.push(el);
            obj[key] = true;
        }
    });
    return result;
}
module.exports = arrayUnique;

},{"bf1d7e190c31f26f":"1n2CK","94ea5e4702a25cff":"laRDC","8c4cf2ce61a75a83":"ffntQ","f5f6547f2c8a343c":"dU8Nu"}],"inbzO":[function(require,module,exports) {
"use strict";
var HAS_CONCAT_BUG = require("f994a2b1d9ae4205"), arraySafeConcat = require("b91cab3622530f8d");
function arrayConcat(arr1, arr2) {
    // istanbul ignore if
    if (HAS_CONCAT_BUG) return arraySafeConcat(arr1, arr2);
    return arr1.concat(arr2);
}
module.exports = arrayConcat;

},{"f994a2b1d9ae4205":"15St8","b91cab3622530f8d":"eCiYs"}],"15St8":[function(require,module,exports) {
"use strict";
module.exports = !("0" in [].concat(undefined).concat());

},{}],"eCiYs":[function(require,module,exports) {
"use strict";
var forEach = require("6158de648166e46"), arrayClone = require("7e7cf13b0aede92e"), classChecks = require("e16fb8b3159e720f");
var isArray = classChecks.isArray;
function arraySafeConcat(arr, arg) {
    var result = arrayClone(arr), len = result.length, arr2;
    arr2 = isArray(arg) ? arg : [
        arg
    ];
    result.length += arr2.length;
    forEach(arr2, function(el, i) {
        result[len + i] = el;
    });
    return result;
}
module.exports = arraySafeConcat;

},{"6158de648166e46":"1n2CK","7e7cf13b0aede92e":"3sj18","e16fb8b3159e720f":"lUOLF"}],"45OFm":[function(require,module,exports) {
"use strict";
var Sugar = require("4ed8c4e46516ede1"), arrayUnique = require("c487a9348a4a99e");
Sugar.Array.defineInstance({
    "unique": function(arr, map) {
        return arrayUnique(arr, map);
    }
});
module.exports = Sugar.Array.unique;

},{"4ed8c4e46516ede1":"eWYA2","c487a9348a4a99e":"kwate"}],"gJaay":[function(require,module,exports) {
"use strict";
var Sugar = require("1907ec87021a7b20"), map = require("27f52817d55e0486");
Sugar.Array.defineInstanceWithArguments({
    "zip": function(arr, args) {
        return map(arr, function(el, i) {
            return [
                el
            ].concat(map(args, function(k) {
                return i in k ? k[i] : null;
            }));
        });
    }
});
module.exports = Sugar.Array.zip;

},{"1907ec87021a7b20":"eWYA2","27f52817d55e0486":"b19ZA"}],"6LBFH":[function(require,module,exports) {
"use strict";
var Sugar = require("bda1232bf398e744"), append = require("87e65a5257031208");
Sugar.Array.alias("insert", "append");
module.exports = Sugar.Array.insert;

},{"bda1232bf398e744":"eWYA2","87e65a5257031208":"8G7FT"}],"4K2vV":[function(require,module,exports) {
"use strict";
var Sugar = require("79edfed3a8f341a5"), ARRAY_OPTIONS = require("914227d8517c42a8");
var _arrayOptions = ARRAY_OPTIONS._arrayOptions;
module.exports = Sugar.Array.getOption;

},{"79edfed3a8f341a5":"eWYA2","914227d8517c42a8":"i3Lyv"}],"l3jx5":[function(require,module,exports) {
"use strict";
var Sugar = require("6f8b61baa95d8586"), ARRAY_OPTIONS = require("ca0c15e27bec740");
var _arrayOptions = ARRAY_OPTIONS._arrayOptions;
module.exports = Sugar.Array.setOption;

},{"6f8b61baa95d8586":"eWYA2","ca0c15e27bec740":"i3Lyv"}],"aHgPY":[function(require,module,exports) {
"use strict";
// Static Methods
require("cd39ae8501209bbe");
require("592c284cc566744a");
require("53345013fa5835fb");
require("9aa00ec32e73b7f8");
require("f4384b6c23b6c3ec");
require("360fc00af8b04f80");
require("dc491eb51905b530");
require("fef7979c4aa60c13");
require("a93e26d2322aa15a");
require("80f8d34ca01e8fd3");
require("b4b2346f774a8dff");
require("1d465671d249b3a7");
require("ac5c63b4d9bd7b64");
require("edb912180bf9cf2e");
require("edaa01d561f6e02e");
require("fec54eff012f4dfd");
// Instance Methods
require("c8b6f58acd64609f");
require("df8e065d6722cdf9");
require("2394b67c0edd5c25");
require("d5b08592c8b2e740");
require("fa05f3cc2063752");
require("f946913e06625e78");
require("9667af3f8240e19b");
require("1b8db920db6c6503");
require("3e575ab5ad2e44e5");
require("20f29df7b28411a7");
require("5e450cb47757b5e6");
require("55d7181914c0140b");
require("6918008e58f18765");
require("f5e1a97923502dc");
require("e5b6c99cba4fb8d3");
require("2972c33d1f1f3bae");
require("c525a9180c7858f7");
require("fac4e2e86230f7ba");
require("f1a61225a68bf9ab");
require("180ef4ab5a35709b");
require("5c23294861db83bc");
require("2f8f8dbd1428764a");
require("47cdcf38da2075f0");
require("92dd9bf1deb170af");
module.exports = require("9303754079129ab7");

},{"cd39ae8501209bbe":"9I1ZI","592c284cc566744a":"f9W6l","53345013fa5835fb":"04o5C","9aa00ec32e73b7f8":"ebyeA","f4384b6c23b6c3ec":"9zc8P","360fc00af8b04f80":"becJm","dc491eb51905b530":"h7jn4","fef7979c4aa60c13":"jU20j","a93e26d2322aa15a":"aS8gn","80f8d34ca01e8fd3":"8rTe8","b4b2346f774a8dff":"k3gY7","1d465671d249b3a7":"kN5mc","ac5c63b4d9bd7b64":"kEipb","edb912180bf9cf2e":"2KGP2","edaa01d561f6e02e":"i3fBb","fec54eff012f4dfd":"32hoy","c8b6f58acd64609f":"dLDmW","df8e065d6722cdf9":"2D5aq","2394b67c0edd5c25":"4KVzT","d5b08592c8b2e740":"62cPt","fa05f3cc2063752":"f6DlH","f946913e06625e78":"4vYrz","9667af3f8240e19b":"2yf04","1b8db920db6c6503":"igPfA","3e575ab5ad2e44e5":"9XRZE","20f29df7b28411a7":"eAQf1","5e450cb47757b5e6":"de8id","55d7181914c0140b":"53xjT","6918008e58f18765":"6s57M","f5e1a97923502dc":"jdfh1","e5b6c99cba4fb8d3":"eTHEn","2972c33d1f1f3bae":"1pTNK","c525a9180c7858f7":"6dcy3","fac4e2e86230f7ba":"kx4bY","f1a61225a68bf9ab":"lshs8","180ef4ab5a35709b":"4IC3p","5c23294861db83bc":"65CX2","2f8f8dbd1428764a":"cnzE4","47cdcf38da2075f0":"c639u","92dd9bf1deb170af":"6IlsS","9303754079129ab7":"eWYA2"}],"9I1ZI":[function(require,module,exports) {
"use strict";
var Sugar = require("c7293e6ca9d79ecd"), average = require("fdab9ed2eb5c25ca");
Sugar.Object.defineInstanceAndStatic({
    "average": function(obj, map) {
        return average(obj, map);
    }
});
module.exports = Sugar.Object.average;

},{"c7293e6ca9d79ecd":"eWYA2","fdab9ed2eb5c25ca":"lFg20"}],"lFg20":[function(require,module,exports) {
"use strict";
var enumerateWithMapping = require("bcf33938af171884");
function average(obj, map) {
    var sum = 0, count = 0;
    enumerateWithMapping(obj, map, function(val) {
        sum += val;
        count++;
    });
    // Prevent divide by 0
    return sum / (count || 1);
}
module.exports = average;

},{"bcf33938af171884":"6XfkM"}],"6XfkM":[function(require,module,exports) {
"use strict";
var classChecks = require("3f74ba20dcf0208"), isArrayIndex = require("fb49d83f93402625"), mapWithShortcuts = require("fa11b84f0d466488"), coreUtilityAliases = require("c7973b89b3c22a25");
var isArray = classChecks.isArray, forEachProperty = coreUtilityAliases.forEachProperty;
function enumerateWithMapping(obj, map, fn) {
    var arrayIndexes = isArray(obj);
    forEachProperty(obj, function(val, key) {
        if (arrayIndexes) {
            if (!isArrayIndex(key)) return;
            key = +key;
        }
        var mapped = mapWithShortcuts(val, map, obj, [
            val,
            key,
            obj
        ]);
        fn(mapped, key);
    });
}
module.exports = enumerateWithMapping;

},{"3f74ba20dcf0208":"lUOLF","fb49d83f93402625":"7uQbA","fa11b84f0d466488":"laRDC","c7973b89b3c22a25":"dU8Nu"}],"f9W6l":[function(require,module,exports) {
"use strict";
var Sugar = require("3db77723ff3ad06f"), objectCount = require("31358ec0ea3e4fc");
Sugar.Object.defineInstanceAndStatic({
    "count": function(obj, f) {
        return objectCount(obj, f);
    }
});
module.exports = Sugar.Object.count;

},{"3db77723ff3ad06f":"eWYA2","31358ec0ea3e4fc":"bgN0x"}],"bgN0x":[function(require,module,exports) {
"use strict";
var getMatcher = require("5f0104593f555cd2"), coreUtilityAliases = require("c878db3cdb56c017");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectCount(obj, f) {
    var matcher = getMatcher(f), count = 0;
    forEachProperty(obj, function(val, key) {
        if (matcher(val, key, obj)) count++;
    });
    return count;
}
module.exports = objectCount;

},{"5f0104593f555cd2":"3InyL","c878db3cdb56c017":"dU8Nu"}],"04o5C":[function(require,module,exports) {
"use strict";
var Sugar = require("876b7faa9a51520a"), objectMatchers = require("ebd0fc5feb10dbab");
var objectEvery = objectMatchers.objectEvery;
Sugar.Object.defineInstanceAndStatic({
    "every": objectEvery
});
module.exports = Sugar.Object.every;

},{"876b7faa9a51520a":"eWYA2","ebd0fc5feb10dbab":"9LFLP"}],"9LFLP":[function(require,module,exports) {
"use strict";
var wrapObjectMatcher = require("33d2f01eeac5847b");
module.exports = {
    objectSome: wrapObjectMatcher("some"),
    objectFind: wrapObjectMatcher("find"),
    objectEvery: wrapObjectMatcher("every")
};

},{"33d2f01eeac5847b":"EXGSI"}],"EXGSI":[function(require,module,exports) {
"use strict";
var getKeys = require("6836e59d4f7a5633"), getMatcher = require("2762d4f7694758f");
function wrapObjectMatcher(name) {
    var nativeFn = Array.prototype[name];
    return function(obj, f) {
        var matcher = getMatcher(f);
        return nativeFn.call(getKeys(obj), function(key) {
            return matcher(obj[key], key, obj);
        });
    };
}
module.exports = wrapObjectMatcher;

},{"6836e59d4f7a5633":"6cOTr","2762d4f7694758f":"3InyL"}],"ebyeA":[function(require,module,exports) {
"use strict";
var Sugar = require("da23ab454b0f56b8"), objectFilter = require("9de53a41108f867a");
Sugar.Object.defineInstanceAndStatic({
    "filter": function(obj, f) {
        return objectFilter(obj, f);
    }
});
module.exports = Sugar.Object.filter;

},{"da23ab454b0f56b8":"eWYA2","9de53a41108f867a":"25Hc1"}],"25Hc1":[function(require,module,exports) {
"use strict";
var getMatcher = require("5cc71ddd193891cc"), coreUtilityAliases = require("d01a66f2b3dc0c0");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectFilter(obj, f) {
    var matcher = getMatcher(f), result = {};
    forEachProperty(obj, function(val, key) {
        if (matcher(val, key, obj)) result[key] = val;
    });
    return result;
}
module.exports = objectFilter;

},{"5cc71ddd193891cc":"3InyL","d01a66f2b3dc0c0":"dU8Nu"}],"9zc8P":[function(require,module,exports) {
"use strict";
var Sugar = require("a422d9826feaa508"), objectMatchers = require("1290e2e9cc81bc6a");
var objectFind = objectMatchers.objectFind;
Sugar.Object.defineInstanceAndStatic({
    "find": objectFind
});
module.exports = Sugar.Object.find;

},{"a422d9826feaa508":"eWYA2","1290e2e9cc81bc6a":"9LFLP"}],"becJm":[function(require,module,exports) {
"use strict";
var Sugar = require("40457091b487b94d"), objectForEach = require("d39e8e027dad6b9d");
Sugar.Object.defineInstanceAndStatic({
    "forEach": function(obj, eachFn) {
        return objectForEach(obj, eachFn);
    }
});
module.exports = Sugar.Object.forEach;

},{"40457091b487b94d":"eWYA2","d39e8e027dad6b9d":"hak2I"}],"hak2I":[function(require,module,exports) {
"use strict";
var assertCallable = require("aa7c7c6780aecb9e"), coreUtilityAliases = require("d0e5b3c36c65324");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectForEach(obj, fn) {
    assertCallable(fn);
    forEachProperty(obj, function(val, key) {
        fn(val, key, obj);
    });
    return obj;
}
module.exports = objectForEach;

},{"aa7c7c6780aecb9e":"cWKg6","d0e5b3c36c65324":"dU8Nu"}],"cWKg6":[function(require,module,exports) {
"use strict";
var classChecks = require("3be9ecbdc38da2bf");
var isFunction = classChecks.isFunction;
function assertCallable(obj) {
    if (!isFunction(obj)) throw new TypeError("Function is not callable");
}
module.exports = assertCallable;

},{"3be9ecbdc38da2bf":"lUOLF"}],"h7jn4":[function(require,module,exports) {
"use strict";
var Sugar = require("a5ab785bd832d534"), getLeastOrMost = require("47c926369c5635e6");
Sugar.Object.defineInstanceAndStatic({
    "least": function(obj, all, map) {
        return getLeastOrMost(obj, all, map, false, true);
    }
});
module.exports = Sugar.Object.least;

},{"a5ab785bd832d534":"eWYA2","47c926369c5635e6":"200vd"}],"200vd":[function(require,module,exports) {
"use strict";
var classChecks = require("fd30d99019df2251"), getMinOrMax = require("2c83ab3769a0d02"), serializeInternal = require("5c53fa1b3f2afe02"), coreUtilityAliases = require("b80f48af3322a774"), enumerateWithMapping = require("16a2e1b49e9c1cbe"), getReducedMinMaxResult = require("7c15e4757500d5a0");
var isBoolean = classChecks.isBoolean, getOwn = coreUtilityAliases.getOwn, forEachProperty = coreUtilityAliases.forEachProperty;
function getLeastOrMost(obj, arg1, arg2, most, asObject) {
    var group = {}, refs = [], minMaxResult, result, all, map;
    if (isBoolean(arg1)) {
        all = arg1;
        map = arg2;
    } else map = arg1;
    enumerateWithMapping(obj, map, function(val, key) {
        var groupKey = serializeInternal(val, refs);
        var arr = getOwn(group, groupKey) || [];
        arr.push(asObject ? key : obj[key]);
        group[groupKey] = arr;
    });
    minMaxResult = getMinOrMax(group, !!all, "length", most, true);
    if (all) {
        result = [];
        // Flatten result
        forEachProperty(minMaxResult, function(val) {
            result = result.concat(val);
        });
    } else result = getOwn(group, minMaxResult);
    return getReducedMinMaxResult(result, obj, all, asObject);
}
module.exports = getLeastOrMost;

},{"fd30d99019df2251":"lUOLF","2c83ab3769a0d02":"elE3h","5c53fa1b3f2afe02":"ffntQ","b80f48af3322a774":"dU8Nu","16a2e1b49e9c1cbe":"6XfkM","7c15e4757500d5a0":"1Uk4f"}],"elE3h":[function(require,module,exports) {
"use strict";
var classChecks = require("8d3b8d8a281c0efa"), isUndefined = require("4b86c505dce6d88c"), enumerateWithMapping = require("c9f2b1316f6ebf"), getReducedMinMaxResult = require("34b2fef125c3d716");
var isBoolean = classChecks.isBoolean;
function getMinOrMax(obj, arg1, arg2, max, asObject) {
    var result = [], pushVal, edge, all, map;
    if (isBoolean(arg1)) {
        all = arg1;
        map = arg2;
    } else map = arg1;
    enumerateWithMapping(obj, map, function(val, key) {
        if (isUndefined(val)) throw new TypeError("Cannot compare with undefined");
        pushVal = asObject ? key : obj[key];
        if (val === edge) result.push(pushVal);
        else if (isUndefined(edge) || max && val > edge || !max && val < edge) {
            result = [
                pushVal
            ];
            edge = val;
        }
    });
    return getReducedMinMaxResult(result, obj, all, asObject);
}
module.exports = getMinOrMax;

},{"8d3b8d8a281c0efa":"lUOLF","4b86c505dce6d88c":"hnApm","c9f2b1316f6ebf":"6XfkM","34b2fef125c3d716":"1Uk4f"}],"1Uk4f":[function(require,module,exports) {
"use strict";
function getReducedMinMaxResult(result, obj, all, asObject) {
    if (asObject && all) // The method has returned an array of keys so use this array
    // to build up the resulting object in the form we want it in.
    return result.reduce(function(o, key) {
        o[key] = obj[key];
        return o;
    }, {});
    else if (result && !all) result = result[0];
    return result;
}
module.exports = getReducedMinMaxResult;

},{}],"jU20j":[function(require,module,exports) {
"use strict";
var Sugar = require("b720d8a8755606c9"), objectMap = require("acebda5d659f7866");
Sugar.Object.defineInstanceAndStatic({
    "map": function(obj, map) {
        return objectMap(obj, map);
    }
});
module.exports = Sugar.Object.map;

},{"b720d8a8755606c9":"eWYA2","acebda5d659f7866":"GsW70"}],"GsW70":[function(require,module,exports) {
"use strict";
var mapWithShortcuts = require("4d9bb856ab077b0d"), coreUtilityAliases = require("e1cf384d1d3f82b5");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectMap(obj, map) {
    var result = {};
    forEachProperty(obj, function(val, key) {
        result[key] = mapWithShortcuts(val, map, obj, [
            val,
            key,
            obj
        ]);
    });
    return result;
}
module.exports = objectMap;

},{"4d9bb856ab077b0d":"laRDC","e1cf384d1d3f82b5":"dU8Nu"}],"aS8gn":[function(require,module,exports) {
"use strict";
var Sugar = require("540f09bb587cae18"), getMinOrMax = require("88d10997d71667c9");
Sugar.Object.defineInstanceAndStatic({
    "max": function(obj, all, map) {
        return getMinOrMax(obj, all, map, true, true);
    }
});
module.exports = Sugar.Object.max;

},{"540f09bb587cae18":"eWYA2","88d10997d71667c9":"elE3h"}],"8rTe8":[function(require,module,exports) {
"use strict";
var Sugar = require("b64129b3a9c2705f"), median = require("7a599c036d8d9a86");
Sugar.Object.defineInstanceAndStatic({
    "median": function(obj, map) {
        return median(obj, map);
    }
});
module.exports = Sugar.Object.median;

},{"b64129b3a9c2705f":"eWYA2","7a599c036d8d9a86":"6v2k7"}],"6v2k7":[function(require,module,exports) {
"use strict";
var trunc = require("43060ff6d15a1fbd"), enumerateWithMapping = require("80f325b8fd1627e0");
function median(obj, map) {
    var result = [], middle, len;
    enumerateWithMapping(obj, map, function(val) {
        result.push(val);
    });
    len = result.length;
    if (!len) return 0;
    result.sort(function(a, b) {
        // IE7 will throw errors on non-numbers!
        return (a || 0) - (b || 0);
    });
    middle = trunc(len / 2);
    return len % 2 ? result[middle] : (result[middle - 1] + result[middle]) / 2;
}
module.exports = median;

},{"43060ff6d15a1fbd":"ePaYC","80f325b8fd1627e0":"6XfkM"}],"k3gY7":[function(require,module,exports) {
"use strict";
var Sugar = require("d94a1a3d5f376aae"), getMinOrMax = require("e4e1278d59280862");
Sugar.Object.defineInstanceAndStatic({
    "min": function(obj, all, map) {
        return getMinOrMax(obj, all, map, false, true);
    }
});
module.exports = Sugar.Object.min;

},{"d94a1a3d5f376aae":"eWYA2","e4e1278d59280862":"elE3h"}],"kN5mc":[function(require,module,exports) {
"use strict";
var Sugar = require("438a92f3f3e5b40"), getLeastOrMost = require("218bb5a243157171");
Sugar.Object.defineInstanceAndStatic({
    "most": function(obj, all, map) {
        return getLeastOrMost(obj, all, map, true, true);
    }
});
module.exports = Sugar.Object.most;

},{"438a92f3f3e5b40":"eWYA2","218bb5a243157171":"200vd"}],"kEipb":[function(require,module,exports) {
"use strict";
var Sugar = require("b43fa8aad97cef20"), objectNone = require("cd15c81ec5128d71");
Sugar.Object.defineInstanceAndStatic({
    "none": function(obj, f) {
        return objectNone(obj, f);
    }
});
module.exports = Sugar.Object.none;

},{"b43fa8aad97cef20":"eWYA2","cd15c81ec5128d71":"63SfT"}],"63SfT":[function(require,module,exports) {
"use strict";
var objectMatchers = require("d2b2a1bf9c1f688e");
var objectSome = objectMatchers.objectSome;
function objectNone(obj, f) {
    return !objectSome(obj, f);
}
module.exports = objectNone;

},{"d2b2a1bf9c1f688e":"9LFLP"}],"2KGP2":[function(require,module,exports) {
"use strict";
var Sugar = require("845af1e5507f285a"), objectReduce = require("362962a1a7281acc");
Sugar.Object.defineInstanceAndStatic({
    "reduce": function(obj, fn, init) {
        return objectReduce(obj, fn, init);
    }
});
module.exports = Sugar.Object.reduce;

},{"845af1e5507f285a":"eWYA2","362962a1a7281acc":"8Vd5T"}],"8Vd5T":[function(require,module,exports) {
"use strict";
var isDefined = require("a6f7c695e3f93616"), coreUtilityAliases = require("d4e56412f091febe");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectReduce(obj, fn, acc) {
    var init = isDefined(acc);
    forEachProperty(obj, function(val, key) {
        if (!init) {
            acc = val;
            init = true;
            return;
        }
        acc = fn(acc, val, key, obj);
    });
    return acc;
}
module.exports = objectReduce;

},{"a6f7c695e3f93616":"6Ge6e","d4e56412f091febe":"dU8Nu"}],"i3fBb":[function(require,module,exports) {
"use strict";
var Sugar = require("a83d34d71a519ad0"), objectMatchers = require("ce2048ab91e034be");
var objectSome = objectMatchers.objectSome;
Sugar.Object.defineInstanceAndStatic({
    "some": objectSome
});
module.exports = Sugar.Object.some;

},{"a83d34d71a519ad0":"eWYA2","ce2048ab91e034be":"9LFLP"}],"32hoy":[function(require,module,exports) {
"use strict";
var Sugar = require("397b946fba0430fa"), sum = require("4268492162a44262");
Sugar.Object.defineInstanceAndStatic({
    "sum": function(obj, map) {
        return sum(obj, map);
    }
});
module.exports = Sugar.Object.sum;

},{"397b946fba0430fa":"eWYA2","4268492162a44262":"8R3yS"}],"8R3yS":[function(require,module,exports) {
"use strict";
var enumerateWithMapping = require("36f9e28c632612a0");
function sum(obj, map) {
    var _$sum = 0;
    enumerateWithMapping(obj, map, function(val) {
        _$sum += val;
    });
    return _$sum;
}
module.exports = sum;

},{"36f9e28c632612a0":"6XfkM"}],"dLDmW":[function(require,module,exports) {
"use strict";
var Sugar = require("d03c6ff1700c8412"), average = require("c9143863ff0ec60a");
Sugar.Array.defineInstance({
    "average": function(arr, map) {
        return average(arr, map);
    }
});
module.exports = Sugar.Array.average;

},{"d03c6ff1700c8412":"eWYA2","c9143863ff0ec60a":"lFg20"}],"2D5aq":[function(require,module,exports) {
"use strict";
var Sugar = require("7e4113676e5ac25f"), arrayCount = require("49848abd91956542"), fixArgumentLength = require("f08888d84400d9ef");
Sugar.Array.defineInstance({
    "count": fixArgumentLength(arrayCount)
});
module.exports = Sugar.Array.count;

},{"7e4113676e5ac25f":"eWYA2","49848abd91956542":"b4yQV","f08888d84400d9ef":"kYocG"}],"b4yQV":[function(require,module,exports) {
"use strict";
var isUndefined = require("e35e1b9f2103ce50"), enhancedMatcherMethods = require("f296822fba473f62");
var enhancedFilter = enhancedMatcherMethods.enhancedFilter;
function arrayCount(arr, f) {
    if (isUndefined(f)) return arr.length;
    return enhancedFilter.apply(this, arguments).length;
}
module.exports = arrayCount;

},{"e35e1b9f2103ce50":"hnApm","f296822fba473f62":"6JWwl"}],"6JWwl":[function(require,module,exports) {
"use strict";
var buildEnhancedMatching = require("8b4b243afdf255e4");
module.exports = {
    enhancedFind: buildEnhancedMatching("find"),
    enhancedSome: buildEnhancedMatching("some"),
    enhancedEvery: buildEnhancedMatching("every"),
    enhancedFilter: buildEnhancedMatching("filter"),
    enhancedFindIndex: buildEnhancedMatching("findIndex")
};

},{"8b4b243afdf255e4":"e8MCo"}],"e8MCo":[function(require,module,exports) {
"use strict";
var enhancedMatching = require("160e0d50e86f52c8"), wrapNativeArrayMethod = require("ec0903f80fcbef22");
function buildEnhancedMatching(name) {
    return wrapNativeArrayMethod(name, enhancedMatching);
}
module.exports = buildEnhancedMatching;

},{"160e0d50e86f52c8":"eXbAS","ec0903f80fcbef22":"fmUFh"}],"eXbAS":[function(require,module,exports) {
"use strict";
var getMatcher = require("36d2e4280f24efdc"), classChecks = require("9027e603ab4310f1");
var isFunction = classChecks.isFunction;
function enhancedMatching(f) {
    var matcher;
    if (isFunction(f)) return f;
    matcher = getMatcher(f);
    return function(el, i, arr) {
        return matcher(el, i, arr);
    };
}
module.exports = enhancedMatching;

},{"36d2e4280f24efdc":"3InyL","9027e603ab4310f1":"lUOLF"}],"fmUFh":[function(require,module,exports) {
"use strict";
var assertArgument = require("807a4ab8e6abc875");
function wrapNativeArrayMethod(methodName, wrapper) {
    var nativeFn = Array.prototype[methodName];
    return function(arr, f, context, argsLen) {
        var args = new Array(2);
        assertArgument(argsLen > 0);
        args[0] = wrapper(f, context);
        args[1] = context;
        return nativeFn.apply(arr, args);
    };
}
module.exports = wrapNativeArrayMethod;

},{"807a4ab8e6abc875":"9HL2i"}],"9HL2i":[function(require,module,exports) {
"use strict";
function assertArgument(exists) {
    if (!exists) throw new TypeError("Argument required");
}
module.exports = assertArgument;

},{}],"4KVzT":[function(require,module,exports) {
"use strict";
var Sugar = require("10145841c1dac60"), ENHANCEMENTS_FLAG = require("82d7ce5e126d9e1b"), ARRAY_ENHANCEMENTS_FLAG = require("700315fca33e4ee8"), fixArgumentLength = require("6ac69f46748f0226"), enhancedMatcherMethods = require("bf8a83d9aad256ea");
var enhancedEvery = enhancedMatcherMethods.enhancedEvery;
Sugar.Array.defineInstance({
    "every": fixArgumentLength(enhancedEvery)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.every;

},{"10145841c1dac60":"eWYA2","82d7ce5e126d9e1b":"g3Tpr","700315fca33e4ee8":"7QZ0V","6ac69f46748f0226":"kYocG","bf8a83d9aad256ea":"6JWwl"}],"7QZ0V":[function(require,module,exports) {
"use strict";
module.exports = "enhanceArray";

},{}],"62cPt":[function(require,module,exports) {
"use strict";
var Sugar = require("5b9b9f0f0818ed65");
require("457b8ca96247d088");
module.exports = Sugar.Array.everyFromIndex;

},{"5b9b9f0f0818ed65":"eWYA2","457b8ca96247d088":"hIZ3Z"}],"hIZ3Z":[function(require,module,exports) {
"use strict";
var buildFromIndexMethods = require("c86f7811ef8c7c80");
buildFromIndexMethods();

},{"c86f7811ef8c7c80":"fEwdx"}],"fEwdx":[function(require,module,exports) {
"use strict";
var forEach = require("538b3fea71cd8c0e"), spaceSplit = require("a5f9402ac1228eef"), classChecks = require("43cbb10c838a4715"), mathAliases = require("69c716195aa2ac7"), assertArgument = require("2bc50f66cd99ee19"), enhancedMapping = require("259e5b3eca7683e7"), namespaceAliases = require("d51b07a0a0cc6b33"), enhancedMatching = require("51a7c376bba51751"), getNormalizedIndex = require("8fd2ceab8f48f42a"), coreUtilityAliases = require("7220673eaadc5f7c"), methodDefineAliases = require("bf810dafe913d67");
var forEachProperty = coreUtilityAliases.forEachProperty, defineInstanceWithArguments = methodDefineAliases.defineInstanceWithArguments, sugarArray = namespaceAliases.sugarArray, min = mathAliases.min, max = mathAliases.max, isBoolean = classChecks.isBoolean;
function buildFromIndexMethods() {
    var methods = {
        "forEach": {
            base: forEachAsNative
        },
        "map": {
            wrapper: enhancedMapping
        },
        "some every": {
            wrapper: enhancedMatching
        },
        "findIndex": {
            wrapper: enhancedMatching,
            result: indexResult
        },
        "reduce": {
            apply: applyReduce
        },
        "filter find": {
            wrapper: enhancedMatching
        },
        "reduceRight": {
            apply: applyReduce,
            slice: sliceArrayFromRight,
            clamp: clampStartIndexFromRight
        }
    };
    forEachProperty(methods, function(opts, key) {
        forEach(spaceSplit(key), function(baseName) {
            var methodName = baseName + "FromIndex";
            var fn = createFromIndexWithOptions(baseName, opts);
            defineInstanceWithArguments(sugarArray, methodName, fn);
        });
    });
    function forEachAsNative(fn) {
        forEach(this, fn);
    }
    // Methods like filter and find have a direct association between the value
    // returned by the callback and the element of the current iteration. This
    // means that when looping, array elements must match the actual index for
    // which they are being called, so the array must be sliced. This is not the
    // case for methods like forEach and map, which either do not use return
    // values or use them in a way that simply getting the element at a shifted
    // index will not affect the final return value. However, these methods will
    // still fail on sparse arrays, so always slicing them here. For example, if
    // "forEachFromIndex" were to be called on [1,,2] from index 1, although the
    // actual index 1 would itself would be skipped, when the array loops back to
    // index 0, shifting it by adding 1 would result in the element for that
    // iteration being undefined. For shifting to work, all gaps in the array
    // between the actual index and the shifted index would have to be accounted
    // for. This is infeasible and is easily solved by simply slicing the actual
    // array instead so that gaps align. Note also that in the case of forEach,
    // we are using the internal function which handles sparse arrays in a way
    // that does not increment the index, and so is highly optimized compared to
    // the others here, which are simply going through the native implementation.
    function sliceArrayFromLeft(arr, startIndex, loop) {
        var result = arr;
        if (startIndex) {
            result = arr.slice(startIndex);
            if (loop) result = result.concat(arr.slice(0, startIndex));
        }
        return result;
    }
    // When iterating from the right, indexes are effectively shifted by 1.
    // For example, iterating from the right from index 2 in an array of 3
    // should also include the last element in the array. This matches the
    // "lastIndexOf" method which also iterates from the right.
    function sliceArrayFromRight(arr, startIndex, loop) {
        if (!loop) {
            startIndex += 1;
            arr = arr.slice(0, max(0, startIndex));
        }
        return arr;
    }
    function clampStartIndex(startIndex, len) {
        return min(len, max(0, startIndex));
    }
    // As indexes are shifted by 1 when starting from the right, clamping has to
    // go down to -1 to accommodate the full range of the sliced array.
    function clampStartIndexFromRight(startIndex, len) {
        return min(len, max(-1, startIndex));
    }
    function applyReduce(arr, startIndex, fn, context, len, loop) {
        return function(acc, val, i) {
            i = getNormalizedIndex(i + startIndex, len, loop);
            return fn.call(arr, acc, val, i, arr);
        };
    }
    function applyEach(arr, startIndex, fn, context, len, loop) {
        return function(el, i) {
            i = getNormalizedIndex(i + startIndex, len, loop);
            return fn.call(context, arr[i], i, arr);
        };
    }
    function indexResult(result, startIndex, len) {
        if (result !== -1) result = (result + startIndex) % len;
        return result;
    }
    function createFromIndexWithOptions(methodName, opts) {
        var baseFn = opts.base || Array.prototype[methodName], applyCallback = opts.apply || applyEach, sliceArray = opts.slice || sliceArrayFromLeft, clampIndex = opts.clamp || clampStartIndex, getResult = opts.result, wrapper = opts.wrapper;
        return function(arr, startIndex, args) {
            var callArgs = [], argIndex = 0, lastArg, result, len, loop, fn;
            len = arr.length;
            if (isBoolean(args[0])) loop = args[argIndex++];
            fn = args[argIndex++];
            lastArg = args[argIndex];
            if (startIndex < 0) startIndex += len;
            startIndex = clampIndex(startIndex, len);
            assertArgument(args.length);
            fn = wrapper ? wrapper(fn, lastArg) : fn;
            callArgs.push(applyCallback(arr, startIndex, fn, lastArg, len, loop));
            if (lastArg) callArgs.push(lastArg);
            result = baseFn.apply(sliceArray(arr, startIndex, loop), callArgs);
            if (getResult) result = getResult(result, startIndex, len);
            return result;
        };
    }
}
module.exports = buildFromIndexMethods;

},{"538b3fea71cd8c0e":"1n2CK","a5f9402ac1228eef":"8g1bL","43cbb10c838a4715":"lUOLF","69c716195aa2ac7":"89tTN","2bc50f66cd99ee19":"9HL2i","259e5b3eca7683e7":"8ss8x","d51b07a0a0cc6b33":"1TEpR","51a7c376bba51751":"eXbAS","8fd2ceab8f48f42a":"2mIyX","7220673eaadc5f7c":"dU8Nu","bf810dafe913d67":"l2cG2"}],"8ss8x":[function(require,module,exports) {
"use strict";
var classChecks = require("e4f463f3ca9f6e25"), mapWithShortcuts = require("121bc317ce3c4c53");
var isFunction = classChecks.isFunction;
function enhancedMapping(map, context) {
    if (isFunction(map)) return map;
    else if (map) return function(el, i, arr) {
        return mapWithShortcuts(el, map, context, [
            el,
            i,
            arr
        ]);
    };
}
module.exports = enhancedMapping;

},{"e4f463f3ca9f6e25":"lUOLF","121bc317ce3c4c53":"laRDC"}],"f6DlH":[function(require,module,exports) {
"use strict";
var Sugar = require("8b40be2f299fa74f"), ENHANCEMENTS_FLAG = require("eb27d9dfe9888988"), ARRAY_ENHANCEMENTS_FLAG = require("d99ecf32d0d6abaa"), fixArgumentLength = require("c0be594de2129560"), enhancedMatcherMethods = require("aac307b454886cad");
var enhancedFilter = enhancedMatcherMethods.enhancedFilter;
Sugar.Array.defineInstance({
    "filter": fixArgumentLength(enhancedFilter)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.filter;

},{"8b40be2f299fa74f":"eWYA2","eb27d9dfe9888988":"g3Tpr","d99ecf32d0d6abaa":"7QZ0V","c0be594de2129560":"kYocG","aac307b454886cad":"6JWwl"}],"4vYrz":[function(require,module,exports) {
"use strict";
var Sugar = require("47b637756976ad49");
require("5961852c32bb679b");
module.exports = Sugar.Array.filterFromIndex;

},{"47b637756976ad49":"eWYA2","5961852c32bb679b":"hIZ3Z"}],"2yf04":[function(require,module,exports) {
"use strict";
var Sugar = require("3ae268653e075427"), ENHANCEMENTS_FLAG = require("6f086aeb3ded4c7c"), ARRAY_ENHANCEMENTS_FLAG = require("2b6b249601a5f7f0"), fixArgumentLength = require("25fe02bd48b726a2"), enhancedMatcherMethods = require("53e89cc268e34447");
var enhancedFind = enhancedMatcherMethods.enhancedFind;
Sugar.Array.defineInstance({
    "find": fixArgumentLength(enhancedFind)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.find;

},{"3ae268653e075427":"eWYA2","6f086aeb3ded4c7c":"g3Tpr","2b6b249601a5f7f0":"7QZ0V","25fe02bd48b726a2":"kYocG","53e89cc268e34447":"6JWwl"}],"igPfA":[function(require,module,exports) {
"use strict";
var Sugar = require("78c188644992ff06");
require("cf44512acbb7fa61");
module.exports = Sugar.Array.findFromIndex;

},{"78c188644992ff06":"eWYA2","cf44512acbb7fa61":"hIZ3Z"}],"9XRZE":[function(require,module,exports) {
"use strict";
var Sugar = require("b3442199dc691791"), ENHANCEMENTS_FLAG = require("59e39835e1a8b9e0"), ARRAY_ENHANCEMENTS_FLAG = require("cecd78e6453d2f70"), fixArgumentLength = require("4e9e5fdb7a85573d"), enhancedMatcherMethods = require("bbb4f6020b6209b0");
var enhancedFindIndex = enhancedMatcherMethods.enhancedFindIndex;
Sugar.Array.defineInstance({
    "findIndex": fixArgumentLength(enhancedFindIndex)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.findIndex;

},{"b3442199dc691791":"eWYA2","59e39835e1a8b9e0":"g3Tpr","cecd78e6453d2f70":"7QZ0V","4e9e5fdb7a85573d":"kYocG","bbb4f6020b6209b0":"6JWwl"}],"eAQf1":[function(require,module,exports) {
"use strict";
var Sugar = require("7077260512c42ccd");
require("9b025bd2d70c75a6");
module.exports = Sugar.Array.findIndexFromIndex;

},{"7077260512c42ccd":"eWYA2","9b025bd2d70c75a6":"hIZ3Z"}],"de8id":[function(require,module,exports) {
"use strict";
var Sugar = require("a6226ad2ca0fab4a");
require("a31253e2d30ae1c0");
module.exports = Sugar.Array.forEachFromIndex;

},{"a6226ad2ca0fab4a":"eWYA2","a31253e2d30ae1c0":"hIZ3Z"}],"53xjT":[function(require,module,exports) {
"use strict";
var Sugar = require("40a7a99f525655d9"), getLeastOrMost = require("5412f2399863a170");
Sugar.Array.defineInstance({
    "least": function(arr, all, map) {
        return getLeastOrMost(arr, all, map);
    }
});
module.exports = Sugar.Array.least;

},{"40a7a99f525655d9":"eWYA2","5412f2399863a170":"200vd"}],"6s57M":[function(require,module,exports) {
"use strict";
var Sugar = require("49c59914eb298fa"), ENHANCEMENTS_FLAG = require("5a4374d1dc17b31f"), ARRAY_ENHANCEMENTS_FLAG = require("daea3332ba6921de"), enhancedMap = require("bf7043834f4fb09b"), fixArgumentLength = require("7ccbc37c7096d69c");
Sugar.Array.defineInstance({
    "map": fixArgumentLength(enhancedMap)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.map;

},{"49c59914eb298fa":"eWYA2","5a4374d1dc17b31f":"g3Tpr","daea3332ba6921de":"7QZ0V","bf7043834f4fb09b":"27Zy2","7ccbc37c7096d69c":"kYocG"}],"27Zy2":[function(require,module,exports) {
"use strict";
var buildEnhancedMapping = require("702125771e741609");
module.exports = buildEnhancedMapping("map");

},{"702125771e741609":"byvJM"}],"byvJM":[function(require,module,exports) {
"use strict";
var enhancedMapping = require("e5144c3967b558c"), wrapNativeArrayMethod = require("e19357b60de1f44f");
function buildEnhancedMapping(name) {
    return wrapNativeArrayMethod(name, enhancedMapping);
}
module.exports = buildEnhancedMapping;

},{"e5144c3967b558c":"8ss8x","e19357b60de1f44f":"fmUFh"}],"jdfh1":[function(require,module,exports) {
"use strict";
var Sugar = require("96cec2815fb5ecbc");
require("add4c0a3fbeab897");
module.exports = Sugar.Array.mapFromIndex;

},{"96cec2815fb5ecbc":"eWYA2","add4c0a3fbeab897":"hIZ3Z"}],"eTHEn":[function(require,module,exports) {
"use strict";
var Sugar = require("62823afaf0eddabf"), getMinOrMax = require("838f76c7d489ca9b");
Sugar.Array.defineInstance({
    "max": function(arr, all, map) {
        return getMinOrMax(arr, all, map, true);
    }
});
module.exports = Sugar.Array.max;

},{"62823afaf0eddabf":"eWYA2","838f76c7d489ca9b":"elE3h"}],"1pTNK":[function(require,module,exports) {
"use strict";
var Sugar = require("fb4bcdfeb56b55"), median = require("91e167672b023af8");
Sugar.Array.defineInstance({
    "median": function(arr, map) {
        return median(arr, map);
    }
});
module.exports = Sugar.Array.median;

},{"fb4bcdfeb56b55":"eWYA2","91e167672b023af8":"6v2k7"}],"6dcy3":[function(require,module,exports) {
"use strict";
var Sugar = require("95018520042c6c"), getMinOrMax = require("17881813a9f2f420");
Sugar.Array.defineInstance({
    "min": function(arr, all, map) {
        return getMinOrMax(arr, all, map);
    }
});
module.exports = Sugar.Array.min;

},{"95018520042c6c":"eWYA2","17881813a9f2f420":"elE3h"}],"kx4bY":[function(require,module,exports) {
"use strict";
var Sugar = require("494b7d5a1911901d"), getLeastOrMost = require("95c5346da59bbc02");
Sugar.Array.defineInstance({
    "most": function(arr, all, map) {
        return getLeastOrMost(arr, all, map, true);
    }
});
module.exports = Sugar.Array.most;

},{"494b7d5a1911901d":"eWYA2","95c5346da59bbc02":"200vd"}],"lshs8":[function(require,module,exports) {
"use strict";
var Sugar = require("c533e14b87b6e09f"), arrayNone = require("9cacb1f5b6c3543f"), fixArgumentLength = require("a3049111b00308f4");
Sugar.Array.defineInstance({
    "none": fixArgumentLength(arrayNone)
});
module.exports = Sugar.Array.none;

},{"c533e14b87b6e09f":"eWYA2","9cacb1f5b6c3543f":"5r77G","a3049111b00308f4":"kYocG"}],"5r77G":[function(require,module,exports) {
"use strict";
var enhancedMatcherMethods = require("735a3ba0b94e45f2");
var enhancedSome = enhancedMatcherMethods.enhancedSome;
function arrayNone() {
    return !enhancedSome.apply(this, arguments);
}
module.exports = arrayNone;

},{"735a3ba0b94e45f2":"6JWwl"}],"4IC3p":[function(require,module,exports) {
"use strict";
var Sugar = require("307d2a3046f04cd5");
require("4ad8304031766209");
module.exports = Sugar.Array.reduceFromIndex;

},{"307d2a3046f04cd5":"eWYA2","4ad8304031766209":"hIZ3Z"}],"65CX2":[function(require,module,exports) {
"use strict";
var Sugar = require("5b3a3b90a71e5810");
require("650297c3f3cf2c1d");
module.exports = Sugar.Array.reduceRightFromIndex;

},{"5b3a3b90a71e5810":"eWYA2","650297c3f3cf2c1d":"hIZ3Z"}],"cnzE4":[function(require,module,exports) {
"use strict";
var Sugar = require("98087a2b3b54c901"), ENHANCEMENTS_FLAG = require("ba4661608e28425"), ARRAY_ENHANCEMENTS_FLAG = require("7da9f437090f49"), fixArgumentLength = require("3e9b672065f31a2"), enhancedMatcherMethods = require("a44055d8ef154f9c");
var enhancedSome = enhancedMatcherMethods.enhancedSome;
Sugar.Array.defineInstance({
    "some": fixArgumentLength(enhancedSome)
}, [
    ENHANCEMENTS_FLAG,
    ARRAY_ENHANCEMENTS_FLAG
]);
module.exports = Sugar.Array.some;

},{"98087a2b3b54c901":"eWYA2","ba4661608e28425":"g3Tpr","7da9f437090f49":"7QZ0V","3e9b672065f31a2":"kYocG","a44055d8ef154f9c":"6JWwl"}],"c639u":[function(require,module,exports) {
"use strict";
var Sugar = require("7833f767171d1225");
require("802e55878b60f8bc");
module.exports = Sugar.Array.someFromIndex;

},{"7833f767171d1225":"eWYA2","802e55878b60f8bc":"hIZ3Z"}],"6IlsS":[function(require,module,exports) {
"use strict";
var Sugar = require("5a45283e74865cc4"), sum = require("d10fd3f48c3f2331");
Sugar.Array.defineInstance({
    "sum": function(arr, map) {
        return sum(arr, map);
    }
});
module.exports = Sugar.Array.sum;

},{"5a45283e74865cc4":"eWYA2","d10fd3f48c3f2331":"8R3yS"}],"lzA4y":[function(require,module,exports) {
"use strict";
// Static Methods
require("c93d549841282360");
require("17592e73f61ab9cb");
require("94a8de22cb1970d6");
require("bc18ea70a20172c5");
require("2102925ea00aaa99");
require("41d535c741a40fe2");
require("85cc4e06c0e3a62d");
require("ec6c233dd0c4e463");
require("6ba0803e577a8fe1");
require("dbe620f1549cc2cc");
require("ad465b86b3a70442");
require("aca020c54699a25b");
require("9c9bcdd96cfe26ab");
require("a3d7f8478015cb37");
require("77ba20169ada47e0");
require("3dee6e229f52dd06");
require("82d177280122f548");
require("90cc91eebf142ada");
require("e7e522da2f278f10");
require("fb666d923197f87c");
require("80744f6562b338ea");
require("ee587d54683059a6");
require("a56ac5c959bfef28");
require("5aab33abc3a6da36");
require("3ce68b0125e96bf6");
require("c8f1314caf5497ae");
require("3fa8e6dd2779012f");
require("d4c7c23d646c2b3e");
require("db7f6218bc105b4d");
require("20733d75d928612f");
require("a0fc215076b75c08");
require("cd71f477210352ce");
require("29cd4ec8cb9a6e04");
require("ff0f3c3312315693");
require("1c57ea657291aa14");
// Instance Methods
require("c9da3dc54ea3ad07");
module.exports = require("335c9c9543af8469");

},{"c93d549841282360":"O6XD0","17592e73f61ab9cb":"8EVNG","94a8de22cb1970d6":"7DA22","bc18ea70a20172c5":"jGo20","2102925ea00aaa99":"kXfSd","41d535c741a40fe2":"cagrz","85cc4e06c0e3a62d":"g3GEg","ec6c233dd0c4e463":"94lL2","6ba0803e577a8fe1":"2moQU","dbe620f1549cc2cc":"atmmj","ad465b86b3a70442":"iXGSD","aca020c54699a25b":"hyRZW","9c9bcdd96cfe26ab":"aRJL2","a3d7f8478015cb37":"1RUbu","77ba20169ada47e0":"jry3Z","3dee6e229f52dd06":"7rUxs","82d177280122f548":"a9MW8","90cc91eebf142ada":"2d9kK","e7e522da2f278f10":"bBR3L","fb666d923197f87c":"7E8r1","80744f6562b338ea":"iXoA0","ee587d54683059a6":"ffyQa","a56ac5c959bfef28":"7qJz3","5aab33abc3a6da36":"gXmbc","3ce68b0125e96bf6":"4B7R6","c8f1314caf5497ae":"hHqp2","3fa8e6dd2779012f":"1hmMF","d4c7c23d646c2b3e":"92fRB","db7f6218bc105b4d":"e8ykP","20733d75d928612f":"arko1","a0fc215076b75c08":"cT2kE","cd71f477210352ce":"ccSTU","29cd4ec8cb9a6e04":"fqv7U","ff0f3c3312315693":"hUvf4","1c57ea657291aa14":"5p8IA","c9da3dc54ea3ad07":"aOraN","335c9c9543af8469":"eWYA2"}],"O6XD0":[function(require,module,exports) {
"use strict";
var Sugar = require("b18cf41f822cc9f0"), clone = require("da9d3b161fc32473"), mergeWithOptions = require("a085f4ea99dbbd1c");
Sugar.Object.defineInstanceAndStatic({
    "add": function(obj1, obj2, opts) {
        return mergeWithOptions(clone(obj1), obj2, opts);
    }
});
module.exports = Sugar.Object.add;

},{"b18cf41f822cc9f0":"eWYA2","da9d3b161fc32473":"10sjn","a085f4ea99dbbd1c":"i6pKq"}],"10sjn":[function(require,module,exports) {
"use strict";
var objectMerge = require("f57257c17d0e3f9a"), getNewObjectForMerge = require("54ab0940c33f97f0");
function clone(source, deep) {
    var target = getNewObjectForMerge(source);
    return objectMerge(target, source, deep, true, true, true);
}
module.exports = clone;

},{"f57257c17d0e3f9a":"g0mPj","54ab0940c33f97f0":"3UsoI"}],"g0mPj":[function(require,module,exports) {
"use strict";
var Sugar = require("e56446f96aeca5e5"), isDefined = require("5d38fcc1cd228f4a"), classChecks = require("e4cd4e4582400a64"), isPrimitive = require("9df2188e27298985"), isUndefined = require("f9e05f785587c42"), isObjectType = require("dd81d0f7538881ba"), coreUtilityAliases = require("24d920683f5c194"), getOwnPropertyNames = require("e0b055efa6fa0362"), getNewObjectForMerge = require("65bcfa557019aebb"), iterateOverProperties = require("fed487fc4ada8b55"), coercePrimitiveToObject = require("128d066dc85aa6cd"), mergeByPropertyDescriptor = require("41bbdeef363ca4db");
var isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction, getOwn = coreUtilityAliases.getOwn;
function objectMerge(target, source, deep, resolve, hidden, descriptor) {
    var resolveByFunction = isFunction(resolve), resolveConflicts = resolve !== false;
    if (isUndefined(target)) target = getNewObjectForMerge(source);
    else if (resolveConflicts && isDate(target) && isDate(source)) // A date's timestamp is a property that can only be reached through its
    // methods, so actively set it up front if both are dates.
    target.setTime(source.getTime());
    if (isPrimitive(target)) // Will not merge into a primitive type, so simply override.
    return source;
    // If the source object is a primitive
    // type then coerce it into an object.
    if (isPrimitive(source)) source = coercePrimitiveToObject(source);
    iterateOverProperties(hidden, source, function(val, key) {
        var sourceVal, targetVal, resolved, goDeep, result;
        sourceVal = source[key];
        // We are iterating over properties of the source, so hasOwnProperty on
        // it is guaranteed to always be true. However, the target may happen to
        // have properties in its prototype chain that should not be considered
        // as conflicts.
        targetVal = getOwn(target, key);
        if (resolveByFunction) {
            result = resolve(key, targetVal, sourceVal, target, source);
            if (isUndefined(result)) // Result is undefined so do not merge this property.
            return;
            else if (isDefined(result) && result !== Sugar) {
                // If the source returns anything except undefined, then the conflict
                // has been resolved, so don't continue traversing into the object. If
                // the returned value is the Sugar global object, then allowing Sugar
                // to resolve the conflict, so continue on.
                sourceVal = result;
                resolved = true;
            }
        } else if (isUndefined(sourceVal)) // Will not merge undefined.
        return;
        // Regex properties are read-only, so intentionally disallowing deep
        // merging for now. Instead merge by reference even if deep.
        goDeep = !resolved && deep && isObjectType(sourceVal) && !isRegExp(sourceVal);
        if (!goDeep && !resolveConflicts && isDefined(targetVal)) return;
        if (goDeep) sourceVal = objectMerge(targetVal, sourceVal, deep, resolve, hidden, descriptor);
        // getOwnPropertyNames is standing in as
        // a test for property descriptor support
        if (getOwnPropertyNames && descriptor) mergeByPropertyDescriptor(target, source, key, sourceVal);
        else target[key] = sourceVal;
    });
    return target;
}
module.exports = objectMerge;

},{"e56446f96aeca5e5":"eWYA2","5d38fcc1cd228f4a":"6Ge6e","e4cd4e4582400a64":"lUOLF","9df2188e27298985":"jzeAF","f9e05f785587c42":"hnApm","dd81d0f7538881ba":"l3TUh","24d920683f5c194":"dU8Nu","e0b055efa6fa0362":"lRUBk","65bcfa557019aebb":"3UsoI","fed487fc4ada8b55":"jeO93","128d066dc85aa6cd":"3zTir","41bbdeef363ca4db":"lvH2A"}],"lRUBk":[function(require,module,exports) {
"use strict";
module.exports = Object.getOwnPropertyNames;

},{}],"3UsoI":[function(require,module,exports) {
"use strict";
var classChecks = require("afdf68c9d903263e"), isPrimitive = require("7f15152675bcb868"), isPlainObject = require("92c68444a4049033"), getRegExpFlags = require("35ffae192874aa3c"), coreUtilityAliases = require("8ba3c8dc03d64238");
var classToString = coreUtilityAliases.classToString, isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isArray = classChecks.isArray;
function getNewObjectForMerge(source) {
    var klass = classToString(source);
    // Primitive types, dates, and regexes have no "empty" state. If they exist
    // at all, then they have an associated value. As we are only creating new
    // objects when they don't exist in the target, these values can come alone
    // for the ride when created.
    if (isArray(source, klass)) return [];
    else if (isPlainObject(source, klass)) return {};
    else if (isDate(source, klass)) return new Date(source.getTime());
    else if (isRegExp(source, klass)) return RegExp(source.source, getRegExpFlags(source));
    else if (isPrimitive(source && source.valueOf())) return source;
    // If the object is not of a known type, then simply merging its
    // properties into a plain object will result in something different
    // (it will not respond to instanceof operator etc). Similarly we don't
    // want to call a constructor here as we can't know for sure what the
    // original constructor was called with (Events etc), so throw an
    // error here instead. Non-standard types can be handled if either they
    // already exist and simply have their properties merged, if the merge
    // is not deep so their references will simply be copied over, or if a
    // resolve function is used to assist the merge.
    throw new TypeError("Must be a basic data type");
}
module.exports = getNewObjectForMerge;

},{"afdf68c9d903263e":"lUOLF","7f15152675bcb868":"jzeAF","92c68444a4049033":"byAbX","35ffae192874aa3c":"658bK","8ba3c8dc03d64238":"dU8Nu"}],"jeO93":[function(require,module,exports) {
"use strict";
var iterateOverKeys = require("4d18a6b3ae2954a3"), coreUtilityAliases = require("3e8f61acd698eb9d"), getOwnPropertyNames = require("b54b24af70f2315e"), getOwnPropertySymbols = require("b21a217167593d25");
var forEachProperty = coreUtilityAliases.forEachProperty;
function iterateOverProperties(hidden, obj, fn) {
    if (getOwnPropertyNames && hidden) iterateOverKeys(getOwnPropertyNames, obj, fn, hidden);
    else forEachProperty(obj, fn);
    if (getOwnPropertySymbols) iterateOverKeys(getOwnPropertySymbols, obj, fn, hidden);
}
module.exports = iterateOverProperties;

},{"4d18a6b3ae2954a3":"k8F0e","3e8f61acd698eb9d":"dU8Nu","b54b24af70f2315e":"lRUBk","b21a217167593d25":"d3c6j"}],"k8F0e":[function(require,module,exports) {
"use strict";
var getOwnPropertyDescriptor = require("588b33cd20c7c3f4");
function iterateOverKeys(getFn, obj, fn, hidden) {
    var keys = getFn(obj), desc;
    for(var i = 0, key; key = keys[i]; i++){
        desc = getOwnPropertyDescriptor(obj, key);
        if (desc.enumerable || hidden) fn(obj[key], key);
    }
}
module.exports = iterateOverKeys;

},{"588b33cd20c7c3f4":"lFTDe"}],"lFTDe":[function(require,module,exports) {
"use strict";
module.exports = Object.getOwnPropertyDescriptor;

},{}],"d3c6j":[function(require,module,exports) {
"use strict";
module.exports = Object.getOwnPropertySymbols;

},{}],"3zTir":[function(require,module,exports) {
"use strict";
var NO_KEYS_IN_STRING_OBJECTS = require("53fa8d70c6e6c8a8"), isPrimitive = require("be3e3cbfe8bf8664"), classChecks = require("63a1cd03e452a855"), forceStringCoercion = require("398922db6fcb4f3f");
var isString = classChecks.isString;
function coercePrimitiveToObject(obj) {
    if (isPrimitive(obj)) obj = Object(obj);
    // istanbul ignore next
    if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) forceStringCoercion(obj);
    return obj;
}
module.exports = coercePrimitiveToObject;

},{"53fa8d70c6e6c8a8":"3BfWL","be3e3cbfe8bf8664":"jzeAF","63a1cd03e452a855":"lUOLF","398922db6fcb4f3f":"6DKaw"}],"3BfWL":[function(require,module,exports) {
"use strict";
module.exports = !("0" in Object("a"));

},{}],"6DKaw":[function(require,module,exports) {
"use strict";
function forceStringCoercion(obj) {
    var i = 0, chr;
    while(chr = obj.charAt(i))obj[i++] = chr;
}
module.exports = forceStringCoercion;

},{}],"lvH2A":[function(require,module,exports) {
"use strict";
var isDefined = require("abbcc83865867ff8"), coreUtilityAliases = require("fbf47fcbb3a5c008"), getOwnPropertyDescriptor = require("1a320283fd0db90");
var defineProperty = coreUtilityAliases.defineProperty;
function mergeByPropertyDescriptor(target, source, prop, sourceVal) {
    var descriptor = getOwnPropertyDescriptor(source, prop);
    if (isDefined(descriptor.value)) descriptor.value = sourceVal;
    defineProperty(target, prop, descriptor);
}
module.exports = mergeByPropertyDescriptor;

},{"abbcc83865867ff8":"6Ge6e","fbf47fcbb3a5c008":"dU8Nu","1a320283fd0db90":"lFTDe"}],"i6pKq":[function(require,module,exports) {
"use strict";
var objectMerge = require("19b51ec97b5a4431");
function mergeWithOptions(target, source, opts) {
    opts = opts || {};
    return objectMerge(target, source, opts.deep, opts.resolve, opts.hidden, opts.descriptor);
}
module.exports = mergeWithOptions;

},{"19b51ec97b5a4431":"g0mPj"}],"8EVNG":[function(require,module,exports) {
"use strict";
var Sugar = require("1d260745c09e4952"), clone = require("7bce03497536c508"), mergeAll = require("3fc5d36ddba8778");
Sugar.Object.defineInstanceAndStatic({
    "addAll": function(obj, sources, opts) {
        return mergeAll(clone(obj), sources, opts);
    }
});
module.exports = Sugar.Object.addAll;

},{"1d260745c09e4952":"eWYA2","7bce03497536c508":"10sjn","3fc5d36ddba8778":"bcmw6"}],"bcmw6":[function(require,module,exports) {
"use strict";
var forEach = require("9b9c3dbd82196b72"), classChecks = require("677360e9d4fc1fb1"), mergeWithOptions = require("919841d4db306f2e");
var isArray = classChecks.isArray;
function mergeAll(target, sources, opts) {
    if (!isArray(sources)) sources = [
        sources
    ];
    forEach(sources, function(source) {
        return mergeWithOptions(target, source, opts);
    });
    return target;
}
module.exports = mergeAll;

},{"9b9c3dbd82196b72":"1n2CK","677360e9d4fc1fb1":"lUOLF","919841d4db306f2e":"i6pKq"}],"7DA22":[function(require,module,exports) {
"use strict";
var Sugar = require("870f5b4c4b416988"), clone = require("1c3a09e917b1c14d");
Sugar.Object.defineInstanceAndStatic({
    "clone": function(obj, deep) {
        return clone(obj, deep);
    }
});
module.exports = Sugar.Object.clone;

},{"870f5b4c4b416988":"eWYA2","1c3a09e917b1c14d":"10sjn"}],"jGo20":[function(require,module,exports) {
"use strict";
var Sugar = require("b5fee81862e6e8f0"), defaults = require("c84bbb27b688cbc0");
Sugar.Object.defineInstanceAndStatic({
    "defaults": function(target, sources, opts) {
        return defaults(target, sources, opts);
    }
});
module.exports = Sugar.Object.defaults;

},{"b5fee81862e6e8f0":"eWYA2","c84bbb27b688cbc0":"5QTrt"}],"5QTrt":[function(require,module,exports) {
"use strict";
var mergeAll = require("2279c5134bde286e");
function defaults(target, sources, opts) {
    opts = opts || {};
    opts.resolve = opts.resolve || false;
    return mergeAll(target, sources, opts);
}
module.exports = defaults;

},{"2279c5134bde286e":"bcmw6"}],"kXfSd":[function(require,module,exports) {
"use strict";
var Sugar = require("23871ca4067e6edb"), objectExclude = require("92073976e7b467d3");
Sugar.Object.defineInstanceAndStatic({
    "exclude": function(obj, f) {
        return objectExclude(obj, f);
    }
});
module.exports = Sugar.Object.exclude;

},{"23871ca4067e6edb":"eWYA2","92073976e7b467d3":"7ISOP"}],"7ISOP":[function(require,module,exports) {
"use strict";
var getMatcher = require("20611c639a055133"), coreUtilityAliases = require("cad537b816c051ed");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectExclude(obj, f) {
    var result = {};
    var matcher = getMatcher(f);
    forEachProperty(obj, function(val, key) {
        if (!matcher(val, key, obj)) result[key] = val;
    });
    return result;
}
module.exports = objectExclude;

},{"20611c639a055133":"3InyL","cad537b816c051ed":"dU8Nu"}],"cagrz":[function(require,module,exports) {
"use strict";
var Sugar = require("5ffe05fded543fd0"), fromQueryStringWithOptions = require("928d9f10df5f17c5");
Sugar.Object.defineStatic({
    "fromQueryString": function(obj, options) {
        return fromQueryStringWithOptions(obj, options);
    }
});
module.exports = Sugar.Object.fromQueryString;

},{"5ffe05fded543fd0":"eWYA2","928d9f10df5f17c5":"joUyu"}],"joUyu":[function(require,module,exports) {
"use strict";
var forEach = require("8e64e86ae9c61253"), parseQueryComponent = require("358e7925b2eb66c7");
function fromQueryStringWithOptions(obj, opts) {
    var str = String(obj || "").replace(/^.*?\?/, ""), result = {}, auto;
    opts = opts || {};
    if (str) forEach(str.split("&"), function(p) {
        var split = p.split("=");
        var key = decodeURIComponent(split[0]);
        var val = split.length === 2 ? decodeURIComponent(split[1]) : "";
        auto = opts.auto !== false;
        parseQueryComponent(result, key, val, opts.deep, auto, opts.separator, opts.transform);
    });
    return result;
}
module.exports = fromQueryStringWithOptions;

},{"8e64e86ae9c61253":"1n2CK","358e7925b2eb66c7":"7ukPI"}],"7ukPI":[function(require,module,exports) {
"use strict";
var DEEP_QUERY_STRING_REG = require("7977aa7f4a88c2ae"), setQueryProperty = require("98c2e92291601238"), mapQuerySeparatorToKeys = require("ef6a157e43fa59b6"), parseDeepQueryComponent = require("5f7f60ef4f7b6843");
function parseQueryComponent(obj, key, val, deep, auto, separator, transform) {
    var match;
    if (separator) {
        key = mapQuerySeparatorToKeys(key, separator);
        deep = true;
    }
    if (deep === true && (match = key.match(DEEP_QUERY_STRING_REG))) parseDeepQueryComponent(obj, match, val, deep, auto, separator, transform);
    else setQueryProperty(obj, key, val, auto, transform);
}
module.exports = parseQueryComponent;

},{"7977aa7f4a88c2ae":"kMWPa","98c2e92291601238":"1gQHZ","ef6a157e43fa59b6":"5QTFs","5f7f60ef4f7b6843":"a5WiA"}],"kMWPa":[function(require,module,exports) {
"use strict";
module.exports = /^(.+?)(\[.*\])$/;

},{}],"1gQHZ":[function(require,module,exports) {
"use strict";
var isDefined = require("be076bf53da58ab9"), getQueryValueAuto = require("7ba0c6578f8a2ee7");
function setQueryProperty(obj, key, val, auto, transform) {
    var fnValue;
    if (transform) fnValue = transform(val, key, obj);
    if (isDefined(fnValue)) val = fnValue;
    else if (auto) val = getQueryValueAuto(obj, key, val);
    obj[key] = val;
}
module.exports = setQueryProperty;

},{"be076bf53da58ab9":"6Ge6e","7ba0c6578f8a2ee7":"5zf8e"}],"5zf8e":[function(require,module,exports) {
"use strict";
var classChecks = require("588fe39a208e86a5"), stringIsDecimal = require("ad4be148ef80747b"), coreUtilityAliases = require("fea29e780beb1204");
var getOwn = coreUtilityAliases.getOwn, isArray = classChecks.isArray;
function getQueryValueAuto(obj, key, val) {
    if (!val) return null;
    else if (val === "true") return true;
    else if (val === "false") return false;
    var num = +val;
    if (!isNaN(num) && stringIsDecimal(val)) return num;
    var existing = getOwn(obj, key);
    if (val && existing) return isArray(existing) ? existing.concat(val) : [
        existing,
        val
    ];
    return val;
}
module.exports = getQueryValueAuto;

},{"588fe39a208e86a5":"lUOLF","ad4be148ef80747b":"4wNWC","fea29e780beb1204":"dU8Nu"}],"4wNWC":[function(require,module,exports) {
"use strict";
var NON_DECIMAL_REG = require("476906fa0a173555");
function stringIsDecimal(str) {
    return str !== "" && !NON_DECIMAL_REG.test(str);
}
module.exports = stringIsDecimal;

},{"476906fa0a173555":"hXHGK"}],"hXHGK":[function(require,module,exports) {
"use strict";
module.exports = /[^\d.-]/;

},{}],"5QTFs":[function(require,module,exports) {
"use strict";
function mapQuerySeparatorToKeys(key, separator) {
    var split = key.split(separator), result = split[0];
    for(var i = 1, len = split.length; i < len; i++)result += "[" + split[i] + "]";
    return result;
}
module.exports = mapQuerySeparatorToKeys;

},{}],"a5WiA":[function(require,module,exports) {
"use strict";
var forEach = require("dce5d5c15e37c9f4"), setQueryProperty = require("21fc31b9c8e3e29f"), coreUtilityAliases = require("3d7f43547ee08c1b");
var hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn;
function parseDeepQueryComponent(obj, match, val, deep, auto, separator, transform) {
    var key = match[1];
    var inner = match[2].slice(1, -1).split("][");
    forEach(inner, function(k) {
        if (!hasOwn(obj, key)) obj[key] = k ? {} : [];
        obj = getOwn(obj, key);
        key = k ? k : obj.length.toString();
    });
    setQueryProperty(obj, key, val, auto, transform);
}
module.exports = parseDeepQueryComponent;

},{"dce5d5c15e37c9f4":"1n2CK","21fc31b9c8e3e29f":"1gQHZ","3d7f43547ee08c1b":"dU8Nu"}],"g3GEg":[function(require,module,exports) {
"use strict";
var Sugar = require("e9c9799c85dd16a"), deepGetProperty = require("3b9df22b6c2d92b");
Sugar.Object.defineInstanceAndStatic({
    "get": function(obj, key, any) {
        return deepGetProperty(obj, key, any);
    }
});
module.exports = Sugar.Object.get;

},{"e9c9799c85dd16a":"eWYA2","3b9df22b6c2d92b":"fxfTs"}],"94lL2":[function(require,module,exports) {
"use strict";
var Sugar = require("f675c06019cd6ad1"), deepHasProperty = require("4ff42eeec4c5d0f3");
Sugar.Object.defineInstanceAndStatic({
    "has": function(obj, key, any) {
        return deepHasProperty(obj, key, any);
    }
});
module.exports = Sugar.Object.has;

},{"f675c06019cd6ad1":"eWYA2","4ff42eeec4c5d0f3":"fGkab"}],"fGkab":[function(require,module,exports) {
"use strict";
var handleDeepProperty = require("c0cc8f4c5faa4ed8");
function deepHasProperty(obj, key, any) {
    return handleDeepProperty(obj, key, any, true);
}
module.exports = deepHasProperty;

},{"c0cc8f4c5faa4ed8":"6pPpG"}],"2moQU":[function(require,module,exports) {
"use strict";
var Sugar = require("54af3b088c4d7ac0"), objectIntersectOrSubtract = require("48dd66c603b47cac");
Sugar.Object.defineInstanceAndStatic({
    "intersect": function(obj1, obj2) {
        return objectIntersectOrSubtract(obj1, obj2, false);
    }
});
module.exports = Sugar.Object.intersect;

},{"54af3b088c4d7ac0":"eWYA2","48dd66c603b47cac":"dFQrr"}],"dFQrr":[function(require,module,exports) {
"use strict";
var isEqual = require("e996b100d8d7ee85"), objectMerge = require("79987f748b461d64"), isObjectType = require("9c45e295d05730e6"), coercePrimitiveToObject = require("2f41a52976c4ff92");
function objectIntersectOrSubtract(obj1, obj2, subtract) {
    if (!isObjectType(obj1)) return subtract ? obj1 : {};
    obj2 = coercePrimitiveToObject(obj2);
    function resolve(key, val, val1) {
        var exists = key in obj2 && isEqual(val1, obj2[key]);
        if (exists !== subtract) return val1;
    }
    return objectMerge({}, obj1, false, resolve);
}
module.exports = objectIntersectOrSubtract;

},{"e996b100d8d7ee85":"jiWWj","79987f748b461d64":"g0mPj","9c45e295d05730e6":"l3TUh","2f41a52976c4ff92":"3zTir"}],"atmmj":[function(require,module,exports) {
"use strict";
var Sugar = require("6dc6ad59eccec75f"), coreUtilityAliases = require("29410cfef3ac142");
var hasOwn = coreUtilityAliases.hasOwn, forEachProperty = coreUtilityAliases.forEachProperty;
Sugar.Object.defineInstanceAndStatic({
    "invert": function(obj, multi) {
        var result = {};
        multi = multi === true;
        forEachProperty(obj, function(val, key) {
            if (hasOwn(result, val) && multi) result[val].push(key);
            else if (multi) result[val] = [
                key
            ];
            else result[val] = key;
        });
        return result;
    }
});
module.exports = Sugar.Object.invert;

},{"6dc6ad59eccec75f":"eWYA2","29410cfef3ac142":"dU8Nu"}],"iXGSD":[function(require,module,exports) {
"use strict";
var Sugar = require("1108bd3af148b57"), isArguments = require("9e4d9149f252abb7");
Sugar.Object.defineInstanceAndStatic({
    "isArguments": function(obj) {
        return isArguments(obj);
    }
});
module.exports = Sugar.Object.isArguments;

},{"1108bd3af148b57":"eWYA2","9e4d9149f252abb7":"VuBMF"}],"VuBMF":[function(require,module,exports) {
"use strict";
var hasProperty = require("f76c97fc81cb55f6"), coreUtilityAliases = require("3f152109f3d14c79");
var classToString = coreUtilityAliases.classToString;
function isArguments(obj, className) {
    className = className || classToString(obj);
    // .callee exists on Arguments objects in < IE8
    return hasProperty(obj, "length") && (className === "[object Arguments]" || !!obj.callee);
}
module.exports = isArguments;

},{"f76c97fc81cb55f6":"jqwrq","3f152109f3d14c79":"dU8Nu"}],"jqwrq":[function(require,module,exports) {
"use strict";
var isPrimitive = require("8d3858abeccaa90b");
function hasProperty(obj, prop) {
    return !isPrimitive(obj) && prop in obj;
}
module.exports = hasProperty;

},{"8d3858abeccaa90b":"jzeAF"}],"hyRZW":[function(require,module,exports) {
"use strict";
var Sugar = require("18f84cc44fa12d8a");
require("ba507c6bf91822c4");
module.exports = Sugar.Object.isArray;

},{"18f84cc44fa12d8a":"eWYA2","ba507c6bf91822c4":"2Hau1"}],"2Hau1":[function(require,module,exports) {
"use strict";
var buildClassCheckMethods = require("ee0c9824ae34accf");
buildClassCheckMethods();

},{"ee0c9824ae34accf":"iNMTg"}],"iNMTg":[function(require,module,exports) {
"use strict";
var NATIVE_TYPES = require("ad06e6966af14156"), classChecks = require("94d384e0035fb31c"), namespaceAliases = require("43183132912008fa"), defineInstanceAndStaticSimilar = require("f4f64f4ab83fa8aa");
var isBoolean = classChecks.isBoolean, isNumber = classChecks.isNumber, isString = classChecks.isString, isDate = classChecks.isDate, isRegExp = classChecks.isRegExp, isFunction = classChecks.isFunction, isArray = classChecks.isArray, isSet = classChecks.isSet, isMap = classChecks.isMap, isError = classChecks.isError, sugarObject = namespaceAliases.sugarObject;
function buildClassCheckMethods() {
    var checks = [
        isBoolean,
        isNumber,
        isString,
        isDate,
        isRegExp,
        isFunction,
        isArray,
        isError,
        isSet,
        isMap
    ];
    defineInstanceAndStaticSimilar(sugarObject, NATIVE_TYPES, function(methods, name, i) {
        methods["is" + name] = checks[i];
    });
}
module.exports = buildClassCheckMethods;

},{"ad06e6966af14156":"iwfp4","94d384e0035fb31c":"lUOLF","43183132912008fa":"1TEpR","f4f64f4ab83fa8aa":"8kzhK"}],"8kzhK":[function(require,module,exports) {
"use strict";
var methodDefineAliases = require("18c3ed57cc212b69"), collectSimilarMethods = require("46a5b5ac10e6bf63");
var defineInstanceAndStatic = methodDefineAliases.defineInstanceAndStatic;
function defineInstanceAndStaticSimilar(sugarNamespace, set, fn, flags) {
    defineInstanceAndStatic(sugarNamespace, collectSimilarMethods(set, fn), flags);
}
module.exports = defineInstanceAndStaticSimilar;

},{"18c3ed57cc212b69":"l2cG2","46a5b5ac10e6bf63":"bQRtP"}],"aRJL2":[function(require,module,exports) {
"use strict";
var Sugar = require("17427c75e387cfe6");
require("4b13a69138932c91");
module.exports = Sugar.Object.isBoolean;

},{"17427c75e387cfe6":"eWYA2","4b13a69138932c91":"2Hau1"}],"1RUbu":[function(require,module,exports) {
"use strict";
var Sugar = require("452a1667f330de40");
require("4ddffd13f2008fa9");
module.exports = Sugar.Object.isDate;

},{"452a1667f330de40":"eWYA2","4ddffd13f2008fa9":"2Hau1"}],"jry3Z":[function(require,module,exports) {
"use strict";
var Sugar = require("34590ea284310333"), objectSize = require("5a622b31aae4e589");
Sugar.Object.defineInstanceAndStatic({
    "isEmpty": function(obj) {
        return objectSize(obj) === 0;
    }
});
module.exports = Sugar.Object.isEmpty;

},{"34590ea284310333":"eWYA2","5a622b31aae4e589":"ehaua"}],"ehaua":[function(require,module,exports) {
"use strict";
var getKeysWithObjectCoercion = require("7acc791c6c8abc23");
function objectSize(obj) {
    return getKeysWithObjectCoercion(obj).length;
}
module.exports = objectSize;

},{"7acc791c6c8abc23":"5aXhk"}],"5aXhk":[function(require,module,exports) {
"use strict";
var getKeys = require("1fcbe40a45b0f253"), coercePrimitiveToObject = require("15578a046ed3d17e");
function getKeysWithObjectCoercion(obj) {
    return getKeys(coercePrimitiveToObject(obj));
}
module.exports = getKeysWithObjectCoercion;

},{"1fcbe40a45b0f253":"6cOTr","15578a046ed3d17e":"3zTir"}],"7rUxs":[function(require,module,exports) {
"use strict";
var Sugar = require("7cd082fe30e606c8"), isEqual = require("2a82a1439bd4dbbb");
Sugar.Object.defineInstanceAndStatic({
    "isEqual": function(obj1, obj2) {
        return isEqual(obj1, obj2);
    }
});
module.exports = Sugar.Object.isEqual;

},{"7cd082fe30e606c8":"eWYA2","2a82a1439bd4dbbb":"jiWWj"}],"a9MW8":[function(require,module,exports) {
"use strict";
var Sugar = require("eb7d5de73882eb1c");
require("f38a99ecd2d02de7");
module.exports = Sugar.Object.isError;

},{"eb7d5de73882eb1c":"eWYA2","f38a99ecd2d02de7":"2Hau1"}],"2d9kK":[function(require,module,exports) {
"use strict";
var Sugar = require("705a011efb95e2e6");
require("6626c9c5eda4d34");
module.exports = Sugar.Object.isFunction;

},{"705a011efb95e2e6":"eWYA2","6626c9c5eda4d34":"2Hau1"}],"bBR3L":[function(require,module,exports) {
"use strict";
var Sugar = require("1756c7d785120da5");
require("19ea55072645b4bc");
module.exports = Sugar.Object.isMap;

},{"1756c7d785120da5":"eWYA2","19ea55072645b4bc":"2Hau1"}],"7E8r1":[function(require,module,exports) {
"use strict";
var Sugar = require("a02d2e608dacf929");
require("1d715db7d5132c8b");
module.exports = Sugar.Object.isNumber;

},{"a02d2e608dacf929":"eWYA2","1d715db7d5132c8b":"2Hau1"}],"iXoA0":[function(require,module,exports) {
"use strict";
var Sugar = require("f9794a65bcf63515"), isPlainObject = require("38b0e73abddc7338");
Sugar.Object.defineInstanceAndStatic({
    "isObject": function(obj) {
        return isPlainObject(obj);
    }
});
module.exports = Sugar.Object.isObject;

},{"f9794a65bcf63515":"eWYA2","38b0e73abddc7338":"byAbX"}],"ffyQa":[function(require,module,exports) {
"use strict";
var Sugar = require("3104b8e43ce4fbaa");
require("2d5c3463f076740e");
module.exports = Sugar.Object.isRegExp;

},{"3104b8e43ce4fbaa":"eWYA2","2d5c3463f076740e":"2Hau1"}],"7qJz3":[function(require,module,exports) {
"use strict";
var Sugar = require("1d9ca9c85436ca7a");
require("58486c7071b91dad");
module.exports = Sugar.Object.isSet;

},{"1d9ca9c85436ca7a":"eWYA2","58486c7071b91dad":"2Hau1"}],"gXmbc":[function(require,module,exports) {
"use strict";
var Sugar = require("803950d61e1ad159");
require("88736380b1f5fb9f");
module.exports = Sugar.Object.isString;

},{"803950d61e1ad159":"eWYA2","88736380b1f5fb9f":"2Hau1"}],"4B7R6":[function(require,module,exports) {
"use strict";
var Sugar = require("47adf2771f308b13"), mergeWithOptions = require("200835d21ad9df60");
Sugar.Object.defineInstanceAndStatic({
    "merge": function(target, source, opts) {
        return mergeWithOptions(target, source, opts);
    }
});
module.exports = Sugar.Object.merge;

},{"47adf2771f308b13":"eWYA2","200835d21ad9df60":"i6pKq"}],"hHqp2":[function(require,module,exports) {
"use strict";
var Sugar = require("4463ef43adda8beb"), mergeAll = require("17837a07f867737b");
Sugar.Object.defineInstanceAndStatic({
    "mergeAll": function(target, sources, opts) {
        return mergeAll(target, sources, opts);
    }
});
module.exports = Sugar.Object.mergeAll;

},{"4463ef43adda8beb":"eWYA2","17837a07f867737b":"bcmw6"}],"1hmMF":[function(require,module,exports) {
"use strict";
var Sugar = require("60e31f5f678aedb1"), objectReject = require("1d77c3163bcd836c");
Sugar.Object.defineInstanceAndStatic({
    "reject": function(obj, f) {
        return objectReject(obj, f);
    }
});
module.exports = Sugar.Object.reject;

},{"60e31f5f678aedb1":"eWYA2","1d77c3163bcd836c":"8eXnb"}],"8eXnb":[function(require,module,exports) {
"use strict";
var selectFromObject = require("1a354dfffd2d1190");
function objectReject(obj, f) {
    return selectFromObject(obj, f, false);
}
module.exports = objectReject;

},{"1a354dfffd2d1190":"8ULYh"}],"8ULYh":[function(require,module,exports) {
"use strict";
var matchInObject = require("9ef4d087d11725c7"), coreUtilityAliases = require("69ef3b4d9cc8373");
var forEachProperty = coreUtilityAliases.forEachProperty;
function selectFromObject(obj, f, select) {
    var match, result = {};
    f = [].concat(f);
    forEachProperty(obj, function(val, key) {
        match = false;
        for(var i = 0; i < f.length; i++)if (matchInObject(f[i], key)) match = true;
        if (match === select) result[key] = val;
    });
    return result;
}
module.exports = selectFromObject;

},{"9ef4d087d11725c7":"4QF85","69ef3b4d9cc8373":"dU8Nu"}],"4QF85":[function(require,module,exports) {
"use strict";
var classChecks = require("a0d25f792f651e2e"), isObjectType = require("8fe92da33337e7f7");
var isRegExp = classChecks.isRegExp;
function matchInObject(match, key) {
    if (isRegExp(match)) return match.test(key);
    else if (isObjectType(match)) return key in match;
    else return key === String(match);
}
module.exports = matchInObject;

},{"a0d25f792f651e2e":"lUOLF","8fe92da33337e7f7":"l3TUh"}],"92fRB":[function(require,module,exports) {
"use strict";
var Sugar = require("dc8ab56afa0c4e37"), objectRemove = require("7ec380744293932f");
Sugar.Object.defineInstanceAndStatic({
    "remove": function(obj, f) {
        return objectRemove(obj, f);
    }
});
module.exports = Sugar.Object.remove;

},{"dc8ab56afa0c4e37":"eWYA2","7ec380744293932f":"iIN5s"}],"iIN5s":[function(require,module,exports) {
"use strict";
var getMatcher = require("950f56892a02f93f"), coreUtilityAliases = require("cb3cba6574d84887");
var forEachProperty = coreUtilityAliases.forEachProperty;
function objectRemove(obj, f) {
    var matcher = getMatcher(f);
    forEachProperty(obj, function(val, key) {
        if (matcher(val, key, obj)) delete obj[key];
    });
    return obj;
}
module.exports = objectRemove;

},{"950f56892a02f93f":"3InyL","cb3cba6574d84887":"dU8Nu"}],"e8ykP":[function(require,module,exports) {
"use strict";
var Sugar = require("b17e8cccc1fcccd2"), objectSelect = require("e802716444991082");
Sugar.Object.defineInstanceAndStatic({
    "select": function(obj, f) {
        return objectSelect(obj, f);
    }
});
module.exports = Sugar.Object.select;

},{"b17e8cccc1fcccd2":"eWYA2","e802716444991082":"4u1DD"}],"4u1DD":[function(require,module,exports) {
"use strict";
var selectFromObject = require("f2912d9ca0d2f823");
function objectSelect(obj, f) {
    return selectFromObject(obj, f, true);
}
module.exports = objectSelect;

},{"f2912d9ca0d2f823":"8ULYh"}],"arko1":[function(require,module,exports) {
"use strict";
var Sugar = require("97e36e37f013f6cb"), deepSetProperty = require("73bd16fcf25dace2");
Sugar.Object.defineInstanceAndStatic({
    "set": function(obj, key, val) {
        return deepSetProperty(obj, key, val);
    }
});
module.exports = Sugar.Object.set;

},{"97e36e37f013f6cb":"eWYA2","73bd16fcf25dace2":"dZOlR"}],"dZOlR":[function(require,module,exports) {
"use strict";
var handleDeepProperty = require("5841b882017ea4f1");
function deepSetProperty(obj, key, val) {
    handleDeepProperty(obj, key, false, false, true, false, val);
    return obj;
}
module.exports = deepSetProperty;

},{"5841b882017ea4f1":"6pPpG"}],"cT2kE":[function(require,module,exports) {
"use strict";
var Sugar = require("9beb879640bd282e"), objectSize = require("ac18d775179c61be");
Sugar.Object.defineInstanceAndStatic({
    "size": function(obj) {
        return objectSize(obj);
    }
});
module.exports = Sugar.Object.size;

},{"9beb879640bd282e":"eWYA2","ac18d775179c61be":"ehaua"}],"ccSTU":[function(require,module,exports) {
"use strict";
var Sugar = require("ad53fd3a8b926dc6"), objectIntersectOrSubtract = require("5af96a8916d241de");
Sugar.Object.defineInstanceAndStatic({
    "subtract": function(obj1, obj2) {
        return objectIntersectOrSubtract(obj1, obj2, true);
    }
});
module.exports = Sugar.Object.subtract;

},{"ad53fd3a8b926dc6":"eWYA2","5af96a8916d241de":"dFQrr"}],"fqv7U":[function(require,module,exports) {
"use strict";
var Sugar = require("a2c9554adf059052"), tap = require("9e8977667f37b5ab");
Sugar.Object.defineInstanceAndStatic({
    "tap": function(obj, arg) {
        return tap(obj, arg);
    }
});
module.exports = Sugar.Object.tap;

},{"a2c9554adf059052":"eWYA2","9e8977667f37b5ab":"dinaQ"}],"dinaQ":[function(require,module,exports) {
"use strict";
var classChecks = require("95381a5662bf3abc");
var isFunction = classChecks.isFunction;
function tap(obj, arg) {
    var fn = arg;
    if (!isFunction(arg)) fn = function fn() {
        if (arg) obj[arg]();
    };
    fn.call(obj, obj);
    return obj;
}
module.exports = tap;

},{"95381a5662bf3abc":"lUOLF"}],"hUvf4":[function(require,module,exports) {
"use strict";
var Sugar = require("7f895fc60729f070"), toQueryStringWithOptions = require("2dfa17ba31d5e4f5");
Sugar.Object.defineInstanceAndStatic({
    "toQueryString": function(obj, options) {
        return toQueryStringWithOptions(obj, options);
    }
});
module.exports = Sugar.Object.toQueryString;

},{"7f895fc60729f070":"eWYA2","2dfa17ba31d5e4f5":"kZlGI"}],"kZlGI":[function(require,module,exports) {
"use strict";
var isUndefined = require("63939d6be03559c3"), toQueryString = require("da66bb86ccc1777e");
function toQueryStringWithOptions(obj, opts) {
    opts = opts || {};
    if (isUndefined(opts.separator)) opts.separator = "_";
    return toQueryString(obj, opts.deep, opts.transform, opts.prefix || "", opts.separator);
}
module.exports = toQueryStringWithOptions;

},{"63939d6be03559c3":"hnApm","da66bb86ccc1777e":"dxbaz"}],"dxbaz":[function(require,module,exports) {
"use strict";
var classChecks = require("1c249da6d2f28aae"), isObjectType = require("7a507b7dd840a0b0"), internalToString = require("44425a8c9c2a12bd"), coreUtilityAliases = require("1d7da3feb877f8f4"), getURIComponentValue = require("6d4664449b8bfec3"), sanitizeURIComponent = require("23d3bed4caaa711b");
var isArray = classChecks.isArray, forEachProperty = coreUtilityAliases.forEachProperty;
function toQueryString(obj, deep, transform, prefix, separator) {
    if (isArray(obj)) return collectArrayAsQueryString(obj, deep, transform, prefix, separator);
    else if (isObjectType(obj) && obj.toString === internalToString) return collectObjectAsQueryString(obj, deep, transform, prefix, separator);
    else if (prefix) return getURIComponentValue(obj, prefix, transform);
    return "";
}
function collectArrayAsQueryString(arr, deep, transform, prefix, separator) {
    var el, qc, key, result = [];
    // Intentionally treating sparse arrays as dense here by avoiding map,
    // otherwise indexes will shift during the process of serialization.
    for(var i = 0, len = arr.length; i < len; i++){
        el = arr[i];
        key = prefix + (prefix && deep ? "[]" : "");
        if (!key && !isObjectType(el)) // If there is no key, then the values of the array should be
        // considered as null keys, so use them instead;
        qc = sanitizeURIComponent(el);
        else qc = toQueryString(el, deep, transform, key, separator);
        result.push(qc);
    }
    return result.join("&");
}
function collectObjectAsQueryString(obj, deep, transform, prefix, separator) {
    var result = [];
    forEachProperty(obj, function(val, key) {
        var fullKey;
        if (prefix && deep) fullKey = prefix + "[" + key + "]";
        else if (prefix) fullKey = prefix + separator + key;
        else fullKey = key;
        result.push(toQueryString(val, deep, transform, fullKey, separator));
    });
    return result.join("&");
}
module.exports = toQueryString;

},{"1c249da6d2f28aae":"lUOLF","7a507b7dd840a0b0":"l3TUh","44425a8c9c2a12bd":"aX2YP","1d7da3feb877f8f4":"dU8Nu","6d4664449b8bfec3":"lA0sx","23d3bed4caaa711b":"6oDSv"}],"aX2YP":[function(require,module,exports) {
"use strict";
module.exports = Object.prototype.toString;

},{}],"lA0sx":[function(require,module,exports) {
"use strict";
var classChecks = require("ae072cc96087f473"), sanitizeURIComponent = require("27786b45f1d6df89");
var isDate = classChecks.isDate;
function getURIComponentValue(obj, prefix, transform) {
    var value;
    if (transform) value = transform(obj, prefix);
    else if (isDate(obj)) value = obj.getTime();
    else value = obj;
    return sanitizeURIComponent(prefix) + "=" + sanitizeURIComponent(value);
}
module.exports = getURIComponentValue;

},{"ae072cc96087f473":"lUOLF","27786b45f1d6df89":"6oDSv"}],"6oDSv":[function(require,module,exports) {
"use strict";
function sanitizeURIComponent(obj) {
    // undefined, null, and NaN are represented as a blank string,
    // while false and 0 are stringified.
    return !obj && obj !== false && obj !== 0 ? "" : encodeURIComponent(obj);
}
module.exports = sanitizeURIComponent;

},{}],"5p8IA":[function(require,module,exports) {
"use strict";
var Sugar = require("35c7edc98aff84c1"), getValues = require("6ddccc8933221ec0");
Sugar.Object.defineInstanceAndStatic({
    "values": function(obj) {
        return getValues(obj);
    }
});
module.exports = Sugar.Object.values;

},{"35c7edc98aff84c1":"eWYA2","6ddccc8933221ec0":"dPx0b"}],"dPx0b":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("1d4d2489262a1bd9");
var forEachProperty = coreUtilityAliases.forEachProperty;
function getValues(obj) {
    var values = [];
    forEachProperty(obj, function(val) {
        values.push(val);
    });
    return values;
}
module.exports = getValues;

},{"1d4d2489262a1bd9":"dU8Nu"}],"aOraN":[function(require,module,exports) {
"use strict";
var Sugar = require("3f1be903e72d814e"), getKeys = require("ab5b2c57128301f9");
Sugar.Object.defineInstance({
    "keys": function(obj) {
        return getKeys(obj);
    }
});
module.exports = Sugar.Object.keys;

},{"3f1be903e72d814e":"eWYA2","ab5b2c57128301f9":"6cOTr"}],"e9r6r":[function(require,module,exports) {
"use strict";
// Static Methods
require("1d13af8a37580ebe");
require("d2050545db2e592e");
require("d5ebf0b0e8da20b1");
require("17aeb18d107af4e9");
require("fa13bc2730a99d33");
require("b2ab7a48e0b930b2");
require("e77aa1b5c984e8d7");
// Instance Methods
require("58a032da46f5d694");
require("7368b386c34390ff");
require("3948fb48634a7872");
require("dd219133d0cdde23");
require("f118f5ef3738f15a");
require("ee9cb6f09cdecb4f");
require("d122b52bd5ae66f0");
require("a8159420af93eb52");
require("b941c6ea5e165e49");
require("92c03ffc7fddf435");
require("b6e7394ce186bdd1");
require("e85dc8247de00bea");
require("5d28967c911a21eb");
require("96c09face753707a");
require("ceefe6e9da434049");
require("d295ad4073cf68e9");
require("40bd3d5a20c3ea6f");
require("ad05160a74e10e1b");
require("d9fca06bfb8c0479");
require("5c1f7f52031ea10c");
require("93a7273aa0a821c3");
require("31f989ef6270bf8a");
require("fe61e749091ee8e7");
require("908875e5bc3672d7");
require("1103d7c053a446be");
require("7dbee6745831d0df");
require("b322557eca4c9682");
require("3e13ca642ebdf41e");
require("89a60ce99fc8e1b7");
require("447176d0525c5340");
require("400ca0d64a88637a");
require("9448d789896dce9a");
require("1bfb8e9845b8c64a");
require("81936931dd1f23fe");
require("6963fa5be713a55f");
require("17a10aa740579aa3");
require("c21bf028e8eb8351");
require("50bc8798b275b8b2");
require("9eabfdfd25723ffe");
require("63ce3b7f86e2cec7");
require("fdcf9ec12d522af3");
require("261807c6c4c49e17");
require("c5cd9f50ef83d6ec");
require("dbc756bf4cdeb24d");
require("9b187cb1c531fa20");
require("d7fdb874572f1d36");
require("5e47270a383f61e1");
require("ed1760e291fc9dc3");
require("ab47f741abf794a0");
require("7176047746ad4c78");
require("4b0adafa71ecc3e5");
require("25498a63f375ec0d");
require("6271de16bcc8b389");
require("c28283654b5d6b6a");
require("7d7950f82189c051");
require("c8fea55615b462ab");
require("5a013392f8689d51");
require("3436618dbc818f5c");
require("5e945faf0c229032");
require("b493b2d5e616a497");
require("186dedebfe4d6dfe");
require("d67dd1d0717eff00");
require("553a605590a390f9");
require("511123a20b764eca");
require("62b310cfed1759f");
require("45e39f8b4d6aa55");
require("3eb5c4db31824226");
require("5537fe8e08b24785");
require("d6259f524eb4c1d7");
require("85c1a3b3d5baae03");
require("4581665363e5926c");
require("77be710d5ec4b20f");
require("bbbc7e438440905f");
require("28466754bbae5b24");
require("f1a74e05663e0b5e");
require("31a89dce945ae493");
require("ebe38ce1619d1f84");
require("5d44e5913843b681");
require("1cd830c96c174d89");
require("de7621d2847f1309");
require("537089476ace5f6d");
require("3a2e529221bfd1c6");
require("6df1ca63290938f1");
require("3a82f73211e263df");
require("ce7cc44d215e561d");
require("8bde09dae28e7360");
require("c64e9da43b3c548e");
require("f34f41c0faf4f857");
require("c0ce59403d7ec733");
require("e7a750bb9c55b77a");
require("8f8582529d1894c9");
require("24ebbde343dee517");
require("8691303443e0c964");
require("f80ca43929da76a0");
require("c822aa1c30a9107a");
require("39b7ef078da1e13");
require("b7dea61427d5396d");
require("6ee5248e3ffa1c10");
require("4e722ac3bd8a2988");
require("b2487ef79867e12b");
require("d363e76520db3749");
require("30c3cd63cde46471");
require("2763f6f77ae843f8");
require("ce48f6eecfe8368d");
require("7a9598d016469248");
require("f1d58a6a26fbd07c");
require("602d55b4d1735ab6");
require("54e755f4667075dc");
require("23618daa799be039");
require("e1fdbcb42cd5297b");
require("109eed20f62a1c19");
require("d95db4144db77f4f");
require("f82eb1d11730b0dd");
require("7d9dfa89e9a828ac");
require("75fda6df651b3fe7");
require("52093787b3c01013");
require("9b18b5eb0db91323");
require("20fc31da61caee7a");
require("5315ca3ff85cf505");
require("cbad019561f580e0");
require("ed4d4b0f4766b03a");
require("c54f9d9667ca025c");
require("820274112051cefb");
require("721e23b98f6a89df");
require("36a61640702bb96a");
require("f3744b9689050161");
require("faf34c95eeb6397e");
require("a3f2316945876c7e");
require("3b3b80c88f5ba4c1");
require("26365ea2e8d6d177");
require("3486ece9c7ecf655");
require("91060d0ab55b0ad8");
require("548c42e6d632fff4");
require("e1c15564d149b0f4");
require("5de0613996cbaf30");
require("c3bb343c283eda8a");
require("3e24fbb2c4e9be47");
require("61f9b96c8c4a0580");
require("539fac5b2a727896");
require("c93fdb6d0e3430f5");
require("4f2762496db71a14");
require("22ce7aca43abd162");
require("ccf0a9ea79e5614c");
require("9b829115c7e39746");
require("831e946e1214adf8");
require("8e8ba3db2af99692");
require("6a5d442c2385e77d");
require("7771268b62aa5db9");
require("e9a58620ca70981e");
require("64c5151c8d073823");
require("f1017b8ebc0688a8");
require("f8f01beb574f2970");
require("af133fb605cfc0c3");
require("4ec6a043172d2472");
require("a8d47288d87f8bd5");
require("8c07179648d7050c");
require("c96f64a9d90ef17");
require("c2169dc79b5aa7fa");
require("a692cf1e82658a11");
require("2e2a1e3ade31719");
require("4ebdda715f77ef0e");
require("43921e6a98752d5d");
require("cf513ed30ce456fe");
require("4da909daca350e34");
require("24659e95db138f98");
require("62843b609eb190c6");
require("cf1d33c07571a8c4");
require("46d20019356a32d9");
require("81a65d5e4bc7e38f");
require("72629c58bc9f667d");
require("729c5ab214541f");
require("e9ebf418903214ab");
require("891ad145df08c8ba");
require("ebb31c26223258e6");
require("d77061808991232e");
require("ef82938b17f57267");
require("b8a2aee24d52d3d4");
require("cd85e16beb561f6a");
require("4731e58671ee552c");
// Accessors
require("55a5d6e927a41402");
require("aff2e027a42ad1c7");
module.exports = require("ffbfea7b3caf6f49");

},{"1d13af8a37580ebe":"9KYu4","d2050545db2e592e":"3xAxM","d5ebf0b0e8da20b1":"eoQ1l","17aeb18d107af4e9":"ew3oH","fa13bc2730a99d33":"iLjEm","b2ab7a48e0b930b2":"bzKi8","e77aa1b5c984e8d7":"jCEVj","58a032da46f5d694":"eqv6f","7368b386c34390ff":"iKIj7","3948fb48634a7872":"97FlW","dd219133d0cdde23":"93T0w","f118f5ef3738f15a":"jSIOv","ee9cb6f09cdecb4f":"d4rNE","d122b52bd5ae66f0":"3ks3W","a8159420af93eb52":"dMZhp","b941c6ea5e165e49":"1a3Cp","92c03ffc7fddf435":"1SKDP","b6e7394ce186bdd1":"iqj8C","e85dc8247de00bea":"56998","5d28967c911a21eb":"iEcIf","96c09face753707a":"57DK4","ceefe6e9da434049":"iR4ri","d295ad4073cf68e9":"bES7l","40bd3d5a20c3ea6f":"423PR","ad05160a74e10e1b":"jCzzH","d9fca06bfb8c0479":"g3ps3","5c1f7f52031ea10c":"7YCvN","93a7273aa0a821c3":"8oV3l","31f989ef6270bf8a":"2fwlr","fe61e749091ee8e7":"hAkCm","908875e5bc3672d7":"e4902","1103d7c053a446be":"j2IaI","7dbee6745831d0df":"3nT54","b322557eca4c9682":"iDb3a","3e13ca642ebdf41e":"4NNPE","89a60ce99fc8e1b7":"69QPo","447176d0525c5340":"bShkG","400ca0d64a88637a":"dbxck","9448d789896dce9a":"kvXa7","1bfb8e9845b8c64a":"4oCYD","81936931dd1f23fe":"hJjQh","6963fa5be713a55f":"gEkAS","17a10aa740579aa3":"fqZP4","c21bf028e8eb8351":"dE8lQ","50bc8798b275b8b2":"2rgI2","9eabfdfd25723ffe":"brRJq","63ce3b7f86e2cec7":"jlRzI","fdcf9ec12d522af3":"klNK4","261807c6c4c49e17":"50kiq","c5cd9f50ef83d6ec":"bTM0K","dbc756bf4cdeb24d":"jFJPW","9b187cb1c531fa20":"ihEbp","d7fdb874572f1d36":"dQSYf","5e47270a383f61e1":"441RH","ed1760e291fc9dc3":"bgWsb","ab47f741abf794a0":"efAiH","7176047746ad4c78":"lAUA2","4b0adafa71ecc3e5":"9tNbs","25498a63f375ec0d":"54TXa","6271de16bcc8b389":"hGPHK","c28283654b5d6b6a":"4CndI","7d7950f82189c051":"hh82e","c8fea55615b462ab":"bD6Vu","5a013392f8689d51":"ifb9O","3436618dbc818f5c":"5CMWb","5e945faf0c229032":"kwRtq","b493b2d5e616a497":"3wAWP","186dedebfe4d6dfe":"lbSa7","d67dd1d0717eff00":"csBoO","553a605590a390f9":"fDRcM","511123a20b764eca":"geiiQ","62b310cfed1759f":"eXsvE","45e39f8b4d6aa55":"wtubL","3eb5c4db31824226":"4i0Q3","5537fe8e08b24785":"020xA","d6259f524eb4c1d7":"6Krz9","85c1a3b3d5baae03":"kYU07","4581665363e5926c":"4GuKQ","77be710d5ec4b20f":"gPb8g","bbbc7e438440905f":"7eoGd","28466754bbae5b24":"hLEZh","f1a74e05663e0b5e":"kXIpU","31a89dce945ae493":"hoKw3","ebe38ce1619d1f84":"i2e46","5d44e5913843b681":"lKTNJ","1cd830c96c174d89":"eSlMz","de7621d2847f1309":"eSo4L","537089476ace5f6d":"9HlrV","3a2e529221bfd1c6":"aHfBo","6df1ca63290938f1":"iZrlT","3a82f73211e263df":"jp3ip","ce7cc44d215e561d":"4PSIz","8bde09dae28e7360":"kjwu9","c64e9da43b3c548e":"efMTx","f34f41c0faf4f857":"2cQla","c0ce59403d7ec733":"kbdwn","e7a750bb9c55b77a":"1nMl5","8f8582529d1894c9":"5knSP","24ebbde343dee517":"i7OS2","8691303443e0c964":"k9Pqj","f80ca43929da76a0":"l4k2e","c822aa1c30a9107a":"cWdto","39b7ef078da1e13":"5eIqt","b7dea61427d5396d":"hF3GR","6ee5248e3ffa1c10":"jmpeU","4e722ac3bd8a2988":"gl9jK","b2487ef79867e12b":"6enX6","d363e76520db3749":"ilvNe","30c3cd63cde46471":"6h6XD","2763f6f77ae843f8":"98YG6","ce48f6eecfe8368d":"15hPr","7a9598d016469248":"48zmW","f1d58a6a26fbd07c":"icalL","602d55b4d1735ab6":"Gbn2k","54e755f4667075dc":"1e2un","23618daa799be039":"1h0gS","e1fdbcb42cd5297b":"cLbQ5","109eed20f62a1c19":"5Keb2","d95db4144db77f4f":"hwQuO","f82eb1d11730b0dd":"hmj5z","7d9dfa89e9a828ac":"ljW93","75fda6df651b3fe7":"co7DM","52093787b3c01013":"NHyLm","9b18b5eb0db91323":"eHr6J","20fc31da61caee7a":"dix6e","5315ca3ff85cf505":"dyKzC","cbad019561f580e0":"8sPO7","ed4d4b0f4766b03a":"1P7cb","c54f9d9667ca025c":"17v6S","820274112051cefb":"6SnZ3","721e23b98f6a89df":"bt2cM","36a61640702bb96a":"6xM2k","f3744b9689050161":"1FuhS","faf34c95eeb6397e":"1Hjkj","a3f2316945876c7e":"8FQmC","3b3b80c88f5ba4c1":"7VbsW","26365ea2e8d6d177":"dsWQX","3486ece9c7ecf655":"1j4r3","91060d0ab55b0ad8":"dAgYB","548c42e6d632fff4":"zpSv4","e1c15564d149b0f4":"iwJgj","5de0613996cbaf30":"d2UBw","c3bb343c283eda8a":"jcjDh","3e24fbb2c4e9be47":"kPhB1","61f9b96c8c4a0580":"dWemj","539fac5b2a727896":"k7XZu","c93fdb6d0e3430f5":"dp6RU","4f2762496db71a14":"lpbwI","22ce7aca43abd162":"1XNSk","ccf0a9ea79e5614c":"j9zXp","9b829115c7e39746":"lxt8R","831e946e1214adf8":"iHlWa","8e8ba3db2af99692":"lNbcj","6a5d442c2385e77d":"cLAKJ","7771268b62aa5db9":"bQGx5","e9a58620ca70981e":"3CG9R","64c5151c8d073823":"63QEC","f1017b8ebc0688a8":"bwLxu","f8f01beb574f2970":"6mAkE","af133fb605cfc0c3":"j32Ft","4ec6a043172d2472":"81qhX","a8d47288d87f8bd5":"hQmZS","8c07179648d7050c":"g8BHg","c96f64a9d90ef17":"d6kpQ","c2169dc79b5aa7fa":"jpjxv","a692cf1e82658a11":"1K8Aj","2e2a1e3ade31719":"fpdD2","4ebdda715f77ef0e":"hPlCd","43921e6a98752d5d":"9Pa40","cf513ed30ce456fe":"9reZP","4da909daca350e34":"c3SpY","24659e95db138f98":"9DWEk","62843b609eb190c6":"aqJQD","cf1d33c07571a8c4":"cfXgo","46d20019356a32d9":"gJWXs","81a65d5e4bc7e38f":"jTKt0","72629c58bc9f667d":"7Q16P","729c5ab214541f":"2MVPA","e9ebf418903214ab":"5hcRf","891ad145df08c8ba":"2m5uv","ebb31c26223258e6":"ha4IE","d77061808991232e":"3trrq","ef82938b17f57267":"8n83U","b8a2aee24d52d3d4":"kPNZ8","cd85e16beb561f6a":"ariwB","4731e58671ee552c":"fKMpO","55a5d6e927a41402":"bFvxN","aff2e027a42ad1c7":"hFGrH","ffbfea7b3caf6f49":"eWYA2"}],"9KYu4":[function(require,module,exports) {
"use strict";
var Sugar = require("507f1c4148324824"), LocaleHelpers = require("a15dfb7446a13e12");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "addLocale": function(code, set) {
        return localeManager.add(code, set);
    }
});
module.exports = Sugar.Date.addLocale;

},{"507f1c4148324824":"eWYA2","a15dfb7446a13e12":"14L7V"}],"14L7V":[function(require,module,exports) {
"use strict";
var LazyLoadedLocales = require("70b2047106261970"), AmericanEnglishDefinition = require("3dca3df602f7bb26"), getNewLocale = require("4a9534e36dd6c657");
var English, localeManager;
function buildLocales() {
    function LocaleManager(loc) {
        this.locales = {};
        this.add(loc);
    }
    LocaleManager.prototype = {
        get: function get(code, fallback) {
            var loc = this.locales[code];
            if (!loc && LazyLoadedLocales[code]) loc = this.add(code, LazyLoadedLocales[code]);
            else if (!loc && code) loc = this.locales[code.slice(0, 2)];
            return loc || fallback === false ? loc : this.current;
        },
        getAll: function getAll() {
            return this.locales;
        },
        set: function set(code) {
            var loc = this.get(code, false);
            if (!loc) throw new TypeError("Invalid Locale: " + code);
            return this.current = loc;
        },
        add: function add(code, def) {
            if (!def) {
                def = code;
                code = def.code;
            } else def.code = code;
            var loc = def.compiledFormats ? def : getNewLocale(def);
            this.locales[code] = loc;
            if (!this.current) this.current = loc;
            return loc;
        },
        remove: function remove(code) {
            if (this.current.code === code) this.current = this.get("en");
            return delete this.locales[code];
        }
    };
    // Sorry about this guys...
    English = getNewLocale(AmericanEnglishDefinition);
    localeManager = new LocaleManager(English);
}
buildLocales();
module.exports = {
    English: English,
    localeManager: localeManager
};

},{"70b2047106261970":"cVOx4","3dca3df602f7bb26":"l5IOk","4a9534e36dd6c657":"42zGU"}],"cVOx4":[function(require,module,exports) {
"use strict";
var BritishEnglishDefinition = require("226cf9945d9eb9ae"), AmericanEnglishDefinition = require("68c6f6398eab40c6"), CanadianEnglishDefinition = require("50dfef6a65d0c321");
var LazyLoadedLocales = {
    "en-US": AmericanEnglishDefinition,
    "en-GB": BritishEnglishDefinition,
    "en-AU": BritishEnglishDefinition,
    "en-CA": CanadianEnglishDefinition
};
module.exports = LazyLoadedLocales;

},{"226cf9945d9eb9ae":"9lkpc","68c6f6398eab40c6":"l5IOk","50dfef6a65d0c321":"2W4ti"}],"9lkpc":[function(require,module,exports) {
"use strict";
var getEnglishVariant = require("d73e605b5d9c9513");
var BritishEnglishDefinition = getEnglishVariant({
    "short": "{dd}/{MM}/{yyyy}",
    "medium": "{d} {Month} {yyyy}",
    "long": "{d} {Month} {yyyy} {H}:{mm}",
    "full": "{Weekday}, {d} {Month}, {yyyy} {time}",
    "stamp": "{Dow} {d} {Mon} {yyyy} {time}"
});
module.exports = BritishEnglishDefinition;

},{"d73e605b5d9c9513":"eJDxD"}],"eJDxD":[function(require,module,exports) {
"use strict";
var EnglishLocaleBaseDefinition = require("94a4683015b4121"), simpleMerge = require("d51872911c196993"), simpleClone = require("f0bb22964fa7a385");
function getEnglishVariant(v) {
    return simpleMerge(simpleClone(EnglishLocaleBaseDefinition), v);
}
module.exports = getEnglishVariant;

},{"94a4683015b4121":"dEkFX","d51872911c196993":"bkfA1","f0bb22964fa7a385":"5Aio4"}],"dEkFX":[function(require,module,exports) {
"use strict";
var EnglishLocaleBaseDefinition = {
    "code": "en",
    "plural": true,
    "timeMarkers": "at",
    "ampm": "AM|A.M.|a,PM|P.M.|p",
    "units": "millisecond:|s,second:|s,minute:|s,hour:|s,day:|s,week:|s,month:|s,year:|s",
    "months": "Jan:uary|,Feb:ruary|,Mar:ch|,Apr:il|,May,Jun:e|,Jul:y|,Aug:ust|,Sep:tember|t|,Oct:ober|,Nov:ember|,Dec:ember|",
    "weekdays": "Sun:day|,Mon:day|,Tue:sday|,Wed:nesday|,Thu:rsday|,Fri:day|,Sat:urday|+weekend",
    "numerals": "zero,one|first,two|second,three|third,four:|th,five|fifth,six:|th,seven:|th,eight:|h,nin:e|th,ten:|th",
    "articles": "a,an,the",
    "tokens": "the,st|nd|rd|th,of|in,a|an,on",
    "time": "{H}:{mm}",
    "past": "{num} {unit} {sign}",
    "future": "{num} {unit} {sign}",
    "duration": "{num} {unit}",
    "modifiers": [
        {
            "name": "half",
            "src": "half",
            "value": .5
        },
        {
            "name": "midday",
            "src": "noon",
            "value": 12
        },
        {
            "name": "midday",
            "src": "midnight",
            "value": 24
        },
        {
            "name": "day",
            "src": "yesterday",
            "value": -1
        },
        {
            "name": "day",
            "src": "today|tonight",
            "value": 0
        },
        {
            "name": "day",
            "src": "tomorrow",
            "value": 1
        },
        {
            "name": "sign",
            "src": "ago|before",
            "value": -1
        },
        {
            "name": "sign",
            "src": "from now|after|from|in|later",
            "value": 1
        },
        {
            "name": "edge",
            "src": "first day|first|beginning",
            "value": -2
        },
        {
            "name": "edge",
            "src": "last day",
            "value": 1
        },
        {
            "name": "edge",
            "src": "end|last",
            "value": 2
        },
        {
            "name": "shift",
            "src": "last",
            "value": -1
        },
        {
            "name": "shift",
            "src": "the|this",
            "value": 0
        },
        {
            "name": "shift",
            "src": "next",
            "value": 1
        }
    ],
    "parse": [
        "(?:just)? now",
        "{shift} {unit:5-7}",
        "{months?} {year}",
        "{midday} {4?} {day|weekday}",
        "{months},?[-.\\/\\s]?{year?}",
        "{edge} of (?:day)? {day|weekday}",
        "{0} {num}{1?} {weekday} {2} {months},? {year?}",
        "{shift?} {day?} {weekday?} (?:at)? {midday}",
        "{sign?} {3?} {half} {3?} {unit:3-4|unit:7} {sign?}",
        "{0?} {edge} {weekday?} {2} {shift?} {unit:4-7?} {months?},? {year?}"
    ],
    "timeParse": [
        "{day|weekday}",
        "{shift} {unit:5?} {weekday}",
        "{0?} {date}{1?} {2?} {months?}",
        "{weekday} {2?} {shift} {unit:5}",
        "{0?} {num} {2?} {months}\\.?,? {year?}",
        "{num?} {unit:4-5} {sign} {day|weekday}",
        "{0|months} {date?}{1?} of {shift} {unit:6-7}",
        "{0?} {num}{1?} {weekday} of {shift} {unit:6}",
        "{year?}[-.\\/\\s]?{months}[-.\\/\\s]{date}",
        "{date}[-.\\/\\s]{months}(?:[-.\\/\\s]{year|yy})?",
        "{weekday?}\\.?,? {months}\\.?,? {date}{1?},? {year?}",
        "{weekday?}\\.?,? {date} {months} {year}"
    ],
    "timeFrontParse": [
        "{sign} {num} {unit}",
        "{num} {unit} {sign}",
        "{4?} {day|weekday}"
    ]
};
module.exports = EnglishLocaleBaseDefinition;

},{}],"l5IOk":[function(require,module,exports) {
"use strict";
var getEnglishVariant = require("486604f9b572d5");
var AmericanEnglishDefinition = getEnglishVariant({
    "mdy": true,
    "firstDayOfWeek": 0,
    "firstDayOfWeekYear": 1,
    "short": "{MM}/{dd}/{yyyy}",
    "medium": "{Month} {d}, {yyyy}",
    "long": "{Month} {d}, {yyyy} {time}",
    "full": "{Weekday}, {Month} {d}, {yyyy} {time}",
    "stamp": "{Dow} {Mon} {d} {yyyy} {time}",
    "time": "{h}:{mm} {TT}"
});
module.exports = AmericanEnglishDefinition;

},{"486604f9b572d5":"eJDxD"}],"2W4ti":[function(require,module,exports) {
"use strict";
var getEnglishVariant = require("b4e86dd6bcac1bfe");
var CanadianEnglishDefinition = getEnglishVariant({
    "short": "{yyyy}-{MM}-{dd}",
    "medium": "{d} {Month}, {yyyy}",
    "long": "{d} {Month}, {yyyy} {H}:{mm}",
    "full": "{Weekday}, {d} {Month}, {yyyy} {time}",
    "stamp": "{Dow} {d} {Mon} {yyyy} {time}"
});
module.exports = CanadianEnglishDefinition;

},{"b4e86dd6bcac1bfe":"eJDxD"}],"42zGU":[function(require,module,exports) {
"use strict";
var LOCALE_ARRAY_FIELDS = require("dd20f08a4341bb6e"), ISODefaults = require("34091c16f0152e62"), CoreParsingTokens = require("509507a920e449ab"), CoreParsingFormats = require("46d25976c0619c43"), LocalizedParsingTokens = require("846b514cabdacc26"), map = require("49baff444060620f"), filter = require("fe9fafe792d64100"), forEach = require("adc14f898b82e452"), isDefined = require("44c3802f9921b3f5"), commaSplit = require("d386ea313400e961"), classChecks = require("ac22f33952089817"), mathAliases = require("d9b43586e0c459"), isUndefined = require("cf6948a3bea2a1f5"), simpleMerge = require("613bbd2a0440128"), getOrdinalSuffix = require("24c087d702ac25fe"), getArrayWithOffset = require("19c775dddeba679f"), getRegNonCapturing = require("cf5776870da844bf"), coreUtilityAliases = require("26273174730c0bcc"), iterateOverDateUnits = require("c25529094900567d"), arrayToRegAlternates = require("a7788c195aa0fa06"), fullwidthNumberHelpers = require("48ad5f23788de582"), getAdjustedUnitForNumber = require("1e5106a29661904"), getParsingTokenWithSuffix = require("2b11d0dab484520e");
var hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn, forEachProperty = coreUtilityAliases.forEachProperty, fullWidthNumberMap = fullwidthNumberHelpers.fullWidthNumberMap, fullWidthNumbers = fullwidthNumberHelpers.fullWidthNumbers, pow = mathAliases.pow, max = mathAliases.max, ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR, isString = classChecks.isString, isFunction = classChecks.isFunction;
function getNewLocale(def) {
    function Locale(def) {
        this.init(def);
    }
    Locale.prototype = {
        getMonthName: function getMonthName(n, alternate) {
            if (this.monthSuffix) return n + 1 + this.monthSuffix;
            return getArrayWithOffset(this.months, n, alternate, 12);
        },
        getWeekdayName: function getWeekdayName(n, alternate) {
            return getArrayWithOffset(this.weekdays, n, alternate, 7);
        },
        // TODO: rename to parse in next major version
        parseValue: function parseValue(str, param) {
            var map = this[param + "Map"];
            if (hasOwn(map, str)) return map[str];
            return this.parseNumber(str, param);
        },
        // TODO: analyze performance of parsing first vs checking
        // numeralMap first.
        parseNumber: function parseNumber(str, param) {
            var val;
            // Simple numerals such as "one" are mapped directly in
            // the numeral map so catch up front if there is a match.
            if (hasOwn(this.numeralMap, str)) val = this.numeralMap[str];
            // TODO: perf test isNaN vs other methods
            if (isNaN(val)) val = this.parseRegularNumerals(str);
            if (isNaN(val)) val = this.parseIrregularNumerals(str);
            if (param === "month") // Months are the only numeric date field
            // whose value is not the same as its number.
            val -= 1;
            return val;
        },
        // TODO: perf test returning up front if no regular decimals exist
        parseRegularNumerals: function parseRegularNumerals(str) {
            // Allow decimals as commas and the minus-sign as per ISO-8601.
            str = str.replace(/^−/, "-").replace(/,/, ".");
            // The unary plus operator here shows better performance and handles
            // every format that parseFloat does with the exception of trailing
            // characters, which are guaranteed not to be in our string at this point.
            return +str;
        },
        parseIrregularNumerals: function parseIrregularNumerals(str) {
            var place = 1, num = 0, lastWasPlace, isPlace, numeral, digit, arr;
            // Note that "numerals" that need to be converted through this method are
            // all considered to be single characters in order to handle CJK. This
            // method is by no means unique to CJK, but the complexity of handling
            // inflections in non-CJK languages adds too much overhead for not enough
            // value, so avoiding for now.
            arr = str.split("");
            for(var i = arr.length - 1; numeral = arr[i]; i--){
                digit = getOwn(this.numeralMap, numeral);
                if (isUndefined(digit)) digit = getOwn(fullWidthNumberMap, numeral) || 0;
                isPlace = digit > 0 && digit % 10 === 0;
                if (isPlace) {
                    if (lastWasPlace) num += place;
                    if (i) place = digit;
                    else num += digit;
                } else {
                    num += digit * place;
                    place *= 10;
                }
                lastWasPlace = isPlace;
            }
            return num;
        },
        getOrdinal: function getOrdinal(n) {
            var suffix = this.ordinalSuffix;
            return suffix || getOrdinalSuffix(n);
        },
        getRelativeFormat: function getRelativeFormat(adu, type) {
            return this.convertAdjustedToFormat(adu, type);
        },
        getDuration: function getDuration(ms) {
            return this.convertAdjustedToFormat(getAdjustedUnitForNumber(max(0, ms)), "duration");
        },
        getFirstDayOfWeek: function getFirstDayOfWeek() {
            var val = this.firstDayOfWeek;
            return isDefined(val) ? val : ISO_FIRST_DAY_OF_WEEK;
        },
        getFirstDayOfWeekYear: function getFirstDayOfWeekYear() {
            return this.firstDayOfWeekYear || ISO_FIRST_DAY_OF_WEEK_YEAR;
        },
        convertAdjustedToFormat: function convertAdjustedToFormat(adu, type) {
            var sign, unit, mult, num = adu[0], u = adu[1], ms = adu[2], format = this[type] || this.relative;
            if (isFunction(format)) return format.call(this, num, u, ms, type);
            mult = !this.plural || num === 1 ? 0 : 1;
            unit = this.units[mult * 8 + u] || this.units[u];
            sign = this[ms > 0 ? "fromNow" : "ago"];
            return format.replace(/\{(.*?)\}/g, function(full, match) {
                switch(match){
                    case "num":
                        return num;
                    case "unit":
                        return unit;
                    case "sign":
                        return sign;
                }
            });
        },
        cacheFormat: function cacheFormat(dif, i) {
            this.compiledFormats.splice(i, 1);
            this.compiledFormats.unshift(dif);
        },
        addFormat: function addFormat(format) {
            var loc = this, src, to;
            function getTokenSrc(token) {
                var suffix, src, tmp, opt = token.match(/\?$/), nc = token.match(/^(\d+)\??$/), slice = token.match(/(\d)(?:-(\d))?/), param = token.replace(/[^a-z]+$/i, "");
                // Allowing alias tokens such as {time}
                if (tmp = getOwn(loc.parsingAliases, param)) {
                    src = formatToSrc(tmp);
                    if (opt) src = getRegNonCapturing(src, true);
                    return src;
                }
                if (nc) src = loc.tokens[nc[1]];
                else if (tmp = getOwn(CoreParsingTokens, param)) {
                    src = tmp.src;
                    param = tmp.param || param;
                } else {
                    tmp = getOwn(loc.parsingTokens, param) || getOwn(loc, param);
                    // Both the "months" array and the "month" parsing token can be accessed
                    // by either {month} or {months}, falling back as necessary, however
                    // regardless of whether or not a fallback occurs, the final field to
                    // be passed to addRawFormat must be normalized as singular.
                    param = param.replace(/s$/, "");
                    if (!tmp) tmp = getOwn(loc.parsingTokens, param) || getOwn(loc, param + "s");
                    if (isString(tmp)) {
                        src = tmp;
                        suffix = loc[param + "Suffix"];
                    } else {
                        // This is a hack to temporarily disallow parsing of single character
                        // weekdays until the format can be changed to allow for this.
                        if (param === "weekday" && loc.code === "ko") tmp = filter(tmp, function(str) {
                            return str.length > 1;
                        });
                        if (slice) tmp = filter(tmp, function(m, i) {
                            var mod = i % (loc.units ? 8 : tmp.length);
                            return mod >= slice[1] && mod <= (slice[2] || slice[1]);
                        });
                        src = arrayToRegAlternates(tmp);
                    }
                }
                if (!src) return "";
                if (nc) // Non-capturing tokens like {0}
                src = getRegNonCapturing(src);
                else {
                    // Capturing group and add to parsed tokens
                    to.push(param);
                    src = "(" + src + ")";
                }
                if (suffix) // Date/time suffixes such as those in CJK
                src = getParsingTokenWithSuffix(param, src, suffix);
                if (opt) src += "?";
                return src;
            }
            function formatToSrc(str) {
                // Make spaces optional
                str = str.replace(/ /g, " ?");
                str = str.replace(/\{([^,]+?)\}/g, function(match, token) {
                    var tokens = token.split("|");
                    if (tokens.length > 1) return getRegNonCapturing(map(tokens, getTokenSrc).join("|"));
                    else return getTokenSrc(token);
                });
                return str;
            }
            function parseInputFormat() {
                to = [];
                src = formatToSrc(format);
            }
            parseInputFormat();
            loc.addRawFormat(src, to);
        },
        addRawFormat: function addRawFormat(format, to) {
            this.compiledFormats.unshift({
                reg: RegExp("^ *" + format + " *$", "i"),
                to: to
            });
        },
        init: function init(def) {
            var loc = this;
            // -- Initialization helpers
            function initFormats() {
                loc.compiledFormats = [];
                loc.parsingAliases = {};
                loc.parsingTokens = {};
            }
            function initDefinition() {
                simpleMerge(loc, def);
            }
            function initArrayFields() {
                forEach(LOCALE_ARRAY_FIELDS, function(name) {
                    var val = loc[name];
                    if (isString(val)) loc[name] = commaSplit(val);
                    else if (!val) loc[name] = [];
                });
            }
            // -- Value array build helpers
            function buildValueArray(name, mod, map, fn) {
                var field = name, all = [], setMap;
                if (!loc[field]) field += "s";
                if (!map) {
                    map = {};
                    setMap = true;
                }
                forAllAlternates(field, function(alt, j, i) {
                    var idx = j * mod + i, val;
                    val = fn ? fn(i) : i;
                    map[alt] = val;
                    map[alt.toLowerCase()] = val;
                    all[idx] = alt;
                });
                loc[field] = all;
                if (setMap) loc[name + "Map"] = map;
            }
            function forAllAlternates(field, fn) {
                forEach(loc[field], function(str, i) {
                    forEachAlternate(str, function(alt, j) {
                        fn(alt, j, i);
                    });
                });
            }
            function forEachAlternate(str, fn) {
                var arr = map(str.split("+"), function(split) {
                    return split.replace(/(.+):(.+)$/, function(full, base, suffixes) {
                        return map(suffixes.split("|"), function(suffix) {
                            return base + suffix;
                        }).join("|");
                    });
                }).join("|");
                forEach(arr.split("|"), fn);
            }
            function buildNumerals() {
                var map = {};
                buildValueArray("numeral", 10, map);
                buildValueArray("article", 1, map, function() {
                    return 1;
                });
                buildValueArray("placeholder", 4, map, function(n) {
                    return pow(10, n + 1);
                });
                loc.numeralMap = map;
            }
            function buildTimeFormats() {
                loc.parsingAliases["time"] = getTimeFormat();
                loc.parsingAliases["tzOffset"] = getTZOffsetFormat();
            }
            function getTimeFormat(standalone) {
                var src, sep;
                sep = getTimeSeparatorSrc(standalone);
                if (loc.ampmFront) // "ampmFront" exists mostly for CJK locales, which also presume that
                // time suffixes exist, allowing this to be a simpler regex.
                src = "{ampm?} {hour} (?:{minute} (?::?{second})?)?";
                else if (loc.ampm.length) src = "{hour}(?:" + sep + "{minute?}(?:" + sep + "{second?})? {ampm?}| {ampm})";
                else src = "{hour}(?:" + sep + "{minute?}(?:" + sep + "{second?})?)";
                return src;
            }
            function getTimeSeparatorSrc() {
                if (loc.timeSeparator) return "[:" + loc.timeSeparator + "]";
                else return ":";
            }
            function getTZOffsetFormat() {
                return "(?:{Z}|{GMT?}(?:{tzHour}(?::?{tzMinute}(?: \\([\\w\\s]+\\))?)?)?)?";
            }
            function buildParsingTokens() {
                forEachProperty(LocalizedParsingTokens, function(token, name) {
                    var src = token.base ? getCoreTokensForBase(token.base) : token.src, arr;
                    if (token.requiresNumerals || loc.numeralUnits) src += getNumeralSrc();
                    arr = loc[name + "s"];
                    if (arr && arr.length) src += "|" + arrayToRegAlternates(arr);
                    loc.parsingTokens[name] = src;
                });
            }
            function getCoreTokensForBase(base) {
                return map(base.split("|"), function(key) {
                    return CoreParsingTokens[key].src;
                }).join("|");
            }
            function getNumeralSrc() {
                var all, src = "";
                all = loc.numerals.concat(loc.placeholders).concat(loc.articles);
                if (loc.allowsFullWidth) all = all.concat(fullWidthNumbers.split(""));
                if (all.length) src = "|(?:" + arrayToRegAlternates(all) + ")+";
                return src;
            }
            function buildTimeSuffixes() {
                iterateOverDateUnits(function(unit, i) {
                    var token = loc.timeSuffixes[i];
                    if (token) loc[(unit.alias || unit.name) + "Suffix"] = token;
                });
            }
            function buildModifiers() {
                forEach(loc.modifiers, function(modifier) {
                    var name = modifier.name, mapKey = name + "Map", map;
                    map = loc[mapKey] || {};
                    forEachAlternate(modifier.src, function(alt, j) {
                        var token = getOwn(loc.parsingTokens, name), val = modifier.value;
                        map[alt] = val;
                        loc.parsingTokens[name] = token ? token + "|" + alt : alt;
                        if (modifier.name === "sign" && j === 0) // Hooking in here to set the first "fromNow" or "ago" modifier
                        // directly on the locale, so that it can be reused in the
                        // relative format.
                        loc[val === 1 ? "fromNow" : "ago"] = alt;
                    });
                    loc[mapKey] = map;
                });
            }
            // -- Format adding helpers
            function addCoreFormats() {
                forEach(CoreParsingFormats, function(df) {
                    var src = df.src;
                    if (df.localeCheck && !df.localeCheck(loc)) return;
                    if (df.mdy && loc.mdy) // Use the mm/dd/yyyy variant if it
                    // exists and the locale requires it
                    src = df.mdy;
                    if (df.time) {
                        // Core formats that allow time require the time
                        // reg on both sides, so add both versions here.
                        loc.addFormat(getFormatWithTime(src, true));
                        loc.addFormat(getFormatWithTime(src));
                    } else loc.addFormat(src);
                });
                loc.addFormat("{time}");
            }
            function addLocaleFormats() {
                addFormatSet("parse");
                addFormatSet("timeParse", true);
                addFormatSet("timeFrontParse", true, true);
            }
            function addFormatSet(field, allowTime, timeFront) {
                forEach(loc[field], function(format) {
                    if (allowTime) format = getFormatWithTime(format, timeFront);
                    loc.addFormat(format);
                });
            }
            function getFormatWithTime(baseFormat, timeBefore) {
                if (timeBefore) return getTimeBefore() + baseFormat;
                return baseFormat + getTimeAfter();
            }
            function getTimeBefore() {
                return getRegNonCapturing("{time}[,\\s\\u3000]", true);
            }
            function getTimeAfter() {
                var markers = ",?[\\s\\u3000]", localized;
                localized = arrayToRegAlternates(loc.timeMarkers);
                if (localized) markers += "| (?:" + localized + ") ";
                markers = getRegNonCapturing(markers, loc.timeMarkerOptional);
                return getRegNonCapturing(markers + "{time}{tzOffset}", true);
            }
            initFormats();
            initDefinition();
            initArrayFields();
            buildValueArray("month", 12);
            buildValueArray("weekday", 7);
            buildValueArray("unit", 8);
            buildValueArray("ampm", 2);
            buildNumerals();
            buildTimeFormats();
            buildParsingTokens();
            buildTimeSuffixes();
            buildModifiers();
            // The order of these formats is important. Order is reversed so formats
            // that are initialized later will take precedence. Generally, this means
            // that more specific formats should come later.
            addCoreFormats();
            addLocaleFormats();
        }
    };
    return new Locale(def);
}
module.exports = getNewLocale;

},{"dd20f08a4341bb6e":"gDpT9","34091c16f0152e62":"8rA66","509507a920e449ab":"fLK8y","46d25976c0619c43":"hA6yX","846b514cabdacc26":"hXD6N","49baff444060620f":"b19ZA","fe9fafe792d64100":"3TIFw","adc14f898b82e452":"1n2CK","44c3802f9921b3f5":"6Ge6e","d386ea313400e961":"1JJ8q","ac22f33952089817":"lUOLF","d9b43586e0c459":"89tTN","cf6948a3bea2a1f5":"hnApm","613bbd2a0440128":"bkfA1","24c087d702ac25fe":"4F9Cp","19c775dddeba679f":"7M14Z","cf5776870da844bf":"l1c3E","26273174730c0bcc":"dU8Nu","c25529094900567d":"aMlAF","a7788c195aa0fa06":"2R6Xl","48ad5f23788de582":"429TR","1e5106a29661904":"30W5C","2b11d0dab484520e":"dnAIc"}],"gDpT9":[function(require,module,exports) {
"use strict";
var LOCALE_ARRAY_FIELDS = [
    "months",
    "weekdays",
    "units",
    "numerals",
    "placeholders",
    "articles",
    "tokens",
    "timeMarkers",
    "ampm",
    "timeSuffixes",
    "parse",
    "timeParse",
    "timeFrontParse",
    "modifiers"
];
module.exports = LOCALE_ARRAY_FIELDS;

},{}],"8rA66":[function(require,module,exports) {
"use strict";
module.exports = {
    ISO_FIRST_DAY_OF_WEEK: 1,
    ISO_FIRST_DAY_OF_WEEK_YEAR: 4
};

},{}],"fLK8y":[function(require,module,exports) {
"use strict";
var CoreParsingTokens = {
    "yyyy": {
        param: "year",
        src: "[-\u2212+]?\\d{4,6}"
    },
    "yy": {
        param: "year",
        src: "\\d{2}"
    },
    "y": {
        param: "year",
        src: "\\d"
    },
    "ayy": {
        param: "year",
        src: "'\\d{2}"
    },
    "MM": {
        param: "month",
        src: "(?:1[012]|0?[1-9])"
    },
    "dd": {
        param: "date",
        src: "(?:3[01]|[12][0-9]|0?[1-9])"
    },
    "hh": {
        param: "hour",
        src: "(?:2[0-4]|[01]?[0-9])"
    },
    "mm": {
        param: "minute",
        src: "[0-5]\\d"
    },
    "ss": {
        param: "second",
        src: "[0-5]\\d(?:[,.]\\d+)?"
    },
    "tzHour": {
        src: "[-\u2212+](?:2[0-4]|[01]?[0-9])"
    },
    "tzMinute": {
        src: "[0-5]\\d"
    },
    "iyyyy": {
        param: "year",
        src: "(?:[-\u2212+]?\\d{4}|[-\u2212+]\\d{5,6})"
    },
    "ihh": {
        param: "hour",
        src: "(?:2[0-4]|[01][0-9])(?:[,.]\\d+)?"
    },
    "imm": {
        param: "minute",
        src: "[0-5]\\d(?:[,.]\\d+)?"
    },
    "GMT": {
        param: "utc",
        src: "GMT"
    },
    "Z": {
        param: "utc",
        src: "Z"
    },
    "timestamp": {
        src: "\\d+"
    }
};
module.exports = CoreParsingTokens;

},{}],"hA6yX":[function(require,module,exports) {
"use strict";
var CoreParsingFormats = [
    {
        // 12-1978
        // 08-1978 (MDY)
        src: "{MM}[-.\\/]{yyyy}"
    },
    {
        // 12/08/1978
        // 08/12/1978 (MDY)
        time: true,
        src: "{dd}[-\\/]{MM}(?:[-\\/]{yyyy|yy|y})?",
        mdy: "{MM}[-\\/]{dd}(?:[-\\/]{yyyy|yy|y})?"
    },
    {
        // 12.08.1978
        // 08.12.1978 (MDY)
        time: true,
        src: "{dd}\\.{MM}(?:\\.{yyyy|yy|y})?",
        mdy: "{MM}\\.{dd}(?:\\.{yyyy|yy|y})?",
        localeCheck: function localeCheck(loc) {
            // Do not allow this format if the locale
            // uses a period as a time separator.
            return loc.timeSeparator !== ".";
        }
    },
    {
        // 1975-08-25
        time: true,
        src: "{yyyy}[-.\\/]{MM}(?:[-.\\/]{dd})?"
    },
    {
        // .NET JSON
        src: "\\\\/Date\\({timestamp}(?:[-+]\\d{4,4})?\\)\\\\/"
    },
    {
        // ISO-8601
        src: "{iyyyy}(?:-?{MM}(?:-?{dd}(?:T{ihh}(?::?{imm}(?::?{ss})?)?)?)?)?{tzOffset?}"
    }
];
module.exports = CoreParsingFormats;

},{}],"hXD6N":[function(require,module,exports) {
"use strict";
var LocalizedParsingTokens = {
    "year": {
        base: "yyyy|ayy",
        requiresSuffix: true
    },
    "month": {
        base: "MM",
        requiresSuffix: true
    },
    "date": {
        base: "dd",
        requiresSuffix: true
    },
    "hour": {
        base: "hh",
        requiresSuffixOr: ":"
    },
    "minute": {
        base: "mm"
    },
    "second": {
        base: "ss"
    },
    "num": {
        src: "\\d+",
        requiresNumerals: true
    }
};
module.exports = LocalizedParsingTokens;

},{}],"7M14Z":[function(require,module,exports) {
"use strict";
function getArrayWithOffset(arr, n, alternate, offset) {
    var val;
    if (alternate > 1) val = arr[n + (alternate - 1) * offset];
    return val || arr[n];
}
module.exports = getArrayWithOffset;

},{}],"l1c3E":[function(require,module,exports) {
"use strict";
function getRegNonCapturing(src, opt) {
    if (src.length > 1) src = "(?:" + src + ")";
    if (opt) src += "?";
    return src;
}
module.exports = getRegNonCapturing;

},{}],"aMlAF":[function(require,module,exports) {
"use strict";
var DateUnits = require("5d4287acad47fcac"), DateUnitIndexes = require("69a5003fa1fbf9e7"), isUndefined = require("636b9f3b52cb4eb7");
var YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function iterateOverDateUnits(fn, startIndex, endIndex) {
    endIndex = endIndex || 0;
    if (isUndefined(startIndex)) startIndex = YEAR_INDEX;
    for(var index = startIndex; index >= endIndex; index--){
        if (fn(DateUnits[index], index) === false) break;
    }
}
module.exports = iterateOverDateUnits;

},{"5d4287acad47fcac":"5sdJf","69a5003fa1fbf9e7":"gdeYg","636b9f3b52cb4eb7":"hnApm"}],"5sdJf":[function(require,module,exports) {
"use strict";
var getDaysInMonth = require("1d43561f0db625da");
var DateUnits = [
    {
        name: "millisecond",
        method: "Milliseconds",
        multiplier: 1,
        start: 0,
        end: 999
    },
    {
        name: "second",
        method: "Seconds",
        multiplier: 1000,
        start: 0,
        end: 59
    },
    {
        name: "minute",
        method: "Minutes",
        multiplier: 60000,
        start: 0,
        end: 59
    },
    {
        name: "hour",
        method: "Hours",
        multiplier: 3600000,
        start: 0,
        end: 23
    },
    {
        name: "day",
        alias: "date",
        method: "Date",
        ambiguous: true,
        multiplier: 86400000,
        start: 1,
        end: function end(d) {
            return getDaysInMonth(d);
        }
    },
    {
        name: "week",
        method: "ISOWeek",
        ambiguous: true,
        multiplier: 604800000
    },
    {
        name: "month",
        method: "Month",
        ambiguous: true,
        multiplier: 2629800000,
        start: 0,
        end: 11
    },
    {
        name: "year",
        method: "FullYear",
        ambiguous: true,
        multiplier: 31557600000,
        start: 0
    }
];
module.exports = DateUnits;

},{"1d43561f0db625da":"1DVIV"}],"1DVIV":[function(require,module,exports) {
"use strict";
var getYear = require("ef2416ccd72b793f"), getMonth = require("c63ddac59c2c8a11"), callDateGet = require("b82de3bf5ea562d7");
function getDaysInMonth(d) {
    return 32 - callDateGet(new Date(getYear(d), getMonth(d), 32), "Date");
}
module.exports = getDaysInMonth;

},{"ef2416ccd72b793f":"8JXHQ","c63ddac59c2c8a11":"90gXu","b82de3bf5ea562d7":"kBI9T"}],"8JXHQ":[function(require,module,exports) {
"use strict";
var callDateGet = require("30bd61c0d5420b93");
function getYear(d) {
    return callDateGet(d, "FullYear");
}
module.exports = getYear;

},{"30bd61c0d5420b93":"kBI9T"}],"kBI9T":[function(require,module,exports) {
"use strict";
var _utc = require("edbf99ecf5944f7");
function callDateGet(d, method) {
    return d["get" + (_utc(d) ? "UTC" : "") + method]();
}
module.exports = callDateGet;

},{"edbf99ecf5944f7":"c68pM"}],"c68pM":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("fa36cc255297ee91");
module.exports = privatePropertyAccessor("utc");

},{"fa36cc255297ee91":"eP4xz"}],"eP4xz":[function(require,module,exports) {
"use strict";
var PRIVATE_PROP_PREFIX = require("c22766d42cb8fd0d"), coreUtilityAliases = require("95d9e8a1fe4ffade");
var setProperty = coreUtilityAliases.setProperty;
function privatePropertyAccessor(key) {
    var privateKey = PRIVATE_PROP_PREFIX + key;
    return function(obj, val) {
        if (arguments.length > 1) {
            setProperty(obj, privateKey, val);
            return obj;
        }
        return obj[privateKey];
    };
}
module.exports = privatePropertyAccessor;

},{"c22766d42cb8fd0d":"3ZxiV","95d9e8a1fe4ffade":"dU8Nu"}],"3ZxiV":[function(require,module,exports) {
"use strict";
module.exports = "_sugar_";

},{}],"90gXu":[function(require,module,exports) {
"use strict";
var callDateGet = require("56dcc5894b6ff225");
function getMonth(d) {
    return callDateGet(d, "Month");
}
module.exports = getMonth;

},{"56dcc5894b6ff225":"kBI9T"}],"gdeYg":[function(require,module,exports) {
"use strict";
module.exports = {
    HOURS_INDEX: 3,
    DAY_INDEX: 4,
    WEEK_INDEX: 5,
    MONTH_INDEX: 6,
    YEAR_INDEX: 7
};

},{}],"2R6Xl":[function(require,module,exports) {
"use strict";
var map = require("9efaa416b500a34a"), escapeRegExp = require("811a481b1d9fb02e");
function arrayToRegAlternates(arr) {
    var joined = arr.join("");
    if (!arr || !arr.length) return "";
    if (joined.length === arr.length) return "[" + joined + "]";
    // map handles sparse arrays so no need to compact the array here.
    return map(arr, escapeRegExp).join("|");
}
module.exports = arrayToRegAlternates;

},{"9efaa416b500a34a":"b19ZA","811a481b1d9fb02e":"dWlXH"}],"30W5C":[function(require,module,exports) {
"use strict";
var trunc = require("c7ffa0560dadf2e2"), withPrecision = require("a1258328400b4db"), getAdjustedUnit = require("c2e5563528c5ea7b");
function getAdjustedUnitForNumber(ms) {
    return getAdjustedUnit(ms, function(unit) {
        return trunc(withPrecision(ms / unit.multiplier, 1));
    });
}
module.exports = getAdjustedUnitForNumber;

},{"c7ffa0560dadf2e2":"ePaYC","a1258328400b4db":"6JCWQ","c2e5563528c5ea7b":"jYoRD"}],"jYoRD":[function(require,module,exports) {
"use strict";
var mathAliases = require("84ba1d2e53139070"), iterateOverDateUnits = require("a635b6e6e2532f00");
var abs = mathAliases.abs;
function getAdjustedUnit(ms, fn) {
    var unitIndex = 0, value = 0;
    iterateOverDateUnits(function(unit, i) {
        value = abs(fn(unit));
        if (value >= 1) {
            unitIndex = i;
            return false;
        }
    });
    return [
        value,
        unitIndex,
        ms
    ];
}
module.exports = getAdjustedUnit;

},{"84ba1d2e53139070":"89tTN","a635b6e6e2532f00":"aMlAF"}],"dnAIc":[function(require,module,exports) {
"use strict";
var LocalizedParsingTokens = require("e4aa454ede029be2"), getRegNonCapturing = require("7dfefe32b97c7d97");
function getParsingTokenWithSuffix(field, src, suffix) {
    var token = LocalizedParsingTokens[field];
    if (token.requiresSuffix) src = getRegNonCapturing(src + getRegNonCapturing(suffix));
    else if (token.requiresSuffixOr) src += getRegNonCapturing(token.requiresSuffixOr + "|" + suffix);
    else src += getRegNonCapturing(suffix, true);
    return src;
}
module.exports = getParsingTokenWithSuffix;

},{"e4aa454ede029be2":"hXD6N","7dfefe32b97c7d97":"l1c3E"}],"3xAxM":[function(require,module,exports) {
"use strict";
var Sugar = require("679029a18747d68d"), createDate = require("321d5c4a8cd6e381");
require("28de8ba043f75d21");
Sugar.Date.defineStatic({
    "create": function(d, options) {
        return createDate(d, options);
    }
});
module.exports = Sugar.Date.create;

},{"679029a18747d68d":"eWYA2","321d5c4a8cd6e381":"h5ei3","28de8ba043f75d21":"8korI"}],"h5ei3":[function(require,module,exports) {
"use strict";
var getExtendedDate = require("e469d47d6e7831bb");
function createDate(d, options, forceClone) {
    return getExtendedDate(null, d, options, forceClone).date;
}
module.exports = createDate;

},{"e469d47d6e7831bb":"5yq5j"}],"5yq5j":[function(require,module,exports) {
"use strict";
var MINUTES = require("1335865f9d77cd4f"), ABBREVIATED_YEAR_REG = require("1d1211049c101d37"), LocaleHelpers = require("9acbbfaaaa305079"), DateUnitIndexes = require("a554a13583580010"), _utc = require("b37cf0f01fe79eb4"), trunc = require("ea5478fddef9a446"), forEach = require("aaaf1f50b62e28fd"), tzOffset = require("a84e5259060bf45f"), isDefined = require("a108fed1ea048dd7"), resetTime = require("550daca03ef3b76d"), getNewDate = require("d7cb0b891c5a52b7"), updateDate = require("48ecf376f6df0192"), setWeekday = require("ef1bb4543b98e758"), simpleMerge = require("e6b48ee5237b8a63"), advanceDate = require("babd95c20b387c11"), isUndefined = require("d0ea0e967c415a16"), classChecks = require("de1f96768f735b8c"), dateIsValid = require("2af947d1a1d6005d"), simpleClone = require("8c37b6b39fa58ab0"), isObjectType = require("e9f89e0f9229cd6b"), moveToEndOfUnit = require("679298900828039a"), deleteDateParam = require("90a0766ceb34d14"), coreUtilityAliases = require("4c41543347e95df3"), moveToBeginningOfUnit = require("8c1e2d9e2d98391f"), iterateOverDateParams = require("eb9885fa66e1ebd1"), getYearFromAbbreviation = require("68267cf6c5086694"), iterateOverHigherDateParams = require("d5e62c14942b5185");
var isNumber = classChecks.isNumber, isString = classChecks.isString, isDate = classChecks.isDate, getOwn = coreUtilityAliases.getOwn, English = LocaleHelpers.English, localeManager = LocaleHelpers.localeManager, DAY_INDEX = DateUnitIndexes.DAY_INDEX, WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX, YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function getExtendedDate(contextDate, d, opt, forceClone) {
    // Locals
    var date, set, loc, afterCallbacks, relative, weekdayDir;
    // Options
    var optPrefer, optLocale, optFromUTC, optSetUTC, optParams, optClone;
    afterCallbacks = [];
    setupOptions(opt);
    function setupOptions(opt) {
        opt = isString(opt) ? {
            locale: opt
        } : opt || {};
        optPrefer = +!!getOwn(opt, "future") - +!!getOwn(opt, "past");
        optLocale = getOwn(opt, "locale");
        optFromUTC = getOwn(opt, "fromUTC");
        optSetUTC = getOwn(opt, "setUTC");
        optParams = getOwn(opt, "params");
        optClone = getOwn(opt, "clone");
    }
    function parseFormatValues(match, dif) {
        var set = optParams || {};
        forEach(dif.to, function(param, i) {
            var str = match[i + 1], val;
            if (!str) return;
            val = parseIrregular(str, param);
            if (isUndefined(val)) val = loc.parseValue(str, param);
            set[param] = val;
        });
        return set;
    }
    function parseIrregular(str, param) {
        if (param === "utc") return 1;
        else if (param === "year") {
            var match = str.match(ABBREVIATED_YEAR_REG);
            if (match) return getYearFromAbbreviation(match[1], date, optPrefer);
        }
    }
    // Force the UTC flags to be true if the source date
    // date is UTC, as they will be overwritten later.
    function cloneDateByFlag(d, clone) {
        if (_utc(d) && !isDefined(optFromUTC)) optFromUTC = true;
        if (_utc(d) && !isDefined(optSetUTC)) optSetUTC = true;
        if (clone) d = new Date(d.getTime());
        return d;
    }
    function afterDateSet(fn) {
        afterCallbacks.push(fn);
    }
    function fireCallbacks() {
        forEach(afterCallbacks, function(fn) {
            fn.call();
        });
    }
    function parseStringDate(str) {
        str = str.toLowerCase();
        // The act of getting the locale will initialize
        // if it is missing and add the required formats.
        loc = localeManager.get(optLocale);
        for(var i = 0, dif, match; dif = loc.compiledFormats[i]; i++){
            match = str.match(dif.reg);
            if (match) {
                // Note that caching the format will modify the compiledFormats array
                // which is not a good idea to do inside its for loop, however we
                // know at this point that we have a matched format and that we will
                // break out below, so simpler to do it here.
                loc.cacheFormat(dif, i);
                set = parseFormatValues(match, dif);
                if (isDefined(set.timestamp)) {
                    date.setTime(set.timestamp);
                    break;
                }
                if (isDefined(set.ampm)) handleAmpm(set.ampm);
                if (set.utc || isDefined(set.tzHour)) handleTimezoneOffset(set.tzHour, set.tzMinute);
                if (isDefined(set.shift) && isUndefined(set.unit)) // "next january", "next monday", etc
                handleUnitlessShift();
                if (isDefined(set.num) && isUndefined(set.unit)) // "the second of January", etc
                handleUnitlessNum(set.num);
                if (set.midday) // "noon" and "midnight"
                handleMidday(set.midday);
                if (isDefined(set.day)) // Relative day localizations such as "today" and "tomorrow".
                handleRelativeDay(set.day);
                if (isDefined(set.unit)) // "3 days ago", etc
                handleRelativeUnit(set.unit);
                if (set.edge) // "the end of January", etc
                handleEdge(set.edge, set);
                break;
            }
        }
        if (!set) {
            // TODO: remove in next major version
            // Fall back to native parsing
            date = new Date(str);
            if (optFromUTC && dateIsValid(date)) // Falling back to system date here which cannot be parsed as UTC,
            // so if we're forcing UTC then simply add the offset.
            date.setTime(date.getTime() + tzOffset(date) * MINUTES);
        } else if (relative) updateDate(date, set, false, 1);
        else updateDate(date, set, true, 0, optPrefer, weekdayDir, contextDate);
        fireCallbacks();
        return date;
    }
    function handleAmpm(ampm) {
        if (ampm === 1 && set.hour < 12) // If the time is 1pm-11pm advance the time by 12 hours.
        set.hour += 12;
        else if (ampm === 0 && set.hour === 12) // If it is 12:00am then set the hour to 0.
        set.hour = 0;
    }
    function handleTimezoneOffset(tzHour, tzMinute) {
        // Adjust for timezone offset
        _utc(date, true);
        // Sign is parsed as part of the hour, so flip
        // the minutes if it's negative.
        if (tzHour < 0) tzMinute *= -1;
        var offset = tzHour * 60 + (tzMinute || 0);
        if (offset) set.minute = (set.minute || 0) - offset;
    }
    function handleUnitlessShift() {
        if (isDefined(set.month)) // "next January"
        set.unit = YEAR_INDEX;
        else if (isDefined(set.weekday)) // "next Monday"
        set.unit = WEEK_INDEX;
    }
    function handleUnitlessNum(num) {
        if (isDefined(set.weekday)) // "The second Tuesday of March"
        setOrdinalWeekday(num);
        else if (isDefined(set.month)) // "The second of March"
        set.date = set.num;
    }
    function handleMidday(hour) {
        set.hour = hour % 24;
        if (hour > 23) // If the date has hours past 24, we need to prevent it from traversing
        // into a new day as that would make it being part of a new week in
        // ambiguous dates such as "Monday".
        afterDateSet(function() {
            advanceDate(date, "date", trunc(hour / 24));
        });
    }
    function handleRelativeDay() {
        resetTime(date);
        if (isUndefined(set.unit)) {
            set.unit = DAY_INDEX;
            set.num = set.day;
            delete set.day;
        }
    }
    function handleRelativeUnit(unitIndex) {
        var num;
        if (isDefined(set.num)) num = set.num;
        else if (isDefined(set.edge) && isUndefined(set.shift)) num = 0;
        else num = 1;
        // If a weekday is defined, there are 3 possible formats being applied:
        //
        // 1. "the day after monday": unit is days
        // 2. "next monday": short for "next week monday", unit is weeks
        // 3. "the 2nd monday of next month": unit is months
        //
        // In the first case, we need to set the weekday up front, as the day is
        // relative to it. The second case also needs to be handled up front for
        // formats like "next monday at midnight" which will have its weekday reset
        // if not set up front. The last case will set up the params necessary to
        // shift the weekday and allow separateAbsoluteUnits below to handle setting
        // it after the date has been shifted.
        if (isDefined(set.weekday)) {
            if (unitIndex === MONTH_INDEX) {
                setOrdinalWeekday(num);
                num = 1;
            } else {
                updateDate(date, {
                    weekday: set.weekday
                }, true);
                delete set.weekday;
            }
        }
        if (set.half) // Allow localized "half" as a standalone colloquialism. Purposely avoiding
        // the locale number system to reduce complexity. The units "month" and
        // "week" are purposely excluded in the English date formats below, as
        // "half a week" and "half a month" are meaningless as exact dates.
        num *= set.half;
        if (isDefined(set.shift)) // Shift and unit, ie "next month", "last week", etc.
        num *= set.shift;
        else if (set.sign) // Unit and sign, ie "months ago", "weeks from now", etc.
        num *= set.sign;
        if (isDefined(set.day)) {
            // "the day after tomorrow"
            num += set.day;
            delete set.day;
        }
        // Formats like "the 15th of last month" or "6:30pm of next week"
        // contain absolute units in addition to relative ones, so separate
        // them here, remove them from the params, and set up a callback to
        // set them after the relative ones have been set.
        separateAbsoluteUnits(unitIndex);
        // Finally shift the unit.
        set[English.units[unitIndex]] = num;
        relative = true;
    }
    function handleEdge(edge, params) {
        var edgeIndex = params.unit, weekdayOfMonth;
        if (!edgeIndex) // If we have "the end of January", then we need to find the unit index.
        iterateOverHigherDateParams(params, function(unitName, val, unit, i) {
            if (unitName === "weekday" && isDefined(params.month)) // If both a month and weekday exist, then we have a format like
            // "the last tuesday in November, 2012", where the "last" is still
            // relative to the end of the month, so prevent the unit "weekday"
            // from taking over.
            return;
            edgeIndex = i;
        });
        if (edgeIndex === MONTH_INDEX && isDefined(params.weekday)) {
            // If a weekday in a month exists (as described above),
            // then set it up to be set after the date has been shifted.
            weekdayOfMonth = params.weekday;
            delete params.weekday;
        }
        afterDateSet(function() {
            var stopIndex;
            // "edge" values that are at the very edge are "2" so the beginning of the
            // year is -2 and the end of the year is 2. Conversely, the "last day" is
            // actually 00:00am so it is 1. -1 is reserved but unused for now.
            if (edge < 0) moveToBeginningOfUnit(date, edgeIndex, optLocale);
            else if (edge > 0) {
                if (edge === 1) {
                    stopIndex = DAY_INDEX;
                    moveToBeginningOfUnit(date, DAY_INDEX);
                }
                moveToEndOfUnit(date, edgeIndex, optLocale, stopIndex);
            }
            if (isDefined(weekdayOfMonth)) {
                setWeekday(date, weekdayOfMonth, -edge);
                resetTime(date);
            }
        });
        if (edgeIndex === MONTH_INDEX) params.specificity = DAY_INDEX;
        else params.specificity = edgeIndex - 1;
    }
    function setOrdinalWeekday(num) {
        // If we have "the 2nd Tuesday of June", then pass the "weekdayDir"
        // flag along to updateDate so that the date does not accidentally traverse
        // into the previous month. This needs to be independent of the "prefer"
        // flag because we are only ensuring that the weekday is in the future, not
        // the entire date.
        set.weekday = 7 * (num - 1) + set.weekday;
        set.date = 1;
        weekdayDir = 1;
    }
    function separateAbsoluteUnits(unitIndex) {
        var params;
        iterateOverDateParams(set, function(name, val, unit, i) {
            // If there is a time unit set that is more specific than
            // the matched unit we have a string like "5:30am in 2 minutes",
            // which is meaningless, so invalidate the date...
            if (i >= unitIndex) {
                date.setTime(NaN);
                return false;
            } else if (i < unitIndex) {
                // ...otherwise set the params to set the absolute date
                // as a callback after the relative date has been set.
                params = params || {};
                params[name] = val;
                deleteDateParam(set, name);
            }
        });
        if (params) {
            afterDateSet(function() {
                updateDate(date, params, true, 0, false, weekdayDir);
                if (optParams) simpleMerge(optParams, params);
            });
            if (set.edge) {
                // "the end of March of next year"
                handleEdge(set.edge, params);
                delete set.edge;
            }
        }
    }
    if (contextDate && d) // If a context date is passed ("get" and "unitsFromNow"),
    // then use it as the starting point.
    date = cloneDateByFlag(contextDate, true);
    else date = getNewDate();
    _utc(date, optFromUTC);
    if (isString(d)) date = parseStringDate(d);
    else if (isDate(d)) date = cloneDateByFlag(d, optClone || forceClone);
    else if (isObjectType(d)) {
        set = simpleClone(d);
        updateDate(date, set, true);
    } else if (isNumber(d) || d === null) date.setTime(d);
    // A date created by parsing a string presumes that the format *itself* is
    // UTC, but not that the date, once created, should be manipulated as such. In
    // other words, if you are creating a date object from a server time
    // "2012-11-15T12:00:00Z", in the majority of cases you are using it to create
    // a date that will, after creation, be manipulated as local, so reset the utc
    // flag here unless "setUTC" is also set.
    _utc(date, !!optSetUTC);
    return {
        set: set,
        date: date
    };
}
module.exports = getExtendedDate;

},{"1335865f9d77cd4f":"enORn","1d1211049c101d37":"8C3XT","9acbbfaaaa305079":"14L7V","a554a13583580010":"gdeYg","b37cf0f01fe79eb4":"c68pM","ea5478fddef9a446":"ePaYC","aaaf1f50b62e28fd":"1n2CK","a84e5259060bf45f":"hZpDB","a108fed1ea048dd7":"6Ge6e","550daca03ef3b76d":"66P9z","d7cb0b891c5a52b7":"fTtJa","48ecf376f6df0192":"3A93x","ef1bb4543b98e758":"2wPrY","e6b48ee5237b8a63":"bkfA1","babd95c20b387c11":"4dVD0","d0ea0e967c415a16":"hnApm","de1f96768f735b8c":"lUOLF","2af947d1a1d6005d":"g2Fy2","8c37b6b39fa58ab0":"5Aio4","e9f89e0f9229cd6b":"l3TUh","679298900828039a":"5NVeO","90a0766ceb34d14":"laN9X","4c41543347e95df3":"dU8Nu","8c1e2d9e2d98391f":"lHsKR","eb9885fa66e1ebd1":"9qXnd","68267cf6c5086694":"d7Nt5","d5e62c14942b5185":"eubHC"}],"enORn":[function(require,module,exports) {
"use strict";
module.exports = 60000;

},{}],"8C3XT":[function(require,module,exports) {
"use strict";
module.exports = /^'?(\d{1,2})$/;

},{}],"hZpDB":[function(require,module,exports) {
"use strict";
function tzOffset(d) {
    return d.getTimezoneOffset();
}
module.exports = tzOffset;

},{}],"66P9z":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("f19b1c0cebd94420"), setUnitAndLowerToEdge = require("bde1dbc4e477e773");
var HOURS_INDEX = DateUnitIndexes.HOURS_INDEX;
function resetTime(d) {
    return setUnitAndLowerToEdge(d, HOURS_INDEX);
}
module.exports = resetTime;

},{"f19b1c0cebd94420":"gdeYg","bde1dbc4e477e773":"5Zx4m"}],"5Zx4m":[function(require,module,exports) {
"use strict";
var isDefined = require("6599b1d16cd49586"), classChecks = require("50f9fd9e006cb14a"), callDateSet = require("bbcdbaad2f283549"), walkUnitDown = require("e8df863a692e6012");
var isFunction = classChecks.isFunction;
function setUnitAndLowerToEdge(d, startIndex, stopIndex, end) {
    walkUnitDown(startIndex, function(unit, i) {
        var val = end ? unit.end : unit.start;
        if (isFunction(val)) val = val(d);
        callDateSet(d, unit.method, val);
        return !isDefined(stopIndex) || i > stopIndex;
    });
    return d;
}
module.exports = setUnitAndLowerToEdge;

},{"6599b1d16cd49586":"6Ge6e","50f9fd9e006cb14a":"lUOLF","bbcdbaad2f283549":"6i5qR","e8df863a692e6012":"74NWI"}],"6i5qR":[function(require,module,exports) {
"use strict";
var _utc = require("676af4b929593966"), callDateGet = require("3d9668a0e326a317");
function callDateSet(d, method, value, safe) {
    // "Safe" denotes not setting the date if the value is the same as what is
    // currently set. In theory this should be a noop, however it will cause
    // timezone shifts when in the middle of a DST fallback. This is unavoidable
    // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
    // November 1st, 2015 in northern hemisphere timezones that follow DST),
    // however when advancing or rewinding dates this can throw off calculations
    // so avoiding this unintentional shifting on an opt-in basis.
    if (safe && value === callDateGet(d, method, value)) return;
    d["set" + (_utc(d) ? "UTC" : "") + method](value);
}
module.exports = callDateSet;

},{"676af4b929593966":"c68pM","3d9668a0e326a317":"kBI9T"}],"74NWI":[function(require,module,exports) {
"use strict";
var DateUnits = require("77eee0c3a38a01ae"), getLowerUnitIndex = require("6ef09a073e91ea00");
function walkUnitDown(unitIndex, fn) {
    while(unitIndex >= 0){
        if (fn(DateUnits[unitIndex], unitIndex) === false) break;
        unitIndex = getLowerUnitIndex(unitIndex);
    }
}
module.exports = walkUnitDown;

},{"77eee0c3a38a01ae":"5sdJf","6ef09a073e91ea00":"eQJNq"}],"eQJNq":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("4fab001cca70cb46");
var HOURS_INDEX = DateUnitIndexes.HOURS_INDEX, DAY_INDEX = DateUnitIndexes.DAY_INDEX, WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function getLowerUnitIndex(index) {
    if (index === MONTH_INDEX) return DAY_INDEX;
    else if (index === WEEK_INDEX) return HOURS_INDEX;
    return index - 1;
}
module.exports = getLowerUnitIndex;

},{"4fab001cca70cb46":"gdeYg"}],"fTtJa":[function(require,module,exports) {
"use strict";
var _dateOptions = require("719b7c5b1d8777ed");
function getNewDate() {
    return _dateOptions("newDateInternal")();
}
module.exports = getNewDate;

},{"719b7c5b1d8777ed":"iUAin"}],"iUAin":[function(require,module,exports) {
"use strict";
var DATE_OPTIONS = require("58e376db141d9669"), namespaceAliases = require("3514b24d0d851d68"), defineOptionsAccessor = require("44cf99dd6b3d0060");
var sugarDate = namespaceAliases.sugarDate;
module.exports = defineOptionsAccessor(sugarDate, DATE_OPTIONS);

},{"58e376db141d9669":"ioknp","3514b24d0d851d68":"1TEpR","44cf99dd6b3d0060":"5GDAt"}],"ioknp":[function(require,module,exports) {
"use strict";
var defaultNewDate = require("e64bb0ef4c4bb731");
var DATE_OPTIONS = {
    "newDateInternal": defaultNewDate
};
module.exports = DATE_OPTIONS;

},{"e64bb0ef4c4bb731":"HKEbw"}],"HKEbw":[function(require,module,exports) {
"use strict";
function defaultNewDate() {
    return new Date;
}
module.exports = defaultNewDate;

},{}],"3A93x":[function(require,module,exports) {
"use strict";
var DateUnits = require("8f57308450a9e55d"), DateUnitIndexes = require("b860fd91eee26379"), trunc = require("427bdd6604fb7cae"), setDate = require("46b11a679e474666"), getDate = require("8e0f52e30c02c26b"), getMonth = require("11850cbca1783678"), getNewDate = require("f5c1f354081bafe7"), setWeekday = require("d79574283983ab39"), mathAliases = require("3944edbc2257d714"), callDateGet = require("5c7f6dfc83e0b7e8"), classChecks = require("7dfab1c950071b56"), resetLowerUnits = require("9e83fa9be7257ccb"), getLowerUnitIndex = require("cf576b96000a2b69"), getHigherUnitIndex = require("f306f98a1deeabab"), callDateSetWithWeek = require("e5765e622e1864d3"), iterateOverDateParams = require("fc2824de175fc3e6");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX, WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX, YEAR_INDEX = DateUnitIndexes.YEAR_INDEX, round = mathAliases.round, isNumber = classChecks.isNumber;
function updateDate(d, params, reset, advance, prefer, weekdayDir, contextDate) {
    var upperUnitIndex;
    function setUpperUnit(unitName, unitIndex) {
        if (prefer && !upperUnitIndex) {
            if (unitName === "weekday") upperUnitIndex = WEEK_INDEX;
            else upperUnitIndex = getHigherUnitIndex(unitIndex);
        }
    }
    function setSpecificity(unitIndex) {
        // Other functions may preemptively set the specificity before arriving
        // here so concede to them if they have already set more specific units.
        if (unitIndex > params.specificity) return;
        params.specificity = unitIndex;
    }
    function canDisambiguate() {
        if (!upperUnitIndex || upperUnitIndex > YEAR_INDEX) return;
        switch(prefer){
            case -1:
                return d >= (contextDate || getNewDate());
            case 1:
                return d <= (contextDate || getNewDate());
        }
    }
    function disambiguateHigherUnit() {
        var unit = DateUnits[upperUnitIndex];
        advance = prefer;
        setUnit(unit.name, 1, unit, upperUnitIndex);
    }
    function handleFraction(unit, unitIndex, fraction) {
        if (unitIndex) {
            var lowerUnit = DateUnits[getLowerUnitIndex(unitIndex)];
            var val = round(unit.multiplier / lowerUnit.multiplier * fraction);
            params[lowerUnit.name] = val;
        }
    }
    function monthHasShifted(d, targetMonth) {
        if (targetMonth < 0) targetMonth = targetMonth % 12 + 12;
        return targetMonth % 12 !== getMonth(d);
    }
    function setUnit(unitName, value, unit, unitIndex) {
        var method = unit.method, checkMonth, fraction;
        setUpperUnit(unitName, unitIndex);
        setSpecificity(unitIndex);
        fraction = value % 1;
        if (fraction) {
            handleFraction(unit, unitIndex, fraction);
            value = trunc(value);
        }
        if (unitName === "weekday") {
            if (!advance) // Weekdays are always considered absolute units so simply set them
            // here even if it is an "advance" operation. This is to help avoid
            // ambiguous meanings in "advance" as well as to neatly allow formats
            // like "Wednesday of next week" without more complex logic.
            setWeekday(d, value, weekdayDir);
            return;
        }
        checkMonth = unitIndex === MONTH_INDEX && getDate(d) > 28;
        // If we are advancing or rewinding, then we need we need to set the
        // absolute time if the unit is "hours" or less. This is due to the fact
        // that setting by method is ambiguous during DST shifts. For example,
        // 1:00am on November 1st 2015 occurs twice in North American timezones
        // with DST, the second time being after the clocks are rolled back at
        // 2:00am. When springing forward this is automatically handled as there
        // is no 2:00am so the date automatically jumps to 3:00am. However, when
        // rolling back, setHours(2) will always choose the first "2am" even if
        // the date is currently set to the second, causing unintended jumps.
        // This ambiguity is unavoidable when setting dates as the notation is
        // ambiguous. However when advancing, we clearly want the resulting date
        // to be an acutal hour ahead, which can only be accomplished by setting
        // the absolute time. Conversely, any unit higher than "hours" MUST use
        // the internal set methods, as they are ambiguous as absolute units of
        // time. Years may be 365 or 366 days depending on leap years, months are
        // all over the place, and even days may be 23-25 hours depending on DST
        // shifts. Finally, note that the kind of jumping described above will
        // occur when calling ANY "set" method on the date and will occur even if
        // the value being set is identical to the one currently set (i.e.
        // setHours(2) on a date at 2am may not be a noop). This is precarious,
        // so avoiding this situation in callDateSet by checking up front that
        // the value is not the same before setting.
        if (advance && !unit.ambiguous) {
            d.setTime(d.getTime() + value * advance * unit.multiplier);
            return;
        } else if (advance) {
            if (unitIndex === WEEK_INDEX) {
                value *= 7;
                method = DateUnits[DAY_INDEX].method;
            }
            value = value * advance + callDateGet(d, method);
        }
        callDateSetWithWeek(d, method, value, advance);
        if (checkMonth && monthHasShifted(d, value)) // As we are setting the units in reverse order, there is a chance that
        // our date may accidentally traverse into a new month, such as setting
        // { month: 1, date 15 } on January 31st. Check for this here and reset
        // the date to the last day of the previous month if this has happened.
        setDate(d, 0);
    }
    if (isNumber(params) && advance) // If param is a number and advancing, the number is in milliseconds.
    params = {
        millisecond: params
    };
    else if (isNumber(params)) {
        // Otherwise just set the timestamp and return.
        d.setTime(params);
        return d;
    }
    iterateOverDateParams(params, setUnit);
    if (reset && params.specificity) resetLowerUnits(d, params.specificity);
    // If past or future is preferred, then the process of "disambiguation" will
    // ensure that an ambiguous time/date ("4pm", "thursday", "June", etc.) will
    // be in the past or future. Weeks are only considered ambiguous if there is
    // a weekday, i.e. "thursday" is an ambiguous week, but "the 4th" is an
    // ambiguous month.
    if (canDisambiguate()) disambiguateHigherUnit();
    return d;
}
module.exports = updateDate;

},{"8f57308450a9e55d":"5sdJf","b860fd91eee26379":"gdeYg","427bdd6604fb7cae":"ePaYC","46b11a679e474666":"cOXbt","8e0f52e30c02c26b":"2e49M","11850cbca1783678":"90gXu","f5c1f354081bafe7":"fTtJa","d79574283983ab39":"2wPrY","3944edbc2257d714":"89tTN","5c7f6dfc83e0b7e8":"kBI9T","7dfab1c950071b56":"lUOLF","9e83fa9be7257ccb":"1uTIY","cf576b96000a2b69":"eQJNq","f306f98a1deeabab":"DZqQO","e5765e622e1864d3":"htdMd","fc2824de175fc3e6":"9qXnd"}],"cOXbt":[function(require,module,exports) {
"use strict";
var callDateSet = require("e5e069328aae0208");
function setDate(d, val) {
    callDateSet(d, "Date", val);
}
module.exports = setDate;

},{"e5e069328aae0208":"6i5qR"}],"2e49M":[function(require,module,exports) {
"use strict";
var callDateGet = require("8ac1a8fd978fed23");
function getDate(d) {
    return callDateGet(d, "Date");
}
module.exports = getDate;

},{"8ac1a8fd978fed23":"kBI9T"}],"2wPrY":[function(require,module,exports) {
"use strict";
var setDate = require("55e77d167629d85b"), getDate = require("7690e5abdffffac4"), getWeekday = require("c3c85e947ec34fe4"), classChecks = require("14c5512d6624d14a"), mathAliases = require("f8596510adb41854");
var isNumber = classChecks.isNumber, abs = mathAliases.abs;
function setWeekday(d, dow, dir) {
    if (!isNumber(dow)) return;
    var currentWeekday = getWeekday(d);
    if (dir) {
        // Allow a "direction" parameter to determine whether a weekday can
        // be set beyond the current weekday in either direction.
        var ndir = dir > 0 ? 1 : -1;
        var offset = dow % 7 - currentWeekday;
        if (offset && offset / abs(offset) !== ndir) dow += 7 * ndir;
    }
    setDate(d, getDate(d) + dow - currentWeekday);
    return d.getTime();
}
module.exports = setWeekday;

},{"55e77d167629d85b":"cOXbt","7690e5abdffffac4":"2e49M","c3c85e947ec34fe4":"gHTdp","14c5512d6624d14a":"lUOLF","f8596510adb41854":"89tTN"}],"gHTdp":[function(require,module,exports) {
"use strict";
var callDateGet = require("5740c4220bf1bddf");
function getWeekday(d) {
    return callDateGet(d, "Day");
}
module.exports = getWeekday;

},{"5740c4220bf1bddf":"kBI9T"}],"1uTIY":[function(require,module,exports) {
"use strict";
var getLowerUnitIndex = require("424243a82dae9ecb"), setUnitAndLowerToEdge = require("381ae2a29546aa50");
function resetLowerUnits(d, unitIndex) {
    return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex));
}
module.exports = resetLowerUnits;

},{"424243a82dae9ecb":"eQJNq","381ae2a29546aa50":"5Zx4m"}],"DZqQO":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("7ced2975e50b4454");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function getHigherUnitIndex(index) {
    return index === DAY_INDEX ? MONTH_INDEX : index + 1;
}
module.exports = getHigherUnitIndex;

},{"7ced2975e50b4454":"gdeYg"}],"htdMd":[function(require,module,exports) {
"use strict";
var callDateSet = require("8877b2f568d351f4"), setISOWeekNumber = require("7f5420a5b1b10073");
function callDateSetWithWeek(d, method, value, safe) {
    if (method === "ISOWeek") setISOWeekNumber(d, value);
    else callDateSet(d, method, value, safe);
}
module.exports = callDateSetWithWeek;

},{"8877b2f568d351f4":"6i5qR","7f5420a5b1b10073":"55U86"}],"55U86":[function(require,module,exports) {
"use strict";
var ISODefaults = require("32bc2c5c0c660936"), getDate = require("d2e3494c14cef968"), setDate = require("72603056ca8759f9"), setYear = require("ddcd90a9a886fa02"), getYear = require("8408c175d160a43"), getMonth = require("d7acafc0681386b9"), setMonth = require("a30e97b0b43b30b"), cloneDate = require("fc6ff9bb581ada2f"), getWeekday = require("ca6e996641ff2b62"), setWeekday = require("195ab21306d5cf75"), classChecks = require("46893685149f756b"), moveToFirstDayOfWeekYear = require("2e227f31bea598fb");
var isNumber = classChecks.isNumber, ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR;
function setISOWeekNumber(d, num) {
    if (isNumber(num)) {
        // Intentionally avoiding updateDate here to prevent circular dependencies.
        var isoWeek = cloneDate(d), dow = getWeekday(d);
        moveToFirstDayOfWeekYear(isoWeek, ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR);
        setDate(isoWeek, getDate(isoWeek) + 7 * (num - 1));
        setYear(d, getYear(isoWeek));
        setMonth(d, getMonth(isoWeek));
        setDate(d, getDate(isoWeek));
        setWeekday(d, dow || 7);
    }
    return d.getTime();
}
module.exports = setISOWeekNumber;

},{"32bc2c5c0c660936":"8rA66","d2e3494c14cef968":"2e49M","72603056ca8759f9":"cOXbt","ddcd90a9a886fa02":"aD4Fi","8408c175d160a43":"8JXHQ","d7acafc0681386b9":"90gXu","a30e97b0b43b30b":"dXh2C","fc6ff9bb581ada2f":"eedt3","ca6e996641ff2b62":"gHTdp","195ab21306d5cf75":"2wPrY","46893685149f756b":"lUOLF","2e227f31bea598fb":"ht9xE"}],"aD4Fi":[function(require,module,exports) {
"use strict";
var callDateSet = require("9c6e5a273897967");
function setYear(d, val) {
    callDateSet(d, "FullYear", val);
}
module.exports = setYear;

},{"9c6e5a273897967":"6i5qR"}],"dXh2C":[function(require,module,exports) {
"use strict";
var callDateSet = require("8a49e801979304b2");
function setMonth(d, val) {
    callDateSet(d, "Month", val);
}
module.exports = setMonth;

},{"8a49e801979304b2":"6i5qR"}],"eedt3":[function(require,module,exports) {
"use strict";
var _utc = require("5154beec32f53e07");
function cloneDate(d) {
    // Rhino environments have a bug where new Date(d) truncates
    // milliseconds so need to call getTime() here.
    var clone = new Date(d.getTime());
    _utc(clone, !!_utc(d));
    return clone;
}
module.exports = cloneDate;

},{"5154beec32f53e07":"c68pM"}],"ht9xE":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("8d962ec69a72b930"), setDate = require("a45a7367f3c62e23"), setUnitAndLowerToEdge = require("e930bb8dcf3de909"), moveToBeginningOfWeek = require("395f4d987d7d3a95");
var MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function moveToFirstDayOfWeekYear(d, firstDayOfWeek, firstDayOfWeekYear) {
    setUnitAndLowerToEdge(d, MONTH_INDEX);
    setDate(d, firstDayOfWeekYear);
    moveToBeginningOfWeek(d, firstDayOfWeek);
}
module.exports = moveToFirstDayOfWeekYear;

},{"8d962ec69a72b930":"gdeYg","a45a7367f3c62e23":"cOXbt","e930bb8dcf3de909":"5Zx4m","395f4d987d7d3a95":"9q27J"}],"9q27J":[function(require,module,exports) {
"use strict";
var setWeekday = require("b2fea3de6eef4173"), getWeekday = require("667339a4fd04c8de"), mathAliases = require("916c5ea3492ab7b6");
var floor = mathAliases.floor;
function moveToBeginningOfWeek(d, firstDayOfWeek) {
    setWeekday(d, floor((getWeekday(d) - firstDayOfWeek) / 7) * 7 + firstDayOfWeek);
    return d;
}
module.exports = moveToBeginningOfWeek;

},{"b2fea3de6eef4173":"2wPrY","667339a4fd04c8de":"gHTdp","916c5ea3492ab7b6":"89tTN"}],"9qXnd":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("2a4a7b827b9391e8"), isDefined = require("c6e7b6d374cb154"), getDateParam = require("67e5c358b26d3928"), iterateOverDateUnits = require("6c6acc04b6e833bd");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
function iterateOverDateParams(params, fn, startIndex, endIndex) {
    function run(name, unit, i) {
        var val = getDateParam(params, name);
        if (isDefined(val)) fn(name, val, unit, i);
    }
    iterateOverDateUnits(function(unit, i) {
        var result = run(unit.name, unit, i);
        if (result !== false && i === DAY_INDEX) // Check for "weekday", which has a distinct meaning
        // in the context of setting a date, but has the same
        // meaning as "day" as a unit of time.
        result = run("weekday", unit, i);
        return result;
    }, startIndex, endIndex);
}
module.exports = iterateOverDateParams;

},{"2a4a7b827b9391e8":"gdeYg","c6e7b6d374cb154":"6Ge6e","67e5c358b26d3928":"9do9e","6c6acc04b6e833bd":"aMlAF"}],"9do9e":[function(require,module,exports) {
"use strict";
var getDateParamKey = require("477efbaff8da2ea5"), coreUtilityAliases = require("f8a68b51875dc5a1");
var getOwn = coreUtilityAliases.getOwn;
function getDateParam(params, key) {
    return getOwn(params, getDateParamKey(params, key));
}
module.exports = getDateParam;

},{"477efbaff8da2ea5":"kG4Lp","f8a68b51875dc5a1":"dU8Nu"}],"kG4Lp":[function(require,module,exports) {
"use strict";
var getOwnKey = require("78aa89eb6ed23c0d");
function getDateParamKey(params, key) {
    return getOwnKey(params, key) || getOwnKey(params, key + "s") || key === "day" && getOwnKey(params, "date");
}
module.exports = getDateParamKey;

},{"78aa89eb6ed23c0d":"lMBpH"}],"lMBpH":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("d774bffb059fde5c");
var hasOwn = coreUtilityAliases.hasOwn;
function getOwnKey(obj, key) {
    if (hasOwn(obj, key)) return key;
}
module.exports = getOwnKey;

},{"d774bffb059fde5c":"dU8Nu"}],"4dVD0":[function(require,module,exports) {
"use strict";
var updateDate = require("9bcb876b739eefd4");
function advanceDate(d, unit, num, reset) {
    var set = {};
    set[unit] = num;
    return updateDate(d, set, reset, 1);
}
module.exports = advanceDate;

},{"9bcb876b739eefd4":"3A93x"}],"g2Fy2":[function(require,module,exports) {
"use strict";
function dateIsValid(d) {
    return !isNaN(d.getTime());
}
module.exports = dateIsValid;

},{}],"5NVeO":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("77c9dcce54fe81f0"), DateUnitIndexes = require("4a70673ff32fd92b"), moveToEndOfWeek = require("57315136451d819"), getLowerUnitIndex = require("80c74397bd09a6ec"), setUnitAndLowerToEdge = require("c68325758b48d1c2");
var WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, localeManager = LocaleHelpers.localeManager;
function moveToEndOfUnit(d, unitIndex, localeCode, stopIndex) {
    if (unitIndex === WEEK_INDEX) moveToEndOfWeek(d, localeManager.get(localeCode).getFirstDayOfWeek());
    return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex), stopIndex, true);
}
module.exports = moveToEndOfUnit;

},{"77c9dcce54fe81f0":"14L7V","4a70673ff32fd92b":"gdeYg","57315136451d819":"ae8ut","80c74397bd09a6ec":"eQJNq","c68325758b48d1c2":"5Zx4m"}],"ae8ut":[function(require,module,exports) {
"use strict";
var setWeekday = require("f780cb5fe3d31811"), getWeekday = require("98d407c149320dda"), mathAliases = require("c585c083913472c3");
var ceil = mathAliases.ceil;
function moveToEndOfWeek(d, firstDayOfWeek) {
    var target = firstDayOfWeek - 1;
    setWeekday(d, ceil((getWeekday(d) - target) / 7) * 7 + target);
    return d;
}
module.exports = moveToEndOfWeek;

},{"f780cb5fe3d31811":"2wPrY","98d407c149320dda":"gHTdp","c585c083913472c3":"89tTN"}],"laN9X":[function(require,module,exports) {
"use strict";
var getDateParamKey = require("48d1cf3f9fe5f481");
function deleteDateParam(params, key) {
    delete params[getDateParamKey(params, key)];
}
module.exports = deleteDateParam;

},{"48d1cf3f9fe5f481":"kG4Lp"}],"lHsKR":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("f5a4a16aaf98f70e"), DateUnitIndexes = require("eb0cf4a4da90827"), getLowerUnitIndex = require("dbe788127350b57a"), moveToBeginningOfWeek = require("99d65aa839b01219"), setUnitAndLowerToEdge = require("23f7b557225cf55a");
var WEEK_INDEX = DateUnitIndexes.WEEK_INDEX, localeManager = LocaleHelpers.localeManager;
function moveToBeginningOfUnit(d, unitIndex, localeCode) {
    if (unitIndex === WEEK_INDEX) moveToBeginningOfWeek(d, localeManager.get(localeCode).getFirstDayOfWeek());
    return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex));
}
module.exports = moveToBeginningOfUnit;

},{"f5a4a16aaf98f70e":"14L7V","eb0cf4a4da90827":"gdeYg","dbe788127350b57a":"eQJNq","99d65aa839b01219":"9q27J","23f7b557225cf55a":"5Zx4m"}],"d7Nt5":[function(require,module,exports) {
"use strict";
var getYear = require("428603d1b435e8ba"), mathAliases = require("ba4114eb5b64b2bf");
var abs = mathAliases.abs;
function getYearFromAbbreviation(str, d, prefer) {
    // Following IETF here, adding 1900 or 2000 depending on the last two digits.
    // Note that this makes no accordance for what should happen after 2050, but
    // intentionally ignoring this for now. https://www.ietf.org/rfc/rfc2822.txt
    var val = +str, delta;
    val += val < 50 ? 2000 : 1900;
    if (prefer) {
        delta = val - getYear(d);
        if (delta / abs(delta) !== prefer) val += prefer * 100;
    }
    return val;
}
module.exports = getYearFromAbbreviation;

},{"428603d1b435e8ba":"8JXHQ","ba4114eb5b64b2bf":"89tTN"}],"eubHC":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("83e728e558d1af78"), iterateOverDateParams = require("c573ccd1b679cd05");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX, YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function iterateOverHigherDateParams(params, fn) {
    iterateOverDateParams(params, fn, YEAR_INDEX, DAY_INDEX);
}
module.exports = iterateOverHigherDateParams;

},{"83e728e558d1af78":"gdeYg","c573ccd1b679cd05":"9qXnd"}],"8korI":[function(require,module,exports) {
"use strict";
var setDateChainableConstructor = require("f2ca6583fab42a0c");
setDateChainableConstructor();

},{"f2ca6583fab42a0c":"exAdz"}],"exAdz":[function(require,module,exports) {
"use strict";
var createDate = require("f96dbda191364dcb"), namespaceAliases = require("97c7e8c80f116bf8"), setChainableConstructor = require("65a0c271f705efa6");
var sugarDate = namespaceAliases.sugarDate;
function setDateChainableConstructor() {
    setChainableConstructor(sugarDate, createDate);
}
module.exports = setDateChainableConstructor;

},{"f96dbda191364dcb":"h5ei3","97c7e8c80f116bf8":"1TEpR","65a0c271f705efa6":"e8Ncr"}],"eoQ1l":[function(require,module,exports) {
"use strict";
var Sugar = require("a8fa63e45c1434bc"), LocaleHelpers = require("998a83525f3b984a"), getKeys = require("a3fadafd69b65b69");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "getAllLocaleCodes": function() {
        return getKeys(localeManager.getAll());
    }
});
module.exports = Sugar.Date.getAllLocaleCodes;

},{"a8fa63e45c1434bc":"eWYA2","998a83525f3b984a":"14L7V","a3fadafd69b65b69":"6cOTr"}],"ew3oH":[function(require,module,exports) {
"use strict";
var Sugar = require("350ed86b6337dfb8"), LocaleHelpers = require("1ac2cf11ba9d655d");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "getAllLocales": function() {
        return localeManager.getAll();
    }
});
module.exports = Sugar.Date.getAllLocales;

},{"350ed86b6337dfb8":"eWYA2","1ac2cf11ba9d655d":"14L7V"}],"iLjEm":[function(require,module,exports) {
"use strict";
var Sugar = require("16a2475a84379ced"), LocaleHelpers = require("2102d00e66de0a75");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "getLocale": function(code) {
        return localeManager.get(code, !code);
    }
});
module.exports = Sugar.Date.getLocale;

},{"16a2475a84379ced":"eWYA2","2102d00e66de0a75":"14L7V"}],"bzKi8":[function(require,module,exports) {
"use strict";
var Sugar = require("881b1bdf7f243fbb"), LocaleHelpers = require("a4293a826b164415");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "removeLocale": function(code) {
        return localeManager.remove(code);
    }
});
module.exports = Sugar.Date.removeLocale;

},{"881b1bdf7f243fbb":"eWYA2","a4293a826b164415":"14L7V"}],"jCEVj":[function(require,module,exports) {
"use strict";
var Sugar = require("2e194fa384bab4f"), LocaleHelpers = require("5df091b3ca772e92");
var localeManager = LocaleHelpers.localeManager;
Sugar.Date.defineStatic({
    "setLocale": function(code) {
        return localeManager.set(code);
    }
});
module.exports = Sugar.Date.setLocale;

},{"2e194fa384bab4f":"eWYA2","5df091b3ca772e92":"14L7V"}],"eqv6f":[function(require,module,exports) {
"use strict";
var Sugar = require("5161ac700bb98bf2");
require("7104c1d2f530315a");
module.exports = Sugar.Number.day;

},{"5161ac700bb98bf2":"eWYA2","7104c1d2f530315a":"bJYzv"}],"bJYzv":[function(require,module,exports) {
"use strict";
var buildNumberUnitMethods = require("e29c3ee3b2a23ac3");
buildNumberUnitMethods();

},{"e29c3ee3b2a23ac3":"6cH7J"}],"6cH7J":[function(require,module,exports) {
"use strict";
var DateUnits = require("231b697d9931ce0"), createDate = require("1b9dfa0af85c91b7"), mathAliases = require("24e6373f9561205b"), advanceDate = require("8c670efc941eb1de"), namespaceAliases = require("fd70ce2e6f79b06a"), defineInstanceSimilar = require("7a06f9ad97c9695e");
var sugarNumber = namespaceAliases.sugarNumber, round = mathAliases.round;
function buildNumberUnitMethods() {
    defineInstanceSimilar(sugarNumber, DateUnits, function(methods, unit) {
        var name = unit.name, base, after, before;
        base = function base(n) {
            return round(n * unit.multiplier);
        };
        after = function after(n, d, options) {
            return advanceDate(createDate(d, options, true), name, n);
        };
        before = function before(n, d, options) {
            return advanceDate(createDate(d, options, true), name, -n);
        };
        methods[name] = base;
        methods[name + "s"] = base;
        methods[name + "Before"] = before;
        methods[name + "sBefore"] = before;
        methods[name + "Ago"] = before;
        methods[name + "sAgo"] = before;
        methods[name + "After"] = after;
        methods[name + "sAfter"] = after;
        methods[name + "FromNow"] = after;
        methods[name + "sFromNow"] = after;
    });
}
module.exports = buildNumberUnitMethods;

},{"231b697d9931ce0":"5sdJf","1b9dfa0af85c91b7":"h5ei3","24e6373f9561205b":"89tTN","8c670efc941eb1de":"4dVD0","fd70ce2e6f79b06a":"1TEpR","7a06f9ad97c9695e":"BfBjK"}],"iKIj7":[function(require,module,exports) {
"use strict";
var Sugar = require("ce269ea34e72a013");
require("37661e0b6442eaf9");
module.exports = Sugar.Number.dayAfter;

},{"ce269ea34e72a013":"eWYA2","37661e0b6442eaf9":"bJYzv"}],"97FlW":[function(require,module,exports) {
"use strict";
var Sugar = require("f6789f6a100edcd");
require("7bd1ebbaea1d20a9");
module.exports = Sugar.Number.dayAgo;

},{"f6789f6a100edcd":"eWYA2","7bd1ebbaea1d20a9":"bJYzv"}],"93T0w":[function(require,module,exports) {
"use strict";
var Sugar = require("b8d03a717bba1c63");
require("2f65d94db13d872b");
module.exports = Sugar.Number.dayBefore;

},{"b8d03a717bba1c63":"eWYA2","2f65d94db13d872b":"bJYzv"}],"jSIOv":[function(require,module,exports) {
"use strict";
var Sugar = require("76ad73e8b21a413e");
require("4392122fee409104");
module.exports = Sugar.Number.dayFromNow;

},{"76ad73e8b21a413e":"eWYA2","4392122fee409104":"bJYzv"}],"d4rNE":[function(require,module,exports) {
"use strict";
var Sugar = require("719eec179515c49e");
require("5972f7d4b2b23323");
module.exports = Sugar.Number.days;

},{"719eec179515c49e":"eWYA2","5972f7d4b2b23323":"bJYzv"}],"3ks3W":[function(require,module,exports) {
"use strict";
var Sugar = require("876072070022ada0");
require("46aff7a564cd9891");
module.exports = Sugar.Number.daysAfter;

},{"876072070022ada0":"eWYA2","46aff7a564cd9891":"bJYzv"}],"dMZhp":[function(require,module,exports) {
"use strict";
var Sugar = require("48dfb5eb66f3d0a4");
require("641283aa9d2d7bbf");
module.exports = Sugar.Number.daysAgo;

},{"48dfb5eb66f3d0a4":"eWYA2","641283aa9d2d7bbf":"bJYzv"}],"1a3Cp":[function(require,module,exports) {
"use strict";
var Sugar = require("878b7029b53d6b41");
require("61ed6fc43e8af92c");
module.exports = Sugar.Number.daysBefore;

},{"878b7029b53d6b41":"eWYA2","61ed6fc43e8af92c":"bJYzv"}],"1SKDP":[function(require,module,exports) {
"use strict";
var Sugar = require("196b70395278974b");
require("656ff7170629ce6");
module.exports = Sugar.Number.daysFromNow;

},{"196b70395278974b":"eWYA2","656ff7170629ce6":"bJYzv"}],"iqj8C":[function(require,module,exports) {
"use strict";
var Sugar = require("167791c90248a133"), LocaleHelpers = require("abae49f0eb5a3228");
var localeManager = LocaleHelpers.localeManager;
Sugar.Number.defineInstance({
    "duration": function(n, localeCode) {
        return localeManager.get(localeCode).getDuration(n);
    }
});
module.exports = Sugar.Number.duration;

},{"167791c90248a133":"eWYA2","abae49f0eb5a3228":"14L7V"}],"56998":[function(require,module,exports) {
"use strict";
var Sugar = require("9f5a9902081ef970");
require("19f71104ec0223e9");
module.exports = Sugar.Number.hour;

},{"9f5a9902081ef970":"eWYA2","19f71104ec0223e9":"bJYzv"}],"iEcIf":[function(require,module,exports) {
"use strict";
var Sugar = require("107ad9187d2bb7f5");
require("bdb691c84a48cd45");
module.exports = Sugar.Number.hourAfter;

},{"107ad9187d2bb7f5":"eWYA2","bdb691c84a48cd45":"bJYzv"}],"57DK4":[function(require,module,exports) {
"use strict";
var Sugar = require("a611b75d6d2b9616");
require("c11ec1dc51e0fc90");
module.exports = Sugar.Number.hourAgo;

},{"a611b75d6d2b9616":"eWYA2","c11ec1dc51e0fc90":"bJYzv"}],"iR4ri":[function(require,module,exports) {
"use strict";
var Sugar = require("90b355fe94d7133e");
require("17f044a14081e816");
module.exports = Sugar.Number.hourBefore;

},{"90b355fe94d7133e":"eWYA2","17f044a14081e816":"bJYzv"}],"bES7l":[function(require,module,exports) {
"use strict";
var Sugar = require("f49851ffab041ec6");
require("21eca0f3264d939b");
module.exports = Sugar.Number.hourFromNow;

},{"f49851ffab041ec6":"eWYA2","21eca0f3264d939b":"bJYzv"}],"423PR":[function(require,module,exports) {
"use strict";
var Sugar = require("e4c5e0455686a802");
require("d7565e03352444ce");
module.exports = Sugar.Number.hours;

},{"e4c5e0455686a802":"eWYA2","d7565e03352444ce":"bJYzv"}],"jCzzH":[function(require,module,exports) {
"use strict";
var Sugar = require("8b471ea5352a9fa");
require("f8a9c156b958de95");
module.exports = Sugar.Number.hoursAfter;

},{"8b471ea5352a9fa":"eWYA2","f8a9c156b958de95":"bJYzv"}],"g3ps3":[function(require,module,exports) {
"use strict";
var Sugar = require("e7a6cd757b21686c");
require("c5cbdb0a1f748a93");
module.exports = Sugar.Number.hoursAgo;

},{"e7a6cd757b21686c":"eWYA2","c5cbdb0a1f748a93":"bJYzv"}],"7YCvN":[function(require,module,exports) {
"use strict";
var Sugar = require("9f6591af000a8a8d");
require("e19f2777c3d574e6");
module.exports = Sugar.Number.hoursBefore;

},{"9f6591af000a8a8d":"eWYA2","e19f2777c3d574e6":"bJYzv"}],"8oV3l":[function(require,module,exports) {
"use strict";
var Sugar = require("b1b98a41da946bd3");
require("e9ca656a81061acd");
module.exports = Sugar.Number.hoursFromNow;

},{"b1b98a41da946bd3":"eWYA2","e9ca656a81061acd":"bJYzv"}],"2fwlr":[function(require,module,exports) {
"use strict";
var Sugar = require("942fdc2890fdeef1");
require("bad6774b1d670317");
module.exports = Sugar.Number.millisecond;

},{"942fdc2890fdeef1":"eWYA2","bad6774b1d670317":"bJYzv"}],"hAkCm":[function(require,module,exports) {
"use strict";
var Sugar = require("af8f7db2d3a7f6bc");
require("c779c6d410b48624");
module.exports = Sugar.Number.millisecondAfter;

},{"af8f7db2d3a7f6bc":"eWYA2","c779c6d410b48624":"bJYzv"}],"e4902":[function(require,module,exports) {
"use strict";
var Sugar = require("23e6bad7acfed5e4");
require("9a79107714a2c7d8");
module.exports = Sugar.Number.millisecondAgo;

},{"23e6bad7acfed5e4":"eWYA2","9a79107714a2c7d8":"bJYzv"}],"j2IaI":[function(require,module,exports) {
"use strict";
var Sugar = require("eefa6920253f8ac");
require("d016f510f07a7ac6");
module.exports = Sugar.Number.millisecondBefore;

},{"eefa6920253f8ac":"eWYA2","d016f510f07a7ac6":"bJYzv"}],"3nT54":[function(require,module,exports) {
"use strict";
var Sugar = require("2c8b1b0eece12551");
require("65f07e2d3f29428");
module.exports = Sugar.Number.millisecondFromNow;

},{"2c8b1b0eece12551":"eWYA2","65f07e2d3f29428":"bJYzv"}],"iDb3a":[function(require,module,exports) {
"use strict";
var Sugar = require("ecacf0eafe680fde");
require("5dac133953cffe7");
module.exports = Sugar.Number.milliseconds;

},{"ecacf0eafe680fde":"eWYA2","5dac133953cffe7":"bJYzv"}],"4NNPE":[function(require,module,exports) {
"use strict";
var Sugar = require("93711df04e9a85d0");
require("a25eff1accef526e");
module.exports = Sugar.Number.millisecondsAfter;

},{"93711df04e9a85d0":"eWYA2","a25eff1accef526e":"bJYzv"}],"69QPo":[function(require,module,exports) {
"use strict";
var Sugar = require("d36fdb49254e22fb");
require("4e890db2479f23a");
module.exports = Sugar.Number.millisecondsAgo;

},{"d36fdb49254e22fb":"eWYA2","4e890db2479f23a":"bJYzv"}],"bShkG":[function(require,module,exports) {
"use strict";
var Sugar = require("d3cf426812f17015");
require("4483b4ed0368752b");
module.exports = Sugar.Number.millisecondsBefore;

},{"d3cf426812f17015":"eWYA2","4483b4ed0368752b":"bJYzv"}],"dbxck":[function(require,module,exports) {
"use strict";
var Sugar = require("a7e2a594e367fd31");
require("63970541c197d3a");
module.exports = Sugar.Number.millisecondsFromNow;

},{"a7e2a594e367fd31":"eWYA2","63970541c197d3a":"bJYzv"}],"kvXa7":[function(require,module,exports) {
"use strict";
var Sugar = require("8628456f49f81dfd");
require("279f2bfed1ae2b98");
module.exports = Sugar.Number.minute;

},{"8628456f49f81dfd":"eWYA2","279f2bfed1ae2b98":"bJYzv"}],"4oCYD":[function(require,module,exports) {
"use strict";
var Sugar = require("a995cb3993f5bbfe");
require("4b2f1e378639a9df");
module.exports = Sugar.Number.minuteAfter;

},{"a995cb3993f5bbfe":"eWYA2","4b2f1e378639a9df":"bJYzv"}],"hJjQh":[function(require,module,exports) {
"use strict";
var Sugar = require("6d1056372e623025");
require("e2dff67dffac1e9e");
module.exports = Sugar.Number.minuteAgo;

},{"6d1056372e623025":"eWYA2","e2dff67dffac1e9e":"bJYzv"}],"gEkAS":[function(require,module,exports) {
"use strict";
var Sugar = require("b040302926c670c5");
require("6288c4939b3e36c1");
module.exports = Sugar.Number.minuteBefore;

},{"b040302926c670c5":"eWYA2","6288c4939b3e36c1":"bJYzv"}],"fqZP4":[function(require,module,exports) {
"use strict";
var Sugar = require("fb1567639ab2c886");
require("2d1c2db59de2f9b7");
module.exports = Sugar.Number.minuteFromNow;

},{"fb1567639ab2c886":"eWYA2","2d1c2db59de2f9b7":"bJYzv"}],"dE8lQ":[function(require,module,exports) {
"use strict";
var Sugar = require("7b3cb2a330f704e5");
require("e8c0c82da28399a6");
module.exports = Sugar.Number.minutes;

},{"7b3cb2a330f704e5":"eWYA2","e8c0c82da28399a6":"bJYzv"}],"2rgI2":[function(require,module,exports) {
"use strict";
var Sugar = require("3e37ab71084d70ad");
require("cf5315872dbf6df");
module.exports = Sugar.Number.minutesAfter;

},{"3e37ab71084d70ad":"eWYA2","cf5315872dbf6df":"bJYzv"}],"brRJq":[function(require,module,exports) {
"use strict";
var Sugar = require("ea9e26d83fe0d9af");
require("d1e36e89a20466eb");
module.exports = Sugar.Number.minutesAgo;

},{"ea9e26d83fe0d9af":"eWYA2","d1e36e89a20466eb":"bJYzv"}],"jlRzI":[function(require,module,exports) {
"use strict";
var Sugar = require("d9b52939696eb39c");
require("e1a86d92913a4b0a");
module.exports = Sugar.Number.minutesBefore;

},{"d9b52939696eb39c":"eWYA2","e1a86d92913a4b0a":"bJYzv"}],"klNK4":[function(require,module,exports) {
"use strict";
var Sugar = require("5e25f1fb14b73b8d");
require("b1ca3f25b34002dc");
module.exports = Sugar.Number.minutesFromNow;

},{"5e25f1fb14b73b8d":"eWYA2","b1ca3f25b34002dc":"bJYzv"}],"50kiq":[function(require,module,exports) {
"use strict";
var Sugar = require("ac3df84423d52de4");
require("5bc1d2b1e3d986ee");
module.exports = Sugar.Number.month;

},{"ac3df84423d52de4":"eWYA2","5bc1d2b1e3d986ee":"bJYzv"}],"bTM0K":[function(require,module,exports) {
"use strict";
var Sugar = require("678091c90da799ae");
require("8916314d095f1247");
module.exports = Sugar.Number.monthAfter;

},{"678091c90da799ae":"eWYA2","8916314d095f1247":"bJYzv"}],"jFJPW":[function(require,module,exports) {
"use strict";
var Sugar = require("f3bedda6d3744e4d");
require("9798b044ccfaa722");
module.exports = Sugar.Number.monthAgo;

},{"f3bedda6d3744e4d":"eWYA2","9798b044ccfaa722":"bJYzv"}],"ihEbp":[function(require,module,exports) {
"use strict";
var Sugar = require("74f48408c7c69e8d");
require("89fa96e6b5c42c43");
module.exports = Sugar.Number.monthBefore;

},{"74f48408c7c69e8d":"eWYA2","89fa96e6b5c42c43":"bJYzv"}],"dQSYf":[function(require,module,exports) {
"use strict";
var Sugar = require("13f2377f1176a8af");
require("5454996d0bc919cc");
module.exports = Sugar.Number.monthFromNow;

},{"13f2377f1176a8af":"eWYA2","5454996d0bc919cc":"bJYzv"}],"441RH":[function(require,module,exports) {
"use strict";
var Sugar = require("b58a08301bb8a2da");
require("953c9b6350f72cf6");
module.exports = Sugar.Number.months;

},{"b58a08301bb8a2da":"eWYA2","953c9b6350f72cf6":"bJYzv"}],"bgWsb":[function(require,module,exports) {
"use strict";
var Sugar = require("c04021ce2ec78b22");
require("5f85300557c05836");
module.exports = Sugar.Number.monthsAfter;

},{"c04021ce2ec78b22":"eWYA2","5f85300557c05836":"bJYzv"}],"efAiH":[function(require,module,exports) {
"use strict";
var Sugar = require("a648afdaba684fbe");
require("50ae85892362874f");
module.exports = Sugar.Number.monthsAgo;

},{"a648afdaba684fbe":"eWYA2","50ae85892362874f":"bJYzv"}],"lAUA2":[function(require,module,exports) {
"use strict";
var Sugar = require("1ef67d1a87dff6bb");
require("1cc03b1dc0e37fe9");
module.exports = Sugar.Number.monthsBefore;

},{"1ef67d1a87dff6bb":"eWYA2","1cc03b1dc0e37fe9":"bJYzv"}],"9tNbs":[function(require,module,exports) {
"use strict";
var Sugar = require("b10cae6ddec0a9a6");
require("73200449b5a86ba8");
module.exports = Sugar.Number.monthsFromNow;

},{"b10cae6ddec0a9a6":"eWYA2","73200449b5a86ba8":"bJYzv"}],"54TXa":[function(require,module,exports) {
"use strict";
var Sugar = require("6c8324b68ab57074");
require("446e587eb7b98fa8");
module.exports = Sugar.Number.second;

},{"6c8324b68ab57074":"eWYA2","446e587eb7b98fa8":"bJYzv"}],"hGPHK":[function(require,module,exports) {
"use strict";
var Sugar = require("692802ac77db390f");
require("a82248d7da57302d");
module.exports = Sugar.Number.secondAfter;

},{"692802ac77db390f":"eWYA2","a82248d7da57302d":"bJYzv"}],"4CndI":[function(require,module,exports) {
"use strict";
var Sugar = require("27cc12d45c9ef6f6");
require("bad3cd613f43a04b");
module.exports = Sugar.Number.secondAgo;

},{"27cc12d45c9ef6f6":"eWYA2","bad3cd613f43a04b":"bJYzv"}],"hh82e":[function(require,module,exports) {
"use strict";
var Sugar = require("ee6efe53f7005e58");
require("e295e9a2ac4dba3c");
module.exports = Sugar.Number.secondBefore;

},{"ee6efe53f7005e58":"eWYA2","e295e9a2ac4dba3c":"bJYzv"}],"bD6Vu":[function(require,module,exports) {
"use strict";
var Sugar = require("35dd4cf397bde0e0");
require("1b46df60aa912938");
module.exports = Sugar.Number.secondFromNow;

},{"35dd4cf397bde0e0":"eWYA2","1b46df60aa912938":"bJYzv"}],"ifb9O":[function(require,module,exports) {
"use strict";
var Sugar = require("7caafb15d4c8fe25");
require("dac782dc4dfadc4");
module.exports = Sugar.Number.seconds;

},{"7caafb15d4c8fe25":"eWYA2","dac782dc4dfadc4":"bJYzv"}],"5CMWb":[function(require,module,exports) {
"use strict";
var Sugar = require("82983f054a90b6a5");
require("d033f6806e13f611");
module.exports = Sugar.Number.secondsAfter;

},{"82983f054a90b6a5":"eWYA2","d033f6806e13f611":"bJYzv"}],"kwRtq":[function(require,module,exports) {
"use strict";
var Sugar = require("4f895db220cd9c12");
require("501caed7ead9e94d");
module.exports = Sugar.Number.secondsAgo;

},{"4f895db220cd9c12":"eWYA2","501caed7ead9e94d":"bJYzv"}],"3wAWP":[function(require,module,exports) {
"use strict";
var Sugar = require("e1452c1b1099ed6a");
require("7c58d0e5e1590606");
module.exports = Sugar.Number.secondsBefore;

},{"e1452c1b1099ed6a":"eWYA2","7c58d0e5e1590606":"bJYzv"}],"lbSa7":[function(require,module,exports) {
"use strict";
var Sugar = require("70aa2adbbc797b8e");
require("5f442df2ea9135d8");
module.exports = Sugar.Number.secondsFromNow;

},{"70aa2adbbc797b8e":"eWYA2","5f442df2ea9135d8":"bJYzv"}],"csBoO":[function(require,module,exports) {
"use strict";
var Sugar = require("db764115992a5865");
require("743651ba7ab8ff28");
module.exports = Sugar.Number.week;

},{"db764115992a5865":"eWYA2","743651ba7ab8ff28":"bJYzv"}],"fDRcM":[function(require,module,exports) {
"use strict";
var Sugar = require("c62b2df9e93be77");
require("6e7318ac449d6b88");
module.exports = Sugar.Number.weekAfter;

},{"c62b2df9e93be77":"eWYA2","6e7318ac449d6b88":"bJYzv"}],"geiiQ":[function(require,module,exports) {
"use strict";
var Sugar = require("8ead87fc5af7475");
require("10398ed3e7f12be7");
module.exports = Sugar.Number.weekAgo;

},{"8ead87fc5af7475":"eWYA2","10398ed3e7f12be7":"bJYzv"}],"eXsvE":[function(require,module,exports) {
"use strict";
var Sugar = require("7b58cd04233941ed");
require("566ac0dae90024b0");
module.exports = Sugar.Number.weekBefore;

},{"7b58cd04233941ed":"eWYA2","566ac0dae90024b0":"bJYzv"}],"wtubL":[function(require,module,exports) {
"use strict";
var Sugar = require("d7762041ebaa8d80");
require("80e29b2de5658d3");
module.exports = Sugar.Number.weekFromNow;

},{"d7762041ebaa8d80":"eWYA2","80e29b2de5658d3":"bJYzv"}],"4i0Q3":[function(require,module,exports) {
"use strict";
var Sugar = require("1db3b74db4aef12f");
require("5b08b6d5fe16abfe");
module.exports = Sugar.Number.weeks;

},{"1db3b74db4aef12f":"eWYA2","5b08b6d5fe16abfe":"bJYzv"}],"020xA":[function(require,module,exports) {
"use strict";
var Sugar = require("26c147cb4c3e414a");
require("fc22486f9bd798f1");
module.exports = Sugar.Number.weeksAfter;

},{"26c147cb4c3e414a":"eWYA2","fc22486f9bd798f1":"bJYzv"}],"6Krz9":[function(require,module,exports) {
"use strict";
var Sugar = require("e84730f3b2507e8c");
require("b47769222f9f5045");
module.exports = Sugar.Number.weeksAgo;

},{"e84730f3b2507e8c":"eWYA2","b47769222f9f5045":"bJYzv"}],"kYU07":[function(require,module,exports) {
"use strict";
var Sugar = require("4a6863bcadd416c2");
require("4b9c3f5cb87d1de5");
module.exports = Sugar.Number.weeksBefore;

},{"4a6863bcadd416c2":"eWYA2","4b9c3f5cb87d1de5":"bJYzv"}],"4GuKQ":[function(require,module,exports) {
"use strict";
var Sugar = require("23242960531fee73");
require("5d9f65869b02c8c2");
module.exports = Sugar.Number.weeksFromNow;

},{"23242960531fee73":"eWYA2","5d9f65869b02c8c2":"bJYzv"}],"gPb8g":[function(require,module,exports) {
"use strict";
var Sugar = require("cb72644dc586dbeb");
require("d046a837248255f7");
module.exports = Sugar.Number.year;

},{"cb72644dc586dbeb":"eWYA2","d046a837248255f7":"bJYzv"}],"7eoGd":[function(require,module,exports) {
"use strict";
var Sugar = require("7ccd8f2bd185f41d");
require("2a1a189db7e35ab3");
module.exports = Sugar.Number.yearAfter;

},{"7ccd8f2bd185f41d":"eWYA2","2a1a189db7e35ab3":"bJYzv"}],"hLEZh":[function(require,module,exports) {
"use strict";
var Sugar = require("564daa764b2516db");
require("59414e50068a0b1b");
module.exports = Sugar.Number.yearAgo;

},{"564daa764b2516db":"eWYA2","59414e50068a0b1b":"bJYzv"}],"kXIpU":[function(require,module,exports) {
"use strict";
var Sugar = require("3f27fbdfdc9e36d");
require("fcfc88250c320770");
module.exports = Sugar.Number.yearBefore;

},{"3f27fbdfdc9e36d":"eWYA2","fcfc88250c320770":"bJYzv"}],"hoKw3":[function(require,module,exports) {
"use strict";
var Sugar = require("225d416b0b364bcd");
require("9d63ca8502c0b0a6");
module.exports = Sugar.Number.yearFromNow;

},{"225d416b0b364bcd":"eWYA2","9d63ca8502c0b0a6":"bJYzv"}],"i2e46":[function(require,module,exports) {
"use strict";
var Sugar = require("47ccb1a1c3da3771");
require("f79c581d0221de20");
module.exports = Sugar.Number.years;

},{"47ccb1a1c3da3771":"eWYA2","f79c581d0221de20":"bJYzv"}],"lKTNJ":[function(require,module,exports) {
"use strict";
var Sugar = require("269aafcb797bad00");
require("9fa0e22fe1e5220f");
module.exports = Sugar.Number.yearsAfter;

},{"269aafcb797bad00":"eWYA2","9fa0e22fe1e5220f":"bJYzv"}],"eSlMz":[function(require,module,exports) {
"use strict";
var Sugar = require("ee9b8597cfa028c2");
require("7145c07985b0cf64");
module.exports = Sugar.Number.yearsAgo;

},{"ee9b8597cfa028c2":"eWYA2","7145c07985b0cf64":"bJYzv"}],"eSo4L":[function(require,module,exports) {
"use strict";
var Sugar = require("87d8a04083fffd63");
require("1c7dca10e01b2625");
module.exports = Sugar.Number.yearsBefore;

},{"87d8a04083fffd63":"eWYA2","1c7dca10e01b2625":"bJYzv"}],"9HlrV":[function(require,module,exports) {
"use strict";
var Sugar = require("b4245bc1989c018c");
require("1628e05bf0b16a4b");
module.exports = Sugar.Number.yearsFromNow;

},{"b4245bc1989c018c":"eWYA2","1628e05bf0b16a4b":"bJYzv"}],"aHfBo":[function(require,module,exports) {
"use strict";
var Sugar = require("bc782b6c532e80e7");
require("5e618e1b01d2d4ae");
module.exports = Sugar.Date.addDays;

},{"bc782b6c532e80e7":"eWYA2","5e618e1b01d2d4ae":"2DvlL"}],"2DvlL":[function(require,module,exports) {
"use strict";
var buildDateUnitMethods = require("9b066416d20dd83c");
buildDateUnitMethods();

},{"9b066416d20dd83c":"3wHBn"}],"3wHBn":[function(require,module,exports) {
"use strict";
var DateUnits = require("70db0493e85b6dae"), DateUnitIndexes = require("bb6af4480041dff3"), forEach = require("f4a68246d898ab2"), createDate = require("7dd50e63e9338ed2"), compareDate = require("e90cdc602368b242"), advanceDate = require("7531cefcc12f20a4"), moveToEndOfUnit = require("dc6f528f27c706e0"), namespaceAliases = require("d96ae4eb17ce77a0"), simpleCapitalize = require("c16164f87f18cf86"), moveToBeginningOfUnit = require("345c96ac4483464e"), defineInstanceSimilar = require("6f03737cf132aade"), getTimeDistanceForUnit = require("4cfde535d20fd037");
var sugarDate = namespaceAliases.sugarDate, HOURS_INDEX = DateUnitIndexes.HOURS_INDEX, DAY_INDEX = DateUnitIndexes.DAY_INDEX;
function buildDateUnitMethods() {
    defineInstanceSimilar(sugarDate, DateUnits, function(methods, unit, index) {
        var name = unit.name, caps = simpleCapitalize(name);
        if (index > DAY_INDEX) forEach([
            "Last",
            "This",
            "Next"
        ], function(shift) {
            methods["is" + shift + caps] = function(d, localeCode) {
                return compareDate(d, shift + " " + name, 0, localeCode, {
                    locale: "en"
                });
            };
        });
        if (index > HOURS_INDEX) {
            methods["beginningOf" + caps] = function(d, localeCode) {
                return moveToBeginningOfUnit(d, index, localeCode);
            };
            methods["endOf" + caps] = function(d, localeCode) {
                return moveToEndOfUnit(d, index, localeCode);
            };
        }
        methods["add" + caps + "s"] = function(d, num, reset) {
            return advanceDate(d, name, num, reset);
        };
        var since = function since(date, d, options) {
            return getTimeDistanceForUnit(date, createDate(d, options, true), unit);
        };
        var until = function until(date, d, options) {
            return getTimeDistanceForUnit(createDate(d, options, true), date, unit);
        };
        methods[name + "sAgo"] = methods[name + "sUntil"] = until;
        methods[name + "sSince"] = methods[name + "sFromNow"] = since;
    });
}
module.exports = buildDateUnitMethods;

},{"70db0493e85b6dae":"5sdJf","bb6af4480041dff3":"gdeYg","f4a68246d898ab2":"1n2CK","7dd50e63e9338ed2":"h5ei3","e90cdc602368b242":"kLi9A","7531cefcc12f20a4":"4dVD0","dc6f528f27c706e0":"5NVeO","d96ae4eb17ce77a0":"1TEpR","c16164f87f18cf86":"jYftQ","345c96ac4483464e":"lHsKR","6f03737cf132aade":"BfBjK","4cfde535d20fd037":"eGw7X"}],"kLi9A":[function(require,module,exports) {
"use strict";
var MINUTES = require("9af3ed2ba35bf0fb"), DateUnits = require("6deeb7f7f37f4d99"), DateUnitIndexes = require("3b5ab5f103571b6c"), _utc = require("b51839836c2e7e5"), tzOffset = require("e6ce12f7ecfcace9"), cloneDate = require("2416e843a520138a"), isDefined = require("c783b6415f212f06"), advanceDate = require("7822314615730b68"), dateIsValid = require("736e58dbba504987"), moveToEndOfUnit = require("1d2e2f2a1d15e884"), getExtendedDate = require("ac071b6ec87e19ea"), moveToBeginningOfUnit = require("a4d81ac353451c47");
var MONTH_INDEX = DateUnitIndexes.MONTH_INDEX;
function compareDate(date, d, margin, localeCode, options) {
    var loMargin = 0, hiMargin = 0, timezoneShift, compareEdges, override, min, max, p, t;
    function getTimezoneShift() {
        // If there is any specificity in the date then we're implicitly not
        // checking absolute time, so ignore timezone shifts.
        if (p.set && p.set.specificity) return 0;
        return (tzOffset(p.date) - tzOffset(date)) * MINUTES;
    }
    function addSpecificUnit() {
        var unit = DateUnits[p.set.specificity];
        return advanceDate(cloneDate(p.date), unit.name, 1).getTime() - 1;
    }
    if (_utc(date)) {
        options = options || {};
        options.fromUTC = true;
        options.setUTC = true;
    }
    p = getExtendedDate(null, d, options, true);
    if (margin > 0) {
        loMargin = hiMargin = margin;
        override = true;
    }
    if (!dateIsValid(p.date)) return false;
    if (p.set && p.set.specificity) {
        if (isDefined(p.set.edge) || isDefined(p.set.shift)) {
            compareEdges = true;
            moveToBeginningOfUnit(p.date, p.set.specificity, localeCode);
        }
        if (compareEdges || p.set.specificity === MONTH_INDEX) max = moveToEndOfUnit(cloneDate(p.date), p.set.specificity, localeCode).getTime();
        else max = addSpecificUnit();
        if (!override && isDefined(p.set.sign) && p.set.specificity) {
            // If the time is relative, there can occasionally be an disparity between
            // the relative date and "now", which it is being compared to, so set an
            // extra margin to account for this.
            loMargin = 50;
            hiMargin = -50;
        }
    }
    t = date.getTime();
    min = p.date.getTime();
    max = max || min;
    timezoneShift = getTimezoneShift();
    // istanbul ignore if
    if (timezoneShift) {
        min -= timezoneShift;
        max -= timezoneShift;
    }
    return t >= min - loMargin && t <= max + hiMargin;
}
module.exports = compareDate;

},{"9af3ed2ba35bf0fb":"enORn","6deeb7f7f37f4d99":"5sdJf","3b5ab5f103571b6c":"gdeYg","b51839836c2e7e5":"c68pM","e6ce12f7ecfcace9":"hZpDB","2416e843a520138a":"eedt3","c783b6415f212f06":"6Ge6e","7822314615730b68":"4dVD0","736e58dbba504987":"g2Fy2","1d2e2f2a1d15e884":"5NVeO","ac071b6ec87e19ea":"5yq5j","a4d81ac353451c47":"lHsKR"}],"eGw7X":[function(require,module,exports) {
"use strict";
var trunc = require("7eb87c36f7e800bc"), cloneDate = require("7dcc787bd3ab70d7"), advanceDate = require("f83d60bb577e5bed");
function getTimeDistanceForUnit(d1, d2, unit) {
    var fwd = d2 > d1, num, tmp;
    if (!fwd) {
        tmp = d2;
        d2 = d1;
        d1 = tmp;
    }
    num = d2 - d1;
    if (unit.multiplier > 1) num = trunc(num / unit.multiplier);
    // For higher order with potential ambiguity, use the numeric calculation
    // as a starting point, then iterate until we pass the target date. Decrement
    // starting point by 1 to prevent overshooting the date due to inconsistencies
    // in ambiguous units numerically. For example, calculating the number of days
    // from the beginning of the year to August 5th at 11:59:59 by doing a simple
    // d2 - d1 will produce different results depending on whether or not a
    // timezone shift was encountered due to DST, however that should not have an
    // effect on our calculation here, so subtract by 1 to ensure that the
    // starting point has not already overshot our target date.
    if (unit.ambiguous) {
        d1 = cloneDate(d1);
        if (num) {
            num -= 1;
            advanceDate(d1, unit.name, num);
        }
        while(d1 < d2){
            advanceDate(d1, unit.name, 1);
            if (d1 > d2) break;
            num += 1;
        }
    }
    return fwd ? -num : num;
}
module.exports = getTimeDistanceForUnit;

},{"7eb87c36f7e800bc":"ePaYC","7dcc787bd3ab70d7":"eedt3","f83d60bb577e5bed":"4dVD0"}],"iZrlT":[function(require,module,exports) {
"use strict";
var Sugar = require("f6c2b4d5a1bd60db");
require("3f20f7db648193a4");
module.exports = Sugar.Date.addHours;

},{"f6c2b4d5a1bd60db":"eWYA2","3f20f7db648193a4":"2DvlL"}],"jp3ip":[function(require,module,exports) {
"use strict";
var Sugar = require("5f410b6aebffa6b9");
require("9ba4d9edb98d97f6");
module.exports = Sugar.Date.addMilliseconds;

},{"5f410b6aebffa6b9":"eWYA2","9ba4d9edb98d97f6":"2DvlL"}],"4PSIz":[function(require,module,exports) {
"use strict";
var Sugar = require("fa32509b4d16b077");
require("a8482c96988b82ca");
module.exports = Sugar.Date.addMinutes;

},{"fa32509b4d16b077":"eWYA2","a8482c96988b82ca":"2DvlL"}],"kjwu9":[function(require,module,exports) {
"use strict";
var Sugar = require("1c57fa8d9b3e98df");
require("5b494539afaeee17");
module.exports = Sugar.Date.addMonths;

},{"1c57fa8d9b3e98df":"eWYA2","5b494539afaeee17":"2DvlL"}],"efMTx":[function(require,module,exports) {
"use strict";
var Sugar = require("9509bdef675c88a9");
require("9b5b94e9d0243b97");
module.exports = Sugar.Date.addSeconds;

},{"9509bdef675c88a9":"eWYA2","9b5b94e9d0243b97":"2DvlL"}],"2cQla":[function(require,module,exports) {
"use strict";
var Sugar = require("2ba41a6f743b41e5");
require("a20c9fc34867dea7");
module.exports = Sugar.Date.addWeeks;

},{"2ba41a6f743b41e5":"eWYA2","a20c9fc34867dea7":"2DvlL"}],"kbdwn":[function(require,module,exports) {
"use strict";
var Sugar = require("dc138e8a8b95e144");
require("33a0501c1a42272a");
module.exports = Sugar.Date.addYears;

},{"dc138e8a8b95e144":"eWYA2","33a0501c1a42272a":"2DvlL"}],"1nMl5":[function(require,module,exports) {
"use strict";
var Sugar = require("8b3076a6b74e3741"), advanceDateWithArgs = require("d5efa39447b656b8");
Sugar.Date.defineInstanceWithArguments({
    "advance": function(d, args) {
        return advanceDateWithArgs(d, args, 1);
    }
});
module.exports = Sugar.Date.advance;

},{"8b3076a6b74e3741":"eWYA2","d5efa39447b656b8":"bGrKY"}],"bGrKY":[function(require,module,exports) {
"use strict";
var updateDate = require("90238c19a6cb2ded"), collectUpdateDateArguments = require("a9c82b90b20ac820");
function advanceDateWithArgs(d, args, dir) {
    args = collectUpdateDateArguments(args, true);
    return updateDate(d, args[0], args[1], dir);
}
module.exports = advanceDateWithArgs;

},{"90238c19a6cb2ded":"3A93x","a9c82b90b20ac820":"34jSC"}],"34jSC":[function(require,module,exports) {
"use strict";
var classChecks = require("e77e9632eb73a2de"), simpleClone = require("22e57e05fd71f390"), isObjectType = require("b9f434ec7a43a1bc"), getDateParamsFromString = require("fadc24f1d59b3ac7"), collectDateParamsFromArguments = require("38d29b2b25f5ab1f");
var isNumber = classChecks.isNumber, isString = classChecks.isString;
function collectUpdateDateArguments(args, allowDuration) {
    var arg1 = args[0], arg2 = args[1], params, reset;
    if (allowDuration && isString(arg1)) {
        params = getDateParamsFromString(arg1);
        reset = arg2;
    } else if (isNumber(arg1) && isNumber(arg2)) params = collectDateParamsFromArguments(args);
    else {
        params = isObjectType(arg1) ? simpleClone(arg1) : arg1;
        reset = arg2;
    }
    return [
        params,
        reset
    ];
}
module.exports = collectUpdateDateArguments;

},{"e77e9632eb73a2de":"lUOLF","22e57e05fd71f390":"5Aio4","b9f434ec7a43a1bc":"l3TUh","fadc24f1d59b3ac7":"cpn0K","38d29b2b25f5ab1f":"2oP30"}],"cpn0K":[function(require,module,exports) {
"use strict";
var isUndefined = require("501b2f4f87acf144");
function getDateParamsFromString(str) {
    var match, num, params = {};
    match = str.match(/^(-?\d*[\d.]\d*)?\s?(\w+?)s?$/i);
    if (match) {
        if (isUndefined(num)) num = match[1] ? +match[1] : 1;
        params[match[2].toLowerCase()] = num;
    }
    return params;
}
module.exports = getDateParamsFromString;

},{"501b2f4f87acf144":"hnApm"}],"2oP30":[function(require,module,exports) {
"use strict";
var DateUnitIndexes = require("82ff4a8d1f114242"), isDefined = require("31b4be4579206a44"), walkUnitDown = require("1ab1bebe8d2b6868");
var YEAR_INDEX = DateUnitIndexes.YEAR_INDEX;
function collectDateParamsFromArguments(args) {
    var params = {}, index = 0;
    walkUnitDown(YEAR_INDEX, function(unit) {
        var arg = args[index++];
        if (isDefined(arg)) params[unit.name] = arg;
    });
    return params;
}
module.exports = collectDateParamsFromArguments;

},{"82ff4a8d1f114242":"gdeYg","31b4be4579206a44":"6Ge6e","1ab1bebe8d2b6868":"74NWI"}],"5knSP":[function(require,module,exports) {
"use strict";
var Sugar = require("5c6973ea7801741d");
require("c69f83b9355d85ea");
module.exports = Sugar.Date.beginningOfDay;

},{"5c6973ea7801741d":"eWYA2","c69f83b9355d85ea":"2DvlL"}],"i7OS2":[function(require,module,exports) {
"use strict";
var Sugar = require("a9a8e54eedf1b810"), resetTime = require("f2467c83cd17de8d"), getWeekday = require("b818248341d359d2"), setWeekday = require("57b130907add0afb");
Sugar.Date.defineInstance({
    "beginningOfISOWeek": function(date) {
        var day = getWeekday(date);
        if (day === 0) day = -6;
        else if (day !== 1) day = 1;
        setWeekday(date, day);
        return resetTime(date);
    }
});
module.exports = Sugar.Date.beginningOfISOWeek;

},{"a9a8e54eedf1b810":"eWYA2","f2467c83cd17de8d":"66P9z","b818248341d359d2":"gHTdp","57b130907add0afb":"2wPrY"}],"k9Pqj":[function(require,module,exports) {
"use strict";
var Sugar = require("a01dadeb0f099115");
require("7089109bb802a336");
module.exports = Sugar.Date.beginningOfMonth;

},{"a01dadeb0f099115":"eWYA2","7089109bb802a336":"2DvlL"}],"l4k2e":[function(require,module,exports) {
"use strict";
var Sugar = require("c8cca8ca8850191d");
require("4f282561ccfebfe8");
module.exports = Sugar.Date.beginningOfWeek;

},{"c8cca8ca8850191d":"eWYA2","4f282561ccfebfe8":"2DvlL"}],"cWdto":[function(require,module,exports) {
"use strict";
var Sugar = require("1279d65ae5a3144e");
require("fe0dc4f6558f3c5d");
module.exports = Sugar.Date.beginningOfYear;

},{"1279d65ae5a3144e":"eWYA2","fe0dc4f6558f3c5d":"2DvlL"}],"5eIqt":[function(require,module,exports) {
"use strict";
var Sugar = require("de97fbb4dff7e88"), cloneDate = require("73d471d5e516fd24");
Sugar.Date.defineInstance({
    "clone": function(date) {
        return cloneDate(date);
    }
});
module.exports = Sugar.Date.clone;

},{"de97fbb4dff7e88":"eWYA2","73d471d5e516fd24":"eedt3"}],"hF3GR":[function(require,module,exports) {
"use strict";
var Sugar = require("c6459fd655918c92");
require("c14828c476c2f4c2");
module.exports = Sugar.Date.daysAgo;

},{"c6459fd655918c92":"eWYA2","c14828c476c2f4c2":"2DvlL"}],"jmpeU":[function(require,module,exports) {
"use strict";
var Sugar = require("ad96f121dd5ff230");
require("335822e69379811d");
module.exports = Sugar.Date.daysFromNow;

},{"ad96f121dd5ff230":"eWYA2","335822e69379811d":"2DvlL"}],"gl9jK":[function(require,module,exports) {
"use strict";
var Sugar = require("7ee742866732a99"), getDaysInMonth = require("a30876e10023e8b8");
Sugar.Date.defineInstance({
    "daysInMonth": function(date) {
        return getDaysInMonth(date);
    }
});
module.exports = Sugar.Date.daysInMonth;

},{"7ee742866732a99":"eWYA2","a30876e10023e8b8":"1DVIV"}],"6enX6":[function(require,module,exports) {
"use strict";
var Sugar = require("a580f91da7086182");
require("de3596fa0c97d33d");
module.exports = Sugar.Date.daysSince;

},{"a580f91da7086182":"eWYA2","de3596fa0c97d33d":"2DvlL"}],"ilvNe":[function(require,module,exports) {
"use strict";
var Sugar = require("72c9c553f708ec4c");
require("bb467f0df53a0c68");
module.exports = Sugar.Date.daysUntil;

},{"72c9c553f708ec4c":"eWYA2","bb467f0df53a0c68":"2DvlL"}],"6h6XD":[function(require,module,exports) {
"use strict";
var Sugar = require("32fd6d174b1c3554");
require("ef69a7b00912bbe2");
module.exports = Sugar.Date.endOfDay;

},{"32fd6d174b1c3554":"eWYA2","ef69a7b00912bbe2":"2DvlL"}],"98YG6":[function(require,module,exports) {
"use strict";
var Sugar = require("6d23b0fe32a0f346"), DateUnitIndexes = require("693bccff7324a324"), getWeekday = require("9aff21e463496b26"), setWeekday = require("f8f9a9ded0715b62"), moveToEndOfUnit = require("effebc8785138206");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
Sugar.Date.defineInstance({
    "endOfISOWeek": function(date) {
        if (getWeekday(date) !== 0) setWeekday(date, 7);
        return moveToEndOfUnit(date, DAY_INDEX);
    }
});
module.exports = Sugar.Date.endOfISOWeek;

},{"6d23b0fe32a0f346":"eWYA2","693bccff7324a324":"gdeYg","9aff21e463496b26":"gHTdp","f8f9a9ded0715b62":"2wPrY","effebc8785138206":"5NVeO"}],"15hPr":[function(require,module,exports) {
"use strict";
var Sugar = require("1fcd4940eb2efbc9");
require("c3cf9a6aa45343d7");
module.exports = Sugar.Date.endOfMonth;

},{"1fcd4940eb2efbc9":"eWYA2","c3cf9a6aa45343d7":"2DvlL"}],"48zmW":[function(require,module,exports) {
"use strict";
var Sugar = require("3caffdc976b19a94");
require("fbe47a497c8cf7b5");
module.exports = Sugar.Date.endOfWeek;

},{"3caffdc976b19a94":"eWYA2","fbe47a497c8cf7b5":"2DvlL"}],"icalL":[function(require,module,exports) {
"use strict";
var Sugar = require("e86ebb2d6d14a0c1");
require("e26d24a33fe79a80");
module.exports = Sugar.Date.endOfYear;

},{"e86ebb2d6d14a0c1":"eWYA2","e26d24a33fe79a80":"2DvlL"}],"Gbn2k":[function(require,module,exports) {
"use strict";
var Sugar = require("531e21f5a14854e1"), dateFormat = require("4f9c6742a338a29");
Sugar.Date.defineInstance({
    "format": function(date, f, localeCode) {
        return dateFormat(date, f, localeCode);
    }
});
module.exports = Sugar.Date.format;

},{"531e21f5a14854e1":"eWYA2","4f9c6742a338a29":"963a2"}],"963a2":[function(require,module,exports) {
"use strict";
var CoreOutputFormats = require("339c0fc1101046f3"), formattingTokens = require("d68d538c0f90b191"), assertDateIsValid = require("2cda98cb44b4f57d");
var dateFormatMatcher = formattingTokens.dateFormatMatcher;
function dateFormat(d, format, localeCode) {
    assertDateIsValid(d);
    format = CoreOutputFormats[format] || format || "{long}";
    return dateFormatMatcher(format, d, localeCode);
}
module.exports = dateFormat;

},{"339c0fc1101046f3":"fAGRo","d68d538c0f90b191":"i5e4v","2cda98cb44b4f57d":"fk448"}],"fAGRo":[function(require,module,exports) {
"use strict";
var CoreOutputFormats = {
    "ISO8601": "{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{SSS}{Z}",
    "RFC1123": "{Dow}, {dd} {Mon} {yyyy} {HH}:{mm}:{ss} {ZZ}",
    "RFC1036": "{Weekday}, {dd}-{Mon}-{yy} {HH}:{mm}:{ss} {ZZ}"
};
module.exports = CoreOutputFormats;

},{}],"i5e4v":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("939ac7a3420ec847"), FormatTokensBase = require("2311cb92ec6c38e8"), CoreOutputFormats = require("4714d6ceed43c13a"), forEach = require("1f16087106719006"), padNumber = require("79fb2273e32b112d"), spaceSplit = require("42560ad223aaef0b"), namespaceAliases = require("88736942fe4ecf9e"), coreUtilityAliases = require("d048daf7493660a0"), createFormatMatcher = require("6daa3b42dbfe72e5"), defineInstanceSimilar = require("f9915a86fbb0104e");
var localeManager = LocaleHelpers.localeManager, hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn, forEachProperty = coreUtilityAliases.forEachProperty, sugarDate = namespaceAliases.sugarDate;
var ldmlTokens, strfTokens;
function buildDateFormatTokens() {
    function addFormats(target, tokens, fn) {
        if (tokens) forEach(spaceSplit(tokens), function(token) {
            target[token] = fn;
        });
    }
    function buildLowercase(get) {
        return function(d, localeCode) {
            return get(d, localeCode).toLowerCase();
        };
    }
    function buildOrdinal(get) {
        return function(d, localeCode) {
            var n = get(d, localeCode);
            return n + localeManager.get(localeCode).getOrdinal(n);
        };
    }
    function buildPadded(get, padding) {
        return function(d, localeCode) {
            return padNumber(get(d, localeCode), padding);
        };
    }
    function buildTwoDigits(get) {
        return function(d, localeCode) {
            return get(d, localeCode) % 100;
        };
    }
    function buildAlias(alias) {
        return function(d, localeCode) {
            return dateFormatMatcher(alias, d, localeCode);
        };
    }
    function buildAlternates(f) {
        for(var n = 1; n <= 5; n++)buildAlternate(f, n);
    }
    function buildAlternate(f, n) {
        var alternate = function alternate(d, localeCode) {
            return f.get(d, localeCode, n);
        };
        addFormats(ldmlTokens, f.ldml + n, alternate);
        if (f.lowerToken) ldmlTokens[f.lowerToken + n] = buildLowercase(alternate);
    }
    function getIdentityFormat(name) {
        return function(d, localeCode) {
            var loc = localeManager.get(localeCode);
            return dateFormatMatcher(loc[name], d, localeCode);
        };
    }
    ldmlTokens = {};
    strfTokens = {};
    forEach(FormatTokensBase, function(f) {
        var get = f.get, getPadded;
        if (f.lowerToken) ldmlTokens[f.lowerToken] = buildLowercase(get);
        if (f.ordinalToken) ldmlTokens[f.ordinalToken] = buildOrdinal(get, f);
        if (f.ldmlPaddedToken) ldmlTokens[f.ldmlPaddedToken] = buildPadded(get, f.ldmlPaddedToken.length);
        if (f.ldmlTwoDigitToken) ldmlTokens[f.ldmlTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
        if (f.strfTwoDigitToken) strfTokens[f.strfTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
        if (f.strfPadding) getPadded = buildPadded(get, f.strfPadding);
        if (f.alias) get = buildAlias(f.alias);
        if (f.allowAlternates) buildAlternates(f);
        addFormats(ldmlTokens, f.ldml, get);
        addFormats(strfTokens, f.strf, getPadded || get);
    });
    forEachProperty(CoreOutputFormats, function(src, name) {
        addFormats(ldmlTokens, name, buildAlias(src));
    });
    defineInstanceSimilar(sugarDate, "short medium long full", function(methods, name) {
        var fn = getIdentityFormat(name);
        addFormats(ldmlTokens, name, fn);
        methods[name] = fn;
    });
    addFormats(ldmlTokens, "time", getIdentityFormat("time"));
    addFormats(ldmlTokens, "stamp", getIdentityFormat("stamp"));
}
var dateFormatMatcher;
function buildDateFormatMatcher() {
    function getLdml(d, token, localeCode) {
        return getOwn(ldmlTokens, token)(d, localeCode);
    }
    function getStrf(d, token, localeCode) {
        return getOwn(strfTokens, token)(d, localeCode);
    }
    function checkDateToken(ldml, strf) {
        return hasOwn(ldmlTokens, ldml) || hasOwn(strfTokens, strf);
    }
    // Format matcher for LDML or STRF tokens.
    dateFormatMatcher = createFormatMatcher(getLdml, getStrf, checkDateToken);
}
buildDateFormatTokens();
buildDateFormatMatcher();
module.exports = {
    ldmlTokens: ldmlTokens,
    strfTokens: strfTokens,
    dateFormatMatcher: dateFormatMatcher
};

},{"939ac7a3420ec847":"14L7V","2311cb92ec6c38e8":"lGjwm","4714d6ceed43c13a":"fAGRo","1f16087106719006":"1n2CK","79fb2273e32b112d":"6THs5","42560ad223aaef0b":"8g1bL","88736942fe4ecf9e":"1TEpR","d048daf7493660a0":"dU8Nu","6daa3b42dbfe72e5":"lcx4s","f9915a86fbb0104e":"BfBjK"}],"lGjwm":[function(require,module,exports) {
"use strict";
var TIMEZONE_ABBREVIATION_REG = require("2c383e998cd0b7df"), LocaleHelpers = require("d6649b2e84a5f65e"), DateUnitIndexes = require("421c99b466ef8c77"), trunc = require("113e760a6fb83051"), getDate = require("746bde9b38ebb152"), getYear = require("f6da0ba99cde8455"), getHours = require("4c9439246512e6dc"), getMonth = require("70ae358e2242d0c4"), cloneDate = require("3cf5a71e0b486dca"), padNumber = require("6d326b47ffbe614b"), getWeekday = require("9c0822f6f87de965"), callDateGet = require("e689355c33caf3ec"), mathAliases = require("79866fa9515f4230"), getWeekYear = require("5c184e31faf466a0"), getUTCOffset = require("456d70424a4cbd64"), getDaysSince = require("6decf8b225fdc914"), getWeekNumber = require("4b9afd8579fd4b1d"), getMeridiemToken = require("929897cb48606a30"), setUnitAndLowerToEdge = require("f02a9156156ef5a7");
var localeManager = LocaleHelpers.localeManager, MONTH_INDEX = DateUnitIndexes.MONTH_INDEX, ceil = mathAliases.ceil;
var FormatTokensBase = [
    {
        ldml: "Dow",
        strf: "a",
        lowerToken: "dow",
        get: function get(d, localeCode) {
            return localeManager.get(localeCode).getWeekdayName(getWeekday(d), 2);
        }
    },
    {
        ldml: "Weekday",
        strf: "A",
        lowerToken: "weekday",
        allowAlternates: true,
        get: function get(d, localeCode, alternate) {
            return localeManager.get(localeCode).getWeekdayName(getWeekday(d), alternate);
        }
    },
    {
        ldml: "Mon",
        strf: "b h",
        lowerToken: "mon",
        get: function get(d, localeCode) {
            return localeManager.get(localeCode).getMonthName(getMonth(d), 2);
        }
    },
    {
        ldml: "Month",
        strf: "B",
        lowerToken: "month",
        allowAlternates: true,
        get: function get(d, localeCode, alternate) {
            return localeManager.get(localeCode).getMonthName(getMonth(d), alternate);
        }
    },
    {
        strf: "C",
        get: function get(d) {
            return getYear(d).toString().slice(0, 2);
        }
    },
    {
        ldml: "d date day",
        strf: "d",
        strfPadding: 2,
        ldmlPaddedToken: "dd",
        ordinalToken: "do",
        get: function get(d) {
            return getDate(d);
        }
    },
    {
        strf: "e",
        get: function get(d) {
            return padNumber(getDate(d), 2, false, 10, " ");
        }
    },
    {
        ldml: "H 24hr",
        strf: "H",
        strfPadding: 2,
        ldmlPaddedToken: "HH",
        get: function get(d) {
            return getHours(d);
        }
    },
    {
        ldml: "h hours 12hr",
        strf: "I",
        strfPadding: 2,
        ldmlPaddedToken: "hh",
        get: function get(d) {
            return getHours(d) % 12 || 12;
        }
    },
    {
        ldml: "D",
        strf: "j",
        strfPadding: 3,
        ldmlPaddedToken: "DDD",
        get: function get(d) {
            var s = setUnitAndLowerToEdge(cloneDate(d), MONTH_INDEX);
            return getDaysSince(d, s) + 1;
        }
    },
    {
        ldml: "M",
        strf: "m",
        strfPadding: 2,
        ordinalToken: "Mo",
        ldmlPaddedToken: "MM",
        get: function get(d) {
            return getMonth(d) + 1;
        }
    },
    {
        ldml: "m minutes",
        strf: "M",
        strfPadding: 2,
        ldmlPaddedToken: "mm",
        get: function get(d) {
            return callDateGet(d, "Minutes");
        }
    },
    {
        ldml: "Q",
        get: function get(d) {
            return ceil((getMonth(d) + 1) / 3);
        }
    },
    {
        ldml: "TT",
        strf: "p",
        get: function get(d, localeCode) {
            return getMeridiemToken(d, localeCode);
        }
    },
    {
        ldml: "tt",
        strf: "P",
        get: function get(d, localeCode) {
            return getMeridiemToken(d, localeCode).toLowerCase();
        }
    },
    {
        ldml: "T",
        lowerToken: "t",
        get: function get(d, localeCode) {
            return getMeridiemToken(d, localeCode).charAt(0);
        }
    },
    {
        ldml: "s seconds",
        strf: "S",
        strfPadding: 2,
        ldmlPaddedToken: "ss",
        get: function get(d) {
            return callDateGet(d, "Seconds");
        }
    },
    {
        ldml: "S ms",
        strfPadding: 3,
        ldmlPaddedToken: "SSS",
        get: function get(d) {
            return callDateGet(d, "Milliseconds");
        }
    },
    {
        ldml: "e",
        strf: "u",
        ordinalToken: "eo",
        get: function get(d) {
            return getWeekday(d) || 7;
        }
    },
    {
        strf: "U",
        strfPadding: 2,
        get: function get(d) {
            // Sunday first, 0-53
            return getWeekNumber(d, false, 0);
        }
    },
    {
        ldml: "W",
        strf: "V",
        strfPadding: 2,
        ordinalToken: "Wo",
        ldmlPaddedToken: "WW",
        get: function get(d) {
            // Monday first, 1-53 (ISO8601)
            return getWeekNumber(d, true);
        }
    },
    {
        strf: "w",
        get: function get(d) {
            return getWeekday(d);
        }
    },
    {
        ldml: "w",
        ordinalToken: "wo",
        ldmlPaddedToken: "ww",
        get: function get(d, localeCode) {
            // Locale dependent, 1-53
            var loc = localeManager.get(localeCode), dow = loc.getFirstDayOfWeek(localeCode), doy = loc.getFirstDayOfWeekYear(localeCode);
            return getWeekNumber(d, true, dow, doy);
        }
    },
    {
        strf: "W",
        strfPadding: 2,
        get: function get(d) {
            // Monday first, 0-53
            return getWeekNumber(d, false);
        }
    },
    {
        ldmlPaddedToken: "gggg",
        ldmlTwoDigitToken: "gg",
        get: function get(d, localeCode) {
            return getWeekYear(d, localeCode);
        }
    },
    {
        strf: "G",
        strfPadding: 4,
        strfTwoDigitToken: "g",
        ldmlPaddedToken: "GGGG",
        ldmlTwoDigitToken: "GG",
        get: function get(d, localeCode) {
            return getWeekYear(d, localeCode, true);
        }
    },
    {
        ldml: "year",
        ldmlPaddedToken: "yyyy",
        ldmlTwoDigitToken: "yy",
        strf: "Y",
        strfPadding: 4,
        strfTwoDigitToken: "y",
        get: function get(d) {
            return getYear(d);
        }
    },
    {
        ldml: "ZZ",
        strf: "z",
        get: function get(d) {
            return getUTCOffset(d);
        }
    },
    {
        ldml: "X",
        get: function get(d) {
            return trunc(d.getTime() / 1000);
        }
    },
    {
        ldml: "x",
        get: function get(d) {
            return d.getTime();
        }
    },
    {
        ldml: "Z",
        get: function get(d) {
            return getUTCOffset(d, true);
        }
    },
    {
        ldml: "z",
        strf: "Z",
        get: function get(d) {
            // Note that this is not accurate in all browsing environments!
            // https://github.com/moment/moment/issues/162
            // It will continue to be supported for Node and usage with the
            // understanding that it may be blank.
            var match = d.toString().match(TIMEZONE_ABBREVIATION_REG);
            // istanbul ignore next
            return match ? match[1] : "";
        }
    },
    {
        strf: "D",
        alias: "%m/%d/%y"
    },
    {
        strf: "F",
        alias: "%Y-%m-%d"
    },
    {
        strf: "r",
        alias: "%I:%M:%S %p"
    },
    {
        strf: "R",
        alias: "%H:%M"
    },
    {
        strf: "T",
        alias: "%H:%M:%S"
    },
    {
        strf: "x",
        alias: "{short}"
    },
    {
        strf: "X",
        alias: "{time}"
    },
    {
        strf: "c",
        alias: "{stamp}"
    }
];
module.exports = FormatTokensBase;

},{"2c383e998cd0b7df":"1o4UX","d6649b2e84a5f65e":"14L7V","421c99b466ef8c77":"gdeYg","113e760a6fb83051":"ePaYC","746bde9b38ebb152":"2e49M","f6da0ba99cde8455":"8JXHQ","4c9439246512e6dc":"1sKnS","70ae358e2242d0c4":"90gXu","3cf5a71e0b486dca":"eedt3","6d326b47ffbe614b":"6THs5","9c0822f6f87de965":"gHTdp","e689355c33caf3ec":"kBI9T","79866fa9515f4230":"89tTN","5c184e31faf466a0":"8iavJ","456d70424a4cbd64":"j5j7I","6decf8b225fdc914":"e9Dxa","4b9afd8579fd4b1d":"gnVLd","929897cb48606a30":"4z7D8","f02a9156156ef5a7":"5Zx4m"}],"1o4UX":[function(require,module,exports) {
"use strict";
module.exports = /\(([-+]\d{2,4}|\w{3,5})\)$/;

},{}],"1sKnS":[function(require,module,exports) {
"use strict";
var callDateGet = require("3fb339f62bac77a7");
function getHours(d) {
    return callDateGet(d, "Hours");
}
module.exports = getHours;

},{"3fb339f62bac77a7":"kBI9T"}],"8iavJ":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("4e482cfcda0da28f"), getYear = require("adccdbc8eb50f8cd"), getMonth = require("f540546f5568a41d"), getWeekNumber = require("24e6d939c91decd6");
var localeManager = LocaleHelpers.localeManager;
function getWeekYear(d, localeCode, iso) {
    var year, month, firstDayOfWeek, firstDayOfWeekYear, week, loc;
    year = getYear(d);
    month = getMonth(d);
    if (month === 0 || month === 11) {
        if (!iso) {
            loc = localeManager.get(localeCode);
            firstDayOfWeek = loc.getFirstDayOfWeek(localeCode);
            firstDayOfWeekYear = loc.getFirstDayOfWeekYear(localeCode);
        }
        week = getWeekNumber(d, false, firstDayOfWeek, firstDayOfWeekYear);
        if (month === 0 && week === 0) year -= 1;
        else if (month === 11 && week === 1) year += 1;
    }
    return year;
}
module.exports = getWeekYear;

},{"4e482cfcda0da28f":"14L7V","adccdbc8eb50f8cd":"8JXHQ","f540546f5568a41d":"90gXu","24e6d939c91decd6":"gnVLd"}],"gnVLd":[function(require,module,exports) {
"use strict";
var ISODefaults = require("c72eb123cf2d49b3"), setDate = require("2f6a1b18a8d2b0f4"), getDate = require("63cc504bc3692286"), cloneDate = require("9387811d5249c538"), isUndefined = require("84e2d12a8c9bc5f0"), moveToEndOfWeek = require("5d83604d1e5b9af"), moveToBeginningOfWeek = require("2ea26251cc35423c"), moveToFirstDayOfWeekYear = require("bbdd24be261dd36e");
var ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK, ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR;
function getWeekNumber(d, allowPrevious, firstDayOfWeek, firstDayOfWeekYear) {
    var isoWeek, n = 0;
    if (isUndefined(firstDayOfWeek)) firstDayOfWeek = ISO_FIRST_DAY_OF_WEEK;
    if (isUndefined(firstDayOfWeekYear)) firstDayOfWeekYear = ISO_FIRST_DAY_OF_WEEK_YEAR;
    // Moving to the end of the week allows for forward year traversal, ie
    // Dec 29 2014 is actually week 01 of 2015.
    isoWeek = moveToEndOfWeek(cloneDate(d), firstDayOfWeek);
    moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
    if (allowPrevious && d < isoWeek) {
        // If the date is still before the start of the year, then it should be
        // the last week of the previous year, ie Jan 1 2016 is actually week 53
        // of 2015, so move to the beginning of the week to traverse the year.
        isoWeek = moveToBeginningOfWeek(cloneDate(d), firstDayOfWeek);
        moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
    }
    while(isoWeek <= d){
        // Doing a very simple walk to get the week number.
        setDate(isoWeek, getDate(isoWeek) + 7);
        n++;
    }
    return n;
}
module.exports = getWeekNumber;

},{"c72eb123cf2d49b3":"8rA66","2f6a1b18a8d2b0f4":"cOXbt","63cc504bc3692286":"2e49M","9387811d5249c538":"eedt3","84e2d12a8c9bc5f0":"hnApm","5d83604d1e5b9af":"ae8ut","2ea26251cc35423c":"9q27J","bbdd24be261dd36e":"ht9xE"}],"j5j7I":[function(require,module,exports) {
"use strict";
var _utc = require("e2c6db18f54bf94c"), trunc = require("77af0d609c5e3810"), tzOffset = require("d6e06bff6fcd908a"), padNumber = require("ffc8e55e1c879828"), mathAliases = require("2918b09c0528d49e");
var abs = mathAliases.abs;
function getUTCOffset(d, iso) {
    var offset = _utc(d) ? 0 : tzOffset(d), hours, mins, colon;
    colon = iso === true ? ":" : "";
    if (!offset && iso) return "Z";
    hours = padNumber(trunc(-offset / 60), 2, true);
    mins = padNumber(abs(offset % 60), 2);
    return hours + colon + mins;
}
module.exports = getUTCOffset;

},{"e2c6db18f54bf94c":"c68pM","77af0d609c5e3810":"ePaYC","d6e06bff6fcd908a":"hZpDB","ffc8e55e1c879828":"6THs5","2918b09c0528d49e":"89tTN"}],"e9Dxa":[function(require,module,exports) {
"use strict";
var DateUnits = require("bd1c1eb44f49738c"), DateUnitIndexes = require("ca27b1bb3fc0a15f"), getTimeDistanceForUnit = require("239e63b01e9ffa4e");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
function getDaysSince(d1, d2) {
    return getTimeDistanceForUnit(d1, d2, DateUnits[DAY_INDEX]);
}
module.exports = getDaysSince;

},{"bd1c1eb44f49738c":"5sdJf","ca27b1bb3fc0a15f":"gdeYg","239e63b01e9ffa4e":"eGw7X"}],"4z7D8":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("2a126ddce6952c6d"), trunc = require("e910fd04a980266c"), getHours = require("d19c07a81412db77");
var localeManager = LocaleHelpers.localeManager;
function getMeridiemToken(d, localeCode) {
    var hours = getHours(d);
    return localeManager.get(localeCode).ampm[trunc(hours / 12)] || "";
}
module.exports = getMeridiemToken;

},{"2a126ddce6952c6d":"14L7V","e910fd04a980266c":"ePaYC","d19c07a81412db77":"1sKnS"}],"fk448":[function(require,module,exports) {
"use strict";
var dateIsValid = require("30803fa3af5514c2");
function assertDateIsValid(d) {
    if (!dateIsValid(d)) throw new TypeError("Date is not valid");
}
module.exports = assertDateIsValid;

},{"30803fa3af5514c2":"g2Fy2"}],"1e2un":[function(require,module,exports) {
"use strict";
var Sugar = require("8e8a2a9c3ebd4a1e"), createDateWithContext = require("e7ec65698a11aac0");
Sugar.Date.defineInstance({
    "get": function(date, d, options) {
        return createDateWithContext(date, d, options);
    }
});
module.exports = Sugar.Date.get;

},{"8e8a2a9c3ebd4a1e":"eWYA2","e7ec65698a11aac0":"k12fj"}],"k12fj":[function(require,module,exports) {
"use strict";
var getExtendedDate = require("590f992e697be20f");
function createDateWithContext(contextDate, d, options, forceClone) {
    return getExtendedDate(contextDate, d, options, forceClone).date;
}
module.exports = createDateWithContext;

},{"590f992e697be20f":"5yq5j"}],"1h0gS":[function(require,module,exports) {
"use strict";
var Sugar = require("73457cf75f48a0b5"), getWeekNumber = require("e7eb1f359044aeb4");
Sugar.Date.defineInstance({
    "getISOWeek": function(date) {
        return getWeekNumber(date, true);
    }
});
module.exports = Sugar.Date.getISOWeek;

},{"73457cf75f48a0b5":"eWYA2","e7eb1f359044aeb4":"gnVLd"}],"cLbQ5":[function(require,module,exports) {
"use strict";
var Sugar = require("ba8725557267116d"), getUTCOffset = require("633010fd96e8cb73");
Sugar.Date.defineInstance({
    "getUTCOffset": function(date, iso) {
        return getUTCOffset(date, iso);
    }
});
module.exports = Sugar.Date.getUTCOffset;

},{"ba8725557267116d":"eWYA2","633010fd96e8cb73":"j5j7I"}],"5Keb2":[function(require,module,exports) {
"use strict";
var Sugar = require("bef2e8c64855c435");
Sugar.Date.defineInstance({
    "getUTCWeekday": function(date) {
        return date.getUTCDay();
    }
});
module.exports = Sugar.Date.getUTCWeekday;

},{"bef2e8c64855c435":"eWYA2"}],"hwQuO":[function(require,module,exports) {
"use strict";
var Sugar = require("a451f7a3c95ba6cf"), getWeekday = require("993b26d30df274e5");
Sugar.Date.defineInstance({
    "getWeekday": function(date) {
        return getWeekday(date);
    }
});
module.exports = Sugar.Date.getWeekday;

},{"a451f7a3c95ba6cf":"eWYA2","993b26d30df274e5":"gHTdp"}],"hmj5z":[function(require,module,exports) {
"use strict";
var Sugar = require("c1c2c4f54e219b21");
require("77634a4f85e3d455");
module.exports = Sugar.Date.hoursAgo;

},{"c1c2c4f54e219b21":"eWYA2","77634a4f85e3d455":"2DvlL"}],"ljW93":[function(require,module,exports) {
"use strict";
var Sugar = require("85ff24e7458a0809");
require("66e625a3aebfbc6f");
module.exports = Sugar.Date.hoursFromNow;

},{"85ff24e7458a0809":"eWYA2","66e625a3aebfbc6f":"2DvlL"}],"co7DM":[function(require,module,exports) {
"use strict";
var Sugar = require("aa2bebf5e1d69b03");
require("4ba1162b317b2827");
module.exports = Sugar.Date.hoursSince;

},{"aa2bebf5e1d69b03":"eWYA2","4ba1162b317b2827":"2DvlL"}],"NHyLm":[function(require,module,exports) {
"use strict";
var Sugar = require("95470fc9a1d416c1");
require("650fcb8e39e5f847");
module.exports = Sugar.Date.hoursUntil;

},{"95470fc9a1d416c1":"eWYA2","650fcb8e39e5f847":"2DvlL"}],"eHr6J":[function(require,module,exports) {
"use strict";
var Sugar = require("7f8197edd1b55478"), fullCompareDate = require("f455ddd6b3e2b663");
Sugar.Date.defineInstance({
    "is": function(date, d, margin) {
        return fullCompareDate(date, d, margin);
    }
});
module.exports = Sugar.Date.is;

},{"7f8197edd1b55478":"eWYA2","f455ddd6b3e2b663":"8iHjN"}],"8iHjN":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("9a918ec619114f28"), trim = require("318bf82868050285"), getMonth = require("fd6b3bb630525e2"), isDefined = require("55f844757d5ba760"), getNewDate = require("20f3a4adf75be50b"), compareDay = require("20e30fec757554ea"), getWeekday = require("3e1eeb1ae651d547"), dateIsValid = require("1c77777b65da4c6c"), classChecks = require("e2da439e7ea0c7fb"), compareDate = require("4887a99baa7e2f83");
var isString = classChecks.isString, English = LocaleHelpers.English;
function fullCompareDate(date, d, margin) {
    var tmp;
    if (!dateIsValid(date)) return;
    if (isString(d)) {
        d = trim(d).toLowerCase();
        switch(true){
            case d === "future":
                return date.getTime() > getNewDate().getTime();
            case d === "past":
                return date.getTime() < getNewDate().getTime();
            case d === "today":
                return compareDay(date);
            case d === "tomorrow":
                return compareDay(date, 1);
            case d === "yesterday":
                return compareDay(date, -1);
            case d === "weekday":
                return getWeekday(date) > 0 && getWeekday(date) < 6;
            case d === "weekend":
                return getWeekday(date) === 0 || getWeekday(date) === 6;
            case isDefined(tmp = English.weekdayMap[d]):
                return getWeekday(date) === tmp;
            case isDefined(tmp = English.monthMap[d]):
                return getMonth(date) === tmp;
        }
    }
    return compareDate(date, d, margin);
}
module.exports = fullCompareDate;

},{"9a918ec619114f28":"14L7V","318bf82868050285":"7k3lh","fd6b3bb630525e2":"90gXu","55f844757d5ba760":"6Ge6e","20f3a4adf75be50b":"fTtJa","20e30fec757554ea":"2oDWn","3e1eeb1ae651d547":"gHTdp","1c77777b65da4c6c":"g2Fy2","e2da439e7ea0c7fb":"lUOLF","4887a99baa7e2f83":"kLi9A"}],"2oDWn":[function(require,module,exports) {
"use strict";
var setDate = require("1c1f5a8f27e11bd4"), getDate = require("c51f349974412dc9"), getYear = require("506a6bf29d3d458e"), getMonth = require("9b152be3e6a9d2eb"), getNewDate = require("5958ba451fddbbad");
function compareDay(d, shift) {
    var comp = getNewDate();
    if (shift) setDate(comp, getDate(comp) + shift);
    return getYear(d) === getYear(comp) && getMonth(d) === getMonth(comp) && getDate(d) === getDate(comp);
}
module.exports = compareDay;

},{"1c1f5a8f27e11bd4":"cOXbt","c51f349974412dc9":"2e49M","506a6bf29d3d458e":"8JXHQ","9b152be3e6a9d2eb":"90gXu","5958ba451fddbbad":"fTtJa"}],"dix6e":[function(require,module,exports) {
"use strict";
var Sugar = require("c6f11b2c3b8f7b8e"), createDate = require("d85cbc1c4c51bc33");
Sugar.Date.defineInstance({
    "isAfter": function(date, d, margin) {
        return date.getTime() > createDate(d).getTime() - (margin || 0);
    }
});
module.exports = Sugar.Date.isAfter;

},{"c6f11b2c3b8f7b8e":"eWYA2","d85cbc1c4c51bc33":"h5ei3"}],"dyKzC":[function(require,module,exports) {
"use strict";
var Sugar = require("a1a1c7bb255fab12"), createDate = require("a4acb2cb741ad38e");
Sugar.Date.defineInstance({
    "isBefore": function(date, d, margin) {
        return date.getTime() < createDate(d).getTime() + (margin || 0);
    }
});
module.exports = Sugar.Date.isBefore;

},{"a1a1c7bb255fab12":"eWYA2","a4acb2cb741ad38e":"h5ei3"}],"8sPO7":[function(require,module,exports) {
"use strict";
var Sugar = require("2cb0c7220d388c63"), createDate = require("f5af8a14a45114be"), mathAliases = require("95f89df4a2caf397");
var min = mathAliases.min, max = mathAliases.max;
Sugar.Date.defineInstance({
    "isBetween": function(date, d1, d2, margin) {
        var t = date.getTime();
        var t1 = createDate(d1).getTime();
        var t2 = createDate(d2).getTime();
        var lo = min(t1, t2);
        var hi = max(t1, t2);
        margin = margin || 0;
        return lo - margin <= t && hi + margin >= t;
    }
});
module.exports = Sugar.Date.isBetween;

},{"2cb0c7220d388c63":"eWYA2","f5af8a14a45114be":"h5ei3","95f89df4a2caf397":"89tTN"}],"1P7cb":[function(require,module,exports) {
"use strict";
var Sugar = require("aafaf7b2125e6f3f");
require("356ca609c0db56cc");
module.exports = Sugar.Date.isFriday;

},{"aafaf7b2125e6f3f":"eWYA2","356ca609c0db56cc":"4kMAF"}],"4kMAF":[function(require,module,exports) {
"use strict";
var buildRelativeAliases = require("eec04d5a012d99ea");
buildRelativeAliases();

},{"eec04d5a012d99ea":"eniGT"}],"eniGT":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("3f44a4004d07c73a"), spaceSplit = require("8d5f9515910e848b"), fullCompareDate = require("a5b22aa5d10ea848"), namespaceAliases = require("1ce5de1a474d76d6"), defineInstanceSimilar = require("70286f4ede1e71be");
var English = LocaleHelpers.English, sugarDate = namespaceAliases.sugarDate;
function buildRelativeAliases() {
    var special = spaceSplit("Today Yesterday Tomorrow Weekday Weekend Future Past");
    var weekdays = English.weekdays.slice(0, 7);
    var months = English.months.slice(0, 12);
    var together = special.concat(weekdays).concat(months);
    defineInstanceSimilar(sugarDate, together, function(methods, name) {
        methods["is" + name] = function(d) {
            return fullCompareDate(d, name);
        };
    });
}
module.exports = buildRelativeAliases;

},{"3f44a4004d07c73a":"14L7V","8d5f9515910e848b":"8g1bL","a5b22aa5d10ea848":"8iHjN","1ce5de1a474d76d6":"1TEpR","70286f4ede1e71be":"BfBjK"}],"17v6S":[function(require,module,exports) {
"use strict";
var Sugar = require("29e3c19dc93847fb");
require("a754452a738fd608");
module.exports = Sugar.Date.isFuture;

},{"29e3c19dc93847fb":"eWYA2","a754452a738fd608":"4kMAF"}],"6SnZ3":[function(require,module,exports) {
"use strict";
var Sugar = require("2c5a71a384d1125f");
require("7d9d80f68597d35c");
module.exports = Sugar.Date.isLastMonth;

},{"2c5a71a384d1125f":"eWYA2","7d9d80f68597d35c":"2DvlL"}],"bt2cM":[function(require,module,exports) {
"use strict";
var Sugar = require("6aac1c454808f9b5");
require("4b62e085a79eb722");
module.exports = Sugar.Date.isLastWeek;

},{"6aac1c454808f9b5":"eWYA2","4b62e085a79eb722":"2DvlL"}],"6xM2k":[function(require,module,exports) {
"use strict";
var Sugar = require("1aeee567e62abbe0");
require("ef2e2fb9392ad872");
module.exports = Sugar.Date.isLastYear;

},{"1aeee567e62abbe0":"eWYA2","ef2e2fb9392ad872":"2DvlL"}],"1FuhS":[function(require,module,exports) {
"use strict";
var Sugar = require("444f87f6c7798dbe"), getYear = require("f97d4617fa3aa788");
Sugar.Date.defineInstance({
    "isLeapYear": function(date) {
        var year = getYear(date);
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
});
module.exports = Sugar.Date.isLeapYear;

},{"444f87f6c7798dbe":"eWYA2","f97d4617fa3aa788":"8JXHQ"}],"1Hjkj":[function(require,module,exports) {
"use strict";
var Sugar = require("e1c936b24b3d58ee");
require("ebafadf2d3b0b98d");
module.exports = Sugar.Date.isMonday;

},{"e1c936b24b3d58ee":"eWYA2","ebafadf2d3b0b98d":"4kMAF"}],"8FQmC":[function(require,module,exports) {
"use strict";
var Sugar = require("abbe817ac5ffc994");
require("452f62edcc27e0f6");
module.exports = Sugar.Date.isNextMonth;

},{"abbe817ac5ffc994":"eWYA2","452f62edcc27e0f6":"2DvlL"}],"7VbsW":[function(require,module,exports) {
"use strict";
var Sugar = require("a686deb00758307c");
require("3f41fc463c9df6be");
module.exports = Sugar.Date.isNextWeek;

},{"a686deb00758307c":"eWYA2","3f41fc463c9df6be":"2DvlL"}],"dsWQX":[function(require,module,exports) {
"use strict";
var Sugar = require("324632bfc86c8fa6");
require("15c7cb054c1080b8");
module.exports = Sugar.Date.isNextYear;

},{"324632bfc86c8fa6":"eWYA2","15c7cb054c1080b8":"2DvlL"}],"1j4r3":[function(require,module,exports) {
"use strict";
var Sugar = require("26b8ae5533e89bc4");
require("f1344936bb4031e9");
module.exports = Sugar.Date.isPast;

},{"26b8ae5533e89bc4":"eWYA2","f1344936bb4031e9":"4kMAF"}],"dAgYB":[function(require,module,exports) {
"use strict";
var Sugar = require("61f4644afc16c99e");
require("d2234f2f4dbb15b0");
module.exports = Sugar.Date.isSaturday;

},{"61f4644afc16c99e":"eWYA2","d2234f2f4dbb15b0":"4kMAF"}],"zpSv4":[function(require,module,exports) {
"use strict";
var Sugar = require("89567854af0fbf4");
require("fd3e98f762934461");
module.exports = Sugar.Date.isSunday;

},{"89567854af0fbf4":"eWYA2","fd3e98f762934461":"4kMAF"}],"iwJgj":[function(require,module,exports) {
"use strict";
var Sugar = require("e408e17d35e07370");
require("90c6af83ec70a025");
module.exports = Sugar.Date.isThisMonth;

},{"e408e17d35e07370":"eWYA2","90c6af83ec70a025":"2DvlL"}],"d2UBw":[function(require,module,exports) {
"use strict";
var Sugar = require("8b7ac87d7ef59329");
require("f80c86b9275d96e0");
module.exports = Sugar.Date.isThisWeek;

},{"8b7ac87d7ef59329":"eWYA2","f80c86b9275d96e0":"2DvlL"}],"jcjDh":[function(require,module,exports) {
"use strict";
var Sugar = require("aec3fa338c1ff6b0");
require("c9240965633b15f6");
module.exports = Sugar.Date.isThisYear;

},{"aec3fa338c1ff6b0":"eWYA2","c9240965633b15f6":"2DvlL"}],"kPhB1":[function(require,module,exports) {
"use strict";
var Sugar = require("373a6ca74935d9c5");
require("55ea3c446af7cf32");
module.exports = Sugar.Date.isThursday;

},{"373a6ca74935d9c5":"eWYA2","55ea3c446af7cf32":"4kMAF"}],"dWemj":[function(require,module,exports) {
"use strict";
var Sugar = require("71390b9c6535b024");
require("b6ccd5d9492bdb1");
module.exports = Sugar.Date.isToday;

},{"71390b9c6535b024":"eWYA2","b6ccd5d9492bdb1":"4kMAF"}],"k7XZu":[function(require,module,exports) {
"use strict";
var Sugar = require("fbbd2cd6c5f25eab");
require("6ec5516c545f3bab");
module.exports = Sugar.Date.isTomorrow;

},{"fbbd2cd6c5f25eab":"eWYA2","6ec5516c545f3bab":"4kMAF"}],"dp6RU":[function(require,module,exports) {
"use strict";
var Sugar = require("5dbf69032c94c1ff");
require("2a0fa5ef84b6e8b0");
module.exports = Sugar.Date.isTuesday;

},{"5dbf69032c94c1ff":"eWYA2","2a0fa5ef84b6e8b0":"4kMAF"}],"lpbwI":[function(require,module,exports) {
"use strict";
var Sugar = require("95c518b524622f94"), isUTC = require("bf7b6b36244cb23f");
Sugar.Date.defineInstance({
    "isUTC": function(date) {
        return isUTC(date);
    }
});
module.exports = Sugar.Date.isUTC;

},{"95c518b524622f94":"eWYA2","bf7b6b36244cb23f":"71B8W"}],"71B8W":[function(require,module,exports) {
"use strict";
var _utc = require("d1550da7c2ff6ddb"), tzOffset = require("daa8588937cacf13");
function isUTC(d) {
    return !!_utc(d) || tzOffset(d) === 0;
}
module.exports = isUTC;

},{"d1550da7c2ff6ddb":"c68pM","daa8588937cacf13":"hZpDB"}],"1XNSk":[function(require,module,exports) {
"use strict";
var Sugar = require("fb6e844e4969c42b"), dateIsValid = require("214928cefa3ad23a");
Sugar.Date.defineInstance({
    "isValid": function(date) {
        return dateIsValid(date);
    }
});
module.exports = Sugar.Date.isValid;

},{"fb6e844e4969c42b":"eWYA2","214928cefa3ad23a":"g2Fy2"}],"j9zXp":[function(require,module,exports) {
"use strict";
var Sugar = require("6d4d3a00abe541b5");
require("85775563a16cdd3d");
module.exports = Sugar.Date.isWednesday;

},{"6d4d3a00abe541b5":"eWYA2","85775563a16cdd3d":"4kMAF"}],"lxt8R":[function(require,module,exports) {
"use strict";
var Sugar = require("99a32516d2b52599");
require("69f7789aaad59d15");
module.exports = Sugar.Date.isWeekday;

},{"99a32516d2b52599":"eWYA2","69f7789aaad59d15":"4kMAF"}],"iHlWa":[function(require,module,exports) {
"use strict";
var Sugar = require("509a1feea689d0d");
require("e1ff9037efb335f9");
module.exports = Sugar.Date.isWeekend;

},{"509a1feea689d0d":"eWYA2","e1ff9037efb335f9":"4kMAF"}],"lNbcj":[function(require,module,exports) {
"use strict";
var Sugar = require("ffcaf477257ba979");
require("3924841b491c6f3d");
module.exports = Sugar.Date.isYesterday;

},{"ffcaf477257ba979":"eWYA2","3924841b491c6f3d":"4kMAF"}],"cLAKJ":[function(require,module,exports) {
"use strict";
var Sugar = require("2a2e959777466ff0");
Sugar.Date.defineInstance({
    "iso": function(date) {
        return date.toISOString();
    }
});
module.exports = Sugar.Date.iso;

},{"2a2e959777466ff0":"eWYA2"}],"bQGx5":[function(require,module,exports) {
"use strict";
var Sugar = require("b436e86d2555b20d");
require("c2789f9c2fc47cac");
module.exports = Sugar.Date.millisecondsAgo;

},{"b436e86d2555b20d":"eWYA2","c2789f9c2fc47cac":"2DvlL"}],"3CG9R":[function(require,module,exports) {
"use strict";
var Sugar = require("7bebdd0985c97c08");
require("248e903420614437");
module.exports = Sugar.Date.millisecondsFromNow;

},{"7bebdd0985c97c08":"eWYA2","248e903420614437":"2DvlL"}],"63QEC":[function(require,module,exports) {
"use strict";
var Sugar = require("1ea9a06bc088bc9c");
require("1a55dfadd5860e44");
module.exports = Sugar.Date.millisecondsSince;

},{"1ea9a06bc088bc9c":"eWYA2","1a55dfadd5860e44":"2DvlL"}],"bwLxu":[function(require,module,exports) {
"use strict";
var Sugar = require("1ea6a8fd4ee936c8");
require("d8a9daa8c35113a0");
module.exports = Sugar.Date.millisecondsUntil;

},{"1ea6a8fd4ee936c8":"eWYA2","d8a9daa8c35113a0":"2DvlL"}],"6mAkE":[function(require,module,exports) {
"use strict";
var Sugar = require("3a8f6cd19d006627");
require("3137ae242adf11a6");
module.exports = Sugar.Date.minutesAgo;

},{"3a8f6cd19d006627":"eWYA2","3137ae242adf11a6":"2DvlL"}],"j32Ft":[function(require,module,exports) {
"use strict";
var Sugar = require("984cd4d6fc8bd3d3");
require("34e0fdf309a60b46");
module.exports = Sugar.Date.minutesFromNow;

},{"984cd4d6fc8bd3d3":"eWYA2","34e0fdf309a60b46":"2DvlL"}],"81qhX":[function(require,module,exports) {
"use strict";
var Sugar = require("9526f96588b37d2b");
require("d9f0a753cc6beffd");
module.exports = Sugar.Date.minutesSince;

},{"9526f96588b37d2b":"eWYA2","d9f0a753cc6beffd":"2DvlL"}],"hQmZS":[function(require,module,exports) {
"use strict";
var Sugar = require("37419185e3fc1501");
require("3cdd686bbdfb959c");
module.exports = Sugar.Date.minutesUntil;

},{"37419185e3fc1501":"eWYA2","3cdd686bbdfb959c":"2DvlL"}],"g8BHg":[function(require,module,exports) {
"use strict";
var Sugar = require("8c1416bcad55945f");
require("e11b1cffaad48743");
module.exports = Sugar.Date.monthsAgo;

},{"8c1416bcad55945f":"eWYA2","e11b1cffaad48743":"2DvlL"}],"d6kpQ":[function(require,module,exports) {
"use strict";
var Sugar = require("987628b406bceaa1");
require("9f31471b473abefe");
module.exports = Sugar.Date.monthsFromNow;

},{"987628b406bceaa1":"eWYA2","9f31471b473abefe":"2DvlL"}],"jpjxv":[function(require,module,exports) {
"use strict";
var Sugar = require("168ae2d304d3b5dc");
require("13c470634da263a6");
module.exports = Sugar.Date.monthsSince;

},{"168ae2d304d3b5dc":"eWYA2","13c470634da263a6":"2DvlL"}],"1K8Aj":[function(require,module,exports) {
"use strict";
var Sugar = require("60ee6e4e2b5f7149");
require("458434a59dc15f14");
module.exports = Sugar.Date.monthsUntil;

},{"60ee6e4e2b5f7149":"eWYA2","458434a59dc15f14":"2DvlL"}],"fpdD2":[function(require,module,exports) {
"use strict";
var Sugar = require("d6c01ab10714cf8c"), dateRelative = require("c574d0f69ab4a500");
Sugar.Date.defineInstance({
    "relative": function(date, localeCode, relativeFn) {
        return dateRelative(date, null, localeCode, relativeFn);
    }
});
module.exports = Sugar.Date.relative;

},{"d6c01ab10714cf8c":"eWYA2","c574d0f69ab4a500":"eyhov"}],"eyhov":[function(require,module,exports) {
"use strict";
var LocaleHelpers = require("7b8b4d5cdec14b8c"), dateFormat = require("4b25986e805f6321"), classChecks = require("1975b3162afddff8"), assertDateIsValid = require("bd05b7086fa07607"), getAdjustedUnitForDate = require("970c4a1584731e56");
var isFunction = classChecks.isFunction, localeManager = LocaleHelpers.localeManager;
function dateRelative(d, dRelative, arg1, arg2) {
    var adu, format, type, localeCode, fn;
    assertDateIsValid(d);
    if (isFunction(arg1)) fn = arg1;
    else {
        localeCode = arg1;
        fn = arg2;
    }
    adu = getAdjustedUnitForDate(d, dRelative);
    if (fn) {
        format = fn.apply(d, adu.concat(localeManager.get(localeCode)));
        if (format) return dateFormat(d, format, localeCode);
    }
    // Adjust up if time is in ms, as this doesn't
    // look very good for a standard relative date.
    if (adu[1] === 0) {
        adu[1] = 1;
        adu[0] = 1;
    }
    if (dRelative) type = "duration";
    else if (adu[2] > 0) type = "future";
    else type = "past";
    return localeManager.get(localeCode).getRelativeFormat(adu, type);
}
module.exports = dateRelative;

},{"7b8b4d5cdec14b8c":"14L7V","4b25986e805f6321":"963a2","1975b3162afddff8":"lUOLF","bd05b7086fa07607":"fk448","970c4a1584731e56":"fG50v"}],"fG50v":[function(require,module,exports) {
"use strict";
var getNewDate = require("a832855bde9ad755"), mathAliases = require("4647af4d6d45526b"), getAdjustedUnit = require("1ad461071428e432"), getTimeDistanceForUnit = require("464c1cfe8fc3237f");
var abs = mathAliases.abs;
function getAdjustedUnitForDate(d, dRelative) {
    var ms;
    if (!dRelative) {
        dRelative = getNewDate();
        if (d > dRelative) // If our date is greater than the one that we got from getNewDate, it
        // means that we are finding the unit for a date that is in the future
        // relative to now. However, often the incoming date was created in
        // the same cycle as our comparison, but our "now" date will have been
        // created an instant after it, creating situations where "5 minutes from
        // now" becomes "4 minutes from now" in the same tick. To prevent this,
        // subtract a buffer of 10ms to compensate.
        dRelative = new Date(dRelative.getTime() - 10);
    }
    ms = d - dRelative;
    return getAdjustedUnit(ms, function(u) {
        return abs(getTimeDistanceForUnit(d, dRelative, u));
    });
}
module.exports = getAdjustedUnitForDate;

},{"a832855bde9ad755":"fTtJa","4647af4d6d45526b":"89tTN","1ad461071428e432":"jYoRD","464c1cfe8fc3237f":"eGw7X"}],"hPlCd":[function(require,module,exports) {
"use strict";
var Sugar = require("256cda251a25656f"), createDate = require("133f87db528876cc"), dateRelative = require("dc8c9a226ef65b9d");
Sugar.Date.defineInstance({
    "relativeTo": function(date, d, localeCode) {
        return dateRelative(date, createDate(d), localeCode);
    }
});
module.exports = Sugar.Date.relativeTo;

},{"256cda251a25656f":"eWYA2","133f87db528876cc":"h5ei3","dc8c9a226ef65b9d":"eyhov"}],"9Pa40":[function(require,module,exports) {
"use strict";
var Sugar = require("21aab1b0ed2594d6"), DateUnitIndexes = require("99ad760c1b7d13a1"), moveToBeginningOfUnit = require("803a9913852f5c82"), getUnitIndexForParamName = require("14a4b0f7115611d3");
var DAY_INDEX = DateUnitIndexes.DAY_INDEX;
Sugar.Date.defineInstance({
    "reset": function(date, unit, localeCode) {
        var unitIndex = unit ? getUnitIndexForParamName(unit) : DAY_INDEX;
        moveToBeginningOfUnit(date, unitIndex, localeCode);
        return date;
    }
});
module.exports = Sugar.Date.reset;

},{"21aab1b0ed2594d6":"eWYA2","99ad760c1b7d13a1":"gdeYg","803a9913852f5c82":"lHsKR","14a4b0f7115611d3":"2FN2D"}],"2FN2D":[function(require,module,exports) {
"use strict";
var iterateOverDateParams = require("cd9fb70d4b152db6");
function getUnitIndexForParamName(name) {
    var params = {}, unitIndex;
    params[name] = 1;
    iterateOverDateParams(params, function(name, val, unit, i) {
        unitIndex = i;
        return false;
    });
    return unitIndex;
}
module.exports = getUnitIndexForParamName;

},{"cd9fb70d4b152db6":"9qXnd"}],"9reZP":[function(require,module,exports) {
"use strict";
var Sugar = require("6b33280849b6c544"), advanceDateWithArgs = require("5ae666deded610e6");
Sugar.Date.defineInstanceWithArguments({
    "rewind": function(d, args) {
        return advanceDateWithArgs(d, args, -1);
    }
});
module.exports = Sugar.Date.rewind;

},{"6b33280849b6c544":"eWYA2","5ae666deded610e6":"bGrKY"}],"c3SpY":[function(require,module,exports) {
"use strict";
var Sugar = require("62ba7f71abd84821");
require("3470b09e5a3a485d");
module.exports = Sugar.Date.secondsAgo;

},{"62ba7f71abd84821":"eWYA2","3470b09e5a3a485d":"2DvlL"}],"9DWEk":[function(require,module,exports) {
"use strict";
var Sugar = require("c4e516ba2697ad0f");
require("f8132802b6dce01a");
module.exports = Sugar.Date.secondsFromNow;

},{"c4e516ba2697ad0f":"eWYA2","f8132802b6dce01a":"2DvlL"}],"aqJQD":[function(require,module,exports) {
"use strict";
var Sugar = require("375742fae4ddd7b");
require("a8e717406d142124");
module.exports = Sugar.Date.secondsSince;

},{"375742fae4ddd7b":"eWYA2","a8e717406d142124":"2DvlL"}],"cfXgo":[function(require,module,exports) {
"use strict";
var Sugar = require("b6691d7da07f7e82");
require("115d96f4e73976a6");
module.exports = Sugar.Date.secondsUntil;

},{"b6691d7da07f7e82":"eWYA2","115d96f4e73976a6":"2DvlL"}],"gJWXs":[function(require,module,exports) {
"use strict";
var Sugar = require("8a13c922a02ccc7c"), updateDate = require("8995e39389cbd0a4"), collectUpdateDateArguments = require("38c410a801edb5a0");
Sugar.Date.defineInstanceWithArguments({
    "set": function(d, args) {
        args = collectUpdateDateArguments(args);
        return updateDate(d, args[0], args[1]);
    }
});
module.exports = Sugar.Date.set;

},{"8a13c922a02ccc7c":"eWYA2","8995e39389cbd0a4":"3A93x","38c410a801edb5a0":"34jSC"}],"jTKt0":[function(require,module,exports) {
"use strict";
var Sugar = require("496550d5e33d13a7"), setISOWeekNumber = require("f2a35fb0f5cd834c");
Sugar.Date.defineInstance({
    "setISOWeek": function(date, num) {
        return setISOWeekNumber(date, num);
    }
});
module.exports = Sugar.Date.setISOWeek;

},{"496550d5e33d13a7":"eWYA2","f2a35fb0f5cd834c":"55U86"}],"7Q16P":[function(require,module,exports) {
"use strict";
var Sugar = require("20459e9ad8a05bed"), _utc = require("8fee80544b887081");
Sugar.Date.defineInstance({
    "setUTC": function(date, on) {
        return _utc(date, on);
    }
});
module.exports = Sugar.Date.setUTC;

},{"20459e9ad8a05bed":"eWYA2","8fee80544b887081":"c68pM"}],"2MVPA":[function(require,module,exports) {
"use strict";
var Sugar = require("c5587bb95409bc11"), setWeekday = require("59bdf4d92ca3355a");
Sugar.Date.defineInstance({
    "setWeekday": function(date, dow) {
        return setWeekday(date, dow);
    }
});
module.exports = Sugar.Date.setWeekday;

},{"c5587bb95409bc11":"eWYA2","59bdf4d92ca3355a":"2wPrY"}],"5hcRf":[function(require,module,exports) {
"use strict";
var Sugar = require("c7e5d85fe17fd695");
require("5a85d016e62ef969");
module.exports = Sugar.Date.weeksAgo;

},{"c7e5d85fe17fd695":"eWYA2","5a85d016e62ef969":"2DvlL"}],"2m5uv":[function(require,module,exports) {
"use strict";
var Sugar = require("4163f308df005b7f");
require("9d7a8c7e53f03ab1");
module.exports = Sugar.Date.weeksFromNow;

},{"4163f308df005b7f":"eWYA2","9d7a8c7e53f03ab1":"2DvlL"}],"ha4IE":[function(require,module,exports) {
"use strict";
var Sugar = require("162dd91ec086e5a5");
require("4247c7f16b5f6302");
module.exports = Sugar.Date.weeksSince;

},{"162dd91ec086e5a5":"eWYA2","4247c7f16b5f6302":"2DvlL"}],"3trrq":[function(require,module,exports) {
"use strict";
var Sugar = require("404e88b1a7628317");
require("4006771fe367c8ea");
module.exports = Sugar.Date.weeksUntil;

},{"404e88b1a7628317":"eWYA2","4006771fe367c8ea":"2DvlL"}],"8n83U":[function(require,module,exports) {
"use strict";
var Sugar = require("cbcee5c53f21f649");
require("f382dc2682d9013d");
module.exports = Sugar.Date.yearsAgo;

},{"cbcee5c53f21f649":"eWYA2","f382dc2682d9013d":"2DvlL"}],"kPNZ8":[function(require,module,exports) {
"use strict";
var Sugar = require("dcacf1a84c51a7be");
require("9973841ff326a711");
module.exports = Sugar.Date.yearsFromNow;

},{"dcacf1a84c51a7be":"eWYA2","9973841ff326a711":"2DvlL"}],"ariwB":[function(require,module,exports) {
"use strict";
var Sugar = require("4b8f3003bebdec16");
require("e6dcd11e870eb921");
module.exports = Sugar.Date.yearsSince;

},{"4b8f3003bebdec16":"eWYA2","e6dcd11e870eb921":"2DvlL"}],"fKMpO":[function(require,module,exports) {
"use strict";
var Sugar = require("2fad075bd74241b2");
require("397e550abb79fdbc");
module.exports = Sugar.Date.yearsUntil;

},{"2fad075bd74241b2":"eWYA2","397e550abb79fdbc":"2DvlL"}],"bFvxN":[function(require,module,exports) {
"use strict";
var Sugar = require("1ed1555fd9924358"), _dateOptions = require("d050126db8d27899");
module.exports = Sugar.Date.getOption;

},{"1ed1555fd9924358":"eWYA2","d050126db8d27899":"iUAin"}],"hFGrH":[function(require,module,exports) {
"use strict";
var Sugar = require("949138ea1e07595f"), _dateOptions = require("2c156dd1d16dd517");
module.exports = Sugar.Date.setOption;

},{"949138ea1e07595f":"eWYA2","2c156dd1d16dd517":"iUAin"}],"iV5en":[function(require,module,exports) {
"use strict";
// Static Methods
require("bd324f2a06352096");
require("24985eb5c0af04e2");
require("f031754ff86e8132");
// Instance Methods
require("c07f79ad1e8b97dd");
require("5b7c50b443216c09");
require("ccb0d4ddc588cfb0");
// Prototype Methods
require("beb4528adde71f26");
require("29025407cba6e62a");
require("7aa5f8f298605d8f");
require("b6ec4c6b4170991a");
require("9c9fe2c9b7d71bc6");
require("38ea01a3629bdc9");
require("c1467751a741fe21");
require("2c452e45c13140dd");
require("829f0451d66926d5");
require("b934a38fdb7a1005");
require("8c48b436b42f8e61");
require("d5e3fc4bb963e5f");
require("da1b7b9b405d36e3");
require("c90dc39577643610");
require("a389466aaf351222");
require("8efc8f8bc121c49e");
require("9f61173d12e12dcb");
require("fb9ad100d60c0c42");
// Aliases
require("67e9ff224fbfc50a");
module.exports = require("b05a2ed2c2c26c6b");

},{"bd324f2a06352096":"hxONE","24985eb5c0af04e2":"dsuWf","f031754ff86e8132":"ig2Px","c07f79ad1e8b97dd":"lBjoJ","5b7c50b443216c09":"efZLG","ccb0d4ddc588cfb0":"hcOAr","beb4528adde71f26":"8pDLz","29025407cba6e62a":"cnJtc","7aa5f8f298605d8f":"9PUE2","b6ec4c6b4170991a":"8qOck","9c9fe2c9b7d71bc6":"4fwJu","38ea01a3629bdc9":"hnZzi","c1467751a741fe21":"eLvGo","2c452e45c13140dd":"9jjQr","829f0451d66926d5":"gfmOe","b934a38fdb7a1005":"gxBqj","8c48b436b42f8e61":"bjgeJ","d5e3fc4bb963e5f":"OsaXa","da1b7b9b405d36e3":"7GAr1","c90dc39577643610":"gx3aX","a389466aaf351222":"7T9if","8efc8f8bc121c49e":"5L89W","9f61173d12e12dcb":"6E330","fb9ad100d60c0c42":"2D8Xc","67e9ff224fbfc50a":"31dUD","b05a2ed2c2c26c6b":"eWYA2"}],"hxONE":[function(require,module,exports) {
"use strict";
var Sugar = require("e8da496755dbf89d"), DateRangeConstructor = require("7cb3eaff48fd3c28");
Sugar.Date.defineStatic({
    "range": DateRangeConstructor
});
module.exports = Sugar.Date.range;

},{"e8da496755dbf89d":"eWYA2","7cb3eaff48fd3c28":"cACkF"}],"cACkF":[function(require,module,exports) {
"use strict";
var Range = require("329da92aed2f80fa"), classChecks = require("fa164f6adb5e39b3"), getDateForRange = require("27963433ba0a642f"), createDateRangeFromString = require("59cf51ca662e845a");
var isString = classChecks.isString;
var DateRangeConstructor = function DateRangeConstructor(start, end) {
    if (arguments.length === 1 && isString(start)) return createDateRangeFromString(start);
    return new Range(getDateForRange(start), getDateForRange(end));
};
module.exports = DateRangeConstructor;

},{"329da92aed2f80fa":"koAZ1","fa164f6adb5e39b3":"lUOLF","27963433ba0a642f":"3IpYQ","59cf51ca662e845a":"6yfuH"}],"koAZ1":[function(require,module,exports) {
"use strict";
var cloneRangeMember = require("f9946f5aeee3cc12");
function Range(start, end) {
    this.start = cloneRangeMember(start);
    this.end = cloneRangeMember(end);
}
module.exports = Range;

},{"f9946f5aeee3cc12":"5yp2S"}],"5yp2S":[function(require,module,exports) {
"use strict";
var classChecks = require("1a223d4367e22bcd"), getRangeMemberPrimitiveValue = require("8a5bbaa0b13a8eb2");
var isDate = classChecks.isDate;
function cloneRangeMember(m) {
    if (isDate(m)) return new Date(m.getTime());
    else return getRangeMemberPrimitiveValue(m);
}
module.exports = cloneRangeMember;

},{"1a223d4367e22bcd":"lUOLF","8a5bbaa0b13a8eb2":"7vYJx"}],"7vYJx":[function(require,module,exports) {
"use strict";
var classChecks = require("d6857f1f00f7a797");
var isDate = classChecks.isDate;
function getRangeMemberPrimitiveValue(m) {
    if (m == null) return m;
    return isDate(m) ? m.getTime() : m.valueOf();
}
module.exports = getRangeMemberPrimitiveValue;

},{"d6857f1f00f7a797":"lUOLF"}],"3IpYQ":[function(require,module,exports) {
"use strict";
var classChecks = require("caa7c4c822571c04"), namespaceAliases = require("c5ff5296e1441548");
var isDate = classChecks.isDate, sugarDate = namespaceAliases.sugarDate;
function getDateForRange(d) {
    if (isDate(d)) return d;
    else if (d == null) return new Date();
    else if (sugarDate.create) return sugarDate.create(d);
    return new Date(d);
}
module.exports = getDateForRange;

},{"caa7c4c822571c04":"lUOLF","c5ff5296e1441548":"1TEpR"}],"6yfuH":[function(require,module,exports) {
"use strict";
var Range = require("3debee032444f8e2"), DurationTextFormats = require("dbe788ffce799ba9"), incrementDate = require("9754af747d794349"), getDateForRange = require("ec1dfb1989b581f9"), namespaceAliases = require("a51fdfe7becfbce8"), getDateIncrementObject = require("3649a4448eb1fbcd");
var sugarDate = namespaceAliases.sugarDate, RANGE_REG_FROM_TO = DurationTextFormats.RANGE_REG_FROM_TO, RANGE_REG_REAR_DURATION = DurationTextFormats.RANGE_REG_REAR_DURATION, RANGE_REG_FRONT_DURATION = DurationTextFormats.RANGE_REG_FRONT_DURATION;
function createDateRangeFromString(str) {
    var match, datetime, duration, dio, start, end;
    if (sugarDate.get && (match = str.match(RANGE_REG_FROM_TO))) {
        start = getDateForRange(match[1].replace("from", "at"));
        end = sugarDate.get(start, match[2]);
        return new Range(start, end);
    }
    if (match = str.match(RANGE_REG_FRONT_DURATION)) {
        duration = match[1];
        datetime = match[2];
    }
    if (match = str.match(RANGE_REG_REAR_DURATION)) {
        datetime = match[1];
        duration = match[2];
    }
    if (datetime && duration) {
        start = getDateForRange(datetime);
        dio = getDateIncrementObject(duration);
        end = incrementDate(start, dio[0], dio[1]);
    } else start = str;
    return new Range(getDateForRange(start), getDateForRange(end));
}
module.exports = createDateRangeFromString;

},{"3debee032444f8e2":"koAZ1","dbe788ffce799ba9":"3xuBU","9754af747d794349":"fGIGO","ec1dfb1989b581f9":"3IpYQ","a51fdfe7becfbce8":"1TEpR","3649a4448eb1fbcd":"eRO03"}],"3xuBU":[function(require,module,exports) {
"use strict";
var FULL_CAPTURED_DURATION = require("232d286e85401e7f");
module.exports = {
    RANGE_REG_FROM_TO: /(?:from)?\s*(.+)\s+(?:to|until)\s+(.+)$/i,
    RANGE_REG_REAR_DURATION: RegExp("(.+)\\s*for\\s*" + FULL_CAPTURED_DURATION, "i"),
    RANGE_REG_FRONT_DURATION: RegExp("(?:for)?\\s*" + FULL_CAPTURED_DURATION + "\\s*(?:starting)?\\s(?:at\\s)?(.+)", "i")
};

},{"232d286e85401e7f":"5vaIW"}],"5vaIW":[function(require,module,exports) {
"use strict";
var DURATION_UNITS = require("189c4d658e733021");
module.exports = "((?:\\d+)?\\s*(?:" + DURATION_UNITS + "))s?";

},{"189c4d658e733021":"hVjGC"}],"hVjGC":[function(require,module,exports) {
"use strict";
module.exports = "year|month|week|day|hour|minute|second|millisecond";

},{}],"fGIGO":[function(require,module,exports) {
"use strict";
var MULTIPLIERS = require("7474e009fae4ea51"), callDateSet = require("56c078880a5afe5c"), callDateGet = require("5117d5989734f31c");
function incrementDate(src, amount, unit) {
    var mult = MULTIPLIERS[unit], d;
    if (mult) d = new Date(src.getTime() + amount * mult);
    else {
        d = new Date(src);
        callDateSet(d, unit, callDateGet(src, unit) + amount);
    }
    return d;
}
module.exports = incrementDate;

},{"7474e009fae4ea51":"5FMXR","56c078880a5afe5c":"6i5qR","5117d5989734f31c":"kBI9T"}],"5FMXR":[function(require,module,exports) {
"use strict";
var MULTIPLIERS = {
    "Hours": 3600000,
    "Minutes": 60000,
    "Seconds": 1000,
    "Milliseconds": 1
};
module.exports = MULTIPLIERS;

},{}],"eRO03":[function(require,module,exports) {
"use strict";
var DURATION_REG = require("6ad6f1938b0d9aa9"), classChecks = require("3d72495b618a4511"), simpleCapitalize = require("123ade260321ba0c");
var isNumber = classChecks.isNumber;
function getDateIncrementObject(amt) {
    var match, val, unit;
    if (isNumber(amt)) return [
        amt,
        "Milliseconds"
    ];
    match = amt.match(DURATION_REG);
    val = +match[1] || 1;
    unit = simpleCapitalize(match[2].toLowerCase());
    if (unit.match(/hour|minute|second/i)) unit += "s";
    else if (unit === "Year") unit = "FullYear";
    else if (unit === "Week") {
        unit = "Date";
        val *= 7;
    } else if (unit === "Day") unit = "Date";
    return [
        val,
        unit
    ];
}
module.exports = getDateIncrementObject;

},{"6ad6f1938b0d9aa9":"bnLHR","3d72495b618a4511":"lUOLF","123ade260321ba0c":"jYftQ"}],"bnLHR":[function(require,module,exports) {
"use strict";
var DURATION_UNITS = require("aa4701d5a3678f03");
module.exports = RegExp("(\\d+)?\\s*(" + DURATION_UNITS + ")s?", "i");

},{"aa4701d5a3678f03":"hVjGC"}],"dsuWf":[function(require,module,exports) {
"use strict";
var Sugar = require("25efb347696e4b8a"), PrimitiveRangeConstructor = require("d91972827cc46696");
Sugar.Number.defineStatic({
    "range": PrimitiveRangeConstructor
});
module.exports = Sugar.Number.range;

},{"25efb347696e4b8a":"eWYA2","d91972827cc46696":"gIzkP"}],"gIzkP":[function(require,module,exports) {
"use strict";
var Range = require("ef9fac11ffbbffc8");
var PrimitiveRangeConstructor = function PrimitiveRangeConstructor(start, end) {
    return new Range(start, end);
};
module.exports = PrimitiveRangeConstructor;

},{"ef9fac11ffbbffc8":"koAZ1"}],"ig2Px":[function(require,module,exports) {
"use strict";
var Sugar = require("24d1415c7429622"), PrimitiveRangeConstructor = require("ee172faa650031ca");
Sugar.String.defineStatic({
    "range": PrimitiveRangeConstructor
});
module.exports = Sugar.String.range;

},{"24d1415c7429622":"eWYA2","ee172faa650031ca":"gIzkP"}],"lBjoJ":[function(require,module,exports) {
"use strict";
var Sugar = require("49c858659e1c0df1"), Range = require("4aa738b76fb397f1"), rangeClamp = require("16e1a7db8e4a833e");
Sugar.Number.defineInstance({
    "cap": function(n, max) {
        return rangeClamp(new Range(undefined, max), n);
    }
});
module.exports = Sugar.Number.cap;

},{"49c858659e1c0df1":"eWYA2","4aa738b76fb397f1":"koAZ1","16e1a7db8e4a833e":"giQuy"}],"giQuy":[function(require,module,exports) {
"use strict";
var cloneRangeMember = require("df4044aa143b542");
function rangeClamp(range, obj) {
    var clamped, start = range.start, end = range.end, min = end < start ? end : start, max = start > end ? start : end;
    if (obj < min) clamped = min;
    else if (obj > max) clamped = max;
    else clamped = obj;
    return cloneRangeMember(clamped);
}
module.exports = rangeClamp;

},{"df4044aa143b542":"5yp2S"}],"efZLG":[function(require,module,exports) {
"use strict";
var Sugar = require("b078d32f546e75b5"), Range = require("31d095cdee536da4"), rangeClamp = require("c1bddc97b3108a03");
Sugar.Number.defineInstance({
    "clamp": function(n, start, end) {
        return rangeClamp(new Range(start, end), n);
    }
});
module.exports = Sugar.Number.clamp;

},{"b078d32f546e75b5":"eWYA2","31d095cdee536da4":"koAZ1","c1bddc97b3108a03":"giQuy"}],"hcOAr":[function(require,module,exports) {
"use strict";
var Sugar = require("26c714d0b4b94f6a"), Range = require("a3220ad9a1212a37"), rangeEvery = require("e2415f71ebcee373");
Sugar.Number.defineInstance({
    "upto": function(n, num, step, everyFn) {
        return rangeEvery(new Range(n, num), step, false, everyFn);
    }
});
module.exports = Sugar.Number.upto;

},{"26c714d0b4b94f6a":"eWYA2","a3220ad9a1212a37":"koAZ1","e2415f71ebcee373":"gRnjp"}],"gRnjp":[function(require,module,exports) {
"use strict";
var classChecks = require("40d25f6b226680eb"), rangeIsValid = require("c7bf034fd77dd8ed"), incrementDate = require("3e75f80b0cc634eb"), incrementNumber = require("5b8510d6989a1a40"), incrementString = require("987bc4cab766eec5"), getGreaterPrecision = require("6c8d8bc81b5437db"), getDateIncrementObject = require("96d872de003372d0");
var isNumber = classChecks.isNumber, isString = classChecks.isString, isDate = classChecks.isDate, isFunction = classChecks.isFunction;
function rangeEvery(range, step, countOnly, fn) {
    var increment, precision, dio, unit, start = range.start, end = range.end, inverse = end < start, current = start, index = 0, result = [];
    if (!rangeIsValid(range)) return countOnly ? NaN : [];
    if (isFunction(step)) {
        fn = step;
        step = null;
    }
    step = step || 1;
    if (isNumber(start)) {
        precision = getGreaterPrecision(start, step);
        increment = function increment() {
            return incrementNumber(current, step, precision);
        };
    } else if (isString(start)) increment = function increment() {
        return incrementString(current, step);
    };
    else if (isDate(start)) {
        dio = getDateIncrementObject(step);
        step = dio[0];
        unit = dio[1];
        increment = function increment() {
            return incrementDate(current, step, unit);
        };
    }
    // Avoiding infinite loops
    if (inverse && step > 0) step *= -1;
    while(inverse ? current >= end : current <= end){
        if (!countOnly) result.push(current);
        if (fn) fn(current, index, range);
        current = increment();
        index++;
    }
    return countOnly ? index - 1 : result;
}
module.exports = rangeEvery;

},{"40d25f6b226680eb":"lUOLF","c7bf034fd77dd8ed":"5Cys2","3e75f80b0cc634eb":"fGIGO","5b8510d6989a1a40":"hQ9kT","987bc4cab766eec5":"RuCP3","6c8d8bc81b5437db":"iF65p","96d872de003372d0":"eRO03"}],"5Cys2":[function(require,module,exports) {
"use strict";
var isValidRangeMember = require("5bcd9a1d606aae8a");
function rangeIsValid(range) {
    return isValidRangeMember(range.start) && isValidRangeMember(range.end) && typeof range.start === typeof range.end;
}
module.exports = rangeIsValid;

},{"5bcd9a1d606aae8a":"2FnOb"}],"2FnOb":[function(require,module,exports) {
"use strict";
var valueIsNotInfinite = require("4c8c3f88af7fa4f"), getRangeMemberPrimitiveValue = require("49c3fb7c5f7a4303");
function isValidRangeMember(m) {
    var val = getRangeMemberPrimitiveValue(m);
    return (!!val || val === 0) && valueIsNotInfinite(m);
}
module.exports = isValidRangeMember;

},{"4c8c3f88af7fa4f":"2hQxS","49c3fb7c5f7a4303":"7vYJx"}],"2hQxS":[function(require,module,exports) {
"use strict";
function valueIsNotInfinite(m) {
    return m !== -Infinity && m !== Infinity;
}
module.exports = valueIsNotInfinite;

},{}],"hQ9kT":[function(require,module,exports) {
"use strict";
var withPrecision = require("2653c2196f154d64");
function incrementNumber(current, amount, precision) {
    return withPrecision(current + amount, precision);
}
module.exports = incrementNumber;

},{"2653c2196f154d64":"6JCWQ"}],"RuCP3":[function(require,module,exports) {
"use strict";
var chr = require("6a2ed93dc075c25d");
function incrementString(current, amount) {
    return chr(current.charCodeAt(0) + amount);
}
module.exports = incrementString;

},{"6a2ed93dc075c25d":"fFtOs"}],"iF65p":[function(require,module,exports) {
"use strict";
var mathAliases = require("d4b3abb696600e44"), getPrecision = require("c013d98689fb8aa5");
var max = mathAliases.max;
function getGreaterPrecision(n1, n2) {
    return max(getPrecision(n1), getPrecision(n2));
}
module.exports = getGreaterPrecision;

},{"d4b3abb696600e44":"89tTN","c013d98689fb8aa5":"2AKnm"}],"2AKnm":[function(require,module,exports) {
"use strict";
var periodSplit = require("2fa10a86d5003c0");
function getPrecision(n) {
    var split = periodSplit(n.toString());
    return split[1] ? split[1].length : 0;
}
module.exports = getPrecision;

},{"2fa10a86d5003c0":"jncZt"}],"8pDLz":[function(require,module,exports) {
"use strict";
var Range = require("664b128e6ad66197"), rangeClamp = require("5e73028aa6d571d4"), defineOnPrototype = require("2072fca4f673d215");
defineOnPrototype(Range, {
    "clamp": function(el) {
        return rangeClamp(this, el);
    }
}); // This package does not export anything as it is
 // simply defining "clamp" on Range.prototype.

},{"664b128e6ad66197":"koAZ1","5e73028aa6d571d4":"giQuy","2072fca4f673d215":"9QG9p"}],"9QG9p":[function(require,module,exports) {
"use strict";
var coreUtilityAliases = require("b9c39505f9ed37eb");
var forEachProperty = coreUtilityAliases.forEachProperty;
function defineOnPrototype(ctor, methods) {
    var proto = ctor.prototype;
    forEachProperty(methods, function(val, key) {
        proto[key] = val;
    });
}
module.exports = defineOnPrototype;

},{"b9c39505f9ed37eb":"dU8Nu"}],"cnJtc":[function(require,module,exports) {
"use strict";
var Range = require("7923392baf0c1011"), defineOnPrototype = require("c25588d068d67d37");
defineOnPrototype(Range, {
    "clone": function() {
        return new Range(this.start, this.end);
    }
}); // This package does not export anything as it is
 // simply defining "clone" on Range.prototype.

},{"7923392baf0c1011":"koAZ1","c25588d068d67d37":"9QG9p"}],"9PUE2":[function(require,module,exports) {
"use strict";
var Range = require("e96abd58dce3a49"), defineOnPrototype = require("667528d32278574e");
defineOnPrototype(Range, {
    "contains": function(el) {
        if (el == null) return false;
        if (el.start && el.end) return el.start >= this.start && el.start <= this.end && el.end >= this.start && el.end <= this.end;
        else return el >= this.start && el <= this.end;
    }
}); // This package does not export anything as it is
 // simply defining "contains" on Range.prototype.

},{"e96abd58dce3a49":"koAZ1","667528d32278574e":"9QG9p"}],"8qOck":[function(require,module,exports) {
"use strict";
require("39e7c91df824d2a5"); // This package does not export anything as it is
 // simply defining "days" on Range.prototype.

},{"39e7c91df824d2a5":"7MO1H"}],"7MO1H":[function(require,module,exports) {
"use strict";
var buildDateRangeUnits = require("20810ef226de73d9");
buildDateRangeUnits();

},{"20810ef226de73d9":"jdbCX"}],"jdbCX":[function(require,module,exports) {
"use strict";
var MULTIPLIERS = require("985f302ac2eb4df9"), DURATION_UNITS = require("27767927d99fd6c3"), Range = require("32ea9c6cc3d94318"), trunc = require("7771282feaeab3d"), forEach = require("45850dd88fdb6be4"), rangeEvery = require("42a5e84071e3a54d"), simpleCapitalize = require("1c7b33a022573117"), defineOnPrototype = require("6df17fa396e34d7b");
function buildDateRangeUnits() {
    var methods = {};
    forEach(DURATION_UNITS.split("|"), function(unit, i) {
        var name = unit + "s", mult, fn;
        if (i < 4) fn = function fn() {
            return rangeEvery(this, unit, true);
        };
        else {
            mult = MULTIPLIERS[simpleCapitalize(name)];
            fn = function fn() {
                return trunc((this.end - this.start) / mult);
            };
        }
        methods[name] = fn;
    });
    defineOnPrototype(Range, methods);
}
module.exports = buildDateRangeUnits;

},{"985f302ac2eb4df9":"5FMXR","27767927d99fd6c3":"hVjGC","32ea9c6cc3d94318":"koAZ1","7771282feaeab3d":"ePaYC","45850dd88fdb6be4":"1n2CK","42a5e84071e3a54d":"gRnjp","1c7b33a022573117":"jYftQ","6df17fa396e34d7b":"9QG9p"}],"4fwJu":[function(require,module,exports) {
"use strict";
var Range = require("8f0453249fe3514e"), rangeEvery = require("773caf56e7c317fa"), defineOnPrototype = require("af74fbf32e914c4b");
defineOnPrototype(Range, {
    "every": function(amount, everyFn) {
        return rangeEvery(this, amount, false, everyFn);
    }
}); // This package does not export anything as it is
 // simply defining "every" on Range.prototype.

},{"8f0453249fe3514e":"koAZ1","773caf56e7c317fa":"gRnjp","af74fbf32e914c4b":"9QG9p"}],"hnZzi":[function(require,module,exports) {
"use strict";
require("cddc36e67ae4ee56"); // This package does not export anything as it is
 // simply defining "hours" on Range.prototype.

},{"cddc36e67ae4ee56":"7MO1H"}],"eLvGo":[function(require,module,exports) {
"use strict";
var Range = require("9a280dfd08138921"), defineOnPrototype = require("48307a0ffc6ba4d1");
defineOnPrototype(Range, {
    "intersect": function(range) {
        if (range.start > this.end || range.end < this.start) return new Range(NaN, NaN);
        return new Range(this.start > range.start ? this.start : range.start, this.end < range.end ? this.end : range.end);
    }
}); // This package does not export anything as it is
 // simply defining "intersect" on Range.prototype.

},{"9a280dfd08138921":"koAZ1","48307a0ffc6ba4d1":"9QG9p"}],"9jjQr":[function(require,module,exports) {
"use strict";
var Range = require("6edb2127389b25e5"), rangeIsValid = require("eec320eb6db276d3"), defineOnPrototype = require("a734682e79d91773");
defineOnPrototype(Range, {
    "isValid": function() {
        return rangeIsValid(this);
    }
}); // This package does not export anything as it is
 // simply defining "isValid" on Range.prototype.

},{"6edb2127389b25e5":"koAZ1","eec320eb6db276d3":"5Cys2","a734682e79d91773":"9QG9p"}],"gfmOe":[function(require,module,exports) {
"use strict";
require("874c3eb71313f371"); // This package does not export anything as it is
 // simply defining "milliseconds" on Range.prototype.

},{"874c3eb71313f371":"7MO1H"}],"gxBqj":[function(require,module,exports) {
"use strict";
require("92cc0c09aeb70b73"); // This package does not export anything as it is
 // simply defining "minutes" on Range.prototype.

},{"92cc0c09aeb70b73":"7MO1H"}],"bjgeJ":[function(require,module,exports) {
"use strict";
require("9502920fdbf08625"); // This package does not export anything as it is
 // simply defining "months" on Range.prototype.

},{"9502920fdbf08625":"7MO1H"}],"OsaXa":[function(require,module,exports) {
"use strict";
require("d251e3dd174926a3"); // This package does not export anything as it is
 // simply defining "seconds" on Range.prototype.

},{"d251e3dd174926a3":"7MO1H"}],"7GAr1":[function(require,module,exports) {
"use strict";
var Range = require("3d301159852331ab"), mathAliases = require("39f68f066019a0e0"), rangeIsValid = require("a672c69269e03354"), defineOnPrototype = require("ac4a7fd75b91c1dc"), getRangeMemberNumericValue = require("c55e398211a0bdc4");
var abs = mathAliases.abs;
defineOnPrototype(Range, {
    "span": function() {
        var n = getRangeMemberNumericValue(this.end) - getRangeMemberNumericValue(this.start);
        return rangeIsValid(this) ? abs(n) + 1 : NaN;
    }
}); // This package does not export anything as it is
 // simply defining "span" on Range.prototype.

},{"3d301159852331ab":"koAZ1","39f68f066019a0e0":"89tTN","a672c69269e03354":"5Cys2","ac4a7fd75b91c1dc":"9QG9p","c55e398211a0bdc4":"hWNwZ"}],"hWNwZ":[function(require,module,exports) {
"use strict";
var classChecks = require("7144fedac558483d");
var isString = classChecks.isString;
function getRangeMemberNumericValue(m) {
    return isString(m) ? m.charCodeAt(0) : m;
}
module.exports = getRangeMemberNumericValue;

},{"7144fedac558483d":"lUOLF"}],"gx3aX":[function(require,module,exports) {
"use strict";
var Range = require("d9a4fdf47e36fa32"), rangeEvery = require("482a70e4fd10bd78"), defineOnPrototype = require("b6d64bd8ee6d04a3");
defineOnPrototype(Range, {
    "toArray": function() {
        return rangeEvery(this);
    }
}); // This package does not export anything as it is
 // simply defining "toArray" on Range.prototype.

},{"d9a4fdf47e36fa32":"koAZ1","482a70e4fd10bd78":"gRnjp","b6d64bd8ee6d04a3":"9QG9p"}],"7T9if":[function(require,module,exports) {
"use strict";
var Range = require("b9ba167dfb753257"), rangeIsValid = require("f7a5d2386aef55e7"), defineOnPrototype = require("2b8b08fc34fe8f32");
defineOnPrototype(Range, {
    "toString": function() {
        return rangeIsValid(this) ? this.start + ".." + this.end : "Invalid Range";
    }
}); // This package does not export anything as it is
 // simply defining "toString" on Range.prototype.

},{"b9ba167dfb753257":"koAZ1","f7a5d2386aef55e7":"5Cys2","2b8b08fc34fe8f32":"9QG9p"}],"5L89W":[function(require,module,exports) {
"use strict";
var Range = require("3f7a92ea4e3ef88f"), defineOnPrototype = require("156ce9a535eeb3c0");
defineOnPrototype(Range, {
    "union": function(range) {
        return new Range(this.start < range.start ? this.start : range.start, this.end > range.end ? this.end : range.end);
    }
}); // This package does not export anything as it is
 // simply defining "union" on Range.prototype.

},{"3f7a92ea4e3ef88f":"koAZ1","156ce9a535eeb3c0":"9QG9p"}],"6E330":[function(require,module,exports) {
"use strict";
require("f939aab7bf55c75d"); // This package does not export anything as it is
 // simply defining "weeks" on Range.prototype.

},{"f939aab7bf55c75d":"7MO1H"}],"2D8Xc":[function(require,module,exports) {
"use strict";
require("90e3d28614469a9"); // This package does not export anything as it is
 // simply defining "years" on Range.prototype.

},{"90e3d28614469a9":"7MO1H"}],"31dUD":[function(require,module,exports) {
"use strict";
var Sugar = require("bc6c39c3adee1195"), upto = require("c267de5b0178ff1c");
Sugar.Number.alias("downto", "upto");
module.exports = Sugar.Number.downto;

},{"bc6c39c3adee1195":"eWYA2","c267de5b0178ff1c":"hcOAr"}],"egKZI":[function(require,module,exports) {
"use strict";
// Instance Methods
require("ea5892428f6d96d6");
require("143a908bd069f0a9");
require("f9fb65c4246c7f28");
require("dfe9867c3c6d54c0");
require("c3ad277fc0580df9");
require("796255e856c5c51d");
require("f2b48732b0d3ecd3");
require("34ea3698a1c50d98");
require("97a402cb76edd34b");
require("edfa64c61274be56");
require("e5689b4e3a70533f");
module.exports = require("63286029cb16575f");

},{"ea5892428f6d96d6":"gbsR4","143a908bd069f0a9":"inea3","f9fb65c4246c7f28":"imSFQ","dfe9867c3c6d54c0":"3LY9M","c3ad277fc0580df9":"8OgUU","796255e856c5c51d":"4xQL6","f2b48732b0d3ecd3":"ax5NQ","34ea3698a1c50d98":"cFI6E","97a402cb76edd34b":"2rq9E","edfa64c61274be56":"7U56o","e5689b4e3a70533f":"9baTs","63286029cb16575f":"eWYA2"}],"gbsR4":[function(require,module,exports) {
"use strict";
var Sugar = require("55c95b2b1b9f9133"), coercePositiveInteger = require("4b7c08a037f29eaf");
Sugar.Function.defineInstance({
    "after": function(fn, num) {
        var count = 0, collectedArgs = [];
        num = coercePositiveInteger(num);
        return function() {
            // Optimized: no leaking arguments
            var args = [];
            for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
            collectedArgs.push(args);
            count++;
            if (count >= num) return fn.call(this, collectedArgs);
        };
    }
});
module.exports = Sugar.Function.after;

},{"55c95b2b1b9f9133":"eWYA2","4b7c08a037f29eaf":"5NU91"}],"inea3":[function(require,module,exports) {
"use strict";
var Sugar = require("7ecc8f2801b86f6a"), cancelFunction = require("85a7b44c1e2920bc");
Sugar.Function.defineInstance({
    "cancel": function(fn) {
        return cancelFunction(fn);
    }
});
module.exports = Sugar.Function.cancel;

},{"7ecc8f2801b86f6a":"eWYA2","85a7b44c1e2920bc":"aIoJt"}],"aIoJt":[function(require,module,exports) {
"use strict";
var _timers = require("10f186a481e1f3d7"), _canceled = require("b46856bbd57327d8"), classChecks = require("f795747fa6549f14");
var isArray = classChecks.isArray;
function cancelFunction(fn) {
    var timers = _timers(fn), timer;
    if (isArray(timers)) while(timer = timers.shift())clearTimeout(timer);
    _canceled(fn, true);
    return fn;
}
module.exports = cancelFunction;

},{"10f186a481e1f3d7":"e8AR9","b46856bbd57327d8":"eX31q","f795747fa6549f14":"lUOLF"}],"e8AR9":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("483f23472a400de8");
module.exports = privatePropertyAccessor("timers");

},{"483f23472a400de8":"eP4xz"}],"eX31q":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("267af61f7fff1de1");
module.exports = privatePropertyAccessor("canceled");

},{"267af61f7fff1de1":"eP4xz"}],"imSFQ":[function(require,module,exports) {
"use strict";
var Sugar = require("dcd21b8d010d6cfd"), setDelay = require("59cf70a67c558a73"), cancelFunction = require("dc8b29039feb9c02");
Sugar.Function.defineInstance({
    "debounce": function(fn, ms) {
        function debounced() {
            // Optimized: no leaking arguments
            var args = [];
            for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
            cancelFunction(debounced);
            setDelay(debounced, ms, fn, this, args);
        }
        return debounced;
    }
});
module.exports = Sugar.Function.debounce;

},{"dcd21b8d010d6cfd":"eWYA2","59cf70a67c558a73":"k1Elc","dc8b29039feb9c02":"aIoJt"}],"k1Elc":[function(require,module,exports) {
"use strict";
var _timers = require("9345cd0143326539"), _canceled = require("99602a2658fa9434"), coercePositiveInteger = require("86e813b7dc6db349");
function setDelay(fn, ms, after, scope, args) {
    // Delay of infinity is never called of course...
    ms = coercePositiveInteger(ms || 0);
    if (!_timers(fn)) _timers(fn, []);
    // This is a workaround for <= IE8, which apparently has the
    // ability to call timeouts in the queue on the same tick (ms?)
    // even if functionally they have already been cleared.
    _canceled(fn, false);
    _timers(fn).push(setTimeout(function() {
        if (!_canceled(fn)) after.apply(scope, args || []);
    }, ms));
}
module.exports = setDelay;

},{"9345cd0143326539":"e8AR9","99602a2658fa9434":"eX31q","86e813b7dc6db349":"5NU91"}],"3LY9M":[function(require,module,exports) {
"use strict";
var Sugar = require("8a1e4fc24a9db303"), setDelay = require("a8feecff5be4c2a5");
Sugar.Function.defineInstanceWithArguments({
    "delay": function(fn, ms, args) {
        setDelay(fn, ms, fn, fn, args);
        return fn;
    }
});
module.exports = Sugar.Function.delay;

},{"8a1e4fc24a9db303":"eWYA2","a8feecff5be4c2a5":"k1Elc"}],"8OgUU":[function(require,module,exports) {
"use strict";
var Sugar = require("c8a20b56944064fb"), setDelay = require("d17f1d4a97382d1e");
Sugar.Function.defineInstanceWithArguments({
    "every": function(fn, ms, args) {
        function execute() {
            // Set the delay first here, so that cancel
            // can be called within the executing function.
            setDelay(fn, ms, execute);
            fn.apply(fn, args);
        }
        setDelay(fn, ms, execute);
        return fn;
    }
});
module.exports = Sugar.Function.every;

},{"c8a20b56944064fb":"eWYA2","d17f1d4a97382d1e":"k1Elc"}],"4xQL6":[function(require,module,exports) {
"use strict";
var Sugar = require("21fcf3783844f761"), createLazyFunction = require("61bd89428177e0c9");
Sugar.Function.defineInstance({
    "lazy": function(fn, ms, immediate, limit) {
        return createLazyFunction(fn, ms, immediate, limit);
    }
});
module.exports = Sugar.Function.lazy;

},{"21fcf3783844f761":"eWYA2","61bd89428177e0c9":"cJUwT"}],"cJUwT":[function(require,module,exports) {
"use strict";
var setDelay = require("4b5811199be798cc"), mathAliases = require("b93b4c14587c5990");
var max = mathAliases.max, ceil = mathAliases.ceil, round = mathAliases.round;
function createLazyFunction(fn, ms, immediate, limit) {
    var queue = [], locked = false, execute, rounded, perExecution, result;
    ms = ms || 1;
    limit = limit || Infinity;
    rounded = ceil(ms);
    perExecution = round(rounded / ms) || 1;
    execute = function() {
        var queueLength = queue.length, maxPerRound;
        if (queueLength == 0) return;
        // Allow fractions of a millisecond by calling
        // multiple times per actual timeout execution
        maxPerRound = max(queueLength - perExecution, 0);
        while(queueLength > maxPerRound){
            // Getting uber-meta here...
            result = Function.prototype.apply.apply(fn, queue.shift());
            queueLength--;
        }
        setDelay(lazy, rounded, function() {
            locked = false;
            execute();
        });
    };
    function lazy() {
        // If the execution has locked and it's immediate, then
        // allow 1 less in the queue as 1 call has already taken place.
        if (queue.length < limit - (locked && immediate ? 1 : 0)) {
            // Optimized: no leaking arguments
            var args = [];
            for(var $i = 0, $len = arguments.length; $i < $len; $i++)args.push(arguments[$i]);
            queue.push([
                this,
                args
            ]);
        }
        if (!locked) {
            locked = true;
            if (immediate) execute();
            else setDelay(lazy, rounded, execute);
        }
        // Return the memoized result
        return result;
    }
    return lazy;
}
module.exports = createLazyFunction;

},{"4b5811199be798cc":"k1Elc","b93b4c14587c5990":"89tTN"}],"ax5NQ":[function(require,module,exports) {
"use strict";
var Sugar = require("14e926900b6f09dd"), _lock = require("48cc79720e950ea2"), _partial = require("aeea86d6aba08758"), classChecks = require("3ceb47a3483b32b2"), mathAliases = require("2cfee297856d890");
var isNumber = classChecks.isNumber, min = mathAliases.min;
Sugar.Function.defineInstance({
    "lock": function(fn, n) {
        var lockedFn;
        if (_partial(fn)) {
            _lock(fn, isNumber(n) ? n : null);
            return fn;
        }
        lockedFn = function() {
            arguments.length = min(_lock(lockedFn), arguments.length);
            return fn.apply(this, arguments);
        };
        _lock(lockedFn, isNumber(n) ? n : fn.length);
        return lockedFn;
    }
});
module.exports = Sugar.Function.lock;

},{"14e926900b6f09dd":"eWYA2","48cc79720e950ea2":"duWUR","aeea86d6aba08758":"9lnxg","3ceb47a3483b32b2":"lUOLF","2cfee297856d890":"89tTN"}],"duWUR":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("89551de6a73e2b4a");
module.exports = privatePropertyAccessor("lock");

},{"89551de6a73e2b4a":"eP4xz"}],"9lnxg":[function(require,module,exports) {
"use strict";
var privatePropertyAccessor = require("c6010bd4892608b5");
module.exports = privatePropertyAccessor("partial");

},{"c6010bd4892608b5":"eP4xz"}],"cFI6E":[function(require,module,exports) {
"use strict";
var Sugar = require("bf62088101758950"), classChecks = require("66abd8b016a3f772"), deepGetProperty = require("f1619333811e743b"), collectArguments = require("b95bcfdedef95e4a"), createHashedMemoizeFunction = require("eae1f80c4fed5645");
var isNumber = classChecks.isNumber, isString = classChecks.isString;
Sugar.Function.defineInstance({
    "memoize": function(fn, arg1, arg2) {
        var hashFn, limit, prop;
        if (isNumber(arg1)) limit = arg1;
        else {
            hashFn = arg1;
            limit = arg2;
        }
        if (isString(hashFn)) {
            prop = hashFn;
            hashFn = function hashFn(obj) {
                return deepGetProperty(obj, prop);
            };
        } else if (!hashFn) hashFn = collectArguments;
        return createHashedMemoizeFunction(fn, hashFn, limit);
    }
});
module.exports = Sugar.Function.memoize;

},{"bf62088101758950":"eWYA2","66abd8b016a3f772":"lUOLF","f1619333811e743b":"fxfTs","b95bcfdedef95e4a":"1uoxU","eae1f80c4fed5645":"2pbzo"}],"1uoxU":[function(require,module,exports) {
"use strict";
function collectArguments() {
    var args = arguments, i = args.length, arr = new Array(i);
    while(i--)arr[i] = args[i];
    return arr;
}
module.exports = collectArguments;

},{}],"2pbzo":[function(require,module,exports) {
"use strict";
var serializeInternal = require("5ca23127cba2b973"), coreUtilityAliases = require("4a8079658eef6a1f");
var hasOwn = coreUtilityAliases.hasOwn, getOwn = coreUtilityAliases.getOwn;
function createHashedMemoizeFunction(fn, hashFn, limit) {
    var map = {}, refs = [], counter = 0;
    return function() {
        var hashObj = hashFn.apply(this, arguments);
        var key = serializeInternal(hashObj, refs);
        if (hasOwn(map, key)) return getOwn(map, key);
        if (counter === limit) {
            map = {};
            refs = [];
            counter = 0;
        }
        counter++;
        return map[key] = fn.apply(this, arguments);
    };
}
module.exports = createHashedMemoizeFunction;

},{"5ca23127cba2b973":"ffntQ","4a8079658eef6a1f":"dU8Nu"}],"2rq9E":[function(require,module,exports) {
"use strict";
var Sugar = require("afc913acc3d621dc");
Sugar.Function.defineInstance({
    "once": function(fn) {
        var called = false, val;
        return function() {
            if (called) return val;
            called = true;
            return val = fn.apply(this, arguments);
        };
    }
});
module.exports = Sugar.Function.once;

},{"afc913acc3d621dc":"eWYA2"}],"7U56o":[function(require,module,exports) {
"use strict";
var Sugar = require("16d8f8d03d4828e3"), _lock = require("4f6dce669d0a4469"), _partial = require("2b18d1e11a15a9eb"), isDefined = require("7fc8951d3ccb6b78"), classChecks = require("b3c64dcb6a357a87"), mathAliases = require("9072ef83e0378b30"), isObjectType = require("23bcfd79f6a7503f"), createInstanceFromPrototype = require("f508e0d615085331");
var isNumber = classChecks.isNumber, min = mathAliases.min;
Sugar.Function.defineInstanceWithArguments({
    "partial": function(fn, curriedArgs) {
        var curriedLen = curriedArgs.length;
        var partialFn = function partialFn1() {
            var argIndex = 0, applyArgs = [], self = this, lock = _lock(partialFn), result, i;
            for(i = 0; i < curriedLen; i++){
                var arg = curriedArgs[i];
                if (isDefined(arg)) applyArgs[i] = arg;
                else applyArgs[i] = arguments[argIndex++];
            }
            for(i = argIndex; i < arguments.length; i++)applyArgs.push(arguments[i]);
            if (lock === null) lock = curriedLen;
            if (isNumber(lock)) applyArgs.length = min(applyArgs.length, lock);
            // If the bound "this" object is an instance of the partialed
            // function, then "new" was used, so preserve the prototype
            // so that constructor functions can also be partialed.
            if (self instanceof partialFn) {
                self = createInstanceFromPrototype(fn.prototype);
                result = fn.apply(self, applyArgs);
                // An explicit return value is allowed from constructors
                // as long as they are of "object" type, so return the
                // correct result here accordingly.
                return isObjectType(result) ? result : self;
            }
            return fn.apply(self, applyArgs);
        };
        _partial(partialFn, true);
        return partialFn;
    }
});
module.exports = Sugar.Function.partial;

},{"16d8f8d03d4828e3":"eWYA2","4f6dce669d0a4469":"duWUR","2b18d1e11a15a9eb":"9lnxg","7fc8951d3ccb6b78":"6Ge6e","b3c64dcb6a357a87":"lUOLF","9072ef83e0378b30":"89tTN","23bcfd79f6a7503f":"l3TUh","f508e0d615085331":"aze6A"}],"aze6A":[function(require,module,exports) {
"use strict";
var createInstanceFromPrototype = Object.create || function(prototype) {
    var ctor = function ctor() {};
    ctor.prototype = prototype;
    return new ctor;
};
module.exports = createInstanceFromPrototype;

},{}],"9baTs":[function(require,module,exports) {
"use strict";
var Sugar = require("e0f0a3b11e153078"), createLazyFunction = require("20ce9e9c3e0b33a9");
Sugar.Function.defineInstance({
    "throttle": function(fn, ms) {
        return createLazyFunction(fn, ms, true, 1);
    }
});
module.exports = Sugar.Function.throttle;

},{"e0f0a3b11e153078":"eWYA2","20ce9e9c3e0b33a9":"cJUwT"}],"4ikmk":[function(require,module,exports) {
"use strict";
// Static Methods
require("18c49a3cc0120e46");
// Instance Methods
require("c37a851667fd0b7b");
require("b0f912764975615f");
require("d5fdad72e8b5d7ce");
require("b9f0831d0a175270");
module.exports = require("4ef3911f7ed565b4");

},{"18c49a3cc0120e46":"cCXRW","c37a851667fd0b7b":"CkOD2","b0f912764975615f":"cGY1h","d5fdad72e8b5d7ce":"gA3aY","b9f0831d0a175270":"fnFXk","4ef3911f7ed565b4":"eWYA2"}],"cCXRW":[function(require,module,exports) {
"use strict";
var Sugar = require("57e63d2af234a1b5"), escapeRegExp = require("7a044429a2a86f41");
Sugar.RegExp.defineStatic({
    "escape": function(str) {
        return escapeRegExp(str);
    }
});
module.exports = Sugar.RegExp.escape;

},{"57e63d2af234a1b5":"eWYA2","7a044429a2a86f41":"dWlXH"}],"CkOD2":[function(require,module,exports) {
"use strict";
var Sugar = require("fe6584a83d4d8efe"), getRegExpFlags = require("917f22ab2935ce49");
Sugar.RegExp.defineInstance({
    "addFlags": function(r, flags) {
        return RegExp(r.source, getRegExpFlags(r, flags));
    }
});
module.exports = Sugar.RegExp.addFlags;

},{"fe6584a83d4d8efe":"eWYA2","917f22ab2935ce49":"658bK"}],"cGY1h":[function(require,module,exports) {
"use strict";
var Sugar = require("fe598126580dc4c1"), getRegExpFlags = require("8f05237fec32c48b");
Sugar.RegExp.defineInstance({
    "getFlags": function(r) {
        return getRegExpFlags(r);
    }
});
module.exports = Sugar.RegExp.getFlags;

},{"fe598126580dc4c1":"eWYA2","8f05237fec32c48b":"658bK"}],"gA3aY":[function(require,module,exports) {
"use strict";
var Sugar = require("dc33c4b882f84e61"), allCharsReg = require("b0e17efd1443f33e"), getRegExpFlags = require("f673a3788a1161cc");
Sugar.RegExp.defineInstance({
    "removeFlags": function(r, flags) {
        var reg = allCharsReg(flags);
        return RegExp(r.source, getRegExpFlags(r).replace(reg, ""));
    }
});
module.exports = Sugar.RegExp.removeFlags;

},{"dc33c4b882f84e61":"eWYA2","b0e17efd1443f33e":"gTjdM","f673a3788a1161cc":"658bK"}],"fnFXk":[function(require,module,exports) {
"use strict";
var Sugar = require("d6163f7b41a047c");
Sugar.RegExp.defineInstance({
    "setFlags": function(r, flags) {
        return RegExp(r.source, flags);
    }
});
module.exports = Sugar.RegExp.setFlags;

},{"d6163f7b41a047c":"eWYA2"}],"1trlU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRange", ()=>DateRange);
var _cbformatting = require("../codebricks-runtime/CBFormatting");
var DateRange = /** @class */ function() {
    function DateRange() {}
    DateRange.valueToOutput = function(cfg, val) {
        var presets = cfg.presets;
        for(var p = 0; p < presets.length; p++)if (val == presets[p].label || val == p + "") {
            var outval = {
                start: presets[p].start,
                end: presets[p].end
            };
            // this.datepicker_from.selectDate(outval.start);
            // this.datepicker_to.selectDate(outval.end);
            // if(this.input) {
            //     this.input.value = presets[p].label;
            // }
            return outval;
        }
        if (val.indexOf(" - ") != -1) {
            var s = val.split(" - ");
            return {
                start: s[0],
                end: s[1]
            };
        }
        return {
            start: val,
            end: val
        };
    };
    DateRange.GetValues = function(cfg, system_options) {
        var ret = {};
        ret.displayformat = cfg.displayformat || system_options.date_format || "Date({short})";
        ret.outputformat = cfg.outputformat || ret.displayformat;
        ret.preset = cfg.value;
        var start = Sugar.Date.create(); //Sugar.Date.format(Sugar.Date.create(), ret.dateformat);
        var end = Sugar.Date.create(); //Sugar.Date.format(Sugar.Date.create(), ret.dateformat);
        if (cfg.value) {
            if (typeof cfg.value == "string" && cfg.value.indexOf(" - ") != -1) {
                var s = cfg.value.split(" - ");
                start = Sugar.Date.create(s[0]); //Sugar.Date.format(Sugar.Date.create(s[0]), ret.dateformat);
                end = Sugar.Date.create(s[1]); //Sugar.Date.format(Sugar.Date.create(s[1]), ret.dateformat);
                ret.preset = "";
            } else if (Array.isArray(cfg.value.value)) {
                if (cfg.value[0]) start = Sugar.Date.create(cfg.value[0]); //Sugar.Date.format(Sugar.Date.create(cfg.value[0]), ret.dateformat);
                if (cfg.value[1]) end = Sugar.Date.create(cfg.value[1]); //Sugar.Date.format(Sugar.Date.create(cfg.value[1]), ret.dateformat);
                ret.preset = "";
            } else if (typeof cfg.value.value == "object") {
                if (cfg.value.start) start = Sugar.Date.create(cfg.value.start); //Sugar.Date.format(Sugar.Date.create(cfg.value.start), ret.dateformat);
                if (cfg.value.end) end = Sugar.Date.create(cfg.value.end); //Sugar.Date.format(Sugar.Date.create(cfg.value.end), ret.dateformat);
                ret.preset = "";
            } else {
                if (cfg.presets) for(var _i = 0, _a = cfg.presets; _i < _a.length; _i++){
                    var preset = _a[_i];
                    if (preset.label == ret.preset) {
                        start = Sugar.Date.create(preset.start); //Sugar.Date.format(Sugar.Date.create(preset.start), ret.dateformat);
                        end = Sugar.Date.create(preset.end); //Sugar.Date.format(Sugar.Date.create(preset.end), ret.dateformat);
                        break;
                    }
                }
            }
        } else ret.preset = "";
        ret.display_value = (0, _cbformatting.codebricks_format)(start, ret.displayformat, system_options).value + " - " + (0, _cbformatting.codebricks_format)(end, ret.displayformat, system_options).value;
        ret.date1 = cfg.from == "" ? Sugar.Date.create() : Sugar.Date.create(start);
        ret.date2 = cfg.to == "" ? Sugar.Date.create() : Sugar.Date.create(end);
        return ret;
    };
    return DateRange;
}();

},{"../codebricks-runtime/CBFormatting":"TabN7","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"ddnmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cb_datetimepicker", ()=>cb_datetimepicker);
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
class cb_datetimepicker {
    init(value) {
        this.value_date = value ? (0, _sugarDefault.default).Date.create(value) : (0, _sugarDefault.default).Date.create();
        var container = document.getElementById(this.container_id);
        if (container) {
            var year = Number((0, _sugarDefault.default).Date.format(this.value_date, "{yyyy}"));
            var years = "";
            for(var y = this.end_year; y >= this.start_year; y--)years += `<option value="${y}" ${y == year ? "selected" : ""}>${y}</option>`;
            var selected_hour = (0, _sugarDefault.default).Date.format(this.value_date, "{HH}");
            var hours = "";
            for(var h = 0; h <= 23; h++){
                var hour = (0, _sugarDefault.default).String.padLeft(String(h), 2, "0");
                hours += `<option value="${hour}" ${hour == selected_hour ? "selected" : ""}>${hour}</option>`;
            }
            var selected_minute = (0, _sugarDefault.default).Date.format(this.value_date, "{mm}");
            var minutes = "";
            for(var m = 0; m <= 59; m++){
                var minute = (0, _sugarDefault.default).String.padLeft(String(m), 2, "0");
                minutes += `<option value="${minute}" ${minute == selected_minute ? "selected" : ""}>${minute}</option>`;
            }
            var month = Number((0, _sugarDefault.default).Date.format(this.value_date, "{M}"));
            var html = `<div class="cb_dtp">
                <div class="cb_dtp_yearmonth">
                    <button class="cb_dtp_btn cb_dtp_year_down" id="${this.container_id}$year_dn"><span></span></button>
                    <button class="cb_dtp_btn cb_dtp_month_down" id="${this.container_id}$month_dn"><span></span></button>
                    <select id="${this.container_id}$year">${years}</select>
                    <select id="${this.container_id}$month">
                        <option value="01" ${month == 1 ? "selected" : ""}>Jan</option>
                        <option value="02" ${month == 2 ? "selected" : ""}>Feb</option>
                        <option value="03" ${month == 3 ? "selected" : ""}>Mar</option>
                        <option value="04" ${month == 4 ? "selected" : ""}>Apr</option>
                        <option value="05" ${month == 5 ? "selected" : ""}>May</option>
                        <option value="06" ${month == 6 ? "selected" : ""}>Jun</option>
                        <option value="07" ${month == 7 ? "selected" : ""}>Jul</option>
                        <option value="08" ${month == 8 ? "selected" : ""}>Aug</option>
                        <option value="09" ${month == 9 ? "selected" : ""}>Sep</option>
                        <option value="10" ${month == 10 ? "selected" : ""}>Oct</option>
                        <option value="11" ${month == 11 ? "selected" : ""}>Nov</option>
                        <option value="12" ${month == 12 ? "selected" : ""}>Dec</option>
                    </select>
                    <button class="cb_dtp_btn cb_dtp_month_up" id="${this.container_id}$month_up"><span></span></button>
                    <button class="cb_dtp_btn cb_dtp_year_up" id="${this.container_id}$year_up"><span></span></button>
                </div>
                <div class="cb_dtp_days_container" id="${this.container_id}$days_container">
                    
                </div>
                <div class="cb_dtp_time_container${this.show_hour || this.show_minute ? "" : " hidden"}" id="${this.container_id}$time_container">
                    <div class="cbp_time_icon"></div><select id="${this.container_id}$hour" class="${this.show_hour ? "" : "hidden"}">${hours}</select>${this.show_hour && this.show_minute ? " : " : ""}<select id="${this.container_id}$minute" class="${this.show_minute ? "" : "hidden"}">${minutes}</select>
                </div>
            </div>`;
            container.innerHTML = html;
            this.refresh_date();
            var self = this;
            var year_select = document.getElementById(`${this.container_id}$year`);
            if (year_select) year_select.addEventListener("change", function(e) {
                self.year_selected(e.target.value);
            });
            var month_select = document.getElementById(`${this.container_id}$month`);
            if (month_select) month_select.addEventListener("change", function(e) {
                self.month_selected(e.target.value);
            });
            var year_dn = document.getElementById(`${this.container_id}$year_dn`);
            if (year_dn) year_dn.addEventListener("click", function() {
                var year = Number((0, _sugarDefault.default).Date.format(self.value_date, "{yyyy}"));
                year--;
                self.year_selected(year);
            });
            var year_up = document.getElementById(`${this.container_id}$year_up`);
            if (year_up) year_up.addEventListener("click", function() {
                var year = Number((0, _sugarDefault.default).Date.format(self.value_date, "{yyyy}"));
                year++;
                self.year_selected(year);
            });
            var month_dn = document.getElementById(`${this.container_id}$month_dn`);
            if (month_dn) month_dn.addEventListener("click", function() {
                var month = Number((0, _sugarDefault.default).Date.format(self.value_date, "{M}"));
                month--;
                self.month_selected(month);
            });
            var month_up = document.getElementById(`${this.container_id}$month_up`);
            if (month_up) month_up.addEventListener("click", function() {
                var month = Number((0, _sugarDefault.default).Date.format(self.value_date, "{M}"));
                month++;
                self.month_selected(month);
            });
            var hour_select = document.getElementById(`${this.container_id}$hour`);
            if (hour_select) hour_select.addEventListener("change", function(e) {
                (0, _sugarDefault.default).Date.set(self.value_date, {
                    hour: e.target.value
                });
                self.value_changed_callback(self.value_date);
            });
            var minute_select = document.getElementById(`${this.container_id}$minute`);
            if (minute_select) minute_select.addEventListener("change", function(e) {
                (0, _sugarDefault.default).Date.set(self.value_date, {
                    minute: e.target.value
                });
                self.value_changed_callback(self.value_date);
            });
        }
    }
    refresh_date() {
        var days = `<table class="cb_dtp_days">
        <tr>
            <th>Su</th>
            <th>Mo</th>
            <th>Tu</th>
            <th>We</th>
            <th>Th</th>
            <th>Fr</th>
            <th>Sa</th>
        </tr>`;
        var start_of_month = (0, _sugarDefault.default).Date.create((0, _sugarDefault.default).Date.format(this.value_date, "{yyyy}-{MM}") + "-01");
        var start_dow = (0, _sugarDefault.default).Date.getWeekday(start_of_month);
        var days_in_month = (0, _sugarDefault.default).Date.daysInMonth(start_of_month);
        var startcol = Number(start_dow);
        var rem = 0;
        var day_num = Number((0, _sugarDefault.default).Date.format(this.value_date, "{d}"));
        for(var i = 0; i < days_in_month + startcol; i++){
            if (i % 7 == 0) {
                if (i == 0) days += "<tr>";
                else days += "</tr><tr>";
            }
            if (i < startcol) days += "<td></td>";
            else {
                var date = i - start_dow + 1;
                var day_str = (0, _sugarDefault.default).Number.pad(date, 2);
                var sel = "";
                if (date == day_num) sel = " cb_dtp_day_selected";
                days += `<td><div class="cb_dtp_day${sel}" id="${this.container_id}$${date}">${day_str}</div></td>`;
            }
            rem = 7 - i % 7 - 1;
        }
        for(var i1 = 0; i1 < rem; i1++)days += "<td></td>";
        days += "</tr></table>";
        var days_container = document.getElementById(`${this.container_id}$days_container`);
        if (days_container) days_container.innerHTML = days;
        var self = this;
        for(var i2 = 0; i2 < days_in_month; i2++){
            var day_div = document.getElementById(`${this.container_id}$${i2 + 1}`);
            if (day_div) day_div.addEventListener("click", function(e) {
                var clicked_item_id = e.target.id;
                var s = clicked_item_id.split("$");
                var day = Number(s[s.length - 1]);
                self.day_selected(day);
            });
        }
        var year = (0, _sugarDefault.default).Date.format(this.value_date, "{yyyy}");
        var year_select = document.getElementById(`${this.container_id}$year`);
        if (year_select) year_select.value = year;
        var month = (0, _sugarDefault.default).Date.format(this.value_date, "{MM}");
        var month_select = document.getElementById(`${this.container_id}$month`);
        if (month_select) month_select.value = month;
        var selected_hour = (0, _sugarDefault.default).Date.format(this.value_date, "{HH}");
        var hour_select = document.getElementById(`${this.container_id}$hour`);
        if (hour_select) hour_select.value = selected_hour;
        var selected_minute = (0, _sugarDefault.default).Date.format(this.value_date, "{mm}");
        var minute_select = document.getElementById(`${this.container_id}$minute`);
        if (minute_select) minute_select.value = selected_minute;
        self.value_changed_callback(self.value_date);
    }
    set_value(value_date) {
        this.value_date = value_date;
        this.refresh_date();
    }
    year_selected(year) {
        (0, _sugarDefault.default).Date.set(this.value_date, {
            year: year
        });
        this.value_changed_callback(this.value_date);
        this.refresh_date();
    }
    month_selected(month) {
        (0, _sugarDefault.default).Date.set(this.value_date, {
            month: month - 1
        });
        this.value_changed_callback(this.value_date);
        this.refresh_date();
    }
    day_selected(day) {
        var prev_date = Number((0, _sugarDefault.default).Date.format(this.value_date, "{d}"));
        var prev = document.getElementById(`${this.container_id}$${prev_date}`);
        if (prev) prev.classList.remove("cb_dtp_day_selected");
        var new_day = document.getElementById(`${this.container_id}$${day}`);
        if (new_day) new_day.classList.add("cb_dtp_day_selected");
        (0, _sugarDefault.default).Date.set(this.value_date, {
            day: day
        });
        this.value_changed_callback(this.value_date);
    }
    hour_selected(hour) {
        (0, _sugarDefault.default).Date.set(this.value_date, {
            hour: hour
        });
        this.value_changed_callback(this.value_date);
        this.refresh_date();
    }
    minute_selected(minute) {
        (0, _sugarDefault.default).Date.set(this.value_date, {
            minute: minute
        });
        this.value_changed_callback(this.value_date);
        this.refresh_date();
    }
    setShowHour(show_hour) {
        this.show_hour = show_hour;
        var time_container = document.getElementById(`${this.container_id}$time_container`);
        if (time_container) time_container.classList.toggle("hidden", !(this.show_hour || this.show_minute));
        var hour_select = document.getElementById(`${this.container_id}$hour`);
        if (hour_select) hour_select.classList.toggle("hidden", !this.show_hour);
    }
    setShowMinute(show_minute) {
        this.show_minute = show_minute;
        var time_container = document.getElementById(`${this.container_id}$time_container`);
        if (time_container) time_container.classList.toggle("hidden", !(this.show_hour || this.show_minute));
        var minute_select = document.getElementById(`${this.container_id}$minute`);
        if (minute_select) minute_select.classList.toggle("hidden", !this.show_minute);
    }
    constructor(container_id, show_year, show_month, show_day, show_hour, show_minute, start_year, end_year, value_changed_callback){
        this.container_id = container_id;
        this.value_changed_callback = value_changed_callback;
        this.show_year = show_year;
        this.show_month = show_month;
        this.show_day = show_day;
        this.show_hour = show_hour;
        this.show_minute = show_minute;
        this.start_year = start_year;
        this.end_year = end_year;
    }
}

},{"sugar":"gcIJ7","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"rIvyj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_datetime_webcomponent", ()=>c_datetime_webcomponent);
parcelHelpers.export(exports, "web_c_datetime", ()=>web_c_datetime);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbformatting = require("../../codebricks-runtime/CBFormatting");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbDatetimepicker = require("../controls/cb_datetimepicker");
var _cbPopout = require("../controls/cb_popout");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
class c_datetime_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_datetime(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-datetime", c_datetime_webcomponent);
class web_c_datetime extends (0, _codeBrick.CodeBrick) {
    running_clock() {
        var _a, _b, _c, _d, _e;
        if (!this.cfg.value && this.cfg.running_clock) {
            (_a = this.datetimepicker) === null || _a === void 0 || _a.set_value((0, _sugarDefault.default).Date.create());
            (_b = this.datetimepicker) === null || _b === void 0 || _b.value_changed_callback((_c = this.datetimepicker) === null || _c === void 0 ? void 0 : _c.value_date);
            var emit_val = (0, _cbformatting.codebricks_format)((_d = this.datetimepicker) === null || _d === void 0 ? void 0 : _d.value_date, this.cfg.outputformat || this.cfg.displayformat || "Date({short})", ((_e = this.context.composition_runners[this.cid].compos) === null || _e === void 0 ? void 0 : _e.system_options) || {}).value;
            this.cb_emit({
                "@": emit_val
            });
            var self = this;
            setTimeout(function() {
                self.running_clock();
            }, 60000);
        }
    }
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _a, _b, self, current_year, preset_value, preset_name, presets_html, p, presets_element, self1, p1, preset_button, presets_element1, value_str;
            return (0, _tsGenerator._)(this, function(_state) {
                _this.cfg = cfg;
                self = _this;
                current_year = Number((0, _sugarDefault.default).Date.format((0, _sugarDefault.default).Date.create(), "{yyyy}"));
                if (!_this.datetimepicker) _this.datetimepicker = new (0, _cbDatetimepicker.cb_datetimepicker)(_this.brick_id + "$picker", !cfg.hide_year, !cfg.hide_month, !cfg.hide_day, cfg.show_hour, cfg.show_minute, current_year - 120, current_year + 50, function(value_date) {
                    var _a;
                    var value_str = (0, _cbformatting.codebricks_format)(value_date, self.cfg.outputformat || self.cfg.displayformat || "Date({short})", ((_a = self.context.composition_runners[self.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value;
                    self.displayvalue = value_str;
                    self.popout.setDisplayValue(value_str);
                });
                preset_value = "";
                preset_name = "";
                if (_this.cfg.presets && _this.cfg.presets.length > 0) {
                    presets_html = `<div class="c-datetime-presets-heading">Presets</div>`;
                    if (cfg.presets) for(p = 0; p < cfg.presets.length; p++)presets_html += `<button class="c-datetime-preset" id="${_this.brick_id}$preset${p}">${cfg.presets[p].label}</button>`;
                    presets_element = document.getElementById(_this.brick_id + "$presets");
                    if (presets_element) presets_element.innerHTML = presets_html;
                    if (cfg.presets) {
                        self1 = _this;
                        for(p1 = 0; p1 < cfg.presets.length; p1++){
                            preset_button = document.getElementById(_this.brick_id + "$preset" + p1);
                            if (!cfg.value && !preset_name || cfg.value == cfg.presets[p1].label) {
                                preset_name = cfg.presets[p1].label;
                                preset_value = (0, _cbformatting.codebricks_format)(cfg.presets[p1].datetime, self1.cfg.outputformat || self1.cfg.displayformat || "Date({short})", ((_a = self1.context.composition_runners[self1.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}).value;
                            }
                            if (preset_button) preset_button.addEventListener("click", function(e) {
                                var p = Number(e.target.id.split("$preset")[1]);
                                var preset = self1.cfg.presets[p];
                                var date = (0, _sugarDefault.default).Date.create(preset.datetime, self1.cfg.dateformat);
                                if (self1.datetimepicker) self1.datetimepicker.set_value(date);
                                self1.displayvalue = preset.label;
                                self1.popout.setDisplayValue(preset.label);
                                self1.snapshot = self1.snapshot || {};
                                self1.snapshot.cfg = self1.snapshot.cfg || {};
                                self1.snapshot.cfg.value = preset.label;
                            });
                        }
                    }
                } else {
                    presets_element1 = document.getElementById(_this.brick_id + "$presets");
                    if (presets_element1) presets_element1.innerHTML = "";
                }
                _this.datetimepicker.init(_this.cfg.value);
                value_str = preset_value || (0, _cbformatting.codebricks_format)(_this.datetimepicker.value_date, self.cfg.outputformat || self.cfg.displayformat || "Date({short})", ((_b = self.context.composition_runners[self.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value;
                _this.popout.setLabel(cfg.label);
                _this.datetimepicker.setShowHour(cfg.show_hour);
                _this.datetimepicker.setShowMinute(cfg.show_minute);
                if (_this.context.platform == "file") preset_name = value_str;
                _this.popout.setDisplayValue(preset_name || value_str);
                if (!self.cfg.value && self.cfg.running_clock) setTimeout(function() {
                    self.running_clock();
                }, 60000);
                return [
                    2,
                    {
                        "@": value_str
                    }
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "required") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) input.classList.add("required");
        } else if (status == "") {
            var input1 = document.getElementById(`${this.brick_id}`);
            if (input1) input1.classList.remove("required");
        }
    }
    cb_snapshot() {
        return this.snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.dateformat = "Date({short})";
        this.displayvalue = "";
        this.cfg = {};
        this.snapshot = undefined;
        this.element = element;
        var self = this;
        this.element.innerHTML = `<div id="${this.brick_id}" class='form-element-container c-datetime-container'></div>`;
        this.popout = new (0, _cbPopout.cb_popout)(this.brick_id, true, this.blueprint.ins.cfg, "c-datepicker", false, false, function() {}, function() {
            var _a, _b;
            var emit_val = (0, _cbformatting.codebricks_format)((_a = self.datetimepicker) === null || _a === void 0 ? void 0 : _a.value_date, self.cfg.outputformat || self.cfg.displayformat || "Date({short})", ((_b = self.context.composition_runners[self.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {}).value;
            self.snapshot = self.snapshot || {};
            self.snapshot.cfg = self.snapshot.cfg || {};
            self.snapshot.cfg.value = emit_val;
            self.cfg.value = emit_val;
            self.cb_emit({
                "@": emit_val
            });
        });
        var drop = document.getElementById(this.brick_id + "$drop");
        if (drop) drop.innerHTML = `<div class="c-datetime-drop"><div id="${this.brick_id}$picker"></div><div class="c-datetime-presets-container" id="${this.brick_id}$presets"></div></div>`;
        this.popout.init();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBFormatting":"TabN7","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_datetimepicker":"ddnmR","../controls/cb_popout":"8UNLF","sugar":"gcIJ7","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"bbDMD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_editor_code_webcomponent", ()=>c_editor_code_webcomponent);
parcelHelpers.export(exports, "web_c_editor_code", ()=>web_c_editor_code);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _codemirror = require("codemirror");
var _view = require("@codemirror/view");
var _commands = require("@codemirror/commands");
var _langJavascript = require("@codemirror/lang-javascript");
var _langCss = require("@codemirror/lang-css");
var _langHtml = require("@codemirror/lang-html");
var _langYaml = require("@codemirror/lang-yaml");
var _language = require("@codemirror/language");
var _cbtemplateParser = require("../template_lang/cbtemplate-parser");
var _common = require("@lezer/common");
class c_editor_code_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var ins = this.getAttribute("ins");
            this.ci = new web_c_editor_code(context, cid, name, dc, Number(idx), container_id, this, ins);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-editor-code", c_editor_code_webcomponent);
class web_c_editor_code extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var self, element, container, div, extensions, mixedCBTemplateParser, cbtemplateLanguage, cbtemplateAutocompletion, selection, was_val, val;
            return (0, _tsGenerator._)(this, function(_state) {
                self = _this;
                if (input == "cfg") {
                    _this.cfg = cfg;
                    element = document.getElementById(_this.brick_id);
                    if (element && cfg.height) {
                        container = element.parentElement;
                        if (container) container.style.height = cfg.height;
                    }
                } else if (input == "value") {
                    div = document.getElementById(_this.brick_id);
                    if (div) {
                        if (!_this.editor) {
                            extensions = [
                                (0, _codemirror.basicSetup),
                                (0, _view.keymap).of([
                                    (0, _commands.indentWithTab)
                                ]),
                                (0, _codemirror.EditorView).lineWrapping,
                                (0, _codemirror.EditorView).updateListener.of((v)=>{
                                    if (v.docChanged) self.cb_emit({
                                        "@": v.state.doc.toString()
                                    });
                                })
                            ];
                            if (_this.cfg.language == "javascript") {
                                extensions.push((0, _langJavascript.javascript)());
                                extensions.push((0, _language.indentUnit).of("    "));
                                extensions.push((0, _langJavascript.javascriptLanguage).data.of({
                                    autocomplete: (0, _langJavascript.scopeCompletionSource)(globalThis)
                                }));
                            } else if (_this.cfg.language == "css") {
                                extensions.push((0, _langCss.css)());
                                extensions.push((0, _language.indentUnit).of("    "));
                                extensions.push((0, _langCss.cssLanguage).data.of({
                                    autocomplete: (0, _langCss.cssCompletionSource)
                                }));
                            } else if (_this.cfg.language == "html") {
                                mixedCBTemplateParser = (0, _cbtemplateParser.parser).configure({
                                    props: [],
                                    wrap: (0, _common.parseMixed)((node)=>{
                                        return node.type.isTop ? {
                                            parser: (0, _langHtml.htmlLanguage).parser,
                                            overlay: (node)=>node.type.name == "Text"
                                        } : null;
                                    })
                                });
                                cbtemplateLanguage = (0, _language.LRLanguage).define({
                                    parser: mixedCBTemplateParser
                                });
                                extensions.push(cbtemplateLanguage);
                                cbtemplateAutocompletion = cbtemplateLanguage.data.of({
                                    autocomplete: function cbTemplateCompletionSource(context) {
                                        var state = context.state, pos = context.pos;
                                        var tree = (0, _language.syntaxTree)(state).resolveInner(pos, -1);
                                        var lang = cbtemplateLanguage;
                                        var word = context.matchBefore(/{{.*/);
                                        console.log(word.text);
                                        return {
                                            from: word.from,
                                            options: [
                                                {
                                                    label: word.text,
                                                    displayLabel: "CB Template...",
                                                    type: "keyword"
                                                }
                                            ]
                                        };
                                    }
                                });
                                extensions.push(cbtemplateAutocompletion);
                                extensions.push((0, _langHtml.html)().support);
                            } else if (_this.cfg.language == "yaml") {
                                extensions.push((0, _langYaml.yaml)());
                                extensions.push((0, _language.indentUnit).of("  "));
                            }
                            _this.editor = new (0, _codemirror.EditorView)({
                                doc: cfg,
                                extensions: extensions,
                                parent: div
                            });
                        } else {
                            selection = _this.editor.state.selection.main;
                            was_val = _this.getValue();
                            _this.editor.dispatch({
                                changes: {
                                    from: 0,
                                    to: _this.editor.state.doc.length,
                                    insert: cfg
                                }
                            });
                            if (cfg == was_val) {
                                _this.editor.focus();
                                _this.editor.dispatch(_this.editor.state.update({
                                    selection: selection,
                                    scrollIntoView: true
                                }));
                            }
                        }
                    }
                } else if (input == "append") _this.editor.dispatch({
                    changes: {
                        from: _this.editor.state.doc.length,
                        to: _this.editor.state.doc.length,
                        insert: cfg
                    }
                });
                else if (input == "token_list") _this.token_list = cfg;
                if (_this.editor) {
                    val = _this.getValue();
                    return [
                        2,
                        {
                            "@": val
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    getValue() {
        return this.editor.state.doc.toString();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id);
        if (container) {
            var outer = container.parentElement;
            if (outer) {
                if (status == "loading") {
                    container.classList.add("hidden");
                    outer.classList.add("loading");
                } else {
                    outer.classList.remove("loading");
                    container.classList.remove("hidden");
                }
            }
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element, standalone_ins){
        super(context, cid, name, dc, idx, container_id, standalone_ins);
        this.token_list = null;
        this.element = element;
        if (cid == undefined) {
            this.blueprint.name = element.id;
            this.brick_id = element.id + "_brick";
            window.so_bricks = window.so_bricks || {};
            window.so_bricks[this.brick_id] = this;
        }
        var html = `<div class='c-editor-code-container'><div id="${this.brick_id}" class="c-editor-code"></div></div>`;
        element.innerHTML = html;
        var self = this;
        if (cid == undefined) setTimeout(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
            var _tmp, _tmp1, _i, input, ret;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!self.blueprint.ins) return [
                            3,
                            4
                        ];
                        _tmp = [];
                        for(_tmp1 in self.blueprint.ins)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            4
                        ];
                        input = _tmp[_i];
                        return [
                            4,
                            self.cb_event(input, self.blueprint.ins[input], {})
                        ];
                    case 2:
                        ret = _state.sent();
                        _state.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }), 0);
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","codemirror":"dEQfk","@codemirror/view":"l3day","@codemirror/commands":"8GWsb","@codemirror/lang-javascript":"0dLBb","@codemirror/lang-css":"25igp","@codemirror/lang-html":"5bkjX","@codemirror/lang-yaml":"j44hx","@codemirror/language":"jct2S","../template_lang/cbtemplate-parser":"c7JSA","@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"dEQfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorView", ()=>(0, _view.EditorView));
parcelHelpers.export(exports, "basicSetup", ()=>basicSetup);
parcelHelpers.export(exports, "minimalSetup", ()=>minimalSetup);
var _view = require("@codemirror/view");
var _state = require("@codemirror/state");
var _language = require("@codemirror/language");
var _commands = require("@codemirror/commands");
var _search = require("@codemirror/search");
var _autocomplete = require("@codemirror/autocomplete");
var _lint = require("@codemirror/lint");
// (The superfluous function calls around the list of extensions work
// around current limitations in tree-shaking software.)
/**
This is an extension value that just pulls together a number of
extensions that you might want in a basic editor. It is meant as a
convenient helper to quickly set up CodeMirror without installing
and importing a lot of separate packages.

Specifically, it includes...

 - [the default command bindings](https://codemirror.net/6/docs/ref/#commands.defaultKeymap)
 - [line numbers](https://codemirror.net/6/docs/ref/#view.lineNumbers)
 - [special character highlighting](https://codemirror.net/6/docs/ref/#view.highlightSpecialChars)
 - [the undo history](https://codemirror.net/6/docs/ref/#commands.history)
 - [a fold gutter](https://codemirror.net/6/docs/ref/#language.foldGutter)
 - [custom selection drawing](https://codemirror.net/6/docs/ref/#view.drawSelection)
 - [drop cursor](https://codemirror.net/6/docs/ref/#view.dropCursor)
 - [multiple selections](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
 - [reindentation on input](https://codemirror.net/6/docs/ref/#language.indentOnInput)
 - [the default highlight style](https://codemirror.net/6/docs/ref/#language.defaultHighlightStyle) (as fallback)
 - [bracket matching](https://codemirror.net/6/docs/ref/#language.bracketMatching)
 - [bracket closing](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets)
 - [autocompletion](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion)
 - [rectangular selection](https://codemirror.net/6/docs/ref/#view.rectangularSelection) and [crosshair cursor](https://codemirror.net/6/docs/ref/#view.crosshairCursor)
 - [active line highlighting](https://codemirror.net/6/docs/ref/#view.highlightActiveLine)
 - [active line gutter highlighting](https://codemirror.net/6/docs/ref/#view.highlightActiveLineGutter)
 - [selection match highlighting](https://codemirror.net/6/docs/ref/#search.highlightSelectionMatches)
 - [search](https://codemirror.net/6/docs/ref/#search.searchKeymap)
 - [linting](https://codemirror.net/6/docs/ref/#lint.lintKeymap)

(You'll probably want to add some language package to your setup
too.)

This extension does not allow customization. The idea is that,
once you decide you want to configure your editor more precisely,
you take this package's source (which is just a bunch of imports
and an array literal), copy it into your own code, and adjust it
as desired.
*/ var basicSetup = /*@__PURE__*/ (()=>[
        (0, _view.lineNumbers)(),
        (0, _view.highlightActiveLineGutter)(),
        (0, _view.highlightSpecialChars)(),
        (0, _commands.history)(),
        (0, _language.foldGutter)(),
        (0, _view.drawSelection)(),
        (0, _view.dropCursor)(),
        (0, _state.EditorState).allowMultipleSelections.of(true),
        (0, _language.indentOnInput)(),
        (0, _language.syntaxHighlighting)((0, _language.defaultHighlightStyle), {
            fallback: true
        }),
        (0, _language.bracketMatching)(),
        (0, _autocomplete.closeBrackets)(),
        (0, _autocomplete.autocompletion)(),
        (0, _view.rectangularSelection)(),
        (0, _view.crosshairCursor)(),
        (0, _view.highlightActiveLine)(),
        (0, _search.highlightSelectionMatches)(),
        (0, _view.keymap).of([
            ...(0, _autocomplete.closeBracketsKeymap),
            ...(0, _commands.defaultKeymap),
            ...(0, _search.searchKeymap),
            ...(0, _commands.historyKeymap),
            ...(0, _language.foldKeymap),
            ...(0, _autocomplete.completionKeymap),
            ...(0, _lint.lintKeymap)
        ])
    ])();
/**
A minimal set of extensions to create a functional editor. Only
includes [the default keymap](https://codemirror.net/6/docs/ref/#commands.defaultKeymap), [undo
history](https://codemirror.net/6/docs/ref/#commands.history), [special character
highlighting](https://codemirror.net/6/docs/ref/#view.highlightSpecialChars), [custom selection
drawing](https://codemirror.net/6/docs/ref/#view.drawSelection), and [default highlight
style](https://codemirror.net/6/docs/ref/#language.defaultHighlightStyle).
*/ var minimalSetup = /*@__PURE__*/ (()=>[
        (0, _view.highlightSpecialChars)(),
        (0, _commands.history)(),
        (0, _view.drawSelection)(),
        (0, _language.syntaxHighlighting)((0, _language.defaultHighlightStyle), {
            fallback: true
        }),
        (0, _view.keymap).of([
            ...(0, _commands.defaultKeymap),
            ...(0, _commands.historyKeymap)
        ])
    ])();

},{"@codemirror/view":"l3day","@codemirror/state":"fECfb","@codemirror/language":"jct2S","@codemirror/commands":"8GWsb","@codemirror/search":"lND0o","@codemirror/autocomplete":"2rxgM","@codemirror/lint":"8JYEE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"l3day":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BidiSpan", ()=>BidiSpan);
parcelHelpers.export(exports, "BlockInfo", ()=>BlockInfo);
parcelHelpers.export(exports, "BlockType", ()=>BlockType);
parcelHelpers.export(exports, "Decoration", ()=>Decoration);
parcelHelpers.export(exports, "Direction", ()=>Direction);
parcelHelpers.export(exports, "EditorView", ()=>EditorView);
parcelHelpers.export(exports, "GutterMarker", ()=>GutterMarker);
parcelHelpers.export(exports, "MatchDecorator", ()=>MatchDecorator);
parcelHelpers.export(exports, "RectangleMarker", ()=>RectangleMarker);
parcelHelpers.export(exports, "ViewPlugin", ()=>ViewPlugin);
parcelHelpers.export(exports, "ViewUpdate", ()=>ViewUpdate);
parcelHelpers.export(exports, "WidgetType", ()=>WidgetType);
parcelHelpers.export(exports, "__test", ()=>__test);
parcelHelpers.export(exports, "closeHoverTooltips", ()=>closeHoverTooltips);
parcelHelpers.export(exports, "crosshairCursor", ()=>crosshairCursor);
parcelHelpers.export(exports, "drawSelection", ()=>drawSelection);
parcelHelpers.export(exports, "dropCursor", ()=>dropCursor);
parcelHelpers.export(exports, "getDrawSelectionConfig", ()=>getDrawSelectionConfig);
parcelHelpers.export(exports, "getPanel", ()=>getPanel);
parcelHelpers.export(exports, "getTooltip", ()=>getTooltip);
parcelHelpers.export(exports, "gutter", ()=>gutter);
parcelHelpers.export(exports, "gutterLineClass", ()=>gutterLineClass);
parcelHelpers.export(exports, "gutters", ()=>gutters);
parcelHelpers.export(exports, "hasHoverTooltips", ()=>hasHoverTooltips);
parcelHelpers.export(exports, "highlightActiveLine", ()=>highlightActiveLine);
parcelHelpers.export(exports, "highlightActiveLineGutter", ()=>highlightActiveLineGutter);
parcelHelpers.export(exports, "highlightSpecialChars", ()=>highlightSpecialChars);
parcelHelpers.export(exports, "highlightTrailingWhitespace", ()=>highlightTrailingWhitespace);
parcelHelpers.export(exports, "highlightWhitespace", ()=>highlightWhitespace);
parcelHelpers.export(exports, "hoverTooltip", ()=>hoverTooltip);
parcelHelpers.export(exports, "keymap", ()=>keymap);
parcelHelpers.export(exports, "layer", ()=>layer);
parcelHelpers.export(exports, "lineNumberMarkers", ()=>lineNumberMarkers);
parcelHelpers.export(exports, "lineNumbers", ()=>lineNumbers);
parcelHelpers.export(exports, "logException", ()=>logException);
parcelHelpers.export(exports, "panels", ()=>panels);
parcelHelpers.export(exports, "placeholder", ()=>placeholder);
parcelHelpers.export(exports, "rectangularSelection", ()=>rectangularSelection);
parcelHelpers.export(exports, "repositionTooltips", ()=>repositionTooltips);
parcelHelpers.export(exports, "runScopeHandlers", ()=>runScopeHandlers);
parcelHelpers.export(exports, "scrollPastEnd", ()=>scrollPastEnd);
parcelHelpers.export(exports, "showPanel", ()=>showPanel);
parcelHelpers.export(exports, "showTooltip", ()=>showTooltip);
parcelHelpers.export(exports, "tooltips", ()=>tooltips);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _state = require("@codemirror/state");
var _styleMod = require("style-mod");
var _w3CKeyname = require("w3c-keyname");
function getSelection(root) {
    var target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function deepActiveElement(doc) {
    var elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function clientRectsFor(dom) {
    if (dom.nodeType == 3) return textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? scanFor(node, off, targetNode, targetOff, -1) || scanFor(node, off, targetNode, targetOff, 1) : false;
}
function domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            var parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? maxOffset(node) : 0;
        } else return false;
    }
}
function maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function flattenRect(rect, left) {
    var x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function windowRect(win) {
    var vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function getScale(elt, rect) {
    var scaleX = rect.width / elt.offsetWidth;
    var scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX,
        scaleY
    };
}
function scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    var doc = dom.ownerDocument, win = doc.defaultView || window;
    for(var cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            var bounding = void 0, top = cur == doc.body;
            var scaleX = 1, scaleY = 1;
            if (top) bounding = windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                var _$rect = cur.getBoundingClientRect();
                var ref;
                ref = getScale(cur, _$rect), scaleX = ref.scaleX, scaleY = ref.scaleY, ref;
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: _$rect.left,
                    right: _$rect.left + cur.clientWidth * scaleX,
                    top: _$rect.top,
                    bottom: _$rect.top + cur.clientHeight * scaleY
                };
            }
            var moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = -(bounding.top - rect.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + moveY + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = -(bounding.top + moveY - rect.top + yMargin);
                }
            } else {
                var rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                var targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = -(bounding.left - rect.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + moveX + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = -(bounding.left + moveX - rect.left + xMargin);
                }
            } else {
                var targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    var movedX = 0, movedY = 0;
                    if (moveY) {
                        var start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        var start1 = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start1) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function scrollableParent(dom) {
    var doc = dom.ownerDocument;
    for(var cur = dom.parentNode; cur;){
        if (cur == doc.body) break;
        else if (cur.nodeType == 1) {
            if (cur.scrollHeight > cur.clientHeight || cur.scrollWidth > cur.clientWidth) return cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return null;
}
class DOMSelectionState {
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        var anchorNode = range.anchorNode, focusNode = range.focusNode;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
}
var preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if (preventScrollSupported) return dom.focus(preventScrollSupported);
    var stack = [];
    for(var cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus(preventScrollSupported == null ? {
        get preventScroll () {
            preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!preventScrollSupported) {
        preventScrollSupported = false;
        for(var i = 0; i < stack.length;){
            var elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
var scratchRange;
function textRange(node, from) {
    var to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : from;
    var range = scratchRange || (scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function dispatchKey(elt, name, code, mods) {
    var options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    var ref;
    if (mods) ref = mods, options.altKey = ref.altKey, options.ctrlKey = ref.ctrlKey, options.shiftKey = ref.shiftKey, options.metaKey = ref.metaKey, ref;
    var down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    var up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
function atElementStart(doc, selection) {
    var node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            var prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = domIndex(node);
            node = node.parentNode;
        }
    }
}
function isScrolledToBottom(elt) {
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
class DOMPos {
    static before(dom, precise) {
        return new DOMPos(dom.parentNode, domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new DOMPos(dom.parentNode, domIndex(dom) + 1, precise);
    }
    constructor(node, offset, ref){
        var precise = ref === void 0 ? true : ref;
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
}
var noChildren = [];
class ContentView {
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        var pos = this.posAtStart;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (child == view) return pos;
                pos += child.length + child.breakAfter;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    sync(view, track) {
        if (this.flags & 2 /* ViewFlag.NodeDirty */ ) {
            var parent = this.dom;
            var prev = null, next;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                        if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                            var contentView = ContentView.get(next);
                            if (!contentView || !contentView.parent && contentView.canReuseDOM(child)) child.reuseDOM(next);
                        }
                        child.sync(view, track);
                        child.flags &= -8 /* ViewFlag.Dirty */ ;
                    }
                    next = prev ? prev.nextSibling : parent.firstChild;
                    if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                    if (child.dom.parentNode == parent) while(next && next != child.dom)next = rm$1(next);
                    else parent.insertBefore(child.dom, next);
                    prev = child.dom;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = rm$1(next);
        } else if (this.flags & 1 /* ViewFlag.ChildDirty */ ) {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = this.children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var child1 = _step1.value;
                    if (child1.flags & 7 /* ViewFlag.Dirty */ ) {
                        child1.sync(view, track);
                        child1.flags &= -8 /* ViewFlag.Dirty */ ;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        var after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            var bias = maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                var parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(var i = 0, pos = 0;; i++){
            var child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to) {
        var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(var i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            var child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty() {
        var andParent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        this.flags |= 2 /* ViewFlag.NodeDirty */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(var parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.flags |= 2 /* ViewFlag.NodeDirty */ ;
            if (parent.flags & 1 /* ViewFlag.ChildDirty */ ) return;
            parent.flags |= 1 /* ViewFlag.ChildDirty */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.flags & 7 /* ViewFlag.Dirty */ ) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom == dom) return;
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(var v = this;;){
            var parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to) {
        var children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : noChildren;
        this.markDirty();
        for(var i = from; i < to; i++){
            var child = this.children[i];
            if (child.parent == this && children.indexOf(child) < 0) child.destroy();
        }
        this.children.splice(from, to - from, ...children);
        for(var i1 = 0; i1 < children.length; i1++)children[i1].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor() {
        var pos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.length;
        return new ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        var name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    get isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    canReuseDOM(other) {
        return other.constructor == this.constructor && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (child.parent == this) child.destroy();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.parent = null;
    }
    constructor(){
        this.parent = null;
        this.dom = null;
        this.flags = 2 /* ViewFlag.NodeDirty */ ;
    }
}
ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function rm$1(dom) {
    var next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class ChildCursor {
    findPos(pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            var next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
}
function replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    var children = parent.children;
    var before = children.length ? children[fromI] : null;
    var last = insert.length ? insert[insert.length - 1] : null;
    var breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        var after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && (toOff < after.length || after.breakAfter && (last === null || last === void 0 ? void 0 : last.breakAfter))) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff || after.children.length && !after.children[0].length) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    var cur = parent.childCursor();
    var _cur_findPos = cur.findPos(to, 1), toI = _cur_findPos.i, toOff = _cur_findPos.off;
    var _cur_findPos1 = cur.findPos(from, -1), fromI = _cur_findPos1.i, fromOff = _cur_findPos1.off;
    var dLen = from - to;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = insert[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var view = _step.value;
            dLen += view.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    parent.length += dLen;
    replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
var nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
var doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
var ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec(nav.userAgent);
var ie_upto10 = /*@__PURE__*/ /MSIE \d/.test(nav.userAgent);
var ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(nav.userAgent);
var ie = !!(ie_upto10 || ie_11up || ie_edge);
var gecko = !ie && /*@__PURE__*/ /gecko\/(\d+)/i.test(nav.userAgent);
var chrome = !ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec(nav.userAgent);
var webkit = "webkitFontSmoothing" in doc.documentElement.style;
var safari = !ie && /*@__PURE__*/ /Apple Computer/.test(nav.vendor);
var ios = safari && /*@__PURE__*/ (/Mobile\/\w+/.test(nav.userAgent) || nav.maxTouchPoints > 2);
var browser = {
    mac: ios || /*@__PURE__*/ /Mac/.test(nav.platform),
    windows: /*@__PURE__*/ /Win/.test(nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test(nav.platform),
    ie,
    ie_version: ie_upto10 ? doc.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0,
    gecko,
    gecko_version: gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec(nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!chrome,
    chrome_version: chrome ? +chrome[1] : 0,
    ios,
    android: /*@__PURE__*/ /Android\b/.test(nav.userAgent),
    webkit,
    safari,
    webkit_version: webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
var MaxJoinLen = 256;
class TextView extends ContentView {
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(view, track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (this.flags & 8 /* ViewFlag.Composition */  || source && (!(source instanceof TextView) || this.length - (to - from) + source.length > MaxJoinLen || source.flags & 8 /* ViewFlag.Composition */ )) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        var result = new TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        result.flags |= this.flags & 8 /* ViewFlag.Composition */ ;
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return textCoords(this.dom, pos, side);
    }
    constructor(text){
        super();
        this.text = text;
    }
}
class MarkView extends ContentView {
    setAttrs(dom) {
        clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(var name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    canReuseDOM(other) {
        return super.canReuseDOM(other) && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) this.setAttrs(this.dom);
        super.sync(view, track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        var result = [], off = 0, detachFrom = -1, i = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elt = _step.value;
                var end = off + elt.length;
                if (end > from) result.push(off < from ? elt.split(from - off) : elt);
                if (detachFrom < 0 && off >= from) detachFrom = i;
                off = end;
                i++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return inlineDOMAtPos(this, pos);
    }
    coordsAt(pos, side) {
        return coordsInChildren(this, pos, side);
    }
    constructor(mark, ref, ref1){
        var children = ref === void 0 ? [] : ref, length = ref1 === void 0 ? 0 : ref1;
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ch = _step.value;
                ch.setParent(this);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
function textCoords(text, pos, side) {
    var length = text.nodeValue.length;
    if (pos > length) pos = length;
    var from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!(browser.chrome || browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    var rects = textRange(text, from, to).getClientRects();
    if (!rects.length) return null;
    var rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if (browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class WidgetView extends ContentView {
    static create(widget, length, side) {
        return new WidgetView(widget, length, side);
    }
    split(from) {
        var result = WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other instanceof WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
            if (!this.widget.compare(other.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, _state.Text).empty;
        var top = this;
        while(top.parent)top = top.parent;
        var view = top.view, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, _state.Text).empty;
    }
    domAtPos(pos) {
        return (this.length ? pos == 0 : this.side > 0) ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        var custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        var rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return null;
        var fromBack = this.side ? this.side < 0 : pos > 0;
        for(var i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return flattenRect(rect, !fromBack);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class WidgetBufferView extends ContentView {
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof WidgetBufferView && other.side == this.side;
    }
    split() {
        return new WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            var dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return this.side > 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
        return (0, _state.Text).empty;
    }
    get isHidden() {
        return true;
    }
    constructor(side){
        super();
        this.side = side;
    }
}
TextView.prototype.children = WidgetView.prototype.children = WidgetBufferView.prototype.children = noChildren;
function inlineDOMAtPos(parent, pos) {
    var dom = parent.dom, children = parent.children, i = 0;
    for(var off = 0; i < children.length; i++){
        var child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(var j = i; j > 0; j--){
        var prev = children[j - 1];
        if (prev.dom.parentNode == dom) return prev.domAtPos(prev.length);
    }
    for(var j1 = i; j1 < children.length; j1++){
        var next = children[j1];
        if (next.dom.parentNode == dom) return next.domAtPos(0);
    }
    return new DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function joinInlineInto(parent, view, open) {
    var last, children = parent.children;
    if (open > 0 && view instanceof MarkView && children.length && (last = children[children.length - 1]) instanceof MarkView && last.mark.eq(view.mark)) joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function coordsInChildren(view, pos, side) {
    var before = null, beforePos = -1, after = null, afterPos = -1;
    function scan(view, pos) {
        for(var i = 0, off = 0; i < view.children.length && off <= pos; i++){
            var child = view.children[i], end = off + child.length;
            if (end >= pos) {
                if (child.children.length) scan(child, pos - off);
                else if ((!after || after.isHidden && side > 0) && (end > pos || off == end && child.getSide() > 0)) {
                    after = child;
                    afterPos = pos - off;
                } else if (off < pos || off == end && child.getSide() < 0 && !child.isHidden) {
                    before = child;
                    beforePos = pos - off;
                }
            }
            off = end;
        }
    }
    scan(view, pos);
    var target = (side < 0 ? before : after) || before || after;
    if (target) return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
    return fallbackRect(view);
}
function fallbackRect(view) {
    var last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    var rects = clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function combineAttrs(source, target) {
    for(var name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
var noAttrs = /*@__PURE__*/ Object.create(null);
function attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = noAttrs;
    if (!b) b = noAttrs;
    var keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keysA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function updateAttrs(dom, prev, attrs) {
    var changed = false;
    if (prev) {
        for(var name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(var name1 in attrs)if (!(prev && prev[name1] == attrs[name1])) {
            changed = true;
            if (name1 == "style") dom.style.cssText = attrs[name1];
            else dom.setAttribute(name1, attrs[name1]);
        }
    }
    return changed;
}
function getAttrs(dom) {
    var attrs = Object.create(null);
    for(var i = 0; i < dom.attributes.length; i++){
        var attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
class LineView extends ContentView {
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart, openEnd);
        return true;
    }
    split(at) {
        var end = new LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        var _this_childPos = this.childPos(at), i = _this_childPos.i, off = _this_childPos.off;
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(var j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        var attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return inlineDOMAtPos(this, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) {
            clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(view, track);
        var last = this.dom.lastChild;
        while(last && ContentView.get(last) instanceof MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!browser.ios || !this.children.some((ch)=>ch instanceof TextView))) {
            var hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        var totalWidth = 0, textHeight;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (!(child instanceof TextView) || /[^ -~]/.test(child.text)) return null;
                var rects = clientRectsFor(child.dom);
                if (rects.length != 1) return null;
                totalWidth += rects[0].width;
                textHeight = rects[0].height;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !totalWidth ? null : {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length,
            textHeight
        };
    }
    coordsAt(pos, side) {
        var rect = coordsInChildren(this, pos, side);
        // Correct rectangle height for empty lines when the returned
        // height is larger than the text height.
        if (!this.children.length && rect && this.parent) {
            var heightOracle = this.parent.view.viewState.heightOracle, height = rect.bottom - rect.top;
            if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
                var dist = (height - heightOracle.textHeight) / 2;
                return {
                    top: rect.top + dist,
                    bottom: rect.bottom - dist,
                    left: rect.left,
                    right: rect.left
                };
            }
        }
        return rect;
    }
    become(_other) {
        return false;
    }
    covers() {
        return true;
    }
    static find(docView, pos) {
        for(var i = 0, off = 0; i < docView.children.length; i++){
            var block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
}
class BlockWidgetView extends ContentView {
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        var len = this.length - at;
        this.length = at;
        var end = new BlockWidgetView(this.widget, len, this.deco);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return noChildren;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, _state.Text).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof BlockWidgetView && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.compare(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.deco = other.deco;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    coordsAt(pos, side) {
        return this.widget.coordsAt(this.dom, pos, side);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
    covers(side) {
        var _this_deco = this.deco, startSide = _this_deco.startSide, endSide = _this_deco.endSide;
        return startSide == endSide ? false : side < 0 ? startSide < 0 : endSide > 0;
    }
    constructor(widget, length, deco){
        super();
        this.widget = widget;
        this.length = length;
        this.deco = deco;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class WidgetType {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var BlockType = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}(BlockType || (BlockType = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class Decoration extends (0, _state.RangeValue) {
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        var side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        var block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            var _getInclusive = getInclusive(spec, block), start = _getInclusive.start, end = _getInclusive.end;
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of) {
        var sort = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0, _state.RangeSet).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
}
/**
The empty set of decorations.
*/ Decoration.none = (0, _state.RangeSet).empty;
class MarkDecoration extends Decoration {
    eq(other) {
        var _a, _b;
        return this == other || other instanceof MarkDecoration && this.tagName == other.tagName && (this.class || ((_a = this.attrs) === null || _a === void 0 ? void 0 : _a.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && attrsEq(this.attrs, other.attrs, "class");
    }
    range(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : from;
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
    constructor(spec){
        var _getInclusive = getInclusive(spec), start = _getInclusive.start, end = _getInclusive.end;
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
}
MarkDecoration.prototype.point = false;
class LineDecoration extends Decoration {
    eq(other) {
        return other instanceof LineDecoration && this.spec.class == other.spec.class && attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : from;
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
}
LineDecoration.prototype.mapMode = (0, _state.MapMode).TrackBefore;
LineDecoration.prototype.point = true;
class PointDecoration extends Decoration {
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? BlockType.WidgetRange : this.startSide <= 0 ? BlockType.WidgetBefore : BlockType.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof PointDecoration && widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : from;
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, _state.MapMode).TrackDel : startSide <= 0 ? (0, _state.MapMode).TrackBefore : (0, _state.MapMode).TrackAfter;
    }
}
PointDecoration.prototype.point = true;
function getInclusive(spec) {
    var block = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var start = spec.inclusiveStart, end = spec.inclusiveEnd;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function addRange(from, to, ranges) {
    var margin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class ContentBuilder {
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        var last = this.content[this.content.length - 1];
        return !(last.breakAfter || last instanceof BlockWidgetView && last.deco.endSide < 0);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer() {
        var active = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.bufferMarks;
        if (this.pendingBuffer) {
            this.curLine.append(wrapMarks(new WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* Buf.No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer();
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (this.pendingBuffer && openEnd <= this.bufferMarks.length) this.flushBuffer();
        else this.pendingBuffer = 0 /* Buf.No */ ;
        if (!this.posCovered() && !(openEnd && this.content.length && this.content[this.content.length - 1] instanceof BlockWidgetView)) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                var _this_cursor_next = this.cursor.next(this.skip), value = _this_cursor_next.value, lineBreak = _this_cursor_next.lineBreak, done = _this_cursor_next.done;
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer();
                    this.curLine = null;
                    this.atCursorPos = true;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            var take = Math.min(this.text.length - this.textOff, length, 512 /* T.Chunk */ );
            this.flushBuffer(active.slice(active.length - openStart));
            this.getLine().append(wrapMarks(new TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        var len = to - from;
        if (deco instanceof PointDecoration) {
            if (deco.block) {
                if (deco.startSide > 0 && !this.posCovered()) this.getLine();
                this.addBlockWidget(new BlockWidgetView(deco.widget || NullWidget.block, len, deco));
            } else {
                var view = WidgetView.create(deco.widget || NullWidget.inline, len, len ? 0 : deco.startSide);
                var cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                var cursorAfter = !view.isEditable && (from < to || openStart > active.length || deco.startSide <= 0);
                var line = this.getLine();
                if (this.pendingBuffer == 2 /* Buf.IfCursor */  && !cursorBefore && !view.isEditable) this.pendingBuffer = 0 /* Buf.No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append(wrapMarks(new WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append(wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* Buf.No */  : from < to || openStart > active.length ? 1 /* Buf.Yes */  : 2 /* Buf.IfCursor */ ;
                if (this.pendingBuffer) this.bufferMarks = active.slice();
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        var builder = new ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, _state.RangeSet).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* Buf.No */ ;
        this.bufferMarks = [];
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
}
function wrapMarks(view, active) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = active[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var mark = _step.value;
            view = new MarkView(mark, [
                view
            ], view.length);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return view;
}
class NullWidget extends WidgetType {
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
    constructor(tag){
        super();
        this.tag = tag;
    }
}
NullWidget.inline = /*@__PURE__*/ new NullWidget("span");
NullWidget.block = /*@__PURE__*/ new NullWidget("div");
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var Direction = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}(Direction || (Direction = {}));
var LTR = Direction.LTR, RTL = Direction.RTL;
// Decode a string with each type encoded as log2(type)
function dec(str) {
    var result = [];
    for(var i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
var LowTypes = /*@__PURE__*/ dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
var ArabicTypes = /*@__PURE__*/ dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
var Brackets = /*@__PURE__*/ Object.create(null), BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for(var _i = 0, _iter = [
    "()",
    "[]",
    "{}"
]; _i < _iter.length; _i++){
    var p = _iter[_i];
    var l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    Brackets[l] = r;
    Brackets[r] = -l;
}
function charType(ch) {
    return ch <= 0xf7 ? LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
var BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class BidiSpan {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? RTL : LTR;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        var maybe = -1;
        for(var i = 0; i < order.length; i++){
            var span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
}
function isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(var i = 0; i < a.length; i++){
        var iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
var types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(var iI = 0; iI <= isolates.length; iI++){
        var from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        var prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(var i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            var type = charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(var i1 = from, prev1 = prevType, prevStrong1 = prevType; i1 < to; i1++){
            var type1 = types[i1];
            if (type1 == 128 /* T.CS */ ) {
                if (i1 < to - 1 && prev1 == types[i1 + 1] && prev1 & 24 /* T.Num */ ) type1 = types[i1] = prev1;
                else types[i1] = 256 /* T.NI */ ;
            } else if (type1 == 64 /* T.ET */ ) {
                var end = i1 + 1;
                while(end < to && types[end] == 64 /* T.ET */ )end++;
                var replace = i1 && prev1 == 8 /* T.EN */  || end < rTo && types[end] == 8 /* T.EN */  ? prevStrong1 == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(var j = i1; j < end; j++)types[j] = replace;
                i1 = end - 1;
            } else if (type1 == 8 /* T.EN */  && prevStrong1 == 1 /* T.L */ ) types[i1] = 1 /* T.L */ ;
            prev1 = type1;
            if (type1 & 7 /* T.Strong */ ) prevStrong1 = type1;
        }
    }
}
// Process brackets throughout a run sequence.
function processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    var oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(var iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        var from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(var i = from, ch = void 0, br = void 0, type = void 0; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(var sJ = sI - 3; sJ >= 0; sJ -= 3)if (BracketStack[sJ + 1] == -br) {
                        var flags = BracketStack[sJ + 2];
                        var type1 = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type1) types[i] = types[BracketStack[sJ]] = type1;
                        sI = sJ;
                        break;
                    }
                } else if (BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    BracketStack[sI++] = i;
                    BracketStack[sI++] = ch;
                    BracketStack[sI++] = context;
                }
            } else if ((type = types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                var embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(var sJ1 = sI - 3; sJ1 >= 0; sJ1 -= 3){
                    var cur = BracketStack[sJ1 + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) BracketStack[sJ1 + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        BracketStack[sJ1 + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function processNeutrals(rFrom, rTo, isolates, outerType) {
    for(var iI = 0, prev = outerType; iI <= isolates.length; iI++){
        var from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(var i = from; i < to;){
            var type = types[i];
            if (type == 256 /* T.NI */ ) {
                var end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if (types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                var beforeL = prev == 1 /* T.L */ ;
                var afterL = (end < rTo ? types[end] : outerType) == 1 /* T.L */ ;
                var replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(var j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function emitSpans(line, from, to, level, baseLevel, isolates, order) {
    var ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(var iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        var sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            var next = types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        var recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        var localLevel = sameDir ? level : level + 1;
        var iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                var iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(var upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if (types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new BidiSpan(iCh, iso.from, localLevel));
                    var dirSwap = iso.direction == LTR != !(localLevel % 2);
                    computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? types[iScan] != ourType : types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new BidiSpan(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(var iCh1 = to, iI1 = isolates.length; iCh1 > from;){
        var sameDir1 = true, isNum1 = false;
        if (!iI1 || iCh1 > isolates[iI1 - 1].to) {
            var next1 = types[iCh1 - 1];
            if (next1 != ourType) {
                sameDir1 = false;
                isNum1 = next1 == 16 /* T.AN */ ;
            }
        }
        var recurse1 = !sameDir1 && ourType == 1 /* T.L */  ? [] : null;
        var localLevel1 = sameDir1 ? level : level + 1;
        var iScan1 = iCh1;
        run: for(;;){
            if (iI1 && iScan1 == isolates[iI1 - 1].to) {
                if (isNum1) break run;
                var iso1 = isolates[--iI1];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir1) for(var upto1 = iso1.from, jI1 = iI1;;){
                    if (upto1 == from) break run;
                    if (jI1 && isolates[jI1 - 1].to == upto1) upto1 = isolates[--jI1].from;
                    else if (types[upto1 - 1] == ourType) break run;
                    else break;
                }
                if (recurse1) recurse1.push(iso1);
                else {
                    if (iso1.to < iCh1) order.push(new BidiSpan(iso1.to, iCh1, localLevel1));
                    var dirSwap1 = iso1.direction == LTR != !(localLevel1 % 2);
                    computeSectionOrder(line, dirSwap1 ? level + 1 : level, baseLevel, iso1.inner, iso1.from, iso1.to, order);
                    iCh1 = iso1.from;
                }
                iScan1 = iso1.from;
            } else if (iScan1 == from || (sameDir1 ? types[iScan1 - 1] != ourType : types[iScan1 - 1] == ourType)) break;
            else iScan1--;
        }
        if (recurse1) emitSpans(line, iScan1, iCh1, level + 1, baseLevel, recurse1, order);
        else if (iScan1 < iCh1) order.push(new BidiSpan(iScan1, iCh1, localLevel1));
        iCh1 = iScan1;
    }
}
function computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    var outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    computeCharTypes(line, from, to, isolates, outerType);
    processBracketPairs(line, from, to, isolates, outerType);
    processNeutrals(from, to, isolates, outerType);
    emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function computeOrder(line, direction, isolates) {
    if (!line) return [
        new BidiSpan(0, 0, direction == RTL ? 1 : 0)
    ];
    if (direction == LTR && !isolates.length && !BidiRE.test(line)) return trivialOrder(line.length);
    if (isolates.length) while(line.length > types.length)types[types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    var order = [], level = direction == LTR ? 0 : 1;
    computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function trivialOrder(length) {
    return [
        new BidiSpan(0, length, 0)
    ];
}
var movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function moveVisually(line, order, dir, start, forward) {
    var _a;
    var startIndex = start.head - line.from;
    var spanI = BidiSpan.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    var span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        var nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    var nextIndex = (0, _state.findClusterBreak)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    var nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, _state.EditorSelection).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, _state.EditorSelection).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function autoDirection(text, from, to) {
    for(var i = from; i < to; i++){
        var type = charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return RTL;
    }
    return LTR;
}
var clickAddsSelectionRange = /*@__PURE__*/ (0, _state.Facet).define();
var dragMovesSelection$1 = /*@__PURE__*/ (0, _state.Facet).define();
var mouseSelectionStyle = /*@__PURE__*/ (0, _state.Facet).define();
var exceptionSink = /*@__PURE__*/ (0, _state.Facet).define();
var updateListener = /*@__PURE__*/ (0, _state.Facet).define();
var inputHandler = /*@__PURE__*/ (0, _state.Facet).define();
var focusChangeEffect = /*@__PURE__*/ (0, _state.Facet).define();
var perLineTextDirection = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
var nativeSelectionHidden = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
var scrollHandler = /*@__PURE__*/ (0, _state.Facet).define();
class ScrollTarget {
    map(changes) {
        return changes.empty ? this : new ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new ScrollTarget((0, _state.EditorSelection).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    constructor(range, ref, ref1, ref2, ref3, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    ref4){
        var y = ref === void 0 ? "nearest" : ref, x = ref1 === void 0 ? "nearest" : ref1, yMargin = ref2 === void 0 ? 5 : ref2, xMargin = ref3 === void 0 ? 5 : ref3, isSnapshot = ref4 === void 0 ? false : ref4;
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
}
var scrollIntoView = /*@__PURE__*/ (0, _state.StateEffect).define({
    map: (t, ch)=>t.map(ch)
});
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function logException(state, exception, context) {
    var handler = state.facet(exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror) window.onerror(String(exception), context, undefined, undefined, exception);
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
var editable = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.length ? values[0] : true
});
var nextPluginID = 0;
var viewPlugin = /*@__PURE__*/ (0, _state.Facet).define();
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view.
*/ class ViewPlugin {
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        var _ref = spec || {}, eventHandlers = _ref.eventHandlers, eventObservers = _ref.eventObservers, provide = _ref.provide, deco = _ref.decorations;
        return new ViewPlugin(nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            var ext = [
                viewPlugin.of(plugin)
            ];
            if (deco) ext.push(decorations.of((view)=>{
                var pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : Decoration.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return ViewPlugin.define((view)=>new cls(view), spec);
    }
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.extension = buildExtensions(this);
    }
}
class PluginInstance {
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.create(view);
            } catch (e) {
                logException(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            var update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                logException(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            logException(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `false`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
}
var editorAttributes = /*@__PURE__*/ (0, _state.Facet).define();
var contentAttributes = /*@__PURE__*/ (0, _state.Facet).define();
// Provide decorations
var decorations = /*@__PURE__*/ (0, _state.Facet).define();
var outerDecorations = /*@__PURE__*/ (0, _state.Facet).define();
var atomicRanges = /*@__PURE__*/ (0, _state.Facet).define();
var bidiIsolatedRanges = /*@__PURE__*/ (0, _state.Facet).define();
function getIsolatedRanges(view, line) {
    var isolates = view.state.facet(bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    var sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    var result = [];
    (0, _state.RangeSet).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            var from = fromDoc - line.from, to = toDoc - line.from;
            var level = result;
            for(var i = active.length - 1; i >= 0; i--, open--){
                var direction = active[i].spec.bidiIsolate, update = void 0;
                if (direction == null) direction = autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    var add = {
                        from,
                        to,
                        direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
var scrollMargins = /*@__PURE__*/ (0, _state.Facet).define();
function getScrollMargins(view) {
    var left = 0, right = 0, top = 0, bottom = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = view.state.facet(scrollMargins)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            var m = source(view);
            if (m) {
                if (m.left != null) left = Math.max(left, m.left);
                if (m.right != null) right = Math.max(right, m.right);
                if (m.top != null) top = Math.max(top, m.top);
                if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        left,
        right,
        top,
        bottom
    };
}
var styleModule = /*@__PURE__*/ (0, _state.Facet).define();
class ChangedRange {
    join(other) {
        return new ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        var i = set.length, me = this;
        for(; i > 0; i--){
            var range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        var result = [];
        for(var dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            var next = dI == diff.length ? null : diff[dI], off = posA - posB;
            var end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                var from = ranges[rI], to = ranges[rI + 1];
                var fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class ViewUpdate {
    /**
    @internal
    */ static create(view, state, transactions) {
        return new ViewUpdate(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 10 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, _state.ChangeSet).empty(this.startState.doc.length);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tr = _step.value;
                this.changes = this.changes.compose(tr.changes);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
}
class DocView extends ContentView {
    get length() {
        return this.view.state.doc.length;
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        var changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every((param)=>{
                var fromA = param.fromA, toA = param.toA;
                return toA < this.minWidthFrom || fromA > this.minWidthTo;
            })) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        var readCompositionAt = -1;
        if (this.view.inputState.composing >= 0) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        var composition = readCompositionAt > -1 ? findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            this.markedForComposition.clear();
            var _this_hasComposition = this.hasComposition, from = _this_hasComposition.from, to = _this_hasComposition.to;
            changedRanges = new ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if ((browser.ie || browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        var prevDeco = this.decorations, deco = this.updateDeco();
        var decoDiff = findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (!(this.flags & 7 /* ViewFlag.Dirty */ ) && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength, composition) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength, composition);
        var observer = this.view.observer;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            var track = browser.chrome || browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(this.view, track);
            this.flags &= -8 /* ViewFlag.Dirty */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        this.markedForComposition.forEach((cView)=>cView.flags &= -9 /* ViewFlag.Composition */ );
        var gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    if (child instanceof BlockWidgetView && child.widget instanceof BlockGapWidget) gaps.push(child.dom);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength, composition) {
        var ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
        var cursor = this.childCursor(oldLength);
        for(var i = ranges.length - 1;; i--){
            var next = i >= 0 ? ranges[i] : null;
            if (!next) break;
            var fromA = next.fromA, toA = next.toA, fromB = next.fromB, toB = next.toB, content = void 0, breakAtStart = void 0, openStart = void 0, openEnd = void 0;
            var ref;
            if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
                var before = ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
                var after = ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
                breakAtStart = before.breakAtStart;
                openStart = before.openStart;
                openEnd = after.openEnd;
                var compLine = this.compositionView(composition);
                if (after.breakAtStart) compLine.breakAfter = 1;
                else if (after.content.length && compLine.merge(compLine.length, compLine.length, after.content[0], false, after.openStart, 0)) {
                    compLine.breakAfter = after.content[0].breakAfter;
                    after.content.shift();
                }
                if (before.content.length && compLine.merge(0, 0, before.content[before.content.length - 1], true, 0, before.openEnd)) before.content.pop();
                content = before.content.concat(compLine).concat(after.content);
            } else ref = ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap), content = ref.content, breakAtStart = ref.breakAtStart, openStart = ref.openStart, openEnd = ref.openEnd, ref;
            var _cursor_findPos = cursor.findPos(toA, 1), toI = _cursor_findPos.i, toOff = _cursor_findPos.off;
            var _cursor_findPos1 = cursor.findPos(fromA, -1), fromI = _cursor_findPos1.i, fromOff = _cursor_findPos1.off;
            replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
        if (composition) this.fixCompositionDOM(composition);
    }
    compositionView(composition) {
        var cur = new TextView(composition.text.nodeValue);
        cur.flags |= 8 /* ViewFlag.Composition */ ;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = composition.marks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var deco = _step.value.deco;
                cur = new MarkView(deco, [
                    cur
                ], cur.length);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var line = new LineView;
        line.append(cur, 0);
        return line;
    }
    fixCompositionDOM(composition) {
        var fix = (dom, cView)=>{
            cView.flags |= 8 /* ViewFlag.Composition */  | (cView.children.some((c)=>c.flags & 7 /* ViewFlag.Dirty */ ) ? 1 /* ViewFlag.ChildDirty */  : 0);
            this.markedForComposition.add(cView);
            var prev = ContentView.get(dom);
            if (prev && prev != cView) prev.dom = null;
            cView.setDOM(dom);
        };
        var pos = this.childPos(composition.range.fromB, 1);
        var cView = this.children[pos.i];
        fix(composition.line, cView);
        for(var i = composition.marks.length - 1; i >= -1; i--){
            pos = cView.childPos(pos.off, 1);
            cView = cView.children[pos.i];
            fix(i >= 0 ? composition.marks[i].node : composition.text, cView);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection() {
        var mustRead = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, fromPointer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        var activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
        var selectionNotFocus = !focused && hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        var force = this.forceSelection;
        this.forceSelection = false;
        var main = this.view.state.selection.main;
        var anchor = this.moveToLine(this.domAtPos(main.anchor));
        var head = main.empty ? anchor : this.moveToLine(this.domAtPos(main.head));
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if (browser.gecko && main.empty && !this.hasComposition && betweenUneditable(anchor)) {
            var dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new DOMPos(dummy, 0);
            force = true;
        }
        var domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if (browser.android && browser.chrome && this.dom.contains(domSel.focusNode) && inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                var rawSel = getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if (browser.gecko) {
                        var nextTo = nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            var text = nearbyTextNode(anchor.node, anchor.offset, nextTo == 1 /* NextTo.Before */  ? 1 : -1);
                            if (text) anchor = new DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    var range = document.createRange();
                    var ref;
                    if (main.anchor > main.head) ref = [
                        head,
                        anchor
                    ], anchor = ref[0], head = ref[1], ref;
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == this.dom) {
                    this.dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && !this.compositionBarrier.size && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        var view = this.view, cursor = view.state.selection.main;
        var sel = getSelection(view.root);
        var _view_observer_selectionRange = view.observer.selectionRange, anchorNode = _view_observer_selectionRange.anchorNode, anchorOffset = _view_observer_selectionRange.anchorOffset;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        var line = LineView.find(this, cursor.head);
        if (!line) return;
        var lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        var before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        var dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        var newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    // If a position is in/near a block widget, move it to a nearby text
    // line, since we don't want the cursor inside a block widget.
    moveToLine(pos) {
        // Block widgets will return positions before/after them, which
        // are thus directly in the document DOM element.
        var dom = this.dom, newPos;
        if (pos.node != dom) return pos;
        for(var i = pos.offset; !newPos && i < dom.childNodes.length; i++){
            var view = ContentView.get(dom.childNodes[i]);
            if (view instanceof LineView) newPos = view.domAtPos(0);
        }
        for(var i1 = pos.offset - 1; !newPos && i1 >= 0; i1--){
            var view1 = ContentView.get(dom.childNodes[i1]);
            if (view1 instanceof LineView) newPos = view1.domAtPos(view1.length);
        }
        return newPos ? new DOMPos(newPos.node, newPos.offset, true) : pos;
    }
    nearest(dom) {
        for(var cur = dom; cur;){
            var domView = ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        var view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        var _this_childCursor_findPos = this.childCursor().findPos(pos, -1), i = _this_childCursor_findPos.i, off = _this_childCursor_findPos.off;
        for(; i < this.children.length - 1;){
            var child = this.children[i];
            if (off < child.length || child instanceof LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        var best = null, bestPos = 0;
        for(var off = this.length, i = this.children.length - 1; i >= 0; i--){
            var child = this.children[i], end = off - child.breakAfter, start = end - child.length;
            if (end < pos) break;
            if (start <= pos && (start < pos || child.covers(-1)) && (end > pos || child.covers(1)) && (!best || child instanceof LineView && !(best instanceof LineView && side >= 0))) {
                best = child;
                bestPos = start;
            }
            off = start;
        }
        return best ? best.coordsAt(pos - bestPos, side) : null;
    }
    coordsForChar(pos) {
        var _this_childPos = this.childPos(pos, 1), i = _this_childPos.i, off = _this_childPos.off, child = this.children[i];
        if (!(child instanceof LineView)) return null;
        while(child.children.length){
            var _child_childPos = child.childPos(off, 1), i1 = _child_childPos.i, childOff = _child_childPos.off;
            for(;; i1++){
                if (i1 == child.children.length) return null;
                if ((child = child.children[i1]).length) break;
            }
            off = childOff;
        }
        if (!(child instanceof TextView)) return null;
        var end = (0, _state.findClusterBreak)(child.text, off);
        if (end == off) return null;
        var rects = textRange(child.dom, off, end).getClientRects();
        for(var i2 = 0; i2 < rects.length; i2++){
            var rect = rects[i2];
            if (i2 == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
        }
        return null;
    }
    measureVisibleLineHeights(viewport) {
        var result = [], from = viewport.from, to = viewport.to;
        var contentWidth = this.view.contentDOM.clientWidth;
        var isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        var widest = -1, ltr = this.view.textDirection == Direction.LTR;
        for(var pos = 0, i = 0; i < this.children.length; i++){
            var child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                var childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    var last = child.dom.lastChild;
                    var rects = last ? clientRectsFor(last) : [];
                    if (rects.length) {
                        var rect = rects[rects.length - 1];
                        var width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        var i = this.childPos(pos, 1).i;
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? Direction.RTL : Direction.LTR;
    }
    measureTextSize() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (child instanceof LineView) {
                    var measure = child.measureTextSize();
                    if (measure) return measure;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // If no workable line exists, force a layout of a measurable element
        var dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            var rect = clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            textHeight = rect ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight,
            charWidth,
            textHeight
        };
    }
    childCursor() {
        var pos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.length;
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        var i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        var deco = [], vs = this.view.viewState;
        for(var pos = 0, i = 0;; i++){
            var next = i == vs.viewports.length ? null : vs.viewports[i];
            var end = next ? next.from - 1 : this.length;
            if (end > pos) {
                var height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push(Decoration.replace({
                    widget: new BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return Decoration.set(deco);
    }
    updateDeco() {
        var i = 1;
        var allDeco = this.view.state.facet(decorations).map((d)=>{
            var dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        var dynamicOuter = false, outerDeco = this.view.state.facet(outerDecorations).map((d, i)=>{
            var dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, _state.RangeSet).join(outerDeco));
        }
        this.decorations = [
            this.compositionBarrier,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        return this.decorations;
    }
    // Starting a composition will style the inserted text with the
    // style of the text before it, and this is only cleared when the
    // composition ends, because touching it before that will abort it.
    // This (called from compositionstart handler) tries to notice when
    // the cursor is after a non-inclusive mark, where the styling could
    // be jarring, and insert an ad-hoc widget before the cursor to
    // isolate it from the style before it.
    maybeCreateCompositionBarrier() {
        var _this_view_state_selection = this.view.state.selection, _this_view_state_selection_main = _this_view_state_selection.main, head = _this_view_state_selection_main.head, empty = _this_view_state_selection_main.empty;
        if (!empty) return false;
        var found = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.decorations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var set = _step.value;
                set.between(head, head, (from, to, value)=>{
                    if (value.point) found = false;
                    else if (value.endSide < 0 && from < head && to == head) found = true;
                });
                if (found === false) break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.compositionBarrier = found ? Decoration.set(compositionBarrierWidget.range(head)) : Decoration.none;
        return !!found;
    }
    clearCompositionBarrier() {
        this.compositionBarrier = Decoration.none;
    }
    scrollIntoView(target) {
        if (target.isSnapshot) {
            var ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.view.state.facet(scrollHandler)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var handler = _step.value;
                try {
                    if (handler(this.view, target.range, target)) return true;
                } catch (e) {
                    logException(this.view.state, e, "scroll handler");
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var range = target.range;
        var rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        var margins = getScrollMargins(this.view);
        var targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        var _this_view_scrollDOM = this.view.scrollDOM, offsetWidth = _this_view_scrollDOM.offsetWidth, offsetHeight = _this_view_scrollDOM.offsetHeight;
        scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == Direction.LTR);
    }
    constructor(view){
        super();
        this.view = view;
        this.decorations = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.markedForComposition = new Set;
        this.compositionBarrier = Decoration.none;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0, null);
    }
}
var compositionBarrierWidget = /*@__PURE__*/ Decoration.widget({
    side: -1,
    widget: NullWidget.inline
});
function betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
class BlockGapWidget extends WidgetType {
    toDOM() {
        var elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
    constructor(height){
        super();
        this.height = height;
    }
}
function findCompositionNode(view, headPos) {
    var sel = view.observer.selectionRange;
    var textNode = sel.focusNode && nearbyTextNode(sel.focusNode, sel.focusOffset, 0);
    if (!textNode) return null;
    var from = headPos - textNode.offset;
    return {
        from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function findCompositionRange(view, changes, headPos) {
    var found = findCompositionNode(view, headPos);
    if (!found) return null;
    var textNode = found.node, from = found.from, to = found.to, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    var inv = changes.invertedDesc;
    var range = new ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to);
    var marks = [];
    for(var parent = textNode.parentNode;; parent = parent.parentNode){
        var parentView = ContentView.get(parent);
        if (parentView instanceof MarkView) marks.push({
            node: parent,
            deco: parentView.mark
        });
        else if (parentView instanceof LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM) return {
            range,
            text: textNode,
            marks,
            line: parent
        };
        else if (parent != view.contentDOM) marks.push({
            node: parent,
            deco: new MarkDecoration({
                inclusive: true,
                attributes: getAttrs(parent),
                tagName: parent.tagName.toLowerCase()
            })
        });
        else return null;
    }
}
function nearbyTextNode(startNode, startOffset, side) {
    if (side <= 0) for(var node = startNode, offset = startOffset;;){
        if (node.nodeType == 3) return {
            node: node,
            offset: offset
        };
        if (node.nodeType == 1 && offset > 0) {
            node = node.childNodes[offset - 1];
            offset = maxOffset(node);
        } else break;
    }
    if (side >= 0) for(var node1 = startNode, offset1 = startOffset;;){
        if (node1.nodeType == 3) return {
            node: node1,
            offset: offset1
        };
        if (node1.nodeType == 1 && offset1 < node1.childNodes.length && side >= 0) {
            node1 = node1.childNodes[offset1];
            offset1 = 0;
        } else break;
    }
    return null;
}
function nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
var DecorationComparator$1 = class DecorationComparator {
    compareRange(from, to) {
        addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        addRange(from, to, this.changes);
    }
    constructor(){
        this.changes = [];
    }
};
function findChangedDeco(a, b, diff) {
    var comp = new DecorationComparator$1;
    (0, _state.RangeSet).compare(a, b, diff, comp);
    return comp.changes;
}
function inUneditable(node, inside) {
    for(var cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == "false") return true;
    }
    return false;
}
function touchesComposition(changes, composition) {
    var touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
function groupAt(state, pos) {
    var bias = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var categorize = state.charCategorizer(pos);
    var line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, _state.EditorSelection).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    var from = linePos, to = linePos;
    if (bias < 0) from = (0, _state.findClusterBreak)(line.text, linePos, false);
    else to = (0, _state.findClusterBreak)(line.text, linePos);
    var cat = categorize(line.text.slice(from, to));
    while(from > 0){
        var prev = (0, _state.findClusterBreak)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        var next = (0, _state.findClusterBreak)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, _state.EditorSelection).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function upTop(rect, top) {
    return top < rect.top ? {
        top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom
    } : rect;
}
function domPosAtCoords(parent, x, y) {
    var closest, closestRect, closestX, closestY, closestOverlap = false;
    var above, below, aboveRect, belowRect;
    for(var child = parent.firstChild; child; child = child.nextSibling){
        var rects = clientRectsFor(child);
        for(var i = 0; i < rects.length; i++){
            var rect = rects[i];
            if (closestRect && yOverlap(closestRect, rect)) rect = upTop(upBot(rect, closestRect.bottom), closestRect.top);
            var dx = getdx(x, rect), dy = getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? domPosInText(child, x, y) : domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
                var side = dy ? y < rect.top ? -1 : 1 : dx ? x < rect.left ? -1 : 1 : 0;
                closestOverlap = !side || (side > 0 ? i < rects.length - 1 : i > 0);
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && yOverlap(aboveRect, rect)) aboveRect = upBot(aboveRect, rect.bottom);
            else if (belowRect && yOverlap(belowRect, rect)) belowRect = upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    var clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return domPosInText(closest, clipX, y);
    if (closestOverlap && closest.contentEditable != "false") return domPosAtCoords(closest, clipX, y);
    var offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset
    };
}
function domPosInText(node, x, y) {
    var len = node.nodeValue.length;
    var closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(var i = 0; i < len; i++){
        var rects = textRange(node, i, i + 1).getClientRects();
        for(var j = 0; j < rects.length; j++){
            var rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            var dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                var right = x >= (rect.left + rect.right) / 2, after = right;
                if (browser.chrome || browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    var rectBefore = textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function posAtCoords(view, coords, precise) {
    var bias = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
    var _a, _b;
    var content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    var block, docHeight = view.viewState.docHeight;
    var x = coords.x, y = coords.y, yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(var halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == BlockType.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    var lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    var doc = view.dom.ownerDocument;
    var root = view.root.elementFromPoint ? view.root : doc;
    var element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    var node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            var pos = doc.caretPositionFromPoint(x, y);
            var ref;
            if (pos) ref = pos, node = ref.offsetNode, offset = ref.offset, ref;
        } else if (doc.caretRangeFromPoint) {
            var range = doc.caretRangeFromPoint(x, y);
            if (range) {
                var ref1;
                ref1 = range, node = ref1.startContainer, offset = ref1.startOffset, ref1;
                if (!view.contentDOM.contains(node) || browser.safari && isSuspiciousSafariCaretResult(node, offset, x) || browser.chrome && isSuspiciousChromeCaretResult(node, offset, x)) node = undefined;
            }
        }
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        var line = LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        var ref2;
        ref2 = domPosAtCoords(line.dom, x, y), node = ref2.node, offset = ref2.offset, ref2;
    }
    var nearest = view.docView.nearest(node);
    if (!nearest) return null;
    if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
        var rect = nearest.dom.getBoundingClientRect();
        return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
    } else return nearest.localPosFromDOM(node, offset) + nearest.posAtStart;
}
function posAtCoordsImprecise(view, contentRect, block, x, y) {
    var into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        var textHeight = view.viewState.heightOracle.textHeight;
        var line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    var content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, _state.findColumn)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function isSuspiciousSafariCaretResult(node, offset, x) {
    var len;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(var next = node.nextSibling; next; next = next.nextSibling)if (next.nodeType != 1 || next.nodeName != "BR") return false;
    return textRange(node, len - 1, len).getBoundingClientRect().left > x;
}
// Chrome will move positions between lines to the start of the next line
function isSuspiciousChromeCaretResult(node, offset, x) {
    if (offset != 0) return false;
    for(var cur = node;;){
        var parent = cur.parentNode;
        if (!parent || parent.nodeType != 1 || parent.firstChild != cur) return false;
        if (parent.classList.contains("cm-line")) break;
        cur = parent;
    }
    var rect = node.nodeType == 1 ? node.getBoundingClientRect() : textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
    return x - rect.left > 5;
}
function blockAt(view, pos) {
    var line = view.lineBlockAt(pos);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (Array.isArray(line.type)) try {
        for(var _iterator = line.type[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var l = _step.value;
            if (l.to > pos || l.to == pos && (l.to == line.to || l.type == BlockType.Text)) return l;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return line;
}
function moveToLineBoundary(view, start, forward, includeWrap) {
    var line = blockAt(view, start.head);
    var coords = !includeWrap || line.type != BlockType.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        var editorRect = view.dom.getBoundingClientRect();
        var direction = view.textDirectionAt(line.from);
        var pos = view.posAtCoords({
            x: forward == (direction == Direction.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, _state.EditorSelection).cursor(pos, forward ? -1 : 1);
    }
    return (0, _state.EditorSelection).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function moveByChar(view, start, forward, by) {
    var line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    var direction = view.textDirectionAt(line.from);
    for(var cur = start, check = null;;){
        var next = moveVisually(line, spans, direction, cur, forward), char = movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function byGroup(view, pos, start) {
    var categorize = view.state.charCategorizer(pos);
    var cat = categorize(start);
    return (next)=>{
        var nextCat = categorize(next);
        if (cat == (0, _state.CharCategory).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function moveVertically(view, start, forward, distance) {
    var startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, _state.EditorSelection).cursor(startPos, start.assoc);
    var goal = start.goalColumn, startY;
    var rect = view.contentDOM.getBoundingClientRect();
    var startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        var line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    var resolvedGoal = rect.left + goal;
    var dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(var extra = 0;; extra += 10){
        var curY = startY + (dist + extra) * dir;
        var pos = posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) {
            var charRect = view.docView.coordsForChar(pos);
            var assoc = !charRect || curY < charRect.top ? -1 : 1;
            return (0, _state.EditorSelection).cursor(pos, assoc, undefined, goal);
        }
    }
}
function skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        var moved = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var set = _step.value;
                set.between(pos - 1, pos + 1, (from, to, value)=>{
                    if (pos > from && pos < to) {
                        var side = moved || bias || (pos - from < to - pos ? -1 : 1);
                        pos = side < 0 ? from : to;
                        moved = side;
                    }
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!moved) return pos;
    }
}
function skipAtoms(view, oldPos, pos) {
    var newPos = skipAtomicRanges(view.state.facet(atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, _state.EditorSelection).cursor(newPos, newPos < pos.from ? 1 : -1);
}
// This will also be where dragging info and such goes
class InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    handleEvent(event) {
        if (!eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        var handlers = this.handlers[type];
        if (handlers) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = handlers.observers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var observer = _step.value;
                    observer(this.view, event);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = handlers.handlers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var handler = _step1.value;
                    if (event.defaultPrevented) break;
                    if (handler(this.view, event)) {
                        event.preventDefault();
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    ensureHandlers(plugins) {
        var handlers = computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(var type in handlers)if (type != "scroll") {
            var passive = !handlers[type].handlers.length;
            var exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive
            });
        }
        for(var type1 in prev)if (type1 != "scroll" && !handlers[type1]) dom.removeEventListener(type1, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && Date.now() < this.lastEscPress + 2000) return true;
        if (event.keyCode != 27 && modifierCodes.indexOf(event.keyCode) < 0) this.view.inputState.lastEscPress = 0;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if (browser.android && browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        var pending;
        if (browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        var key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : undefined);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if (browser.safari && !browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastEscPress = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if (browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if (browser.gecko) firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
}
function bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            logException(view.state, e);
        }
    };
}
function computeHandlers(plugins) {
    var result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            var spec = plugin.spec;
            if (spec && spec.domEventHandlers) for(var type in spec.domEventHandlers){
                var f = spec.domEventHandlers[type];
                if (f) record(type).handlers.push(bindHandler(plugin.value, f));
            }
            if (spec && spec.domEventObservers) for(var type1 in spec.domEventObservers){
                var f1 = spec.domEventObservers[type1];
                if (f1) record(type1).observers.push(bindHandler(plugin.value, f1));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var type2 in handlers)record(type2).handlers.push(handlers[type2]);
    for(var type3 in observers)record(type3).observers.push(observers[type3]);
    return result;
}
var PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
var EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
var modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
var dragScrollMargin = 6;
function dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class MouseSelection {
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        var _a;
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        var sx = 0, sy = 0;
        var rect = ((_a = this.scrollParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
            left: 0,
            top: 0,
            right: this.view.win.innerWidth,
            bottom: this.view.win.innerHeight
        };
        var margins = getScrollMargins(this.view);
        if (event.clientX - margins.left <= rect.left + dragScrollMargin) sx = -dragScrollSpeed(rect.left - event.clientX);
        else if (event.clientX + margins.right >= rect.right - dragScrollMargin) sx = dragScrollSpeed(event.clientX - rect.right);
        if (event.clientY - margins.top <= rect.top + dragScrollMargin) sy = -dragScrollSpeed(rect.top - event.clientY);
        else if (event.clientY + margins.bottom >= rect.bottom - dragScrollMargin) sy = dragScrollSpeed(event.clientY - rect.bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        var doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        if (this.scrollParent) {
            this.scrollParent.scrollLeft += this.scrollSpeed.x;
            this.scrollParent.scrollTop += this.scrollSpeed.y;
        } else this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    skipAtoms(sel) {
        var ranges = null;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i], updated = null;
            if (range.empty) {
                var pos = skipAtomicRanges(this.atoms, range.from, 0);
                if (pos != range.from) updated = (0, _state.EditorSelection).cursor(pos, -1);
            } else {
                var from = skipAtomicRanges(this.atoms, range.from, -1);
                var to = skipAtomicRanges(this.atoms, range.to, 1);
                if (from != range.from || to != range.to) updated = (0, _state.EditorSelection).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
            if (updated) {
                if (!ranges) ranges = sel.ranges.slice();
                ranges[i] = updated;
            }
        }
        return ranges ? (0, _state.EditorSelection).create(ranges, sel.mainIndex) : sel;
    }
    select(event) {
        var view = this.view, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParent = scrollableParent(view.contentDOM);
        this.atoms = view.state.facet(atomicRanges).map((f)=>f(view));
        var doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, _state.EditorState).allowMultipleSelections) && addsSelectionRange(view, startEvent);
        this.dragging = isInPrimarySelection(view, startEvent) && getClickType(startEvent) == 1 ? null : false;
    }
}
function addsSelectionRange(view, event) {
    var facet = view.state.facet(clickAddsSelectionRange);
    return facet.length ? facet[0](event) : browser.mac ? event.metaKey : event.ctrlKey;
}
function dragMovesSelection(view, event) {
    var facet = view.state.facet(dragMovesSelection$1);
    return facet.length ? facet[0](event) : browser.mac ? !event.altKey : !event.ctrlKey;
}
function isInPrimarySelection(view, event) {
    var main = view.state.selection.main;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    var sel = getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    var rects = sel.getRangeAt(0).getClientRects();
    for(var i = 0; i < rects.length; i++){
        var rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(var node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
var handlers = /*@__PURE__*/ Object.create(null);
var observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
var brokenClipboardAPI = browser.ie && browser.ie_version < 15 || browser.ios && browser.webkit_version < 604;
function capturePaste(view) {
    var parent = view.dom.parentNode;
    if (!parent) return;
    var target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        doPaste(view, target.value);
    }, 50);
}
function doPaste(view, input) {
    var state = view.state, changes, i = 1, text = state.toText(input);
    var byLine = text.lines == state.selection.ranges.length;
    var linewise = lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && lastLinewiseCopy == text.toString();
    if (linewise) {
        var lastLine = -1;
        changes = state.changeByRange((range)=>{
            var line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range
            };
            lastLine = line.from;
            var insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert
                },
                range: (0, _state.EditorSelection).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        var line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, _state.EditorSelection).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
observers.scroll = (view)=>{
    view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
    view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27) view.inputState.lastEscPress = Date.now();
    return false;
};
observers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    var style = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = view.state.facet(mouseSelectionStyle)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var makeStyle = _step.value;
            style = makeStyle(view, event);
            if (style) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!style && event.button == 0) style = basicMouseSelection(view, event);
    if (style) {
        var mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>focusPreventScroll(view.contentDOM));
        var mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    }
    return false;
};
function rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, _state.EditorSelection).cursor(pos, bias);
    else if (type == 2) return groupAt(view.state, pos, bias);
    else {
        var visual = LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        var from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, _state.EditorSelection).range(from, to);
    }
}
var insideY = (y, rect)=>y >= rect.top && y <= rect.bottom;
var inside = (x, y, rect)=>insideY(y, rect) && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function findPositionSide(view, pos, x, y) {
    var line = LineView.find(view.docView, pos);
    if (!line) return 1;
    var off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    var before = line.coordsAt(off, -1);
    if (before && inside(x, y, before)) return -1;
    var after = line.coordsAt(off, 1);
    if (after && inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // beside it.
    return before && insideY(y, before) ? -1 : 1;
}
function queryPos(view, event) {
    var pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos,
        bias: findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
var BadMouseDetail = browser.ie && browser.ie_version <= 11;
var lastMouseDown = null, lastMouseDownCount = 0, lastMouseDownTime = 0;
function getClickType(event) {
    if (!BadMouseDetail) return event.detail;
    var last = lastMouseDown, lastTime = lastMouseDownTime;
    lastMouseDown = event;
    lastMouseDownTime = Date.now();
    return lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? (lastMouseDownCount + 1) % 3 : 1;
}
function basicMouseSelection(view, event) {
    var start = queryPos(view, event), type = getClickType(event);
    var startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            var cur = queryPos(view, event), removed;
            var range = rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                var startRange = rangeForClick(view, start.pos, start.bias, type);
                var from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, _state.EditorSelection).range(from, to) : (0, _state.EditorSelection).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, _state.EditorSelection).create([
                range
            ]);
        }
    };
}
function removeRangeAround(sel, pos) {
    for(var i = 0; i < sel.ranges.length; i++){
        var _sel_ranges_i = sel.ranges[i], from = _sel_ranges_i.from, to = _sel_ranges_i.to;
        if (from <= pos && to >= pos) return (0, _state.EditorSelection).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
handlers.dragstart = (view, event)=>{
    var _view_state = view.state, _view_state_selection = _view_state.selection, range = _view_state_selection.main;
    if (event.target.draggable) {
        var cView = view.docView.nearest(event.target);
        if (cView && cView.isWidget) {
            var from = cView.posAtStart, to = from + cView.length;
            if (from >= range.to || to <= range.from) range = (0, _state.EditorSelection).range(from, to);
        }
    }
    var inputState = view.inputState;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", view.state.sliceDoc(range.from, range.to));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function dropText(view, event, text, direct) {
    if (!text) return;
    var dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    var draggedContent = view.inputState.draggedContent;
    var del = direct && draggedContent && dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    var ins = {
        from: dropPos,
        insert: text
    };
    var changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    var files = event.dataTransfer.files;
    if (files && files.length) {
        var _loop = function(i) {
            var reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        };
        var text = Array(files.length), read = 0;
        var finishFile = ()=>{
            if (++read == files.length) dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(var i = 0; i < files.length; i++)_loop(i);
        return true;
    } else {
        var text1 = event.dataTransfer.getData("Text");
        if (text1) {
            dropText(view, event, text1, true);
            return true;
        }
    }
    return false;
};
handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    var data = brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        capturePaste(view);
        return false;
    }
};
function captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    var parent = view.dom.parentNode;
    if (!parent) return;
    var target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function copiedRange(state) {
    var content = [], ranges = [], linewise = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var range = _step.value;
            if (!range.empty) {
                content.push(state.sliceDoc(range.from, range.to));
                ranges.push(range);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        var upto = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = state.selection.ranges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var from = _step1.value.from;
                var line = state.doc.lineAt(from);
                if (line.number > upto) {
                    content.push(line.text);
                    ranges.push({
                        from: line.from,
                        to: Math.min(state.doc.length, line.to + 1)
                    });
                }
                upto = line.number;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        linewise = true;
    }
    return {
        text: content.join(state.lineBreak),
        ranges,
        linewise
    };
}
var lastLinewiseCopy = null;
handlers.copy = handlers.cut = (view, event)=>{
    var _copiedRange = copiedRange(view.state), text = _copiedRange.text, ranges = _copiedRange.ranges, linewise = _copiedRange.linewise;
    if (!text && !linewise) return false;
    lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    var data = brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        captureCopy(view, text);
        return false;
    }
};
var isFocusChange = /*@__PURE__*/ (0, _state.Annotation).define();
function focusChangeTransaction(state, focus) {
    var effects = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.facet(focusChangeEffect)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var getEffect = _step.value;
            var effect = getEffect(state, focus);
            if (effect) effects.push(effect);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return effects ? state.update({
        effects,
        annotations: isFocusChange.of(true)
    }) : null;
}
function updateForFocusChange(view) {
    setTimeout(()=>{
        var focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            var tr = focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    updateForFocusChange(view);
};
observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    updateForFocusChange(view);
};
observers.compositionstart = observers.compositionupdate = (view)=>{
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) {
        // FIXME possibly set a timeout to clear it again on Android
        view.inputState.composing = 0;
        if (view.docView.maybeCreateCompositionBarrier()) {
            view.update([]);
            view.docView.clearCompositionBarrier();
        }
    }
};
observers.compositionend = (view)=>{
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if (browser.chrome && browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
handlers.beforeinput = (view, event)=>{
    var _a;
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    var pending;
    if (browser.chrome && browser.android && (pending = PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            var startViewHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if (browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    return false;
};
var appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See https://github.com/codemirror/dev/issues/1082
// and https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function firefoxCopyCutHack(doc) {
    if (!appliedFirefoxHack.has(doc)) {
        appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
var wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
class HeightOracle {
    heightForGap(from, to) {
        var lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        var lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / (this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        var newHeight = false;
        for(var i = 0; i < lineHeights.length; i++){
            var h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        var lineWrapping = wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        var changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(var i = 0; i < knownHeights.length; i++){
                var h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, _state.Text).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
        // Used to track, during updateHeight, if any actual heights changed
        this.heightChanged = false;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class MeasuredHeights {
    get more() {
        return this.index < this.heights.length;
    }
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class BlockInfo {
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? BlockType.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        var content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new BlockInfo(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-create line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
}
var QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}(QueryType || (QueryType = {}));
var Epsilon = 1e-3;
class HeightMap {
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(oracle, height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > Epsilon) oracle.heightChanged = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        var me = this, doc = oracle.doc;
        for(var i = changes.length - 1; i >= 0; i--){
            var _changes_i = changes[i], fromA = _changes_i.fromA, toA = _changes_i.toA, fromB = _changes_i.fromB, toB = _changes_i.toB;
            var start = me.lineAt(fromA, QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            var end = start.to >= toA ? start : me.lineAt(toA, QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            var nodes = NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = me.replace(fromA, toA, nodes);
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        var i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    var split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    var split1 = nodes[j];
                    if (split1.break) nodes.splice(j, 1, split1.left, null, split1.right);
                    else nodes.splice(j, 1, split1.left, split1.right);
                    j += 2 + split1.break;
                    after -= split1.size;
                } else break;
            } else if (before < after) {
                var next = nodes[i++];
                if (next) before += next.size;
            } else {
                var next1 = nodes[--j];
                if (next1) after += next1.size;
            }
        }
        var brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new HeightMapBranch(HeightMap.of(nodes.slice(0, i)), brk, HeightMap.of(nodes.slice(j)));
    }
    constructor(length, height, ref /* Flag.Outdated */ ){
        var flags = ref === void 0 ? 2 : ref;
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
}
HeightMap.prototype.size = 1;
class HeightMapBlock extends HeightMap {
    blockAt(_height, _oracle, top, offset) {
        return new BlockInfo(offset, this.length, top, this.height, this.deco || 0);
    }
    lineAt(_value, _type, oracle, top, offset) {
        return this.blockAt(0, oracle, top, offset);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, oracle, top, offset));
    }
    updateHeight(oracle) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, _force = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, measured = arguments.length > 3 ? arguments[3] : void 0;
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
    }
}
class HeightMapText extends HeightMapBlock {
    blockAt(_height, _oracle, top, offset) {
        return new BlockInfo(offset, this.length, top, this.height, this.breaks);
    }
    replace(_from, _to, nodes) {
        var node = nodes[0];
        if (nodes.length == 1 && (node instanceof HeightMapText || node instanceof HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof HeightMapGap) node = new HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return HeightMap.of(nodes);
    }
    updateHeight(oracle) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, force = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, measured = arguments.length > 3 ? arguments[3] : void 0;
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(oracle, Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
    constructor(length, height){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
    }
}
class HeightMapGap extends HeightMap {
    heightMetrics(oracle, offset) {
        var firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        var lines = lastLine - firstLine + 1;
        var perLine, perChar = 0;
        if (oracle.lineWrapping) {
            var totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine,
            lastLine,
            perLine,
            perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        var _this_heightMetrics = this.heightMetrics(oracle, offset), firstLine = _this_heightMetrics.firstLine, lastLine = _this_heightMetrics.lastLine, perLine = _this_heightMetrics.perLine, perChar = _this_heightMetrics.perChar;
        if (oracle.lineWrapping) {
            var guess = offset + Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length);
            var line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            var lineTop = Math.max(top, height - lineHeight / 2);
            return new BlockInfo(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            var line1 = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            var _oracle_doc_line = oracle.doc.line(firstLine + line1), from = _oracle_doc_line.from, length = _oracle_doc_line.length;
            return new BlockInfo(from, length, top + perLine * line1, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == QueryType.ByPosNoHeight) {
            var _oracle_doc_lineAt = oracle.doc.lineAt(value), from = _oracle_doc_lineAt.from, to = _oracle_doc_lineAt.to;
            return new BlockInfo(from, to - from, 0, 0, 0);
        }
        var _this_heightMetrics = this.heightMetrics(oracle, offset), firstLine = _this_heightMetrics.firstLine, perLine = _this_heightMetrics.perLine, perChar = _this_heightMetrics.perChar;
        var line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        var linesAbove = line.number - firstLine;
        var lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new BlockInfo(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        var _this_heightMetrics = this.heightMetrics(oracle, offset), firstLine = _this_heightMetrics.firstLine, perLine = _this_heightMetrics.perLine, perChar = _this_heightMetrics.perChar;
        for(var pos = from, lineTop = top; pos <= to;){
            var line = oracle.doc.lineAt(pos);
            if (pos == from) {
                var linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            var lineHeight = perLine + perChar * line.length;
            f(new BlockInfo(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        var after = this.length - to;
        if (after > 0) {
            var last = nodes[nodes.length - 1];
            if (last instanceof HeightMapGap) nodes[nodes.length - 1] = new HeightMapGap(last.length + after);
            else nodes.push(null, new HeightMapGap(after - 1));
        }
        if (from > 0) {
            var first = nodes[0];
            if (first instanceof HeightMapGap) nodes[0] = new HeightMapGap(from + first.length);
            else nodes.unshift(new HeightMapGap(from - 1), null);
        }
        return HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, force = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, measured = arguments.length > 3 ? arguments[3] : void 0;
        var end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            var nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                var len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                var height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= Epsilon) singleHeight = -2;
                var line = new HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new HeightMapGap(end - pos).updateHeight(oracle, pos));
            var result = HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= Epsilon) oracle.heightChanged = true;
            return result;
        } else if (force || this.outdated) {
            this.setHeight(oracle, oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
    constructor(length){
        super(length, 0);
    }
}
class HeightMapBranch extends HeightMap {
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        var mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        var rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        var left = type == QueryType.ByHeight ? value < rightTop : value < rightOffset;
        var base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        var subQuery = type == QueryType.ByPosNoHeight ? QueryType.ByPosNoHeight : QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        var rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            var mid = this.lineAt(rightOffset, QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        var rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        var result = [];
        if (from > 0) this.decomposeLeft(from, result);
        var left = result.length;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                result.push(node);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (from > 0) mergeGaps(result, left - 1);
        if (to < this.length) {
            var right = result.length;
            this.decomposeRight(to, result);
            mergeGaps(result, right);
        }
        return HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        var left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        var left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = left;
        this.right = right;
        this.height = left.height + right.height;
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, force = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, measured = arguments.length > 3 ? arguments[3] : void 0;
        var _this = this, left = _this.left, right = _this.right, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
}
function mergeGaps(nodes, around) {
    var before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof HeightMapGap && (after = nodes[around + 1]) instanceof HeightMapGap) nodes.splice(around - 1, 3, new HeightMapGap(before.length + 1 + after.length));
}
var relevantWidgetHeight = 5;
class NodeBuilder {
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            var end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            var height = deco.widget ? deco.widget.estimatedHeight : 0;
            var breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            var len = to - from;
            if (deco.block) this.addBlock(new HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        var _this_oracle_doc_lineAt = this.oracle.doc.lineAt(this.pos), from = _this_oracle_doc_lineAt.from, to = _this_oracle_doc_lineAt.to;
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        var gap = new HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        var last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof HeightMapText) return last;
        var line = new HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        var deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        var line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        var last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof HeightMapText) && !this.isCovered) this.nodes.push(new HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        var pos = from;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node instanceof HeightMapText) node.updateHeight(this.oracle, pos);
                pos += node ? node.length : 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        var builder = new NodeBuilder(from, oracle);
        (0, _state.RangeSet).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
}
function heightRelevantDecoChanges(a, b, diff) {
    var comp = new DecorationComparator;
    (0, _state.RangeSet).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class DecorationComparator {
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) addRange(from, to, this.changes, 5);
    }
    constructor(){
        this.changes = [];
    }
}
function visiblePixelRange(dom, paddingTop) {
    var rect = dom.getBoundingClientRect();
    var doc = dom.ownerDocument, win = doc.defaultView || window;
    var left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    var top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(var parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            var elt = parent;
            var style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                var parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = parent == dom.parentNode ? parentRect.bottom : Math.min(bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function fullPixelRange(dom, paddingTop) {
    var rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class LineGap {
    static same(a, b) {
        if (a.length != b.length) return false;
        for(var i = 0; i < a.length; i++){
            var gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return Decoration.replace({
            widget: new LineGapWidget(this.size * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
    constructor(from, to, size){
        this.from = from;
        this.to = to;
        this.size = size;
    }
}
class LineGapWidget extends WidgetType {
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        var elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
}
class ViewState {
    updateForViewport() {
        var _this = this, _loop = function(i) {
            var pos = i ? main.head : main.anchor;
            if (!viewports.some((param)=>{
                var from = param.from, to = param.to;
                return pos >= from && pos <= to;
            })) {
                var _this_lineBlockAt = _this.lineBlockAt(pos), from = _this_lineBlockAt.from, to = _this_lineBlockAt.to;
                viewports.push(new Viewport(from, to));
            }
        };
        var viewports = [
            this.viewport
        ], main = this.state.selection.main;
        for(var i = 0; i <= 1; i++)_loop(i);
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? IdScaler : new BigScaler(this.heightOracle, this.heightMap, this.viewports);
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push(this.scaler.scale == 1 ? block : scaleBlock(block, this.scaler));
        });
    }
    update(update) {
        var scrollTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        this.state = update.state;
        var prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet(decorations).filter((d)=>typeof d != "function");
        var contentChanges = update.changedRanges;
        var heightChanges = ChangedRange.extendWithRanges(contentChanges, heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, _state.ChangeSet).empty(this.state.doc.length)));
        var prevHeight = this.heightMap.height;
        var scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = this.heightMap.height;
        }
        var viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        var updateLines = !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */  || viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        this.updateForViewport();
        if (updateLines) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges();
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet(nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        var dom = view.contentDOM, style = window.getComputedStyle(dom);
        var oracle = this.heightOracle;
        var whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? Direction.RTL : Direction.LTR;
        var refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        var domRect = dom.getBoundingClientRect();
        var measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        var result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            var _getScale = getScale(dom, domRect), scaleX = _getScale.scaleX, scaleY = _getScale.scaleY;
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 8 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        var paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        var paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 10 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 8 /* UpdateFlag.Geometry */ ;
        }
        var scrollTop = view.scrollDOM.scrollTop * this.scaleY;
        if (this.scrollTop != scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = scrollTop;
        }
        this.scrolledToBottom = isScrolledToBottom(view.scrollDOM);
        // Pixel viewport
        var pixelViewport = (this.printing ? fullPixelRange : visiblePixelRange)(dom, this.paddingTop);
        var dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        var inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget) return 0;
        var contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 8 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            var lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                var _view_docView_measureTextSize = view.docView.measureTextSize(), lineHeight = _view_docView_measureTextSize.lineHeight, charWidth = _view_docView_measureTextSize.charWidth, textHeight = _view_docView_measureTextSize.textHeight;
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, contentWidth / charWidth, lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 8 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            oracle.heightChanged = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.viewports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var vp = _step.value;
                    var heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                    this.heightMap = (refresh ? HeightMap.empty().applyChanges(this.stateDeco, (0, _state.Text).empty, this.heightOracle, [
                        new ChangedRange(0, 0, 0, view.state.doc.length)
                    ]) : this.heightMap).updateHeight(oracle, 0, refresh, new MeasuredHeights(vp.from, heights));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (oracle.heightChanged) result |= 2 /* UpdateFlag.Height */ ;
        }
        var viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) this.viewport = this.getViewport(bias, this.scrollTarget);
        this.updateForViewport();
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        var marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        var map = this.heightMap, oracle = this.heightOracle;
        var _this = this, visibleTop = _this.visibleTop, visibleBottom = _this.visibleBottom;
        var viewport = new Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            var head = scrollTarget.range.head;
            if (head < viewport.from || head > viewport.to) {
                var viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                var block = map.lineAt(head, QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new Viewport(map.lineAt(topPos - 500, QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        var from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new Viewport(this.heightMap.lineAt(from, QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate(param) {
        var from = param.from, to = param.to, bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (!this.inView) return true;
        var top = this.heightMap.lineAt(from, QueryType.ByPos, this.heightOracle, 0, 0).top;
        var bottom = this.heightMap.lineAt(to, QueryType.ByPos, this.heightOracle, 0, 0).bottom;
        var _this = this, visibleTop = _this.visibleTop, visibleBottom = _this.visibleBottom;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        var mapped = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = gaps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var gap = _step.value;
                if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        var wrapping = this.heightOracle.lineWrapping;
        var margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != Direction.LTR && !wrapping) return [];
        var gaps = [];
        var addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            var sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = avoid[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var pos = _step.value;
                    if (pos > from && pos < to) {
                        addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                        addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                        return;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var gap = find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    var lineStart = mayMeasure.moveToLineBoundary((0, _state.EditorSelection).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                gap = new LineGap(from, to, this.gapSize(line, from, to, structure));
            }
            gaps.push(gap);
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.viewportLines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                if (line.length < doubleMargin) continue;
                var structure = lineStructure(line.from, line.to, this.stateDeco);
                if (structure.total < doubleMargin) continue;
                var target = this.scrollTarget ? this.scrollTarget.range.head : null;
                var viewFrom = void 0, viewTo = void 0;
                if (wrapping) {
                    var marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                    var top = void 0, bot = void 0;
                    if (target != null) {
                        var targetFrac = findFraction(structure, target);
                        var spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                        top = targetFrac - spaceFrac;
                        bot = targetFrac + spaceFrac;
                    } else {
                        top = (this.visibleTop - line.top - marginHeight) / line.height;
                        bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                    }
                    viewFrom = findPosition(structure, top);
                    viewTo = findPosition(structure, bot);
                } else {
                    var totalWidth = structure.total * this.heightOracle.charWidth;
                    var marginWidth = margin * this.heightOracle.charWidth;
                    var left = void 0, right = void 0;
                    if (target != null) {
                        var targetFrac1 = findFraction(structure, target);
                        var spaceFrac1 = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + marginWidth) / totalWidth;
                        left = targetFrac1 - spaceFrac1;
                        right = targetFrac1 + spaceFrac1;
                    } else {
                        left = (this.pixelViewport.left - marginWidth) / totalWidth;
                        right = (this.pixelViewport.right + marginWidth) / totalWidth;
                    }
                    viewFrom = findPosition(structure, left);
                    viewTo = findPosition(structure, right);
                }
                if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
                if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return gaps;
    }
    gapSize(line, from, to, structure) {
        var fraction = findFraction(structure, to) - findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = Decoration.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges() {
        var deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        var ranges = [];
        (0, _state.RangeSet).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from,
                    to
                });
            },
            point () {}
        }, 20);
        var changed = ranges.length != this.visibleRanges.length || this.visibleRanges.some((r, i)=>r.from != ranges[i].from || r.to != ranges[i].to);
        this.visibleRanges = ranges;
        return changed ? 4 /* UpdateFlag.Viewport */  : 0;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || scaleBlock(this.heightMap.lineAt(pos, QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(scrollTop) {
        var block = this.lineBlockAtHeight(scrollTop + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        this.scrollTop = 0; // Last seen scrollDOM.scrollTop, scaled
        this.scrolledToBottom = true;
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = Direction.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        var guessWrapping = state.facet(contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new HeightOracle(guessWrapping);
        this.stateDeco = state.facet(decorations).filter((d)=>typeof d != "function");
        this.heightMap = HeightMap.empty().applyChanges(this.stateDeco, (0, _state.Text).empty, this.heightOracle.setDoc(state.doc), [
            new ChangedRange(0, 0, 0, state.doc.length)
        ]);
        this.viewport = this.getViewport(0, null);
        this.updateViewportLines();
        this.updateForViewport();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = Decoration.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.computeVisibleRanges();
    }
}
class Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function lineStructure(from, to, stateDeco) {
    var ranges = [], pos = from, total = 0;
    (0, _state.RangeSet).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to
        });
        total += to - pos;
    }
    return {
        total,
        ranges
    };
}
function findPosition(param, ratio) {
    var total = param.total, ranges = param.ranges;
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    var dist = Math.floor(total * ratio);
    for(var i = 0;; i++){
        var _ranges_i = ranges[i], from = _ranges_i.from, to = _ranges_i.to, size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function findFraction(structure, pos) {
    var counted = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = structure.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
            if (pos <= to) {
                counted += pos - from;
                break;
            }
            counted += to - from;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return counted / structure.total;
}
function find(array, f) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var val = _step.value;
            if (f(val)) return val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
var IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class BigScaler {
    toDOM(n) {
        for(var i = 0, base = 0, domBase = 0;; i++){
            var vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(var i = 0, base = 0, domBase = 0;; i++){
            var vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    constructor(oracle, heightMap, viewports){
        var vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map((param)=>{
            var from = param.from, to = param.to;
            var top = heightMap.lineAt(from, QueryType.ByPos, oracle, 0, 0).top;
            var bottom = heightMap.lineAt(to, QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from,
                to,
                top,
                bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.viewports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var obj = _step.value;
                obj.domTop = domBase + (obj.top - base) * this.scale;
                domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
                base = obj.bottom;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
function scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    var bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new BlockInfo(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>scaleBlock(b, scaler)) : block._content);
}
var theme = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (strs)=>strs.join(" ")
});
var darkTheme = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.indexOf(true) > -1
});
var baseThemeID = /*@__PURE__*/ (0, _styleMod.StyleModule).newName(), baseLightID = /*@__PURE__*/ (0, _styleMod.StyleModule).newName(), baseDarkID = /*@__PURE__*/ (0, _styleMod.StyleModule).newName();
var lightDarkIDs = {
    "&light": "." + baseLightID,
    "&dark": "." + baseDarkID
};
function buildTheme(main, spec, scopes) {
    return new (0, _styleMod.StyleModule)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
var baseTheme$1 = /*@__PURE__*/ buildTheme("." + baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#444"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        insetInlineStart: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-highlightSpace:before": {
        content: "attr(data-display)",
        position: "absolute",
        pointerEvents: "none",
        color: "#888"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, lightDarkIDs);
var LineBreakPlaceholder = "\uFFFF";
class DOMReader {
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        var parent = start.parentNode;
        for(var cur = start;;){
            this.findPointBefore(parent, cur);
            var oldLen = this.text.length;
            this.readNode(cur);
            var next = cur.nextSibling;
            if (next == end) break;
            var view = ContentView.get(cur), nextView = ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : isBlockElement(cur)) || isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore) && this.text.length > oldLen) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        var text = node.nodeValue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var point = _step.value;
                if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            var nextBreak = -1, breakSize = 1, m = void 0;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.points[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var point1 = _step1.value;
                        if (point1.node == node && point1.pos > this.text.length) point1.pos -= breakSize - 1;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        var view = ContentView.get(node);
        var fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(var i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var point = _step.value;
                if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    findPointInside(node, length) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var point = _step.value;
                if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + (isAtEnd(node, point.node, point.offset) ? length : 0);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, _state.EditorState).lineSeparator);
    }
}
function isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < maxOffset(node)) return false;
        if (node == parent) return true;
        offset = domIndex(node) + 1;
        node = node.parentNode;
    }
}
function isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
class DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        var _view_docView = view.docView, iHead = _view_docView.impreciseHead, iAnchor = _view_docView.impreciseAnchor;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
            var selPoints = iHead || iAnchor ? [] : selectionPoints(view);
            var reader = new DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = selectionFromPoints(selPoints, this.bounds.from);
        } else {
            var domSel = view.observer.selectionRange;
            var head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            var anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            var vp = view.viewport;
            if ((browser.ios || browser.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
                var from = Math.min(head, anchor), to = Math.max(head, anchor);
                var offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            this.newSel = (0, _state.EditorSelection).single(anchor, head);
        }
    }
}
function applyDOMChange(view, domChange) {
    var change;
    var newSel = domChange.newSel, sel = view.state.selection.main;
    var lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        var _domChange_bounds = domChange.bounds, from = _domChange_bounds.from, to = _domChange_bounds.to;
        var preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        var diff = findDiff(view.state.doc.sliceString(from, to, LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if (browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == LineBreakPlaceholder + LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, _state.Text).of(domChange.text.slice(diff.from, diff.toB).split(LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet(editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if ((browser.mac || browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, _state.EditorSelection).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, _state.Text).of([
                " "
            ])
        };
    } else if (browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, _state.EditorSelection).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, _state.Text).of([
                " "
            ])
        };
    }
    if (change) {
        if (browser.ios && view.inputState.flushIOSKey(change)) return true;
        // Android browsers don't fire reasonable key events for enter,
        // backspace, or delete. So this detects changes that look like
        // they're caused by those keys, and reinterprets them as key
        // events. (Some of these keys are also handled by beforeinput
        // events and the pendingAndroidKey mechanism, but that's not
        // reliable in all situations.)
        if (browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
        // after a completion when you press enter
        (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && dispatchKey(view.contentDOM, "Delete", 46))) return true;
        var text = change.insert.toString();
        if (view.inputState.composing >= 0) view.inputState.composing++;
        var defaultTr;
        var defaultInsert = ()=>defaultTr || (defaultTr = applyDefaultInsert(view, change, newSel));
        if (!view.state.facet(inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
        return true;
    } else if (newSel && !newSel.main.eq(sel)) {
        var scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView,
            userEvent
        });
        return true;
    } else return false;
}
function applyDefaultInsert(view, change, newSel) {
    var tr, startState = view.state, sel = startState.selection.main;
    if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        var before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        var after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        var changes = startState.changes(change);
        var mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
            var replaced = view.state.sliceDoc(change.from, change.to);
            var compositionRange, composition = newSel && findCompositionNode(view, newSel.main.head);
            if (composition) {
                var dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            var offset = sel.to - change.to, size = sel.to - sel.from;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes,
                    range: mainSel || range.map(changes)
                };
                var to = range.to - offset, from = to - replaced.length;
                if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                range.to >= compositionRange.from && range.from <= compositionRange.to) return {
                    range
                };
                var rangeChanges = startState.changes({
                    from,
                    to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, _state.EditorSelection).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    var userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent,
        scrollIntoView: true
    });
}
function findDiff(a, b, preferredPos, preferredSide) {
    var minLen = Math.min(a.length, b.length);
    var from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    var toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        var adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        var move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        var move1 = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move1;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from,
        toA,
        toB
    };
}
function selectionPoints(view) {
    var result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    var _view_observer_selectionRange = view.observer.selectionRange, anchorNode = _view_observer_selectionRange.anchorNode, anchorOffset = _view_observer_selectionRange.anchorOffset, focusNode = _view_observer_selectionRange.focusNode, focusOffset = _view_observer_selectionRange.focusOffset;
    if (anchorNode) {
        result.push(new DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    var anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, _state.EditorSelection).single(anchor + base, head + base) : null;
}
var observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
var useCharData = browser.ie && browser.ie_version <= 11;
class DOMObserver {
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if (event.type == "change" && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = gaps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var gap = _step.value;
                    this.gapIntersection.observe(gap);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        var wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        var view = this.view, sel = this.selectionRange;
        if (view.state.facet(editable) ? view.root.activeElement != this.dom : !hasSelection(view.dom, sel)) return;
        var context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if ((browser.ie && browser.ie_version <= 11 || browser.android && browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        var view = this.view;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        var range = browser.safari && view.root.nodeType == 11 && deepActiveElement(this.dom.ownerDocument) == this.dom && safariSelectionRangeHack(this.view) || getSelection(view.root);
        if (!range || this.selectionRange.eq(range)) return false;
        var local = hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        var i = 0, changed = null;
        for(var dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.scrollTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var dom1 = _step.value;
                    dom1.removeEventListener("scroll", this.onScroll);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = (this.scrollTargets = changed)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var dom2 = _step1.value;
                    dom2.addEventListener("scroll", this.onScroll);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, observeOptions);
        if (useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if (useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            var flush = ()=>{
                var _$key = this.delayedAndroidKey;
                if (_$key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = _$key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    var flushed = this.flush();
                    if (!flushed && _$key.force) dispatchKey(this.dom, _$key.key, _$key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key,
            keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.observer.takeRecords()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mut = _step.value;
                this.queue.push(mut);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return this.queue;
    }
    processRecords() {
        var records = this.pendingRecords();
        if (records.length) this.queue = [];
        var from = -1, to = -1, typeOver = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = records[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var record = _step.value;
                var range = this.readMutation(record);
                if (!range) continue;
                if (range.typeOver) typeOver = true;
                var ref;
                if (from == -1) ref = range, from = ref.from, to = ref.to, ref;
                else {
                    from = Math.min(range.from, from);
                    to = Math.max(range.to, to);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            from,
            to,
            typeOver
        };
    }
    readChange() {
        var _this_processRecords = this.processRecords(), from = _this_processRecords.from, to = _this_processRecords.to, typeOver = _this_processRecords.typeOver;
        var newSel = this.selectionChanged && hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        var change = new DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush() {
        var readSelection = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        var domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        var startState = this.view.state;
        var handled = applyDOMChange(this.view, domChange);
        // The view wasn't updated
        if (this.view.state == startState) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        var cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.flags |= 4 /* ViewFlag.AttrsDirty */ ;
        if (rec.type == "childList") {
            var childBefore = findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            var childAfter = findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) this.printQuery.addEventListener("change", this.onPrint);
        else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) this.printQuery.removeEventListener("change", this.onPrint);
        else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.scrollTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dom = _step.value;
                dom.removeEventListener("scroll", this.onScroll);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
    }
    constructor(view){
        this.view = view;
        this.active = false;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mut = _step.value;
                    this.queue.push(mut);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if ((browser.ie && browser.ie_version <= 11 || browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
}
function findChild(cView, dom, dir) {
    while(dom){
        var curView = ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        var parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function safariSelectionRangeHack(view) {
    var found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    if (!found) return null;
    var anchorNode = found.startContainer, anchorOffset = found.startOffset;
    var focusNode = found.endContainer, focusOffset = found.endOffset;
    var curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    var ref;
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if (isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) ref = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ], anchorNode = ref[0], anchorOffset = ref[1], focusNode = ref[2], focusOffset = ref[3], ref;
    return {
        anchorNode,
        anchorOffset,
        focusNode,
        focusOffset
    };
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class EditorView {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    dispatch() {
        for(var _len = arguments.length, input = new Array(_len), _key = 0; _key < _len; _key++){
            input[_key] = arguments[_key];
        }
        var trs = input.length == 1 && input[0] instanceof (0, _state.Transaction) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        var redrawn = false, attrsChanged = false, update;
        var state = this.state;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tr = _step.value;
                if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
                state = tr.state;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        var focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation(isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        var pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, _state.EditorState).phrases) != this.state.facet((0, _state.EditorState).phrases)) return this.setState(state);
        update = ViewUpdate.create(this, state, transactions);
        update.flags |= focusFlag;
        var scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = transactions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var tr1 = _step1.value;
                    if (scrollTarget) scrollTarget = scrollTarget.map(tr1.changes);
                    if (tr1.scrollIntoView) {
                        var main = tr1.state.selection.main;
                        scrollTarget = new ScrollTarget(main.empty ? main : (0, _state.EditorSelection).cursor(main.head, main.head > main.anchor ? -1 : 1));
                    }
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = tr1.effects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _$e = _step2.value;
                            if (_$e.is(scrollIntoView)) scrollTarget = _$e.value.clip(this.state);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet(styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet(theme) != update.state.facet(theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
        if (!update.empty) try {
            for(var _iterator3 = this.state.facet(updateListener)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                var listener = _step3.value;
                try {
                    listener(update);
                } catch (e) {
                    logException(this.state, e, "update listener");
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                }
            } finally{
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!applyDOMChange(this, domChange) && pendingKey.force) dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        var hadFocus = this.hasFocus;
        try {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var plugin = _step.value;
                    plugin.destroy(this);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.viewState = new ViewState(newState);
            this.plugins = newState.facet(viewPlugin).map((spec)=>new PluginInstance(spec));
            this.pluginMap.clear();
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = this.plugins[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var plugin1 = _step1.value;
                    plugin1.update(this);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            this.docView.destroy();
            this.docView = new DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        var prevSpecs = update.startState.facet(viewPlugin), specs = update.state.facet(viewPlugin);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (prevSpecs != specs) {
            var newPlugins = [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = specs[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var spec = _step.value;
                    var found = prevSpecs.indexOf(spec);
                    if (found < 0) newPlugins.push(new PluginInstance(spec));
                    else {
                        var plugin = this.plugins[found];
                        plugin.mustUpdate = update;
                        newPlugins.push(plugin);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator1 = this.plugins[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                    var plugin1 = _step1.value;
                    if (plugin1.mustUpdate != update) plugin1.destroy(this);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else try {
            for(var _iterator2 = this.plugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion = true){
                var p = _step2.value;
                p.mustUpdate = update;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                var val = plugin.value;
                if (val && val.docViewUpdate) try {
                    val.docViewUpdate(this);
                } catch (e) {
                    logException(this.state, e, "doc view update listener");
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    /**
    @internal
    */ measure() {
        var flush = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        var updated = null;
        var sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
        var _this_viewState = this.viewState, scrollAnchorPos = _this_viewState.scrollAnchorPos, scrollAnchorHeight = _this_viewState.scrollAnchorHeight;
        if (Math.abs(scrollTop - this.viewState.scrollTop) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            var _this = this, _loop = function(i) {
                if (scrollAnchorHeight < 0) {
                    if (isScrolledToBottom(sDOM)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = _this.viewState.heightMap.height;
                    } else {
                        var block = _this.viewState.scrollAnchorAt(scrollTop);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                _this.updateState = 1 /* UpdateState.Measuring */ ;
                var changed = _this.viewState.measure(_this);
                if (!changed && !_this.measureRequests.length && _this.viewState.scrollTarget == null) return "break";
                if (i > 5) {
                    console.warn(_this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    return "break";
                }
                var measuring = [];
                var ref;
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) ref = [
                    measuring,
                    _this.measureRequests
                ], _this.measureRequests = ref[0], measuring = ref[1], ref;
                var measured = measuring.map((m)=>{
                    try {
                        return m.read(_this);
                    } catch (e) {
                        logException(_this.state, e);
                        return BadMeasure;
                    }
                });
                var update = ViewUpdate.create(_this, _this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                _this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    _this.updatePlugins(update);
                    _this.inputState.update(update);
                    _this.updateAttrs();
                    redrawn = _this.docView.update(update);
                    if (redrawn) _this.docViewUpdate();
                }
                for(var i1 = 0; i1 < measuring.length; i1++)if (measured[i1] != BadMeasure) try {
                    var m = measuring[i1];
                    if (m.write) m.write(measured[i1], _this);
                } catch (e) {
                    logException(_this.state, e);
                }
                if (redrawn) _this.docView.updateSelection(true);
                if (!update.viewportChanged && _this.measureRequests.length == 0) {
                    if (_this.viewState.editorHeight) {
                        if (_this.viewState.scrollTarget) {
                            _this.docView.scrollIntoView(_this.viewState.scrollTarget);
                            _this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            return "continue";
                        } else {
                            var newAnchorHeight = scrollAnchorPos < 0 ? _this.viewState.heightMap.height : _this.viewState.lineBlockAt(scrollAnchorPos).top;
                            var diff = newAnchorHeight - scrollAnchorHeight;
                            if (diff > 1 || diff < -1) {
                                scrollTop = scrollTop + diff;
                                sDOM.scrollTop = scrollTop / _this.scaleY;
                                scrollAnchorHeight = -1;
                                return "continue";
                            }
                        }
                    }
                    return "break";
                }
            };
            for(var i = 0;; i++){
                var _ret = _loop(i);
                if (_ret === "break") break;
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (updated && !updated.empty) try {
            for(var _iterator = this.state.facet(updateListener)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var listener = _step.value;
                listener(updated);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return baseThemeID + " " + (this.state.facet(darkTheme) ? baseDarkID : baseLightID) + " " + this.state.facet(theme);
    }
    updateAttrs() {
        var editorAttrs = attrsFromFacet(this, editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        var contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            translate: "no",
            contenteditable: !this.state.facet(editable) ? "false" : "true",
            class: "cm-content",
            style: `${browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        attrsFromFacet(this, contentAttributes, contentAttrs);
        var changed = this.observer.ignore(()=>{
            var changedContent = updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            var changedEditor = updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        var first = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = trs[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var tr = _step.value;
                try {
                    for(var _iterator1 = tr.effects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var effect = _step1.value;
                        if (effect.is(EditorView.announce)) {
                            if (first) this.announceDOM.textContent = "";
                            first = false;
                            var div = this.announceDOM.appendChild(document.createElement("div"));
                            div.textContent = effect.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet(styleModule);
        var nonce = this.state.facet(EditorView.cspNonce);
        (0, _styleMod.StyleModule).mount(this.root, this.styleModules.concat(baseTheme$1).reverse(), nonce ? {
            nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(var i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        var known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.spec != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.spec == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return skipAtoms(this, start, moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return skipAtoms(this, start, moveByChar(this, start, forward, (initial)=>byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        var order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        var span = order[end ? order.length - 1 : 0];
        return (0, _state.EditorSelection).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward) {
        var includeWrap = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        return moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return skipAtoms(this, start, moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords) {
        var precise = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        this.readMeasured();
        return posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        this.readMeasured();
        var rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        var line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        var span = order[BidiSpan.find(order, pos - line.from, -1, side)];
        return flattenRect(rect, span.dir == Direction.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        var perLine = this.state.facet(perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > MaxBidiLine) return trivialOrder(line.length);
        var dir = this.textDirectionAt(line.from), isolates;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.bidiCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.from == line.from && entry.dir == dir && (entry.fresh || isolatesEq(entry.isolates, isolates = getIsolatedRanges(this, line)))) return entry.order;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!isolates) isolates = getIsolatedRanges(this, line);
        var order = computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                plugin.destroy(this);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return scrollIntoView.of(new ScrollTarget(typeof pos == "number" ? (0, _state.EditorSelection).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        var _this_scrollDOM = this.scrollDOM, scrollTop = _this_scrollDOM.scrollTop, scrollLeft = _this_scrollDOM.scrollLeft;
        var ref = this.viewState.scrollAnchorAt(scrollTop);
        return scrollIntoView.of(new ScrollTarget((0, _state.EditorSelection).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return ViewPlugin.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return ViewPlugin.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        var prefix = (0, _styleMod.StyleModule).newName();
        var result = [
            theme.of(prefix),
            styleModule.of(buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push(darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, _state.Prec).lowest(styleModule.of(buildTheme("." + baseThemeID, spec, lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        var content = dom.querySelector(".cm-content");
        var cView = content && ContentView.get(content) || ContentView.get(dom);
        return ((_a = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(ref){
        var config = ref === void 0 ? {} : ref;
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        var dispatch = config.dispatch;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || getRoot(config.parent) || document;
        this.viewState = new ViewState(config.state || (0, _state.EditorState).create(config));
        if (config.scrollTo && config.scrollTo.is(scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet(viewPlugin).map((spec)=>new PluginInstance(spec));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                plugin.update(this);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.observer = new DOMObserver(this);
        this.inputState = new InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ EditorView.styleModule = styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ EditorView.inputHandler = inputHandler;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ EditorView.scrollHandler = scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ EditorView.focusChangeEffect = focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ EditorView.perLineTextDirection = perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ EditorView.exceptionSink = exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ EditorView.updateListener = updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ EditorView.editable = editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ EditorView.mouseSelectionStyle = mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ EditorView.dragMovesSelection = dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ EditorView.clickAddsSelectionRange = clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ EditorView.decorations = decorations;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping \`outerDecorations\` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ EditorView.outerDecorations = outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ EditorView.atomicRanges = atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ EditorView.bidiIsolatedRanges = bidiIsolatedRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ EditorView.scrollMargins = scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ EditorView.darkTheme = darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ EditorView.cspNonce = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ EditorView.contentAttributes = contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ EditorView.editorAttributes = editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ EditorView.lineWrapping = /*@__PURE__*/ EditorView.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ EditorView.announce = /*@__PURE__*/ (0, _state.StateEffect).define();
// Maximum line length for which we compute accurate bidi info
var MaxBidiLine = 4096;
var BadMeasure = {};
class CachedOrder {
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        var result = [], lastDir = cache.length ? cache[cache.length - 1].dir : Direction.LTR;
        for(var i = Math.max(0, cache.length - 10); i < cache.length; i++){
            var entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
}
function attrsFromFacet(view, facet, base) {
    for(var sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        var source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) combineAttrs(value, base);
    }
    return base;
}
var currentPlatform = browser.mac ? "mac" : browser.windows ? "win" : browser.linux ? "linux" : "key";
function normalizeKeyName(name, platform) {
    var parts = name.split(/-(?!$)/);
    var result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    var alt, ctrl, shift, meta;
    for(var i = 0; i < parts.length - 1; ++i){
        var mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
var handleKeyEvents = /*@__PURE__*/ (0, _state.Prec).default(/*@__PURE__*/ EditorView.domEventHandlers({
    keydown (event, view) {
        return runHandlers(getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ var keymap = /*@__PURE__*/ (0, _state.Facet).define({
    enables: handleKeyEvents
});
var Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function getKeymap(state) {
    var bindings = state.facet(keymap);
    var map = Keymaps.get(bindings);
    if (!map) Keymaps.set(bindings, map = buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function runScopeHandlers(view, event, scope) {
    return runHandlers(getKeymap(view.state), event, view, scope);
}
var storedPrefix = null;
var PrefixTimeout = 4000;
function buildKeymap(bindings) {
    var platform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : currentPlatform;
    var bound = Object.create(null);
    var isPrefix = Object.create(null);
    var checkPrefix = (name, is)=>{
        var current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    var add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _loop = function(i) {
            var prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        var ourObj = storedPrefix = {
                            view,
                            prefix,
                            scope
                        };
                        setTimeout(()=>{
                            if (storedPrefix == ourObj) storedPrefix = null;
                        }, PrefixTimeout);
                        return true;
                    }
                ]
            };
        };
        var _a, _b;
        var scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        var parts = key.split(/ (?!$)/).map((k)=>normalizeKeyName(k, platform));
        for(var i = 1; i < parts.length; i++)_loop(i);
        var full = parts.join(" ");
        checkPrefix(full, false);
        var binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            var scopes = b.scope ? b.scope.split(" ") : [
                "editor"
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (b.any) try {
                for(var _iterator1 = scopes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var scope = _step1.value;
                    var scopeObj = bound[scope] || (bound[scope] = Object.create(null));
                    if (!scopeObj._any) scopeObj._any = {
                        preventDefault: false,
                        stopPropagation: false,
                        run: []
                    };
                    for(var key in scopeObj)scopeObj[key].run.push(b.any);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var name = b[platform] || b.key;
            if (!name) continue;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = scopes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var scope1 = _step2.value;
                    add(scope1, name, b.run, b.preventDefault, b.stopPropagation);
                    if (b.shift) add(scope1, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return bound;
}
function runHandlers(map, event, view, scope) {
    var name = (0, _w3CKeyname.keyName)(event);
    var charCode = (0, _state.codePointAt)(name, 0), isChar = (0, _state.codePointSize)(charCode) == name.length && name != " ";
    var prefix = "", handled = false, prevented = false, stopPropagation = false;
    if (storedPrefix && storedPrefix.view == view && storedPrefix.scope == scope) {
        prefix = storedPrefix.prefix + " ";
        if (modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            storedPrefix = null;
        }
    }
    var ran = new Set;
    var runFor = (binding)=>{
        if (binding) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = binding.run[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cmd = _step.value;
                    if (!ran.has(cmd)) {
                        ran.add(cmd);
                        if (cmd(view, event)) {
                            if (binding.stopPropagation) stopPropagation = true;
                            return true;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    var scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !(browser.windows && event.ctrlKey && event.altKey) && (baseName = (0, _w3CKeyname.base)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, _w3CKeyname.shift)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class RectangleMarker {
    draw() {
        var elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            var pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            var base = getBase(view);
            return [
                new RectangleMarker(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return rectanglesForRange(view, className, range);
    }
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
}
function getBase(view) {
    var rect = view.scrollDOM.getBoundingClientRect();
    var left = view.textDirection == Direction.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function wrappedLine(view, pos, inside) {
    var range = (0, _state.EditorSelection).cursor(pos);
    return {
        from: Math.max(inside.from, view.moveToLineBoundary(range, false, true).from),
        to: Math.min(inside.to, view.moveToLineBoundary(range, true, true).from),
        type: BlockType.Text
    };
}
function rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    var from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    var ltr = view.textDirection == Direction.LTR;
    var content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = getBase(view);
    var lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    var leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    var rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    var startBlock = blockAt(view, from), endBlock = blockAt(view, to);
    var visualStart = startBlock.type == BlockType.Text ? startBlock : null;
    var visualEnd = endBlock.type == BlockType.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = wrappedLine(view, from, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = wrappedLine(view, to, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        var top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        var bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        var between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == BlockType.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new RectangleMarker(className, left - base.left, top - base.top - 0.01 /* C.Epsilon */ , right - left, bottom - top + 0.01 /* C.Epsilon */ );
    }
    function pieces(param) {
        var top = param.top, bottom = param.bottom, horizontal = param.horizontal;
        var _$pieces = [];
        for(var i = 0; i < horizontal.length; i += 2)_$pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return _$pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        var top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            var fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            var toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == Direction.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        var start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Split the range by visible range and document line
            for(var _iterator = view.visibleRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                if (r.to > start && r.from < end) for(var pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
                    var docLine = view.state.doc.lineAt(pos);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = view.bidiSpans(docLine)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var span = _step1.value;
                            var spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                            if (spanFrom >= endPos) break;
                            if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    pos = docLine.to + 1;
                    if (pos >= endPos) break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top,
            bottom,
            horizontal
        };
    }
    function drawForWidget(block, top) {
        var y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class LayerView {
    update(update) {
        if (update.startState.facet(layerOrder) != update.state.facet(layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        var pos = 0, order = state.facet(layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        var _this_view = this.view, scaleX = _this_view.scaleX, scaleY = _this_view.scaleY;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!sameMarker(p, this.drawn[i]))) {
            var old = this.dom.firstChild, oldI = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = markers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var marker = _step.value;
                    if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                        old = old.nextSibling;
                        oldI++;
                    } else this.dom.insertBefore(marker.draw(), old);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            while(old){
                var next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
}
var layerOrder = /*@__PURE__*/ (0, _state.Facet).define();
/**
Define a layer.
*/ function layer(config) {
    return [
        ViewPlugin.define((v)=>new LayerView(v, config)),
        layerOrder.of(config)
    ];
}
var CanHidePrimary = !browser.ios; // FIXME test IE
var selectionConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        return (0, _state.combineConfig)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function drawSelection() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        selectionConfig.of(config),
        cursorLayer,
        selectionLayer,
        hideNativeSelection,
        nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function getDrawSelectionConfig(state) {
    return state.facet(selectionConfig);
}
function configChanged(update) {
    return update.startState.facet(selectionConfig) != update.state.facet(selectionConfig);
}
var cursorLayer = /*@__PURE__*/ layer({
    above: true,
    markers (view) {
        var state = view.state, conf = state.facet(selectionConfig);
        var cursors = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                var prim = r == state.selection.main;
                if (r.empty ? !prim || CanHidePrimary : conf.drawRangeCursor) {
                    var className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                    var cursor = r.empty ? r : (0, _state.EditorSelection).cursor(r.head, r.head > r.anchor ? -1 : 1);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = RectangleMarker.forRange(view, className, cursor)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var piece = _step1.value;
                            cursors.push(piece);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        var confChange = configChanged(update);
        if (confChange) setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet(selectionConfig).cursorBlinkRate + "ms";
}
var selectionLayer = /*@__PURE__*/ layer({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : RectangleMarker.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || configChanged(update);
    },
    class: "cm-selectionLayer"
});
var themeSpec = {
    ".cm-line": {
        "& ::selection": {
            backgroundColor: "transparent !important"
        },
        "&::selection": {
            backgroundColor: "transparent !important"
        }
    }
};
if (CanHidePrimary) {
    themeSpec[".cm-line"].caretColor = "transparent !important";
    themeSpec[".cm-content"] = {
        caretColor: "transparent !important"
    };
}
var hideNativeSelection = /*@__PURE__*/ (0, _state.Prec).highest(/*@__PURE__*/ EditorView.theme(themeSpec));
var setDropCursorPos = /*@__PURE__*/ (0, _state.StateEffect).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
var dropCursorPos = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is(setDropCursorPos) ? e.value : pos, pos);
    }
});
var drawDropCursor = /*@__PURE__*/ ViewPlugin.fromClass(class {
    update(update) {
        var _a;
        var cursorPos = update.state.field(dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field(dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        var view = this.view;
        var pos = view.state.field(dropCursorPos);
        var rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        var outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            var _this_view = this.view, scaleX = _this_view.scaleX, scaleY = _this_view.scaleY;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field(dropCursorPos) != pos) this.view.dispatch({
            effects: setDropCursorPos.of(pos)
        });
    }
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function dropCursor() {
    return [
        dropCursorPos,
        drawDropCursor
    ];
}
function iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(var cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function matchRanges(view, maxLength) {
    var visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = visible[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
            from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
            to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
            if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
            else result.push({
                from,
                to
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class MatchDecorator {
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        var build = new (0, _state.RangeSetBuilder)(), add = build.add.bind(build);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matchRanges(view, this.maxLength)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
                iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        var changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to > update.view.viewport.from && from < update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportChanged || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _this = this, _loop = function() {
                var r = _step.value;
                var from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
                if (to > from) {
                    var fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                    var start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                    if (_this.boundary) {
                        for(; from > fromLine.from; from--)if (_this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                            start = from;
                            break;
                        }
                        for(; to < toLine.to; to++)if (_this.boundary.test(toLine.text[to - toLine.from])) {
                            end = to;
                            break;
                        }
                    }
                    var ranges = [], m = void 0;
                    var add = (from, to, deco)=>ranges.push(deco.range(from, to));
                    if (fromLine == toLine) {
                        _this.regexp.lastIndex = start - fromLine.from;
                        while((m = _this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)_this.addMatch(m, view, m.index + fromLine.from, add);
                    } else iterMatches(view.state.doc, _this.regexp, start, end, (from, m)=>_this.addMatch(m, view, from, add));
                    deco = deco.update({
                        filterFrom: start,
                        filterTo: end,
                        filter: (from, to)=>from < start || to > end,
                        add: ranges
                    });
                }
            };
            for(var _iterator = view.visibleRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return deco;
    }
    /**
    Create a decorator.
    */ constructor(config){
        var regexp = config.regexp, decoration = config.decoration, decorate = config.decorate, boundary = config.boundary, _config_maxLength = config.maxLength, maxLength = _config_maxLength === void 0 ? 1000 : _config_maxLength;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            var deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
}
var UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
var Specials = /*@__PURE__*/ new RegExp("[\0-\b\n-\x1f\x7f-\x9f\xad\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\u2066\u2067\u2069\uFEFF\uFFF9-\uFFFC]", UnicodeRegexpSupport);
var Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
var _supportsTabSize = null;
function supportsTabSize() {
    var _a;
    if (_supportsTabSize == null && typeof document != "undefined" && document.body) {
        var styles = document.body.style;
        _supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return _supportsTabSize || false;
}
var specialCharConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        var config = (0, _state.combineConfig)(configs, {
            render: null,
            specialChars: Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !supportsTabSize()) config.specialChars = new RegExp("	|" + config.specialChars.source, UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function highlightSpecialChars() {
    var /**
Configuration options.
*/ config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        specialCharConfig.of(config),
        specialCharPlugin()
    ];
}
var _plugin = null;
function specialCharPlugin() {
    return _plugin || (_plugin = ViewPlugin.fromClass(class {
        makeDecorator(conf) {
            return new MatchDecorator({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    var doc = view.state.doc;
                    var code = (0, _state.codePointAt)(m[0], 0);
                    if (code == 9) {
                        var line = doc.lineAt(pos);
                        var size = view.state.tabSize, col = (0, _state.countColumn)(line.text, size, pos - line.from);
                        return Decoration.replace({
                            widget: new TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = Decoration.replace({
                        widget: new SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            var conf = update.state.facet(specialCharConfig);
            if (update.startState.facet(specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
        constructor(view){
            this.view = view;
            this.decorations = Decoration.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet(specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
var DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function placeholder$1(code) {
    if (code >= 32) return DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class SpecialCharWidget extends WidgetType {
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        var ph = placeholder$1(this.code);
        var desc = view.state.phrase("Control character") + " " + (Names[this.code] || "0x" + this.code.toString(16));
        var custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        var span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
}
class TabWidget extends WidgetType {
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        var span = document.createElement("span");
        span.textContent = "	";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
    constructor(width){
        super();
        this.width = width;
    }
}
var plugin = /*@__PURE__*/ ViewPlugin.fromClass(class {
    update(update) {
        var view = update.view;
        var height = view.viewState.editorHeight * view.scaleY - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function scrollPastEnd() {
    return [
        plugin,
        contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function highlightActiveLine() {
    return activeLineHighlighter;
}
var lineDeco = /*@__PURE__*/ Decoration.line({
    class: "cm-activeLine"
});
var activeLineHighlighter = /*@__PURE__*/ ViewPlugin.fromClass(class {
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        var lastLineStart = -1, deco = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = view.state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                var line = view.lineBlockAt(r.head);
                if (line.from > lastLineStart) {
                    deco.push(lineDeco.range(line.from));
                    lastLineStart = line.from;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Decoration.set(deco);
    }
    constructor(view){
        this.decorations = this.getDeco(view);
    }
}, {
    decorations: (v)=>v.decorations
});
class Placeholder extends WidgetType {
    toDOM() {
        var wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content);
        if (typeof this.content == "string") wrap.setAttribute("aria-label", "placeholder " + this.content);
        else wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        var rects = dom.firstChild ? clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        var style = window.getComputedStyle(dom.parentNode);
        var rect = flattenRect(rects[0], style.direction != "rtl");
        var lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
    constructor(content){
        super();
        this.content = content;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function placeholder(content) {
    return ViewPlugin.fromClass(class {
        get decorations() {
            return this.view.state.doc.length ? Decoration.none : this.placeholder;
        }
        constructor(view){
            this.view = view;
            this.placeholder = content ? Decoration.set([
                Decoration.widget({
                    widget: new Placeholder(content),
                    side: 1
                }).range(0)
            ]) : Decoration.none;
        }
    }, {
        decorations: (v)=>v.decorations
    });
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
var MaxOff = 2000;
function rectangleFor(state, a, b) {
    var startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    var ranges = [];
    if (a.off > MaxOff || b.off > MaxOff || a.col < 0 || b.col < 0) {
        var startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(var i = startLine; i <= endLine; i++){
            var line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, _state.EditorSelection).range(line.from + startOff, line.to + endOff));
        }
    } else {
        var startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(var i1 = startLine; i1 <= endLine; i1++){
            var line1 = state.doc.line(i1);
            var start = (0, _state.findColumn)(line1.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, _state.EditorSelection).cursor(line1.to));
            else {
                var end = (0, _state.findColumn)(line1.text, endCol, state.tabSize);
                ranges.push((0, _state.EditorSelection).range(line1.from + start, line1.from + end));
            }
        }
    }
    return ranges;
}
function absoluteColumn(view, x) {
    var ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function getPos(view, event) {
    var offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    var line = view.state.doc.lineAt(offset), off = offset - line.from;
    var col = off > MaxOff ? -1 : off == line.length ? absoluteColumn(view, event.clientX) : (0, _state.countColumn)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col,
        off
    };
}
function rectangleSelectionStyle(view, event) {
    var start = getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                var newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                var newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            var cur = getPos(view, event);
            if (!cur) return startSel;
            var ranges = rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, _state.EditorSelection).create(ranges.concat(startSel.ranges));
            else return (0, _state.EditorSelection).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function rectangularSelection(options) {
    var filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return EditorView.mouseSelectionStyle.of((view, event)=>filter(event) ? rectangleSelectionStyle(view, event) : null);
}
var keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
var showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function crosshairCursor() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _keys_ = (0, _slicedToArray._)(keys[options.key || "Alt"], 2), code = _keys_[0], getter = _keys_[1];
    var plugin = ViewPlugin.fromClass(class {
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        EditorView.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? showCrosshair : null;
        })
    ];
}
var Outside = "-10000px";
class TooltipViewManager {
    update(update, above) {
        var _a;
        var input = update.state.facet(this.facet);
        var tooltips = input.filter((x)=>x);
        if (input === this.input) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    if (t.update) t.update(update);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return false;
        }
        var tooltipViews = [], newAbove = above ? [] : null;
        for(var i = 0; i < tooltips.length; i++){
            var tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(var i1 = 0; i1 < this.tooltips.length; i1++){
                var other = this.tooltips[i1];
                if (other && other.create == tip.create) known = i1;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                var tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = this.tooltipViews[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var t1 = _step1.value;
                if (tooltipViews.indexOf(t1) < 0) {
                    this.removeTooltipView(t1);
                    (_a = t1.destroy) === null || _a === void 0 || _a.call(t1);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        var prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function tooltips() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return tooltipConfig.of(config);
}
function windowSpace(view) {
    var win = view.win;
    return {
        top: 0,
        left: 0,
        bottom: win.innerHeight,
        right: win.innerWidth
    };
}
var tooltipConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || windowSpace
        };
    }
});
var knownHeight = /*@__PURE__*/ new WeakMap();
var tooltipPlugin = /*@__PURE__*/ ViewPlugin.fromClass(class {
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var tooltip = _step.value;
                    this.intersectionObserver.observe(tooltip.dom);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        var updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        var shouldMeasure = updated || update.geometryChanged;
        var newConfig = update.state.facet(tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    t.dom.style.position = this.position;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = this.manager.tooltipViews[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var t1 = _step1.value;
                    this.container.appendChild(t1.dom);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        var tooltipView = tooltip.create(this.view);
        var before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            var arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.insertBefore(arrow, before);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tooltipView = _step.value;
                tooltipView.dom.remove();
                (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        var editor = this.view.dom.getBoundingClientRect();
        var scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            var dom = this.manager.tooltipViews[0].dom;
            if (browser.gecko) // Firefox sets the element's `offsetParent` to the
            // transformed element when a transform interferes with fixed
            // positioning.
            makeAbsolute = dom.offsetParent != this.container.ownerDocument.body;
            else if (dom.style.top == Outside && dom.style.left == "0px") {
                // On other browsers, we have to awkwardly try and use other
                // information to detect a transform.
                var rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            }
        }
        if (makeAbsolute || this.position == "absolute") {
            var ref;
            if (this.parent) {
                var rect1 = this.parent.getBoundingClientRect();
                if (rect1.width && rect1.height) {
                    scaleX = rect1.width / this.parent.offsetWidth;
                    scaleY = rect1.height / this.parent.offsetHeight;
                }
            } else ref = this.view.viewState, scaleX = ref.scaleX, scaleY = ref.scaleY, ref;
        }
        return {
            editor,
            parent: this.parent ? this.container.getBoundingClientRect() : editor,
            pos: this.manager.tooltips.map((t, i)=>{
                var tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map((param)=>{
                var dom = param.dom;
                return dom.getBoundingClientRect();
            }),
            space: this.view.state.facet(tooltipConfig).tooltipSpace(this.view),
            scaleX,
            scaleY,
            makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    t.dom.style.position = "absolute";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var editor = measured.editor, space = measured.space, scaleX = measured.scaleX, scaleY = measured.scaleY;
        var others = [];
        for(var i = 0; i < this.manager.tooltips.length; i++){
            var tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], dom = tView.dom;
            var pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || pos.bottom <= Math.max(editor.top, space.top) || pos.top >= Math.min(editor.bottom, space.bottom) || pos.right < Math.max(editor.left, space.left) - .1 || pos.left > Math.min(editor.right, space.right) + .1) {
                dom.style.top = Outside;
                continue;
            }
            var arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            var arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            var width = size.right - size.left, height = (_a = knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            var offset = tView.offset || noOffset, ltr = this.view.textDirection == Direction.LTR;
            var left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width) : Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x);
            var above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - (size.bottom - size.top) - offset.y < space.top : pos.bottom + (size.bottom - size.top) + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            var spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = Outside;
                    continue;
                }
                knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            var top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            var right = left + width;
            if (tView.overlap !== true) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = others[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var r = _step1.value;
                        if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                dom.style.left = (left - measured.parent.left) / scaleX + "px";
            } else {
                dom.style.top = top / scaleY + "px";
                dom.style.left = left / scaleX + "px";
            }
            if (arrow) {
                var arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left,
                top,
                right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (!this.inView) try {
                    for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tv = _step.value;
                        tv.dom.style.top = Outside;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        var config = view.state.facet(tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new TooltipViewManager(view, showTooltip, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
var baseTheme = /*@__PURE__*/ EditorView.baseTheme({
    ".cm-tooltip": {
        zIndex: 100,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
var noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ var showTooltip = /*@__PURE__*/ (0, _state.Facet).define({
    enables: [
        tooltipPlugin,
        baseTheme
    ]
});
var showHoverTooltip = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new HoverTooltipHost(view);
    }
    createHostedView(tooltip, prev) {
        var hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var hostedView = _step.value;
                if (hostedView.mount) hostedView.mount(view);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.mounted = true;
    }
    positioned(space) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var hostedView = _step.value;
                if (hostedView.positioned) hostedView.positioned(space);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                (_a = t.destroy) === null || _a === void 0 || _a.call(t);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    passProp(name) {
        var value = undefined;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.manager.tooltipViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var view = _step.value;
                var given = view[name];
                if (given !== undefined) {
                    if (value === undefined) value = given;
                    else if (value !== given) return undefined;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new TooltipViewManager(view, showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
}
var showHoverTooltipHost = /*@__PURE__*/ showTooltip.compute([
    showHoverTooltip
], (state)=>{
    var tooltips = state.facet(showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class HoverPlugin {
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        var hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        var _this = this, view = _this.view, lastMove = _this.lastMove;
        var desc = view.docView.nearest(lastMove.target);
        if (!desc) return;
        var pos, side = 1;
        if (desc instanceof WidgetView) pos = desc.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            var posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            var bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            var rtl = bidi && bidi.dir == Direction.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        var open = this.source(view, pos, side);
        if (open === null || open === void 0 ? void 0 : open.then) {
            var pending = this.pending = {
                pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result && !(Array.isArray(result) && !result.length)) view.dispatch({
                        effects: this.setHover.of(Array.isArray(result) ? result : [
                            result
                        ])
                    });
                }
            }, (e)=>logException(view.state, e, "hover tooltip"));
        } else if (open && !(Array.isArray(open) && !open.length)) view.dispatch({
            effects: this.setHover.of(Array.isArray(open) ? open : [
                open
            ])
        });
    }
    get tooltip() {
        var plugin = this.view.plugin(tooltipPlugin);
        var index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        var _this = this, active = _this.active, tooltip = _this.tooltip;
        if (active.length && tooltip && !isInTooltip(tooltip.dom, event) || this.pending) {
            var pos = (active[0] || this.pending).pos, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        var active = this.active;
        if (active.length) {
            var tooltip = this.tooltip;
            var inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        var watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            if (this.active.length && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
}
var tooltipMargin = 4;
function isInTooltip(tooltip, event) {
    var rect = tooltip.getBoundingClientRect();
    return event.clientX >= rect.left - tooltipMargin && event.clientX <= rect.right + tooltipMargin && event.clientY >= rect.top - tooltipMargin && event.clientY <= rect.bottom + tooltipMargin;
}
function isOverRange(view, from, to, x, y, margin) {
    var rect = view.scrollDOM.getBoundingClientRect();
    var docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    var pos = view.posAtCoords({
        x,
        y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.
*/ function hoverTooltip(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var setHover = (0, _state.StateEffect).define();
    var hoverState = (0, _state.StateField).define({
        create () {
            return [];
        },
        update (value, tr) {
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
                if (tr.docChanged) {
                    var mapped = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var tooltip = _step.value;
                            var newPos = tr.changes.mapPos(tooltip.pos, -1, (0, _state.MapMode).TrackDel);
                            if (newPos != null) {
                                var copy = Object.assign(Object.create(null), tooltip);
                                copy.pos = newPos;
                                if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                                mapped.push(copy);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    value = mapped;
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = tr.effects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var effect = _step1.value;
                    if (effect.is(setHover)) value = effect.value;
                    if (effect.is(closeHoverTooltipEffect)) value = [];
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return value;
        },
        provide: (f)=>showHoverTooltip.from(f)
    });
    return [
        hoverState,
        ViewPlugin.define((view)=>new HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Hover.Time */ )),
        showHoverTooltipHost
    ];
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function getTooltip(view, tooltip) {
    var plugin = view.plugin(tooltipPlugin);
    if (!plugin) return null;
    var found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function hasHoverTooltips(state) {
    return state.facet(showHoverTooltip).some((x)=>x);
}
var closeHoverTooltipEffect = /*@__PURE__*/ (0, _state.StateEffect).define();
/**
Transaction effect that closes all hover tooltips.
*/ var closeHoverTooltips = /*@__PURE__*/ closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function repositionTooltips(view) {
    var plugin = view.plugin(tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
var panelConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        var topContainer, bottomContainer;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = configs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                topContainer = topContainer || c.topContainer;
                bottomContainer = bottomContainer || c.bottomContainer;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            topContainer,
            bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function panels(config) {
    return config ? [
        panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function getPanel(view, panel) {
    var plugin = view.plugin(panelPlugin);
    var index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
var panelPlugin = /*@__PURE__*/ ViewPlugin.fromClass(class {
    update(update) {
        var conf = update.state.facet(panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        var input = update.state.facet(showPanel);
        if (input != this.input) {
            var specs = input.filter((x)=>x);
            var panels = [], top = [], bottom = [], mount = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = specs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var spec = _step.value;
                    var known = this.specs.indexOf(spec), panel = void 0;
                    if (known < 0) {
                        panel = spec(update.view);
                        mount.push(panel);
                    } else {
                        panel = this.panels[known];
                        if (panel.update) panel.update(update);
                    }
                    panels.push(panel);
                    (panel.top ? top : bottom).push(panel);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = mount[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var p = _step1.value;
                    p.dom.classList.add("cm-panel");
                    if (p.mount) p.mount();
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        } else {
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = this.panels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var p1 = _step2.value;
                    if (p1.update) p1.update(update);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
    constructor(view){
        this.input = view.state.facet(showPanel);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        var conf = view.state.facet(panelConfig);
        this.top = new PanelGroup(view, true, conf.topContainer);
        this.bottom = new PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.panels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}, {
    provide: (plugin)=>EditorView.scrollMargins.of((view)=>{
            var value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class PanelGroup {
    sync(panels) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.panels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                if (p.destroy && panels.indexOf(p) < 0) p.destroy();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            var parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        var curDOM = this.dom.firstChild;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.panels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var panel = _step.value;
                if (panel.dom.parentNode == this.dom) {
                    while(curDOM != panel.dom)curDOM = rm(curDOM);
                    curDOM = curDOM.nextSibling;
                } else this.dom.insertBefore(panel.dom, curDOM);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        while(curDOM)curDOM = rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.classes.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cls = _step.value;
                if (cls) this.container.classList.remove(cls);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = (this.classes = this.view.themeClasses).split(" ")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var cls1 = _step1.value;
                if (cls1) this.container.classList.add(cls1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
}
function rm(node) {
    var next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ var showPanel = /*@__PURE__*/ (0, _state.Facet).define({
    enables: panelPlugin
});
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class GutterMarker extends (0, _state.RangeValue) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
GutterMarker.prototype.elementClass = "";
GutterMarker.prototype.toDOM = undefined;
GutterMarker.prototype.mapMode = (0, _state.MapMode).TrackBefore;
GutterMarker.prototype.startSide = GutterMarker.prototype.endSide = -1;
GutterMarker.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ var gutterLineClass = /*@__PURE__*/ (0, _state.Facet).define();
var defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, _state.RangeSet).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
};
var activeGutters = /*@__PURE__*/ (0, _state.Facet).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function gutter(config) {
    return [
        gutters(),
        activeGutters.of(Object.assign(Object.assign({}, defaults), config))
    ];
}
var unfixGutters = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function gutters(config) {
    var result = [
        gutterView
    ];
    if (config && config.fixed === false) result.push(unfixGutters.of(true));
    return result;
}
var gutterView = /*@__PURE__*/ ViewPlugin.fromClass(class {
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            var vpA = this.prevViewport, vpB = update.view.viewport;
            var vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        if (this.view.state.facet(unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        var after = this.dom.nextSibling;
        if (detach) this.dom.remove();
        var lineClasses = (0, _state.RangeSet).iter(this.view.state.facet(gutterLineClass), this.view.viewport.from);
        var classSet = [];
        var contexts = this.gutters.map((gutter)=>new UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.view.viewportLineBlocks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                if (classSet.length) classSet = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (Array.isArray(line.type)) {
                    var first = true;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator1 = line.type[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                            var b = _step1.value;
                            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            if (b.type == BlockType.Text && first) {
                                advanceCursor(lineClasses, classSet, b.from);
                                var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                try {
                                    for(var _iterator2 = contexts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion4 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion4 = true){
                                        var cx = _step2.value;
                                        cx.line(this.view, b, classSet);
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                                first = false;
                            } else if (b.widget) try {
                                for(var _iterator3 = contexts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                    var cx1 = _step3.value;
                                    cx1.widget(this.view, b);
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                        _iterator3.return();
                                    }
                                } finally{
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else if (line.type == BlockType.Text) {
                    advanceCursor(lineClasses, classSet, line.from);
                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(var _iterator4 = contexts[Symbol.iterator](), _step4; !(_iteratorNormalCompletion5 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion5 = true){
                            var cx2 = _step4.value;
                            cx2.line(this.view, line, classSet);
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                } else if (line.widget) try {
                    for(var _iterator5 = contexts[Symbol.iterator](), _step5; !(_iteratorNormalCompletion1 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion1 = true){
                        var cx3 = _step5.value;
                        cx3.widget(this.view, line);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator5.return != null) {
                            _iterator5.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
        try {
            for(var _iterator6 = contexts[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                var cx4 = _step6.value;
                cx4.finish();
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                    _iterator6.return();
                }
            } finally{
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }
        if (detach) this.view.scrollDOM.insertBefore(this.dom, after);
    }
    updateGutters(update) {
        var prev = update.startState.facet(activeGutters), cur = update.state.facet(activeGutters);
        var change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, _state.RangeSet).eq(update.startState.facet(gutterLineClass), update.state.facet(gutterLineClass), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.gutters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var gutter = _step.value;
                    if (gutter.update(update)) change = true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else {
            change = true;
            var gutters = [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = cur[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var conf = _step1.value;
                    var known = prev.indexOf(conf);
                    if (known < 0) gutters.push(new SingleGutterView(this.view, conf));
                    else {
                        this.gutters[known].update(update);
                        gutters.push(this.gutters[known]);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = this.gutters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var g = _step2.value;
                    g.dom.remove();
                    if (gutters.indexOf(g) < 0) g.destroy();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = gutters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var g1 = _step3.value;
                    this.dom.appendChild(g1.dom);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.gutters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var view = _step.value;
                view.destroy();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.dom.remove();
    }
    constructor(view){
        this.view = view;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet(activeGutters).map((conf)=>new SingleGutterView(view, conf));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.gutters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var gutter = _step.value;
                this.dom.appendChild(gutter.dom);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.fixed = !view.state.facet(unfixGutters);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
}, {
    provide: (plugin)=>EditorView.scrollMargins.of((view)=>{
            var value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            return view.textDirection == Direction.LTR ? {
                left: value.dom.offsetWidth * view.scaleX
            } : {
                right: value.dom.offsetWidth * view.scaleX
            };
        })
});
function asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class UpdateContext {
    addElement(view, block, markers) {
        var gutter = this.gutter, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            var newElt = new GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        var localMarkers = [];
        advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        var forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        var gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        var marker = this.gutter.config.widgetMarker(view, block.widget, block);
        if (marker) this.addElement(view, block, [
            marker
        ]);
    }
    finish() {
        var gutter = this.gutter;
        while(gutter.elements.length > this.i){
            var last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, _state.RangeSet).iter(gutter.markers, viewport.from);
    }
}
class SingleGutterView {
    update(update) {
        var prevMarkers = this.markers;
        this.markers = asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            var updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        var vp = update.view.viewport;
        return !(0, _state.RangeSet).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elt = _step.value;
                elt.destroy();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    constructor(view, config){
        var _this = this, _loop = function(prop) {
            _this.dom.addEventListener(prop, (event)=>{
                var target = event.target, y;
                if (target != _this.dom && _this.dom.contains(target)) {
                    while(target.parentNode != _this.dom)target = target.parentNode;
                    var rect = target.getBoundingClientRect();
                    y = (rect.top + rect.bottom) / 2;
                } else y = event.clientY;
                var line = view.lineBlockAtHeight(y - view.documentTop);
                if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
            });
        };
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(var prop in config.domEventHandlers)_loop(prop);
        this.markers = asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
}
class GutterElement {
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        var cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(var iNew = 0, iOld = 0;;){
            var skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                var c = marker.elementClass;
                if (c) cls += " " + c;
                for(var i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                var next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    var after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
}
function sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(var i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ var lineNumberMarkers = /*@__PURE__*/ (0, _state.Facet).define();
var lineNumberConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (values) {
        return (0, _state.combineConfig)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                var _loop = function(event) {
                    var exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                };
                var result = Object.assign({}, a);
                for(var event in b)_loop(event);
                return result;
            }
        });
    }
});
class NumberMarker extends GutterMarker {
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
    constructor(number){
        super();
        this.number = number;
    }
}
function formatNumber(view, number) {
    return view.state.facet(lineNumberConfig).formatNumber(number, view.state);
}
var lineNumberGutter = /*@__PURE__*/ activeGutters.compute([
    lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet(lineNumberMarkers);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new NumberMarker(formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: ()=>null,
        lineMarkerChange: (update)=>update.startState.facet(lineNumberConfig) != update.state.facet(lineNumberConfig),
        initialSpacer (view) {
            return new NumberMarker(formatNumber(view, maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            var max = formatNumber(update.view, maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new NumberMarker(max);
        },
        domEventHandlers: state.facet(lineNumberConfig).domEventHandlers
    }));
/**
Create a line number gutter extension.
*/ function lineNumbers() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        lineNumberConfig.of(config),
        gutters(),
        lineNumberGutter
    ];
}
function maxLineNumber(lines) {
    var last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
var activeLineGutterMarker = /*@__PURE__*/ new class extends GutterMarker {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
var activeLineGutterHighlighter = /*@__PURE__*/ gutterLineClass.compute([
    "selection"
], (state)=>{
    var marks = [], last = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var range = _step.value;
            var linePos = state.doc.lineAt(range.head).from;
            if (linePos > last) {
                last = linePos;
                marks.push(activeLineGutterMarker.range(linePos));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, _state.RangeSet).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function highlightActiveLineGutter() {
    return activeLineGutterHighlighter;
}
var WhitespaceDeco = /*@__PURE__*/ new Map();
function getWhitespaceDeco(space) {
    var deco = WhitespaceDeco.get(space);
    if (!deco) WhitespaceDeco.set(space, deco = Decoration.mark({
        attributes: space === "	" ? {
            class: "cm-highlightTab"
        } : {
            class: "cm-highlightSpace",
            "data-display": space.replace(/ /g, "\xb7")
        }
    }));
    return deco;
}
function matcher(decorator) {
    return ViewPlugin.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
var whitespaceHighlighter = /*@__PURE__*/ matcher(/*@__PURE__*/ new MatchDecorator({
    regexp: /\t| +/g,
    decoration: (match)=>getWhitespaceDeco(match[0]),
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function highlightWhitespace() {
    return whitespaceHighlighter;
}
var trailingHighlighter = /*@__PURE__*/ matcher(/*@__PURE__*/ new MatchDecorator({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ Decoration.mark({
        class: "cm-trailingSpace"
    }),
    boundary: /\S/
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function highlightTrailingWhitespace() {
    return trailingHighlighter;
}
/**
@internal
*/ var __test = {
    HeightMap,
    HeightOracle,
    MeasuredHeights,
    QueryType,
    ChangedRange,
    computeOrder,
    moveVisually
};

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@codemirror/state":"fECfb","style-mod":"dgaAD","w3c-keyname":"ij6cg","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"fECfb":[function(require,module,exports) {
/**
The data structure for documents. @nonabstract
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Annotation", ()=>Annotation);
parcelHelpers.export(exports, "AnnotationType", ()=>AnnotationType);
parcelHelpers.export(exports, "ChangeDesc", ()=>ChangeDesc);
parcelHelpers.export(exports, "ChangeSet", ()=>ChangeSet);
parcelHelpers.export(exports, "CharCategory", ()=>CharCategory);
parcelHelpers.export(exports, "Compartment", ()=>Compartment);
parcelHelpers.export(exports, "EditorSelection", ()=>EditorSelection);
parcelHelpers.export(exports, "EditorState", ()=>EditorState);
parcelHelpers.export(exports, "Facet", ()=>Facet);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "MapMode", ()=>MapMode);
parcelHelpers.export(exports, "Prec", ()=>Prec);
parcelHelpers.export(exports, "Range", ()=>Range);
parcelHelpers.export(exports, "RangeSet", ()=>RangeSet);
parcelHelpers.export(exports, "RangeSetBuilder", ()=>RangeSetBuilder);
parcelHelpers.export(exports, "RangeValue", ()=>RangeValue);
parcelHelpers.export(exports, "SelectionRange", ()=>SelectionRange);
parcelHelpers.export(exports, "StateEffect", ()=>StateEffect);
parcelHelpers.export(exports, "StateEffectType", ()=>StateEffectType);
parcelHelpers.export(exports, "StateField", ()=>StateField);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "Transaction", ()=>Transaction);
parcelHelpers.export(exports, "codePointAt", ()=>codePointAt);
parcelHelpers.export(exports, "codePointSize", ()=>codePointSize);
parcelHelpers.export(exports, "combineConfig", ()=>combineConfig);
parcelHelpers.export(exports, "countColumn", ()=>countColumn);
parcelHelpers.export(exports, "findClusterBreak", ()=>findClusterBreak);
parcelHelpers.export(exports, "findColumn", ()=>findColumn);
parcelHelpers.export(exports, "fromCodePoint", ()=>fromCodePoint);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
class Text {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        var ref;
        ref = (0, _slicedToArray._)(clip(this, from, to), 2), from = ref[0], to = ref[1], ref;
        var parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length;
        var ref;
        ref = (0, _slicedToArray._)(clip(this, from, to), 2), from = ref[0], to = ref[1], ref;
        var parts = [];
        this.decompose(from, to, parts, 0);
        return TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        var start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        var a = new RawTextCursor(this), b = new RawTextCursor(other);
        for(var skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter() {
        var dir = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        return new RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length;
        return new PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        var inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            var start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        var lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return Text.empty;
        return text.length <= 32 /* Tree.Branch */  ? new TextLeaf(text) : TextNode.from(TextLeaf.split(text, []));
    }
    /**
    @internal
    */ constructor(){}
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class TextLeaf extends Text {
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(var i = 0;; i++){
            var string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new Line(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        var text = from <= 0 && to >= this.length ? this : new TextLeaf(sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            var prev = target.pop();
            var joined = appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new TextLeaf(joined, prev.length + text.length));
            else {
                var mid = joined.length >> 1;
                target.push(new TextLeaf(joined.slice(0, mid)), new TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof TextLeaf)) return super.replace(from, to, text);
        var ref;
        ref = (0, _slicedToArray._)(clip(this, from, to), 2), from = ref[0], to = ref[1], ref;
        var lines = appendText(this.text, appendText(text.text, sliceText(this.text, 0, from)), to);
        var newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new TextLeaf(lines, newLen);
        return TextNode.from(TextLeaf.split(lines, []), newLen);
    }
    sliceString(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length, lineSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "\n";
        var ref;
        ref = (0, _slicedToArray._)(clip(this, from, to), 2), from = ref[0], to = ref[1], ref;
        var result = "";
        for(var pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            var line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                target.push(line);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        var part = [], len = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                part.push(line);
                len += line.length + 1;
                if (part.length == 32 /* Tree.Branch */ ) {
                    target.push(new TextLeaf(part, len));
                    part = [];
                    len = -1;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (len > -1) target.push(new TextLeaf(part, len));
        return target;
    }
    constructor(text, ref){
        var length = ref === void 0 ? textLength(text) : ref;
        super();
        this.text = text;
        this.length = length;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class TextNode extends Text {
    lineInner(target, isLine, line, offset) {
        for(var i = 0;; i++){
            var child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(var i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            var child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                var childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        var ref;
        ref = (0, _slicedToArray._)(clip(this, from, to), 2), from = ref[0], to = ref[1], ref;
        if (text.lines < this.lines) for(var i = 0, pos = 0; i < this.children.length; i++){
            var child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                var updated = child.replace(from - pos, to - pos, text);
                var totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    var copy = this.children.slice();
                    copy[i] = updated;
                    return new TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length, lineSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "\n";
        var ref;
        ref = (0, _slicedToArray._)(clip(this, from, to), 2), from = ref[0], to = ref[1], ref;
        var result = "";
        for(var i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            var child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                child.flatten(target);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    scanIdentical(other, dir) {
        if (!(other instanceof TextNode)) return 0;
        var length = 0;
        var _ref = (0, _slicedToArray._)(dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ], 4), iA = _ref[0], iB = _ref[1], eA = _ref[2], eB = _ref[3];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            var chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children) {
        var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : children.reduce((l, ch)=>l + ch.length + 1, -1);
        var lines = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ch = _step.value;
                lines += ch.lines;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (lines < 32 /* Tree.Branch */ ) {
            var flat = [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var ch1 = _step1.value;
                    ch1.flatten(flat);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return new TextLeaf(flat, length);
        }
        var chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        var chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            var last;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (child.lines > maxChunk && child instanceof TextNode) try {
                for(var _iterator = child.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    add(node);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var child = _step2.value;
                add(child);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        flush();
        return chunked.length == 1 ? chunked[0] : new TextNode(chunked, length);
    }
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                this.lines += child.lines;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
Text.empty = /*@__PURE__*/ new TextLeaf([
    ""
], 0);
function textLength(text) {
    var length = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var line = _step.value;
            length += line.length + 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return length;
}
function appendText(text, target) {
    var from = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, to = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1e9;
    for(var pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        var line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function sliceText(text, from, to) {
    return appendText(text, [
        ""
    ], from, to);
}
class RawTextCursor {
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            var last = this.nodes.length - 1;
            var top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            var size = top instanceof TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof TextLeaf) {
                // Move to the next string
                var next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                var next1 = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next1.length) {
                    skip -= next1.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next1);
                    this.offsets.push(dir > 0 ? 1 : (next1 instanceof TextLeaf ? next1.text.length : next1.children.length) << 1);
                }
            }
        }
    }
    next() {
        var skip = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
    constructor(text, ref){
        var dir = ref === void 0 ? 1 : ref;
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
}
class PartialTextCursor {
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        var limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        var value = this.cursor.next(skip).value;
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next() {
        var skip = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
}
class LineCursor {
    next() {
        var skip = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _this_inner_next = this.inner.next(skip), done = _this_inner_next.done, lineBreak = _this_inner_next.lineBreak, value = _this_inner_next.value;
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
}
if (typeof Symbol != "undefined") {
    Text.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    RawTextCursor.prototype[Symbol.iterator] = PartialTextCursor.prototype[Symbol.iterator] = LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class Line {
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
}
function clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
// Compressed representation of the Grapheme_Cluster_Break=Extend
// information from
// http://www.unicode.org/Public/13.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
// Each pair of elements represents a range, as an offet from the
// previous range and a length. Numbers are in base-36, with the empty
// string being a shorthand for 1.
var extend = /*@__PURE__*/ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
// Convert offsets into absolute values
for(var i = 1; i < extend.length; i++)extend[i] += extend[i - 1];
function isExtendingChar(code) {
    for(var i = 1; i < extend.length; i += 2)if (extend[i] > code) return extend[i - 1] <= code;
    return false;
}
function isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
var ZWJ = 0x200d;
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function findClusterBreak(str, pos) {
    var forward = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, includeExtending = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    return (forward ? nextClusterBreak : prevClusterBreak)(str, pos, includeExtending);
}
function nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && surrogateLow(str.charCodeAt(pos)) && surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    var prev = codePointAt(str, pos);
    pos += codePointSize(prev);
    while(pos < str.length){
        var next = codePointAt(str, pos);
        if (prev == ZWJ || next == ZWJ || includeExtending && isExtendingChar(next)) {
            pos += codePointSize(next);
            prev = next;
        } else if (isRegionalIndicator(next)) {
            var countBefore = 0, i = pos - 2;
            while(i >= 0 && isRegionalIndicator(codePointAt(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        var found = nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function codePointAt(str, pos) {
    var code0 = str.charCodeAt(pos);
    if (!surrogateHigh(code0) || pos + 1 == str.length) return code0;
    var code1 = str.charCodeAt(pos + 1);
    if (!surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function fromCodePoint(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up a JavaScript string.
*/ function codePointSize(code) {
    return code < 0x10000 ? 1 : 2;
}
var DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var MapMode = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}(MapMode || (MapMode = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class ChangeDesc {
    /**
    The length of the document before the change.
    */ get length() {
        var result = 0;
        for(var i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        var result = 0;
        for(var i = 0; i < this.sections.length; i += 2){
            var ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(var i = 0, posA = 0, posB = 0; i < this.sections.length;){
            var len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f) {
        var individual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        var sections = [];
        for(var i = 0; i < this.sections.length;){
            var len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new ChangeDesc(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `other` happened before the ones in `this`.
    */ mapDesc(other) {
        var before = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return other.empty ? this : mapSet(this, other, before);
    }
    mapPos(pos) {
        var assoc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MapMode.Simple;
        var posA = 0, posB = 0;
        for(var i = 0; i < this.sections.length;){
            var len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != MapMode.Simple && endA >= pos && (mode == MapMode.TrackDel && posA < pos && endA > pos || mode == MapMode.TrackBefore && posA < pos || mode == MapMode.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : from;
        for(var i = 0, pos = 0; i < this.sections.length && pos <= to;){
            var len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        var result = "";
        for(var i = 0; i < this.sections.length;){
            var len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new ChangeDesc(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new ChangeDesc(sections);
    }
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class ChangeSet extends ChangeDesc {
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other) {
        var before = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        var sections = this.sections.slice(), inserted = [];
        for(var i = 0, pos = 0; i < sections.length; i += 2){
            var len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                var index = i >> 1;
                while(inserted.length < index)inserted.push(Text.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : Text.empty);
            }
            pos += len;
        }
        return new ChangeSet(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other) {
        var before = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return other.empty ? this : mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f) {
        var individual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return ChangeDesc.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        var resultSections = [], resultInserted = [], filteredSections = [];
        var iter = new SectionIter(this);
        done: for(var i = 0, pos = 0;;){
            var next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                var len = Math.min(iter.len, next - pos);
                addSection(filteredSections, len, -1);
                var ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                addSection(resultSections, len, ins);
                if (ins > 0) addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            var end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                var len1 = Math.min(iter.len, end - pos);
                addSection(resultSections, len1, -1);
                addSection(filteredSections, len1, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len1);
                pos += len1;
            }
        }
        return {
            changes: new ChangeSet(resultSections, resultInserted),
            filtered: ChangeDesc.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        var parts = [];
        for(var i = 0; i < this.sections.length; i += 2){
            var len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        var sections = [], inserted = [], pos = 0;
        var total = null;
        function flush() {
            var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (!force && !sections.length) return;
            if (pos < length) addSection(sections, length - pos, -1);
            var set = new ChangeSet(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (Array.isArray(spec)) try {
                for(var _iterator = spec[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    process(sub);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if (spec instanceof ChangeSet) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                var from = spec.from, _spec_to = spec.to, to = _spec_to === void 0 ? from : _spec_to, insert = spec.insert;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                var insText = !insert ? Text.empty : typeof insert == "string" ? Text.of(insert.split(lineSep || DefaultSplit)) : insert;
                var insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) addSection(sections, from - pos, -1);
                addSection(sections, to - from, insLen);
                addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new ChangeSet(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        var _loop = function(i) {
            var part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push(Text.empty);
                inserted[i] = Text.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        };
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        var sections = [], inserted = [];
        for(var i = 0; i < json.length; i++)_loop(i);
        return new ChangeSet(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new ChangeSet(sections, inserted);
    }
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
}
function addSection(sections, len, ins) {
    var forceJoin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (len == 0 && ins <= 0) return;
    var last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function addInsert(values, sections, value) {
    if (value.length == 0) return;
    var index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push(Text.empty);
        values.push(value);
    }
}
function iterChanges(desc, f, individual) {
    var inserted = desc.inserted;
    for(var posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        var len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            var endA = posA, endB = posB, text = Text.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function mapSet(setA, setB, before) {
    var mkSet = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    var sections = [], insert = mkSet ? [] : null;
    var a = new SectionIter(setA), b = new SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(var inserted = -1;;){
        if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            var len = Math.min(a.len, b.len);
            addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            var len1 = b.len;
            addSection(sections, b.ins, -1);
            while(len1){
                var piece = Math.min(a.len, len1);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    addSection(sections, 0, a.ins);
                    if (insert) addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len1 -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            var len2 = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    var piece1 = Math.min(left, b.len);
                    len2 += piece1;
                    left -= piece1;
                    b.forward(piece1);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            addSection(sections, len2, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? ChangeSet.createSet(sections, insert) : ChangeDesc.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function composeSets(setA, setB) {
    var mkSet = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var sections = [];
    var insert = mkSet ? [] : null;
    var a = new SectionIter(setA), b = new SectionIter(setB);
    for(var open = false;;){
        if (a.done && b.done) return insert ? ChangeSet.createSet(sections, insert) : ChangeDesc.create(sections);
        else if (a.ins == 0) {
            addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            addSection(sections, 0, b.ins, open);
            if (insert) addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            var len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                var insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                addSection(sections, len, insB, open);
                if (insert && insB) addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) addInsert(insert, sections, a.textBit(len));
            } else {
                addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class SectionIter {
    next() {
        var sections = this.set.sections;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        var inserted = this.set.inserted, index = this.i - 2 >> 1;
        return index >= inserted.length ? Text.empty : inserted[index];
    }
    textBit(len) {
        var inserted = this.set.inserted, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? Text.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class SelectionRange {
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        var level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        var value = this.flags >> 6 /* RangeFlag.GoalColumnOffset */ ;
        return value == 16777215 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change) {
        var assoc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
        var from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new SelectionRange(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : from;
        if (from <= this.anchor && to >= this.anchor) return EditorSelection.range(from, to);
        var head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return EditorSelection.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other) {
        var includeAssoc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return this.anchor == other.anchor && this.head == other.head && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return EditorSelection.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new SelectionRange(from, to, flags);
    }
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class EditorSelection {
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change) {
        var assoc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
        if (change.empty) return this;
        return EditorSelection.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other) {
        var includeAssoc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(var i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new EditorSelection([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range) {
        var main = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return EditorSelection.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range) {
        var which = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.mainIndex;
        var ranges = this.ranges.slice();
        ranges[which] = range;
        return EditorSelection.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new EditorSelection(json.ranges.map((r)=>SelectionRange.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor) {
        var head = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : anchor;
        return new EditorSelection([
            EditorSelection.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges) {
        var mainIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(var pos = 0, i = 0; i < ranges.length; i++){
            var range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return EditorSelection.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new EditorSelection(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos) {
        var assoc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, bidiLevel = arguments.length > 2 ? arguments[2] : void 0, goalColumn = arguments.length > 3 ? arguments[3] : void 0;
        return SelectionRange.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        var flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
        return head < anchor ? SelectionRange.create(head, anchor, 48 /* RangeFlag.AssocAfter */  | flags) : SelectionRange.create(anchor, head, (head > anchor ? 8 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges) {
        var mainIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(var i = 1; i < ranges.length; i++){
            var range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                var from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? EditorSelection.range(to, from) : EditorSelection.range(from, to));
            }
        }
        return new EditorSelection(ranges, mainIndex);
    }
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
}
function checkSelection(selection, docLength) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var range = _step.value;
            if (range.to > docLength) throw new RangeError("Selection points outside of document");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class Facet {
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new Facet(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
}
function sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class FacetProvider {
    dynamicSlot(addresses) {
        var _a;
        var getter = this.value;
        var compare = this.facet.compareInput;
        var id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        var depDoc = false, depSel = false, depAddrs = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.dependencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dep = _step.value;
                if (dep == "doc") depDoc = true;
                else if (dep == "selection") depSel = true;
                else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || ensureAll(state, depAddrs)) {
                    var newVal = getter(state);
                    if (multi ? !compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                var newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    var oldVal = getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof Facet ? oldState.facet(dep) === state.facet(dep) : dep instanceof StateField ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = nextID++;
    }
}
function compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(var i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function ensureAll(state, addrs) {
    var changed = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = addrs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var addr = _step.value;
            if (ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return changed;
}
function dynamicFacetSlot(addresses, facet, providers) {
    var providerAddrs = providers.map((p)=>addresses[p.id]);
    var providerTypes = providers.map((p)=>p.type);
    var dynamic = providerAddrs.filter((p)=>!(p & 1));
    var idx = addresses[facet.id] >> 1;
    function get(state) {
        var values = [];
        for(var i = 0; i < providerAddrs.length; i++){
            var value = getAddr(state, providerAddrs[i]);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (providerTypes[i] == 2 /* Provider.Multi */ ) try {
                for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var val = _step.value;
                    values.push(val);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = providerAddrs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var addr = _step.value;
                    ensureAddr(state, addr);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!ensureAll(state, dynamic)) return 0;
            var value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            var depChanged = ensureAll(state, providerAddrs);
            var oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            var value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
var initField = /*@__PURE__*/ Facet.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class StateField {
    /**
    Define a state field.
    */ static define(config) {
        var field = new StateField(nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        var init = state.facet(initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        var idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                var oldVal = state.values[idx];
                var value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            initField.of({
                field: this,
                create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
}
var Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function prec(value) {
    return (ext)=>new PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ var Prec = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ prec(Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ prec(Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ prec(Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ prec(Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ prec(Prec_.lowest)
};
class PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class Compartment {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return Compartment.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class Configuration {
    staticFacet(facet) {
        var addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        var _loop = function(id) {
            var providers = facets[id], facet = providers[0].facet;
            var oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if (sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    var value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var p = _step.value;
                        if (p.type == 0 /* Provider.Static */ ) {
                            address[p.id] = staticValues.length << 1 | 1;
                            staticValues.push(p.value);
                        } else {
                            address[p.id] = dynamicSlots.length << 1;
                            dynamicSlots.push((a)=>p.dynamicSlot(a));
                        }
                    };
                    for(var _iterator = providers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>dynamicFacetSlot(a, facet, providers));
            }
        };
        var fields = [];
        var facets = Object.create(null);
        var newCompartments = new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = flatten(base, compartments, newCompartments)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ext = _step.value;
                if (ext instanceof StateField) fields.push(ext);
                else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var address = Object.create(null);
        var staticValues = [];
        var dynamicSlots = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            var _loop1 = function() {
                var field = _step1.value;
                address[field.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>field.slot(a));
            };
            for(var _iterator1 = fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop1();
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(var id in facets)_loop(id);
        var dynamic = dynamicSlots.map((f)=>f(address));
        return new Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
}
function flatten(extension, compartments, newCompartments) {
    var result = [
        [],
        [],
        [],
        [],
        []
    ];
    var seen = new Map();
    function inner(ext, prec) {
        var known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            var found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Array.isArray(ext)) try {
            for(var _iterator = ext[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                inner(e, prec);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else if (ext instanceof CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            var content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof StateField) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, Prec_.default);
        } else {
            var content1 = ext.extension;
            if (!content1) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content1, prec);
        }
    }
    inner(extension, Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    var idx = addr >> 1;
    var status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    var changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
var languageData = /*@__PURE__*/ Facet.define();
var allowMultipleSelections = /*@__PURE__*/ Facet.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
var lineSeparator = /*@__PURE__*/ Facet.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
var changeFilter = /*@__PURE__*/ Facet.define();
var transactionFilter = /*@__PURE__*/ Facet.define();
var transactionExtender = /*@__PURE__*/ Facet.define();
var readOnly = /*@__PURE__*/ Facet.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class Annotation {
    /**
    Define a new type of annotation.
    */ static define() {
        return new AnnotationType();
    }
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class AnnotationType {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new Annotation(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class StateEffectType {
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new StateEffect(this, value);
    }
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class StateEffect {
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        var mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new StateEffect(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define() {
        var spec = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new StateEffectType(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        var result = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                var mapped = effect.map(mapping);
                if (mapped) result.push(mapped);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ StateEffect.reconfigure = /*@__PURE__*/ StateEffect.define();
/**
Append extensions to the top-level configuration of the editor.
*/ StateEffect.appendConfig = /*@__PURE__*/ StateEffect.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class Transaction {
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new Transaction(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.annotations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ann = _step.value;
                if (ann.type == type) return ann.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        var e = this.annotation(Transaction.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == Transaction.time)) this.annotations = annotations.concat(Transaction.time.of(Date.now()));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ Transaction.time = /*@__PURE__*/ Annotation.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ Transaction.userEvent = /*@__PURE__*/ Annotation.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ Transaction.addToHistory = /*@__PURE__*/ Annotation.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ Transaction.remote = /*@__PURE__*/ Annotation.define();
function joinRanges(a, b) {
    var result = [];
    for(var iA = 0, iB = 0;;){
        var from = void 0, to = void 0;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function mergeTransaction(a, b, sequential) {
    var _a;
    var mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = ChangeSet.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: StateEffect.mapEffects(a.effects, mapForA).concat(StateEffect.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function resolveTransactionInner(state, spec, docSize) {
    var sel = spec.selection, annotations = asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat(Transaction.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof ChangeSet ? spec.changes : ChangeSet.of(spec.changes || [], docSize, state.facet(lineSeparator)),
        selection: sel && (sel instanceof EditorSelection ? sel : EditorSelection.single(sel.anchor, sel.head)),
        effects: asArray(spec.effects),
        annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function resolveTransaction(state, specs, filter) {
    var s = resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(var i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        var seq = !!specs[i].sequential;
        s = mergeTransaction(s, resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    var tr = Transaction.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return extendTransaction(filter ? filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function filterTransaction(tr) {
    var state = tr.startState;
    // Change filters
    var result = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.facet(changeFilter)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var filter = _step.value;
            var value = filter(tr);
            if (value === false) {
                result = false;
                break;
            }
            if (Array.isArray(value)) result = result === true ? value : joinRanges(result, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (result !== true) {
        var changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = ChangeSet.empty(state.doc.length);
        } else {
            var filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = Transaction.create(state, changes, tr.selection && tr.selection.map(back), StateEffect.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    var filters = state.facet(transactionFilter);
    for(var i = filters.length - 1; i >= 0; i--){
        var filtered1 = filters[i](tr);
        if (filtered1 instanceof Transaction) tr = filtered1;
        else if (Array.isArray(filtered1) && filtered1.length == 1 && filtered1[0] instanceof Transaction) tr = filtered1[0];
        else tr = resolveTransaction(state, asArray(filtered1), false);
    }
    return tr;
}
function extendTransaction(tr) {
    var state = tr.startState, extenders = state.facet(transactionExtender), spec = tr;
    for(var i = extenders.length - 1; i >= 0; i--){
        var extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = mergeTransaction(spec, resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : Transaction.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
var none = [];
function asArray(value) {
    return value == null ? none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var CharCategory = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}(CharCategory || (CharCategory = {}));
var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
var wordChar;
try {
    wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function hasWordChar(str) {
    if (wordChar) return wordChar.test(str);
    for(var i = 0; i < str.length; i++){
        var ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return CharCategory.Space;
        if (hasWordChar(char)) return CharCategory.Word;
        for(var i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return CharCategory.Word;
        return CharCategory.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class EditorState {
    field(field) {
        var require1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var addr = this.config.address[field.id];
        if (addr == null) {
            if (require1) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        ensureAddr(this, addr);
        return getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update() {
        for(var _len = arguments.length, specs = new Array(_len), _key = 0; _key < _len; _key++){
            specs[_key] = arguments[_key];
        }
        return resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        var conf = this.config, base = conf.base, compartments = conf.compartments;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(Compartment.reconfigure)) {
                    if (conf) {
                        compartments = new Map;
                        conf.compartments.forEach((val, key)=>compartments.set(key, val));
                        conf = null;
                    }
                    compartments.set(effect.value.compartment, effect.value.extension);
                } else if (effect.is(StateEffect.reconfigure)) {
                    conf = null;
                    base = effect.value;
                } else if (effect.is(StateEffect.appendConfig)) {
                    conf = null;
                    base = asArray(base).concat(effect.value);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var startValues;
        if (!conf) {
            conf = Configuration.resolve(base, compartments, this);
            var intermediateState = new EditorState(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        var selection = tr.startState.facet(allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new EditorState(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: EditorSelection.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        var sel = this.selection;
        var result1 = f(sel.ranges[0]);
        var changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        var effects = asArray(result1.effects);
        for(var i = 1; i < sel.ranges.length; i++){
            var result = f(sel.ranges[i]);
            var newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(var j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            var mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = StateEffect.mapEffects(effects, newMapped).concat(StateEffect.mapEffects(asArray(result.effects), mapBy));
        }
        return {
            changes,
            selection: EditorSelection.create(ranges, sel.mainIndex),
            effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes() {
        var spec = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (spec instanceof ChangeSet) return spec;
        return ChangeSet.of(spec, this.doc.length, this.facet(EditorState.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return Text.of(string.split(this.facet(EditorState.lineSeparator) || DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc() {
        var from = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.doc.length;
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        var addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        ensureAddr(this, addr);
        return getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        var result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(var prop in fields){
            var value = fields[prop];
            if (value instanceof StateField && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json) {
        var _loop = function(prop) {
            if (Object.prototype.hasOwnProperty.call(json, prop)) {
                var field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        };
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fields = arguments.length > 2 ? arguments[2] : void 0;
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        var fieldInit = [];
        if (fields) for(var prop in fields)_loop(prop);
        return EditorState.create({
            doc: json.doc,
            selection: EditorSelection.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var configuration = Configuration.resolve(config.extensions || [], new Map);
        var doc = config.doc instanceof Text ? config.doc : Text.of((config.doc || "").split(configuration.staticFacet(EditorState.lineSeparator) || DefaultSplit));
        var selection = !config.selection ? EditorSelection.single(0) : config.selection instanceof EditorSelection ? config.selection : EditorSelection.single(config.selection.anchor, config.selection.head);
        checkSelection(selection, doc.length);
        if (!configuration.staticFacet(allowMultipleSelections)) selection = selection.asSingle();
        return new EditorState(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet(EditorState.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet(EditorState.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet(readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase) {
        for(var _len = arguments.length, insert = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            insert[_key - 1] = arguments[_key];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.facet(EditorState.phrases)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var map = _step.value;
                if (Object.prototype.hasOwnProperty.call(map, phrase)) {
                    phrase = map[phrase];
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            var n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos) {
        var side = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
        var values = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.facet(languageData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var provider = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = provider(this, pos, side)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var result = _step1.value;
                        if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        var _this_doc_lineAt = this.doc.lineAt(pos), text = _this_doc_lineAt.text, from = _this_doc_lineAt.from, length = _this_doc_lineAt.length;
        var cat = this.charCategorizer(pos);
        var start = pos - from, end = pos - from;
        while(start > 0){
            var prev = findClusterBreak(text, start, false);
            if (cat(text.slice(prev, start)) != CharCategory.Word) break;
            start = prev;
        }
        while(end < length){
            var next = findClusterBreak(text, end);
            if (cat(text.slice(end, next)) != CharCategory.Word) break;
            end = next;
        }
        return start == end ? null : EditorSelection.range(start + from, end + from);
    }
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(var i = 0; i < this.config.dynamicSlots.length; i++)ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ EditorState.allowMultipleSelections = allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ EditorState.tabSize = /*@__PURE__*/ Facet.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ EditorState.lineSeparator = lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ EditorState.readOnly = readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ EditorState.phrases = /*@__PURE__*/ Facet.define({
    compare (a, b) {
        var kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ EditorState.languageData = languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ EditorState.changeFilter = changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ EditorState.transactionFilter = transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ EditorState.transactionExtender = transactionExtender;
Compartment.reconfigure = /*@__PURE__*/ StateEffect.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function combineConfig(configs, defaults) {
    var combine = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = configs[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var config = _step.value;
            try {
                for(var _iterator1 = Object.keys(config)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var key = _step1.value;
                    var value = config[key], current = result[key];
                    if (current === undefined) result[key] = value;
                    else if (current === value || value === undefined) ; // No conflict
                    else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
                    else throw new Error("Config merge conflict for field " + key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    for(var key1 in defaults)if (result[key1] === undefined) result[key1] = defaults[key1];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class RangeValue {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from) {
        var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : from;
        return Range.create(from, to, this);
    }
}
RangeValue.prototype.startSide = RangeValue.prototype.endSide = 0;
RangeValue.prototype.point = false;
RangeValue.prototype.mapMode = MapMode.TrackDel;
/**
A range associates a value with a range of positions.
*/ class Range {
    /**
    @internal
    */ static create(from, to, value) {
        return new Range(from, to, value);
    }
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
}
function cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class Chunk {
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end) {
        var startAt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        var arr = end ? this.to : this.from;
        for(var lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            var mid = lo + hi >> 1;
            var diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(var i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        var value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(var i = 0; i < this.value.length; i++){
            var val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom = void 0, newTo = void 0;
            if (curFrom == curTo) {
                var mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class RangeSet {
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new RangeSet(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        var last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        var size = this.nextLayer.size;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.chunk[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var chunk = _step.value;
                size += chunk.value.length;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        var _updateSpec_add = updateSpec.add, add = _updateSpec_add === void 0 ? [] : _updateSpec_add, _updateSpec_sort = updateSpec.sort, sort = _updateSpec_sort === void 0 ? false : _updateSpec_sort, _updateSpec_filterFrom = updateSpec.filterFrom, filterFrom = _updateSpec_filterFrom === void 0 ? 0 : _updateSpec_filterFrom, _updateSpec_filterTo = updateSpec.filterTo, filterTo = _updateSpec_filterTo === void 0 ? this.length : _updateSpec_filterTo;
        var filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort(cmpRange);
        if (this.isEmpty) return add.length ? RangeSet.of(add) : this;
        var cur = new LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        var builder = new RangeSetBuilder();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                var range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push(Range.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? RangeSet.empty : this.nextLayer.update({
            add: spill,
            filter,
            filterFrom,
            filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        var chunks = [], chunkPos = [], maxPoint = -1;
        for(var i = 0; i < this.chunk.length; i++){
            var start = this.chunkPos[i], chunk = this.chunk[i];
            var touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                var _chunk_map = chunk.map(start, changes), mapped = _chunk_map.mapped, pos = _chunk_map.pos;
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        var next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new RangeSet(chunkPos, chunks, next || RangeSet.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(var i = 0; i < this.chunk.length; i++){
            var start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter() {
        var from = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets) {
        var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator) {
        var /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : -1;
        var a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        var b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        var sharedChunks = findSharedChunks(a, b, textDiff);
        var sideA = new SpanCursor(a, sharedChunks, minPointSize);
        var sideB = new SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets) {
        var from = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, to = arguments.length > 3 ? arguments[3] : void 0;
        if (to == null) to = 999999999;
        var a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        var b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        var sharedChunks = findSharedChunks(a, b);
        var sideA = new SpanCursor(a, sharedChunks, 0).goto(from), sideB = new SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator) {
        var /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : -1;
        var cursor = new SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        var openRanges = cursor.openStart;
        for(;;){
            var curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                var active = cursor.activeForPoint(cursor.to);
                var openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges) {
        var sort = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var build = new RangeSetBuilder();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (ranges instanceof Range ? [
                ranges
            ] : sort ? lazySort(ranges) : ranges)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var range = _step.value;
                build.add(range.from, range.to, range.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return RangeSet.empty;
        var result = sets[sets.length - 1];
        for(var i = sets.length - 2; i >= 0; i--)for(var layer = sets[i]; layer != RangeSet.empty; layer = layer.nextLayer)result = new RangeSet(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
}
/**
The empty set of ranges.
*/ RangeSet.empty = /*@__PURE__*/ new RangeSet([], [], null, -1);
function lazySort(ranges) {
    if (ranges.length > 1) for(var prev = ranges[0], i = 1; i < ranges.length; i++){
        var cur = ranges[i];
        if (cmpRange(prev, cur) > 0) return ranges.slice().sort(cmpRange);
        prev = cur;
    }
    return ranges;
}
RangeSet.empty.nextLayer = RangeSet.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class RangeSetBuilder {
    finishChunk(newArrays) {
        this.chunks.push(new Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new RangeSetBuilder)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        var diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        var last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner(RangeSet.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        var result = RangeSet.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
}
function findSharedChunks(a, b, textDiff) {
    var inA = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var set = _step.value;
            for(var i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var shared = new Set();
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = b[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var set1 = _step1.value;
            for(var i1 = 0; i1 < set1.chunk.length; i1++){
                var known = inA.get(set1.chunk[i1]);
                if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set1.chunkPos[i1] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set1.chunk[i1].length))) shared.add(set1.chunk[i1]);
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return shared;
}
class LayerCursor {
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 /* C.Far */  ? arguments[1] : -1000000000;
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            var next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            var rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            var chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            var from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
    constructor(layer, skip, minPoint, ref){
        var rank = ref === void 0 ? 0 : ref;
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
}
class HeapCursor {
    static from(sets) {
        var skip = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, minPoint = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
        var heap = [];
        for(var i = 0; i < sets.length; i++){
            for(var cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 /* C.Far */  ? arguments[1] : -1000000000;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.heap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cur = _step.value;
                cur.goto(pos, side);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var i = this.heap.length >> 1; i >= 0; i--)heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.heap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cur = _step.value;
                cur.forward(pos, side);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var i = this.heap.length >> 1; i >= 0; i--)heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            var top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            heapBubble(this.heap, 0);
        }
    }
    constructor(heap){
        this.heap = heap;
    }
}
function heapBubble(heap, index) {
    for(var cur = heap[index];;){
        var childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        var child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class SpanCursor {
    goto(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 /* C.Far */  ? arguments[1] : -1000000000;
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        remove(this.active, index);
        remove(this.activeTo, index);
        remove(this.activeRank, index);
        this.minActive = findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        var i = 0, _this_cursor = this.cursor, value = _this_cursor.value, to = _this_cursor.to, rank = _this_cursor.rank;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        insert(this.active, i, value);
        insert(this.activeTo, i, to);
        insert(this.activeRank, i, rank);
        if (trackOpen) insert(trackOpen, i, this.cursor.from);
        this.minActive = findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        var from = this.to, wasPoint = this.point;
        this.point = null;
        var trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            var a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                var nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(var i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        var active = [];
        for(var i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        var open = 0;
        for(var i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = HeapCursor.from(sets, skip, minPoint);
    }
}
function compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    var endB = startB + length;
    var pos = startB, dPos = startB - startA;
    for(;;){
        var diff = a.to + dPos - b.to || a.endSide - b.endSide;
        var end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function sameValues(a, b) {
    if (a.length != b.length) return false;
    for(var i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function remove(array, index) {
    for(var i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function insert(array, index, value) {
    for(var i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function findMinIndex(value, array) {
    var found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(var i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function countColumn(string, tabSize) {
    var to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : string.length;
    var n = 0;
    for(var i = 0; i < to;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = findClusterBreak(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function findColumn(string, col, tabSize, strict) {
    for(var i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = findClusterBreak(string, i);
    }
    return strict === true ? -1 : string.length;
}

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"dgaAD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// :: - Style modules encapsulate a set of CSS rules defined from
// JavaScript. Their definitions are only available in a given DOM
// root after it has been _mounted_ there with `StyleModule.mount`.
//
// Style modules should be created once and stored somewhere, as
// opposed to re-creating them every time you need them. The amount of
// CSS rules generated for a given DOM root is bounded by the amount
// of style modules that were used. So to avoid leaking rules, don't
// create these dynamically, but treat them as one-time allocations.
parcelHelpers.export(exports, "StyleModule", ()=>StyleModule);
var C = "\u037C";
var COUNT = typeof Symbol == "undefined" ? "__" + C : Symbol.for(C);
var SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
var top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class StyleModule {
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        var id = top[COUNT] || 1;
        top[COUNT] = id + 1;
        return C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        var set = root[SET], nonce = options && options.nonce;
        if (!set) set = new StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        var finish = (options || {}).finish;
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            var local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(var prop in spec){
                var value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(var prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
}
var adoptedSet = new Map //<Document, StyleSet>
;
class StyleSet {
    mount(modules, root) {
        var sheet = this.sheet;
        var pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(var i = 0; i < modules.length; i++){
            var mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(var k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            var text = "";
            for(var i1 = 0; i1 < this.modules.length; i1++)text += this.modules[i1].getRules() + "\n";
            this.styleTag.textContent = text;
            var target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
    constructor(root, nonce){
        var doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            var adopted = adoptedSet.get(doc);
            if (adopted) return root[SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[SET] = this;
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"ij6cg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base", ()=>base);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "keyName", ()=>keyName);
var base = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var shift = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var i = 0; i < 10; i++)base[48 + i] = base[96 + i] = String(i);
// The function keys
for(var i = 1; i <= 24; i++)base[i + 111] = "F" + i;
// And the alphabetic keys
for(var i = 65; i <= 90; i++){
    base[i] = String.fromCharCode(i + 32);
    shift[i] = String.fromCharCode(i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var code in base)if (!shift.hasOwnProperty(code)) shift[code] = base[code];
function keyName(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? shift : base)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jct2S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocInput", ()=>DocInput);
parcelHelpers.export(exports, "HighlightStyle", ()=>HighlightStyle);
parcelHelpers.export(exports, "IndentContext", ()=>IndentContext);
parcelHelpers.export(exports, "LRLanguage", ()=>LRLanguage);
parcelHelpers.export(exports, "Language", ()=>Language);
parcelHelpers.export(exports, "LanguageDescription", ()=>LanguageDescription);
parcelHelpers.export(exports, "LanguageSupport", ()=>LanguageSupport);
parcelHelpers.export(exports, "ParseContext", ()=>ParseContext);
parcelHelpers.export(exports, "StreamLanguage", ()=>StreamLanguage);
parcelHelpers.export(exports, "StringStream", ()=>StringStream);
parcelHelpers.export(exports, "TreeIndentContext", ()=>TreeIndentContext);
parcelHelpers.export(exports, "bidiIsolates", ()=>bidiIsolates);
parcelHelpers.export(exports, "bracketMatching", ()=>bracketMatching);
parcelHelpers.export(exports, "bracketMatchingHandle", ()=>bracketMatchingHandle);
parcelHelpers.export(exports, "codeFolding", ()=>codeFolding);
parcelHelpers.export(exports, "continuedIndent", ()=>continuedIndent);
parcelHelpers.export(exports, "defaultHighlightStyle", ()=>defaultHighlightStyle);
parcelHelpers.export(exports, "defineLanguageFacet", ()=>defineLanguageFacet);
parcelHelpers.export(exports, "delimitedIndent", ()=>delimitedIndent);
parcelHelpers.export(exports, "ensureSyntaxTree", ()=>ensureSyntaxTree);
parcelHelpers.export(exports, "flatIndent", ()=>flatIndent);
parcelHelpers.export(exports, "foldAll", ()=>foldAll);
parcelHelpers.export(exports, "foldCode", ()=>foldCode);
parcelHelpers.export(exports, "foldEffect", ()=>foldEffect);
parcelHelpers.export(exports, "foldGutter", ()=>foldGutter);
parcelHelpers.export(exports, "foldInside", ()=>foldInside);
parcelHelpers.export(exports, "foldKeymap", ()=>foldKeymap);
parcelHelpers.export(exports, "foldNodeProp", ()=>foldNodeProp);
parcelHelpers.export(exports, "foldService", ()=>foldService);
parcelHelpers.export(exports, "foldState", ()=>foldState);
parcelHelpers.export(exports, "foldable", ()=>foldable);
parcelHelpers.export(exports, "foldedRanges", ()=>foldedRanges);
parcelHelpers.export(exports, "forceParsing", ()=>forceParsing);
parcelHelpers.export(exports, "getIndentUnit", ()=>getIndentUnit);
parcelHelpers.export(exports, "getIndentation", ()=>getIndentation);
parcelHelpers.export(exports, "highlightingFor", ()=>highlightingFor);
parcelHelpers.export(exports, "indentNodeProp", ()=>indentNodeProp);
parcelHelpers.export(exports, "indentOnInput", ()=>indentOnInput);
parcelHelpers.export(exports, "indentRange", ()=>indentRange);
parcelHelpers.export(exports, "indentService", ()=>indentService);
parcelHelpers.export(exports, "indentString", ()=>indentString);
parcelHelpers.export(exports, "indentUnit", ()=>indentUnit);
parcelHelpers.export(exports, "language", ()=>language);
parcelHelpers.export(exports, "languageDataProp", ()=>languageDataProp);
parcelHelpers.export(exports, "matchBrackets", ()=>matchBrackets);
parcelHelpers.export(exports, "sublanguageProp", ()=>sublanguageProp);
parcelHelpers.export(exports, "syntaxHighlighting", ()=>syntaxHighlighting);
parcelHelpers.export(exports, "syntaxParserRunning", ()=>syntaxParserRunning);
parcelHelpers.export(exports, "syntaxTree", ()=>syntaxTree);
parcelHelpers.export(exports, "syntaxTreeAvailable", ()=>syntaxTreeAvailable);
parcelHelpers.export(exports, "toggleFold", ()=>toggleFold);
parcelHelpers.export(exports, "unfoldAll", ()=>unfoldAll);
parcelHelpers.export(exports, "unfoldCode", ()=>unfoldCode);
parcelHelpers.export(exports, "unfoldEffect", ()=>unfoldEffect);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _common = require("@lezer/common");
var _state = require("@codemirror/state");
var _view = require("@codemirror/view");
var _highlight = require("@lezer/highlight");
var _styleMod = require("style-mod");
var _a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ var languageDataProp = /*@__PURE__*/ new (0, _common.NodeProp)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function defineLanguageFacet(baseData) {
    return (0, _state.Facet).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ var sublanguageProp = /*@__PURE__*/ new (0, _common.NodeProp)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class Language {
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos) {
        var side = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
        return topNodeAt(state, pos, side).type.prop(languageDataProp) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        var lang = state.facet(language);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        var result = [];
        var explore = (tree, from)=>{
            if (tree.prop(languageDataProp) == this.data) {
                result.push({
                    from,
                    to: from + tree.length
                });
                return;
            }
            var mount = tree.prop((0, _common.NodeProp).mounted);
            if (mount) {
                if (mount.tree.prop(languageDataProp) == this.data) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (mount.overlay) try {
                        for(var _iterator = mount.overlay[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            result.push({
                                from: r.from + from,
                                to: r.to + from
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    var size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(var i = 0; i < tree.children.length; i++){
                var ch = tree.children[i];
                if (ch instanceof (0, _common.Tree)) explore(ch, tree.positions[i] + from);
            }
        };
        explore(syntaxTree(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, ref, /**
    A language name.
    */ ref1){
        var extraExtensions = ref === void 0 ? [] : ref, name = ref1 === void 0 ? "" : ref1;
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, _state.EditorState).prototype.hasOwnProperty("tree")) Object.defineProperty((0, _state.EditorState).prototype, "tree", {
            get () {
                return syntaxTree(this);
            }
        });
        this.parser = parser;
        this.extension = [
            language.of(this),
            (0, _state.EditorState).languageData.of((state, pos, side)=>{
                var top = topNodeAt(state, pos, side), _$data = top.type.prop(languageDataProp);
                if (!_$data) return [];
                var base = state.facet(_$data), sub = top.type.prop(sublanguageProp);
                if (sub) {
                    var innerNode = top.resolve(pos - top.from, side);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = sub[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var sublang = _step.value;
                            if (sublang.test(innerNode, state)) {
                                var _$data1 = state.facet(sublang.facet);
                                return sublang.type == "replace" ? _$data1 : _$data1.concat(base);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
}
/**
@internal
*/ Language.setState = /*@__PURE__*/ (0, _state.StateEffect).define();
function topNodeAt(state, pos, side) {
    var topLang = state.facet(language), tree = syntaxTree(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(var node = tree; node; node = node.enter(pos, side, (0, _common.IterMode).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class LRLanguage extends Language {
    /**
    Define a language from a parser.
    */ static define(spec) {
        var data = defineLanguageFacet(spec.languageData);
        return new LRLanguage(data, spec.parser.configure({
            props: [
                languageDataProp.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new LRLanguage(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function syntaxTree(state) {
    var field = state.field(Language.state, false);
    return field ? field.tree : (0, _common.Tree).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function ensureSyntaxTree(state, upto) {
    var timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 50;
    var _a;
    var parse = (_a = state.field(Language.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    var oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    var result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function syntaxTreeAvailable(state) {
    var upto = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : state.doc.length;
    var _a;
    return ((_a = state.field(Language.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function forceParsing(view) {
    var upto = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : view.viewport.to, timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
    var success = ensureSyntaxTree(view.state, upto, timeout);
    if (success != syntaxTree(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function syntaxParserRunning(view) {
    var _a;
    return ((_a = view.plugin(parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class DocInput {
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        var stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
}
var currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class ParseContext {
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new ParseContext(parser, state, [], (0, _common.Tree).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new DocInput(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, _common.Tree).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                var endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                var done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, _common.TreeFragment).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        var pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, _common.TreeFragment).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        var prev = currentContext;
        currentContext = this;
        try {
            return f();
        } finally{
            currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(var r; r = this.tempSkipped.pop();)fragments = cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        var _this = this, fragments = _this.fragments, tree = _this.tree, treeLen = _this.treeLen, viewport = _this.viewport, skipped = _this.skipped;
        this.takeTree();
        if (!changes.empty) {
            var ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA,
                    toA,
                    fromB,
                    toB
                }));
            fragments = (0, _common.TreeFragment).applyChanges(fragments, ranges);
            tree = (0, _common.Tree).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.skipped[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        var from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                        if (from < to) skipped.push({
                            from,
                            to
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        return new ParseContext(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        var startLen = this.skipped.length;
        for(var i = 0; i < this.skipped.length; i++){
            var _this_skipped_i = this.skipped[i], from = _this_skipped_i.from, to = _this_skipped_i.to;
            if (from < viewport.to && to > viewport.from) {
                this.fragments = cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from,
            to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, _common.Parser) {
            createParse(input, fragments, ranges) {
                var from = ranges[0].from, to = ranges[ranges.length - 1].to;
                var parser = {
                    parsedPos: from,
                    advance () {
                        var cx = currentContext;
                        if (cx) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var r = _step.value;
                                    cx.tempSkipped.push(r);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, _common.Tree)((0, _common.NodeType).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        var frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return currentContext;
    }
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ ref, /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        var fragments = ref === void 0 ? [] : ref;
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
}
function cutFragments(fragments, from, to) {
    return (0, _common.TreeFragment).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class LanguageState {
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        var newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        var upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new LanguageState(newCx);
    }
    static init(state) {
        var vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        var parseState = ParseContext.create(state.facet(language).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new LanguageState(parseState);
    }
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
}
Language.state = /*@__PURE__*/ (0, _state.StateField).define({
    create: LanguageState.init,
    update (value, tr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.is(Language.setState)) return e.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (tr.startState.facet(language) != tr.state.facet(language)) return LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
var requestIdle = (callback)=>{
    var timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") requestIdle = (callback)=>{
    var idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
var isInputPending = typeof navigator != "undefined" && ((_a = navigator.scheduling) === null || _a === void 0 ? void 0 : _a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
var parseWorker = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class ParseWorker {
    update(update) {
        var cx = this.view.state.field(Language.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        var state = this.view.state, field = state.field(Language.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        var now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        var _this_view = this.view, state = _this_view.state, _this_view_viewport = _this_view.viewport, vpTo = _this_view_viewport.to, field = state.field(Language.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        var endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        var viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        var done = field.context.work(()=>{
            return isInputPending && isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: Language.setState.of(new LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, _view.logException)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ var language = /*@__PURE__*/ (0, _state.Facet).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            Language.state,
            parseWorker,
            (0, _view.EditorView).contentAttributes.compute([
                language
            ], (state)=>{
                var lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class LanguageSupport {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ ref){
        var support = ref === void 0 ? [] : ref;
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class LanguageDescription {
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        var load = spec.load, support = spec.support;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new LanguageDescription(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = descs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (d.filename && d.filename.test(filename)) return d;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = descs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var d1 = _step1.value;
                    if (d1.extensions.indexOf(ext[1]) > -1) return d1;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name) {
        var fuzzy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        name = name.toLowerCase();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = descs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (d.alias.some((a)=>a == name)) return d;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        if (fuzzy) try {
            for(var _iterator1 = descs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                var d1 = _step1.value;
                try {
                    for(var _iterator2 = d1.alias[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                        var a = _step2.value;
                        var found = name.indexOf(a);
                        if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d1;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return null;
    }
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ var indentService = /*@__PURE__*/ (0, _state.Facet).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting either entirely of the same whitespace
character. When not set, this defaults to 2 spaces.
*/ var indentUnit = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        var unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function getIndentUnit(state) {
    var unit = state.facet(indentUnit);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function indentString(state, cols) {
    var result = "", ts = state.tabSize, ch = state.facet(indentUnit)[0];
    if (ch == "	") {
        while(cols >= ts){
            result += "	";
            cols -= ts;
        }
        ch = " ";
    }
    for(var i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function getIndentation(context, pos) {
    if (context instanceof (0, _state.EditorState)) context = new IndentContext(context);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.state.facet(indentService)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var service = _step.value;
            var result = service(context, pos);
            if (result !== undefined) return result;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var tree = syntaxTree(context.state);
    return tree.length >= pos ? syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function indentRange(state, from, to) {
    var updated = Object.create(null);
    var context = new IndentContext(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    var changes = [];
    for(var pos = from; pos <= to;){
        var line = state.doc.lineAt(pos);
        pos = line.to + 1;
        var indent = getIndentation(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        var cur = /^\s*/.exec(line.text)[0];
        var norm = indentString(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class IndentContext {
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var line = this.state.doc.lineAt(pos);
        var _this_options = this.options, simulateBreak = _this_options.simulateBreak, simulateDoubleBreak = _this_options.simulateDoubleBreak;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        var _this_lineAt = this.lineAt(pos, bias), text = _this_lineAt.text, from = _this_lineAt.from;
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var _this_lineAt = this.lineAt(pos, bias), text = _this_lineAt.text, from = _this_lineAt.from;
        var result = this.countColumn(text, pos - from);
        var override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line) {
        var pos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : line.length;
        return (0, _state.countColumn)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var _this_lineAt = this.lineAt(pos, bias), text = _this_lineAt.text, from = _this_lineAt.from;
        var override = this.options.overrideIndentation;
        if (override) {
            var overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ ref){
        var options = ref === void 0 ? {} : ref;
        this.state = state;
        this.options = options;
        this.unit = getIndentUnit(state);
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ var indentNodeProp = /*@__PURE__*/ new (0, _common.NodeProp)();
// Compute the indentation for a given position from the syntax tree.
function syntaxIndentation(cx, ast, pos) {
    var stack = ast.resolveStack(pos);
    var inner = stack.node.enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        var add = [];
        for(var cur = inner; cur != stack.node; cur = cur.parent)add.push(cur);
        for(var i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return indentFor(stack, cx, pos);
}
function indentFor(stack, cx, pos) {
    for(var cur = stack; cur; cur = cur.next){
        var strategy = indentStrategy(cur.node);
        if (strategy) return strategy(TreeIndentContext.create(cx, pos, cur));
    }
    return 0;
}
function ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function indentStrategy(tree) {
    var strategy = tree.type.prop(indentNodeProp);
    if (strategy) return strategy;
    var first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, _common.NodeProp).closedBy))) {
        var last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>delimitedStrategy(cx, true, 1, undefined, closed && !ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? topIndent : null;
}
function topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class TreeIndentContext extends IndentContext {
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new TreeIndentContext(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        var line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            var atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if (isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return indentFor(this.context.next, this.base, this.pos);
    }
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
}
function isParent(parent, of) {
    for(var cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function bracketedAligned(context) {
    var tree = context.node;
    var openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    var sim = context.options.simulateBreak;
    var openLine = context.state.doc.lineAt(openToken.from);
    var lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(var pos = openToken.to;;){
        var next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) return next.from < lineEnd ? openToken : null;
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function delimitedIndent(param) {
    var closing = param.closing, _param_align = param.align, align = _param_align === void 0 ? true : _param_align, _param_units = param.units, units = _param_units === void 0 ? 1 : _param_units;
    return (context)=>delimitedStrategy(context, align, units, closing);
}
function delimitedStrategy(context, align, units, closing, closedAt) {
    var after = context.textAfter, space = after.match(/^\s*/)[0].length;
    var closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    var aligned = align ? bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ var flatIndent = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function continuedIndent() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, except = _ref.except, _ref_units = _ref.units, units = _ref_units === void 0 ? 1 : _ref_units;
    return (context)=>{
        var matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
var DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function indentOnInput() {
    return (0, _state.EditorState).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        var rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        var doc = tr.newDoc, head = tr.newSelection.main.head, line = doc.lineAt(head);
        if (head > line.from + DontIndentBeyond) return tr;
        var lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        var state = tr.state, last = -1, changes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var head1 = _step.value.head;
                var line1 = state.doc.lineAt(head1);
                if (line1.from == last) continue;
                last = line1.from;
                var indent = getIndentation(state, line1.from);
                if (indent == null) continue;
                var cur = /^\s*/.exec(line1.text)[0];
                var norm = indentString(state, indent);
                if (cur != norm) changes.push({
                    from: line1.from,
                    to: line1.from + cur.length,
                    insert: norm
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return changes.length ? [
            tr,
            {
                changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ var foldService = /*@__PURE__*/ (0, _state.Facet).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ var foldNodeProp = /*@__PURE__*/ new (0, _common.NodeProp)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function foldInside(node) {
    var first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function syntaxFolding(state, start, end) {
    var tree = syntaxTree(state);
    if (tree.length < end) return null;
    var stack = tree.resolveStack(end, 1);
    var found = null;
    for(var iter = stack; iter; iter = iter.next){
        var cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        var prop = cur.type.prop(foldNodeProp);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !isUnfinished(cur))) {
            var value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function isUnfinished(node) {
    var ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function foldable(state, lineStart, lineEnd) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.facet(foldService)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var service = _step.value;
            var result = service(state, lineStart, lineEnd);
            if (result) return result;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return syntaxFolding(state, lineStart, lineEnd);
}
function mapRange(range, mapping) {
    var from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from,
        to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ var foldEffect = /*@__PURE__*/ (0, _state.StateEffect).define({
    map: mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ var unfoldEffect = /*@__PURE__*/ (0, _state.StateEffect).define({
    map: mapRange
});
function selectedLines(view) {
    var lines = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var head = _step.value.head;
            if (lines.some((l)=>l.from <= head && l.to >= head)) return "continue";
            lines.push(view.lineBlockAt(head));
        };
        for(var _iterator = view.state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ var foldState = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return (0, _view.Decoration).none;
    },
    update (folded, tr) {
        folded = folded.map(tr.changes);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var e = _step.value;
                if (e.is(foldEffect) && !foldExists(folded, e.value.from, e.value.to)) {
                    var preparePlaceholder = tr.state.facet(foldConfig).preparePlaceholder;
                    var widget = !preparePlaceholder ? foldWidget : (0, _view.Decoration).replace({
                        widget: new PreparedFoldWidget(preparePlaceholder(tr.state, e.value))
                    });
                    folded = folded.update({
                        add: [
                            widget.range(e.value.from, e.value.to)
                        ]
                    });
                } else if (e.is(unfoldEffect)) folded = folded.update({
                    filter: (from, to)=>e.value.from != from || e.value.to != to,
                    filterFrom: e.value.from,
                    filterTo: e.value.to
                });
            };
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) {
            var onSelection = false, head = tr.selection.main.head;
            folded.between(head, head, (a, b)=>{
                if (a < head && b > head) onSelection = true;
            });
            if (onSelection) folded = folded.update({
                filterFrom: head,
                filterTo: head,
                filter: (a, b)=>b <= head || a >= head
            });
        }
        return folded;
    },
    provide: (f)=>(0, _view.EditorView).decorations.from(f),
    toJSON (folded, state) {
        var ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        var ranges = [];
        for(var i = 0; i < value.length;){
            var from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push(foldWidget.range(from, to));
        }
        return (0, _view.Decoration).set(ranges, true);
    }
});
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function foldedRanges(state) {
    return state.field(foldState, false) || (0, _state.RangeSet).empty;
}
function findFold(state, from, to) {
    var _a;
    var found = null;
    (_a = state.field(foldState, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from,
            to
        };
    });
    return found;
}
function foldExists(folded, from, to) {
    var found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function maybeEnable(state, other) {
    return state.field(foldState, false) ? other : other.concat((0, _state.StateEffect).appendConfig.of(codeFolding()));
}
/**
Fold the lines that are selected, if possible.
*/ var foldCode = (view)=>{
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selectedLines(view)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var line = _step.value;
            var range = foldable(view.state, line.from, line.to);
            if (range) {
                view.dispatch({
                    effects: maybeEnable(view.state, [
                        foldEffect.of(range),
                        announceFold(view, range)
                    ])
                });
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ var unfoldCode = (view)=>{
    if (!view.state.field(foldState, false)) return false;
    var effects = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selectedLines(view)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var line = _step.value;
            var folded = findFold(view.state, line.from, line.to);
            if (folded) effects.push(unfoldEffect.of(folded), announceFold(view, folded, false));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (effects.length) view.dispatch({
        effects
    });
    return effects.length > 0;
};
function announceFold(view, range) {
    var fold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, _view.EditorView).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ var foldAll = (view)=>{
    var state = view.state, effects = [];
    for(var pos = 0; pos < state.doc.length;){
        var line = view.lineBlockAt(pos), range = foldable(state, line.from, line.to);
        if (range) effects.push(foldEffect.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ var unfoldAll = (view)=>{
    var field = view.state.field(foldState, false);
    if (!field || !field.size) return false;
    var effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push(unfoldEffect.of({
            from,
            to
        }));
    });
    view.dispatch({
        effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(var line = lineBlock;;){
        var foldableRegion = foldable(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ var toggleFold = (view)=>{
    var effects = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selectedLines(view)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var line = _step.value;
            var folded = findFold(view.state, line.from, line.to);
            if (folded) effects.push(unfoldEffect.of(folded), announceFold(view, folded, false));
            else {
                var foldRange = foldableContainer(view, line);
                if (foldRange) effects.push(foldEffect.of(foldRange), announceFold(view, foldRange));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ var foldKeymap = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: foldCode
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: unfoldCode
    },
    {
        key: "Ctrl-Alt-[",
        run: foldAll
    },
    {
        key: "Ctrl-Alt-]",
        run: unfoldAll
    }
];
var defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
var foldConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (values) {
        return (0, _state.combineConfig)(values, defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function codeFolding(config) {
    var result = [
        foldState,
        baseTheme$1
    ];
    if (config) result.push(foldConfig.of(config));
    return result;
}
function widgetToDOM(view, prepared) {
    var state = view.state, conf = state.facet(foldConfig);
    var onclick = (event)=>{
        var line = view.lineBlockAt(view.posAtDOM(event.target));
        var folded = findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: unfoldEffect.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    var element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
var foldWidget = /*@__PURE__*/ (0, _view.Decoration).replace({
    widget: /*@__PURE__*/ new class extends (0, _view.WidgetType) {
        toDOM(view) {
            return widgetToDOM(view, null);
        }
    }
});
class PreparedFoldWidget extends (0, _view.WidgetType) {
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return widgetToDOM(view, this.value);
    }
    constructor(value){
        super();
        this.value = value;
    }
}
var foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class FoldMarker extends (0, _view.GutterMarker) {
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        var span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function foldGutter() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var fullConfig = Object.assign(Object.assign({}, foldGutterDefaults), config);
    var canFold = new FoldMarker(fullConfig, true), canUnfold = new FoldMarker(fullConfig, false);
    var markers = (0, _view.ViewPlugin).fromClass(class {
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet(language) != update.state.facet(language) || update.startState.field(foldState, false) != update.state.field(foldState, false) || syntaxTree(update.startState) != syntaxTree(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            var builder = new (0, _state.RangeSetBuilder)();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = view.viewportLineBlocks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var line = _step.value;
                    var mark = findFold(view.state, line.from, line.to) ? canUnfold : foldable(view.state, line.from, line.to) ? canFold : null;
                    if (mark) builder.add(line.from, line.from, mark);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return builder.finish();
        }
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
    });
    var domEventHandlers = fullConfig.domEventHandlers;
    return [
        markers,
        (0, _view.gutter)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, _state.RangeSet).empty;
            },
            initialSpacer () {
                return new FoldMarker(fullConfig, false);
            },
            domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), {
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    var folded = findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: unfoldEffect.of(folded)
                        });
                        return true;
                    }
                    var range = foldable(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: foldEffect.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            })
        }),
        codeFolding()
    ];
}
var baseTheme$1 = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class HighlightStyle {
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new HighlightStyle(specs, options || {});
    }
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        var modSpec;
        function def(spec) {
            var cls = (0, _styleMod.StyleModule).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        var all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        var scopeOpt = options.scope;
        this.scope = scopeOpt instanceof Language ? (type)=>type.prop(languageDataProp) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, _highlight.tagHighlighter)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all
        }).style;
        this.module = modSpec ? new (0, _styleMod.StyleModule)(modSpec) : null;
        this.themeType = options.themeType;
    }
}
var highlighterFacet = /*@__PURE__*/ (0, _state.Facet).define();
var fallbackHighlighter = /*@__PURE__*/ (0, _state.Facet).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function getHighlighters(state) {
    var main = state.facet(highlighterFacet);
    return main.length ? main : state.facet(fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function syntaxHighlighting(highlighter, options) {
    var ext = [
        treeHighlighter
    ], themeType;
    if (highlighter instanceof HighlightStyle) {
        if (highlighter.module) ext.push((0, _view.EditorView).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push(fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push(highlighterFacet.computeN([
        (0, _view.EditorView).darkTheme
    ], (state)=>{
        return state.facet((0, _view.EditorView).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push(highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function highlightingFor(state, tags, scope) {
    var highlighters = getHighlighters(state);
    var result = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (highlighters) try {
        for(var _iterator = highlighters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var highlighter = _step.value;
            if (!highlighter.scope || scope && highlighter.scope(scope)) {
                var cls = highlighter.style(tags);
                if (cls) result = result ? result + " " + cls : cls;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
class TreeHighlighter {
    update(update) {
        var tree = syntaxTree(update.state), highlighters = getHighlighters(update.state);
        var styleChange = highlighters != getHighlighters(update.startState);
        var viewport = update.view.viewport, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, _view.Decoration).none;
        var builder = new (0, _state.RangeSetBuilder)();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = view.visibleRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
                (0, _highlight.highlightTree)(this.tree, highlighters, (from, to, style)=>{
                    builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, _view.Decoration).mark({
                        class: style
                    })));
                }, from, to);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return builder.finish();
    }
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = syntaxTree(view.state);
        this.decorations = this.buildDeco(view, getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
}
var treeHighlighter = /*@__PURE__*/ (0, _state.Prec).high(/*@__PURE__*/ (0, _view.ViewPlugin).fromClass(TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ var defaultHighlightStyle = /*@__PURE__*/ HighlightStyle.define([
    {
        tag: (0, _highlight.tags).meta,
        color: "#404740"
    },
    {
        tag: (0, _highlight.tags).link,
        textDecoration: "underline"
    },
    {
        tag: (0, _highlight.tags).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, _highlight.tags).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, _highlight.tags).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, _highlight.tags).atom,
            (0, _highlight.tags).bool,
            (0, _highlight.tags).url,
            (0, _highlight.tags).contentSeparator,
            (0, _highlight.tags).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, _highlight.tags).literal,
            (0, _highlight.tags).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, _highlight.tags).string,
            (0, _highlight.tags).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, _highlight.tags).regexp,
            (0, _highlight.tags).escape,
            /*@__PURE__*/ (0, _highlight.tags).special((0, _highlight.tags).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, _highlight.tags).definition((0, _highlight.tags).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, _highlight.tags).local((0, _highlight.tags).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, _highlight.tags).typeName,
            (0, _highlight.tags).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, _highlight.tags).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, _highlight.tags).special((0, _highlight.tags).variableName),
            (0, _highlight.tags).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, _highlight.tags).definition((0, _highlight.tags).propertyName),
        color: "#00c"
    },
    {
        tag: (0, _highlight.tags).comment,
        color: "#940"
    },
    {
        tag: (0, _highlight.tags).invalid,
        color: "#f00"
    }
]);
var baseTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
var DefaultScanDist = 10000, DefaultBrackets = "()[]{}";
var bracketMatchingConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        return (0, _state.combineConfig)(configs, {
            afterCursor: true,
            brackets: DefaultBrackets,
            maxScanDistance: DefaultScanDist,
            renderMatch: defaultRenderMatch
        });
    }
});
var matchingMark = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-matchingBracket"
}), nonmatchingMark = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-nonmatchingBracket"
});
function defaultRenderMatch(match) {
    var decorations = [];
    var mark = match.matched ? matchingMark : nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
var bracketMatchingState = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return (0, _view.Decoration).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        var decorations = [];
        var config = tr.state.facet(bracketMatchingConfig);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var range = _step.value;
                if (!range.empty) continue;
                var match = matchBrackets(tr.state, range.head, -1, config) || range.head > 0 && matchBrackets(tr.state, range.head - 1, 1, config) || config.afterCursor && (matchBrackets(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && matchBrackets(tr.state, range.head + 1, -1, config));
                if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0, _view.Decoration).set(decorations, true);
    },
    provide: (f)=>(0, _view.EditorView).decorations.from(f)
});
var bracketMatchingUnique = [
    bracketMatchingState,
    baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function bracketMatching() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        bracketMatchingConfig.of(config),
        bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ var bracketMatchingHandle = /*@__PURE__*/ new (0, _common.NodeProp)();
function matchingNodes(node, dir, brackets) {
    var byProp = node.prop(dir < 0 ? (0, _common.NodeProp).openedBy : (0, _common.NodeProp).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        var index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function findHandle(node) {
    var hasHandle = node.type.prop(bracketMatchingHandle);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function matchBrackets(state, pos, dir) {
    var config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var maxScanDistance = config.maxScanDistance || DefaultScanDist, brackets = config.brackets || DefaultBrackets;
    var tree = syntaxTree(state), node = tree.resolveInner(pos, dir);
    for(var cur = node; cur; cur = cur.parent){
        var matches = matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            var handle = findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    var parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    var depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            var endHandle = findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if (matchingNodes(cursor.type, dir, brackets)) depth++;
        else if (matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                var endHandle1 = findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle1 && endHandle1.from < endHandle1.to ? {
                        from: endHandle1.from,
                        to: endHandle1.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    var startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    var bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    var startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    var iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(var distance = 0; !iter.next().done && distance <= maxScanDistance;){
        var text = iter.value;
        if (dir < 0) distance += text.length;
        var basePos = pos + distance * dir;
        for(var _$pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; _$pos != end; _$pos += dir){
            var found = brackets.indexOf(text[_$pos]);
            if (found < 0 || tree.resolveInner(basePos + _$pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + _$pos,
                    to: basePos + _$pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function countCol(string, end, tabSize) {
    var startIndex = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, startValue = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    var n = startValue;
    for(var i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class StringStream {
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        var start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
}
function fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || noTokens
    };
}
function defaultCopyState(state) {
    if (typeof state != "object") return state;
    var newState = {};
    for(var prop in state){
        var val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
var IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class StreamLanguage extends Language {
    /**
    Define a stream language.
    */ static define(spec) {
        return new StreamLanguage(spec);
    }
    getIndent(cx, pos) {
        var tree = syntaxTree(cx.state), at = tree.resolve(pos);
        while(at && at.type != this.topNode)at = at.parent;
        if (!at) return null;
        var from = undefined;
        var overrideIndentation = cx.options.overrideIndentation;
        if (overrideIndentation) {
            from = IndentedFrom.get(cx.state);
            if (from != null && from < pos - 1e4) from = undefined;
        }
        var start = findState(this, tree, 0, at.from, from !== null && from !== void 0 ? from : pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = 0;
        }
        if (pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < pos){
            var line = cx.state.doc.lineAt(statePos), end = Math.min(pos, line.to);
            if (line.length) {
                var indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                var stream = new StringStream(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == pos) break;
            statePos = line.to + 1;
        }
        var line1 = cx.lineAt(pos);
        if (overrideIndentation && from == null) IndentedFrom.set(cx.state, line1.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line1.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
    constructor(parser){
        var data = defineLanguageFacet(parser.languageData);
        var p = fullParser(parser), self;
        var impl = new class extends (0, _common.Parser) {
            createParse(input, fragments, ranges) {
                return new Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [
            indentService.of((cx, pos)=>this.getIndent(cx, pos))
        ], parser.name);
        this.topNode = docID(data);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, _common.NodeProp)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new TokenTable(p.tokenTable) : defaultTokenTable;
    }
}
function findState(lang, tree, off, startPos, before) {
    var state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(var i = tree.children.length - 1; i >= 0; i--){
        var child = tree.children[i], pos = off + tree.positions[i];
        var found = child instanceof (0, _common.Tree) && pos < before && findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && tree.type == lang.topNode) inside = true;
    for(var i = tree.children.length - 1; i >= 0; i--){
        var pos = tree.positions[i], child = tree.children[i], inner = void 0;
        if (pos < to && child instanceof (0, _common.Tree)) {
            if (!(inner = cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, _common.Tree)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function findStartInFragments(lang, fragments, startPos, editorState) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = fragments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var f = _step.value;
            var from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
            var found = from <= startPos && to > startPos && findState(lang, f.tree, 0 - f.offset, startPos, to), tree = void 0;
            if (found && (tree = cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
                state: found.state,
                tree
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        state: lang.streamParser.startState(editorState ? getIndentUnit(editorState) : 4),
        tree: (0, _common.Tree).empty
    };
}
class Parse {
    advance() {
        var context = ParseContext.get();
        var parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        var end = Math.min(parseEnd, this.chunkStart + 2048 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        var chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            var eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        var from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(var index = this.rangeIndex;;){
            var rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            var rangeStart = this.ranges[index].from;
            var after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line,
            end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            var end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            var start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, size, offset) {
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            var len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        var _this_nextLine = this.nextLine(), line = _this_nextLine.line, end = _this_nextLine.end, offset = 0, streamParser = this.lang.streamParser;
        var stream = new StringStream(line, context ? context.state.tabSize : 4, context ? getIndentUnit(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            var token = readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, 4, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        var tree = (0, _common.Tree).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, _common.Tree)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, _common.Tree)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        var context = ParseContext.get(), from = ranges[0].from;
        var _findStartInFragments = findStartInFragments(lang, fragments, from, context === null || context === void 0 ? void 0 : context.state), state = _findStartInFragments.state, tree = _findStartInFragments.tree;
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(var i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */ ) {
            this.state = this.lang.streamParser.startState(getIndentUnit(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
}
function readToken(token, stream, state) {
    stream.start = stream.pos;
    for(var i = 0; i < 10; i++){
        var result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
var noTokens = /*@__PURE__*/ Object.create(null);
var typeArray = [
    (0, _common.NodeType).none
];
var nodeSet = /*@__PURE__*/ new (0, _common.NodeSet)(typeArray);
var warned = [];
// Cache of node types by name and tags
var byTag = /*@__PURE__*/ Object.create(null);
var defaultTable = /*@__PURE__*/ Object.create(null);
for(var _i = 0, _iter = [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
]; _i < _iter.length; _i++){
    var _iter__i = (0, _slicedToArray._)(_iter[_i], 2), legacyName = _iter__i[0], name = _iter__i[1];
    defaultTable[legacyName] = /*@__PURE__*/ createTokenType(noTokens, name);
}
class TokenTable {
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = createTokenType(this.extra, tag));
    }
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), defaultTable);
    }
}
var defaultTokenTable = /*@__PURE__*/ new TokenTable(noTokens);
function warnForPart(part, msg) {
    if (warned.indexOf(part) > -1) return;
    warned.push(part);
    console.warn(msg);
}
function createTokenType(extra, tagStr) {
    var tags$1 = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tagStr.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var found = [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = name.split(".")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var part = _step1.value;
                    var value = extra[part] || (0, _highlight.tags)[part];
                    if (!value) warnForPart(part, `Unknown highlighting tag ${part}`);
                    else if (typeof value == "function") {
                        if (!found.length) warnForPart(part, `Modifier ${part} used at start of tag`);
                        else found = found.map(value);
                    } else if (found.length) warnForPart(part, `Tag ${part} used as modifier`);
                    else found = Array.isArray(value) ? value : [
                        value
                    ];
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = found[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var tag = _step2.value;
                    tags$1.push(tag);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!tags$1.length) return 0;
    var name1 = tagStr.replace(/ /g, "_"), key = name1 + " " + tags$1.map((t)=>t.id);
    var known = byTag[key];
    if (known) return known.id;
    var type = byTag[key] = (0, _common.NodeType).define({
        id: typeArray.length,
        name: name1,
        props: [
            (0, _highlight.styleTags)({
                [name1]: tags$1
            })
        ]
    });
    typeArray.push(type);
    return type.id;
}
function docID(data) {
    var type = (0, _common.NodeType).define({
        id: typeArray.length,
        name: "Document",
        props: [
            languageDataProp.add(()=>data)
        ],
        top: true
    });
    typeArray.push(type);
    return type;
}
function buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function textHasRTL(text) {
    for(var i = text.iter(); !i.next().done;)if (buildForLine(i.value)) return true;
    return false;
}
function changeAddsRTL(change) {
    var added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && textHasRTL(ins)) added = true;
    });
    return added;
}
var alwaysIsolate = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function bidiIsolates() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var extensions = [
        isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push(alwaysIsolate.of(true));
    return extensions;
}
var isolateMarks = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class {
    update(update) {
        var always = update.state.facet(alwaysIsolate) || update.view.textDirection != (0, _view.Direction).LTR || update.state.facet((0, _view.EditorView).perLineTextDirection);
        if (!always && !this.hasRTL && changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        var tree = syntaxTree(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = buildDeco(update.view, tree, always);
        }
    }
    constructor(view){
        this.always = view.state.facet(alwaysIsolate) || view.textDirection != (0, _view.Direction).LTR || view.state.facet((0, _view.EditorView).perLineTextDirection);
        this.hasRTL = !this.always && textHasRTL(view.state.doc);
        this.tree = syntaxTree(view.state);
        this.decorations = this.always || this.hasRTL ? buildDeco(view, this.tree, this.always) : (0, _view.Decoration).none;
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, _view.Decoration).none;
        }
        return [
            (0, _view.EditorView).outerDecorations.of(access),
            (0, _state.Prec).lowest((0, _view.EditorView).bidiIsolatedRanges.of(access))
        ];
    }
});
function buildDeco(view, tree, always) {
    var deco = new (0, _state.RangeSetBuilder)();
    var ranges = view.visibleRanges;
    if (!always) ranges = clipRTLLines(ranges, view.state.doc);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
            tree.iterate({
                enter: (node)=>{
                    var iso = node.type.prop((0, _common.NodeProp).isolate);
                    if (iso) deco.add(node.from, node.to, marks[iso]);
                },
                from,
                to
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return deco.finish();
}
function clipRTLLines(ranges, doc) {
    var cur = doc.iter(), pos = 0, result = [], last = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
            if (from != pos) {
                if (pos < from) cur.next(from - pos);
                pos = from;
            }
            for(;;){
                var start = pos, end = pos + cur.value.length;
                if (!cur.lineBreak && buildForLine(cur.value)) {
                    if (last && last.to > start - 10) last.to = Math.min(to, end);
                    else result.push(last = {
                        from: start,
                        to: Math.min(to, end)
                    });
                }
                if (pos >= to) break;
                pos = end;
                cur.next();
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
var marks = {
    rtl: /*@__PURE__*/ (0, _view.Decoration).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, _view.Direction).RTL
    }),
    ltr: /*@__PURE__*/ (0, _view.Decoration).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, _view.Direction).LTR
    }),
    auto: /*@__PURE__*/ (0, _view.Decoration).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@lezer/common":"9CjLE","@codemirror/state":"fECfb","@codemirror/view":"l3day","@lezer/highlight":"pdORT","style-mod":"dgaAD","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"9CjLE":[function(require,module,exports) {
/**
The default maximum length of a `TreeBuffer` node.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultBufferLength", ()=>DefaultBufferLength);
parcelHelpers.export(exports, "IterMode", ()=>IterMode);
parcelHelpers.export(exports, "MountedTree", ()=>MountedTree);
parcelHelpers.export(exports, "NodeProp", ()=>NodeProp);
parcelHelpers.export(exports, "NodeSet", ()=>NodeSet);
parcelHelpers.export(exports, "NodeType", ()=>NodeType);
parcelHelpers.export(exports, "NodeWeakMap", ()=>NodeWeakMap);
parcelHelpers.export(exports, "Parser", ()=>Parser);
parcelHelpers.export(exports, "Tree", ()=>Tree);
parcelHelpers.export(exports, "TreeBuffer", ()=>TreeBuffer);
parcelHelpers.export(exports, "TreeCursor", ()=>TreeCursor);
parcelHelpers.export(exports, "TreeFragment", ()=>TreeFragment);
parcelHelpers.export(exports, "parseMixed", ()=>parseMixed);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var DefaultBufferLength = 1024;
var nextPropID = 0;
class Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class NodeProp {
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = NodeType.match(match);
        return (type)=>{
            var result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
    /**
    Create a new node prop type.
    */ constructor(ref){
        var config = ref === void 0 ? {} : ref;
        this.id = nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ NodeProp.closedBy = new NodeProp({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ NodeProp.openedBy = new NodeProp({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ NodeProp.group = new NodeProp({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ NodeProp.isolate = new NodeProp({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ NodeProp.contextHash = new NodeProp({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ NodeProp.lookAhead = new NodeProp({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ NodeProp.mounted = new NodeProp({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class MountedTree {
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[NodeProp.mounted.id];
    }
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
}
var noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class NodeType {
    /**
    Define a node type.
    */ static define(spec) {
        var props = spec.props && spec.props.length ? Object.create(null) : noProps;
        var flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        var type = new NodeType(spec.name || "", props, spec.id, flags);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (spec.props) try {
            for(var _iterator = spec.props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var src = _step.value;
                if (!Array.isArray(src)) src = src(type);
                if (src) {
                    if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                    props[src[0].id] = src[1];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == "string") {
            if (this.name == name) return true;
            var group = this.prop(NodeProp.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        var direct = Object.create(null);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var prop in map)try {
            for(var _iterator = prop.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                direct[name] = map[prop];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (node)=>{
            for(var groups = node.prop(NodeProp.group), i = -1; i < (groups ? groups.length : 0); i++){
                var found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ ref){
        var flags = ref === void 0 ? 0 : ref;
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ NodeType.none = new NodeType("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class NodeSet {
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend() {
        for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
            props[_key] = arguments[_key];
        }
        var newTypes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var type = _step.value;
                var newProps = null;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = props[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var source = _step1.value;
                        var add = source(type);
                        if (add) {
                            if (!newProps) newProps = Object.assign({}, type.props);
                            newProps[add[0].id] = add[1];
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                newTypes.push(newProps ? new NodeType(type.name, newProps, type.id, type.flags) : type);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new NodeSet(newTypes);
    }
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(var i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
}
var CachedNode = new WeakMap(), CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var IterMode;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})(IterMode || (IterMode = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class Tree {
    /**
    @internal
    */ toString() {
        var mounted = MountedTree.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        var children = "";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ch = _step.value;
                var str = ch.toString();
                if (str) {
                    if (children) children += ",";
                    children += str;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor() {
        var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return new TreeCursor(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var scope = CachedNode.get(this) || this.topNode;
        var cursor = new TreeCursor(scope);
        cursor.moveTo(pos, side);
        CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var node = resolveNode(CachedNode.get(this) || this.topNode, pos, side, false);
        CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var node = resolveNode(CachedInnerNode.get(this) || this.topNode, pos, side, true);
        CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        var enter = spec.enter, leave = spec.leave, _spec_from = spec.from, from = _spec_from === void 0 ? 0 : _spec_from, _spec_to = spec.to, to = _spec_to === void 0 ? this.length : _spec_to;
        var mode = spec.mode || 0, anon = (mode & IterMode.IncludeAnonymous) > 0;
        for(var c = this.cursor(mode | IterMode.IncludeAnonymous);;){
            var entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        var result = [];
        if (this.props) for(var id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : balanceRange(NodeType.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new Tree(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new Tree(NodeType.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return buildTree(data);
    }
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), prop = _step_value[0], value = _step_value[1];
                    this.props[typeof prop == "number" ? prop : prop.id] = value;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
}
/**
The empty tree
*/ Tree.empty = new Tree(NodeType.none, [], [], 0);
class FlatBufferCursor {
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new FlatBufferCursor(this.buffer, this.index);
    }
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class TreeBuffer {
    /**
    @internal
    */ get type() {
        return NodeType.none;
    }
    /**
    @internal
    */ toString() {
        var result = [];
        for(var index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        var id = this.buffer[index], endIndex = this.buffer[index + 3];
        var type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        var children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        var buffer = this.buffer, pick = -1;
        for(var i = startIndex; i != endIndex; i = buffer[i + 3])if (checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        var b = this.buffer;
        var copy = new Uint16Array(endI - startI), len = 0;
        for(var i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            var to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new TreeBuffer(copy, len, this.set);
    }
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
}
function checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        var parent = !overlays && node instanceof TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    var mode = overlays ? 0 : IterMode.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(var scan = node, parent1 = scan.parent; parent1; scan = parent1, parent1 = scan.parent)if (scan instanceof TreeNode && scan.index < 0 && ((_a = parent1.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent1;
    }
    for(;;){
        var inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class BaseNode {
    cursor() {
        var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return new TreeCursor(this, mode);
    }
    getChild(type) {
        var before = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, after = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var r = getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type) {
        var before = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, after = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        return getChildren(this, type, before, after);
    }
    resolve(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return resolveNode(this, pos, side, false);
    }
    resolveInner(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return matchNodeContext(this, context);
    }
    enterUnfinishedNodesBefore(pos) {
        var scan = this.childBefore(pos), node = this;
        while(scan){
            var last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class TreeNode extends BaseNode {
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side) {
        var mode = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
        for(var parent = this;;){
            for(var _parent__tree = parent._tree, children = _parent__tree.children, positions = _parent__tree.positions, e = dir > 0 ? children.length : -1; i != e; i += dir){
                var next = children[i], start = positions[i] + parent.from;
                if (!checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof TreeBuffer) {
                    if (mode & IterMode.ExcludeBuffers) continue;
                    var index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new BufferNode(new BufferContext(parent, next, i, start), null, index);
                } else if (mode & IterMode.IncludeAnonymous || !next.type.isAnonymous || hasChild(next)) {
                    var mounted = void 0;
                    if (!(mode & IterMode.IgnoreMounts) && (mounted = MountedTree.get(next)) && !mounted.overlay) return new TreeNode(mounted.tree, start, i, parent);
                    var inner = new TreeNode(next, start, i, parent);
                    return mode & IterMode.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & IterMode.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side) {
        var mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var mounted;
        if (!(mode & IterMode.IgnoreOverlays) && (mounted = MountedTree.get(this._tree)) && mounted.overlay) {
            var rPos = pos - this.from;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mounted.overlay[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
                    if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        var val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
}
function getChildren(node, type, before, after) {
    var cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(var found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function matchNodeContext(node, context) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : context.length - 1;
    for(var p = node.parent; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class BufferNode extends BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    child(dir, pos, side) {
        var buffer = this.context.buffer;
        var index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side) {
        var mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if (mode & IterMode.ExcludeBuffers) return null;
        var buffer = this.context.buffer;
        var index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        var buffer = this.context.buffer;
        var after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        var buffer = this.context.buffer;
        var parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        var children = [], positions = [];
        var buffer = this.context.buffer;
        var startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            var from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new Tree(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
}
function iterStack(heads) {
    if (!heads.length) return null;
    var pick = 0, picked = heads[0];
    for(var i = 1; i < heads.length; i++){
        var node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    var next = picked instanceof TreeNode && picked.index < 0 ? null : picked.parent;
    var newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new StackIterator(newHeads, picked);
}
class StackIterator {
    get next() {
        return iterStack(this.heads);
    }
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
}
function stackIterator(tree, pos, side) {
    var inner = tree.resolveInner(pos, side), layers = null;
    for(var scan = inner instanceof TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        var parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        var mount = MountedTree.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            var root = new TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push(resolveNode(root, pos, side, false));
        }
    }
    return layers ? iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class TreeCursor {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        var _this_buffer = this.buffer, start = _this_buffer.start, buffer = _this_buffer.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        var buffer = this.buffer.buffer;
        var index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side) {
        var mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.mode;
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & IterMode.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & IterMode.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        var parent = this.mode & IterMode.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        var buffer = this.buffer.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            var parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            var after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        var index, parent, buffer = this.buffer;
        var ref;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(var i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            var ref1;
            ref1 = buffer, index = ref1.index, parent = ref1.parent, ref1;
        } else ref = this._tree, index = ref.index, parent = ref._parent, ref;
        var ref2;
        for(; parent; ref2 = parent, index = ref2.index, parent = ref2._parent, ref2){
            if (index > -1) for(var i1 = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i1 != e; i1 += dir){
                var child = parent._tree.children[i1];
                if (this.mode & IterMode.IncludeAnonymous || child instanceof TreeBuffer || !child.type.isAnonymous || hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next() {
        var enter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traveral. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev() {
        var enter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos) {
        var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        var cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(var index = this.index, d = this.stack.length; d >= 0;){
            for(var c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(var i = depth; i < this.stack.length; i++)result = new BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(var depth = 0;;){
            var mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (this.nextSibling()) break;
                if (!depth) return;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return matchNodeContext(this.node, context);
        var buffer = this.buffer.buffer, types = buffer.set.types;
        for(var i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return matchNodeContext(this.node, context, i);
            var type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
    /**
    @internal
    */ constructor(node, /**
    @internal
    */ ref){
        var mode = ref === void 0 ? 0 : ref;
        this.mode = mode;
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        if (node instanceof TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(var n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
}
function hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof TreeBuffer || !ch.type.isAnonymous || hasChild(ch));
}
function buildTree(data) {
    var _a;
    var buffer = data.buffer, nodeSet = data.nodeSet, _data_maxBufferLength = data.maxBufferLength, maxBufferLength = _data_maxBufferLength === void 0 ? DefaultBufferLength : _data_maxBufferLength, _data_reused = data.reused, reused = _data_reused === void 0 ? [] : _data_reused, _data_minRepeatType = data.minRepeatType, minRepeatType = _data_minRepeatType === void 0 ? nodeSet.types.length : _data_minRepeatType;
    var cursor = Array.isArray(buffer) ? new FlatBufferCursor(buffer, buffer.length) : buffer;
    var types = nodeSet.types;
    var contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        var id = cursor.id, start = cursor.start, end = cursor.end, size = cursor.size;
        var lookAheadAtStart = lookAhead;
        while(size < 0){
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                var node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        var type = types[id], node1, buffer;
        var startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            var _$data = new Uint16Array(buffer.size - buffer.skip);
            var endPos = cursor.pos - buffer.size, index = _$data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, _$data, index);
            node1 = new TreeBuffer(_$data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            var endPos1 = cursor.pos - size;
            cursor.next();
            var localChildren = [], localPositions = [];
            var localInRepeat = id >= minRepeatType ? id : -1;
            var lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos1){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos1, localChildren, localPositions);
                else takeNode(start, endPos1, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                var make = makeBalanced(type);
                node1 = balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node1 = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end);
        }
        children.push(node1);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        var nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        var nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            var id = cursor.id, start = cursor.start, end = cursor.end, size = cursor.size;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            var buffer = new Uint16Array(nodeCount * 4);
            var start1 = nodes[nodes.length - 2];
            for(var i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start1;
                buffer[j++] = nodes[i + 2] - start1;
                buffer[j++] = j;
            }
            children.push(new TreeBuffer(buffer, nodes[2] - start1, nodeSet));
            positions.push(start1 - parentStart);
        }
    }
    function makeBalanced(type) {
        return (children, positions, length)=>{
            var lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof Tree) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop(NodeProp.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead) {
        var localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length) {
        var lookAhead = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, props = arguments.length > 5 ? arguments[5] : void 0;
        if (contextHash) {
            var pair = [
                NodeProp.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            var pair1 = [
                NodeProp.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair1
            ].concat(props) : [
                pair1
            ];
        }
        return new Tree(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        var fork = cursor.fork();
        var size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        var result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(var minPos = fork.pos - maxSize; fork.pos > minPos;){
            var nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            var startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            var localSkipped = fork.id >= minRepeatType ? 4 : 0;
            var nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        var id = cursor.id, start = cursor.start, end = cursor.end, size = cursor.size;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            var startIndex = index;
            if (size > 4) {
                var endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    var children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    var length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new Tree(types[data.topID], children.reverse(), positions.reverse(), length);
}
var nodeSizeCache = new WeakMap;
function nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof TreeBuffer || node.type != balanceType) return 1;
    var size = nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (child.type != balanceType || !(child instanceof Tree)) {
                    size = 1;
                    break;
                }
                size += nodeSize(balanceType, child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        nodeSizeCache.set(node, size);
    }
    return size;
}
function balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    var total = 0;
    for(var i = from; i < to; i++)total += nodeSize(balanceType, children[i]);
    var maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    var localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(var i = from; i < to;){
            var groupFrom = i, groupStart = positions[i], groupSize = nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                var nextSize = nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    var only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                var _$length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push(balanceRange(balanceType, children, positions, groupFrom, i, groupStart, _$length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class NodeWeakMap {
    setBuffer(buffer, index, value) {
        var inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        var inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
    constructor(){
        this.map = new WeakMap();
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class TreeFragment {
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree) {
        var fragments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], partial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var result = [
            new TreeFragment(0, tree.length, tree, 0, false, partial)
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fragments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var f = _step.value;
                if (f.to > tree.length) result.push(f);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes) {
        var minGap = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 128;
        if (!changes.length) return fragments;
        var result = [];
        var fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(var cI = 0, pos = 0, off = 0;; cI++){
            var nextC = cI < changes.length ? changes[cI] : null;
            var nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                var cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    var fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new TreeFragment(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, ref, ref1){
        var openStart = ref === void 0 ? false : ref, openEnd = ref1 === void 0 ? false : ref1;
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
}
/**
A superclass that parsers should extend.
*/ class Parser {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new StringInput(input);
        ranges = !ranges ? [
            new Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new Range(r.from, r.to)) : [
            new Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        var parse = this.startParse(input, fragments, ranges);
        for(;;){
            var done = parse.advance();
            if (done) return done;
        }
    }
}
class StringInput {
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
    constructor(string){
        this.string = string;
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function parseMixed(nest) {
    return (parse, input, fragments, ranges)=>new MixedParse(parse, nest, input, fragments, ranges);
}
class InnerParse {
    constructor(parser, parse, overlay, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.from = from;
    }
}
function checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
var stoppedInner = new NodeProp({
    perNode: true
});
class MixedParse {
    advance() {
        if (this.baseParse) {
            var done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (this.stoppedAt != null) try {
                for(var _iterator = this.inner[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var inner = _step.value;
                    inner.parse.stopAt(this.stoppedAt);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (this.innerDone == this.inner.length) {
            var result = this.baseTree;
            if (this.stoppedAt != null) result = new Tree(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        var inner1 = this.inner[this.innerDone], done1 = inner1.parse.advance();
        if (done1) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            var props = Object.assign(Object.create(null), inner1.target.props);
            props[NodeProp.mounted.id] = new MountedTree(done1, inner1.overlay, inner1.parser);
            inner1.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        var pos = this.input.length;
        for(var i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(var i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        var _this = this, _loop = function(nest1, isCovered1) {
            var enter = true, range = void 0;
            if (_this.stoppedAt != null && cursor.from >= _this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    var match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (match) try {
                        var _loop = function() {
                            var r = _step.value;
                            var from = r.from + match.pos, to = r.to + match.pos;
                            if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                                from,
                                to
                            });
                        };
                        for(var _iterator = match.mount.overlay[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                enter = false;
            } else if (covered && (isCovered1 = checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered1 != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest1 = _this.nest(cursor, _this.input)) && (cursor.from < cursor.to || !nest1.overlay)) {
                if (!cursor.tree) materialize(cursor);
                var oldMounts = fragmentCursor.findMounts(cursor.from, nest1.parser);
                if (typeof nest1.overlay == "function") overlay = new ActiveOverlay(nest1.parser, nest1.overlay, oldMounts, _this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    var ranges = punchRanges(_this.ranges, nest1.overlay || (cursor.from < cursor.to ? [
                        new Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) checkRanges(ranges);
                    if (ranges.length || !nest1.overlay) _this.inner.push(new InnerParse(nest1.parser, ranges.length ? nest1.parser.startParse(_this.input, enterFragments(oldMounts, ranges), ranges) : nest1.parser.startParse(""), nest1.overlay ? nest1.overlay.map((r)=>new Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest1.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new Range(cursor.from, cursor.to);
                if (range.from < range.to) overlay.ranges.push(range);
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) return nest = nest1, isCovered = isCovered1, "break|scan";
                if (overlay && !--overlay.depth) {
                    var ranges1 = punchRanges(_this.ranges, overlay.ranges);
                    if (ranges1.length) {
                        checkRanges(ranges1);
                        _this.inner.splice(overlay.index, 0, new InnerParse(overlay.parser, overlay.parser.startParse(_this.input, enterFragments(overlay.mounts, ranges1), ranges1), overlay.ranges.map((r)=>new Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges1[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
            nest = nest1, isCovered = isCovered1, void 0;
        };
        var fragmentCursor = new FragmentCursor(this.fragments);
        var overlay = null;
        var covered = null;
        var cursor = new TreeCursor(new TreeNode(this.baseTree, this.ranges[0].from, 0, null), IterMode.IncludeAnonymous | IterMode.IgnoreMounts);
        scan: for(var nest, isCovered;;){
            var _ret = _loop(nest, isCovered);
            switch(_ret){
                case "break|scan":
                    break scan;
            }
        }
    }
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
}
function checkCover(covered, from, to) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = covered[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var range = _step.value;
            if (range.from >= to) break;
            if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        var from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function materialize(cursor) {
    var node = cursor.node, stack = [];
    var buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    var base = cursor.tree, i = base.children.indexOf(buffer);
    var buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        var targetI = stack[stackPos];
        var children = [], positions = [];
        sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        var from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        var child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new Tree(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, NodeType.none, 0, buf.length, stack.length - 1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Move the cursor back to the target node
        for(var _iterator = newStack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
            cursor.yield(new TreeNode(tree, pos + cursor.from, index, cursor._tree));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
class StructureCursor {
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        var cursor = this.cursor, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, IterMode.IgnoreOverlays | IterMode.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(var tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof Tree) tree = tree.children[0];
            else break;
        }
        return false;
    }
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor(IterMode.IncludeAnonymous | IterMode.IgnoreMounts);
    }
}
class FragmentCursor {
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            var frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop(stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        var result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(var _$pos = this.inner.cursor.node; _$pos; _$pos = _$pos.parent){
                var mount = (_a = _$pos.tree) === null || _a === void 0 ? void 0 : _a.prop(NodeProp.mounted);
                if (mount && mount.parser == parser) for(var i = this.fragI; i < this.fragments.length; i++){
                    var frag = this.fragments[i];
                    if (frag.from >= _$pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag,
                        pos: _$pos.from - frag.offset,
                        mount
                    });
                }
            }
        }
        return result;
    }
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            var first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop(stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
}
function punchRanges(outer, ranges) {
    var copy = null, current = ranges;
    for(var i = 1, j = 0; i < outer.length; i++){
        var gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            var r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function findCoverChanges(a, b, from, to) {
    var iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    var result = [];
    for(;;){
        var nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        var nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            var start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function enterFragments(mounts, ranges) {
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = _step.value, pos = _step_value.pos, mount = _step_value.mount, frag = _step_value.frag;
            var startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
            var from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
            if (mount.overlay) {
                var overlay = mount.overlay.map((r)=>new Range(r.from + pos, r.to + pos));
                var changes = findCoverChanges(ranges, overlay, from, to);
                for(var i = 0, pos1 = from;; i++){
                    var last = i == changes.length, end = last ? to : changes[i].from;
                    if (end > pos1) result.push(new TreeFragment(pos1, end, mount.tree, -startPos, frag.from >= pos1 || frag.openStart, frag.to <= end || frag.openEnd));
                    if (last) break;
                    pos1 = changes[i].to;
                }
            } else result.push(new TreeFragment(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
        };
        for(var _iterator = mounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"pdORT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "classHighlighter", ()=>classHighlighter);
parcelHelpers.export(exports, "getStyleTags", ()=>getStyleTags);
parcelHelpers.export(exports, "highlightCode", ()=>highlightCode);
parcelHelpers.export(exports, "highlightTree", ()=>highlightTree);
parcelHelpers.export(exports, "styleTags", ()=>styleTags);
parcelHelpers.export(exports, "tagHighlighter", ()=>tagHighlighter);
parcelHelpers.export(exports, "tags", ()=>tags);
var _common = require("@lezer/common");
var nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class Tag {
    /**
    Define a new tag. If `parent` is given, the tag is treated as a
    sub-tag of that parent, and
    [highlighters](#highlight.tagHighlighter) that don't mention
    this tag will try to fall back to the parent tag (or grandparent
    tag, etc).
    */ static define(parent) {
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        var tag = new Tag([], null, []);
        tag.set.push(tag);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (parent) try {
            for(var _iterator = parent.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                tag.set.push(t);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier() {
        var mod = new Modifier;
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
    /**
    @internal
    */ constructor(/**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = nextTagID++;
    }
}
var nextModifierID = 0;
class Modifier {
    static get(base, mods) {
        if (!mods.length) return base;
        var exists = mods[0].instances.find((t)=>t.base == base && sameArray(mods, t.modified));
        if (exists) return exists;
        var set = [], tag = new Tag(set, base, mods);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = mods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var m = _step.value;
                m.instances.push(tag);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var configs = powerSet(mods);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator1 = base.set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                var parent = _step1.value;
                if (!parent.modified.length) try {
                    for(var _iterator2 = configs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                        var config = _step2.value;
                        set.push(Modifier.get(parent, config));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return tag;
    }
    constructor(){
        this.instances = [];
        this.id = nextModifierID++;
    }
}
function sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function powerSet(array) {
    var sets = [
        []
    ];
    for(var i = 0; i < array.length; i++)for(var j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.withProps(
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
)
```
*/ function styleTags(spec) {
    var byName = Object.create(null);
    for(var prop in spec){
        var tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = prop.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                if (part) {
                    var pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
                    for(var pos = 0;;){
                        if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                            mode = 1 /* Mode.Inherit */ ;
                            break;
                        }
                        var m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                        if (!m) throw new RangeError("Invalid path: " + part);
                        pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                        pos += m[0].length;
                        if (pos == part.length) break;
                        var next = part[pos++];
                        if (pos == part.length && next == "!") {
                            mode = 0 /* Mode.Opaque */ ;
                            break;
                        }
                        if (next != "/") throw new RangeError("Invalid path: " + part);
                        rest = part.slice(pos);
                    }
                    var last = pieces.length - 1, inner = pieces[last];
                    if (!inner) throw new RangeError("Invalid path: " + part);
                    var rule = new Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
                    byName[inner] = rule.sort(byName[inner]);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return ruleNodeProp.add(byName);
}
var ruleNodeProp = new (0, _common.NodeProp)();
class Rule {
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
}
Rule.empty = new Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function tagHighlighter(tags, options) {
    var map = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var style = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
            else try {
                for(var _iterator1 = style.tag[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var tag = _step1.value;
                    map[tag.id] = style.class;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _ref = options || {}, scope = _ref.scope, _ref_all = _ref.all, all = _ref_all === void 0 ? null : _ref_all;
    return {
        style: (tags)=>{
            var cls = all;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var tag = _step.value;
                    try {
                        for(var _iterator1 = tag.set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var sub = _step1.value;
                            var tagClass = map[sub.id];
                            if (tagClass) {
                                cls = cls ? cls + " " + tagClass : tagClass;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return cls;
        },
        scope
    };
}
function highlightTags(highlighters, tags) {
    var result = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = highlighters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var highlighter = _step.value;
            var value = highlighter.style(tags);
            if (value) result = result ? result + " " + value : value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function highlightTree(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle) {
    var /**
The start of the range to highlight.
*/ from = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, /**
The end of the range.
*/ to = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : tree.length;
    var builder = new HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function highlightCode(code, tree, highlighter, putText, putBreak) {
    var from = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, to = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : code.length;
    var pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(var text = code.slice(pos, p), i = 0;;){
            var nextBreak = text.indexOf("\n", i);
            var upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    highlightTree(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class HighlightBuilder {
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        var type = cursor.type, start = cursor.from, end = cursor.to;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        var cls = inheritedClass;
        var rule = getStyleTags(cursor) || Rule.empty;
        var tagCls = highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        var mounted = cursor.tree && cursor.tree.prop((0, _common.NodeProp).mounted);
        if (mounted && mounted.overlay) {
            var inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            var innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            var hasChild = cursor.firstChild();
            for(var i = 0, pos = start;; i++){
                var next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                var nextPos = next ? next.from + start : end;
                var rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function getStyleTags(node) {
    var rule = node.type.prop(ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
var t = Tag.define;
var comment = t(), name = t(), typeName = t(name), propertyName = t(name), literal = t(), string = t(literal), number = t(literal), content = t(), heading = t(content), keyword = t(), operator = t(), punctuation = t(), bracket = t(punctuation), meta = t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ var tags = {
    /**
    A comment.
    */ comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: t(comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: t(comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: t(comment),
    /**
    Any kind of identifier.
    */ name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: t(name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: t(typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: t(propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: t(name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: t(name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: t(name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: t(name),
    /**
    A literal value.
    */ literal,
    /**
    A string [literal](#highlight.tags.literal).
    */ string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: t(string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: t(string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: t(string),
    /**
    A number [literal](#highlight.tags.literal).
    */ number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: t(number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: t(number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: t(literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: t(literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: t(literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: t(literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: t(literal),
    /**
    A language keyword.
    */ keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: t(keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: t(keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: t(keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: t(keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: t(keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: t(keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: t(keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: t(keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: t(keyword),
    /**
    An operator.
    */ operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: t(operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: t(operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: t(operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: t(operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: t(operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: t(operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: t(operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: t(operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: t(operator),
    /**
    Program or markup punctuation.
    */ punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: t(punctuation),
    /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: t(bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: t(bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: t(bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: t(bracket),
    /**
    Content, for example plain text in XML or markup documents.
    */ content,
    /**
    [Content](#highlight.tags.content) that represents a heading.
    */ heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: t(heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: t(heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: t(heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: t(heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: t(heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: t(heading),
    /**
    A prose separator (such as a horizontal rule).
    */ contentSeparator: t(content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: t(content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: t(content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: t(content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: t(content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: t(content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: t(content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: t(content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: t(),
    /**
    Deleted text.
    */ deleted: t(),
    /**
    Changed text.
    */ changed: t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: t(),
    /**
    Metadata or meta-instruction.
    */ meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: t(meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: t(meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: t(meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: Tag.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: Tag.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: Tag.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: Tag.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: Tag.defineModifier(),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: Tag.defineModifier()
};
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ var classHighlighter = tagHighlighter([
    {
        tag: tags.link,
        class: "tok-link"
    },
    {
        tag: tags.heading,
        class: "tok-heading"
    },
    {
        tag: tags.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: tags.strong,
        class: "tok-strong"
    },
    {
        tag: tags.keyword,
        class: "tok-keyword"
    },
    {
        tag: tags.atom,
        class: "tok-atom"
    },
    {
        tag: tags.bool,
        class: "tok-bool"
    },
    {
        tag: tags.url,
        class: "tok-url"
    },
    {
        tag: tags.labelName,
        class: "tok-labelName"
    },
    {
        tag: tags.inserted,
        class: "tok-inserted"
    },
    {
        tag: tags.deleted,
        class: "tok-deleted"
    },
    {
        tag: tags.literal,
        class: "tok-literal"
    },
    {
        tag: tags.string,
        class: "tok-string"
    },
    {
        tag: tags.number,
        class: "tok-number"
    },
    {
        tag: [
            tags.regexp,
            tags.escape,
            tags.special(tags.string)
        ],
        class: "tok-string2"
    },
    {
        tag: tags.variableName,
        class: "tok-variableName"
    },
    {
        tag: tags.local(tags.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: tags.definition(tags.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: tags.special(tags.variableName),
        class: "tok-variableName2"
    },
    {
        tag: tags.definition(tags.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: tags.typeName,
        class: "tok-typeName"
    },
    {
        tag: tags.namespace,
        class: "tok-namespace"
    },
    {
        tag: tags.className,
        class: "tok-className"
    },
    {
        tag: tags.macroName,
        class: "tok-macroName"
    },
    {
        tag: tags.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: tags.operator,
        class: "tok-operator"
    },
    {
        tag: tags.comment,
        class: "tok-comment"
    },
    {
        tag: tags.meta,
        class: "tok-meta"
    },
    {
        tag: tags.invalid,
        class: "tok-invalid"
    },
    {
        tag: tags.punctuation,
        class: "tok-punctuation"
    }
]);

},{"@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8GWsb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blockComment", ()=>blockComment);
parcelHelpers.export(exports, "blockUncomment", ()=>blockUncomment);
parcelHelpers.export(exports, "copyLineDown", ()=>copyLineDown);
parcelHelpers.export(exports, "copyLineUp", ()=>copyLineUp);
parcelHelpers.export(exports, "cursorCharBackward", ()=>cursorCharBackward);
parcelHelpers.export(exports, "cursorCharForward", ()=>cursorCharForward);
parcelHelpers.export(exports, "cursorCharLeft", ()=>cursorCharLeft);
parcelHelpers.export(exports, "cursorCharRight", ()=>cursorCharRight);
parcelHelpers.export(exports, "cursorDocEnd", ()=>cursorDocEnd);
parcelHelpers.export(exports, "cursorDocStart", ()=>cursorDocStart);
parcelHelpers.export(exports, "cursorGroupBackward", ()=>cursorGroupBackward);
parcelHelpers.export(exports, "cursorGroupForward", ()=>cursorGroupForward);
parcelHelpers.export(exports, "cursorGroupLeft", ()=>cursorGroupLeft);
parcelHelpers.export(exports, "cursorGroupRight", ()=>cursorGroupRight);
parcelHelpers.export(exports, "cursorLineBoundaryBackward", ()=>cursorLineBoundaryBackward);
parcelHelpers.export(exports, "cursorLineBoundaryForward", ()=>cursorLineBoundaryForward);
parcelHelpers.export(exports, "cursorLineBoundaryLeft", ()=>cursorLineBoundaryLeft);
parcelHelpers.export(exports, "cursorLineBoundaryRight", ()=>cursorLineBoundaryRight);
parcelHelpers.export(exports, "cursorLineDown", ()=>cursorLineDown);
parcelHelpers.export(exports, "cursorLineEnd", ()=>cursorLineEnd);
parcelHelpers.export(exports, "cursorLineStart", ()=>cursorLineStart);
parcelHelpers.export(exports, "cursorLineUp", ()=>cursorLineUp);
parcelHelpers.export(exports, "cursorMatchingBracket", ()=>cursorMatchingBracket);
parcelHelpers.export(exports, "cursorPageDown", ()=>cursorPageDown);
parcelHelpers.export(exports, "cursorPageUp", ()=>cursorPageUp);
parcelHelpers.export(exports, "cursorSubwordBackward", ()=>cursorSubwordBackward);
parcelHelpers.export(exports, "cursorSubwordForward", ()=>cursorSubwordForward);
parcelHelpers.export(exports, "cursorSyntaxLeft", ()=>cursorSyntaxLeft);
parcelHelpers.export(exports, "cursorSyntaxRight", ()=>cursorSyntaxRight);
parcelHelpers.export(exports, "defaultKeymap", ()=>defaultKeymap);
parcelHelpers.export(exports, "deleteCharBackward", ()=>deleteCharBackward);
parcelHelpers.export(exports, "deleteCharForward", ()=>deleteCharForward);
parcelHelpers.export(exports, "deleteGroupBackward", ()=>deleteGroupBackward);
parcelHelpers.export(exports, "deleteGroupForward", ()=>deleteGroupForward);
parcelHelpers.export(exports, "deleteLine", ()=>deleteLine);
parcelHelpers.export(exports, "deleteLineBoundaryBackward", ()=>deleteLineBoundaryBackward);
parcelHelpers.export(exports, "deleteLineBoundaryForward", ()=>deleteLineBoundaryForward);
parcelHelpers.export(exports, "deleteToLineEnd", ()=>deleteToLineEnd);
parcelHelpers.export(exports, "deleteToLineStart", ()=>deleteToLineStart);
parcelHelpers.export(exports, "deleteTrailingWhitespace", ()=>deleteTrailingWhitespace);
parcelHelpers.export(exports, "emacsStyleKeymap", ()=>emacsStyleKeymap);
parcelHelpers.export(exports, "history", ()=>history);
parcelHelpers.export(exports, "historyField", ()=>historyField);
parcelHelpers.export(exports, "historyKeymap", ()=>historyKeymap);
parcelHelpers.export(exports, "indentLess", ()=>indentLess);
parcelHelpers.export(exports, "indentMore", ()=>indentMore);
parcelHelpers.export(exports, "indentSelection", ()=>indentSelection);
parcelHelpers.export(exports, "indentWithTab", ()=>indentWithTab);
parcelHelpers.export(exports, "insertBlankLine", ()=>insertBlankLine);
parcelHelpers.export(exports, "insertNewline", ()=>insertNewline);
parcelHelpers.export(exports, "insertNewlineAndIndent", ()=>insertNewlineAndIndent);
parcelHelpers.export(exports, "insertTab", ()=>insertTab);
parcelHelpers.export(exports, "invertedEffects", ()=>invertedEffects);
parcelHelpers.export(exports, "isolateHistory", ()=>isolateHistory);
parcelHelpers.export(exports, "lineComment", ()=>lineComment);
parcelHelpers.export(exports, "lineUncomment", ()=>lineUncomment);
parcelHelpers.export(exports, "moveLineDown", ()=>moveLineDown);
parcelHelpers.export(exports, "moveLineUp", ()=>moveLineUp);
parcelHelpers.export(exports, "redo", ()=>redo);
parcelHelpers.export(exports, "redoDepth", ()=>redoDepth);
parcelHelpers.export(exports, "redoSelection", ()=>redoSelection);
parcelHelpers.export(exports, "selectAll", ()=>selectAll);
parcelHelpers.export(exports, "selectCharBackward", ()=>selectCharBackward);
parcelHelpers.export(exports, "selectCharForward", ()=>selectCharForward);
parcelHelpers.export(exports, "selectCharLeft", ()=>selectCharLeft);
parcelHelpers.export(exports, "selectCharRight", ()=>selectCharRight);
parcelHelpers.export(exports, "selectDocEnd", ()=>selectDocEnd);
parcelHelpers.export(exports, "selectDocStart", ()=>selectDocStart);
parcelHelpers.export(exports, "selectGroupBackward", ()=>selectGroupBackward);
parcelHelpers.export(exports, "selectGroupForward", ()=>selectGroupForward);
parcelHelpers.export(exports, "selectGroupLeft", ()=>selectGroupLeft);
parcelHelpers.export(exports, "selectGroupRight", ()=>selectGroupRight);
parcelHelpers.export(exports, "selectLine", ()=>selectLine);
parcelHelpers.export(exports, "selectLineBoundaryBackward", ()=>selectLineBoundaryBackward);
parcelHelpers.export(exports, "selectLineBoundaryForward", ()=>selectLineBoundaryForward);
parcelHelpers.export(exports, "selectLineBoundaryLeft", ()=>selectLineBoundaryLeft);
parcelHelpers.export(exports, "selectLineBoundaryRight", ()=>selectLineBoundaryRight);
parcelHelpers.export(exports, "selectLineDown", ()=>selectLineDown);
parcelHelpers.export(exports, "selectLineEnd", ()=>selectLineEnd);
parcelHelpers.export(exports, "selectLineStart", ()=>selectLineStart);
parcelHelpers.export(exports, "selectLineUp", ()=>selectLineUp);
parcelHelpers.export(exports, "selectMatchingBracket", ()=>selectMatchingBracket);
parcelHelpers.export(exports, "selectPageDown", ()=>selectPageDown);
parcelHelpers.export(exports, "selectPageUp", ()=>selectPageUp);
parcelHelpers.export(exports, "selectParentSyntax", ()=>selectParentSyntax);
parcelHelpers.export(exports, "selectSubwordBackward", ()=>selectSubwordBackward);
parcelHelpers.export(exports, "selectSubwordForward", ()=>selectSubwordForward);
parcelHelpers.export(exports, "selectSyntaxLeft", ()=>selectSyntaxLeft);
parcelHelpers.export(exports, "selectSyntaxRight", ()=>selectSyntaxRight);
parcelHelpers.export(exports, "simplifySelection", ()=>simplifySelection);
parcelHelpers.export(exports, "splitLine", ()=>splitLine);
parcelHelpers.export(exports, "standardKeymap", ()=>standardKeymap);
parcelHelpers.export(exports, "toggleBlockComment", ()=>toggleBlockComment);
parcelHelpers.export(exports, "toggleBlockCommentByLine", ()=>toggleBlockCommentByLine);
parcelHelpers.export(exports, "toggleComment", ()=>toggleComment);
parcelHelpers.export(exports, "toggleLineComment", ()=>toggleLineComment);
parcelHelpers.export(exports, "transposeChars", ()=>transposeChars);
parcelHelpers.export(exports, "undo", ()=>undo);
parcelHelpers.export(exports, "undoDepth", ()=>undoDepth);
parcelHelpers.export(exports, "undoSelection", ()=>undoSelection);
var _state = require("@codemirror/state");
var _view = require("@codemirror/view");
var _language = require("@codemirror/language");
var _common = require("@lezer/common");
/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ var toggleComment = (target)=>{
    var state = target.state, line = state.doc.lineAt(state.selection.main.from), config = getConfig(target.state, line.from);
    return config.line ? toggleLineComment(target) : config.block ? toggleBlockCommentByLine(target) : false;
};
function command(f, option) {
    return (param)=>{
        var state = param.state, dispatch = param.dispatch;
        if (state.readOnly) return false;
        var tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ var toggleLineComment = /*@__PURE__*/ command(changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ var lineComment = /*@__PURE__*/ command(changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ var lineUncomment = /*@__PURE__*/ command(changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ var toggleBlockComment = /*@__PURE__*/ command(changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ var blockComment = /*@__PURE__*/ command(changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ var blockUncomment = /*@__PURE__*/ command(changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ var toggleBlockCommentByLine = /*@__PURE__*/ command((o, s)=>changeBlockComment(o, s, selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function getConfig(state, pos) {
    var data = state.languageDataAt("commentTokens", pos);
    return data.length ? data[0] : {};
}
var SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function findBlockComment(state, param, from, to) {
    var open = param.open, close = param.close;
    var textBefore = state.sliceDoc(from - SearchMargin, from);
    var textAfter = state.sliceDoc(to, to + SearchMargin);
    var spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    var beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    var startText, endText;
    if (to - from <= 2 * SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + SearchMargin);
        endText = state.sliceDoc(to - SearchMargin, to);
    }
    var startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    var endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function selectedLineRanges(state) {
    var ranges = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            var fromLine = state.doc.lineAt(r.from);
            var toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
            var last = ranges.length - 1;
            if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
            else ranges.push({
                from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
                to: toLine.to
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function changeBlockComment(option, state) {
    var ranges = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : state.selection.ranges;
    var tokens = ranges.map((r)=>getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    var comments = ranges.map((r, i)=>findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        var changes = [];
        for(var i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            var token = tokens[i], open = comment.open, close = comment.close;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function changeLineComment(option, state) {
    var ranges = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : state.selection.ranges;
    var lines = [];
    var prevLine = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
            var startI = lines.length, minIndent = 1e9;
            var token = getConfig(state, from).line;
            if (!token) continue;
            for(var pos = from; pos <= to;){
                var line = state.doc.lineAt(pos);
                if (line.from > prevLine && (from == to || to > line.from)) {
                    prevLine = line.from;
                    var indent = /^\s*/.exec(line.text)[0].length;
                    var empty = indent == line.length;
                    var comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                    if (indent < line.text.length && indent < minIndent) minIndent = indent;
                    lines.push({
                        line,
                        comment,
                        token,
                        indent,
                        empty,
                        single: false
                    });
                }
                pos = line.to + 1;
            }
            if (minIndent < 1e9) {
                for(var i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
            }
            if (lines.length == startI + 1) lines[startI].single = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        var changes = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = lines[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = _step1.value, line1 = _step_value1.line, token1 = _step_value1.token, indent1 = _step_value1.indent, empty1 = _step_value1.empty, single = _step_value1.single;
                if (single || !empty1) changes.push({
                    from: line1.from + indent1,
                    insert: token1 + " "
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        var changes1 = [];
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = lines[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var _step_value2 = _step2.value, line2 = _step_value2.line, comment1 = _step_value2.comment, token2 = _step_value2.token;
                if (comment1 >= 0) {
                    var from1 = line2.from + comment1, to1 = from1 + token2.length;
                    if (line2.text[to1 - line2.from] == " ") to1++;
                    changes1.push({
                        from: from1,
                        to: to1
                    });
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return {
            changes: changes1
        };
    }
    return null;
}
var fromHistory = /*@__PURE__*/ (0, _state.Annotation).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ var isolateHistory = /*@__PURE__*/ (0, _state.Annotation).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ var invertedEffects = /*@__PURE__*/ (0, _state.Facet).define();
var historyConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        return (0, _state.combineConfig)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
var historyField_ = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return HistoryState.empty;
    },
    update (state, tr) {
        var config = tr.state.facet(historyConfig);
        var fromHist = tr.annotation(fromHistory);
        if (fromHist) {
            var item = HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            var other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = updateBranch(other, other.length, config.minDepth, item);
            else other = addSelection(other, tr.startState.selection);
            return new HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        var isolate = tr.annotation(isolateHistory);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, _state.Transaction).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        var event = HistEvent.fromTransaction(tr);
        var time = tr.annotation((0, _state.Transaction).time), userEvent = tr.annotation((0, _state.Transaction).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new HistoryState(json.done.map(HistEvent.fromJSON), json.undone.map(HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function history() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        historyField_,
        historyConfig.of(config),
        (0, _view.EditorView).domEventHandlers({
            beforeinput (e, view) {
                var _$command = e.inputType == "historyUndo" ? undo : e.inputType == "historyRedo" ? redo : null;
                if (!_$command) return false;
                e.preventDefault();
                return _$command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ var historyField = historyField_;
function cmd(side, selection) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch;
        if (!selection && state.readOnly) return false;
        var historyState = state.field(historyField_, false);
        if (!historyState) return false;
        var tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ var undo = /*@__PURE__*/ cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ var redo = /*@__PURE__*/ cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ var undoSelection = /*@__PURE__*/ cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ var redoSelection = /*@__PURE__*/ cmd(1 /* BranchName.Undone */ , true);
function depth(side) {
    return function(state) {
        var histState = state.field(historyField_, false);
        if (!histState) return 0;
        var branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ var undoDepth = /*@__PURE__*/ depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ var redoDepth = /*@__PURE__*/ depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class HistEvent {
    setSelAfter(after) {
        return new HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new HistEvent(json.changes && (0, _state.ChangeSet).fromJSON(json.changes), [], json.mapped && (0, _state.ChangeDesc).fromJSON(json.mapped), json.startSelection && (0, _state.EditorSelection).fromJSON(json.startSelection), json.selectionsAfter.map((0, _state.EditorSelection).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        var effects = none;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.startState.facet(invertedEffects)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var invert = _step.value;
                var result = invert(tr);
                if (result.length) effects = effects.concat(result);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!effects.length && tr.changes.empty) return null;
        return new HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, none);
    }
    static selection(selections) {
        return new HistEvent(undefined, none, undefined, undefined, selections);
    }
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
}
function updateBranch(branch, to, maxLen, newEvent) {
    var start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    var newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function isAdjacent(a, b) {
    var ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(var i = 0; i < ranges.length;){
            var from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
var none = [];
var MaxSelectionsPerEvent = 200;
function addSelection(branch, selection) {
    if (!branch.length) return [
        HistEvent.selection([
            selection
        ])
    ];
    else {
        var lastEvent = branch[branch.length - 1];
        var sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function popSelection(branch) {
    var last = branch[branch.length - 1];
    var newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    var length = branch.length, selections = none;
    while(length){
        var event = mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            var result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        HistEvent.selection(selections)
    ] : none;
}
function mapEvent(event, mapping, extraSelections) {
    var selections = conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return HistEvent.selection(selections);
    var mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    var fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new HistEvent(mappedChanges, (0, _state.StateEffect).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
var joinableUserEvent = /^(input\.type|delete)($|\.)/;
class HistoryState {
    isolate() {
        return this.prevTime ? new HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        var done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = updateBranch(done, done.length - 1, config.minDepth, new HistEvent(event.changes.compose(lastEvent.changes), conc(event.effects, lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, none));
        else done = updateBranch(done, done.length, config.minDepth, event);
        return new HistoryState(done, none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        var last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && eqSelectionShape(last[last.length - 1], selection)) return this;
        return new HistoryState(addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new HistoryState(addMappingToBranch(this.done, mapping), addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        var branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        var event = branch[branch.length - 1], selection = event.selectionsAfter[0] || state.selection;
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: fromHistory.of({
                side,
                rest: popSelection(branch),
                selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            var rest = branch.length == 1 ? none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: fromHistory.of({
                    side,
                    rest,
                    selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
    constructor(done, undone, ref, prevUserEvent){
        var prevTime = ref === void 0 ? 0 : ref;
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
}
HistoryState.empty = /*@__PURE__*/ new HistoryState(none, none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ var historyKeymap = [
    {
        key: "Mod-z",
        run: undo,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: redo,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: redo,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: undoSelection,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: redoSelection,
        preventDefault: true
    }
];
function updateSel(sel, by) {
    return (0, _state.EditorSelection).create(sel.ranges.map(by), sel.mainIndex);
}
function setSel(state, selection) {
    return state.update({
        selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function moveSel(param, how) {
    var state = param.state, dispatch = param.dispatch;
    var selection = updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch(setSel(state, selection));
    return true;
}
function rangeEnd(range, forward) {
    return (0, _state.EditorSelection).cursor(forward ? range.to : range.from);
}
function cursorByChar(view, forward) {
    return moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : rangeEnd(range, forward));
}
function ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, _view.Direction).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ var cursorCharLeft = (view)=>cursorByChar(view, !ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ var cursorCharRight = (view)=>cursorByChar(view, ltrAtCursor(view));
/**
Move the selection one character forward.
*/ var cursorCharForward = (view)=>cursorByChar(view, true);
/**
Move the selection one character backward.
*/ var cursorCharBackward = (view)=>cursorByChar(view, false);
function cursorByGroup(view, forward) {
    return moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ var cursorGroupLeft = (view)=>cursorByGroup(view, !ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ var cursorGroupRight = (view)=>cursorByGroup(view, ltrAtCursor(view));
/**
Move the selection one group forward.
*/ var cursorGroupForward = (view)=>cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ var cursorGroupBackward = (view)=>cursorByGroup(view, false);
var segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function moveBySubword(view, range, forward) {
    var categorize = view.state.charCategorizer(range.from);
    var cat = (0, _state.CharCategory).Space, pos = range.from, steps = 0;
    var done = false, sawUpper = false, sawLower = false;
    var step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        var nextCat = categorize(next), ahead;
        if (nextCat == (0, _state.CharCategory).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, _state.CharCategory).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, _state.CharCategory).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, _state.CharCategory).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    var end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if (segmenter && cat == (0, _state.CharCategory).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        var from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        var skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            var segments = Array.from(segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, _state.EditorSelection).cursor(range.head + segments[1].index, -1);
                return (0, _state.EditorSelection).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function cursorBySubword(view, forward) {
    return moveSel(view, (range)=>range.empty ? moveBySubword(view, range, forward) : rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ var cursorSubwordForward = (view)=>cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ var cursorSubwordBackward = (view)=>cursorBySubword(view, false);
function interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    var len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function moveBySyntax(state, start, forward) {
    var pos = (0, _language.syntaxTree)(state).resolveInner(start.head);
    var bracketProp = forward ? (0, _common.NodeProp).closedBy : (0, _common.NodeProp).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(var at = start.head;;){
        var next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if (interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    var bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, _language.matchBrackets)(state, pos.from, 1) : (0, _language.matchBrackets)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, _state.EditorSelection).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ var cursorSyntaxLeft = (view)=>moveSel(view, (range)=>moveBySyntax(view.state, range, !ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ var cursorSyntaxRight = (view)=>moveSel(view, (range)=>moveBySyntax(view.state, range, ltrAtCursor(view)));
function cursorByLine(view, forward) {
    return moveSel(view, (range)=>{
        if (!range.empty) return rangeEnd(range, forward);
        var moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ var cursorLineUp = (view)=>cursorByLine(view, false);
/**
Move the selection one line down.
*/ var cursorLineDown = (view)=>cursorByLine(view, true);
function pageInfo(view) {
    var selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    var marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = view.state.facet((0, _view.EditorView).scrollMargins)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var source = _step.value;
                var margins = source(view);
                if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
                if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop,
        marginBottom,
        selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function cursorByPage(view, forward) {
    var page = pageInfo(view);
    var state = view.state, selection = updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    var effect;
    if (page.selfScroll) {
        var startPos = view.coordsAtPos(state.selection.main.head);
        var scrollRect = view.scrollDOM.getBoundingClientRect();
        var scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, _view.EditorView).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch(setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ var cursorPageUp = (view)=>cursorByPage(view, false);
/**
Move the selection one page down.
*/ var cursorPageDown = (view)=>cursorByPage(view, true);
function moveByLineBoundary(view, start, forward) {
    var line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        var space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, _state.EditorSelection).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ var cursorLineBoundaryForward = (view)=>moveSel(view, (range)=>moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ var cursorLineBoundaryBackward = (view)=>moveSel(view, (range)=>moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ var cursorLineBoundaryLeft = (view)=>moveSel(view, (range)=>moveByLineBoundary(view, range, !ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ var cursorLineBoundaryRight = (view)=>moveSel(view, (range)=>moveByLineBoundary(view, range, ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ var cursorLineStart = (view)=>moveSel(view, (range)=>(0, _state.EditorSelection).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ var cursorLineEnd = (view)=>moveSel(view, (range)=>(0, _state.EditorSelection).cursor(view.lineBlockAt(range.head).to, -1));
function toMatchingBracket(state, dispatch, extend) {
    var found = false, selection = updateSel(state.selection, (range)=>{
        var matching = (0, _language.matchBrackets)(state, range.head, -1) || (0, _language.matchBrackets)(state, range.head, 1) || range.head > 0 && (0, _language.matchBrackets)(state, range.head - 1, 1) || range.head < state.doc.length && (0, _language.matchBrackets)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        var head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, _state.EditorSelection).range(range.anchor, head) : (0, _state.EditorSelection).cursor(head);
    });
    if (!found) return false;
    dispatch(setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ var cursorMatchingBracket = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    return toMatchingBracket(state, dispatch, false);
};
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ var selectMatchingBracket = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    return toMatchingBracket(state, dispatch, true);
};
function extendSel(view, how) {
    var selection = updateSel(view.state.selection, (range)=>{
        var head = how(range);
        return (0, _state.EditorSelection).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined);
    });
    if (selection.eq(view.state.selection)) return false;
    view.dispatch(setSel(view.state, selection));
    return true;
}
function selectByChar(view, forward) {
    return extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ var selectCharLeft = (view)=>selectByChar(view, !ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ var selectCharRight = (view)=>selectByChar(view, ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ var selectCharForward = (view)=>selectByChar(view, true);
/**
Move the selection head one character backward.
*/ var selectCharBackward = (view)=>selectByChar(view, false);
function selectByGroup(view, forward) {
    return extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ var selectGroupLeft = (view)=>selectByGroup(view, !ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ var selectGroupRight = (view)=>selectByGroup(view, ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ var selectGroupForward = (view)=>selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ var selectGroupBackward = (view)=>selectByGroup(view, false);
function selectBySubword(view, forward) {
    return extendSel(view, (range)=>moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ var selectSubwordForward = (view)=>selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ var selectSubwordBackward = (view)=>selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ var selectSyntaxLeft = (view)=>extendSel(view, (range)=>moveBySyntax(view.state, range, !ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ var selectSyntaxRight = (view)=>extendSel(view, (range)=>moveBySyntax(view.state, range, ltrAtCursor(view)));
function selectByLine(view, forward) {
    return extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ var selectLineUp = (view)=>selectByLine(view, false);
/**
Move the selection head one line down.
*/ var selectLineDown = (view)=>selectByLine(view, true);
function selectByPage(view, forward) {
    return extendSel(view, (range)=>view.moveVertically(range, forward, pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ var selectPageUp = (view)=>selectByPage(view, false);
/**
Move the selection head one page down.
*/ var selectPageDown = (view)=>selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ var selectLineBoundaryForward = (view)=>extendSel(view, (range)=>moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ var selectLineBoundaryBackward = (view)=>extendSel(view, (range)=>moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ var selectLineBoundaryLeft = (view)=>extendSel(view, (range)=>moveByLineBoundary(view, range, !ltrAtCursor(view)));
/**
Move the selection head one line boundary to the right.
*/ var selectLineBoundaryRight = (view)=>extendSel(view, (range)=>moveByLineBoundary(view, range, ltrAtCursor(view)));
/**
Move the selection head to the start of the line.
*/ var selectLineStart = (view)=>extendSel(view, (range)=>(0, _state.EditorSelection).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ var selectLineEnd = (view)=>extendSel(view, (range)=>(0, _state.EditorSelection).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ var cursorDocStart = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    dispatch(setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ var cursorDocEnd = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    dispatch(setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ var selectDocStart = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    dispatch(setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ var selectDocEnd = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    dispatch(setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ var selectAll = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ var selectLine = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var ranges = selectedLineBlocks(state).map((param)=>{
        var from = param.from, to = param.to;
        return (0, _state.EditorSelection).range(from, Math.min(to + 1, state.doc.length));
    });
    dispatch(state.update({
        selection: (0, _state.EditorSelection).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ var selectParentSyntax = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var selection = updateSel(state.selection, (range)=>{
        var _a;
        var stack = (0, _language.syntaxTree)(state).resolveStack(range.from, 1);
        for(var cur = stack; cur; cur = cur.next){
            var node = cur.node;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && ((_a = node.parent) === null || _a === void 0 ? void 0 : _a.parent)) return (0, _state.EditorSelection).range(node.to, node.from);
        }
        return range;
    });
    dispatch(setSel(state, selection));
    return true;
};
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ var simplifySelection = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, _state.EditorSelection).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, _state.EditorSelection).create([
        (0, _state.EditorSelection).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch(setSel(state, selection));
    return true;
};
function deleteBy(target, by) {
    if (target.state.readOnly) return false;
    var event = "delete.selection", state = target.state;
    var changes = state.changeByRange((range)=>{
        var from = range.from, to = range.to;
        if (from == to) {
            var towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = skipAtomic(target, from, false);
            to = skipAtomic(target, to, true);
        }
        return from == to ? {
            range
        } : {
            changes: {
                from,
                to
            },
            range: (0, _state.EditorSelection).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, _view.EditorView).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function skipAtomic(target, pos, forward) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (target instanceof (0, _view.EditorView)) try {
        for(var _iterator = target.state.facet((0, _view.EditorView).atomicRanges).map((f)=>f(target))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ranges = _step.value;
            ranges.between(pos, pos, (from, to)=>{
                if (from < pos && to > pos) pos = forward ? to : from;
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return pos;
}
var deleteByChar = (target, forward)=>deleteBy(target, (range)=>{
        var pos = range.from, state = target.state, line = state.doc.lineAt(pos), before, targetPos;
        if (!forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "	") return pos - 1;
            var col = (0, _state.countColumn)(before, state.tabSize), drop = col % (0, _language.getIndentUnit)(state) || (0, _language.getIndentUnit)(state);
            for(var i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, _state.findClusterBreak)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, _state.findClusterBreak)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character
before the cursor.
*/ var deleteCharBackward = (view)=>deleteByChar(view, false);
/**
Delete the selection or the character after the cursor.
*/ var deleteCharForward = (view)=>deleteByChar(view, true);
var deleteByGroup = (target, forward)=>deleteBy(target, (range)=>{
        var pos = range.head, state = target.state, line = state.doc.lineAt(pos);
        var categorize = state.charCategorizer(pos);
        for(var cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            var next = (0, _state.findClusterBreak)(line.text, pos - line.from, forward) + line.from;
            var nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            var nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ var deleteGroupBackward = (target)=>deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ var deleteGroupForward = (target)=>deleteByGroup(target, true);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ var deleteToLineEnd = (view)=>deleteBy(view, (range)=>{
        var lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ var deleteToLineStart = (view)=>deleteBy(view, (range)=>{
        var lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ var deleteLineBoundaryBackward = (view)=>deleteBy(view, (range)=>{
        var lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ var deleteLineBoundaryForward = (view)=>deleteBy(view, (range)=>{
        var lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ var deleteTrailingWhitespace = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    var changes = [];
    for(var pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            var trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ var splitLine = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    var changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, _state.Text).of([
                    "",
                    ""
                ])
            },
            range: (0, _state.EditorSelection).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ var transposeChars = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    var changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range
        };
        var pos = range.from, line = state.doc.lineAt(pos);
        var from = pos == line.from ? pos - 1 : (0, _state.findClusterBreak)(line.text, pos - line.from, false) + line.from;
        var to = pos == line.to ? pos + 1 : (0, _state.findClusterBreak)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from,
                to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, _state.EditorSelection).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function selectedLineBlocks(state) {
    var blocks = [], upto = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.selection.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var range = _step.value;
            var startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
            if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
            if (upto >= startLine.number) {
                var prev = blocks[blocks.length - 1];
                prev.to = endLine.to;
                prev.ranges.push(range);
            } else blocks.push({
                from: startLine.from,
                to: endLine.to,
                ranges: [
                    range
                ]
            });
            upto = endLine.number + 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return blocks;
}
function moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    var changes = [], ranges = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selectedLineBlocks(state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var block = _step.value;
            if (forward ? block.to == state.doc.length : block.from == 0) continue;
            var nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
            var size = nextLine.length + 1;
            if (forward) {
                changes.push({
                    from: block.to,
                    to: nextLine.to
                }, {
                    from: block.from,
                    insert: nextLine.text + state.lineBreak
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = block.ranges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var r = _step1.value;
                        ranges.push((0, _state.EditorSelection).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            } else {
                changes.push({
                    from: nextLine.from,
                    to: block.from
                }, {
                    from: block.to,
                    insert: state.lineBreak + nextLine.text
                });
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = block.ranges[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var r1 = _step2.value;
                        ranges.push((0, _state.EditorSelection).range(r1.anchor - size, r1.head - size));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes,
        scrollIntoView: true,
        selection: (0, _state.EditorSelection).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ var moveLineUp = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    return moveLine(state, dispatch, false);
};
/**
Move the selected lines down one line.
*/ var moveLineDown = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    return moveLine(state, dispatch, true);
};
function copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    var changes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selectedLineBlocks(state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var block = _step.value;
            if (forward) changes.push({
                from: block.from,
                insert: state.doc.slice(block.from, block.to) + state.lineBreak
            });
            else changes.push({
                from: block.to,
                insert: state.lineBreak + state.doc.slice(block.from, block.to)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    dispatch(state.update({
        changes,
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ var copyLineUp = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    return copyLine(state, dispatch, false);
};
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ var copyLineDown = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    return copyLine(state, dispatch, true);
};
/**
Delete selected lines.
*/ var deleteLine = (view)=>{
    if (view.state.readOnly) return false;
    var state = view.state, changes = state.changes(selectedLineBlocks(state).map((param)=>{
        var from = param.from, to = param.to;
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from,
            to
        };
    }));
    var selection = updateSel(state.selection, (range)=>view.moveVertically(range, true)).map(changes);
    view.dispatch({
        changes,
        selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ var insertNewline = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    var context = (0, _language.syntaxTree)(state).resolveInner(pos);
    var before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, _common.NodeProp).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ var insertNewlineAndIndent = /*@__PURE__*/ newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ var insertBlankLine = /*@__PURE__*/ newlineAndIndent(true);
function newlineAndIndent(atEof) {
    return (param)=>{
        var state = param.state, dispatch = param.dispatch;
        if (state.readOnly) return false;
        var changes = state.changeByRange((range)=>{
            var from = range.from, to = range.to, line = state.doc.lineAt(from);
            var explode = !atEof && from == to && isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            var cx = new (0, _language.IndentContext)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            var indent = (0, _language.getIndentation)(cx, from);
            if (indent == null) indent = (0, _state.countColumn)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            var ref;
            if (explode) ref = explode, from = ref.from, to = ref.to, ref;
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            var insert = [
                "",
                (0, _language.indentString)(state, indent)
            ];
            if (explode) insert.push((0, _language.indentString)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from,
                    to,
                    insert: (0, _state.Text).of(insert)
                },
                range: (0, _state.EditorSelection).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function changeBySelectedLine(state, f) {
    var atLine = -1;
    return state.changeByRange((range)=>{
        var changes = [];
        for(var pos = range.from; pos <= range.to;){
            var line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        var changeSet = state.changes(changes);
        return {
            changes,
            range: (0, _state.EditorSelection).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ var indentSelection = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    var updated = Object.create(null);
    var context = new (0, _language.IndentContext)(state, {
        overrideIndentation: (start)=>{
            var found = updated[start];
            return found == null ? -1 : found;
        }
    });
    var changes = changeBySelectedLine(state, (line, changes, range)=>{
        var indent = (0, _language.getIndentation)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        var cur = /^\s*/.exec(line.text)[0];
        var norm = (0, _language.indentString)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ var indentMore = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    dispatch(state.update(changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, _language.indentUnit))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ var indentLess = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    dispatch(state.update(changeBySelectedLine(state, (line, changes)=>{
        var space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        var col = (0, _state.countColumn)(space, state.tabSize), keep = 0;
        var insert = (0, _language.indentString)(state, Math.max(0, col - (0, _language.getIndentUnit)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ var insertTab = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.selection.ranges.some((r)=>!r.empty)) return indentMore({
        state,
        dispatch
    });
    dispatch(state.update(state.replaceSelection("	"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ var emacsStyleKeymap = [
    {
        key: "Ctrl-b",
        run: cursorCharLeft,
        shift: selectCharLeft,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: cursorCharRight,
        shift: selectCharRight
    },
    {
        key: "Ctrl-p",
        run: cursorLineUp,
        shift: selectLineUp
    },
    {
        key: "Ctrl-n",
        run: cursorLineDown,
        shift: selectLineDown
    },
    {
        key: "Ctrl-a",
        run: cursorLineStart,
        shift: selectLineStart
    },
    {
        key: "Ctrl-e",
        run: cursorLineEnd,
        shift: selectLineEnd
    },
    {
        key: "Ctrl-d",
        run: deleteCharForward
    },
    {
        key: "Ctrl-h",
        run: deleteCharBackward
    },
    {
        key: "Ctrl-k",
        run: deleteToLineEnd
    },
    {
        key: "Ctrl-Alt-h",
        run: deleteGroupBackward
    },
    {
        key: "Ctrl-o",
        run: splitLine
    },
    {
        key: "Ctrl-t",
        run: transposeChars
    },
    {
        key: "Ctrl-v",
        run: cursorPageDown
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ var standardKeymap = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: cursorCharLeft,
        shift: selectCharLeft,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: cursorGroupLeft,
        shift: selectGroupLeft,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: cursorLineBoundaryLeft,
        shift: selectLineBoundaryLeft,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: cursorCharRight,
        shift: selectCharRight,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: cursorGroupRight,
        shift: selectGroupRight,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: cursorLineBoundaryRight,
        shift: selectLineBoundaryRight,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: cursorLineUp,
        shift: selectLineUp,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: cursorDocStart,
        shift: selectDocStart
    },
    {
        mac: "Ctrl-ArrowUp",
        run: cursorPageUp,
        shift: selectPageUp
    },
    {
        key: "ArrowDown",
        run: cursorLineDown,
        shift: selectLineDown,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: cursorDocEnd,
        shift: selectDocEnd
    },
    {
        mac: "Ctrl-ArrowDown",
        run: cursorPageDown,
        shift: selectPageDown
    },
    {
        key: "PageUp",
        run: cursorPageUp,
        shift: selectPageUp
    },
    {
        key: "PageDown",
        run: cursorPageDown,
        shift: selectPageDown
    },
    {
        key: "Home",
        run: cursorLineBoundaryBackward,
        shift: selectLineBoundaryBackward,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: cursorDocStart,
        shift: selectDocStart
    },
    {
        key: "End",
        run: cursorLineBoundaryForward,
        shift: selectLineBoundaryForward,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: cursorDocEnd,
        shift: selectDocEnd
    },
    {
        key: "Enter",
        run: insertNewlineAndIndent
    },
    {
        key: "Mod-a",
        run: selectAll
    },
    {
        key: "Backspace",
        run: deleteCharBackward,
        shift: deleteCharBackward
    },
    {
        key: "Delete",
        run: deleteCharForward
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: deleteGroupBackward
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: deleteGroupForward
    },
    {
        mac: "Mod-Backspace",
        run: deleteLineBoundaryBackward
    },
    {
        mac: "Mod-Delete",
        run: deleteLineBoundaryForward
    }
].concat(/*@__PURE__*/ emacsStyleKeymap.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
*/ var defaultKeymap = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: cursorSyntaxLeft,
        shift: selectSyntaxLeft
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: cursorSyntaxRight,
        shift: selectSyntaxRight
    },
    {
        key: "Alt-ArrowUp",
        run: moveLineUp
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: copyLineUp
    },
    {
        key: "Alt-ArrowDown",
        run: moveLineDown
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: copyLineDown
    },
    {
        key: "Escape",
        run: simplifySelection
    },
    {
        key: "Mod-Enter",
        run: insertBlankLine
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: selectLine
    },
    {
        key: "Mod-i",
        run: selectParentSyntax,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: indentLess
    },
    {
        key: "Mod-]",
        run: indentMore
    },
    {
        key: "Mod-Alt-\\",
        run: indentSelection
    },
    {
        key: "Shift-Mod-k",
        run: deleteLine
    },
    {
        key: "Shift-Mod-\\",
        run: cursorMatchingBracket
    },
    {
        key: "Mod-/",
        run: toggleComment
    },
    {
        key: "Alt-A",
        run: toggleBlockComment
    }
].concat(standardKeymap);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ var indentWithTab = {
    key: "Tab",
    run: indentMore,
    shift: indentLess
};

},{"@codemirror/state":"fECfb","@codemirror/view":"l3day","@codemirror/language":"jct2S","@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lND0o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegExpCursor", ()=>RegExpCursor);
parcelHelpers.export(exports, "SearchCursor", ()=>SearchCursor);
parcelHelpers.export(exports, "SearchQuery", ()=>SearchQuery);
parcelHelpers.export(exports, "closeSearchPanel", ()=>closeSearchPanel);
parcelHelpers.export(exports, "findNext", ()=>findNext);
parcelHelpers.export(exports, "findPrevious", ()=>findPrevious);
parcelHelpers.export(exports, "getSearchQuery", ()=>getSearchQuery);
parcelHelpers.export(exports, "gotoLine", ()=>gotoLine);
parcelHelpers.export(exports, "highlightSelectionMatches", ()=>highlightSelectionMatches);
parcelHelpers.export(exports, "openSearchPanel", ()=>openSearchPanel);
parcelHelpers.export(exports, "replaceAll", ()=>replaceAll);
parcelHelpers.export(exports, "replaceNext", ()=>replaceNext);
parcelHelpers.export(exports, "search", ()=>search);
parcelHelpers.export(exports, "searchKeymap", ()=>searchKeymap);
parcelHelpers.export(exports, "searchPanelOpen", ()=>searchPanelOpen);
parcelHelpers.export(exports, "selectMatches", ()=>selectMatches);
parcelHelpers.export(exports, "selectNextOccurrence", ()=>selectNextOccurrence);
parcelHelpers.export(exports, "selectSelectionMatches", ()=>selectSelectionMatches);
parcelHelpers.export(exports, "setSearchQuery", ()=>setSearchQuery);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _view = require("@codemirror/view");
var _state = require("@codemirror/state");
var _crelt = require("crelt");
var _creltDefault = parcelHelpers.interopDefault(_crelt);
var basicNormalize = typeof String.prototype.normalize == "function" ? (x)=>x.normalize("NFKD") : (x)=>x;
/**
A search cursor provides an iterator over text matches in a
document.
*/ class SearchCursor {
    peek() {
        if (this.bufferPos == this.buffer.length) {
            this.bufferStart += this.buffer.length;
            this.iter.next();
            if (this.iter.done) return -1;
            this.bufferPos = 0;
            this.buffer = this.iter.value;
        }
        return (0, _state.codePointAt)(this.buffer, this.bufferPos);
    }
    /**
    Look for the next match. Updates the iterator's
    [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
    [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
    at least once before using the cursor.
    */ next() {
        while(this.matches.length)this.matches.pop();
        return this.nextOverlapping();
    }
    /**
    The `next` method will ignore matches that partially overlap a
    previous match. This method behaves like `next`, but includes
    such matches.
    */ nextOverlapping() {
        for(;;){
            var next = this.peek();
            if (next < 0) {
                this.done = true;
                return this;
            }
            var str = (0, _state.fromCodePoint)(next), start = this.bufferStart + this.bufferPos;
            this.bufferPos += (0, _state.codePointSize)(next);
            var norm = this.normalize(str);
            for(var i = 0, pos = start;; i++){
                var code = norm.charCodeAt(i);
                var match = this.match(code, pos, this.bufferPos + this.bufferStart);
                if (i == norm.length - 1) {
                    if (match) {
                        this.value = match;
                        return this;
                    }
                    break;
                }
                if (pos == start && i < str.length && str.charCodeAt(i) == code) pos++;
            }
        }
    }
    match(code, pos, end) {
        var match = null;
        for(var i = 0; i < this.matches.length; i += 2){
            var index = this.matches[i], keep = false;
            if (this.query.charCodeAt(index) == code) {
                if (index == this.query.length - 1) match = {
                    from: this.matches[i + 1],
                    to: end
                };
                else {
                    this.matches[i]++;
                    keep = true;
                }
            }
            if (!keep) {
                this.matches.splice(i, 2);
                i -= 2;
            }
        }
        if (this.query.charCodeAt(0) == code) {
            if (this.query.length == 1) match = {
                from: pos,
                to: end
            };
            else this.matches.push(1, pos);
        }
        if (match && this.test && !this.test(match.from, match.to, this.buffer, this.bufferStart)) match = null;
        return match;
    }
    /**
    Create a text cursor. The query is the search string, `from` to
    `to` provides the region to search.
    
    When `normalize` is given, it will be called, on both the query
    string and the content it is matched against, before comparing.
    You can, for example, create a case-insensitive search by
    passing `s => s.toLowerCase()`.
    
    Text is always normalized with
    [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
    (when supported).
    */ constructor(text, query, ref, ref1, normalize, test){
        var from = ref === void 0 ? 0 : ref, to = ref1 === void 0 ? text.length : ref1;
        this.test = test;
        /**
        The current match (only holds a meaningful value after
        [`next`](https://codemirror.net/6/docs/ref/#search.SearchCursor.next) has been called and when
        `done` is false).
        */ this.value = {
            from: 0,
            to: 0
        };
        /**
        Whether the end of the iterated region has been reached.
        */ this.done = false;
        this.matches = [];
        this.buffer = "";
        this.bufferPos = 0;
        this.iter = text.iterRange(from, to);
        this.bufferStart = from;
        this.normalize = normalize ? (x)=>normalize(basicNormalize(x)) : basicNormalize;
        this.query = this.normalize(query);
    }
}
if (typeof Symbol != "undefined") SearchCursor.prototype[Symbol.iterator] = function() {
    return this;
};
var empty = {
    from: -1,
    to: -1,
    match: /*@__PURE__*/ /.*/.exec("")
};
var baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
/**
This class is similar to [`SearchCursor`](https://codemirror.net/6/docs/ref/#search.SearchCursor)
but searches for a regular expression pattern instead of a plain
string.
*/ class RegExpCursor {
    getLine(skip) {
        this.iter.next(skip);
        if (this.iter.lineBreak) this.curLine = "";
        else {
            this.curLine = this.iter.value;
            if (this.curLineStart + this.curLine.length > this.to) this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
            this.iter.next();
        }
    }
    nextLine() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1;
        if (this.curLineStart > this.to) this.curLine = "";
        else this.getLine(0);
    }
    /**
    Move to the next match, if there is one.
    */ next() {
        for(var off = this.matchPos - this.curLineStart;;){
            this.re.lastIndex = off;
            var match = this.matchPos <= this.to && this.re.exec(this.curLine);
            if (match) {
                var from = this.curLineStart + match.index, to = from + match[0].length;
                this.matchPos = toCharEnd(this.text, to + (from == to ? 1 : 0));
                if (from == this.curLineStart + this.curLine.length) this.nextLine();
                if ((from < to || from > this.value.to) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from,
                        to,
                        match
                    };
                    return this;
                }
                off = this.matchPos - this.curLineStart;
            } else if (this.curLineStart + this.curLine.length < this.to) {
                this.nextLine();
                off = 0;
            } else {
                this.done = true;
                return this;
            }
        }
    }
    /**
    Create a cursor that will search the given range in the given
    document. `query` should be the raw pattern (as you'd pass it to
    `new RegExp`).
    */ constructor(text, query, options, ref, ref1){
        var from = ref === void 0 ? 0 : ref, to = ref1 === void 0 ? text.length : ref1;
        this.text = text;
        this.to = to;
        this.curLine = "";
        /**
        Set to `true` when the cursor has reached the end of the search
        range.
        */ this.done = false;
        /**
        Will contain an object with the extent of the match and the
        match object when [`next`](https://codemirror.net/6/docs/ref/#search.RegExpCursor.next)
        sucessfully finds a match.
        */ this.value = empty;
        if (/\\[sWDnr]|\n|\r|\[\^/.test(query)) return new MultilineRegExpCursor(text, query, options, from, to);
        this.re = new RegExp(query, baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.iter = text.iter();
        var startLine = text.lineAt(from);
        this.curLineStart = startLine.from;
        this.matchPos = toCharEnd(text, from);
        this.getLine(this.curLineStart);
    }
}
var flattened = /*@__PURE__*/ new WeakMap();
// Reusable (partially) flattened document strings
class FlattenedDoc {
    get to() {
        return this.from + this.text.length;
    }
    static get(doc, from, to) {
        var cached = flattened.get(doc);
        if (!cached || cached.from >= to || cached.to <= from) {
            var flat = new FlattenedDoc(from, doc.sliceString(from, to));
            flattened.set(doc, flat);
            return flat;
        }
        if (cached.from == from && cached.to == to) return cached;
        var text = cached.text, cachedFrom = cached.from;
        if (cachedFrom > from) {
            text = doc.sliceString(from, cachedFrom) + text;
            cachedFrom = from;
        }
        if (cached.to < to) text += doc.sliceString(cached.to, to);
        flattened.set(doc, new FlattenedDoc(cachedFrom, text));
        return new FlattenedDoc(from, text.slice(from - cachedFrom, to - cachedFrom));
    }
    constructor(from, text){
        this.from = from;
        this.text = text;
    }
}
class MultilineRegExpCursor {
    chunkEnd(pos) {
        return pos >= this.to ? this.to : this.text.lineAt(pos).to;
    }
    next() {
        for(;;){
            var off = this.re.lastIndex = this.matchPos - this.flat.from;
            var match = this.re.exec(this.flat.text);
            // Skip empty matches directly after the last match
            if (match && !match[0] && match.index == off) {
                this.re.lastIndex = off + 1;
                match = this.re.exec(this.flat.text);
            }
            if (match) {
                var from = this.flat.from + match.index, to = from + match[0].length;
                // If a match goes almost to the end of a noncomplete chunk, try
                // again, since it'll likely be able to match more
                if ((this.flat.to >= this.to || match.index + match[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from,
                        to,
                        match
                    };
                    this.matchPos = toCharEnd(this.text, to + (from == to ? 1 : 0));
                    return this;
                }
            }
            if (this.flat.to == this.to) {
                this.done = true;
                return this;
            }
            // Grow the flattened doc
            this.flat = FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
        }
    }
    constructor(text, query, options, from, to){
        this.text = text;
        this.to = to;
        this.done = false;
        this.value = empty;
        this.matchPos = toCharEnd(text, from);
        this.re = new RegExp(query, baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.flat = FlattenedDoc.get(text, from, this.chunkEnd(from + 5000 /* Chunk.Base */ ));
    }
}
if (typeof Symbol != "undefined") RegExpCursor.prototype[Symbol.iterator] = MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
};
function validRegExp(source) {
    try {
        new RegExp(source, baseFlags);
        return true;
    } catch (_a) {
        return false;
    }
}
function toCharEnd(text, pos) {
    if (pos >= text.length) return pos;
    var line = text.lineAt(pos), next;
    while(pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 0xDC00 && next < 0xE000)pos++;
    return pos;
}
function createLineDialog(view) {
    var line = String(view.state.doc.lineAt(view.state.selection.main.head).number);
    var input = (0, _creltDefault.default)("input", {
        class: "cm-textfield",
        name: "line",
        value: line
    });
    var dom = (0, _creltDefault.default)("form", {
        class: "cm-gotoLine",
        onkeydown: (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                view.dispatch({
                    effects: dialogEffect.of(false)
                });
                view.focus();
            } else if (event.keyCode == 13) {
                event.preventDefault();
                go();
            }
        },
        onsubmit: (event)=>{
            event.preventDefault();
            go();
        }
    }, (0, _creltDefault.default)("label", view.state.phrase("Go to line"), ": ", input), " ", (0, _creltDefault.default)("button", {
        class: "cm-button",
        type: "submit"
    }, view.state.phrase("go")));
    function go() {
        var match = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
        if (!match) return;
        var state = view.state, startLine = state.doc.lineAt(state.selection.main.head);
        var _match = (0, _slicedToArray._)(match, 5), sign = _match[1], ln = _match[2], cl = _match[3], percent = _match[4];
        var col = cl ? +cl.slice(1) : 0;
        var line = ln ? +ln : startLine.number;
        if (ln && percent) {
            var pc = line / 100;
            if (sign) pc = pc * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
            line = Math.round(state.doc.lines * pc);
        } else if (ln && sign) line = line * (sign == "-" ? -1 : 1) + startLine.number;
        var docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
        var selection = (0, _state.EditorSelection).cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
        view.dispatch({
            effects: [
                dialogEffect.of(false),
                (0, _view.EditorView).scrollIntoView(selection.from, {
                    y: "center"
                })
            ],
            selection
        });
        view.focus();
    }
    return {
        dom
    };
}
var dialogEffect = /*@__PURE__*/ (0, _state.StateEffect).define();
var dialogField = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return true;
    },
    update (value, tr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.is(dialogEffect)) value = e.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    },
    provide: (f)=>(0, _view.showPanel).from(f, (val)=>val ? createLineDialog : null)
});
/**
Command that shows a dialog asking the user for a line number, and
when a valid position is provided, moves the cursor to that line.

Supports line numbers, relative line offsets prefixed with `+` or
`-`, document percentages suffixed with `%`, and an optional
column position by adding `:` and a second number after the line
number.
*/ var gotoLine = (view)=>{
    var panel = (0, _view.getPanel)(view, createLineDialog);
    if (!panel) {
        var effects = [
            dialogEffect.of(true)
        ];
        if (view.state.field(dialogField, false) == null) effects.push((0, _state.StateEffect).appendConfig.of([
            dialogField,
            baseTheme$1
        ]));
        view.dispatch({
            effects
        });
        panel = (0, _view.getPanel)(view, createLineDialog);
    }
    if (panel) panel.dom.querySelector("input").select();
    return true;
};
var baseTheme$1 = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-panel.cm-gotoLine": {
        padding: "2px 6px 4px",
        "& label": {
            fontSize: "80%"
        }
    }
});
var defaultHighlightOptions = {
    highlightWordAroundCursor: false,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: false
};
var highlightConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (options) {
        return (0, _state.combineConfig)(options, defaultHighlightOptions, {
            highlightWordAroundCursor: (a, b)=>a || b,
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
/**
This extension highlights text that matches the selection. It uses
the `"cm-selectionMatch"` class for the highlighting. When
`highlightWordAroundCursor` is enabled, the word at the cursor
itself will be highlighted with `"cm-selectionMatch-main"`.
*/ function highlightSelectionMatches(options) {
    var ext = [
        defaultTheme,
        matchHighlighter
    ];
    if (options) ext.push(highlightConfig.of(options));
    return ext;
}
var matchDeco = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-selectionMatch"
});
var mainMatchDeco = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
// Whether the characters directly outside the given positions are non-word characters
function insideWordBoundaries(check, state, from, to) {
    return (from == 0 || check(state.sliceDoc(from - 1, from)) != (0, _state.CharCategory).Word) && (to == state.doc.length || check(state.sliceDoc(to, to + 1)) != (0, _state.CharCategory).Word);
}
// Whether the characters directly at the given positions are word characters
function insideWord(check, state, from, to) {
    return check(state.sliceDoc(from, from + 1)) == (0, _state.CharCategory).Word && check(state.sliceDoc(to - 1, to)) == (0, _state.CharCategory).Word;
}
var matchHighlighter = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class {
    update(update) {
        if (update.selectionSet || update.docChanged || update.viewportChanged) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        var conf = view.state.facet(highlightConfig);
        var state = view.state, sel = state.selection;
        if (sel.ranges.length > 1) return (0, _view.Decoration).none;
        var range = sel.main, query, check = null;
        if (range.empty) {
            if (!conf.highlightWordAroundCursor) return (0, _view.Decoration).none;
            var word = state.wordAt(range.head);
            if (!word) return (0, _view.Decoration).none;
            check = state.charCategorizer(range.head);
            query = state.sliceDoc(word.from, word.to);
        } else {
            var len = range.to - range.from;
            if (len < conf.minSelectionLength || len > 200) return (0, _view.Decoration).none;
            if (conf.wholeWords) {
                query = state.sliceDoc(range.from, range.to); // TODO: allow and include leading/trailing space?
                check = state.charCategorizer(range.head);
                if (!(insideWordBoundaries(check, state, range.from, range.to) && insideWord(check, state, range.from, range.to))) return (0, _view.Decoration).none;
            } else {
                query = state.sliceDoc(range.from, range.to);
                if (!query) return (0, _view.Decoration).none;
            }
        }
        var deco = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = view.visibleRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                var cursor = new SearchCursor(state.doc, query, part.from, part.to);
                while(!cursor.next().done){
                    var _cursor_value = cursor.value, from = _cursor_value.from, to = _cursor_value.to;
                    if (!check || insideWordBoundaries(check, state, from, to)) {
                        if (range.empty && from <= range.from && to >= range.to) deco.push(mainMatchDeco.range(from, to));
                        else if (from >= range.to || to <= range.from) deco.push(matchDeco.range(from, to));
                        if (deco.length > conf.maxMatches) return (0, _view.Decoration).none;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0, _view.Decoration).set(deco);
    }
    constructor(view){
        this.decorations = this.getDeco(view);
    }
}, {
    decorations: (v)=>v.decorations
});
var defaultTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
// Select the words around the cursors.
var selectWord = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var selection = state.selection;
    var newSel = (0, _state.EditorSelection).create(selection.ranges.map((range)=>state.wordAt(range.head) || (0, _state.EditorSelection).cursor(range.head)), selection.mainIndex);
    if (newSel.eq(selection)) return false;
    dispatch(state.update({
        selection: newSel
    }));
    return true;
};
// Find next occurrence of query relative to last cursor. Wrap around
// the document if there are no more matches.
function findNextOccurrence(state, query) {
    var _loop = function(cycled1, cursor1) {
        cursor1.next();
        if (cursor1.done) {
            if (cycled1) return cursor = cursor1, cycled = cycled1, {
                v: null
            };
            cursor1 = new SearchCursor(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
            cycled1 = true;
        } else {
            if (cycled1 && ranges.some((r)=>r.from == cursor1.value.from)) return cursor = cursor1, cycled = cycled1, "continue";
            if (fullWord) {
                var word = state.wordAt(cursor1.value.from);
                if (!word || word.from != cursor1.value.from || word.to != cursor1.value.to) return cursor = cursor1, cycled = cycled1, "continue";
            }
            return cursor = cursor1, cycled = cycled1, {
                v: cursor1.value
            };
        }
        cursor = cursor1, cycled = cycled1, void 0;
    };
    var _state_selection = state.selection, main = _state_selection.main, ranges = _state_selection.ranges;
    var word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
    for(var cycled = false, cursor = new SearchCursor(state.doc, query, ranges[ranges.length - 1].to);;){
        var _ret = _loop(cycled, cursor);
        if ((0, _typeOf._)(_ret) === "object") return _ret.v;
    }
}
/**
Select next occurrence of the current selection. Expand selection
to the surrounding word when the selection is empty.
*/ var selectNextOccurrence = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var ranges = state.selection.ranges;
    if (ranges.some((sel)=>sel.from === sel.to)) return selectWord({
        state,
        dispatch
    });
    var searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
    if (state.selection.ranges.some((r)=>state.sliceDoc(r.from, r.to) != searchedText)) return false;
    var range = findNextOccurrence(state, searchedText);
    if (!range) return false;
    dispatch(state.update({
        selection: state.selection.addRange((0, _state.EditorSelection).range(range.from, range.to), false),
        effects: (0, _view.EditorView).scrollIntoView(range.to)
    }));
    return true;
};
var searchConfigFacet = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        return (0, _state.combineConfig)(configs, {
            top: false,
            caseSensitive: false,
            literal: false,
            regexp: false,
            wholeWord: false,
            createPanel: (view)=>new SearchPanel(view),
            scrollToMatch: (range)=>(0, _view.EditorView).scrollIntoView(range)
        });
    }
});
/**
Add search state to the editor configuration, and optionally
configure the search extension.
([`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) will automatically
enable this if it isn't already on).
*/ function search(config) {
    return config ? [
        searchConfigFacet.of(config),
        searchExtensions
    ] : searchExtensions;
}
/**
A search query. Part of the editor's search state.
*/ class SearchQuery {
    /**
    @internal
    */ unquote(text) {
        return this.literal ? text : text.replace(/\\([nrt\\])/g, (_, ch)=>ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "	" : "\\");
    }
    /**
    Compare this query to another query.
    */ eq(other) {
        return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
    }
    /**
    @internal
    */ create() {
        return this.regexp ? new RegExpQuery(this) : new StringQuery(this);
    }
    /**
    Get a search cursor for this query, searching through the given
    range in the given state.
    */ getCursor(state) {
        var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, to = arguments.length > 2 ? arguments[2] : void 0;
        var st = state.doc ? state : (0, _state.EditorState).create({
            doc: state
        });
        if (to == null) to = st.doc.length;
        return this.regexp ? regexpCursor(this, st, from, to) : stringCursor(this, st, from, to);
    }
    /**
    Create a query object.
    */ constructor(config){
        this.search = config.search;
        this.caseSensitive = !!config.caseSensitive;
        this.literal = !!config.literal;
        this.regexp = !!config.regexp;
        this.replace = config.replace || "";
        this.valid = !!this.search && (!this.regexp || validRegExp(this.search));
        this.unquoted = this.unquote(this.search);
        this.wholeWord = !!config.wholeWord;
    }
}
class QueryType {
    constructor(spec){
        this.spec = spec;
    }
}
function stringCursor(spec, state, from, to) {
    return new SearchCursor(state.doc, spec.unquoted, from, to, spec.caseSensitive ? undefined : (x)=>x.toLowerCase(), spec.wholeWord ? stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : undefined);
}
function stringWordTest(doc, categorizer) {
    return (from, to, buf, bufPos)=>{
        if (bufPos > from || bufPos + buf.length < to) {
            bufPos = Math.max(0, from - 2);
            buf = doc.sliceString(bufPos, Math.min(doc.length, to + 2));
        }
        return (categorizer(charBefore(buf, from - bufPos)) != (0, _state.CharCategory).Word || categorizer(charAfter(buf, from - bufPos)) != (0, _state.CharCategory).Word) && (categorizer(charAfter(buf, to - bufPos)) != (0, _state.CharCategory).Word || categorizer(charBefore(buf, to - bufPos)) != (0, _state.CharCategory).Word);
    };
}
class StringQuery extends QueryType {
    nextMatch(state, curFrom, curTo) {
        var cursor = stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
        if (cursor.done) cursor = stringCursor(this.spec, state, 0, curFrom).nextOverlapping();
        return cursor.done ? null : cursor.value;
    }
    // Searching in reverse is, rather than implementing an inverted search
    // cursor, done by scanning chunk after chunk forward.
    prevMatchInRange(state, from, to) {
        for(var pos = to;;){
            var start = Math.max(from, pos - 10000 /* FindPrev.ChunkSize */  - this.spec.unquoted.length);
            var cursor = stringCursor(this.spec, state, start, pos), range = null;
            while(!cursor.nextOverlapping().done)range = cursor.value;
            if (range) return range;
            if (start == from) return null;
            pos -= 10000 /* FindPrev.ChunkSize */ ;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(_result) {
        return this.spec.unquote(this.spec.replace);
    }
    matchAll(state, limit) {
        var cursor = stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        var cursor = stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to + this.spec.unquoted.length, state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
    constructor(spec){
        super(spec);
    }
}
function regexpCursor(spec, state, from, to) {
    return new RegExpCursor(state.doc, spec.search, {
        ignoreCase: !spec.caseSensitive,
        test: spec.wholeWord ? regexpWordTest(state.charCategorizer(state.selection.main.head)) : undefined
    }, from, to);
}
function charBefore(str, index) {
    return str.slice((0, _state.findClusterBreak)(str, index, false), index);
}
function charAfter(str, index) {
    return str.slice(index, (0, _state.findClusterBreak)(str, index));
}
function regexpWordTest(categorizer) {
    return (_from, _to, match)=>!match[0].length || (categorizer(charBefore(match.input, match.index)) != (0, _state.CharCategory).Word || categorizer(charAfter(match.input, match.index)) != (0, _state.CharCategory).Word) && (categorizer(charAfter(match.input, match.index + match[0].length)) != (0, _state.CharCategory).Word || categorizer(charBefore(match.input, match.index + match[0].length)) != (0, _state.CharCategory).Word);
}
class RegExpQuery extends QueryType {
    nextMatch(state, curFrom, curTo) {
        var cursor = regexpCursor(this.spec, state, curTo, state.doc.length).next();
        if (cursor.done) cursor = regexpCursor(this.spec, state, 0, curFrom).next();
        return cursor.done ? null : cursor.value;
    }
    prevMatchInRange(state, from, to) {
        for(var size = 1;; size++){
            var start = Math.max(from, to - size * 10000 /* FindPrev.ChunkSize */ );
            var cursor = regexpCursor(this.spec, state, start, to), range = null;
            while(!cursor.next().done)range = cursor.value;
            if (range && (start == from || range.from > start + 10)) return range;
            if (start == from) return null;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(result) {
        return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (m, i)=>i == "$" ? "$" : i == "&" ? result.match[0] : i != "0" && +i < result.match.length ? result.match[i] : m);
    }
    matchAll(state, limit) {
        var cursor = regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        var cursor = regexpCursor(this.spec, state, Math.max(0, from - 250 /* RegExp.HighlightMargin */ ), Math.min(to + 250 /* RegExp.HighlightMargin */ , state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
/**
A state effect that updates the current search query. Note that
this only has an effect if the search state has been initialized
(by including [`search`](https://codemirror.net/6/docs/ref/#search.search) in your configuration or
by running [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) at least
once).
*/ var setSearchQuery = /*@__PURE__*/ (0, _state.StateEffect).define();
var togglePanel = /*@__PURE__*/ (0, _state.StateEffect).define();
var searchState = /*@__PURE__*/ (0, _state.StateField).define({
    create (state) {
        return new SearchState(defaultQuery(state).create(), null);
    },
    update (value, tr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(setSearchQuery)) value = new SearchState(effect.value.create(), value.panel);
                else if (effect.is(togglePanel)) value = new SearchState(value.query, effect.value ? createSearchPanel : null);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    },
    provide: (f)=>(0, _view.showPanel).from(f, (val)=>val.panel)
});
/**
Get the current search query from an editor state.
*/ function getSearchQuery(state) {
    var curState = state.field(searchState, false);
    return curState ? curState.query.spec : defaultQuery(state);
}
/**
Query whether the search panel is open in the given editor state.
*/ function searchPanelOpen(state) {
    var _a;
    return ((_a = state.field(searchState, false)) === null || _a === void 0 ? void 0 : _a.panel) != null;
}
class SearchState {
    constructor(query, panel){
        this.query = query;
        this.panel = panel;
    }
}
var matchMark = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-searchMatch"
}), selectedMatchMark = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-searchMatch cm-searchMatch-selected"
});
var searchHighlighter = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class {
    update(update) {
        var state = update.state.field(searchState);
        if (state != update.startState.field(searchState) || update.docChanged || update.selectionSet || update.viewportChanged) this.decorations = this.highlight(state);
    }
    highlight(param) {
        var _loop = function(i1, ranges, l) {
            var _ranges_i = ranges[i1], from = _ranges_i.from, to = _ranges_i.to;
            while(i1 < l - 1 && to > ranges[i1 + 1].from - 500 /* RegExp.HighlightMargin */ )to = ranges[++i1].to;
            query.highlight(view.state, from, to, (from, to)=>{
                var selected = view.state.selection.ranges.some((r)=>r.from == from && r.to == to);
                builder.add(from, to, selected ? selectedMatchMark : matchMark);
            });
            i = i1, void 0;
        };
        var query = param.query, panel = param.panel;
        if (!panel || !query.spec.valid) return (0, _view.Decoration).none;
        var view = this.view;
        var builder = new (0, _state.RangeSetBuilder)();
        for(var i = 0, ranges = view.visibleRanges, l = ranges.length; i < l; i++)_loop(i, ranges, l);
        return builder.finish();
    }
    constructor(view){
        this.view = view;
        this.decorations = this.highlight(view.state.field(searchState));
    }
}, {
    decorations: (v)=>v.decorations
});
function searchCommand(f) {
    return (view)=>{
        var state = view.state.field(searchState, false);
        return state && state.query.spec.valid ? f(view, state) : openSearchPanel(view);
    };
}
/**
Open the search panel if it isn't already open, and move the
selection to the first match after the current main selection.
Will wrap around to the start of the document when it reaches the
end.
*/ var findNext = /*@__PURE__*/ searchCommand((view, param)=>{
    var query = param.query;
    var to = view.state.selection.main.to;
    var next = query.nextMatch(view.state, to, to);
    if (!next) return false;
    var selection = (0, _state.EditorSelection).single(next.from, next.to);
    var config = view.state.facet(searchConfigFacet);
    view.dispatch({
        selection,
        effects: [
            announceMatch(view, next),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    selectSearchInput(view);
    return true;
});
/**
Move the selection to the previous instance of the search query,
before the current main selection. Will wrap past the start
of the document to start searching at the end again.
*/ var findPrevious = /*@__PURE__*/ searchCommand((view, param)=>{
    var query = param.query;
    var state = view.state, from = state.selection.main.from;
    var prev = query.prevMatch(state, from, from);
    if (!prev) return false;
    var selection = (0, _state.EditorSelection).single(prev.from, prev.to);
    var config = view.state.facet(searchConfigFacet);
    view.dispatch({
        selection,
        effects: [
            announceMatch(view, prev),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    selectSearchInput(view);
    return true;
});
/**
Select all instances of the search query.
*/ var selectMatches = /*@__PURE__*/ searchCommand((view, param)=>{
    var query = param.query;
    var ranges = query.matchAll(view.state, 1000);
    if (!ranges || !ranges.length) return false;
    view.dispatch({
        selection: (0, _state.EditorSelection).create(ranges.map((r)=>(0, _state.EditorSelection).range(r.from, r.to))),
        userEvent: "select.search.matches"
    });
    return true;
});
/**
Select all instances of the currently selected text.
*/ var selectSelectionMatches = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var sel = state.selection;
    if (sel.ranges.length > 1 || sel.main.empty) return false;
    var _sel_main = sel.main, from = _sel_main.from, to = _sel_main.to;
    var ranges = [], main = 0;
    for(var cur = new SearchCursor(state.doc, state.sliceDoc(from, to)); !cur.next().done;){
        if (ranges.length > 1000) return false;
        if (cur.value.from == from) main = ranges.length;
        ranges.push((0, _state.EditorSelection).range(cur.value.from, cur.value.to));
    }
    dispatch(state.update({
        selection: (0, _state.EditorSelection).create(ranges, main),
        userEvent: "select.search.matches"
    }));
    return true;
};
/**
Replace the current match of the search query.
*/ var replaceNext = /*@__PURE__*/ searchCommand((view, param)=>{
    var query = param.query;
    var state = view.state, _state_selection_main = state.selection.main, from = _state_selection_main.from, to = _state_selection_main.to;
    if (state.readOnly) return false;
    var next = query.nextMatch(state, from, from);
    if (!next) return false;
    var changes = [], selection, replacement;
    var effects = [];
    if (next.from == from && next.to == to) {
        replacement = state.toText(query.getReplacement(next));
        changes.push({
            from: next.from,
            to: next.to,
            insert: replacement
        });
        next = query.nextMatch(state, next.from, next.to);
        effects.push((0, _view.EditorView).announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
    }
    if (next) {
        var off = changes.length == 0 || changes[0].from >= next.to ? 0 : next.to - next.from - replacement.length;
        selection = (0, _state.EditorSelection).single(next.from - off, next.to - off);
        effects.push(announceMatch(view, next));
        effects.push(state.facet(searchConfigFacet).scrollToMatch(selection.main, view));
    }
    view.dispatch({
        changes,
        selection,
        effects,
        userEvent: "input.replace"
    });
    return true;
});
/**
Replace all instances of the search query with the given
replacement.
*/ var replaceAll = /*@__PURE__*/ searchCommand((view, param)=>{
    var query = param.query;
    if (view.state.readOnly) return false;
    var changes = query.matchAll(view.state, 1e9).map((match)=>{
        var from = match.from, to = match.to;
        return {
            from,
            to,
            insert: query.getReplacement(match)
        };
    });
    if (!changes.length) return false;
    var announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
    view.dispatch({
        changes,
        effects: (0, _view.EditorView).announce.of(announceText),
        userEvent: "input.replace.all"
    });
    return true;
});
function createSearchPanel(view) {
    return view.state.facet(searchConfigFacet).createPanel(view);
}
function defaultQuery(state, fallback) {
    var _a, _b, _c, _d, _e;
    var sel = state.selection.main;
    var selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
    if (fallback && !selText) return fallback;
    var config = state.facet(searchConfigFacet);
    return new SearchQuery({
        search: ((_a = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a !== void 0 ? _a : config.literal) ? selText : selText.replace(/\n/g, "\\n"),
        caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config.caseSensitive,
        literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config.literal,
        regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config.regexp,
        wholeWord: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e !== void 0 ? _e : config.wholeWord
    });
}
function getSearchInput(view) {
    var panel = (0, _view.getPanel)(view, createSearchPanel);
    return panel && panel.dom.querySelector("[main-field]");
}
function selectSearchInput(view) {
    var input = getSearchInput(view);
    if (input && input == view.root.activeElement) input.select();
}
/**
Make sure the search panel is open and focused.
*/ var openSearchPanel = (view)=>{
    var state = view.state.field(searchState, false);
    if (state && state.panel) {
        var searchInput = getSearchInput(view);
        if (searchInput && searchInput != view.root.activeElement) {
            var query = defaultQuery(view.state, state.query.spec);
            if (query.valid) view.dispatch({
                effects: setSearchQuery.of(query)
            });
            searchInput.focus();
            searchInput.select();
        }
    } else view.dispatch({
        effects: [
            togglePanel.of(true),
            state ? setSearchQuery.of(defaultQuery(view.state, state.query.spec)) : (0, _state.StateEffect).appendConfig.of(searchExtensions)
        ]
    });
    return true;
};
/**
Close the search panel.
*/ var closeSearchPanel = (view)=>{
    var state = view.state.field(searchState, false);
    if (!state || !state.panel) return false;
    var panel = (0, _view.getPanel)(view, createSearchPanel);
    if (panel && panel.dom.contains(view.root.activeElement)) view.focus();
    view.dispatch({
        effects: togglePanel.of(false)
    });
    return true;
};
/**
Default search-related key bindings.

 - Mod-f: [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel)
 - F3, Mod-g: [`findNext`](https://codemirror.net/6/docs/ref/#search.findNext)
 - Shift-F3, Shift-Mod-g: [`findPrevious`](https://codemirror.net/6/docs/ref/#search.findPrevious)
 - Mod-Alt-g: [`gotoLine`](https://codemirror.net/6/docs/ref/#search.gotoLine)
 - Mod-d: [`selectNextOccurrence`](https://codemirror.net/6/docs/ref/#search.selectNextOccurrence)
*/ var searchKeymap = [
    {
        key: "Mod-f",
        run: openSearchPanel,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: findNext,
        shift: findPrevious,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Mod-g",
        run: findNext,
        shift: findPrevious,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Escape",
        run: closeSearchPanel,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: selectSelectionMatches
    },
    {
        key: "Mod-Alt-g",
        run: gotoLine
    },
    {
        key: "Mod-d",
        run: selectNextOccurrence,
        preventDefault: true
    }
];
class SearchPanel {
    commit() {
        var query = new SearchQuery({
            search: this.searchField.value,
            caseSensitive: this.caseField.checked,
            regexp: this.reField.checked,
            wholeWord: this.wordField.checked,
            replace: this.replaceField.value
        });
        if (!query.eq(this.query)) {
            this.query = query;
            this.view.dispatch({
                effects: setSearchQuery.of(query)
            });
        }
    }
    keydown(e) {
        if ((0, _view.runScopeHandlers)(this.view, e, "search-panel")) e.preventDefault();
        else if (e.keyCode == 13 && e.target == this.searchField) {
            e.preventDefault();
            (e.shiftKey ? findPrevious : findNext)(this.view);
        } else if (e.keyCode == 13 && e.target == this.replaceField) {
            e.preventDefault();
            replaceNext(this.view);
        }
    }
    update(update) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = update.transactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var tr = _step.value;
                try {
                    for(var _iterator1 = tr.effects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var effect = _step1.value;
                        if (effect.is(setSearchQuery) && !effect.value.eq(this.query)) this.setQuery(effect.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    setQuery(query) {
        this.query = query;
        this.searchField.value = query.search;
        this.replaceField.value = query.replace;
        this.caseField.checked = query.caseSensitive;
        this.reField.checked = query.regexp;
        this.wordField.checked = query.wholeWord;
    }
    mount() {
        this.searchField.select();
    }
    get pos() {
        return 80;
    }
    get top() {
        return this.view.state.facet(searchConfigFacet).top;
    }
    constructor(view){
        this.view = view;
        var query = this.query = view.state.field(searchState).query.spec;
        this.commit = this.commit.bind(this);
        this.searchField = (0, _creltDefault.default)("input", {
            value: query.search,
            placeholder: phrase(view, "Find"),
            "aria-label": phrase(view, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.replaceField = (0, _creltDefault.default)("input", {
            value: query.replace,
            placeholder: phrase(view, "Replace"),
            "aria-label": phrase(view, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.caseField = (0, _creltDefault.default)("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: query.caseSensitive,
            onchange: this.commit
        });
        this.reField = (0, _creltDefault.default)("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: query.regexp,
            onchange: this.commit
        });
        this.wordField = (0, _creltDefault.default)("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: query.wholeWord,
            onchange: this.commit
        });
        function button(name, onclick, content) {
            return (0, _creltDefault.default)("button", {
                class: "cm-button",
                name,
                onclick,
                type: "button"
            }, content);
        }
        this.dom = (0, _creltDefault.default)("div", {
            onkeydown: (e)=>this.keydown(e),
            class: "cm-search"
        }, [
            this.searchField,
            button("next", ()=>findNext(view), [
                phrase(view, "next")
            ]),
            button("prev", ()=>findPrevious(view), [
                phrase(view, "previous")
            ]),
            button("select", ()=>selectMatches(view), [
                phrase(view, "all")
            ]),
            (0, _creltDefault.default)("label", null, [
                this.caseField,
                phrase(view, "match case")
            ]),
            (0, _creltDefault.default)("label", null, [
                this.reField,
                phrase(view, "regexp")
            ]),
            (0, _creltDefault.default)("label", null, [
                this.wordField,
                phrase(view, "by word")
            ]),
            ...view.state.readOnly ? [] : [
                (0, _creltDefault.default)("br"),
                this.replaceField,
                button("replace", ()=>replaceNext(view), [
                    phrase(view, "replace")
                ]),
                button("replaceAll", ()=>replaceAll(view), [
                    phrase(view, "replace all")
                ])
            ],
            (0, _creltDefault.default)("button", {
                name: "close",
                onclick: ()=>closeSearchPanel(view),
                "aria-label": phrase(view, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]);
    }
}
function phrase(view, phrase) {
    return view.state.phrase(phrase);
}
var AnnounceMargin = 30;
var Break = /[\s\.,:;?!]/;
function announceMatch(view, param) {
    var from = param.from, to = param.to;
    var line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to).to;
    var start = Math.max(line.from, from - AnnounceMargin), end = Math.min(lineEnd, to + AnnounceMargin);
    var text = view.state.sliceDoc(start, end);
    if (start != line.from) {
        for(var i = 0; i < AnnounceMargin; i++)if (!Break.test(text[i + 1]) && Break.test(text[i])) {
            text = text.slice(i);
            break;
        }
    }
    if (end != lineEnd) {
        for(var i1 = text.length - 1; i1 > text.length - AnnounceMargin; i1--)if (!Break.test(text[i1 - 1]) && Break.test(text[i1])) {
            text = text.slice(0, i1);
            break;
        }
    }
    return (0, _view.EditorView).announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
var baseTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
});
var searchExtensions = [
    searchState,
    /*@__PURE__*/ (0, _state.Prec).low(searchHighlighter),
    baseTheme
];

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@swc/helpers/_/_type_of":"b2I7C","@codemirror/view":"l3day","@codemirror/state":"fECfb","crelt":"4YF2f","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"b2I7C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_type_of", ()=>_type_of);
parcelHelpers.export(exports, "_", ()=>_type_of);
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"4YF2f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>crelt);
function crelt() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)add(elt, arguments[i]);
    return elt;
}
function add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2rxgM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompletionContext", ()=>CompletionContext);
parcelHelpers.export(exports, "acceptCompletion", ()=>acceptCompletion);
parcelHelpers.export(exports, "autocompletion", ()=>autocompletion);
parcelHelpers.export(exports, "clearSnippet", ()=>clearSnippet);
parcelHelpers.export(exports, "closeBrackets", ()=>closeBrackets);
parcelHelpers.export(exports, "closeBracketsKeymap", ()=>closeBracketsKeymap);
parcelHelpers.export(exports, "closeCompletion", ()=>closeCompletion);
parcelHelpers.export(exports, "completeAnyWord", ()=>completeAnyWord);
parcelHelpers.export(exports, "completeFromList", ()=>completeFromList);
parcelHelpers.export(exports, "completionKeymap", ()=>completionKeymap);
parcelHelpers.export(exports, "completionStatus", ()=>completionStatus);
parcelHelpers.export(exports, "currentCompletions", ()=>currentCompletions);
parcelHelpers.export(exports, "deleteBracketPair", ()=>deleteBracketPair);
parcelHelpers.export(exports, "hasNextSnippetField", ()=>hasNextSnippetField);
parcelHelpers.export(exports, "hasPrevSnippetField", ()=>hasPrevSnippetField);
parcelHelpers.export(exports, "ifIn", ()=>ifIn);
parcelHelpers.export(exports, "ifNotIn", ()=>ifNotIn);
parcelHelpers.export(exports, "insertBracket", ()=>insertBracket);
parcelHelpers.export(exports, "insertCompletionText", ()=>insertCompletionText);
parcelHelpers.export(exports, "moveCompletionSelection", ()=>moveCompletionSelection);
parcelHelpers.export(exports, "nextSnippetField", ()=>nextSnippetField);
parcelHelpers.export(exports, "pickedCompletion", ()=>pickedCompletion);
parcelHelpers.export(exports, "prevSnippetField", ()=>prevSnippetField);
parcelHelpers.export(exports, "selectedCompletion", ()=>selectedCompletion);
parcelHelpers.export(exports, "selectedCompletionIndex", ()=>selectedCompletionIndex);
parcelHelpers.export(exports, "setSelectedCompletion", ()=>setSelectedCompletion);
parcelHelpers.export(exports, "snippet", ()=>snippet);
parcelHelpers.export(exports, "snippetCompletion", ()=>snippetCompletion);
parcelHelpers.export(exports, "snippetKeymap", ()=>snippetKeymap);
parcelHelpers.export(exports, "startCompletion", ()=>startCompletion);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _state = require("@codemirror/state");
var _view = require("@codemirror/view");
var _language = require("@codemirror/language");
/**
An instance of this is passed to completion source functions.
*/ class CompletionContext {
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        var token = (0, _language.syntaxTree)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        var line = this.state.doc.lineAt(this.pos);
        var start = Math.max(line.from, this.pos - 250);
        var str = line.text.slice(start - line.from, this.pos - line.from);
        var found = str.search(ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    */ addEventListener(type, listener) {
        if (type == "abort" && this.abortListeners) this.abortListeners.push(listener);
    }
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        /**
        @internal
        */ this.abortListeners = [];
    }
}
function toSet(chars) {
    var flat = Object.keys(chars).join("");
    var words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function prefixMatch(options) {
    var first = Object.create(null), rest = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var label = _step.value.label;
            first[label[0]] = true;
            for(var i = 1; i < label.length; i++)rest[label[i]] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var source = toSet(first) + toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function completeFromList(list) {
    var options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    var _ref = (0, _slicedToArray._)(options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : prefixMatch(options), 2), validFor = _ref[0], match = _ref[1];
    return (context)=>{
        var token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options,
            validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function ifIn(nodes, source) {
    return (context)=>{
        for(var pos = (0, _language.syntaxTree)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function ifNotIn(nodes, source) {
    return (context)=>{
        for(var pos = (0, _language.syntaxTree)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function ensureAnchor(expr, start) {
    var _a;
    var source = expr.source;
    var addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ var pickedCompletion = /*@__PURE__*/ (0, _state.Annotation).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function insertCompletionText(state, text, from, to) {
    var main = state.selection.main, fromOff = from - main.from, toOff = to - main.from;
    return Object.assign(Object.assign({}, state.changeByRange((range)=>{
        if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
            range
        };
        return {
            changes: {
                from: range.from + fromOff,
                to: to == main.from ? range.to : range.from + toOff,
                insert: text
            },
            range: (0, _state.EditorSelection).cursor(range.from + fromOff + text.length)
        };
    })), {
        scrollIntoView: true,
        userEvent: "input.complete"
    });
}
var SourceCache = /*@__PURE__*/ new WeakMap();
function asSource(source) {
    if (!Array.isArray(source)) return source;
    var known = SourceCache.get(source);
    if (!known) SourceCache.set(source, known = completeFromList(source));
    return known;
}
var startCompletionEffect = /*@__PURE__*/ (0, _state.StateEffect).define();
var closeCompletionEffect = /*@__PURE__*/ (0, _state.StateEffect).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class FuzzyMatcher {
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        var _this = this, chars = _this.chars, folded = _this.folded, any = _this.any, precise = _this.precise, byWord = _this.byWord;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            var first = (0, _state.codePointAt)(word, 0), firstSize = (0, _state.codePointSize)(first);
            var score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        var direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        var len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(var i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                var next = (0, _state.codePointAt)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, _state.codePointSize)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        var preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        var byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        var adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        var hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(var i1 = 0, e1 = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i1 < e1 && byWordTo < len;){
            var next1 = (0, _state.codePointAt)(word, i1);
            if (direct < 0) {
                if (preciseTo < len && next1 == chars[preciseTo]) precise[preciseTo++] = i1;
                if (adjacentTo < len) {
                    if (next1 == chars[adjacentTo] || next1 == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i1;
                        adjacentEnd = i1 + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            var ch = void 0, type = next1 < 0xff ? next1 >= 48 && next1 <= 57 || next1 >= 97 && next1 <= 122 ? 2 /* Tp.Lower */  : next1 >= 65 && next1 <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, _state.fromCodePoint)(next1)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i1 || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next1 || folded[byWordTo] == next1 && (byWordFolded = true)) byWord[byWordTo++] = i1;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i1 += (0, _state.codePointSize)(next1);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        var result = [], i = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = positions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var pos = _step.value;
                var to = pos + (this.astral ? (0, _state.codePointSize)((0, _state.codePointAt)(word, pos)) : 1);
                if (i && result[i - 1] == pos) result[i - 1] = to;
                else {
                    result[i++] = pos;
                    result[i++] = to;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return this.ret(score - word.length, result);
    }
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(var p = 0; p < pattern.length;){
            var char = (0, _state.codePointAt)(pattern, p), size = (0, _state.codePointSize)(char);
            this.chars.push(char);
            var part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, _state.codePointAt)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
}
class StrictMatcher {
    match(word) {
        if (word.length < this.pattern.length) return null;
        var start = word.slice(0, this.pattern.length);
        var match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
}
var completionConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        return (0, _state.combineConfig)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>a.label.localeCompare(b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function defaultPositionInfo(view, list, option, info, space, tooltip) {
    var rtl = view.textDirection == (0, _view.Direction).RTL, left = rtl, narrow = false;
    var side = "top", offset, maxWidth;
    var spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    var infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        var spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    var scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    var scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
function optionContent(config) {
    var content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            var icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            var labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            var label = completion.displayLabel || completion.label, off = 0;
            for(var j = 0; j < match.length;){
                var from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                var span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            var detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        var off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    var off1 = Math.floor((total - selected) / max);
    return {
        from: total - (off1 + 1) * max,
        to: total - off1 * max
    };
}
class CompletionTooltip {
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        var cState = update.state.field(this.stateField);
        var prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            var _cState_open = cState.open, options = _cState_open.options, selected = _cState_open.selected, disabled = _cState_open.disabled;
            if (!prevState.open || prevState.open.options != options) {
                this.range = rangeAroundSelected(options.length, selected, update.state.facet(completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        var cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.currentClass.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    if (c) this.dom.classList.remove(c);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = cls.split(" ")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var c1 = _step1.value;
                    if (c1) this.dom.classList.add(c1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        var cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = rangeAroundSelected(open.options.length, open.selected, this.view.state.facet(completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        if (this.updateSelectedOption(open.selected)) {
            this.destroyInfo();
            var completion = open.options[open.selected].completion;
            var info = completion.info;
            if (!info) return;
            var infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, _view.logException)(this.view.state, e, "completion info"));
            else this.addInfoPane(infoResult, completion);
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        var wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            var dom = content.dom, destroy = content.destroy;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        var set = null;
        for(var opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) opt.removeAttribute("aria-selected");
        }
        if (set) scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        var sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        var listRect = this.dom.getBoundingClientRect();
        var infoRect = this.info.getBoundingClientRect();
        var selRect = sel.getBoundingClientRect();
        var space = this.space;
        if (!space) {
            var win = this.dom.ownerDocument.defaultView || window;
            space = {
                left: 0,
                top: 0,
                right: win.innerWidth,
                bottom: win.innerHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet(completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        var ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        var curSection = null;
        for(var i = range.from; i < range.to; i++){
            var _options_i = options[i], completion = _options_i.completion, match = _options_i.match, section = completion.section;
            if (section) {
                var name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        var header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            var li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            var cls = this.optionClass(completion);
            if (cls) li.className = cls;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.optionContent[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var source = _step.value;
                    var node = source(completion, this.view.state, this.view, match);
                    if (node) li.appendChild(node);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        var cState = view.state.field(stateField);
        var _cState_open = cState.open, options = _cState_open.options, selected = _cState_open.selected;
        var config = view.state.facet(completionConfig);
        this.optionContent = optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            var options = view.state.field(stateField).open.options;
            for(var dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            var state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet(completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
}
function completionTooltip(stateField, applyCompletion) {
    return (view)=>new CompletionTooltip(view, stateField, applyCompletion);
}
function scrollIntoView(container, element) {
    var parent = container.getBoundingClientRect();
    var self = element.getBoundingClientRect();
    var scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function sortOptions(active, state) {
    var options = [];
    var sections = null;
    var addOption = (option)=>{
        options.push(option);
        var section = option.completion.section;
        if (section) {
            if (!sections) sections = [];
            var name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name
            } : section);
        }
    };
    var conf = state.facet(completionConfig);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = active[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            if (a.hasResult()) {
                var getMatch = a.result.getMatch;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (a.result.filter === false) try {
                    for(var _iterator1 = a.result.options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var option = _step1.value;
                        addOption(new Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                else {
                    var pattern = state.sliceDoc(a.from, a.to), match = void 0;
                    var matcher = conf.filterStrict ? new StrictMatcher(pattern) : new FuzzyMatcher(pattern);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = a.result.options[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var option1 = _step2.value;
                            if (match = matcher.match(option1.label)) {
                                var matched = !option1.displayLabel ? match.matched : getMatch ? getMatch(option1, match.matched) : [];
                                addOption(new Option(option1, a.source, matched, match.score + (option1.boost || 0)));
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (sections) {
        var sectionOrder = Object.create(null), pos = 0;
        var cmp = (a, b)=>{
            var _a, _b;
            return ((_a = a.rank) !== null && _a !== void 0 ? _a : 1e9) - ((_b = b.rank) !== null && _b !== void 0 ? _b : 1e9) || (a.name < b.name ? -1 : 1);
        };
        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
        try {
            for(var _iterator3 = sections.sort(cmp)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                var s = _step3.value;
                pos -= 1e5;
                sectionOrder[s.name] = pos;
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                }
            } finally{
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
        try {
            for(var _iterator4 = options[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                var option2 = _step4.value;
                var section = option2.completion.section;
                if (section) option2.score += sectionOrder[typeof section == "string" ? section : section.name];
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                }
            } finally{
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }
    var result = [], prev = null;
    var compare = conf.compareCompletions;
    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
    try {
        for(var _iterator5 = options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
            var opt = _step5.value;
            var cur = opt.completion;
            if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
            else if (score(opt.completion) > score(prev)) result[result.length - 1] = opt;
            prev = opt.completion;
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
            }
        } finally{
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }
    return result;
}
class CompletionDialog {
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new CompletionDialog(this.options, makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf) {
        var options = sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.state == 1 /* State.Pending */ ) ? new CompletionDialog(prev.options, prev.attrs, prev.tooltip, prev.timestamp, prev.selected, true) : null;
        var selected = state.facet(completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            var selectedValue = prev.options[prev.selected].completion;
            for(var i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new CompletionDialog(options, makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
            pos: changes.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected, this.disabled);
    }
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
}
class CompletionState {
    static start() {
        return new CompletionState(none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        var state = tr.state, conf = state.facet(completionConfig);
        var sources = conf.override || state.languageDataAt("autocomplete", cur(state)).map(asSource);
        var active = sources.map((source)=>{
            var value = this.active.find((s)=>s.source == source) || new ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        var open = this.open;
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !sameResults(active, this.active)) open = CompletionDialog.build(active, state, this.id, open, conf);
        else if (open && open.disabled && !active.some((a)=>a.state == 1 /* State.Pending */ )) open = null;
        if (!open && active.every((a)=>a.state != 1 /* State.Pending */ ) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return active == this.active && open == this.open ? this : new CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : baseAttrs;
    }
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
}
function sameResults(a, b) {
    if (a == b) return true;
    for(var iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult)iA++;
        while(iB < b.length && !b[iB].hasResult)iB++;
        var endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
var baseAttrs = {
    "aria-autocomplete": "list"
};
function makeAttrs(id, selected) {
    var result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
var none = [];
function getUserEvent(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        var completion = tr.annotation(pickedCompletion);
        if (completion && conf.activateOnCompletion(completion)) return "input";
    }
    return tr.isUserEvent("input.type") ? "input" : tr.isUserEvent("delete.backward") ? "delete" : null;
}
class ActiveSource {
    hasResult() {
        return false;
    }
    update(tr, conf) {
        var event = getUserEvent(tr, conf), value = this;
        if (event) value = value.handleUserEvent(tr, event, conf);
        else if (tr.docChanged) value = value.handleChange(tr);
        else if (tr.selection && value.state != 0 /* State.Inactive */ ) value = new ActiveSource(value.source, 0 /* State.Inactive */ );
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(startCompletionEffect)) value = new ActiveSource(value.source, 1 /* State.Pending */ , effect.value ? cur(tr.state) : -1);
                else if (effect.is(closeCompletionEffect)) value = new ActiveSource(value.source, 0 /* State.Inactive */ );
                else if (effect.is(setActiveEffect)) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = effect.value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var active = _step1.value;
                            if (active.source == value.source) value = active;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    }
    handleUserEvent(tr, type, conf) {
        return type == "delete" || !conf.activateOnTyping ? this.map(tr.changes) : new ActiveSource(this.source, 1 /* State.Pending */ );
    }
    handleChange(tr) {
        return tr.changes.touchesRange(cur(tr.startState)) ? new ActiveSource(this.source, 0 /* State.Inactive */ ) : this.map(tr.changes);
    }
    map(changes) {
        return changes.empty || this.explicitPos < 0 ? this : new ActiveSource(this.source, this.state, changes.mapPos(this.explicitPos));
    }
    constructor(source, state, ref){
        var explicitPos = ref === void 0 ? -1 : ref;
        this.source = source;
        this.state = state;
        this.explicitPos = explicitPos;
    }
}
class ActiveResult extends ActiveSource {
    hasResult() {
        return true;
    }
    handleUserEvent(tr, type, conf) {
        var _a;
        var result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        var from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        var pos = cur(tr.state);
        if ((this.explicitPos < 0 ? pos <= from : pos < this.from) || pos > to || !result || type == "delete" && cur(tr.startState) == this.from) return new ActiveSource(this.source, type == "input" && conf.activateOnTyping ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        var explicitPos = this.explicitPos < 0 ? -1 : tr.changes.mapPos(this.explicitPos);
        if (checkValid(result.validFor, tr.state, from, to)) return new ActiveResult(this.source, explicitPos, result, from, to);
        if (result.update && (result = result.update(result, from, to, new CompletionContext(tr.state, pos, explicitPos >= 0)))) return new ActiveResult(this.source, explicitPos, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : cur(tr.state));
        return new ActiveSource(this.source, 1 /* State.Pending */ , explicitPos);
    }
    handleChange(tr) {
        return tr.changes.touchesRange(this.from, this.to) ? new ActiveSource(this.source, 0 /* State.Inactive */ ) : this.map(tr.changes);
    }
    map(mapping) {
        if (mapping.empty) return this;
        var result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new ActiveSource(this.source, 0 /* State.Inactive */ );
        return new ActiveResult(this.source, this.explicitPos < 0 ? -1 : mapping.mapPos(this.explicitPos), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
    constructor(source, explicitPos, result, from, to){
        super(source, 2 /* State.Result */ , explicitPos);
        this.result = result;
        this.from = from;
        this.to = to;
    }
}
function checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    var text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : ensureAnchor(validFor, true).test(text);
}
var setActiveEffect = /*@__PURE__*/ (0, _state.StateEffect).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
var setSelectedEffect = /*@__PURE__*/ (0, _state.StateEffect).define();
var completionState = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, _view.showTooltip).from(f, (val)=>val.tooltip),
            (0, _view.EditorView).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function applyCompletion(view, option) {
    var apply = option.completion.apply || option.completion.label;
    var result = view.state.field(completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch(Object.assign(Object.assign({}, insertCompletionText(view.state, apply, result.from, result.to)), {
        annotations: pickedCompletion.of(option.completion)
    }));
    else apply(view, option.completion, result.from, result.to);
    return true;
}
var createTooltip = /*@__PURE__*/ completionTooltip(completionState, applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function moveCompletionSelection(forward) {
    var by = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "option";
    return (view)=>{
        var cState = view.state.field(completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay) return false;
        var step = 1, tooltip;
        if (by == "page" && (tooltip = (0, _view.getTooltip)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        var length = cState.open.options.length;
        var selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ var acceptCompletion = (view)=>{
    var cState = view.state.field(completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay) return false;
    return applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ var startCompletion = (view)=>{
    var cState = view.state.field(completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ var closeCompletion = (view)=>{
    var cState = view.state.field(completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: closeCompletionEffect.of(null)
    });
    return true;
};
class RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
var MaxUpdateCount = 50, MinAbortTime = 1000;
var completionPlugin = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class {
    update(update) {
        var cState = update.state.field(completionState);
        var conf = update.state.facet(completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field(completionState) == cState) return;
        var doesReset = update.transactions.some((tr)=>{
            return (tr.selection || tr.docChanged) && !getUserEvent(tr, conf);
        });
        for(var i = 0; i < this.running.length; i++){
            var query = this.running[i];
            if (doesReset || query.updates.length + update.transactions.length > MaxUpdateCount && Date.now() - query.time > MinAbortTime) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = query.context.abortListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        try {
                            handler();
                        } catch (e) {
                            (0, _view.logException)(this.view.state, e);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is(startCompletionEffect)))) this.pendingStart = true;
        var delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.state == 1 /* State.Pending */  && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (this.composing != 0 /* CompositionState.None */ ) try {
            for(var _iterator1 = update.transactions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var tr = _step1.value;
                if (getUserEvent(tr, conf) == "input") this.composing = 2 /* CompositionState.Changed */ ;
                else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        var state = this.view.state, cState = state.field(completionState);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _this = this, _loop = function() {
                var active = _step.value;
                if (active.state == 1 /* State.Pending */  && !_this.running.some((r)=>r.active.source == active.source)) _this.startQuery(active);
            };
            for(var _iterator = cState.active[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    startQuery(active) {
        var state = this.view.state, pos = cur(state);
        var context = new CompletionContext(state, pos, active.explicitPos == pos);
        var pending = new RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: closeCompletionEffect.of(null)
            });
            (0, _view.logException)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet(completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _this = this, _loop = function(i1) {
            var query = _this.running[i1];
            if (query.done === undefined) return i = i1, "continue";
            _this.running.splice(i1--, 1);
            if (query.done) {
                var active = new ActiveResult(query.active.source, query.active.explicitPos, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : cur(query.updates.length ? query.updates[0].startState : _this.view.state));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Replay the transactions that happened since the start of
                    // the request and see if that preserves the result
                    for(var _iterator = query.updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tr = _step.value;
                        active = active.update(tr, conf);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (active.hasResult()) {
                    updated.push(active);
                    return i = i1, "continue";
                }
            }
            var current = _this.view.state.field(completionState).active.find((a)=>a.source == query.active.source);
            if (current && current.state == 1 /* State.Pending */ ) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    var active1 = new ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = query.updates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var tr1 = _step1.value;
                            active1 = active1.update(tr1, conf);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (active1.state != 1 /* State.Pending */ ) updated.push(active1);
                } else // Cleared by subsequent transactions. Restart.
                _this.startQuery(current);
            }
            i = i1, void 0;
        };
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        var updated = [];
        var conf = this.view.state.facet(completionConfig);
        for(var i = 0; i < this.running.length; i++)_loop(i);
        if (updated.length) this.view.dispatch({
            effects: setActiveEffect.of(updated)
        });
    }
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = view.state.field(completionState).active[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var active = _step.value;
                if (active.state == 1 /* State.Pending */ ) this.startQuery(active);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}, {
    eventHandlers: {
        blur (event) {
            var state = this.view.state.field(completionState, false);
            if (state && state.tooltip && this.view.state.facet(completionConfig).closeOnBlur) {
                var dialog = state.open && (0, _view.getTooltip)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
var windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
var commitCharacters = /*@__PURE__*/ (0, _state.Prec).highest(/*@__PURE__*/ (0, _view.EditorView).domEventHandlers({
    keydown (event, view) {
        var field = view.state.field(completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !(windows && event.altKey) || event.metaKey) return false;
        var option = field.open.options[field.open.selected];
        var result = field.active.find((a)=>a.source == option.source);
        var commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) applyCompletion(view, option);
        return false;
    }
}));
var baseTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class FieldRange {
    map(changes) {
        var from = changes.mapPos(this.from, -1, (0, _state.MapMode).TrackDel);
        var to = changes.mapPos(this.to, 1, (0, _state.MapMode).TrackDel);
        return from == null || to == null ? null : new FieldRange(this.field, from, to);
    }
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
}
class Snippet {
    instantiate(state, pos) {
        var text = [], lineStart = [
            pos
        ];
        var lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                if (text.length) {
                    var indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                    for(var i = 0; i < tabs; i++)indent += state.facet((0, _language.indentUnit));
                    lineStart.push(pos + indent.length - tabs);
                    line = indent + line.slice(tabs);
                }
                text.push(line);
                pos += line.length + 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var ranges = this.fieldPositions.map((pos)=>new FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text,
            ranges
        };
    }
    static parse(template) {
        var fields = [];
        var lines = [], positions = [], m;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = template.split(/\r\n?|\n/)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var line = _step.value;
                while(m = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(line)){
                    var seq = m[1] ? +m[1] : null, name = m[2] || m[3] || "", found = -1;
                    for(var i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                    if (found < 0) {
                        var i1 = 0;
                        while(i1 < fields.length && (seq == null || fields[i1].seq != null && fields[i1].seq < seq))i1++;
                        fields.splice(i1, 0, {
                            seq,
                            name
                        });
                        found = i1;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = positions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var pos = _step1.value;
                                if (pos.field >= found) pos.field++;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                    positions.push(new FieldPos(found, lines.length, m.index, m.index + name.length));
                    line = line.slice(0, m.index) + name + line.slice(m.index + m[0].length);
                }
                for(var esc = void 0; esc = /\\([{}])/.exec(line);){
                    line = line.slice(0, esc.index) + esc[1] + line.slice(esc.index + esc[0].length);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = positions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var pos1 = _step2.value;
                            if (pos1.line == lines.length && pos1.from > esc.index) {
                                pos1.from--;
                                pos1.to--;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                lines.push(line);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new Snippet(lines, positions);
    }
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
}
var fieldMarker = /*@__PURE__*/ (0, _view.Decoration).widget({
    widget: /*@__PURE__*/ new class extends (0, _view.WidgetType) {
        toDOM() {
            var span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
var fieldRange = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-snippetField"
});
class ActiveSnippet {
    map(changes) {
        var ranges = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                var mapped = r.map(changes);
                if (!mapped) return null;
                ranges.push(mapped);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, _view.Decoration).set(ranges.map((r)=>(r.from == r.to ? fieldMarker : fieldRange).range(r.from, r.to)));
    }
}
var setActive = /*@__PURE__*/ (0, _state.StateEffect).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
var moveToField = /*@__PURE__*/ (0, _state.StateEffect).define();
var snippetState = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return null;
    },
    update (value, tr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(setActive)) return effect.value;
                if (effect.is(moveToField) && value) return new ActiveSnippet(value.ranges, effect.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, _view.EditorView).decorations.from(f, (val)=>val ? val.deco : (0, _view.Decoration).none)
});
function fieldSelection(ranges, field) {
    return (0, _state.EditorSelection).create(ranges.filter((r)=>r.field == field).map((r)=>(0, _state.EditorSelection).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function snippet(template) {
    var snippet = Snippet.parse(template);
    return (editor, completion, from, to)=>{
        var _snippet_instantiate = snippet.instantiate(editor.state, from), text = _snippet_instantiate.text, ranges = _snippet_instantiate.ranges;
        var spec = {
            changes: {
                from,
                to,
                insert: (0, _state.Text).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                pickedCompletion.of(completion),
                (0, _state.Transaction).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            var active = new ActiveSnippet(ranges, 0);
            var effects = spec.effects = [
                setActive.of(active)
            ];
            if (editor.state.field(snippetState, false) === undefined) effects.push((0, _state.StateEffect).appendConfig.of([
                snippetState,
                addSnippetKeymap,
                snippetPointerHandler,
                baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function moveField(dir) {
    return (param)=>{
        var state = param.state, dispatch = param.dispatch;
        var active = state.field(snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        var next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: fieldSelection(active.ranges, next),
            effects: setActive.of(last ? null : new ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ var clearSnippet = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    var active = state.field(snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ var nextSnippetField = /*@__PURE__*/ moveField(1);
/**
Move to the previous snippet field, if available.
*/ var prevSnippetField = /*@__PURE__*/ moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function hasNextSnippetField(state) {
    var active = state.field(snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function hasPrevSnippetField(state) {
    var active = state.field(snippetState, false);
    return !!(active && active.active > 0);
}
var defaultSnippetKeymap = [
    {
        key: "Tab",
        run: nextSnippetField,
        shift: prevSnippetField
    },
    {
        key: "Escape",
        run: clearSnippet
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ var snippetKeymap = /*@__PURE__*/ (0, _state.Facet).define({
    combine (maps) {
        return maps.length ? maps[0] : defaultSnippetKeymap;
    }
});
var addSnippetKeymap = /*@__PURE__*/ (0, _state.Prec).highest(/*@__PURE__*/ (0, _view.keymap).compute([
    snippetKeymap
], (state)=>state.facet(snippetKeymap)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function snippetCompletion(template, completion) {
    return Object.assign(Object.assign({}, completion), {
        apply: snippet(template)
    });
}
var snippetPointerHandler = /*@__PURE__*/ (0, _view.EditorView).domEventHandlers({
    mousedown (event, view) {
        var active = view.state.field(snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        var match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: fieldSelection(active.ranges, match.field),
            effects: setActive.of(active.ranges.some((r)=>r.field > match.field) ? new ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function wordRE(wordChars) {
    var escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
var wordCaches = /*@__PURE__*/ Object.create(null);
function wordCache(wordChars) {
    return wordCaches[wordChars] || (wordCaches[wordChars] = new WeakMap);
}
function storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(var lines = doc.iterLines(), pos = 0; !lines.next().done;){
        var value = lines.value, m = void 0;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function collectWords(doc, cache, wordRE, to, ignoreAt) {
    var big = doc.length >= 1000 /* C.MinCacheLen */ ;
    var cached = big && cache.get(doc);
    if (cached) return cached;
    var result = [], seen = Object.create(null);
    if (doc.children) {
        var pos = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = doc.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ch = _step.value;
                if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var c = _step1.value;
                            if (!seen[c.label]) {
                                seen[c.label] = true;
                                result.push(c);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else storeWords(ch, wordRE, result, seen, ignoreAt - pos);
                pos += ch.length + 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ var completeAnyWord = (context)=>{
    var wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    var re = wordRE(wordChars);
    var token = context.matchBefore(mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    var from = token ? token.from : context.pos;
    var options = collectWords(context.state.doc, wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from,
        options,
        validFor: mapRE(re, (s)=>"^" + s)
    };
};
var defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
var closeBracketEffect = /*@__PURE__*/ (0, _state.StateEffect).define({
    map (value, mapping) {
        var mapped = mapping.mapPos(value, -1, (0, _state.MapMode).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
var closedBracket = /*@__PURE__*/ new class extends (0, _state.RangeValue) {
};
closedBracket.startSide = 1;
closedBracket.endSide = -1;
var bracketState = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return (0, _state.RangeSet).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            var line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(closeBracketEffect)) value = value.update({
                    add: [
                        closedBracket.range(effect.value, effect.value + 1)
                    ]
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function closeBrackets() {
    return [
        inputHandler,
        bracketState
    ];
}
var definedClosing = "()[]{}<>";
function closing(ch) {
    for(var i = 0; i < definedClosing.length; i += 2)if (definedClosing.charCodeAt(i) == ch) return definedClosing.charAt(i + 1);
    return (0, _state.fromCodePoint)(ch < 128 ? ch : ch + 1);
}
function config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || defaults;
}
var android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
var inputHandler = /*@__PURE__*/ (0, _view.EditorView).inputHandler.of((view, from, to, insert)=>{
    if ((android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    var sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, _state.codePointSize)((0, _state.codePointAt)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    var tr = insertBracket(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ var deleteBracketPair = (param)=>{
    var state = param.state, dispatch = param.dispatch;
    if (state.readOnly) return false;
    var conf = config(state, state.selection.main.head);
    var tokens = conf.brackets || defaults.brackets;
    var dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            var before = prevChar(state.doc, range.head);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var token = _step.value;
                    if (token == before && nextChar(state.doc, range.head) == closing((0, _state.codePointAt)(token, 0))) return {
                        changes: {
                            from: range.head - token.length,
                            to: range.head + token.length
                        },
                        range: (0, _state.EditorSelection).cursor(range.head - token.length)
                    };
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ var closeBracketsKeymap = [
    {
        key: "Backspace",
        run: deleteBracketPair
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function insertBracket(state, bracket) {
    var conf = config(state, state.selection.main.head);
    var tokens = conf.brackets || defaults.brackets;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tok = _step.value;
            var closed = closing((0, _state.codePointAt)(tok, 0));
            if (bracket == tok) return closed == tok ? handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : handleOpen(state, tok, closed, conf.before || defaults.before);
            if (bracket == closed && closedBracketAt(state, state.selection.main.from)) return handleClose(state, tok, closed);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function closedBracketAt(state, pos) {
    var found = false;
    state.field(bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function nextChar(doc, pos) {
    var next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, _state.codePointSize)((0, _state.codePointAt)(next, 0)));
}
function prevChar(doc, pos) {
    var prev = doc.sliceString(pos - 2, pos);
    return (0, _state.codePointSize)((0, _state.codePointAt)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function handleOpen(state, open, close, closeBefore) {
    var dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: closeBracketEffect.of(range.to + open.length),
            range: (0, _state.EditorSelection).range(range.anchor + open.length, range.head + open.length)
        };
        var next = nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: closeBracketEffect.of(range.head + open.length),
            range: (0, _state.EditorSelection).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function handleClose(state, _open, close) {
    var dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, _state.EditorSelection).cursor(range.head + close.length)
        };
        return dont = {
            range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function handleSame(state, token, allowTriple, config) {
    var stringPrefixes = config.stringPrefixes || defaults.stringPrefixes;
    var dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: closeBracketEffect.of(range.to + token.length),
            range: (0, _state.EditorSelection).range(range.anchor + token.length, range.head + token.length)
        };
        var pos = range.head, next = nextChar(state.doc, pos), start;
        if (next == token) {
            if (nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: closeBracketEffect.of(pos + token.length),
                range: (0, _state.EditorSelection).cursor(pos + token.length)
            };
            else if (closedBracketAt(state, pos)) {
                var isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                var content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, _state.EditorSelection).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: closeBracketEffect.of(pos + token.length),
            range: (0, _state.EditorSelection).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, _state.CharCategory).Word) {
            if (canStartStringAt(state, pos, stringPrefixes) > -1 && !probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: closeBracketEffect.of(pos + token.length),
                range: (0, _state.EditorSelection).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function nodeStart(state, pos) {
    var tree = (0, _language.syntaxTree)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function probablyInString(state, pos, quoteToken, prefixes) {
    var node = (0, _language.syntaxTree)(state).resolveInner(pos, -1);
    var maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(var i = 0; i < 5; i++){
        var start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        var quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            var first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        var parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function canStartStringAt(state, pos, prefixes) {
    var charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, _state.CharCategory).Word) return pos;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prefix = _step.value;
            var start = pos - prefix.length;
            if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, _state.CharCategory).Word) return start;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function autocompletion() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        commitCharacters,
        completionState,
        completionConfig.of(config),
        completionPlugin,
        completionKeymapExt,
        baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space: [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ var completionKeymap = [
    {
        key: "Ctrl-Space",
        run: startCompletion
    },
    {
        key: "Escape",
        run: closeCompletion
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ moveCompletionSelection(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ moveCompletionSelection(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ moveCompletionSelection(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ moveCompletionSelection(false, "page")
    },
    {
        key: "Enter",
        run: acceptCompletion
    }
];
var completionKeymapExt = /*@__PURE__*/ (0, _state.Prec).highest(/*@__PURE__*/ (0, _view.keymap).computeN([
    completionConfig
], (state)=>state.facet(completionConfig).defaultKeymap ? [
        completionKeymap
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function completionStatus(state) {
    var cState = state.field(completionState, false);
    return cState && cState.active.some((a)=>a.state == 1 /* State.Pending */ ) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
var completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function currentCompletions(state) {
    var _a;
    var open = (_a = state.field(completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    var completions = completionArrayCache.get(open.options);
    if (!completions) completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function selectedCompletion(state) {
    var _a;
    var open = (_a = state.field(completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function selectedCompletionIndex(state) {
    var _a;
    var open = (_a = state.field(completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function setSelectedCompletion(index) {
    return setSelectedEffect.of(index);
}

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@codemirror/state":"fECfb","@codemirror/view":"l3day","@codemirror/language":"jct2S","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8JYEE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeLintPanel", ()=>closeLintPanel);
parcelHelpers.export(exports, "diagnosticCount", ()=>diagnosticCount);
parcelHelpers.export(exports, "forEachDiagnostic", ()=>forEachDiagnostic);
parcelHelpers.export(exports, "forceLinting", ()=>forceLinting);
parcelHelpers.export(exports, "lintGutter", ()=>lintGutter);
parcelHelpers.export(exports, "lintKeymap", ()=>lintKeymap);
parcelHelpers.export(exports, "linter", ()=>linter);
parcelHelpers.export(exports, "nextDiagnostic", ()=>nextDiagnostic);
parcelHelpers.export(exports, "openLintPanel", ()=>openLintPanel);
parcelHelpers.export(exports, "previousDiagnostic", ()=>previousDiagnostic);
parcelHelpers.export(exports, "setDiagnostics", ()=>setDiagnostics);
parcelHelpers.export(exports, "setDiagnosticsEffect", ()=>setDiagnosticsEffect);
var _view = require("@codemirror/view");
var _state = require("@codemirror/state");
var _crelt = require("crelt");
var _creltDefault = parcelHelpers.interopDefault(_crelt);
class SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class LintState {
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        var markedDiagnostics = diagnostics;
        var diagnosticFilter = state.facet(lintConfig).markerFilter;
        if (diagnosticFilter) markedDiagnostics = diagnosticFilter(markedDiagnostics, state);
        var ranges = (0, _view.Decoration).set(markedDiagnostics.map((d)=>{
            // For zero-length ranges or ranges covering only a line break, create a widget
            return d.from == d.to || d.from == d.to - 1 && state.doc.lineAt(d.from).to == d.from ? (0, _view.Decoration).widget({
                widget: new DiagnosticWidget(d),
                diagnostic: d
            }).range(d.from) : (0, _view.Decoration).mark({
                attributes: {
                    class: "cm-lintRange cm-lintRange-" + d.severity + (d.markClass ? " " + d.markClass : "")
                },
                diagnostic: d,
                inclusive: true
            }).range(d.from, d.to);
        }), true);
        return new LintState(ranges, panel, findDiagnostic(ranges));
    }
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
}
function findDiagnostic(diagnostics) {
    var diagnostic = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, after = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var found = null;
    diagnostics.between(after, 1e9, (from, to, param)=>{
        var spec = param.spec;
        if (diagnostic && spec.diagnostic != diagnostic) return;
        found = new SelectedDiagnostic(from, to, spec.diagnostic);
        return false;
    });
    return found;
}
function hideTooltip(tr, tooltip) {
    var line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is(setDiagnosticsEffect)) || tr.changes.touchesRange(line.from, line.to));
}
function maybeEnableLint(state, effects) {
    return state.field(lintState, false) ? effects : effects.concat((0, _state.StateEffect).appendConfig.of(lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function setDiagnostics(state, diagnostics) {
    return {
        effects: maybeEnableLint(state, [
            setDiagnosticsEffect.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ var setDiagnosticsEffect = /*@__PURE__*/ (0, _state.StateEffect).define();
var togglePanel = /*@__PURE__*/ (0, _state.StateEffect).define();
var movePanelSelection = /*@__PURE__*/ (0, _state.StateEffect).define();
var lintState = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return new LintState((0, _view.Decoration).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged) {
            var mapped = value.diagnostics.map(tr.changes), selected = null;
            if (value.selected) {
                var selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = findDiagnostic(mapped, value.selected.diagnostic, selPos) || findDiagnostic(mapped, null, selPos);
            }
            value = new LintState(mapped, value.panel, selected);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(setDiagnosticsEffect)) value = LintState.init(effect.value, value.panel, tr.state);
                else if (effect.is(togglePanel)) value = new LintState(value.diagnostics, effect.value ? LintPanel.open : null, value.selected);
                else if (effect.is(movePanelSelection)) value = new LintState(value.diagnostics, value.panel, effect.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return value;
    },
    provide: (f)=>[
            (0, _view.showPanel).from(f, (val)=>val.panel),
            (0, _view.EditorView).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function diagnosticCount(state) {
    var lint = state.field(lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
var activeMark = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-lintRange cm-lintRange-active",
    inclusive: true
});
function lintTooltip(view, pos, side) {
    var diagnostics = view.state.field(lintState).diagnostics;
    var found = [], stackStart = 2e8, stackEnd = 0;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, param)=>{
        var spec = param.spec;
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found.push(spec.diagnostic);
            stackStart = Math.min(from, stackStart);
            stackEnd = Math.max(to, stackEnd);
        }
    });
    var diagnosticFilter = view.state.facet(lintConfig).tooltipFilter;
    if (diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found.length) return null;
    return {
        pos: stackStart,
        end: stackEnd,
        above: view.state.doc.lineAt(stackStart).to < stackEnd,
        create () {
            return {
                dom: diagnosticsTooltip(view, found)
            };
        }
    };
}
function diagnosticsTooltip(view, diagnostics) {
    return (0, _creltDefault.default)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ var openLintPanel = (view)=>{
    var field = view.state.field(lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: maybeEnableLint(view.state, [
            togglePanel.of(true)
        ])
    });
    var panel = (0, _view.getPanel)(view, LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ var closeLintPanel = (view)=>{
    var field = view.state.field(lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ var nextDiagnostic = (view)=>{
    var field = view.state.field(lintState, false);
    if (!field) return false;
    var sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
    if (!next.value) {
        next = field.diagnostics.iter(0);
        if (!next.value || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ var previousDiagnostic = (view)=>{
    var state = view.state, field = state.field(lintState, false);
    if (!field) return false;
    var sel = state.selection.main;
    var prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    view.dispatch({
        selection: {
            anchor: prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom,
            head: prevTo !== null && prevTo !== void 0 ? prevTo : lastTo
        },
        scrollIntoView: true
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ var lintKeymap = [
    {
        key: "Mod-Shift-m",
        run: openLintPanel,
        preventDefault: true
    },
    {
        key: "F8",
        run: nextDiagnostic
    }
];
var lintPlugin = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class {
    run() {
        var now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            var state = this.view.state, sources = state.facet(lintConfig).sources;
            if (sources.length) Promise.all(sources.map((source)=>Promise.resolve(source(this.view)))).then((annotations)=>{
                var all = annotations.reduce((a, b)=>a.concat(b));
                if (this.view.state.doc == state.doc) this.view.dispatch(setDiagnostics(this.view.state, all));
            }, (error)=>{
                (0, _view.logException)(this.view.state, error);
            });
        }
    }
    update(update) {
        var config = update.state.facet(lintConfig);
        if (update.docChanged || config != update.startState.facet(lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        var delay = view.state.facet(lintConfig).delay;
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
});
var lintConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (input) {
        return Object.assign({
            sources: input.map((i)=>i.source).filter((x)=>x != null)
        }, (0, _state.combineConfig)(input.map((i)=>i.config), {
            delay: 750,
            markerFilter: null,
            tooltipFilter: null,
            needsRefresh: null
        }, {
            needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u)
        }));
    }
});
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed). If `null` is given as
source, this only configures the lint extension.
*/ function linter(source) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return [
        lintConfig.of({
            source,
            config
        }),
        lintPlugin,
        lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function forceLinting(view) {
    var plugin = view.plugin(lintPlugin);
    if (plugin) plugin.force();
}
function assignKeys(actions) {
    var assigned = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (actions) try {
        var _loop = function() {
            var _loop = function(i) {
                var ch = name[i];
                if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                    assigned.push(ch);
                    return "continue|actions";
                }
            };
            var name = _step.value.name;
            for(var i = 0; i < name.length; i++){
                var _ret = _loop(i);
                switch(_ret){
                    case "continue|actions":
                        return "continue|actions";
                }
            }
            assigned.push("");
        };
        actions: for(var _iterator = actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            switch(_ret){
                case "continue|actions":
                    continue actions;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return assigned;
}
function renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    var keys = inPanel ? assignKeys(diagnostic.actions) : [];
    return (0, _creltDefault.default)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, _creltDefault.default)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage() : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        var fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            var found = findDiagnostic(view.state.field(lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        var name = action.name, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        var nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, _creltDefault.default)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        return (0, _creltDefault.default)("button", {
            type: "button",
            class: "cm-diagnosticAction",
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, _creltDefault.default)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class DiagnosticWidget extends (0, _view.WidgetType) {
    eq(other) {
        return other.diagnostic == this.diagnostic;
    }
    toDOM() {
        return (0, _creltDefault.default)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity
        });
    }
    constructor(diagnostic){
        super();
        this.diagnostic = diagnostic;
    }
}
class PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class LintPanel {
    get selectedIndex() {
        var selected = this.view.state.field(lintState).selected;
        if (!selected) return -1;
        for(var i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        var _this_view_state_field = this.view.state.field(lintState), diagnostics = _this_view_state_field.diagnostics, selected = _this_view_state_field.selected;
        var i = 0, needsSync = false, newSelectedItem = null;
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, param)=>{
            var spec = param.spec;
            var found = -1, item;
            for(var j = i; j < this.items.length; j++)if (this.items[j].diagnostic == spec.diagnostic) {
                found = j;
                break;
            }
            if (found < 0) {
                item = new PanelItem(this.view, spec.diagnostic);
                this.items.splice(i, 0, item);
                needsSync = true;
            } else {
                item = this.items[found];
                if (found > i) {
                    this.items.splice(i, found - i);
                    needsSync = true;
                }
            }
            if (selected && item.diagnostic == selected.diagnostic) {
                if (!item.dom.hasAttribute("aria-selected")) {
                    item.dom.setAttribute("aria-selected", "true");
                    newSelectedItem = item;
                }
            } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
            i++;
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: (param)=>{
                    var sel = param.sel, panel = param.panel;
                    var scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        var domPos = this.list.firstChild;
        function rm() {
            var prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.dom.parentNode == this.list) {
                    while(domPos != item.dom)rm();
                    domPos = item.dom.nextSibling;
                } else this.list.insertBefore(item.dom, domPos);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        var field = this.view.state.field(lintState);
        var selection = findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new LintPanel(view);
    }
    constructor(view){
        this.view = view;
        this.items = [];
        var onkeydown = (event)=>{
            if (event.keyCode == 27) {
                closeLintPanel(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                var diagnostic = this.items[this.selectedIndex].diagnostic, keys = assignKeys(diagnostic.actions);
                for(var i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    var found = findDiagnostic(this.view.state.field(lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        var onclick = (event)=>{
            for(var i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, _creltDefault.default)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown,
            onclick
        });
        this.dom = (0, _creltDefault.default)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, _creltDefault.default)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>closeLintPanel(this.view)
        }, "\xd7"));
        this.update();
    }
}
function svg(content) {
    var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `viewBox="0 0 40 40"`;
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function underline(color) {
    return svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
var baseTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ underline("#d11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    }
});
function severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
class LintGutterMarker extends (0, _view.GutterMarker) {
    toDOM(view) {
        var elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        var diagnostics = this.diagnostics;
        var diagnosticsFilter = view.state.facet(lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = diagnostics.reduce((max, d)=>severityWeight(max) < severityWeight(d.severity) ? d.severity : max, "hint");
    }
}
function trackHoverOn(view, marker) {
    var mousemove = (event)=>{
        var rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(var target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field(lintGutterTooltip)) view.dispatch({
            effects: setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        var line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        var linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                create () {
                    return {
                        dom: diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        trackHoverOn(view, marker);
    }
    var hoverTime = view.state.facet(lintGutterConfig).hoverTime;
    var hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function markersForDiagnostics(doc, diagnostics) {
    var byLine = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = diagnostics[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var diagnostic = _step.value;
            var line = doc.lineAt(diagnostic.from);
            (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var markers = [];
    for(var line1 in byLine)markers.push(new LintGutterMarker(byLine[line1]).range(+line1));
    return (0, _state.RangeSet).of(markers, true);
}
var lintGutterExtension = /*@__PURE__*/ (0, _view.gutter)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field(lintGutterMarkers)
});
var lintGutterMarkers = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return (0, _state.RangeSet).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        var diagnosticFilter = tr.state.facet(lintGutterConfig).markerFilter;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var effect = _step.value;
                if (effect.is(setDiagnosticsEffect)) {
                    var diagnostics = effect.value;
                    if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
                    markers = markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return markers;
    }
});
var setLintGutterTooltip = /*@__PURE__*/ (0, _state.StateEffect).define();
var lintGutterTooltip = /*@__PURE__*/ (0, _state.StateField).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = hideTooltip(tr, tooltip) ? null : Object.assign(Object.assign({}, tooltip), {
            pos: tr.changes.mapPos(tooltip.pos)
        });
        return tr.effects.reduce((t, e)=>e.is(setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, _view.showTooltip).from(field)
});
var lintGutterTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
var lintExtensions = [
    lintState,
    /*@__PURE__*/ (0, _view.EditorView).decorations.compute([
        lintState
    ], (state)=>{
        var _state_field = state.field(lintState), selected = _state_field.selected, panel = _state_field.panel;
        return !selected || !panel || selected.from == selected.to ? (0, _view.Decoration).none : (0, _view.Decoration).set([
            activeMark.range(selected.from, selected.to)
        ]);
    }),
    /*@__PURE__*/ (0, _view.hoverTooltip)(lintTooltip, {
        hideOn: hideTooltip
    }),
    baseTheme
];
var lintGutterConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine (configs) {
        return (0, _state.combineConfig)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function lintGutter() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        lintGutterConfig.of(config),
        lintGutterMarkers,
        lintGutterExtension,
        lintGutterTheme,
        lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function forEachDiagnostic(state, f) {
    var lState = state.field(lintState, false);
    if (lState && lState.diagnostics.size) for(var iter = (0, _state.RangeSet).iter([
        lState.diagnostics
    ]); iter.value; iter.next())f(iter.value.spec.diagnostic, iter.from, iter.to);
}

},{"@codemirror/view":"l3day","@codemirror/state":"fECfb","crelt":"4YF2f","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"0dLBb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoCloseTags", ()=>autoCloseTags);
parcelHelpers.export(exports, "completionPath", ()=>completionPath);
parcelHelpers.export(exports, "esLint", ()=>esLint);
parcelHelpers.export(exports, "javascript", ()=>javascript);
parcelHelpers.export(exports, "javascriptLanguage", ()=>javascriptLanguage);
parcelHelpers.export(exports, "jsxLanguage", ()=>jsxLanguage);
parcelHelpers.export(exports, "localCompletionSource", ()=>localCompletionSource);
parcelHelpers.export(exports, "scopeCompletionSource", ()=>scopeCompletionSource);
parcelHelpers.export(exports, "snippets", ()=>snippets);
parcelHelpers.export(exports, "tsxLanguage", ()=>tsxLanguage);
parcelHelpers.export(exports, "typescriptLanguage", ()=>typescriptLanguage);
parcelHelpers.export(exports, "typescriptSnippets", ()=>typescriptSnippets);
var _javascript = require("@lezer/javascript");
var _language = require("@codemirror/language");
var _state = require("@codemirror/state");
var _view = require("@codemirror/view");
var _autocomplete = require("@codemirror/autocomplete");
var _common = require("@lezer/common");
/**
A collection of JavaScript-related
[snippets](https://codemirror.net/6/docs/ref/#autocomplete.snippet).
*/ var snippets = [
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("function ${name}(${params}) {\n	${}\n}", {
        label: "function",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("for (let ${name} of ${collection}) {\n	${}\n}", {
        label: "for",
        detail: "of loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("do {\n	${}\n} while (${})", {
        label: "do",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("while (${}) {\n	${}\n}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("try {\n	${}\n} catch (${error}) {\n	${}\n}", {
        label: "try",
        detail: "/ catch block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("if (${}) {\n	${}\n}", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("if (${}) {\n	${}\n} else {\n	${}\n}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("class ${name} {\n	constructor(${params}) {\n		${}\n	}\n}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)('import {${names}} from "${module}"\n${}', {
        label: "import",
        detail: "named",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)('import ${name} from "${module}"\n${}', {
        label: "import",
        detail: "default",
        type: "keyword"
    })
];
/**
A collection of snippet completions for TypeScript. Includes the
JavaScript [snippets](https://codemirror.net/6/docs/ref/#lang-javascript.snippets).
*/ var typescriptSnippets = /*@__PURE__*/ snippets.concat([
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("interface ${name} {\n	${}\n}", {
        label: "interface",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("type ${name} = ${type}", {
        label: "type",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, _autocomplete.snippetCompletion)("enum ${name} {\n	${}\n}", {
        label: "enum",
        detail: "definition",
        type: "keyword"
    })
]);
var cache = /*@__PURE__*/ new (0, _common.NodeWeakMap)();
var ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Block",
    "FunctionExpression",
    "FunctionDeclaration",
    "ArrowFunction",
    "MethodDeclaration",
    "ForStatement"
]);
function defID(type) {
    return (node, def)=>{
        var id = node.node.getChild("VariableDefinition");
        if (id) def(id, type);
        return true;
    };
}
var functionContext = [
    "FunctionDeclaration"
];
var gatherCompletions = {
    FunctionDeclaration: /*@__PURE__*/ defID("function"),
    ClassDeclaration: /*@__PURE__*/ defID("class"),
    ClassExpression: ()=>true,
    EnumDeclaration: /*@__PURE__*/ defID("constant"),
    TypeAliasDeclaration: /*@__PURE__*/ defID("type"),
    NamespaceDeclaration: /*@__PURE__*/ defID("namespace"),
    VariableDefinition (node, def) {
        if (!node.matchContext(functionContext)) def(node, "variable");
    },
    TypeDefinition (node, def) {
        def(node, "type");
    },
    __proto__: null
};
function getScope(doc, node) {
    var cached = cache.get(node);
    if (cached) return cached;
    var completions = [], top = true;
    function def(node, type) {
        var name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type
        });
    }
    node.cursor((0, _common.IterMode).IncludeAnonymous).iterate((node)=>{
        if (top) top = false;
        else if (node.name) {
            var gather = gatherCompletions[node.name];
            if (gather && gather(node, def) || ScopeNodes.has(node.name)) return false;
        } else if (node.to - node.from > 8192) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Allow caching for bigger internal nodes
                for(var _iterator = getScope(doc, node.node)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    completions.push(c);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return false;
        }
    });
    cache.set(node, completions);
    return completions;
}
var Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
var dontComplete = [
    "TemplateString",
    "String",
    "RegExp",
    "LineComment",
    "BlockComment",
    "VariableDefinition",
    "TypeDefinition",
    "Label",
    "PropertyDefinition",
    "PropertyName",
    "PrivatePropertyDefinition",
    "PrivatePropertyName",
    ".",
    "?."
];
/**
Completion source that looks up locally defined names in
JavaScript code.
*/ function localCompletionSource(context) {
    var inner = (0, _language.syntaxTree)(context.state).resolveInner(context.pos, -1);
    if (dontComplete.indexOf(inner.name) > -1) return null;
    var isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    var options = [];
    for(var pos = inner; pos; pos = pos.parent)if (ScopeNodes.has(pos.name)) options = options.concat(getScope(context.state.doc, pos));
    return {
        options,
        from: isWord ? inner.from : context.pos,
        validFor: Identifier
    };
}
function pathFor(read, member, name) {
    var _a;
    var path = [];
    for(;;){
        var obj = member.firstChild, prop = void 0;
        if ((obj === null || obj === void 0 ? void 0 : obj.name) == "VariableName") {
            path.push(read(obj));
            return {
                path: path.reverse(),
                name
            };
        } else if ((obj === null || obj === void 0 ? void 0 : obj.name) == "MemberExpression" && ((_a = prop = obj.lastChild) === null || _a === void 0 ? void 0 : _a.name) == "PropertyName") {
            path.push(read(prop));
            member = obj;
        } else return null;
    }
}
/**
Helper function for defining JavaScript completion sources. It
returns the completable name and object path for a completion
context, or null if no name/property completion should happen at
that position. For example, when completing after `a.b.c` it will
return `{path: ["a", "b"], name: "c"}`. When completing after `x`
it will return `{path: [], name: "x"}`. When not in a property or
name, it will return null if `context.explicit` is false, and
`{path: [], name: ""}` otherwise.
*/ function completionPath(context) {
    var read = (node)=>context.state.doc.sliceString(node.from, node.to);
    var inner = (0, _language.syntaxTree)(context.state).resolveInner(context.pos, -1);
    if (inner.name == "PropertyName") return pathFor(read, inner.parent, read(inner));
    else if ((inner.name == "." || inner.name == "?.") && inner.parent.name == "MemberExpression") return pathFor(read, inner.parent, "");
    else if (dontComplete.indexOf(inner.name) > -1) return null;
    else if (inner.name == "VariableName" || inner.to - inner.from < 20 && Identifier.test(read(inner))) return {
        path: [],
        name: read(inner)
    };
    else if (inner.name == "MemberExpression") return pathFor(read, inner, "");
    else return context.explicit ? {
        path: [],
        name: ""
    } : null;
}
function enumeratePropertyCompletions(obj, top) {
    var options = [], seen = new Set;
    for(var depth = 0;; depth++){
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (Object.getOwnPropertyNames || Object.keys)(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(name) || seen.has(name)) continue;
                seen.add(name);
                var value = void 0;
                try {
                    value = obj[name];
                } catch (_) {
                    continue;
                }
                options.push({
                    label: name,
                    type: typeof value == "function" ? /^[A-Z]/.test(name) ? "class" : top ? "function" : "method" : top ? "variable" : "property",
                    boost: -depth
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var next = Object.getPrototypeOf(obj);
        if (!next) return options;
        obj = next;
    }
}
/**
Defines a [completion source](https://codemirror.net/6/docs/ref/#autocomplete.CompletionSource) that
completes from the given scope object (for example `globalThis`).
Will enter properties of the object when completing properties on
a directly-named path.
*/ function scopeCompletionSource(scope) {
    var cache = new Map;
    return (context)=>{
        var path = completionPath(context);
        if (!path) return null;
        var target = scope;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = path.path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var step = _step.value;
                target = target[step];
                if (!target) return null;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var options = cache.get(target);
        if (!options) cache.set(target, options = enumeratePropertyCompletions(target, !path.path.length));
        return {
            from: context.pos - path.name.length,
            options,
            validFor: Identifier
        };
    };
}
/**
A language provider based on the [Lezer JavaScript
parser](https://github.com/lezer-parser/javascript), extended with
highlighting and indentation information.
*/ var javascriptLanguage = /*@__PURE__*/ (0, _language.LRLanguage).define({
    name: "javascript",
    parser: /*@__PURE__*/ (0, _javascript.parser).configure({
        props: [
            /*@__PURE__*/ (0, _language.indentNodeProp).add({
                IfStatement: /*@__PURE__*/ (0, _language.continuedIndent)({
                    except: /^\s*({|else\b)/
                }),
                TryStatement: /*@__PURE__*/ (0, _language.continuedIndent)({
                    except: /^\s*({|catch\b|finally\b)/
                }),
                LabeledStatement: (0, _language.flatIndent),
                SwitchBody: (context)=>{
                    var after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
                    return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
                },
                Block: /*@__PURE__*/ (0, _language.delimitedIndent)({
                    closing: "}"
                }),
                ArrowFunction: (cx)=>cx.baseIndent + cx.unit,
                "TemplateString BlockComment": ()=>null,
                "Statement Property": /*@__PURE__*/ (0, _language.continuedIndent)({
                    except: /^{/
                }),
                JSXElement (context) {
                    var closed = /^\s*<\//.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                JSXEscape (context) {
                    var closed = /\s*\}/.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                "JSXOpenTag JSXSelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                }
            }),
            /*@__PURE__*/ (0, _language.foldNodeProp).add({
                "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": (0, _language.foldInside),
                BlockComment (tree) {
                    return {
                        from: tree.from + 2,
                        to: tree.to - 2
                    };
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "`"
            ]
        },
        commentTokens: {
            line: "//",
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
        wordChars: "$"
    }
});
var jsxSublanguage = {
    test: (node)=>/^JSX/.test(node.name),
    facet: /*@__PURE__*/ (0, _language.defineLanguageFacet)({
        commentTokens: {
            block: {
                open: "{/*",
                close: "*/}"
            }
        }
    })
};
/**
A language provider for TypeScript.
*/ var typescriptLanguage = /*@__PURE__*/ javascriptLanguage.configure({
    dialect: "ts"
}, "typescript");
/**
Language provider for JSX.
*/ var jsxLanguage = /*@__PURE__*/ javascriptLanguage.configure({
    dialect: "jsx",
    props: [
        /*@__PURE__*/ (0, _language.sublanguageProp).add((n)=>n.isTop ? [
                jsxSublanguage
            ] : undefined)
    ]
});
/**
Language provider for JSX + TypeScript.
*/ var tsxLanguage = /*@__PURE__*/ javascriptLanguage.configure({
    dialect: "jsx ts",
    props: [
        /*@__PURE__*/ (0, _language.sublanguageProp).add((n)=>n.isTop ? [
                jsxSublanguage
            ] : undefined)
    ]
}, "typescript");
var kwCompletion = (name)=>({
        label: name,
        type: "keyword"
    });
var keywords = /*@__PURE__*/ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(kwCompletion);
var typescriptKeywords = /*@__PURE__*/ keywords.concat(/*@__PURE__*/ [
    "declare",
    "implements",
    "private",
    "protected",
    "public"
].map(kwCompletion));
/**
JavaScript support. Includes [snippet](https://codemirror.net/6/docs/ref/#lang-javascript.snippets)
and local variable completion.
*/ function javascript() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var lang = config.jsx ? config.typescript ? tsxLanguage : jsxLanguage : config.typescript ? typescriptLanguage : javascriptLanguage;
    var completions = config.typescript ? typescriptSnippets.concat(typescriptKeywords) : snippets.concat(keywords);
    return new (0, _language.LanguageSupport)(lang, [
        javascriptLanguage.data.of({
            autocomplete: (0, _autocomplete.ifNotIn)(dontComplete, (0, _autocomplete.completeFromList)(completions))
        }),
        javascriptLanguage.data.of({
            autocomplete: localCompletionSource
        }),
        config.jsx ? autoCloseTags : []
    ]);
}
function findOpenTag(node) {
    for(;;){
        if (node.name == "JSXOpenTag" || node.name == "JSXSelfClosingTag" || node.name == "JSXFragmentTag") return node;
        if (node.name == "JSXEscape" || !node.parent) return null;
        node = node.parent;
    }
}
function elementName(doc, tree) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : doc.length;
    for(var ch = tree === null || tree === void 0 ? void 0 : tree.firstChild; ch; ch = ch.nextSibling){
        if (ch.name == "JSXIdentifier" || ch.name == "JSXBuiltin" || ch.name == "JSXNamespacedName" || ch.name == "JSXMemberExpression") return doc.sliceString(ch.from, Math.min(ch.to, max));
    }
    return "";
}
var android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
/**
Extension that will automatically insert JSX close tags when a `>` or
`/` is typed.
*/ var autoCloseTags = /*@__PURE__*/ (0, _view.EditorView).inputHandler.of((view, from, to, text, defaultInsert)=>{
    if ((android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to || text != ">" && text != "/" || !javascriptLanguage.isActiveAt(view.state, from, -1)) return false;
    var base = defaultInsert(), state = base.state;
    var closeTags = state.changeByRange((range)=>{
        var _a;
        var head = range.head, around = (0, _language.syntaxTree)(state).resolveInner(head - 1, -1), name;
        if (around.name == "JSXStartTag") around = around.parent;
        if (state.doc.sliceString(head - 1, head) != text || around.name == "JSXAttributeValue" && around.to > head) ;
        else if (text == ">" && around.name == "JSXFragmentTag") return {
            range,
            changes: {
                from: head,
                insert: `</>`
            }
        };
        else if (text == "/" && around.name == "JSXStartCloseTag") {
            var empty = around.parent, base = empty.parent;
            if (base && empty.from == head - 2 && ((name = elementName(state.doc, base.firstChild, head)) || ((_a = base.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "JSXFragmentTag")) {
                var insert = `${name}>`;
                return {
                    range: (0, _state.EditorSelection).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        insert
                    }
                };
            }
        } else if (text == ">") {
            var openTag = findOpenTag(around);
            if (openTag && openTag.name == "JSXOpenTag" && !/^\/?>|^<\//.test(state.doc.sliceString(head, head + 2)) && (name = elementName(state.doc, openTag, head))) return {
                range,
                changes: {
                    from: head,
                    insert: `</${name}>`
                }
            };
        }
        return {
            range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});
/**
Connects an [ESLint](https://eslint.org/) linter to CodeMirror's
[lint](https://codemirror.net/6/docs/ref/#lint) integration. `eslint` should be an instance of the
[`Linter`](https://eslint.org/docs/developer-guide/nodejs-api#linter)
class, and `config` an optional ESLint configuration. The return
value of this function can be passed to [`linter`](https://codemirror.net/6/docs/ref/#lint.linter)
to create a JavaScript linting extension.

Note that ESLint targets node, and is tricky to run in the
browser. The
[eslint-linter-browserify](https://github.com/UziTech/eslint-linter-browserify)
package may help with that (see
[example](https://github.com/UziTech/eslint-linter-browserify/blob/master/example/script.js)).
*/ function esLint(eslint, config) {
    if (!config) {
        config = {
            parserOptions: {
                ecmaVersion: 2019,
                sourceType: "module"
            },
            env: {
                browser: true,
                node: true,
                es6: true,
                es2015: true,
                es2017: true,
                es2020: true
            },
            rules: {}
        };
        eslint.getRules().forEach((desc, name)=>{
            if (desc.meta.docs.recommended) config.rules[name] = 2;
        });
    }
    return (view)=>{
        var state = view.state, found = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = javascriptLanguage.findRegions(state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _step.value, from = _step_value.from, to = _step_value.to;
                var fromLine = state.doc.lineAt(from), offset = {
                    line: fromLine.number - 1,
                    col: from - fromLine.from,
                    pos: from
                };
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = eslint.verify(state.sliceDoc(from, to), config)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var d = _step1.value;
                        found.push(translateDiagnostic(d, state.doc, offset));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return found;
    };
}
function mapPos(line, col, doc, offset) {
    return doc.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function translateDiagnostic(input, doc, offset) {
    var start = mapPos(input.line, input.column, doc, offset);
    var result = {
        from: start,
        to: input.endLine != null && input.endColumn != 1 ? mapPos(input.endLine, input.endColumn, doc, offset) : start,
        message: input.message,
        source: input.ruleId ? "eslint:" + input.ruleId : "eslint",
        severity: input.severity == 1 ? "warning" : "error"
    };
    if (input.fix) {
        var _input_fix = input.fix, range = _input_fix.range, text = _input_fix.text, from = range[0] + offset.pos - start, to = range[1] + offset.pos - start;
        result.actions = [
            {
                name: "fix",
                apply (view, start) {
                    view.dispatch({
                        changes: {
                            from: start + from,
                            to: start + to,
                            insert: text
                        },
                        scrollIntoView: true
                    });
                }
            }
        ];
    }
    return result;
}

},{"@lezer/javascript":"2nkCo","@codemirror/language":"jct2S","@codemirror/state":"fECfb","@codemirror/view":"l3day","@codemirror/autocomplete":"2rxgM","@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2nkCo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", ()=>parser);
var _lr = require("@lezer/lr");
var _highlight = require("@lezer/highlight");
// This file was generated by lezer-generator. You probably shouldn't edit it.
var noSemi = 309, incdec = 1, incdecPrefix = 2, JSXStartTag = 3, insertSemi = 310, spaces = 312, newline = 313, LineComment = 4, BlockComment = 5, Dialect_jsx = 0;
/* Hand-written tokenizers for JavaScript tokens that can't be
   expressed by lezer's built-in tokenizer. */ var space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
var braceR = 125, semicolon = 59, slash = 47, star = 42, plus = 43, minus = 45, lt = 60, comma = 44;
var trackNewline = new (0, _lr.ContextTracker)({
    start: false,
    shift (context, term) {
        return term == LineComment || term == BlockComment || term == spaces ? context : term == newline;
    },
    strict: false
});
var insertSemicolon = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    var next = input.next;
    if (next == braceR || next == -1 || stack.context) input.acceptToken(insertSemi);
}, {
    contextual: true,
    fallback: true
});
var noSemicolon = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    var next = input.next, after;
    if (space.indexOf(next) > -1) return;
    if (next == slash && ((after = input.peek(1)) == slash || after == star)) return;
    if (next != braceR && next != semicolon && next != -1 && !stack.context) input.acceptToken(noSemi);
}, {
    contextual: true
});
var incdecToken = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    var next = input.next;
    if (next == plus || next == minus) {
        input.advance();
        if (next == input.next) {
            input.advance();
            var mayPostfix = !stack.context && stack.canShift(incdec);
            input.acceptToken(mayPostfix ? incdec : incdecPrefix);
        }
    }
}, {
    contextual: true
});
function identifierChar(ch, start) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch == 95 || ch >= 192 || !start && ch >= 48 && ch <= 57;
}
var jsx = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    if (input.next != lt || !stack.dialectEnabled(Dialect_jsx)) return;
    input.advance();
    if (input.next == slash) return;
    // Scan for an identifier followed by a comma or 'extends', don't
    // treat this as a start tag if present.
    var back = 0;
    while(space.indexOf(input.next) > -1){
        input.advance();
        back++;
    }
    if (identifierChar(input.next, true)) {
        input.advance();
        back++;
        while(identifierChar(input.next, false)){
            input.advance();
            back++;
        }
        while(space.indexOf(input.next) > -1){
            input.advance();
            back++;
        }
        if (input.next == comma) return;
        for(var i = 0;; i++){
            if (i == 7) {
                if (!identifierChar(input.next, true)) return;
                break;
            }
            if (input.next != "extends".charCodeAt(i)) break;
            input.advance();
            back++;
        }
    }
    input.acceptToken(JSXStartTag, -back);
});
var jsHighlight = (0, _highlight.styleTags)({
    "get set async static": (0, _highlight.tags).modifier,
    "for while do if else switch try catch finally return throw break continue default case": (0, _highlight.tags).controlKeyword,
    "in of await yield void typeof delete instanceof": (0, _highlight.tags).operatorKeyword,
    "let var const using function class extends": (0, _highlight.tags).definitionKeyword,
    "import export from": (0, _highlight.tags).moduleKeyword,
    "with debugger as new": (0, _highlight.tags).keyword,
    TemplateString: (0, _highlight.tags).special((0, _highlight.tags).string),
    super: (0, _highlight.tags).atom,
    BooleanLiteral: (0, _highlight.tags).bool,
    this: (0, _highlight.tags).self,
    null: (0, _highlight.tags).null,
    Star: (0, _highlight.tags).modifier,
    VariableName: (0, _highlight.tags).variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": (0, _highlight.tags).function((0, _highlight.tags).variableName),
    VariableDefinition: (0, _highlight.tags).definition((0, _highlight.tags).variableName),
    Label: (0, _highlight.tags).labelName,
    PropertyName: (0, _highlight.tags).propertyName,
    PrivatePropertyName: (0, _highlight.tags).special((0, _highlight.tags).propertyName),
    "CallExpression/MemberExpression/PropertyName": (0, _highlight.tags).function((0, _highlight.tags).propertyName),
    "FunctionDeclaration/VariableDefinition": (0, _highlight.tags).function((0, _highlight.tags).definition((0, _highlight.tags).variableName)),
    "ClassDeclaration/VariableDefinition": (0, _highlight.tags).definition((0, _highlight.tags).className),
    PropertyDefinition: (0, _highlight.tags).definition((0, _highlight.tags).propertyName),
    PrivatePropertyDefinition: (0, _highlight.tags).definition((0, _highlight.tags).special((0, _highlight.tags).propertyName)),
    UpdateOp: (0, _highlight.tags).updateOperator,
    "LineComment Hashbang": (0, _highlight.tags).lineComment,
    BlockComment: (0, _highlight.tags).blockComment,
    Number: (0, _highlight.tags).number,
    String: (0, _highlight.tags).string,
    Escape: (0, _highlight.tags).escape,
    ArithOp: (0, _highlight.tags).arithmeticOperator,
    LogicOp: (0, _highlight.tags).logicOperator,
    BitOp: (0, _highlight.tags).bitwiseOperator,
    CompareOp: (0, _highlight.tags).compareOperator,
    RegExp: (0, _highlight.tags).regexp,
    Equals: (0, _highlight.tags).definitionOperator,
    Arrow: (0, _highlight.tags).function((0, _highlight.tags).punctuation),
    ": Spread": (0, _highlight.tags).punctuation,
    "( )": (0, _highlight.tags).paren,
    "[ ]": (0, _highlight.tags).squareBracket,
    "{ }": (0, _highlight.tags).brace,
    "InterpolationStart InterpolationEnd": (0, _highlight.tags).special((0, _highlight.tags).brace),
    ".": (0, _highlight.tags).derefOperator,
    ", ;": (0, _highlight.tags).separator,
    "@": (0, _highlight.tags).meta,
    TypeName: (0, _highlight.tags).typeName,
    TypeDefinition: (0, _highlight.tags).definition((0, _highlight.tags).typeName),
    "type enum interface implements namespace module declare": (0, _highlight.tags).definitionKeyword,
    "abstract global Privacy readonly override": (0, _highlight.tags).modifier,
    "is keyof unique infer": (0, _highlight.tags).operatorKeyword,
    JSXAttributeValue: (0, _highlight.tags).attributeValue,
    JSXText: (0, _highlight.tags).content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": (0, _highlight.tags).angleBracket,
    "JSXIdentifier JSXNameSpacedName": (0, _highlight.tags).tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": (0, _highlight.tags).attributeName,
    "JSXBuiltin/JSXIdentifier": (0, _highlight.tags).standard((0, _highlight.tags).tagName)
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
var spec_identifier = {
    __proto__: null,
    export: 18,
    as: 23,
    from: 31,
    default: 34,
    async: 39,
    function: 40,
    extends: 52,
    this: 56,
    true: 64,
    false: 64,
    null: 76,
    void: 80,
    typeof: 84,
    super: 102,
    new: 136,
    delete: 152,
    yield: 161,
    await: 165,
    class: 170,
    public: 227,
    private: 227,
    protected: 227,
    readonly: 229,
    instanceof: 248,
    satisfies: 251,
    in: 252,
    const: 254,
    import: 286,
    keyof: 339,
    unique: 343,
    infer: 349,
    is: 385,
    abstract: 405,
    implements: 407,
    type: 409,
    let: 412,
    var: 414,
    using: 417,
    interface: 423,
    enum: 427,
    namespace: 433,
    module: 435,
    declare: 439,
    global: 443,
    for: 462,
    of: 471,
    while: 474,
    with: 478,
    do: 482,
    if: 486,
    else: 488,
    switch: 492,
    case: 498,
    try: 504,
    catch: 508,
    finally: 512,
    return: 516,
    throw: 520,
    break: 524,
    continue: 528,
    debugger: 532
};
var spec_word = {
    __proto__: null,
    async: 123,
    get: 125,
    set: 127,
    declare: 187,
    public: 189,
    private: 189,
    protected: 189,
    static: 191,
    abstract: 193,
    override: 195,
    readonly: 201,
    accessor: 203,
    new: 389
};
var spec_LessThan = {
    __proto__: null,
    "<": 143
};
var parser = (0, _lr.LRParser).deserialize({
    version: 14,
    states: "$<UO%TQ^OOO%[Q^OOO'_Q`OOP(lOWOOO*zQ08SO'#ChO+RO!bO'#CiO+aO#tO'#CiO+oO?MpO'#D^O.QQ^O'#DdO.bQ^O'#DoO%[Q^O'#DyO0fQ^O'#EROOQ07b'#EZ'#EZO1PQWO'#EWOOQO'#El'#ElOOQO'#Ie'#IeO1XQWO'#GmO1dQWO'#EkO1iQWO'#EkO3kQ08SO'#JiO6[Q08SO'#JjO6xQWO'#FZO6}Q&jO'#FqOOQ07b'#Fc'#FcO7YO,YO'#FcO7hQ7[O'#FxO9UQWO'#FwOOQ07b'#Jj'#JjOOQ07`'#Ji'#JiO9ZQWO'#GqOOQU'#KU'#KUO9fQWO'#IRO9kQ07hO'#ISOOQU'#JW'#JWOOQU'#IW'#IWQ`Q^OOO`Q^OOO%[Q^O'#DqO9sQ^O'#D}O9zQ^O'#EPO9aQWO'#GmO:RQ7[O'#CnO:aQWO'#EjO:lQWO'#EuO:qQ7[O'#FbO;`QWO'#GmOOQO'#KV'#KVO;eQWO'#KVO;sQWO'#GuO;sQWO'#GvO;sQWO'#GxO9aQWO'#G{O<jQWO'#HOO>RQWO'#CdO>cQWO'#H[O>kQWO'#HbO>kQWO'#HdO`Q^O'#HfO>kQWO'#HhO>kQWO'#HkO>pQWO'#HqO>uQ07iO'#HwO%[Q^O'#HyO?QQ07iO'#H{O?]Q07iO'#H}O9kQ07hO'#IPO?hQ08SO'#ChO@jQ`O'#DiQOQWOOO%[Q^O'#EPOAQQWO'#ESO:RQ7[O'#EjOA]QWO'#EjOAhQpO'#FbOOQU'#Cf'#CfOOQ07`'#Dn'#DnOOQ07`'#Jm'#JmO%[Q^O'#JmOOQO'#Jq'#JqOOQO'#Ib'#IbOBhQ`O'#EcOOQ07`'#Eb'#EbOCdQ07pO'#EcOCnQ`O'#EVOOQO'#Jp'#JpODSQ`O'#JqOEaQ`O'#EVOCnQ`O'#EcPEnO!0LbO'#CaPOOO)CDu)CDuOOOO'#IX'#IXOEyO!bO,59TOOQ07b,59T,59TOOOO'#IY'#IYOFXO#tO,59TO%[Q^O'#D`OOOO'#I['#I[OFgO?MpO,59xOOQ07b,59x,59xOFuQ^O'#I]OGYQWO'#JkOI[QrO'#JkO+}Q^O'#JkOIcQWO,5:OOIyQWO'#ElOJWQWO'#JyOJcQWO'#JxOJcQWO'#JxOJkQWO,5;YOJpQWO'#JwOOQ07f,5:Z,5:ZOJwQ^O,5:ZOLxQ08SO,5:eOMiQWO,5:mONSQ07hO'#JvONZQWO'#JuO9ZQWO'#JuONoQWO'#JuONwQWO,5;XON|QWO'#JuO!#UQrO'#JjOOQ07b'#Ch'#ChO%[Q^O'#ERO!#tQpO,5:rOOQO'#Jr'#JrOOQO-E<c-E<cO9aQWO,5=XO!$[QWO,5=XO!$aQ^O,5;VO!&dQ7[O'#EgO!'}QWO,5;VO!)mQ7[O'#DsO!)tQ^O'#DxO!*OQ`O,5;`O!*WQ`O,5;`O%[Q^O,5;`OOQU'#FR'#FROOQU'#FT'#FTO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aO%[Q^O,5;aOOQU'#FX'#FXO!*fQ^O,5;rOOQ07b,5;w,5;wOOQ07b,5;x,5;xO!,iQWO,5;xOOQ07b,5;y,5;yO%[Q^O'#IiO!,qQ07hO,5<eO!&dQ7[O,5;aO!-`Q7[O,5;aO%[Q^O,5;uO!-gQ&jO'#FgO!.dQ&jO'#J}O!.OQ&jO'#J}O!.kQ&jO'#J}OOQO'#J}'#J}O!/PQ&jO,5<POOOS,5<],5<]O!/bQ^O'#FsOOOS'#Ih'#IhO7YO,YO,5;}O!/iQ&jO'#FuOOQ07b,5;},5;}O!0YQMhO'#CuOOQ07b'#Cy'#CyO!0mQWO'#CyO!0rO?MpO'#C}O!1`Q7[O,5<bO!1gQWO,5<dO!3SQ!LQO'#GSO!3aQWO'#GTO!3fQWO'#GTO!3kQ!LQO'#GXO!4jQ`O'#G]OOQO'#Gh'#GhO!(SQ7[O'#GgOOQO'#Gj'#GjO!(SQ7[O'#GiO!5]QMhO'#JdOOQ07b'#Jd'#JdO!5gQWO'#JcO!5uQWO'#JbO!5}QWO'#CtOOQ07b'#Cw'#CwOOQ07b'#DR'#DROOQ07b'#DT'#DTO1SQWO'#DVO!(SQ7[O'#FzO!(SQ7[O'#F|O!6VQWO'#GOO!6[QWO'#GPO!3fQWO'#GVO!(SQ7[O'#G[O!6aQWO'#EmO!7OQWO,5<cOOQ07`'#Cq'#CqO!7WQWO'#EnO!8QQ`O'#EoOOQ07`'#Jw'#JwO!8XQ07hO'#KWO9kQ07hO,5=]O`Q^O,5>mOOQU'#J`'#J`OOQU,5>n,5>nOOQU-E<U-E<UO!:ZQ08SO,5:]O!<wQ08SO,5:iO%[Q^O,5:iO!?bQ08SO,5:kOOQO,5@q,5@qO!@RQ7[O,5=XO!@aQ07hO'#JaO9UQWO'#JaO!@rQ07hO,59YO!@}Q`O,59YO!AVQ7[O,59YO:RQ7[O,59YO!AbQWO,5;VO!AjQWO'#HZO!BOQWO'#KZO%[Q^O,5;zO!7{Q`O,5;|O!BWQWO,5=tO!B]QWO,5=tO!BbQWO,5=tO9kQ07hO,5=tO;sQWO,5=dOOQO'#Cu'#CuO!BpQ`O,5=aO!BxQ7[O,5=bO!CTQWO,5=dO!CYQpO,5=gO!CbQWO'#KVO>pQWO'#HQO9aQWO'#HSO!CgQWO'#HSO:RQ7[O'#HUO!ClQWO'#HUOOQU,5=j,5=jO!CqQWO'#HVO!DSQWO'#CnO!DXQWO,59OO!DcQWO,59OO!FhQ^O,59OOOQU,59O,59OO!FxQ07hO,59OO%[Q^O,59OO!ITQ^O'#H^OOQU'#H_'#H_OOQU'#H`'#H`O`Q^O,5=vO!IkQWO,5=vO`Q^O,5=|O`Q^O,5>OO!IpQWO,5>QO`Q^O,5>SO!IuQWO,5>VO!IzQ^O,5>]OOQU,5>c,5>cO%[Q^O,5>cO9kQ07hO,5>eOOQU,5>g,5>gO!NUQWO,5>gOOQU,5>i,5>iO!NUQWO,5>iOOQU,5>k,5>kO!NZQ`O'#D[O%[Q^O'#JmO!NxQ`O'#JmO# gQ`O'#DjO# xQ`O'#DjO#$ZQ^O'#DjO#$bQWO'#JlO#$jQWO,5:TO#$oQWO'#EpO#$}QWO'#JzO#%VQWO,5;ZO#%[Q`O'#DjO#%iQ`O'#EUOOQ07b,5:n,5:nO%[Q^O,5:nO#%pQWO,5:nO>pQWO,5;UO!@}Q`O,5;UO!AVQ7[O,5;UO:RQ7[O,5;UO#%xQWO,5@XO#%}Q$ISO,5:rOOQO-E<`-E<`O#'TQ07pO,5:}OCnQ`O,5:qO#'_Q`O,5:qOCnQ`O,5:}O!@rQ07hO,5:qOOQ07`'#Ef'#EfOOQO,5:},5:}O%[Q^O,5:}O#'lQ07hO,5:}O#'wQ07hO,5:}O!@}Q`O,5:qOOQO,5;T,5;TO#(VQ07hO,5:}POOO'#IV'#IVP#(kO!0LbO,58{POOO,58{,58{OOOO-E<V-E<VOOQ07b1G.o1G.oOOOO-E<W-E<WO#(vQpO,59zOOOO-E<Y-E<YOOQ07b1G/d1G/dO#({QrO,5>wO+}Q^O,5>wOOQO,5>},5>}O#)VQ^O'#I]OOQO-E<Z-E<ZO#)dQWO,5@VO#)lQrO,5@VO#)sQWO,5@dOOQ07b1G/j1G/jO%[Q^O,5@eO#){QWO'#IcOOQO-E<a-E<aO#)sQWO,5@dOOQ07`1G0t1G0tOOQ07f1G/u1G/uOOQ07f1G0X1G0XO%[Q^O,5@bO#*aQ07hO,5@bO#*rQ07hO,5@bO#*yQWO,5@aO9ZQWO,5@aO#+RQWO,5@aO#+aQWO'#IfO#*yQWO,5@aOOQ07`1G0s1G0sO!*OQ`O,5:tO!*ZQ`O,5:tOOQO,5:v,5:vO#,RQWO,5:vO#,ZQ7[O1G2sO9aQWO1G2sOOQ07b1G0q1G0qO#,iQ08SO1G0qO#-nQ08QO,5;ROOQ07b'#GR'#GRO#.[Q08SO'#JdO!$aQ^O1G0qO#0dQ7[O'#JnO#0nQWO,5:_O#0sQrO'#JoO%[Q^O'#JoO#0}QWO,5:dOOQ07b'#D['#D[OOQ07b1G0z1G0zO%[Q^O1G0zOOQ07b1G1d1G1dO#1SQWO1G0zO#3kQ08SO1G0{O#3rQ08SO1G0{O#6]Q08SO1G0{O#6dQ08SO1G0{O#8nQ08SO1G0{O#9UQ08SO1G0{O#<OQ08SO1G0{O#<VQ08SO1G0{O#>jQ08SO1G0{O#>wQ08SO1G0{O#@uQ08SO1G0{O#CuQ(CYO'#ChO#EsQ(CYO1G1^O#EzQ(CYO'#JjO!,lQWO1G1dO#F[Q08SO,5?TOOQ07`-E<g-E<gO#GOQ08SO1G0{OOQ07b1G0{1G0{O#IZQ08SO1G1aO#I}Q&jO,5<TO#JVQ&jO,5<UO#J_Q&jO'#FlO#JvQWO'#FkOOQO'#KO'#KOOOQO'#Ig'#IgO#J{Q&jO1G1kOOQ07b1G1k1G1kOOOS1G1v1G1vO#K^Q(CYO'#JiO#KhQWO,5<_O!*fQ^O,5<_OOOS-E<f-E<fOOQ07b1G1i1G1iO#KmQ`O'#J}OOQ07b,5<a,5<aO#KuQ`O,5<aOOQ07b,59e,59eO!&dQ7[O'#DPOOOO'#IZ'#IZO#KzO?MpO,59iOOQ07b,59i,59iO%[Q^O1G1|O!6[QWO'#IkO#LVQ7[O,5<uOOQ07b,5<r,5<rO!(SQ7[O'#InO#LuQ7[O,5=RO!(SQ7[O'#IpO#MhQ7[O,5=TO!&dQ7[O,5=VOOQO1G2O1G2OO#MrQpO'#CqO#NVQpO,5<nO#N^QWO'#KRO9aQWO'#KRO#NlQWO,5<pO!(SQ7[O,5<oO#NqQWO'#GUO#N|QWO,5<oO$ RQpO'#GRO$ `QpO'#KSO$ jQWO'#KSO!&dQ7[O'#KSO$ oQWO,5<sO$ tQ`O'#G^O!4eQ`O'#G^O$!VQWO'#G`O$![QWO'#GbO!3fQWO'#GeO$!aQ07hO'#ImO$!lQ`O,5<wOOQ07f,5<w,5<wO$!sQ`O'#G^O$#RQ`O'#G_O$#ZQ`O'#G_O$#`Q7[O,5=RO$#pQ7[O,5=TOOQ07b,5=W,5=WO!(SQ7[O,5?}O!(SQ7[O,5?}O$$QQWO'#IrO$$]QWO,5?|O$$eQWO,59`O$%UQ7[O,59qOOQ07b,59q,59qO$%wQ7[O,5<fO$&jQ7[O,5<hO@bQWO,5<jOOQ07b,5<k,5<kO$&tQWO,5<qO$&yQ7[O,5<vO$'ZQWO'#JuO!$aQ^O1G1}O$'`QWO1G1}O9ZQWO'#JxO9ZQWO'#EpO%[Q^O'#EpO9ZQWO'#ItO$'eQ07hO,5@rOOQU1G2w1G2wOOQU1G4X1G4XOOQ07b1G/w1G/wO!,iQWO1G/wO$)jQ08SO1G0TOOQU1G2s1G2sO!&dQ7[O1G2sO%[Q^O1G2sO#,^QWO1G2sO$+nQ7[O'#EgOOQ07`,5?{,5?{O$+xQ07hO,5?{OOQU1G.t1G.tO!@rQ07hO1G.tO!@}Q`O1G.tO!AVQ7[O1G.tO$,ZQWO1G0qO$,`QWO'#ChO$,kQWO'#K[O$,sQWO,5=uO$,xQWO'#K[O$,}QWO'#K[O$-]QWO'#IzO$-kQWO,5@uO$-sQrO1G1fOOQ07b1G1h1G1hO9aQWO1G3`O@bQWO1G3`O$-zQWO1G3`O$.PQWO1G3`OOQU1G3`1G3`O!CTQWO1G3OO!&dQ7[O1G2{O$.UQWO1G2{OOQU1G2|1G2|O!&dQ7[O1G2|O$.ZQWO1G2|O$.cQ`O'#GzOOQU1G3O1G3OO!4eQ`O'#IvO!CYQpO1G3ROOQU1G3R1G3ROOQU,5=l,5=lO$.kQ7[O,5=nO9aQWO,5=nO$![QWO,5=pO9UQWO,5=pO!@}Q`O,5=pO!AVQ7[O,5=pO:RQ7[O,5=pO$.yQWO'#KYO$/UQWO,5=qOOQU1G.j1G.jO$/ZQ07hO1G.jO@bQWO1G.jO$/fQWO1G.jO9kQ07hO1G.jO$1kQrO,5@wO$1{QWO,5@wO9ZQWO,5@wO$2WQ^O,5=xO$2_QWO,5=xOOQU1G3b1G3bO`Q^O1G3bOOQU1G3h1G3hOOQU1G3j1G3jO>kQWO1G3lO$2dQ^O1G3nO$6hQ^O'#HmOOQU1G3q1G3qO$6uQWO'#HsO>pQWO'#HuOOQU1G3w1G3wO$6}Q^O1G3wO9kQ07hO1G3}OOQU1G4P1G4POOQ07`'#GY'#GYO9kQ07hO1G4RO9kQ07hO1G4TO$;UQWO,5@XO!*fQ^O,5;[O9ZQWO,5;[O>pQWO,5:UO!*fQ^O,5:UO!@}Q`O,5:UO$;ZQ(CYO,5:UOOQO,5;[,5;[O$;eQ`O'#I^O$;{QWO,5@WOOQ07b1G/o1G/oO$<TQ`O'#IdO$<_QWO,5@fOOQ07`1G0u1G0uO# xQ`O,5:UOOQO'#Ia'#IaO$<gQ`O,5:pOOQ07f,5:p,5:pO#%sQWO1G0YOOQ07b1G0Y1G0YO%[Q^O1G0YOOQ07b1G0p1G0pO>pQWO1G0pO!@}Q`O1G0pO!AVQ7[O1G0pOOQ07`1G5s1G5sO!@rQ07hO1G0]OOQO1G0i1G0iO%[Q^O1G0iO$<nQ07hO1G0iO$<yQ07hO1G0iO!@}Q`O1G0]OCnQ`O1G0]O$=XQ07hO1G0iOOQO1G0]1G0]O$=mQ08SO1G0iPOOO-E<T-E<TPOOO1G.g1G.gOOOO1G/f1G/fO$=wQpO,5<eO$>PQrO1G4cOOQO1G4i1G4iO%[Q^O,5>wO$>ZQWO1G5qO$>cQWO1G6OO$>kQrO1G6PO9ZQWO,5>}O$>uQ08SO1G5|O%[Q^O1G5|O$?VQ07hO1G5|O$?hQWO1G5{O$?hQWO1G5{O9ZQWO1G5{O$?pQWO,5?QO9ZQWO,5?QOOQO,5?Q,5?QO$@UQWO,5?QO$'ZQWO,5?QOOQO-E<d-E<dOOQO1G0`1G0`OOQO1G0b1G0bO!,lQWO1G0bOOQU7+(_7+(_O!&dQ7[O7+(_O%[Q^O7+(_O$@dQWO7+(_O$@oQ7[O7+(_O$@}Q08SO,5=RO$CYQ08SO,5=TO$EeQ08SO,5=RO$GvQ08SO,5=TO$JXQ08SO,59qO$LaQ08SO,5<fO$NlQ08SO,5<hO%!wQ08SO,5<vOOQ07b7+&]7+&]O%%YQ08SO7+&]O%%|Q7[O'#I_O%&WQWO,5@YOOQ07b1G/y1G/yO%&`Q^O'#I`O%&mQWO,5@ZO%&uQrO,5@ZOOQ07b1G0O1G0OO%'PQWO7+&fOOQ07b7+&f7+&fO%'UQ(CYO,5:eO%[Q^O7+&xO%'`Q(CYO,5:]O%'mQ(CYO,5:iO%'wQ(CYO,5:kOOQ07b7+'O7+'OOOQO1G1o1G1oOOQO1G1p1G1pO%(RQtO,5<WO!*fQ^O,5<VOOQO-E<e-E<eOOQ07b7+'V7+'VOOOS7+'b7+'bOOOS1G1y1G1yO%(^QWO1G1yOOQ07b1G1{1G1{O%(cQpO,59kOOOO-E<X-E<XOOQ07b1G/T1G/TO%(jQ08SO7+'hOOQ07b,5?V,5?VO%)^QpO,5?VOOQ07b1G2a1G2aP!&dQ7[O'#IkPOQ07b-E<i-E<iO%)|Q7[O,5?YOOQ07b-E<l-E<lO%*oQ7[O,5?[OOQ07b-E<n-E<nO%*yQpO1G2qOOQ07b1G2Y1G2YO%+QQWO'#IjO%+`QWO,5@mO%+`QWO,5@mO%+hQWO,5@mO%+sQWO,5@mOOQO1G2[1G2[O%,RQ7[O1G2ZO!(SQ7[O1G2ZO%,cQ!LQO'#IlO%,sQWO,5@nO!&dQ7[O,5@nO%,{QpO,5@nOOQ07b1G2_1G2_OOQ07`,5<x,5<xOOQ07`,5<y,5<yO$'ZQWO,5<yOC_QWO,5<yO!@}Q`O,5<xOOQO'#Ga'#GaO%-VQWO,5<zOOQ07`,5<|,5<|O$'ZQWO,5=POOQO,5?X,5?XOOQO-E<k-E<kOOQ07f1G2c1G2cO!4eQ`O,5<xO%-_QWO,5<yO$!VQWO,5<zO!4eQ`O,5<yO!(SQ7[O'#InO%.RQ7[O1G2mO!(SQ7[O'#IpO%.tQ7[O1G2oO%/OQ7[O1G5iO%/YQ7[O1G5iOOQO,5?^,5?^OOQO-E<p-E<pOOQO1G.z1G.zO!7{Q`O,59sO%[Q^O,59sO%/gQWO1G2UO!(SQ7[O1G2]O%/lQ08SO7+'iOOQ07b7+'i7+'iO!$aQ^O7+'iO%0`QWO,5;[OOQ07`,5?`,5?`OOQ07`-E<r-E<rOOQ07b7+%c7+%cO%0eQpO'#KTO#%sQWO7+(_O%0oQrO7+(_O$@gQWO7+(_O%0vQ08QO'#ChO%1ZQ08QO,5<}O%1{QWO,5<}OOQ07`1G5g1G5gOOQU7+$`7+$`O!@rQ07hO7+$`O!@}Q`O7+$`O!$aQ^O7+&]O%2QQWO'#IyO%2iQWO,5@vOOQO1G3a1G3aO9aQWO,5@vO%2iQWO,5@vO%2qQWO,5@vOOQO,5?f,5?fOOQO-E<x-E<xOOQ07b7+'Q7+'QO%2vQWO7+(zO9kQ07hO7+(zO9aQWO7+(zO@bQWO7+(zOOQU7+(j7+(jO%2{Q08QO7+(gO!&dQ7[O7+(gO%3VQpO7+(hOOQU7+(h7+(hO!&dQ7[O7+(hO%3^QWO'#KXO%3iQWO,5=fOOQO,5?b,5?bOOQO-E<t-E<tOOQU7+(m7+(mO%4xQ`O'#HTOOQU1G3Y1G3YO!&dQ7[O1G3YO%[Q^O1G3YO%5PQWO1G3YO%5[Q7[O1G3YO9kQ07hO1G3[O$![QWO1G3[O9UQWO1G3[O!@}Q`O1G3[O!AVQ7[O1G3[O%5jQWO'#IxO%6OQWO,5@tO%6WQ`O,5@tOOQ07`1G3]1G3]OOQU7+$U7+$UO@bQWO7+$UO9kQ07hO7+$UO%6cQWO7+$UO%[Q^O1G6cO%[Q^O1G6dO%6hQ07hO1G6cO%6rQ^O1G3dO%6yQWO1G3dO%7OQ^O1G3dOOQU7+(|7+(|O9kQ07hO7+)WO`Q^O7+)YOOQU'#K_'#K_OOQU'#I{'#I{O%7VQ^O,5>XOOQU,5>X,5>XO%[Q^O'#HnO%7dQWO'#HpOOQU,5>_,5>_O9ZQWO,5>_OOQU,5>a,5>aOOQU7+)c7+)cOOQU7+)i7+)iOOQU7+)m7+)mOOQU7+)o7+)oO%7iQ`O1G5sO%7}Q(CYO1G0vO%8XQWO1G0vOOQO1G/p1G/pO%8dQ(CYO1G/pO>pQWO1G/pO!*fQ^O'#DjOOQO,5>x,5>xOOQO-E<[-E<[OOQO,5?O,5?OOOQO-E<b-E<bO!@}Q`O1G/pOOQO-E<_-E<_OOQ07f1G0[1G0[OOQ07b7+%t7+%tO#%sQWO7+%tOOQ07b7+&[7+&[O>pQWO7+&[O!@}Q`O7+&[OOQO7+%w7+%wO$=mQ08SO7+&TOOQO7+&T7+&TO%[Q^O7+&TO%8nQ07hO7+&TO!@rQ07hO7+%wO!@}Q`O7+%wO%8yQ07hO7+&TO%9XQ08SO7++hO%[Q^O7++hO%9iQWO7++gO%9iQWO7++gOOQO1G4l1G4lO9ZQWO1G4lO%9qQWO1G4lOOQO7+%|7+%|O#%sQWO<<KyO%0oQrO<<KyO%:PQWO<<KyOOQU<<Ky<<KyO!&dQ7[O<<KyO%[Q^O<<KyO%:XQWO<<KyO%:dQ08SO,5?YO%<oQ08SO,5?[O%>zQ08SO1G2ZO%A]Q08SO1G2mO%ChQ08SO1G2oO%EsQ7[O,5>yOOQO-E<]-E<]O%E}QrO,5>zO%[Q^O,5>zOOQO-E<^-E<^O%FXQWO1G5uOOQ07b<<JQ<<JQO%FaQ(CYO1G0qO%HkQ(CYO1G0{O%HrQ(CYO1G0{O%JvQ(CYO1G0{O%J}Q(CYO1G0{O%LrQ(CYO1G0{O%MYQ(CYO1G0{O& mQ(CYO1G0{O& tQ(CYO1G0{O&#rQ(CYO1G0{O&$PQ(CYO1G0{O&%}Q(CYO1G0{O&&bQ08SO<<JdO&'gQ(CYO1G0{O&)]Q(CYO'#JdO&+`Q(CYO1G1aO&+mQ(CYO1G0TO!*fQ^O'#FnOOQO'#KP'#KPOOQO1G1r1G1rO&+wQWO1G1qO&+|Q(CYO,5?TOOOS7+'e7+'eOOOO1G/V1G/VOOQ07b1G4q1G4qO!(SQ7[O7+(]O&,WQWO,5?UO9aQWO,5?UOOQO-E<h-E<hO&,fQWO1G6XO&,fQWO1G6XO&,nQWO1G6XO&,yQ7[O7+'uO&-ZQpO,5?WO&-eQWO,5?WO!&dQ7[O,5?WOOQO-E<j-E<jO&-jQpO1G6YO&-tQWO1G6YOOQ07`1G2e1G2eO$'ZQWO1G2eOOQ07`1G2d1G2dO&-|QWO1G2fO!&dQ7[O1G2fOOQ07`1G2k1G2kO!@}Q`O1G2dOC_QWO1G2eO&.RQWO1G2fO&.ZQWO1G2eO&.}Q7[O,5?YOOQ07b-E<m-E<mO&/pQ7[O,5?[OOQ07b-E<o-E<oO!(SQ7[O7++TOOQ07b1G/_1G/_O&/zQWO1G/_OOQ07b7+'p7+'pO&0PQ7[O7+'wO&0aQ08SO<<KTOOQ07b<<KT<<KTO&1TQWO1G0vO!&dQ7[O'#IsO&1YQWO,5@oO!&dQ7[O1G2iOOQU<<Gz<<GzO!@rQ07hO<<GzO&1bQ08SO<<IwOOQ07b<<Iw<<IwOOQO,5?e,5?eO&2UQWO,5?eO&2ZQWO,5?eOOQO-E<w-E<wO&2iQWO1G6bO&2iQWO1G6bO9aQWO1G6bO@bQWO<<LfOOQU<<Lf<<LfO&2qQWO<<LfO9kQ07hO<<LfOOQU<<LR<<LRO%2{Q08QO<<LROOQU<<LS<<LSO%3VQpO<<LSO&2vQ`O'#IuO&3RQWO,5@sO!*fQ^O,5@sOOQU1G3Q1G3QO&3ZQ^O'#JmOOQO'#Iw'#IwO9kQ07hO'#IwO&3eQ`O,5=oOOQU,5=o,5=oO&3lQ`O'#EcO&4QQWO7+(tO&4VQWO7+(tOOQU7+(t7+(tO!&dQ7[O7+(tO%[Q^O7+(tO&4_QWO7+(tOOQU7+(v7+(vO9kQ07hO7+(vO$![QWO7+(vO9UQWO7+(vO!@}Q`O7+(vO&4jQWO,5?dOOQO-E<v-E<vOOQO'#HW'#HWO&4uQWO1G6`O9kQ07hO<<GpOOQU<<Gp<<GpO@bQWO<<GpO&4}QWO7++}O&5SQWO7+,OO%[Q^O7++}O%[Q^O7+,OOOQU7+)O7+)OO&5XQWO7+)OO&5^Q^O7+)OO&5eQWO7+)OOOQU<<Lr<<LrOOQU<<Lt<<LtOOQU-E<y-E<yOOQU1G3s1G3sO&5jQWO,5>YOOQU,5>[,5>[O&5oQWO1G3yO9ZQWO7+&bO!*fQ^O7+&bOOQO7+%[7+%[O&5tQ(CYO1G6PO>pQWO7+%[OOQ07b<<I`<<I`OOQ07b<<Iv<<IvO>pQWO<<IvOOQO<<Io<<IoO$=mQ08SO<<IoO%[Q^O<<IoOOQO<<Ic<<IcO!@rQ07hO<<IcO&6OQ07hO<<IoO&6ZQ08SO<= SO&6kQWO<= ROOQO7+*W7+*WO9ZQWO7+*WOOQUANAeANAeO&6sQWOANAeO!&dQ7[OANAeO#%sQWOANAeO%0oQrOANAeO%[Q^OANAeO&6{Q08SO7+'uO&9^Q08SO,5?YO&;iQ08SO,5?[O&=tQ08SO7+'wO&@VQrO1G4fO&@aQ(CYO7+&]O&BeQ(CYO,5=RO&DlQ(CYO,5=TO&D|Q(CYO,5=RO&E^Q(CYO,5=TO&EnQ(CYO,59qO&GqQ(CYO,5<fO&ItQ(CYO,5<hO&KwQ(CYO,5<vO&MmQ(CYO7+'hO&MzQ(CYO7+'iO&NXQWO,5<YOOQO7+']7+']O&N^Q7[O<<KwOOQO1G4p1G4pO&NeQWO1G4pO&NpQWO1G4pO' OQWO7++sO' OQWO7++sO!&dQ7[O1G4rO' WQpO1G4rO' bQWO7++tOOQ07`7+(P7+(PO$'ZQWO7+(QO' jQpO7+(QOOQ07`7+(O7+(OO$'ZQWO7+(PO' qQWO7+(QO!&dQ7[O7+(QOC_QWO7+(PO' vQ7[O<<NoOOQ07b7+$y7+$yO'!QQpO,5?_OOQO-E<q-E<qO'![Q08QO7+(TOOQUAN=fAN=fO9aQWO1G5POOQO1G5P1G5PO'!lQWO1G5PO'!qQWO7++|O'!qQWO7++|O9kQ07hOANBQO@bQWOANBQOOQUANBQANBQOOQUANAmANAmOOQUANAnANAnO'!yQWO,5?aOOQO-E<s-E<sO'#UQ(CYO1G6_O'%fQrO'#ChOOQO,5?c,5?cOOQO-E<u-E<uOOQU1G3Z1G3ZO&3ZQ^O,5<zOOQU<<L`<<L`O!&dQ7[O<<L`O&4QQWO<<L`O'%pQWO<<L`O%[Q^O<<L`OOQU<<Lb<<LbO9kQ07hO<<LbO$![QWO<<LbO9UQWO<<LbO'%xQ`O1G5OO'&TQWO7++zOOQUAN=[AN=[O9kQ07hOAN=[OOQU<= i<= iOOQU<= j<= jO'&]QWO<= iO'&bQWO<= jOOQU<<Lj<<LjO'&gQWO<<LjO'&lQ^O<<LjOOQU1G3t1G3tO>pQWO7+)eO'&sQWO<<I|O''OQ(CYO<<I|OOQO<<Hv<<HvOOQ07bAN?bAN?bOOQOAN?ZAN?ZO$=mQ08SOAN?ZOOQOAN>}AN>}O%[Q^OAN?ZOOQO<<Mr<<MrOOQUG27PG27PO!&dQ7[OG27PO#%sQWOG27PO''YQWOG27PO%0oQrOG27PO''bQ(CYO<<JdO''oQ(CYO1G2ZO')eQ(CYO,5?YO'+hQ(CYO,5?[O'-kQ(CYO1G2mO'/nQ(CYO1G2oO'1qQ(CYO<<KTO'2OQ(CYO<<IwOOQO1G1t1G1tO!(SQ7[OANAcOOQO7+*[7+*[O'2]QWO7+*[O'2hQWO<= _O'2pQpO7+*^OOQ07`<<Kl<<KlO$'ZQWO<<KlOOQ07`<<Kk<<KkO'2zQpO<<KlO$'ZQWO<<KkOOQO7+*k7+*kO9aQWO7+*kO'3RQWO<= hOOQUG27lG27lO9kQ07hOG27lO!*fQ^O1G4{O'3ZQWO7++yO&4QQWOANAzOOQUANAzANAzO!&dQ7[OANAzO'3cQWOANAzOOQUANA|ANA|O9kQ07hOANA|O$![QWOANA|OOQO'#HX'#HXOOQO7+*j7+*jOOQUG22vG22vOOQUANETANETOOQUANEUANEUOOQUANBUANBUO'3kQWOANBUOOQU<<MP<<MPO!*fQ^OAN?hOOQOG24uG24uO$=mQ08SOG24uO#%sQWOLD,kOOQULD,kLD,kO!&dQ7[OLD,kO'3pQWOLD,kO'3xQ(CYO7+'uO'5nQ(CYO,5?YO'7qQ(CYO,5?[O'9tQ(CYO7+'wO';jQ7[OG26}OOQO<<Mv<<MvOOQ07`ANAWANAWO$'ZQWOANAWOOQ07`ANAVANAVOOQO<<NV<<NVOOQULD-WLD-WO';zQ(CYO7+*gOOQUG27fG27fO&4QQWOG27fO!&dQ7[OG27fOOQUG27hG27hO9kQ07hOG27hOOQUG27pG27pO'<UQ(CYOG25SOOQOLD*aLD*aOOQU!$(!V!$(!VO#%sQWO!$(!VO!&dQ7[O!$(!VO'<`Q08SOG26}OOQ07`G26rG26rOOQULD-QLD-QO&4QQWOLD-QOOQULD-SLD-SOOQU!)9Eq!)9EqO#%sQWO!)9EqOOQU!$(!l!$(!lOOQU!.K;]!.K;]O'>qQ(CYOG26}O!*fQ^O'#DyO1PQWO'#EWO'@gQrO'#JiO!*fQ^O'#DqO'@nQ^O'#D}O'@uQrO'#ChO'C]QrO'#ChO!*fQ^O'#EPO'CmQ^O,5;VO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O,5;aO!*fQ^O'#IiO'EpQWO,5<eO'ExQ7[O,5;aO'GcQ7[O,5;aO!*fQ^O,5;uO!&dQ7[O'#GgO'ExQ7[O'#GgO!&dQ7[O'#GiO'ExQ7[O'#GiO1SQWO'#DVO1SQWO'#DVO!&dQ7[O'#FzO'ExQ7[O'#FzO!&dQ7[O'#F|O'ExQ7[O'#F|O!&dQ7[O'#G[O'ExQ7[O'#G[O!*fQ^O,5:iO!*fQ^O,5@eO'CmQ^O1G0qO'GjQ(CYO'#ChO!*fQ^O1G1|O!&dQ7[O'#InO'ExQ7[O'#InO!&dQ7[O'#IpO'ExQ7[O'#IpO!&dQ7[O,5<oO'ExQ7[O,5<oO'CmQ^O1G1}O!*fQ^O7+&xO!&dQ7[O1G2ZO'ExQ7[O1G2ZO!&dQ7[O'#InO'ExQ7[O'#InO!&dQ7[O'#IpO'ExQ7[O'#IpO!&dQ7[O1G2]O'ExQ7[O1G2]O'CmQ^O7+'iO'CmQ^O7+&]O!&dQ7[OANAcO'ExQ7[OANAcO'GtQWO'#EkO'GyQWO'#EkO'HRQWO'#FZO'HWQWO'#EuO'H]QWO'#JyO'HhQWO'#JwO'HsQWO,5;VO'HxQ7[O,5<bO'IPQWO'#GTO'IUQWO'#GTO'IZQWO,5<cO'IcQWO,5;VO'IkQ(CYO1G1^O'IrQWO,5<oO'IwQWO,5<oO'I|QWO,5<qO'JRQWO,5<qO'JWQWO1G1}O'J]QWO1G0qO'JbQ7[O<<KwO'JiQ7[O<<KwO7hQ7[O'#FxO9UQWO'#FwOA]QWO'#EjO!*fQ^O,5;rO!3fQWO'#GTO!3fQWO'#GTO!3fQWO'#GVO!3fQWO'#GVO!(SQ7[O7+(]O!(SQ7[O7+(]O%*yQpO1G2qO%*yQpO1G2qO!&dQ7[O,5=VO!&dQ7[O,5=V",
    stateData: "'Km~O'tOS'uOSSOS'vRQ~OPYOQYORfOX!VO`qOczOdyOlkOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO![XO!fuO!kZO!nYO!oYO!pYO!rvO!twO!wxO!{]O#s!PO$T|O%b}O%d!QO%f!OO%g!OO%h!OO%k!RO%m!SO%p!TO%q!TO%s!UO&P!WO&V!XO&X!YO&Z!ZO&]![O&`!]O&f!^O&l!_O&n!`O&p!aO&r!bO&t!cO'{SO'}TO(QUO(XVO(g[O(tiO~OVtO~P`OPYOQYORfOc!jOd!iOlkOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO![!eO!fuO!kZO!nYO!oYO!pYO!rvO!t!gO!w!hO$T!kO'{!dO'}TO(QUO(XVO(g[O(tiO~O`!vOo!nO!P!oO!_!xO!`!uO!a!uO!{:dO#P!pO#Q!pO#R!wO#S!pO#T!pO#W!yO#X!yO'|!lO'}TO(QUO([!mO(g!sO~O'v!zO~OP[XZ[X`[Xn[X|[X}[X!P[X!Y[X!h[X!i[X!k[X!o[X#[[X#geX#j[X#k[X#l[X#m[X#n[X#o[X#p[X#q[X#r[X#t[X#v[X#x[X#y[X$O[X'r[X(X[X(h[X(o[X(p[X~O!d$|X~P(qO^!|O'}#OO(O!|O(P#OO~O^#PO(P#OO(Q#OO(R#PO~Ot#RO!R#SO(Y#SO(Z#UO~OPYOQYORfOc!jOd!iOlkOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO![!eO!fuO!kZO!nYO!oYO!pYO!rvO!t!gO!w!hO$T!kO'{:hO'}TO(QUO(XVO(g[O(tiO~O!X#YO!Y#VO!V(_P!V(lP~P+}O!Z#bO~P`OPYOQYORfOc!jOd!iOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO![!eO!fuO!kZO!nYO!oYO!pYO!rvO!t!gO!w!hO$T!kO'}TO(QUO(XVO(g[O(tiO~Ol#lO!X#hO!{]O#e#kO#f#hO'{:iO!j(iP~P.iO!k#nO'{#mO~O!w#rO!{]O%b#sO~O#g#tO~O!d#uO#g#tO~OP$]OZ$dOn$QO|#yO}#zO!P#{O!Y$aO!h$SO!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO#o$SO#p$SO#q$cO#r$SO#t$TO#v$VO#x$XO#y$YO(XVO(h$ZO(o#|O(p#}O~O`(]X'r(]X'p(]X!j(]X!V(]X![(]X%c(]X!d(]X~P1qO#[$eO$O$eOP(^XZ(^Xn(^X|(^X}(^X!P(^X!Y(^X!h(^X!k(^X!o(^X#j(^X#k(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#r(^X#t(^X#v(^X#x(^X#y(^X(X(^X(h(^X(o(^X(p(^X![(^X%c(^X~O`(^X!i(^X'r(^X'p(^X!V(^X!j(^Xr(^X!d(^X~P4XO#[$eO~O$Y$gO$[$fO$c$lO~ORfO![$mO$f$nO$h$pO~Og%VOl%WOn$tOo$sOp$sOv%XOx%YOz%ZO!P${O![$|O!f%`O!k$xO#f%aO$T%^O$o%[O$q%]O$t%_O'{$rO'}TO(QUO(X$uO(o$}O(p%POf(UP~O!k%bO~O!P%eO![%fO'{%dO~O!d%jO~O`%kO'r%kO~O'|!lO~P%[O%h%rO~P%[Og%VO!k%bO'{%dO'|!lO~Od%yO!k%bO'{%dO~O#r$SO~O|&OO![%{O!k%}O%d&RO'{%dO'|!lO'}TO(QUO_(}P~O!w#rO~O%m&TO!P(yX![(yX'{(yX~O'{&UO~O!t&ZO#s!PO%d!QO%f!OO%g!OO%h!OO%k!RO%m!SO%p!TO%q!TO~Oc&`Od&_O!w&]O%b&^O%u&[O~P;xOc&cOdyO![&bO!t&ZO!wxO!{]O#s!PO%b}O%f!OO%g!OO%h!OO%k!RO%m!SO%p!TO%q!TO%s!UO~Oa&fO#[&iO%d&dO'|!lO~P<}O!k&jO!t&nO~O!k#nO~O![XO~O`%kO'q&vO'r%kO~O`%kO'q&yO'r%kO~O`%kO'q&{O'r%kO~O'p[X!V[Xr[X!j[X&T[X![[X%c[X!d[X~P(qO!_'YO!`'RO!a'RO'|!lO'}TO(QUO~Oo'PO!P'OO!X'SO([&}O!Z(`P!Z(nP~P@UOj']O!['ZO'{%dO~Od'bO!k%bO'{%dO~O|&OO!k%}O~Oo!nO!P!oO!{:dO#P!pO#Q!pO#S!pO#T!pO'|!lO'}TO(QUO([!mO(g!sO~O!_'hO!`'gO!a'gO#R!pO#W'iO#X'iO~PApO`%kOg%VO!d#uO!k%bO'r%kO(h'kO~O!o'oO#['mO~PCOOo!nO!P!oO'}TO(QUO([!mO(g!sO~O![XOo(eX!P(eX!_(eX!`(eX!a(eX!{(eX#P(eX#Q(eX#R(eX#S(eX#T(eX#W(eX#X(eX'|(eX'}(eX(Q(eX([(eX(g(eX~O!`'gO!a'gO'|!lO~PCnO'w'sO'x'sO'y'uO~O^!|O'}'wO(O!|O(P'wO~O^#PO(P'wO(Q'wO(R#PO~Ot#RO!R#SO(Y#SO(Z'{O~O!X'}O!V'PX!V'VX!Y'PX!Y'VX~P+}O!Y(PO!V(_X~OP$]OZ$dOn$QO|#yO}#zO!P#{O!Y(PO!h$SO!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO#o$SO#p$SO#q$cO#r$SO#t$TO#v$VO#x$XO#y$YO(XVO(h$ZO(o#|O(p#}O~O!V(_X~PGbO!V(UO~O!V(kX!Y(kX!d(kX!j(kX(h(kX~O#[(kX#g#`X!Z(kX~PIhO#[(VO!V(mX!Y(mX~O!Y(WO!V(lX~O!V(ZO~O#[$eO~PIhO!Z([O~P`O|#yO}#zO!P#{O!i#wO!k#xO(XVOP!maZ!man!ma!Y!ma!h!ma!o!ma#j!ma#k!ma#l!ma#m!ma#n!ma#o!ma#p!ma#q!ma#r!ma#t!ma#v!ma#x!ma#y!ma(h!ma(o!ma(p!ma~O`!ma'r!ma'p!ma!V!ma!j!mar!ma![!ma%c!ma!d!ma~PKOO!j(]O~O!d#uO#[(^O(h'kO!Y(jX`(jX'r(jX~O!j(jX~PMnO!P%eO![%fO!{]O#e(cO#f(bO'{%dO~O!Y(dO!j(iX~O!j(fO~O!P%eO![%fO#f(bO'{%dO~OP(^XZ(^Xn(^X|(^X}(^X!P(^X!Y(^X!h(^X!i(^X!k(^X!o(^X#j(^X#k(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#r(^X#t(^X#v(^X#x(^X#y(^X(X(^X(h(^X(o(^X(p(^X~O!d#uO!j(^X~P! [O|(gO}(hO!i#wO!k#xO!{!za!P!za~O!w!za%b!za![!za#e!za#f!za'{!za~P!#`O!w(lO~OPYOQYORfOc!jOd!iOlkOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO![XO!fuO!kZO!nYO!oYO!pYO!rvO!t!gO!w!hO$T!kO'{!dO'}TO(QUO(XVO(g[O(tiO~Og%VOl%WOn$tOo$sOp$sOv%XOx%YOz;QO!P${O![$|O!f<`O!k$xO#f;WO$T%^O$o;SO$q;UO$t%_O'{(pO'}TO(QUO(X$uO(o$}O(p%PO~O#g(rO~Og%VOl%WOn$tOo$sOp$sOv%XOx%YOz%ZO!P${O![$|O!f%`O!k$xO#f%aO$T%^O$o%[O$q%]O$t%_O'{(pO'}TO(QUO(X$uO(o$}O(p%PO~Of(bP~P!(SO!X(vO!j(cP~P%[O([(xO(g[O~O!P(zO!k#xO([(xO(g[O~OP:cOQ:cORfOc<[Od!iOlkOn:cOokOpkOvkOx:cOz:cO!PWO!TkO!UkO![!eO!f:fO!kZO!n:cO!o:cO!p:cO!r:gO!t:jO!w!hO$T!kO'{)YO'}TO(QUO(XVO(g[O(t<YO~O})]O!k#xO~O!Y$aO`$ma'r$ma'p$ma!j$ma!V$ma![$ma%c$ma!d$ma~O#s)aO~P!&dO|)dO!d)cO![$ZX$W$ZX$Y$ZX$[$ZX$c$ZX~O!d)cO![(qX$W(qX$Y(qX$[(qX$c(qX~O|)dO~P!.OO|)dO![(qX$W(qX$Y(qX$[(qX$c(qX~O![)fO$W)jO$Y)eO$[)eO$c)kO~O!X)nO~P!*fO$Y$gO$[$fO$c)rO~Oj$uX|$uX!P$uX!i$uX(o$uX(p$uX~OfiXf$uXjiX!YiX#[iX~P!/tOo)tO~Ot)uO(Y)vO(Z)xO~Oj*RO|)zO!P){O(o$}O(p%PO~Of)yO~P!0}Of*SO~Og%VOl%WOn$tOo$sOp$sOv%XOx%YOz;QO!P${O![$|O!f<`O!k$xO#f;WO$T%^O$o;SO$q;UO$t%_O'}TO(QUO(X$uO(o$}O(p%PO~O!X*WO'{*TO!j(uP~P!1lO#g*YO~O!k*ZO~O!X*`O'{*]O!V(vP~P!1lOn*lO!P*dO!_*jO!`*cO!a*cO!k*ZO#W*kO%Y*fO'|!lO([!mO~O!Z*iO~P!3xO!i#wOj(WX|(WX!P(WX(o(WX(p(WX!Y(WX#[(WX~Of(WX#|(WX~P!4qOj*qO#[*pOf(VX!Y(VX~O!Y*rOf(UX~O'{&UOf(UP~O!k*yO~O'{(pO~Ol*}O!P%eO!X#hO![%fO!{]O#e#kO#f#hO'{%dO!j(iP~O!d#uO#g+OO~O!P%eO!X+QO!Y(WO![%fO'{%dO!V(lP~Oo'VO!P+SO!X+RO'}TO(QUO([(xO~O!Z(nP~P!7lO!Y+TO`(zX'r(zX~OP$]OZ$dOn$QO|#yO}#zO!P#{O!h$SO!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO#o$SO#p$SO#q$cO#r$SO#t$TO#v$VO#x$XO#y$YO(XVO(h$ZO(o#|O(p#}O~O`!ea!Y!ea'r!ea'p!ea!V!ea!j!ear!ea![!ea%c!ea!d!ea~P!8dO|#yO}#zO!P#{O!i#wO!k#xO(XVOP!qaZ!qan!qa!Y!qa!h!qa!o!qa#j!qa#k!qa#l!qa#m!qa#n!qa#o!qa#p!qa#q!qa#r!qa#t!qa#v!qa#x!qa#y!qa(h!qa(o!qa(p!qa~O`!qa'r!qa'p!qa!V!qa!j!qar!qa![!qa%c!qa!d!qa~P!:}O|#yO}#zO!P#{O!i#wO!k#xO(XVOP!saZ!san!sa!Y!sa!h!sa!o!sa#j!sa#k!sa#l!sa#m!sa#n!sa#o!sa#p!sa#q!sa#r!sa#t!sa#v!sa#x!sa#y!sa(h!sa(o!sa(p!sa~O`!sa'r!sa'p!sa!V!sa!j!sar!sa![!sa%c!sa!d!sa~P!=hOg%VOj+^O!['ZO%c+]O~O!d+`O`(TX![(TX'r(TX!Y(TX~O`%kO![XO'r%kO~Og%VO!k%bO~Og%VO!k%bO'{%dO~O!d#uO#g(rO~Oa+kO%d+lO'{+hO'}TO(QUO!Z)OP~O!Y+mO_(}X~OZ+qO~O_+rO~O![%{O'{%dO'|!lO_(}P~Og%VO#[+wO~Og%VOj+zO![$|O~O![+|O~O|,OO![XO~O%h%rO~O!w,TO~Od,YO~Oa,ZO'{#mO'}TO(QUO!Z(|P~Od%yO~O%d!QO'{&UO~P<}OZ,`O_,_O~OPYOQYORfOczOdyOlkOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO!fuO!kZO!nYO!oYO!pYO!rvO!wxO!{]O%b}O'}TO(QUO(XVO(g[O(tiO~O![!eO!t!gO$T!kO'{!dO~P!DkO_,_O`%kO'r%kO~OPYOQYORfOc!jOd!iOlkOnYOokOpkOvkOxYOzYO!PWO!TkO!UkO![!eO!fuO!kZO!nYO!oYO!pYO!rvO!w!hO$T!kO'{!dO'}TO(QUO(XVO(g[O(tiO~O`,eO!twO#s!OO%f!OO%g!OO%h!OO~P!GTO!k&jO~O&V,kO~O![,mO~O&h,oO&j,pOP&eaQ&eaR&eaX&ea`&eac&ead&eal&ean&eao&eap&eav&eax&eaz&ea!P&ea!T&ea!U&ea![&ea!f&ea!k&ea!n&ea!o&ea!p&ea!r&ea!t&ea!w&ea!{&ea#s&ea$T&ea%b&ea%d&ea%f&ea%g&ea%h&ea%k&ea%m&ea%p&ea%q&ea%s&ea&P&ea&V&ea&X&ea&Z&ea&]&ea&`&ea&f&ea&l&ea&n&ea&p&ea&r&ea&t&ea'p&ea'{&ea'}&ea(Q&ea(X&ea(g&ea(t&ea!Z&ea&^&eaa&ea&c&ea~O'{,uO~Og!bX!Y!OX!Y!bX!Z!OX!Z!bX!d!OX!d!bX!k!bX#[!OX~O!d,zO#[,yOg(aX!Y#dX!Y(aX!Z#dX!Z(aX!d(aX!k(aX~Og%VO!d,|O!k%bO!Y!^X!Z!^X~Oo!nO!P!oO'}TO(QUO([!mO~OP:cOQ:cORfOc<[Od!iOlkOn:cOokOpkOvkOx:cOz:cO!PWO!TkO!UkO![!eO!f:fO!kZO!n:cO!o:cO!p:cO!r:gO!t:jO!w!hO$T!kO'}TO(QUO(XVO(g[O(t<YO~O'{;]O~P#!ZO!Y-QO!Z(`X~O!Z-SO~O!d,zO#[,yO!Y#dX!Z#dX~O!Y-TO!Z(nX~O!Z-VO~O!`-WO!a-WO'|!lO~P# xO!Z-ZO~P'_Oj-^O!['ZO~O!V-cO~Oo!za!_!za!`!za!a!za#P!za#Q!za#R!za#S!za#T!za#W!za#X!za'|!za'}!za(Q!za([!za(g!za~P!#`O!o-hO#[-fO~PCOO!`-jO!a-jO'|!lO~PCnO`%kO#[-fO'r%kO~O`%kO!d#uO#[-fO'r%kO~O`%kO!d#uO!o-hO#[-fO'r%kO(h'kO~O'w'sO'x'sO'y-oO~Or-pO~O!V'Pa!Y'Pa~P!8dO!X-tO!V'PX!Y'PX~P%[O!Y(PO!V(_a~O!V(_a~PGbO!Y(WO!V(la~O!P%eO!X-xO![%fO'{%dO!V'VX!Y'VX~O#[-zO!Y(ja!j(ja`(ja'r(ja~O!d#uO~P#*aO!Y(dO!j(ia~O!P%eO![%fO#f.OO'{%dO~Ol.TO!P%eO!X.QO![%fO!{]O#e.SO#f.QO'{%dO!Y'YX!j'YX~O}.XO!k#xO~Og%VOj.[O!['ZO%c.ZO~O`#_i!Y#_i'r#_i'p#_i!V#_i!j#_ir#_i![#_i%c#_i!d#_i~P!8dOj<fO|)zO!P){O(o$}O(p%PO~O#g#Za`#Za#[#Za'r#Za!Y#Za!j#Za![#Za!V#Za~P#-]O#g(WXP(WXZ(WX`(WXn(WX}(WX!h(WX!k(WX!o(WX#j(WX#k(WX#l(WX#m(WX#n(WX#o(WX#p(WX#q(WX#r(WX#t(WX#v(WX#x(WX#y(WX'r(WX(X(WX(h(WX!j(WX!V(WX'p(WXr(WX![(WX%c(WX!d(WX~P!4qO!Y.iOf(bX~P!0}Of.kO~O!Y.lO!j(cX~P!8dO!j.oO~O!V.qO~OP$]O|#yO}#zO!P#{O!i#wO!k#xO!o$]O(XVOZ#ii`#iin#ii!Y#ii!h#ii#k#ii#l#ii#m#ii#n#ii#o#ii#p#ii#q#ii#r#ii#t#ii#v#ii#x#ii#y#ii'r#ii(h#ii(o#ii(p#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~O#j#ii~P#1XO#j$OO~P#1XOP$]O|#yO}#zO!P#{O!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO(XVOZ#ii`#ii!Y#ii!h#ii#n#ii#o#ii#p#ii#q#ii#r#ii#t#ii#v#ii#x#ii#y#ii'r#ii(h#ii(o#ii(p#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~On#ii~P#3yOn$QO~P#3yOP$]On$QO|#yO}#zO!P#{O!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO(XVO`#ii!Y#ii#t#ii#v#ii#x#ii#y#ii'r#ii(h#ii(o#ii(p#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~OZ#ii!h#ii#o#ii#p#ii#q#ii#r#ii~P#6kOZ$dO!h$SO#o$SO#p$SO#q$cO#r$SO~P#6kOP$]OZ$dOn$QO|#yO}#zO!P#{O!h$SO!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO#o$SO#p$SO#q$cO#r$SO#t$TO(XVO(p#}O`#ii!Y#ii#x#ii#y#ii'r#ii(h#ii(o#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~O#v$VO~P#9lO#v#ii~P#9lOP$]OZ$dOn$QO|#yO}#zO!P#{O!h$SO!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO#o$SO#p$SO#q$cO#r$SO#t$TO(XVO`#ii!Y#ii#x#ii#y#ii'r#ii(h#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~O#v#ii(o#ii(p#ii~P#<^O#v$VO(o#|O(p#}O~P#<^OP$]OZ$dOn$QO|#yO}#zO!P#{O!h$SO!i#wO!k#xO!o$]O#j$OO#k$PO#l$PO#m$PO#n$RO#o$SO#p$SO#q$cO#r$SO#t$TO#v$VO#x$XO(XVO(o#|O(p#}O~O`#ii!Y#ii#y#ii'r#ii(h#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~P#?UOP[XZ[Xn[X|[X}[X!P[X!h[X!i[X!k[X!o[X#[[X#geX#j[X#k[X#l[X#m[X#n[X#o[X#p[X#q[X#r[X#t[X#v[X#x[X#y[X$O[X(X[X(h[X(o[X(p[X!Y[X!Z[X~O#|[X~P#AoOP$]OZ:zOn:nO|#yO}#zO!P#{O!h:pO!i#wO!k#xO!o$]O#j:lO#k:mO#l:mO#m:mO#n:oO#o:pO#p:pO#q:yO#r:pO#t:qO#v:sO#x:uO#y:vO(XVO(h$ZO(o#|O(p#}O~O#|.sO~P#C|O#[:{O$O:{O#|(^X!Z(^X~P! [O`']a!Y']a'r']a'p']a!j']a!V']ar']a![']a%c']a!d']a~P!8dOP#iiZ#ii`#iin#ii}#ii!Y#ii!h#ii!i#ii!k#ii!o#ii#j#ii#k#ii#l#ii#m#ii#n#ii#o#ii#p#ii#q#ii#r#ii#t#ii#v#ii#x#ii#y#ii'r#ii(X#ii(h#ii'p#ii!V#ii!j#iir#ii![#ii%c#ii!d#ii~P#-]O`#}i!Y#}i'r#}i'p#}i!V#}i!j#}ir#}i![#}i%c#}i!d#}i~P!8dO$Y.xO$[.xO~O$Y.yO$[.yO~O!d)cO#[.zO![$`X$W$`X$Y$`X$[$`X$c$`X~O!X.{O~O![)fO$W.}O$Y)eO$[)eO$c/OO~O!Y:wO!Z(]X~P#C|O!Z/PO~O!d)cO$c(qX~O$c/RO~Ot)uO(Y)vO(Z/UO~O!V/YO~P!&dO(o$}Oj%Za|%Za!P%Za(p%Za!Y%Za#[%Za~Of%Za#|%Za~P#L^O(p%POj%]a|%]a!P%]a(o%]a!Y%]a#[%]a~Of%]a#|%]a~P#MPO!YeX!deX!jeX!j$uX(heX~P!/tO!j/bO~P#-]O!Y/cO!d#uO(h'kO!j(uX~O!j/hO~O!X*WO'{%dO!j(uP~O#g/jO~O!V$uX!Y$uX!d$|X~P!/tO!Y/kO!V(vX~P#-]O!d/mO~O!V/oO~Og%VOn/sO!d#uO!k%bO(h'kO~O'{/uO~O!d+`O~O`%kO!Y/yO'r%kO~O!Z/{O~P!3xO!`/|O!a/|O'|!lO([!mO~O!P0OO([!mO~O#W0PO~Of%Za!Y%Za#[%Za#|%Za~P!0}Of%]a!Y%]a#[%]a#|%]a~P!0}O'{&UOf'fX!Y'fX~O!Y*rOf(Ua~Of0YO~O|0ZO}0ZO!P0[Ojya(oya(pya!Yya#[ya~Ofya#|ya~P$$jO|)zO!P){Oj$na(o$na(p$na!Y$na#[$na~Of$na#|$na~P$%`O|)zO!P){Oj$pa(o$pa(p$pa!Y$pa#[$pa~Of$pa#|$pa~P$&RO#g0^O~Of%Oa!Y%Oa#[%Oa#|%Oa~P!0}O!d#uO~O#g0aO~O!Y+TO`(za'r(za~O|#yO}#zO!P#{O!i#wO!k#xO(XVOP!qiZ!qin!qi!Y!qi!h!qi!o!qi#j!qi#k!qi#l!qi#m!qi#n!qi#o!qi#p!qi#q!qi#r!qi#t!qi#v!qi#x!qi#y!qi(h!qi(o!qi(p!qi~O`!qi'r!qi'p!qi!V!qi!j!qir!qi![!qi%c!qi!d!qi~P$'pOg%VOn$tOo$sOp$sOv%XOx%YOz;QO!P${O![$|O!f<`O!k$xO#f;WO$T%^O$o;SO$q;UO$t%_O'}TO(QUO(X$uO(o$}O(p%PO~Ol0kO'{0jO~P$*ZO!d+`O`(Ta![(Ta'r(Ta!Y(Ta~O#g0qO~OZ[X!YeX!ZeX~O!Y0rO!Z)OX~O!Z0tO~OZ0uO~Oa0wO'{+hO'}TO(QUO~O![%{O'{%dO_'nX!Y'nX~O!Y+mO_(}a~O!j0zO~P!8dOZ0}O~O_1OO~O#[1RO~Oj1UO![$|O~O([(xO!Z({P~Og%VOj1_O![1[O%c1^O~OZ1iO!Y1gO!Z(|X~O!Z1jO~O_1lO`%kO'r%kO~O'{#mO'}TO(QUO~O#[$eO$O$eOP(^XZ(^Xn(^X|(^X}(^X!P(^X!Y(^X!h(^X!k(^X!o(^X#j(^X#k(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#t(^X#v(^X#x(^X#y(^X(X(^X(h(^X(o(^X(p(^X~O#r1oO&T1pO`(^X!i(^X~P$/qO#[$eO#r1oO&T1pO~O`1rO~P%[O`1tO~O&^1wOP&[iQ&[iR&[iX&[i`&[ic&[id&[il&[in&[io&[ip&[iv&[ix&[iz&[i!P&[i!T&[i!U&[i![&[i!f&[i!k&[i!n&[i!o&[i!p&[i!r&[i!t&[i!w&[i!{&[i#s&[i$T&[i%b&[i%d&[i%f&[i%g&[i%h&[i%k&[i%m&[i%p&[i%q&[i%s&[i&P&[i&V&[i&X&[i&Z&[i&]&[i&`&[i&f&[i&l&[i&n&[i&p&[i&r&[i&t&[i'p&[i'{&[i'}&[i(Q&[i(X&[i(g&[i(t&[i!Z&[ia&[i&c&[i~Oa1}O!Z1{O&c1|O~P`O![XO!k2PO~O&j,pOP&eiQ&eiR&eiX&ei`&eic&eid&eil&ein&eio&eip&eiv&eix&eiz&ei!P&ei!T&ei!U&ei![&ei!f&ei!k&ei!n&ei!o&ei!p&ei!r&ei!t&ei!w&ei!{&ei#s&ei$T&ei%b&ei%d&ei%f&ei%g&ei%h&ei%k&ei%m&ei%p&ei%q&ei%s&ei&P&ei&V&ei&X&ei&Z&ei&]&ei&`&ei&f&ei&l&ei&n&ei&p&ei&r&ei&t&ei'p&ei'{&ei'}&ei(Q&ei(X&ei(g&ei(t&ei!Z&ei&^&eia&ei&c&ei~O!V2VO~O!Y!^a!Z!^a~P#C|Oo!nO!P!oO!X2]O([!mO!Y'QX!Z'QX~P@UO!Y-QO!Z(`a~O!Y'WX!Z'WX~P!7lO!Y-TO!Z(na~O!Z2dO~P'_O`%kO#[2mO'r%kO~O`%kO!d#uO#[2mO'r%kO~O`%kO!d#uO!o2qO#[2mO'r%kO(h'kO~O`%kO'r%kO~P!8dO!Y$aOr$ma~O!V'Pi!Y'Pi~P!8dO!Y(PO!V(_i~O!Y(WO!V(li~O!V(mi!Y(mi~P!8dO!Y(ji!j(ji`(ji'r(ji~P!8dO#[2sO!Y(ji!j(ji`(ji'r(ji~O!Y(dO!j(ii~O!P%eO![%fO!{]O#e2xO#f2wO'{%dO~O!P%eO![%fO#f2wO'{%dO~Oj3PO!['ZO%c3OO~Og%VOj3PO!['ZO%c3OO~O#g%ZaP%ZaZ%Za`%Zan%Za}%Za!h%Za!i%Za!k%Za!o%Za#j%Za#k%Za#l%Za#m%Za#n%Za#o%Za#p%Za#q%Za#r%Za#t%Za#v%Za#x%Za#y%Za'r%Za(X%Za(h%Za!j%Za!V%Za'p%Zar%Za![%Za%c%Za!d%Za~P#L^O#g%]aP%]aZ%]a`%]an%]a}%]a!h%]a!i%]a!k%]a!o%]a#j%]a#k%]a#l%]a#m%]a#n%]a#o%]a#p%]a#q%]a#r%]a#t%]a#v%]a#x%]a#y%]a'r%]a(X%]a(h%]a!j%]a!V%]a'p%]ar%]a![%]a%c%]a!d%]a~P#MPO#g%ZaP%ZaZ%Za`%Zan%Za}%Za!Y%Za!h%Za!i%Za!k%Za!o%Za#j%Za#k%Za#l%Za#m%Za#n%Za#o%Za#p%Za#q%Za#r%Za#t%Za#v%Za#x%Za#y%Za'r%Za(X%Za(h%Za!j%Za!V%Za'p%Za#[%Zar%Za![%Za%c%Za!d%Za~P#-]O#g%]aP%]aZ%]a`%]an%]a}%]a!Y%]a!h%]a!i%]a!k%]a!o%]a#j%]a#k%]a#l%]a#m%]a#n%]a#o%]a#p%]a#q%]a#r%]a#t%]a#v%]a#x%]a#y%]a'r%]a(X%]a(h%]a!j%]a!V%]a'p%]a#[%]ar%]a![%]a%c%]a!d%]a~P#-]O#gyaPyaZya`yanya!hya!iya!kya!oya#jya#kya#lya#mya#nya#oya#pya#qya#rya#tya#vya#xya#yya'rya(Xya(hya!jya!Vya'pyarya![ya%cya!dya~P$$jO#g$naP$naZ$na`$nan$na}$na!h$na!i$na!k$na!o$na#j$na#k$na#l$na#m$na#n$na#o$na#p$na#q$na#r$na#t$na#v$na#x$na#y$na'r$na(X$na(h$na!j$na!V$na'p$nar$na![$na%c$na!d$na~P$%`O#g$paP$paZ$pa`$pan$pa}$pa!h$pa!i$pa!k$pa!o$pa#j$pa#k$pa#l$pa#m$pa#n$pa#o$pa#p$pa#q$pa#r$pa#t$pa#v$pa#x$pa#y$pa'r$pa(X$pa(h$pa!j$pa!V$pa'p$par$pa![$pa%c$pa!d$pa~P$&RO#g%OaP%OaZ%Oa`%Oan%Oa}%Oa!Y%Oa!h%Oa!i%Oa!k%Oa!o%Oa#j%Oa#k%Oa#l%Oa#m%Oa#n%Oa#o%Oa#p%Oa#q%Oa#r%Oa#t%Oa#v%Oa#x%Oa#y%Oa'r%Oa(X%Oa(h%Oa!j%Oa!V%Oa'p%Oa#[%Oar%Oa![%Oa%c%Oa!d%Oa~P#-]O`#_q!Y#_q'r#_q'p#_q!V#_q!j#_qr#_q![#_q%c#_q!d#_q~P!8dOf'RX!Y'RX~P!(SO!Y.iOf(ba~O!X3ZO!Y'SX!j'SX~P%[O!Y.lO!j(ca~O!Y.lO!j(ca~P!8dO!V3^O~O#|!ma!Z!ma~PKOO#|!ea!Y!ea!Z!ea~P#C|O#|!qa!Z!qa~P!:}O#|!sa!Z!sa~P!=hORfO![3pO$a3qO~O!Z3uO~Or3vO~P#-]O`$jq!Y$jq'r$jq'p$jq!V$jq!j$jqr$jq![$jq%c$jq!d$jq~P!8dO!V3wO~P#-]O|)zO!P){O(p%POj'ba(o'ba!Y'ba#['ba~Of'ba#|'ba~P%)eO|)zO!P){Oj'da(o'da(p'da!Y'da#['da~Of'da#|'da~P%*WO(h$ZO~P#-]O!X3zO'{%dO!Y'^X!j'^X~O!Y/cO!j(ua~O!Y/cO!d#uO!j(ua~O!Y/cO!d#uO(h'kO!j(ua~Of$wi!Y$wi#[$wi#|$wi~P!0}O!X4SO'{*]O!V'`X!Y'`X~P!1lO!Y/kO!V(va~O!Y/kO!V(va~P#-]O!d#uO#r4[O~On4_O!d#uO(h'kO~O(o$}Oj%Zi|%Zi!P%Zi(p%Zi!Y%Zi#[%Zi~Of%Zi#|%Zi~P%-jO(p%POj%]i|%]i!P%]i(o%]i!Y%]i#[%]i~Of%]i#|%]i~P%.]Of(Vi!Y(Vi~P!0}O#[4fOf(Vi!Y(Vi~P!0}O!j4iO~O`$kq!Y$kq'r$kq'p$kq!V$kq!j$kqr$kq![$kq%c$kq!d$kq~P!8dO!V4mO~O!Y4nO![(wX~P#-]O!i#wO~P4XO`$uX![$uX%W[X'r$uX!Y$uX~P!/tO%W4pO`kXjkX|kX!PkX![kX'rkX(okX(pkX!YkX~O%W4pO~Oa4vO%d4wO'{+hO'}TO(QUO!Y'mX!Z'mX~O!Y0rO!Z)Oa~OZ4{O~O_4|O~O`%kO'r%kO~P#-]O![$|O~P#-]O!Y5UO#[5WO!Z({X~O!Z5XO~Oo!nO!P5YO!_!xO!`!uO!a!uO!{:dO#P!pO#Q!pO#R!pO#S!pO#T!pO#W5_O#X!yO'|!lO'}TO(QUO([!mO(g!sO~O!Z5^O~P%3nOj5dO![1[O%c5cO~Og%VOj5dO![1[O%c5cO~Oa5kO'{#mO'}TO(QUO!Y'lX!Z'lX~O!Y1gO!Z(|a~O'}TO(QUO([5mO~O_5qO~O#r5tO&T5uO~PMnO!j5vO~P%[O`5xO~O`5xO~P%[Oa1}O!Z5}O&c1|O~P`O!d6PO~O!d6ROg(ai!Y(ai!Z(ai!d(ai!k(ai~O!Y#di!Z#di~P#C|O#[6SO!Y#di!Z#di~O!Y!^i!Z!^i~P#C|O`%kO#[6]O'r%kO~O`%kO!d#uO#[6]O'r%kO~O!Y(jq!j(jq`(jq'r(jq~P!8dO!Y(dO!j(iq~O!P%eO![%fO#f6dO'{%dO~O!['ZO%c6gO~Oj6jO!['ZO%c6gO~O#g'baP'baZ'ba`'ban'ba}'ba!h'ba!i'ba!k'ba!o'ba#j'ba#k'ba#l'ba#m'ba#n'ba#o'ba#p'ba#q'ba#r'ba#t'ba#v'ba#x'ba#y'ba'r'ba(X'ba(h'ba!j'ba!V'ba'p'bar'ba!['ba%c'ba!d'ba~P%)eO#g'daP'daZ'da`'dan'da}'da!h'da!i'da!k'da!o'da#j'da#k'da#l'da#m'da#n'da#o'da#p'da#q'da#r'da#t'da#v'da#x'da#y'da'r'da(X'da(h'da!j'da!V'da'p'dar'da!['da%c'da!d'da~P%*WO#g$wiP$wiZ$wi`$win$wi}$wi!Y$wi!h$wi!i$wi!k$wi!o$wi#j$wi#k$wi#l$wi#m$wi#n$wi#o$wi#p$wi#q$wi#r$wi#t$wi#v$wi#x$wi#y$wi'r$wi(X$wi(h$wi!j$wi!V$wi'p$wi#[$wir$wi![$wi%c$wi!d$wi~P#-]O#g%ZiP%ZiZ%Zi`%Zin%Zi}%Zi!h%Zi!i%Zi!k%Zi!o%Zi#j%Zi#k%Zi#l%Zi#m%Zi#n%Zi#o%Zi#p%Zi#q%Zi#r%Zi#t%Zi#v%Zi#x%Zi#y%Zi'r%Zi(X%Zi(h%Zi!j%Zi!V%Zi'p%Zir%Zi![%Zi%c%Zi!d%Zi~P%-jO#g%]iP%]iZ%]i`%]in%]i}%]i!h%]i!i%]i!k%]i!o%]i#j%]i#k%]i#l%]i#m%]i#n%]i#o%]i#p%]i#q%]i#r%]i#t%]i#v%]i#x%]i#y%]i'r%]i(X%]i(h%]i!j%]i!V%]i'p%]ir%]i![%]i%c%]i!d%]i~P%.]Of'Ra!Y'Ra~P!0}O!Y'Sa!j'Sa~P!8dO!Y.lO!j(ci~O#|#_i!Y#_i!Z#_i~P#C|OP$]O|#yO}#zO!P#{O!i#wO!k#xO!o$]O(XVOZ#iin#ii!h#ii#k#ii#l#ii#m#ii#n#ii#o#ii#p#ii#q#ii#r#ii#t#ii#v#ii#x#ii#y#ii#|#ii(h#ii(o#ii(p#ii!Y#ii!Z#ii~O#j#ii~P%FnO#j:lO~P%FnOP$]O|#yO}#zO!P#{O!i#wO!k#xO!o$]O#j:lO#k:mO#l:mO#m:mO(XVOZ#ii!h#ii#n#ii#o#ii#p#ii#q#ii#r#ii#t#ii#v#ii#x#ii#y#ii#|#ii(h#ii(o#ii(p#ii!Y#ii!Z#ii~On#ii~P%HyOn:nO~P%HyOP$]On:nO|#yO}#zO!P#{O!i#wO!k#xO!o$]O#j:lO#k:mO#l:mO#m:mO#n:oO(XVO#t#ii#v#ii#x#ii#y#ii#|#ii(h#ii(o#ii(p#ii!Y#ii!Z#ii~OZ#ii!h#ii#o#ii#p#ii#q#ii#r#ii~P%KUOZ:zO!h:pO#o:pO#p:pO#q:yO#r:pO~P%KUOP$]OZ:zOn:nO|#yO}#zO!P#{O!h:pO!i#wO!k#xO!o$]O#j:lO#k:mO#l:mO#m:mO#n:oO#o:pO#p:pO#q:yO#r:pO#t:qO(XVO(p#}O#x#ii#y#ii#|#ii(h#ii(o#ii!Y#ii!Z#ii~O#v:sO~P%MpO#v#ii~P%MpOP$]OZ:zOn:nO|#yO}#zO!P#{O!h:pO!i#wO!k#xO!o$]O#j:lO#k:mO#l:mO#m:mO#n:oO#o:pO#p:pO#q:yO#r:pO#t:qO(XVO#x#ii#y#ii#|#ii(h#ii!Y#ii!Z#ii~O#v#ii(o#ii(p#ii~P& {O#v:sO(o#|O(p#}O~P& {OP$]OZ:zOn:nO|#yO}#zO!P#{O!h:pO!i#wO!k#xO!o$]O#j:lO#k:mO#l:mO#m:mO#n:oO#o:pO#p:pO#q:yO#r:pO#t:qO#v:sO#x:uO(XVO(o#|O(p#}O~O#y#ii#|#ii(h#ii!Y#ii!Z#ii~P&$^O`#zy!Y#zy'r#zy'p#zy!V#zy!j#zyr#zy![#zy%c#zy!d#zy~P!8dOj<gO|)zO!P){O(o$}O(p%PO~OP#iiZ#iin#ii}#ii!h#ii!i#ii!k#ii!o#ii#j#ii#k#ii#l#ii#m#ii#n#ii#o#ii#p#ii#q#ii#r#ii#t#ii#v#ii#x#ii#y#ii#|#ii(X#ii(h#ii!Y#ii!Z#ii~P&'UO!i#wOP(WXZ(WXj(WXn(WX|(WX}(WX!P(WX!h(WX!k(WX!o(WX#j(WX#k(WX#l(WX#m(WX#n(WX#o(WX#p(WX#q(WX#r(WX#t(WX#v(WX#x(WX#y(WX#|(WX(X(WX(h(WX(o(WX(p(WX!Y(WX!Z(WX~O#|#}i!Y#}i!Z#}i~P#C|O#|!qi!Z!qi~P$'pO!Z6|O~O!Y']a!Z']a~P#C|O!d#uO(h'kO!Y'^a!j'^a~O!Y/cO!j(ui~O!Y/cO!d#uO!j(ui~Of$wq!Y$wq#[$wq#|$wq~P!0}O!V'`a!Y'`a~P#-]O!d7TO~O!Y/kO!V(vi~P#-]O!Y/kO!V(vi~O!V7XO~O!d#uO#r7^O~On7_O!d#uO(h'kO~O|)zO!P){O(p%POj'ca(o'ca!Y'ca#['ca~Of'ca#|'ca~P&.fO|)zO!P){Oj'ea(o'ea(p'ea!Y'ea#['ea~Of'ea#|'ea~P&/XO!V7aO~Of$yq!Y$yq#[$yq#|$yq~P!0}O`$ky!Y$ky'r$ky'p$ky!V$ky!j$kyr$ky![$ky%c$ky!d$ky~P!8dO!d6RO~O!Y4nO![(wa~O`#_y!Y#_y'r#_y'p#_y!V#_y!j#_yr#_y![#_y%c#_y!d#_y~P!8dOZ7fO~Oa7hO'{+hO'}TO(QUO~O!Y0rO!Z)Oi~O_7lO~O([(xO!Y'iX!Z'iX~O!Y5UO!Z({a~OlkO'{7sO~P.iO!Z7vO~P%3nOo!nO!P7wO'}TO(QUO([!mO(g!sO~O![1[O~O![1[O%c7yO~Oj7|O![1[O%c7yO~OZ8RO!Y'la!Z'la~O!Y1gO!Z(|i~O!j8VO~O!j8WO~O!j8ZO~O!j8ZO~P%[O`8]O~O!d8^O~O!j8_O~O!Y(mi!Z(mi~P#C|O`%kO#[8gO'r%kO~O!Y(jy!j(jy`(jy'r(jy~P!8dO!Y(dO!j(iy~O!['ZO%c8jO~O#g$wqP$wqZ$wq`$wqn$wq}$wq!Y$wq!h$wq!i$wq!k$wq!o$wq#j$wq#k$wq#l$wq#m$wq#n$wq#o$wq#p$wq#q$wq#r$wq#t$wq#v$wq#x$wq#y$wq'r$wq(X$wq(h$wq!j$wq!V$wq'p$wq#[$wqr$wq![$wq%c$wq!d$wq~P#-]O#g'caP'caZ'ca`'can'ca}'ca!h'ca!i'ca!k'ca!o'ca#j'ca#k'ca#l'ca#m'ca#n'ca#o'ca#p'ca#q'ca#r'ca#t'ca#v'ca#x'ca#y'ca'r'ca(X'ca(h'ca!j'ca!V'ca'p'car'ca!['ca%c'ca!d'ca~P&.fO#g'eaP'eaZ'ea`'ean'ea}'ea!h'ea!i'ea!k'ea!o'ea#j'ea#k'ea#l'ea#m'ea#n'ea#o'ea#p'ea#q'ea#r'ea#t'ea#v'ea#x'ea#y'ea'r'ea(X'ea(h'ea!j'ea!V'ea'p'ear'ea!['ea%c'ea!d'ea~P&/XO#g$yqP$yqZ$yq`$yqn$yq}$yq!Y$yq!h$yq!i$yq!k$yq!o$yq#j$yq#k$yq#l$yq#m$yq#n$yq#o$yq#p$yq#q$yq#r$yq#t$yq#v$yq#x$yq#y$yq'r$yq(X$yq(h$yq!j$yq!V$yq'p$yq#[$yqr$yq![$yq%c$yq!d$yq~P#-]O!Y'Si!j'Si~P!8dO#|#_q!Y#_q!Z#_q~P#C|O(o$}OP%ZaZ%Zan%Za}%Za!h%Za!i%Za!k%Za!o%Za#j%Za#k%Za#l%Za#m%Za#n%Za#o%Za#p%Za#q%Za#r%Za#t%Za#v%Za#x%Za#y%Za#|%Za(X%Za(h%Za!Y%Za!Z%Za~Oj%Za|%Za!P%Za(p%Za~P&@nO(p%POP%]aZ%]an%]a}%]a!h%]a!i%]a!k%]a!o%]a#j%]a#k%]a#l%]a#m%]a#n%]a#o%]a#p%]a#q%]a#r%]a#t%]a#v%]a#x%]a#y%]a#|%]a(X%]a(h%]a!Y%]a!Z%]a~Oj%]a|%]a!P%]a(o%]a~P&BuOj<gO|)zO!P){O(p%PO~P&@nOj<gO|)zO!P){O(o$}O~P&BuO|0ZO}0ZO!P0[OPyaZyajyanya!hya!iya!kya!oya#jya#kya#lya#mya#nya#oya#pya#qya#rya#tya#vya#xya#yya#|ya(Xya(hya(oya(pya!Yya!Zya~O|)zO!P){OP$naZ$naj$nan$na}$na!h$na!i$na!k$na!o$na#j$na#k$na#l$na#m$na#n$na#o$na#p$na#q$na#r$na#t$na#v$na#x$na#y$na#|$na(X$na(h$na(o$na(p$na!Y$na!Z$na~O|)zO!P){OP$paZ$paj$pan$pa}$pa!h$pa!i$pa!k$pa!o$pa#j$pa#k$pa#l$pa#m$pa#n$pa#o$pa#p$pa#q$pa#r$pa#t$pa#v$pa#x$pa#y$pa#|$pa(X$pa(h$pa(o$pa(p$pa!Y$pa!Z$pa~OP%OaZ%Oan%Oa}%Oa!h%Oa!i%Oa!k%Oa!o%Oa#j%Oa#k%Oa#l%Oa#m%Oa#n%Oa#o%Oa#p%Oa#q%Oa#r%Oa#t%Oa#v%Oa#x%Oa#y%Oa#|%Oa(X%Oa(h%Oa!Y%Oa!Z%Oa~P&'UO#|$jq!Y$jq!Z$jq~P#C|O#|$kq!Y$kq!Z$kq~P#C|O!Z8vO~O#|8wO~P!0}O!d#uO!Y'^i!j'^i~O!d#uO(h'kO!Y'^i!j'^i~O!Y/cO!j(uq~O!V'`i!Y'`i~P#-]O!Y/kO!V(vq~O!V8}O~P#-]O!V8}O~Of(Vy!Y(Vy~P!0}O!Y'ga!['ga~P#-]O`%Vq![%Vq'r%Vq!Y%Vq~P#-]OZ9SO~O!Y0rO!Z)Oq~O#[9WO!Y'ia!Z'ia~O!Y5UO!Z({i~P#C|OP[XZ[Xn[X|[X}[X!P[X!V[X!Y[X!h[X!i[X!k[X!o[X#[[X#geX#j[X#k[X#l[X#m[X#n[X#o[X#p[X#q[X#r[X#t[X#v[X#x[X#y[X$O[X(X[X(h[X(o[X(p[X~O!d%TX#r%TX~P'#`O![1[O%c9[O~O'}TO(QUO([9aO~O!Y1gO!Z(|q~O!j9dO~O!j9eO~O!j9fO~O!j9fO~P%[O#[9iO!Y#dy!Z#dy~O!Y#dy!Z#dy~P#C|O!['ZO%c9nO~O#|#zy!Y#zy!Z#zy~P#C|OP$wiZ$win$wi}$wi!h$wi!i$wi!k$wi!o$wi#j$wi#k$wi#l$wi#m$wi#n$wi#o$wi#p$wi#q$wi#r$wi#t$wi#v$wi#x$wi#y$wi#|$wi(X$wi(h$wi!Y$wi!Z$wi~P&'UO|)zO!P){O(p%POP'baZ'baj'ban'ba}'ba!h'ba!i'ba!k'ba!o'ba#j'ba#k'ba#l'ba#m'ba#n'ba#o'ba#p'ba#q'ba#r'ba#t'ba#v'ba#x'ba#y'ba#|'ba(X'ba(h'ba(o'ba!Y'ba!Z'ba~O|)zO!P){OP'daZ'daj'dan'da}'da!h'da!i'da!k'da!o'da#j'da#k'da#l'da#m'da#n'da#o'da#p'da#q'da#r'da#t'da#v'da#x'da#y'da#|'da(X'da(h'da(o'da(p'da!Y'da!Z'da~O(o$}OP%ZiZ%Zij%Zin%Zi|%Zi}%Zi!P%Zi!h%Zi!i%Zi!k%Zi!o%Zi#j%Zi#k%Zi#l%Zi#m%Zi#n%Zi#o%Zi#p%Zi#q%Zi#r%Zi#t%Zi#v%Zi#x%Zi#y%Zi#|%Zi(X%Zi(h%Zi(p%Zi!Y%Zi!Z%Zi~O(p%POP%]iZ%]ij%]in%]i|%]i}%]i!P%]i!h%]i!i%]i!k%]i!o%]i#j%]i#k%]i#l%]i#m%]i#n%]i#o%]i#p%]i#q%]i#r%]i#t%]i#v%]i#x%]i#y%]i#|%]i(X%]i(h%]i(o%]i!Y%]i!Z%]i~O#|$ky!Y$ky!Z$ky~P#C|O#|#_y!Y#_y!Z#_y~P#C|O!d#uO!Y'^q!j'^q~O!Y/cO!j(uy~O!V'`q!Y'`q~P#-]O!V9wO~P#-]O!Y0rO!Z)Oy~O!Y5UO!Z({q~O![1[O%c:OO~O!j:RO~O!['ZO%c:WO~OP$wqZ$wqn$wq}$wq!h$wq!i$wq!k$wq!o$wq#j$wq#k$wq#l$wq#m$wq#n$wq#o$wq#p$wq#q$wq#r$wq#t$wq#v$wq#x$wq#y$wq#|$wq(X$wq(h$wq!Y$wq!Z$wq~P&'UO|)zO!P){O(p%POP'caZ'caj'can'ca}'ca!h'ca!i'ca!k'ca!o'ca#j'ca#k'ca#l'ca#m'ca#n'ca#o'ca#p'ca#q'ca#r'ca#t'ca#v'ca#x'ca#y'ca#|'ca(X'ca(h'ca(o'ca!Y'ca!Z'ca~O|)zO!P){OP'eaZ'eaj'ean'ea}'ea!h'ea!i'ea!k'ea!o'ea#j'ea#k'ea#l'ea#m'ea#n'ea#o'ea#p'ea#q'ea#r'ea#t'ea#v'ea#x'ea#y'ea#|'ea(X'ea(h'ea(o'ea(p'ea!Y'ea!Z'ea~OP$yqZ$yqn$yq}$yq!h$yq!i$yq!k$yq!o$yq#j$yq#k$yq#l$yq#m$yq#n$yq#o$yq#p$yq#q$yq#r$yq#t$yq#v$yq#x$yq#y$yq#|$yq(X$yq(h$yq!Y$yq!Z$yq~P&'UOf%_!Z!Y%_!Z#[%_!Z#|%_!Z~P!0}O!Y'iq!Z'iq~P#C|O!Y#d!Z!Z#d!Z~P#C|O#g%_!ZP%_!ZZ%_!Z`%_!Zn%_!Z}%_!Z!Y%_!Z!h%_!Z!i%_!Z!k%_!Z!o%_!Z#j%_!Z#k%_!Z#l%_!Z#m%_!Z#n%_!Z#o%_!Z#p%_!Z#q%_!Z#r%_!Z#t%_!Z#v%_!Z#x%_!Z#y%_!Z'r%_!Z(X%_!Z(h%_!Z!j%_!Z!V%_!Z'p%_!Z#[%_!Zr%_!Z![%_!Z%c%_!Z!d%_!Z~P#-]OP%_!ZZ%_!Zn%_!Z}%_!Z!h%_!Z!i%_!Z!k%_!Z!o%_!Z#j%_!Z#k%_!Z#l%_!Z#m%_!Z#n%_!Z#o%_!Z#p%_!Z#q%_!Z#r%_!Z#t%_!Z#v%_!Z#x%_!Z#y%_!Z#|%_!Z(X%_!Z(h%_!Z!Y%_!Z!Z%_!Z~P&'UOr(]X~P1qO'|!lO~P!*fO!VeX!YeX#[eX~P'#`OP[XZ[Xn[X|[X}[X!P[X!Y[X!YeX!h[X!i[X!k[X!o[X#[[X#[eX#geX#j[X#k[X#l[X#m[X#n[X#o[X#p[X#q[X#r[X#t[X#v[X#x[X#y[X$O[X(X[X(h[X(o[X(p[X~O!deX!j[X!jeX(heX~P'ASOP:cOQ:cORfOc<[Od!iOlkOn:cOokOpkOvkOx:cOz:cO!PWO!TkO!UkO![XO!f:fO!kZO!n:cO!o:cO!p:cO!r:gO!t:jO!w!hO$T!kO'{)YO'}TO(QUO(XVO(g[O(t<YO~O!Y:wO!Z$ma~Og%VOl%WOn$tOo$sOp$sOv%XOx%YOz;RO!P${O![$|O!f<aO!k$xO#f;XO$T%^O$o;TO$q;VO$t%_O'{(pO'}TO(QUO(X$uO(o$}O(p%PO~O#s)aO~P'ExO!Z[X!ZeX~P'ASO#g:kO~O!d#uO#g:kO~O#[:{O~O#r:pO~O#[;ZO!Y(mX!Z(mX~O#[:{O!Y(kX!Z(kX~O#g;[O~Of;^O~P!0}O#g;cO~O#g;dO~O!d#uO#g;eO~O!d#uO#g;[O~O#|;fO~P#C|O#g;gO~O#g;hO~O#g;mO~O#g;nO~O#g;oO~O#g;pO~O#|;qO~P!0}O#|;rO~P!0}O!i#P#Q#S#T#W#e#f#q(t$o$q$t%W%b%c%d%k%m%p%q%s%u~'vS#k!U't'|#lo#j#mn|'u$Y'u'{$[([~",
    goto: "$2p)SPPPPP)TPP)WP)iP*x.|PPPP5pPP6WPP<S?gP?zP?zPPP?zPAxP?zP?zP?zPA|PPBRPBlPGdPPPGhPPPPGhJiPPPJoKjPGhPMxPPPP!!WGhPPPGhPGhP!$fGhP!'z!(|!)VP!)y!)}!)yPPPPP!-Y!(|PP!-v!.pP!1dGhGh!1i!4s!9Y!9Y!=OPPP!=VGhPPPPPPPPPPP!@dP!AqPPGh!CSPGhPGhGhGhGhPGh!DfP!GnP!JrP!Jv!KQ!KU!KUP!GkP!KY!KYP!N^P!NbGhGh!Nh##k?zP?zP?z?zP#$v?z?z#'O?z#)k?z#+m?z?z#,[#.f#.f#.j#.r#.f#.zP#.fP?z#/d?z#3R?z?z5pPPP#6vPPP#7a#7aP#7aP#7w#7aPP#7}P#7tP#7t#8b#7t#8|#9S5m)W#9V)WP#9^#9^#9^P)WP)WP)WP)WPP)WP#9d#9gP#9g)WP#9kP#9nP)WP)WP)WP)WP)WP)W)WPP#9t#9z#:V#:]#:c#:i#:o#:}#;T#;Z#;e#;k#;u#<U#<[#<|#=`#=f#=l#=z#>a#@O#@^#@d#Ax#BW#Cr#DQ#DW#D^#Dd#Dn#Dt#Dz#EU#Eh#EnPPPPPPPPPP#EtPPPPPPP#Fi#Ip#KP#KW#K`PPPP$!d$%Z$+r$+u$+x$,q$,t$,w$-O$-WPP$-^$-b$.Y$/X$/]$/qPP$/u$/{$0PP$0S$0W$0Z$1P$1h$2P$2T$2W$2Z$2a$2d$2h$2lR!{RoqOXst!Z#c%j&m&o&p&r,h,m1w1zY!uQ'Z-Y1[5]Q%pvQ%xyQ&P|Q&e!VS'R!e-QQ'a!iS'g!r!xS*c$|*hQ+f%yQ+s&RQ,X&_Q-W'YQ-b'bQ-j'hQ/|*jQ1f,YR;Y:g%OdOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&m&o&p&r&v'O']'m'}(P(V(^(r(v(z)y+O+S,e,h,m-^-f-t-z.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3Z5Y5d5t5u5x6]7w7|8]8gS#p]:d!r)[$[$m'S)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]Q*u%ZQ+k%{Q,Z&bQ,b&jQ.c;QQ0h+^Q0l+`Q0w+lQ1n,`Q2{.[Q4v0rQ5k1gQ6i3PQ6u;RQ7h4wR8m6j&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]t!nQ!r!u!x!y'R'Y'Z'g'h'i-Q-W-Y-j1[5]5_$v$si#u#w$c$d$x${%O%Q%[%]%a)u){)}*P*R*Y*`*p*q+]+`+w+z.Z.i/Z/j/k/m0Q0S0^1R1U1^3O3x4S4[4f4n4p5c6g7T7^7y8j8w9[9n:O:W:y:z:|:};O;P;S;T;U;V;W;X;_;`;a;b;c;d;g;h;i;j;k;l;m;n;q;r<Y<b<c<f<gQ&S|Q'P!eS'V%f-TQ+k%{Q,Z&bQ0]*yQ0w+lQ0|+rQ1m,_Q1n,`Q4v0rQ5P1OQ5k1gQ5n1iQ5o1lQ7h4wQ7k4|Q8U5qQ9V7lR9b8RrnOXst!V!Z#c%j&d&m&o&p&r,h,m1w1zR,]&f&v^OPXYstuvwz!Z!`!g!j!o#R#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%j%p%}&f&i&j&m&o&p&r&v'O']'m(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<[<][#[WZ#V#Y'S'}!S%gm#g#h#k%b%e(W(b(c(d+Q+R+T,d,z-x.O.P.Q.S2P2w2x6R6dQ%sxQ%wyS%||&RQ&Y!TQ'^!hQ'`!iQ(k#rS*V$x*ZS+e%x%yQ+i%{Q,S&]Q,W&_S-a'a'bQ.^(lQ/g*WQ0p+fQ0v+lQ0x+mQ0{+qQ1a,TS1e,X,YQ2i-bQ3y/cQ4u0rQ4y0uQ5O0}Q5j1fQ7Q3zQ7g4wQ7j4{Q9R7fR9y9S!O$zi#w%O%Q%[%]%a)}*P*Y*p*q.i/j0Q0S0^3x4f8w<Y<b<c!S%uy!i!t%w%x%y'Q'`'a'b'f'p*b+e+f,}-a-b-i/t0p2b2i2p4^Q+_%sQ+x&VQ+{&WQ,V&_Q.](kQ1`,SU1d,W,X,YQ3Q.^Q5e1aS5i1e1fQ8Q5j#W<^#u$c$d$x${)u){*R*`+]+`+w+z.Z/Z/k/m1R1U1^3O4S4[4n4p5c6g7T7^7y8j9[9n:O:W:|;O;S;U;W;_;a;c;g;i;k;m;q<f<go<_:y:z:};P;T;V;X;`;b;d;h;j;l;n;rW%Ti%V*r<YS&V!Q&dQ&W!RQ&X!SR+v&T$w%Si#u#w$c$d$x${%O%Q%[%]%a)u){)}*P*R*Y*`*p*q+]+`+w+z.Z.i/Z/j/k/m0Q0S0^1R1U1^3O3x4S4[4f4n4p5c6g7T7^7y8j8w9[9n:O:W:y:z:|:};O;P;S;T;U;V;W;X;_;`;a;b;c;d;g;h;i;j;k;l;m;n;q;r<Y<b<c<f<gT)v$u)wV*v%Z;Q;RU'V!e%f-TS(y#y#zQ+p&OS.V(g(hQ1V+|Q4g0ZR7p5U&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]$i$`c#X#d%n%o%q'|(S(n(u(})O)P)Q)R)S)T)U)V)W)X)Z)^)b)l+Z+o-O-m-r-w-y.h.n.r.t.u.v/V0_2W2Z2k2r3Y3_3`3a3b3c3d3e3f3g3h3i3j3k3n3o3t4k4s6U6[6a6o6p6y6z7r8a8e8n8t8u9k9{:S:e<PT#SV#T&}kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]Q'T!eR2^-Qv!nQ!e!r!u!x!y'R'Y'Z'g'h'i-Q-W-Y-j1[5]5_S*b$|*hS/t*c*jQ/}*kQ1X,OQ4^/|R4a0PnqOXst!Z#c%j&m&o&p&r,h,m1w1zQ&t!^Q'q!wS(m#t:kQ+c%vQ,Q&YQ,R&[Q-_'_Q-l'jS.g(r;[S0`+O;eQ0n+dQ1Z,PQ2O,oQ2Q,pQ2Y,{Q2g-`Q2j-dS4l0a;oQ4q0oS4t0q;pQ6T2[Q6X2hQ6^2oQ7e4rQ8b6VQ8c6YQ8f6_R9h8_$d$_c#X#d%o%q'|(S(n(u(})O)P)Q)R)S)T)U)V)W)X)Z)^)b)l+Z+o-O-m-r-w-y.h.n.r.u.v/V0_2W2Z2k2r3Y3_3`3a3b3c3d3e3f3g3h3i3j3k3n3o3t4k4s6U6[6a6o6p6y6z7r8a8e8n8t8u9k9{:S:e<PS(j#o'dU*o%R(q3mS+Y%n.tQ2|0hQ6f2{Q8l6iR9o8m$d$^c#X#d%o%q'|(S(n(u(})O)P)Q)R)S)T)U)V)W)X)Z)^)b)l+Z+o-O-m-r-w-y.h.n.r.u.v/V0_2W2Z2k2r3Y3_3`3a3b3c3d3e3f3g3h3i3j3k3n3o3t4k4s6U6[6a6o6p6y6z7r8a8e8n8t8u9k9{:S:e<PS(i#o'dS({#z$_S+X%n.tS.W(h(jQ.w)]Q0e+YR2y.X&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]S#p]:dQ&o!XQ&p!YQ&r![Q&s!]R1v,kQ'[!hQ+[%sQ-]'^S.Y(k+_Q2e-[W2}.].^0g0iQ6W2fU6e2z2|3QS8i6f6hS9m8k8lS:U9l9oQ:^:VR:a:_U!vQ'Z-YT5Z1[5]!Q_OXZ`st!V!Z#c#g%b%j&d&f&m&o&p&r(d,h,m.P1w1z]!pQ!r'Z-Y1[5]T#p]:d%Y{OPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&j&m&o&p&r&v'O']'m'}(P(V(^(r(v(z)y+O+S+^,e,h,m-^-f-t-z.[.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3P3Z5Y5d5t5u5x6]6j7w7|8]8gS(y#y#zS.V(g(h!s;v$[$m'S)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]Y!tQ'Z-Y1[5]Q'f!rS'p!u!xS'r!y5_S-i'g'hQ-k'iR2p-jQ'o!tS(`#f1qS-h'f'rQ/f*VQ/r*bQ2q-kQ4O/gS4X/s/}Q7P3yS7[4_4aQ8y7QR9Q7_Q#vbQ'n!tS(_#f1qS(a#l*}Q+P%cQ+a%tQ+g%zU-g'f'o'rQ-{(`Q/e*VQ/q*bQ/w*eQ0m+bQ1b,US2n-h-kQ2v.TS3}/f/gS4W/r/}Q4Z/vQ4]/xQ5g1cQ6`2qQ7O3yQ7S4OS7W4X4aQ7]4`Q8O5hS8x7P7QQ8|7XQ9O7[Q9_8PQ9u8yQ9v8}Q9x9QQ:Q9`Q:Y9wQ;y;tQ<U;}R<V<OV!vQ'Z-Y%YaOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&j&m&o&p&r&v'O']'m'}(P(V(^(r(v(z)y+O+S+^,e,h,m-^-f-t-z.[.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3P3Z5Y5d5t5u5x6]6j7w7|8]8gS#vz!j!r;s$[$m'S)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]R;y<[%YbOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&j&m&o&p&r&v'O']'m'}(P(V(^(r(v(z)y+O+S+^,e,h,m-^-f-t-z.[.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3P3Z5Y5d5t5u5x6]6j7w7|8]8gQ%cj!S%ty!i!t%w%x%y'Q'`'a'b'f'p*b+e+f,}-a-b-i/t0p2b2i2p4^S%zz!jQ+b%uQ,U&_W1c,V,W,X,YU5h1d1e1fS8P5i5jQ9`8Q!r;t$[$m'S)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]Q;}<ZR<O<[$|eOPXYstuvw!Z!`!g!o#R#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&m&o&p&r&v'O']'m(P(V(^(r(v(z)y+O+S+^,e,h,m-^-f-t-z.[.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3P3Z5Y5d5t5u5x6]6j7w7|8]8gY#aWZ#V#Y'}!S%gm#g#h#k%b%e(W(b(c(d+Q+R+T,d,z-x.O.P.Q.S2P2w2x6R6dQ,c&j!p;u$[$m)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]R;x'SS'W!e%fR2`-T%OdOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&m&o&p&r&v'O']'m'}(P(V(^(r(v(z)y+O+S,e,h,m-^-f-t-z.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3Z5Y5d5t5u5x6]7w7|8]8g!r)[$[$m'S)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]Q,b&jQ0h+^Q2{.[Q6i3PR8m6j!b$Uc#X%n'|(S(n(u)W)X)^)b+o-m-r-w-y.h.n/V0_2k2r3Y3k4k4s6[6a6o8e9k:e!P:r)Z)l-O.t2W2Z3_3i3j3n3t6U6p6y6z7r8a8n8t8u9{:S<P!f$Wc#X%n'|(S(n(u)T)U)W)X)^)b+o-m-r-w-y.h.n/V0_2k2r3Y3k4k4s6[6a6o8e9k:e!T:t)Z)l-O.t2W2Z3_3f3g3i3j3n3t6U6p6y6z7r8a8n8t8u9{:S<P!^$[c#X%n'|(S(n(u)^)b+o-m-r-w-y.h.n/V0_2k2r3Y3k4k4s6[6a6o8e9k:eQ3x/az<])Z)l-O.t2W2Z3_3n3t6U6p6y6z7r8a8n8t8u9{:S<PQ<b<dR<c<e&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]S$nh$oR3q.z'TgOPWXYZhstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m$o%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.z.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]T$jf$pQ$hfS)e$k)iR)q$pT$if$pT)g$k)i'ThOPWXYZhstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m$o%j%p%}&f&i&j&m&o&p&r&v'O'S']'m'}(P(V(^(r(v(z)n)y+O+S+^,e,h,m,y,|-^-f-t-z.[.l.s.z.{0[0a0q1_1o1p1r1t1w1z1|2]2m2s3P3Z3p5W5Y5d5t5u5x6S6]6j7w7|8]8g9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]T$nh$oQ$qhR)p$o%YjOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%j%p%}&f&i&j&m&o&p&r&v'O']'m'}(P(V(^(r(v(z)y+O+S+^,e,h,m-^-f-t-z.[.l.s0[0a0q1_1o1p1r1t1w1z1|2m2s3P3Z5Y5d5t5u5x6]6j7w7|8]8g!s<Z$[$m'S)n,y,|.{2]3p5W6S9W9i:c:f:g:j:k:l:m:n:o:p:q:r:s:t:u:v:w:{;Y;Z;[;^;e;f;o;p<]#clOPXZst!Z!`!o#R#c#n#{$m%j&f&i&j&m&o&p&r&v'O'](z)n+S+^,e,h,m-^.[.{0[1_1o1p1r1t1w1z1|3P3p5Y5d5t5u5x6j7w7|8]!O%Ri#w%O%Q%[%]%a)}*P*Y*p*q.i/j0Q0S0^3x4f8w<Y<b<c#W(q#u$c$d$x${)u){*R*`+]+`+w+z.Z/Z/k/m1R1U1^3O4S4[4n4p5c6g7T7^7y8j9[9n:O:W:|;O;S;U;W;_;a;c;g;i;k;m;q<f<gQ*z%_Q/W)zo3m:y:z:};P;T;V;X;`;b;d;h;j;l;n;r!O$yi#w%O%Q%[%]%a)}*P*Y*p*q.i/j0Q0S0^3x4f8w<Y<b<cQ*[$zS*e$|*hQ*{%`Q/x*f#W;{#u$c$d$x${)u){*R*`+]+`+w+z.Z/Z/k/m1R1U1^3O4S4[4n4p5c6g7T7^7y8j9[9n:O:W:|;O;S;U;W;_;a;c;g;i;k;m;q<f<gn;|:y:z:};P;T;V;X;`;b;d;h;j;l;n;rQ<Q<^Q<R<_Q<S<`R<T<a!O%Ri#w%O%Q%[%]%a)}*P*Y*p*q.i/j0Q0S0^3x4f8w<Y<b<c#W(q#u$c$d$x${)u){*R*`+]+`+w+z.Z/Z/k/m1R1U1^3O4S4[4n4p5c6g7T7^7y8j9[9n:O:W:|;O;S;U;W;_;a;c;g;i;k;m;q<f<go3m:y:z:};P;T;V;X;`;b;d;h;j;l;n;rnoOXst!Z#c%j&m&o&p&r,h,m1w1zQ*_${Q,v&yQ,w&{R4R/k$v%Si#u#w$c$d$x${%O%Q%[%]%a)u){)}*P*R*Y*`*p*q+]+`+w+z.Z.i/Z/j/k/m0Q0S0^1R1U1^3O3x4S4[4f4n4p5c6g7T7^7y8j8w9[9n:O:W:y:z:|:};O;P;S;T;U;V;W;X;_;`;a;b;c;d;g;h;i;j;k;l;m;n;q;r<Y<b<c<f<gQ+y&WQ1T+{Q5S1SR7o5TT*g$|*hS*g$|*hT5[1[5]S/v*d5YT4`0O7wQ+a%tQ/w*eQ0m+bQ1b,UQ5g1cQ8O5hQ9_8PR:Q9`!O%Oi#w%O%Q%[%]%a)}*P*Y*p*q.i/j0Q0S0^3x4f8w<Y<b<cr)}$v(s*O*n*|/i0U0V3W4P4j6}7`9t;z<W<XS0Q*m0R#W:|#u$c$d$x${)u){*R*`+]+`+w+z.Z/Z/k/m1R1U1^3O4S4[4n4p5c6g7T7^7y8j9[9n:O:W:|;O;S;U;W;_;a;c;g;i;k;m;q<f<gn:}:y:z:};P;T;V;X;`;b;d;h;j;l;n;r!^;_(o)`*U*^._.b.f/S/X/a/n0f1Q1S3T4Q4U5R5T6k6n7U7Y7b7d8{9P:X<d<e`;`3l6q6t6x8o9p9s:bS;i.a3UT;j6s8r!O%Qi#w%O%Q%[%]%a)}*P*Y*p*q.i/j0Q0S0^3x4f8w<Y<b<cv*P$v(s*Q*m*|/]/i0U0V3W4P4b4j6}7`9t;z<W<XS0S*n0T#W;O#u$c$d$x${)u){*R*`+]+`+w+z.Z/Z/k/m1R1U1^3O4S4[4n4p5c6g7T7^7y8j9[9n:O:W:|;O;S;U;W;_;a;c;g;i;k;m;q<f<gn;P:y:z:};P;T;V;X;`;b;d;h;j;l;n;r!b;a(o)`*U*^.`.a.f/S/X/a/n0f1Q1S3R3T4Q4U5R5T6k6l6n7U7Y7b7d8{9P:X<d<ed;b3l6r6s6x8o8p9p9q9s:bS;k.b3VT;l6t8srnOXst!V!Z#c%j&d&m&o&p&r,h,m1w1zQ&a!UR,e&jrnOXst!V!Z#c%j&d&m&o&p&r,h,m1w1zR&a!UQ+}&XR1P+vsnOXst!V!Z#c%j&d&m&o&p&r,h,m1w1zQ1],SS5b1`1aU7x5`5a5eS9Z7z7{S9|9Y9]Q:Z9}R:`:[Q&h!VR,^&dR5n1iS%||&RR0x+mQ&m!WR,h&nR,n&sT1x,m1zR,r&tQ,q&tR2R,rQ't!zR-n'tSsOtQ#cXT%ms#cQ!}TR'v!}Q#QUR'x#QQ)w$uR/T)wQ#TVR'z#TQ#WWU(Q#W(R-uQ(R#XR-u(SQ-R'TR2_-RQ.j(sR3X.jQ.m(uS3[.m3]R3].nQ-Y'ZR2c-YY!rQ'Z-Y1[5]R'e!rS#^W%eU(X#^(Y-vQ(Y#_R-v(TQ-U'WR2a-Ut`OXst!V!Z#c%j&d&f&m&o&p&r,h,m1w1zS#gZ%bU#q`#g.PR.P(dQ(e#iQ-|(aW.U(e-|2t6bQ2t-}R6b2uQ)i$kR.|)iQ$ohR)o$oQ$bcU)_$b-q:xQ-q:eR:x)lQ/d*VW3{/d3|7R8zU3|/e/f/gS7R3}4OR8z7S$X)|$v(o(s)`*U*^*m*n*w*x*|.a.b.d.e.f/S/X/]/_/a/i/n0U0V0f1Q1S3R3S3T3W3l4P4Q4U4b4d4j5R5T6k6l6m6n6s6t6v6w6x6}7U7Y7`7b7d8o8p8q8{9P9p9q9r9s9t:X:b;z<W<X<d<eQ/l*^U4T/l4V7VQ4V/nR7V4UQ*h$|R/z*hr*O$v(s*m*n*|/i0U0V3W4P4j6}7`9t;z<W<X!^._(o)`*U*^.a.b.f/S/X/a/n0f1Q1S3T4Q4U5R5T6k6n7U7Y7b7d8{9P:X<d<eU/^*O._6qa6q3l6s6t6x8o9p9s:bQ0R*mQ3U.aU4c0R3U8rR8r6sv*Q$v(s*m*n*|/]/i0U0V3W4P4b4j6}7`9t;z<W<X!b.`(o)`*U*^.a.b.f/S/X/a/n0f1Q1S3R3T4Q4U5R5T6k6l6n7U7Y7b7d8{9P:X<d<eU/`*Q.`6re6r3l6s6t6x8o8p9p9q9s:bQ0T*nQ3V.bU4e0T3V8sR8s6tQ*s%UR0X*sQ4o0fR7c4oQ+U%hR0d+UQ5V1VS7q5V9XR9X7rQ,P&YR1Y,PQ5]1[R7u5]Q1h,ZS5l1h8SR8S5nQ0s+iW4x0s4z7i9TQ4z0vQ7i4yR9T7jQ+n%|R0y+nQ1z,mR5|1zYrOXst#cQ&q!ZQ+W%jQ,g&mQ,i&oQ,j&pQ,l&rQ1u,hS1x,m1zR5{1wQ%lpQ&u!_Q&x!aQ&z!bQ&|!cQ'l!tQ+V%iQ+c%vQ+u&SQ,]&hQ,t&wW-e'f'n'o'rQ-l'jQ/y*gQ0n+dS1k,^,aQ2S,sQ2T,vQ2U,wQ2j-dW2l-g-h-k-mQ4q0oQ4}0|Q5Q1QQ5f1bQ5p1mQ5z1vU6Z2k2n2qQ6^2oQ7e4rQ7m5PQ7n5RQ7t5[Q7}5gQ8T5oS8d6[6`Q8f6_Q9U7kQ9^8OQ9c8UQ9j8eQ9z9VQ:P9_Q:T9kR:]:QQ%vyQ'_!iQ'j!tU+d%w%x%yQ,{'QU-`'`'a'bS-d'f'pQ/p*bS0o+e+fQ2[,}S2h-a-bQ2o-iQ4Y/tQ4r0pQ6V2bQ6Y2iQ6_2pR7Z4^S$wi<YR*t%VU%Ui%V<YR0W*rQ$viS(o#u+`Q(s#wS)`$c$dQ*U$xQ*^${Q*m%OQ*n%QQ*w%[Q*x%]Q*|%aQ.a:|Q.b;OQ.d;SQ.e;UQ.f;WQ/S)uS/X){/ZQ/])}Q/_*PQ/a*RQ/i*YQ/n*`Q0U*pQ0V*qh0f+].Z1^3O5c6g7y8j9[9n:O:WQ1Q+wQ1S+zQ3R;_Q3S;aQ3T;cQ3W.iS3l:y:zQ4P/jQ4Q/kQ4U/mQ4b0QQ4d0SQ4j0^Q5R1RQ5T1UQ6k;gQ6l;iQ6m;kQ6n;mQ6s:}Q6t;PQ6v;TQ6w;VQ6x;XQ6}3xQ7U4SQ7Y4[Q7`4fQ7b4nQ7d4pQ8o;dQ8p;`Q8q;bQ8{7TQ9P7^Q9p;hQ9q;jQ9r;lQ9s;nQ9t8wQ:X;qQ:b;rQ;z<YQ<W<bQ<X<cQ<d<fR<e<gnpOXst!Z#c%j&m&o&p&r,h,m1w1zQ!fPS#eZ#nQ&w!`U'c!o5Y7wQ'y#RQ(|#{Q)m$mS,a&f&iQ,f&jQ,s&vQ,x'OQ-[']Q.p(zQ/Q)nQ0b+SQ0i+^Q1s,eQ2f-^Q2|.[Q3s.{Q4h0[Q5a1_Q5r1oQ5s1pQ5w1rQ5y1tQ6O1|Q6f3PQ6{3pQ7{5dQ8X5tQ8Y5uQ8[5xQ8l6jQ9]7|R9g8]#WcOPXZst!Z!`!o#c#n#{%j&f&i&j&m&o&p&r&v'O'](z+S+^,e,h,m-^.[0[1_1o1p1r1t1w1z1|3P5Y5d5t5u5x6j7w7|8]Q#XWQ#dYQ%nuQ%ovS%qw!gS'|#V(PQ(S#YQ(n#tQ(u#xQ(}$OQ)O$PQ)P$QQ)Q$RQ)R$SQ)S$TQ)T$UQ)U$VQ)V$WQ)W$XQ)X$YQ)Z$[Q)^$aQ)b$eW)l$m)n.{3pQ+Z%pQ+o%}S-O'S2]Q-m'mS-r'}-tQ-w(VQ-y(^Q.h(rQ.n(vQ.r:cQ.t:fQ.u:gQ.v:jQ/V)yQ0_+OQ2W,yQ2Z,|Q2k-fQ2r-zQ3Y.lQ3_:kQ3`:lQ3a:mQ3b:nQ3c:oQ3d:pQ3e:qQ3f:rQ3g:sQ3h:tQ3i:uQ3j:vQ3k.sQ3n:{Q3o;YQ3t:wQ4k0aQ4s0qQ6U;ZQ6[2mQ6a2sQ6o3ZQ6p;[Q6y;^Q6z;eQ7r5WQ8a6SQ8e6]Q8n;fQ8t;oQ8u;pQ9k8gQ9{9WQ:S9iQ:e#RR<P<]R#ZWR'U!eY!tQ'Z-Y1[5]S'Q!e-QQ'f!rS'p!u!xS'r!y5_S,}'R'YS-i'g'hQ-k'iQ2b-WR2p-jR(t#wR(w#xQ!fQT-X'Z-Y]!qQ!r'Z-Y1[5]Q#o]R'd:dT#jZ%bS#iZ%bS%hm,dU(a#g#h#kS-}(b(cQ.R(dQ0c+TQ2u.OU2v.P.Q.SS6c2w2xR8h6d`#]W#V#Y%e'}(W+Q-xr#fZm#g#h#k%b(b(c(d+T.O.P.Q.S2w2x6dQ1q,dQ2X,zQ6Q2PQ8`6RT;w'S+RT#`W%eS#_W%eS(O#V(WS(T#Y+QS-P'S+RT-s'}-xT'X!e%fQ$kfR)s$pT)h$k)iR3r.zT*X$x*ZR*a${Q0g+]Q2z.ZQ5`1^Q6h3OQ7z5cQ8k6gQ9Y7yQ9l8jQ9}9[Q:V9nQ:[:OR:_:WnqOXst!Z#c%j&m&o&p&r,h,m1w1zQ&g!VR,]&dtmOXst!U!V!Z#c%j&d&m&o&p&r,h,m1w1zR,d&jT%im,dR1W+|R,[&bQ&Q|R+t&RR+j%{T&k!W&nT&l!W&nT1y,m1z",
    nodeNames: "\u26A0 ArithOp ArithOp JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . ?. PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewExpression new TypeArgList CompareOp < ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in const CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast ArrowFunction TypeParamList SequenceExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
    maxTerm: 371,
    context: trackNewline,
    nodeProps: [
        [
            "isolate",
            -8,
            4,
            5,
            13,
            33,
            35,
            48,
            50,
            52,
            ""
        ],
        [
            "group",
            -26,
            8,
            16,
            18,
            65,
            201,
            205,
            209,
            210,
            212,
            215,
            218,
            228,
            230,
            236,
            238,
            240,
            242,
            245,
            251,
            257,
            259,
            261,
            263,
            265,
            267,
            268,
            "Statement",
            -32,
            12,
            13,
            28,
            31,
            32,
            38,
            48,
            51,
            52,
            54,
            59,
            67,
            75,
            79,
            81,
            83,
            84,
            106,
            107,
            116,
            117,
            134,
            137,
            139,
            140,
            141,
            142,
            144,
            145,
            164,
            165,
            167,
            "Expression",
            -23,
            27,
            29,
            33,
            37,
            39,
            41,
            168,
            170,
            172,
            173,
            175,
            176,
            177,
            179,
            180,
            181,
            183,
            184,
            185,
            195,
            197,
            199,
            200,
            "Type",
            -3,
            87,
            99,
            105,
            "ClassItem"
        ],
        [
            "openedBy",
            22,
            "<",
            34,
            "InterpolationStart",
            53,
            "[",
            57,
            "{",
            72,
            "(",
            157,
            "JSXStartCloseTag"
        ],
        [
            "closedBy",
            23,
            ">",
            36,
            "InterpolationEnd",
            47,
            "]",
            58,
            "}",
            73,
            ")",
            162,
            "JSXEndTag"
        ]
    ],
    propSources: [
        jsHighlight
    ],
    skippedNodes: [
        0,
        4,
        5,
        271
    ],
    repeatNodeCount: 37,
    tokenData: "$Fj(CSR!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#8g!R![#:v![!]#Gv!]!^#IS!^!_#J^!_!`#Ns!`!a$#_!a!b$(l!b!c$,k!c!}Er!}#O$-u#O#P$/P#P#Q$4h#Q#R$5r#R#SEr#S#T$7P#T#o$8Z#o#p$<k#p#q$=a#q#r$>q#r#s$?}#s$f%Z$f$g+g$g#BYEr#BY#BZ$AX#BZ$ISEr$IS$I_$AX$I_$I|Er$I|$I}$Dd$I}$JO$Dd$JO$JTEr$JT$JU$AX$JU$KVEr$KV$KW$AX$KW&FUEr&FU&FV$AX&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$AX?HUOEr(n%d_$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$f&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$f&j(R!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(R!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$f&j(OpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(OpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Op(R!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z(CS+rq$f&j(Op(R!b't(;dOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z(CS.ST(P#S$f&j'u(;dO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c(CS.n_$f&j(Op(R!b'u(;dOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`/x`$f&j!o$Ip(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S1V`#t$Id$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S2d_#t$Id$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/|3l_'}$(n$f&j(R!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$f&j(R!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$f&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$a`$f&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$a``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$a`$f&j(R!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(R!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$a`(R!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k#%|:hh$f&j(Op(R!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__VS$f&j(Op(R!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]VS$f&j(R!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXVS$f&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSVSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWVS(R!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]VS$f&j(OpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWVS(OpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYVS(Op(R!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S#%|C}i$f&j(g!L^(Op(R!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr#%|EoP;=`<%lCr(CSFRk$f&j(Op(R!b$Y#t'{&;d([!LYOY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$f&j(Op(R!b$Y#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv(CSJPP;=`<%lEr%#SJ_`$f&j(Op(R!b#l$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#SKl_$f&j$O$Id(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&COLva(p&;`$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#SNW`$f&j#x$Id(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/|! c_(Q$)`$f&j(OpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$f&j(OpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$f&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$a`$f&j(OpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(OpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$a`(OpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b(*Q!'t_!k(!b$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'l!)O_!jM|$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+h!*[b$f&j(Op(R!b'|#)d#m$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S!+o`$f&j(Op(R!b#j$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&-O!,|`$f&j(Op(R!bn&%`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&C[!.Z_!Y&;l$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS!/ec$f&j(Op(R!b|'<nOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'d!0ya$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'d!2Z_!XMt$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!3eg$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!5Vg$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!6wc$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!8_c$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS!9uf$f&j(Op(R!b#k$IdOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpxz!;Zz{#,f{!P!;Z!P!Q#-{!Q!^!;Z!^!_#'Z!_!`#5k!`!a#7Q!a!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z(r!;fb$f&j(Op(R!b!USOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z(Q!<w`$f&j(R!b!USOY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eb!Q!^!<n!^!_!GY!_!}!<n!}#O!Ja#O#P!Dj#P#o!<n#o#p!GY#p;'S!<n;'S;=`!Kj<%lO!<n&n!>Q^$f&j!USOY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@Y!_!}!=y!}#O!Bw#O#P!Dj#P#o!=y#o#p!@Y#p;'S!=y;'S;=`!E[<%lO!=y&n!?Ta$f&j!USO!^&c!_#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&cS!@_X!USOY!@YZ!P!@Y!P!Q!@z!Q!}!@Y!}#O!Ac#O#P!Bb#P;'S!@Y;'S;=`!Bq<%lO!@YS!APU!US#Z#[!@z#]#^!@z#a#b!@z#g#h!@z#i#j!@z#m#n!@zS!AfVOY!AcZ#O!Ac#O#P!A{#P#Q!@Y#Q;'S!Ac;'S;=`!B[<%lO!AcS!BOSOY!AcZ;'S!Ac;'S;=`!B[<%lO!AcS!B_P;=`<%l!AcS!BeSOY!@YZ;'S!@Y;'S;=`!Bq<%lO!@YS!BtP;=`<%l!@Y&n!B|[$f&jOY!BwYZ&cZ!^!Bw!^!_!Ac!_#O!Bw#O#P!Cr#P#Q!=y#Q#o!Bw#o#p!Ac#p;'S!Bw;'S;=`!Dd<%lO!Bw&n!CwX$f&jOY!BwYZ&cZ!^!Bw!^!_!Ac!_#o!Bw#o#p!Ac#p;'S!Bw;'S;=`!Dd<%lO!Bw&n!DgP;=`<%l!Bw&n!DoX$f&jOY!=yYZ&cZ!^!=y!^!_!@Y!_#o!=y#o#p!@Y#p;'S!=y;'S;=`!E[<%lO!=y&n!E_P;=`<%l!=y(Q!Eki$f&j(R!b!USOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#Z&}#Z#[!Eb#[#]&}#]#^!Eb#^#a&}#a#b!Eb#b#g&}#g#h!Eb#h#i&}#i#j!Eb#j#m&}#m#n!Eb#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!f!GaZ(R!b!USOY!GYZw!GYwx!@Yx!P!GY!P!Q!HS!Q!}!GY!}#O!Ic#O#P!Bb#P;'S!GY;'S;=`!JZ<%lO!GY!f!HZb(R!b!USOY'}Zw'}x#O'}#P#Z'}#Z#[!HS#[#]'}#]#^!HS#^#a'}#a#b!HS#b#g'}#g#h!HS#h#i'}#i#j!HS#j#m'}#m#n!HS#n;'S'};'S;=`(f<%lO'}!f!IhX(R!bOY!IcZw!Icwx!Acx#O!Ic#O#P!A{#P#Q!GY#Q;'S!Ic;'S;=`!JT<%lO!Ic!f!JWP;=`<%l!Ic!f!J^P;=`<%l!GY(Q!Jh^$f&j(R!bOY!JaYZ&cZw!Jawx!Bwx!^!Ja!^!_!Ic!_#O!Ja#O#P!Cr#P#Q!<n#Q#o!Ja#o#p!Ic#p;'S!Ja;'S;=`!Kd<%lO!Ja(Q!KgP;=`<%l!Ja(Q!KmP;=`<%l!<n'`!Ky`$f&j(Op!USOY!KpYZ&cZr!Kprs!=ys!P!Kp!P!Q!L{!Q!^!Kp!^!_!Ns!_!}!Kp!}#O##z#O#P!Dj#P#o!Kp#o#p!Ns#p;'S!Kp;'S;=`#%T<%lO!Kp'`!MUi$f&j(Op!USOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#Z(r#Z#[!L{#[#](r#]#^!L{#^#a(r#a#b!L{#b#g(r#g#h!L{#h#i(r#i#j!L{#j#m(r#m#n!L{#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rt!NzZ(Op!USOY!NsZr!Nsrs!@Ys!P!Ns!P!Q# m!Q!}!Ns!}#O#!|#O#P!Bb#P;'S!Ns;'S;=`##t<%lO!Nst# tb(Op!USOY)rZr)rs#O)r#P#Z)r#Z#[# m#[#])r#]#^# m#^#a)r#a#b# m#b#g)r#g#h# m#h#i)r#i#j# m#j#m)r#m#n# m#n;'S)r;'S;=`*Z<%lO)rt##RX(OpOY#!|Zr#!|rs!Acs#O#!|#O#P!A{#P#Q!Ns#Q;'S#!|;'S;=`##n<%lO#!|t##qP;=`<%l#!|t##wP;=`<%l!Ns'`#$R^$f&j(OpOY##zYZ&cZr##zrs!Bws!^##z!^!_#!|!_#O##z#O#P!Cr#P#Q!Kp#Q#o##z#o#p#!|#p;'S##z;'S;=`#$}<%lO##z'`#%QP;=`<%l##z'`#%WP;=`<%l!Kp(r#%fk$f&j(Op(R!b!USOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#Z%Z#Z#[#%Z#[#]%Z#]#^#%Z#^#a%Z#a#b#%Z#b#g%Z#g#h#%Z#h#i%Z#i#j#%Z#j#m%Z#m#n#%Z#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#W#'d](Op(R!b!USOY#'ZZr#'Zrs!GYsw#'Zwx!Nsx!P#'Z!P!Q#(]!Q!}#'Z!}#O#)w#O#P!Bb#P;'S#'Z;'S;=`#*w<%lO#'Z#W#(fe(Op(R!b!USOY*gZr*grs'}sw*gwx)rx#O*g#P#Z*g#Z#[#(]#[#]*g#]#^#(]#^#a*g#a#b#(]#b#g*g#g#h#(]#h#i*g#i#j#(]#j#m*g#m#n#(]#n;'S*g;'S;=`+Z<%lO*g#W#*OZ(Op(R!bOY#)wZr#)wrs!Icsw#)wwx#!|x#O#)w#O#P!A{#P#Q#'Z#Q;'S#)w;'S;=`#*q<%lO#)w#W#*tP;=`<%l#)w#W#*zP;=`<%l#'Z(r#+W`$f&j(Op(R!bOY#*}YZ&cZr#*}rs!Jasw#*}wx##zx!^#*}!^!_#)w!_#O#*}#O#P!Cr#P#Q!;Z#Q#o#*}#o#p#)w#p;'S#*};'S;=`#,Y<%lO#*}(r#,]P;=`<%l#*}(r#,cP;=`<%l!;Z(CS#,sb$f&j(Op(R!b'v(;d!USOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z(CS#.W_$f&j(Op(R!bS(;dOY#-{YZ&cZr#-{rs#/Vsw#-{wx#2gx!^#-{!^!_#4f!_#O#-{#O#P#0X#P#o#-{#o#p#4f#p;'S#-{;'S;=`#5e<%lO#-{(Bb#/`]$f&j(R!bS(;dOY#/VYZ&cZw#/Vwx#0Xx!^#/V!^!_#1j!_#O#/V#O#P#0X#P#o#/V#o#p#1j#p;'S#/V;'S;=`#2a<%lO#/V(AO#0`X$f&jS(;dOY#0XYZ&cZ!^#0X!^!_#0{!_#o#0X#o#p#0{#p;'S#0X;'S;=`#1d<%lO#0X(;d#1QSS(;dOY#0{Z;'S#0{;'S;=`#1^<%lO#0{(;d#1aP;=`<%l#0{(AO#1gP;=`<%l#0X(<v#1qW(R!bS(;dOY#1jZw#1jwx#0{x#O#1j#O#P#0{#P;'S#1j;'S;=`#2Z<%lO#1j(<v#2^P;=`<%l#1j(Bb#2dP;=`<%l#/V(Ap#2p]$f&j(OpS(;dOY#2gYZ&cZr#2grs#0Xs!^#2g!^!_#3i!_#O#2g#O#P#0X#P#o#2g#o#p#3i#p;'S#2g;'S;=`#4`<%lO#2g(<U#3pW(OpS(;dOY#3iZr#3irs#0{s#O#3i#O#P#0{#P;'S#3i;'S;=`#4Y<%lO#3i(<U#4]P;=`<%l#3i(Ap#4cP;=`<%l#2g(=h#4oY(Op(R!bS(;dOY#4fZr#4frs#1jsw#4fwx#3ix#O#4f#O#P#0{#P;'S#4f;'S;=`#5_<%lO#4f(=h#5bP;=`<%l#4f(CS#5hP;=`<%l#-{%#W#5xb$f&j$O$Id(Op(R!b!USOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z+h#7_b$W#t$f&j(Op(R!b!USOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z$/l#8rp$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#:v![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#:v#S#U%Z#U#V#>Q#V#X%Z#X#Y!4|#Y#b%Z#b#c#<v#c#d#AY#d#l%Z#l#m#D[#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#;Rk$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#:v![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#:v#S#X%Z#X#Y!4|#Y#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#=R_$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#>Zd$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#?i!R!S#?i!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#?i#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#?tf$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#?i!R!S#?i!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#?i#S#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#Acc$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#Bn!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#Bn#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#Bye$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#Bn!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#Bn#S#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#Deg$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#E|![!^%Z!^!_*g!_!c%Z!c!i#E|!i#O%Z#O#P&c#P#R%Z#R#S#E|#S#T%Z#T#Z#E|#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#FXi$f&j(Op(R!bo$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#E|![!^%Z!^!_*g!_!c%Z!c!i#E|!i#O%Z#O#P&c#P#R%Z#R#S#E|#S#T%Z#T#Z#E|#Z#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%Gh#HT_!d$b$f&j#|%<f(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#I__`l$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(@^#Jk^g!*v!h'.r(Op(R!b(tSOY*gZr*grs'}sw*gwx)rx!P*g!P!Q#Kg!Q!^*g!^!_#L]!_!`#M}!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#KpX$h&j(Op(R!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#LfZ#n$Id(Op(R!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#MX!`#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#MbX$O$Id(Op(R!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#NWX#o$Id(Op(R!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g%Gh$ Oa#[%?x$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$!T!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#W$!`_#g$Ih$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%Gh$#nafBf#o$Id$c#|$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$$s!`!a$%}!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$%O_#o$Id$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$&Ya#n$Id$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$'_!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$'j`#n$Id$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+h$(wc(h$Ip$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P$*S!P!^%Z!^!_*g!_!a%Z!a!b$+^!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+`$*__}'#p$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$+i`$f&j#y$Id(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&^$,v_!{!Ln$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(@^$.Q_!P(8n$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/UZ$f&jO!^$/w!^!_$0_!_#i$/w#i#j$0d#j#l$/w#l#m$2V#m#o$/w#o#p$0_#p;'S$/w;'S;=`$4b<%lO$/w(n$0OT^#S$f&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0dO^#S(n$0i[$f&jO!Q&c!Q![$1_![!^&c!_!c&c!c!i$1_!i#T&c#T#Z$1_#Z#o&c#o#p$3u#p;'S&c;'S;=`&w<%lO&c(n$1dZ$f&jO!Q&c!Q![$2V![!^&c!_!c&c!c!i$2V!i#T&c#T#Z$2V#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2[Z$f&jO!Q&c!Q![$2}![!^&c!_!c&c!c!i$2}!i#T&c#T#Z$2}#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3SZ$f&jO!Q&c!Q![$/w![!^&c!_!c&c!c!i$/w!i#T&c#T#Z$/w#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$3xR!Q![$4R!c!i$4R#T#Z$4R#S$4US!Q![$4R!c!i$4R#T#Z$4R#q#r$0_(n$4eP;=`<%l$/w!2r$4s_!V!+S$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$5}`#v$Id$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&,v$7[_$f&j(Op(R!b(X&%WOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS$8jk$f&j(Op(R!b'{&;d$[#t([!LYOY%ZYZ&cZr%Zrs&}st%Ztu$8Zuw%Zwx(rx}%Z}!O$:_!O!Q%Z!Q![$8Z![!^%Z!^!_*g!_!c%Z!c!}$8Z!}#O%Z#O#P&c#P#R%Z#R#S$8Z#S#T%Z#T#o$8Z#o#p*g#p$g%Z$g;'S$8Z;'S;=`$<e<%lO$8Z+d$:jk$f&j(Op(R!b$[#tOY%ZYZ&cZr%Zrs&}st%Ztu$:_uw%Zwx(rx}%Z}!O$:_!O!Q%Z!Q![$:_![!^%Z!^!_*g!_!c%Z!c!}$:_!}#O%Z#O#P&c#P#R%Z#R#S$:_#S#T%Z#T#o$:_#o#p*g#p$g%Z$g;'S$:_;'S;=`$<_<%lO$:_+d$<bP;=`<%l$:_(CS$<hP;=`<%l$8Z!5p$<tX![!3l(Op(R!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g&CO$=la(o&;`$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+^#q;'S%Z;'S;=`+a<%lO%Z%#`$?O_!Z$I`r`$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(r$@Y_!pS$f&j(Op(R!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS$Aj|$f&j(Op(R!b't(;d$Y#t'{&;d([!LYOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$AX#BZ$ISEr$IS$I_$AX$I_$JTEr$JT$JU$AX$JU$KVEr$KV$KW$AX$KW&FUEr&FU&FV$AX&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$AX?HUOEr(CS$Duk$f&j(Op(R!b'u(;d$Y#t'{&;d([!LYOY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
    tokenizers: [
        noSemicolon,
        incdecToken,
        jsx,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        insertSemicolon,
        new (0, _lr.LocalTokenGroup)("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOt~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!R~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(Z~~", 141, 332),
        new (0, _lr.LocalTokenGroup)("j~RQYZXz{^~^O'x~~aP!P!Qd~iO'y~~", 25, 315)
    ],
    topRules: {
        "Script": [
            0,
            6
        ],
        "SingleExpression": [
            1,
            269
        ],
        "SingleClassItem": [
            2,
            270
        ]
    },
    dialects: {
        jsx: 0,
        ts: 14614
    },
    dynamicPrecedences: {
        "69": 1,
        "79": 1,
        "81": 1,
        "165": 1,
        "193": 1
    },
    specialized: [
        {
            term: 319,
            get: (value)=>spec_identifier[value] || -1
        },
        {
            term: 334,
            get: (value)=>spec_word[value] || -1
        },
        {
            term: 70,
            get: (value)=>spec_LessThan[value] || -1
        }
    ],
    tokenPrec: 14638
});

},{"@lezer/lr":"gQicU","@lezer/highlight":"pdORT","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"gQicU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextTracker", ()=>ContextTracker);
parcelHelpers.export(exports, "ExternalTokenizer", ()=>ExternalTokenizer);
parcelHelpers.export(exports, "InputStream", ()=>InputStream);
parcelHelpers.export(exports, "LRParser", ()=>LRParser);
parcelHelpers.export(exports, "LocalTokenGroup", ()=>LocalTokenGroup);
parcelHelpers.export(exports, "Stack", ()=>Stack);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _common = require("@lezer/common");
var process = require("d88a62f5f4081843");
/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class Stack {
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state) {
        var pos = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var cx = p.parser.context;
        return new Stack(p, [], state, pos, pos, 0, [], 0, cx ? new StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        var depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        var parser = this.p.parser;
        var dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        var base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        var start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        var bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            var pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            var baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end) {
        var size = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 4, isReduce = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            var cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!isReduce || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            var index = this.buffer.length;
            if (index > 0 && this.buffer[index - 4] != 0 /* Term.Err */ ) while(index > 0 && this.buffer[index - 2] > end){
                // Move this record forward
                this.buffer[index] = this.buffer[index - 4];
                this.buffer[index + 1] = this.buffer[index - 3];
                this.buffer[index + 2] = this.buffer[index - 2];
                this.buffer[index + 3] = this.buffer[index - 1];
                index -= 4;
                if (size > 4) size -= 4;
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            var nextState = action, parser = this.p.parser;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        var index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        var start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        var parent = this;
        var off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        var buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new Stack(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        var isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(var sim = new SimulatedStack(this);;){
            var action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        var nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            var _loop = function(i1) {
                var s = nextStates[i1 + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i1], s);
            };
            var best = [];
            for(var i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(var i1 = 0; best.length < 8 && i1 < nextStates.length; i1 += 2)_loop(i1);
            nextStates = best;
        }
        var result = [];
        for(var i2 = 0; i2 < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i2 += 2){
            var s1 = nextStates[i2 + 1];
            if (s1 == this.state) continue;
            var stack = this.split();
            stack.pushState(s1, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i2], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        var parser = this.p.parser;
        var reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            var depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            var target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                var backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        var parser = this.p.parser, seen = [];
        var explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    var rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        var term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    var found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        var parser = this.p.parser;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(var i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        var last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        var last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            var newCx = new StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead > this.lookAhead) {
            this.emitLookAhead();
            this.lookAhead = lookAhead;
        }
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ ref, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        var lookAhead = ref === void 0 ? 0 : ref;
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
}
class StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class SimulatedStack {
    reduce(action) {
        var term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        var goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class StackBufferCursor {
    static create(stack) {
        var pos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : stack.bufferBase + stack.buffer.length;
        return new StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        var next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new StackBufferCursor(this.stack, this.pos, this.index);
    }
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function decodeArray(input) {
    var Type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Uint16Array;
    if (typeof input != "string") return input;
    var array = null;
    for(var pos = 0, out = 0; pos < input.length;){
        var value = 0;
        for(;;){
            var next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            var digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
var nullToken = new CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class InputStream {
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        var range = this.range, index = this.rangeIndex;
        var pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            var next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            var next1 = this.ranges[++index];
            pos += next1.from - range.to;
            range = next1;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var range = _step.value;
                if (range.to > pos) return Math.max(pos, range.from);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        var idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            var resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                var i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token) {
        var endOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            var _this = this, chunk = _this.chunk, chunkPos = _this.chunkPos;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            var nextChunk = this.input.chunk(this.pos);
            var end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance() {
        var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        var result = "";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                if (r.from >= to) break;
                if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
}
/**
@internal
*/ class TokenGroup {
    token(input, stack) {
        var parser = stack.p.parser;
        readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
}
TokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
/**
@hide
*/ class LocalTokenGroup {
    token(input, stack) {
        var start = input.pos, skipped = 0;
        for(;;){
            var atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? decodeArray(data) : data;
    }
}
LocalTokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class ExternalTokenizer {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, ref){
        var options = ref === void 0 ? {} : ref;
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function readToken(data, input, stack, group, precTable, precOffset) {
    var state = 0, groupMask = 1 << group, dialect = stack.p.parser.dialect;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        var accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(var i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            var term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        var next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            var mid = low + high >> 1;
            var index = accEnd + mid + (mid << 1);
            var from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function findOffset(data, start, term) {
    for(var i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function overrides(token, prev, tableData, tableOffset) {
    var iPrev = findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
var verbose = typeof process != "undefined" && process.env && /\bparse\b/.test(undefined);
var stackIDs = null;
function cutAt(tree, pos, side) {
    var cursor = tree.cursor((0, _common.IterMode).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Safety.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Safety.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class FragmentCursor {
    nextFragment() {
        var fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            var last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            var top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            var next = top.children[index];
            var start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, _common.Tree)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    var end = start + next.length;
                    if (end <= this.safeTo) {
                        var lookAhead = next.prop((0, _common.NodeProp).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
}
class TokenCache {
    getActions(stack) {
        var actionIndex = 0;
        var main = null;
        var parser = stack.p.parser, tokenizers = parser.tokenizers;
        var mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        var context = stack.curContext ? stack.curContext.hash : 0;
        var lookAhead = 0;
        for(var i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            var tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Safety.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                var startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        var main = new CachedToken, pos = stack.pos, p = stack.p;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        var start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            var parser = stack.p.parser;
            for(var i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                var result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(var i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        var state = stack.state, parser = stack.p.parser, data = parser.data;
        for(var set = 0; set < 2; set++)for(var i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction(pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction(pair(data, i + 1), token, end, index);
        }
        return index;
    }
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new CachedToken);
    }
}
class Parse {
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        var stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        var newStacks = this.stacks = [];
        var stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            var _stacks = (0, _slicedToArray._)(stacks, 1), s = _stacks[0];
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(var i = 0; i < stacks.length; i++){
            var stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    var tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            var finished = stopped && findFinished(stopped);
            if (finished) {
                if (verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if (verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            var finished1 = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished1) {
                if (verbose) console.log("Force-finish " + this.stackID(finished1));
                return this.stackToTree(finished1.forceAll());
            }
        }
        if (this.recovering) {
            var maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(var i1 = 0; i1 < newStacks.length - 1; i1++){
                var stack1 = newStacks[i1];
                for(var j = i1 + 1; j < newStacks.length; j++){
                    var other = newStacks[j];
                    if (stack1.sameState(other) || stack1.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack1.score - other.score || stack1.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i1--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
        }
        this.minStackPos = newStacks[0].pos;
        for(var i2 = 1; i2 < newStacks.length; i2++)if (newStacks[i2].pos < this.minStackPos) this.minStackPos = newStacks[i2].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        var start = stack.pos, parser = this.parser;
        var base = verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            var strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(var cached = this.fragments.nodeAt(start); cached;){
                var match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, _common.NodeProp).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if (verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, _common.Tree)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                var inner = cached.children[0];
                if (inner instanceof (0, _common.Tree) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        var defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if (verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        var actions = this.tokens.getActions(stack);
        for(var i = 0; i < actions.length;){
            var action = actions[i++], term = actions[i++], end = actions[i++];
            var last = i == actions.length || !split;
            var localStack = last ? stack : stack.split();
            var main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if (verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        var pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        var finished = null, restarted = false;
        for(var i = 0; i < stacks.length; i++){
            var stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            var base = verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if (verbose) console.log(base + this.stackID(stack) + " (restarted)");
                var done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            var force = stack.split(), forceBase = base;
            for(var j = 0; force.forceReduce() && j < 10 /* Rec.ForceReduceLimit */ ; j++){
                if (verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                var done1 = this.advanceFully(force, newStacks);
                if (done1) break;
                if (verbose) forceBase = this.stackID(force) + " -> ";
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = stack.recoverByInsert(token)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var insert = _step.value;
                    if (verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                    this.advanceFully(insert, newStacks);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if (verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, _common.Tree).build({
            buffer: StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        var id = (stackIDs || (stackIDs = new WeakMap)).get(stack);
        if (!id) stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new InputStream(input, ranges);
        this.tokens = new TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        var from = ranges[0].from;
        this.stacks = [
            Stack.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new FragmentCursor(fragments, parser.nodeSet) : null;
    }
}
function pushStackDedup(stack, newStacks) {
    for(var i = 0; i < newStacks.length; i++){
        var other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class Dialect {
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
}
var id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class ContextTracker {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || id;
        this.reduce = spec.reduce || id;
        this.reuse = spec.reuse || id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class LRParser extends (0, _common.Parser) {
    createParse(input, fragments, ranges) {
        var parse = new Parse(this, input, fragments, ranges);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.wrappers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var w = _step.value;
                parse = w(parse, input, fragments, ranges);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term) {
        var loose = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var table = this.goto;
        if (term >= table[0]) return -1;
        for(var pos = table[term + 1];;){
            var groupTag = table[pos++], last = groupTag & 1;
            var target = table[pos++];
            if (last && loose) return target;
            for(var end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        var data = this.data;
        for(var set = 0; set < 2; set++)for(var i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next = void 0;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        var deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        var result = deflt ? action(deflt) : undefined;
        for(var i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = pair(this.data, i + 2);
                else break;
            }
            result = action(pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        var _this = this, _loop = function(i1) {
            if (_this.data[i1] == 65535 /* Seq.End */ ) {
                if (_this.data[i1 + 1] == 1 /* Seq.Next */ ) i1 = pair(_this.data, i1 + 2);
                else return i = i1, "break";
            }
            if ((_this.data[i1 + 2] & 1) == 0) {
                var value = _this.data[i1 + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(_this.data[i1], value);
            }
            i = i1, void 0;
        };
        var result = [];
        for(var i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            var _ret = _loop(i);
            if (_ret === "break") break;
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        var copy = Object.assign(Object.create(LRParser.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            var info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            var found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                var found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                var spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        var prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        var values = Object.keys(this.dialects), flags = values.map(()=>false);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (dialect) try {
            for(var _iterator = dialect.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                var id = values.indexOf(part);
                if (id >= 0) flags[id] = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var disabled = null;
        for(var i = 0; i < values.length; i++)if (!flags[i]) for(var j = this.dialects[values[i]], id1 = void 0; (id1 = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id1] = 1;
        return new Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new LRParser(spec);
    }
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        var nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(var i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        var topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        var nodeProps = [];
        for(var i1 = 0; i1 < nodeNames.length; i1++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (spec.nodeProps) try {
            for(var _iterator = spec.nodeProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var propSpec = _step.value;
                var prop = propSpec[0];
                if (typeof prop == "string") prop = (0, _common.NodeProp)[prop];
                for(var i2 = 1; i2 < propSpec.length;){
                    var next = propSpec[i2++];
                    if (next >= 0) setProp(next, prop, propSpec[i2++]);
                    else {
                        var value = propSpec[i2 + -next];
                        for(var j = -next; j > 0; j--)setProp(propSpec[i2++], prop, value);
                        i2++;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.nodeSet = new (0, _common.NodeSet)(nodeNames.map((name, i)=>(0, _common.NodeType).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, _common.DefaultBufferLength);
        var tokenArray = decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(var i3 = 0; i3 < this.specializerSpecs.length; i3++)this.specialized[i3] = this.specializerSpecs[i3].term;
        this.specializers = this.specializerSpecs.map(getSpecializer);
        this.states = decodeArray(spec.states, Uint32Array);
        this.data = decodeArray(spec.stateData);
        this.goto = decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
}
function pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function findFinished(stacks) {
    var best = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stack = _step.value;
            var stopped = stack.p.stoppedAt;
            if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
}
function getSpecializer(spec) {
    if (spec.external) {
        var mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}

},{"@swc/helpers/_/_sliced_to_array":"cdERl","d88a62f5f4081843":"lJ1km","@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lJ1km":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"25igp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cssCompletionSource", ()=>cssCompletionSource);
parcelHelpers.export(exports, "cssLanguage", ()=>cssLanguage);
parcelHelpers.export(exports, "defineCSSCompletionSource", ()=>defineCSSCompletionSource);
var _css = require("@lezer/css");
var _language = require("@codemirror/language");
var _common = require("@lezer/common");
var _properties = null;
function properties() {
    if (!_properties && typeof document == "object" && document.body) {
        var style = document.body.style, names = [], seen = new Set;
        for(var prop in style)if (prop != "cssText" && prop != "cssFloat") {
            if (typeof style[prop] == "string") {
                if (/[A-Z]/.test(prop)) prop = prop.replace(/[A-Z]/g, (ch)=>"-" + ch.toLowerCase());
                if (!seen.has(prop)) {
                    names.push(prop);
                    seen.add(prop);
                }
            }
        }
        _properties = names.sort().map((name)=>({
                type: "property",
                label: name
            }));
    }
    return _properties || [];
}
var pseudoClasses = /*@__PURE__*/ [
    "active",
    "after",
    "any-link",
    "autofill",
    "backdrop",
    "before",
    "checked",
    "cue",
    "default",
    "defined",
    "disabled",
    "empty",
    "enabled",
    "file-selector-button",
    "first",
    "first-child",
    "first-letter",
    "first-line",
    "first-of-type",
    "focus",
    "focus-visible",
    "focus-within",
    "fullscreen",
    "has",
    "host",
    "host-context",
    "hover",
    "in-range",
    "indeterminate",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "marker",
    "modal",
    "not",
    "nth-child",
    "nth-last-child",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "part",
    "placeholder",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "selection",
    "slotted",
    "target",
    "target-text",
    "valid",
    "visited",
    "where"
].map((name)=>({
        type: "class",
        label: name
    }));
var values = /*@__PURE__*/ [
    "above",
    "absolute",
    "activeborder",
    "additive",
    "activecaption",
    "after-white-space",
    "ahead",
    "alias",
    "all",
    "all-scroll",
    "alphabetic",
    "alternate",
    "always",
    "antialiased",
    "appworkspace",
    "asterisks",
    "attr",
    "auto",
    "auto-flow",
    "avoid",
    "avoid-column",
    "avoid-page",
    "avoid-region",
    "axis-pan",
    "background",
    "backwards",
    "baseline",
    "below",
    "bidi-override",
    "blink",
    "block",
    "block-axis",
    "bold",
    "bolder",
    "border",
    "border-box",
    "both",
    "bottom",
    "break",
    "break-all",
    "break-word",
    "bullets",
    "button",
    "button-bevel",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "calc",
    "capitalize",
    "caps-lock-indicator",
    "caption",
    "captiontext",
    "caret",
    "cell",
    "center",
    "checkbox",
    "circle",
    "cjk-decimal",
    "clear",
    "clip",
    "close-quote",
    "col-resize",
    "collapse",
    "color",
    "color-burn",
    "color-dodge",
    "column",
    "column-reverse",
    "compact",
    "condensed",
    "contain",
    "content",
    "contents",
    "content-box",
    "context-menu",
    "continuous",
    "copy",
    "counter",
    "counters",
    "cover",
    "crop",
    "cross",
    "crosshair",
    "currentcolor",
    "cursive",
    "cyclic",
    "darken",
    "dashed",
    "decimal",
    "decimal-leading-zero",
    "default",
    "default-button",
    "dense",
    "destination-atop",
    "destination-in",
    "destination-out",
    "destination-over",
    "difference",
    "disc",
    "discard",
    "disclosure-closed",
    "disclosure-open",
    "document",
    "dot-dash",
    "dot-dot-dash",
    "dotted",
    "double",
    "down",
    "e-resize",
    "ease",
    "ease-in",
    "ease-in-out",
    "ease-out",
    "element",
    "ellipse",
    "ellipsis",
    "embed",
    "end",
    "ethiopic-abegede-gez",
    "ethiopic-halehame-aa-er",
    "ethiopic-halehame-gez",
    "ew-resize",
    "exclusion",
    "expanded",
    "extends",
    "extra-condensed",
    "extra-expanded",
    "fantasy",
    "fast",
    "fill",
    "fill-box",
    "fixed",
    "flat",
    "flex",
    "flex-end",
    "flex-start",
    "footnotes",
    "forwards",
    "from",
    "geometricPrecision",
    "graytext",
    "grid",
    "groove",
    "hand",
    "hard-light",
    "help",
    "hidden",
    "hide",
    "higher",
    "highlight",
    "highlighttext",
    "horizontal",
    "hsl",
    "hsla",
    "hue",
    "icon",
    "ignore",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infinite",
    "infobackground",
    "infotext",
    "inherit",
    "initial",
    "inline",
    "inline-axis",
    "inline-block",
    "inline-flex",
    "inline-grid",
    "inline-table",
    "inset",
    "inside",
    "intrinsic",
    "invert",
    "italic",
    "justify",
    "keep-all",
    "landscape",
    "large",
    "larger",
    "left",
    "level",
    "lighter",
    "lighten",
    "line-through",
    "linear",
    "linear-gradient",
    "lines",
    "list-item",
    "listbox",
    "listitem",
    "local",
    "logical",
    "loud",
    "lower",
    "lower-hexadecimal",
    "lower-latin",
    "lower-norwegian",
    "lowercase",
    "ltr",
    "luminosity",
    "manipulation",
    "match",
    "matrix",
    "matrix3d",
    "medium",
    "menu",
    "menutext",
    "message-box",
    "middle",
    "min-intrinsic",
    "mix",
    "monospace",
    "move",
    "multiple",
    "multiple_mask_images",
    "multiply",
    "n-resize",
    "narrower",
    "ne-resize",
    "nesw-resize",
    "no-close-quote",
    "no-drop",
    "no-open-quote",
    "no-repeat",
    "none",
    "normal",
    "not-allowed",
    "nowrap",
    "ns-resize",
    "numbers",
    "numeric",
    "nw-resize",
    "nwse-resize",
    "oblique",
    "opacity",
    "open-quote",
    "optimizeLegibility",
    "optimizeSpeed",
    "outset",
    "outside",
    "outside-shape",
    "overlay",
    "overline",
    "padding",
    "padding-box",
    "painted",
    "page",
    "paused",
    "perspective",
    "pinch-zoom",
    "plus-darker",
    "plus-lighter",
    "pointer",
    "polygon",
    "portrait",
    "pre",
    "pre-line",
    "pre-wrap",
    "preserve-3d",
    "progress",
    "push-button",
    "radial-gradient",
    "radio",
    "read-only",
    "read-write",
    "read-write-plaintext-only",
    "rectangle",
    "region",
    "relative",
    "repeat",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeat-x",
    "repeat-y",
    "reset",
    "reverse",
    "rgb",
    "rgba",
    "ridge",
    "right",
    "rotate",
    "rotate3d",
    "rotateX",
    "rotateY",
    "rotateZ",
    "round",
    "row",
    "row-resize",
    "row-reverse",
    "rtl",
    "run-in",
    "running",
    "s-resize",
    "sans-serif",
    "saturation",
    "scale",
    "scale3d",
    "scaleX",
    "scaleY",
    "scaleZ",
    "screen",
    "scroll",
    "scrollbar",
    "scroll-position",
    "se-resize",
    "self-start",
    "self-end",
    "semi-condensed",
    "semi-expanded",
    "separate",
    "serif",
    "show",
    "single",
    "skew",
    "skewX",
    "skewY",
    "skip-white-space",
    "slide",
    "slider-horizontal",
    "slider-vertical",
    "sliderthumb-horizontal",
    "sliderthumb-vertical",
    "slow",
    "small",
    "small-caps",
    "small-caption",
    "smaller",
    "soft-light",
    "solid",
    "source-atop",
    "source-in",
    "source-out",
    "source-over",
    "space",
    "space-around",
    "space-between",
    "space-evenly",
    "spell-out",
    "square",
    "start",
    "static",
    "status-bar",
    "stretch",
    "stroke",
    "stroke-box",
    "sub",
    "subpixel-antialiased",
    "svg_masks",
    "super",
    "sw-resize",
    "symbolic",
    "symbols",
    "system-ui",
    "table",
    "table-caption",
    "table-cell",
    "table-column",
    "table-column-group",
    "table-footer-group",
    "table-header-group",
    "table-row",
    "table-row-group",
    "text",
    "text-bottom",
    "text-top",
    "textarea",
    "textfield",
    "thick",
    "thin",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "to",
    "top",
    "transform",
    "translate",
    "translate3d",
    "translateX",
    "translateY",
    "translateZ",
    "transparent",
    "ultra-condensed",
    "ultra-expanded",
    "underline",
    "unidirectional-pan",
    "unset",
    "up",
    "upper-latin",
    "uppercase",
    "url",
    "var",
    "vertical",
    "vertical-text",
    "view-box",
    "visible",
    "visibleFill",
    "visiblePainted",
    "visibleStroke",
    "visual",
    "w-resize",
    "wait",
    "wave",
    "wider",
    "window",
    "windowframe",
    "windowtext",
    "words",
    "wrap",
    "wrap-reverse",
    "x-large",
    "x-small",
    "xor",
    "xx-large",
    "xx-small"
].map((name)=>({
        type: "keyword",
        label: name
    })).concat(/*@__PURE__*/ [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "grey",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
].map((name)=>({
        type: "constant",
        label: name
    })));
var tags = /*@__PURE__*/ [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hgroup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "meter",
    "nav",
    "ol",
    "output",
    "p",
    "pre",
    "ruby",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul"
].map((name)=>({
        type: "type",
        label: name
    }));
var identifier = /^(\w[\w-]*|-\w[\w-]*|)$/, variable = /^-(-[\w-]*)?$/;
function isVarArg(node, doc) {
    var _a;
    if (node.name == "(" || node.type.isError) node = node.parent || node;
    if (node.name != "ArgList") return false;
    var callee = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.firstChild;
    if ((callee === null || callee === void 0 ? void 0 : callee.name) != "Callee") return false;
    return doc.sliceString(callee.from, callee.to) == "var";
}
var VariablesByNode = /*@__PURE__*/ new (0, _common.NodeWeakMap)();
var declSelector = [
    "Declaration"
];
function astTop(node) {
    for(var cur = node;;){
        if (cur.type.isTop) return cur;
        if (!(cur = cur.parent)) return node;
    }
}
function variableNames(doc, node, isVariable) {
    if (node.to - node.from > 4096) {
        var known = VariablesByNode.get(node);
        if (known) return known;
        var result = [], seen = new Set, cursor = node.cursor((0, _common.IterMode).IncludeAnonymous);
        if (cursor.firstChild()) do {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = variableNames(doc, cursor.node, isVariable)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var option = _step.value;
                    if (!seen.has(option.label)) {
                        seen.add(option.label);
                        result.push(option);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }while (cursor.nextSibling());
        VariablesByNode.set(node, result);
        return result;
    } else {
        var result1 = [], seen1 = new Set;
        node.cursor().iterate((node)=>{
            var _a;
            if (isVariable(node) && node.matchContext(declSelector) && ((_a = node.node.nextSibling) === null || _a === void 0 ? void 0 : _a.name) == ":") {
                var name = doc.sliceString(node.from, node.to);
                if (!seen1.has(name)) {
                    seen1.add(name);
                    result1.push({
                        label: name,
                        type: "variable"
                    });
                }
            }
        });
        return result1;
    }
}
/**
Create a completion source for a CSS dialect, providing a
predicate for determining what kind of syntax node can act as a
completable variable. This is used by language modes like Sass and
Less to reuse this package's completion logic.
*/ var defineCSSCompletionSource = (isVariable)=>(context)=>{
        var state = context.state, pos = context.pos, node = (0, _language.syntaxTree)(state).resolveInner(pos, -1);
        var isDash = node.type.isError && node.from == node.to - 1 && state.doc.sliceString(node.from, node.to) == "-";
        if (node.name == "PropertyName" || (isDash || node.name == "TagName") && /^(Block|Styles)$/.test(node.resolve(node.to).name)) return {
            from: node.from,
            options: properties(),
            validFor: identifier
        };
        if (node.name == "ValueName") return {
            from: node.from,
            options: values,
            validFor: identifier
        };
        if (node.name == "PseudoClassName") return {
            from: node.from,
            options: pseudoClasses,
            validFor: identifier
        };
        if (isVariable(node) || (context.explicit || isDash) && isVarArg(node, state.doc)) return {
            from: isVariable(node) || isDash ? node.from : pos,
            options: variableNames(state.doc, astTop(node), isVariable),
            validFor: variable
        };
        if (node.name == "TagName") {
            for(var parent = node.parent; parent; parent = parent.parent)if (parent.name == "Block") return {
                from: node.from,
                options: properties(),
                validFor: identifier
            };
            return {
                from: node.from,
                options: tags,
                validFor: identifier
            };
        }
        if (!context.explicit) return null;
        var above = node.resolve(pos), before = above.childBefore(pos);
        if (before && before.name == ":" && above.name == "PseudoClassSelector") return {
            from: pos,
            options: pseudoClasses,
            validFor: identifier
        };
        if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList") return {
            from: pos,
            options: values,
            validFor: identifier
        };
        if (above.name == "Block" || above.name == "Styles") return {
            from: pos,
            options: properties(),
            validFor: identifier
        };
        return null;
    };
/**
CSS property, variable, and value keyword completion source.
*/ var cssCompletionSource = /*@__PURE__*/ defineCSSCompletionSource((n)=>n.name == "VariableName");
/**
A language provider based on the [Lezer CSS
parser](https://github.com/lezer-parser/css), extended with
highlighting and indentation information.
*/ var cssLanguage = /*@__PURE__*/ (0, _language.LRLanguage).define({
    name: "css",
    parser: /*@__PURE__*/ (0, _css.parser).configure({
        props: [
            /*@__PURE__*/ (0, _language.indentNodeProp).add({
                Declaration: /*@__PURE__*/ (0, _language.continuedIndent)()
            }),
            /*@__PURE__*/ (0, _language.foldNodeProp).add({
                "Block KeyframeList": (0, _language.foldInside)
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*\}$/,
        wordChars: "-"
    }
});
/**
Language support for CSS.
*/ function css() {
    return new (0, _language.LanguageSupport)(cssLanguage, cssLanguage.data.of({
        autocomplete: cssCompletionSource
    }));
}

},{"@lezer/css":"17PuP","@codemirror/language":"jct2S","@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"17PuP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", ()=>parser);
var _lr = require("@lezer/lr");
var _highlight = require("@lezer/highlight");
// This file was generated by lezer-generator. You probably shouldn't edit it.
var descendantOp = 99, Unit = 1, callee = 100, identifier = 101, VariableName = 2;
/* Hand-written tokenizers for CSS tokens that can't be
   expressed by Lezer's built-in tokenizer. */ var space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
var colon = 58, parenL = 40, underscore = 95, bracketL = 91, dash = 45, period = 46, hash = 35, percent = 37, ampersand = 38, backslash = 92, newline = 10;
function isAlpha(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch >= 161;
}
function isDigit(ch) {
    return ch >= 48 && ch <= 57;
}
var identifiers = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    for(var inside = false, dashes = 0, i = 0;; i++){
        var next = input.next;
        if (isAlpha(next) || next == dash || next == underscore || inside && isDigit(next)) {
            if (!inside && (next != dash || i > 0)) inside = true;
            if (dashes === i && next == dash) dashes++;
            input.advance();
        } else if (next == backslash && input.peek(1) != newline) {
            input.advance();
            if (input.next > -1) input.advance();
            inside = true;
        } else {
            if (inside) input.acceptToken(next == parenL ? callee : dashes == 2 && stack.canShift(VariableName) ? VariableName : identifier);
            break;
        }
    }
});
var descendant = new (0, _lr.ExternalTokenizer)((input)=>{
    if (space.includes(input.peek(-1))) {
        var next = input.next;
        if (isAlpha(next) || next == underscore || next == hash || next == period || next == bracketL || next == colon && isAlpha(input.peek(1)) || next == dash || next == ampersand) input.acceptToken(descendantOp);
    }
});
var unitToken = new (0, _lr.ExternalTokenizer)((input)=>{
    if (!space.includes(input.peek(-1))) {
        var next = input.next;
        if (next == percent) {
            input.advance();
            input.acceptToken(Unit);
        }
        if (isAlpha(next)) {
            do input.advance();
            while (isAlpha(input.next) || isDigit(input.next));
            input.acceptToken(Unit);
        }
    }
});
var cssHighlighting = (0, _highlight.styleTags)({
    "AtKeyword import charset namespace keyframes media supports": (0, _highlight.tags).definitionKeyword,
    "from to selector": (0, _highlight.tags).keyword,
    NamespaceName: (0, _highlight.tags).namespace,
    KeyframeName: (0, _highlight.tags).labelName,
    KeyframeRangeName: (0, _highlight.tags).operatorKeyword,
    TagName: (0, _highlight.tags).tagName,
    ClassName: (0, _highlight.tags).className,
    PseudoClassName: (0, _highlight.tags).constant((0, _highlight.tags).className),
    IdName: (0, _highlight.tags).labelName,
    "FeatureName PropertyName": (0, _highlight.tags).propertyName,
    AttributeName: (0, _highlight.tags).attributeName,
    NumberLiteral: (0, _highlight.tags).number,
    KeywordQuery: (0, _highlight.tags).keyword,
    UnaryQueryOp: (0, _highlight.tags).operatorKeyword,
    "CallTag ValueName": (0, _highlight.tags).atom,
    VariableName: (0, _highlight.tags).variableName,
    Callee: (0, _highlight.tags).operatorKeyword,
    Unit: (0, _highlight.tags).unit,
    "UniversalSelector NestingSelector": (0, _highlight.tags).definitionOperator,
    MatchOp: (0, _highlight.tags).compareOperator,
    "ChildOp SiblingOp, LogicOp": (0, _highlight.tags).logicOperator,
    BinOp: (0, _highlight.tags).arithmeticOperator,
    Important: (0, _highlight.tags).modifier,
    Comment: (0, _highlight.tags).blockComment,
    ColorLiteral: (0, _highlight.tags).color,
    "ParenthesizedContent StringLiteral": (0, _highlight.tags).string,
    ":": (0, _highlight.tags).punctuation,
    "PseudoOp #": (0, _highlight.tags).derefOperator,
    "; ,": (0, _highlight.tags).separator,
    "( )": (0, _highlight.tags).paren,
    "[ ]": (0, _highlight.tags).squareBracket,
    "{ }": (0, _highlight.tags).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
var spec_callee = {
    __proto__: null,
    lang: 32,
    "nth-child": 32,
    "nth-last-child": 32,
    "nth-of-type": 32,
    "nth-last-of-type": 32,
    dir: 32,
    "host-context": 32,
    url: 60,
    "url-prefix": 60,
    domain: 60,
    regexp: 60,
    selector: 138
};
var spec_AtKeyword = {
    __proto__: null,
    "@import": 118,
    "@media": 142,
    "@charset": 146,
    "@namespace": 150,
    "@keyframes": 156,
    "@supports": 168
};
var spec_identifier = {
    __proto__: null,
    not: 132,
    only: 132
};
var parser = (0, _lr.LRParser).deserialize({
    version: 14,
    states: ":^QYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DTO$vQ[O'#DWOOQP'#Em'#EmO${QdO'#DgO%jQ[O'#DtO${QdO'#DvO%{Q[O'#DxO&WQ[O'#D{O&`Q[O'#ERO&nQ[O'#ETOOQS'#El'#ElOOQS'#EW'#EWQYQ[OOO&uQXO'#CdO'jQWO'#DcO'oQWO'#EsO'zQ[O'#EsQOQWOOP(UO#tO'#C_POOO)C@[)C@[OOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(aQ[O'#E[O({QWO,58{O)TQ[O,59SO$qQ[O,59oO$vQ[O,59rO(aQ[O,59uO(aQ[O,59wO(aQ[O,59xO)`Q[O'#DbOOQS,58{,58{OOQP'#Ck'#CkOOQO'#DR'#DROOQP,59S,59SO)gQWO,59SO)lQWO,59SOOQP'#DV'#DVOOQP,59o,59oOOQO'#DX'#DXO)qQ`O,59rOOQS'#Cp'#CpO${QdO'#CqO)yQvO'#CsO+ZQtO,5:ROOQO'#Cx'#CxO)lQWO'#CwO+oQWO'#CyO+tQ[O'#DOOOQS'#Ep'#EpOOQO'#Dj'#DjO+|Q[O'#DqO,[QWO'#EtO&`Q[O'#DoO,jQWO'#DrOOQO'#Eu'#EuO)OQWO,5:`O,oQpO,5:bOOQS'#Dz'#DzO,wQWO,5:dO,|Q[O,5:dOOQO'#D}'#D}O-UQWO,5:gO-ZQWO,5:mO-cQWO,5:oOOQS-E8U-E8UO${QdO,59}O-kQ[O'#E^O-xQWO,5;_O-xQWO,5;_POOO'#EV'#EVP.TO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO.zQXO,5:vOOQO-E8Y-E8YOOQS1G.g1G.gOOQP1G.n1G.nO)gQWO1G.nO)lQWO1G.nOOQP1G/Z1G/ZO/XQ`O1G/^O/rQXO1G/aO0YQXO1G/cO0pQXO1G/dO1WQWO,59|O1]Q[O'#DSO1dQdO'#CoOOQP1G/^1G/^O${QdO1G/^O1kQpO,59]OOQS,59_,59_O${QdO,59aO1sQWO1G/mOOQS,59c,59cO1xQ!bO,59eOOQS'#DP'#DPOOQS'#EY'#EYO2QQ[O,59jOOQS,59j,59jO2YQWO'#DjO2eQWO,5:VO2jQWO,5:]O&`Q[O,5:XO&`Q[O'#E_O2rQWO,5;`O2}QWO,5:ZO(aQ[O,5:^OOQS1G/z1G/zOOQS1G/|1G/|OOQS1G0O1G0OO3`QWO1G0OO3eQdO'#EOOOQS1G0R1G0ROOQS1G0X1G0XOOQS1G0Z1G0ZO3pQtO1G/iOOQO,5:x,5:xO4WQ[O,5:xOOQO-E8[-E8[O4eQWO1G0yPOOO-E8T-E8TPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$x7+$xO${QdO7+$xOOQS1G/h1G/hO4pQXO'#ErO4wQWO,59nO4|QtO'#EXO5tQdO'#EoO6OQWO,59ZO6TQpO7+$xOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%X7+%XO6]QWO1G/POOQS-E8W-E8WOOQS1G/U1G/UO${QdO1G/qOOQO1G/w1G/wOOQO1G/s1G/sO6bQWO,5:yOOQO-E8]-E8]O6pQXO1G/xOOQS7+%j7+%jO6wQYO'#CsOOQO'#EQ'#EQO7SQ`O'#EPOOQO'#EP'#EPO7_QWO'#E`O7gQdO,5:jOOQS,5:j,5:jO7rQtO'#E]O${QdO'#E]O8sQdO7+%TOOQO7+%T7+%TOOQO1G0d1G0dO9WQpO<<HdO9`QWO,5;^OOQP1G/Y1G/YOOQS-E8V-E8VO${QdO'#EZO9hQWO,5;ZOOQT1G.u1G.uOOQP<<Hd<<HdOOQS7+$k7+$kO9pQdO7+%]OOQO7+%d7+%dOOQO,5:k,5:kO3hQdO'#EaO7_QWO,5:zOOQS,5:z,5:zOOQS-E8^-E8^OOQS1G0U1G0UO9wQtO,5:wOOQS-E8Z-E8ZOOQO<<Ho<<HoOOQPAN>OAN>OO:xQdO,5:uOOQO-E8X-E8XOOQO<<Hw<<HwOOQO,5:{,5:{OOQO-E8_-E8_OOQS1G0f1G0f",
    stateData: ";[~O#ZOS#[QQ~OUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XRO#bTO~OQfOUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XeO#bTO~O#U#gP~P!ZO#[jO~O#XlO~O]qO^qOqsOtoOxrO!OtO!RvO#VuO#bnO~O!TwO~P#pO`}O#WzO#XyO~O#X!OO~O#X!QO~OQ![Ob!TOf![Oh![On!YOq!ZO#W!WO#X!SO#e!UO~Ob!^O!d!`O!g!aO#X!]O!T#hP~Oh!fOn!YO#X!eO~Oh!hO#X!hO~Ob!^O!d!`O!g!aO#X!]O~O!Y#hP~P%jO]WX]!WX^WXqWXtWXxWX!OWX!RWX!TWX#VWX#bWX~O]!mO~O!Y!nO#U#gX!S#gX~O#U#gX!S#gX~P!ZO#]!qO#^!qO#_!sO~OUYOXYO]VO^VOqXOxWO#XRO#bTO~OtoO!TwO~O`!zO#WzO#XyO~O!S#gP~P!ZOb#RO~Ob#SO~Op#TO|#UO~OP#WObgXjgX!YgX!dgX!ggX#XgXagXQgXfgXhgXngXqgXtgX!XgX#UgX#WgX#egXpgX!SgX~Ob!^Oj#XO!d!`O!g!aO#X!]O!Y#hP~Ob#[O~Op#`O#X#]O~Ob!^O!d!`O!g!aO#X#aO~Ot#eO!b#dO!T#hX!Y#hX~Ob#hO~Oj#XO!Y#jO~O!Y#kO~Oh#lOn!YO~O!T#mO~O!TwO!b#dO~O!TwO!Y#pO~O!Y#QX#U#QX!S#QX~P!ZO!Y!nO#U#ga!S#ga~O#]!qO#^!qO#_#wO~O]qO^qOqsOxrO!OtO!RvO#VuO#bnO~Ot#Oa!T#Oaa#Oa~P.`Op#yO|#zO~O]qO^qOqsOxrO#bnO~Ot}i!O}i!R}i!T}i#V}ia}i~P/aOt!Pi!O!Pi!R!Pi!T!Pi#V!Pia!Pi~P/aOt!Qi!O!Qi!R!Qi!T!Qi#V!Qia!Qi~P/aO!S#{O~Oa#fP~P(aOa#cP~P${Oa$SOj#XO~O!Y$UO~Oh$VOo$VO~Op$XO#X#]O~O]!`Xa!^X!b!^X~O]$YO~Oa$ZO!b#dO~Ot#eO!T#ha!Y#ha~O!b#dOt!ca!T!ca!Y!caa!ca~O!Y$`O~O!S$gO#X$bO#e$aO~Oj#XOt$iO!X$kO!Y!Vi#U!Vi!S!Vi~P${O!Y#Qa#U#Qa!S#Qa~P!ZO!Y!nO#U#gi!S#gi~Oa#fX~P#pOa$oO~Oj#XOQ!{Xa!{Xb!{Xf!{Xh!{Xn!{Xq!{Xt!{X#W!{X#X!{X#e!{X~Ot$qOa#cX~P${Oa$sO~Oj#XOp$tO~Oa$uO~O!b#dOt#Ra!T#Ra!Y#Ra~Oa$wO~P.`OP#WOtgX!TgX~O#e$aOt!sX!T!sX~Ot$yO!TwO~O!S$}O#X$bO#e$aO~Oj#XOQ#PXb#PXf#PXh#PXn#PXq#PXt#PX!X#PX!Y#PX#U#PX#W#PX#X#PX#e#PX!S#PX~Ot$iO!X%QO!Y!Vq#U!Vq!S!Vq~P${Oj#XOp%RO~OtoOa#fa~Ot$qOa#ca~Oa%UO~P${Oj#XOQ#Pab#Paf#Pah#Pan#Paq#Pat#Pa!X#Pa!Y#Pa#U#Pa#W#Pa#X#Pa#e#Pa!S#Pa~Oa!}at!}a~P${O#Zo#[#ej!R#e~",
    goto: "-g#jPPP#kP#nP#w$WP#w$g#wPP$mPPP$s$|$|P%`P$|P$|%z&^PPPP$|&vP&z'Q#wP'W#w'^P#wP#w#wPPP'd'y(WPP#nPP(_(_(i(_P(_P(_(_P#nP#nP#nP(l#nP(o(r(u(|#nP#nP)R)X)h)v)|*S*^*d*n*t*zPPPPPPPPPP+Q+ZP+v+yP,o,r,x-RRkQ_bOPdhw!n#skYOPdhotuvw!n#R#h#skSOPdhotuvw!n#R#h#sQmTR!tnQ{VR!xqQ!x}Q#Z!XR#x!zq![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%Sp![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%SU$d#m$f$yR$x$cq!XZ]!T!m#S#U#X#q#z$P$Y$i$j$q$v%Sp![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%SQ!f^R#l!gT#^!Z#_Q|VR!yqQ!x|R#x!yQ!PWR!{rQ!RXR!|sQxUQ!wpQ#i!cQ#o!jQ#p!kQ${$eR%X$zSgPwQ!phQ#r!nR$l#sZfPhw!n#sa!b[`a!V!^!`#d#eR#b!^R!g^R!i_R#n!iS$e#m$fR%V$yV$c#m$f$yQ!rjR#v!rQdOShPwU!ldh#sR#s!nQ$P#SU$p$P$v%SQ$v$YR%S$qQ#_!ZR$W#_Q$r$PR%T$rQpUS!vp$nR$n#|Q$j#qR%P$jQ!ogS#t!o#uR#u!pQ#f!_R$^#fQ$f#mR$|$fQ$z$eR%W$z_cOPdhw!n#s^UOPdhw!n#sQ!uoQ!}tQ#OuQ#PvQ#|#RR$_#hR$Q#SQ!VZQ!d]Q#V!TQ#q!m[$O#S$P$Y$q$v%SQ$R#UQ$T#XS$h#q$jQ$m#zR%O$iR#}#RQiPR#QwQ!c[Q!kaR#Y!VU!_[a!VQ!j`Q#c!^Q#g!`Q$[#dR$]#e",
    nodeNames: "\u26A0 Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent ] [ LineNames LineName , PseudoClassName ArgList IdSelector # IdName AttributeSelector AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
    maxTerm: 117,
    nodeProps: [
        [
            "isolate",
            -2,
            3,
            24,
            ""
        ],
        [
            "openedBy",
            17,
            "(",
            32,
            "[",
            50,
            "{"
        ],
        [
            "closedBy",
            18,
            ")",
            33,
            "]",
            51,
            "}"
        ]
    ],
    propSources: [
        cssHighlighting
    ],
    skippedNodes: [
        0,
        3,
        87
    ],
    repeatNodeCount: 11,
    tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#Z~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#Z~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!X[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYxQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QS|So`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!RQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#e[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#e[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSt^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#bQOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#[~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!Y^Oy%^z;'S%^;'S;=`%o<%lO%^dCoS|SOy%^z;'S%^;'S;=`%o<%lO%^bDQU!OQOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS!OQo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[![Qo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^nFfSq^Oy%^z;'S%^;'S;=`%o<%lO%^nFwSp^Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!bQo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!TUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!S^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!RQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
    tokenizers: [
        descendant,
        unitToken,
        identifiers,
        1,
        2,
        3,
        4,
        new (0, _lr.LocalTokenGroup)("m~RRYZ[z{a~~g~aO#^~~dP!P!Qg~lO#_~~", 28, 105)
    ],
    topRules: {
        "StyleSheet": [
            0,
            4
        ],
        "Styles": [
            1,
            86
        ]
    },
    specialized: [
        {
            term: 100,
            get: (value)=>spec_callee[value] || -1
        },
        {
            term: 58,
            get: (value)=>spec_AtKeyword[value] || -1
        },
        {
            term: 101,
            get: (value)=>spec_identifier[value] || -1
        }
    ],
    tokenPrec: 1200
});

},{"@lezer/lr":"gQicU","@lezer/highlight":"pdORT","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5bkjX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoCloseTags", ()=>autoCloseTags);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "htmlCompletionSource", ()=>htmlCompletionSource);
parcelHelpers.export(exports, "htmlCompletionSourceWith", ()=>htmlCompletionSourceWith);
parcelHelpers.export(exports, "htmlLanguage", ()=>htmlLanguage);
parcelHelpers.export(exports, "htmlPlain", ()=>htmlPlain);
var _html = require("@lezer/html");
var _langCss = require("@codemirror/lang-css");
var _langJavascript = require("@codemirror/lang-javascript");
var _view = require("@codemirror/view");
var _state = require("@codemirror/state");
var _language = require("@codemirror/language");
var Targets = [
    "_blank",
    "_self",
    "_top",
    "_parent"
];
var Charsets = [
    "ascii",
    "utf-8",
    "utf-16",
    "latin1",
    "latin1"
];
var Methods = [
    "get",
    "post",
    "put",
    "delete"
];
var Encs = [
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
];
var Bool = [
    "true",
    "false"
];
var S = {}; // Empty tag spec
var Tags = {
    a: {
        attrs: {
            href: null,
            ping: null,
            type: null,
            media: null,
            target: Targets,
            hreflang: null
        }
    },
    abbr: S,
    address: S,
    area: {
        attrs: {
            alt: null,
            coords: null,
            href: null,
            target: null,
            ping: null,
            media: null,
            hreflang: null,
            type: null,
            shape: [
                "default",
                "rect",
                "circle",
                "poly"
            ]
        }
    },
    article: S,
    aside: S,
    audio: {
        attrs: {
            src: null,
            mediagroup: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "none",
                "metadata",
                "auto"
            ],
            autoplay: [
                "autoplay"
            ],
            loop: [
                "loop"
            ],
            controls: [
                "controls"
            ]
        }
    },
    b: S,
    base: {
        attrs: {
            href: null,
            target: Targets
        }
    },
    bdi: S,
    bdo: S,
    blockquote: {
        attrs: {
            cite: null
        }
    },
    body: S,
    br: S,
    button: {
        attrs: {
            form: null,
            formaction: null,
            name: null,
            value: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "autofocus"
            ],
            formenctype: Encs,
            formmethod: Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: Targets,
            type: [
                "submit",
                "reset",
                "button"
            ]
        }
    },
    canvas: {
        attrs: {
            width: null,
            height: null
        }
    },
    caption: S,
    center: S,
    cite: S,
    code: S,
    col: {
        attrs: {
            span: null
        }
    },
    colgroup: {
        attrs: {
            span: null
        }
    },
    command: {
        attrs: {
            type: [
                "command",
                "checkbox",
                "radio"
            ],
            label: null,
            icon: null,
            radiogroup: null,
            command: null,
            title: null,
            disabled: [
                "disabled"
            ],
            checked: [
                "checked"
            ]
        }
    },
    data: {
        attrs: {
            value: null
        }
    },
    datagrid: {
        attrs: {
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    datalist: {
        attrs: {
            data: null
        }
    },
    dd: S,
    del: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    details: {
        attrs: {
            open: [
                "open"
            ]
        }
    },
    dfn: S,
    div: S,
    dl: S,
    dt: S,
    em: S,
    embed: {
        attrs: {
            src: null,
            type: null,
            width: null,
            height: null
        }
    },
    eventsource: {
        attrs: {
            src: null
        }
    },
    fieldset: {
        attrs: {
            disabled: [
                "disabled"
            ],
            form: null,
            name: null
        }
    },
    figcaption: S,
    figure: S,
    footer: S,
    form: {
        attrs: {
            action: null,
            name: null,
            "accept-charset": Charsets,
            autocomplete: [
                "on",
                "off"
            ],
            enctype: Encs,
            method: Methods,
            novalidate: [
                "novalidate"
            ],
            target: Targets
        }
    },
    h1: S,
    h2: S,
    h3: S,
    h4: S,
    h5: S,
    h6: S,
    head: {
        children: [
            "title",
            "base",
            "link",
            "style",
            "meta",
            "script",
            "noscript",
            "command"
        ]
    },
    header: S,
    hgroup: S,
    hr: S,
    html: {
        attrs: {
            manifest: null
        }
    },
    i: S,
    iframe: {
        attrs: {
            src: null,
            srcdoc: null,
            name: null,
            width: null,
            height: null,
            sandbox: [
                "allow-top-navigation",
                "allow-same-origin",
                "allow-forms",
                "allow-scripts"
            ],
            seamless: [
                "seamless"
            ]
        }
    },
    img: {
        attrs: {
            alt: null,
            src: null,
            ismap: null,
            usemap: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ]
        }
    },
    input: {
        attrs: {
            alt: null,
            dirname: null,
            form: null,
            formaction: null,
            height: null,
            list: null,
            max: null,
            maxlength: null,
            min: null,
            name: null,
            pattern: null,
            placeholder: null,
            size: null,
            src: null,
            step: null,
            value: null,
            width: null,
            accept: [
                "audio/*",
                "video/*",
                "image/*"
            ],
            autocomplete: [
                "on",
                "off"
            ],
            autofocus: [
                "autofocus"
            ],
            checked: [
                "checked"
            ],
            disabled: [
                "disabled"
            ],
            formenctype: Encs,
            formmethod: Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: Targets,
            multiple: [
                "multiple"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            type: [
                "hidden",
                "text",
                "search",
                "tel",
                "url",
                "email",
                "password",
                "datetime",
                "date",
                "month",
                "week",
                "time",
                "datetime-local",
                "number",
                "range",
                "color",
                "checkbox",
                "radio",
                "file",
                "submit",
                "image",
                "reset",
                "button"
            ]
        }
    },
    ins: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    kbd: S,
    keygen: {
        attrs: {
            challenge: null,
            form: null,
            name: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            keytype: [
                "RSA"
            ]
        }
    },
    label: {
        attrs: {
            for: null,
            form: null
        }
    },
    legend: S,
    li: {
        attrs: {
            value: null
        }
    },
    link: {
        attrs: {
            href: null,
            type: null,
            hreflang: null,
            media: null,
            sizes: [
                "all",
                "16x16",
                "16x16 32x32",
                "16x16 32x32 64x64"
            ]
        }
    },
    map: {
        attrs: {
            name: null
        }
    },
    mark: S,
    menu: {
        attrs: {
            label: null,
            type: [
                "list",
                "context",
                "toolbar"
            ]
        }
    },
    meta: {
        attrs: {
            content: null,
            charset: Charsets,
            name: [
                "viewport",
                "application-name",
                "author",
                "description",
                "generator",
                "keywords"
            ],
            "http-equiv": [
                "content-language",
                "content-type",
                "default-style",
                "refresh"
            ]
        }
    },
    meter: {
        attrs: {
            value: null,
            min: null,
            low: null,
            high: null,
            max: null,
            optimum: null
        }
    },
    nav: S,
    noscript: S,
    object: {
        attrs: {
            data: null,
            type: null,
            name: null,
            usemap: null,
            form: null,
            width: null,
            height: null,
            typemustmatch: [
                "typemustmatch"
            ]
        }
    },
    ol: {
        attrs: {
            reversed: [
                "reversed"
            ],
            start: null,
            type: [
                "1",
                "a",
                "A",
                "i",
                "I"
            ]
        },
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    optgroup: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null
        }
    },
    option: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null,
            selected: [
                "selected"
            ],
            value: null
        }
    },
    output: {
        attrs: {
            for: null,
            form: null,
            name: null
        }
    },
    p: S,
    param: {
        attrs: {
            name: null,
            value: null
        }
    },
    pre: S,
    progress: {
        attrs: {
            value: null,
            max: null
        }
    },
    q: {
        attrs: {
            cite: null
        }
    },
    rp: S,
    rt: S,
    ruby: S,
    samp: S,
    script: {
        attrs: {
            type: [
                "text/javascript"
            ],
            src: null,
            async: [
                "async"
            ],
            defer: [
                "defer"
            ],
            charset: Charsets
        }
    },
    section: S,
    select: {
        attrs: {
            form: null,
            name: null,
            size: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    slot: {
        attrs: {
            name: null
        }
    },
    small: S,
    source: {
        attrs: {
            src: null,
            type: null,
            media: null
        }
    },
    span: S,
    strong: S,
    style: {
        attrs: {
            type: [
                "text/css"
            ],
            media: null,
            scoped: null
        }
    },
    sub: S,
    summary: S,
    sup: S,
    table: S,
    tbody: S,
    td: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null
        }
    },
    template: S,
    textarea: {
        attrs: {
            dirname: null,
            form: null,
            maxlength: null,
            name: null,
            placeholder: null,
            rows: null,
            cols: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            wrap: [
                "soft",
                "hard"
            ]
        }
    },
    tfoot: S,
    th: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null,
            scope: [
                "row",
                "col",
                "rowgroup",
                "colgroup"
            ]
        }
    },
    thead: S,
    time: {
        attrs: {
            datetime: null
        }
    },
    title: S,
    tr: S,
    track: {
        attrs: {
            src: null,
            label: null,
            default: null,
            kind: [
                "subtitles",
                "captions",
                "descriptions",
                "chapters",
                "metadata"
            ],
            srclang: null
        }
    },
    ul: {
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    var: S,
    video: {
        attrs: {
            src: null,
            poster: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "auto",
                "metadata",
                "none"
            ],
            autoplay: [
                "autoplay"
            ],
            mediagroup: [
                "movie"
            ],
            muted: [
                "muted"
            ],
            controls: [
                "controls"
            ]
        }
    },
    wbr: S
};
var GlobalAttrs = {
    accesskey: null,
    class: null,
    contenteditable: Bool,
    contextmenu: null,
    dir: [
        "ltr",
        "rtl",
        "auto"
    ],
    draggable: [
        "true",
        "false",
        "auto"
    ],
    dropzone: [
        "copy",
        "move",
        "link",
        "string:",
        "file:"
    ],
    hidden: [
        "hidden"
    ],
    id: null,
    inert: [
        "inert"
    ],
    itemid: null,
    itemprop: null,
    itemref: null,
    itemscope: [
        "itemscope"
    ],
    itemtype: null,
    lang: [
        "ar",
        "bn",
        "de",
        "en-GB",
        "en-US",
        "es",
        "fr",
        "hi",
        "id",
        "ja",
        "pa",
        "pt",
        "ru",
        "tr",
        "zh"
    ],
    spellcheck: Bool,
    autocorrect: Bool,
    autocapitalize: Bool,
    style: null,
    tabindex: null,
    title: null,
    translate: [
        "yes",
        "no"
    ],
    rel: [
        "stylesheet",
        "alternate",
        "author",
        "bookmark",
        "help",
        "license",
        "next",
        "nofollow",
        "noreferrer",
        "prefetch",
        "prev",
        "search",
        "tag"
    ],
    role: /*@__PURE__*/ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
    "aria-activedescendant": null,
    "aria-atomic": Bool,
    "aria-autocomplete": [
        "inline",
        "list",
        "both",
        "none"
    ],
    "aria-busy": Bool,
    "aria-checked": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-controls": null,
    "aria-describedby": null,
    "aria-disabled": Bool,
    "aria-dropeffect": null,
    "aria-expanded": [
        "true",
        "false",
        "undefined"
    ],
    "aria-flowto": null,
    "aria-grabbed": [
        "true",
        "false",
        "undefined"
    ],
    "aria-haspopup": Bool,
    "aria-hidden": Bool,
    "aria-invalid": [
        "true",
        "false",
        "grammar",
        "spelling"
    ],
    "aria-label": null,
    "aria-labelledby": null,
    "aria-level": null,
    "aria-live": [
        "off",
        "polite",
        "assertive"
    ],
    "aria-multiline": Bool,
    "aria-multiselectable": Bool,
    "aria-owns": null,
    "aria-posinset": null,
    "aria-pressed": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-readonly": Bool,
    "aria-relevant": null,
    "aria-required": Bool,
    "aria-selected": [
        "true",
        "false",
        "undefined"
    ],
    "aria-setsize": null,
    "aria-sort": [
        "ascending",
        "descending",
        "none",
        "other"
    ],
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null
};
var eventAttributes = /*@__PURE__*/ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((n)=>"on" + n);
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = eventAttributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var a = _step.value;
        GlobalAttrs[a] = null;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
class Schema {
    constructor(extraTags, extraAttrs){
        this.tags = Object.assign(Object.assign({}, Tags), extraTags);
        this.globalAttrs = Object.assign(Object.assign({}, GlobalAttrs), extraAttrs);
        this.allTags = Object.keys(this.tags);
        this.globalAttrNames = Object.keys(this.globalAttrs);
    }
}
Schema.default = /*@__PURE__*/ new Schema;
function elementName(doc, tree) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : doc.length;
    if (!tree) return "";
    var tag = tree.firstChild;
    var name = tag && tag.getChild("TagName");
    return name ? doc.sliceString(name.from, Math.min(name.to, max)) : "";
}
function findParentElement(tree) {
    var skip = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    for(; tree; tree = tree.parent)if (tree.name == "Element") {
        if (skip) skip = false;
        else return tree;
    }
    return null;
}
function allowedChildren(doc, tree, schema) {
    var parentInfo = schema.tags[elementName(doc, findParentElement(tree))];
    return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || schema.allTags;
}
function openTags(doc, tree) {
    var open = [];
    for(var parent = findParentElement(tree); parent && !parent.type.isTop; parent = findParentElement(parent.parent)){
        var tagName = elementName(doc, parent);
        if (tagName && parent.lastChild.name == "CloseTag") break;
        if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to)) open.push(tagName);
    }
    return open;
}
var identifier = /^[:\-\.\w\u00b7-\uffff]*$/;
function completeTag(state, schema, tree, from, to) {
    var end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    var parent = findParentElement(tree, true);
    return {
        from,
        to,
        options: allowedChildren(state.doc, parent, schema).map((tagName)=>({
                label: tagName,
                type: "type"
            })).concat(openTags(state.doc, tree).map((tag, i)=>({
                label: "/" + tag,
                apply: "/" + tag + end,
                type: "type",
                boost: 99 - i
            }))),
        validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function completeCloseTag(state, tree, from, to) {
    var end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    return {
        from,
        to,
        options: openTags(state.doc, tree).map((tag, i)=>({
                label: tag,
                apply: tag + end,
                type: "type",
                boost: 99 - i
            })),
        validFor: identifier
    };
}
function completeStartTag(state, schema, tree, pos) {
    var options = [], level = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allowedChildren(state.doc, tree, schema)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tagName = _step.value;
            options.push({
                label: "<" + tagName,
                type: "type"
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = openTags(state.doc, tree)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var open = _step1.value;
            options.push({
                label: "</" + open + ">",
                type: "type",
                boost: 99 - level++
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        from: pos,
        to: pos,
        options,
        validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function completeAttrName(state, schema, tree, from, to) {
    var elt = findParentElement(tree), info = elt ? schema.tags[elementName(state.doc, elt)] : null;
    var localAttrs = info && info.attrs ? Object.keys(info.attrs) : [];
    var names = info && info.globalAttrs === false ? localAttrs : localAttrs.length ? localAttrs.concat(schema.globalAttrNames) : schema.globalAttrNames;
    return {
        from,
        to,
        options: names.map((attrName)=>({
                label: attrName,
                type: "property"
            })),
        validFor: identifier
    };
}
function completeAttrValue(state, schema, tree, from, to) {
    var _a;
    var nameNode = (_a = tree.parent) === null || _a === void 0 ? void 0 : _a.getChild("AttributeName");
    var options = [], token = undefined;
    if (nameNode) {
        var attrName = state.sliceDoc(nameNode.from, nameNode.to);
        var attrs = schema.globalAttrs[attrName];
        if (!attrs) {
            var elt = findParentElement(tree), info = elt ? schema.tags[elementName(state.doc, elt)] : null;
            attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
        }
        if (attrs) {
            var base = state.sliceDoc(from, to).toLowerCase(), quoteStart = '"', quoteEnd = '"';
            if (/^['"]/.test(base)) {
                token = base[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
                quoteStart = "";
                quoteEnd = state.sliceDoc(to, to + 1) == base[0] ? "" : base[0];
                base = base.slice(1);
                from++;
            } else token = /^[^\s<>='"]*$/;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = attrs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var value = _step.value;
                    options.push({
                        label: value,
                        apply: quoteStart + value + quoteEnd,
                        type: "constant"
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    return {
        from,
        to,
        options,
        validFor: token
    };
}
function htmlCompletionFor(schema, context) {
    var state = context.state, pos = context.pos, tree = (0, _language.syntaxTree)(state).resolveInner(pos, -1), around = tree.resolve(pos);
    for(var scan = pos, before; around == tree && (before = tree.childBefore(scan));){
        var last = before.lastChild;
        if (!last || !last.type.isError || last.from < last.to) break;
        around = tree = before;
        scan = last.from;
    }
    if (tree.name == "TagName") return tree.parent && /CloseTag$/.test(tree.parent.name) ? completeCloseTag(state, tree, tree.from, pos) : completeTag(state, schema, tree, tree.from, pos);
    else if (tree.name == "StartTag") return completeTag(state, schema, tree, pos, pos);
    else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") return completeCloseTag(state, tree, pos, pos);
    else if (tree.name == "OpenTag" || tree.name == "SelfClosingTag" || tree.name == "AttributeName") return completeAttrName(state, schema, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
    else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") return completeAttrValue(state, schema, tree, tree.name == "Is" ? pos : tree.from, pos);
    else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) return completeStartTag(state, schema, tree, pos);
    else return null;
}
/**
HTML tag completion. Opens and closes tags and attributes in a
context-aware way.
*/ function htmlCompletionSource(context) {
    return htmlCompletionFor(Schema.default, context);
}
/**
Create a completion source for HTML extended with additional tags
or attributes.
*/ function htmlCompletionSourceWith(config) {
    var extraTags = config.extraTags, extraAttrs = config.extraGlobalAttributes;
    var schema = extraAttrs || extraTags ? new Schema(extraTags, extraAttrs) : Schema.default;
    return (context)=>htmlCompletionFor(schema, context);
}
var jsonParser = /*@__PURE__*/ (0, _langJavascript.javascriptLanguage).parser.configure({
    top: "SingleExpression"
});
var defaultNesting = [
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript" || attrs.lang == "ts",
        parser: (0, _langJavascript.typescriptLanguage).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/babel" || attrs.type == "text/jsx",
        parser: (0, _langJavascript.jsxLanguage).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript-jsx",
        parser: (0, _langJavascript.tsxLanguage).parser
    },
    {
        tag: "script",
        attrs (attrs) {
            return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(attrs.type);
        },
        parser: jsonParser
    },
    {
        tag: "script",
        attrs (attrs) {
            return !attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(attrs.type);
        },
        parser: (0, _langJavascript.javascriptLanguage).parser
    },
    {
        tag: "style",
        attrs (attrs) {
            return (!attrs.lang || attrs.lang == "css") && (!attrs.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(attrs.type));
        },
        parser: (0, _langCss.cssLanguage).parser
    }
];
var defaultAttrs = /*@__PURE__*/ [
    {
        name: "style",
        parser: /*@__PURE__*/ (0, _langCss.cssLanguage).parser.configure({
            top: "Styles"
        })
    }
].concat(/*@__PURE__*/ eventAttributes.map((name)=>({
        name,
        parser: (0, _langJavascript.javascriptLanguage).parser
    })));
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ var htmlPlain = /*@__PURE__*/ (0, _language.LRLanguage).define({
    name: "html",
    parser: /*@__PURE__*/ (0, _html.parser).configure({
        props: [
            /*@__PURE__*/ (0, _language.indentNodeProp).add({
                Element (context) {
                    var after = /^(\s*)(<\/)?/.exec(context.textAfter);
                    if (context.node.to <= context.pos + after[0].length) return context.continue();
                    return context.lineIndent(context.node.from) + (after[2] ? 0 : context.unit);
                },
                "OpenTag CloseTag SelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                },
                Document (context) {
                    if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to) return context.continue();
                    var endElt = null, close;
                    for(var cur = context.node;;){
                        var last = cur.lastChild;
                        if (!last || last.name != "Element" || last.to != cur.to) break;
                        endElt = cur = last;
                    }
                    if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag"))) return context.lineIndent(endElt.from) + context.unit;
                    return null;
                }
            }),
            /*@__PURE__*/ (0, _language.foldNodeProp).add({
                Element (node) {
                    var first = node.firstChild, last = node.lastChild;
                    if (!first || first.name != "OpenTag") return null;
                    return {
                        from: first.to,
                        to: last.name == "CloseTag" ? last.from : node.to
                    };
                }
            }),
            /*@__PURE__*/ (0, _language.bracketMatchingHandle).add({
                "OpenTag CloseTag": (node)=>node.getChild("TagName")
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "<!--",
                close: "-->"
            }
        },
        indentOnInput: /^\s*<\/\w+\W$/,
        wordChars: "-._"
    }
});
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ var htmlLanguage = /*@__PURE__*/ htmlPlain.configure({
    wrap: /*@__PURE__*/ (0, _html.configureNesting)(defaultNesting, defaultAttrs)
});
/**
Language support for HTML, including
[`htmlCompletion`](https://codemirror.net/6/docs/ref/#lang-html.htmlCompletion) and JavaScript and
CSS support extensions.
*/ function html() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var dialect = "", wrap;
    if (config.matchClosingTags === false) dialect = "noMatch";
    if (config.selfClosingTags === true) dialect = (dialect ? dialect + " " : "") + "selfClosing";
    if (config.nestedLanguages && config.nestedLanguages.length || config.nestedAttributes && config.nestedAttributes.length) wrap = (0, _html.configureNesting)((config.nestedLanguages || []).concat(defaultNesting), (config.nestedAttributes || []).concat(defaultAttrs));
    var lang = wrap ? htmlPlain.configure({
        wrap,
        dialect
    }) : dialect ? htmlLanguage.configure({
        dialect
    }) : htmlLanguage;
    return new (0, _language.LanguageSupport)(lang, [
        htmlLanguage.data.of({
            autocomplete: htmlCompletionSourceWith(config)
        }),
        config.autoCloseTags !== false ? autoCloseTags : [],
        (0, _langJavascript.javascript)().support,
        (0, _langCss.css)().support
    ]);
}
var selfClosers = /*@__PURE__*/ new Set(/*@__PURE__*/ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" "));
/**
Extension that will automatically insert close tags when a `>` or
`/` is typed.
*/ var autoCloseTags = /*@__PURE__*/ (0, _view.EditorView).inputHandler.of((view, from, to, text, insertTransaction)=>{
    if (view.composing || view.state.readOnly || from != to || text != ">" && text != "/" || !htmlLanguage.isActiveAt(view.state, from, -1)) return false;
    var base = insertTransaction(), state = base.state;
    var closeTags = state.changeByRange((range)=>{
        var _a, _b, _c;
        var didType = state.doc.sliceString(range.from - 1, range.to) == text;
        var head = range.head, around = (0, _language.syntaxTree)(state).resolveInner(head - 1, -1), name;
        if (around.name == "TagName" || around.name == "StartTag") around = around.parent;
        if (didType && text == ">" && around.name == "OpenTag") {
            if (((_b = (_a = around.parent) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.name) != "CloseTag" && (name = elementName(state.doc, around.parent, head)) && !selfClosers.has(name)) {
                var _$to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                var insert = `</${name}>`;
                return {
                    range,
                    changes: {
                        from: head,
                        to: _$to,
                        insert
                    }
                };
            }
        } else if (didType && text == "/" && around.name == "IncompleteCloseTag") {
            var base = around.parent;
            if (around.from == head - 2 && ((_c = base.lastChild) === null || _c === void 0 ? void 0 : _c.name) != "CloseTag" && (name = elementName(state.doc, base, head)) && !selfClosers.has(name)) {
                var _$to1 = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                var insert1 = `${name}>`;
                return {
                    range: (0, _state.EditorSelection).cursor(head + insert1.length, -1),
                    changes: {
                        from: head,
                        to: _$to1,
                        insert: insert1
                    }
                };
            }
        }
        return {
            range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});

},{"@lezer/html":"6XKWB","@codemirror/lang-css":"25igp","@codemirror/lang-javascript":"0dLBb","@codemirror/view":"l3day","@codemirror/state":"fECfb","@codemirror/language":"jct2S","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"6XKWB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configureNesting", ()=>configureNesting);
parcelHelpers.export(exports, "parser", ()=>parser);
var _lr = require("@lezer/lr");
var _highlight = require("@lezer/highlight");
var _common = require("@lezer/common");
// This file was generated by lezer-generator. You probably shouldn't edit it.
var scriptText = 54, StartCloseScriptTag = 1, styleText = 55, StartCloseStyleTag = 2, textareaText = 56, StartCloseTextareaTag = 3, EndTag = 4, SelfClosingEndTag = 5, StartTag = 6, StartScriptTag = 7, StartStyleTag = 8, StartTextareaTag = 9, StartSelfClosingTag = 10, StartCloseTag = 11, NoMatchStartCloseTag = 12, MismatchedStartCloseTag = 13, missingCloseTag = 57, IncompleteCloseTag = 14, commentContent$1 = 58, Element = 20, TagName = 22, Attribute = 23, AttributeName = 24, AttributeValue = 26, UnquotedAttributeValue = 27, ScriptText = 28, StyleText = 31, TextareaText = 34, OpenTag = 36, CloseTag = 37, Dialect_noMatch = 0, Dialect_selfClosing = 1;
/* Hand-written tokenizers for HTML. */ var selfClosers = {
    area: true,
    base: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
var implicitlyClosed = {
    dd: true,
    li: true,
    optgroup: true,
    option: true,
    p: true,
    rp: true,
    rt: true,
    tbody: true,
    td: true,
    tfoot: true,
    th: true,
    tr: true
};
var closeOnOpen = {
    dd: {
        dd: true,
        dt: true
    },
    dt: {
        dd: true,
        dt: true
    },
    li: {
        li: true
    },
    option: {
        option: true,
        optgroup: true
    },
    optgroup: {
        optgroup: true
    },
    p: {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        dir: true,
        div: true,
        dl: true,
        fieldset: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        menu: true,
        nav: true,
        ol: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        ul: true
    },
    rp: {
        rp: true,
        rt: true
    },
    rt: {
        rp: true,
        rt: true
    },
    tbody: {
        tbody: true,
        tfoot: true
    },
    td: {
        td: true,
        th: true
    },
    tfoot: {
        tbody: true
    },
    th: {
        td: true,
        th: true
    },
    thead: {
        tbody: true,
        tfoot: true
    },
    tr: {
        tr: true
    }
};
function nameChar(ch) {
    return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function isSpace(ch) {
    return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
var cachedName = null, cachedInput = null, cachedPos = 0;
function tagNameAfter(input, offset) {
    var pos = input.pos + offset;
    if (cachedPos == pos && cachedInput == input) return cachedName;
    var next = input.peek(offset);
    while(isSpace(next))next = input.peek(++offset);
    var name = "";
    for(;;){
        if (!nameChar(next)) break;
        name += String.fromCharCode(next);
        next = input.peek(++offset);
    }
    // Undefined to signal there's a <? or <!, null for just missing
    cachedInput = input;
    cachedPos = pos;
    return cachedName = name ? name.toLowerCase() : next == question || next == bang ? undefined : null;
}
var lessThan = 60, greaterThan = 62, slash = 47, question = 63, bang = 33, dash = 45;
function ElementContext(name, parent) {
    this.name = name;
    this.parent = parent;
    this.hash = parent ? parent.hash : 0;
    for(var i = 0; i < name.length; i++)this.hash += (this.hash << 4) + name.charCodeAt(i) + (name.charCodeAt(i) << 8);
}
var startTagTerms = [
    StartTag,
    StartSelfClosingTag,
    StartScriptTag,
    StartStyleTag,
    StartTextareaTag
];
var elementContext = new (0, _lr.ContextTracker)({
    start: null,
    shift (context, term, stack, input) {
        return startTagTerms.indexOf(term) > -1 ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
    },
    reduce (context, term) {
        return term == Element && context ? context.parent : context;
    },
    reuse (context, node, stack, input) {
        var type = node.type.id;
        return type == StartTag || type == OpenTag ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
    },
    hash (context) {
        return context ? context.hash : 0;
    },
    strict: false
});
var tagStart = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    if (input.next != lessThan) {
        // End of file, close any open tags
        if (input.next < 0 && stack.context) input.acceptToken(missingCloseTag);
        return;
    }
    input.advance();
    var close = input.next == slash;
    if (close) input.advance();
    var name = tagNameAfter(input, 0);
    if (name === undefined) return;
    if (!name) return input.acceptToken(close ? IncompleteCloseTag : StartTag);
    var parent = stack.context ? stack.context.name : null;
    if (close) {
        if (name == parent) return input.acceptToken(StartCloseTag);
        if (parent && implicitlyClosed[parent]) return input.acceptToken(missingCloseTag, -2);
        if (stack.dialectEnabled(Dialect_noMatch)) return input.acceptToken(NoMatchStartCloseTag);
        for(var cx = stack.context; cx; cx = cx.parent)if (cx.name == name) return;
        input.acceptToken(MismatchedStartCloseTag);
    } else {
        if (name == "script") return input.acceptToken(StartScriptTag);
        if (name == "style") return input.acceptToken(StartStyleTag);
        if (name == "textarea") return input.acceptToken(StartTextareaTag);
        if (selfClosers.hasOwnProperty(name)) return input.acceptToken(StartSelfClosingTag);
        if (parent && closeOnOpen[parent] && closeOnOpen[parent][name]) input.acceptToken(missingCloseTag, -1);
        else input.acceptToken(StartTag);
    }
}, {
    contextual: true
});
var commentContent = new (0, _lr.ExternalTokenizer)((input)=>{
    for(var dashes = 0, i = 0;; i++){
        if (input.next < 0) {
            if (i) input.acceptToken(commentContent$1);
            break;
        }
        if (input.next == dash) dashes++;
        else if (input.next == greaterThan && dashes >= 2) {
            if (i >= 3) input.acceptToken(commentContent$1, -2);
            break;
        } else dashes = 0;
        input.advance();
    }
});
function inForeignElement(context) {
    for(; context; context = context.parent)if (context.name == "svg" || context.name == "math") return true;
    return false;
}
var endTag = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    if (input.next == slash && input.peek(1) == greaterThan) {
        var selfClosing = stack.dialectEnabled(Dialect_selfClosing) || inForeignElement(stack.context);
        input.acceptToken(selfClosing ? SelfClosingEndTag : EndTag, 2);
    } else if (input.next == greaterThan) input.acceptToken(EndTag, 1);
});
function contentTokenizer(tag, textToken, endToken) {
    var lastState = 2 + tag.length;
    return new (0, _lr.ExternalTokenizer)((input)=>{
        // state means:
        // - 0 nothing matched
        // - 1 '<' matched
        // - 2 '</' + possibly whitespace matched
        // - 3-(1+tag.length) part of the tag matched
        // - lastState whole tag + possibly whitespace matched
        for(var state = 0, matchedLen = 0, i = 0;; i++){
            if (input.next < 0) {
                if (i) input.acceptToken(textToken);
                break;
            }
            if (state == 0 && input.next == lessThan || state == 1 && input.next == slash || state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2)) {
                state++;
                matchedLen++;
            } else if ((state == 2 || state == lastState) && isSpace(input.next)) matchedLen++;
            else if (state == lastState && input.next == greaterThan) {
                if (i > matchedLen) input.acceptToken(textToken, -matchedLen);
                else input.acceptToken(endToken, -(matchedLen - 2));
                break;
            } else if ((input.next == 10 /* '\n' */  || input.next == 13 /* '\r' */ ) && i) {
                input.acceptToken(textToken, 1);
                break;
            } else state = matchedLen = 0;
            input.advance();
        }
    });
}
var scriptTokens = contentTokenizer("script", scriptText, StartCloseScriptTag);
var styleTokens = contentTokenizer("style", styleText, StartCloseStyleTag);
var textareaTokens = contentTokenizer("textarea", textareaText, StartCloseTextareaTag);
var htmlHighlighting = (0, _highlight.styleTags)({
    "Text RawText": (0, _highlight.tags).content,
    "StartTag StartCloseTag SelfClosingEndTag EndTag": (0, _highlight.tags).angleBracket,
    TagName: (0, _highlight.tags).tagName,
    "MismatchedCloseTag/TagName": [
        (0, _highlight.tags).tagName,
        (0, _highlight.tags).invalid
    ],
    AttributeName: (0, _highlight.tags).attributeName,
    "AttributeValue UnquotedAttributeValue": (0, _highlight.tags).attributeValue,
    Is: (0, _highlight.tags).definitionOperator,
    "EntityReference CharacterReference": (0, _highlight.tags).character,
    Comment: (0, _highlight.tags).blockComment,
    ProcessingInst: (0, _highlight.tags).processingInstruction,
    DoctypeDecl: (0, _highlight.tags).documentMeta
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
var parser = (0, _lr.LRParser).deserialize({
    version: 14,
    states: ",xOVO!rOOO!WQ#tO'#CqO!]Q#tO'#CzO!bQ#tO'#C}O!gQ#tO'#DQO!lQ#tO'#DSO!qOaO'#CpO!|ObO'#CpO#XOdO'#CpO$eO!rO'#CpOOO`'#Cp'#CpO$lO$fO'#DTO$tQ#tO'#DVO$yQ#tO'#DWOOO`'#Dk'#DkOOO`'#DY'#DYQVO!rOOO%OQ&rO,59]O%ZQ&rO,59fO%fQ&rO,59iO%qQ&rO,59lO%|Q&rO,59nOOOa'#D^'#D^O&XOaO'#CxO&dOaO,59[OOOb'#D_'#D_O&lObO'#C{O&wObO,59[OOOd'#D`'#D`O'POdO'#DOO'[OdO,59[OOO`'#Da'#DaO'dO!rO,59[O'kQ#tO'#DROOO`,59[,59[OOOp'#Db'#DbO'pO$fO,59oOOO`,59o,59oO'xQ#|O,59qO'}Q#|O,59rOOO`-E7W-E7WO(SQ&rO'#CsOOQW'#DZ'#DZO(bQ&rO1G.wOOOa1G.w1G.wOOO`1G/Y1G/YO(mQ&rO1G/QOOOb1G/Q1G/QO(xQ&rO1G/TOOOd1G/T1G/TO)TQ&rO1G/WOOO`1G/W1G/WO)`Q&rO1G/YOOOa-E7[-E7[O)kQ#tO'#CyOOO`1G.v1G.vOOOb-E7]-E7]O)pQ#tO'#C|OOOd-E7^-E7^O)uQ#tO'#DPOOO`-E7_-E7_O)zQ#|O,59mOOOp-E7`-E7`OOO`1G/Z1G/ZOOO`1G/]1G/]OOO`1G/^1G/^O*PQ,UO,59_OOQW-E7X-E7XOOOa7+$c7+$cOOO`7+$t7+$tOOOb7+$l7+$lOOOd7+$o7+$oOOO`7+$r7+$rO*[Q#|O,59eO*aQ#|O,59hO*fQ#|O,59kOOO`1G/X1G/XO*kO7[O'#CvO*|OMhO'#CvOOQW1G.y1G.yOOO`1G/P1G/POOO`1G/S1G/SOOO`1G/V1G/VOOOO'#D['#D[O+_O7[O,59bOOQW,59b,59bOOOO'#D]'#D]O+pOMhO,59bOOOO-E7Y-E7YOOQW1G.|1G.|OOOO-E7Z-E7Z",
    stateData: ",]~O!^OS~OUSOVPOWQOXROYTO[]O][O^^O`^Oa^Ob^Oc^Ox^O{_O!dZO~OfaO~OfbO~OfcO~OfdO~OfeO~O!WfOPlP!ZlP~O!XiOQoP!ZoP~O!YlORrP!ZrP~OUSOVPOWQOXROYTOZqO[]O][O^^O`^Oa^Ob^Oc^Ox^O!dZO~O!ZrO~P#dO![sO!euO~OfvO~OfwO~OS|OT}OhyO~OS!POT}OhyO~OS!ROT}OhyO~OS!TOT}OhyO~OS}OT}OhyO~O!WfOPlX!ZlX~OP!WO!Z!XO~O!XiOQoX!ZoX~OQ!ZO!Z!XO~O!YlORrX!ZrX~OR!]O!Z!XO~O!Z!XO~P#dOf!_O~O![sO!e!aO~OS!bO~OS!cO~Oi!dOSgXTgXhgX~OS!fOT!gOhyO~OS!hOT!gOhyO~OS!iOT!gOhyO~OS!jOT!gOhyO~OS!gOT!gOhyO~Of!kO~Of!lO~Of!mO~OS!nO~Ok!qO!`!oO!b!pO~OS!rO~OS!sO~OS!tO~Oa!uOb!uOc!uO!`!wO!a!uO~Oa!xOb!xOc!xO!b!wO!c!xO~Oa!uOb!uOc!uO!`!{O!a!uO~Oa!xOb!xOc!xO!b!{O!c!xO~OT~bac!dx{!d~",
    goto: "%p!`PPPPPPPPPPPPPPPPPPPP!a!gP!mPP!yP!|#P#S#Y#]#`#f#i#l#r#x!aP!a!aP$O$U$l$r$x%O%U%[%bPPPPPPPP%hX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
    nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
    maxTerm: 67,
    context: elementContext,
    nodeProps: [
        [
            "closedBy",
            -10,
            1,
            2,
            3,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            "EndTag",
            6,
            "EndTag SelfClosingEndTag",
            -4,
            21,
            30,
            33,
            36,
            "CloseTag"
        ],
        [
            "openedBy",
            4,
            "StartTag StartCloseTag",
            5,
            "StartTag",
            -4,
            29,
            32,
            35,
            37,
            "OpenTag"
        ],
        [
            "group",
            -9,
            14,
            17,
            18,
            19,
            20,
            39,
            40,
            41,
            42,
            "Entity",
            16,
            "Entity TextContent",
            -3,
            28,
            31,
            34,
            "TextContent Entity"
        ],
        [
            "isolate",
            -11,
            21,
            29,
            30,
            32,
            33,
            35,
            36,
            37,
            38,
            41,
            42,
            "ltr",
            -3,
            26,
            27,
            39,
            ""
        ]
    ],
    propSources: [
        htmlHighlighting
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 9,
    tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|c`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bX`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UV`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pT`POv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!cpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({W`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!a`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!a`!cpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYkWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]``P!a`!cp!^^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebhSkWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXhSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vchS`P!a`!cpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!`h`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WihSkWc!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zbkWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOa!R!R7tP;=`<%l7S!Z8OYkWa!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{ihSkWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbhSkWa!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QchSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXhSa!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TakWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOb!R!RAwP;=`<%lAY!ZBRYkWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbhSkWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbhSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXhSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!bx`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYlhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_khS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_X`P!a`!cp!eQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZhSfQ`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!a`!cpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!a`!cp!dPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!a`!cpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!a`!cpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!a`!cpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!a`!cpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!a`!cpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!a`!cpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!a`!cpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!cpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO{PP!-nP;=`<%l!-Sq!-xS!cp{POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!a`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!a`{POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!a`!cp{POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!a`!cpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!a`!cpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!a`!cpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!a`!cpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!a`!cpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!a`!cpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!cpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOxPP!7TP;=`<%l!6Vq!7]V!cpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!cpxPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!a`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!a`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!a`xPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!a`!cpxPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXiS`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
    tokenizers: [
        scriptTokens,
        styleTokens,
        textareaTokens,
        endTag,
        tagStart,
        commentContent,
        0,
        1,
        2,
        3,
        4,
        5
    ],
    topRules: {
        "Document": [
            0,
            15
        ]
    },
    dialects: {
        noMatch: 0,
        selfClosing: 509
    },
    tokenPrec: 511
});
function getAttrs(openTag, input) {
    var attrs = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = openTag.getChildren(Attribute)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var att = _step.value;
            var name = att.getChild(AttributeName), value = att.getChild(AttributeValue) || att.getChild(UnquotedAttributeValue);
            if (name) attrs[input.read(name.from, name.to)] = !value ? "" : value.type.id == AttributeValue ? input.read(value.from + 1, value.to - 1) : input.read(value.from, value.to);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return attrs;
}
function findTagName(openTag, input) {
    var tagNameNode = openTag.getChild(TagName);
    return tagNameNode ? input.read(tagNameNode.from, tagNameNode.to) : " ";
}
function maybeNest(node, input, tags) {
    var attrs;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tag = _step.value;
            if (!tag.attrs || tag.attrs(attrs || (attrs = getAttrs(node.node.parent.firstChild, input)))) return {
                parser: tag.parser
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
// tags?: {
//   tag: string,
//   attrs?: ({[attr: string]: string}) => boolean,
//   parser: Parser
// }[]
// attributes?: {
//   name: string,
//   tagName?: string,
//   parser: Parser
// }[]
function configureNesting() {
    var _$tags = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var script = [], style = [], textarea = [], other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _$tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tag = _step.value;
            var array = tag.tag == "script" ? script : tag.tag == "style" ? style : tag.tag == "textarea" ? textarea : other;
            array.push(tag);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var attrs = attributes.length ? Object.create(null) : null;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = attributes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var attr = _step1.value;
            (attrs[attr.name] || (attrs[attr.name] = [])).push(attr);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return (0, _common.parseMixed)((node, input)=>{
        var id = node.type.id;
        if (id == ScriptText) return maybeNest(node, input, script);
        if (id == StyleText) return maybeNest(node, input, style);
        if (id == TextareaText) return maybeNest(node, input, textarea);
        if (id == Element && other.length) {
            var n = node.node, open = n.firstChild, tagName = open && findTagName(open, input), attrs1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (tagName) try {
                for(var _iterator = other[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var tag = _step.value;
                    if (tag.tag == tagName && (!tag.attrs || tag.attrs(attrs1 || (attrs1 = getAttrs(n, input))))) {
                        var close = n.lastChild;
                        var to = close.type.id == CloseTag ? close.from : n.to;
                        if (to > open.to) return {
                            parser: tag.parser,
                            overlay: [
                                {
                                    from: open.to,
                                    to
                                }
                            ]
                        };
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (attrs && id == Attribute) {
            var n1 = node.node, nameNode;
            if (nameNode = n1.firstChild) {
                var matches = attrs[input.read(nameNode.from, nameNode.to)];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (matches) try {
                    for(var _iterator1 = matches[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var attr = _step1.value;
                        if (attr.tagName && attr.tagName != findTagName(n1.parent, input)) continue;
                        var value = n1.lastChild;
                        if (value.type.id == AttributeValue) {
                            var from = value.from + 1;
                            var last = value.lastChild, to1 = value.to - (last && last.isError ? 0 : 1);
                            if (to1 > from) return {
                                parser: attr.parser,
                                overlay: [
                                    {
                                        from,
                                        to: to1
                                    }
                                ]
                            };
                        } else if (value.type.id == UnquotedAttributeValue) return {
                            parser: attr.parser,
                            overlay: [
                                {
                                    from: value.from,
                                    to: value.to
                                }
                            ]
                        };
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
        return null;
    });
}

},{"@lezer/lr":"gQicU","@lezer/highlight":"pdORT","@lezer/common":"9CjLE","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"j44hx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "yaml", ()=>yaml);
parcelHelpers.export(exports, "yamlLanguage", ()=>yamlLanguage);
var _yaml = require("@lezer/yaml");
var _language = require("@codemirror/language");
/**
A language provider based on the [Lezer YAML
parser](https://github.com/lezer-parser/yaml), extended with
highlighting and indentation information.
*/ var yamlLanguage = /*@__PURE__*/ (0, _language.LRLanguage).define({
    name: "yaml",
    parser: /*@__PURE__*/ (0, _yaml.parser).configure({
        props: [
            /*@__PURE__*/ (0, _language.indentNodeProp).add({
                Stream: (cx)=>{
                    for(var before = cx.node.resolve(cx.pos, -1); before && before.to >= cx.pos; before = before.parent){
                        if (before.name == "BlockLiteralContent" && before.from < before.to) return cx.baseIndentFor(before);
                        if (before.name == "BlockLiteral") return cx.baseIndentFor(before) + cx.unit;
                        if (before.name == "BlockSequence" || before.name == "BlockMapping") return cx.column(before.from, 1);
                        if (before.name == "QuotedLiteral") return null;
                        if (before.name == "Literal") {
                            var col = cx.column(before.from, 1);
                            if (col == cx.lineIndent(before.from, 1)) return col; // Start on own line
                            if (before.to > cx.pos) return null;
                        }
                    }
                    return null;
                },
                FlowMapping: /*@__PURE__*/ (0, _language.delimitedIndent)({
                    closing: "}"
                }),
                FlowSequence: /*@__PURE__*/ (0, _language.delimitedIndent)({
                    closing: "]"
                })
            }),
            /*@__PURE__*/ (0, _language.foldNodeProp).add({
                "FlowMapping FlowSequence": (0, _language.foldInside),
                "BlockSequence BlockMapping BlockLiteral": (node, state)=>({
                        from: state.doc.lineAt(node.from).to,
                        to: node.to
                    })
            })
        ]
    }),
    languageData: {
        commentTokens: {
            line: "#"
        },
        indentOnInput: /^\s*[\]\}]$/
    }
});
/**
Language support for YAML.
*/ function yaml() {
    return new (0, _language.LanguageSupport)(yamlLanguage);
}

},{"@lezer/yaml":"jslaO","@codemirror/language":"jct2S","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jslaO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", ()=>parser);
var _defineProperty = require("@swc/helpers/_/_define_property");
var _lr = require("@lezer/lr");
var _highlight = require("@lezer/highlight");
// This file was generated by lezer-generator. You probably shouldn't edit it.
var blockEnd = 63, eof = 64, DirectiveEnd = 1, DocEnd = 2, sequenceStartMark = 3, sequenceContinueMark = 4, explicitMapStartMark = 5, explicitMapContinueMark = 6, flowMapMark = 7, mapStartMark = 65, mapContinueMark = 66, Literal = 8, QuotedLiteral = 9, Anchor = 10, Alias = 11, Tag = 12, BlockLiteralContent = 13, BracketL = 19, FlowSequence = 20, Colon = 29, BraceL = 33, FlowMapping = 34, BlockLiteralHeader = 47;
var type_Top = 0, type_Seq = 1, type_Map = 2, type_Flow = 3, type_Lit = 4; // Block literal with explicit indentation
class Context {
    constructor(parent, depth, type){
        this.parent = parent;
        this.depth = depth;
        this.type = type;
        this.hash = (parent ? parent.hash + parent.hash << 8 : 0) + depth + (depth << 4) + type;
    }
}
(0, _defineProperty._)(Context, "top", new Context(null, -1, type_Top));
function findColumn(input, pos) {
    for(var col = 0, p = pos - input.pos - 1;; p--, col++){
        var ch = input.peek(p);
        if (isBreakSpace(ch) || ch == -1) return col;
    }
}
function isNonBreakSpace(ch) {
    return ch == 32 || ch == 9;
}
function isBreakSpace(ch) {
    return ch == 10 || ch == 13;
}
function isSpace(ch) {
    return isNonBreakSpace(ch) || isBreakSpace(ch);
}
function isSep(ch) {
    return ch < 0 || isSpace(ch);
}
var indentation = new (0, _lr.ContextTracker)({
    start: Context.top,
    reduce (context, term) {
        return context.type == type_Flow && (term == FlowSequence || term == FlowMapping) ? context.parent : context;
    },
    shift (context, term, stack, input) {
        if (term == sequenceStartMark) return new Context(context, findColumn(input, input.pos), type_Seq);
        if (term == mapStartMark || term == explicitMapStartMark) return new Context(context, findColumn(input, input.pos), type_Map);
        if (term == blockEnd) return context.parent;
        if (term == BracketL || term == BraceL) return new Context(context, 0, type_Flow);
        if (term == BlockLiteralContent && context.type == type_Lit) return context.parent;
        if (term == BlockLiteralHeader) {
            var indent = /[1-9]/.exec(input.read(input.pos, stack.pos));
            if (indent) return new Context(context, context.depth + +indent[0], type_Lit);
        }
        return context;
    },
    hash (context) {
        return context.hash;
    }
});
function three(input, ch) {
    var off = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return input.peek(off) == ch && input.peek(off + 1) == ch && input.peek(off + 2) == ch && isSep(input.peek(off + 3));
}
var newlines = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    if (input.next == -1 && stack.canShift(eof)) return input.acceptToken(eof);
    var prev = input.peek(-1);
    if ((isBreakSpace(prev) || prev < 0) && stack.context.type != type_Flow) {
        if (three(input, 45 /* '-' */ )) {
            if (stack.canShift(blockEnd)) input.acceptToken(blockEnd);
            else return input.acceptToken(DirectiveEnd, 3);
        }
        if (three(input, 46 /* '.' */ )) {
            if (stack.canShift(blockEnd)) input.acceptToken(blockEnd);
            else return input.acceptToken(DocEnd, 3);
        }
        var depth = 0;
        while(input.next == 32 /* ' ' */ ){
            depth++;
            input.advance();
        }
        if ((depth < stack.context.depth || depth == stack.context.depth && stack.context.type == type_Seq && (input.next != 45 /* '-' */  || !isSep(input.peek(1)))) && // Not blank
        input.next != -1 && !isBreakSpace(input.next) && input.next != 35 /* '#' */ ) input.acceptToken(blockEnd, -depth);
    }
}, {
    contextual: true
});
var blockMark = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    if (stack.context.type == type_Flow) {
        if (input.next == 63 /* '?' */ ) {
            input.advance();
            if (isSep(input.next)) input.acceptToken(flowMapMark);
        }
        return;
    }
    if (input.next == 45 /* '-' */ ) {
        input.advance();
        if (isSep(input.next)) input.acceptToken(stack.context.type == type_Seq && stack.context.depth == findColumn(input, input.pos - 1) ? sequenceContinueMark : sequenceStartMark);
    } else if (input.next == 63 /* '?' */ ) {
        input.advance();
        if (isSep(input.next)) input.acceptToken(stack.context.type == type_Map && stack.context.depth == findColumn(input, input.pos - 1) ? explicitMapContinueMark : explicitMapStartMark);
    } else {
        var start = input.pos;
        // Scan over a potential key to see if it is followed by a colon.
        for(;;){
            if (isNonBreakSpace(input.next)) {
                if (input.pos == start) return;
                input.advance();
            } else if (input.next == 33 /* '!' */ ) readTag(input);
            else if (input.next == 38 /* '&' */ ) readAnchor(input);
            else if (input.next == 42 /* '*' */ ) {
                readAnchor(input);
                break;
            } else if (input.next == 39 /* "'" */  || input.next == 34 /* '"' */ ) {
                if (readQuoted(input, true)) break;
                return;
            } else if (input.next == 91 /* '[' */  || input.next == 123 /* '{' */ ) {
                if (!scanBrackets(input)) return;
                break;
            } else {
                readPlain(input, true, false, 0);
                break;
            }
        }
        while(isNonBreakSpace(input.next))input.advance();
        if (input.next == 58 /* ':' */ ) {
            if (input.pos == start && stack.canShift(Colon)) return;
            var after = input.peek(1);
            if (isSep(after)) input.acceptTokenTo(stack.context.type == type_Map && stack.context.depth == findColumn(input, start) ? mapContinueMark : mapStartMark, start);
        }
    }
}, {
    contextual: true
});
function uriChar(ch) {
    return ch > 32 && ch < 127 && ch != 34 && ch != 37 && ch != 44 && ch != 60 && ch != 62 && ch != 92 && ch != 94 && ch != 96 && ch != 123 && ch != 124 && ch != 125;
}
function hexChar(ch) {
    return ch >= 48 && ch <= 57 || ch >= 97 && ch <= 102 || ch >= 65 && ch <= 70;
}
function readUriChar(input, quoted) {
    if (input.next == 37 /* '%' */ ) {
        input.advance();
        if (hexChar(input.next)) input.advance();
        if (hexChar(input.next)) input.advance();
        return true;
    } else if (uriChar(input.next) || quoted && input.next == 44 /* ',' */ ) {
        input.advance();
        return true;
    }
    return false;
}
function readTag(input) {
    input.advance(); // !
    if (input.next == 60 /* '<' */ ) {
        input.advance();
        for(;;)if (!readUriChar(input, true)) {
            if (input.next == 62 /* '>' */ ) input.advance();
            break;
        }
    } else {
        while(readUriChar(input, false));
    }
}
function readAnchor(input) {
    input.advance();
    while(!isSep(input.next) && charTag(input.tag) != "f")input.advance();
}
function readQuoted(input, scan) {
    var quote = input.next, lineBreak = false, start = input.pos;
    input.advance();
    for(;;){
        var ch = input.next;
        if (ch < 0) break;
        input.advance();
        if (ch == quote) {
            if (ch == 39 /* "'" */ ) {
                if (input.next == 39) input.advance();
                else break;
            } else break;
        } else if (ch == 92 /* "\\" */  && quote == 34 /* '"' */ ) {
            if (input.next >= 0) input.advance();
        } else if (isBreakSpace(ch)) {
            if (scan) return false;
            lineBreak = true;
        } else if (scan && input.pos >= start + 1024) return false;
    }
    return !lineBreak;
}
function scanBrackets(input) {
    for(var stack = [], end = input.pos + 1024;;){
        if (input.next == 91 /* '[' */  || input.next == 123 /* '{' */ ) {
            stack.push(input.next);
            input.advance();
        } else if (input.next == 39 /* "'" */  || input.next == 34 /* '"' */ ) {
            if (!readQuoted(input, true)) return false;
        } else if (input.next == 93 /* ']' */  || input.next == 125 /* '}' */ ) {
            if (stack[stack.length - 1] != input.next - 2) return false;
            stack.pop();
            input.advance();
            if (!stack.length) return true;
        } else if (input.next < 0 || input.pos > end || isBreakSpace(input.next)) return false;
        else input.advance();
    }
}
// "Safe char" info for char codes 33 to 125. s: safe, i: indicator, f: flow indicator
var charTable = "iiisiiissisfissssssssssssisssiiissssssssssssssssssssssssssfsfssissssssssssssssssssssssssssfif";
function charTag(ch) {
    if (ch < 33) return "u";
    if (ch > 125) return "s";
    return charTable[ch - 33];
}
function isSafe(ch, inFlow) {
    var tag = charTag(ch);
    return tag != "u" && !(inFlow && tag == "f");
}
function readPlain(input, scan, inFlow, indent) {
    if (charTag(input.next) == "s" || (input.next == 63 /* '?' */  || input.next == 58 /* ':' */  || input.next == 45 /* '-' */ ) && isSafe(input.peek(1), inFlow)) input.advance();
    else return false;
    var start = input.pos;
    for(;;){
        var next = input.next, off = 0, lineIndent = indent + 1;
        while(isSpace(next)){
            if (isBreakSpace(next)) {
                if (scan) return false;
                lineIndent = 0;
            } else lineIndent++;
            next = input.peek(++off);
        }
        var safe = next >= 0 && (next == 58 /* ':' */  ? isSafe(input.peek(off + 1), inFlow) : next == 35 /* '#' */  ? input.peek(off - 1) != 32 /* ' ' */  : isSafe(next, inFlow));
        if (!safe || !inFlow && lineIndent <= indent || lineIndent == 0 && !inFlow && (three(input, 45, off) || three(input, 46, off))) break;
        if (scan && charTag(next) == "f") return false;
        for(var i = off; i >= 0; i--)input.advance();
        if (scan && input.pos > start + 1024) return false;
    }
    return true;
}
var literals = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    if (input.next == 33 /* '!' */ ) {
        readTag(input);
        input.acceptToken(Tag);
    } else if (input.next == 38 /* '&' */  || input.next == 42 /* '*' */ ) {
        var token = input.next == 38 ? Anchor : Alias;
        readAnchor(input);
        input.acceptToken(token);
    } else if (input.next == 39 /* "'" */  || input.next == 34 /* '"' */ ) {
        readQuoted(input, false);
        input.acceptToken(QuotedLiteral);
    } else if (readPlain(input, false, stack.context.type == type_Flow, stack.context.depth)) input.acceptToken(Literal);
});
var blockLiteral = new (0, _lr.ExternalTokenizer)((input, stack)=>{
    var indent = stack.context.type == type_Lit ? stack.context.depth : -1, upto = input.pos;
    scan: for(;;){
        var depth = 0, next = input.next;
        while(next == 32 /* ' ' */ )next = input.peek(++depth);
        if (!depth && (three(input, 45, depth) || three(input, 46, depth))) break;
        if (!isBreakSpace(next)) {
            if (indent < 0) indent = Math.max(stack.context.depth + 1, depth);
            if (depth < indent) break;
        }
        for(;;){
            if (input.next < 0) break scan;
            var isBreak = isBreakSpace(input.next);
            input.advance();
            if (isBreak) continue scan;
            upto = input.pos;
        }
    }
    input.acceptTokenTo(BlockLiteralContent, upto);
});
var yamlHighlighting = (0, _highlight.styleTags)({
    DirectiveName: (0, _highlight.tags).keyword,
    DirectiveContent: (0, _highlight.tags).attributeValue,
    "DirectiveEnd DocEnd": (0, _highlight.tags).meta,
    QuotedLiteral: (0, _highlight.tags).string,
    BlockLiteralHeader: (0, _highlight.tags).special((0, _highlight.tags).string),
    BlockLiteralContent: (0, _highlight.tags).content,
    Literal: (0, _highlight.tags).content,
    "Key/Literal Key/QuotedLiteral": (0, _highlight.tags).definition((0, _highlight.tags).propertyName),
    "Anchor Alias": (0, _highlight.tags).labelName,
    Tag: (0, _highlight.tags).typeName,
    Comment: (0, _highlight.tags).lineComment,
    ": , -": (0, _highlight.tags).separator,
    "?": (0, _highlight.tags).punctuation,
    "[ ]": (0, _highlight.tags).squareBracket,
    "{ }": (0, _highlight.tags).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
var parser = (0, _lr.LRParser).deserialize({
    version: 14,
    states: "5lQ!ZQgOOO#PQfO'#CpO#uQfO'#DOOOQR'#Dv'#DvO$qQgO'#DRO%gQdO'#DUO%nQgO'#DUO&ROaO'#D[OOQR'#Du'#DuO&{QgO'#D^O'rQgO'#D`OOQR'#Dt'#DtO(iOqO'#DbOOQP'#Dj'#DjO(zQaO'#CmO)YQgO'#CmOOQP'#Cm'#CmQ)jQaOOQ)uQgOOQ]QgOOO*PQdO'#CrO*nQdO'#CtOOQO'#Dw'#DwO+]Q`O'#CxO+hQdO'#CwO+rQ`O'#CwOOQO'#Cv'#CvO+wQdO'#CvOOQO'#Cq'#CqO,UQ`O,59[O,^QfO,59[OOQR,59[,59[OOQO'#Cx'#CxO,eQ`O'#DPO,pQdO'#DPOOQO'#Dx'#DxO,zQdO'#DxO-XQ`O,59jO-aQfO,59jOOQR,59j,59jOOQR'#DS'#DSO-hQcO,59mO-sQgO'#DVO.TQ`O'#DVO.YQcO,59pOOQR'#DX'#DXO#|QfO'#DWO.hQcO'#DWOOQR,59v,59vO.yOWO,59vO/OOaO,59vO/WOaO,59vO/cQgO'#D_OOQR,59x,59xO0VQgO'#DaOOQR,59z,59zOOQP,59|,59|O0yOaO,59|O1ROaO,59|O1aOqO,59|OOQP-E7h-E7hO1oQgO,59XOOQP,59X,59XO2PQaO'#DeO2_QgO'#DeO2oQgO'#DkOOQP'#Dk'#DkQ)jQaOOO3PQdO'#CsOOQO,59^,59^O3kQdO'#CuOOQO,59`,59`OOQO,59c,59cO4VQdO,59cO4aQdO'#CzO4kQ`O'#CzOOQO,59b,59bOOQU,5:Q,5:QOOQR1G.v1G.vO4pQ`O1G.vOOQU-E7d-E7dO4xQdO,59kOOQO,59k,59kO5SQdO'#DQO5^Q`O'#DQOOQO,5:d,5:dOOQU,5:R,5:ROOQR1G/U1G/UO5cQ`O1G/UOOQU-E7e-E7eO5kQgO'#DhO5xQcO1G/XOOQR1G/X1G/XOOQR,59q,59qO6TQgO,59qO6eQdO'#DiO6lQgO'#DiO7PQcO1G/[OOQR1G/[1G/[OOQR,59r,59rO#|QfO,59rOOQR1G/b1G/bO7_OWO1G/bO7dOaO1G/bOOQR,59y,59yOOQR,59{,59{OOQP1G/h1G/hO7lOaO1G/hO7tOaO1G/hO8POaO1G/hOOQP1G.s1G.sO8_QgO,5:POOQP,5:P,5:POOQP,5:V,5:VOOQP-E7i-E7iOOQO,59_,59_OOQO,59a,59aOOQO1G.}1G.}OOQO,59f,59fO8oQdO,59fOOQR7+$b7+$bP,XQ`O'#DfOOQO1G/V1G/VOOQO,59l,59lO8yQdO,59lOOQR7+$p7+$pP9TQ`O'#DgOOQR'#DT'#DTOOQR,5:S,5:SOOQR-E7f-E7fOOQR7+$s7+$sOOQR1G/]1G/]O9YQgO'#DYO9jQ`O'#DYOOQR,5:T,5:TO#|QfO'#DZO9oQcO'#DZOOQR-E7g-E7gOOQR7+$v7+$vOOQR1G/^1G/^OOQR7+$|7+$|O:QOWO7+$|OOQP7+%S7+%SO:VOaO7+%SO:_OaO7+%SOOQP1G/k1G/kOOQO1G/Q1G/QOOQO1G/W1G/WOOQR,59t,59tO:jQgO,59tOOQR,59u,59uO#|QfO,59uOOQR<<Hh<<HhOOQP<<Hn<<HnO:zOaO<<HnOOQR1G/`1G/`OOQR1G/a1G/aOOQPAN>YAN>Y",
    stateData: ";S~O!fOS!gOS^OS~OP_OQbORSOTUOWROXROYYOZZO[XOcPOqQO!PVO!V[O!cTO~O`cO~P]OVkOWROXROYeOZfO[dOcPOmhOqQO~OboO~P!bOVtOWROXROYeOZfO[dOcPOmrOqQO~OpwO~P#WORSOTUOWROXROYYOZZO[XOcPOqQO!PVO!cTO~OSvP!avP!bvP~P#|OWROXROYeOZfO[dOcPOqQO~OmzO~P%OOm!OOUzP!azP!bzP!dzP~P#|O^!SO!b!QO!f!TO!g!RO~ORSOTUOWROXROcPOqQO!PVO!cTO~OY!UOP!QXQ!QX!V!QX!`!QXS!QX!a!QX!b!QXU!QXm!QX!d!QX~P&aO[!WOP!SXQ!SX!V!SX!`!SXS!SX!a!SX!b!SXU!SXm!SX!d!SX~P&aO^!ZO!W![O!b!YO!f!]O!g!YO~OP!_O!V[OQaX!`aX~OPaXQaX!VaX!`aX~P#|OP!bOQ!cO!V[O~OP_O!V[O~P#|OWROXROY!fOcPOqQObfXmfXofXpfX~OWROXRO[!hOcPOqQObhXmhXohXphX~ObeXmlXoeX~ObkXokX~P%OOm!kO~Om!lObnPonP~P%OOb!pOo!oO~Ob!pO~P!bOm!sOosXpsX~OosXpsX~P%OOm!uOotPptP~P%OOo!xOp!yO~Op!yO~P#WOS!|O!a#OO!b#OO~OUyX!ayX!byX!dyX~P#|Om#QO~OU#SO!a#UO!b#UO!d#RO~Om#WOUzX!azX!bzX!dzX~O]#XO~O!b#XO!g#YO~O^#ZO!b#XO!g#YO~OP!RXQ!RX!V!RX!`!RXS!RX!a!RX!b!RXU!RXm!RX!d!RX~P&aOP!TXQ!TX!V!TX!`!TXS!TX!a!TX!b!TXU!TXm!TX!d!TX~P&aO!b#^O!g#^O~O^#_O!b#^O!f#`O!g#^O~O^#_O!W#aO!b#^O!g#^O~OPaaQaa!Vaa!`aa~P#|OP#cO!V[OQ!XX!`!XX~OP!XXQ!XX!V!XX!`!XX~P#|OP_O!V[OQ!_X!`!_X~P#|OWROXROcPOqQObgXmgXogXpgX~OWROXROcPOqQObiXmiXoiXpiX~Obkaoka~P%OObnXonX~P%OOm#kO~Ob#lOo!oO~Oosapsa~P%OOotXptX~P%OOm#pO~Oo!xOp#qO~OSwP!awP!bwP~P#|OS!|O!a#vO!b#vO~OUya!aya!bya!dya~P#|Om#xO~P%OOm#{OU}P!a}P!b}P!d}P~P#|OU#SO!a$OO!b$OO!d#RO~O]$QO~O!b$QO!g$RO~O!b$SO!g$SO~O^$TO!b$SO!g$SO~O^$TO!b$SO!f$UO!g$SO~OP!XaQ!Xa!V!Xa!`!Xa~P#|Obnaona~P%OOotapta~P%OOo!xO~OU|X!a|X!b|X!d|X~P#|Om$ZO~Om$]OU}X!a}X!b}X!d}X~O]$^O~O!b$_O!g$_O~O^$`O!b$_O!g$_O~OU|a!a|a!b|a!d|a~P#|O!b$cO!g$cO~O",
    goto: ",]!mPPPPPPPPPPPPPPPPP!nPP!v#v#|$`#|$c$f$j$nP%VPPP!v%Y%^%a%{&O%a&R&U&X&_&b%aP&e&{&e'O'RPP']'a'g'm's'y(XPPPPPPPP(_)e*X+c,VUaObcR#e!c!{ROPQSTUXY_bcdehknrtvz!O!U!W!_!b!c!f!h!k!l!s!u!|#Q#R#S#W#c#k#p#x#{$Z$]QmPR!qnqfPQThknrtv!k!l!s!u#R#k#pR!gdR!ieTlPnTjPnSiPnSqQvQ{TQ!mkQ!trQ!vtR#y#RR!nkTsQvR!wt!RWOSUXY_bcz!O!U!W!_!b!c!|#Q#S#W#c#x#{$Z$]RySR#t!|R|TR|UQ!PUR#|#SR#z#RR#z#SyZOSU_bcz!O!_!b!c!|#Q#S#W#c#x#{$Z$]R!VXR!XYa]O^abc!a!c!eT!da!eQnPR!rnQvQR!{vQ!}yR#u!}Q#T|R#}#TW^Obc!cS!^^!aT!aa!eQ!eaR#f!eW`Obc!cQxSS}U#SQ!`_Q#PzQ#V!OQ#b!_Q#d!bQ#s!|Q#w#QQ$P#WQ$V#cQ$Y#xQ$[#{Q$a$ZR$b$]xZOSU_bcz!O!_!b!c!|#Q#S#W#c#x#{$Z$]Q!VXQ!XYQ#[!UR#]!W!QWOSUXY_bcz!O!U!W!_!b!c!|#Q#S#W#c#x#{$Z$]pfPQThknrtv!k!l!s!u#R#k#pQ!gdQ!ieQ#g!fR#h!hSgPn^pQTkrtv#RQ!jhQ#i!kQ#j!lQ#n!sQ#o!uQ$W#kR$X#pQuQR!zv",
    nodeNames: "\u26A0 DirectiveEnd DocEnd - - ? ? ? Literal QuotedLiteral Anchor Alias Tag BlockLiteralContent Comment Stream BOM Document ] [ FlowSequence Item Tagged Anchored Anchored Tagged FlowMapping Pair Key : Pair , } { FlowMapping Pair Pair BlockSequence Item Item BlockMapping Pair Pair Key Pair Pair BlockLiteral BlockLiteralHeader Tagged Anchored Anchored Tagged Directive DirectiveName DirectiveContent Document",
    maxTerm: 74,
    context: indentation,
    nodeProps: [
        [
            "isolate",
            -3,
            8,
            9,
            14,
            ""
        ],
        [
            "openedBy",
            18,
            "[",
            32,
            "{"
        ],
        [
            "closedBy",
            19,
            "]",
            33,
            "}"
        ]
    ],
    propSources: [
        yamlHighlighting
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 6,
    tokenData: "-Y~RnOX#PXY$QYZ$]Z]#P]^$]^p#Ppq$Qqs#Pst$btu#Puv$yv|#P|}&e}![#P![!]'O!]!`#P!`!a'i!a!}#P!}#O*g#O#P#P#P#Q+Q#Q#o#P#o#p+k#p#q'i#q#r,U#r;'S#P;'S;=`#z<%l?HT#P?HT?HU,o?HUO#PQ#UU!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PQ#kTOY#PZs#Pt;'S#P;'S;=`#z<%lO#PQ#}P;=`<%l#P~$VQ!f~XY$Qpq$Q~$bO!g~~$gS^~OY$bZ;'S$b;'S;=`$s<%lO$b~$vP;=`<%l$bR%OX!WQOX%kXY#PZ]%k]^#P^p%kpq#hq;'S%k;'S;=`&_<%lO%kR%rX!WQ!VPOX%kXY#PZ]%k]^#P^p%kpq#hq;'S%k;'S;=`&_<%lO%kR&bP;=`<%l%kR&lUoP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR'VUmP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR'p[!PP!WQOY#PZp#Ppq#hq{#P{|(f|}#P}!O(f!O!R#P!R![)p![;'S#P;'S;=`#z<%lO#PR(mW!PP!WQOY#PZp#Ppq#hq!R#P!R![)V![;'S#P;'S;=`#z<%lO#PR)^U!PP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR)wY!PP!WQOY#PZp#Ppq#hq{#P{|)V|}#P}!O)V!O;'S#P;'S;=`#z<%lO#PR*nUcP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR+XUbP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR+rUqP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR,]UpP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR,vU`P!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#P",
    tokenizers: [
        newlines,
        blockMark,
        literals,
        blockLiteral,
        0,
        1
    ],
    topRules: {
        "Stream": [
            0,
            15
        ]
    },
    tokenPrec: 0
});

},{"@swc/helpers/_/_define_property":"8uLqc","@lezer/lr":"gQicU","@lezer/highlight":"pdORT","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"c7JSA":[function(require,module,exports) {
// This file was generated by lezer-generator. You probably shouldn't edit it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", ()=>parser);
var _lr = require("@lezer/lr");
var _cbtemplateHighlightJs = require("./cbtemplate-highlight.js");
var parser = (0, _lr.LRParser).deserialize({
    version: 14,
    states: "*hQVQPOOOsQQO'#C^OOQO'#C}'#C}QVQPOOO_QQO'#D[OzQQO'#DZOOQO'#DZ'#DZO#OQQO'#DYO$PQQO'#DXO$zQQO'#DWO%fQQO,58xO_QQO,58xOOQO-E6{-E6{O%qQQO,59vO%|QSO,59uO&UQQO,59uO_QQO'#DRO'YQQO,59tO_QQO,59sO_QQO'#DSO(ZQQO,59rO_QQO,59rO_QQO'#DPO(uQQO1G.dOOQO1G.d1G.dO)QQWO1G.dO(uQQO1G.dO)VQQO1G/bOOQO1G/b1G/bO)QQWO1G/bOOQO,59j,59jO)bQQO1G/aO&PQSO'#DOOOQO-E6|-E6|OOQO,59m,59mOOQO-E7P-E7POOQO1G/_1G/_OOQO,59n,59nOOQO-E7Q-E7QO_QQO1G/^O*fQQO1G/^OOQO,59k,59kOOQO-E6}-E6}OOQO7+$O7+$OO)QQWO7+$OO*wQSO'#D]O+VQQO7+$OO+[QQO7+$OOOQO7+$|7+$|O)QQWO7+$|O+gQQO7+$|O+lQQO7+${O,pQQO7+$xO_QQO7+$xO-RQQO<<GjO-WQ`O'#DQO-]QQO,59wO-]QQO,59wOOQO<<Gj<<GjO)QQWO<<GjO-hQQO<<HhOOQO<<Hh<<HhO_QQO<<HdOOQO<<Hd<<HdOOQOAN=UAN=UO-mQSO,59lOOQO-E7O-E7OO-rQQO1G/cO-}QQOAN=UOOQOAN>SAN>SOOQOAN>OAN>OOOQO1G/W1G/WOOQOG22pG22p",
    stateData: ".[~OyOS~ORPOpQO~OTTOXUOYUOZUO[UO]SO~OSZO~P_OU^O^}X_}Xd}Xe}Xf}Xg}Xh}Xi}Xj}Xk}Xl}Xm}Xo}Xc}Xn}X~Od`O^|X_|Xe|Xf|Xg|Xh|Xi|Xj|Xk|Xl|Xm|Xo|Xc|Xn|X~OebOfbOgbOhbOibO^{X_{Xj{Xk{Xl{Xm{Xo{Xc{X~OjcOkcOleOmeO^zX_zXozXczX~O^fO_iOohO~O^fO_mOclO~OVoOWnO~OUpO^}a_}ad}ae}af}ag}ah}ai}aj}ak}al}am}ao}ac}an}a~Od`O^|a_|ae|af|ag|ah|ai|aj|ak|al|am|ao|ac|an|a~OjcOkcOlwOmwO^za_zaozacza~O^fO_|Oo{O~O`}O~O^fO_!ROc!QO~OUpO^}i_}id}ie}if}ig}ih}ii}ij}ik}il}im}io}ic}in}i~On!VO^zi_zioziczi~OU!XOa!ZOo!PXc!PX~Oo![O~O^fO_!]Oo![O~Oc!_O~OUpO^}q_}qd}qe}qf}qg}qh}qi}qj}qk}ql}qm}qo}qc}qn}q~On!`O^zq_zqozqczq~Oo!bO~Ob!cO~OU!XOo!Pac!Pa~Oc!gO~Oa!iO~OU!XOo!Pic!Pi~Oo!jO~OyXpZ[TZ~",
    goto: "%V!QPP!RPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP!V!]!g!u#P#VPPP#]#i#r$Y$i$vTQORQROR[RQ_TSq_!TR!ToQgYQk]Uzgk!PR!PjQ!Y}S!d!Y!eR!e!ZQaVRsaQdXRvdQYPQ]SQjZRyfWXPSZfRucYWPSZcfQtbQxeQ!UwQ!a!VR!h!`dVPSZbcefw!V!`Rr`gUPSZ`bcefw!V!`Q!OiQ!SmQ!W|Q!^!RR!f!]",
    nodeNames: "\u26A0 Template Tag {{ * Brick . Output Prop String Number Boolean Null ( , ; FormatType Formatparams FormatFunc ) Plus Eq < > <= >= And Or ? ~ : }} Text",
    maxTerm: 47,
    propSources: [
        (0, _cbtemplateHighlightJs.cbtemplateHighlighting)
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 6,
    tokenData: "He~R!]OX$zX^%c^p$zpq%cqr'Urs(Qsv$zvw)twx*rxy+|yz.^z{.q{|/U|}/i}!O/|!O!P1O!P!Q$z!Q![1c![!]3]!]!^3p!^!_4T!_!`5R!`!a5l!a!b6j!b!c6}!c!}7w!}#R$z#R#S8w#S#T$z#T#Y7w#Y#Z9u#Z#b7w#b#c?^#c#h7w#h#iCr#i#o7w#o#pFO#p#qFZ#q#rGU#r#sHQ#s#y$z#y#z%c#z$f$z$f$g%c$g#BY$z#BY#BZ%c#BZ$IS$z$IS$I_%c$I_$I|$z$I|$JO%c$JO$JT$z$JT$JU%c$JU$KV$z$KV$KW%c$KW&FU$z&FU&FV%c&FV;'S$z;'S;=`%]<%lO$zP%PSpPO#o$z#p;'S$z;'S;=`%]<%lO$zP%`P;=`<%l$z~%jhy~pPOX$zX^%c^p$zpq%cq#o$z#p#y$z#y#z%c#z$f$z$f$g%c$g#BY$z#BY#BZ%c#BZ$IS$z$IS$I_%c$I_$I|$z$I|$JO%c$JO$JT$z$JT$JU%c$JU$KV$z$KV$KW%c$KW&FU$z&FU&FV%c&FV;'S$z;'S;=`%]<%lO$zR'ZUpPO!_$z!_!`'m!`#o$z#p;'S$z;'S;=`%]<%lO$zR'tSeQpPO#o$z#p;'S$z;'S;=`%]<%lO$z~(VVpPOr(Qrs(ls#o(Q#o#p)P#p;'S(Q;'S;=`)n<%lO(Q~(sSX~pPO#o$z#p;'S$z;'S;=`%]<%lO$z~)STOr)Prs)cs;'S)P;'S;=`)h<%lO)P~)hOX~~)kP;=`<%l)P~)qP;=`<%l(QR){UjQpPOv$zvw*_w#o$z#p;'S$z;'S;=`%]<%lO$zR*fSjQpPO#o$z#p;'S$z;'S;=`%]<%lO$z~*wVpPOw*rwx(lx#o*r#o#p+^#p;'S*r;'S;=`+v<%lO*r~+aTOw+^wx)cx;'S+^;'S;=`+p<%lO+^~+sP;=`<%l+^~+yP;=`<%l*rV,TV]QpPOy,jyz-Uz#o,j#o#p-i#p;'S,j;'S;=`.W<%lO,jT,oVpPOy,jyz-Uz#o,j#o#p-i#p;'S,j;'S;=`.W<%lO,jT-]SaSpPO#o$z#p;'S$z;'S;=`%]<%lO$zS-lTOy-iyz-{z;'S-i;'S;=`.Q<%lO-iS.QOaSS.TP;=`<%l-iT.ZP;=`<%l,jV.eScUpPO#o$z#p;'S$z;'S;=`%]<%lO$zR.xSSQpPO#o$z#p;'S$z;'S;=`%]<%lO$zR/]SdQpPO#o$z#p;'S$z;'S;=`%]<%lO$zR/pS^QpPO#o$z#p;'S$z;'S;=`%]<%lO$zR0RUpPO!Q$z!Q![0e![#o$z#p;'S$z;'S;=`%]<%lO$zR0lUYQpPO!Q$z!Q![0e![#o$z#p;'S$z;'S;=`%]<%lO$zV1VSUUpPO#o$z#p;'S$z;'S;=`%]<%lO$z_1nZ`WYQWSpPO!Q$z!Q![1c![!c$z!c!}2a!}#R$z#R#S2a#S#T$z#T#o2a#p;'S$z;'S;=`%]<%lO$z]2jZ`WWSpPO!Q$z!Q![2a![!c$z!c!}2a!}#R$z#R#S2a#S#T$z#T#o2a#p;'S$z;'S;=`%]<%lO$zR3dSnQpPO#o$z#p;'S$z;'S;=`%]<%lO$zR3wS_QpPO#o$z#p;'S$z;'S;=`%]<%lO$zR4[UfQpPO!_$z!_!`4n!`#o$z#p;'S$z;'S;=`%]<%lO$zR4uShQpPO#o$z#p;'S$z;'S;=`%]<%lO$zR5YUeQpPO!_$z!_!`'m!`#o$z#p;'S$z;'S;=`%]<%lO$zR5sUgQpPO!_$z!_!`6V!`#o$z#p;'S$z;'S;=`%]<%lO$zR6^SiQpPO#o$z#p;'S$z;'S;=`%]<%lO$zR6qSlQpPO#o$z#p;'S$z;'S;=`%]<%lO$zT7UZVSpPO!Q$z!Q![6}![!c$z!c!}6}!}#R$z#R#S6}#S#T$z#T#o6}#p;'S$z;'S;=`%]<%lO$zo8UZb``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#o7w#p;'S$z;'S;=`%]<%lO$z_9SZ`WWSpPTQO!Q$z!Q![8w![!c$z!c!}8w!}#R$z#R#S8w#S#T$z#T#o8w#p;'S$z;'S;=`%]<%lO$zo:S[b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#U:x#U#o7w#p;'S$z;'S;=`%]<%lO$zo;V]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#`7w#`#a<O#a#o7w#p;'S$z;'S;=`%]<%lO$zo<]]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#g7w#g#h=U#h#o7w#p;'S$z;'S;=`%]<%lO$zo=c]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#X7w#X#Y>[#Y#o7w#p;'S$z;'S;=`%]<%lO$zo>kZb``WWSpPZQTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#o7w#p;'S$z;'S;=`%]<%lO$zo?k]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#i7w#i#j@d#j#o7w#p;'S$z;'S;=`%]<%lO$zo@q]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#`7w#`#aAj#a#o7w#p;'S$z;'S;=`%]<%lO$zoAw]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#`7w#`#aBp#a#o7w#p;'S$z;'S;=`%]<%lO$zoCPZb``WWSpP[QTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#o7w#p;'S$z;'S;=`%]<%lO$zoDP]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#f7w#f#gDx#g#o7w#p;'S$z;'S;=`%]<%lO$zoEV]b``WWSpPTQO!Q$z!Q![8w![!c$z!c!}7w!}#R$z#R#S8w#S#T$z#T#i7w#i#j=U#j#o7w#p;'S$z;'S;=`%]<%lO$z~FRP#o#pFU~FZOR~RFbTkQpPO#o$z#p#qFq#q;'S$z;'S;=`%]<%lO$zRFxSkQpPO#o$z#p;'S$z;'S;=`%]<%lO$zVGZUpPO#o$z#p#q$z#q#rGm#r;'S$z;'S;=`%]<%lO$zVGtSoUpPO#o$z#p;'S$z;'S;=`%]<%lO$zRHXSmQpPO#o$z#p;'S$z;'S;=`%]<%lO$z",
    tokenizers: [
        0,
        1,
        2,
        3,
        4
    ],
    topRules: {
        "Template": [
            0,
            1
        ]
    },
    tokenPrec: 602
});

},{"@lezer/lr":"gQicU","./cbtemplate-highlight.js":"fKbnc","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"fKbnc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cbtemplateHighlighting", ()=>cbtemplateHighlighting);
parcelHelpers.export(exports, "cbtemplateHighlightStyle", ()=>cbtemplateHighlightStyle);
var _highlight = require("@lezer/highlight");
var _language = require("@codemirror/language");
var cbtemplateHighlighting = (0, _highlight.styleTags)({
    "{{ }}": (0, _highlight.tags).brace,
    ". = > < <= >= ? ~ ; : & | ( ) ,": (0, _highlight.tags).operator,
    Brick: (0, _highlight.tags).moduleKeyword,
    Output: (0, _highlight.tags).modifier,
    Prop: (0, _highlight.tags).namespace,
    String: (0, _highlight.tags).string,
    Number: (0, _highlight.tags).number,
    Boolean: (0, _highlight.tags).bool,
    Null: (0, _highlight.tags).null,
    Eq: (0, _highlight.tags).operator,
    And: (0, _highlight.tags).operator,
    Or: (0, _highlight.tags).operator,
    FormatType: (0, _highlight.tags).annotation,
    FormatFunc: (0, _highlight.tags).updateOperator,
    Formatparams: (0, _highlight.tags).changed
});
var cbtemplateHighlightStyle = (0, _language.HighlightStyle).define([
    {
        tag: (0, _highlight.tags).brace,
        color: "#61bdff",
        fontWeight: "bold"
    },
    //{tag: tags.operator, color: "#00419b", fontWeight: "bold" },
    {
        tag: (0, _highlight.tags).operator,
        color: "#000000",
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).moduleKeyword,
        color: "#00f",
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).modifier,
        color: "#00bd52",
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).namespace,
        color: "#00f"
    },
    {
        tag: (0, _highlight.tags).string,
        color: "#00ad76"
    },
    {
        tag: (0, _highlight.tags).number,
        color: "#aa00ff"
    },
    {
        tag: (0, _highlight.tags).bool,
        color: "#aa00ff",
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).null,
        color: "#aa00ff",
        fontWeight: "bold"
    },
    //{tag: tags.namespace, color: "#dd4eea", fontWeight: "bold" },
    {
        tag: (0, _highlight.tags).annotation,
        color: "#dd4eea",
        fontWeight: "bold"
    },
    {
        tag: (0, _highlight.tags).updateOperator,
        color: "#dd4eea"
    },
    {
        tag: (0, _highlight.tags).changed,
        color: "#aa00ff"
    },
    //html style
    {
        tag: (0, _highlight.tags).tagName,
        color: "#0a5"
    },
    //js style
    {
        tag: (0, _highlight.tags).function,
        color: "#708"
    }
]); //, { scope: cbtemplateParser.topNode });
 //export let extensions = [syntaxHighlighting(cbtemplateHighlightStyle)];

},{"@lezer/highlight":"pdORT","@codemirror/language":"jct2S","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8Zujt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_editor_code_diffwebcomponent", ()=>c_editor_code_diffwebcomponent);
parcelHelpers.export(exports, "web_c_editor_code_dff", ()=>web_c_editor_code_dff);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _codemirror = require("codemirror");
var _langJavascript = require("@codemirror/lang-javascript");
var _langCss = require("@codemirror/lang-css");
var _langHtml = require("@codemirror/lang-html");
var _langYaml = require("@codemirror/lang-yaml");
var _langSql = require("@codemirror/lang-sql");
var _cbtemplateParser = require("../template_lang/cbtemplate-parser");
var _language = require("@codemirror/language");
var _common = require("@lezer/common");
var _merge = require("@codemirror/merge");
var _state = require("@codemirror/state");
class c_editor_code_diffwebcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var ins = this.getAttribute("ins");
            this.ci = new web_c_editor_code_dff(context, cid, name, dc, Number(idx), container_id, this, ins);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-editor-code-diff", c_editor_code_diffwebcomponent);
class web_c_editor_code_dff extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var div, element, container, extensions, mixedCBTemplateParser, cbtemplateLanguage;
            return (0, _tsGenerator._)(this, function(_state1) {
                if (input == "cfg") {
                    if (!_this.view) {
                        div = document.getElementById(_this.brick_id);
                        if (div) {
                            _this.cfg = cfg;
                            element = document.getElementById(_this.brick_id);
                            if (element && cfg.height) {
                                container = element.parentElement;
                                if (container) container.style.height = cfg.height;
                            }
                            extensions = [
                                (0, _codemirror.basicSetup)
                            ];
                            if (cfg.readonly) {
                                extensions.push((0, _codemirror.EditorView).editable.of(false));
                                extensions.push((0, _state.EditorState).readOnly.of(true));
                            }
                            if (_this.cfg.language == "javascript") {
                                extensions.push((0, _langJavascript.javascript)());
                                extensions.push((0, _language.indentUnit).of("    "));
                                extensions.push((0, _langJavascript.javascriptLanguage).data.of({
                                    autocomplete: (0, _langJavascript.scopeCompletionSource)(globalThis)
                                }));
                            } else if (_this.cfg.language == "css") {
                                extensions.push((0, _langCss.css)());
                                extensions.push((0, _language.indentUnit).of("    "));
                                extensions.push((0, _langCss.cssLanguage).data.of({
                                    autocomplete: (0, _langCss.cssCompletionSource)
                                }));
                            } else if (_this.cfg.language == "html") {
                                mixedCBTemplateParser = (0, _cbtemplateParser.parser).configure({
                                    props: [],
                                    wrap: (0, _common.parseMixed)((node)=>{
                                        return node.type.isTop ? {
                                            parser: (0, _langHtml.htmlLanguage).parser,
                                            overlay: (node)=>node.type.name == "Text"
                                        } : null;
                                    })
                                });
                                cbtemplateLanguage = (0, _language.LRLanguage).define({
                                    parser: mixedCBTemplateParser
                                });
                                extensions.push(cbtemplateLanguage);
                                extensions.push((0, _langHtml.html)().support);
                            } else if (_this.cfg.language == "yaml") {
                                extensions.push((0, _langYaml.yaml)());
                                extensions.push((0, _language.indentUnit).of("  "));
                            } else if (_this.cfg.language && _this.cfg.language.startsWith("sql")) {
                                if (_this.cfg.language.toLowerCase() == "sql-postgresql") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.PostgreSQL)
                                }));
                                else if (_this.cfg.language.toLowerCase() == "sql-mssql") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.MSSQL)
                                }));
                                else if (_this.cfg.language.toLowerCase() == "sql-mysql") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.MySQL)
                                }));
                                else if (_this.cfg.language.toLowerCase() == "sql-mariasql") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.MariaSQL)
                                }));
                                else if (_this.cfg.language.toLowerCase() == "sql-sqlite") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.SQLite)
                                }));
                                else if (_this.cfg.language.toLowerCase() == "sql-cassandra") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.Cassandra)
                                }));
                                else if (_this.cfg.language.toLowerCase() == "sql-plsql") extensions.push((0, _langSql.sql)({
                                    dialect: (0, _langSql.PLSQL)
                                }));
                                else extensions.push((0, _langSql.sql)());
                            }
                            _this.view = new (0, _merge.MergeView)({
                                a: {
                                    doc: cfg.value_left,
                                    extensions: extensions
                                },
                                b: {
                                    doc: cfg.value_right,
                                    extensions: extensions
                                },
                                parent: div
                            });
                        }
                    } else {
                        _this.view.a.dispatch({
                            changes: {
                                from: 0,
                                to: _this.view.a.state.doc.length,
                                insert: cfg.value_left
                            }
                        });
                        _this.view.b.dispatch({
                            changes: {
                                from: 0,
                                to: _this.view.b.state.doc.length,
                                insert: cfg.value_right
                            }
                        });
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    getValue() {}
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id);
        if (container) {
            var outer = container.parentElement;
            if (outer) {
                if (status == "loading") {
                    container.classList.add("hidden");
                    outer.classList.add("loading");
                } else {
                    outer.classList.remove("loading");
                    container.classList.remove("hidden");
                }
            }
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element, standalone_ins){
        super(context, cid, name, dc, idx, container_id, standalone_ins);
        this.token_list = null;
        this.element = element;
        if (cid == undefined) {
            this.blueprint.name = element.id;
            this.brick_id = element.id + "_brick";
            window.so_bricks = window.so_bricks || {};
            window.so_bricks[this.brick_id] = this;
        }
        var html = `<div class='c-editor-code-diff-container'><div id="${this.brick_id}" class="c-editor-code-diff"></div></div>`;
        element.innerHTML = html;
        var self = this;
        if (cid == undefined) setTimeout(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
            var _tmp, _tmp1, _i, input, ret;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!self.blueprint.ins) return [
                            3,
                            4
                        ];
                        _tmp = [];
                        for(_tmp1 in self.blueprint.ins)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            4
                        ];
                        input = _tmp[_i];
                        return [
                            4,
                            self.cb_event(input, self.blueprint.ins[input], {})
                        ];
                    case 2:
                        ret = _state.sent();
                        _state.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }), 0);
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","codemirror":"dEQfk","@codemirror/lang-javascript":"0dLBb","@codemirror/lang-css":"25igp","@codemirror/lang-html":"5bkjX","@codemirror/lang-yaml":"j44hx","@codemirror/lang-sql":"kVmrY","../template_lang/cbtemplate-parser":"c7JSA","@codemirror/language":"jct2S","@lezer/common":"9CjLE","@codemirror/merge":"isu0o","@codemirror/state":"fECfb","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"kVmrY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cassandra", ()=>Cassandra);
parcelHelpers.export(exports, "MSSQL", ()=>MSSQL);
parcelHelpers.export(exports, "MariaSQL", ()=>MariaSQL);
parcelHelpers.export(exports, "MySQL", ()=>MySQL);
parcelHelpers.export(exports, "PLSQL", ()=>PLSQL);
parcelHelpers.export(exports, "PostgreSQL", ()=>PostgreSQL);
parcelHelpers.export(exports, "SQLDialect", ()=>SQLDialect);
parcelHelpers.export(exports, "SQLite", ()=>SQLite);
parcelHelpers.export(exports, "StandardSQL", ()=>StandardSQL);
parcelHelpers.export(exports, "keywordCompletion", ()=>keywordCompletion);
parcelHelpers.export(exports, "keywordCompletionSource", ()=>keywordCompletionSource);
parcelHelpers.export(exports, "schemaCompletion", ()=>schemaCompletion);
parcelHelpers.export(exports, "schemaCompletionSource", ()=>schemaCompletionSource);
parcelHelpers.export(exports, "sql", ()=>sql);
var _language = require("@codemirror/language");
var _highlight = require("@lezer/highlight");
var _lr = require("@lezer/lr");
var _autocomplete = require("@codemirror/autocomplete");
// This file was generated by lezer-generator. You probably shouldn't edit it.
var whitespace = 36, LineComment = 1, BlockComment = 2, String$1 = 3, Number = 4, Bool = 5, Null = 6, ParenL = 7, ParenR = 8, BraceL = 9, BraceR = 10, BracketL = 11, BracketR = 12, Semi = 13, Dot = 14, Operator = 15, Punctuation = 16, SpecialVar = 17, Identifier = 18, QuotedIdentifier = 19, Keyword = 20, Type = 21, Bits = 22, Bytes = 23, Builtin = 24;
function isAlpha(ch) {
    return ch >= 65 /* Ch.A */  && ch <= 90 /* Ch.Z */  || ch >= 97 /* Ch.a */  && ch <= 122 /* Ch.z */  || ch >= 48 /* Ch._0 */  && ch <= 57 /* Ch._9 */ ;
}
function isHexDigit(ch) {
    return ch >= 48 /* Ch._0 */  && ch <= 57 /* Ch._9 */  || ch >= 97 /* Ch.a */  && ch <= 102 /* Ch.f */  || ch >= 65 /* Ch.A */  && ch <= 70 /* Ch.F */ ;
}
function readLiteral(input, endQuote, backslashEscapes) {
    for(var escaped = false;;){
        if (input.next < 0) return;
        if (input.next == endQuote && !escaped) {
            input.advance();
            return;
        }
        escaped = backslashEscapes && !escaped && input.next == 92 /* Ch.Backslash */ ;
        input.advance();
    }
}
function readDoubleDollarLiteral(input, tag) {
    scan: for(;;){
        if (input.next < 0) return console.log("exit at end", input.pos);
        if (input.next == 36 /* Ch.Dollar */ ) {
            input.advance();
            for(var i = 0; i < tag.length; i++){
                if (input.next != tag.charCodeAt(i)) continue scan;
                input.advance();
            }
            if (input.next == 36 /* Ch.Dollar */ ) {
                input.advance();
                return;
            }
        } else input.advance();
    }
}
function readPLSQLQuotedLiteral(input, openDelim) {
    var matchingDelim = "[{<(".indexOf(String.fromCharCode(openDelim));
    var closeDelim = matchingDelim < 0 ? openDelim : "]}>)".charCodeAt(matchingDelim);
    for(;;){
        if (input.next < 0) return;
        if (input.next == closeDelim && input.peek(1) == 39 /* Ch.SingleQuote */ ) {
            input.advance(2);
            return;
        }
        input.advance();
    }
}
function readWord(input, result) {
    for(;;){
        if (input.next != 95 /* Ch.Underscore */  && !isAlpha(input.next)) break;
        if (result != null) result += String.fromCharCode(input.next);
        input.advance();
    }
    return result;
}
function readWordOrQuoted(input) {
    if (input.next == 39 /* Ch.SingleQuote */  || input.next == 34 /* Ch.DoubleQuote */  || input.next == 96 /* Ch.Backtick */ ) {
        var quote = input.next;
        input.advance();
        readLiteral(input, quote, false);
    } else readWord(input);
}
function readBits(input, endQuote) {
    while(input.next == 48 /* Ch._0 */  || input.next == 49 /* Ch._1 */ )input.advance();
    if (endQuote && input.next == endQuote) input.advance();
}
function readNumber(input, sawDot) {
    for(;;){
        if (input.next == 46 /* Ch.Dot */ ) {
            if (sawDot) break;
            sawDot = true;
        } else if (input.next < 48 /* Ch._0 */  || input.next > 57 /* Ch._9 */ ) break;
        input.advance();
    }
    if (input.next == 69 /* Ch.E */  || input.next == 101 /* Ch.e */ ) {
        input.advance();
        if (input.next == 43 /* Ch.Plus */  || input.next == 45 /* Ch.Dash */ ) input.advance();
        while(input.next >= 48 /* Ch._0 */  && input.next <= 57 /* Ch._9 */ )input.advance();
    }
}
function eol(input) {
    while(!(input.next < 0 || input.next == 10 /* Ch.Newline */ ))input.advance();
}
function inString(ch, str) {
    for(var i = 0; i < str.length; i++)if (str.charCodeAt(i) == ch) return true;
    return false;
}
var Space = " 	\r\n";
function keywords(keywords, types, builtin) {
    var result = Object.create(null);
    result["true"] = result["false"] = Bool;
    result["null"] = result["unknown"] = Null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keywords.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var kw = _step.value;
            if (kw) result[kw] = Keyword;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = types.split(" ")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var tp = _step1.value;
            if (tp) result[tp] = Type;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = (builtin || "").split(" ")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var kw1 = _step2.value;
            if (kw1) result[kw1] = Builtin;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return result;
}
var SQLTypes = "array binary bit boolean char character clob date decimal double float int integer interval large national nchar nclob numeric object precision real smallint time timestamp varchar varying ";
var SQLKeywords = "absolute action add after all allocate alter and any are as asc assertion at authorization before begin between both breadth by call cascade cascaded case cast catalog check close collate collation column commit condition connect connection constraint constraints constructor continue corresponding count create cross cube current current_date current_default_transform_group current_transform_group_for_type current_path current_role current_time current_timestamp current_user cursor cycle data day deallocate declare default deferrable deferred delete depth deref desc describe descriptor deterministic diagnostics disconnect distinct do domain drop dynamic each else elseif end end-exec equals escape except exception exec execute exists exit external fetch first for foreign found from free full function general get global go goto grant group grouping handle having hold hour identity if immediate in indicator initially inner inout input insert intersect into is isolation join key language last lateral leading leave left level like limit local localtime localtimestamp locator loop map match method minute modifies module month names natural nesting new next no none not of old on only open option or order ordinality out outer output overlaps pad parameter partial path prepare preserve primary prior privileges procedure public read reads recursive redo ref references referencing relative release repeat resignal restrict result return returns revoke right role rollback rollup routine row rows savepoint schema scroll search second section select session session_user set sets signal similar size some space specific specifictype sql sqlexception sqlstate sqlwarning start state static system_user table temporary then timezone_hour timezone_minute to trailing transaction translation treat trigger under undo union unique unnest until update usage user using value values view when whenever where while with without work write year zone ";
var defaults = {
    backslashEscapes: false,
    hashComments: false,
    spaceAfterDashes: false,
    slashComments: false,
    doubleQuotedStrings: false,
    doubleDollarQuotedStrings: false,
    unquotedBitLiterals: false,
    treatBitsAsBytes: false,
    charSetCasts: false,
    plsqlQuotingMechanism: false,
    operatorChars: "*+-%<>!=&|~^/",
    specialVar: "?",
    identifierQuotes: '"',
    caseInsensitiveIdentifiers: false,
    words: /*@__PURE__*/ keywords(SQLKeywords, SQLTypes)
};
function dialect(spec, kws, types, builtin) {
    var dialect = {};
    for(var prop in defaults)dialect[prop] = (spec.hasOwnProperty(prop) ? spec : defaults)[prop];
    if (kws) dialect.words = keywords(kws, types || "", builtin);
    return dialect;
}
function tokensFor(d) {
    return new (0, _lr.ExternalTokenizer)((input)=>{
        var _a;
        var next = input.next;
        input.advance();
        if (inString(next, Space)) {
            while(inString(input.next, Space))input.advance();
            input.acceptToken(whitespace);
        } else if (next == 36 /* Ch.Dollar */  && d.doubleDollarQuotedStrings) {
            var tag = readWord(input, "");
            if (input.next == 36 /* Ch.Dollar */ ) {
                input.advance();
                readDoubleDollarLiteral(input, tag);
                input.acceptToken(String$1);
            }
        } else if (next == 39 /* Ch.SingleQuote */  || next == 34 /* Ch.DoubleQuote */  && d.doubleQuotedStrings) {
            readLiteral(input, next, d.backslashEscapes);
            input.acceptToken(String$1);
        } else if (next == 35 /* Ch.Hash */  && d.hashComments || next == 47 /* Ch.Slash */  && input.next == 47 /* Ch.Slash */  && d.slashComments) {
            eol(input);
            input.acceptToken(LineComment);
        } else if (next == 45 /* Ch.Dash */  && input.next == 45 /* Ch.Dash */  && (!d.spaceAfterDashes || input.peek(1) == 32 /* Ch.Space */ )) {
            eol(input);
            input.acceptToken(LineComment);
        } else if (next == 47 /* Ch.Slash */  && input.next == 42 /* Ch.Star */ ) {
            input.advance();
            for(var depth = 1;;){
                var cur = input.next;
                if (input.next < 0) break;
                input.advance();
                if (cur == 42 /* Ch.Star */  && input.next == 47 /* Ch.Slash */ ) {
                    depth--;
                    input.advance();
                    if (!depth) break;
                } else if (cur == 47 /* Ch.Slash */  && input.next == 42 /* Ch.Star */ ) {
                    depth++;
                    input.advance();
                }
            }
            input.acceptToken(BlockComment);
        } else if ((next == 101 /* Ch.e */  || next == 69 /* Ch.E */ ) && input.next == 39 /* Ch.SingleQuote */ ) {
            input.advance();
            readLiteral(input, 39 /* Ch.SingleQuote */ , true);
            input.acceptToken(String$1);
        } else if ((next == 110 /* Ch.n */  || next == 78 /* Ch.N */ ) && input.next == 39 /* Ch.SingleQuote */  && d.charSetCasts) {
            input.advance();
            readLiteral(input, 39 /* Ch.SingleQuote */ , d.backslashEscapes);
            input.acceptToken(String$1);
        } else if (next == 95 /* Ch.Underscore */  && d.charSetCasts) for(var i = 0;; i++){
            if (input.next == 39 /* Ch.SingleQuote */  && i > 1) {
                input.advance();
                readLiteral(input, 39 /* Ch.SingleQuote */ , d.backslashEscapes);
                input.acceptToken(String$1);
                break;
            }
            if (!isAlpha(input.next)) break;
            input.advance();
        }
        else if (d.plsqlQuotingMechanism && (next == 113 /* Ch.q */  || next == 81 /* Ch.Q */ ) && input.next == 39 /* Ch.SingleQuote */  && input.peek(1) > 0 && !inString(input.peek(1), Space)) {
            var openDelim = input.peek(1);
            input.advance(2);
            readPLSQLQuotedLiteral(input, openDelim);
            input.acceptToken(String$1);
        } else if (next == 40 /* Ch.ParenL */ ) input.acceptToken(ParenL);
        else if (next == 41 /* Ch.ParenR */ ) input.acceptToken(ParenR);
        else if (next == 123 /* Ch.BraceL */ ) input.acceptToken(BraceL);
        else if (next == 125 /* Ch.BraceR */ ) input.acceptToken(BraceR);
        else if (next == 91 /* Ch.BracketL */ ) input.acceptToken(BracketL);
        else if (next == 93 /* Ch.BracketR */ ) input.acceptToken(BracketR);
        else if (next == 59 /* Ch.Semi */ ) input.acceptToken(Semi);
        else if (d.unquotedBitLiterals && next == 48 /* Ch._0 */  && input.next == 98 /* Ch.b */ ) {
            input.advance();
            readBits(input);
            input.acceptToken(Bits);
        } else if ((next == 98 /* Ch.b */  || next == 66 /* Ch.B */ ) && (input.next == 39 /* Ch.SingleQuote */  || input.next == 34 /* Ch.DoubleQuote */ )) {
            var quoteStyle = input.next;
            input.advance();
            if (d.treatBitsAsBytes) {
                readLiteral(input, quoteStyle, d.backslashEscapes);
                input.acceptToken(Bytes);
            } else {
                readBits(input, quoteStyle);
                input.acceptToken(Bits);
            }
        } else if (next == 48 /* Ch._0 */  && (input.next == 120 /* Ch.x */  || input.next == 88 /* Ch.X */ ) || (next == 120 /* Ch.x */  || next == 88 /* Ch.X */ ) && input.next == 39 /* Ch.SingleQuote */ ) {
            var quoted = input.next == 39 /* Ch.SingleQuote */ ;
            input.advance();
            while(isHexDigit(input.next))input.advance();
            if (quoted && input.next == 39 /* Ch.SingleQuote */ ) input.advance();
            input.acceptToken(Number);
        } else if (next == 46 /* Ch.Dot */  && input.next >= 48 /* Ch._0 */  && input.next <= 57 /* Ch._9 */ ) {
            readNumber(input, true);
            input.acceptToken(Number);
        } else if (next == 46 /* Ch.Dot */ ) input.acceptToken(Dot);
        else if (next >= 48 /* Ch._0 */  && next <= 57 /* Ch._9 */ ) {
            readNumber(input, false);
            input.acceptToken(Number);
        } else if (inString(next, d.operatorChars)) {
            while(inString(input.next, d.operatorChars))input.advance();
            input.acceptToken(Operator);
        } else if (inString(next, d.specialVar)) {
            if (input.next == next) input.advance();
            readWordOrQuoted(input);
            input.acceptToken(SpecialVar);
        } else if (inString(next, d.identifierQuotes)) {
            readLiteral(input, next, false);
            input.acceptToken(QuotedIdentifier);
        } else if (next == 58 /* Ch.Colon */  || next == 44 /* Ch.Comma */ ) input.acceptToken(Punctuation);
        else if (isAlpha(next)) {
            var word = readWord(input, String.fromCharCode(next));
            input.acceptToken(input.next == 46 /* Ch.Dot */  || input.peek(-word.length - 1) == 46 /* Ch.Dot */  ? Identifier : (_a = d.words[word.toLowerCase()]) !== null && _a !== void 0 ? _a : Identifier);
        }
    });
}
var tokens = /*@__PURE__*/ tokensFor(defaults);
// This file was generated by lezer-generator. You probably shouldn't edit it.
var parser$1 = /*@__PURE__*/ (0, _lr.LRParser).deserialize({
    version: 14,
    states: "%vQ]QQOOO#wQRO'#DSO$OQQO'#CwO%eQQO'#CxO%lQQO'#CyO%sQQO'#CzOOQQ'#DS'#DSOOQQ'#C}'#C}O'UQRO'#C{OOQQ'#Cv'#CvOOQQ'#C|'#C|Q]QQOOQOQQOOO'`QQO'#DOO(xQRO,59cO)PQQO,59cO)UQQO'#DSOOQQ,59d,59dO)cQQO,59dOOQQ,59e,59eO)jQQO,59eOOQQ,59f,59fO)qQQO,59fOOQQ-E6{-E6{OOQQ,59b,59bOOQQ-E6z-E6zOOQQ,59j,59jOOQQ-E6|-E6|O+VQRO1G.}O+^QQO,59cOOQQ1G/O1G/OOOQQ1G/P1G/POOQQ1G/Q1G/QP+kQQO'#C}O+rQQO1G.}O)PQQO,59cO,PQQO'#Cw",
    stateData: ",[~OtOSPOSQOS~ORUOSUOTUOUUOVROXSOZTO]XO^QO_UO`UOaPObPOcPOdUOeUOfUOgUOhUO~O^]ORvXSvXTvXUvXVvXXvXZvX]vX_vX`vXavXbvXcvXdvXevXfvXgvXhvX~OsvX~P!jOa_Ob_Oc_O~ORUOSUOTUOUUOVROXSOZTO^tO_UO`UOa`Ob`Oc`OdUOeUOfUOgUOhUO~OWaO~P$ZOYcO~P$ZO[eO~P$ZORUOSUOTUOUUOVROXSOZTO^QO_UO`UOaPObPOcPOdUOeUOfUOgUOhUO~O]hOsoX~P%zOajObjOcjO~O^]ORkaSkaTkaUkaVkaXkaZka]ka_ka`kaakabkackadkaekafkagkahka~Oska~P'kO^]O~OWvXYvX[vX~P!jOWnO~P$ZOYoO~P$ZO[pO~P$ZO^]ORkiSkiTkiUkiVkiXkiZki]ki_ki`kiakibkickidkiekifkigkihki~Oski~P)xOWkaYka[ka~P'kO]hO~P$ZOWkiYki[ki~P)xOasObsOcsO~O",
    goto: "#hwPPPPPPPPPPPPPPPPPPPPPPPPPPx||||!Y!^!d!xPPP#[TYOZeUORSTWZbdfqT[OZQZORiZSWOZQbRQdSQfTZgWbdfqQ^PWk^lmrQl_Qm`RrseVORSTWZbdfq",
    nodeNames: "\u26A0 LineComment BlockComment String Number Bool Null ( ) { } [ ] ; . Operator Punctuation SpecialVar Identifier QuotedIdentifier Keyword Type Bits Bytes Builtin Script Statement CompositeIdentifier Parens Braces Brackets Statement",
    maxTerm: 38,
    nodeProps: [
        [
            "isolate",
            -4,
            1,
            2,
            3,
            19,
            ""
        ]
    ],
    skippedNodes: [
        0,
        1,
        2
    ],
    repeatNodeCount: 3,
    tokenData: "RORO",
    tokenizers: [
        0,
        tokens
    ],
    topRules: {
        "Script": [
            0,
            25
        ]
    },
    tokenPrec: 0
});
function tokenBefore(tree) {
    var cursor = tree.cursor().moveTo(tree.from, -1);
    while(/Comment/.test(cursor.name))cursor.moveTo(cursor.from, -1);
    return cursor.node;
}
function idName(doc, node) {
    var text = doc.sliceString(node.from, node.to);
    var quoted = /^([`'"])(.*)\1$/.exec(text);
    return quoted ? quoted[2] : text;
}
function plainID(node) {
    return node && (node.name == "Identifier" || node.name == "QuotedIdentifier");
}
function pathFor(doc, id) {
    if (id.name == "CompositeIdentifier") {
        var path = [];
        for(var ch = id.firstChild; ch; ch = ch.nextSibling)if (plainID(ch)) path.push(idName(doc, ch));
        return path;
    }
    return [
        idName(doc, id)
    ];
}
function parentsFor(doc, node) {
    for(var path = [];;){
        if (!node || node.name != ".") return path;
        var name = tokenBefore(node);
        if (!plainID(name)) return path;
        path.unshift(idName(doc, name));
        node = tokenBefore(name);
    }
}
function sourceContext(state, startPos) {
    var pos = (0, _language.syntaxTree)(state).resolveInner(startPos, -1);
    var aliases = getAliases(state.doc, pos);
    if (pos.name == "Identifier" || pos.name == "QuotedIdentifier" || pos.name == "Keyword") return {
        from: pos.from,
        quoted: pos.name == "QuotedIdentifier" ? state.doc.sliceString(pos.from, pos.from + 1) : null,
        parents: parentsFor(state.doc, tokenBefore(pos)),
        aliases
    };
    if (pos.name == ".") return {
        from: startPos,
        quoted: null,
        parents: parentsFor(state.doc, pos),
        aliases
    };
    else return {
        from: startPos,
        quoted: null,
        parents: [],
        empty: true,
        aliases
    };
}
var EndFrom = /*@__PURE__*/ new Set(/*@__PURE__*/ "where group having order union intersect except all distinct limit offset fetch for".split(" "));
function getAliases(doc, at) {
    var statement;
    for(var parent = at; !statement; parent = parent.parent){
        if (!parent) return null;
        if (parent.name == "Statement") statement = parent;
    }
    var aliases = null;
    for(var scan = statement.firstChild, sawFrom = false, prevID = null; scan; scan = scan.nextSibling){
        var kw = scan.name == "Keyword" ? doc.sliceString(scan.from, scan.to).toLowerCase() : null;
        var alias = null;
        if (!sawFrom) sawFrom = kw == "from";
        else if (kw == "as" && prevID && plainID(scan.nextSibling)) alias = idName(doc, scan.nextSibling);
        else if (kw && EndFrom.has(kw)) break;
        else if (prevID && plainID(scan)) alias = idName(doc, scan);
        if (alias) {
            if (!aliases) aliases = Object.create(null);
            aliases[alias] = pathFor(doc, prevID);
        }
        prevID = /Identifier$/.test(scan.name) ? scan : null;
    }
    return aliases;
}
function maybeQuoteCompletions(quote, completions) {
    if (!quote) return completions;
    return completions.map((c)=>Object.assign(Object.assign({}, c), {
            label: c.label[0] == quote ? c.label : quote + c.label + quote,
            apply: undefined
        }));
}
var Span = /^\w*$/, QuotedSpan = /^[`'"]?\w*[`'"]?$/;
function isSelfTag(namespace) {
    return namespace.self && typeof namespace.self.label == "string";
}
class CompletionLevel {
    child(name) {
        var children = this.children || (this.children = Object.create(null));
        var found = children[name];
        if (found) return found;
        if (name && !this.list.some((c)=>c.label == name)) this.list.push(nameCompletion(name, "type", this.idQuote, this.idCaseInsensitive));
        return children[name] = new CompletionLevel(this.idQuote, this.idCaseInsensitive);
    }
    maybeChild(name) {
        return this.children ? this.children[name] : null;
    }
    addCompletion(option) {
        var found = this.list.findIndex((o)=>o.label == option.label);
        if (found > -1) this.list[found] = option;
        else this.list.push(option);
    }
    addCompletions(completions) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = completions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var option = _step.value;
                this.addCompletion(typeof option == "string" ? nameCompletion(option, "property", this.idQuote, this.idCaseInsensitive) : option);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    addNamespace(namespace) {
        if (Array.isArray(namespace)) this.addCompletions(namespace);
        else if (isSelfTag(namespace)) this.addNamespace(namespace.children);
        else this.addNamespaceObject(namespace);
    }
    addNamespaceObject(namespace) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _this = this, _loop = function() {
                var name = _step.value;
                var children = namespace[name], self = null;
                var parts = name.replace(/\\?\./g, (p)=>p == "." ? "\0" : p).split("\0");
                var scope = _this;
                if (isSelfTag(children)) {
                    self = children.self;
                    children = children.children;
                }
                for(var i = 0; i < parts.length; i++){
                    if (self && i == parts.length - 1) scope.addCompletion(self);
                    scope = scope.child(parts[i].replace(/\\\./g, "."));
                }
                scope.addNamespace(children);
            };
            for(var _iterator = Object.keys(namespace)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    constructor(idQuote, idCaseInsensitive){
        this.idQuote = idQuote;
        this.idCaseInsensitive = idCaseInsensitive;
        this.list = [];
        this.children = undefined;
    }
}
function nameCompletion(label, type, idQuote, idCaseInsensitive) {
    if (new RegExp("^[a-z_][a-z_\\d]*$", idCaseInsensitive ? "i" : "").test(label)) return {
        label,
        type
    };
    return {
        label,
        type,
        apply: idQuote + label + idQuote
    };
}
// Some of this is more gnarly than it has to be because we're also
// supporting the deprecated, not-so-well-considered style of
// supplying the schema (dotted property names for schemas, separate
// `tables` and `schemas` completions).
function completeFromSchema(schema, tables, schemas, defaultTableName, defaultSchemaName, dialect) {
    var _a;
    var idQuote = ((_a = dialect === null || dialect === void 0 ? void 0 : dialect.spec.identifierQuotes) === null || _a === void 0 ? void 0 : _a[0]) || '"';
    var top = new CompletionLevel(idQuote, !!(dialect === null || dialect === void 0 ? void 0 : dialect.spec.caseInsensitiveIdentifiers));
    var defaultSchema = defaultSchemaName ? top.child(defaultSchemaName) : null;
    top.addNamespace(schema);
    if (tables) (defaultSchema || top).addCompletions(tables);
    if (schemas) top.addCompletions(schemas);
    if (defaultSchema) top.addCompletions(defaultSchema.list);
    if (defaultTableName) top.addCompletions((defaultSchema || top).child(defaultTableName).list);
    return (context)=>{
        var _sourceContext = sourceContext(context.state, context.pos), parents = _sourceContext.parents, from = _sourceContext.from, quoted = _sourceContext.quoted, empty = _sourceContext.empty, aliases = _sourceContext.aliases;
        if (empty && !context.explicit) return null;
        if (aliases && parents.length == 1) parents = aliases[parents[0]] || parents;
        var level = top;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                while(!level.children || !level.children[name]){
                    if (level == top && defaultSchema) level = defaultSchema;
                    else if (level == defaultSchema && defaultTableName) level = level.child(defaultTableName);
                    else return null;
                }
                var next = level.maybeChild(name);
                if (!next) return null;
                level = next;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var quoteAfter = quoted && context.state.sliceDoc(context.pos, context.pos + 1) == quoted;
        var options = level.list;
        if (level == top && aliases) options = options.concat(Object.keys(aliases).map((name)=>({
                label: name,
                type: "constant"
            })));
        return {
            from,
            to: quoteAfter ? context.pos + 1 : undefined,
            options: maybeQuoteCompletions(quoted, options),
            validFor: quoted ? QuotedSpan : Span
        };
    };
}
function completeKeywords(keywords, upperCase) {
    var completions = Object.keys(keywords).map((keyword)=>({
            label: upperCase ? keyword.toUpperCase() : keyword,
            type: keywords[keyword] == Type ? "type" : keywords[keyword] == Keyword ? "keyword" : "variable",
            boost: -1
        }));
    return (0, _autocomplete.ifNotIn)([
        "QuotedIdentifier",
        "SpecialVar",
        "String",
        "LineComment",
        "BlockComment",
        "."
    ], (0, _autocomplete.completeFromList)(completions));
}
var parser = /*@__PURE__*/ parser$1.configure({
    props: [
        /*@__PURE__*/ (0, _language.indentNodeProp).add({
            Statement: /*@__PURE__*/ (0, _language.continuedIndent)()
        }),
        /*@__PURE__*/ (0, _language.foldNodeProp).add({
            Statement (tree, state) {
                return {
                    from: Math.min(tree.from + 100, state.doc.lineAt(tree.from).to),
                    to: tree.to
                };
            },
            BlockComment (tree) {
                return {
                    from: tree.from + 2,
                    to: tree.to - 2
                };
            }
        }),
        /*@__PURE__*/ (0, _highlight.styleTags)({
            Keyword: (0, _highlight.tags).keyword,
            Type: (0, _highlight.tags).typeName,
            Builtin: /*@__PURE__*/ (0, _highlight.tags).standard((0, _highlight.tags).name),
            Bits: (0, _highlight.tags).number,
            Bytes: (0, _highlight.tags).string,
            Bool: (0, _highlight.tags).bool,
            Null: (0, _highlight.tags).null,
            Number: (0, _highlight.tags).number,
            String: (0, _highlight.tags).string,
            Identifier: (0, _highlight.tags).name,
            QuotedIdentifier: /*@__PURE__*/ (0, _highlight.tags).special((0, _highlight.tags).string),
            SpecialVar: /*@__PURE__*/ (0, _highlight.tags).special((0, _highlight.tags).name),
            LineComment: (0, _highlight.tags).lineComment,
            BlockComment: (0, _highlight.tags).blockComment,
            Operator: (0, _highlight.tags).operator,
            "Semi Punctuation": (0, _highlight.tags).punctuation,
            "( )": (0, _highlight.tags).paren,
            "{ }": (0, _highlight.tags).brace,
            "[ ]": (0, _highlight.tags).squareBracket
        })
    ]
});
/**
Represents an SQL dialect.
*/ class SQLDialect {
    /**
    Returns the language for this dialect as an extension.
    */ get extension() {
        return this.language.extension;
    }
    /**
    Define a new dialect.
    */ static define(spec) {
        var d = dialect(spec, spec.keywords, spec.types, spec.builtin);
        var language = (0, _language.LRLanguage).define({
            name: "sql",
            parser: parser.configure({
                tokenizers: [
                    {
                        from: tokens,
                        to: tokensFor(d)
                    }
                ]
            }),
            languageData: {
                commentTokens: {
                    line: "--",
                    block: {
                        open: "/*",
                        close: "*/"
                    }
                },
                closeBrackets: {
                    brackets: [
                        "(",
                        "[",
                        "{",
                        "'",
                        '"',
                        "`"
                    ]
                }
            }
        });
        return new SQLDialect(d, language, spec);
    }
    constructor(/**
    @internal
    */ dialect, /**
    The language for this dialect.
    */ language, /**
    The spec used to define this dialect.
    */ spec){
        this.dialect = dialect;
        this.language = language;
        this.spec = spec;
    }
}
/**
Returns a completion source that provides keyword completion for
the given SQL dialect.
*/ function keywordCompletionSource(dialect) {
    var upperCase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return completeKeywords(dialect.dialect.words, upperCase);
}
/**
FIXME remove on 1.0 @internal
*/ function keywordCompletion(dialect) {
    var upperCase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return dialect.language.data.of({
        autocomplete: keywordCompletionSource(dialect, upperCase)
    });
}
/**
Returns a completion sources that provides schema-based completion
for the given configuration.
*/ function schemaCompletionSource(config) {
    return config.schema ? completeFromSchema(config.schema, config.tables, config.schemas, config.defaultTable, config.defaultSchema, config.dialect || StandardSQL) : ()=>null;
}
/**
FIXME remove on 1.0 @internal
*/ function schemaCompletion(config) {
    return config.schema ? (config.dialect || StandardSQL).language.data.of({
        autocomplete: schemaCompletionSource(config)
    }) : [];
}
/**
SQL language support for the given SQL dialect, with keyword
completion, and, if provided, schema-based completion as extra
extensions.
*/ function sql() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var lang = config.dialect || StandardSQL;
    return new (0, _language.LanguageSupport)(lang.language, [
        schemaCompletion(config),
        keywordCompletion(lang, !!config.upperCaseKeywords)
    ]);
}
/**
The standard SQL dialect.
*/ var StandardSQL = /*@__PURE__*/ SQLDialect.define({});
/**
Dialect for [PostgreSQL](https://www.postgresql.org).
*/ var PostgreSQL = /*@__PURE__*/ SQLDialect.define({
    charSetCasts: true,
    doubleDollarQuotedStrings: true,
    operatorChars: "+-*/<>=~!@#%^&|`?",
    specialVar: "",
    keywords: SQLKeywords + "a abort abs absent access according ada admin aggregate alias also always analyse analyze array_agg array_max_cardinality asensitive assert assignment asymmetric atomic attach attribute attributes avg backward base64 begin_frame begin_partition bernoulli bit_length blocked bom c cache called cardinality catalog_name ceil ceiling chain char_length character_length character_set_catalog character_set_name character_set_schema characteristics characters checkpoint class class_origin cluster coalesce cobol collation_catalog collation_name collation_schema collect column_name columns command_function command_function_code comment comments committed concurrently condition_number configuration conflict connection_name constant constraint_catalog constraint_name constraint_schema contains content control conversion convert copy corr cost covar_pop covar_samp csv cume_dist current_catalog current_row current_schema cursor_name database datalink datatype datetime_interval_code datetime_interval_precision db debug defaults defined definer degree delimiter delimiters dense_rank depends derived detach detail dictionary disable discard dispatch dlnewcopy dlpreviouscopy dlurlcomplete dlurlcompleteonly dlurlcompletewrite dlurlpath dlurlpathonly dlurlpathwrite dlurlscheme dlurlserver dlvalue document dump dynamic_function dynamic_function_code element elsif empty enable encoding encrypted end_frame end_partition endexec enforced enum errcode error event every exclude excluding exclusive exp explain expression extension extract family file filter final first_value flag floor following force foreach fortran forward frame_row freeze fs functions fusion g generated granted greatest groups handler header hex hierarchy hint id ignore ilike immediately immutable implementation implicit import include including increment indent index indexes info inherit inherits inline insensitive instance instantiable instead integrity intersection invoker isnull k key_member key_type label lag last_value lead leakproof least length library like_regex link listen ln load location lock locked log logged lower m mapping matched materialized max max_cardinality maxvalue member merge message message_length message_octet_length message_text min minvalue mod mode more move multiset mumps name namespace nfc nfd nfkc nfkd nil normalize normalized nothing notice notify notnull nowait nth_value ntile nullable nullif nulls number occurrences_regex octet_length octets off offset oids operator options ordering others over overlay overriding owned owner p parallel parameter_mode parameter_name parameter_ordinal_position parameter_specific_catalog parameter_specific_name parameter_specific_schema parser partition pascal passing passthrough password percent percent_rank percentile_cont percentile_disc perform period permission pg_context pg_datatype_name pg_exception_context pg_exception_detail pg_exception_hint placing plans pli policy portion position position_regex power precedes preceding prepared print_strict_params procedural procedures program publication query quote raise range rank reassign recheck recovery refresh regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy regr_syy reindex rename repeatable replace replica requiring reset respect restart restore result_oid returned_cardinality returned_length returned_octet_length returned_sqlstate returning reverse routine_catalog routine_name routine_schema routines row_count row_number rowtype rule scale schema_name schemas scope scope_catalog scope_name scope_schema security selective self sensitive sequence sequences serializable server server_name setof share show simple skip slice snapshot source specific_name sqlcode sqlerror sqrt stable stacked standalone statement statistics stddev_pop stddev_samp stdin stdout storage strict strip structure style subclass_origin submultiset subscription substring substring_regex succeeds sum symmetric sysid system system_time t table_name tables tablesample tablespace temp template ties token top_level_count transaction_active transactions_committed transactions_rolled_back transform transforms translate translate_regex trigger_catalog trigger_name trigger_schema trim trim_array truncate trusted type types uescape unbounded uncommitted unencrypted unlink unlisten unlogged unnamed untyped upper uri use_column use_variable user_defined_type_catalog user_defined_type_code user_defined_type_name user_defined_type_schema vacuum valid validate validator value_of var_pop var_samp varbinary variable_conflict variadic verbose version versioning views volatile warning whitespace width_bucket window within wrapper xmlagg xmlattributes xmlbinary xmlcast xmlcomment xmlconcat xmldeclaration xmldocument xmlelement xmlexists xmlforest xmliterate xmlnamespaces xmlparse xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltext xmlvalidate yes",
    types: SQLTypes + "bigint int8 bigserial serial8 varbit bool box bytea cidr circle precision float8 inet int4 json jsonb line lseg macaddr macaddr8 money numeric pg_lsn point polygon float4 int2 smallserial serial2 serial serial4 text timetz timestamptz tsquery tsvector txid_snapshot uuid xml"
});
var MySQLKeywords = "accessible algorithm analyze asensitive authors auto_increment autocommit avg avg_row_length binlog btree cache catalog_name chain change changed checkpoint checksum class_origin client_statistics coalesce code collations columns comment committed completion concurrent consistent contains contributors convert database databases day_hour day_microsecond day_minute day_second delay_key_write delayed delimiter des_key_file dev_pop dev_samp deviance directory disable discard distinctrow div dual dumpfile enable enclosed ends engine engines enum errors escaped even event events every explain extended fast field fields flush force found_rows fulltext grants handler hash high_priority hosts hour_microsecond hour_minute hour_second ignore ignore_server_ids import index index_statistics infile innodb insensitive insert_method install invoker iterate keys kill linear lines list load lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modify mutex mysql_errno no_write_to_binlog offline offset one online optimize optionally outfile pack_keys parser partition partitions password phase plugin plugins prev processlist profile profiles purge query quick range read_write rebuild recover regexp relaylog remove rename reorganize repair repeatable replace require resume rlike row_format rtree schedule schema_name schemas second_microsecond security sensitive separator serializable server share show slave slow snapshot soname spatial sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result ssl starting starts std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace terminated triggers truncate uncommitted uninstall unlock upgrade use use_frm user_resources user_statistics utc_date utc_time utc_timestamp variables views warnings xa xor year_month zerofill";
var MySQLTypes = SQLTypes + "bool blob long longblob longtext medium mediumblob mediumint mediumtext tinyblob tinyint tinytext text bigint int1 int2 int3 int4 int8 float4 float8 varbinary varcharacter precision datetime unsigned signed";
var MySQLBuiltin = "charset clear edit ego help nopager notee nowarning pager print prompt quit rehash source status system tee";
/**
[MySQL](https://dev.mysql.com/) dialect.
*/ var MySQL = /*@__PURE__*/ SQLDialect.define({
    operatorChars: "*+-%<>!=&|^",
    charSetCasts: true,
    doubleQuotedStrings: true,
    unquotedBitLiterals: true,
    hashComments: true,
    spaceAfterDashes: true,
    specialVar: "@?",
    identifierQuotes: "`",
    keywords: SQLKeywords + "group_concat " + MySQLKeywords,
    types: MySQLTypes,
    builtin: MySQLBuiltin
});
/**
Variant of [`MySQL`](https://codemirror.net/6/docs/ref/#lang-sql.MySQL) for
[MariaDB](https://mariadb.org/).
*/ var MariaSQL = /*@__PURE__*/ SQLDialect.define({
    operatorChars: "*+-%<>!=&|^",
    charSetCasts: true,
    doubleQuotedStrings: true,
    unquotedBitLiterals: true,
    hashComments: true,
    spaceAfterDashes: true,
    specialVar: "@?",
    identifierQuotes: "`",
    keywords: SQLKeywords + "always generated groupby_concat hard persistent shutdown soft virtual " + MySQLKeywords,
    types: MySQLTypes,
    builtin: MySQLBuiltin
});
/**
SQL dialect for Microsoft [SQL
Server](https://www.microsoft.com/en-us/sql-server).
*/ var MSSQL = /*@__PURE__*/ SQLDialect.define({
    keywords: SQLKeywords + "trigger proc view index for add constraint key primary foreign collate clustered nonclustered declare exec go if use index holdlock nolock nowait paglock pivot readcommitted readcommittedlock readpast readuncommitted repeatableread rowlock serializable snapshot tablock tablockx unpivot updlock with",
    types: SQLTypes + "bigint smallint smallmoney tinyint money real text nvarchar ntext varbinary image hierarchyid uniqueidentifier sql_variant xml",
    builtin: "binary_checksum checksum connectionproperty context_info current_request_id error_line error_message error_number error_procedure error_severity error_state formatmessage get_filestream_transaction_context getansinull host_id host_name isnull isnumeric min_active_rowversion newid newsequentialid rowcount_big xact_state object_id",
    operatorChars: "*+-%<>!=^&|/",
    specialVar: "@"
});
/**
[SQLite](https://sqlite.org/) dialect.
*/ var SQLite = /*@__PURE__*/ SQLDialect.define({
    keywords: SQLKeywords + "abort analyze attach autoincrement conflict database detach exclusive fail glob ignore index indexed instead isnull notnull offset plan pragma query raise regexp reindex rename replace temp vacuum virtual",
    types: SQLTypes + "bool blob long longblob longtext medium mediumblob mediumint mediumtext tinyblob tinyint tinytext text bigint int2 int8 unsigned signed real",
    builtin: "auth backup bail changes clone databases dbinfo dump echo eqp explain fullschema headers help import imposter indexes iotrace lint load log mode nullvalue once print prompt quit restore save scanstats separator shell show stats system tables testcase timeout timer trace vfsinfo vfslist vfsname width",
    operatorChars: "*+-%<>!=&|/~",
    identifierQuotes: '`"',
    specialVar: "@:?$"
});
/**
Dialect for [Cassandra](https://cassandra.apache.org/)'s SQL-ish query language.
*/ var Cassandra = /*@__PURE__*/ SQLDialect.define({
    keywords: "add all allow alter and any apply as asc authorize batch begin by clustering columnfamily compact consistency count create custom delete desc distinct drop each_quorum exists filtering from grant if in index insert into key keyspace keyspaces level limit local_one local_quorum modify nan norecursive nosuperuser not of on one order password permission permissions primary quorum rename revoke schema select set storage superuser table three to token truncate ttl two type unlogged update use user users using values where with writetime infinity NaN",
    types: SQLTypes + "ascii bigint blob counter frozen inet list map static text timeuuid tuple uuid varint",
    slashComments: true
});
/**
[PL/SQL](https://en.wikipedia.org/wiki/PL/SQL) dialect.
*/ var PLSQL = /*@__PURE__*/ SQLDialect.define({
    keywords: SQLKeywords + "abort accept access add all alter and any arraylen as asc assert assign at attributes audit authorization avg base_table begin between binary_integer body by case cast char_base check close cluster clusters colauth column comment commit compress connected constant constraint crash create current currval cursor data_base database dba deallocate debugoff debugon declare default definition delay delete desc digits dispose distinct do drop else elseif elsif enable end entry exception exception_init exchange exclusive exists external fast fetch file for force form from function generic goto grant group having identified if immediate in increment index indexes indicator initial initrans insert interface intersect into is key level library like limited local lock log logging loop master maxextents maxtrans member minextents minus mislabel mode modify multiset new next no noaudit nocompress nologging noparallel not nowait number_base of off offline on online only option or order out package parallel partition pctfree pctincrease pctused pls_integer positive positiven pragma primary prior private privileges procedure public raise range raw rebuild record ref references refresh rename replace resource restrict return returning returns reverse revoke rollback row rowid rowlabel rownum rows run savepoint schema segment select separate set share snapshot some space split sql start statement storage subtype successful synonym tabauth table tables tablespace task terminate then to trigger truncate type union unique unlimited unrecoverable unusable update use using validate value values variable view views when whenever where while with work",
    builtin: "appinfo arraysize autocommit autoprint autorecovery autotrace blockterminator break btitle cmdsep colsep compatibility compute concat copycommit copytypecheck define echo editfile embedded feedback flagger flush heading headsep instance linesize lno loboffset logsource longchunksize markup native newpage numformat numwidth pagesize pause pno recsep recsepchar repfooter repheader serveroutput shiftinout show showmode spool sqlblanklines sqlcase sqlcode sqlcontinue sqlnumber sqlpluscompatibility sqlprefix sqlprompt sqlterminator suffix tab term termout timing trimout trimspool ttitle underline verify version wrap",
    types: SQLTypes + "ascii bfile bfilename bigserial bit blob dec long number nvarchar nvarchar2 serial smallint string text uid varchar2 xml",
    operatorChars: "*/+-%<>!=~",
    doubleQuotedStrings: true,
    charSetCasts: true,
    plsqlQuotingMechanism: true
});

},{"@codemirror/language":"jct2S","@lezer/highlight":"pdORT","@lezer/lr":"gQicU","@codemirror/autocomplete":"2rxgM","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"isu0o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Change", ()=>Change);
parcelHelpers.export(exports, "Chunk", ()=>Chunk);
parcelHelpers.export(exports, "MergeView", ()=>MergeView);
parcelHelpers.export(exports, "acceptChunk", ()=>acceptChunk);
parcelHelpers.export(exports, "diff", ()=>diff);
parcelHelpers.export(exports, "getChunks", ()=>getChunks);
parcelHelpers.export(exports, "getOriginalDoc", ()=>getOriginalDoc);
parcelHelpers.export(exports, "goToNextChunk", ()=>goToNextChunk);
parcelHelpers.export(exports, "goToPreviousChunk", ()=>goToPreviousChunk);
parcelHelpers.export(exports, "originalDocChangeEffect", ()=>originalDocChangeEffect);
parcelHelpers.export(exports, "presentableDiff", ()=>presentableDiff);
parcelHelpers.export(exports, "rejectChunk", ()=>rejectChunk);
parcelHelpers.export(exports, "unifiedMergeView", ()=>unifiedMergeView);
parcelHelpers.export(exports, "updateOriginalDoc", ()=>updateOriginalDoc);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _view = require("@codemirror/view");
var _state = require("@codemirror/state");
var _styleMod = require("style-mod");
var _language = require("@codemirror/language");
var _highlight = require("@lezer/highlight");
// This algorithm was heavily inspired by Neil Fraser's
// diff-match-patch library. See https://github.com/google/diff-match-patch/
/**
A changed range.
*/ class Change {
    /**
    @internal
    */ offset(offA, offB) {
        return new Change(this.fromA + offA, this.toA + offA, this.fromB + offB, this.toB + offB);
    }
    constructor(/**
    The start of the change in document A.
    */ fromA, /**
    The end of the change in document A. This is equal to `fromA`
    in case of insertions.
    */ toA, /**
    The start of the change in document B.
    */ fromB, /**
    The end of the change in document B. This is equal to `fromB`
    for deletions.
    */ toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
}
function findDiff(a, fromA, toA, b, fromB, toB) {
    if (a == b) return [];
    // Remove identical prefix and suffix
    var prefix = commonPrefix(a, fromA, toA, b, fromB, toB);
    var suffix = commonSuffix(a, fromA + prefix, toA, b, fromB + prefix, toB);
    fromA += prefix;
    toA -= suffix;
    fromB += prefix;
    toB -= suffix;
    var lenA = toA - fromA, lenB = toB - fromB;
    // Nothing left in one of them
    if (!lenA || !lenB) return [
        new Change(fromA, toA, fromB, toB)
    ];
    // Try to find one string in the other to cover cases with just 2
    // deletions/insertions.
    if (lenA > lenB) {
        var found = a.slice(fromA, toA).indexOf(b.slice(fromB, toB));
        if (found > -1) return [
            new Change(fromA, fromA + found, fromB, fromB),
            new Change(fromA + found + lenB, toA, toB, toB)
        ];
    } else if (lenB > lenA) {
        var found1 = b.slice(fromB, toB).indexOf(a.slice(fromA, toA));
        if (found1 > -1) return [
            new Change(fromA, fromA, fromB, fromB + found1),
            new Change(toA, toA, fromB + found1 + lenA, toB)
        ];
    }
    // Only one character left on one side, does not occur in other
    // string.
    if (lenA == 1 || lenB == 1) return [
        new Change(fromA, toA, fromB, toB)
    ];
    // Try to split the problem in two by finding a substring of one of
    // the strings in the other.
    var half = halfMatch(a, fromA, toA, b, fromB, toB);
    if (half) {
        var _half = (0, _slicedToArray._)(half, 3), sharedA = _half[0], sharedB = _half[1], sharedLen = _half[2];
        return findDiff(a, fromA, sharedA, b, fromB, sharedB).concat(findDiff(a, sharedA + sharedLen, toA, b, sharedB + sharedLen, toB));
    }
    // Fall back to more expensive general search for a shared
    // subsequence.
    return findSnake(a, fromA, toA, b, fromB, toB);
}
var scanLimit = 1e9;
// Implementation of Myers 1986 "An O(ND) Difference Algorithm and Its Variations"
function findSnake(a, fromA, toA, b, fromB, toB) {
    var lenA = toA - fromA, lenB = toB - fromB;
    if (scanLimit < 1e9 && Math.min(lenA, lenB) > scanLimit * 16) {
        if (Math.min(lenA, lenB) > scanLimit * 64) return [
            new Change(fromA, toA, fromB, toB)
        ];
        return crudeMatch(a, fromA, toA, b, fromB, toB);
    }
    var off = Math.ceil((lenA + lenB) / 2);
    frontier1.reset(off);
    frontier2.reset(off);
    var match1 = (x, y)=>a.charCodeAt(fromA + x) == b.charCodeAt(fromB + y);
    var match2 = (x, y)=>a.charCodeAt(toA - x - 1) == b.charCodeAt(toB - y - 1);
    var test1 = (lenA - lenB) % 2 != 0 ? frontier2 : null, test2 = test1 ? null : frontier1;
    for(var depth = 0; depth < off; depth++){
        if (depth > scanLimit) return crudeMatch(a, fromA, toA, b, fromB, toB);
        var done = frontier1.advance(depth, lenA, lenB, off, test1, false, match1) || frontier2.advance(depth, lenA, lenB, off, test2, true, match2);
        if (done) return bisect(a, fromA, toA, fromA + done[0], b, fromB, toB, fromB + done[1]);
    }
    // No commonality at all.
    return [
        new Change(fromA, toA, fromB, toB)
    ];
}
class Frontier {
    reset(off) {
        this.len = off << 1;
        for(var i = 0; i < this.len; i++)this.vec[i] = -1;
        this.vec[off + 1] = 0;
        this.start = this.end = 0;
    }
    advance(depth, lenX, lenY, vOff, other, fromBack, match) {
        for(var k = -depth + this.start; k <= depth - this.end; k += 2){
            var off = vOff + k;
            var x = k == -depth || k != depth && this.vec[off - 1] < this.vec[off + 1] ? this.vec[off + 1] : this.vec[off - 1] + 1;
            var y = x - k;
            while(x < lenX && y < lenY && match(x, y)){
                x++;
                y++;
            }
            this.vec[off] = x;
            if (x > lenX) this.end += 2;
            else if (y > lenY) this.start += 2;
            else if (other) {
                var offOther = vOff + (lenX - lenY) - k;
                if (offOther >= 0 && offOther < this.len && other.vec[offOther] != -1) {
                    if (!fromBack) {
                        var xOther = lenX - other.vec[offOther];
                        if (x >= xOther) return [
                            x,
                            y
                        ];
                    } else {
                        var xOther1 = other.vec[offOther];
                        if (xOther1 >= lenX - x) return [
                            xOther1,
                            vOff + xOther1 - offOther
                        ];
                    }
                }
            }
        }
        return null;
    }
    constructor(){
        this.vec = [];
    }
}
// Reused across calls to avoid growing the vectors again and again
var frontier1 = /*@__PURE__*/ new Frontier, frontier2 = /*@__PURE__*/ new Frontier;
// Given a position in both strings, recursively call `findDiff` with
// the sub-problems before and after that position. Make sure cut
// points lie on character boundaries.
function bisect(a, fromA, toA, splitA, b, fromB, toB, splitB) {
    var stop = false;
    if (!validIndex(a, splitA) && ++splitA == toA) stop = true;
    if (!validIndex(b, splitB) && ++splitB == toB) stop = true;
    if (stop) return [
        new Change(fromA, toA, fromB, toB)
    ];
    return findDiff(a, fromA, splitA, b, fromB, splitB).concat(findDiff(a, splitA, toA, b, splitB, toB));
}
function chunkSize(lenA, lenB) {
    var size = 1, max = Math.min(lenA, lenB);
    while(size < max)size = size << 1;
    return size;
}
// Common prefix length of the given ranges. Because string comparison
// is so much faster than a JavaScript by-character loop, this
// compares whole chunks at a time.
function commonPrefix(a, fromA, toA, b, fromB, toB) {
    if (fromA == toA || fromA == toB || a.charCodeAt(fromA) != b.charCodeAt(fromB)) return 0;
    var chunk = chunkSize(toA - fromA, toB - fromB);
    for(var pA = fromA, pB = fromB;;){
        var endA = pA + chunk, endB = pB + chunk;
        if (endA > toA || endB > toB || a.slice(pA, endA) != b.slice(pB, endB)) {
            if (chunk == 1) return pA - fromA - (validIndex(a, pA) ? 0 : 1);
            chunk = chunk >> 1;
        } else if (endA == toA || endB == toB) return endA - fromA;
        else {
            pA = endA;
            pB = endB;
        }
    }
}
// Common suffix length
function commonSuffix(a, fromA, toA, b, fromB, toB) {
    if (fromA == toA || fromB == toB || a.charCodeAt(toA - 1) != b.charCodeAt(toB - 1)) return 0;
    var chunk = chunkSize(toA - fromA, toB - fromB);
    for(var pA = toA, pB = toB;;){
        var sA = pA - chunk, sB = pB - chunk;
        if (sA < fromA || sB < fromB || a.slice(sA, pA) != b.slice(sB, pB)) {
            if (chunk == 1) return toA - pA - (validIndex(a, pA) ? 0 : 1);
            chunk = chunk >> 1;
        } else if (sA == fromA || sB == fromB) return toA - sA;
        else {
            pA = sA;
            pB = sB;
        }
    }
}
// a assumed to be be longer than b
function findMatch(a, fromA, toA, b, fromB, toB, size, divideTo) {
    var rangeB = b.slice(fromB, toB);
    // Try some substrings of A of length `size` and see if they exist
    // in B.
    var best = null;
    for(;;){
        if (best || size < divideTo) return best;
        for(var start = fromA + size;;){
            if (!validIndex(a, start)) start++;
            var end = start + size;
            if (!validIndex(a, end)) end += end == start + 1 ? 1 : -1;
            if (end >= toA) break;
            var seed = a.slice(start, end);
            var found = -1;
            while((found = rangeB.indexOf(seed, found + 1)) != -1){
                var prefixAfter = commonPrefix(a, end, toA, b, fromB + found + seed.length, toB);
                var suffixBefore = commonSuffix(a, fromA, start, b, fromB, fromB + found);
                var length = seed.length + prefixAfter + suffixBefore;
                if (!best || best[2] < length) best = [
                    start - suffixBefore,
                    fromB + found - suffixBefore,
                    length
                ];
            }
            start = end;
        }
        if (divideTo < 0) return best;
        size = size >> 1;
    }
}
// Find a shared substring that is at least half the length of the
// longer range. Returns an array describing the substring [startA,
// startB, len], or null.
function halfMatch(a, fromA, toA, b, fromB, toB) {
    var lenA = toA - fromA, lenB = toB - fromB;
    if (lenA < lenB) {
        var result = halfMatch(b, fromB, toB, a, fromA, toA);
        return result && [
            result[1],
            result[0],
            result[2]
        ];
    }
    // From here a is known to be at least as long as b
    if (lenA < 4 || lenB * 2 < lenA) return null;
    return findMatch(a, fromA, toA, b, fromB, toB, Math.floor(lenA / 4), -1);
}
function crudeMatch(a, fromA, toA, b, fromB, toB) {
    var lenA = toA - fromA, lenB = toB - fromB;
    var result;
    if (lenA < lenB) {
        var inv = findMatch(b, fromB, toB, a, fromA, toA, Math.floor(lenA / 6), 50);
        result = inv && [
            inv[1],
            inv[0],
            inv[2]
        ];
    } else result = findMatch(a, fromA, toA, b, fromB, toB, Math.floor(lenB / 6), 50);
    if (!result) return [
        new Change(fromA, toA, fromB, toB)
    ];
    var _result = (0, _slicedToArray._)(result, 3), sharedA = _result[0], sharedB = _result[1], sharedLen = _result[2];
    return findDiff(a, fromA, sharedA, b, fromB, sharedB).concat(findDiff(a, sharedA + sharedLen, toA, b, sharedB + sharedLen, toB));
}
function mergeAdjacent(changes, minGap) {
    for(var i = 1; i < changes.length; i++){
        var prev = changes[i - 1], cur = changes[i];
        if (prev.toA > cur.fromA - minGap && prev.toB > cur.fromB - minGap) {
            changes[i - 1] = new Change(prev.fromA, cur.toA, prev.fromB, cur.toB);
            changes.splice(i--, 1);
        }
    }
}
// Reorder and merge changes
function normalize(a, b, changes) {
    for(;;){
        mergeAdjacent(changes, 1);
        var moved = false;
        // Move unchanged ranges that can be fully moved across an
        // adjacent insertion/deletion, to simplify the diff.
        for(var i = 0; i < changes.length; i++){
            var ch = changes[i], pre = void 0, post = void 0;
            // The half-match heuristic sometimes produces non-minimal
            // diffs. Strip matching pre- and post-fixes again here.
            if (pre = commonPrefix(a, ch.fromA, ch.toA, b, ch.fromB, ch.toB)) ch = changes[i] = new Change(ch.fromA + pre, ch.toA, ch.fromB + pre, ch.toB);
            if (post = commonSuffix(a, ch.fromA, ch.toA, b, ch.fromB, ch.toB)) ch = changes[i] = new Change(ch.fromA, ch.toA - post, ch.fromB, ch.toB - post);
            var lenA = ch.toA - ch.fromA, lenB = ch.toB - ch.fromB;
            // Only look at plain insertions/deletions
            if (lenA && lenB) continue;
            var beforeLen = ch.fromA - (i ? changes[i - 1].toA : 0);
            var afterLen = (i < changes.length - 1 ? changes[i + 1].fromA : a.length) - ch.toA;
            if (!beforeLen || !afterLen) continue;
            var text = lenA ? a.slice(ch.fromA, ch.toA) : b.slice(ch.fromB, ch.toB);
            if (beforeLen <= text.length && a.slice(ch.fromA - beforeLen, ch.fromA) == text.slice(text.length - beforeLen)) {
                // Text before matches the end of the change
                changes[i] = new Change(ch.fromA - beforeLen, ch.toA - beforeLen, ch.fromB - beforeLen, ch.toB - beforeLen);
                moved = true;
            } else if (afterLen <= text.length && a.slice(ch.toA, ch.toA + afterLen) == text.slice(0, afterLen)) {
                // Text after matches the start of the change
                changes[i] = new Change(ch.fromA + afterLen, ch.toA + afterLen, ch.fromB + afterLen, ch.toB + afterLen);
                moved = true;
            }
        }
        if (!moved) break;
    }
    return changes;
}
// Process a change set to make it suitable for presenting to users.
function makePresentable(changes, a, b) {
    for(var posA = 0, i = 0; i < changes.length; i++){
        var change = changes[i];
        var lenA = change.toA - change.fromA, lenB = change.toB - change.fromB;
        // Don't touch short insertions or deletions.
        if (lenA && lenB || lenA > 3 || lenB > 3) {
            var nextChangeA = i == changes.length - 1 ? a.length : changes[i + 1].fromA;
            var maxScanBefore = change.fromA - posA, maxScanAfter = nextChangeA - change.toA;
            var boundBefore = findWordBoundaryBefore(a, change.fromA, Math.min(maxScanBefore, 5));
            var boundAfter = findWordBoundaryAfter(a, change.toA, Math.min(maxScanAfter, 5));
            var lenBefore = change.fromA - boundBefore, lenAfter = boundAfter - change.toA;
            if (!lenA || !lenB) {
                var changeLen = Math.max(lenA, lenB);
                var _ref = (0, _slicedToArray._)(lenA ? [
                    a,
                    change.fromA,
                    change.toA
                ] : [
                    b,
                    change.fromB,
                    change.toB
                ], 3), changeText = _ref[0], changeFrom = _ref[1], changeTo = _ref[2];
                var indentBefore = void 0, indentLen = void 0;
                // An insertion or deletion that falls inside words on both
                // sides can maybe be moved to align with word boundaries.
                if (lenBefore && lenAfter) {
                    if (changeLen > lenBefore && a.slice(boundBefore, change.fromA) == changeText.slice(changeTo - lenBefore, changeTo)) {
                        change = changes[i] = new Change(boundBefore, boundBefore + lenA, change.fromB - lenBefore, change.toB - lenBefore);
                        boundBefore = change.fromA;
                        boundAfter = findWordBoundaryAfter(a, change.toA, Math.min(nextChangeA - change.toA, 5));
                    } else if (changeLen > lenAfter && a.slice(change.toA, boundAfter) == changeText.slice(changeFrom, changeFrom + lenAfter)) {
                        change = changes[i] = new Change(boundAfter - lenA, boundAfter, change.fromB + lenAfter, change.toB + lenAfter);
                        boundAfter = change.toA;
                        boundBefore = findWordBoundaryBefore(a, change.fromA, Math.min(change.fromA - posA, 5));
                    }
                    lenBefore = change.fromA - boundBefore;
                    lenAfter = boundAfter - change.toA;
                // Indentation before the change is repeated at its end. Move it across.
                } else if (!lenBefore && !lenAfter && (indentLen = change.fromA - (indentBefore = findIndentBefore(a, change.fromA, maxScanBefore))) && a.slice(indentBefore, change.fromA) == changeText.slice(changeTo - indentLen, changeTo)) change = changes[i] = new Change(indentBefore, indentBefore + lenA, change.fromB - indentLen, change.toB - indentLen);
            }
            // Grow the change to the word boundaries.
            if (lenBefore || lenAfter) change = changes[i] = new Change(change.fromA - lenBefore, change.toA + lenAfter, change.fromB - lenBefore, change.toB + lenAfter);
            posA = change.toA;
        }
    }
    mergeAdjacent(changes, 3);
    return changes;
}
var wordChar;
try {
    wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}]", "u");
} catch (_) {}
function asciiWordChar(code) {
    return code > 48 && code < 58 || code > 64 && code < 91 || code > 96 && code < 123;
}
function wordCharAfter(s, pos) {
    if (pos == s.length) return 0;
    var next = s.charCodeAt(pos);
    if (next < 192) return asciiWordChar(next) ? 1 : 0;
    if (!wordChar) return 0;
    if (!isSurrogate1(next) || pos == s.length - 1) return wordChar.test(String.fromCharCode(next)) ? 1 : 0;
    return wordChar.test(s.slice(pos, pos + 2)) ? 2 : 0;
}
function wordCharBefore(s, pos) {
    if (!pos) return 0;
    var prev = s.charCodeAt(pos - 1);
    if (prev < 192) return asciiWordChar(prev) ? 1 : 0;
    if (!wordChar) return 0;
    if (!isSurrogate2(prev) || pos == 1) return wordChar.test(String.fromCharCode(prev)) ? 1 : 0;
    return wordChar.test(s.slice(pos - 2, pos)) ? 2 : 0;
}
function findWordBoundaryAfter(s, pos, max) {
    if (pos == s.length || !wordCharBefore(s, pos)) return pos;
    for(var cur = pos, end = pos + max;;){
        var size = wordCharAfter(s, cur);
        if (!size) return cur;
        cur += size;
        if (cur > end) return pos;
    }
}
function findWordBoundaryBefore(s, pos, max) {
    if (!pos || !wordCharAfter(s, pos)) return pos;
    for(var cur = pos, end = pos - max;;){
        var size = wordCharBefore(s, cur);
        if (!size) return cur;
        cur -= size;
        if (cur < end) return pos;
    }
}
function findIndentBefore(s, pos, max) {
    for(var cur = pos, end = pos - max;;){
        var next = cur ? s.charCodeAt(cur - 1) : 10;
        if (next == 10) return cur;
        cur--;
        if (cur < end || next != 32 && next != 9) return pos;
    }
}
var isSurrogate1 = (code)=>code >= 0xD800 && code <= 0xDBFF;
var isSurrogate2 = (code)=>code >= 0xDC00 && code <= 0xDFFF;
// Returns false if index looks like it is in the middle of a
// surrogate pair.
function validIndex(s, index) {
    return !index || index == s.length || !isSurrogate1(s.charCodeAt(index - 1)) || !isSurrogate2(s.charCodeAt(index));
}
/**
Compute the difference between two strings.
*/ function diff(a, b, config) {
    var _a;
    scanLimit = ((_a = config === null || config === void 0 ? void 0 : config.scanLimit) !== null && _a !== void 0 ? _a : 1e9) >> 1;
    return normalize(a, b, findDiff(a, 0, a.length, b, 0, b.length));
}
/**
Compute the difference between the given strings, and clean up the
resulting diff for presentation to users by dropping short
unchanged ranges, and aligning changes to word boundaries when
appropriate.
*/ function presentableDiff(a, b, config) {
    return makePresentable(diff(a, b, config), a, b);
}
var mergeConfig = /*@__PURE__*/ (0, _state.Facet).define({
    combine: (values)=>values[0]
});
var setChunks = /*@__PURE__*/ (0, _state.StateEffect).define();
var ChunkField = /*@__PURE__*/ (0, _state.StateField).define({
    create (state) {
        return null;
    },
    update (current, tr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.is(setChunks)) current = e.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return current;
    }
});
/**
Get the changed chunks for the merge view that this editor is part
of, plus the side it is on if it is part of a `MergeView`. Returns
null if the editor doesn't have a merge extension active or the
merge view hasn't finished initializing yet.
*/ function getChunks(state) {
    var field = state.field(ChunkField, false);
    if (!field) return null;
    var conf = state.facet(mergeConfig);
    return {
        chunks: field,
        side: conf ? conf.side : null
    };
}
var moveByChunk = (dir)=>(param)=>{
        var state = param.state, dispatch = param.dispatch;
        var chunks = state.field(ChunkField, false), conf = state.facet(mergeConfig);
        if (!chunks || !chunks.length || !conf) return false;
        var head = state.selection.main.head, pos = 0;
        for(var i = chunks.length - 1; i >= 0; i--){
            var chunk = chunks[i];
            var _ref = (0, _slicedToArray._)(conf.side == "b" ? [
                chunk.fromB,
                chunk.toB
            ] : [
                chunk.fromA,
                chunk.toA
            ], 2), from = _ref[0], to = _ref[1];
            if (to < head) {
                pos = i + 1;
                break;
            }
            if (from <= head) {
                if (chunks.length == 1) return false;
                pos = i + (dir < 0 ? 0 : 1);
                break;
            }
        }
        var next = chunks[(pos + (dir < 0 ? chunks.length - 1 : 0)) % chunks.length];
        var _ref1 = (0, _slicedToArray._)(conf.side == "b" ? [
            next.fromB,
            next.toB
        ] : [
            next.fromA,
            next.toA
        ], 2), from1 = _ref1[0], to1 = _ref1[1];
        dispatch(state.update({
            selection: {
                anchor: from1
            },
            userEvent: "select.byChunk",
            effects: (0, _view.EditorView).scrollIntoView((0, _state.EditorSelection).range(to1, from1))
        }));
        return true;
    };
/**
Move the selection to the next changed chunk.
*/ var goToNextChunk = /*@__PURE__*/ moveByChunk(1);
/**
Move the selection to the previous changed chunk.
*/ var goToPreviousChunk = /*@__PURE__*/ moveByChunk(-1);
/**
A chunk describes a range of lines which have changed content in
them. Either side (a/b) may either be empty (when its `to` is
equal to its `from`), or points at a range starting at the start
of the first changed line, to 1 past the end of the last changed
line. Note that `to` positions may point past the end of the
document. Use `endA`/`endB` if you need an end position that is
certain to be a valid document position.
*/ class Chunk {
    /**
    @internal
    */ offset(offA, offB) {
        return offA || offB ? new Chunk(this.changes, this.fromA + offA, this.toA + offA, this.fromB + offB, this.toB + offB) : this;
    }
    /**
    Returns `fromA` if the chunk is empty in A, or the end of the
    last line in the chunk otherwise.
    */ get endA() {
        return Math.max(this.fromA, this.toA - 1);
    }
    /**
    Returns `fromB` if the chunk is empty in B, or the end of the
    last line in the chunk otherwise.
    */ get endB() {
        return Math.max(this.fromB, this.toB - 1);
    }
    /**
    Build a set of changed chunks for the given documents.
    */ static build(a, b, conf) {
        return toChunks(presentableDiff(a.toString(), b.toString(), conf), a, b, 0, 0);
    }
    /**
    Update a set of chunks for changes in document A. `a` should
    hold the updated document A.
    */ static updateA(chunks, a, b, changes, conf) {
        return updateChunks(findRangesForChange(chunks, changes, true, b.length), chunks, a, b, conf);
    }
    /**
    Update a set of chunks for changes in document B.
    */ static updateB(chunks, a, b, changes, conf) {
        return updateChunks(findRangesForChange(chunks, changes, false, a.length), chunks, a, b, conf);
    }
    constructor(/**
    The individual changes inside this chunk. These are stored
    relative to the start of the chunk, so you have to add
    `chunk.fromA`/`fromB` to get document positions.
    */ changes, /**
    The start of the chunk in document A.
    */ fromA, /**
    The end of the chunk in document A. This is equal to `fromA`
    when the chunk covers no lines in document A, or is one unit
    past the end of the last line in the chunk if it does.
    */ toA, /**
    The start of the chunk in document B.
    */ fromB, /**
    The end of the chunk in document A.
    */ toB){
        this.changes = changes;
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
}
function fromLine(fromA, fromB, a, b) {
    var lineA = a.lineAt(fromA), lineB = b.lineAt(fromB);
    return lineA.to == fromA && lineB.to == fromB && fromA < a.length && fromB < b.length ? [
        fromA + 1,
        fromB + 1
    ] : [
        lineA.from,
        lineB.from
    ];
}
function toLine(toA, toB, a, b) {
    var lineA = a.lineAt(toA), lineB = b.lineAt(toB);
    return lineA.from == toA && lineB.from == toB ? [
        toA,
        toB
    ] : [
        lineA.to + 1,
        lineB.to + 1
    ];
}
function toChunks(changes, a, b, offA, offB) {
    var chunks = [];
    for(var i = 0; i < changes.length; i++){
        var change = changes[i];
        var _fromLine = (0, _slicedToArray._)(fromLine(change.fromA + offA, change.fromB + offB, a, b), 2), fromA = _fromLine[0], fromB = _fromLine[1];
        var _toLine = (0, _slicedToArray._)(toLine(change.toA + offA, change.toB + offB, a, b), 2), toA = _toLine[0], toB = _toLine[1];
        var chunk = [
            change.offset(-fromA + offA, -fromB + offB)
        ];
        while(i < changes.length - 1){
            var next = changes[i + 1];
            var _fromLine1 = (0, _slicedToArray._)(fromLine(next.fromA + offA, next.fromB + offB, a, b), 2), nextA = _fromLine1[0], nextB = _fromLine1[1];
            if (nextA > toA + 1 && nextB > toB + 1) break;
            chunk.push(next.offset(-fromA + offA, -fromB + offB));
            var ref;
            ref = (0, _slicedToArray._)(toLine(next.toA + offA, next.toB + offB, a, b), 2), toA = ref[0], toB = ref[1], ref;
            i++;
        }
        chunks.push(new Chunk(chunk, fromA, Math.max(fromA, toA), fromB, Math.max(fromB, toB)));
    }
    return chunks;
}
var updateMargin = 1000;
// Finds the given position in the chunks. Returns the extent of the
// chunk it overlaps with if it overlaps, or a position corresponding
// to that position on both sides otherwise.
function findPos(chunks, pos, isA, start) {
    var lo = 0, hi = chunks.length;
    for(;;){
        if (lo == hi) {
            var refA = 0, refB = 0;
            var ref;
            if (lo) ref = chunks[lo - 1], refA = ref.toA, refB = ref.toB, ref;
            var off = pos - (isA ? refA : refB);
            return [
                refA + off,
                refB + off
            ];
        }
        var mid = lo + hi >> 1, chunk = chunks[mid];
        var _ref = (0, _slicedToArray._)(isA ? [
            chunk.fromA,
            chunk.toA
        ] : [
            chunk.fromB,
            chunk.toB
        ], 2), from = _ref[0], to = _ref[1];
        if (from > pos) hi = mid;
        else if (to <= pos) lo = mid + 1;
        else return start ? [
            chunk.fromA,
            chunk.fromB
        ] : [
            chunk.toA,
            chunk.toB
        ];
    }
}
function findRangesForChange(chunks, changes, isA, otherLen) {
    var ranges = [];
    changes.iterChangedRanges((cFromA, cToA, cFromB, cToB)=>{
        var fromA = 0, toA = isA ? changes.length : otherLen;
        var fromB = 0, toB = isA ? otherLen : changes.length;
        var ref;
        if (cFromA > updateMargin) ref = (0, _slicedToArray._)(findPos(chunks, cFromA - updateMargin, isA, true), 2), fromA = ref[0], fromB = ref[1], ref;
        var ref1;
        if (cToA < changes.length - updateMargin) ref1 = (0, _slicedToArray._)(findPos(chunks, cToA + updateMargin, isA, false), 2), toA = ref1[0], toB = ref1[1], ref1;
        var lenDiff = cToB - cFromB - (cToA - cFromA), last;
        var _ref = (0, _slicedToArray._)(isA ? [
            lenDiff,
            0
        ] : [
            0,
            lenDiff
        ], 2), diffA = _ref[0], diffB = _ref[1];
        if (ranges.length && (last = ranges[ranges.length - 1]).toA >= fromA) ranges[ranges.length - 1] = {
            fromA: last.fromA,
            fromB: last.fromB,
            toA,
            toB,
            diffA: last.diffA + diffA,
            diffB: last.diffB + diffB
        };
        else ranges.push({
            fromA,
            toA,
            fromB,
            toB,
            diffA,
            diffB
        });
    });
    return ranges;
}
function updateChunks(ranges, chunks, a, b, conf) {
    if (!ranges.length) return chunks;
    var result = [];
    for(var i = 0, offA = 0, offB = 0, chunkI = 0;; i++){
        var range = i == ranges.length ? null : ranges[i];
        var fromA = range ? range.fromA + offA : a.length, fromB = range ? range.fromB + offB : b.length;
        while(chunkI < chunks.length){
            var next = chunks[chunkI];
            if (next.toA + offA > fromA || next.toB + offB > fromB) break;
            result.push(next.offset(offA, offB));
            chunkI++;
        }
        if (!range) break;
        var toA = range.toA + offA + range.diffA, toB = range.toB + offB + range.diffB;
        var diff = presentableDiff(a.sliceString(fromA, toA), b.sliceString(fromB, toB), conf);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toChunks(diff, a, b, fromA, fromB)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var chunk = _step.value;
                result.push(chunk);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        offA += range.diffA;
        offB += range.diffB;
        while(chunkI < chunks.length){
            var next1 = chunks[chunkI];
            if (next1.fromA + offA > toA && next1.fromB + offB > toB) break;
            chunkI++;
        }
    }
    return result;
}
var defaultDiffConfig = {
    scanLimit: 500
};
var decorateChunks = /*@__PURE__*/ (0, _view.ViewPlugin).fromClass(class {
    update(update) {
        var ref;
        if (update.docChanged || update.viewportChanged || chunksChanged(update.startState, update.state) || configChanged(update.startState, update.state)) ref = getChunkDeco(update.view), this.deco = ref.deco, this.gutter = ref.gutter, ref;
    }
    constructor(view){
        var ref;
        ref = getChunkDeco(view), this.deco = ref.deco, this.gutter = ref.gutter, ref;
    }
}, {
    decorations: (d)=>d.deco
});
var changeGutter = /*@__PURE__*/ (0, _state.Prec).low(/*@__PURE__*/ (0, _view.gutter)({
    class: "cm-changeGutter",
    markers: (view)=>{
        var _a;
        return ((_a = view.plugin(decorateChunks)) === null || _a === void 0 ? void 0 : _a.gutter) || (0, _state.RangeSet).empty;
    }
}));
function chunksChanged(s1, s2) {
    return s1.field(ChunkField, false) != s2.field(ChunkField, false);
}
function configChanged(s1, s2) {
    return s1.facet(mergeConfig) != s2.facet(mergeConfig);
}
var changedLine = /*@__PURE__*/ (0, _view.Decoration).line({
    class: "cm-changedLine"
});
var changedText = /*@__PURE__*/ (0, _view.Decoration).mark({
    class: "cm-changedText"
});
var inserted = /*@__PURE__*/ (0, _view.Decoration).mark({
    tagName: "ins",
    class: "cm-insertedLine"
});
var deleted = /*@__PURE__*/ (0, _view.Decoration).mark({
    tagName: "del",
    class: "cm-deletedLine"
});
var changedLineGutterMarker = /*@__PURE__*/ new class extends (0, _view.GutterMarker) {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-changedLineGutter";
    }
};
function buildChunkDeco(chunk, doc, isA, highlight, builder, gutterBuilder) {
    var from = isA ? chunk.fromA : chunk.fromB, to = isA ? chunk.toA : chunk.toB;
    var changeI = 0;
    if (from != to) {
        builder.add(from, from, changedLine);
        builder.add(from, to, isA ? deleted : inserted);
        if (gutterBuilder) gutterBuilder.add(from, from, changedLineGutterMarker);
        for(var iter = doc.iterRange(from, to - 1), pos = from; !iter.next().done;){
            if (iter.lineBreak) {
                pos++;
                builder.add(pos, pos, changedLine);
                if (gutterBuilder) gutterBuilder.add(pos, pos, changedLineGutterMarker);
                continue;
            }
            var lineEnd = pos + iter.value.length;
            if (highlight) while(changeI < chunk.changes.length){
                var nextChange = chunk.changes[changeI];
                var nextFrom = from + (isA ? nextChange.fromA : nextChange.fromB);
                var nextTo = from + (isA ? nextChange.toA : nextChange.toB);
                var chFrom = Math.max(pos, nextFrom), chTo = Math.min(lineEnd, nextTo);
                if (chFrom < chTo) builder.add(chFrom, chTo, changedText);
                if (nextTo < lineEnd) changeI++;
                else break;
            }
            pos = lineEnd;
        }
    }
}
function getChunkDeco(view) {
    var chunks = view.state.field(ChunkField);
    var _view_state_facet = view.state.facet(mergeConfig), side = _view_state_facet.side, highlightChanges = _view_state_facet.highlightChanges, markGutter = _view_state_facet.markGutter, isA = side == "a";
    var builder = new (0, _state.RangeSetBuilder)();
    var gutterBuilder = markGutter ? new (0, _state.RangeSetBuilder)() : null;
    var _view_viewport = view.viewport, from = _view_viewport.from, to = _view_viewport.to;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = chunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var chunk = _step.value;
            if ((isA ? chunk.fromA : chunk.fromB) >= to) break;
            if ((isA ? chunk.toA : chunk.toB) > from) buildChunkDeco(chunk, view.state.doc, isA, highlightChanges, builder, gutterBuilder);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        deco: builder.finish(),
        gutter: gutterBuilder && gutterBuilder.finish()
    };
}
class Spacer extends (0, _view.WidgetType) {
    eq(other) {
        return this.height == other.height;
    }
    toDOM() {
        var elt = document.createElement("div");
        elt.className = "cm-mergeSpacer";
        elt.style.height = this.height + "px";
        return elt;
    }
    updateDOM(dom) {
        dom.style.height = this.height + "px";
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
    constructor(height){
        super();
        this.height = height;
    }
}
var adjustSpacers = /*@__PURE__*/ (0, _state.StateEffect).define({
    map: (value, mapping)=>value.map(mapping)
});
var Spacers = /*@__PURE__*/ (0, _state.StateField).define({
    create: ()=>(0, _view.Decoration).none,
    update: (spacers, tr)=>{
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.is(adjustSpacers)) return e.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return spacers.map(tr.changes);
    },
    provide: (f)=>(0, _view.EditorView).decorations.from(f)
});
var epsilon = .01;
function updateSpacers(a, b, chunks) {
    var buildA = new (0, _state.RangeSetBuilder)(), buildB = new (0, _state.RangeSetBuilder)();
    var spacersA = a.state.field(Spacers).iter(), spacersB = b.state.field(Spacers).iter();
    var posA = 0, posB = 0, offA = 0, offB = 0;
    for(var chunkI = 0;; chunkI++){
        var chunk = chunkI < chunks.length ? chunks[chunkI] : null;
        // A range at posA/posB is unchanged, must be aligned.
        if (posA < (chunk ? chunk.fromA : a.state.doc.length)) {
            var heightA = a.lineBlockAt(posA).top + offA;
            var heightB = b.lineBlockAt(posB).top + offB;
            var diff = heightA - heightB;
            if (diff < -epsilon) {
                offA -= diff;
                buildA.add(posA, posA, (0, _view.Decoration).widget({
                    widget: new Spacer(-diff),
                    block: true,
                    side: -1
                }));
            } else if (diff > epsilon) {
                offB += diff;
                buildB.add(posB, posB, (0, _view.Decoration).widget({
                    widget: new Spacer(diff),
                    block: true,
                    side: -1
                }));
            }
        }
        if (!chunk) break;
        posA = chunk.toA;
        posB = chunk.toB;
        while(spacersA.value && spacersA.from < posA){
            offA -= spacersA.value.spec.widget.height;
            spacersA.next();
        }
        while(spacersB.value && spacersB.from < posB){
            offB -= spacersB.value.spec.widget.height;
            spacersB.next();
        }
    }
    while(spacersA.value){
        offA -= spacersA.value.spec.widget.height;
        spacersA.next();
    }
    while(spacersB.value){
        offB -= spacersB.value.spec.widget.height;
        spacersB.next();
    }
    var docDiff = a.contentHeight + offA - (b.contentHeight + offB);
    if (docDiff < epsilon) buildA.add(a.state.doc.length, a.state.doc.length, (0, _view.Decoration).widget({
        widget: new Spacer(-docDiff),
        block: true,
        side: 1
    }));
    else if (docDiff > epsilon) buildB.add(b.state.doc.length, b.state.doc.length, (0, _view.Decoration).widget({
        widget: new Spacer(docDiff),
        block: true,
        side: 1
    }));
    var decoA = buildA.finish(), decoB = buildB.finish();
    if (!(0, _state.RangeSet).eq([
        decoA
    ], [
        a.state.field(Spacers)
    ])) a.dispatch({
        effects: adjustSpacers.of(decoA)
    });
    if (!(0, _state.RangeSet).eq([
        decoB
    ], [
        b.state.field(Spacers)
    ])) b.dispatch({
        effects: adjustSpacers.of(decoB)
    });
}
var uncollapse = /*@__PURE__*/ (0, _state.StateEffect).define({
    map: (value, change)=>change.mapPos(value)
});
class CollapseWidget extends (0, _view.WidgetType) {
    eq(other) {
        return this.lines == other.lines;
    }
    toDOM(view) {
        var outer = document.createElement("div");
        outer.className = "cm-collapsedLines";
        outer.textContent = "\u299A " + view.state.phrase("$ unchanged lines", this.lines) + " \u299A";
        outer.addEventListener("click", (e)=>{
            var pos = view.posAtDOM(e.target);
            view.dispatch({
                effects: uncollapse.of(pos)
            });
            var _view_state_facet = view.state.facet(mergeConfig), side = _view_state_facet.side, sibling = _view_state_facet.sibling;
            if (sibling) sibling().dispatch({
                effects: uncollapse.of(mapPos(pos, view.state.field(ChunkField), side == "a"))
            });
        });
        return outer;
    }
    ignoreEvent(e) {
        return e instanceof MouseEvent;
    }
    get estimatedHeight() {
        return 27;
    }
    constructor(lines){
        super();
        this.lines = lines;
    }
}
function mapPos(pos, chunks, isA) {
    var startOur = 0, startOther = 0;
    for(var i = 0;; i++){
        var next = i < chunks.length ? chunks[i] : null;
        if (!next || (isA ? next.fromA : next.fromB) >= pos) return startOther + (pos - startOur);
        var ref;
        ref = (0, _slicedToArray._)(isA ? [
            next.toA,
            next.toB
        ] : [
            next.toB,
            next.toA
        ], 2), startOur = ref[0], startOther = ref[1], ref;
    }
}
var CollapsedRanges = /*@__PURE__*/ (0, _state.StateField).define({
    create (state) {
        return (0, _view.Decoration).none;
    },
    update (deco, tr) {
        deco = deco.map(tr.changes);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var e = _step.value;
                if (e.is(uncollapse)) deco = deco.update({
                    filter: (from)=>from != e.value
                });
            };
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return deco;
    },
    provide: (f)=>(0, _view.EditorView).decorations.from(f)
});
function collapseUnchanged(param) {
    var _param_margin = param.margin, margin = _param_margin === void 0 ? 3 : _param_margin, _param_minSize = param.minSize, minSize = _param_minSize === void 0 ? 4 : _param_minSize;
    return CollapsedRanges.init((state)=>buildCollapsedRanges(state, margin, minSize));
}
function buildCollapsedRanges(state, margin, minLines) {
    var builder = new (0, _state.RangeSetBuilder)();
    var isA = state.facet(mergeConfig).side == "a";
    var chunks = state.field(ChunkField);
    var prevLine = 1;
    for(var i = 0;; i++){
        var chunk = i < chunks.length ? chunks[i] : null;
        var collapseFrom = i ? prevLine + margin : 1;
        var collapseTo = chunk ? state.doc.lineAt(isA ? chunk.fromA : chunk.fromB).number - 1 - margin : state.doc.lines;
        var lines = collapseTo - collapseFrom + 1;
        if (lines >= minLines) builder.add(state.doc.line(collapseFrom).from, state.doc.line(collapseTo).to, (0, _view.Decoration).replace({
            widget: new CollapseWidget(lines),
            block: true
        }));
        if (!chunk) break;
        prevLine = state.doc.lineAt(Math.min(state.doc.length, isA ? chunk.toA : chunk.toB)).number;
    }
    return builder.finish();
}
var externalTheme = /*@__PURE__*/ (0, _view.EditorView).styleModule.of(/*@__PURE__*/ new (0, _styleMod.StyleModule)({
    ".cm-mergeView": {
        overflowY: "auto"
    },
    ".cm-mergeViewEditors": {
        display: "flex",
        alignItems: "stretch"
    },
    ".cm-mergeViewEditor": {
        flexGrow: 1,
        flexBasis: 0,
        overflow: "hidden"
    },
    ".cm-merge-revert": {
        width: "1.6em",
        flexGrow: 0,
        flexShrink: 0,
        position: "relative"
    },
    ".cm-merge-revert button": {
        position: "absolute",
        display: "block",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "center",
        background: "none",
        border: "none",
        font: "inherit",
        cursor: "pointer"
    }
}));
var baseTheme = /*@__PURE__*/ (0, _view.EditorView).baseTheme({
    ".cm-mergeView & .cm-scroller, .cm-mergeView &": {
        height: "auto !important",
        overflowY: "visible !important"
    },
    "&.cm-merge-a .cm-changedLine, .cm-deletedChunk": {
        backgroundColor: "rgba(160, 128, 100, .08)"
    },
    "&.cm-merge-b .cm-changedLine": {
        backgroundColor: "rgba(100, 160, 128, .08)"
    },
    "&light.cm-merge-a .cm-changedText, &light .cm-deletedChunk .cm-deletedText": {
        background: "linear-gradient(#ee443366, #ee443366) bottom/100% 2px no-repeat"
    },
    "&dark.cm-merge-a .cm-changedText, &dark .cm-deletedChunk .cm-deletedText": {
        background: "linear-gradient(#ffaa9966, #ffaa9966) bottom/100% 2px no-repeat"
    },
    "&light.cm-merge-b .cm-changedText": {
        background: "linear-gradient(#22bb2266, #22bb2266) bottom/100% 2px no-repeat"
    },
    "&dark.cm-merge-b .cm-changedText": {
        background: "linear-gradient(#88ff8866, #88ff8866) bottom/100% 2px no-repeat"
    },
    ".cm-insertedLine, .cm-deletedLine": {
        textDecoration: "none"
    },
    ".cm-deletedChunk": {
        paddingLeft: "6px",
        "& .cm-chunkButtons": {
            position: "absolute",
            insetInlineEnd: "5px"
        },
        "& button": {
            border: "none",
            cursor: "pointer",
            color: "white",
            margin: "0 2px",
            borderRadius: "3px",
            "&[name=accept]": {
                background: "#2a2"
            },
            "&[name=reject]": {
                background: "#d43"
            }
        }
    },
    ".cm-collapsedLines": {
        padding: "5px 5px 5px 10px",
        cursor: "pointer"
    },
    "&light .cm-collapsedLines": {
        color: "#444",
        background: "linear-gradient(to bottom, transparent 0, #f3f3f3 30%, #f3f3f3 70%, transparent 100%)"
    },
    "&dark .cm-collapsedLines": {
        color: "#ddd",
        background: "linear-gradient(to bottom, transparent 0, #222 30%, #222 70%, transparent 100%)"
    },
    ".cm-changeGutter": {
        width: "3px",
        paddingLeft: "1px"
    },
    "&light.cm-merge-a .cm-changedLineGutter, &light .cm-deletedLineGutter": {
        background: "#e43"
    },
    "&dark.cm-merge-a .cm-changedLineGutter, &dark .cm-deletedLineGutter": {
        background: "#fa9"
    },
    "&light.cm-merge-b .cm-changedLineGutter": {
        background: "#2b2"
    },
    "&dark.cm-merge-b .cm-changedLineGutter": {
        background: "#8f8"
    }
});
var collapseCompartment = /*@__PURE__*/ new (0, _state.Compartment), configCompartment = /*@__PURE__*/ new (0, _state.Compartment);
/**
A merge view manages two editors side-by-side, highlighting the
difference between them and vertically aligning unchanged lines.
If you want one of the editors to be read-only, you have to
configure that in its extensions.

By default, views are not scrollable. Style them (`.cm-mergeView`)
with a height and `overflow: auto` to make them scrollable.
*/ class MergeView {
    dispatch(trs, target) {
        if (trs.some((tr)=>tr.docChanged)) {
            var last = trs[trs.length - 1];
            var changes = trs.reduce((chs, tr)=>chs.compose(tr.changes), (0, _state.ChangeSet).empty(trs[0].startState.doc.length));
            this.chunks = target == this.a ? Chunk.updateA(this.chunks, last.newDoc, this.b.state.doc, changes, this.diffConf) : Chunk.updateB(this.chunks, this.a.state.doc, last.newDoc, changes, this.diffConf);
            target.update([
                ...trs,
                last.state.update({
                    effects: setChunks.of(this.chunks)
                })
            ]);
            var other = target == this.a ? this.b : this.a;
            other.update([
                other.state.update({
                    effects: setChunks.of(this.chunks)
                })
            ]);
            this.scheduleMeasure();
        } else target.update(trs);
    }
    /**
    Reconfigure an existing merge view.
    */ reconfigure(config) {
        if ("diffConfig" in config) this.diffConf = config.diffConfig;
        if ("orientation" in config) {
            var aB = config.orientation != "b-a";
            if (aB != (this.editorDOM.firstChild == this.a.dom.parentNode)) {
                var domA = this.a.dom.parentNode, domB = this.b.dom.parentNode;
                domA.remove();
                domB.remove();
                this.editorDOM.insertBefore(aB ? domA : domB, this.editorDOM.firstChild);
                this.editorDOM.appendChild(aB ? domB : domA);
                this.revertToLeft = !this.revertToLeft;
                if (this.revertDOM) this.revertDOM.textContent = "";
            }
        }
        if ("revertControls" in config || "renderRevertControl" in config) {
            var controls = !!this.revertDOM, toA = this.revertToA, render = this.renderRevert;
            if ("revertControls" in config) {
                controls = !!config.revertControls;
                toA = config.revertControls == "b-to-a";
            }
            if ("renderRevertControl" in config) render = config.renderRevertControl;
            this.setupRevertControls(controls, toA, render);
        }
        var highlight = "highlightChanges" in config, _$gutter = "gutter" in config, collapse = "collapseUnchanged" in config;
        if (highlight || _$gutter || collapse) {
            var effectsA = [], effectsB = [];
            if (highlight || _$gutter) {
                var currentConfig = this.a.state.facet(mergeConfig);
                var markGutter = _$gutter ? config.gutter !== false : currentConfig.markGutter;
                var highlightChanges = highlight ? config.highlightChanges !== false : currentConfig.highlightChanges;
                effectsA.push(configCompartment.reconfigure([
                    mergeConfig.of({
                        side: "a",
                        sibling: ()=>this.b,
                        highlightChanges,
                        markGutter
                    }),
                    markGutter ? changeGutter : []
                ]));
                effectsB.push(configCompartment.reconfigure([
                    mergeConfig.of({
                        side: "b",
                        sibling: ()=>this.a,
                        highlightChanges,
                        markGutter
                    }),
                    markGutter ? changeGutter : []
                ]));
            }
            if (collapse) {
                var effect = collapseCompartment.reconfigure(config.collapseUnchanged ? collapseUnchanged(config.collapseUnchanged) : []);
                effectsA.push(effect);
                effectsB.push(effect);
            }
            this.a.dispatch({
                effects: effectsA
            });
            this.b.dispatch({
                effects: effectsB
            });
        }
        this.scheduleMeasure();
    }
    setupRevertControls(controls, toA, render) {
        this.revertToA = toA;
        this.revertToLeft = this.revertToA == (this.editorDOM.firstChild == this.a.dom.parentNode);
        this.renderRevert = render;
        if (!controls && this.revertDOM) {
            this.revertDOM.remove();
            this.revertDOM = null;
        } else if (controls && !this.revertDOM) {
            this.revertDOM = this.editorDOM.insertBefore(document.createElement("div"), this.editorDOM.firstChild.nextSibling);
            this.revertDOM.addEventListener("mousedown", (e)=>this.revertClicked(e));
            this.revertDOM.className = "cm-merge-revert";
        } else if (this.revertDOM) this.revertDOM.textContent = "";
    }
    scheduleMeasure() {
        if (this.measuring < 0) {
            var win = this.dom.ownerDocument.defaultView || window;
            this.measuring = win.requestAnimationFrame(()=>{
                this.measuring = -1;
                this.measure();
            });
        }
    }
    measure() {
        updateSpacers(this.a, this.b, this.chunks);
        if (this.revertDOM) this.updateRevertButtons();
    }
    updateRevertButtons() {
        var dom = this.revertDOM, next = dom.firstChild;
        var vpA = this.a.viewport, vpB = this.b.viewport;
        for(var i = 0; i < this.chunks.length; i++){
            var chunk = this.chunks[i];
            if (chunk.fromA > vpA.to || chunk.fromB > vpB.to) break;
            if (chunk.fromA < vpA.from || chunk.fromB < vpB.from) continue;
            var top = this.a.lineBlockAt(chunk.fromA).top + "px";
            while(next && +next.dataset.chunk < i)next = rm(next);
            if (next && next.dataset.chunk == String(i)) {
                if (next.style.top != top) next.style.top = top;
                next = next.nextSibling;
            } else dom.insertBefore(this.renderRevertButton(top, i), next);
        }
        while(next)next = rm(next);
    }
    renderRevertButton(top, chunk) {
        var elt;
        if (this.renderRevert) elt = this.renderRevert();
        else {
            elt = document.createElement("button");
            var text = this.a.state.phrase("Revert this chunk");
            elt.setAttribute("aria-label", text);
            elt.setAttribute("title", text);
            elt.textContent = this.revertToLeft ? "\u21DC" : "\u21DD";
        }
        elt.style.top = top;
        elt.setAttribute("data-chunk", String(chunk));
        return elt;
    }
    revertClicked(e) {
        var target = e.target, chunk;
        while(target && target.parentNode != this.revertDOM)target = target.parentNode;
        if (target && (chunk = this.chunks[target.dataset.chunk])) {
            var _ref = (0, _slicedToArray._)(this.revertToA ? [
                this.b,
                this.a,
                chunk.fromB,
                chunk.toB,
                chunk.fromA,
                chunk.toA
            ] : [
                this.a,
                this.b,
                chunk.fromA,
                chunk.toA,
                chunk.fromB,
                chunk.toB
            ], 6), source = _ref[0], dest = _ref[1], srcFrom = _ref[2], srcTo = _ref[3], destFrom = _ref[4], destTo = _ref[5];
            var insert = source.state.sliceDoc(srcFrom, Math.max(srcFrom, srcTo - 1));
            if (srcFrom != srcTo && destTo <= dest.state.doc.length) insert += source.state.lineBreak;
            dest.dispatch({
                changes: {
                    from: destFrom,
                    to: Math.min(dest.state.doc.length, destTo),
                    insert
                },
                userEvent: "revert"
            });
            e.preventDefault();
        }
    }
    /**
    Destroy this merge view.
    */ destroy() {
        this.a.destroy();
        this.b.destroy();
        if (this.measuring > -1) (this.dom.ownerDocument.defaultView || window).cancelAnimationFrame(this.measuring);
        this.dom.remove();
    }
    /**
    Create a new merge view.
    */ constructor(config){
        this.revertDOM = null;
        this.revertToA = false;
        this.revertToLeft = false;
        this.measuring = -1;
        this.diffConf = config.diffConfig || defaultDiffConfig;
        var sharedExtensions = [
            (0, _state.Prec).low(decorateChunks),
            baseTheme,
            externalTheme,
            Spacers,
            (0, _view.EditorView).updateListener.of((update)=>{
                if (this.measuring < 0 && (update.heightChanged || update.viewportChanged) && !update.transactions.some((tr)=>tr.effects.some((e)=>e.is(adjustSpacers)))) this.measure();
            })
        ];
        var configA = [
            mergeConfig.of({
                side: "a",
                sibling: ()=>this.b,
                highlightChanges: config.highlightChanges !== false,
                markGutter: config.gutter !== false
            })
        ];
        if (config.gutter !== false) configA.push(changeGutter);
        var stateA = (0, _state.EditorState).create({
            doc: config.a.doc,
            selection: config.a.selection,
            extensions: [
                config.a.extensions || [],
                (0, _view.EditorView).editorAttributes.of({
                    class: "cm-merge-a"
                }),
                configCompartment.of(configA),
                sharedExtensions
            ]
        });
        var configB = [
            mergeConfig.of({
                side: "b",
                sibling: ()=>this.a,
                highlightChanges: config.highlightChanges !== false,
                markGutter: config.gutter !== false
            })
        ];
        if (config.gutter !== false) configB.push(changeGutter);
        var stateB = (0, _state.EditorState).create({
            doc: config.b.doc,
            selection: config.b.selection,
            extensions: [
                config.b.extensions || [],
                (0, _view.EditorView).editorAttributes.of({
                    class: "cm-merge-b"
                }),
                configCompartment.of(configB),
                sharedExtensions
            ]
        });
        this.chunks = Chunk.build(stateA.doc, stateB.doc, this.diffConf);
        var add = [
            ChunkField.init(()=>this.chunks),
            collapseCompartment.of(config.collapseUnchanged ? collapseUnchanged(config.collapseUnchanged) : [])
        ];
        stateA = stateA.update({
            effects: (0, _state.StateEffect).appendConfig.of(add)
        }).state;
        stateB = stateB.update({
            effects: (0, _state.StateEffect).appendConfig.of(add)
        }).state;
        this.dom = document.createElement("div");
        this.dom.className = "cm-mergeView";
        this.editorDOM = this.dom.appendChild(document.createElement("div"));
        this.editorDOM.className = "cm-mergeViewEditors";
        var orientation = config.orientation || "a-b";
        var wrapA = document.createElement("div");
        wrapA.className = "cm-mergeViewEditor";
        var wrapB = document.createElement("div");
        wrapB.className = "cm-mergeViewEditor";
        this.editorDOM.appendChild(orientation == "a-b" ? wrapA : wrapB);
        this.editorDOM.appendChild(orientation == "a-b" ? wrapB : wrapA);
        this.a = new (0, _view.EditorView)({
            state: stateA,
            parent: wrapA,
            root: config.root,
            dispatchTransactions: (trs)=>this.dispatch(trs, this.a)
        });
        this.b = new (0, _view.EditorView)({
            state: stateB,
            parent: wrapB,
            root: config.root,
            dispatchTransactions: (trs)=>this.dispatch(trs, this.b)
        });
        this.setupRevertControls(!!config.revertControls, config.revertControls == "b-to-a", config.renderRevertControl);
        if (config.parent) config.parent.appendChild(this.dom);
        this.scheduleMeasure();
    }
}
function rm(elt) {
    var next = elt.nextSibling;
    elt.remove();
    return next;
}
var deletedChunkGutterMarker = /*@__PURE__*/ new class extends (0, _view.GutterMarker) {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-deletedLineGutter";
    }
};
var unifiedChangeGutter = /*@__PURE__*/ (0, _state.Prec).low(/*@__PURE__*/ (0, _view.gutter)({
    class: "cm-changeGutter",
    markers: (view)=>{
        var _a;
        return ((_a = view.plugin(decorateChunks)) === null || _a === void 0 ? void 0 : _a.gutter) || (0, _state.RangeSet).empty;
    },
    widgetMarker: (view, widget)=>widget instanceof DeletionWidget ? deletedChunkGutterMarker : null
}));
/**
Create an extension that causes the editor to display changes
between its content and the given original document. Changed
chunks will be highlighted, with uneditable widgets displaying the
original text displayed above the new text.
*/ function unifiedMergeView(config) {
    var orig = typeof config.original == "string" ? (0, _state.Text).of(config.original.split(/\r?\n/)) : config.original;
    var diffConf = config.diffConfig || defaultDiffConfig;
    return [
        (0, _state.Prec).low(decorateChunks),
        deletedChunks,
        baseTheme,
        (0, _view.EditorView).editorAttributes.of({
            class: "cm-merge-b"
        }),
        (0, _state.EditorState).transactionExtender.of((tr)=>{
            var updateDoc = tr.effects.find((e)=>e.is(updateOriginalDoc));
            if (!tr.docChanged && !updateDoc) return null;
            var prev = tr.startState.field(ChunkField);
            var chunks = updateDoc ? Chunk.updateA(prev, updateDoc.value.doc, tr.newDoc, updateDoc.value.changes, diffConf) : Chunk.updateB(prev, tr.startState.field(originalDoc), tr.newDoc, tr.changes, diffConf);
            return {
                effects: setChunks.of(chunks)
            };
        }),
        mergeConfig.of({
            highlightChanges: config.highlightChanges !== false,
            markGutter: config.gutter !== false,
            syntaxHighlightDeletions: config.syntaxHighlightDeletions !== false,
            mergeControls: config.mergeControls !== false,
            side: "b"
        }),
        originalDoc.init(()=>orig),
        config.gutter !== false ? unifiedChangeGutter : [],
        ChunkField.init((state)=>Chunk.build(orig, state.doc, diffConf))
    ];
}
/**
The state effect used to signal changes in the original doc in a
unified merge view.
*/ var updateOriginalDoc = /*@__PURE__*/ (0, _state.StateEffect).define();
/**
Create an effect that, when added to a transaction on a unified
merge view, will update the original document that's being compared against.
*/ function originalDocChangeEffect(state, changes) {
    return updateOriginalDoc.of({
        doc: changes.apply(getOriginalDoc(state)),
        changes
    });
}
var originalDoc = /*@__PURE__*/ (0, _state.StateField).define({
    create: ()=>(0, _state.Text).empty,
    update (doc, tr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tr.effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.is(updateOriginalDoc)) doc = e.value.doc;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return doc;
    }
});
/**
Get the original document from a unified merge editor's state.
*/ function getOriginalDoc(state) {
    return state.field(originalDoc);
}
var DeletionWidgets = /*@__PURE__*/ new WeakMap;
class DeletionWidget extends (0, _view.WidgetType) {
    eq(other) {
        return this.dom == other.dom;
    }
    toDOM(view) {
        return this.dom || (this.dom = this.buildDOM(view));
    }
    constructor(buildDOM){
        super();
        this.buildDOM = buildDOM;
        this.dom = null;
    }
}
function deletionWidget(state, chunk) {
    var known = DeletionWidgets.get(chunk.changes);
    if (known) return known;
    var buildDOM = (view)=>{
        var _state_facet = state.facet(mergeConfig), highlightChanges = _state_facet.highlightChanges, syntaxHighlightDeletions = _state_facet.syntaxHighlightDeletions, mergeControls = _state_facet.mergeControls;
        var text = view.state.field(originalDoc).sliceString(chunk.fromA, chunk.endA);
        var lang = syntaxHighlightDeletions && state.facet((0, _language.language));
        var dom = document.createElement("div");
        dom.className = "cm-deletedChunk";
        if (mergeControls) {
            var buttons = dom.appendChild(document.createElement("div"));
            buttons.className = "cm-chunkButtons";
            var accept = buttons.appendChild(document.createElement("button"));
            accept.name = "accept";
            accept.textContent = state.phrase("Accept");
            accept.onmousedown = (e)=>{
                e.preventDefault();
                acceptChunk(view, view.posAtDOM(dom));
            };
            var reject = buttons.appendChild(document.createElement("button"));
            reject.name = "reject";
            reject.textContent = state.phrase("Reject");
            reject.onmousedown = (e)=>{
                e.preventDefault();
                rejectChunk(view, view.posAtDOM(dom));
            };
        }
        var content = dom.appendChild(document.createElement("del"));
        var changes = chunk.changes, changeI = 0, inside = false;
        function add(from, to, cls) {
            for(var at = from; at < to;){
                var nextStop = to, nodeCls = cls + (inside ? " cm-deletedText" : "");
                if (highlightChanges && changeI < changes.length) {
                    var nextBound = inside ? changes[changeI].toA : changes[changeI].fromA;
                    if (nextBound <= nextStop) {
                        nextStop = nextBound;
                        if (inside) changeI++;
                        inside = !inside;
                    }
                }
                if (nextStop > at) {
                    var node = document.createTextNode(text.slice(at, nextStop));
                    if (nodeCls) {
                        var span = dom.appendChild(document.createElement("span"));
                        span.className = nodeCls;
                        content.appendChild(node);
                    } else content.appendChild(node);
                }
                at = nextStop;
            }
        }
        if (lang) {
            var tree = lang.parser.parse(text), pos = 0;
            (0, _highlight.highlightTree)(tree, {
                style: (tags)=>(0, _language.highlightingFor)(state, tags)
            }, (from, to, cls)=>{
                if (from > pos) add(pos, from, "");
                add(from, to, cls);
                pos = to;
            });
            add(pos, text.length, "");
        } else add(0, text.length, "");
        return dom;
    };
    var deco = (0, _view.Decoration).widget({
        block: true,
        side: -1,
        widget: new DeletionWidget(buildDOM)
    });
    DeletionWidgets.set(chunk.changes, deco);
    return deco;
}
/**
In a [unified](https://codemirror.net/6/docs/ref/#merge.unifiedMergeView) merge view, accept the
chunk under the given position or the cursor. This chunk will no
longer be highlighted unless it is edited again.
*/ function acceptChunk(view, pos) {
    var state = view.state, at = pos !== null && pos !== void 0 ? pos : state.selection.main.head;
    var chunk = view.state.field(ChunkField).find((ch)=>ch.fromB <= at && ch.endB >= at);
    if (!chunk) return false;
    var insert = view.state.sliceDoc(chunk.fromB, Math.max(chunk.fromB, chunk.toB - 1));
    var orig = view.state.field(originalDoc);
    if (chunk.fromB != chunk.toB && chunk.toA <= orig.length) insert += view.state.lineBreak;
    var changes = (0, _state.ChangeSet).of({
        from: chunk.fromA,
        to: Math.min(orig.length, chunk.toA),
        insert
    }, orig.length);
    view.dispatch({
        effects: updateOriginalDoc.of({
            doc: changes.apply(orig),
            changes
        }),
        userEvent: "accept"
    });
    return true;
}
/**
In a [unified](https://codemirror.net/6/docs/ref/#merge.unifiedMergeView) merge view, reject the
chunk under the given position or the cursor. Reverts that range
to the content it has in the original document.
*/ function rejectChunk(view, pos) {
    var state = view.state, at = pos !== null && pos !== void 0 ? pos : state.selection.main.head;
    var chunk = state.field(ChunkField).find((ch)=>ch.fromB <= at && ch.endB >= at);
    if (!chunk) return false;
    var orig = state.field(originalDoc);
    var insert = orig.sliceString(chunk.fromA, Math.max(chunk.fromA, chunk.toA - 1));
    if (chunk.fromA != chunk.toA && chunk.toB <= state.doc.length) insert += state.lineBreak;
    view.dispatch({
        changes: {
            from: chunk.fromB,
            to: Math.min(state.doc.length, chunk.toB),
            insert
        },
        userEvent: "revert"
    });
    return true;
}
function buildDeletedChunks(state) {
    var builder = new (0, _state.RangeSetBuilder)();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = state.field(ChunkField)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ch = _step.value;
            builder.add(ch.fromB, ch.fromB, deletionWidget(state, ch));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return builder.finish();
}
var deletedChunks = /*@__PURE__*/ (0, _state.StateField).define({
    create: (state)=>buildDeletedChunks(state),
    update (deco, tr) {
        return tr.state.field(ChunkField, false) != tr.startState.field(ChunkField, false) ? buildDeletedChunks(tr.state) : deco;
    },
    provide: (f)=>(0, _view.EditorView).decorations.from(f)
});

},{"@swc/helpers/_/_sliced_to_array":"cdERl","@codemirror/view":"l3day","@codemirror/state":"fECfb","style-mod":"dgaAD","@codemirror/language":"jct2S","@lezer/highlight":"pdORT","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"aVPAC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_editor_richtext_webcomponent", ()=>c_editor_richtext_webcomponent);
parcelHelpers.export(exports, "web_c_editor_richtext", ()=>web_c_editor_richtext);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _suse = require("../../shared-funcs/SUse");
class c_editor_richtext_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_editor_richtext(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-editor-richtext", c_editor_richtext_webcomponent);
class web_c_editor_richtext extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var self, contents_block_id, contents_block, validation_message_container, self1, label_element;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "value") {
                    self = _this;
                    _this.editor.setData(cfg);
                    self.value = cfg;
                    contents_block_id = "cke_" + _this.brick_id;
                    contents_block = document.getElementById(contents_block_id);
                    if (contents_block) contents_block.classList.remove("c-input-validation-failed");
                    validation_message_container = document.getElementById(`${_this.brick_id}&validation`);
                    if (validation_message_container) {
                        validation_message_container.style.display = "none";
                        validation_message_container.innerHTML = "";
                    }
                    return [
                        2,
                        {
                            "@": cfg
                        }
                    ];
                } else if (input == "cfg") {
                    _this.required = cfg.required == true;
                    if (!_this.initialized) {
                        if (cfg.upload_target) {
                            self1 = _this;
                            self1.cfg = cfg;
                            _this.editor.config.uploadUrl = "/cb_api/cb/sc-use";
                            _this.editor.on("fileUploadRequest", function(evt) {
                                var formData = new FormData();
                                formData.append("composition", self1.context.compositions[self1.cid].composition);
                                formData.append("unit_path", self1.blueprint.name);
                                if (self1.context.composition_runners[self1.cid].debugging_enabled) formData.append("debugging_enabled", "" + self1.context.composition_runners[self1.cid].debugging_enabled);
                                if (info) {
                                    formData.append("source", info.source);
                                    formData.append("source_output", info.source_output);
                                }
                                formData.append("unwrap_output", "true");
                                var params = (0, _suse.SUse).GetPValuePairs(self1, "cfg");
                                if (params) for(var k in params)formData.append(k, params[k]);
                                var fileLoader = evt.data.fileLoader, xhr = fileLoader.xhr;
                                xhr.open("POST", fileLoader.uploadUrl, true);
                                formData.append("file", fileLoader.file, fileLoader.fileName);
                                fileLoader.xhr.send(formData);
                                evt.stop();
                            }, null, null, 4);
                            _this.editor.on("fileUploadResponse", function(evt) {
                                var data = evt.data, xhr = data.fileLoader.xhr, response = xhr.responseText;
                                try {
                                    response = JSON.parse(response);
                                } catch (err) {}
                                self1.cb_emit({
                                    "@upload_response": response
                                });
                            });
                        }
                        _this.initialized = true;
                    }
                    if (cfg.height) _this.editor.on("instanceReady", function() {
                        this.resize("100%", cfg.height);
                    });
                    if (cfg.label === null || cfg.label === undefined) cfg.label = "";
                    label_element = document.getElementById(`${_this.brick_id}$label`);
                    label_element.innerHTML = cfg.label;
                    if (cfg.label === "") label_element.classList.add("hidden");
                    else label_element.classList.remove("hidden");
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.required) {
            if ((this.value || "").toLowerCase().indexOf("<img ") != -1) ;
            else {
                var text = Sugar.String.stripTags(this.value).trim();
                if (text == "") {
                    validates = false;
                    validation_message = "Please enter a value";
                }
            }
        }
        var validation_message_container = document.getElementById(`${this.brick_id}&validation`);
        var contents_block_id = "cke_" + this.brick_id;
        var contents_block = document.getElementById(contents_block_id);
        if (contents_block) {
            if (validates) {
                contents_block.classList.remove("c-input-validation-failed");
                if (validation_message_container) {
                    validation_message_container.style.display = "none";
                    validation_message_container.innerHTML = "";
                }
            } else {
                contents_block.classList.add("c-input-validation-failed");
                if (validation_message_container) {
                    validation_message_container.innerHTML = validation_message;
                    validation_message_container.style.display = "block";
                }
            }
        }
        return validates;
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.required = false;
        this.value = "";
        this.initialized = false;
        this.element = element;
        var html = `<label class="c-editor-richtext-label hidden" id="${this.brick_id}$label" for="${this.brick_id}"></label>
        <textarea name="${this.brick_id}" id="${this.brick_id}"></textarea><div class="c-input-validation-message" id="${this.brick_id}&validation" style="display:none"></div>`;
        element.innerHTML = html;
        this.blueprint.ins.cfg = this.blueprint.ins.cfg || {};
        this.editor = CKEDITOR.replace(this.brick_id, {
            width: "100%",
            removeButtons: this.blueprint.ins.cfg.remove_buttons || "",
            extraPlugins: "uploadimage,image2",
            uploadUrl: "/cb_api/cb/sc-use",
            versionCheck: false
        });
        var self = this;
        this.editor.on("change", function(evt) {
            var text = evt.editor.getData();
            text = text.replace(/{/g, "&#123;").replace(/}/g, "&#125;");
            self.value = text;
            self.cb_emit({
                "@": text
            });
        });
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/SUse":"fbS6h","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"fbS6h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUse", ()=>SUse);
var _cbutil = require("../codebricks-runtime/CBUtil");
var _templateUtil = require("../codebricks-runtime/TemplateUtil");
var SUse = /** @class */ function() {
    function SUse() {}
    SUse.GetSUseParams = function(ci, input) {
        //If we get here, it means the template resolved on the client, so we should post to the server
        //We want to jsut send a nsod the the server, containing only the data referenced in the template p values.
        //This is so the server can run the original template, for security reasons (so altered hacked values will not work)
        //So we need to extract the list of p values, from the parsed ins, and send that as a params object to the server.
        var params = {};
        if (ci.parsed_ins) {
            var pi = ci.parsed_ins[input];
            var pvalues = [];
            if (pi) for(var _i = 0, _a = pi.leaves; _i < _a.length; _i++){
                var leaf = _a[_i];
                for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                    var part = _c[_b];
                    if (part.tag) {
                        if (part.tag.items) for(var _d = 0, _e = part.tag.items; _d < _e.length; _d++){
                            var ti = _e[_d];
                            SUse.GetPValuesRecurse(ti, pvalues);
                        }
                    }
                }
            }
            var nsid = (ci.blueprint.nsid || "") + (ci.dc || "");
            var ns = ci.context.composition_runners[ci.cid].nsods[nsid];
            for(var _f = 0, pvalues_1 = pvalues; _f < pvalues_1.length; _f++){
                var pvalue = pvalues_1[_f];
                var tparts = pvalue.split(".");
                var dparts = [
                    tparts[0]
                ];
                if (tparts.length > 1 && tparts[1][0] == "@") dparts.push(tparts[1]);
                else dparts.push("@");
                dparts.push("d");
                var val = (0, _cbutil.DrillGet)(dparts, ns);
                if (val !== undefined) {
                    params[dparts[0]] = params[dparts[0]] || {};
                    params[dparts[0]][dparts[1]] = val;
                }
            }
        }
        return params;
    };
    SUse.GetPValuePairs = function(ci, input) {
        //This is like above, but only {p: value}, for use by c-fileupload, which only posts form data kvps.
        var params = {};
        if (ci.parsed_ins) {
            var pi = ci.parsed_ins[input];
            var pvalues = [];
            if (pi) for(var _i = 0, _a = pi.leaves; _i < _a.length; _i++){
                var leaf = _a[_i];
                for(var _b = 0, _c = leaf.parts; _b < _c.length; _b++){
                    var part = _c[_b];
                    if (part.tag) {
                        if (part.tag.items) for(var _d = 0, _e = part.tag.items; _d < _e.length; _d++){
                            var ti = _e[_d];
                            SUse.GetPValuesRecurse(ti, pvalues);
                        }
                    }
                }
            }
            var nsid = (ci.blueprint.nsid || "") + (ci.dc || "");
            var ns = ci.context.composition_runners[ci.cid].nsods[nsid];
            for(var _f = 0, pvalues_2 = pvalues; _f < pvalues_2.length; _f++){
                var pvalue = pvalues_2[_f];
                // let tparts = pvalue.split('.');
                // let dparts = [tparts[0]];
                // if(tparts.length > 1) {
                //     if(tparts[1][0] == '@') {
                //         dparts.push(tparts[1]);
                //     }
                // }
                // else {
                //     dparts.push("@");
                // }
                // dparts.push('d');
                var tparts = (0, _templateUtil.TemplateUtil).GetTermParts(pvalue); //tv.split('.');
                var pparts = (0, _templateUtil.TemplateUtil).GetTermParts(pvalue);
                //convert a to a.@, and a.b to a.@.b, but leave a.@o, for template output including default (omitted @)
                if (tparts.length == 1) {
                    tparts.push("@");
                    pparts.push("@");
                    tparts.push("d"); //add the d because seq_out_data has the seq_obj inserted, and the data is under d
                } else if (tparts[1][0] != "@") {
                    tparts.splice(1, 0, "@", "d");
                    pparts.splice(1, 0, "@");
                } else tparts.splice(2, 0, "d");
                var val = (0, _cbutil.DrillGet)(tparts, ns);
                if (val !== undefined) params[pparts.join(".")] = val;
            }
        }
        return params;
    };
    SUse.GetPValuesRecurse = function(tag, out_pvalues) {
        if (tag.type[0] == "p" && tag.slice && tag.slice[0] != "$") out_pvalues.push(tag.slice);
        if (tag.items) for(var _i = 0, _a = tag.items; _i < _a.length; _i++){
            var ti = _a[_i];
            this.GetPValuesRecurse(ti, out_pvalues);
        }
    };
    return SUse;
}();

},{"../codebricks-runtime/CBUtil":"1DxvQ","../codebricks-runtime/TemplateUtil":"ebZ29","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"amToG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_export_webcomponent", ()=>c_export_webcomponent);
parcelHelpers.export(exports, "web_c_export", ()=>web_c_export);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class c_export_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_export(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-export", c_export_webcomponent);
class web_c_export extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var snapshot_name, container_brick_name, container_brick, snapshot_composition, snapshot, snapshot_post_obj, res;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    snapshot_name = cfg["snapshot_name"];
                    container_brick_name = cfg["container_brick"];
                    container_brick = _this.context.compositions[_this.cid];
                    snapshot_composition = container_brick.composition;
                    if (container_brick_name) container_brick = _this.find_brick(_this.context.compositions[_this.cid], container_brick_name);
                    if (container_brick) {
                        snapshot = _this.take_snapshot(container_brick);
                        snapshot_post_obj = {
                            snapshot_name: snapshot_name,
                            snapshot: snapshot
                        };
                        res = _this.api_request(snapshot_composition, snapshot_post_obj);
                        return [
                            2,
                            {
                                "@": res
                            }
                        ];
                    } else console.error("c-snapshot: Container brick " + container_brick_name + " not found.");
                }
                return [
                    2
                ];
            });
        })();
    }
    take_snapshot(blueprint) {
        var snapshot_obj = {
            name: blueprint.name
        };
        var ci = this.get_brick_by_name(blueprint.name);
        if (ci) snapshot_obj.snapshot = ci.cb_snapshot();
        if (blueprint.contains) {
            snapshot_obj.children = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var b = _step.value;
                    snapshot_obj.children[b.name] = this.take_snapshot(b);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    get_brick_by_name(name) {
        var ci = this.context.bricks["cb_" + this.cid + "_" + name];
        return ci;
    }
    find_brick(at, name) {
        if (at.name == name) return at;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (at.contains) try {
            for(var _iterator = at.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                var b = this.find_brick(at.contains[c], name);
                if (b) return b;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    }
    api_request(composition_name, snapshot_post_obj) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var res_data, method, options, uri, res, body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.emit_state("loading");
                        method = "POST";
                        options = {
                            method
                        };
                        uri = "/cb_api/cb/snapshot/" + composition_name;
                        options.body = JSON.stringify(snapshot_post_obj);
                        options.credentials = "include";
                        options.headers = {
                            "Content-Type": "application/json"
                        };
                        return [
                            4,
                            fetch(uri, options)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        try {
                            res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        _this.emit_state("");
                        return [
                            2,
                            res_data
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"ilsqV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_filedownload_webcomponent", ()=>c_filedownload_webcomponent);
parcelHelpers.export(exports, "web_c_filedownload", ()=>web_c_filedownload);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var _cbWebUtil = require("../controls/cb_web_util");
class c_filedownload_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_filedownload(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-filedownload", c_filedownload_webcomponent);
class web_c_filedownload extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var composition, unit_path, qs, html, element;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input != "composition") {
                    composition = _this.context.compositions[_this.cid].composition;
                    unit_path = _this.blueprint.name;
                    qs = "";
                    if (cfg.parameters) qs = "?" + (0, _sugarDefault.default).Object.toQueryString(cfg.parameters);
                    if (_this.context.composition_runners[_this.cid].debugging_enabled) {
                        if (qs) qs += "&debugging_enabled=1";
                        else qs = "?debugging_enabled=1";
                    }
                    html = `<a id="${_this.brick_id}" class="btn btn-primary c-filedownload" href="/cb_api/cb/filedownload/${composition}.${unit_path}${qs}" download>${cfg.button_label || "Download"}</a>`;
                    _this.element.innerHTML = html;
                    element = document.getElementById(_this.brick_id);
                    if (element) {
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(element, cfg, "filedownload");
                        if (cfg.hidden) element.classList.add("hidden");
                        else element.classList.remove("hidden");
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","sugar":"gcIJ7","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"aBJSe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_fileupload_webcomponent", ()=>c_fileupload_webcomponent);
parcelHelpers.export(exports, "web_c_fileupload", ()=>web_c_fileupload);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _suse = require("../../shared-funcs/SUse");
class c_fileupload_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_fileupload(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-fileupload", c_fileupload_webcomponent);
class web_c_fileupload extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var accept, self, file_input, button, button1;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "clear" && cfg) {
                    input = "cfg";
                    cfg = _this.cfg;
                    _this.initialised = false;
                }
                if (input == "cfg") {
                    _this.cfg = cfg || {};
                    _this.info = info;
                    accept = "";
                    if (_this.cfg.accept) accept = ` accept="${_this.cfg.accept}"`;
                    if (!_this.initialised) {
                        _this.element.innerHTML = `<div class="c-fileupload-container">
                    <label for="${_this.brick_id}" class="btn btn-secondary c-fileupload">${cfg.input_label || ""}</label><div id="${_this.brick_id}$filename"class="c-fileupload-filename"></div>
                    <input id="${_this.brick_id}" type="file" name="${_this.brick_id}" class="c-fileupload-input"${accept}/>
                    <button id="${_this.brick_id}$button" class="btn btn-primary c-fileupload-button c-fileupload-button-nofile${cfg.auto_upload ? " hidden" : ""}">${cfg.button_label || ""}</button>                 
                </div>
                <progress id="${_this.brick_id}$progress" class="c-fileupload-progressbar hidden" value="0" max="100"></progress>
                <div id="${_this.brick_id}$uploaded" class="c-fileupload-uploaded"></div>`;
                        self = _this;
                        file_input = document.getElementById(_this.brick_id);
                        if (file_input) file_input.addEventListener("change", function() {
                            var _ref = (0, _asyncToGenerator._)(function(evt) {
                                var filename_elem, upload_button, uploaded_elem;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            self.file_name = evt.target.files[0].name;
                                            filename_elem = document.getElementById(self.brick_id + "$filename");
                                            if (!filename_elem) return [
                                                3,
                                                2
                                            ];
                                            if (self.cfg.show_file_name) filename_elem.innerHTML = evt.target.files[0].name;
                                            upload_button = document.getElementById(self.brick_id + "$button");
                                            if (upload_button) upload_button.classList.remove("c-fileupload-button-nofile");
                                            uploaded_elem = document.getElementById(self.brick_id + "$uploaded");
                                            if (uploaded_elem) uploaded_elem.innerHTML = "";
                                            if (!self.cfg.auto_upload) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                self.upload()
                                            ];
                                        case 1:
                                            _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(evt) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        button = document.getElementById(_this.brick_id + "$button");
                        if (button) button.addEventListener("click", function() {
                            var _ref = (0, _asyncToGenerator._)(function(ev) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                self.upload()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.initialised = true;
                    } else {
                        button1 = document.getElementById(_this.brick_id + "$button");
                        if (button1) button1.innerHTML = cfg.button_label;
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    upload() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var fileupload, uploaded_elem, uploaded_elem1, formData, params, k, self, body, res_data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("c_fileupload " + _this.brick_id + " UPLOAD " + JSON.stringify(_this.cfg));
                        fileupload = document.getElementById(_this.brick_id);
                        if (!fileupload) return [
                            3,
                            2
                        ];
                        if (!fileupload.files || fileupload.files.length == 0) {
                            uploaded_elem = document.getElementById(_this.brick_id + "$uploaded");
                            if (uploaded_elem) uploaded_elem.innerHTML = "No file selected";
                            return [
                                2
                            ];
                        }
                        if (_this.cfg.max_file_size && fileupload.files[0].size > Number(_this.cfg.max_file_size)) {
                            uploaded_elem1 = document.getElementById(_this.brick_id + "$uploaded");
                            if (uploaded_elem1) uploaded_elem1.innerHTML = "File not accepted - file may not be larger than " + Sugar.Number.bytes(Number(_this.cfg.max_file_size));
                            return [
                                2
                            ];
                        }
                        formData = new FormData();
                        formData.append("file", fileupload.files[0]);
                        formData.append("composition", _this.context.compositions[_this.cid].composition);
                        formData.append("unit_path", _this.blueprint.name);
                        if (_this.context.composition_runners[_this.cid].debugging_enabled) formData.append("debugging_enabled", "" + _this.context.composition_runners[_this.cid].debugging_enabled);
                        if (_this.info) {
                            formData.append("source", _this.info.source);
                            formData.append("source_output", _this.info.source_output);
                        }
                        formData.append("unwrap_output", "true");
                        params = (0, _suse.SUse).GetPValuePairs(_this, "cfg");
                        if (params) for(var k in params)formData.append(k, params[k]);
                        self = _this;
                        return [
                            4,
                            new Promise((resolve)=>{
                                var xhr = new XMLHttpRequest();
                                xhr.open("POST", "/cb_api/cb/sc-use", true);
                                xhr.onprogress = function(event) {
                                    var percent = Math.round(event.loaded / event.total * 100);
                                    var uploaded_elem = document.getElementById(self.brick_id + "$uploaded");
                                    if (uploaded_elem) uploaded_elem.innerHTML = "Uploaded " + Sugar.Number.bytes(event.loaded) + " of " + Sugar.Number.bytes(event.total) + " (" + percent + "%)";
                                    var progress_elem = document.getElementById(self.brick_id + "$progress");
                                    if (progress_elem) {
                                        progress_elem.classList.remove("hidden");
                                        progress_elem.value = Math.round(percent);
                                    }
                                };
                                xhr.onload = function(event) {
                                    resolve(xhr.response);
                                    var uploaded_elem = document.getElementById(self.brick_id + "$uploaded");
                                    if (uploaded_elem) uploaded_elem.innerHTML = self.cfg.success_message || "";
                                    var progress_elem = document.getElementById(self.brick_id + "$progress");
                                    if (progress_elem) {
                                        progress_elem.value = 0;
                                        progress_elem.classList.add("hidden");
                                    }
                                };
                                xhr.onerror = function() {
                                    resolve(undefined);
                                    var uploaded_elem = document.getElementById(self.brick_id + "$uploaded");
                                    if (uploaded_elem) uploaded_elem.innerHTML = "An error occurred during the upload";
                                };
                                xhr.onabort = function(e) {
                                    resolve(undefined);
                                    var uploaded_elem = document.getElementById(self.brick_id + "$uploaded");
                                    if (uploaded_elem) uploaded_elem.innerHTML = "Upload aborted";
                                };
                                xhr.send(formData);
                            })
                        ];
                    case 1:
                        body = _state.sent();
                        try {
                            if (body !== undefined) res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        console.log("c_fileupload " + _this.brick_id + " RES " + JSON.stringify(res_data));
                        if (res_data !== undefined) _this.cb_emit({
                            "@": res_data,
                            "@filename": self.file_name
                        });
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.file_name = "";
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/SUse":"fbS6h","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"kbXe0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_framed_composition_webcomponent", ()=>c_framed_composition_webcomponent);
parcelHelpers.export(exports, "web_c_framed_composition", ()=>web_c_framed_composition);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbcompositionRunner = require("../../codebricks-runtime/CBCompositionRunner");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _exportFuncs = require("../../shared-funcs/ExportFuncs");
var _cbWebUtil = require("../controls/cb_web_util");
class c_framed_composition_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_framed_composition(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-framed-composition", c_framed_composition_webcomponent);
class web_c_framed_composition extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var composition, self, urlParams, snapshot_id_param, res, body, compos, context, reuse_cid, slot, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.cfg = cfg;
                        composition = cfg.composition;
                        _this.element.innerHTML = `<div></div>`;
                        if (composition == "null") return [
                            2
                        ];
                        self = _this;
                        urlParams = _this.getUrlParams();
                        snapshot_id_param = "";
                        if (urlParams.snapshot_id) snapshot_id_param = "?snapshot_id=" + urlParams.snapshot_id;
                        if (!composition) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetch("/cb_api/cb/composition/" + composition + snapshot_id_param, {
                                mode: "cors",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        if (body === "") return [
                            2
                        ];
                        try {
                            compos = JSON.parse(body);
                        } catch (err) {
                            console.error("c-framed-composition " + _this.brick_id + ": Error fetching composition json:" + JSON.stringify(err));
                            return [
                                2
                            ];
                        }
                        context = globalThis.codebricks_context;
                        if (context) delete context.compositions[self.composition_id];
                        reuse_cid = null;
                        if (!self.rtcn) self.rtcn = new (0, _cbcompositionRunner.CBCompositionRunner)(composition, globalThis.codebricks_context, function() {
                            var _ref = (0, _asyncToGenerator._)(function(led) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                (0, _cbWebUtil.CBWebUtil).PostRequest("/cb_api/admin/debug_log/" + composition, led)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(led) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        else reuse_cid = self.rtcn.cid;
                        if (self.rtcn.context.compositions._0.composition == "editor" && self.blueprint.name == "composition") self.rtcn.debugging_enabled = true;
                        self.rtcn.context.platform = compos.platform || "web";
                        if (compos.snapshot && compos.snapshot.snapshot) (0, _exportFuncs.ExportFuncs).ApplyBrickSnapshots(compos, compos.snapshot.snapshot);
                        self.rtcn.context.timezone_offset = new Date().getTimezoneOffset();
                        if (compos.snapshot && compos.snapshot.timezone_offset !== undefined) {
                            self.rtcn.context.timezone_offset = compos.snapshot.timezone_offset;
                            compos.system_options.timezone_offset = compos.snapshot.timezone_offset;
                        }
                        compos.ins = compos.ins || {};
                        compos.ins.default = compos.ins.default || {};
                        (0, _cbutil.ObjectDeepMerge)(compos.ins.default, urlParams);
                        self.rtcn.init_composition(compos, urlParams, reuse_cid);
                        if (cfg.params) (0, _cbutil.ObjectDeepMerge)(compos.ins, cfg.params);
                        compos.ins.args = compos.ins.args || {};
                        (0, _cbutil.ObjectDeepMerge)(compos.ins.args, urlParams);
                        slot = self.element.querySelector("div");
                        if (slot) slot.innerHTML = `<${compos.type} cid="${self.rtcn.cid}" name="${compos.name}"></${compos.type}>`;
                        if (window.localStorage.getItem("cb_locale")) compos.system_options.locale = window.localStorage.getItem("cb_locale");
                        return [
                            4,
                            self.rtcn.send_initialisation_events(null)
                        ];
                    case 3:
                        result = _state.sent();
                        result["@loaded"] = true;
                        self.rtcn.context_codebrick = self;
                        return [
                            2,
                            result
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    getUrlParams() {
        var urlParams = {};
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
        }, query = window.location.search.substring(1);
        while(match = search.exec(query))if (decode(match[1]) in urlParams) {
            if (!Array.isArray(urlParams[decode(match[1])])) urlParams[decode(match[1])] = [
                urlParams[decode(match[1])]
            ];
            urlParams[decode(match[1])].push(decode(match[2]));
        } else urlParams[decode(match[1])] = decode(match[2]);
        return urlParams;
    }
    cb_unload() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var pf, keys, k, b;
            return (0, _tsGenerator._)(this, function(_state) {
                if (!_this.context.bricks[_this.brick_id]) return [
                    2
                ];
                if (_this.context.bricks && _this.rtcn) {
                    pf = "cb" + _this.rtcn.cid + "_";
                    keys = Object.keys(_this.context.bricks);
                    for(k = keys.length - 1; k >= 0; k--){
                        b = keys[k];
                        if (_this.context.bricks[b] && b.startsWith(pf)) {
                            if (b != _this.brick_id) _this.context.bricks[b].cb_unload();
                            delete _this.context.bricks[b];
                        }
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.composition_id = "_";
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBCompositionRunner":"lpTA2","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/ExportFuncs":"zlXWx","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"zlXWx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExportFuncs", ()=>ExportFuncs);
var _cbutil = require("../codebricks-runtime/CBUtil");
var ExportFuncs = /** @class */ function() {
    function ExportFuncs() {}
    ExportFuncs.ApplyBrickSnapshots = function(brick, snapshots) {
        if (snapshots[brick.name]) {
            console.log(brick.name + " has snapshot " + JSON.stringify(snapshots[brick.name])); // + " brick.ins "+JSON.stringify(brick.ins));
            (0, _cbutil.ObjectDeepMerge)(brick.ins, snapshots[brick.name]);
        }
        if (brick.contains) for(var _i = 0, _a = brick.contains; _i < _a.length; _i++){
            var c = _a[_i];
            ExportFuncs.ApplyBrickSnapshots(c, snapshots);
        }
    };
    return ExportFuncs;
}();

},{"../codebricks-runtime/CBUtil":"1DxvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"cV8oI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_gauge_webcomponent", ()=>c_gauge_webcomponent);
parcelHelpers.export(exports, "web_c_gauge", ()=>web_c_gauge);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _auto = require("chart.js/auto");
var _cbWebUtil = require("../controls/cb_web_util");
class c_gauge_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_gauge(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-gauge", c_gauge_webcomponent);
class web_c_gauge extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var container, self, title_container, center, canvas, chartconfig, labels, values, colors, sum, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, segment, remainder, dataset, legends, i, label, layout, direction, legend_element, options;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg;
                    container = document.getElementById(_this.brick_id + "$container");
                    if (container) {
                        if (cfg.size) {
                            container.style.height = cfg.size;
                            container.style.maxWidth = cfg.size;
                            container.style.paddingBottom = "8%";
                        }
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "gauge");
                    }
                    self = _this;
                    title_container = document.getElementById(self.brick_id + "$title");
                    if (title_container) {
                        if (cfg.title) {
                            title_container.innerHTML = "<h2>" + cfg.title + "</h2>";
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(title_container.firstElementChild, cfg, "title");
                        } else title_container.innerHTML = "";
                    }
                    center = document.getElementById(self.brick_id + "$center");
                    if (center) {
                        center.innerHTML = cfg.center_text || (cfg.center_text === 0 ? cfg.center_text : "");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(center.firstElementChild, cfg, "center");
                    }
                    canvas = document.getElementById(_this.brick_id);
                    if (canvas) {
                        chartconfig = {};
                        labels = [];
                        values = [];
                        colors = [];
                        sum = 0;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = cfg.segments[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                segment = _step.value;
                                if (segment.value && segment.value !== 0) {
                                    labels.push(segment.name);
                                    values.push(segment.value);
                                    colors.push(segment.color);
                                    sum += segment.value;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        remainder = cfg.max - sum;
                        labels.push(cfg.remainder_label);
                        values.push(remainder);
                        colors.push(cfg.remainder_color);
                        dataset = {
                            label: "",
                            data: values,
                            backgroundColor: colors
                        };
                        if (cfg.legend && cfg.legend != "none" && values.length > 0) {
                            legends = "";
                            for(i = 0; i < values.length; i++){
                                label = void 0;
                                if (labels[i] && (label = labels[i].trim())) legends += `<div class="c-gauge-legend-row"><div class="c-gauge-legend-label"><div class="c-gauge-legend-color" style="background-color:${colors[i]}"> </div>${label}</div><div class="c-gauge-legend-value">${values[i]}</div></div>`;
                            }
                            layout = document.getElementById(_this.brick_id + "$layout");
                            if (layout) {
                                direction = "column";
                                if (cfg.legend == "right") direction = "row";
                                else if (cfg.legend == "top") direction = "column-reverse";
                                else if (cfg.legend == "left") direction = "row-reverse";
                                layout.style.flexDirection = direction;
                                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(layout, cfg, "layout");
                            }
                            legend_element = document.getElementById(_this.brick_id + "$legend");
                            if (legend_element) {
                                legend_element.innerHTML = legends;
                                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(legend_element, cfg, "legend");
                            }
                        }
                        options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    display: false,
                                    position: "bottom"
                                },
                                datalabels: {
                                    display: false
                                }
                            },
                            rotation: cfg.start_angle,
                            circumference: cfg.end_angle - cfg.start_angle
                        };
                        chartconfig = {
                            type: "doughnut",
                            data: {
                                labels: labels,
                                datasets: [
                                    dataset
                                ]
                            },
                            options: options
                        };
                        if (_this.cfg.nativeoptions && _this.cfg.nativeoptions.chartjs) chartconfig = (0, _cbutil.ObjectDeepMerge)(chartconfig, _this.cfg.nativeoptions.chartjs);
                        if (_this.chart) _this.chart.destroy();
                        _this.chart = new (0, _auto.Chart)(canvas, chartconfig);
                    }
                    canvas.style.width = cfg.size;
                    return [
                        2,
                        {
                            "@": cfg.value
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "required") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) input.classList.add("required");
        }
        var container = document.getElementById(this.brick_id + "$layout");
        if (container) {
            if (status == "loading") container.classList.add("chart-loading");
            else if (status == "") container.classList.remove("chart-loading");
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
        var html = `<div class="c-gauge-layout" id="${this.brick_id}$layout">
                        <div>
                            <div class="c-gauge-title" id="${this.brick_id}$title"></div>
                            <div class="c-gauge" id="${this.brick_id}$container">
                                <canvas id="${this.brick_id}"></canvas>
                                <div class="c-gauge-center" id="${this.brick_id}$center"></div>
                            </div>
                        </div>
                        <div id="${this.brick_id}$legend" class="c-gauge-legend"></div>
                    </div>`;
        this.element.innerHTML = html;
        var container = document.getElementById(this.brick_id + "$container");
        if (container) {
            if (this.blueprint.ins.cfg.size) {
                container.style.height = this.blueprint.ins.cfg.size;
                container.style.maxWidth = this.blueprint.ins.cfg.size;
                container.style.paddingBottom = "8%";
            }
        }
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","chart.js/auto":"Q5qgv","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"6tI3Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_html_webcomponent", ()=>c_html_webcomponent);
parcelHelpers.export(exports, "web_c_html", ()=>web_c_html);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _cbWebUtil = require("../controls/cb_web_util");
class c_html_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_html(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-html", c_html_webcomponent);
class web_c_html extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var hidden, btn, self;
            return (0, _tsGenerator._)(this, function(_state) {
                if (_this.debug_waiting) return [
                    2
                ];
                if (input == "cfg") {
                    hidden = "";
                    if (cfg.hidden || cfg.hide) hidden = "hidden";
                    _this.element.innerHTML = `<div id="${_this.brick_id}" ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(hidden, cfg, "container")}>${_this.html}</div>`;
                    btn = document.getElementById(_this.brick_id);
                    if (btn && _this.blueprint.targets) {
                        self = _this;
                        btn.addEventListener("click", function() {
                            self.cb_emit({
                                "@": self.blueprint.name
                            });
                        });
                    }
                    _this.no_loader = cfg.no_loader;
                    _this.loader_class = cfg.loader_class || "";
                } else if (input == "html") {
                    if (cfg === null || cfg === undefined) _this.html = "";
                    else _this.html = cfg;
                    _this.setContent(_this.html);
                }
                (0, _cbTooltip.cb_tooltip).set_tooltips(_this.element);
                return [
                    2
                ];
            });
        })();
    }
    setContent(html) {
        var set_html_var = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var container = document.getElementById(this.brick_id);
        if (container) container.innerHTML = html;
        else {
            this.element.innerHTML = `<div id="${this.brick_id}">${html}</div>`;
            container = document.getElementById(this.brick_id);
        }
        if (container && set_html_var) this.html = window.inlineClassProcessor.processContainer(container);
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id);
        if (container) {
            if (status == "loading") {
                if (this.loader_class) container.classList.add(this.loader_class);
                if (!this.no_loader) this.render_skeleton();
            } else {
                if (this.loader_class) container.classList.remove(this.loader_class);
                this.setContent(this.html || "");
            }
        }
        (0, _cbTooltip.cb_tooltip).set_tooltips(this.element);
    }
    render_skeleton() {
        var skeleton_html = this.createHandlebarsSkeletonLoader(this.blueprint.ins.html);
        this.setContent(skeleton_html, false);
    }
    createHandlebarsSkeletonLoader(template) {
        var handlebarTagsRegex = /\{\{.*?\}\}/g;
        var parts = template.split(handlebarTagsRegex);
        var createSkeletonBlock = (text)=>{
            var length = Math.max(Math.min(text.length, 10), 0);
            if (length == 0) return "";
            return `<span class="html-skeleton-block" style="width: ${length}ch;"></span> `;
        };
        var processedParts = parts.map((part, index)=>{
            return createSkeletonBlock(part);
        });
        var skeletonHtml = processedParts.join('<span class="html-skeleton-block" style="width: 2ch;"></span>');
        return `
            <div class="html-skeleton-loader">
                ${skeletonHtml}
            </div>
        `;
    }
    createStructuredHandlebarsSkeletonLoader(template) {
        var handlebarTagsRegex = /\{\{.*?\}\}/g;
        var createSkeletonBlock = (text)=>{
            var words = text.trim().split(/\s+/);
            return words.map((word)=>{
                var length = Math.max(Math.min(word.length, 10), 0);
                var block = "";
                for(var i = 0; i < length; i++)block += "&#9608;";
                if (length == 0) return "";
                return `<span class="html-skeleton-block" style="width:${length}ch">&nbsp;</span>`;
            }).join(" ");
        };
        var processTextNode = (node)=>{
            var _a, _b;
            if (node.nodeType === Node.TEXT_NODE && node.textContent) {
                var skeletonContent = createSkeletonBlock(node.textContent);
                var tempDiv = document.createElement("span");
                tempDiv.innerHTML = skeletonContent;
                if (tempDiv.firstChild) (_a = node.parentNode) === null || _a === void 0 || _a.insertBefore(tempDiv.firstChild, node);
                (_b = node.parentNode) === null || _b === void 0 || _b.removeChild(node);
            } else if (node.nodeType === Node.ELEMENT_NODE) Array.from(node.childNodes).forEach(processTextNode);
        };
        template = template.replace(handlebarTagsRegex, "...");
        var parser = new DOMParser();
        var doc = parser.parseFromString(template, "text/html");
        processTextNode(doc.body);
        var content = doc.body.innerHTML;
        var processedContent = content;
        console.log(template + " -> " + processedContent);
        return `
            <style>
                @keyframes pulse {
                    0% { opacity: 0.6; }
                    50% { opacity: 1; }
                    100% { opacity: 0.6; }
                }
                .skeleton-loader * {
                    color: #e0e0e0 !important;
                    border-radius: 4px;
                    animation: pulse 1.5s ease-in-out infinite;
                }
            </style>
            <div class="skeleton-loader">
                ${processedContent}
            </div>
        `;
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.html = "";
        this.no_loader = false;
        this.loader_class = "";
        this.debug_waiting = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"iKwdc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_hyperlink_webcomponent", ()=>c_hyperlink_webcomponent);
parcelHelpers.export(exports, "web_c_hyperlink", ()=>web_c_hyperlink);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _cbWebUtil = require("../controls/cb_web_util");
class c_hyperlink_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_hyperlink(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-hyperlink", c_hyperlink_webcomponent);
class web_c_hyperlink extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var disp, p_count, k, prefix, element, href, prefix1, url;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    disp = cfg.label;
                    if (cfg.icon && cfg.icon.url) {
                        if (cfg.icon.url[0] == "<") {
                            if (cfg.icon.placement == "right") disp = `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("", cfg, "icon")}>${cfg.label}${cfg.icon.url || ""}</div>`;
                            else disp = `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("", cfg, "icon")}>${cfg.icon.url}${cfg.label || ""}</div>`;
                        } else if (cfg.icon.placement == "right") disp = `<div>${cfg.label}<img ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("c-hyperlink-icon-right", cfg, "icon")} src="${cfg.icon.url}"/></div>`;
                        else disp = `<div><img ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("c-hyperlink-icon-left", cfg, "icon")} src="${cfg.icon.url}"/>${cfg.label || ""}</div>`;
                    }
                    _this.querystring = "";
                    p_count = 0;
                    if (cfg.parameters) {
                        if (typeof cfg.parameters == "object") for(var k in cfg.parameters){
                            if (p_count == 0) _this.querystring = "?";
                            else _this.querystring += "&";
                            _this.querystring += k + "=" + encodeURIComponent(cfg.parameters[k]);
                            p_count++;
                        }
                    }
                    _this.link_comp = cfg.target || "";
                    prefix = "/";
                    if (_this.link_comp[0] == "/" || _this.link_comp.indexOf("://") != -1) prefix = "";
                    element = document.getElementById(_this.brick_id);
                    if (element) {
                        if (cfg.hidden) element.classList.add("hidden");
                        else element.classList.remove("hidden");
                        if (cfg.new_tab) {
                            element.setAttribute("target", "_blank");
                            _this.new_tab = true;
                        }
                        if (cfg.download) {
                            if (cfg.download === true) element.setAttribute("download", "");
                            else element.setAttribute("download", cfg.download);
                        } else element.removeAttribute("download");
                        href = prefix + _this.link_comp + _this.querystring;
                        if (cfg.disabled) element.removeAttribute("href");
                        else element.setAttribute("href", href);
                        element.innerHTML = disp;
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(element, cfg, "hyperlink");
                        if (cfg.tooltip && cfg.tooltip.text) {
                            element.setAttribute("tooltip", cfg.tooltip.text);
                            (0, _cbTooltip.cb_tooltip).set_tooltip(element);
                        }
                    }
                }
                if (input == "trigger" && cfg && JSON.stringify(cfg) != "{}") {
                    prefix1 = "/";
                    if (_this.link_comp.indexOf("://") != -1) prefix1 = "";
                    url = `${prefix1}${_this.link_comp}${_this.querystring}`;
                    if (_this.new_tab) window.open(url);
                    else window.location = url;
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.link_comp = "";
        this.querystring = "";
        this.new_tab = false;
        this.element = element;
        if (this.context.platform == "file") this.element.innerHTML = `<span id="${this.brick_id}" class="c-hyperlink hidden"></span>`;
        else this.element.innerHTML = `<a id="${this.brick_id}" class="c-hyperlink hidden"></a>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"1PuGo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_image_webcomponent", ()=>c_image_webcomponent);
parcelHelpers.export(exports, "web_c_image", ()=>web_c_image);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class c_image_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_image(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-image", c_image_webcomponent);
class web_c_image extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var wh, btn, self;
            return (0, _tsGenerator._)(this, function(_state) {
                wh = "";
                if (cfg.width || cfg.width === 0) {
                    if (!isNaN(cfg.width)) wh += ` width="${cfg.width}px"`;
                    else wh += ` width="${cfg.width}"`;
                }
                if (cfg.height || cfg.height === 0) {
                    if (!isNaN(cfg.width)) wh += ` height="${cfg.height}px"`;
                    else wh += ` height="${cfg.height}"`;
                }
                if (cfg.src) _this.element.innerHTML = `<img id="${_this.brick_id}" src="${cfg.src}" alt="${cfg.alt || ""}"${wh} ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("c-image", cfg, "container")}/>`;
                else _this.element.innerHTML = "";
                btn = document.getElementById(`${_this.brick_id}`);
                if (btn && !_this.listener) {
                    _this.listener = true;
                    self = _this;
                    btn.addEventListener("click", function() {
                        self.cb_emit({
                            "@": self.blueprint.name
                        });
                    });
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.listener = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"bDC5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_input_webcomponent", ()=>c_input_webcomponent);
parcelHelpers.export(exports, "web_c_input", ()=>web_c_input);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class c_input_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_input(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-input", c_input_webcomponent);
class web_c_input extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _$input, initializing, postfix, input_postfix_class, prefix, input_prefix_class, label, afterlabel, wrap, _$input1, self, label_element, container, input_wrap, validation_message_container, _$input2;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "value") {
                    _this.value = cfg;
                    _$input = document.getElementById(`${_this.brick_id}`);
                    if (_$input) {
                        _$input.value = String(_this.value);
                        _this.clearValidation();
                        return [
                            2,
                            {
                                "@": _this.value,
                                "@live": _this.value
                            }
                        ];
                    }
                } else if (input == "cfg") {
                    initializing = false;
                    if (cfg.label === undefined || cfg.label === null) cfg.label = "";
                    initializing = true;
                    postfix = "";
                    input_postfix_class = "";
                    if (cfg.postfix) {
                        postfix = `<div class="c-input-postfix">${cfg.postfix}</div>`;
                        input_postfix_class = "c-input-postfix-input";
                    }
                    prefix = "";
                    input_prefix_class = "";
                    if (cfg.prefix) {
                        prefix = `<div class="c-input-prefix">${cfg.prefix}</div>`;
                        input_prefix_class = "c-input-prefix-input";
                    }
                    label = document.getElementById(`${_this.brick_id}$label`);
                    label.innerHTML = cfg.label;
                    if (cfg.label == "") label.classList.add("hidden");
                    else label.classList.remove("hidden");
                    afterlabel = document.getElementById(`${_this.brick_id}$after`);
                    afterlabel.innerHTML = cfg.label;
                    if (cfg.label == "") afterlabel.classList.add("hidden");
                    else afterlabel.classList.remove("hidden");
                    wrap = document.getElementById(`${_this.brick_id}$wrap`);
                    _$input1 = document.getElementById(`${_this.brick_id}`);
                    if (prefix) {
                        wrap.insertAdjacentHTML("beforebegin", prefix);
                        _$input1.classList.add(input_prefix_class);
                    }
                    if (postfix) {
                        wrap.insertAdjacentHTML("afterend", postfix);
                        _$input1.classList.add(input_postfix_class);
                    }
                    _$input1.placeholder = cfg.placeholder || cfg.label || "";
                    if (cfg.validation && cfg.validation.maxlength) _$input1.maxLength = cfg.validation.maxlength;
                    _$input1.type = cfg.type;
                    _$input1.name = cfg.label;
                    _$input1.disabled = cfg.disabled;
                    _this.initialised = true;
                    _this.label = cfg.label;
                    _this.placeholder = cfg.placeholder;
                    self = _this;
                    if (_$input1) {
                        _$input1.addEventListener("change", function() {
                            var _a;
                            self.value = _$input1.value;
                            if (cfg.validation && cfg.validation.maxlength && typeof cfg.validation.maxlength == "number" && String(self.value).length > cfg.validation.maxlength) self.value = String(self.value).substring(0, cfg.validation.maxlength);
                            if (cfg.type == "number") self.value = Number(String(self.value).replace(/(?![0-9])./gmi, ""));
                            if (_$input1.value != self.value) _$input1.value = self.value;
                            if ((_a = cfg.validation) === null || _a === void 0 ? void 0 : _a.self_validate) self.cb_validate();
                            self.cb_emit({
                                "@": self.value,
                                "@user_changed": self.value
                            });
                        });
                        _$input1.addEventListener("input", function(event) {
                            self.value = this.value;
                            if (cfg.validation && cfg.validation.maxlength && typeof cfg.validation.maxlength == "number" && String(self.value).length > cfg.validation.maxlength) self.value = String(self.value).substring(0, cfg.validation.maxlength);
                            if (self.validate) self.clearValidation();
                            if (cfg.type == "number") self.value = Number(String(self.value).replace(/(?![0-9])./gmi, ""));
                            if (this.value != self.value) _$input1.value = self.value;
                            if (self.blueprint.targets && self.blueprint.targets["@live"]) self.cb_emit({
                                "@live": self.value
                            });
                        });
                        _$input1.addEventListener("keyup", function(e) {
                            if (e.key === "Enter") self.form_value_submit();
                        });
                        _$input1.addEventListener("blur", function(e) {
                            if (self.blueprint.targets && self.blueprint.targets["@blur"]) self.cb_emit({
                                "@blur": self.value
                            });
                        });
                    }
                    if (_this.label != cfg.label) {
                        label_element = document.getElementById(`${_this.brick_id}$label`);
                        label_element.innerHTML = cfg.label;
                        _this.label = cfg.label;
                        if (cfg.label == "") label_element.classList.add("hidden");
                        else label_element.classList.remove("hidden");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(label_element, cfg, "label");
                    }
                    if (_$input1) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(_$input1, cfg, "input");
                    if (cfg.disabled) _$input1.disabled = true;
                    container = document.getElementById(_this.brick_id + "$container");
                    if (container) {
                        if (cfg.hidden) container.classList.add("hidden");
                        else container.classList.remove("hidden");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                    }
                    _this.validation = cfg.validation;
                    _this.clearValidation();
                    if (_this.validation && _this.validation.invalidate_msg) {
                        input_wrap = document.getElementById(`${_this.brick_id}$wrap`);
                        if (input_wrap) input_wrap.classList.add("c-input-validation-failed");
                        validation_message_container = document.getElementById(`${_this.brick_id}$validation`);
                        if (validation_message_container) {
                            validation_message_container.innerHTML = _this.validation.invalidate_msg;
                            validation_message_container.style.display = "block";
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(validation_message_container, cfg, "validation");
                        }
                    }
                    initializing;
                } else if (input == "focus") {
                    if (cfg) {
                        _$input2 = document.getElementById(`${_this.brick_id}`);
                        if (_$input2) _$input2.focus();
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "focus") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) {
                input.focus();
                return true;
            }
        } else if (status == "loading") {
            var input1 = document.getElementById(`${this.brick_id}`);
            if (input1) {
                input1.disabled = true;
                input1.classList.add("skeleton");
            }
        } else if (status == "") {
            var input2 = document.getElementById(`${this.brick_id}`);
            if (input2) {
                input2.disabled = false;
                input2.classList.remove("skeleton");
            }
        }
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.validation) {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) {
                var value = input.value;
                if (this.validation.required && (value === "" || value === null || value === undefined)) {
                    validates = false;
                    validation_message = (this.label || this.placeholder || "Value") + " is a required field";
                } else if (value !== "" && value !== null && value !== undefined && this.validation.minlength > 0 && value.length < this.validation.minlength) {
                    validates = false;
                    validation_message = (this.label || this.placeholder || "Value") + " must be at least " + this.validation.minlength + " characters";
                } else if (this.validation.maxlength > 0 && value.length > this.validation.maxlength) {
                    validates = false;
                    validation_message = (this.label || this.placeholder || "Value") + " may not exceed " + this.validation.maxlength + " characters";
                } else if (value !== "" && value !== null && value !== undefined && this.validation.pattern !== "" && this.validation.pattern !== null && this.validation.pattern !== undefined) {
                    if (!new RegExp("^(?:" + this.validation.pattern.trim() + ")$").test(value)) {
                        validates = false;
                        validation_message = this.validation.pattern_message || "Please enter a valid value";
                    }
                } else if (this.validation.invalidate_msg) {
                    validates = false;
                    validation_message = this.validation.invalidate_msg;
                }
            }
            var validation_message_container = document.getElementById(`${this.brick_id}$validation`);
            var input_wrap = document.getElementById(`${this.brick_id}$wrap`);
            if (input_wrap) {
                if (validates) {
                    input_wrap.classList.remove("c-input-validation-failed");
                    if (validation_message_container) {
                        validation_message_container.style.display = "none";
                        validation_message_container.innerHTML = "";
                    }
                } else {
                    input_wrap.classList.add("c-input-validation-failed");
                    if (validation_message_container) {
                        validation_message_container.innerHTML = validation_message;
                        validation_message_container.style.display = "block";
                    }
                }
            }
        }
        this.validate = true;
        return validates;
    }
    clearValidation() {
        var input_wrap = document.getElementById(`${this.brick_id}$wrap`);
        if (input_wrap) input_wrap.classList.remove("c-input-validation-failed");
        var validation_message_container = document.getElementById(`${this.brick_id}$validation`);
        if (validation_message_container) {
            validation_message_container.style.display = "none";
            validation_message_container.innerHTML = "";
        }
        this.validate = false;
    }
    cb_snapshot() {
        return {
            value: this.value
        };
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.label = "";
        this.placeholder = "";
        this.validation = null;
        this.validate = false;
        this.element = element;
        this.element.innerHTML = `<div class="form-element-container c-input-container hidden" id="${this.brick_id}$container">
                <label class="form-element-label c-input-label hidden" id="${this.brick_id}$label" for="${this.brick_id}"></label>
                <div class="c-input-wrap" id="${this.brick_id}$wrap"><input type="text" id="${this.brick_id}" name="" class="form-element c-input" placeholder="" required/><div class="c-input-afterlabel" id="${this.brick_id}$after"></div></div>
                </div><div class="c-input-validation-message" id="${this.brick_id}$validation" style="display:none"></div>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"a5SwO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_framed_composition_webcomponent", ()=>c_framed_composition_webcomponent);
parcelHelpers.export(exports, "web_c_framed_composition", ()=>web_c_framed_composition);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbcompositionRunner = require("../../codebricks-runtime/CBCompositionRunner");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
var _exportFuncs = require("../../shared-funcs/ExportFuncs");
class c_framed_composition_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_framed_composition(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-jit-generator", c_framed_composition_webcomponent);
class web_c_framed_composition extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var self, urlParams, res, body, gen_res, context, composition, reuse_cid, slot, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            5
                        ];
                        _this.cfg = cfg;
                        _this.element.innerHTML = `<div></div>`;
                        self = _this;
                        urlParams = _this.getUrlParams();
                        if (!(cfg.generator && cfg.template)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetch("/cb_api/generator/generate-jit/" + _this.context.compositions[_this.cid].composition + "." + _this.blueprint.name + "?platform=" + _this.context.platform, {
                                mode: "cors",
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(cfg.params || {})
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        if (body === "") return [
                            2
                        ];
                        gen_res = null;
                        try {
                            gen_res = JSON.parse(body);
                        } catch (err) {
                            console.error("c-jit-generator " + _this.brick_id + ": Error fetching composition json:" + JSON.stringify(err));
                            return [
                                2
                            ];
                        }
                        if (!gen_res.success) {
                            console.error("c-jit-generator " + _this.brick_id + ": Error fetching composition json:" + JSON.stringify(gen_res));
                            return [
                                2
                            ];
                        }
                        _this.compos = gen_res.compos;
                        if (!_this.compos) return [
                            2
                        ];
                        if (cfg.snapshot) {
                            _this.snapshot = cfg.snapshot;
                            (0, _exportFuncs.ExportFuncs).ApplyBrickSnapshots(_this.compos, cfg.snapshot);
                        }
                        context = globalThis.codebricks_context;
                        if (context) delete context.compositions[self.composition_id];
                        composition = _this.compos.composition;
                        reuse_cid = null;
                        if (!self.rtcn) self.rtcn = new (0, _cbcompositionRunner.CBCompositionRunner)(composition, globalThis.codebricks_context, function() {
                            var _ref = (0, _asyncToGenerator._)(function(led) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                (0, _cbWebUtil.CBWebUtil).PostRequest("/cb_api/admin/debug_log/" + composition, led)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(led) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        else reuse_cid = self.rtcn.cid;
                        if (window.location.pathname == "/editor") self.rtcn.debugging_enabled = true;
                        _this.compos.ins = _this.compos.ins || {};
                        _this.compos.ins.default = _this.compos.ins.default || {};
                        (0, _cbutil.ObjectDeepMerge)(_this.compos.ins.default, urlParams);
                        self.rtcn.init_composition(_this.compos, urlParams, reuse_cid);
                        if (cfg.params) (0, _cbutil.ObjectDeepMerge)(_this.compos.ins, cfg.params);
                        _this.compos.ins.args = _this.compos.ins.args || {};
                        (0, _cbutil.ObjectDeepMerge)(_this.compos.ins.args, urlParams);
                        slot = self.element.querySelector("div");
                        if (slot) slot.innerHTML = `<${_this.compos.type} cid="${self.rtcn.cid}" name="${_this.compos.name}"></${_this.compos.type}>`;
                        if (window.localStorage.getItem("cb_locale")) _this.compos.system_options.locale = window.localStorage.getItem("cb_locale");
                        return [
                            4,
                            self.rtcn.send_initialisation_events(null)
                        ];
                    case 3:
                        result = _state.sent();
                        result["@loaded"] = true;
                        self.rtcn.context_codebrick = self;
                        return [
                            2,
                            result
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (input == "take_snapshot") return [
                            2,
                            {
                                "@snapshot": _this.cb_snapshot().cfg.snapshot
                            }
                        ];
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {
        var snapshots = {};
        this.take_snapshots(snapshots, this.compos);
        return {
            cfg: {
                snapshot: (0, _cbutil.ObjectDeepMerge)(this.snapshot, snapshots)
            }
        };
    }
    take_snapshots(snapshots, blueprint) {
        if (!blueprint) {
            console.error("blueprint " + blueprint);
            return;
        }
        var ci = this.get_brick_by_name(blueprint.name);
        if (ci) {
            var ss = ci.cb_snapshot();
            if (ss && Object.keys(ss).length > 0) snapshots[blueprint.name] = ss;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (blueprint.contains) try {
            for(var _iterator = blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var b = _step.value;
                this.take_snapshots(snapshots, b);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    get_brick_by_name(name) {
        var _a;
        var ci = this.context.bricks["cb" + ((_a = this.rtcn) === null || _a === void 0 ? void 0 : _a.cid) + "_" + name];
        return ci;
    }
    getUrlParams() {
        var urlParams = {};
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
        }, query = window.location.search.substring(1);
        while(match = search.exec(query))if (decode(match[1]) in urlParams) {
            if (!Array.isArray(urlParams[decode(match[1])])) urlParams[decode(match[1])] = [
                urlParams[decode(match[1])]
            ];
            urlParams[decode(match[1])].push(decode(match[2]));
        } else urlParams[decode(match[1])] = decode(match[2]);
        return urlParams;
    }
    cb_unload() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var pf, keys, k, b;
            return (0, _tsGenerator._)(this, function(_state) {
                if (!_this.context.bricks[_this.brick_id]) return [
                    2
                ];
                if (_this.context.bricks && _this.rtcn) {
                    pf = "cb" + _this.rtcn.cid + "_";
                    keys = Object.keys(_this.context.bricks);
                    for(k = keys.length - 1; k >= 0; k--){
                        b = keys[k];
                        if (_this.context.bricks[b] && b.startsWith(pf)) {
                            if (b != _this.brick_id) _this.context.bricks[b].cb_unload();
                            delete _this.context.bricks[b];
                        }
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.composition_id = "_";
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBCompositionRunner":"lpTA2","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","../../shared-funcs/ExportFuncs":"zlXWx","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8p6oy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_markdown_webcomponent", ()=>c_markdown_webcomponent);
parcelHelpers.export(exports, "web_c_markdown", ()=>web_c_markdown);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _showdown = require("showdown");
var _showdownDefault = parcelHelpers.interopDefault(_showdown);
var _cbWebUtil = require("../controls/cb_web_util");
class c_markdown_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_markdown(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-markdown", c_markdown_webcomponent);
class web_c_markdown extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var converter, html, hidden, btn, self;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    if (!cfg || cfg.md === null || cfg.md === undefined) _this.md = "";
                    else {
                        (0, _showdownDefault.default).setFlavor("github");
                        converter = new (0, _showdownDefault.default).Converter(), html = converter.makeHtml(cfg.md);
                        _this.md = html;
                    }
                    hidden = "";
                    if (cfg.hidden || cfg.hide) hidden = "hidden";
                    _this.element.innerHTML = `<div id="${_this.brick_id}" ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(hidden, cfg, "container")}>${_this.md}</div>`;
                    btn = document.getElementById(`${_this.brick_id}`);
                    if (btn && !_this.listener) {
                        _this.listener = true;
                        self = _this;
                        btn.addEventListener("click", function() {
                            self.cb_emit({
                                "@": self.blueprint.name
                            });
                        });
                    }
                    _this.no_loader = cfg.no_loader;
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id);
        if (container) {
            if (status == "loading" && !this.no_loader) container.classList.add("loading");
            else container.classList.remove("loading");
        }
        (0, _cbTooltip.cb_tooltip).set_tooltips(this.element);
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.listener = false;
        this.md = "";
        this.no_loader = false;
        this.element = element;
        this.element.innerHTML = `<div id="${this.brick_id}"></div>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","showdown":"1qIn3","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"1qIn3":[function(require,module,exports) {
(function() {
    /**
 * Created by Tivie on 13-07-2015.
 */ function getDefaultOpts(simple) {
        "use strict";
        var defaultOptions = {
            omitExtraWLInCodeBlocks: {
                defaultValue: false,
                describe: "Omit the default extra whiteline added to code blocks",
                type: "boolean"
            },
            noHeaderId: {
                defaultValue: false,
                describe: "Turn on/off generated header id",
                type: "boolean"
            },
            prefixHeaderId: {
                defaultValue: false,
                describe: "Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic 'section-' prefix",
                type: "string"
            },
            rawPrefixHeaderId: {
                defaultValue: false,
                describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
                type: "boolean"
            },
            ghCompatibleHeaderId: {
                defaultValue: false,
                describe: "Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)",
                type: "boolean"
            },
            rawHeaderId: {
                defaultValue: false,
                describe: "Remove only spaces, ' and \" from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids",
                type: "boolean"
            },
            headerLevelStart: {
                defaultValue: false,
                describe: "The header blocks level start",
                type: "integer"
            },
            parseImgDimensions: {
                defaultValue: false,
                describe: "Turn on/off image dimension parsing",
                type: "boolean"
            },
            simplifiedAutoLink: {
                defaultValue: false,
                describe: "Turn on/off GFM autolink style",
                type: "boolean"
            },
            excludeTrailingPunctuationFromURLs: {
                defaultValue: false,
                describe: "Excludes trailing punctuation from links generated with autoLinking",
                type: "boolean"
            },
            literalMidWordUnderscores: {
                defaultValue: false,
                describe: "Parse midword underscores as literal underscores",
                type: "boolean"
            },
            literalMidWordAsterisks: {
                defaultValue: false,
                describe: "Parse midword asterisks as literal asterisks",
                type: "boolean"
            },
            strikethrough: {
                defaultValue: false,
                describe: "Turn on/off strikethrough support",
                type: "boolean"
            },
            tables: {
                defaultValue: false,
                describe: "Turn on/off tables support",
                type: "boolean"
            },
            tablesHeaderId: {
                defaultValue: false,
                describe: "Add an id to table headers",
                type: "boolean"
            },
            ghCodeBlocks: {
                defaultValue: true,
                describe: "Turn on/off GFM fenced code blocks support",
                type: "boolean"
            },
            tasklists: {
                defaultValue: false,
                describe: "Turn on/off GFM tasklist support",
                type: "boolean"
            },
            smoothLivePreview: {
                defaultValue: false,
                describe: "Prevents weird effects in live previews due to incomplete input",
                type: "boolean"
            },
            smartIndentationFix: {
                defaultValue: false,
                describe: "Tries to smartly fix indentation in es6 strings",
                type: "boolean"
            },
            disableForced4SpacesIndentedSublists: {
                defaultValue: false,
                describe: "Disables the requirement of indenting nested sublists by 4 spaces",
                type: "boolean"
            },
            simpleLineBreaks: {
                defaultValue: false,
                describe: "Parses simple line breaks as <br> (GFM Style)",
                type: "boolean"
            },
            requireSpaceBeforeHeadingText: {
                defaultValue: false,
                describe: "Makes adding a space between `#` and the header text mandatory (GFM Style)",
                type: "boolean"
            },
            ghMentions: {
                defaultValue: false,
                describe: "Enables github @mentions",
                type: "boolean"
            },
            ghMentionsLink: {
                defaultValue: "https://github.com/{u}",
                describe: "Changes the link generated by @mentions. Only applies if ghMentions option is enabled.",
                type: "string"
            },
            encodeEmails: {
                defaultValue: true,
                describe: "Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities",
                type: "boolean"
            },
            openLinksInNewWindow: {
                defaultValue: false,
                describe: "Open all links in new windows",
                type: "boolean"
            },
            backslashEscapesHTMLTags: {
                defaultValue: false,
                describe: "Support for HTML Tag escaping. ex: <div>foo</div>",
                type: "boolean"
            },
            emoji: {
                defaultValue: false,
                describe: "Enable emoji support. Ex: `this is a :smile: emoji`",
                type: "boolean"
            },
            underline: {
                defaultValue: false,
                describe: "Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`",
                type: "boolean"
            },
            ellipsis: {
                defaultValue: true,
                describe: "Replaces three dots with the ellipsis unicode character",
                type: "boolean"
            },
            completeHTMLDocument: {
                defaultValue: false,
                describe: "Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags",
                type: "boolean"
            },
            metadata: {
                defaultValue: false,
                describe: "Enable support for document metadata (defined at the top of the document between `\xab\xab\xab` and `\xbb\xbb\xbb` or between `---` and `---`).",
                type: "boolean"
            },
            splitAdjacentBlockquotes: {
                defaultValue: false,
                describe: "Split adjacent blockquote blocks",
                type: "boolean"
            }
        };
        if (simple === false) return JSON.parse(JSON.stringify(defaultOptions));
        var ret = {};
        for(var opt in defaultOptions)if (defaultOptions.hasOwnProperty(opt)) ret[opt] = defaultOptions[opt].defaultValue;
        return ret;
    }
    function allOptionsOn() {
        "use strict";
        var options = getDefaultOpts(true), ret = {};
        for(var opt in options)if (options.hasOwnProperty(opt)) ret[opt] = true;
        return ret;
    }
    /**
 * Created by Tivie on 06-01-2015.
 */ // Private properties
    var showdown = {}, parsers = {}, extensions = {}, globalOptions = getDefaultOpts(true), setFlavor = "vanilla", flavor = {
        github: {
            omitExtraWLInCodeBlocks: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            strikethrough: true,
            tables: true,
            tablesHeaderId: true,
            ghCodeBlocks: true,
            tasklists: true,
            disableForced4SpacesIndentedSublists: true,
            simpleLineBreaks: true,
            requireSpaceBeforeHeadingText: true,
            ghCompatibleHeaderId: true,
            ghMentions: true,
            backslashEscapesHTMLTags: true,
            emoji: true,
            splitAdjacentBlockquotes: true
        },
        original: {
            noHeaderId: true,
            ghCodeBlocks: false
        },
        ghost: {
            omitExtraWLInCodeBlocks: true,
            parseImgDimensions: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            strikethrough: true,
            tables: true,
            tablesHeaderId: true,
            ghCodeBlocks: true,
            tasklists: true,
            smoothLivePreview: true,
            simpleLineBreaks: true,
            requireSpaceBeforeHeadingText: true,
            ghMentions: false,
            encodeEmails: true
        },
        vanilla: getDefaultOpts(true),
        allOn: allOptionsOn()
    };
    /**
 * helper namespace
 * @type {{}}
 */ showdown.helper = {};
    /**
 * TODO LEGACY SUPPORT CODE
 * @type {{}}
 */ showdown.extensions = {};
    /**
 * Set a global option
 * @static
 * @param {string} key
 * @param {*} value
 * @returns {showdown}
 */ showdown.setOption = function(key, value) {
        "use strict";
        globalOptions[key] = value;
        return this;
    };
    /**
 * Get a global option
 * @static
 * @param {string} key
 * @returns {*}
 */ showdown.getOption = function(key) {
        "use strict";
        return globalOptions[key];
    };
    /**
 * Get the global options
 * @static
 * @returns {{}}
 */ showdown.getOptions = function() {
        "use strict";
        return globalOptions;
    };
    /**
 * Reset global options to the default values
 * @static
 */ showdown.resetOptions = function() {
        "use strict";
        globalOptions = getDefaultOpts(true);
    };
    /**
 * Set the flavor showdown should use as default
 * @param {string} name
 */ showdown.setFlavor = function(name) {
        "use strict";
        if (!flavor.hasOwnProperty(name)) throw Error(name + " flavor was not found");
        showdown.resetOptions();
        var preset = flavor[name];
        setFlavor = name;
        for(var option in preset)if (preset.hasOwnProperty(option)) globalOptions[option] = preset[option];
    };
    /**
 * Get the currently set flavor
 * @returns {string}
 */ showdown.getFlavor = function() {
        "use strict";
        return setFlavor;
    };
    /**
 * Get the options of a specified flavor. Returns undefined if the flavor was not found
 * @param {string} name Name of the flavor
 * @returns {{}|undefined}
 */ showdown.getFlavorOptions = function(name) {
        "use strict";
        if (flavor.hasOwnProperty(name)) return flavor[name];
    };
    /**
 * Get the default options
 * @static
 * @param {boolean} [simple=true]
 * @returns {{}}
 */ showdown.getDefaultOptions = function(simple) {
        "use strict";
        return getDefaultOpts(simple);
    };
    /**
 * Get or set a subParser
 *
 * subParser(name)       - Get a registered subParser
 * subParser(name, func) - Register a subParser
 * @static
 * @param {string} name
 * @param {function} [func]
 * @returns {*}
 */ showdown.subParser = function(name, func) {
        "use strict";
        if (showdown.helper.isString(name)) {
            if (typeof func !== "undefined") parsers[name] = func;
            else {
                if (parsers.hasOwnProperty(name)) return parsers[name];
                else throw Error("SubParser named " + name + " not registered!");
            }
        }
    };
    /**
 * Gets or registers an extension
 * @static
 * @param {string} name
 * @param {object|object[]|function=} ext
 * @returns {*}
 */ showdown.extension = function(name, ext) {
        "use strict";
        if (!showdown.helper.isString(name)) throw Error("Extension 'name' must be a string");
        name = showdown.helper.stdExtName(name);
        // Getter
        if (showdown.helper.isUndefined(ext)) {
            if (!extensions.hasOwnProperty(name)) throw Error("Extension named " + name + " is not registered!");
            return extensions[name];
        // Setter
        } else {
            // Expand extension if it's wrapped in a function
            if (typeof ext === "function") ext = ext();
            // Ensure extension is an array
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var validExtension = validate(ext, name);
            if (validExtension.valid) extensions[name] = ext;
            else throw Error(validExtension.error);
        }
    };
    /**
 * Gets all extensions registered
 * @returns {{}}
 */ showdown.getAllExtensions = function() {
        "use strict";
        return extensions;
    };
    /**
 * Remove an extension
 * @param {string} name
 */ showdown.removeExtension = function(name) {
        "use strict";
        delete extensions[name];
    };
    /**
 * Removes all extensions
 */ showdown.resetExtensions = function() {
        "use strict";
        extensions = {};
    };
    /**
 * Validate extension
 * @param {array} extension
 * @param {string} name
 * @returns {{valid: boolean, error: string}}
 */ function validate(extension, name) {
        "use strict";
        var errMsg = name ? "Error in " + name + " extension->" : "Error in unnamed extension", ret = {
            valid: true,
            error: ""
        };
        if (!showdown.helper.isArray(extension)) extension = [
            extension
        ];
        for(var i = 0; i < extension.length; ++i){
            var baseMsg = errMsg + " sub-extension " + i + ": ", ext = extension[i];
            if (typeof ext !== "object") {
                ret.valid = false;
                ret.error = baseMsg + "must be an object, but " + typeof ext + " given";
                return ret;
            }
            if (!showdown.helper.isString(ext.type)) {
                ret.valid = false;
                ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + " given";
                return ret;
            }
            var type = ext.type = ext.type.toLowerCase();
            // normalize extension type
            if (type === "language") type = ext.type = "lang";
            if (type === "html") type = ext.type = "output";
            if (type !== "lang" && type !== "output" && type !== "listener") {
                ret.valid = false;
                ret.error = baseMsg + "type " + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
                return ret;
            }
            if (type === "listener") {
                if (showdown.helper.isUndefined(ext.listeners)) {
                    ret.valid = false;
                    ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
                    return ret;
                }
            } else if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
                ret.valid = false;
                ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
                return ret;
            }
            if (ext.listeners) {
                if (typeof ext.listeners !== "object") {
                    ret.valid = false;
                    ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + " given";
                    return ret;
                }
                for(var ln in ext.listeners){
                    if (ext.listeners.hasOwnProperty(ln)) {
                        if (typeof ext.listeners[ln] !== "function") {
                            ret.valid = false;
                            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln + " must be a function but " + typeof ext.listeners[ln] + " given";
                            return ret;
                        }
                    }
                }
            }
            if (ext.filter) {
                if (typeof ext.filter !== "function") {
                    ret.valid = false;
                    ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + " given";
                    return ret;
                }
            } else if (ext.regex) {
                if (showdown.helper.isString(ext.regex)) ext.regex = new RegExp(ext.regex, "g");
                if (!(ext.regex instanceof RegExp)) {
                    ret.valid = false;
                    ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + " given";
                    return ret;
                }
                if (showdown.helper.isUndefined(ext.replace)) {
                    ret.valid = false;
                    ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
                    return ret;
                }
            }
        }
        return ret;
    }
    /**
 * Validate extension
 * @param {object} ext
 * @returns {boolean}
 */ showdown.validateExtension = function(ext) {
        "use strict";
        var validateExtension = validate(ext, null);
        if (!validateExtension.valid) {
            console.warn(validateExtension.error);
            return false;
        }
        return true;
    };
    /**
 * showdownjs helper functions
 */ if (!showdown.hasOwnProperty("helper")) showdown.helper = {};
    /**
 * Check if var is string
 * @static
 * @param {string} a
 * @returns {boolean}
 */ showdown.helper.isString = function(a) {
        "use strict";
        return typeof a === "string" || a instanceof String;
    };
    /**
 * Check if var is a function
 * @static
 * @param {*} a
 * @returns {boolean}
 */ showdown.helper.isFunction = function(a) {
        "use strict";
        var getType = {};
        return a && getType.toString.call(a) === "[object Function]";
    };
    /**
 * isArray helper function
 * @static
 * @param {*} a
 * @returns {boolean}
 */ showdown.helper.isArray = function(a) {
        "use strict";
        return Array.isArray(a);
    };
    /**
 * Check if value is undefined
 * @static
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */ showdown.helper.isUndefined = function(value) {
        "use strict";
        return typeof value === "undefined";
    };
    /**
 * ForEach helper function
 * Iterates over Arrays and Objects (own properties only)
 * @static
 * @param {*} obj
 * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
 */ showdown.helper.forEach = function(obj, callback) {
        "use strict";
        // check if obj is defined
        if (showdown.helper.isUndefined(obj)) throw new Error("obj param is required");
        if (showdown.helper.isUndefined(callback)) throw new Error("callback param is required");
        if (!showdown.helper.isFunction(callback)) throw new Error("callback param must be a function/closure");
        if (typeof obj.forEach === "function") obj.forEach(callback);
        else if (showdown.helper.isArray(obj)) for(var i = 0; i < obj.length; i++)callback(obj[i], i, obj);
        else if (typeof obj === "object") {
            for(var prop in obj)if (obj.hasOwnProperty(prop)) callback(obj[prop], prop, obj);
        } else throw new Error("obj does not seem to be an array or an iterable object");
    };
    /**
 * Standardidize extension name
 * @static
 * @param {string} s extension name
 * @returns {string}
 */ showdown.helper.stdExtName = function(s) {
        "use strict";
        return s.replace(/[_?*+\/\\.^-]/g, "").replace(/\s/g, "").toLowerCase();
    };
    function escapeCharactersCallback(wholeMatch, m1) {
        "use strict";
        var charCodeToEscape = m1.charCodeAt(0);
        return "\xa8E" + charCodeToEscape + "E";
    }
    /**
 * Callback used to escape characters when passing through String.replace
 * @static
 * @param {string} wholeMatch
 * @param {string} m1
 * @returns {string}
 */ showdown.helper.escapeCharactersCallback = escapeCharactersCallback;
    /**
 * Escape characters in a string
 * @static
 * @param {string} text
 * @param {string} charsToEscape
 * @param {boolean} afterBackslash
 * @returns {XML|string|void|*}
 */ showdown.helper.escapeCharacters = function(text, charsToEscape, afterBackslash) {
        "use strict";
        // First we have to escape the escape characters so that
        // we can build a character class out of them
        var regexString = "([" + charsToEscape.replace(/([\[\]\\])/g, "\\$1") + "])";
        if (afterBackslash) regexString = "\\\\" + regexString;
        var regex = new RegExp(regexString, "g");
        text = text.replace(regex, escapeCharactersCallback);
        return text;
    };
    /**
 * Unescape HTML entities
 * @param txt
 * @returns {string}
 */ showdown.helper.unescapeHTMLEntities = function(txt) {
        "use strict";
        return txt.replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
    };
    var rgxFindMatchPos = function rgxFindMatchPos(str, left, right, flags) {
        "use strict";
        var f = flags || "", g = f.indexOf("g") > -1, x = new RegExp(left + "|" + right, "g" + f.replace(/g/g, "")), l = new RegExp(left, f.replace(/g/g, "")), pos = [], t, s, m, start, end;
        do {
            t = 0;
            while(m = x.exec(str)){
                if (l.test(m[0])) {
                    if (!t++) {
                        s = x.lastIndex;
                        start = s - m[0].length;
                    }
                } else if (t) {
                    if (!--t) {
                        end = m.index + m[0].length;
                        var obj = {
                            left: {
                                start: start,
                                end: s
                            },
                            match: {
                                start: s,
                                end: m.index
                            },
                            right: {
                                start: m.index,
                                end: end
                            },
                            wholeMatch: {
                                start: start,
                                end: end
                            }
                        };
                        pos.push(obj);
                        if (!g) return pos;
                    }
                }
            }
        }while (t && (x.lastIndex = s));
        return pos;
    };
    /**
 * matchRecursiveRegExp
 *
 * (c) 2007 Steven Levithan <stevenlevithan.com>
 * MIT License
 *
 * Accepts a string to search, a left and right format delimiter
 * as regex patterns, and optional regex flags. Returns an array
 * of matches, allowing nested instances of left/right delimiters.
 * Use the "g" flag to return all matches, otherwise only the
 * first is returned. Be careful to ensure that the left and
 * right format delimiters produce mutually exclusive matches.
 * Backreferences are not supported within the right delimiter
 * due to how it is internally combined with the left delimiter.
 * When matching strings whose format delimiters are unbalanced
 * to the left or right, the output is intentionally as a
 * conventional regex library with recursion support would
 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
 * "<" and ">" as the delimiters (both strings contain a single,
 * balanced instance of "<x>").
 *
 * examples:
 * matchRecursiveRegExp("test", "\\(", "\\)")
 * returns: []
 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
 * returns: ["t<<e>><s>", ""]
 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
 * returns: ["test"]
 */ showdown.helper.matchRecursiveRegExp = function(str, left, right, flags) {
        "use strict";
        var matchPos = rgxFindMatchPos(str, left, right, flags), results = [];
        for(var i = 0; i < matchPos.length; ++i)results.push([
            str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
            str.slice(matchPos[i].match.start, matchPos[i].match.end),
            str.slice(matchPos[i].left.start, matchPos[i].left.end),
            str.slice(matchPos[i].right.start, matchPos[i].right.end)
        ]);
        return results;
    };
    /**
 *
 * @param {string} str
 * @param {string|function} replacement
 * @param {string} left
 * @param {string} right
 * @param {string} flags
 * @returns {string}
 */ showdown.helper.replaceRecursiveRegExp = function(str, replacement, left, right, flags) {
        "use strict";
        if (!showdown.helper.isFunction(replacement)) {
            var repStr = replacement;
            replacement = function replacement() {
                return repStr;
            };
        }
        var matchPos = rgxFindMatchPos(str, left, right, flags), finalStr = str, lng = matchPos.length;
        if (lng > 0) {
            var bits = [];
            if (matchPos[0].wholeMatch.start !== 0) bits.push(str.slice(0, matchPos[0].wholeMatch.start));
            for(var i = 0; i < lng; ++i){
                bits.push(replacement(str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end), str.slice(matchPos[i].match.start, matchPos[i].match.end), str.slice(matchPos[i].left.start, matchPos[i].left.end), str.slice(matchPos[i].right.start, matchPos[i].right.end)));
                if (i < lng - 1) bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
            }
            if (matchPos[lng - 1].wholeMatch.end < str.length) bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
            finalStr = bits.join("");
        }
        return finalStr;
    };
    /**
 * Returns the index within the passed String object of the first occurrence of the specified regex,
 * starting the search at fromIndex. Returns -1 if the value is not found.
 *
 * @param {string} str string to search
 * @param {RegExp} regex Regular expression to search
 * @param {int} [fromIndex = 0] Index to start the search
 * @returns {Number}
 * @throws InvalidArgumentError
 */ showdown.helper.regexIndexOf = function(str, regex, fromIndex) {
        "use strict";
        if (!showdown.helper.isString(str)) throw "InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
        if (regex instanceof RegExp === false) throw "InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp";
        var indexOf = str.substring(fromIndex || 0).search(regex);
        return indexOf >= 0 ? indexOf + (fromIndex || 0) : indexOf;
    };
    /**
 * Splits the passed string object at the defined index, and returns an array composed of the two substrings
 * @param {string} str string to split
 * @param {int} index index to split string at
 * @returns {[string,string]}
 * @throws InvalidArgumentError
 */ showdown.helper.splitAtIndex = function(str, index) {
        "use strict";
        if (!showdown.helper.isString(str)) throw "InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
        return [
            str.substring(0, index),
            str.substring(index)
        ];
    };
    /**
 * Obfuscate an e-mail address through the use of Character Entities,
 * transforming ASCII characters into their equivalent decimal or hex entities.
 *
 * Since it has a random component, subsequent calls to this function produce different results
 *
 * @param {string} mail
 * @returns {string}
 */ showdown.helper.encodeEmailAddress = function(mail) {
        "use strict";
        var encode = [
            function(ch) {
                return "&#" + ch.charCodeAt(0) + ";";
            },
            function(ch) {
                return "&#x" + ch.charCodeAt(0).toString(16) + ";";
            },
            function(ch) {
                return ch;
            }
        ];
        mail = mail.replace(/./g, function(ch) {
            if (ch === "@") // this *must* be encoded. I insist.
            ch = encode[Math.floor(Math.random() * 2)](ch);
            else {
                var r = Math.random();
                // roughly 10% raw, 45% hex, 45% dec
                ch = r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch);
            }
            return ch;
        });
        return mail;
    };
    /**
 *
 * @param str
 * @param targetLength
 * @param padString
 * @returns {string}
 */ showdown.helper.padEnd = function padEnd(str, targetLength, padString) {
        "use strict";
        /*jshint bitwise: false*/ // eslint-disable-next-line space-infix-ops
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        /*jshint bitwise: true*/ padString = String(padString || " ");
        if (str.length > targetLength) return String(str);
        else {
            targetLength = targetLength - str.length;
            if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            return String(str) + padString.slice(0, targetLength);
        }
    };
    /**
 * POLYFILLS
 */ // use this instead of builtin is undefined for IE8 compatibility
    if (typeof console === "undefined") console = {
        warn: function warn(msg) {
            "use strict";
            alert(msg);
        },
        log: function log(msg) {
            "use strict";
            alert(msg);
        },
        error: function error(msg) {
            "use strict";
            throw msg;
        }
    };
    /**
 * Common regexes.
 * We declare some common regexes to improve performance
 */ showdown.helper.regexes = {
        asteriskDashAndColon: /([*_:~])/g
    };
    /**
 * EMOJIS LIST
 */ showdown.helper.emojis = {
        "+1": "\ud83d\udc4d",
        "-1": "\ud83d\udc4e",
        "100": "\ud83d\udcaf",
        "1234": "\ud83d\udd22",
        "1st_place_medal": "\ud83e\udd47",
        "2nd_place_medal": "\ud83e\udd48",
        "3rd_place_medal": "\ud83e\udd49",
        "8ball": "\ud83c\udfb1",
        "a": "\ud83c\udd70\uFE0F",
        "ab": "\ud83c\udd8e",
        "abc": "\ud83d\udd24",
        "abcd": "\ud83d\udd21",
        "accept": "\ud83c\ude51",
        "aerial_tramway": "\ud83d\udea1",
        "airplane": "\u2708\uFE0F",
        "alarm_clock": "\u23F0",
        "alembic": "\u2697\uFE0F",
        "alien": "\ud83d\udc7d",
        "ambulance": "\ud83d\ude91",
        "amphora": "\ud83c\udffa",
        "anchor": "\u2693\uFE0F",
        "angel": "\ud83d\udc7c",
        "anger": "\ud83d\udca2",
        "angry": "\ud83d\ude20",
        "anguished": "\ud83d\ude27",
        "ant": "\ud83d\udc1c",
        "apple": "\ud83c\udf4e",
        "aquarius": "\u2652\uFE0F",
        "aries": "\u2648\uFE0F",
        "arrow_backward": "\u25C0\uFE0F",
        "arrow_double_down": "\u23EC",
        "arrow_double_up": "\u23EB",
        "arrow_down": "\u2B07\uFE0F",
        "arrow_down_small": "\ud83d\udd3d",
        "arrow_forward": "\u25B6\uFE0F",
        "arrow_heading_down": "\u2935\uFE0F",
        "arrow_heading_up": "\u2934\uFE0F",
        "arrow_left": "\u2B05\uFE0F",
        "arrow_lower_left": "\u2199\uFE0F",
        "arrow_lower_right": "\u2198\uFE0F",
        "arrow_right": "\u27A1\uFE0F",
        "arrow_right_hook": "\u21AA\uFE0F",
        "arrow_up": "\u2B06\uFE0F",
        "arrow_up_down": "\u2195\uFE0F",
        "arrow_up_small": "\ud83d\udd3c",
        "arrow_upper_left": "\u2196\uFE0F",
        "arrow_upper_right": "\u2197\uFE0F",
        "arrows_clockwise": "\ud83d\udd03",
        "arrows_counterclockwise": "\ud83d\udd04",
        "art": "\ud83c\udfa8",
        "articulated_lorry": "\ud83d\ude9b",
        "artificial_satellite": "\ud83d\udef0",
        "astonished": "\ud83d\ude32",
        "athletic_shoe": "\ud83d\udc5f",
        "atm": "\ud83c\udfe7",
        "atom_symbol": "\u269B\uFE0F",
        "avocado": "\ud83e\udd51",
        "b": "\ud83c\udd71\uFE0F",
        "baby": "\ud83d\udc76",
        "baby_bottle": "\ud83c\udf7c",
        "baby_chick": "\ud83d\udc24",
        "baby_symbol": "\ud83d\udebc",
        "back": "\ud83d\udd19",
        "bacon": "\ud83e\udd53",
        "badminton": "\ud83c\udff8",
        "baggage_claim": "\ud83d\udec4",
        "baguette_bread": "\ud83e\udd56",
        "balance_scale": "\u2696\uFE0F",
        "balloon": "\ud83c\udf88",
        "ballot_box": "\ud83d\uddf3",
        "ballot_box_with_check": "\u2611\uFE0F",
        "bamboo": "\ud83c\udf8d",
        "banana": "\ud83c\udf4c",
        "bangbang": "\u203C\uFE0F",
        "bank": "\ud83c\udfe6",
        "bar_chart": "\ud83d\udcca",
        "barber": "\ud83d\udc88",
        "baseball": "\u26BE\uFE0F",
        "basketball": "\ud83c\udfc0",
        "basketball_man": "\u26F9\uFE0F",
        "basketball_woman": "\u26F9\uFE0F&zwj;\u2640\uFE0F",
        "bat": "\ud83e\udd87",
        "bath": "\ud83d\udec0",
        "bathtub": "\ud83d\udec1",
        "battery": "\ud83d\udd0b",
        "beach_umbrella": "\ud83c\udfd6",
        "bear": "\ud83d\udc3b",
        "bed": "\ud83d\udecf",
        "bee": "\ud83d\udc1d",
        "beer": "\ud83c\udf7a",
        "beers": "\ud83c\udf7b",
        "beetle": "\ud83d\udc1e",
        "beginner": "\ud83d\udd30",
        "bell": "\ud83d\udd14",
        "bellhop_bell": "\ud83d\udece",
        "bento": "\ud83c\udf71",
        "biking_man": "\ud83d\udeb4",
        "bike": "\ud83d\udeb2",
        "biking_woman": "\ud83d\udeb4&zwj;\u2640\uFE0F",
        "bikini": "\ud83d\udc59",
        "biohazard": "\u2623\uFE0F",
        "bird": "\ud83d\udc26",
        "birthday": "\ud83c\udf82",
        "black_circle": "\u26AB\uFE0F",
        "black_flag": "\ud83c\udff4",
        "black_heart": "\ud83d\udda4",
        "black_joker": "\ud83c\udccf",
        "black_large_square": "\u2B1B\uFE0F",
        "black_medium_small_square": "\u25FE\uFE0F",
        "black_medium_square": "\u25FC\uFE0F",
        "black_nib": "\u2712\uFE0F",
        "black_small_square": "\u25AA\uFE0F",
        "black_square_button": "\ud83d\udd32",
        "blonde_man": "\ud83d\udc71",
        "blonde_woman": "\ud83d\udc71&zwj;\u2640\uFE0F",
        "blossom": "\ud83c\udf3c",
        "blowfish": "\ud83d\udc21",
        "blue_book": "\ud83d\udcd8",
        "blue_car": "\ud83d\ude99",
        "blue_heart": "\ud83d\udc99",
        "blush": "\ud83d\ude0a",
        "boar": "\ud83d\udc17",
        "boat": "\u26F5\uFE0F",
        "bomb": "\ud83d\udca3",
        "book": "\ud83d\udcd6",
        "bookmark": "\ud83d\udd16",
        "bookmark_tabs": "\ud83d\udcd1",
        "books": "\ud83d\udcda",
        "boom": "\ud83d\udca5",
        "boot": "\ud83d\udc62",
        "bouquet": "\ud83d\udc90",
        "bowing_man": "\ud83d\ude47",
        "bow_and_arrow": "\ud83c\udff9",
        "bowing_woman": "\ud83d\ude47&zwj;\u2640\uFE0F",
        "bowling": "\ud83c\udfb3",
        "boxing_glove": "\ud83e\udd4a",
        "boy": "\ud83d\udc66",
        "bread": "\ud83c\udf5e",
        "bride_with_veil": "\ud83d\udc70",
        "bridge_at_night": "\ud83c\udf09",
        "briefcase": "\ud83d\udcbc",
        "broken_heart": "\ud83d\udc94",
        "bug": "\ud83d\udc1b",
        "building_construction": "\ud83c\udfd7",
        "bulb": "\ud83d\udca1",
        "bullettrain_front": "\ud83d\ude85",
        "bullettrain_side": "\ud83d\ude84",
        "burrito": "\ud83c\udf2f",
        "bus": "\ud83d\ude8c",
        "business_suit_levitating": "\ud83d\udd74",
        "busstop": "\ud83d\ude8f",
        "bust_in_silhouette": "\ud83d\udc64",
        "busts_in_silhouette": "\ud83d\udc65",
        "butterfly": "\ud83e\udd8b",
        "cactus": "\ud83c\udf35",
        "cake": "\ud83c\udf70",
        "calendar": "\ud83d\udcc6",
        "call_me_hand": "\ud83e\udd19",
        "calling": "\ud83d\udcf2",
        "camel": "\ud83d\udc2b",
        "camera": "\ud83d\udcf7",
        "camera_flash": "\ud83d\udcf8",
        "camping": "\ud83c\udfd5",
        "cancer": "\u264B\uFE0F",
        "candle": "\ud83d\udd6f",
        "candy": "\ud83c\udf6c",
        "canoe": "\ud83d\udef6",
        "capital_abcd": "\ud83d\udd20",
        "capricorn": "\u2651\uFE0F",
        "car": "\ud83d\ude97",
        "card_file_box": "\ud83d\uddc3",
        "card_index": "\ud83d\udcc7",
        "card_index_dividers": "\ud83d\uddc2",
        "carousel_horse": "\ud83c\udfa0",
        "carrot": "\ud83e\udd55",
        "cat": "\ud83d\udc31",
        "cat2": "\ud83d\udc08",
        "cd": "\ud83d\udcbf",
        "chains": "\u26D3",
        "champagne": "\ud83c\udf7e",
        "chart": "\ud83d\udcb9",
        "chart_with_downwards_trend": "\ud83d\udcc9",
        "chart_with_upwards_trend": "\ud83d\udcc8",
        "checkered_flag": "\ud83c\udfc1",
        "cheese": "\ud83e\uddc0",
        "cherries": "\ud83c\udf52",
        "cherry_blossom": "\ud83c\udf38",
        "chestnut": "\ud83c\udf30",
        "chicken": "\ud83d\udc14",
        "children_crossing": "\ud83d\udeb8",
        "chipmunk": "\ud83d\udc3f",
        "chocolate_bar": "\ud83c\udf6b",
        "christmas_tree": "\ud83c\udf84",
        "church": "\u26EA\uFE0F",
        "cinema": "\ud83c\udfa6",
        "circus_tent": "\ud83c\udfaa",
        "city_sunrise": "\ud83c\udf07",
        "city_sunset": "\ud83c\udf06",
        "cityscape": "\ud83c\udfd9",
        "cl": "\ud83c\udd91",
        "clamp": "\ud83d\udddc",
        "clap": "\ud83d\udc4f",
        "clapper": "\ud83c\udfac",
        "classical_building": "\ud83c\udfdb",
        "clinking_glasses": "\ud83e\udd42",
        "clipboard": "\ud83d\udccb",
        "clock1": "\ud83d\udd50",
        "clock10": "\ud83d\udd59",
        "clock1030": "\ud83d\udd65",
        "clock11": "\ud83d\udd5a",
        "clock1130": "\ud83d\udd66",
        "clock12": "\ud83d\udd5b",
        "clock1230": "\ud83d\udd67",
        "clock130": "\ud83d\udd5c",
        "clock2": "\ud83d\udd51",
        "clock230": "\ud83d\udd5d",
        "clock3": "\ud83d\udd52",
        "clock330": "\ud83d\udd5e",
        "clock4": "\ud83d\udd53",
        "clock430": "\ud83d\udd5f",
        "clock5": "\ud83d\udd54",
        "clock530": "\ud83d\udd60",
        "clock6": "\ud83d\udd55",
        "clock630": "\ud83d\udd61",
        "clock7": "\ud83d\udd56",
        "clock730": "\ud83d\udd62",
        "clock8": "\ud83d\udd57",
        "clock830": "\ud83d\udd63",
        "clock9": "\ud83d\udd58",
        "clock930": "\ud83d\udd64",
        "closed_book": "\ud83d\udcd5",
        "closed_lock_with_key": "\ud83d\udd10",
        "closed_umbrella": "\ud83c\udf02",
        "cloud": "\u2601\uFE0F",
        "cloud_with_lightning": "\ud83c\udf29",
        "cloud_with_lightning_and_rain": "\u26C8",
        "cloud_with_rain": "\ud83c\udf27",
        "cloud_with_snow": "\ud83c\udf28",
        "clown_face": "\ud83e\udd21",
        "clubs": "\u2663\uFE0F",
        "cocktail": "\ud83c\udf78",
        "coffee": "\u2615\uFE0F",
        "coffin": "\u26B0\uFE0F",
        "cold_sweat": "\ud83d\ude30",
        "comet": "\u2604\uFE0F",
        "computer": "\ud83d\udcbb",
        "computer_mouse": "\ud83d\uddb1",
        "confetti_ball": "\ud83c\udf8a",
        "confounded": "\ud83d\ude16",
        "confused": "\ud83d\ude15",
        "congratulations": "\u3297\uFE0F",
        "construction": "\ud83d\udea7",
        "construction_worker_man": "\ud83d\udc77",
        "construction_worker_woman": "\ud83d\udc77&zwj;\u2640\uFE0F",
        "control_knobs": "\ud83c\udf9b",
        "convenience_store": "\ud83c\udfea",
        "cookie": "\ud83c\udf6a",
        "cool": "\ud83c\udd92",
        "policeman": "\ud83d\udc6e",
        "copyright": "\xa9\uFE0F",
        "corn": "\ud83c\udf3d",
        "couch_and_lamp": "\ud83d\udecb",
        "couple": "\ud83d\udc6b",
        "couple_with_heart_woman_man": "\ud83d\udc91",
        "couple_with_heart_man_man": "\ud83d\udc68&zwj;\u2764\uFE0F&zwj;\ud83d\udc68",
        "couple_with_heart_woman_woman": "\ud83d\udc69&zwj;\u2764\uFE0F&zwj;\ud83d\udc69",
        "couplekiss_man_man": "\ud83d\udc68&zwj;\u2764\uFE0F&zwj;\ud83d\udc8b&zwj;\ud83d\udc68",
        "couplekiss_man_woman": "\ud83d\udc8f",
        "couplekiss_woman_woman": "\ud83d\udc69&zwj;\u2764\uFE0F&zwj;\ud83d\udc8b&zwj;\ud83d\udc69",
        "cow": "\ud83d\udc2e",
        "cow2": "\ud83d\udc04",
        "cowboy_hat_face": "\ud83e\udd20",
        "crab": "\ud83e\udd80",
        "crayon": "\ud83d\udd8d",
        "credit_card": "\ud83d\udcb3",
        "crescent_moon": "\ud83c\udf19",
        "cricket": "\ud83c\udfcf",
        "crocodile": "\ud83d\udc0a",
        "croissant": "\ud83e\udd50",
        "crossed_fingers": "\ud83e\udd1e",
        "crossed_flags": "\ud83c\udf8c",
        "crossed_swords": "\u2694\uFE0F",
        "crown": "\ud83d\udc51",
        "cry": "\ud83d\ude22",
        "crying_cat_face": "\ud83d\ude3f",
        "crystal_ball": "\ud83d\udd2e",
        "cucumber": "\ud83e\udd52",
        "cupid": "\ud83d\udc98",
        "curly_loop": "\u27B0",
        "currency_exchange": "\ud83d\udcb1",
        "curry": "\ud83c\udf5b",
        "custard": "\ud83c\udf6e",
        "customs": "\ud83d\udec3",
        "cyclone": "\ud83c\udf00",
        "dagger": "\ud83d\udde1",
        "dancer": "\ud83d\udc83",
        "dancing_women": "\ud83d\udc6f",
        "dancing_men": "\ud83d\udc6f&zwj;\u2642\uFE0F",
        "dango": "\ud83c\udf61",
        "dark_sunglasses": "\ud83d\udd76",
        "dart": "\ud83c\udfaf",
        "dash": "\ud83d\udca8",
        "date": "\ud83d\udcc5",
        "deciduous_tree": "\ud83c\udf33",
        "deer": "\ud83e\udd8c",
        "department_store": "\ud83c\udfec",
        "derelict_house": "\ud83c\udfda",
        "desert": "\ud83c\udfdc",
        "desert_island": "\ud83c\udfdd",
        "desktop_computer": "\ud83d\udda5",
        "male_detective": "\ud83d\udd75\uFE0F",
        "diamond_shape_with_a_dot_inside": "\ud83d\udca0",
        "diamonds": "\u2666\uFE0F",
        "disappointed": "\ud83d\ude1e",
        "disappointed_relieved": "\ud83d\ude25",
        "dizzy": "\ud83d\udcab",
        "dizzy_face": "\ud83d\ude35",
        "do_not_litter": "\ud83d\udeaf",
        "dog": "\ud83d\udc36",
        "dog2": "\ud83d\udc15",
        "dollar": "\ud83d\udcb5",
        "dolls": "\ud83c\udf8e",
        "dolphin": "\ud83d\udc2c",
        "door": "\ud83d\udeaa",
        "doughnut": "\ud83c\udf69",
        "dove": "\ud83d\udd4a",
        "dragon": "\ud83d\udc09",
        "dragon_face": "\ud83d\udc32",
        "dress": "\ud83d\udc57",
        "dromedary_camel": "\ud83d\udc2a",
        "drooling_face": "\ud83e\udd24",
        "droplet": "\ud83d\udca7",
        "drum": "\ud83e\udd41",
        "duck": "\ud83e\udd86",
        "dvd": "\ud83d\udcc0",
        "e-mail": "\ud83d\udce7",
        "eagle": "\ud83e\udd85",
        "ear": "\ud83d\udc42",
        "ear_of_rice": "\ud83c\udf3e",
        "earth_africa": "\ud83c\udf0d",
        "earth_americas": "\ud83c\udf0e",
        "earth_asia": "\ud83c\udf0f",
        "egg": "\ud83e\udd5a",
        "eggplant": "\ud83c\udf46",
        "eight_pointed_black_star": "\u2734\uFE0F",
        "eight_spoked_asterisk": "\u2733\uFE0F",
        "electric_plug": "\ud83d\udd0c",
        "elephant": "\ud83d\udc18",
        "email": "\u2709\uFE0F",
        "end": "\ud83d\udd1a",
        "envelope_with_arrow": "\ud83d\udce9",
        "euro": "\ud83d\udcb6",
        "european_castle": "\ud83c\udff0",
        "european_post_office": "\ud83c\udfe4",
        "evergreen_tree": "\ud83c\udf32",
        "exclamation": "\u2757\uFE0F",
        "expressionless": "\ud83d\ude11",
        "eye": "\ud83d\udc41",
        "eye_speech_bubble": "\ud83d\udc41&zwj;\ud83d\udde8",
        "eyeglasses": "\ud83d\udc53",
        "eyes": "\ud83d\udc40",
        "face_with_head_bandage": "\ud83e\udd15",
        "face_with_thermometer": "\ud83e\udd12",
        "fist_oncoming": "\ud83d\udc4a",
        "factory": "\ud83c\udfed",
        "fallen_leaf": "\ud83c\udf42",
        "family_man_woman_boy": "\ud83d\udc6a",
        "family_man_boy": "\ud83d\udc68&zwj;\ud83d\udc66",
        "family_man_boy_boy": "\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_man_girl": "\ud83d\udc68&zwj;\ud83d\udc67",
        "family_man_girl_boy": "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_man_girl_girl": "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_man_man_boy": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66",
        "family_man_man_boy_boy": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_man_man_girl": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67",
        "family_man_man_girl_boy": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_man_man_girl_girl": "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_man_woman_boy_boy": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_man_woman_girl": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
        "family_man_woman_girl_boy": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_man_woman_girl_girl": "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_woman_boy": "\ud83d\udc69&zwj;\ud83d\udc66",
        "family_woman_boy_boy": "\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_woman_girl": "\ud83d\udc69&zwj;\ud83d\udc67",
        "family_woman_girl_boy": "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_woman_girl_girl": "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "family_woman_woman_boy": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66",
        "family_woman_woman_boy_boy": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
        "family_woman_woman_girl": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
        "family_woman_woman_girl_boy": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
        "family_woman_woman_girl_girl": "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
        "fast_forward": "\u23E9",
        "fax": "\ud83d\udce0",
        "fearful": "\ud83d\ude28",
        "feet": "\ud83d\udc3e",
        "female_detective": "\ud83d\udd75\uFE0F&zwj;\u2640\uFE0F",
        "ferris_wheel": "\ud83c\udfa1",
        "ferry": "\u26F4",
        "field_hockey": "\ud83c\udfd1",
        "file_cabinet": "\ud83d\uddc4",
        "file_folder": "\ud83d\udcc1",
        "film_projector": "\ud83d\udcfd",
        "film_strip": "\ud83c\udf9e",
        "fire": "\ud83d\udd25",
        "fire_engine": "\ud83d\ude92",
        "fireworks": "\ud83c\udf86",
        "first_quarter_moon": "\ud83c\udf13",
        "first_quarter_moon_with_face": "\ud83c\udf1b",
        "fish": "\ud83d\udc1f",
        "fish_cake": "\ud83c\udf65",
        "fishing_pole_and_fish": "\ud83c\udfa3",
        "fist_raised": "\u270A",
        "fist_left": "\ud83e\udd1b",
        "fist_right": "\ud83e\udd1c",
        "flags": "\ud83c\udf8f",
        "flashlight": "\ud83d\udd26",
        "fleur_de_lis": "\u269C\uFE0F",
        "flight_arrival": "\ud83d\udeec",
        "flight_departure": "\ud83d\udeeb",
        "floppy_disk": "\ud83d\udcbe",
        "flower_playing_cards": "\ud83c\udfb4",
        "flushed": "\ud83d\ude33",
        "fog": "\ud83c\udf2b",
        "foggy": "\ud83c\udf01",
        "football": "\ud83c\udfc8",
        "footprints": "\ud83d\udc63",
        "fork_and_knife": "\ud83c\udf74",
        "fountain": "\u26F2\uFE0F",
        "fountain_pen": "\ud83d\udd8b",
        "four_leaf_clover": "\ud83c\udf40",
        "fox_face": "\ud83e\udd8a",
        "framed_picture": "\ud83d\uddbc",
        "free": "\ud83c\udd93",
        "fried_egg": "\ud83c\udf73",
        "fried_shrimp": "\ud83c\udf64",
        "fries": "\ud83c\udf5f",
        "frog": "\ud83d\udc38",
        "frowning": "\ud83d\ude26",
        "frowning_face": "\u2639\uFE0F",
        "frowning_man": "\ud83d\ude4d&zwj;\u2642\uFE0F",
        "frowning_woman": "\ud83d\ude4d",
        "middle_finger": "\ud83d\udd95",
        "fuelpump": "\u26FD\uFE0F",
        "full_moon": "\ud83c\udf15",
        "full_moon_with_face": "\ud83c\udf1d",
        "funeral_urn": "\u26B1\uFE0F",
        "game_die": "\ud83c\udfb2",
        "gear": "\u2699\uFE0F",
        "gem": "\ud83d\udc8e",
        "gemini": "\u264A\uFE0F",
        "ghost": "\ud83d\udc7b",
        "gift": "\ud83c\udf81",
        "gift_heart": "\ud83d\udc9d",
        "girl": "\ud83d\udc67",
        "globe_with_meridians": "\ud83c\udf10",
        "goal_net": "\ud83e\udd45",
        "goat": "\ud83d\udc10",
        "golf": "\u26F3\uFE0F",
        "golfing_man": "\ud83c\udfcc\uFE0F",
        "golfing_woman": "\ud83c\udfcc\uFE0F&zwj;\u2640\uFE0F",
        "gorilla": "\ud83e\udd8d",
        "grapes": "\ud83c\udf47",
        "green_apple": "\ud83c\udf4f",
        "green_book": "\ud83d\udcd7",
        "green_heart": "\ud83d\udc9a",
        "green_salad": "\ud83e\udd57",
        "grey_exclamation": "\u2755",
        "grey_question": "\u2754",
        "grimacing": "\ud83d\ude2c",
        "grin": "\ud83d\ude01",
        "grinning": "\ud83d\ude00",
        "guardsman": "\ud83d\udc82",
        "guardswoman": "\ud83d\udc82&zwj;\u2640\uFE0F",
        "guitar": "\ud83c\udfb8",
        "gun": "\ud83d\udd2b",
        "haircut_woman": "\ud83d\udc87",
        "haircut_man": "\ud83d\udc87&zwj;\u2642\uFE0F",
        "hamburger": "\ud83c\udf54",
        "hammer": "\ud83d\udd28",
        "hammer_and_pick": "\u2692",
        "hammer_and_wrench": "\ud83d\udee0",
        "hamster": "\ud83d\udc39",
        "hand": "\u270B",
        "handbag": "\ud83d\udc5c",
        "handshake": "\ud83e\udd1d",
        "hankey": "\ud83d\udca9",
        "hatched_chick": "\ud83d\udc25",
        "hatching_chick": "\ud83d\udc23",
        "headphones": "\ud83c\udfa7",
        "hear_no_evil": "\ud83d\ude49",
        "heart": "\u2764\uFE0F",
        "heart_decoration": "\ud83d\udc9f",
        "heart_eyes": "\ud83d\ude0d",
        "heart_eyes_cat": "\ud83d\ude3b",
        "heartbeat": "\ud83d\udc93",
        "heartpulse": "\ud83d\udc97",
        "hearts": "\u2665\uFE0F",
        "heavy_check_mark": "\u2714\uFE0F",
        "heavy_division_sign": "\u2797",
        "heavy_dollar_sign": "\ud83d\udcb2",
        "heavy_heart_exclamation": "\u2763\uFE0F",
        "heavy_minus_sign": "\u2796",
        "heavy_multiplication_x": "\u2716\uFE0F",
        "heavy_plus_sign": "\u2795",
        "helicopter": "\ud83d\ude81",
        "herb": "\ud83c\udf3f",
        "hibiscus": "\ud83c\udf3a",
        "high_brightness": "\ud83d\udd06",
        "high_heel": "\ud83d\udc60",
        "hocho": "\ud83d\udd2a",
        "hole": "\ud83d\udd73",
        "honey_pot": "\ud83c\udf6f",
        "horse": "\ud83d\udc34",
        "horse_racing": "\ud83c\udfc7",
        "hospital": "\ud83c\udfe5",
        "hot_pepper": "\ud83c\udf36",
        "hotdog": "\ud83c\udf2d",
        "hotel": "\ud83c\udfe8",
        "hotsprings": "\u2668\uFE0F",
        "hourglass": "\u231B\uFE0F",
        "hourglass_flowing_sand": "\u23F3",
        "house": "\ud83c\udfe0",
        "house_with_garden": "\ud83c\udfe1",
        "houses": "\ud83c\udfd8",
        "hugs": "\ud83e\udd17",
        "hushed": "\ud83d\ude2f",
        "ice_cream": "\ud83c\udf68",
        "ice_hockey": "\ud83c\udfd2",
        "ice_skate": "\u26F8",
        "icecream": "\ud83c\udf66",
        "id": "\ud83c\udd94",
        "ideograph_advantage": "\ud83c\ude50",
        "imp": "\ud83d\udc7f",
        "inbox_tray": "\ud83d\udce5",
        "incoming_envelope": "\ud83d\udce8",
        "tipping_hand_woman": "\ud83d\udc81",
        "information_source": "\u2139\uFE0F",
        "innocent": "\ud83d\ude07",
        "interrobang": "\u2049\uFE0F",
        "iphone": "\ud83d\udcf1",
        "izakaya_lantern": "\ud83c\udfee",
        "jack_o_lantern": "\ud83c\udf83",
        "japan": "\ud83d\uddfe",
        "japanese_castle": "\ud83c\udfef",
        "japanese_goblin": "\ud83d\udc7a",
        "japanese_ogre": "\ud83d\udc79",
        "jeans": "\ud83d\udc56",
        "joy": "\ud83d\ude02",
        "joy_cat": "\ud83d\ude39",
        "joystick": "\ud83d\udd79",
        "kaaba": "\ud83d\udd4b",
        "key": "\ud83d\udd11",
        "keyboard": "\u2328\uFE0F",
        "keycap_ten": "\ud83d\udd1f",
        "kick_scooter": "\ud83d\udef4",
        "kimono": "\ud83d\udc58",
        "kiss": "\ud83d\udc8b",
        "kissing": "\ud83d\ude17",
        "kissing_cat": "\ud83d\ude3d",
        "kissing_closed_eyes": "\ud83d\ude1a",
        "kissing_heart": "\ud83d\ude18",
        "kissing_smiling_eyes": "\ud83d\ude19",
        "kiwi_fruit": "\ud83e\udd5d",
        "koala": "\ud83d\udc28",
        "koko": "\ud83c\ude01",
        "label": "\ud83c\udff7",
        "large_blue_circle": "\ud83d\udd35",
        "large_blue_diamond": "\ud83d\udd37",
        "large_orange_diamond": "\ud83d\udd36",
        "last_quarter_moon": "\ud83c\udf17",
        "last_quarter_moon_with_face": "\ud83c\udf1c",
        "latin_cross": "\u271D\uFE0F",
        "laughing": "\ud83d\ude06",
        "leaves": "\ud83c\udf43",
        "ledger": "\ud83d\udcd2",
        "left_luggage": "\ud83d\udec5",
        "left_right_arrow": "\u2194\uFE0F",
        "leftwards_arrow_with_hook": "\u21A9\uFE0F",
        "lemon": "\ud83c\udf4b",
        "leo": "\u264C\uFE0F",
        "leopard": "\ud83d\udc06",
        "level_slider": "\ud83c\udf9a",
        "libra": "\u264E\uFE0F",
        "light_rail": "\ud83d\ude88",
        "link": "\ud83d\udd17",
        "lion": "\ud83e\udd81",
        "lips": "\ud83d\udc44",
        "lipstick": "\ud83d\udc84",
        "lizard": "\ud83e\udd8e",
        "lock": "\ud83d\udd12",
        "lock_with_ink_pen": "\ud83d\udd0f",
        "lollipop": "\ud83c\udf6d",
        "loop": "\u27BF",
        "loud_sound": "\ud83d\udd0a",
        "loudspeaker": "\ud83d\udce2",
        "love_hotel": "\ud83c\udfe9",
        "love_letter": "\ud83d\udc8c",
        "low_brightness": "\ud83d\udd05",
        "lying_face": "\ud83e\udd25",
        "m": "\u24C2\uFE0F",
        "mag": "\ud83d\udd0d",
        "mag_right": "\ud83d\udd0e",
        "mahjong": "\ud83c\udc04\uFE0F",
        "mailbox": "\ud83d\udceb",
        "mailbox_closed": "\ud83d\udcea",
        "mailbox_with_mail": "\ud83d\udcec",
        "mailbox_with_no_mail": "\ud83d\udced",
        "man": "\ud83d\udc68",
        "man_artist": "\ud83d\udc68&zwj;\ud83c\udfa8",
        "man_astronaut": "\ud83d\udc68&zwj;\ud83d\ude80",
        "man_cartwheeling": "\ud83e\udd38&zwj;\u2642\uFE0F",
        "man_cook": "\ud83d\udc68&zwj;\ud83c\udf73",
        "man_dancing": "\ud83d\udd7a",
        "man_facepalming": "\ud83e\udd26&zwj;\u2642\uFE0F",
        "man_factory_worker": "\ud83d\udc68&zwj;\ud83c\udfed",
        "man_farmer": "\ud83d\udc68&zwj;\ud83c\udf3e",
        "man_firefighter": "\ud83d\udc68&zwj;\ud83d\ude92",
        "man_health_worker": "\ud83d\udc68&zwj;\u2695\uFE0F",
        "man_in_tuxedo": "\ud83e\udd35",
        "man_judge": "\ud83d\udc68&zwj;\u2696\uFE0F",
        "man_juggling": "\ud83e\udd39&zwj;\u2642\uFE0F",
        "man_mechanic": "\ud83d\udc68&zwj;\ud83d\udd27",
        "man_office_worker": "\ud83d\udc68&zwj;\ud83d\udcbc",
        "man_pilot": "\ud83d\udc68&zwj;\u2708\uFE0F",
        "man_playing_handball": "\ud83e\udd3e&zwj;\u2642\uFE0F",
        "man_playing_water_polo": "\ud83e\udd3d&zwj;\u2642\uFE0F",
        "man_scientist": "\ud83d\udc68&zwj;\ud83d\udd2c",
        "man_shrugging": "\ud83e\udd37&zwj;\u2642\uFE0F",
        "man_singer": "\ud83d\udc68&zwj;\ud83c\udfa4",
        "man_student": "\ud83d\udc68&zwj;\ud83c\udf93",
        "man_teacher": "\ud83d\udc68&zwj;\ud83c\udfeb",
        "man_technologist": "\ud83d\udc68&zwj;\ud83d\udcbb",
        "man_with_gua_pi_mao": "\ud83d\udc72",
        "man_with_turban": "\ud83d\udc73",
        "tangerine": "\ud83c\udf4a",
        "mans_shoe": "\ud83d\udc5e",
        "mantelpiece_clock": "\ud83d\udd70",
        "maple_leaf": "\ud83c\udf41",
        "martial_arts_uniform": "\ud83e\udd4b",
        "mask": "\ud83d\ude37",
        "massage_woman": "\ud83d\udc86",
        "massage_man": "\ud83d\udc86&zwj;\u2642\uFE0F",
        "meat_on_bone": "\ud83c\udf56",
        "medal_military": "\ud83c\udf96",
        "medal_sports": "\ud83c\udfc5",
        "mega": "\ud83d\udce3",
        "melon": "\ud83c\udf48",
        "memo": "\ud83d\udcdd",
        "men_wrestling": "\ud83e\udd3c&zwj;\u2642\uFE0F",
        "menorah": "\ud83d\udd4e",
        "mens": "\ud83d\udeb9",
        "metal": "\ud83e\udd18",
        "metro": "\ud83d\ude87",
        "microphone": "\ud83c\udfa4",
        "microscope": "\ud83d\udd2c",
        "milk_glass": "\ud83e\udd5b",
        "milky_way": "\ud83c\udf0c",
        "minibus": "\ud83d\ude90",
        "minidisc": "\ud83d\udcbd",
        "mobile_phone_off": "\ud83d\udcf4",
        "money_mouth_face": "\ud83e\udd11",
        "money_with_wings": "\ud83d\udcb8",
        "moneybag": "\ud83d\udcb0",
        "monkey": "\ud83d\udc12",
        "monkey_face": "\ud83d\udc35",
        "monorail": "\ud83d\ude9d",
        "moon": "\ud83c\udf14",
        "mortar_board": "\ud83c\udf93",
        "mosque": "\ud83d\udd4c",
        "motor_boat": "\ud83d\udee5",
        "motor_scooter": "\ud83d\udef5",
        "motorcycle": "\ud83c\udfcd",
        "motorway": "\ud83d\udee3",
        "mount_fuji": "\ud83d\uddfb",
        "mountain": "\u26F0",
        "mountain_biking_man": "\ud83d\udeb5",
        "mountain_biking_woman": "\ud83d\udeb5&zwj;\u2640\uFE0F",
        "mountain_cableway": "\ud83d\udea0",
        "mountain_railway": "\ud83d\ude9e",
        "mountain_snow": "\ud83c\udfd4",
        "mouse": "\ud83d\udc2d",
        "mouse2": "\ud83d\udc01",
        "movie_camera": "\ud83c\udfa5",
        "moyai": "\ud83d\uddff",
        "mrs_claus": "\ud83e\udd36",
        "muscle": "\ud83d\udcaa",
        "mushroom": "\ud83c\udf44",
        "musical_keyboard": "\ud83c\udfb9",
        "musical_note": "\ud83c\udfb5",
        "musical_score": "\ud83c\udfbc",
        "mute": "\ud83d\udd07",
        "nail_care": "\ud83d\udc85",
        "name_badge": "\ud83d\udcdb",
        "national_park": "\ud83c\udfde",
        "nauseated_face": "\ud83e\udd22",
        "necktie": "\ud83d\udc54",
        "negative_squared_cross_mark": "\u274E",
        "nerd_face": "\ud83e\udd13",
        "neutral_face": "\ud83d\ude10",
        "new": "\ud83c\udd95",
        "new_moon": "\ud83c\udf11",
        "new_moon_with_face": "\ud83c\udf1a",
        "newspaper": "\ud83d\udcf0",
        "newspaper_roll": "\ud83d\uddde",
        "next_track_button": "\u23ED",
        "ng": "\ud83c\udd96",
        "no_good_man": "\ud83d\ude45&zwj;\u2642\uFE0F",
        "no_good_woman": "\ud83d\ude45",
        "night_with_stars": "\ud83c\udf03",
        "no_bell": "\ud83d\udd15",
        "no_bicycles": "\ud83d\udeb3",
        "no_entry": "\u26D4\uFE0F",
        "no_entry_sign": "\ud83d\udeab",
        "no_mobile_phones": "\ud83d\udcf5",
        "no_mouth": "\ud83d\ude36",
        "no_pedestrians": "\ud83d\udeb7",
        "no_smoking": "\ud83d\udead",
        "non-potable_water": "\ud83d\udeb1",
        "nose": "\ud83d\udc43",
        "notebook": "\ud83d\udcd3",
        "notebook_with_decorative_cover": "\ud83d\udcd4",
        "notes": "\ud83c\udfb6",
        "nut_and_bolt": "\ud83d\udd29",
        "o": "\u2B55\uFE0F",
        "o2": "\ud83c\udd7e\uFE0F",
        "ocean": "\ud83c\udf0a",
        "octopus": "\ud83d\udc19",
        "oden": "\ud83c\udf62",
        "office": "\ud83c\udfe2",
        "oil_drum": "\ud83d\udee2",
        "ok": "\ud83c\udd97",
        "ok_hand": "\ud83d\udc4c",
        "ok_man": "\ud83d\ude46&zwj;\u2642\uFE0F",
        "ok_woman": "\ud83d\ude46",
        "old_key": "\ud83d\udddd",
        "older_man": "\ud83d\udc74",
        "older_woman": "\ud83d\udc75",
        "om": "\ud83d\udd49",
        "on": "\ud83d\udd1b",
        "oncoming_automobile": "\ud83d\ude98",
        "oncoming_bus": "\ud83d\ude8d",
        "oncoming_police_car": "\ud83d\ude94",
        "oncoming_taxi": "\ud83d\ude96",
        "open_file_folder": "\ud83d\udcc2",
        "open_hands": "\ud83d\udc50",
        "open_mouth": "\ud83d\ude2e",
        "open_umbrella": "\u2602\uFE0F",
        "ophiuchus": "\u26CE",
        "orange_book": "\ud83d\udcd9",
        "orthodox_cross": "\u2626\uFE0F",
        "outbox_tray": "\ud83d\udce4",
        "owl": "\ud83e\udd89",
        "ox": "\ud83d\udc02",
        "package": "\ud83d\udce6",
        "page_facing_up": "\ud83d\udcc4",
        "page_with_curl": "\ud83d\udcc3",
        "pager": "\ud83d\udcdf",
        "paintbrush": "\ud83d\udd8c",
        "palm_tree": "\ud83c\udf34",
        "pancakes": "\ud83e\udd5e",
        "panda_face": "\ud83d\udc3c",
        "paperclip": "\ud83d\udcce",
        "paperclips": "\ud83d\udd87",
        "parasol_on_ground": "\u26F1",
        "parking": "\ud83c\udd7f\uFE0F",
        "part_alternation_mark": "\u303D\uFE0F",
        "partly_sunny": "\u26C5\uFE0F",
        "passenger_ship": "\ud83d\udef3",
        "passport_control": "\ud83d\udec2",
        "pause_button": "\u23F8",
        "peace_symbol": "\u262E\uFE0F",
        "peach": "\ud83c\udf51",
        "peanuts": "\ud83e\udd5c",
        "pear": "\ud83c\udf50",
        "pen": "\ud83d\udd8a",
        "pencil2": "\u270F\uFE0F",
        "penguin": "\ud83d\udc27",
        "pensive": "\ud83d\ude14",
        "performing_arts": "\ud83c\udfad",
        "persevere": "\ud83d\ude23",
        "person_fencing": "\ud83e\udd3a",
        "pouting_woman": "\ud83d\ude4e",
        "phone": "\u260E\uFE0F",
        "pick": "\u26CF",
        "pig": "\ud83d\udc37",
        "pig2": "\ud83d\udc16",
        "pig_nose": "\ud83d\udc3d",
        "pill": "\ud83d\udc8a",
        "pineapple": "\ud83c\udf4d",
        "ping_pong": "\ud83c\udfd3",
        "pisces": "\u2653\uFE0F",
        "pizza": "\ud83c\udf55",
        "place_of_worship": "\ud83d\uded0",
        "plate_with_cutlery": "\ud83c\udf7d",
        "play_or_pause_button": "\u23EF",
        "point_down": "\ud83d\udc47",
        "point_left": "\ud83d\udc48",
        "point_right": "\ud83d\udc49",
        "point_up": "\u261D\uFE0F",
        "point_up_2": "\ud83d\udc46",
        "police_car": "\ud83d\ude93",
        "policewoman": "\ud83d\udc6e&zwj;\u2640\uFE0F",
        "poodle": "\ud83d\udc29",
        "popcorn": "\ud83c\udf7f",
        "post_office": "\ud83c\udfe3",
        "postal_horn": "\ud83d\udcef",
        "postbox": "\ud83d\udcee",
        "potable_water": "\ud83d\udeb0",
        "potato": "\ud83e\udd54",
        "pouch": "\ud83d\udc5d",
        "poultry_leg": "\ud83c\udf57",
        "pound": "\ud83d\udcb7",
        "rage": "\ud83d\ude21",
        "pouting_cat": "\ud83d\ude3e",
        "pouting_man": "\ud83d\ude4e&zwj;\u2642\uFE0F",
        "pray": "\ud83d\ude4f",
        "prayer_beads": "\ud83d\udcff",
        "pregnant_woman": "\ud83e\udd30",
        "previous_track_button": "\u23EE",
        "prince": "\ud83e\udd34",
        "princess": "\ud83d\udc78",
        "printer": "\ud83d\udda8",
        "purple_heart": "\ud83d\udc9c",
        "purse": "\ud83d\udc5b",
        "pushpin": "\ud83d\udccc",
        "put_litter_in_its_place": "\ud83d\udeae",
        "question": "\u2753",
        "rabbit": "\ud83d\udc30",
        "rabbit2": "\ud83d\udc07",
        "racehorse": "\ud83d\udc0e",
        "racing_car": "\ud83c\udfce",
        "radio": "\ud83d\udcfb",
        "radio_button": "\ud83d\udd18",
        "radioactive": "\u2622\uFE0F",
        "railway_car": "\ud83d\ude83",
        "railway_track": "\ud83d\udee4",
        "rainbow": "\ud83c\udf08",
        "rainbow_flag": "\ud83c\udff3\uFE0F&zwj;\ud83c\udf08",
        "raised_back_of_hand": "\ud83e\udd1a",
        "raised_hand_with_fingers_splayed": "\ud83d\udd90",
        "raised_hands": "\ud83d\ude4c",
        "raising_hand_woman": "\ud83d\ude4b",
        "raising_hand_man": "\ud83d\ude4b&zwj;\u2642\uFE0F",
        "ram": "\ud83d\udc0f",
        "ramen": "\ud83c\udf5c",
        "rat": "\ud83d\udc00",
        "record_button": "\u23FA",
        "recycle": "\u267B\uFE0F",
        "red_circle": "\ud83d\udd34",
        "registered": "\xae\uFE0F",
        "relaxed": "\u263A\uFE0F",
        "relieved": "\ud83d\ude0c",
        "reminder_ribbon": "\ud83c\udf97",
        "repeat": "\ud83d\udd01",
        "repeat_one": "\ud83d\udd02",
        "rescue_worker_helmet": "\u26D1",
        "restroom": "\ud83d\udebb",
        "revolving_hearts": "\ud83d\udc9e",
        "rewind": "\u23EA",
        "rhinoceros": "\ud83e\udd8f",
        "ribbon": "\ud83c\udf80",
        "rice": "\ud83c\udf5a",
        "rice_ball": "\ud83c\udf59",
        "rice_cracker": "\ud83c\udf58",
        "rice_scene": "\ud83c\udf91",
        "right_anger_bubble": "\ud83d\uddef",
        "ring": "\ud83d\udc8d",
        "robot": "\ud83e\udd16",
        "rocket": "\ud83d\ude80",
        "rofl": "\ud83e\udd23",
        "roll_eyes": "\ud83d\ude44",
        "roller_coaster": "\ud83c\udfa2",
        "rooster": "\ud83d\udc13",
        "rose": "\ud83c\udf39",
        "rosette": "\ud83c\udff5",
        "rotating_light": "\ud83d\udea8",
        "round_pushpin": "\ud83d\udccd",
        "rowing_man": "\ud83d\udea3",
        "rowing_woman": "\ud83d\udea3&zwj;\u2640\uFE0F",
        "rugby_football": "\ud83c\udfc9",
        "running_man": "\ud83c\udfc3",
        "running_shirt_with_sash": "\ud83c\udfbd",
        "running_woman": "\ud83c\udfc3&zwj;\u2640\uFE0F",
        "sa": "\ud83c\ude02\uFE0F",
        "sagittarius": "\u2650\uFE0F",
        "sake": "\ud83c\udf76",
        "sandal": "\ud83d\udc61",
        "santa": "\ud83c\udf85",
        "satellite": "\ud83d\udce1",
        "saxophone": "\ud83c\udfb7",
        "school": "\ud83c\udfeb",
        "school_satchel": "\ud83c\udf92",
        "scissors": "\u2702\uFE0F",
        "scorpion": "\ud83e\udd82",
        "scorpius": "\u264F\uFE0F",
        "scream": "\ud83d\ude31",
        "scream_cat": "\ud83d\ude40",
        "scroll": "\ud83d\udcdc",
        "seat": "\ud83d\udcba",
        "secret": "\u3299\uFE0F",
        "see_no_evil": "\ud83d\ude48",
        "seedling": "\ud83c\udf31",
        "selfie": "\ud83e\udd33",
        "shallow_pan_of_food": "\ud83e\udd58",
        "shamrock": "\u2618\uFE0F",
        "shark": "\ud83e\udd88",
        "shaved_ice": "\ud83c\udf67",
        "sheep": "\ud83d\udc11",
        "shell": "\ud83d\udc1a",
        "shield": "\ud83d\udee1",
        "shinto_shrine": "\u26E9",
        "ship": "\ud83d\udea2",
        "shirt": "\ud83d\udc55",
        "shopping": "\ud83d\udecd",
        "shopping_cart": "\ud83d\uded2",
        "shower": "\ud83d\udebf",
        "shrimp": "\ud83e\udd90",
        "signal_strength": "\ud83d\udcf6",
        "six_pointed_star": "\ud83d\udd2f",
        "ski": "\ud83c\udfbf",
        "skier": "\u26F7",
        "skull": "\ud83d\udc80",
        "skull_and_crossbones": "\u2620\uFE0F",
        "sleeping": "\ud83d\ude34",
        "sleeping_bed": "\ud83d\udecc",
        "sleepy": "\ud83d\ude2a",
        "slightly_frowning_face": "\ud83d\ude41",
        "slightly_smiling_face": "\ud83d\ude42",
        "slot_machine": "\ud83c\udfb0",
        "small_airplane": "\ud83d\udee9",
        "small_blue_diamond": "\ud83d\udd39",
        "small_orange_diamond": "\ud83d\udd38",
        "small_red_triangle": "\ud83d\udd3a",
        "small_red_triangle_down": "\ud83d\udd3b",
        "smile": "\ud83d\ude04",
        "smile_cat": "\ud83d\ude38",
        "smiley": "\ud83d\ude03",
        "smiley_cat": "\ud83d\ude3a",
        "smiling_imp": "\ud83d\ude08",
        "smirk": "\ud83d\ude0f",
        "smirk_cat": "\ud83d\ude3c",
        "smoking": "\ud83d\udeac",
        "snail": "\ud83d\udc0c",
        "snake": "\ud83d\udc0d",
        "sneezing_face": "\ud83e\udd27",
        "snowboarder": "\ud83c\udfc2",
        "snowflake": "\u2744\uFE0F",
        "snowman": "\u26C4\uFE0F",
        "snowman_with_snow": "\u2603\uFE0F",
        "sob": "\ud83d\ude2d",
        "soccer": "\u26BD\uFE0F",
        "soon": "\ud83d\udd1c",
        "sos": "\ud83c\udd98",
        "sound": "\ud83d\udd09",
        "space_invader": "\ud83d\udc7e",
        "spades": "\u2660\uFE0F",
        "spaghetti": "\ud83c\udf5d",
        "sparkle": "\u2747\uFE0F",
        "sparkler": "\ud83c\udf87",
        "sparkles": "\u2728",
        "sparkling_heart": "\ud83d\udc96",
        "speak_no_evil": "\ud83d\ude4a",
        "speaker": "\ud83d\udd08",
        "speaking_head": "\ud83d\udde3",
        "speech_balloon": "\ud83d\udcac",
        "speedboat": "\ud83d\udea4",
        "spider": "\ud83d\udd77",
        "spider_web": "\ud83d\udd78",
        "spiral_calendar": "\ud83d\uddd3",
        "spiral_notepad": "\ud83d\uddd2",
        "spoon": "\ud83e\udd44",
        "squid": "\ud83e\udd91",
        "stadium": "\ud83c\udfdf",
        "star": "\u2B50\uFE0F",
        "star2": "\ud83c\udf1f",
        "star_and_crescent": "\u262A\uFE0F",
        "star_of_david": "\u2721\uFE0F",
        "stars": "\ud83c\udf20",
        "station": "\ud83d\ude89",
        "statue_of_liberty": "\ud83d\uddfd",
        "steam_locomotive": "\ud83d\ude82",
        "stew": "\ud83c\udf72",
        "stop_button": "\u23F9",
        "stop_sign": "\ud83d\uded1",
        "stopwatch": "\u23F1",
        "straight_ruler": "\ud83d\udccf",
        "strawberry": "\ud83c\udf53",
        "stuck_out_tongue": "\ud83d\ude1b",
        "stuck_out_tongue_closed_eyes": "\ud83d\ude1d",
        "stuck_out_tongue_winking_eye": "\ud83d\ude1c",
        "studio_microphone": "\ud83c\udf99",
        "stuffed_flatbread": "\ud83e\udd59",
        "sun_behind_large_cloud": "\ud83c\udf25",
        "sun_behind_rain_cloud": "\ud83c\udf26",
        "sun_behind_small_cloud": "\ud83c\udf24",
        "sun_with_face": "\ud83c\udf1e",
        "sunflower": "\ud83c\udf3b",
        "sunglasses": "\ud83d\ude0e",
        "sunny": "\u2600\uFE0F",
        "sunrise": "\ud83c\udf05",
        "sunrise_over_mountains": "\ud83c\udf04",
        "surfing_man": "\ud83c\udfc4",
        "surfing_woman": "\ud83c\udfc4&zwj;\u2640\uFE0F",
        "sushi": "\ud83c\udf63",
        "suspension_railway": "\ud83d\ude9f",
        "sweat": "\ud83d\ude13",
        "sweat_drops": "\ud83d\udca6",
        "sweat_smile": "\ud83d\ude05",
        "sweet_potato": "\ud83c\udf60",
        "swimming_man": "\ud83c\udfca",
        "swimming_woman": "\ud83c\udfca&zwj;\u2640\uFE0F",
        "symbols": "\ud83d\udd23",
        "synagogue": "\ud83d\udd4d",
        "syringe": "\ud83d\udc89",
        "taco": "\ud83c\udf2e",
        "tada": "\ud83c\udf89",
        "tanabata_tree": "\ud83c\udf8b",
        "taurus": "\u2649\uFE0F",
        "taxi": "\ud83d\ude95",
        "tea": "\ud83c\udf75",
        "telephone_receiver": "\ud83d\udcde",
        "telescope": "\ud83d\udd2d",
        "tennis": "\ud83c\udfbe",
        "tent": "\u26FA\uFE0F",
        "thermometer": "\ud83c\udf21",
        "thinking": "\ud83e\udd14",
        "thought_balloon": "\ud83d\udcad",
        "ticket": "\ud83c\udfab",
        "tickets": "\ud83c\udf9f",
        "tiger": "\ud83d\udc2f",
        "tiger2": "\ud83d\udc05",
        "timer_clock": "\u23F2",
        "tipping_hand_man": "\ud83d\udc81&zwj;\u2642\uFE0F",
        "tired_face": "\ud83d\ude2b",
        "tm": "\u2122\uFE0F",
        "toilet": "\ud83d\udebd",
        "tokyo_tower": "\ud83d\uddfc",
        "tomato": "\ud83c\udf45",
        "tongue": "\ud83d\udc45",
        "top": "\ud83d\udd1d",
        "tophat": "\ud83c\udfa9",
        "tornado": "\ud83c\udf2a",
        "trackball": "\ud83d\uddb2",
        "tractor": "\ud83d\ude9c",
        "traffic_light": "\ud83d\udea5",
        "train": "\ud83d\ude8b",
        "train2": "\ud83d\ude86",
        "tram": "\ud83d\ude8a",
        "triangular_flag_on_post": "\ud83d\udea9",
        "triangular_ruler": "\ud83d\udcd0",
        "trident": "\ud83d\udd31",
        "triumph": "\ud83d\ude24",
        "trolleybus": "\ud83d\ude8e",
        "trophy": "\ud83c\udfc6",
        "tropical_drink": "\ud83c\udf79",
        "tropical_fish": "\ud83d\udc20",
        "truck": "\ud83d\ude9a",
        "trumpet": "\ud83c\udfba",
        "tulip": "\ud83c\udf37",
        "tumbler_glass": "\ud83e\udd43",
        "turkey": "\ud83e\udd83",
        "turtle": "\ud83d\udc22",
        "tv": "\ud83d\udcfa",
        "twisted_rightwards_arrows": "\ud83d\udd00",
        "two_hearts": "\ud83d\udc95",
        "two_men_holding_hands": "\ud83d\udc6c",
        "two_women_holding_hands": "\ud83d\udc6d",
        "u5272": "\ud83c\ude39",
        "u5408": "\ud83c\ude34",
        "u55b6": "\ud83c\ude3a",
        "u6307": "\ud83c\ude2f\uFE0F",
        "u6708": "\ud83c\ude37\uFE0F",
        "u6709": "\ud83c\ude36",
        "u6e80": "\ud83c\ude35",
        "u7121": "\ud83c\ude1a\uFE0F",
        "u7533": "\ud83c\ude38",
        "u7981": "\ud83c\ude32",
        "u7a7a": "\ud83c\ude33",
        "umbrella": "\u2614\uFE0F",
        "unamused": "\ud83d\ude12",
        "underage": "\ud83d\udd1e",
        "unicorn": "\ud83e\udd84",
        "unlock": "\ud83d\udd13",
        "up": "\ud83c\udd99",
        "upside_down_face": "\ud83d\ude43",
        "v": "\u270C\uFE0F",
        "vertical_traffic_light": "\ud83d\udea6",
        "vhs": "\ud83d\udcfc",
        "vibration_mode": "\ud83d\udcf3",
        "video_camera": "\ud83d\udcf9",
        "video_game": "\ud83c\udfae",
        "violin": "\ud83c\udfbb",
        "virgo": "\u264D\uFE0F",
        "volcano": "\ud83c\udf0b",
        "volleyball": "\ud83c\udfd0",
        "vs": "\ud83c\udd9a",
        "vulcan_salute": "\ud83d\udd96",
        "walking_man": "\ud83d\udeb6",
        "walking_woman": "\ud83d\udeb6&zwj;\u2640\uFE0F",
        "waning_crescent_moon": "\ud83c\udf18",
        "waning_gibbous_moon": "\ud83c\udf16",
        "warning": "\u26A0\uFE0F",
        "wastebasket": "\ud83d\uddd1",
        "watch": "\u231A\uFE0F",
        "water_buffalo": "\ud83d\udc03",
        "watermelon": "\ud83c\udf49",
        "wave": "\ud83d\udc4b",
        "wavy_dash": "\u3030\uFE0F",
        "waxing_crescent_moon": "\ud83c\udf12",
        "wc": "\ud83d\udebe",
        "weary": "\ud83d\ude29",
        "wedding": "\ud83d\udc92",
        "weight_lifting_man": "\ud83c\udfcb\uFE0F",
        "weight_lifting_woman": "\ud83c\udfcb\uFE0F&zwj;\u2640\uFE0F",
        "whale": "\ud83d\udc33",
        "whale2": "\ud83d\udc0b",
        "wheel_of_dharma": "\u2638\uFE0F",
        "wheelchair": "\u267F\uFE0F",
        "white_check_mark": "\u2705",
        "white_circle": "\u26AA\uFE0F",
        "white_flag": "\ud83c\udff3\uFE0F",
        "white_flower": "\ud83d\udcae",
        "white_large_square": "\u2B1C\uFE0F",
        "white_medium_small_square": "\u25FD\uFE0F",
        "white_medium_square": "\u25FB\uFE0F",
        "white_small_square": "\u25AB\uFE0F",
        "white_square_button": "\ud83d\udd33",
        "wilted_flower": "\ud83e\udd40",
        "wind_chime": "\ud83c\udf90",
        "wind_face": "\ud83c\udf2c",
        "wine_glass": "\ud83c\udf77",
        "wink": "\ud83d\ude09",
        "wolf": "\ud83d\udc3a",
        "woman": "\ud83d\udc69",
        "woman_artist": "\ud83d\udc69&zwj;\ud83c\udfa8",
        "woman_astronaut": "\ud83d\udc69&zwj;\ud83d\ude80",
        "woman_cartwheeling": "\ud83e\udd38&zwj;\u2640\uFE0F",
        "woman_cook": "\ud83d\udc69&zwj;\ud83c\udf73",
        "woman_facepalming": "\ud83e\udd26&zwj;\u2640\uFE0F",
        "woman_factory_worker": "\ud83d\udc69&zwj;\ud83c\udfed",
        "woman_farmer": "\ud83d\udc69&zwj;\ud83c\udf3e",
        "woman_firefighter": "\ud83d\udc69&zwj;\ud83d\ude92",
        "woman_health_worker": "\ud83d\udc69&zwj;\u2695\uFE0F",
        "woman_judge": "\ud83d\udc69&zwj;\u2696\uFE0F",
        "woman_juggling": "\ud83e\udd39&zwj;\u2640\uFE0F",
        "woman_mechanic": "\ud83d\udc69&zwj;\ud83d\udd27",
        "woman_office_worker": "\ud83d\udc69&zwj;\ud83d\udcbc",
        "woman_pilot": "\ud83d\udc69&zwj;\u2708\uFE0F",
        "woman_playing_handball": "\ud83e\udd3e&zwj;\u2640\uFE0F",
        "woman_playing_water_polo": "\ud83e\udd3d&zwj;\u2640\uFE0F",
        "woman_scientist": "\ud83d\udc69&zwj;\ud83d\udd2c",
        "woman_shrugging": "\ud83e\udd37&zwj;\u2640\uFE0F",
        "woman_singer": "\ud83d\udc69&zwj;\ud83c\udfa4",
        "woman_student": "\ud83d\udc69&zwj;\ud83c\udf93",
        "woman_teacher": "\ud83d\udc69&zwj;\ud83c\udfeb",
        "woman_technologist": "\ud83d\udc69&zwj;\ud83d\udcbb",
        "woman_with_turban": "\ud83d\udc73&zwj;\u2640\uFE0F",
        "womans_clothes": "\ud83d\udc5a",
        "womans_hat": "\ud83d\udc52",
        "women_wrestling": "\ud83e\udd3c&zwj;\u2640\uFE0F",
        "womens": "\ud83d\udeba",
        "world_map": "\ud83d\uddfa",
        "worried": "\ud83d\ude1f",
        "wrench": "\ud83d\udd27",
        "writing_hand": "\u270D\uFE0F",
        "x": "\u274C",
        "yellow_heart": "\ud83d\udc9b",
        "yen": "\ud83d\udcb4",
        "yin_yang": "\u262F\uFE0F",
        "yum": "\ud83d\ude0b",
        "zap": "\u26A1\uFE0F",
        "zipper_mouth_face": "\ud83e\udd10",
        "zzz": "\ud83d\udca4",
        /* special emojis :P */ "octocat": '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
        "showdown": "<span style=\"font-family: 'Anonymous Pro', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;\">S</span>"
    };
    /**
 * Created by Estevao on 31-05-2015.
 */ /**
 * Showdown Converter class
 * @class
 * @param {object} [converterOptions]
 * @returns {Converter}
 */ showdown.Converter = function(converterOptions) {
        "use strict";
        var /**
       * Options used by this converter
       * @private
       * @type {{}}
       */ options = {}, /**
       * Language extensions used by this converter
       * @private
       * @type {Array}
       */ langExtensions = [], /**
       * Output modifiers extensions used by this converter
       * @private
       * @type {Array}
       */ outputModifiers = [], /**
       * Event listeners
       * @private
       * @type {{}}
       */ listeners = {}, /**
       * The flavor set in this converter
       */ setConvFlavor = setFlavor, /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */ metadata = {
            parsed: {},
            raw: "",
            format: ""
        };
        _constructor();
        /**
   * Converter constructor
   * @private
   */ function _constructor() {
            converterOptions = converterOptions || {};
            for(var gOpt in globalOptions)if (globalOptions.hasOwnProperty(gOpt)) options[gOpt] = globalOptions[gOpt];
            // Merge options
            if (typeof converterOptions === "object") {
                for(var opt in converterOptions)if (converterOptions.hasOwnProperty(opt)) options[opt] = converterOptions[opt];
            } else throw Error("Converter expects the passed parameter to be an object, but " + typeof converterOptions + " was passed instead.");
            if (options.extensions) showdown.helper.forEach(options.extensions, _parseExtension);
        }
        /**
   * Parse extension
   * @param {*} ext
   * @param {string} [name='']
   * @private
   */ function _parseExtension(ext, name) {
            name = name || null;
            // If it's a string, the extension was previously loaded
            if (showdown.helper.isString(ext)) {
                ext = showdown.helper.stdExtName(ext);
                name = ext;
                // LEGACY_SUPPORT CODE
                if (showdown.extensions[ext]) {
                    console.warn("DEPRECATION WARNING: " + ext + " is an old extension that uses a deprecated loading method." + "Please inform the developer that the extension should be updated!");
                    legacyExtensionLoading(showdown.extensions[ext], ext);
                    return;
                // END LEGACY SUPPORT CODE
                } else if (!showdown.helper.isUndefined(extensions[ext])) ext = extensions[ext];
                else throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
            }
            if (typeof ext === "function") ext = ext();
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var validExt = validate(ext, name);
            if (!validExt.valid) throw Error(validExt.error);
            for(var i = 0; i < ext.length; ++i){
                switch(ext[i].type){
                    case "lang":
                        langExtensions.push(ext[i]);
                        break;
                    case "output":
                        outputModifiers.push(ext[i]);
                        break;
                }
                if (ext[i].hasOwnProperty("listeners")) {
                    for(var ln in ext[i].listeners)if (ext[i].listeners.hasOwnProperty(ln)) listen(ln, ext[i].listeners[ln]);
                }
            }
        }
        /**
   * LEGACY_SUPPORT
   * @param {*} ext
   * @param {string} name
   */ function legacyExtensionLoading(ext, name) {
            if (typeof ext === "function") ext = ext(new showdown.Converter());
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var valid = validate(ext, name);
            if (!valid.valid) throw Error(valid.error);
            for(var i = 0; i < ext.length; ++i)switch(ext[i].type){
                case "lang":
                    langExtensions.push(ext[i]);
                    break;
                case "output":
                    outputModifiers.push(ext[i]);
                    break;
                default:
                    throw Error("Extension loader error: Type unrecognized!!!");
            }
        }
        /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   */ function listen(name, callback) {
            if (!showdown.helper.isString(name)) throw Error("Invalid argument in converter.listen() method: name must be a string, but " + typeof name + " given");
            if (typeof callback !== "function") throw Error("Invalid argument in converter.listen() method: callback must be a function, but " + typeof callback + " given");
            if (!listeners.hasOwnProperty(name)) listeners[name] = [];
            listeners[name].push(callback);
        }
        function rTrimInputText(text) {
            var rsp = text.match(/^\s*/)[0].length, rgx = new RegExp("^\\s{0," + rsp + "}", "gm");
            return text.replace(rgx, "");
        }
        /**
   * Dispatch an event
   * @private
   * @param {string} evtName Event name
   * @param {string} text Text
   * @param {{}} options Converter Options
   * @param {{}} globals
   * @returns {string}
   */ this._dispatch = function dispatch(evtName, text, options, globals) {
            if (listeners.hasOwnProperty(evtName)) for(var ei = 0; ei < listeners[evtName].length; ++ei){
                var nText = listeners[evtName][ei](evtName, text, this, options, globals);
                if (nText && typeof nText !== "undefined") text = nText;
            }
            return text;
        };
        /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   * @returns {showdown.Converter}
   */ this.listen = function(name, callback) {
            listen(name, callback);
            return this;
        };
        /**
   * Converts a markdown string into HTML
   * @param {string} text
   * @returns {*}
   */ this.makeHtml = function(text) {
            //check if text is not falsy
            if (!text) return text;
            var globals = {
                gHtmlBlocks: [],
                gHtmlMdBlocks: [],
                gHtmlSpans: [],
                gUrls: {},
                gTitles: {},
                gDimensions: {},
                gListLevel: 0,
                hashLinkCounts: {},
                langExtensions: langExtensions,
                outputModifiers: outputModifiers,
                converter: this,
                ghCodeBlocks: [],
                metadata: {
                    parsed: {},
                    raw: "",
                    format: ""
                }
            };
            // This lets us use ¨ trema as an escape char to avoid md5 hashes
            // The choice of character is arbitrary; anything that isn't
            // magic in Markdown will work.
            text = text.replace(/¨/g, "\xa8T");
            // Replace $ with ¨D
            // RegExp interprets $ as a special character
            // when it's in a replacement string
            text = text.replace(/\$/g, "\xa8D");
            // Standardize line endings
            text = text.replace(/\r\n/g, "\n"); // DOS to Unix
            text = text.replace(/\r/g, "\n"); // Mac to Unix
            // Stardardize line spaces
            text = text.replace(/\u00A0/g, "&nbsp;");
            if (options.smartIndentationFix) text = rTrimInputText(text);
            // Make sure text begins and ends with a couple of newlines:
            text = "\n\n" + text + "\n\n";
            // detab
            text = showdown.subParser("detab")(text, options, globals);
            /**
     * Strip any lines consisting only of spaces and tabs.
     * This makes subsequent regexs easier to write, because we can
     * match consecutive blank lines with /\n+/ instead of something
     * contorted like /[ \t]*\n+/
     */ text = text.replace(/^[ \t]+$/mg, "");
            //run languageExtensions
            showdown.helper.forEach(langExtensions, function(ext) {
                text = showdown.subParser("runExtension")(ext, text, options, globals);
            });
            // run the sub parsers
            text = showdown.subParser("metadata")(text, options, globals);
            text = showdown.subParser("hashPreCodeTags")(text, options, globals);
            text = showdown.subParser("githubCodeBlocks")(text, options, globals);
            text = showdown.subParser("hashHTMLBlocks")(text, options, globals);
            text = showdown.subParser("hashCodeTags")(text, options, globals);
            text = showdown.subParser("stripLinkDefinitions")(text, options, globals);
            text = showdown.subParser("blockGamut")(text, options, globals);
            text = showdown.subParser("unhashHTMLSpans")(text, options, globals);
            text = showdown.subParser("unescapeSpecialChars")(text, options, globals);
            // attacklab: Restore dollar signs
            text = text.replace(/¨D/g, "$$");
            // attacklab: Restore tremas
            text = text.replace(/¨T/g, "\xa8");
            // render a complete html document instead of a partial if the option is enabled
            text = showdown.subParser("completeHTMLDocument")(text, options, globals);
            // Run output modifiers
            showdown.helper.forEach(outputModifiers, function(ext) {
                text = showdown.subParser("runExtension")(ext, text, options, globals);
            });
            // update metadata
            metadata = globals.metadata;
            return text;
        };
        /**
   * Converts an HTML string into a markdown string
   * @param src
   * @param [HTMLParser] A WHATWG DOM and HTML parser, such as JSDOM. If none is supplied, window.document will be used.
   * @returns {string}
   */ this.makeMarkdown = this.makeMd = function(src, HTMLParser) {
            // replace \r\n with \n
            src = src.replace(/\r\n/g, "\n");
            src = src.replace(/\r/g, "\n"); // old macs
            // due to an edge case, we need to find this: > <
            // to prevent removing of non silent white spaces
            // ex: <em>this is</em> <strong>sparta</strong>
            src = src.replace(/>[ \t]+</, ">\xa8NBSP;<");
            if (!HTMLParser) {
                if (window && window.document) HTMLParser = window.document;
                else throw new Error("HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM");
            }
            var doc = HTMLParser.createElement("div");
            doc.innerHTML = src;
            var globals = {
                preList: substitutePreCodeTags(doc)
            };
            // remove all newlines and collapse spaces
            clean(doc);
            // some stuff, like accidental reference links must now be escaped
            // TODO
            // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);
            var nodes = doc.childNodes, mdDoc = "";
            for(var i = 0; i < nodes.length; i++)mdDoc += showdown.subParser("makeMarkdown.node")(nodes[i], globals);
            function clean(node) {
                for(var n = 0; n < node.childNodes.length; ++n){
                    var child = node.childNodes[n];
                    if (child.nodeType === 3) {
                        if (!/\S/.test(child.nodeValue) && !/^[ ]+$/.test(child.nodeValue)) {
                            node.removeChild(child);
                            --n;
                        } else {
                            child.nodeValue = child.nodeValue.split("\n").join(" ");
                            child.nodeValue = child.nodeValue.replace(/(\s)+/g, "$1");
                        }
                    } else if (child.nodeType === 1) clean(child);
                }
            }
            // find all pre tags and replace contents with placeholder
            // we need this so that we can remove all indentation from html
            // to ease up parsing
            function substitutePreCodeTags(doc) {
                var pres = doc.querySelectorAll("pre"), presPH = [];
                for(var i = 0; i < pres.length; ++i)if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === "code") {
                    var content = pres[i].firstChild.innerHTML.trim(), language = pres[i].firstChild.getAttribute("data-language") || "";
                    // if data-language attribute is not defined, then we look for class language-*
                    if (language === "") {
                        var classes = pres[i].firstChild.className.split(" ");
                        for(var c = 0; c < classes.length; ++c){
                            var matches = classes[c].match(/^language-(.+)$/);
                            if (matches !== null) {
                                language = matches[1];
                                break;
                            }
                        }
                    }
                    // unescape html entities in content
                    content = showdown.helper.unescapeHTMLEntities(content);
                    presPH.push(content);
                    pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
                } else {
                    presPH.push(pres[i].innerHTML);
                    pres[i].innerHTML = "";
                    pres[i].setAttribute("prenum", i.toString());
                }
                return presPH;
            }
            return mdDoc;
        };
        /**
   * Set an option of this Converter instance
   * @param {string} key
   * @param {*} value
   */ this.setOption = function(key, value) {
            options[key] = value;
        };
        /**
   * Get the option of this Converter instance
   * @param {string} key
   * @returns {*}
   */ this.getOption = function(key) {
            return options[key];
        };
        /**
   * Get the options of this Converter instance
   * @returns {{}}
   */ this.getOptions = function() {
            return options;
        };
        /**
   * Add extension to THIS converter
   * @param {{}} extension
   * @param {string} [name=null]
   */ this.addExtension = function(extension, name) {
            name = name || null;
            _parseExtension(extension, name);
        };
        /**
   * Use a global registered extension with THIS converter
   * @param {string} extensionName Name of the previously registered extension
   */ this.useExtension = function(extensionName) {
            _parseExtension(extensionName);
        };
        /**
   * Set the flavor THIS converter should use
   * @param {string} name
   */ this.setFlavor = function(name) {
            if (!flavor.hasOwnProperty(name)) throw Error(name + " flavor was not found");
            var preset = flavor[name];
            setConvFlavor = name;
            for(var option in preset)if (preset.hasOwnProperty(option)) options[option] = preset[option];
        };
        /**
   * Get the currently set flavor of this converter
   * @returns {string}
   */ this.getFlavor = function() {
            return setConvFlavor;
        };
        /**
   * Remove an extension from THIS converter.
   * Note: This is a costly operation. It's better to initialize a new converter
   * and specify the extensions you wish to use
   * @param {Array} extension
   */ this.removeExtension = function(extension) {
            if (!showdown.helper.isArray(extension)) extension = [
                extension
            ];
            for(var a = 0; a < extension.length; ++a){
                var ext = extension[a];
                for(var i = 0; i < langExtensions.length; ++i)if (langExtensions[i] === ext) langExtensions.splice(i, 1);
                for(var ii = 0; ii < outputModifiers.length; ++ii)if (outputModifiers[ii] === ext) outputModifiers.splice(ii, 1);
            }
        };
        /**
   * Get all extension of THIS converter
   * @returns {{language: Array, output: Array}}
   */ this.getAllExtensions = function() {
            return {
                language: langExtensions,
                output: outputModifiers
            };
        };
        /**
   * Get the metadata of the previously parsed document
   * @param raw
   * @returns {string|{}}
   */ this.getMetadata = function(raw) {
            if (raw) return metadata.raw;
            else return metadata.parsed;
        };
        /**
   * Get the metadata format of the previously parsed document
   * @returns {string}
   */ this.getMetadataFormat = function() {
            return metadata.format;
        };
        /**
   * Private: set a single key, value metadata pair
   * @param {string} key
   * @param {string} value
   */ this._setMetadataPair = function(key, value) {
            metadata.parsed[key] = value;
        };
        /**
   * Private: set metadata format
   * @param {string} format
   */ this._setMetadataFormat = function(format) {
            metadata.format = format;
        };
        /**
   * Private: set metadata raw text
   * @param {string} raw
   */ this._setMetadataRaw = function(raw) {
            metadata.raw = raw;
        };
    };
    /**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */ showdown.subParser("anchors", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("anchors.before", text, options, globals);
        var writeAnchorTag = function writeAnchorTag(wholeMatch, linkText, linkId, url, m5, m6, title) {
            if (showdown.helper.isUndefined(title)) title = "";
            linkId = linkId.toLowerCase();
            // Special case for explicit empty url
            if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) url = "";
            else if (!url) {
                if (!linkId) // lower-case and turn embedded newlines into spaces
                linkId = linkText.toLowerCase().replace(/ ?\n/g, " ");
                url = "#" + linkId;
                if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
                    url = globals.gUrls[linkId];
                    if (!showdown.helper.isUndefined(globals.gTitles[linkId])) title = globals.gTitles[linkId];
                } else return wholeMatch;
            }
            //url = showdown.helper.escapeCharacters(url, '*_', false); // replaced line to improve performance
            url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var result = '<a href="' + url + '"';
            if (title !== "" && title !== null) {
                title = title.replace(/"/g, "&quot;");
                //title = showdown.helper.escapeCharacters(title, '*_', false); // replaced line to improve performance
                title = title.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
                result += ' title="' + title + '"';
            }
            // optionLinksInNewWindow only applies
            // to external links. Hash links (#) open in same page
            if (options.openLinksInNewWindow && !/^#/.test(url)) // escaped _
            result += ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            result += ">" + linkText + "</a>";
            return result;
        };
        // First, handle reference-style links: [link text] [id]
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, writeAnchorTag);
        // Next, inline-style links: [link text](url "optional title")
        // cases with crazy urls like ./image/cat1).png
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag);
        // normal cases
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag);
        // handle reference-style shortcuts: [link text]
        // These must come last in case you've also got [link test][1]
        // or [link test](/foo)
        text = text.replace(/\[([^\[\]]+)]()()()()()/g, writeAnchorTag);
        // Lastly handle GithubMentions if option is enabled
        if (options.ghMentions) text = text.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gmi, function(wm, st, escape, mentions, username) {
            if (escape === "\\") return st + mentions;
            //check if options.ghMentionsLink is a string
            if (!showdown.helper.isString(options.ghMentionsLink)) throw new Error("ghMentionsLink option must be a string");
            var lnk = options.ghMentionsLink.replace(/\{u}/g, username), target = "";
            if (options.openLinksInNewWindow) target = ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            return st + '<a href="' + lnk + '"' + target + ">" + mentions + "</a>";
        });
        text = globals.converter._dispatch("anchors.after", text, options, globals);
        return text;
    });
    // url allowed chars [a-z\d_.~:/?#[]@!$&'()*+,;=-]
    var simpleURLRegex = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi, simpleURLRegex2 = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi, delimUrlRegex = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi, simpleMailRegex = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gmi, delimMailRegex = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi, replaceLink = function replaceLink(options) {
        "use strict";
        return function(wm, leadingMagicChars, link, m2, m3, trailingPunctuation, trailingMagicChars) {
            link = link.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var lnkTxt = link, append = "", target = "", lmc = leadingMagicChars || "", tmc = trailingMagicChars || "";
            if (/^www\./i.test(link)) link = link.replace(/^www\./i, "http://www.");
            if (options.excludeTrailingPunctuationFromURLs && trailingPunctuation) append = trailingPunctuation;
            if (options.openLinksInNewWindow) target = ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            return lmc + '<a href="' + link + '"' + target + ">" + lnkTxt + "</a>" + append + tmc;
        };
    }, replaceMail = function replaceMail(options, globals) {
        "use strict";
        return function(wholeMatch, b, mail) {
            var href = "mailto:";
            b = b || "";
            mail = showdown.subParser("unescapeSpecialChars")(mail, options, globals);
            if (options.encodeEmails) {
                href = showdown.helper.encodeEmailAddress(href + mail);
                mail = showdown.helper.encodeEmailAddress(mail);
            } else href = href + mail;
            return b + '<a href="' + href + '">' + mail + "</a>";
        };
    };
    showdown.subParser("autoLinks", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("autoLinks.before", text, options, globals);
        text = text.replace(delimUrlRegex, replaceLink(options));
        text = text.replace(delimMailRegex, replaceMail(options, globals));
        text = globals.converter._dispatch("autoLinks.after", text, options, globals);
        return text;
    });
    showdown.subParser("simplifiedAutoLinks", function(text, options, globals) {
        "use strict";
        if (!options.simplifiedAutoLink) return text;
        text = globals.converter._dispatch("simplifiedAutoLinks.before", text, options, globals);
        if (options.excludeTrailingPunctuationFromURLs) text = text.replace(simpleURLRegex2, replaceLink(options));
        else text = text.replace(simpleURLRegex, replaceLink(options));
        text = text.replace(simpleMailRegex, replaceMail(options, globals));
        text = globals.converter._dispatch("simplifiedAutoLinks.after", text, options, globals);
        return text;
    });
    /**
 * These are all the transformations that form block-level
 * tags like paragraphs, headers, and list items.
 */ showdown.subParser("blockGamut", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("blockGamut.before", text, options, globals);
        // we parse blockquotes first so that we can have headings and hrs
        // inside blockquotes
        text = showdown.subParser("blockQuotes")(text, options, globals);
        text = showdown.subParser("headers")(text, options, globals);
        // Do Horizontal Rules:
        text = showdown.subParser("horizontalRule")(text, options, globals);
        text = showdown.subParser("lists")(text, options, globals);
        text = showdown.subParser("codeBlocks")(text, options, globals);
        text = showdown.subParser("tables")(text, options, globals);
        // We already ran _HashHTMLBlocks() before, in Markdown(), but that
        // was to escape raw HTML in the original Markdown source. This time,
        // we're escaping the markup we've just created, so that we don't wrap
        // <p> tags around block-level tags.
        text = showdown.subParser("hashHTMLBlocks")(text, options, globals);
        text = showdown.subParser("paragraphs")(text, options, globals);
        text = globals.converter._dispatch("blockGamut.after", text, options, globals);
        return text;
    });
    showdown.subParser("blockQuotes", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("blockQuotes.before", text, options, globals);
        // add a couple extra lines after the text and endtext mark
        text = text + "\n\n";
        var rgx = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;
        if (options.splitAdjacentBlockquotes) rgx = /^ {0,3}>[\s\S]*?(?:\n\n)/gm;
        text = text.replace(rgx, function(bq) {
            // attacklab: hack around Konqueror 3.5.4 bug:
            // "----------bug".replace(/^-/g,"") == "bug"
            bq = bq.replace(/^[ \t]*>[ \t]?/gm, ""); // trim one level of quoting
            // attacklab: clean up hack
            bq = bq.replace(/¨0/g, "");
            bq = bq.replace(/^[ \t]+$/gm, ""); // trim whitespace-only lines
            bq = showdown.subParser("githubCodeBlocks")(bq, options, globals);
            bq = showdown.subParser("blockGamut")(bq, options, globals); // recurse
            bq = bq.replace(/(^|\n)/g, "$1  ");
            // These leading spaces screw with <pre> content, so we need to fix that:
            bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function(wholeMatch, m1) {
                var pre = m1;
                // attacklab: hack around Konqueror 3.5.4 bug:
                pre = pre.replace(/^  /mg, "\xa80");
                pre = pre.replace(/¨0/g, "");
                return pre;
            });
            return showdown.subParser("hashBlock")("<blockquote>\n" + bq + "\n</blockquote>", options, globals);
        });
        text = globals.converter._dispatch("blockQuotes.after", text, options, globals);
        return text;
    });
    /**
 * Process Markdown `<pre><code>` blocks.
 */ showdown.subParser("codeBlocks", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("codeBlocks.before", text, options, globals);
        // sentinel workarounds for lack of \A and \Z, safari\khtml bug
        text += "\xa80";
        var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=¨0))/g;
        text = text.replace(pattern, function(wholeMatch, m1, m2) {
            var codeblock = m1, nextChar = m2, end = "\n";
            codeblock = showdown.subParser("outdent")(codeblock, options, globals);
            codeblock = showdown.subParser("encodeCode")(codeblock, options, globals);
            codeblock = showdown.subParser("detab")(codeblock, options, globals);
            codeblock = codeblock.replace(/^\n+/g, ""); // trim leading newlines
            codeblock = codeblock.replace(/\n+$/g, ""); // trim trailing newlines
            if (options.omitExtraWLInCodeBlocks) end = "";
            codeblock = "<pre><code>" + codeblock + end + "</code></pre>";
            return showdown.subParser("hashBlock")(codeblock, options, globals) + nextChar;
        });
        // strip sentinel
        text = text.replace(/¨0/, "");
        text = globals.converter._dispatch("codeBlocks.after", text, options, globals);
        return text;
    });
    /**
 *
 *   *  Backtick quotes are used for <code></code> spans.
 *
 *   *  You can use multiple backticks as the delimiters if you want to
 *     include literal backticks in the code span. So, this input:
 *
 *         Just type ``foo `bar` baz`` at the prompt.
 *
 *       Will translate to:
 *
 *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
 *
 *    There's no arbitrary limit to the number of backticks you
 *    can use as delimters. If you need three consecutive backticks
 *    in your code, use four for delimiters, etc.
 *
 *  *  You can use spaces to get literal backticks at the edges:
 *
 *         ... type `` `bar` `` ...
 *
 *       Turns to:
 *
 *         ... type <code>`bar`</code> ...
 */ showdown.subParser("codeSpans", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("codeSpans.before", text, options, globals);
        if (typeof text === "undefined") text = "";
        text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm, function(wholeMatch, m1, m2, m3) {
            var c = m3;
            c = c.replace(/^([ \t]*)/g, ""); // leading whitespace
            c = c.replace(/[ \t]*$/g, ""); // trailing whitespace
            c = showdown.subParser("encodeCode")(c, options, globals);
            c = m1 + "<code>" + c + "</code>";
            c = showdown.subParser("hashHTMLSpans")(c, options, globals);
            return c;
        });
        text = globals.converter._dispatch("codeSpans.after", text, options, globals);
        return text;
    });
    /**
 * Create a full HTML document from the processed markdown
 */ showdown.subParser("completeHTMLDocument", function(text, options, globals) {
        "use strict";
        if (!options.completeHTMLDocument) return text;
        text = globals.converter._dispatch("completeHTMLDocument.before", text, options, globals);
        var doctype = "html", doctypeParsed = "<!DOCTYPE HTML>\n", title = "", charset = '<meta charset="utf-8">\n', lang = "", metadata = "";
        if (typeof globals.metadata.parsed.doctype !== "undefined") {
            doctypeParsed = "<!DOCTYPE " + globals.metadata.parsed.doctype + ">\n";
            doctype = globals.metadata.parsed.doctype.toString().toLowerCase();
            if (doctype === "html" || doctype === "html5") charset = '<meta charset="utf-8">';
        }
        for(var meta in globals.metadata.parsed)if (globals.metadata.parsed.hasOwnProperty(meta)) switch(meta.toLowerCase()){
            case "doctype":
                break;
            case "title":
                title = "<title>" + globals.metadata.parsed.title + "</title>\n";
                break;
            case "charset":
                if (doctype === "html" || doctype === "html5") charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
                else charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
                break;
            case "language":
            case "lang":
                lang = ' lang="' + globals.metadata.parsed[meta] + '"';
                metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
                break;
            default:
                metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
        }
        text = doctypeParsed + "<html" + lang + ">\n<head>\n" + title + charset + metadata + "</head>\n<body>\n" + text.trim() + "\n</body>\n</html>";
        text = globals.converter._dispatch("completeHTMLDocument.after", text, options, globals);
        return text;
    });
    /**
 * Convert all tabs to spaces
 */ showdown.subParser("detab", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("detab.before", text, options, globals);
        // expand first n-1 tabs
        text = text.replace(/\t(?=\t)/g, "    "); // g_tab_width
        // replace the nth with two sentinels
        text = text.replace(/\t/g, "\xa8A\xa8B");
        // use the sentinel to anchor our regex so it doesn't explode
        text = text.replace(/¨B(.+?)¨A/g, function(wholeMatch, m1) {
            var leadingText = m1, numSpaces = 4 - leadingText.length % 4; // g_tab_width
            // there *must* be a better way to do this:
            for(var i = 0; i < numSpaces; i++)leadingText += " ";
            return leadingText;
        });
        // clean up sentinels
        text = text.replace(/¨A/g, "    "); // g_tab_width
        text = text.replace(/¨B/g, "");
        text = globals.converter._dispatch("detab.after", text, options, globals);
        return text;
    });
    showdown.subParser("ellipsis", function(text, options, globals) {
        "use strict";
        if (!options.ellipsis) return text;
        text = globals.converter._dispatch("ellipsis.before", text, options, globals);
        text = text.replace(/\.\.\./g, "\u2026");
        text = globals.converter._dispatch("ellipsis.after", text, options, globals);
        return text;
    });
    /**
 * Turn emoji codes into emojis
 *
 * List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
 */ showdown.subParser("emoji", function(text, options, globals) {
        "use strict";
        if (!options.emoji) return text;
        text = globals.converter._dispatch("emoji.before", text, options, globals);
        var emojiRgx = /:([\S]+?):/g;
        text = text.replace(emojiRgx, function(wm, emojiCode) {
            if (showdown.helper.emojis.hasOwnProperty(emojiCode)) return showdown.helper.emojis[emojiCode];
            return wm;
        });
        text = globals.converter._dispatch("emoji.after", text, options, globals);
        return text;
    });
    /**
 * Smart processing for ampersands and angle brackets that need to be encoded.
 */ showdown.subParser("encodeAmpsAndAngles", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("encodeAmpsAndAngles.before", text, options, globals);
        // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
        // http://bumppo.net/projects/amputator/
        text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, "&amp;");
        // Encode naked <'s
        text = text.replace(/<(?![a-z\/?$!])/gi, "&lt;");
        // Encode <
        text = text.replace(/</g, "&lt;");
        // Encode >
        text = text.replace(/>/g, "&gt;");
        text = globals.converter._dispatch("encodeAmpsAndAngles.after", text, options, globals);
        return text;
    });
    /**
 * Returns the string, with after processing the following backslash escape sequences.
 *
 * attacklab: The polite way to do this is with the new escapeCharacters() function:
 *
 *    text = escapeCharacters(text,"\\",true);
 *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
 *
 * ...but we're sidestepping its use of the (slow) RegExp constructor
 * as an optimization for Firefox.  This function gets called a LOT.
 */ showdown.subParser("encodeBackslashEscapes", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("encodeBackslashEscapes.before", text, options, globals);
        text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
        text = text.replace(/\\([`*_{}\[\]()>#+.!~=|:-])/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch("encodeBackslashEscapes.after", text, options, globals);
        return text;
    });
    /**
 * Encode/escape certain characters inside Markdown code runs.
 * The point is that in code, these characters are literals,
 * and lose their special Markdown meanings.
 */ showdown.subParser("encodeCode", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("encodeCode.before", text, options, globals);
        // Encode all ampersands; HTML entities are not
        // entities within a Markdown code span.
        text = text.replace(/&/g, "&amp;")// Do the angle bracket song and dance:
        .replace(/</g, "&lt;").replace(/>/g, "&gt;")// Now, escape characters that are magic in Markdown:
        .replace(/([*_{}\[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch("encodeCode.after", text, options, globals);
        return text;
    });
    /**
 * Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
 * don't conflict with their use in Markdown for code, italics and strong.
 */ showdown.subParser("escapeSpecialCharsWithinTagAttributes", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("escapeSpecialCharsWithinTagAttributes.before", text, options, globals);
        // Build a regex to find HTML tags.
        var tags = /<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi, comments = /<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi;
        text = text.replace(tags, function(wholeMatch) {
            return wholeMatch.replace(/(.)<\/?code>(?=.)/g, "$1`").replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
        });
        text = text.replace(comments, function(wholeMatch) {
            return wholeMatch.replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
        });
        text = globals.converter._dispatch("escapeSpecialCharsWithinTagAttributes.after", text, options, globals);
        return text;
    });
    /**
 * Handle github codeblocks prior to running HashHTML so that
 * HTML contained within the codeblock gets escaped properly
 * Example:
 * ```ruby
 *     def hello_world(x)
 *       puts "Hello, #{x}"
 *     end
 * ```
 */ showdown.subParser("githubCodeBlocks", function(text, options, globals) {
        "use strict";
        // early exit if option is not enabled
        if (!options.ghCodeBlocks) return text;
        text = globals.converter._dispatch("githubCodeBlocks.before", text, options, globals);
        text += "\xa80";
        text = text.replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function(wholeMatch, delim, language, codeblock) {
            var end = options.omitExtraWLInCodeBlocks ? "" : "\n";
            // First parse the github code block
            codeblock = showdown.subParser("encodeCode")(codeblock, options, globals);
            codeblock = showdown.subParser("detab")(codeblock, options, globals);
            codeblock = codeblock.replace(/^\n+/g, ""); // trim leading newlines
            codeblock = codeblock.replace(/\n+$/g, ""); // trim trailing whitespace
            codeblock = "<pre><code" + (language ? ' class="' + language + " language-" + language + '"' : "") + ">" + codeblock + end + "</code></pre>";
            codeblock = showdown.subParser("hashBlock")(codeblock, options, globals);
            // Since GHCodeblocks can be false positives, we need to
            // store the primitive text and the parsed text in a global var,
            // and then return a token
            return "\n\n\xa8G" + (globals.ghCodeBlocks.push({
                text: wholeMatch,
                codeblock: codeblock
            }) - 1) + "G\n\n";
        });
        // attacklab: strip sentinel
        text = text.replace(/¨0/, "");
        return globals.converter._dispatch("githubCodeBlocks.after", text, options, globals);
    });
    showdown.subParser("hashBlock", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashBlock.before", text, options, globals);
        text = text.replace(/(^\n+|\n+$)/g, "");
        text = "\n\n\xa8K" + (globals.gHtmlBlocks.push(text) - 1) + "K\n\n";
        text = globals.converter._dispatch("hashBlock.after", text, options, globals);
        return text;
    });
    /**
 * Hash and escape <code> elements that should not be parsed as markdown
 */ showdown.subParser("hashCodeTags", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashCodeTags.before", text, options, globals);
        var repFunc = function repFunc(wholeMatch, match, left, right) {
            var codeblock = left + showdown.subParser("encodeCode")(match, options, globals) + right;
            return "\xa8C" + (globals.gHtmlSpans.push(codeblock) - 1) + "C";
        };
        // Hash naked <code>
        text = showdown.helper.replaceRecursiveRegExp(text, repFunc, "<code\\b[^>]*>", "</code>", "gim");
        text = globals.converter._dispatch("hashCodeTags.after", text, options, globals);
        return text;
    });
    showdown.subParser("hashElement", function(text, options, globals) {
        "use strict";
        return function(wholeMatch, m1) {
            var blockText = m1;
            // Undo double lines
            blockText = blockText.replace(/\n\n/g, "\n");
            blockText = blockText.replace(/^\n/, "");
            // strip trailing blank lines
            blockText = blockText.replace(/\n+$/g, "");
            // Replace the element text with a marker ("¨KxK" where x is its key)
            blockText = "\n\n\xa8K" + (globals.gHtmlBlocks.push(blockText) - 1) + "K\n\n";
            return blockText;
        };
    });
    showdown.subParser("hashHTMLBlocks", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashHTMLBlocks.before", text, options, globals);
        var blockTags = [
            "pre",
            "div",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "table",
            "dl",
            "ol",
            "ul",
            "script",
            "noscript",
            "form",
            "fieldset",
            "iframe",
            "math",
            "style",
            "section",
            "header",
            "footer",
            "nav",
            "article",
            "aside",
            "address",
            "audio",
            "canvas",
            "figure",
            "hgroup",
            "output",
            "video",
            "p"
        ], repFunc = function repFunc(wholeMatch, match, left, right) {
            var txt = wholeMatch;
            // check if this html element is marked as markdown
            // if so, it's contents should be parsed as markdown
            if (left.search(/\bmarkdown\b/) !== -1) txt = left + globals.converter.makeHtml(match) + right;
            return "\n\n\xa8K" + (globals.gHtmlBlocks.push(txt) - 1) + "K\n\n";
        };
        if (options.backslashEscapesHTMLTags) // encode backslash escaped HTML tags
        text = text.replace(/\\<(\/?[^>]+?)>/g, function(wm, inside) {
            return "&lt;" + inside + "&gt;";
        });
        // hash HTML Blocks
        for(var i = 0; i < blockTags.length; ++i){
            var opTagPos, rgx1 = new RegExp("^ {0,3}(<" + blockTags[i] + "\\b[^>]*>)", "im"), patLeft = "<" + blockTags[i] + "\\b[^>]*>", patRight = "</" + blockTags[i] + ">";
            // 1. Look for the first position of the first opening HTML tag in the text
            while((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1){
                // if the HTML tag is \ escaped, we need to escape it and break
                //2. Split the text in that position
                var subTexts = showdown.helper.splitAtIndex(text, opTagPos), //3. Match recursively
                newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, "im");
                // prevent an infinite loop
                if (newSubText1 === subTexts[1]) break;
                text = subTexts[0].concat(newSubText1);
            }
        }
        // HR SPECIAL CASE
        text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, showdown.subParser("hashElement")(text, options, globals));
        // Special case for standalone HTML comments
        text = showdown.helper.replaceRecursiveRegExp(text, function(txt) {
            return "\n\n\xa8K" + (globals.gHtmlBlocks.push(txt) - 1) + "K\n\n";
        }, "^ {0,3}<!--", "-->", "gm");
        // PHP and ASP-style processor instructions (<?...?> and <%...%>)
        text = text.replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, showdown.subParser("hashElement")(text, options, globals));
        text = globals.converter._dispatch("hashHTMLBlocks.after", text, options, globals);
        return text;
    });
    /**
 * Hash span elements that should not be parsed as markdown
 */ showdown.subParser("hashHTMLSpans", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashHTMLSpans.before", text, options, globals);
        function hashHTMLSpan(html) {
            return "\xa8C" + (globals.gHtmlSpans.push(html) - 1) + "C";
        }
        // Hash Self Closing tags
        text = text.replace(/<[^>]+?\/>/gi, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash tags without properties
        text = text.replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash tags with properties
        text = text.replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash self closing tags without />
        text = text.replace(/<[^>]+?>/gi, function(wm) {
            return hashHTMLSpan(wm);
        });
        /*showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');*/ text = globals.converter._dispatch("hashHTMLSpans.after", text, options, globals);
        return text;
    });
    /**
 * Unhash HTML spans
 */ showdown.subParser("unhashHTMLSpans", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("unhashHTMLSpans.before", text, options, globals);
        for(var i = 0; i < globals.gHtmlSpans.length; ++i){
            var repText = globals.gHtmlSpans[i], // limiter to prevent infinite loop (assume 10 as limit for recurse)
            limit = 0;
            while(/¨C(\d+)C/.test(repText)){
                var num = RegExp.$1;
                repText = repText.replace("\xa8C" + num + "C", globals.gHtmlSpans[num]);
                if (limit === 10) {
                    console.error("maximum nesting of 10 spans reached!!!");
                    break;
                }
                ++limit;
            }
            text = text.replace("\xa8C" + i + "C", repText);
        }
        text = globals.converter._dispatch("unhashHTMLSpans.after", text, options, globals);
        return text;
    });
    /**
 * Hash and escape <pre><code> elements that should not be parsed as markdown
 */ showdown.subParser("hashPreCodeTags", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("hashPreCodeTags.before", text, options, globals);
        var repFunc = function repFunc(wholeMatch, match, left, right) {
            // encode html entities
            var codeblock = left + showdown.subParser("encodeCode")(match, options, globals) + right;
            return "\n\n\xa8G" + (globals.ghCodeBlocks.push({
                text: wholeMatch,
                codeblock: codeblock
            }) - 1) + "G\n\n";
        };
        // Hash <pre><code>
        text = showdown.helper.replaceRecursiveRegExp(text, repFunc, "^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>", "^ {0,3}</code>\\s*</pre>", "gim");
        text = globals.converter._dispatch("hashPreCodeTags.after", text, options, globals);
        return text;
    });
    showdown.subParser("headers", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("headers.before", text, options, globals);
        var headerLevelStart = isNaN(parseInt(options.headerLevelStart)) ? 1 : parseInt(options.headerLevelStart), // Set text-style headers:
        //	Header 1
        //	========
        //
        //	Header 2
        //	--------
        //
        setextRegexH1 = options.smoothLivePreview ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm, setextRegexH2 = options.smoothLivePreview ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;
        text = text.replace(setextRegexH1, function(wholeMatch, m1) {
            var spanGamut = showdown.subParser("spanGamut")(m1, options, globals), hID = options.noHeaderId ? "" : ' id="' + headerId(m1) + '"', hLevel = headerLevelStart, hashBlock = "<h" + hLevel + hID + ">" + spanGamut + "</h" + hLevel + ">";
            return showdown.subParser("hashBlock")(hashBlock, options, globals);
        });
        text = text.replace(setextRegexH2, function(matchFound, m1) {
            var spanGamut = showdown.subParser("spanGamut")(m1, options, globals), hID = options.noHeaderId ? "" : ' id="' + headerId(m1) + '"', hLevel = headerLevelStart + 1, hashBlock = "<h" + hLevel + hID + ">" + spanGamut + "</h" + hLevel + ">";
            return showdown.subParser("hashBlock")(hashBlock, options, globals);
        });
        // atx-style headers:
        //  # Header 1
        //  ## Header 2
        //  ## Header 2 with closing hashes ##
        //  ...
        //  ###### Header 6
        //
        var atxStyle = options.requireSpaceBeforeHeadingText ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;
        text = text.replace(atxStyle, function(wholeMatch, m1, m2) {
            var hText = m2;
            if (options.customizedHeaderId) hText = m2.replace(/\s?\{([^{]+?)}\s*$/, "");
            var span = showdown.subParser("spanGamut")(hText, options, globals), hID = options.noHeaderId ? "" : ' id="' + headerId(m2) + '"', hLevel = headerLevelStart - 1 + m1.length, header = "<h" + hLevel + hID + ">" + span + "</h" + hLevel + ">";
            return showdown.subParser("hashBlock")(header, options, globals);
        });
        function headerId(m) {
            var title, prefix;
            // It is separate from other options to allow combining prefix and customized
            if (options.customizedHeaderId) {
                var match = m.match(/\{([^{]+?)}\s*$/);
                if (match && match[1]) m = match[1];
            }
            title = m;
            // Prefix id to prevent causing inadvertent pre-existing style matches.
            if (showdown.helper.isString(options.prefixHeaderId)) prefix = options.prefixHeaderId;
            else if (options.prefixHeaderId === true) prefix = "section-";
            else prefix = "";
            if (!options.rawPrefixHeaderId) title = prefix + title;
            if (options.ghCompatibleHeaderId) title = title.replace(/ /g, "-")// replace previously escaped chars (&, ¨ and $)
            .replace(/&amp;/g, "").replace(/¨T/g, "").replace(/¨D/g, "")// replace rest of the chars (&~$ are repeated as they might have been escaped)
            // borrowed from github's redcarpet (some they should produce similar results)
            .replace(/[&+$,\/:;=?@"#{}|^¨~\[\]`\\*)(%.!'<>]/g, "").toLowerCase();
            else if (options.rawHeaderId) title = title.replace(/ /g, "-")// replace previously escaped chars (&, ¨ and $)
            .replace(/&amp;/g, "&").replace(/¨T/g, "\xa8").replace(/¨D/g, "$")// replace " and '
            .replace(/["']/g, "-").toLowerCase();
            else title = title.replace(/[^\w]/g, "").toLowerCase();
            if (options.rawPrefixHeaderId) title = prefix + title;
            if (globals.hashLinkCounts[title]) title = title + "-" + globals.hashLinkCounts[title]++;
            else globals.hashLinkCounts[title] = 1;
            return title;
        }
        text = globals.converter._dispatch("headers.after", text, options, globals);
        return text;
    });
    /**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */ showdown.subParser("horizontalRule", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("horizontalRule.before", text, options, globals);
        var key = showdown.subParser("hashBlock")("<hr />", options, globals);
        text = text.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, key);
        text = text.replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, key);
        text = text.replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, key);
        text = globals.converter._dispatch("horizontalRule.after", text, options, globals);
        return text;
    });
    /**
 * Turn Markdown image shortcuts into <img> tags.
 */ showdown.subParser("images", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("images.before", text, options, globals);
        var inlineRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, crazyRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g, base64RegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, referenceRegExp = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g, refShortcutRegExp = /!\[([^\[\]]+)]()()()()()/g;
        function writeImageTagBase64(wholeMatch, altText, linkId, url, width, height, m5, title) {
            url = url.replace(/\s/g, "");
            return writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title);
        }
        function writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title) {
            var gUrls = globals.gUrls, gTitles = globals.gTitles, gDims = globals.gDimensions;
            linkId = linkId.toLowerCase();
            if (!title) title = "";
            // Special case for explicit empty url
            if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) url = "";
            else if (url === "" || url === null) {
                if (linkId === "" || linkId === null) // lower-case and turn embedded newlines into spaces
                linkId = altText.toLowerCase().replace(/ ?\n/g, " ");
                url = "#" + linkId;
                if (!showdown.helper.isUndefined(gUrls[linkId])) {
                    url = gUrls[linkId];
                    if (!showdown.helper.isUndefined(gTitles[linkId])) title = gTitles[linkId];
                    if (!showdown.helper.isUndefined(gDims[linkId])) {
                        width = gDims[linkId].width;
                        height = gDims[linkId].height;
                    }
                } else return wholeMatch;
            }
            altText = altText.replace(/"/g, "&quot;")//altText = showdown.helper.escapeCharacters(altText, '*_', false);
            .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            //url = showdown.helper.escapeCharacters(url, '*_', false);
            url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var result = '<img src="' + url + '" alt="' + altText + '"';
            if (title && showdown.helper.isString(title)) {
                title = title.replace(/"/g, "&quot;")//title = showdown.helper.escapeCharacters(title, '*_', false);
                .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
                result += ' title="' + title + '"';
            }
            if (width && height) {
                width = width === "*" ? "auto" : width;
                height = height === "*" ? "auto" : height;
                result += ' width="' + width + '"';
                result += ' height="' + height + '"';
            }
            result += " />";
            return result;
        }
        // First, handle reference-style labeled images: ![alt text][id]
        text = text.replace(referenceRegExp, writeImageTag);
        // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")
        // base64 encoded images
        text = text.replace(base64RegExp, writeImageTagBase64);
        // cases with crazy urls like ./image/cat1).png
        text = text.replace(crazyRegExp, writeImageTag);
        // normal cases
        text = text.replace(inlineRegExp, writeImageTag);
        // handle reference-style shortcuts: ![img text]
        text = text.replace(refShortcutRegExp, writeImageTag);
        text = globals.converter._dispatch("images.after", text, options, globals);
        return text;
    });
    showdown.subParser("italicsAndBold", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("italicsAndBold.before", text, options, globals);
        // it's faster to have 3 separate regexes for each case than have just one
        // because of backtracing, in some cases, it could lead to an exponential effect
        // called "catastrophic backtrace". Ominous!
        function parseInside(txt, left, right) {
            /*
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    */ return left + txt + right;
        }
        // Parse underscores
        if (options.literalMidWordUnderscores) {
            text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function(wm, txt) {
                return parseInside(txt, "<strong><em>", "</em></strong>");
            });
            text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function(wm, txt) {
                return parseInside(txt, "<strong>", "</strong>");
            });
            text = text.replace(/\b_(\S[\s\S]*?)_\b/g, function(wm, txt) {
                return parseInside(txt, "<em>", "</em>");
            });
        } else {
            text = text.replace(/___(\S[\s\S]*?)___/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong><em>", "</em></strong>") : wm;
            });
            text = text.replace(/__(\S[\s\S]*?)__/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong>", "</strong>") : wm;
            });
            text = text.replace(/_([^\s_][\s\S]*?)_/g, function(wm, m) {
                // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
                return /\S$/.test(m) ? parseInside(m, "<em>", "</em>") : wm;
            });
        }
        // Now parse asterisks
        if (options.literalMidWordAsterisks) {
            text = text.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + "<strong><em>", "</em></strong>");
            });
            text = text.replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + "<strong>", "</strong>");
            });
            text = text.replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + "<em>", "</em>");
            });
        } else {
            text = text.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong><em>", "</em></strong>") : wm;
            });
            text = text.replace(/\*\*(\S[\s\S]*?)\*\*/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, "<strong>", "</strong>") : wm;
            });
            text = text.replace(/\*([^\s*][\s\S]*?)\*/g, function(wm, m) {
                // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
                return /\S$/.test(m) ? parseInside(m, "<em>", "</em>") : wm;
            });
        }
        text = globals.converter._dispatch("italicsAndBold.after", text, options, globals);
        return text;
    });
    /**
 * Form HTML ordered (numbered) and unordered (bulleted) lists.
 */ showdown.subParser("lists", function(text, options, globals) {
        "use strict";
        /**
   * Process the contents of a single ordered or unordered list, splitting it
   * into individual list items.
   * @param {string} listStr
   * @param {boolean} trimTrailing
   * @returns {string}
   */ function processListItems(listStr, trimTrailing) {
            // The $g_list_level global keeps track of when we're inside a list.
            // Each time we enter a list, we increment it; when we leave a list,
            // we decrement. If it's zero, we're not in a list anymore.
            //
            // We do this because when we're not inside a list, we want to treat
            // something like this:
            //
            //    I recommend upgrading to version
            //    8. Oops, now this line is treated
            //    as a sub-list.
            //
            // As a single paragraph, despite the fact that the second line starts
            // with a digit-period-space sequence.
            //
            // Whereas when we're inside a list (or sub-list), that line will be
            // treated as the start of a sub-list. What a kludge, huh? This is
            // an aspect of Markdown's syntax that's hard to parse perfectly
            // without resorting to mind-reading. Perhaps the solution is to
            // change the syntax rules such that sub-lists must start with a
            // starting cardinal number; e.g. "1." or "a.".
            globals.gListLevel++;
            // trim trailing blank lines:
            listStr = listStr.replace(/\n{2,}$/, "\n");
            // attacklab: add sentinel to emulate \z
            listStr += "\xa80";
            var rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm, isParagraphed = /\n[ \t]*\n(?!¨0)/.test(listStr);
            // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
            // which is a syntax breaking change
            // activating this option reverts to old behavior
            if (options.disableForced4SpacesIndentedSublists) rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
            listStr = listStr.replace(rgx, function(wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
                checked = checked && checked.trim() !== "";
                var item = showdown.subParser("outdent")(m4, options, globals), bulletStyle = "";
                // Support for github tasklists
                if (taskbtn && options.tasklists) {
                    bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
                    item = item.replace(/^[ \t]*\[(x|X| )?]/m, function() {
                        var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
                        if (checked) otp += " checked";
                        otp += ">";
                        return otp;
                    });
                }
                // ISSUE #312
                // This input: - - - a
                // causes trouble to the parser, since it interprets it as:
                // <ul><li><li><li>a</li></li></li></ul>
                // instead of:
                // <ul><li>- - a</li></ul>
                // So, to prevent it, we will put a marker (¨A)in the beginning of the line
                // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser
                item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function(wm2) {
                    return "\xa8A" + wm2;
                });
                // m1 - Leading line or
                // Has a double return (multi paragraph) or
                // Has sublist
                if (m1 || item.search(/\n{2,}/) > -1) {
                    item = showdown.subParser("githubCodeBlocks")(item, options, globals);
                    item = showdown.subParser("blockGamut")(item, options, globals);
                } else {
                    // Recursion for sub-lists:
                    item = showdown.subParser("lists")(item, options, globals);
                    item = item.replace(/\n$/, ""); // chomp(item)
                    item = showdown.subParser("hashHTMLBlocks")(item, options, globals);
                    // Colapse double linebreaks
                    item = item.replace(/\n\n+/g, "\n\n");
                    if (isParagraphed) item = showdown.subParser("paragraphs")(item, options, globals);
                    else item = showdown.subParser("spanGamut")(item, options, globals);
                }
                // now we need to remove the marker (¨A)
                item = item.replace("\xa8A", "");
                // we can finally wrap the line in list item tags
                item = "<li" + bulletStyle + ">" + item + "</li>\n";
                return item;
            });
            // attacklab: strip sentinel
            listStr = listStr.replace(/¨0/g, "");
            globals.gListLevel--;
            if (trimTrailing) listStr = listStr.replace(/\s+$/, "");
            return listStr;
        }
        function styleStartNumber(list, listType) {
            // check if ol and starts by a number different than 1
            if (listType === "ol") {
                var res = list.match(/^ *(\d+)\./);
                if (res && res[1] !== "1") return ' start="' + res[1] + '"';
            }
            return "";
        }
        /**
   * Check and parse consecutive lists (better fix for issue #142)
   * @param {string} list
   * @param {string} listType
   * @param {boolean} trimTrailing
   * @returns {string}
   */ function parseConsecutiveLists(list, listType, trimTrailing) {
            // check if we caught 2 or more consecutive lists by mistake
            // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
            var olRgx = options.disableForced4SpacesIndentedSublists ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm, ulRgx = options.disableForced4SpacesIndentedSublists ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm, counterRxg = listType === "ul" ? olRgx : ulRgx, result = "";
            if (list.search(counterRxg) !== -1) (function parseCL(txt) {
                var pos = txt.search(counterRxg), style = styleStartNumber(list, listType);
                if (pos !== -1) {
                    // slice
                    result += "\n\n<" + listType + style + ">\n" + processListItems(txt.slice(0, pos), !!trimTrailing) + "</" + listType + ">\n";
                    // invert counterType and listType
                    listType = listType === "ul" ? "ol" : "ul";
                    counterRxg = listType === "ul" ? olRgx : ulRgx;
                    //recurse
                    parseCL(txt.slice(pos));
                } else result += "\n\n<" + listType + style + ">\n" + processListItems(txt, !!trimTrailing) + "</" + listType + ">\n";
            })(list);
            else {
                var style = styleStartNumber(list, listType);
                result = "\n\n<" + listType + style + ">\n" + processListItems(list, !!trimTrailing) + "</" + listType + ">\n";
            }
            return result;
        }
        /** Start of list parsing **/ text = globals.converter._dispatch("lists.before", text, options, globals);
        // add sentinel to hack around khtml/safari bug:
        // http://bugs.webkit.org/show_bug.cgi?id=11231
        text += "\xa80";
        if (globals.gListLevel) text = text.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function(wholeMatch, list, m2) {
            var listType = m2.search(/[*+-]/g) > -1 ? "ul" : "ol";
            return parseConsecutiveLists(list, listType, true);
        });
        else text = text.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function(wholeMatch, m1, list, m3) {
            var listType = m3.search(/[*+-]/g) > -1 ? "ul" : "ol";
            return parseConsecutiveLists(list, listType, false);
        });
        // strip sentinel
        text = text.replace(/¨0/, "");
        text = globals.converter._dispatch("lists.after", text, options, globals);
        return text;
    });
    /**
 * Parse metadata at the top of the document
 */ showdown.subParser("metadata", function(text, options, globals) {
        "use strict";
        if (!options.metadata) return text;
        text = globals.converter._dispatch("metadata.before", text, options, globals);
        function parseMetadataContents(content) {
            // raw is raw so it's not changed in any way
            globals.metadata.raw = content;
            // escape chars forbidden in html attributes
            // double quotes
            content = content// ampersand first
            .replace(/&/g, "&amp;")// double quotes
            .replace(/"/g, "&quot;");
            content = content.replace(/\n {4}/g, " ");
            content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function(wm, key, value) {
                globals.metadata.parsed[key] = value;
                return "";
            });
        }
        text = text.replace(/^\s*«««+(\S*?)\n([\s\S]+?)\n»»»+\n/, function(wholematch, format, content) {
            parseMetadataContents(content);
            return "\xa8M";
        });
        text = text.replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function(wholematch, format, content) {
            if (format) globals.metadata.format = format;
            parseMetadataContents(content);
            return "\xa8M";
        });
        text = text.replace(/¨M/g, "");
        text = globals.converter._dispatch("metadata.after", text, options, globals);
        return text;
    });
    /**
 * Remove one level of line-leading tabs or spaces
 */ showdown.subParser("outdent", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("outdent.before", text, options, globals);
        // attacklab: hack around Konqueror 3.5.4 bug:
        // "----------bug".replace(/^-/g,"") == "bug"
        text = text.replace(/^(\t|[ ]{1,4})/gm, "\xa80"); // attacklab: g_tab_width
        // attacklab: clean up hack
        text = text.replace(/¨0/g, "");
        text = globals.converter._dispatch("outdent.after", text, options, globals);
        return text;
    });
    /**
 *
 */ showdown.subParser("paragraphs", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("paragraphs.before", text, options, globals);
        // Strip leading and trailing lines:
        text = text.replace(/^\n+/g, "");
        text = text.replace(/\n+$/g, "");
        var grafs = text.split(/\n{2,}/g), grafsOut = [], end = grafs.length; // Wrap <p> tags
        for(var i = 0; i < end; i++){
            var str = grafs[i];
            // if this is an HTML marker, copy it
            if (str.search(/¨(K|G)(\d+)\1/g) >= 0) grafsOut.push(str);
            else if (str.search(/\S/) >= 0) {
                str = showdown.subParser("spanGamut")(str, options, globals);
                str = str.replace(/^([ \t]*)/g, "<p>");
                str += "</p>";
                grafsOut.push(str);
            }
        }
        /** Unhashify HTML blocks */ end = grafsOut.length;
        for(i = 0; i < end; i++){
            var blockText = "", grafsOutIt = grafsOut[i], codeFlag = false;
            // if this is a marker for an html block...
            // use RegExp.test instead of string.search because of QML bug
            while(/¨(K|G)(\d+)\1/.test(grafsOutIt)){
                var delim = RegExp.$1, num = RegExp.$2;
                if (delim === "K") blockText = globals.gHtmlBlocks[num];
                else // we need to check if ghBlock is a false positive
                if (codeFlag) // use encoded version of all text
                blockText = showdown.subParser("encodeCode")(globals.ghCodeBlocks[num].text, options, globals);
                else blockText = globals.ghCodeBlocks[num].codeblock;
                blockText = blockText.replace(/\$/g, "$$$$"); // Escape any dollar signs
                grafsOutIt = grafsOutIt.replace(/(\n\n)?¨(K|G)\d+\2(\n\n)?/, blockText);
                // Check if grafsOutIt is a pre->code
                if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) codeFlag = true;
            }
            grafsOut[i] = grafsOutIt;
        }
        text = grafsOut.join("\n");
        // Strip leading and trailing lines:
        text = text.replace(/^\n+/g, "");
        text = text.replace(/\n+$/g, "");
        return globals.converter._dispatch("paragraphs.after", text, options, globals);
    });
    /**
 * Run extension
 */ showdown.subParser("runExtension", function(ext, text, options, globals) {
        "use strict";
        if (ext.filter) text = ext.filter(text, globals.converter, options);
        else if (ext.regex) {
            // TODO remove this when old extension loading mechanism is deprecated
            var re = ext.regex;
            if (!(re instanceof RegExp)) re = new RegExp(re, "g");
            text = text.replace(re, ext.replace);
        }
        return text;
    });
    /**
 * These are all the transformations that occur *within* block-level
 * tags like paragraphs, headers, and list items.
 */ showdown.subParser("spanGamut", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("spanGamut.before", text, options, globals);
        text = showdown.subParser("codeSpans")(text, options, globals);
        text = showdown.subParser("escapeSpecialCharsWithinTagAttributes")(text, options, globals);
        text = showdown.subParser("encodeBackslashEscapes")(text, options, globals);
        // Process anchor and image tags. Images must come first,
        // because ![foo][f] looks like an anchor.
        text = showdown.subParser("images")(text, options, globals);
        text = showdown.subParser("anchors")(text, options, globals);
        // Make links out of things like `<http://example.com/>`
        // Must come after anchors, because you can use < and >
        // delimiters in inline links like [this](<url>).
        text = showdown.subParser("autoLinks")(text, options, globals);
        text = showdown.subParser("simplifiedAutoLinks")(text, options, globals);
        text = showdown.subParser("emoji")(text, options, globals);
        text = showdown.subParser("underline")(text, options, globals);
        text = showdown.subParser("italicsAndBold")(text, options, globals);
        text = showdown.subParser("strikethrough")(text, options, globals);
        text = showdown.subParser("ellipsis")(text, options, globals);
        // we need to hash HTML tags inside spans
        text = showdown.subParser("hashHTMLSpans")(text, options, globals);
        // now we encode amps and angles
        text = showdown.subParser("encodeAmpsAndAngles")(text, options, globals);
        // Do hard breaks
        if (options.simpleLineBreaks) // GFM style hard breaks
        // only add line breaks if the text does not contain a block (special case for lists)
        {
            if (!/\n\n¨K/.test(text)) text = text.replace(/\n+/g, "<br />\n");
        } else // Vanilla hard breaks
        text = text.replace(/  +\n/g, "<br />\n");
        text = globals.converter._dispatch("spanGamut.after", text, options, globals);
        return text;
    });
    showdown.subParser("strikethrough", function(text, options, globals) {
        "use strict";
        function parseInside(txt) {
            if (options.simplifiedAutoLink) txt = showdown.subParser("simplifiedAutoLinks")(txt, options, globals);
            return "<del>" + txt + "</del>";
        }
        if (options.strikethrough) {
            text = globals.converter._dispatch("strikethrough.before", text, options, globals);
            text = text.replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function(wm, txt) {
                return parseInside(txt);
            });
            text = globals.converter._dispatch("strikethrough.after", text, options, globals);
        }
        return text;
    });
    /**
 * Strips link definitions from text, stores the URLs and titles in
 * hash references.
 * Link defs are in the form: ^[id]: url "optional title"
 */ showdown.subParser("stripLinkDefinitions", function(text, options, globals) {
        "use strict";
        var regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm, base64Regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm;
        // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
        text += "\xa80";
        var replaceFunc = function replaceFunc(wholeMatch, linkId, url, width, height, blankLines, title) {
            // if there aren't two instances of linkId it must not be a reference link so back out
            linkId = linkId.toLowerCase();
            if (text.toLowerCase().split(linkId).length - 1 < 2) return wholeMatch;
            if (url.match(/^data:.+?\/.+?;base64,/)) // remove newlines
            globals.gUrls[linkId] = url.replace(/\s/g, "");
            else globals.gUrls[linkId] = showdown.subParser("encodeAmpsAndAngles")(url, options, globals); // Link IDs are case-insensitive
            if (blankLines) // Oops, found blank lines, so it's not a title.
            // Put back the parenthetical statement we stole.
            return blankLines + title;
            else {
                if (title) globals.gTitles[linkId] = title.replace(/"|'/g, "&quot;");
                if (options.parseImgDimensions && width && height) globals.gDimensions[linkId] = {
                    width: width,
                    height: height
                };
            }
            // Completely remove the definition from the text
            return "";
        };
        // first we try to find base64 link references
        text = text.replace(base64Regex, replaceFunc);
        text = text.replace(regex, replaceFunc);
        // attacklab: strip sentinel
        text = text.replace(/¨0/, "");
        return text;
    });
    showdown.subParser("tables", function(text, options, globals) {
        "use strict";
        if (!options.tables) return text;
        var tableRgx = /^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|¨0)/gm, //singeColTblRgx = /^ {0,3}\|.+\|\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n(?: {0,3}\|.+\|\n)+(?:\n\n|¨0)/gm;
        singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;
        function parseStyles(sLine) {
            if (/^:[ \t]*--*$/.test(sLine)) return ' style="text-align:left;"';
            else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) return ' style="text-align:right;"';
            else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) return ' style="text-align:center;"';
            else return "";
        }
        function parseHeaders(header, style) {
            var id = "";
            header = header.trim();
            // support both tablesHeaderId and tableHeaderId due to error in documentation so we don't break backwards compatibility
            if (options.tablesHeaderId || options.tableHeaderId) id = ' id="' + header.replace(/ /g, "_").toLowerCase() + '"';
            header = showdown.subParser("spanGamut")(header, options, globals);
            return "<th" + id + style + ">" + header + "</th>\n";
        }
        function parseCells(cell, style) {
            var subText = showdown.subParser("spanGamut")(cell, options, globals);
            return "<td" + style + ">" + subText + "</td>\n";
        }
        function buildTable(headers, cells) {
            var tb = "<table>\n<thead>\n<tr>\n", tblLgn = headers.length;
            for(var i = 0; i < tblLgn; ++i)tb += headers[i];
            tb += "</tr>\n</thead>\n<tbody>\n";
            for(i = 0; i < cells.length; ++i){
                tb += "<tr>\n";
                for(var ii = 0; ii < tblLgn; ++ii)tb += cells[i][ii];
                tb += "</tr>\n";
            }
            tb += "</tbody>\n</table>\n";
            return tb;
        }
        function parseTable(rawTable) {
            var i, tableLines = rawTable.split("\n");
            for(i = 0; i < tableLines.length; ++i){
                // strip wrong first and last column if wrapped tables are used
                if (/^ {0,3}\|/.test(tableLines[i])) tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, "");
                if (/\|[ \t]*$/.test(tableLines[i])) tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, "");
                // parse code spans first, but we only support one line code spans
                tableLines[i] = showdown.subParser("codeSpans")(tableLines[i], options, globals);
            }
            var rawHeaders = tableLines[0].split("|").map(function(s) {
                return s.trim();
            }), rawStyles = tableLines[1].split("|").map(function(s) {
                return s.trim();
            }), rawCells = [], headers = [], styles = [], cells = [];
            tableLines.shift();
            tableLines.shift();
            for(i = 0; i < tableLines.length; ++i){
                if (tableLines[i].trim() === "") continue;
                rawCells.push(tableLines[i].split("|").map(function(s) {
                    return s.trim();
                }));
            }
            if (rawHeaders.length < rawStyles.length) return rawTable;
            for(i = 0; i < rawStyles.length; ++i)styles.push(parseStyles(rawStyles[i]));
            for(i = 0; i < rawHeaders.length; ++i){
                if (showdown.helper.isUndefined(styles[i])) styles[i] = "";
                headers.push(parseHeaders(rawHeaders[i], styles[i]));
            }
            for(i = 0; i < rawCells.length; ++i){
                var row = [];
                for(var ii = 0; ii < headers.length; ++ii){
                    showdown.helper.isUndefined(rawCells[i][ii]);
                    row.push(parseCells(rawCells[i][ii], styles[ii]));
                }
                cells.push(row);
            }
            return buildTable(headers, cells);
        }
        text = globals.converter._dispatch("tables.before", text, options, globals);
        // find escaped pipe characters
        text = text.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);
        // parse multi column tables
        text = text.replace(tableRgx, parseTable);
        // parse one column tables
        text = text.replace(singeColTblRgx, parseTable);
        text = globals.converter._dispatch("tables.after", text, options, globals);
        return text;
    });
    showdown.subParser("underline", function(text, options, globals) {
        "use strict";
        if (!options.underline) return text;
        text = globals.converter._dispatch("underline.before", text, options, globals);
        if (options.literalMidWordUnderscores) {
            text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function(wm, txt) {
                return "<u>" + txt + "</u>";
            });
            text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function(wm, txt) {
                return "<u>" + txt + "</u>";
            });
        } else {
            text = text.replace(/___(\S[\s\S]*?)___/g, function(wm, m) {
                return /\S$/.test(m) ? "<u>" + m + "</u>" : wm;
            });
            text = text.replace(/__(\S[\s\S]*?)__/g, function(wm, m) {
                return /\S$/.test(m) ? "<u>" + m + "</u>" : wm;
            });
        }
        // escape remaining underscores to prevent them being parsed by italic and bold
        text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch("underline.after", text, options, globals);
        return text;
    });
    /**
 * Swap back in all the special characters we've hidden.
 */ showdown.subParser("unescapeSpecialChars", function(text, options, globals) {
        "use strict";
        text = globals.converter._dispatch("unescapeSpecialChars.before", text, options, globals);
        text = text.replace(/¨E(\d+)E/g, function(wholeMatch, m1) {
            var charCodeToReplace = parseInt(m1);
            return String.fromCharCode(charCodeToReplace);
        });
        text = globals.converter._dispatch("unescapeSpecialChars.after", text, options, globals);
        return text;
    });
    showdown.subParser("makeMarkdown.blockquote", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i){
                var innerTxt = showdown.subParser("makeMarkdown.node")(children[i], globals);
                if (innerTxt === "") continue;
                txt += innerTxt;
            }
        }
        // cleanup
        txt = txt.trim();
        txt = "> " + txt.split("\n").join("\n> ");
        return txt;
    });
    showdown.subParser("makeMarkdown.codeBlock", function(node, globals) {
        "use strict";
        var lang = node.getAttribute("language"), num = node.getAttribute("precodenum");
        return "```" + lang + "\n" + globals.preList[num] + "\n```";
    });
    showdown.subParser("makeMarkdown.codeSpan", function(node) {
        "use strict";
        return "`" + node.innerHTML + "`";
    });
    showdown.subParser("makeMarkdown.emphasis", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            txt += "*";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "*";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.header", function(node, globals, headerLevel) {
        "use strict";
        var headerMark = new Array(headerLevel + 1).join("#"), txt = "";
        if (node.hasChildNodes()) {
            txt = headerMark + " ";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.hr", function() {
        "use strict";
        return "---";
    });
    showdown.subParser("makeMarkdown.image", function(node) {
        "use strict";
        var txt = "";
        if (node.hasAttribute("src")) {
            txt += "![" + node.getAttribute("alt") + "](";
            txt += "<" + node.getAttribute("src") + ">";
            if (node.hasAttribute("width") && node.hasAttribute("height")) txt += " =" + node.getAttribute("width") + "x" + node.getAttribute("height");
            if (node.hasAttribute("title")) txt += ' "' + node.getAttribute("title") + '"';
            txt += ")";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.links", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes() && node.hasAttribute("href")) {
            var children = node.childNodes, childrenLength = children.length;
            txt = "[";
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "](";
            txt += "<" + node.getAttribute("href") + ">";
            if (node.hasAttribute("title")) txt += ' "' + node.getAttribute("title") + '"';
            txt += ")";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.list", function(node, globals, type) {
        "use strict";
        var txt = "";
        if (!node.hasChildNodes()) return "";
        var listItems = node.childNodes, listItemsLenght = listItems.length, listNum = node.getAttribute("start") || 1;
        for(var i = 0; i < listItemsLenght; ++i){
            if (typeof listItems[i].tagName === "undefined" || listItems[i].tagName.toLowerCase() !== "li") continue;
            // define the bullet to use in list
            var bullet = "";
            if (type === "ol") bullet = listNum.toString() + ". ";
            else bullet = "- ";
            // parse list item
            txt += bullet + showdown.subParser("makeMarkdown.listItem")(listItems[i], globals);
            ++listNum;
        }
        // add comment at the end to prevent consecutive lists to be parsed as one
        txt += "\n<!-- -->\n";
        return txt.trim();
    });
    showdown.subParser("makeMarkdown.listItem", function(node, globals) {
        "use strict";
        var listItemTxt = "";
        var children = node.childNodes, childrenLenght = children.length;
        for(var i = 0; i < childrenLenght; ++i)listItemTxt += showdown.subParser("makeMarkdown.node")(children[i], globals);
        // if it's only one liner, we need to add a newline at the end
        if (!/\n$/.test(listItemTxt)) listItemTxt += "\n";
        else // it's multiparagraph, so we need to indent
        listItemTxt = listItemTxt.split("\n").join("\n    ").replace(/^ {4}$/gm, "").replace(/\n\n+/g, "\n\n");
        return listItemTxt;
    });
    showdown.subParser("makeMarkdown.node", function(node, globals, spansOnly) {
        "use strict";
        spansOnly = spansOnly || false;
        var txt = "";
        // edge case of text without wrapper paragraph
        if (node.nodeType === 3) return showdown.subParser("makeMarkdown.txt")(node, globals);
        // HTML comment
        if (node.nodeType === 8) return "<!--" + node.data + "-->\n\n";
        // process only node elements
        if (node.nodeType !== 1) return "";
        var tagName = node.tagName.toLowerCase();
        switch(tagName){
            //
            // BLOCKS
            //
            case "h1":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 1) + "\n\n";
                break;
            case "h2":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 2) + "\n\n";
                break;
            case "h3":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 3) + "\n\n";
                break;
            case "h4":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 4) + "\n\n";
                break;
            case "h5":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 5) + "\n\n";
                break;
            case "h6":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.header")(node, globals, 6) + "\n\n";
                break;
            case "p":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.paragraph")(node, globals) + "\n\n";
                break;
            case "blockquote":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.blockquote")(node, globals) + "\n\n";
                break;
            case "hr":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.hr")(node, globals) + "\n\n";
                break;
            case "ol":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.list")(node, globals, "ol") + "\n\n";
                break;
            case "ul":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.list")(node, globals, "ul") + "\n\n";
                break;
            case "precode":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.codeBlock")(node, globals) + "\n\n";
                break;
            case "pre":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.pre")(node, globals) + "\n\n";
                break;
            case "table":
                if (!spansOnly) txt = showdown.subParser("makeMarkdown.table")(node, globals) + "\n\n";
                break;
            //
            // SPANS
            //
            case "code":
                txt = showdown.subParser("makeMarkdown.codeSpan")(node, globals);
                break;
            case "em":
            case "i":
                txt = showdown.subParser("makeMarkdown.emphasis")(node, globals);
                break;
            case "strong":
            case "b":
                txt = showdown.subParser("makeMarkdown.strong")(node, globals);
                break;
            case "del":
                txt = showdown.subParser("makeMarkdown.strikethrough")(node, globals);
                break;
            case "a":
                txt = showdown.subParser("makeMarkdown.links")(node, globals);
                break;
            case "img":
                txt = showdown.subParser("makeMarkdown.image")(node, globals);
                break;
            default:
                txt = node.outerHTML + "\n\n";
        }
        // common normalization
        // TODO eventually
        return txt;
    });
    showdown.subParser("makeMarkdown.paragraph", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
        }
        // some text normalization
        txt = txt.trim();
        return txt;
    });
    showdown.subParser("makeMarkdown.pre", function(node, globals) {
        "use strict";
        var num = node.getAttribute("prenum");
        return "<pre>" + globals.preList[num] + "</pre>";
    });
    showdown.subParser("makeMarkdown.strikethrough", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            txt += "~~";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "~~";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.strong", function(node, globals) {
        "use strict";
        var txt = "";
        if (node.hasChildNodes()) {
            txt += "**";
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals);
            txt += "**";
        }
        return txt;
    });
    showdown.subParser("makeMarkdown.table", function(node, globals) {
        "use strict";
        var txt = "", tableArray = [
            [],
            []
        ], headings = node.querySelectorAll("thead>tr>th"), rows = node.querySelectorAll("tbody>tr"), i, ii;
        for(i = 0; i < headings.length; ++i){
            var headContent = showdown.subParser("makeMarkdown.tableCell")(headings[i], globals), allign = "---";
            if (headings[i].hasAttribute("style")) {
                var style = headings[i].getAttribute("style").toLowerCase().replace(/\s/g, "");
                switch(style){
                    case "text-align:left;":
                        allign = ":---";
                        break;
                    case "text-align:right;":
                        allign = "---:";
                        break;
                    case "text-align:center;":
                        allign = ":---:";
                        break;
                }
            }
            tableArray[0][i] = headContent.trim();
            tableArray[1][i] = allign;
        }
        for(i = 0; i < rows.length; ++i){
            var r = tableArray.push([]) - 1, cols = rows[i].getElementsByTagName("td");
            for(ii = 0; ii < headings.length; ++ii){
                var cellContent = " ";
                if (typeof cols[ii] !== "undefined") cellContent = showdown.subParser("makeMarkdown.tableCell")(cols[ii], globals);
                tableArray[r].push(cellContent);
            }
        }
        var cellSpacesCount = 3;
        for(i = 0; i < tableArray.length; ++i)for(ii = 0; ii < tableArray[i].length; ++ii){
            var strLen = tableArray[i][ii].length;
            if (strLen > cellSpacesCount) cellSpacesCount = strLen;
        }
        for(i = 0; i < tableArray.length; ++i){
            for(ii = 0; ii < tableArray[i].length; ++ii)if (i === 1) {
                if (tableArray[i][ii].slice(-1) === ":") tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(-1), cellSpacesCount - 1, "-") + ":";
                else tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, "-");
            } else tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
            txt += "| " + tableArray[i].join(" | ") + " |\n";
        }
        return txt.trim();
    });
    showdown.subParser("makeMarkdown.tableCell", function(node, globals) {
        "use strict";
        var txt = "";
        if (!node.hasChildNodes()) return "";
        var children = node.childNodes, childrenLength = children.length;
        for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser("makeMarkdown.node")(children[i], globals, true);
        return txt.trim();
    });
    showdown.subParser("makeMarkdown.txt", function(node) {
        "use strict";
        var txt = node.nodeValue;
        // multiple spaces are collapsed
        txt = txt.replace(/ +/g, " ");
        // replace the custom ¨NBSP; with a space
        txt = txt.replace(/¨NBSP;/g, " ");
        // ", <, > and & should replace escaped html entities
        txt = showdown.helper.unescapeHTMLEntities(txt);
        // escape markdown magic characters
        // emphasis, strong and strikethrough - can appear everywhere
        // we also escape pipe (|) because of tables
        // and escape ` because of code blocks and spans
        txt = txt.replace(/([*_~|`])/g, "\\$1");
        // escape > because of blockquotes
        txt = txt.replace(/^(\s*)>/g, "\\$1>");
        // hash character, only troublesome at the beginning of a line because of headers
        txt = txt.replace(/^#/gm, "\\#");
        // horizontal rules
        txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, "$1\\$2$3");
        // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer
        txt = txt.replace(/^( {0,3}\d+)\./gm, "$1\\.");
        // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)
        txt = txt.replace(/^( {0,3})([+-])/gm, "$1\\$2");
        // images and links, ] followed by ( is problematic, so we escape it
        txt = txt.replace(/]([\s]*)\(/g, "\\]$1\\(");
        // reference URIs must also be escaped
        txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, "\\[$1]:");
        return txt;
    });
    var root = this;
    // AMD Loader
    if (typeof define === "function" && define.amd) define(function() {
        "use strict";
        return showdown;
    });
    else if (0, module.exports) module.exports = showdown;
    else root.showdown = showdown;
}).call(this);

},{}],"fgu1o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_muliselect_webcomponent", ()=>c_muliselect_webcomponent);
parcelHelpers.export(exports, "web_c_muliselect", ()=>web_c_muliselect);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbSelect = require("../controls/cb_select");
class c_muliselect_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_muliselect(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-multiselect", c_muliselect_webcomponent);
class web_c_muliselect extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, option, keys, i, id, label, lkid, selected_options, selection_string, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, so;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg;
                    _this.cb_select_control.default_label = cfg.default_label || "";
                    _this.options = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (cfg.extra_options && cfg.extra_options.length > 0) try {
                        for(_iterator = cfg.extra_options[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            option = _step.value;
                            _this.options.push(option);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (cfg.options && cfg.options.length > 0) {
                        keys = Object.keys(cfg.options[0]);
                        for(var i in cfg.options){
                            if (typeof cfg.options[i] == "string") _this.options.push({
                                value: cfg.options[i],
                                label: cfg.options[i],
                                full: cfg.options[i]
                            });
                            else if (typeof cfg.options[i] == "object") {
                                id = "";
                                if (cfg.value_column) id = cfg.options[i][cfg.value_column];
                                else id = cfg.options[i][keys[0]];
                                label = "";
                                if (cfg.label_column) label = cfg.options[i][cfg.label_column];
                                else {
                                    lkid = 0;
                                    if (keys.length > 1) lkid = 1;
                                    label = cfg.options[i][keys[lkid]];
                                }
                                _this.options.push({
                                    value: id,
                                    label: label,
                                    full: cfg.options[i]
                                });
                            }
                        }
                    }
                    if (cfg.no_loader) _this.no_loader = true;
                    else _this.no_loader = false;
                    cfg.multiselect = true;
                    _this.cb_select_control.setOptions(_this.options, cfg);
                    selected_options = _this.cb_select_control.setMultiSelectValue(cfg.value, cfg);
                    selection_string = "";
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (selected_options) try {
                        for(_iterator1 = selected_options[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            so = _step1.value;
                            if (selection_string != "") selection_string += ",";
                            if (typeof so == "object") selection_string += so[cfg.value_column || "value"];
                            else selection_string += so;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _this.selection_string = selection_string;
                    return [
                        2,
                        {
                            "@": selection_string || "",
                            "@array": selected_options
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id + "$container");
        var loader = document.getElementById(this.brick_id + "_loader");
        if (status == "loading" && !this.no_loader) {
            if (container) container.classList.add("loading");
            if (loader) loader.classList.add("loader-loading");
        } else {
            if (container) container.classList.remove("loading");
            if (loader) loader.classList.remove("loader-loading");
        }
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.cfg.validation) {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) {
                if (this.cfg.validation.required && (this.selection_string === "" || this.selection_string === null || this.selection_string === undefined)) {
                    validates = false;
                    validation_message = (this.cfg.label || "Value") + " is required.";
                    var select = document.getElementById(this.brick_id + "$select");
                    if (select) select.classList.add("c-input-validation-failed");
                    return false;
                }
            }
        }
        var select1 = document.getElementById(this.brick_id + "$select");
        if (select1) select1.classList.remove("c-input-validation-failed");
        return true;
    }
    cb_snapshot() {
        return this.snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.no_loader = false;
        this.options = [];
        this.cfg = {};
        this.selection_string = "";
        this.snapshot = undefined;
        this.element = element;
        this.element.innerHTML = `<div id="${this.brick_id}"></div>`;
        var self = this;
        this.blueprint.ins.cfg.multiselect = true;
        this.cb_select_control = new (0, _cbSelect.cb_select)(this.brick_id, this.blueprint.ins.cfg, function(value, option_value) {
            var selection_string = "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (Array.isArray(value)) try {
                for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var so = _step.value;
                    if (selection_string != "") selection_string += ",";
                    selection_string += String(so);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else selection_string = String(value);
            self.selection_string = selection_string;
            self.snapshot = self.snapshot || {};
            self.snapshot.cfg = self.snapshot.cfg || {};
            self.snapshot.cfg.value = selection_string;
            self.cb_emit({
                "@": selection_string,
                "@user_changed": selection_string,
                "@array": value
            });
        }, this.context.platform);
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_select":"hya6j","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"hya6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cb_select", ()=>cb_select);
var _cbPopout = require("./cb_popout");
var _cbWebUtil = require("./cb_web_util");
class cb_select {
    setOptions(p_options, settings) {
        var _this = this, _loop = function(o) {
            var item = document.getElementById(_this.id + "$i$" + o);
            if (item) item.addEventListener("click", function() {
                var s = this.id.split("$");
                var idx = s[s.length - 1];
                if (self.is_multiselect) {
                    var unselected = false;
                    for(var i = 0; i < self.multi_selected_idxs.length; i++){
                        var mi = self.multi_selected_idxs[i];
                        if (mi == idx) {
                            self.multi_selected_idxs.splice(i, 1);
                            var prev_selected = document.getElementById(self.id + "$i$" + mi);
                            if (prev_selected) prev_selected.classList.remove(`c-multiselect-item-selected`);
                            unselected = true;
                            var select = document.getElementById(self.id + "$select");
                            if (select) select.innerHTML = self.getMultiselectLabel();
                            break;
                        }
                    }
                    if (!unselected) {
                        if (settings.max_selections) {
                            if (self.multi_selected_idxs.length >= settings.max_selections) {
                                var current_val = item.innerHTML;
                                item.innerHTML = `<span class="hilight-red" style="padding:0">Max ${settings.max_selections} allowed</span>`;
                                setTimeout(function() {
                                    item.innerHTML = current_val;
                                }, 500);
                                return;
                            }
                        }
                        self.multi_selected_idxs.push(Number(idx));
                        var select1 = document.getElementById(self.id + "$select");
                        if (select1) select1.innerHTML = self.getMultiselectLabel();
                        var all = document.getElementById(self.id + "$i$all");
                        if (all) all.classList.remove(`c-multiselect-item-selected`);
                        var selected = document.getElementById(self.id + "$i$" + idx);
                        if (selected) selected.classList.add(`c-multiselect-item-selected`);
                    }
                    self.multiselection_changed = true;
                } else {
                    self.closeSelect();
                    self.setSingleSelectValue(self.options[Number(idx)].value, self.settings);
                    if (self.callback) self.callback(self.options[self.selected_option_idx || 0].value, self.options[self.selected_option_idx || 0].full, self.options[self.selected_option_idx || 0].extra_option_idx);
                }
            });
        };
        this.options = [];
        this.all_idxs = [];
        this.settings = settings;
        var select = document.getElementById(this.id + "$select");
        if (select) {
            if (settings.disabled || settings.disable || p_options == null || p_options.length == 0) {
                this.disabled = true;
                select.classList.add("c-select-disabled");
                this.popout.disabled = true;
            } else {
                this.disabled = false;
                select.classList.remove("c-select-disabled");
                this.popout.disabled = false;
            }
        }
        var html = "";
        if (this.is_multiselect) {
            var all_selected = "";
            if (!settings.max_selections) html += `<div id="${this.id}$i$all" class="c-multiselect-item c-multiselect-all${all_selected}">${settings.max_selections ? "Select Max (" + settings.max_selections + ")" : "All"}</div>`;
        }
        var itemidx = 0;
        if (p_options && p_options.length > 0) {
            var keys = Object.keys(p_options[0]);
            for(var i in p_options){
                var option_selected = false;
                if (typeof p_options[i] != "object") {
                    if (this.is_multiselect && (settings.all_value || settings.all_value === 0) && p_options[i] === settings.all_value) continue;
                    html += `<div id="${this.id}$i$${itemidx++}" class="c-${this.is_multiselect}select-item">${p_options[i]}</div>`;
                    this.options.push({
                        value: p_options[i],
                        label: p_options[i],
                        full: p_options[i].full,
                        extra_option_idx: p_options[i].extra_option_idx
                    });
                    if (this.is_multiselect) this.all_idxs.push(itemidx);
                } else if (typeof p_options[i] == "object") {
                    var id = "";
                    id = p_options[i][keys[0]];
                    if (this.is_multiselect && (settings.all_value || settings.all_value === 0) && id === settings.all_value) continue;
                    if (this.is_multiselect) this.all_idxs.push(itemidx);
                    var label = "";
                    var lkid = 0;
                    if (keys.length > 1) lkid = 1;
                    label = p_options[i][keys[lkid]];
                    html += `<div id="${this.id}$i$${itemidx++}" class="c-${this.is_multiselect}select-item${option_selected ? " c-multiselect-item-selected" : ""}">${label}</div>`;
                    this.options.push({
                        value: id,
                        label: label,
                        full: p_options[i].full,
                        extra_option_idx: p_options[i].extra_option_idx
                    });
                }
            }
        }
        if (!this.initialized) {
            var drop = document.getElementById(this.id + "$drop");
            if (drop) drop.innerHTML = `<div class="c-select-search-container">
                <input type="text" id="${this.id}$search" class="form-element c-select-search-input" placeholder="Search" autocomplete="off"/>
            </div>
            <div id="${this.id}$items" tabindex="0" class="select-items">${html}</div>
            `;
        } else {
            var items_container = document.getElementById(`${this.id + "$items"}`);
            if (items_container) items_container.innerHTML = html;
        }
        var label1 = document.getElementById(`${this.id + "$label"}`);
        if (label1) {
            label1.innerHTML = settings.label || "";
            if ((settings.label || "") == "") label1.classList.add("hidden");
            else label1.classList.remove("hidden");
        }
        var container = document.getElementById(`${this.id}`);
        if (container) {
            if (settings.hidden) container.classList.add("hidden");
            else container.classList.remove("hidden");
        }
        var self = this;
        if (select) {
            select.tabIndex = 0;
            if (!this.initialized) select.addEventListener("keydown", function(event) {
                if (event.key == "Enter" || event.key == "ArrowDown") self.openSelect();
            });
        }
        if (this.is_multiselect) {
            var all_item = document.getElementById(this.id + "$i$all");
            if (all_item) all_item.addEventListener("click", function() {
                if (!self.disabled) {
                    var all_item = document.getElementById(self.id + "$i$all");
                    if (self.multi_selected_idxs.length == self.all_idxs.length) {
                        if (all_item) all_item.classList.remove(`c-multiselect-all-selected`);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = self.multi_selected_idxs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var idx = _step.value;
                                var item = document.getElementById(self.id + "$i$" + idx);
                                if (item) item.classList.remove(`c-multiselect-item-selected`);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        self.multi_selected_idxs = [];
                    } else {
                        if (all_item) all_item.classList.add(`c-multiselect-all-selected`);
                        var max = self.all_idxs.length;
                        if (self.settings.max_selections) {
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = self.multi_selected_idxs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var idx1 = _step1.value;
                                    var item1 = document.getElementById(self.id + "$i$" + idx1);
                                    if (item1) item1.classList.remove(`c-multiselect-item-selected`);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            max = self.settings.max_selections;
                        }
                        self.multi_selected_idxs = [];
                        var count = 0;
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = self.all_idxs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var idx2 = _step2.value;
                                self.multi_selected_idxs.push(idx2);
                                var item2 = document.getElementById(self.id + "$i$" + idx2);
                                if (item2) item2.classList.add(`c-multiselect-item-selected`);
                                count++;
                                if (count >= max) break;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    var select = document.getElementById(self.id + "$select");
                    if (select) select.innerHTML = self.getMultiselectLabel();
                    self.multiselection_changed = true;
                }
            });
        }
        for(var o = 0; o < this.options.length; o++)_loop(o);
        if (!this.initialized) {
            var searchbox = document.getElementById(this.id + "$search");
            if (searchbox) {
                searchbox.addEventListener("input", function(e) {
                    var text = e.target.value.toLowerCase();
                    for(var i = 0; i < self.options.length; i++){
                        var option = self.options[i];
                        var option_element = document.getElementById(self.id + "$i$" + i);
                        if (option_element) {
                            if (text.length == 0 || option.label.toLowerCase().indexOf(text) != -1) option_element.classList.remove("hidden");
                            else option_element.classList.add("hidden");
                        }
                    }
                });
                searchbox.addEventListener("keydown", function(event) {
                    if (event.key == "ArrowDown" || event.key == "Tab") {
                        var items = document.getElementById(self.id + "$items");
                        if (items) items.focus();
                        self.set_keyboard_selection(self.selected_option_idx || 0);
                        event.preventDefault();
                    } else if (event.key == "Escape") self.closeSelect();
                });
            }
            var items = document.getElementById(self.id + "$items");
            if (items) items.addEventListener("keydown", function(event) {
                if (event.key == "ArrowDown" || event.key == "Tab") {
                    if (event.key == "Tab" && self.keyboard_selected + 1 >= self.options.length) {
                        self.closeSelect();
                        var select = document.getElementById(self.id + "$select");
                        (0, _cbWebUtil.CBWebUtil).focusNextElement(false, select).focus();
                    } else self.set_keyboard_selection(self.keyboard_selected + 1);
                } else if (event.key == "ArrowUp") {
                    if (self.keyboard_selected == 0) {
                        var searchbox = document.getElementById(self.id + "$search");
                        if (searchbox && !self.search_hidden) {
                            searchbox.focus();
                            self.set_keyboard_selection(-1);
                        }
                    } else self.set_keyboard_selection(self.keyboard_selected - 1);
                } else if (event.key == "Enter") {
                    var item = document.getElementById(self.id + "$i$" + self.keyboard_selected);
                    if (item) item.click();
                } else if (event.key == "Escape") self.closeSelect();
                event.preventDefault();
            });
        }
        var searchbox1 = document.getElementById(this.id + "$search");
        if (searchbox1) {
            var search_entries = settings.search_entries;
            if (isNaN(search_entries) || !search_entries && search_entries !== 0) search_entries = 5;
            if (this.options.length <= Number(search_entries)) {
                searchbox1.classList.add("hidden");
                this.search_hidden = true;
            } else {
                searchbox1.classList.remove("hidden");
                this.search_hidden = false;
            }
        }
        this.initialized = true;
        this.popout.init();
    }
    setSingleSelectValue(value, settings) {
        var may_recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var ret_option = null;
        var option_set = !may_recurse;
        var first_option = null;
        if (this.options && this.options.length > 0) {
            var idx = 0;
            this.multi_selected_idxs = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var option = _step.value;
                    if (!first_option) first_option = option;
                    if (option.value == value) {
                        ret_option = option;
                        if (this.selected_option_idx !== null) {
                            var prev_selected = document.getElementById(this.id + "$i$" + this.selected_option_idx);
                            if (prev_selected) prev_selected.classList.remove(`c-select-item-selected`);
                        }
                        this.selected_option_idx = idx;
                        var select = document.getElementById(this.id + "$select");
                        if (select) select.innerHTML = this.options[this.selected_option_idx].label;
                        var selected = document.getElementById(this.id + "$i$" + this.selected_option_idx);
                        if (selected) selected.classList.add(`c-select-item-selected`);
                        this.selected_option_idx = idx;
                        option_set = true;
                        break;
                    }
                    idx++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else {
            var select1 = document.getElementById(this.id + "$select");
            if (select1) select1.innerHTML = "";
        }
        if (!option_set && first_option && may_recurse) return this.setSingleSelectValue(first_option.value, settings, false);
        return ret_option;
    }
    setMultiSelectValue(value, settings) {
        var selected_options = [];
        this.multi_selected_idxs = [];
        if (settings.all_value !== "" && (value == settings.all_value && (value || "") != "" || this.multi_selected_idxs.length == this.all_idxs.length && this.multi_selected_idxs.length > 0 || this.multi_selected_idxs.length == 0 && this.settings.all_by_default && (value || "") == "")) {
            var all_item = document.getElementById(this.id + "$i$all");
            if (all_item) all_item.classList.add(`c-multiselect-item-selected`);
            var select = document.getElementById(this.id + "$select");
            if (select) select.innerHTML = "All";
            return [
                {
                    value: settings.all_value
                }
            ];
        } else {
            var all_item1 = document.getElementById(this.id + "$i$all");
            if (all_item1) all_item1.classList.remove(`c-multiselect-item-selected`);
            var val_options = [];
            if (typeof value == "string" || typeof value == "number") {
                var str_options = (value + "").split(",");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = str_options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        val_options.push(s.trim());
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            if (Array.isArray(value)) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var v = _step1.value;
                        if (typeof v == "object") {
                            if (settings.value_column) val_options.push(value[settings.value_column]);
                            else {
                                var keys = Object.keys(v);
                                if (keys && keys.length > 0) {
                                    var key = keys[0];
                                    val_options.push(v[key]);
                                }
                            }
                        } else val_options.push(v);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
            if (this.options && this.options.length > 0) {
                var idx = 0;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.options[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var option = _step2.value;
                        var is_selected = false;
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = val_options[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var vo = _step3.value;
                                if (option.value == vo) {
                                    selected_options.push(option.value);
                                    is_selected = true;
                                    var selected = document.getElementById(this.id + "$i$" + idx);
                                    if (selected) selected.classList.add(`c-multiselect-item-selected`);
                                    this.multi_selected_idxs.push(idx);
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                        if (!is_selected) {
                            var selected1 = document.getElementById(this.id + "$i$" + idx);
                            if (selected1) selected1.classList.remove(`c-multiselect-item-selected`);
                        }
                        idx++;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var selected_label = this.getMultiselectLabel();
            var select1 = document.getElementById(this.id + "$select");
            if (select1) select1.innerHTML = selected_label;
        }
        return selected_options;
    }
    set_keyboard_selection(idx) {
        var item = document.getElementById(this.id + "$i$" + idx);
        if (item) {
            var prev_item = document.getElementById(this.id + "$i$" + this.keyboard_selected);
            if (prev_item) prev_item.classList.remove("c-select-item-kb-select");
            item.classList.add("c-select-item-kb-select");
            this.keyboard_selected = idx;
            item.scrollIntoView(false);
        }
    }
    multiselectClosed() {
        if (this.is_multiselect && this.callback && this.multiselection_changed) {
            this.value = [];
            if ((this.settings.all_value || this.settings.all_value === 0) && this.multi_selected_idxs.length == this.all_idxs.length) {
                this.callback([
                    this.settings.all_value
                ], [
                    this.settings.all_value
                ], [
                    this.settings.all_value
                ]);
                this.multiselection_changed = false;
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.multi_selected_idxs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mi = _step.value;
                    this.value.push(this.options[mi].value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.callback(this.value, this.value, this.value);
            this.multiselection_changed = false;
        }
    }
    getMultiselectLabel() {
        if (this.multi_selected_idxs.length == this.all_idxs.length && this.multi_selected_idxs.length > 0) return this.default_label || "All";
        else if (this.multi_selected_idxs.length == 0) return this.default_label || "None selected" + (this.settings.max_selections ? " (max " + this.settings.max_selections + ")" : "");
        else if (this.multi_selected_idxs.length <= this.settings.collapse_amount || 0 || this.platform == "file") {
            var ret = "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.multi_selected_idxs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (ret != "") ret += ", ";
                    ret += this.options[i].label;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return ret;
        } else return this.multi_selected_idxs.length + " selected";
    }
    openSelect() {
        this.popout.openPopout(this.popout);
    }
    closeSelect() {
        this.popout.closeSelect();
    }
    constructor(id, settings, callback, platform){
        this.options = [];
        this.selected_option_idx = null;
        this.multi_selected_idxs = [];
        this.all_idxs = [];
        this.open = false;
        this.initialized = false;
        this.mouse_is_over = false;
        this.is_multiselect = "";
        this.multiselection_changed = false;
        this.open_offset = null;
        this.keyboard_selected = 0;
        this.popout = {};
        this.disabled = false;
        this.search_hidden = false;
        this.default_label = "None Selected";
        this.platform = "";
        this.id = id;
        this.callback = callback;
        this.platform = platform;
        var container = document.getElementById(id);
        if (settings.multiselect) this.is_multiselect = "multi";
        if (container) {
            var transformed_select = false;
            var extract_options = [];
            if (container.tagName == "SELECT") {
                transformed_select = true;
                var select_options = container.options;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = select_options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var o = _step.value;
                        extract_options.push({
                            value: o.value,
                            label: o.text
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var new_container = document.createElement("div");
                container.insertAdjacentElement("afterend", new_container);
                container.style.display = "none";
                container = new_container;
            }
            var label = "";
            var classes = "";
            var styles = "";
            if (settings) {
                var cfg = settings;
                label = cfg.label;
                if (label && label[0] == "{") label = "";
                if (cfg.style) {
                    for(var v in cfg.style)if (v != "src") styles += v + ":" + cfg.style[v] + ";";
                }
                if (cfg.style_classes) for(var cl in cfg.style_classes)classes += " " + cfg.style_classes[cl];
            }
            container.classList.add("form-element-container");
            container.classList.add(`c-${this.is_multiselect}select-container`);
            var html = "";
            if (!transformed_select) {
                var display = "";
                if ((label || "") == "") display = `style="display:none"`;
                html = `<label for="${this.id}$select" class="form-element-label c-${this.is_multiselect}select-label" id="${this.id + "$label"}" ${display}>${label || ""}</label>`;
            }
            html += `<div id="${this.id}$select" class="form-element c-${this.is_multiselect}select ${classes}" style="${styles}" tabindex="0"></div>`;
            container.innerHTML = html;
            var self = this;
            this.popout = new (0, _cbPopout.cb_popout)(id, settings.multiselect, settings, "c-select", true, false, function() {
                self.set_keyboard_selection(self.selected_option_idx || 0);
                if (!self.search_hidden) {
                    var searchbox = document.getElementById(self.id + "$search");
                    if (searchbox) {
                        if (searchbox.classList.contains("hidden")) ;
                        else {
                            searchbox.value = "";
                            searchbox.dispatchEvent(new Event("input", {
                                bubbles: true
                            }));
                            searchbox.focus();
                        }
                    }
                } else {
                    var items = document.getElementById(self.id + "$items");
                    if (items) items.focus();
                }
            }, function() {
                self.multiselectClosed();
            });
            if (transformed_select) {
                this.setOptions(extract_options, settings);
                this.setSingleSelectValue(settings.value, settings);
            }
        }
    }
}

},{"./cb_popout":"8UNLF","./cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5TUqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_notifier_webcomponent", ()=>c_notifier_webcomponent);
parcelHelpers.export(exports, "web_c_notifier", ()=>web_c_notifier);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class c_notifier_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_notifier(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-notifier", c_notifier_webcomponent);
class web_c_notifier extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var notification, message, container, self, open_id;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "show") {
                    notification = document.getElementById(_this.brick_id + "$notification");
                    if (notification) {
                        message = cfg.message;
                        notification.classList.remove("c-notifier-error");
                        notification.classList.remove("c-notifier-alert");
                        notification.classList.remove("c-notifier-success");
                        notification.classList.remove("c-notifier-info");
                        notification.classList.remove("c-notifier-pinned");
                        notification.classList.add("c-notifier-pin");
                        if (cfg.type) cfg.type = cfg.type.toLowerCase();
                        if (cfg.type == "error") {
                            notification.classList.add("c-notifier-error");
                            message = message || "An error occurred and the action could not be completed.";
                        } else if (cfg.type == "alert") notification.classList.add("c-notifier-alert");
                        else if (cfg.type == "success") {
                            notification.classList.add("c-notifier-success");
                            message = message || "The action was completed successfully.";
                        } else notification.classList.add("c-notifier-info");
                        notification.innerHTML = message;
                    }
                    container = document.getElementById(_this.brick_id);
                    if (container) {
                        _this.latest_notification_id++;
                        container.classList.add("c-notifier-container-show");
                        if (_this.blueprint.ins.cfg && _this.blueprint.ins.cfg.auto_hide_ms) {
                            self = _this;
                            open_id = _this.latest_notification_id;
                            setTimeout(function() {
                                if (container && self.latest_notification_id == open_id && !self.clicked_on) container.classList.remove("c-notifier-container-show");
                            }, _this.blueprint.ins.cfg.auto_hide_ms);
                        }
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.clicked_on = false;
        this.latest_notification_id = 0;
        this.element = element;
        var innerHTML = `<div class="c-notifier-base" id="${this.brick_id}"><div class="c-notifier-container">
            <div id="${this.brick_id}$notification" class="c-notifier-notification c-notifier-info"></div>
        </div></div>`;
        window.document.body.insertAdjacentHTML("beforeend", innerHTML);
        var self = this;
        var container = document.getElementById(this.brick_id);
        if (container) window.addEventListener("mousedown", function(e) {
            if (container) {
                if (container.contains(e.target)) {
                    self.clicked_on = !self.clicked_on;
                    var notification = document.getElementById(self.brick_id + "$notification");
                    if (notification) {
                        if (self.clicked_on) {
                            notification.classList.remove("c-notifier-pin");
                            notification.classList.add("c-notifier-pinned");
                        } else {
                            notification.classList.remove("c-notifier-pinned");
                            notification.classList.add("c-notifier-pin");
                        }
                    }
                } else {
                    container.classList.remove("c-notifier-container-show");
                    self.clicked_on = false;
                    var notification1 = document.getElementById(self.brick_id + "$notification");
                    if (notification1) {
                        notification1.classList.remove("c-notifier-pinned");
                        notification1.classList.add("c-notifier-pin");
                    }
                }
            }
        });
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2D4vt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_pager_webcomponent", ()=>c_pager_webcomponent);
parcelHelpers.export(exports, "web_c_pager", ()=>web_c_pager);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPager = require("../controls/cb_pager");
var _cbWebUtil = require("../controls/cb_web_util");
class c_pager_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_pager(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-pager", c_pager_webcomponent);
class web_c_pager extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var container, _tmp, _;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            2
                        ];
                        _this.count = cfg.count || 0;
                        if (cfg.data) {
                            _this.count = cfg.data.length;
                            _this.data = cfg.data;
                        }
                        if (cfg.page !== undefined && cfg.page !== -1 && cfg.page !== null) _this.page = cfg.page;
                        _this.page_size = cfg.page_size || 12;
                        _this.num_pages = Math.ceil(_this.count / _this.page_size);
                        container = document.getElementById(_this.brick_id);
                        if (container) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                        _tmp = {};
                        _ = "@";
                        return [
                            4,
                            _this.setPage(_this.page, false)
                        ];
                    case 1:
                        return [
                            2,
                            (_tmp[_] = _state.sent(), _tmp)
                        ];
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    setPage(page) {
        var emit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var offset, page_data, i, obj;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.page = page;
                        offset = page * _this.page_size;
                        page_data = [];
                        if (_this.data) {
                            if (_this.data.length > offset) for(i = offset; i < _this.data.length && i < offset + _this.page_size; i++)page_data.push(_this.data[i]);
                        }
                        return [
                            4,
                            _this.pager.setPages(_this.count, _this.page_size, _this.page)
                        ];
                    case 1:
                        _state.sent();
                        obj = {
                            offset: offset,
                            page_size: _this.page_size,
                            page: page,
                            page_data: page_data
                        };
                        if (emit) _this.cb_emit({
                            "@": obj
                        });
                        return [
                            2,
                            obj
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "required") {
            var input = document.getElementById("#" + this.brick_id);
            if (input) input.classList.add("required");
        }
        if (status == "loading") {
            var input1 = document.getElementById("#" + this.brick_id);
            if (input1) input1.classList.add("loading");
        } else if (status == "") {
            var input2 = document.getElementById("#" + this.brick_id);
            if (input2) {
                input2.classList.remove("required");
                input2.classList.remove("loading");
            }
        }
    }
    cb_pager_evt(goto_page) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                _this.setPage(goto_page);
                return [
                    2
                ];
            });
        })();
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.count = 0;
        this.page_size = 12;
        this.page = 0;
        this.num_pages = 1;
        this.initial_sent = false;
        this.element = element;
        var html = `<div id="${this.brick_id}"></div>`;
        this.element.innerHTML = html;
        var self = this;
        this.pager = new (0, _cbPager.cb_pager)(this.brick_id, {}, function() {
            var _ref = (0, _asyncToGenerator._)(function(value) {
                return (0, _tsGenerator._)(this, function(_state) {
                    self.cb_pager_evt(value);
                    return [
                        2
                    ];
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_pager":"dC2Kp","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"dC2Kp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cb_pager", ()=>cb_pager);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
class cb_pager {
    setPages(entry_count, page_size, current_page_p) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var max_page_number_buttons, num_pages, handlers, disabled, html, page, active, page1, active1, pn_start, pn_end, pn, active2, from, to, self, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, h, button_id, button;
            return (0, _tsGenerator._)(this, function(_state) {
                _this.entry_count = entry_count;
                _this.page_size = page_size;
                max_page_number_buttons = 5;
                num_pages = Math.ceil(entry_count / page_size);
                if (current_page_p < num_pages) _this.current_page = current_page_p;
                else _this.current_page = num_pages - 1;
                handlers = [];
                disabled = "";
                if (_this.current_page == 0) disabled = " c-pager-button-disabled";
                else handlers.push("prev");
                html = `<div class="c-pager"><div class="c-pager-buttons"><button class="btn c-pager-button c-pager-button-inactive c-pager-prev${disabled}" id="${_this.id}$prev"></button>`;
                if (num_pages <= max_page_number_buttons) for(page = 0; page < num_pages; page++){
                    active = " c-pager-button-inactive";
                    if (page == _this.current_page) active = " btn-primary c-pager-button-active";
                    else handlers.push("" + page);
                    html += `<button class="btn c-pager-button c-pager-page${active}" id="${_this.id}$${page}">${page + 1}</button>`;
                }
                else {
                    page1 = 0;
                    active1 = " c-pager-button-inactive";
                    if (page1 == _this.current_page) active1 = " btn-primary c-pager-button-active";
                    else handlers.push("" + page1);
                    html += `<button class="btn c-pager-button c-pager-page${active1}" id="${_this.id}$${page1}">${page1 + 1}</button>`;
                    if (_this.current_page > 2) html += `<button class="btn c-pager-button c-pager-page c-pager-button-disabled">...</button>`;
                    pn_start = _this.current_page - 1;
                    pn_end = _this.current_page + 1;
                    if (pn_start < 1) pn_start = 1;
                    if (pn_end >= num_pages - 2) pn_end = num_pages - 2;
                    for(pn = pn_start; pn <= pn_end; pn++){
                        active2 = " c-pager-button-inactive";
                        if (pn == _this.current_page) active2 = " btn-primary c-pager-button-active";
                        else handlers.push("" + pn);
                        html += `<button class="btn c-pager-button c-pager-page${active2}" id="${_this.id}$${pn}">${pn + 1}</button>`;
                    }
                    if (_this.current_page < num_pages - 3) html += `<button class="btn c-pager-button c-pager-page c-pager-button-disabled">...</button>`;
                    page1 = num_pages - 1;
                    active1 = " c-pager-button-inactive";
                    if (page1 == _this.current_page) active1 = " btn-primary c-pager-button-active";
                    else handlers.push("" + page1);
                    html += `<button class="btn c-pager-button c-pager-page${active1}" id="${_this.id}$${page1}">${page1 + 1}</button>`;
                }
                disabled = "";
                if (_this.current_page >= num_pages - 1) disabled = " c-pager-button-disabled";
                else handlers.push("next");
                html += `<button class="btn c-pager-button c-pager-button-inactive c-pager-next${disabled}" id="${_this.id}$next"></button>`;
                from = _this.current_page * _this.page_size + 1;
                if (from < 0) from = 0;
                to = from + _this.page_size - 1;
                if (to > _this.entry_count) to = _this.entry_count;
                html += `</div><div class="c-pager-info">Showing ` + from + " to " + to + " of " + _this.entry_count + "</div></div>";
                _this.container.innerHTML = html;
                self = _this;
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(_iterator = handlers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        h = _step.value;
                        button_id = _this.id + "$" + h;
                        button = document.getElementById(button_id);
                        if (button) button.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                            var button_id, s, page;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        button_id = this.id;
                                        s = button_id.split("$");
                                        page = s[s.length - 1];
                                        return [
                                            4,
                                            self.setPage(page)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    setPage(page) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var goto_page;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        goto_page = 0;
                        if (page == "next") goto_page = _this.current_page + 1;
                        else if (page == "prev") {
                            if (_this.current_page <= 0) return [
                                2
                            ];
                            goto_page = _this.current_page - 1;
                        } else goto_page = Number(page);
                        return [
                            4,
                            _this.callback(goto_page)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    constructor(id, settings, callback){
        this.id = id;
        this.callback = callback;
        this.container = document.getElementById(id);
        this.entry_count = 0;
        this.page_size = 10;
        this.current_page = 0;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"4cEni":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_radio_webcomponent", ()=>c_radio_webcomponent);
parcelHelpers.export(exports, "web_c_radio", ()=>web_c_radio);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _cbWebUtil = require("../controls/cb_web_util");
class c_radio_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_radio(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-radio", c_radio_webcomponent);
class web_c_radio extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    _this.setDisplay(cfg)
                ];
            });
        })();
    }
    setDisplay(cfg) {
        this.cfg = cfg;
        if (!this.initialised) {
            var tooltip = "";
            if (cfg.tooltip && cfg.tooltip.text) tooltip = ` tooltip="${cfg.tooltip.text}"`;
            var checked = "";
            if (cfg.selected) checked = `checked="checked"`;
            this.element.innerHTML = `<input type="radio" name="${cfg.group_name}" id="${this.brick_id}" value="${cfg.value || cfg.value === 0 ? cfg.value : cfg.label}" class="c-radio" ${tooltip} ${checked}></input><label for="${this.brick_id}">${cfg.label}</label>`;
            var self = this;
            var btn = document.getElementById(`${this.brick_id}`);
            if (btn) {
                btn.addEventListener("change", function() {
                    var _ref = (0, _asyncToGenerator._)(function(e) {
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (window.cb_popout_global && window.cb_popout_global.window_click_handler) window.cb_popout_global.window_click_handler(e);
                                    return [
                                        4,
                                        self.cb_emit({
                                            "@": self.cfg.value || self.cfg.value === 0 ? self.cfg.value : self.cfg.label
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
                if (cfg.tooltip && cfg.tooltip.text) (0, _cbTooltip.cb_tooltip).set_tooltip(btn);
            }
            this.initialised = true;
        }
        var btn1 = document.getElementById(`${this.brick_id}`);
        if (btn1) {
            if (cfg.style) for(var v in cfg.style)btn1.style.setProperty(v, cfg.style[v]);
            if (cfg.tooltip && cfg.tooltip.text) {
                btn1.setAttribute("tooltip", cfg.tooltip.text);
                (0, _cbTooltip.cb_tooltip).set_tooltip(btn1);
            }
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(btn1, cfg, "button");
            if (cfg.nativeoptions && cfg.nativeoptions.html) {
                if (cfg.nativeoptions.html.attributes) for(var attribute in cfg.nativeoptions.html.attributes)btn1.setAttribute(attribute, cfg.nativeoptions.html.attributes[attribute]);
            }
            if (cfg.hidden) btn1.classList.add("hidden");
            else btn1.classList.remove("hidden");
            if (cfg.disabled) btn1.disabled = true;
            else btn1.disabled = false;
            if (cfg.selected) return {
                "@": cfg.value || cfg.value === 0 ? cfg.value : cfg.label
            };
        }
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var button;
            return (0, _tsGenerator._)(this, function(_state) {
                button = document.getElementById(_this.brick_id);
                if (status == "loading" && !_this.no_loader) {
                    if (button) {
                        button.classList.add("loader");
                        button.classList.add("btn-loader-loading");
                        button.disabled = true;
                    }
                } else if (button) {
                    button.classList.remove("btn-loader-loading");
                    button.classList.remove("loader");
                    button.disabled = false;
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_trigger_submit() {
        var btn = document.getElementById(`${this.brick_id}`);
        if (btn) btn.click();
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.style_classes = [];
        this.initialised = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"364SY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_rangeslider_webcomponent", ()=>c_rangeslider_webcomponent);
parcelHelpers.export(exports, "web_c_rangeslider", ()=>web_c_rangeslider);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _select = require("../../shared-funcs/Select");
var _cbWebUtil = require("../controls/cb_web_util");
class c_rangeslider_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_rangeslider(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-rangeslider", c_rangeslider_webcomponent);
class web_c_rangeslider extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _$input, options_html, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, option, val, html, container, _$input1, self;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "value") {
                    _this.value = cfg;
                    _$input = document.getElementById(`${_this.brick_id}`);
                    if (_$input) {
                        _$input.value = _this.value;
                        return [
                            2,
                            {
                                "@": _this.value
                            }
                        ];
                    }
                } else if (input == "cfg") {
                    _this.options = (0, _select.Select).getOptions(cfg, _this.blueprint);
                    options_html = "";
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (_this.options) try {
                        for(_iterator = _this.options[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            option = _step.value;
                            options_html += `<option value="${option.value}" label="${option.label}"></option>`;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (options_html) options_html = `<datalist id="${_this.brick_id}$datalist" class="c-rangelsider-datalist">${options_html}</datalist>`;
                    val = cfg.value !== undefined ? `value="${cfg.value}"` : "";
                    html = `<label class="form-element-label c-rangeslider-label" id="${_this.brick_id}$label" for="${_this.brick_id}"></label>
                <input ${val} class="c-rangeslider" type="range" min="${cfg.min}" max="${cfg.max}" step=${cfg.step} id="${_this.brick_id}" list="${_this.brick_id}$list" />${options_html}`;
                    container = document.getElementById(_this.brick_id + "$container");
                    if (container) {
                        container.innerHTML = html;
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                    }
                    _$input1 = document.getElementById(_this.brick_id);
                    if (_$input1) {
                        _this.value = _$input1.value;
                        self = _this;
                        _$input1.addEventListener("input", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        self.value = _$input1.value;
                                        return [
                                            4,
                                            self.cb_emit({
                                                "@": self.value,
                                                "@user_changed": self.value
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(_$input1, cfg, "slider");
                    }
                    return [
                        2,
                        {
                            "@": _this.value
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {
        return {
            value: this.value
        };
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.options = [];
        this.element = element;
        this.element.innerHTML = `<div class="form-element-container c-rangeslider-container" id="${this.brick_id}$container">
                
                </div>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/Select":"avAW2","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"avAW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var Select = /** @class */ function() {
    function Select() {}
    Select.getOptions = function(cfg, blueprint) {
        var options = [];
        if (cfg.extra_options && cfg.extra_options.length > 0) this.addOptions(cfg.extra_options, cfg, blueprint, options, true);
        if (cfg.options && cfg.options.length > 0) this.addOptions(cfg.options, cfg, blueprint, options);
        return options;
    };
    Select.addOptions = function(add_options, cfg, blueprint, options, is_extra_options) {
        if (is_extra_options === void 0) is_extra_options = false;
        if (add_options && add_options.length > 0) {
            var keys = Object.keys(add_options[0]);
            for(var i in add_options){
                if (typeof add_options[i] != "object") {
                    var option = {
                        value: add_options[i],
                        label: add_options[i],
                        full: add_options[i]
                    };
                    if (is_extra_options) option.extra_option_idx = i;
                    options.push(option);
                } else if (typeof add_options[i] == "object") {
                    var id = "";
                    if (cfg.value_column && keys.includes(cfg.value_column)) id = add_options[i][cfg.value_column];
                    else id = add_options[i][keys[0]];
                    var label = "";
                    if (cfg.label_column && keys.includes(cfg.label_column)) label = add_options[i][cfg.label_column];
                    else {
                        var lkid = 0;
                        if (keys.length > 1) lkid = 1;
                        label = add_options[i][keys[lkid]];
                    }
                    var option = {
                        value: id,
                        label: label,
                        full: add_options[i]
                    };
                    if (is_extra_options) option.extra_option_idx = i;
                    options.push(option);
                }
            }
        }
    };
    Select.getSingleValue = function(cfg, options, val) {
        if (options) {
            if (val || val === 0) for(var _i = 0, options_1 = options; _i < options_1.length; _i++){
                var option = options_1[_i];
                if (val == option.value) return {
                    value: option.value,
                    label: option.label,
                    full: option.full
                };
            }
        }
        if ((val === "" || val === undefined || val === null) && options.length > 0) return {
            value: options[0].value,
            label: options[0].label,
            full: options[0].full
        };
        return {
            value: undefined,
            label: undefined,
            full: {}
        };
    };
    Select.getMultiValue = function(cfg, options) {
        var val = cfg.value;
        var selected_options = [];
        if (options) {
            if (val !== "" && val !== undefined && val !== null) {
                var vals = val.split(",");
                for(var _i = 0, vals_1 = vals; _i < vals_1.length; _i++){
                    var v_ = vals_1[_i];
                    var v = v_.trim();
                    for(var _a = 0, options_2 = options; _a < options_2.length; _a++){
                        var option = options_2[_a];
                        if (v == option.value) selected_options.push(option);
                    }
                }
            }
        }
        var select_all = false;
        if (val == "" && cfg.all_by_default) select_all = true;
        if (selected_options.length == options.length) select_all = true;
        if (select_all && cfg.all_value) return {
            value: cfg.all_value,
            label: "All",
            option_objects: options
        };
        var value_str = "";
        var label_str = "";
        for(var _b = 0, selected_options_1 = selected_options; _b < selected_options_1.length; _b++){
            var o = selected_options_1[_b];
            if (value_str) {
                value_str += ",";
                label_str += ", ";
            }
            value_str += o.value;
            label_str += o.label;
        }
        return {
            value: value_str,
            label: label_str,
            option_objects: selected_options
        };
    };
    return Select;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"eiHGl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_select_webcomponent", ()=>c_select_webcomponent);
parcelHelpers.export(exports, "web_c_select", ()=>web_c_select);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbSelect = require("../controls/cb_select");
var _select = require("../../shared-funcs/Select");
class c_select_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var ins = this.getAttribute("ins");
            this.ci = new web_c_select(context, cid, name, dc, Number(idx), container_id, this, ins);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-select", c_select_webcomponent);
class web_c_select extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var val, extra_option_idx, extra_option, selected_option;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.options = (0, _select.Select).getOptions(cfg, _this.blueprint);
                    _this.validation = cfg.validation || [];
                    val = cfg.value;
                    if (typeof val == "string" && val.startsWith(" ")) {
                        extra_option_idx = Number(val.trim());
                        if (!isNaN(extra_option_idx)) {
                            extra_option = _this.options.find((o)=>o.extra_option_idx == extra_option_idx);
                            if (extra_option) val = extra_option.value;
                        }
                    }
                    if (_this.initialised) {
                        if (!_this.IsInsLeafFiring(input, "value")) val = _this.value;
                    }
                    _this.cb_select_control.setOptions(_this.options, cfg);
                    selected_option = _this.cb_select_control.setSingleSelectValue(val, cfg);
                    _this.initialised = true;
                    if (selected_option) {
                        _this.value = selected_option.value;
                        return [
                            2,
                            {
                                "@": selected_option.value,
                                "@option_object": selected_option.full
                            }
                        ];
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        var container = document.getElementById(this.brick_id + "$container");
        var loader = document.getElementById(this.brick_id + "_loader");
        if (status == "loading" && !this.no_loader) {
            if (container) container.classList.add("loading");
            if (loader) loader.classList.add("loader-loading");
        } else {
            if (container) container.classList.remove("loading");
            if (loader) loader.classList.remove("loader-loading");
        }
    }
    cb_validate() {
        if (this.validation && Array.isArray(this.validation)) {
            var select = document.getElementById(this.brick_id + "$select");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.validation[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var invalid = _step.value;
                    if (this.value == invalid) {
                        if (select) select.classList.add("c-select-validation-failed");
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (select) select.classList.remove("c-select-validation-failed");
        }
        return true;
    }
    cb_snapshot() {
        console.log("c-select " + this.brick_id + " cb_snapshot: " + JSON.stringify(this.value));
        return this.snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element, standalone_ins){
        super(context, cid, name, dc, idx, container_id, standalone_ins);
        this.initialised = false;
        this.options = [];
        this.no_loader = false;
        this.snapshot = undefined;
        this.value = undefined;
        this.validation = [];
        this.element = element;
        if (cid == undefined) {
            this.blueprint.name = element.id;
            this.brick_id = element.id + "_brick";
            window.so_bricks = window.so_bricks || {};
            window.so_bricks[this.brick_id] = this;
        }
        this.element.innerHTML = `<div id="${this.brick_id}"></div>`;
        var self = this;
        this.cb_select_control = new (0, _cbSelect.cb_select)(this.brick_id, this.blueprint.ins.cfg, function(value, option_object, extra_option_idx) {
            self.snapshot = self.snapshot || {};
            self.snapshot.cfg = self.snapshot.cfg || {};
            if (extra_option_idx !== undefined) self.snapshot.cfg.value = " " + extra_option_idx;
            else self.snapshot.cfg.value = value;
            self.value = value;
            self.cb_emit({
                "@": value,
                "@option_object": option_object,
                "@user_changed": value
            });
        }, this.context.platform);
        if (cid == undefined) setTimeout(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
            var _tmp, _tmp1, _i, input, ret;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [];
                        for(_tmp1 in self.blueprint.ins)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            4
                        ];
                        input = _tmp[_i];
                        return [
                            4,
                            self.cb_event(input, self.blueprint.ins[input], {})
                        ];
                    case 2:
                        ret = _state.sent();
                        _state.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }), 0);
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_select":"hya6j","../../shared-funcs/Select":"avAW2","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5E9ry":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_switch_webcomponent", ()=>c_switch_webcomponent);
parcelHelpers.export(exports, "web_c_switch", ()=>web_c_switch);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class c_switch_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_switch(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-switch", c_switch_webcomponent);
class web_c_switch extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var html, btnid, selected_id, set_selected_class, container, switches, keys, i, checked, id, label, lkid, checked1, switch_container, label1;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.options = cfg.options;
                    html = "";
                    btnid = 0;
                    selected_id = cfg.value === undefined || cfg.value == "" ? null : cfg.value;
                    set_selected_class = "";
                    container = document.getElementById(_this.brick_id + "$container");
                    switches = document.getElementById(_this.brick_id);
                    if (switches) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(switches, cfg, "switchgroup");
                    if (_this.options && _this.options.length > 0) {
                        keys = Object.keys(_this.options[0]);
                        for(var i in _this.options){
                            if (typeof _this.options[i] == "string") {
                                set_selected_class = "c-switch-button-inactive";
                                if (selected_id === null) {
                                    if (cfg.display && cfg.display.toLowerCase().indexOf("radio") != -1) selected_id = _this.options[i];
                                    else {
                                        selected_id = _this.options[i];
                                        _this.selected_idx = 0;
                                    }
                                }
                                checked = "";
                                if (selected_id === _this.options[i]) {
                                    set_selected_class = "btn-primary c-switch-btn-active";
                                    _this.selected_idx = btnid;
                                    checked = "checked";
                                } else set_selected_class = "btn-secondary c-switch-btn-inactive";
                                if (cfg.display && cfg.display.toLowerCase().indexOf("radio") != -1) {
                                    html += `<div><input type="radio" id="${_this.brick_id + "$" + btnid}" name="${_this.brick_id}" value="${_this.options[i]}" ${checked}><label for="${_this.brick_id + "$" + btnid}">${_this.options[i]}</label></div>`;
                                    btnid++;
                                } else html += `<button id="${_this.brick_id + "$" + btnid++}" class="btn btn-group-btn c-switch-button ${set_selected_class}" value="${_this.options[i]}" ${_this.selected_idx === btnid ? ' checked="checked"' : ""}>${_this.options[i]}</button>`;
                            } else if (typeof _this.options[i] == "object") {
                                id = "";
                                if (cfg.value_column) id = _this.options[i][cfg.value_column];
                                else id = _this.options[i][keys[0]];
                                label = "";
                                if (cfg.label_column) label = _this.options[i][cfg.label_column] || "";
                                else {
                                    lkid = 0;
                                    if (keys.length > 1) lkid = 1;
                                    label = _this.options[i][keys[lkid]] || "";
                                }
                                if (selected_id === null) {
                                    if (cfg.display && cfg.display.toLowerCase().indexOf("radio") != -1) selected_id = id;
                                    else {
                                        selected_id = id;
                                        _this.selected_idx = 0;
                                    }
                                }
                                checked1 = "";
                                set_selected_class = "";
                                if (selected_id === id) {
                                    set_selected_class = "btn-primary c-switch-btn-active";
                                    _this.selected_idx = btnid;
                                    checked1 = "checked";
                                } else set_selected_class = "btn-secondary c-switch-btn-inactive";
                                if (cfg.display && cfg.display.toLowerCase().indexOf("radio") != -1) {
                                    html += `<div><input type="radio" id="${_this.brick_id + "$" + btnid}" name="${_this.brick_id}" value="${id}" ${checked1}><label for="${_this.brick_id + "$" + btnid}">${label || ""}</label></div>`;
                                    btnid++;
                                } else html += `<button id="${_this.brick_id + "$" + btnid++}" class="btn c-switch-button ${set_selected_class} " value="${id}">${label || ""}</button>`;
                            }
                        }
                    }
                    switch_container = document.getElementById(_this.brick_id);
                    if (switch_container) {
                        if (cfg.display && cfg.display.toLowerCase().indexOf("radio") != -1) switch_container.classList.add("c-switch-radios");
                        else switch_container.classList.add("c-switch-button-group");
                        switch_container.innerHTML = html;
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(switch_container, cfg, "container");
                    }
                    label1 = document.getElementById(`${_this.brick_id + "$label"}`);
                    if (label1) {
                        label1.innerHTML = cfg.label || "";
                        if (!cfg.label) label1.classList.add("hidden");
                        else label1.classList.remove("hidden");
                    }
                    _this.set_event_handlers(cfg);
                    if (!cfg.user_changes_only) return [
                        2,
                        {
                            "@": selected_id,
                            "@option_object": _this.options[_this.selected_idx]
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    set_event_handlers(cfg) {
        var options = cfg.options;
        var self = this;
        cfg.extra_option && cfg.extra_option.value;
        var idx = 0;
        if (options && options.length > 0) {
            var _this = this, _loop = function(i) {
                var value = void 0;
                if (typeof options[i] == "string") value = options[i];
                else if (typeof options[i] == "object") {
                    if (cfg.value_column) value = options[i][cfg.value_column];
                    else value = options[i][keys[0]];
                }
                var btn = document.getElementById(_this.brick_id + "$" + i);
                if (btn) {
                    var btn_idx = idx;
                    btn.addEventListener("click", function() {
                        if (cfg.display && cfg.display.toLowerCase().indexOf("radio") != -1) ;
                        else {
                            var current_selected = document.getElementById(self.brick_id + "$" + self.selected_idx);
                            if (current_selected) {
                                current_selected.classList.remove("btn-primary");
                                current_selected.classList.remove("c-switch-btn-active");
                                current_selected.classList.add("btn-secondary");
                                current_selected.classList.add("c-switch-btn-inactive");
                            }
                            self.selected_idx = btn_idx;
                            var new_selected = document.getElementById(self.brick_id + "$" + self.selected_idx);
                            if (new_selected) {
                                new_selected.classList.add("btn-primary");
                                new_selected.classList.add("c-switch-btn-active");
                                new_selected.classList.remove("c-switch-btn-inactive");
                                new_selected.classList.remove("btn-secondary");
                            }
                        }
                        self.snapshot = self.snapshot || {};
                        self.snapshot.cfg = self.snapshot.cfg || {};
                        self.snapshot.cfg.value = value;
                        self.cb_emit({
                            "@": value,
                            "@option_object": self.options[self.selected_idx],
                            "@user_changed": value
                        });
                    });
                }
                idx++;
            };
            var keys = Object.keys(this.options[0]);
            for(var i in options)_loop(i);
        }
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {
        return this.snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.options = [];
        this.initial_sent = false;
        this.selected_idx = undefined;
        this.snapshot = undefined;
        this.element = element;
        var label = "";
        if (this.blueprint.ins.cfg) label = this.blueprint.ins.cfg.label || "";
        var html = `<div class='form-element-container c-switch-container' id="${this.brick_id}$container"><label for="${this.brick_id}" class="form-element-label c-switch-label" id="${this.brick_id + "$label"}">${label}</label><div class="btn-group" id="${this.brick_id}"></div></div>`;
        this.element.innerHTML = html;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"a5XRF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_template_form_webcomponent", ()=>c_template_form_webcomponent);
parcelHelpers.export(exports, "web_c_template_form", ()=>web_c_template_form);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _templateUtil = require("../../codebricks-runtime/TemplateUtil");
var _cbWebUtil = require("../controls/cb_web_util");
var _codemirror = require("codemirror");
var _autocomplete = require("@codemirror/autocomplete");
var _cbtemplateParser = require("../template_lang/cbtemplate-parser");
var _langHtml = require("@codemirror/lang-html");
var _common = require("@lezer/common");
var _language = require("@codemirror/language");
var _cbtemplateHighlight = require("../template_lang/cbtemplate-highlight");
var _tagElementPredictor = require("../template_lang/TagElementPredictor");
var _cbtemplateNodes = require("../template_lang/CBTemplateNodes");
var _langJavascript = require("@codemirror/lang-javascript");
var _view = require("@codemirror/view");
var _commands = require("@codemirror/commands");
var _cbTooltip = require("../controls/cb_tooltip");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
class c_template_form_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_template_form(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-template-form", c_template_form_webcomponent);
class web_c_template_form extends (0, _codeBrick.CodeBrick) {
    cb_update_cement(child_idx, cement, row_idx) {
        throw new Error("Method not implemented.");
    }
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var focused_id, selection, ed, editor, mod1_html, self, editor1, head;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "form")) return [
                            3,
                            2
                        ];
                        focused_id = null;
                        selection = null;
                        if (document.activeElement) {
                            ed = document.activeElement;
                            while(ed.parentElement){
                                if (ed.id.startsWith("e_vcb_")) {
                                    focused_id = ed.id;
                                    if (_this.editors_by_e_id[focused_id]) {
                                        editor = _this.editors_by_e_id[focused_id].editor;
                                        if (editor) selection = editor.state.selection.main;
                                    }
                                    break;
                                }
                                ed = ed.parentElement;
                            }
                        }
                        _this.enable_templating = cfg.enable_templating || false;
                        _this.container_id = `c${_this.brick_id}$${_this.nodeid}`;
                        _this.element.innerHTML = `<div id="${_this.brick_id}$form" class="editor-form">`;
                        if (!_this.initialised) {
                            mod1_html = `<cci-modal id="${_this.brick_id}$mod1" ins='{"cfg":{ "title":"Edit Tag", "cancel_button": "Cancel", "ok_button":"OK" }}'></cci-modal>
                <cci-modal id="${_this.brick_id}$mod2" ins='{"cfg":{ "title":"Edit Value", "cancel_button": "Cancel", "ok_button":"OK" }}'>      
                </cci-modal>`;
                            document.body.insertAdjacentHTML("beforeend", mod1_html);
                            self = _this;
                            (0, _cbutil.RegisterSOCallback)(_this.brick_id + "$mod2", "@", function() {
                                var _ref = (0, _asyncToGenerator._)(function(data) {
                                    var value, asjson, parsed, form_element, editor_property, editor_path, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, schema;
                                    return (0, _tsGenerator._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                value = window.so_bricks[self.brick_id + "$expanded_brick"].getValue();
                                                asjson = document.getElementById("asjson");
                                                if (!asjson.checked) return [
                                                    3,
                                                    3
                                                ];
                                                parsed = JSON.parse(value);
                                                return [
                                                    4,
                                                    self.get_form_element_by_path(data.node_path)
                                                ];
                                            case 1:
                                                form_element = _state.sent();
                                                editor_property = form_element.getAttribute("editor_property");
                                                editor_path = form_element.getAttribute("editor_path");
                                                editor_color = "editor-color-1";
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(_iterator = form_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        c = _step.value;
                                                        if (c.indexOf("editor-color") == 0) editor_color = c;
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                schema = self.get_path_schema(editor_path);
                                                if (schema.type == "schema") {
                                                    value = self.get_schema_path_value(editor_path, value);
                                                    schema.sub = true;
                                                    schema.prop_editable = true;
                                                }
                                                return [
                                                    4,
                                                    self.render_form_property(schema, editor_property, parsed, editor_path, editor_color, "string")
                                                ];
                                            case 2:
                                                form_element.outerHTML = _state.sent();
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 3:
                                                return [
                                                    4,
                                                    self.set_form_property_value(data.node_path, value)
                                                ];
                                            case 4:
                                                _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                window.so_bricks[self.brick_id + "$mod2_brick"].cb_event("hide", 1);
                                                self.convertInputDivsToCodemirror();
                                                return [
                                                    4,
                                                    self.cb_emit({
                                                        "@": self.get_form_value()
                                                    })
                                                ];
                                            case 6:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(data) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        }
                        _this.schema = cfg.schema;
                        return [
                            4,
                            _this.render_form_inputs(cfg.schema, cfg.data || {})
                        ];
                    case 1:
                        _state.sent();
                        (0, _cbTooltip.cb_tooltip).set_tooltips();
                        _this.initialised = true;
                        if (focused_id && _this.editors_by_e_id[focused_id]) {
                            editor1 = _this.editors_by_e_id[focused_id].editor;
                            head = _this.editors_by_e_id[focused_id].last_head;
                            if (editor1) {
                                if (head == -1) head = editor1.state.doc.length;
                                editor1.focus();
                                editor1.dispatch(editor1.state.update({
                                    selection: selection
                                }));
                            }
                        }
                        return [
                            2,
                            {
                                "@": _this.get_form_value()
                            }
                        ];
                    case 2:
                        if (input == "property") return [
                            2,
                            {
                                "@": _this.get_form_value()
                            }
                        ];
                        else if (input == "tag_editor_data") {
                            _this.sources = cfg.sources;
                            _this.specs = cfg.specs;
                            _this.composition_name = cfg.composition_name;
                            _this.container_name = cfg.container_name;
                            _this.composition_tree = cfg.composition_tree;
                            _this.brick_name = cfg.brick_name;
                            _this.brick_type = cfg.brick_type;
                            if (_this.composition_tree.debug_log) {
                                (0, _cbutil.ObjectDeepMerge)(_this.composition_tree.debug_log.last_emit_data, _this.context.last_emit_data["_1"]);
                                _this.context.last_emit_data["_1"] = _this.composition_tree.debug_log.last_emit_data;
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    get_value_id(node) {
        var value_id = "v" + this.brick_id + "__" + node.id;
        return value_id;
    }
    removeElement(id) {
        var elem = document.getElementById(id);
        if (elem) {
            var pnode = elem.parentNode;
            if (pnode) return pnode.removeChild(elem);
        }
    }
    cb_initial_cement(cements) {}
    cb_status(status) {
        var container = document.getElementById(this.container_id);
        if (container) {
            if (status == "loading") container.classList.add("loading");
            else container.classList.remove("loading");
        }
    }
    cb_snapshot() {}
    render_form_inputs(schema, data) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var html, _tmp, _tmp1, _i, schema_input, form_container, self;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        html = "";
                        _tmp = [];
                        for(_tmp1 in schema)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            4
                        ];
                        schema_input = _tmp[_i];
                        if (!(schema[schema_input].type !== undefined)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this.render_form_property(schema[schema_input], schema_input, data[schema_input], schema_input, "editor-color-1", "")
                        ];
                    case 2:
                        html += _state.sent();
                        _state.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        form_container = document.getElementById(`${_this.brick_id}$form`);
                        if (form_container) form_container.innerHTML = html;
                        self = _this;
                        _this.convertInputDivsToCodemirror();
                        if (!window["editor_any_type_change_" + _this.ci_idx]) window["editor_any_type_change_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                var editor_element, editor_property, editor_path, container_type, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, new_type, new_data;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_property = editor_element.getAttribute("editor_property");
                                            editor_path = editor_element.getAttribute("editor_path");
                                            container_type = editor_element.getAttribute("container_type");
                                            editor_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = editor_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) editor_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            new_type = element.value;
                                            new_data = "";
                                            if (new_type == "array") new_data = [
                                                ""
                                            ];
                                            else if (new_type == "object") new_data = {};
                                            else if (new_type == "number") new_data = 0;
                                            else if (new_type == "boolean") new_data = false;
                                            return [
                                                4,
                                                self.render_form_property({
                                                    type: "any"
                                                }, editor_property, new_data, editor_path, editor_color, container_type)
                                            ];
                                        case 1:
                                            editor_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_schema_type_change_" + _this.ci_idx]) window["editor_schema_type_change_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                var editor_element, editor_property, editor_path, container_type, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, new_type, new_data;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_property = editor_element.getAttribute("editor_property");
                                            editor_path = editor_element.getAttribute("editor_path");
                                            container_type = editor_element.getAttribute("container_type");
                                            editor_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = editor_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) editor_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            new_type = element.value;
                                            new_data = {
                                                type: new_type,
                                                desc: ""
                                            };
                                            if (new_type == "object" || new_type == "object[]") new_data.properties = {};
                                            return [
                                                4,
                                                self.render_form_property({
                                                    type: "schema",
                                                    sub: true,
                                                    prop_editable: true
                                                }, editor_property, new_data, editor_path, editor_color, container_type)
                                            ];
                                        case 1:
                                            editor_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_any_prop_add_enter_" + _this.ci_idx]) window["editor_any_prop_add_enter_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element, event) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(event.key == "Enter")) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                window["editor_any_prop_add_" + self.ci_idx](element.previousElementSibling)
                                            ];
                                        case 1:
                                            _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element, event) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_any_prop_add_" + _this.ci_idx]) window["editor_any_prop_add_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                var editor_element, editor_property, editor_path, container_type, prop_name_input, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, obj, current_value, prop_name, _$schema, e_id;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_property = editor_element.getAttribute("editor_property");
                                            editor_path = editor_element.getAttribute("editor_path");
                                            container_type = editor_element.getAttribute("container_type");
                                            prop_name_input = element.nextElementSibling;
                                            editor_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = editor_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) editor_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            obj = {};
                                            self.get_form_property_value(obj, editor_element);
                                            current_value = obj[editor_property] || {};
                                            prop_name = prop_name_input.value;
                                            if (prop_name === "") alert("Please supply a property name.");
                                            else current_value[prop_name] = "";
                                            _$schema = self.get_path_schema(editor_path);
                                            _$schema.type = "any";
                                            container_type = container_type || "object";
                                            return [
                                                4,
                                                self.render_form_property(_$schema, editor_property, current_value, editor_path, editor_color, container_type)
                                            ];
                                        case 1:
                                            editor_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            e_id = "e_v" + self.brick_id + "__" + editor_path + "." + prop_name;
                                            setTimeout(function() {
                                                var editor = self.editors_by_e_id[e_id];
                                                if (editor) editor.editor.focus();
                                            }, 100);
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_schema_prop_add_" + _this.ci_idx]) window["editor_schema_prop_add_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element, sub) {
                                var editor_element, editor_property, editor_path, container_type, prop_name_input, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, obj, current_value, prop_name, _$schema;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_property = editor_element.getAttribute("editor_property");
                                            editor_path = editor_element.getAttribute("editor_path");
                                            container_type = editor_element.getAttribute("container_type");
                                            prop_name_input = element.nextElementSibling;
                                            editor_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = editor_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) editor_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            obj = {};
                                            self.get_form_property_value(obj, editor_element);
                                            current_value = obj[editor_property] || {};
                                            prop_name = prop_name_input.value;
                                            if (prop_name === "") alert("Please supply a property name.");
                                            else if (sub) current_value.properties[prop_name] = {
                                                type: "string",
                                                desc: ""
                                            };
                                            else current_value[prop_name] = {
                                                type: "string",
                                                desc: ""
                                            };
                                            _$schema = self.get_path_schema(editor_path);
                                            if (sub) {
                                                _$schema.sub = true;
                                                _$schema.prop_editable = true;
                                            } else {
                                                if (_$schema.sub) delete _$schema.sub;
                                                if (_$schema.prop_editable) delete _$schema.prop_editable;
                                            }
                                            return [
                                                4,
                                                self.render_form_property(_$schema, editor_property, current_value, editor_path, editor_color, container_type)
                                            ];
                                        case 1:
                                            editor_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element, sub) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_any_item_add_" + _this.ci_idx]) window["editor_any_item_add_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                var editor_element, editor_property, editor_path, container_type, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, obj, current_value, prev, _$schema;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_property = editor_element.getAttribute("editor_property");
                                            editor_path = editor_element.getAttribute("editor_path");
                                            container_type = editor_element.getAttribute("container_type");
                                            editor_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = editor_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) editor_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            obj = {};
                                            self.get_form_property_value(obj, editor_element);
                                            current_value = obj[editor_property] || [];
                                            if (current_value.length > 0) {
                                                prev = current_value[current_value.length - 1];
                                                if (Array.isArray(prev)) current_value.push([
                                                    ""
                                                ]);
                                                else if (prev !== null && typeof prev == "object") current_value.push((0, _cbutil.Clone)(prev));
                                                else if (typeof prev == "number") current_value.push(prev + 1);
                                                else if (typeof prev == "boolean") current_value.push(!prev);
                                                else current_value.push("");
                                            } else current_value.push("");
                                            _$schema = self.get_path_schema(editor_path);
                                            return [
                                                4,
                                                self.render_form_property(_$schema, editor_property, current_value, editor_path, editor_color, container_type)
                                            ];
                                        case 1:
                                            editor_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_any_prop_del_" + _this.ci_idx]) window["editor_any_prop_del_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                var editor_element;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_element.parentNode.removeChild(editor_element);
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_any_item_del_" + _this.ci_idx]) window["editor_any_item_del_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                var editor_element, editor_property, container_element, container_property, container_path, container_container_type, container_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, obj, current_value, _$schema;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            editor_element = element.parentElement.parentElement.parentElement;
                                            editor_property = editor_element.getAttribute("editor_property");
                                            container_element = editor_element.parentElement.parentElement;
                                            container_property = container_element.getAttribute("editor_property");
                                            container_path = container_element.getAttribute("editor_path");
                                            container_container_type = editor_element.getAttribute("container_type");
                                            container_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = container_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) container_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            obj = {};
                                            self.get_form_property_value(obj, container_element);
                                            current_value = obj[container_property];
                                            current_value.splice(Number(editor_property), 1);
                                            _$schema = self.get_path_schema(container_path);
                                            return [
                                                4,
                                                self.render_form_property(_$schema, container_property, current_value, container_path, container_color, container_container_type)
                                            ];
                                        case 1:
                                            container_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_onmousedown_" + _this.ci_idx]) window["editor_onmousedown_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(ev) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    self.drag_handle = ev.target;
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_ondragstart_" + _this.ci_idx]) window["editor_ondragstart_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(ev) {
                                var handle;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    handle = ev.target.querySelector('[editor_drag="handle"]');
                                    if (handle.contains(self.drag_handle)) ev.dataTransfer.setData("text/plain", ev.target.id);
                                    else ev.preventDefault();
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_ondragover_" + _this.ci_idx]) window["editor_ondragover_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(ev) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    ev.preventDefault();
                                    ev.dataTransfer.dropEffect = "move";
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_ondragover_child_" + _this.ci_idx]) window["editor_ondragover_child_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(ev) {
                                var _a, source_id, this_id, source_split, source_pos, this_split, this_pos, this_element, prev;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    ev.preventDefault();
                                    source_id = ev.srcElement.id;
                                    this_id = ev.currentTarget.id;
                                    source_split = source_id.split(".");
                                    source_pos = source_split[source_split.length - 1];
                                    this_split = this_id.split(".");
                                    this_pos = this_split[this_split.length - 1];
                                    this_element = document.getElementById(this_id);
                                    if (this_element) {
                                        prev = (_a = this_element.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".editor-drop-target");
                                        if (prev) prev.classList.remove("editor-drop-target");
                                        this_element.classList.add("editor-drop-target");
                                    }
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_ondrop_" + _this.ci_idx]) window["editor_ondrop_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(ev) {
                                var source_id, loc_id, target, source_elem, source_split, source_pos, loc_split, loc_pos, container_element, container_property, container_path, container_container_type, container_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, obj, current_value, source_val, _$schema;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            ev.preventDefault();
                                            source_id = ev.dataTransfer.getData("text/plain");
                                            loc_id = ev.target.id;
                                            target = ev.target;
                                            while(target && target.getAttribute("editor_drag") != "drop"){
                                                target = target.parentNode;
                                                if (target.getAttribute("editor_drag") == "loc") loc_id = target.id;
                                            }
                                            source_elem = document.getElementById(source_id);
                                            if (!(source_elem && target.getAttribute("editor_drag") == "drop")) return [
                                                3,
                                                3
                                            ];
                                            source_split = source_id.split(".");
                                            source_pos = Number(source_split[source_split.length - 1]);
                                            loc_split = loc_id.split(".");
                                            loc_pos = Number(loc_split[loc_split.length - 1]);
                                            container_element = target.parentNode;
                                            container_property = container_element.getAttribute("editor_property");
                                            container_path = container_element.getAttribute("editor_path");
                                            container_container_type = source_elem.getAttribute("container_type");
                                            container_color = "editor-color-1";
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = container_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    c = _step.value;
                                                    if (c.indexOf("editor-color") == 0) container_color = c;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            obj = {};
                                            self.get_form_property_value(obj, container_element);
                                            current_value = obj[container_property];
                                            source_val = current_value[source_pos];
                                            current_value.splice(source_pos, 1);
                                            current_value.splice(loc_pos, 0, source_val);
                                            _$schema = self.get_path_schema(container_path);
                                            return [
                                                4,
                                                self.render_form_property(_$schema, container_property, current_value, container_path, container_color, container_container_type)
                                            ];
                                        case 1:
                                            container_element.outerHTML = _state.sent();
                                            self.convertInputDivsToCodemirror();
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!window["editor_prop_name_" + _this.ci_idx]) window["editor_prop_name_" + _this.ci_idx] = function() {
                            var _ref = (0, _asyncToGenerator._)(function(input) {
                                var form_element, new_prop_name, path, path_parts, new_path;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            form_element = input.parentElement.parentElement.parentElement;
                                            new_prop_name = input.value;
                                            path = form_element.getAttribute("editor_path");
                                            path_parts = path.split(".");
                                            path_parts[path_parts.length - 1] = new_prop_name;
                                            new_path = path_parts.join(".");
                                            form_element.setAttribute("editor_path", new_path);
                                            form_element.setAttribute("id", "_editor__" + new_path);
                                            form_element.setAttribute("editor_property", new_prop_name);
                                            return [
                                                4,
                                                self.cb_emit({
                                                    "@": self.get_form_value()
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(input) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    render_form_property(schema, property, data, path, color_class, parent_container_type) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var editor_type, container_type, is_template, html, render_id, title, no_link, next_color, array_drop_zone, node, _tmp, _tmp1, _i, prop, dp, i, _tmp2, _tmp3, _i1, p, node1, _tmp4, _tmp5, _i2, input, properties, _tmp6, _tmp7, _i3, p1, value_path, node2, array_of_type, s, child_schema, i1, node3, value_id, keys, selected_value, o, selected, selected1, node4;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (schema.type == undefined) return [
                            2,
                            ""
                        ];
                        if (data === undefined || typeof schema.default == "object" && data === "") data = schema.default;
                        editor_type = schema.type;
                        container_type = "";
                        if (schema.type == "any") {
                            if (Array.isArray(data)) editor_type = "array";
                            else if (data && typeof data == "object") editor_type = "object";
                            else editor_type = typeof data;
                            container_type = editor_type;
                        } else if (schema.type[schema.type.length - 1] == "]") {
                            editor_type = "array";
                            container_type = editor_type;
                        } else if (schema.type == "object") container_type = editor_type;
                        is_template = data && typeof data == "string" && (data || "").indexOf("{{") != -1;
                        if (is_template) editor_type = "string";
                        html = `<div id="_editor__${path}" class="editor-form-property ${color_class}" editor_property="${property}" editor_type="${editor_type}" editor_path="${path}" container_type="${container_type}" ${parent_container_type == "array" ? ` draggable="true" editor_drag="loc" ondragstart="editor_ondragstart_${_this.ci_idx}(event)" ondragover="editor_ondragover_child_${_this.ci_idx}(event)"` : ""}>`;
                        render_id = "r" + _this.brick_id + "$" + path;
                        title = property;
                        if (schema.prop_editable) title = `<input style="width:${property.length + 1}ch" class="editor-propname-input" value="${property}" onkeypress="this.style.width = ((this.value.length + 2)) + 'ch';" onchange="editor_prop_name_${_this.ci_idx}(this)"/>`;
                        no_link = !_this.enable_templating || _this.brick_name == _this.composition_tree.name && path.split(".")[0] == "unit_ins";
                        html += `<div class="editor-form-property-header"><div class="editor-property-title" tooltip="${schema.desc || ""}">${title}${schema.desc ? `<div class="c-template-form-info"><img src="https://s2.svgbox.net/materialui.svg?ic=info_outline&color=02366d" width="16" height="16" style="margin:-4px;padding-bottom:2px"></div>` : ""}</div>
            ${parent_container_type == "array" ? `<div editor_drag="handle" class="editor-drag-handle" onmousedown="editor_onmousedown_${_this.ci_idx}(event)"></div>` : ""}
            <div>
                
                ${schema.type == "any" ? `<select class="editor-any-type-select" onchange="editor_any_type_change_${_this.ci_idx}(this)">
                <option value="string" ${editor_type == "string" ? "selected" : ""}>string</option>
                <option value="number" ${editor_type == "number" ? "selected" : ""}>number</option>
                <option value="boolean" ${editor_type == "boolean" ? "selected" : ""}>boolean</option>
                <option value="object" ${editor_type == "object" ? "selected" : ""}>object</option>
                <option value="array" ${editor_type == "array" ? "selected" : ""}>array</option>
                </select>` : ""}

                ${schema.type == "schema" && schema.sub ? `<select editor_role="schema_type_select" onchange="editor_schema_type_change_${_this.ci_idx}(this)">
                <option value="string" ${!data || !data.type || data.type == "string" ? "selected" : ""}>string</option>
                <option value="number" ${data && data.type == "number" ? "selected" : ""}>number</option>
                <option value="boolean" ${data && data.type == "boolean" ? "selected" : ""}>boolean</option>
                <option value="object" ${data && data.type == "object" ? "selected" : ""}>object</option>
                <option value="string[]" ${data && data.type == "string[]" ? "selected" : ""}>string[]</option>
                <option value="object[]" ${data && data.type == "object[]" ? "selected" : ""}>object[]</option>
                <option value="any" ${data && data.type == "any" ? "selected" : ""}>any</option>
                </select>` : ""}

                ${schema.fromdata ? `<button class="c-template-form-button" style="padding: 2px 5px" fromdata='${JSON.stringify(schema.fromdata)}' onclick="cb_editor.fromdata${_this.ci_idx}(this, '${path}')">From Data</button>` : ""} 
                
                ${schema.type != "boolean" && schema.type != "number" && (schema.type != "string" || schema.options) ? `<button id="${render_id}$edit" class="c-template-form-button-sec" style="padding: 2px 5px" onclick="cb_editor.expand${_this.ci_idx}(this, '${path}')"><img src="https://s2.svgbox.net/materialui.svg?ic=content_paste&color=02366d" width="16" height="16" style="margin:-4px;padding-bottom:2px"></button>` : ""}
                ${no_link ? "" : `<button id="${render_id}$link" class="c-template-form-button" style="padding: 2px 5px;margin-left:3px" onclick="cb_editor.addtag${_this.ci_idx}(this, '${path}')"><img src="https://s2.svgbox.net/hero-solid.svg?ic=link&color=fff" width="16" height="16" style="margin:-4px;padding-bottom:2px"></button>`}
                ${parent_container_type == "array" && (schema.type == "any" ? schema.sub : true) ? `<button class="c-template-form-button" style="padding: 2px 5px" onclick="editor_any_item_del_${_this.ci_idx}(this)"><img src="https://s2.svgbox.net/hero-outline.svg?ic=x&color=fff" width="16" height="16" style="margin:-4px;padding-bottom:2px"></button>` : ""}
                ${parent_container_type == "object" && schema.type == "any" && schema.sub || schema.type == "schema" && schema.sub ? `<button class="c-template-form-button" style="padding: 2px 5px" onclick="editor_any_prop_del_${_this.ci_idx}(this)"><img src="https://s2.svgbox.net/hero-outline.svg?ic=x&color=fff" width="16" height="16" style="margin:-4px;padding-bottom:2px"></button>` : ""}
                

            </div>
        </div>`;
                        next_color = _this.next_color_class(color_class);
                        array_drop_zone = container_type == "array" ? ` editor_drag="drop" ondrop="editor_ondrop_${_this.ci_idx}(event)" ondragover="editor_ondragover_${_this.ci_idx}(event)"` : "";
                        if (!(typeof data == "string" && data.indexOf("{{") != -1)) return [
                            3,
                            2
                        ];
                        node = {
                            id: path,
                            path: path,
                            schema: schema,
                            value: data === undefined || data === "" ? schema.default === undefined ? "" : schema.default : data,
                            desc: schema.desc || "",
                            label: property
                        };
                        return [
                            4,
                            _this.render_value_editor_html(node)
                        ];
                    case 1:
                        html += _state.sent();
                        return [
                            3,
                            44
                        ];
                    case 2:
                        if (!(schema.type == "object")) return [
                            3,
                            7
                        ];
                        html += `<div class="editor-form-properties">`;
                        _tmp = [];
                        for(_tmp1 in schema.properties)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 3;
                    case 3:
                        if (!(_i < _tmp.length)) return [
                            3,
                            6
                        ];
                        prop = _tmp[_i];
                        dp = undefined;
                        if (data && typeof data == "object") dp = data[prop];
                        return [
                            4,
                            _this.render_form_property(schema.properties[prop], prop, dp, path + "." + prop, next_color, container_type)
                        ];
                    case 4:
                        html += _state.sent();
                        _state.label = 5;
                    case 5:
                        _i++;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        html += `</div>`;
                        return [
                            3,
                            44
                        ];
                    case 7:
                        if (!(schema.type == "any")) return [
                            3,
                            20
                        ];
                        if (!(data && Array.isArray(data))) return [
                            3,
                            12
                        ];
                        html += `<div class="editor-form-properties" editor_path="${path}" ${array_drop_zone}>`;
                        i = 0;
                        _state.label = 8;
                    case 8:
                        if (!(i < data.length)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            _this.render_form_property({
                                type: "any",
                                sub: true
                            }, i + "", data[i], path + "." + i, next_color, container_type)
                        ];
                    case 9:
                        html += _state.sent();
                        _state.label = 10;
                    case 10:
                        i++;
                        return [
                            3,
                            8
                        ];
                    case 11:
                        html += `<div><button class="c-template-form-button" onclick="editor_any_item_add_${_this.ci_idx}(this)">+</button></div>`;
                        html += `</div>`;
                        return [
                            3,
                            19
                        ];
                    case 12:
                        if (!(data && typeof data == "object")) return [
                            3,
                            17
                        ];
                        html += `<div class="editor-form-properties" editor_path="${path}">`;
                        _tmp2 = [];
                        for(_tmp3 in data)_tmp2.push(_tmp3);
                        _i1 = 0;
                        _state.label = 13;
                    case 13:
                        if (!(_i1 < _tmp2.length)) return [
                            3,
                            16
                        ];
                        p = _tmp2[_i1];
                        return [
                            4,
                            _this.render_form_property({
                                type: "any",
                                prop_editable: true,
                                sub: true
                            }, p, data[p], path + "." + p, next_color, container_type)
                        ];
                    case 14:
                        html += _state.sent();
                        _state.label = 15;
                    case 15:
                        _i1++;
                        return [
                            3,
                            13
                        ];
                    case 16:
                        html += `<div><button class="c-template-form-button" onclick="editor_any_prop_add_${_this.ci_idx}(this)">+</button><input class="editor-prop-add-input" type="text" placeholder="New Property Name" onkeyup="editor_any_prop_add_enter_${_this.ci_idx}(this, event)"></input></div>`;
                        html += `</div>`;
                        return [
                            3,
                            19
                        ];
                    case 17:
                        node1 = {
                            id: path,
                            path: path,
                            schema: schema,
                            value: data === undefined || data === "" ? schema.default === undefined ? "" : schema.default : data,
                            desc: schema.desc || "",
                            label: property
                        };
                        return [
                            4,
                            _this.render_value_editor_html(node1)
                        ];
                    case 18:
                        html += _state.sent();
                        _state.label = 19;
                    case 19:
                        return [
                            3,
                            44
                        ];
                    case 20:
                        if (!(schema.type == "schema")) return [
                            3,
                            35
                        ];
                        if (!(typeof data == "object")) return [
                            3,
                            34
                        ];
                        if (!!schema.sub) return [
                            3,
                            25
                        ];
                        html += `<div class="editor-form-properties" editor_path="${path}">`;
                        _tmp4 = [];
                        for(_tmp5 in data)_tmp4.push(_tmp5);
                        _i2 = 0;
                        _state.label = 21;
                    case 21:
                        if (!(_i2 < _tmp4.length)) return [
                            3,
                            24
                        ];
                        input = _tmp4[_i2];
                        return [
                            4,
                            _this.render_form_property({
                                type: "schema",
                                sub: true,
                                prop_editable: true
                            }, input, data[input], path + "." + input, next_color, container_type)
                        ];
                    case 22:
                        html += _state.sent();
                        _state.label = 23;
                    case 23:
                        _i2++;
                        return [
                            3,
                            21
                        ];
                    case 24:
                        html += `<div><button class="c-template-form-button" onclick="editor_schema_prop_add_${_this.ci_idx}(this, false)">+</button><input class="editor-prop-add-input" type="text" placeholder="Property Name"></input></div>`;
                        html += `</div>`;
                        return [
                            3,
                            34
                        ];
                    case 25:
                        html += `desc: <input editor_role="schema_desc" value="${data.desc === undefined ? "" : data.desc}" onchange="editdesc_${_this.ci_idx}()"/>`;
                        if (!(data.type == "object" || data.type == "object[]")) return [
                            3,
                            30
                        ];
                        properties = data.properties || {};
                        html += "properties:";
                        html += `<div class="editor-form-properties" editor_path="${path}">`;
                        _tmp6 = [];
                        for(_tmp7 in properties)_tmp6.push(_tmp7);
                        _i3 = 0;
                        _state.label = 26;
                    case 26:
                        if (!(_i3 < _tmp6.length)) return [
                            3,
                            29
                        ];
                        p1 = _tmp6[_i3];
                        return [
                            4,
                            _this.render_form_property({
                                type: "schema",
                                sub: true,
                                prop_editable: true
                            }, p1, properties[p1], path + ".properties." + p1, next_color, container_type)
                        ];
                    case 27:
                        html += _state.sent();
                        _state.label = 28;
                    case 28:
                        _i3++;
                        return [
                            3,
                            26
                        ];
                    case 29:
                        html += `<div><button class="c-template-form-button" onclick="editor_schema_prop_add_${_this.ci_idx}(this, true)">+</button><input class="editor-prop-add-input" type="text" placeholder="Property Name"></input></div>`;
                        html += `</div>`;
                        return [
                            3,
                            34
                        ];
                    case 30:
                        if (!(path.split(".")[0].indexOf("out") != -1)) return [
                            3,
                            32
                        ];
                        value_path = path + ".value";
                        node2 = {
                            id: value_path,
                            path: value_path,
                            schema: schema,
                            value: data.value === undefined || data.value === "" ? schema.default === undefined ? "" : schema.default : data.value,
                            desc: "",
                            label: property
                        };
                        html += `value: `;
                        return [
                            4,
                            _this.render_value_editor_html(node2)
                        ];
                    case 31:
                        html += _state.sent();
                        return [
                            3,
                            34
                        ];
                    case 32:
                        return [
                            4,
                            _this.render_form_property({
                                type: "any",
                                sub: true,
                                prop_editable: false
                            }, "default", data.default === undefined ? "" : data.default, path + ".default", next_color, container_type)
                        ];
                    case 33:
                        html += _state.sent();
                        _state.label = 34;
                    case 34:
                        return [
                            3,
                            44
                        ];
                    case 35:
                        if (!(schema.type[schema.type.length - 1] == "]")) return [
                            3,
                            41
                        ];
                        array_of_type = "";
                        for(s = schema.type.length - 1; s >= 0; s--)if (schema.type[s] == "[") {
                            array_of_type = schema.type.substring(0, s);
                            break;
                        }
                        data = data || [];
                        if (!(data && Array.isArray(data))) return [
                            3,
                            40
                        ];
                        child_schema = (0, _cbutil.Clone)(schema);
                        child_schema.type = array_of_type;
                        child_schema.desc = "";
                        if (schema.fromdata) delete child_schema.fromdata;
                        html += `<div class="editor-form-properties" ${array_drop_zone}>`;
                        i1 = 0;
                        _state.label = 36;
                    case 36:
                        if (!(i1 < data.length)) return [
                            3,
                            39
                        ];
                        return [
                            4,
                            _this.render_form_property(child_schema, i1 + "", data[i1], path + "." + i1, next_color, container_type)
                        ];
                    case 37:
                        html += _state.sent();
                        _state.label = 38;
                    case 38:
                        i1++;
                        return [
                            3,
                            36
                        ];
                    case 39:
                        html += `<div><button class="c-template-form-button" onclick="editor_any_item_add_${_this.ci_idx}(this)">+</button></div>`;
                        html += `</div>`;
                        _state.label = 40;
                    case 40:
                        return [
                            3,
                            44
                        ];
                    case 41:
                        if (!(schema.type == "string" && schema.options && (data || "").indexOf("{{") == -1)) return [
                            3,
                            42
                        ];
                        node3 = {
                            id: path,
                            path: path,
                            schema: schema,
                            value: data,
                            desc: schema.desc || "",
                            label: property
                        };
                        value_id = _this.get_value_id(node3);
                        html += `<textarea class='c-input c-template-form-textarea hidden' id="${value_id}" class="c-input" rows="1" placeholder="">${data === undefined ? schema.default || "" : data}</textarea>`;
                        html += `<div><select class="cbeditor-select" onchange="selectvalue_${_this.ci_idx}(this)">`;
                        keys = null;
                        selected_value = "";
                        for(o = 0; o < schema.options.length; o++)if (typeof schema.options[o] == "object") {
                            if (keys === null) keys = Object.keys(schema.options[o]);
                            if (o == 0) selected_value = schema.options[o][keys[0]];
                            else if (data == schema.options[o][keys[0]]) selected_value = data;
                            selected = data == schema.options[o][keys[0]] ? "selected" : "";
                            html += `<option value="${schema.options[o][keys[0]]}" ${selected}>${schema.options[o][keys.length > 1 ? keys[1] : keys[0]]}</option>`;
                        } else {
                            if (o == 0) selected_value = schema.options[o];
                            else if (data == schema.options[o]) selected_value = data;
                            selected1 = data == schema.options[o] ? "selected" : "";
                            html += `<option value="${schema.options[o]}" ${selected1}>${schema.options[o]}</option>`;
                        }
                        html += "</select></div>";
                        return [
                            3,
                            44
                        ];
                    case 42:
                        node4 = {
                            id: path,
                            path: path,
                            schema: schema,
                            value: data === undefined ? schema.default === undefined ? "" : schema.default : data,
                            desc: schema.desc || "",
                            label: property
                        };
                        return [
                            4,
                            _this.render_value_editor_html(node4)
                        ];
                    case 43:
                        html += _state.sent();
                        _state.label = 44;
                    case 44:
                        return [
                            2,
                            html + "</div>"
                        ];
                }
            });
        })();
    }
    get_form_value() {
        var ret = {};
        var form_container = document.getElementById(`${this.brick_id}$form`);
        if (form_container) {
            var children = form_container.children;
            for(var c = 0; c < children.length; c++)this.get_form_property_value(ret, children[c], true);
        }
        return ret;
    }
    get_form_property_value(form_object, editor_element) {
        var is_root = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var editor_type = editor_element.getAttribute("editor_type");
        var editor_property = editor_element.getAttribute("editor_property");
        var editor_path = editor_element.getAttribute("editor_path");
        if (editor_type == "array") {
            var child_container = editor_element.querySelector(".editor-form-properties");
            if (child_container) {
                form_object[editor_property] = [];
                var children = child_container.children;
                for(var c = 0; c < children.length; c++)this.get_form_property_value(form_object[editor_property], children[c]);
                var schema = this.get_path_schema(editor_path);
                if (schema.type != "any" && (schema.default === undefined || JSON.stringify(schema.default) == "[]") && JSON.stringify(form_object[editor_property]) == "[]") delete form_object[editor_property];
            }
        } else if (editor_type == "object") {
            var child_container1 = editor_element.querySelector(".editor-form-properties");
            if (child_container1) {
                form_object[editor_property] = {};
                var children1 = child_container1.children;
                for(var c1 = 0; c1 < children1.length; c1++)this.get_form_property_value(form_object[editor_property], children1[c1]);
                var schema1 = this.get_path_schema(editor_path);
                if (schema1.type != "any" && (schema1.default === undefined || JSON.stringify(schema1.default) == "{}") && JSON.stringify(form_object[editor_property]) == "{}") delete form_object[editor_property];
            }
        } else if (editor_type == "schema") {
            if (editor_path == editor_property) {
                var child_container2 = editor_element.querySelector(".editor-form-properties");
                form_object[editor_property] = form_object[editor_property] || {};
                if (child_container2) {
                    var children2 = child_container2.children;
                    for(var c2 = 0; c2 < children2.length; c2++){
                        var child_property = children2[c2].getAttribute("editor_property");
                        if (child_property) this.get_form_property_value(form_object[editor_property], children2[c2]);
                    }
                }
            } else {
                var type_select = editor_element.querySelector('[editor_role="schema_type_select"]');
                var type = type_select.value;
                var desc_input = editor_element.querySelector('[editor_role="schema_desc"]');
                var desc = "";
                if (desc_input) desc = desc_input.value;
                if (type == "object" || type == "object[]") {
                    form_object[editor_property] = {
                        type: type,
                        properties: {}
                    };
                    if (desc !== "") form_object[editor_property].desc = desc;
                    var child_container3 = editor_element.querySelector(".editor-form-properties");
                    if (child_container3) {
                        var children3 = child_container3.children;
                        for(var c3 = 0; c3 < children3.length; c3++){
                            var child_property1 = children3[c3].getAttribute("editor_property");
                            if (child_property1) this.get_form_property_value(form_object[editor_property].properties, children3[c3]);
                        }
                    }
                } else {
                    form_object[editor_property] = {
                        type: type
                    };
                    if (desc !== "") form_object[editor_property].desc = desc;
                    if (editor_path.split(".")[0].indexOf("out") != -1) {
                        var ta = editor_element.querySelector(".c-template-form-textarea");
                        if (ta) {
                            var val = ta.value;
                            form_object[editor_property].value = val;
                        }
                    } else {
                        var default_object = editor_element.querySelector('[editor_property="default"]');
                        if (default_object) this.get_form_property_value(form_object[editor_property], default_object);
                    }
                }
            }
        } else {
            var ta1 = editor_element.querySelector(".c-template-form-textarea");
            var is_any = editor_element.querySelector(".editor-any-type-select");
            if (ta1) {
                var val1 = ta1.value;
                var schema2 = this.get_path_schema(editor_path);
                if (val1 === undefined) val1 = "";
                if (val1 !== undefined || is_any && editor_path != editor_property) {
                    if (editor_type == "number") {
                        if (!is_root && schema2.type != "any" && val1 == "" && schema2.default === undefined) return;
                        val1 = Number(val1);
                    } else if (editor_type == "boolean") {
                        if (val1 == "false") val1 = false;
                        else if (val1.indexOf("{{") != -1) ;
                        else val1 = Boolean(val1);
                        if (!is_root && schema2.type != "any" && val1 === false && (schema2.default || false) == false) return;
                    } else if (!is_root && (val1 === undefined || schema2.type != "any" && val1 == "" && (schema2.default || "") == "")) return "";
                    if (Array.isArray(form_object)) form_object.push(val1);
                    else form_object[editor_property] = val1;
                }
            }
        }
    }
    get_path_schema(path) {
        var path_parts = (0, _templateUtil.TemplateUtil).GetTermParts(path);
        if (this.schema) return this.get_prop_schema(path_parts, 1, this.schema[path_parts[0]]);
    }
    get_prop_schema(path_parts, at, schema) {
        if (at == path_parts.length) return schema;
        if (schema.type == "object") return this.get_prop_schema(path_parts, at + 1, schema.properties[path_parts[at]]);
        else if (schema.type[schema.type.length - 1] == "]") {
            var array_of_type = "";
            for(var s = schema.type.length - 1; s >= 0; s--)if (schema.type[s] == "[") {
                array_of_type = schema.type.substring(0, s);
                break;
            }
            var child_schema = (0, _cbutil.Clone)(schema);
            child_schema.type = array_of_type;
            child_schema.desc = "";
            return child_schema;
        }
        return schema;
    }
    get_form_element_by_path(path) {
        var path_parts = (0, _templateUtil.TemplateUtil).GetTermParts(path);
        var found = null;
        var form_container = document.getElementById(`${this.brick_id}$form`);
        if (form_container) {
            var children = form_container.children;
            for(var c = 0; c < children.length; c++){
                found = this.find_form_element(children[c], path_parts, 0);
                if (found) break;
            }
        }
        return found;
    }
    find_form_element(editor_element, path_parts, at) {
        var editor_type = editor_element.getAttribute("editor_type");
        var editor_property = editor_element.getAttribute("editor_property");
        if (editor_property == path_parts[at]) {
            if (at == path_parts.length - 1) return editor_element;
            else {
                if (editor_type == "array" || editor_type == "object") {
                    var child_container = editor_element.querySelector(".editor-form-properties");
                    if (child_container) {
                        var children = child_container.children;
                        at++;
                        for(var c = 0; c < children.length; c++){
                            var found = this.find_form_element(children[c], path_parts, at);
                            if (found) return found;
                        }
                    }
                } else if (editor_type == "schema") {
                    if (at == path_parts.length - 2 && path_parts[at + 1] == "value") return editor_element;
                    var header_container = editor_element.querySelector(".editor-form-property-header");
                    var schema_type_select = header_container.querySelector('[editor_role="schema_type_select"]');
                    var child_container1 = editor_element.querySelector(".editor-form-properties");
                    if (child_container1) {
                        if (schema_type_select) {
                            var schema_type = schema_type_select.value;
                            if (schema_type == "object" || schema_type == "object[]") at++;
                        }
                        var children1 = child_container1.children;
                        at++;
                        for(var c1 = 0; c1 < children1.length; c1++){
                            var found1 = this.find_form_element(children1[c1], path_parts, at);
                            if (found1) return found1;
                        }
                    }
                }
            }
        }
        return null;
    }
    set_form_property_value(path, value) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var found, textarea, tageditor, node, form_element, editor_property, editor_path, container_type, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, schema, select;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        found = _this.get_form_element_by_path(path);
                        if (!found) return [
                            3,
                            6
                        ];
                        textarea = found.querySelector(".c-template-form-textarea");
                        if (textarea) textarea.value = value;
                        tageditor = found.querySelector(".editor-value-editor");
                        if (!tageditor) return [
                            3,
                            2
                        ];
                        node = {
                            id: path,
                            path: path,
                            schema: {},
                            value: value,
                            desc: ""
                        };
                        return [
                            4,
                            _this.get_tag_editors_html(node)
                        ];
                    case 1:
                        tageditor.outerHTML = _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!(value.indexOf("{{") != -1)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            _this.get_form_element_by_path(path)
                        ];
                    case 3:
                        form_element = _state.sent();
                        editor_property = form_element.getAttribute("editor_property");
                        editor_path = form_element.getAttribute("editor_path");
                        container_type = form_element.getAttribute("container_type");
                        editor_color = "editor-color-1";
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = form_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                c = _step.value;
                                if (c.indexOf("editor-color") == 0) editor_color = c;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        schema = _this.get_path_schema(editor_path);
                        if (schema.type == "schema") {
                            value = _this.get_schema_path_value(editor_path, value);
                            schema.sub = true;
                            schema.prop_editable = true;
                        }
                        return [
                            4,
                            _this.render_form_property(schema, editor_property, value, editor_path, editor_color, "string")
                        ];
                    case 4:
                        form_element.outerHTML = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        select = found.querySelector("select");
                        if (select) select.value = value;
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    get_schema_path_value(path, value) {
        var scema_value = {};
        var o = scema_value;
        o["type"] = "string";
        o["value"] = value;
        return scema_value;
    }
    next_color_class(color_class) {
        if (color_class == "editor-color-1") return "editor-color-2";
        else return "editor-color-1";
    }
    render_value_editor_html(node) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var html, value_id;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        html = "";
                        value_id = _this.get_value_id(node);
                        html += `<textarea class='c-input c-template-form-textarea hidden' id="${value_id}" class="c-input" rows="1" placeholder="">${node.value === undefined ? "" : node.value}</textarea>`;
                        html += `<div id="${value_id}_tageditor">`;
                        return [
                            4,
                            _this.get_tag_editors_html(node)
                        ];
                    case 1:
                        html += _state.sent();
                        html += "</div>";
                        return [
                            2,
                            html
                        ];
                }
            });
        })();
    }
    update_value_editor_value(node) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var value_id, textarea, tageditor;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value_id = _this.get_value_id(node);
                        textarea = document.getElementById(value_id);
                        if (textarea) textarea.value = node.value;
                        tageditor = document.getElementById(value_id + "_tageditor");
                        if (!tageditor) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this.get_tag_editors_html(node)
                        ];
                    case 1:
                        tageditor.innerHTML = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            _this.cb_emit({
                                "@": _this.get_form_value()
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    get_tag_editors_html(node) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var html, self, value_id, e_id, tags, source, tev, escaped_tev;
            return (0, _tsGenerator._)(this, function(_state) {
                html = "";
                self = _this;
                value_id = _this.get_value_id(node);
                e_id = "e_" + value_id;
                tags = [];
                source = "''";
                if (_this.sources && _this.sources.length > 0) source = _this.sources[0].value;
                tags.push(`{{${source}}}`);
                if (node.value) (0, _templateUtil.TemplateUtil).ExtractTags(node.value, tags);
                window.tag_map = window.tag_map || {};
                tev = node.value === undefined ? "" : node.value;
                escaped_tev = (0, _cbWebUtil.CBWebUtil).escapeHtml(tev);
                if (!window.cb_editor["addtag" + _this.ci_idx]) window.cb_editor["addtag" + _this.ci_idx] = function() {
                    var _ref = (0, _asyncToGenerator._)(function(element, node_path) {
                        var textbox, textbox_path, s, add_text, cursor_plus, head_plus, form_element, form_element_id, editor_property, editor_path, container_type, editor_color, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, schema, val, editor, head, transaction;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    textbox = element.parentElement.parentElement.parentElement.querySelector(".editor-value-editor");
                                    textbox_path = "";
                                    if (textbox) {
                                        s = textbox.id.split("__");
                                        textbox_path = s[s.length - 1];
                                    }
                                    add_text = "{{}}";
                                    cursor_plus = 2;
                                    head_plus = 0;
                                    if (!(!textbox || textbox_path != node_path)) return [
                                        3,
                                        2
                                    ];
                                    form_element = element.parentElement.parentElement.parentElement;
                                    form_element_id = form_element.id;
                                    editor_property = form_element.getAttribute("editor_property");
                                    editor_path = form_element.getAttribute("editor_path");
                                    container_type = form_element.getAttribute("container_type");
                                    editor_color = "editor-color-1";
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = form_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            c = _step.value;
                                            if (c.indexOf("editor-color") == 0) editor_color = c;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    schema = self.get_path_schema(editor_path);
                                    val = "{{";
                                    add_text = "}}";
                                    cursor_plus = 0;
                                    head_plus = 2;
                                    return [
                                        4,
                                        self.render_form_property(schema, editor_property, val, editor_path, editor_color, container_type)
                                    ];
                                case 1:
                                    form_element.outerHTML = _state.sent();
                                    self.convertInputDivsToCodemirror();
                                    form_element = document.getElementById(form_element_id);
                                    textbox = form_element.querySelector(".editor-value-editor");
                                    _state.label = 2;
                                case 2:
                                    if (textbox) {
                                        editor = self.editors_by_e_id[textbox.id].editor;
                                        if (editor) {
                                            head = self.editors_by_e_id[textbox.id].last_head;
                                            if (head == -1) {
                                                editor.dispatch(editor.state.update({
                                                    selection: {
                                                        anchor: editor.state.doc.length
                                                    }
                                                }));
                                                head = editor.state.doc.length;
                                            }
                                            editor.focus();
                                            transaction = editor.state.update({
                                                changes: {
                                                    from: head,
                                                    insert: add_text
                                                },
                                                selection: {
                                                    anchor: head + cursor_plus
                                                },
                                                scrollIntoView: true
                                            });
                                            if (transaction) editor.dispatch(transaction);
                                            (0, _autocomplete.startCompletion)(editor);
                                        }
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(element, node_path) {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (!window.cb_editor["expand" + _this.ci_idx]) window.cb_editor["expand" + _this.ci_idx] = function() {
                    var _ref = (0, _asyncToGenerator._)(function(element, node_path) {
                        var ta, value, asjson, s, textbox_path, editor_element, obj, s2, mod2, language;
                        return (0, _tsGenerator._)(this, function(_state) {
                            self.current_path = node_path;
                            ta = element.parentNode.parentNode.parentNode.querySelector("textarea");
                            value = "";
                            asjson = false;
                            if (ta) {
                                s = ta.id.split("__");
                                textbox_path = s[s.length - 1];
                                if (textbox_path != node_path) {
                                    editor_element = element.parentElement.parentElement.parentElement;
                                    obj = {};
                                    self.get_form_property_value(obj, editor_element);
                                    s2 = node_path.split(".");
                                    value = JSON.stringify(obj[s2[s2.length - 1]], null, 2);
                                    asjson = true;
                                } else value = ta.value || "";
                            }
                            mod2 = document.getElementById(self.brick_id + "$mod2_brick$body");
                            if (mod2) mod2.innerHTML = `<c-editor-code style="width:100%" id="${self.brick_id}$expanded" ins='{ "cfg": { "value": "" }}'></c-editor-code><div><input type="checkbox" id="asjson" name="asjson" ${asjson ? "checked" : ""}/><label for="asjson">Parse as JSON into Object</label></div>`;
                            language = "";
                            if (node_path.endsWith("function")) language = "javascript";
                            else if (node_path.indexOf("html") != -1) language = "html";
                            window.so_bricks[self.brick_id + "$mod2_brick"].cb_event("cfg", {
                                "title": self.brick_name + " - " + node_path,
                                "cancel_button": "Cancel",
                                "ok_button": "OK"
                            });
                            window.so_bricks[self.brick_id + "$mod2_brick"].cb_event("data", {
                                node_path: node_path
                            });
                            window.so_bricks[self.brick_id + "$mod2_brick"].cb_event("show_no_animate", 1);
                            window.so_bricks[self.brick_id + "$expanded_brick"].cb_event("cfg", {
                                "language": language
                            });
                            window.so_bricks[self.brick_id + "$expanded_brick"].cb_event("token_list", self.sources);
                            window.so_bricks[self.brick_id + "$expanded_brick"].cb_event("value", value);
                            window.so_bricks[self.brick_id + "$expanded_brick"].cb_event("focus", value);
                            return [
                                2
                            ];
                        });
                    });
                    return function(element, node_path) {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (!window.cb_editor["fromdata" + _this.ci_idx]) window.cb_editor["fromdata" + _this.ci_idx] = function() {
                    var _ref = (0, _asyncToGenerator._)(function(element, path) {
                        var _a, fromdata, cids, hi_cid, brick_ids, ci, source_data, columns, mapping_col, dest_data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, column, entry, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, mapping, editor_element, editor_property, editor_path, container_type, editor_color, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, c, obj, current_value, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, newcol, has, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, hascol, schema;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    fromdata = JSON.parse(element.getAttribute("fromdata"));
                                    cids = Object.keys(self.context.composition_runners);
                                    hi_cid = cids[cids.length - 1];
                                    brick_ids = self.context.composition_runners[hi_cid].get_brick_ids(self.brick_name, "");
                                    ci = window.codebricks_context.bricks[brick_ids[0]];
                                    source_data = (0, _cbutil.drill)(fromdata.source, ((_a = ci.debug_ios) === null || _a === void 0 ? void 0 : _a.last_ins) || {});
                                    if (!confirm(fromdata.desc + " Proceed?")) return [
                                        2
                                    ];
                                    if (!(fromdata.type == "columns")) return [
                                        3,
                                        3
                                    ];
                                    if (!(source_data && source_data.length > 0)) return [
                                        3,
                                        3
                                    ];
                                    columns = Object.keys(source_data[0]);
                                    mapping_col = "";
                                    dest_data = [];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = columns[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            column = _step.value;
                                            entry = {};
                                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                            try {
                                                for(_iterator1 = fromdata.mappings[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                    mapping = _step1.value;
                                                    if (mapping.transform == "pretty") entry[mapping.dest] = (0, _sugarDefault.default).String.titleize(column);
                                                    else entry[mapping.dest] = column;
                                                    if (!mapping_col) mapping_col = mapping.dest;
                                                }
                                            } catch (err) {
                                                _didIteratorError1 = true;
                                                _iteratorError1 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                        _iterator1.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError1) {
                                                        throw _iteratorError1;
                                                    }
                                                }
                                            }
                                            dest_data.push(entry);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    if (!mapping_col) return [
                                        2
                                    ];
                                    editor_element = element.parentElement.parentElement.parentElement;
                                    editor_property = editor_element.getAttribute("editor_property");
                                    editor_path = editor_element.getAttribute("editor_path");
                                    container_type = editor_element.getAttribute("container_type");
                                    editor_color = "editor-color-1";
                                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(_iterator2 = editor_element.classList[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            c = _step2.value;
                                            if (c.indexOf("editor-color") == 0) editor_color = c;
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                _iterator2.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    obj = {};
                                    self.get_form_property_value(obj, editor_element);
                                    current_value = obj[editor_property] || [];
                                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        for(_iterator3 = dest_data[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            newcol = _step3.value;
                                            has = false;
                                            _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                            try {
                                                for(_iterator4 = current_value[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                                    hascol = _step4.value;
                                                    if (newcol[mapping_col] == hascol[mapping_col]) {
                                                        has = true;
                                                        break;
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError4 = true;
                                                _iteratorError4 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                                        _iterator4.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError4) {
                                                        throw _iteratorError4;
                                                    }
                                                }
                                            }
                                            if (!has) current_value.push(newcol);
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                    schema = self.get_path_schema(editor_path);
                                    return [
                                        4,
                                        self.render_form_property(schema, editor_property, current_value, editor_path, editor_color, container_type)
                                    ];
                                case 1:
                                    editor_element.outerHTML = _state.sent();
                                    return [
                                        4,
                                        self.cb_emit({
                                            "@": self.get_form_value()
                                        })
                                    ];
                                case 2:
                                    _state.sent();
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(element, path) {
                        return _ref.apply(this, arguments);
                    };
                }();
                html += `<div class="editor-value-editor" id="${e_id}" lang="${node.schema.syntax || ""}" static="${node.schema.static || ""}">${escaped_tev}</div>`;
                if (!window["selectvalue_" + _this.ci_idx]) window["selectvalue_" + _this.ci_idx] = function() {
                    var _ref = (0, _asyncToGenerator._)(function(select) {
                        var textarea, selected_value;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    textarea = select.parentElement.parentElement.querySelector("textarea");
                                    if (!textarea) return [
                                        3,
                                        2
                                    ];
                                    selected_value = select.value;
                                    textarea.value = selected_value;
                                    return [
                                        4,
                                        self.cb_emit({
                                            "@": self.get_form_value()
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(select) {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (!window["editvalue_" + _this.ci_idx]) window["editvalue_" + _this.ci_idx] = function() {
                    var _ref = (0, _asyncToGenerator._)(function(ce_div) {
                        var textarea, editor, tag_value;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    textarea = ce_div.parentElement.parentElement.querySelector("textarea");
                                    if (!textarea) return [
                                        3,
                                        2
                                    ];
                                    editor = self.editors_by_e_id[ce_div.id].editor;
                                    if (!editor) return [
                                        3,
                                        2
                                    ];
                                    tag_value = editor.state.doc.toString();
                                    textarea.value = tag_value;
                                    node.value = tag_value;
                                    return [
                                        4,
                                        self.cb_emit({
                                            "@": self.get_form_value()
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(ce_div) {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (!window["editdesc_" + _this.ci_idx]) window["editdesc_" + _this.ci_idx] = /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    self.cb_emit({
                                        "@": self.get_form_value()
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return [
                    2,
                    html
                ];
            });
        })();
    }
    convertInputDivsToCodemirror() {
        var value_editors = document.querySelectorAll(".editor-value-editor");
        if (value_editors) for(var e = 0; e < value_editors.length; e++){
            var value_editor = value_editors[e];
            this.editors_by_e_id[value_editor.id];
            this.editors_by_e_id[value_editor.id] = {
                has: true,
                editor: null,
                last_head: -1
            };
            this.convertToCodeMirror(value_editor);
        }
    }
    convertToCodeMirror(value_editor) {
        if (value_editor.children.length > 0 && value_editor.children[0].classList.contains("cm-editor")) return;
        var self = this;
        var doc = (0, _cbWebUtil.CBWebUtil).unescapeHtml(value_editor.innerHTML);
        value_editor.innerHTML = "";
        var lang = value_editor.getAttribute("lang");
        var is_static = value_editor.getAttribute("static");
        var extensions = [];
        if (!is_static) {
            var config = {
                props: []
            };
            if (lang == "html") config.wrap = (0, _common.parseMixed)((node)=>{
                return node.type.isTop ? {
                    parser: (0, _langHtml.htmlLanguage).parser,
                    overlay: (node)=>node.type.name == "Text"
                } : null;
            });
            var mixedCBTemplateParser = (0, _cbtemplateParser.parser).configure(config);
            var cbtemplateLanguage = (0, _language.LRLanguage).define({
                parser: mixedCBTemplateParser
            });
            var cbtemplateAutocompletion = cbtemplateLanguage.data.of({
                autocomplete: function cbTemplateCompletionSource(context) {
                    var state = context.state, pos = context.pos;
                    var nodeBefore = (0, _language.syntaxTree)(state).resolveInner(pos, -1);
                    var node_type = nodeBefore.type.name;
                    var word = context.matchBefore(/\w*/);
                    var options = [];
                    if (node_type == "Brick") self.CreateBrickOptions(word.text, options);
                    else if (node_type == "Output") {
                        if (nodeBefore.prevSibling) {
                            var brick_name = context.state.sliceDoc(nodeBefore.prevSibling.from, nodeBefore.prevSibling.to);
                            self.CreateOutputOptions(word.text, brick_name, options);
                        }
                    } else if (node_type == "Prop") self.CreatePropOptions(nodeBefore, context.state, word.text, options);
                    else if (node_type == "FormatType") self.CreateFormatTypeOptions(word.text, options);
                    else if (node_type == "FormatFunc") {
                        if (nodeBefore.prevSibling && nodeBefore.prevSibling.prevSibling) {
                            var format_type = context.state.sliceDoc(nodeBefore.prevSibling.prevSibling.from, nodeBefore.prevSibling.prevSibling.to);
                            self.CreateFormatFuncOptions(word.text, format_type, options);
                        }
                    } else if (node_type == "Formatparams") {
                        var option = {
                            label: "()",
                            displayLabel: "() (Add Format Parameters)",
                            section: "Format Functions",
                            apply: function apply(view, completion, from, to) {
                                view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                (0, _autocomplete.startCompletion)(editor);
                                return true;
                            }
                        };
                        options.push(option);
                    }
                    var tep = new (0, _tagElementPredictor.TagElementPredictor)((0, _cbtemplateNodes.CBTemplateParserNodes));
                    tep.GetACOptions(nodeBefore);
                    var allowed_nexts = tep.GetAllAllowedNextTags();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = allowed_nexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var allowed_next = _step.value;
                            if (allowed_next[0] == "Brick" && node_type != "Brick") self.CreateBrickOptions(word.text, options);
                            else if (allowed_next[0] == "Output" && node_type != "Output") {
                                if (nodeBefore.prevSibling) {
                                    var brick_name1 = context.state.sliceDoc(nodeBefore.prevSibling.from, nodeBefore.prevSibling.to);
                                    self.CreateOutputOptions(word.text, brick_name1, options);
                                }
                            } else if (allowed_next[0] == "Prop" && node_type != "Prop") self.CreatePropOptions(nodeBefore, context.state, word.text, options);
                            else if (allowed_next[0] == "Eq") {
                                var option1 = {
                                    label: "=",
                                    displayLabel: "= (" + allowed_next[1] + ")",
                                    section: "Opertators",
                                    boost: -1,
                                    apply: function apply(view, completion, from, to) {
                                        view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                        (0, _autocomplete.startCompletion)(editor);
                                        return true;
                                    }
                                };
                                options.push(option1);
                            } else if (allowed_next[0] == "And") {
                                var option2 = {
                                    label: "&",
                                    displayLabel: "& (And)",
                                    section: "Opertators",
                                    apply: function apply(view, completion, from, to) {
                                        view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                        (0, _autocomplete.startCompletion)(editor);
                                        return true;
                                    }
                                };
                                options.push(option2);
                            } else if (allowed_next[0] == "Or") {
                                var option3 = {
                                    label: "|",
                                    displayLabel: "| (Or)",
                                    section: "Opertators",
                                    apply: function apply(view, completion, from, to) {
                                        view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                        (0, _autocomplete.startCompletion)(editor);
                                        return true;
                                    }
                                };
                                options.push(option3);
                            } else if (allowed_next[0] == "Plus") {
                                var option4 = {
                                    label: "+",
                                    displayLabel: "+ (Append Term)",
                                    section: "Opertators",
                                    apply: function apply(view, completion, from, to) {
                                        view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                        (0, _autocomplete.startCompletion)(editor);
                                        return true;
                                    }
                                };
                                options.push(option4);
                            } else if (allowed_next[0] == "Boolean") {
                                var option5 = {
                                    label: "true",
                                    displayLabel: "true (true)",
                                    section: "Insert Primitive Value: (You may also type numbers)"
                                };
                                options.push(option5);
                                var option21 = {
                                    label: "false",
                                    displayLabel: "false (false)",
                                    section: "Insert Primitive Value: (You may also type numbers)"
                                };
                                options.push(option21);
                            } else if (allowed_next[0] == "Null") {
                                var option6 = {
                                    label: "null",
                                    displayLabel: "null (null)",
                                    section: "Insert Primitive Value: (You may also type numbers)"
                                };
                                options.push(option6);
                            } else if (allowed_next[0] == "String") {
                                var option7 = {
                                    label: '"',
                                    displayLabel: '" (String)',
                                    section: "Insert Primitive Value: (You may also type numbers)"
                                };
                                options.push(option7);
                            } else if (allowed_next[0] == "FormatType" && node_type != "FormatType") self.CreateFormatTypeOptions(word.text, options);
                            else if (allowed_next[0] == "FormatFunc" && node_type != "FormatFunc") {
                                if (nodeBefore.prevSibling) {
                                    var format_type1 = context.state.sliceDoc(nodeBefore.prevSibling.from, nodeBefore.prevSibling.to);
                                    self.CreateFormatFuncOptions(word.text, format_type1, options);
                                }
                            } else if (allowed_next[0] == "Formatparams" && node_type != "Formatparams") {
                                var option8 = {
                                    label: "()",
                                    displayLabel: "() (Add Format Parameters)",
                                    section: "Format Functions",
                                    apply: function apply(view, completion, from, to) {
                                        view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                        (0, _autocomplete.startCompletion)(editor);
                                        return true;
                                    }
                                };
                                options.push(option8);
                            } else if (allowed_next[0] == "Number") ;
                            else {
                                var option9 = {
                                    label: allowed_next[0],
                                    displayLabel: allowed_next[0] + " (" + allowed_next[1] + ")",
                                    section: "Opertators",
                                    boost: -2,
                                    apply: function apply(view, completion, from, to) {
                                        view.dispatch((0, _autocomplete.insertCompletionText)(view.state, completion.label, to, to));
                                        (0, _autocomplete.startCompletion)(editor);
                                        return true;
                                    }
                                };
                                options.push(option9);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        from: word.from,
                        filter: false,
                        options: options
                    };
                }
            });
            this.destroyCodemirrorEditor(value_editor.id);
            extensions = [
                (0, _codemirror.minimalSetup),
                (0, _autocomplete.closeBrackets)(),
                (0, _codemirror.EditorView).lineWrapping,
                (0, _autocomplete.autocompletion)({
                    activateOnCompletion: function activateOnCompletion(completion) {
                        return true;
                    }
                }),
                cbtemplateLanguage,
                cbtemplateAutocompletion,
                (0, _language.syntaxHighlighting)((0, _cbtemplateHighlight.cbtemplateHighlightStyle))
            ];
            if (lang == "html") {
                extensions.push((0, _view.keymap).of([
                    (0, _commands.indentWithTab)
                ]));
                extensions.push((0, _langHtml.html)().support);
            } else if (lang == "javascript") extensions.push((0, _langJavascript.javascript)().support);
            else extensions.push(cbtemplateLanguage.data.of({
                autocomplete: function completionSource(context) {
                    var before = context.matchBefore(/\w+|\{\{/);
                    if (!context.explicit && !before) return null;
                    var char = context.state.doc.slice(context.state.selection.main.head - 1, context.state.selection.main.head);
                    if (char == '"' || char == "'") return;
                    return {
                        from: before ? before.from : context.pos,
                        options: [
                            {
                                label: "null"
                            },
                            {
                                label: "true"
                            },
                            {
                                label: "false"
                            }
                        ],
                        validFor: /^\w*$/
                    };
                }
            }));
        } else {
            extensions = [
                (0, _codemirror.EditorView).lineWrapping
            ];
            if (lang == "javascript") {
                extensions.push((0, _codemirror.basicSetup));
                extensions.push((0, _view.keymap).of([
                    (0, _commands.indentWithTab)
                ]));
                extensions.push((0, _langJavascript.javascript)());
                extensions.push((0, _langJavascript.javascriptLanguage).data.of({
                    autocomplete: (0, _langJavascript.scopeCompletionSource)(globalThis)
                }));
                extensions.push((0, _langJavascript.javascriptLanguage).data.of({
                    autocomplete: function completionSource(context) {
                        var before = context.matchBefore(/\{\{/);
                        if (!context.explicit && !before) return null;
                        if (before != null) return {
                            from: before ? before.from : context.pos,
                            options: [
                                {
                                    label: "{{",
                                    displayLabel: "This is static field, tags are not allowed. Please use tags in the params instead",
                                    type: "tag"
                                }
                            ],
                            validFor: /\{\{/
                        };
                    }
                }));
            } else {
                extensions.push((0, _codemirror.minimalSetup));
                var completions = [
                    {
                        label: "null",
                        type: "keyword"
                    },
                    {
                        label: "true",
                        type: "keyword"
                    },
                    {
                        label: "false",
                        type: "keyword"
                    },
                    {
                        label: "{{",
                        displayLabel: "This is static field, tags are not allowed",
                        type: "tag"
                    }
                ];
                function myCompletions(context) {
                    var before = context.matchBefore(/\w+|\{\{/);
                    if (!context.explicit && !before) return null;
                    return {
                        from: before ? before.from : context.pos,
                        options: completions,
                        validFor: /^\w*$/
                    };
                }
                extensions.push((0, _autocomplete.autocompletion)({
                    override: [
                        myCompletions
                    ]
                }));
            }
        }
        extensions.push((0, _codemirror.EditorView).updateListener.of((v)=>{
            if (editor.hasFocus) {
                if (self.editors_by_e_id[value_editor.id].last_head != editor.state.selection.main.head) {
                    var char = v.state.doc.slice(v.state.selection.main.head - 1, v.state.selection.main.head);
                    if (char == '"' || char == "'") setTimeout(function() {
                        (0, _autocomplete.startCompletion)(editor);
                    }, 1);
                }
                self.editors_by_e_id[value_editor.id].last_head = editor.state.selection.main.head;
            }
            if (v.docChanged) window["editvalue_" + self.ci_idx](value_editor);
        }));
        var editor = new (0, _codemirror.EditorView)({
            doc: doc,
            extensions: extensions,
            parent: value_editor
        });
        this.editors_by_e_id[value_editor.id] = {
            has: true,
            editor: editor,
            last_head: -1
        };
    }
    CreateBrickOptions(search_word, options) {
        if (this.composition_tree && this.composition_tree.debug_log && this.composition_tree.debug_log.last_emit_data) {
            var search_word_lc = search_word.toLowerCase();
            var brick_section = "Get value from this brick:";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var source = _step.value;
                    var brick_name = source.value;
                    if (this.composition_tree.debug_log.last_emit_data[brick_name]) {
                        if (brick_name.toLowerCase().startsWith(search_word_lc)) {
                            var option = {
                                label: brick_name,
                                displayLabel: brick_name + " (" + source.meta + ")",
                                section: brick_section,
                                boost: 1
                            };
                            options.push(option);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = this.sources[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var source1 = _step1.value;
                    var brick_name1 = source1.value;
                    if (this.composition_tree.debug_log.last_emit_data[brick_name1]) {
                        if (!brick_name1.toLowerCase().startsWith(search_word_lc) && brick_name1.toLowerCase().indexOf(search_word_lc) != -1) {
                            var option1 = {
                                label: brick_name1,
                                displayLabel: brick_name1 + " (" + source1.meta + ")",
                                section: brick_section
                            };
                            options.push(option1);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        if ("true".startsWith(search_word)) {
            var option2 = {
                label: "true",
                displayLabel: "true (true)",
                section: "Insert Primitive Value: (You may also type numbers)"
            };
            options.push(option2);
        } else if ("false".startsWith(search_word)) {
            var option3 = {
                label: "false",
                displayLabel: "false (false)",
                section: "Insert Primitive Value: (You may also type numbers)"
            };
            options.push(option3);
        } else if ("null".startsWith(search_word)) {
            var option4 = {
                label: "null",
                displayLabel: "null (null)",
                section: "Insert Primitive Value: (You may also type numbers)"
            };
            options.push(option4);
        }
    }
    CreateOutputOptions(search_word, brick_name, options) {
        if (this.composition_tree && this.composition_tree.debug_log && this.composition_tree.debug_log.last_emit_data && this.composition_tree.debug_log.last_emit_data[brick_name]) {
            var led = this.composition_tree.debug_log.last_emit_data[brick_name];
            var search_word_lc = search_word.toLowerCase();
            for(var output in led.outputs){
                if (output.toLowerCase().indexOf(search_word_lc) != -1) {
                    if (output != "@" && output != "@debug_log") {
                        var option = {
                            label: output,
                            displayLabel: output + " (" + led.outputs[output].desc + ")",
                            section: "On outputs"
                        };
                        options.push(option);
                    }
                }
            }
        }
    }
    CreatePropOptions(nodeBefore, state, search_word, options) {
        var brick_node = nodeBefore.prevSibling;
        var prop_path = [];
        while(brick_node && brick_node.type.name != "Brick"){
            if (brick_node.type.name == "Prop" || brick_node.name == "Output") prop_path.unshift(state.sliceDoc(brick_node.from, brick_node.to));
            brick_node = brick_node.prevSibling;
        }
        if (brick_node) {
            var brick_name = state.sliceDoc(brick_node.from, brick_node.to);
            if (this.composition_tree && this.composition_tree.debug_log && this.composition_tree.debug_log.last_emit_data && this.composition_tree.debug_log.last_emit_data[brick_name]) {
                var led = this.composition_tree.debug_log.last_emit_data[brick_name].outputs;
                if (prop_path.length > 0 && prop_path[0][0] == "@") {
                    led = led[prop_path[0]].data;
                    prop_path.splice(0, 1);
                } else led = led["@"].data;
                var atdata = (0, _cbutil.DrillGet)(prop_path, led);
                var prop;
                if (prop_path.length == 0) prop = undefined;
                else prop = prop_path[prop_path.length - 1];
                this.CreateObjectOptions(prop, atdata, options, "", search_word);
            }
        }
    }
    CreateObjectOptions(key, val, options, path, search_word) {
        if (key !== undefined && key.toLowerCase().indexOf(search_word.toLowerCase()) != -1) {
            var s = path.split(".");
            var last = s[s.length - 1];
            var padstr = "-";
            var display = last.padStart(s.length + (last.length - 1) * padstr.length, padstr);
            var meta = val;
            if (typeof val == "object" && val !== null) {
                if (Array.isArray(val)) meta = "List / Array";
                else meta = "Object";
            }
            options.push({
                label: path,
                displayLabel: display + " (" + meta + ")",
                section: " Property"
            });
        }
        var search_lc = search_word.toLocaleLowerCase();
        if (typeof val == "object" && val !== null) {
            for(var p in val)if (p.toLocaleLowerCase().startsWith(search_lc)) this.CreateObjectOptions(p, val[p], options, path ? path + "." + p : p, search_word);
            for(var p1 in val)if (p1.toLocaleLowerCase().indexOf(search_lc) != -1 && !p1.toLocaleLowerCase().startsWith(search_lc)) this.CreateObjectOptions(p1, val[p1], options, path ? path + "." + p1 : p1, search_word);
        }
    }
    CreateFormatTypeOptions(search_word, options) {
        var types = [
            "Array",
            "Date",
            "DateFromUTC",
            "DateToUTC",
            "Number",
            "Object",
            "Range",
            "RegExp",
            "String"
        ];
        var search_word_lc = search_word.toLowerCase();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var type = _step.value;
                if (type.toLowerCase().startsWith(search_word_lc)) {
                    var option = {
                        label: type,
                        displayLabel: type,
                        section: "Format"
                    };
                    options.push(option);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    CreateFormatFuncOptions(search_word, format_type, options) {
        var search_word_lc = search_word.toLowerCase();
        var funcs = (0, _sugarDefault.default)[format_type];
        if (format_type == "Array") funcs = (0, _sugarDefault.default).Array([]);
        for(var f in funcs)if (f.toLowerCase().startsWith(search_word_lc)) {
            var option = {
                label: f,
                displayLabel: f,
                section: "Format Functions"
            };
            options.push(option);
        }
    }
    destroyCodemirrorEditor(e_id) {
        var editor = this.editors_by_e_id[e_id].editor;
        if (editor) editor.destroy();
    }
    destroyCodemirrorEditors() {
        for(var e_id in this.editors_by_e_id){
            var editor = this.editors_by_e_id[e_id].editor;
            if (editor) editor.destroy();
        }
        this.editors_by_e_id = {};
    }
    get_source_list() {
        var sources_obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (this.sources) try {
            for(var _iterator = this.sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var src = _step.value;
                sources_obj[src.value] = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var context_container_name = this.find_brick_context(this.composition_tree, "");
        if (context_container_name == this.brick_name) {
            var input = this.current_path.split(".")[0];
            if (input == "in_data") {
                var container = (0, _cbutil.FindBrickContainer)(this.composition_tree, this.brick_name);
                if (container) context_container_name = container.name;
            }
        }
        return this.get_context_sources(context_container_name, sources_obj);
    }
    find_brick_context(from, context) {
        if (from.name == this.brick_name) return context;
        if (from.contains) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = from.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    if (c.type == "sc-container") {
                        var found = this.find_brick_context(c, c.name);
                        if (found) return found;
                    } else {
                        var found1 = this.find_brick_context(c, context);
                        if (found1) return found1;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return "";
    }
    get_context_sources(context_container_name, sources_obj) {
        var start = this.composition_tree;
        var sources = [];
        if (context_container_name != "") {
            start = (0, _cbutil.FindBrick)(this.composition_tree, context_container_name);
            sources.push(context_container_name);
        }
        sources.push(start.name);
        this.gather_sources_recurse(start, sources_obj, sources);
        return sources;
    }
    gather_sources_recurse(from, sources_obj, sources) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (from.contains) try {
            for(var _iterator = from.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                if (sources_obj[c.name]) sources.push(c.name);
                if (c.type != "sc-container") this.gather_sources_recurse(c, sources_obj, sources);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.handlers = {};
        this.edit_path = "";
        this.any_props = {};
        this.enable_templating = true;
        this.ui_tree = {};
        this.nodeid = 1;
        this.container_id = "";
        this.cb_selects = {};
        this.sources = [];
        this.specs = {};
        this.composition_name = "";
        this.container_name = "";
        this.composition_tree = {};
        this.brick_name = "";
        this.brick_type = "";
        this.pre_edit_tag_contents = "";
        this.has_ok_callback = false;
        this.element_idx = 0;
        this.schema = {};
        this.current_path = "";
        this.editors_by_e_id = {};
        this.element = element;
        window.cb_editor = window.cb_editor || {};
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../../codebricks-runtime/TemplateUtil":"ebZ29","../controls/cb_web_util":"jCKPs","codemirror":"dEQfk","@codemirror/autocomplete":"2rxgM","../template_lang/cbtemplate-parser":"c7JSA","@codemirror/lang-html":"5bkjX","@lezer/common":"9CjLE","@codemirror/language":"jct2S","../template_lang/cbtemplate-highlight":"fKbnc","../template_lang/TagElementPredictor":"77src","../template_lang/CBTemplateNodes":"lY9lV","@codemirror/lang-javascript":"0dLBb","@codemirror/view":"l3day","@codemirror/commands":"8GWsb","../controls/cb_tooltip":"wtPnN","sugar":"gcIJ7","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"77src":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagElementPredictor", ()=>TagElementPredictor);
class TagElementPredictor {
    GetACOptions(nodeBefore) {
        var tokens = this.GetTokens(nodeBefore);
        this.RunNodeGrammar(tokens);
        var path_states = this.current_states;
        var allowed_next = this.GetAllAllowedNextTags();
        return allowed_next;
    }
    GetTokens(nodeBefore) {
        var tokens = [];
        var node = nodeBefore;
        while(node != null && node.type.name && node.type.name != "\u26A0"){
            tokens.unshift(node.type.name);
            node = node.prevSibling;
        }
        return tokens;
    }
    RunNodeGrammar(tokens) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var token = _step.value;
                var new_states_lists = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.current_states[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var state = _step1.value;
                        var new_states = [];
                        this.FollowNodeForToken(token, state, new_states);
                        if (new_states.length == 0) ;
                        else new_states_lists.push(new_states);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var united_states = [];
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined, _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator2 = new_states_lists[Symbol.iterator](), _step2; !(_iteratorNormalCompletion3 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion3 = true){
                        var list = _step2.value;
                        try {
                            for(var _iterator3 = list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion2 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion2 = true){
                                var state1 = _step3.value;
                                united_states.push(state1);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                this.current_states = united_states;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    FollowNodeForToken(token, from_state, new_states) {
        var node_nexts = this.nodes[from_state.line][from_state.node];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = node_nexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var possible_next = _step.value;
                if (possible_next == "done") {
                    if (from_state.parent) this.FollowNodeForToken(token, from_state.parent, new_states);
                    continue;
                }
                var denumbered_possible_next = possible_next;
                if (possible_next.indexOf("_") != -1) denumbered_possible_next = possible_next.split("_")[0];
                var isvalue = this.values[denumbered_possible_next];
                var isnode = this.nodes[denumbered_possible_next];
                if (isvalue && isvalue[0] == token) new_states.push({
                    line: from_state.line,
                    node: possible_next,
                    parent: from_state.parent
                });
                else if (isnode) {
                    var push_state = {
                        line: denumbered_possible_next,
                        node: "start",
                        parent: {
                            line: from_state.line,
                            node: possible_next,
                            parent: from_state.parent
                        }
                    };
                    this.FollowNodeForToken(token, push_state, new_states);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    GetAllAllowedNextTags() {
        var result = [];
        var has = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.current_states[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var state = _step.value;
                this.GetAllAllowedNextTagsRecurse(state, result, has);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }
    GetAllAllowedNextTagsRecurse(state, result, has) {
        var allowed_nexts = this.nodes[state.line][state.node];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = allowed_nexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var allowed_next = _step.value;
                if (allowed_next == "done") {
                    if (state.parent) this.GetAllAllowedNextTagsRecurse(state.parent, result, has);
                    continue;
                }
                var denumbered_allowed_next = allowed_next;
                if (allowed_next.indexOf("_") != -1) denumbered_allowed_next = allowed_next.split("_")[0];
                var isvalue = this.values[denumbered_allowed_next];
                var isnode = this.nodes[denumbered_allowed_next];
                if (isvalue && !has[isvalue[0]]) {
                    result.push(isvalue);
                    has[isvalue[0]] = true;
                } else if (isnode) {
                    var go_state = {
                        line: denumbered_allowed_next,
                        node: "start"
                    };
                    this.GetAllAllowedNextTagsRecurse(go_state, result, has);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    constructor(grammar){
        this.grammar = grammar;
        this.nodes = this.grammar.grammar.nodes;
        this.values = this.grammar.grammar.values;
        this.current_states = [
            {
                line: "Top",
                node: "start"
            }
        ];
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lY9lV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CBTemplateParserNodes", ()=>CBTemplateParserNodes);
var CBTemplateParserNodes = {
    grammar: {
        values: {
            And: [
                "And",
                "And"
            ],
            Or: [
                "Or",
                "Or"
            ],
            bracesclose: [
                "}}",
                "End tag"
            ],
            bracesopen: [
                "{{",
                "Start tag"
            ],
            bracketclose: [
                ")",
                "End bracket"
            ],
            bracketopen: [
                "(",
                "Start bracket"
            ],
            Brick: [
                "Brick",
                "Select source brick"
            ],
            colon: [
                ":",
                " else"
            ],
            comma: [
                ",",
                "Add another source"
            ],
            dot: [
                ".",
                "Add output or property (optional, else whole output used)"
            ],
            dot2: [
                ".",
                "Add property (optional, else whole output used)"
            ],
            Eq: [
                "Eq",
                "Add equals condition"
            ],
            gt: [
                ">",
                "Add greater than condition"
            ],
            ge: [
                ">=",
                "Add greater or equal condition"
            ],
            lt: [
                "<",
                "Add less than condition"
            ],
            le: [
                "<=",
                "Add less or equal condition"
            ],
            pipe: [
                "|",
                "Or"
            ],
            Output: [
                "Output",
                "Select output"
            ],
            Prop: [
                "Prop",
                "Select property"
            ],
            semicolon: [
                ";",
                "Add format"
            ],
            questionmark: [
                "?",
                "then"
            ],
            tilde: [
                "~",
                "then (Only WHEN left term received)"
            ],
            Null: [
                "Null",
                "Null"
            ],
            Boolean: [
                "Boolean",
                "Boolean"
            ],
            Number: [
                "Number",
                "Number"
            ],
            String: [
                "String",
                "Start string"
            ],
            FormatType: [
                "FormatType",
                "Format Type"
            ],
            Formatparams: [
                "Formatparams",
                "Format Parameters"
            ],
            formatdot: [
                ".",
                "Add format function"
            ],
            FormatFunc: [
                "FormatFunc",
                "Format Function"
            ],
            Plus: [
                "Plus",
                "Append Term"
            ]
        },
        nodes: {
            Top: {
                start: [
                    "bracesopen"
                ],
                bracesopen: [
                    "section"
                ],
                section: [
                    "comma",
                    "semicolon",
                    "bracesclose"
                ],
                comma: [
                    "section"
                ],
                semicolon: [
                    "Format"
                ],
                Format: [
                    "bracesclose"
                ],
                bracesclose: [
                    "done"
                ]
            },
            nestedTag: {
                start: [
                    "bracketopen"
                ],
                bracketopen: [
                    "section"
                ],
                section: [
                    "comma",
                    "semicolon",
                    "bracketclose"
                ],
                comma: [
                    "section"
                ],
                semicolon: [
                    "Format"
                ],
                Format: [
                    "bracketclose"
                ],
                bracketclose: [
                    "done"
                ]
            },
            section: {
                start: [
                    "compareValue"
                ],
                compareValue: [
                    "And",
                    "Or",
                    "questionmark",
                    "tilde",
                    "done"
                ],
                And: [
                    "compareValue"
                ],
                Or: [
                    "compareValue"
                ],
                questionmark: [
                    "appendterm"
                ],
                tilde: [
                    "appendterm"
                ],
                appendterm: [
                    "colon",
                    "done"
                ],
                colon: [
                    "appendterm_2"
                ],
                appendterm_2: [
                    "done"
                ]
            },
            compareValue: {
                start: [
                    "appendterm"
                ],
                appendterm: [
                    "Eq",
                    "lt",
                    "gt",
                    "le",
                    "ge",
                    "done"
                ],
                Eq: [
                    "appendterm_2"
                ],
                lt: [
                    "appendterm_2"
                ],
                gt: [
                    "appendterm_2"
                ],
                le: [
                    "appendterm_2"
                ],
                ge: [
                    "appendterm_2"
                ],
                appendterm_2: [
                    "done"
                ]
            },
            appendterm: {
                start: [
                    "term"
                ],
                term: [
                    "Plus",
                    "done"
                ],
                Plus: [
                    "term"
                ]
            },
            term: {
                start: [
                    "Brick",
                    "String",
                    "Number",
                    "Boolean",
                    "Null",
                    "nestedTag"
                ],
                Brick: [
                    "dot",
                    "dot2",
                    "done"
                ],
                dot: [
                    "Output",
                    "Prop"
                ],
                Output: [
                    "dot2",
                    "done"
                ],
                dot2: [
                    "Prop"
                ],
                String: [
                    "done"
                ],
                Null: [
                    "done"
                ],
                Number: [
                    "done"
                ],
                Boolean: [
                    "done"
                ],
                Prop: [
                    "dot2",
                    "done"
                ],
                nestedTag: [
                    "done"
                ]
            },
            Format: {
                start: [
                    "FormatType"
                ],
                FormatType: [
                    "Formatparams",
                    "formatdot"
                ],
                Formatparams: [
                    "formatdot",
                    "done"
                ],
                formatdot: [
                    "FormatFunc"
                ],
                FormatFunc: [
                    "Formatparams",
                    "done"
                ]
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5wENA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_textarea_webcomponent", ()=>c_textarea_webcomponent);
parcelHelpers.export(exports, "web_c_textarea", ()=>web_c_textarea);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class c_textarea_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_textarea(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-textarea", c_textarea_webcomponent);
class web_c_textarea extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var name, _$input, input_wrap, validation_message_container, _$input1, self, container;
            return (0, _tsGenerator._)(this, function(_state) {
                name = _this.brick_id;
                if (input == "value") {
                    _this.value = cfg;
                    _$input = document.getElementById(`${name}`);
                    if (_$input) {
                        _$input.value = _this.value;
                        _this.clearValidation();
                        input_wrap = document.getElementById(`${_this.brick_id}$wrap`);
                        if (input_wrap) input_wrap.classList.remove("c-input-validation-failed");
                        validation_message_container = document.getElementById(`${_this.brick_id}&validation`);
                        if (validation_message_container) {
                            validation_message_container.style.display = "none";
                            validation_message_container.innerHTML = "";
                        }
                        return [
                            2,
                            {
                                "@": _this.value
                            }
                        ];
                    }
                } else if (input == "cfg") {
                    _this.element.innerHTML = `<div class="form-element-container c-textarea-container"><label class="form-element-label c-textarea-label" for="${name}">${cfg.label || ""}</label><textarea id="${_this.brick_id}" class="form-element c-textarea" rows="${cfg.rows || 5}">${_this.value}</textarea></div><div class="c-input-validation-message" id="${_this.brick_id}&validation" style="display:none"></div>`;
                    _$input1 = document.getElementById(`${_this.brick_id}`);
                    if (!_this.initialised) {
                        _this.initialised = true;
                        _$input1.innerHTML = _this.value;
                        self = _this;
                        if (_$input1) _$input1.addEventListener("change", function() {
                            if (self.validate) self.cb_validate();
                            self.cb_emit({
                                "@": _$input1.value
                            });
                        });
                    }
                    (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(_$input1, cfg, "input");
                    container = _$input1.parentElement;
                    (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                    (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container === null || container === void 0 ? void 0 : container.firstElementChild, cfg, "label");
                    _this.label = cfg.label;
                    _this.validation = cfg.validation;
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "required") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) input.classList.add("required");
        } else if (status == "") {
            var input1 = document.getElementById(`${this.brick_id}`);
            if (input1) input1.classList.remove("required");
        }
    }
    clearValidation() {
        var input_wrap = document.getElementById(`${this.brick_id}`);
        input_wrap.classList.remove("c-input-validation-failed");
        var validation_message_container = document.getElementById(`${this.brick_id}&validation`);
        if (validation_message_container) {
            validation_message_container.style.display = "none";
            validation_message_container.innerHTML = "";
        }
        this.validate = false;
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.validation) {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) {
                var value = input.value;
                if (this.validation.required && (value === "" || value === null || value === undefined)) {
                    validates = false;
                    validation_message = (this.label || "Value") + " is a required field.";
                } else if (this.validation.minlength > 0 && value.length < this.validation.minlength) {
                    validates = false;
                    validation_message = this.label + " must be at least " + this.validation.minlength + " characters.";
                } else if (this.validation.maxlength > 0 && value.length > this.validation.maxlength) {
                    validates = false;
                    validation_message = this.label + " may not exceed " + this.validation.maxlength + " characters.";
                } else if (this.validation.pattern !== "" && this.validation.pattern !== null && this.validation.pattern !== undefined) {
                    if (!new RegExp("^(?:" + this.validation.pattern.trim() + ")$").test(value)) {
                        validates = false;
                        validation_message = this.validation.pattern_message;
                    }
                } else if (this.validation.invalidate_msg) {
                    validates = false;
                    validation_message = this.validation.invalidate_msg;
                }
            }
            var validation_message_container = document.getElementById(`${this.brick_id}&validation`);
            var input_wrap = document.getElementById(`${this.brick_id}`);
            if (validates) {
                input_wrap.classList.remove("c-input-validation-failed");
                if (validation_message_container) {
                    validation_message_container.style.display = "none";
                    validation_message_container.innerHTML = "";
                }
            } else {
                input_wrap.classList.add("c-input-validation-failed");
                if (validation_message_container) {
                    validation_message_container.innerHTML = validation_message;
                    validation_message_container.style.display = "block";
                }
            }
        }
        this.validate = true;
        return validates;
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.label = "";
        this.validation = null;
        this.validate = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"C4QyY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_visual_debugger_webcomponent", ()=>c_visual_debugger_webcomponent);
parcelHelpers.export(exports, "web_c_visual_debugger", ()=>web_c_visual_debugger);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _templateUtil = require("../../codebricks-runtime/TemplateUtil");
var _cbWebUtil = require("../controls/cb_web_util");
class c_visual_debugger_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_c_visual_debugger(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("c-visual-debugger", c_visual_debugger_webcomponent);
class web_c_visual_debugger extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var brick_info_tree, search;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    if (!_this.initialized) {
                        _this.create_modal();
                        _this.initialized = true;
                    }
                    _this.include_sub_compositions = cfg.include_sub_compositions || false;
                    brick_info_tree = cfg.brick_info_tree;
                    if (brick_info_tree && brick_info_tree.blueprint) ;
                    else if (_this.context.composition_runners["_1"]) brick_info_tree = (0, _cbutil.createBrickInfoTree)(_this.context.composition_runners["_1"]);
                    search = (cfg.search || "").toLowerCase();
                    if (brick_info_tree) _this.renderBrickInfoTree(brick_info_tree, search);
                }
                return [
                    2
                ];
            });
        })();
    }
    renderBrickInfoTree(brick_info_tree, search) {
        this.container.innerHTML = "";
        var container = document.getElementById(this.brick_id);
        if (container) this.renderBrickInfoTreeRecurse(brick_info_tree, 0, search);
    }
    renderBrickInfoTreeRecurse(brick_info, nest, search) {
        if (!brick_info.blueprint) {
            console.error("renderBrickInfoTreeRecurse: no blueprint " + JSON.stringify(brick_info));
            return;
        }
        this.CheckFillJitGenerator(brick_info);
        var is_sub = brick_info.blueprint.name.indexOf((0, _cbutil.PrefabNameJoin)) != -1;
        var sub_inc = 0;
        var bi_container = null;
        if ((!is_sub || this.include_sub_compositions) && (search == "" || brick_info.blueprint.name.toLowerCase().indexOf(search) != -1)) {
            var _this = this, _loop = function(input) {
                var in_element = document.createElement("div");
                in_element.classList.add("c-vd-in");
                in_element.style.marginLeft = 2 * NEST_MARGIN + "px";
                var bi_ins_btn = document.createElement("button");
                bi_ins_btn.classList.add("c-vd-btn");
                bi_ins_btn.classList.add("c-vd-btn-in");
                bi_ins_btn.innerHTML = input;
                in_element.appendChild(bi_ins_btn);
                var tags_container = document.createElement("div");
                if (brick_info.debug_ios.last_ins && brick_info.debug_ios.last_ins[input] !== undefined) bi_ins_btn.classList.add("c-vd-btn-active");
                bi_ins_btn.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                    var in_val, template, json;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                in_val = "<h2>Template</h2>";
                                template = (0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(brick_info.blueprint.ins[input], null, 2));
                                template = template.replaceAll("\\n", "\n");
                                in_val += "<pre>" + template + "</pre>";
                                in_val += "<h2>Value</h2>";
                                if (brick_info.debug_ios.last_ins && brick_info.debug_ios.last_ins[input] !== undefined) {
                                    json = JSON.stringify(brick_info.debug_ios.last_ins[input] || {}, null, 2);
                                    json = (0, _cbWebUtil.CBWebUtil).escapeHtml(json);
                                    json = json.replaceAll("\\n", "\n");
                                    in_val += "<pre>" + json + "</pre>";
                                } else in_val += "<p><b>Unresolved:</b> Waiting for input(s) or tag conditions not passed</p>";
                                return [
                                    4,
                                    self.show_modal(brick_info.blueprint.name + " (" + brick_info.blueprint.type + ")<p><b>" + input + "</b> input - last value received:</p>", in_val)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = brick_info.parsed_ins[input].leaves[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var parsed_leaf = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = parsed_leaf.parts[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var tpart = _step1.value;
                                if (tpart.tag) {
                                    var ti_container = _this.renderTagItem(tpart.tag);
                                    ti_container.style.marginLeft = NEST_MARGIN + "px";
                                    tags_container.appendChild(ti_container);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                in_element.appendChild(tags_container);
                bi_container.appendChild(in_element);
            };
            var NEST_MARGIN = 10;
            bi_container = document.createElement("div");
            bi_container.style.marginLeft = nest * NEST_MARGIN + "px";
            var bi_heading = document.createElement("div");
            bi_heading.classList.add("c-vd-brick");
            var bi_name = document.createElement("div");
            bi_name.classList.add("c-vd-brick-name");
            bi_name.innerHTML = brick_info.blueprint.name + (brick_info.dci !== null ? " " + brick_info.dci : "");
            bi_heading.appendChild(bi_name);
            var brick_name = brick_info.blueprint.name;
            var brick_type = brick_info.blueprint.type;
            bi_name.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                var edit_buttons_container, targets, sub_brick_info, ins_str;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            edit_buttons_container = document.getElementById("cb_0_brick_tree-component_tree_container");
                            if (!edit_buttons_container) return [
                                3,
                                3
                            ];
                            targets = edit_buttons_container.querySelectorAll('[label="' + brick_name + '"]');
                            if (!(targets && targets.length > 0)) return [
                                3,
                                1
                            ];
                            targets[0].click();
                            return [
                                3,
                                3
                            ];
                        case 1:
                            sub_brick_info = "<p>This brick is in a sub composition. To edit the brick, please open the sub composition.</p><p> These are the settings for this brick:</p>";
                            ins_str = JSON.stringify(brick_info.blueprint.ins || {}, null, 2);
                            ins_str = (0, _cbWebUtil.CBWebUtil).escapeHtml(ins_str);
                            ins_str = ins_str.replaceAll("\\n", "\n");
                            ins_str = "<pre>" + ins_str + "</pre>";
                            return [
                                4,
                                self.show_modal(brick_name + "<p>" + brick_type + "</p>", sub_brick_info + ins_str)
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }));
            var bi_type = document.createElement("div");
            bi_type.classList.add("c-vd-type");
            bi_type.innerHTML = "(" + brick_info.blueprint.type + ")";
            bi_heading.appendChild(bi_type);
            var bi_outs_btn = document.createElement("button");
            bi_outs_btn.classList.add("c-vd-btn");
            bi_outs_btn.innerHTML = "outs";
            bi_heading.appendChild(bi_outs_btn);
            if (brick_info.debug_ios.last_outs) bi_outs_btn.classList.add("c-vd-btn-active");
            var self = this;
            bi_outs_btn.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                var outs, last_outs, outs_without_brick_info, p;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            outs = "No output";
                            last_outs = brick_info.debug_ios.last_outs;
                            if (brick_info.blueprint.type == "cc-use") {
                                if (brick_info.contains && brick_info.contains.length > 0 && brick_info.contains[0].debug_ios) last_outs = brick_info.contains[0].debug_ios.last_outs;
                                else last_outs = undefined;
                            }
                            if (last_outs !== undefined) {
                                outs_without_brick_info = {};
                                last_outs = last_outs || {};
                                for(var p in last_outs)if (p != "@brick_info_tree") outs_without_brick_info[p] = last_outs[p];
                                outs = '<div>Note: "@" is the default output</div><pre>' + JSON.stringify(outs_without_brick_info, null, 2) + "</pre>";
                            }
                            return [
                                4,
                                self.show_modal(brick_info.blueprint.name + " outs", outs)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            bi_container.appendChild(bi_heading);
            for(var input in brick_info.parsed_ins)_loop(input);
            sub_inc = 1;
            this.container.appendChild(bi_container);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (brick_info.contains) try {
            for(var _iterator = brick_info.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                this.renderBrickInfoTreeRecurse(c, nest + sub_inc, search);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    CheckFillJitGenerator(brick_info) {
        if (brick_info.blueprint.type != "c-jit-generator") return;
        for(var rcid in this.context.composition_runners){
            var runner = this.context.composition_runners[rcid];
            if (runner.context_codebrick && runner.context_codebrick.blueprint.name == brick_info.blueprint.name) {
                var jit_tree = (0, _cbutil.createBrickInfoTree)(runner);
                if (jit_tree) brick_info.contains = [
                    jit_tree
                ];
                return;
            }
        }
    }
    renderTagItem(ti) {
        var ti_container = document.createElement("div");
        ti_container.classList.add("cvd-ti");
        var tag_string = (0, _templateUtil.TemplateUtil).UnParseTagItem(ti, false) || "";
        var tag_container = document.createElement("div");
        tag_container.innerHTML = this.UnParseTagItem(ti, false);
        ti_container.appendChild(tag_container);
        var tag_btn = document.createElement("button");
        tag_btn.classList.add("c-vd-btn-tag");
        tag_btn.innerHTML = `{{<img src="https://s2.svgbox.net/hero-outline.svg?ic=eye&color=02366d"/>}}`;
        ti_container.appendChild(tag_btn);
        if (ti.val !== undefined) tag_btn.classList.add("c-vd-btn-active");
        var self = this;
        tag_btn.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
            var in_val;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        in_val = "";
                        if (ti.val !== undefined) in_val += "<pre>" + JSON.stringify(ti.val, null, 2) + "</pre>";
                        else in_val += "<p><b>Unresolved:</b> Waiting for input(s) or tag conditions not passed</p>";
                        return [
                            4,
                            self.show_modal("Tag Value<p>" + tag_string + "</p>", in_val)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }));
        return ti_container;
    }
    UnParseTagItem(ti) {
        var is_bracket = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ret = "";
        if (ti.type[0] == "{") {
            ret += `<span ${ti.val !== undefined ? `class="cvd-term-active"` : ""}>` + (is_bracket ? "(" : "{" + ti.type) + `</span>`;
            var first = true;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (ti.items) try {
                for(var _iterator = ti.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var section = _step.value;
                    if (first) first = false;
                    else if (section.type == ";") ret += ";";
                    else ret += ",";
                    if (section.type[0] == "{") ret += this.UnParseTagItem(section);
                    else if (section.type == ";") ret += `<span ${ti.val !== undefined ? `class="cvd-term-active"` : ""}>` + section.slice + `</span>`;
                    else ret += this.UnParseSection(section);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            ret += `<span ${ti.val !== undefined ? `class="cvd-term-active"` : ""}>` + (is_bracket ? ")" : "}}") + `</span>`;
            return ret;
        }
        return "";
    }
    UnParseSection(section) {
        var res = `<span ${section.val !== undefined ? `class="cvd-term-active"` : ""}>`;
        if (section.items) for(var t = 0; t < section.items.length; t++){
            var term = section.items[t];
            if (term.type == "p") {
                var json = "<p><b>Unresolved:</b> No value received</p>";
                if (term.val !== undefined) {
                    json = JSON.stringify(term.val, null, 2);
                    json = json.replaceAll('"', '\\"');
                    json = json.replaceAll("\n", "\\n");
                }
                res += `<span class="cvd-term${term.val !== undefined ? " cvd-term-active" : ""}" onclick='codebricks_context.bricks["${this.brick_id}"].show_modal("Term Value<p>${term.slice}</p>","<pre>${json}</pre>")'>${term.slice}</span>`;
            } else if (term.type == "s") res += "'" + (0, _cbWebUtil.CBWebUtil).escapeHtml(term.slice) + "'";
            else if (term.type == "n" || term.type == "b") res += term.slice;
            else if (term.type == "0") res += "null";
            else if (term.type[0] == "{") res += (0, _templateUtil.TemplateUtil).UnParseTagItem(term, true);
            else if (term.type == "!") res += "!=";
            else res += term.type;
        }
        return res + "</span>";
    }
    create_modal() {
        var modal_html = `<cci-modal id="${this.brick_id}$cvd_modal" ins='{"cfg":{ "title":"View", "cancel_button": "Close" }}'></cci-modal>`;
        this.element.insertAdjacentHTML("beforeend", modal_html);
    }
    show_modal(title, content) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var modal_body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            window.so_bricks[_this.brick_id + "$cvd_modal_brick"].cb_event("cfg", {
                                "title": title,
                                "cancel_button": "Close"
                            })
                        ];
                    case 1:
                        _state.sent();
                        modal_body = document.getElementById(_this.brick_id + "$cvd_modal_brick$body");
                        if (modal_body) modal_body.innerHTML = `<div style="overflow:auto">${content}</div>`;
                        return [
                            4,
                            window.so_bricks[_this.brick_id + "$cvd_modal_brick"].cb_event("show", 1)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialized = false;
        this.include_sub_compositions = false;
        this.element = element;
        this.container = document.createElement("div");
        this.container.id = this.brick_id;
        this.element.appendChild(this.container);
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../../codebricks-runtime/TemplateUtil":"ebZ29","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"61dfA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_expander_webcomponent", ()=>cc_expander_webcomponent);
parcelHelpers.export(exports, "web_cc_expander", ()=>web_cc_expander);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_expander_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_expander(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-expander", cc_expander_webcomponent);
class web_cc_expander extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var et, id, btn, accordion_group, label, icon, img, expanded;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    et = document.getElementById(_this.brick_id + "$et");
                    if (!_this.initialized) {
                        if (!_this.handler && cfg.accordion_group) {
                            _this.handler = true;
                            id = _this.brick_id + "_chck1";
                            btn = document.getElementById(id);
                            accordion_group = cfg.accordion_group;
                            if (btn) {
                                btn.classList.add(cfg.accordion_group);
                                btn.addEventListener("click", function() {
                                    var group = document.querySelectorAll("." + accordion_group);
                                    for(var i = 0; i < group.length; i++)if (group[i].id != id) group[i].checked = false;
                                });
                            }
                        }
                        if (et) et.classList.remove("hidden");
                        _this.initialized = true;
                    }
                    if (et) {
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(et, cfg, "expander");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(et.lastElementChild, cfg, "content");
                    }
                    label = document.getElementById(_this.brick_id + "$label");
                    if (label) {
                        label.innerHTML = cfg.label;
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(label, cfg, "label");
                    }
                    icon = document.getElementById(_this.brick_id + "$icon");
                    img = document.getElementById(_this.brick_id + "$img");
                    if (icon && img) {
                        if (cfg.icon) icon.classList.remove("hidden");
                        else icon.classList.remove("hidden");
                        img.src = cfg.icon;
                    }
                    expanded = cfg.expanded == true;
                    _this.expand(expanded);
                }
                return [
                    2
                ];
            });
        })();
    }
    pop_hide() {
        var menu = document.getElementById("cc-expander-expander" + this.ci_idx);
        menu === null || menu === void 0 || menu.classList.remove("cc-expander-show");
    }
    expand(expand) {
        var checkbox = document.getElementById(this.brick_id + "_chck1");
        if (checkbox) checkbox.checked = expand;
    }
    cb_initial_cement(cements) {
        var subs = "";
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                    var prefix = sub.type.split("-")[0];
                    if (prefix.indexOf("i") == -1) {
                        var lop_style = "";
                        var lop_classes = "";
                        var cement = cements[i];
                        var hidden = (cement === null || cement === void 0 ? void 0 : cement.hidden) ? "child-hidden" : "";
                        subs += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(hidden, cement, "")}>${brick}</div>`;
                    } else subs += brick;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var disp = `<span id="${this.brick_id}$label"></span>`;
        var innerHTML = `
        <div id="${this.brick_id}$et" class="cc-expander hidden" style="" id="${this.brick_id}">
            <input type="checkbox" class="cc-expander-input" id="${this.brick_id}_chck1">
            <label class="cc-expander-label" for="${this.brick_id}_chck1">${disp}</label>
            <div class="cc-expander-content">
            ${subs}
        </div>`;
        this.element.innerHTML = innerHTML;
    }
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialized = false;
        this.handleClick = (e)=>{
            var showing = false;
            var menu = document.getElementById("cc-expander-expander" + this.ci_idx);
            if (menu === null || menu === void 0 ? void 0 : menu.classList.contains("cc-expander-show")) showing = true;
            this.expand(!showing);
        };
        this.element = element;
        this.blueprint.ins = this.blueprint.ins || {};
        this.blueprint.ins.cfg = this.blueprint.ins.cfg || {};
        var cfg = this.blueprint.ins.cfg;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"kDYD7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_flexbox_webcomponent", ()=>cc_flexbox_webcomponent);
parcelHelpers.export(exports, "web_cc_flexbox", ()=>web_cc_flexbox);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_flexbox_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_flexbox(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-flexbox", cc_flexbox_webcomponent);
class web_cc_flexbox extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var slot, slot1, _loop, cfg_style, option, styles;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "hidden") {
                    slot = document.getElementById(_this.brick_id);
                    if (slot) {
                        if (cfg) slot.classList.add("hidden");
                        else slot.classList.remove("hidden");
                    }
                } else if (input == "data") return [
                    2,
                    {
                        "@": cfg
                    }
                ];
                else if (input == "cfg") {
                    _this.no_loader = (cfg === null || cfg === void 0 ? void 0 : cfg.no_loader) || false;
                    slot1 = document.getElementById(_this.brick_id);
                    if (slot1) {
                        _loop = function(option) {
                            if (option == "flex-wrap" && cfg[option]) cfg_style.push(`flex-wrap:${cfg["flex-wrap"]}`);
                            else if (option == "align-items" && cfg[option]) cfg_style.push(`align-items:${cfg["align-items"]}`);
                            else if (option == "align-content" && cfg[option]) cfg_style.push(`align-content:${cfg["flex-wrap"]}`);
                            else if (option == "flex-direction" && cfg[option]) cfg_style.push(`flex-direction:${cfg["flex-direction"]}`);
                            else if (option == "justify-content" && cfg[option]) cfg_style.push(`justify-content:${cfg["justify-content"]}`);
                            else if (option == "gap" && cfg[option]) cfg_style.push(`gap:${cfg["gap"]}`);
                            else if (option == "enable_click_event") {
                                _this.enable_click_event = cfg[option];
                                if (_this.enable_click_event) {
                                    var div = document.getElementById(_this.brick_id);
                                    if (div && !_this.has_click_handler) {
                                        var self = _this;
                                        div.addEventListener("click", function() {
                                            if (self.enable_click_event) self.cb_emit({
                                                "@click": true
                                            });
                                        });
                                        _this.has_click_handler = true;
                                    }
                                }
                            }
                        };
                        cfg_style = [];
                        for(var option in cfg)_loop(option);
                        styles = (0, _cbutil.Clone)(cfg.styles || {});
                        styles.flexbox = styles.flexbox || {};
                        styles.flexbox["()"] = cfg_style.join(";");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(slot1, {
                            styles
                        }, "flexbox");
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {
        var slot = document.getElementById(this.brick_id);
        if (slot) {
            var innerHTML = "";
            if (this.blueprint.contains) {
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                        var prefix = sub.type.split("-")[0];
                        if (prefix.indexOf("i") == -1 && prefix[0] != "s") {
                            var lop_style = "";
                            var cement = cements[i];
                            var hidden = "";
                            if (cement) {
                                for(var v in cement){
                                    if (v == "styles" || v == "hidden") ;
                                    else if (cement[v]) lop_style += v + ":" + cement[v] + ";";
                                }
                                if (cement.hidden) hidden = "child-hidden";
                            }
                            innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(hidden, cement, "", lop_style)} id="${this.brick_id}$${i}">${brick}</div>`;
                        } else innerHTML += brick;
                        i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            slot.innerHTML = innerHTML;
        }
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var child = document.getElementById(this.brick_id + "$" + child_idx);
        if (child) {
            if (cement && cement.hidden) child.classList.add("child-hidden");
            else child.classList.remove("child-hidden");
            cement.styles = cement.styles || {};
            for(var prop in cement)if (prop != "styles") cement.styles[prop] = cement[prop];
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        }
    }
    cb_status(status) {
        var _a, _b;
        var div = document.getElementById(this.brick_id);
        if (status == "loading" && !(this.no_loader || ((_b = (_a = this.blueprint.ins) === null || _a === void 0 ? void 0 : _a.cfg) === null || _b === void 0 ? void 0 : _b.no_loader))) {
            if (div) div.classList.add("cc-flexbox-loading");
        } else if (div) div.classList.remove("cc-flexbox-loading");
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.cement_classes = [];
        this.has_click_handler = false;
        this.enable_click_event = false;
        this.no_loader = false;
        this.element = element;
        element.innerHTML = `<div style="" class="cc-flexbox" id="${this.brick_id}"></div>`;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"aUP3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_layout_grid_webcomponent", ()=>cc_layout_grid_webcomponent);
parcelHelpers.export(exports, "web_cc_layout_grid", ()=>web_cc_layout_grid);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _layoutGrid = require("../../shared-funcs/LayoutGrid");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_layout_grid_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_layout_grid(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-layout-grid", cc_layout_grid_webcomponent);
class web_cc_layout_grid extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var container, items, i, item, slot;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg || {};
                    container = document.getElementById(_this.brick_id);
                    if (container) {
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                        items = container.children;
                        if (items) for(i = 0; i < items.length; i++){
                            item = items[i];
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(item, cfg, "item");
                        }
                    }
                } else if (input == "hide") {
                    slot = document.getElementById(_this.brick_id);
                    if (slot) {
                        if (cfg) slot.style.display = "none";
                        else slot.style.display = "flex";
                    }
                } else if (input == "edit_mode") {
                    if (cfg) {
                        if (!_this.edit_mode) _this.enterEditMode();
                        _this.edit_mode = true;
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {
        var ordered_childs = (0, _layoutGrid.LayoutGrid).orderChilds(this.blueprint);
        var container_style = "";
        var at_row = undefined;
        var innerHTML = `<div style="${container_style}" class="cc-layout-grid-container" id="${this.brick_id}">`;
        for(var c = 0; c < ordered_childs.length; c++){
            var sub = ordered_childs[c].sub;
            var cement_idx = ordered_childs[c].p;
            var cement = cements[cement_idx] || {};
            var lop_classes = "";
            var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, cement_idx);
            var prefix = sub.type.split("-")[0];
            if (prefix.indexOf("i") == -1 && prefix[0] != "s") {
                var lop_style = "";
                var cols = sub.cement.width || 12;
                var classes = "";
                classes = "w" + cols;
                if (cement && cement.hidden) classes += " hidden";
                var drag_info = {
                    source_id: this.brick_id,
                    tags: this.blueprint.ins.cfg.drag_tags
                };
                var d = {
                    name: sub.name,
                    type: sub.type,
                    position: c
                };
                this.drop_contained.push(d);
                innerHTML += `<div class="cc-layout-grid-cell ${classes}" id="${this.brick_id}$${cement_idx}" cd-data="${(0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(d))}" drag-info="${(0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(drag_info))}"><div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("card cc-layout-grid-item", cement, "")} >${brick}</div></div>`;
            } else innerHTML += "<div style='display:none'>" + brick + "</div>";
            if ((cement.row || 0) !== at_row) at_row = cement.row || 0;
        }
        innerHTML += `</div>`;
        this.element.innerHTML = innerHTML;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var child = document.getElementById(this.brick_id + "$" + child_idx);
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            var item = child.firstElementChild;
            if (item) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(item, cement, "");
        }
    }
    cb_status(status) {}
    cb_snapshot() {}
    enterEditMode() {
        this.edit_mode = true;
        var blocks = this.element.querySelectorAll(".cc-layout-grid-cell");
        var position = 0;
        var self = this;
        blocks.forEach((draggable)=>{
            if (!draggable.id.startsWith(this.brick_id + "$")) return;
            if (draggable.classList.contains("dragndrop-element-draggable")) return;
            draggable.setAttribute("draggable", true);
            draggable.classList.add("dragndrop-element-draggable");
            var controls_html = `<div class="dragndrop-element-controls" position="${position}">
                <div class="dragndrop-element-controls-delete" onclick=""></div>
            </div>`;
            draggable.insertAdjacentHTML("beforeend", controls_html);
            var drag_handle = `<div class="drag-handle"></div>`;
            draggable.insertAdjacentHTML("beforeend", drag_handle);
            var pos = position;
            var del_btn = this.element.querySelector('.dragndrop-element-controls[position="' + position + '"] > .dragndrop-element-controls-delete');
            if (del_btn) del_btn.addEventListener("click", function() {
                self.deleteBlock(pos);
            });
            draggable.addEventListener("mousedown", (e)=>{
                self.drag_target = e.target;
            });
            draggable.addEventListener("dragstart", (e)=>{
                if (!self.drag_target.classList.contains("drag-handle")) {
                    e.preventDefault();
                    return;
                }
                e.dataTransfer.setData("text", e.target.id);
                window.drag_info = {
                    source_id: self.brick_id,
                    tags: self.cfg.drag_tags
                };
                draggable.classList.add("dragging");
            });
            draggable.addEventListener("dragend", ()=>{
                draggable.classList.remove("dragging");
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
            });
            draggable.addEventListener("dragenter", ()=>{
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
                draggable.classList.add("dropzone");
            });
            draggable.addEventListener("dragover", (e)=>{
                if (!self.may_drop()) return;
                e.preventDefault();
                e.stopPropagation();
            });
            position++;
        });
        var container = this.element.querySelector(".cc-layout-grid-container");
        if (container && container.getAttribute("has_drag_handlers") == null) {
            container.setAttribute("has_drag_handlers", "true");
            container.classList.add("cc-layout-grid-container-editmode");
            container.addEventListener("dragover", (e)=>{
                if (!self.may_drop()) return;
                e.preventDefault();
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
            });
            container.addEventListener("drop", (e)=>{
                e.preventDefault();
                e.stopPropagation();
                var data = e.dataTransfer.getData("text");
                var block = document.getElementById(data);
                if (container && block) {
                    var drag_info = JSON.parse((0, _cbWebUtil.CBWebUtil).unescapeHtml(block.getAttribute("drag-info") || ""));
                    var cd_data = JSON.parse((0, _cbWebUtil.CBWebUtil).unescapeHtml(block.getAttribute("cd-data") || ""));
                    console.log("drop onto " + data + " drag_info " + JSON.stringify(drag_info) + " cd_data " + JSON.stringify(cd_data));
                    if (drag_info.source_id == self.brick_id) {
                        block.classList.remove("dragging");
                        var dropzone = self.element.querySelector(".dropzone");
                        if (dropzone) {
                            var dest_id = dropzone.id;
                            var src_id = data;
                            var dest_idx = Number((0, _cbutil.SplitGetLast)(dest_id, "$"));
                            var src_idx = Number((0, _cbutil.SplitGetLast)(src_id, "$"));
                            console.log("move from idx " + src_idx + " to " + dest_idx);
                            (0, _cbutil.array_move)(self.drop_contained, src_idx, dest_idx);
                            self.saveLayout();
                        } else container.appendChild(block);
                    } else {
                        console.log("drop external data " + data);
                        var dropzone1 = self.element.querySelector(".dropzone");
                        if (dropzone1) {
                            var dest_id1 = dropzone1.id;
                            var dest_idx1 = Number((0, _cbutil.SplitGetLast)(dest_id1, "$"));
                            self.drop_contained.splice(dest_idx1, 0, cd_data);
                        } else self.drop_contained.push(cd_data);
                        self.saveLayout();
                    }
                }
                var dropzone2 = self.element.querySelector(".dropzone");
                if (dropzone2) dropzone2.classList.remove("dropzone");
            });
        }
    }
    may_drop() {
        var drag_info = window.drag_info;
        if (drag_info) {
            if (drag_info.source_id == this.brick_id) {
                if (this.cfg.disallow_move) return;
            } else try {
                var intersection = this.cfg.drop_tags.filter(function(n) {
                    return drag_info.tags.indexOf(n) !== -1;
                });
                if (!intersection || intersection.length == 0) return false;
            } catch (err) {
                console.error(err);
                return false;
            }
            return true;
        }
        return false;
    }
    deleteBlock(position) {
        var controls = this.element.querySelector('.dragndrop-element-controls[position="' + position + '"]');
        if (controls && controls.parentElement) {
            this.drop_contained.splice(position, 1);
            this.saveLayout();
        }
    }
    saveLayout() {
        console.log("cc-layout-grid emit " + JSON.stringify(this.drop_contained));
        this.cb_emit({
            "@contained": this.drop_contained
        });
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.cfg = {};
        this.edit_mode = false;
        this.drop_contained = [];
        this.element = element;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/LayoutGrid":"8oSGg","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8oSGg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGrid", ()=>LayoutGrid);
var LayoutGrid = /** @class */ function() {
    function LayoutGrid() {}
    LayoutGrid.orderChilds = function(brick) {
        var ordered_childs = [];
        var p = 0;
        if (brick.contains) for(var _i = 0, _a = brick.contains; _i < _a.length; _i++){
            var sub = _a[_i];
            var added = false;
            sub.cement = sub.cement || {};
            for(var i = 0; i < ordered_childs.length; i++)if ((sub.cement.row || 999) <= (ordered_childs[i].sub.cement.row || 998) && (sub.cement.position || 999) <= (ordered_childs[i].sub.cement.position || 998)) {
                ordered_childs.splice(i, 0, {
                    p: p,
                    sub: sub
                });
                added = true;
                break;
            }
            if (!added) ordered_childs.push({
                p: p,
                sub: sub
            });
            p++;
        }
        return ordered_childs;
    };
    return LayoutGrid;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lRt3A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_popout_webcomponent", ()=>cc_popout_webcomponent);
parcelHelpers.export(exports, "web_cc_popout", ()=>web_cc_popout);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPopout = require("../controls/cb_popout");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_popout_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_popout(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-popout", cc_popout_webcomponent);
class web_cc_popout extends (0, _codeBrick.CodeBrick) {
    cb_initial_cement(cements) {
        var innerHTML = "";
        innerHTML += "";
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var cement = cements[i];
                    var classes = "";
                    if (cement && cement.hidden) classes += classes ? " hidden" : "hidden";
                    var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                    innerHTML += `<div id="${this.brick_id}$${i}" ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("cc-popout-item " + classes, cement, "")}>${brick}</div>`;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var container = document.getElementById(`${this.brick_id}$drop`);
        if (container) container.innerHTML = innerHTML;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var child = document.getElementById(this.brick_id + "$" + child_idx);
        if (child && cement) {
            if (cement && cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        }
    }
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var html, select, popout, select1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, cl, classes, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, had, has, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, v, launcher;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "show") {
                    if (cfg) _this.popout.openPopout(_this.popout);
                } else if (input == "collapse") {
                    if (cfg) _this.popout.closeSelect();
                } else if (input == "cfg") {
                    if (!_this.initialized) {
                        html = "";
                        if (cfg.icon_left) {
                            if (cfg.icon_left[0] == "<") html += cfg.icon_left;
                            else html += `<img class="cc-popout-icon-left" src="${cfg.icon_left}"/>`;
                        }
                        if (cfg.label) html += '<div class="cc-popout-label">' + cfg.label + "</div>";
                        if (cfg.icon_right) {
                            if (cfg.icon_right[0] == "<") html += cfg.icon_right;
                            else html += `<img class="cc-popout-icon-right" src="${cfg.icon_right}"/>`;
                        }
                        select = document.getElementById(_this.brick_id + "$select");
                        if (select) {
                            select.innerHTML = html;
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(select, cfg, "label");
                        }
                        _this.style_classes = cfg.style_classes;
                        popout = document.getElementById(_this.brick_id + "$drop");
                        if (popout) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(popout, cfg, "popover");
                        _this.initialized = true;
                    } else {
                        select1 = document.getElementById(_this.brick_id + "$select");
                        if (select1) {
                            if (cfg.style_classes) {
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = cfg.style_classes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        cl = _step.value;
                                        select1.classList.add(cl);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                classes = cfg.style_classes;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = _this.style_classes[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        had = _step1.value;
                                        has = false;
                                        _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                        try {
                                            for(_iterator2 = classes[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                v = _step2.value;
                                                if (v == had) {
                                                    has = true;
                                                    break;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                    _iterator2.return();
                                                }
                                            } finally{
                                                if (_didIteratorError2) {
                                                    throw _iteratorError2;
                                                }
                                            }
                                        }
                                        if (!has && had) select1.classList.remove(had);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                _this.style_classes = cfg.style_classes;
                            }
                        }
                    }
                    _this.popout.setNoWindowClickClose(Boolean(cfg.no_window_click_close));
                    launcher = document.getElementById(_this.brick_id + "$select");
                    if (launcher) {
                        if (cfg.hidden) launcher.classList.add("hidden");
                        else launcher.classList.remove("hidden");
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    pop_hide() {
        var menu = document.getElementById(this.brick_id + "$popout");
        if (menu) menu.classList.remove("cc-popout-show");
    }
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.cement_classes = [];
        this.initialized = false;
        this.cement_html = "";
        this.style_classes = [];
        this.handleClick = ()=>{
            var showing = false;
            var menu = document.getElementById(this.brick_id + "$popout");
            if (menu === null || menu === void 0 ? void 0 : menu.classList.contains("cc-popout-show")) showing = true;
            if (showing) menu === null || menu === void 0 || menu.classList.remove("cc-popout-show");
            else {
                menu === null || menu === void 0 || menu.classList.add("cc-popout-show");
                var self = this;
                if (!this.handler) this.handler = function() {
                    var menu = document.getElementById(self.brick_id + "$popout");
                    menu === null || menu === void 0 || menu.classList.remove("cc-popout-show");
                    document.removeEventListener("click", self.handler);
                };
                setTimeout(function() {
                    document.addEventListener("click", self.handler);
                }, 1);
            }
        };
        this.element = element;
        this.element.innerHTML = `<div id="${this.brick_id}$select" class="cc-popout hidden"></div>`;
        this.popout = new (0, _cbPopout.cb_popout)(this.brick_id, true, this.blueprint.ins.cfg, "cc-popout", false, true, function() {}, function() {});
        this.popout.init();
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_popout":"8UNLF","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"h0JNy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_position_webcomponent", ()=>cc_position_webcomponent);
parcelHelpers.export(exports, "web_cc_position", ()=>web_cc_position);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_position_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_position(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-position", cc_position_webcomponent);
class web_cc_position extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {
        var slot = document.getElementById(this.brick_id);
        if (slot) {
            var innerHTML = "";
            if (this.blueprint.contains) {
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        var lop_style = "";
                        var lop_classes = "";
                        var cement = cements[i] || sub.cement;
                        if (cement) for(var v in cement){
                            if (v == "style_classes") ;
                            else if (v == "styles") ;
                            else lop_style += v + ":" + cement[v] + ";";
                        }
                        var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                        innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString((cement === null || cement === void 0 ? void 0 : cement.hidden) ? "hidden" : "", cement, "", lop_style)}>${brick}</div>`;
                        i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            slot.innerHTML = innerHTML;
        }
    }
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
        var container_style = "";
        if (this.blueprint.ins.cfg && this.blueprint.ins.cfg) for(var v in this.blueprint.ins.cfg.style)container_style += v + ":" + this.blueprint.ins.cfg.style[v] + ";";
        element.innerHTML = `<div id="${this.brick_id}" style="${container_style}"></div>`;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"4KGZb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_resizable_panes_webcomponent", ()=>cc_resizable_panes_webcomponent);
parcelHelpers.export(exports, "web_cc_resizable_panes", ()=>web_cc_resizable_panes);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_resizable_panes_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_resizable_panes(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-resizable-panes", cc_resizable_panes_webcomponent);
class web_cc_resizable_panes extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
        var innerHTML = `<div id="${this.brick_id}" style="display: flex;flex-direction: row;">`;
        var i = 0;
        var split_ids = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (this.blueprint.contains) try {
            for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sub = _step.value;
                var lop_style = "";
                if (sub.cement) {
                    lop_style = JSON.stringify(sub.cement).trim();
                    if (lop_style.length >= 2) lop_style = lop_style.substr(1, lop_style.length - 2);
                }
                split_ids.push("#" + this.blueprint.name + "_" + i);
                var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                innerHTML += `<div style="float:left" class="cc-resizable-pane" id="${this.blueprint.name + "_" + i++}">${brick}</div>`;
                i++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        innerHTML += "</div>";
        element.innerHTML = innerHTML;
        var split_Storage_id = this.context.composition_runners[this.cid].composition + this.brick_id + "_split-sizes";
        var stored_sizes = localStorage.getItem(split_Storage_id);
        var options = this.blueprint.ins.cfg || {};
        if (stored_sizes) options.sizes = JSON.parse(stored_sizes);
        options.onDragEnd = function(sizes) {
            localStorage.setItem(split_Storage_id, JSON.stringify(sizes));
        };
        Split(split_ids, options);
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2p53T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_switchpanel_webcomponent", ()=>cc_switchpanel_webcomponent);
parcelHelpers.export(exports, "web_cc_switchpanel", ()=>web_cc_switchpanel);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_switchpanel_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_switchpanel(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-switchpanel", cc_switchpanel_webcomponent);
class web_cc_switchpanel extends (0, _codeBrick.CodeBrick) {
    show_panel(panelid) {
        var no_emit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var i = 0;
        if (!panelid) panelid = "0";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (this.blueprint.contains) try {
            for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sub = _step.value;
                var cement = sub.cement || {};
                if (cement.identifier == panelid || i + "" == panelid) {
                    if (this.cfg.type == "Radio") {
                        var radio = document.getElementById(`${this.brick_id}$${i}_radio`);
                        if (radio) radio.checked = true;
                    } else {
                        var prev = document.getElementById(`${this.brick_id}$${this.prev_indentifier || "0"}`);
                        if (prev) prev.style.display = "none";
                        var panel = document.getElementById(`${this.brick_id}$${cement.identifier || i}`);
                        if (panel) panel.style.display = "block";
                    }
                    if (this.cfg.type == "Tabs") {
                        var prev_tab = document.getElementById(`${this.brick_id}$${this.prev_indentifier || i}_tab`);
                        if (prev_tab) prev_tab.classList.remove("cc-switchpanel-tab-active");
                        var panel_tab = document.getElementById(`${this.brick_id}$${cement.identifier || i}_tab`);
                        if (panel_tab) panel_tab.classList.add("cc-switchpanel-tab-active");
                    } else if (this.cfg.type == "Wizard") {
                        var header = document.getElementById(`${this.brick_id}$_wizard_header`);
                        if (header) header.innerHTML = cement.title || "";
                        var back = document.getElementById(`${this.brick_id}$_back`);
                        if (back) {
                            if (i == 0) back.style.display = "none";
                            else back.style.display = "inline";
                        }
                    }
                    this.prev_indentifier = cement.identifier || i;
                    this.current_idx = 1;
                    if (!no_emit) {
                        this.snapshot = this.snapshot || {};
                        this.snapshot.switch = this.prev_indentifier;
                        this.cb_emit({
                            "@": this.prev_indentifier
                        });
                    }
                    return;
                }
                i++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var new_id, self, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sub, cement, radio, i1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, sub1, cement1, tabname, tab, container;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "switch") {
                    new_id = cfg;
                    if (cfg == null || JSON.stringify(cfg) == "{}") return [
                        2
                    ];
                    if (new_id == "next") new_id = _this.current_idx + 1;
                    else if (new_id == "prev") new_id = _this.current_idx - 1;
                    _this.show_panel(new_id, true);
                } else if (input == "cfg") {
                    self = _this;
                    if (!cfg.type) cfg.type = "Tabs";
                    self.cfg = cfg;
                    if (cfg.type == "Radio") {
                        if (_this.blueprint.contains) {
                            i = 0;
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = _this.blueprint.contains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    sub = _step.value;
                                    cement = _this.cements[i] || sub.cement || {};
                                    radio = document.getElementById(`${_this.brick_id}$${i}_radio`);
                                    if (radio) radio.disabled = cfg.disabled || cement.disabled;
                                    i++;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } else if (cfg.type == "Tabs") {
                        if (_this.blueprint.contains) {
                            i1 = 0;
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = _this.blueprint.contains[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    sub1 = _step1.value;
                                    cement1 = _this.cements[i1] || sub1.cement || {};
                                    tabname = _this.brick_id + "$" + cement1.identifier + "_tab";
                                    if (self.prev_indentifier === "") self.prev_indentifier = cement1.identifier;
                                    tab = document.getElementById(tabname);
                                    if (tab) tab.classList.toggle("cc-switchpanel-tab-disabled", Boolean(cfg.disabled || cement1.disabled));
                                    i1++;
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                    container = document.getElementById(_this.brick_id);
                    if (container) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                }
                return [
                    2,
                    {
                        "@": _this.prev_indentifier
                    }
                ];
            });
        })();
    }
    cb_initial_cement(cements) {
        this.cements = cements;
        var container = document.getElementById(this.brick_id);
        var cfg = this.blueprint.ins.cfg;
        if (container) {
            var type = cfg.type || "Tabs";
            var innerHTML = ``;
            if (type == "Tabs") {
                innerHTML += `<div class="cc-switchpanel-tabheader">`;
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.blueprint.contains) try {
                    for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        var active = "";
                        var cement = this.cements[i] || sub.cement || {};
                        if (!this.prev_indentifier && i == 0 || cement.identifier !== undefined && cement.identifier == this.prev_indentifier) active = "cc-switchpanel-tab-active";
                        innerHTML += `<button class="cc-switchpanel-tab ${active}" id="${this.brick_id}$${cement.identifier || i}_tab">${cement.title || ""}</button>`;
                        i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                innerHTML += `</div>`;
            } else if (type == "Wizard" || type == "Carousel" || type == "Switched") {
                var active_cement = {};
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (this.blueprint.contains) try {
                    for(var _iterator1 = this.blueprint.contains[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var sub1 = _step1.value;
                        var cement1 = sub1.cement || {};
                        if (!active_cement) active_cement = cement1;
                        if (!this.blueprint.ins.switch) {
                            active_cement = cement1;
                            break;
                        }
                        if (cement1.indentifier == this.prev_indentifier) active_cement = cement1;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (type == "Wizard") innerHTML += `<div><span class='cc-switchpanel-wizard-back' id='${this.brick_id}$_back' style='display:none'><</span><span class='cc-switchpanel-wizard-header' id='${this.brick_id}$_wizard_header'>${active_cement.title || ""}</span></div>`;
            }
            var active_identifier;
            if (this.blueprint.contains) {
                var i1 = 0;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.blueprint.contains[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var sub2 = _step2.value;
                        var cement2 = this.cements[i1] || sub2.cement || "";
                        if (type == "Radio") {
                            var checked = !this.blueprint.ins.switch && i1 == 0 || cement2.identifier !== undefined && cement2.identifier == this.prev_indentifier;
                            var disabled = cement2.disabled ? " disabled" : "";
                            innerHTML += `<label class="cc-switchpanel-radio-container">
                                <input type="radio" value="${cement2.identifier || i1}" name="${this.brick_id}" id="${this.brick_id}$${i1}_radio" ${checked ? "checked" : ""}${disabled}>
                                <span class="cc-switchpanel-radio-checkmark"></span>
                                <span class="cc-switchpanel-label">${cement2.title || ""}</span>
                            </label>`;
                        }
                        var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub2, this, i1);
                        var lop_classes = "";
                        if (type == "Tabs") lop_classes += " cc-switchpanel-tab-content";
                        if (type == "Radio") lop_classes += " cc-switchpanel-radio-content";
                        var display = type == "Radio" ? "" : "display:none;";
                        if (i1 == 0 || cement2.identifier !== undefined && cement2.identifier == this.prev_indentifier) {
                            display = "";
                            active_identifier = cement2.identifier || 0;
                        }
                        innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("cc-switchpanel-content " + lop_classes, cement2, "", display)} id="${this.brick_id}$${cement2.identifier || i1}">${brick}</div>`;
                        i1++;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            if (container) container.innerHTML = innerHTML;
            if (type == "Tabs") {
                if (this.blueprint.contains) {
                    var i2 = 0;
                    var self = this;
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        var _this = this, _loop = function() {
                            var sub = _step3.value;
                            var cement = _this.cements[i2] || sub.cement || {};
                            var tab = document.getElementById(`${_this.brick_id}$${cement.identifier || i2}_tab`);
                            if (tab) {
                                var tabidx = i2;
                                tab.addEventListener("click", function() {
                                    if (self.cfg.disabled) return;
                                    var panel_tab = document.getElementById(`${self.brick_id}$${cement.identifier || tabidx}_tab`);
                                    if (panel_tab) {
                                        if (panel_tab.classList.contains("cc-switchpanel-tab-disabled")) return;
                                        panel_tab.classList.add("cc-switchpanel-tab-active");
                                    }
                                    var prev_tab = document.getElementById(`${self.brick_id}$${self.prev_indentifier}_tab`);
                                    if (prev_tab == panel_tab) return;
                                    if (prev_tab) prev_tab.classList.remove("cc-switchpanel-tab-active");
                                    var prev = document.getElementById(`${self.brick_id}$${self.prev_indentifier}`);
                                    if (prev) prev.style.display = "none";
                                    var panel = document.getElementById(`${self.brick_id}$${cement.identifier || tabidx}`);
                                    if (panel) panel.style.display = "block";
                                    self.prev_indentifier = cement.identifier || tabidx;
                                    self.snapshot = self.snapshot || {};
                                    self.snapshot.switch = self.prev_indentifier;
                                    self.cb_emit({
                                        "@": self.prev_indentifier,
                                        "@user_changed": self.prev_indentifier
                                    });
                                });
                            }
                            i2++;
                        };
                        for(var _iterator3 = this.blueprint.contains[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)_loop();
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            }
            if (type == "Wizard") {
                var back = document.getElementById(`${this.brick_id}$_back`);
                var self1 = this;
                if (back) back.addEventListener("click", function() {
                    if (self1.current_idx > 0) self1.show_panel(self1.current_idx - 1);
                });
            }
            if (type == "Radio") {
                if (this.blueprint.contains) {
                    var i3 = 0;
                    var self2 = this;
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = this.blueprint.contains[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var sub3 = _step4.value;
                            var radio = document.getElementById(`${this.brick_id}$${i3}_radio`);
                            if (radio) radio.addEventListener("click", function() {
                                self2.prev_indentifier = this.value;
                                self2.cb_emit({
                                    "@": this.value,
                                    "@user_changed": this.value
                                });
                            });
                            i3++;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            }
            this.prev_indentifier = active_identifier || "0";
        }
    }
    cb_update_cement(child_idx, cement, row_idx) {
        this.cements[child_idx] = cement;
        var tab = document.getElementById(`${this.brick_id}$${cement.identifier || child_idx}_tab`);
        if (tab) {
            tab.innerHTML = cement.title || "";
            tab.classList.toggle("cc-switchpanel-tab-disabled", Boolean(this.cfg.disabled || cement.disabled));
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(tab, cement, "");
        }
        var radio = document.getElementById(`${this.brick_id}$${child_idx}_radio`);
        if (radio && radio.parentElement) radio.parentElement.children[2].innerHTML = cement.title || "";
        if (radio) {
            radio.disabled = this.cfg.disabled || cement.disabled;
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(tab, cement, "");
        }
    }
    cb_status(status) {}
    cb_snapshot() {
        return this.snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.prev_indentifier = "";
        this.initialized = false;
        this.current_idx = 0;
        this.cements = {};
        this.cfg = this.blueprint.ins.cfg;
        this.snapshot = undefined;
        this.element = element;
        this.blueprint.ins = this.blueprint.ins || {};
        this.blueprint.ins.cfg = this.blueprint.ins.cfg || {};
        this.element.innerHTML = `<div id="${this.brick_id}"></div>`;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2rkCL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_tokenfield_webcomponent", ()=>cc_tokenfield_webcomponent);
parcelHelpers.export(exports, "web_cc_tokenfield", ()=>web_cc_tokenfield);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPopout = require("../controls/cb_popout");
var _tokenfield = require("../../shared-funcs/Tokenfield");
var _cbWebUtil = require("../controls/cb_web_util");
var _cbutil = require("../../codebricks-runtime/CBUtil");
class cc_tokenfield_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_tokenfield(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-tokenfield", cc_tokenfield_webcomponent);
class web_cc_tokenfield extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var self, add, _$input, select;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.cfg = cfg;
                    _this.validation = cfg.validation;
                    if (!_this.initialised) {
                        _this.initialised = true;
                        self = _this;
                        add = document.getElementById(_this.brick_id + "$add");
                        if (add) add.addEventListener("click", function() {
                            self.add();
                        });
                        _$input = document.getElementById(self.brick_id + "$input");
                        if (_$input) _$input.addEventListener("keyup", function(e) {
                            if (e.key === "Enter" || e.keyCode === 13) self.add();
                        });
                    }
                    _this.setValue(cfg.value, false);
                    select = document.getElementById(_this.brick_id + "$select");
                    if (select) {
                        if (cfg.disabled) {
                            select.classList.add("cc-tokenfield-disabled");
                            _this.popout.disabled = true;
                        } else {
                            select.classList.remove("cc-tokenfield-disabled");
                            _this.popout.disabled = false;
                        }
                    }
                    return [
                        2,
                        {
                            "@": _this.value_tokens,
                            "@string": _this.value_tokens.join(_this.cfg.output_separator || ","),
                            "@option_objects": cfg.value
                        }
                    ];
                } else if (input == "add") _this.add_token(cfg);
                else if (input == "close_popout") _this.popout.closeSelect();
                return [
                    2
                ];
            });
        })();
    }
    add() {
        var input = document.getElementById(this.brick_id + "$input");
        if (input) {
            var value = input.value;
            if (value != "") {
                if (this.add_token(value)) {
                    input.value = "";
                    this.popout.closeSelect();
                }
            }
        }
    }
    add_token(value) {
        if (typeof value == "string" && value != "" && this.cfg) {
            var value_tokens = (0, _tokenfield.Tokenfield).getTokens(value, this.cfg.separators, this.cfg.value_path);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = value_tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var token = _step.value;
                    if (!this.value_tokens.includes(token)) {
                        if (this.validation && this.validation.pattern && !new RegExp("^(?:" + this.validation.pattern.trim() + ")$").test(token)) {
                            var input = document.getElementById(this.brick_id + "$input");
                            if (input) input.classList.add("cc-tokenfield-validation-failed");
                            var validation_message_container = document.getElementById(`${this.brick_id}&validation`);
                            if (validation_message_container) {
                                validation_message_container.innerHTML = this.validation.pattern_message;
                                validation_message_container.style.display = "block";
                            }
                            return false;
                        }
                        this.value_tokens.push(token);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.label_tokens = value_tokens;
            this.setValue(this.value_tokens, true);
            var input1 = document.getElementById(this.brick_id + "$input");
            if (input1) input1.classList.remove("cc-tokenfield-validation-failed");
            var validation_message_container1 = document.getElementById(`${this.brick_id}&validation`);
            if (validation_message_container1) {
                validation_message_container1.innerHTML = "";
                validation_message_container1.style.display = "none";
            }
        } else if (typeof value == "object" && value && this.cfg) {
            var str_value = (0, _cbutil.drill)(this.cfg.label_path || this.cfg.value_path, value);
            if (str_value != "") {
                var has = false;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var has_value = _step1.value;
                        if (JSON.stringify(has_value) == JSON.stringify(value)) {
                            has = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (!has) this.values.push(value);
                else return true;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.value_tokens[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var token1 = _step2.value;
                        if (!this.value_tokens.includes(token1)) this.value_tokens.push(token1);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = this.label_tokens[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var token2 = _step3.value;
                        if (!this.label_tokens.includes(token2)) this.label_tokens.push(token2);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                this.setValue(this.values, true);
            }
        }
        return true;
    }
    setValue(value, emit) {
        if (Array.isArray(value)) this.values = value;
        else if (typeof value == "string") this.values = (0, _cbWebUtil.CBWebUtil).SplitByMultipleSeparators(value, this.cfg.separators || [
            ","
        ]);
        this.value_tokens = (0, _tokenfield.Tokenfield).getTokens(this.values, this.cfg.separators, this.cfg.value_path);
        this.label_tokens = (0, _tokenfield.Tokenfield).getTokens(this.values, this.cfg.separators, this.cfg.label_path || this.cfg.value_path);
        var html = "";
        if (this.label_tokens) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.label_tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var token = _step.value;
                    if (token) html += `<div class="cc-tokenfield-token">${token}<div class="cc-tokenfield-token-close" id="${this.brick_id}$close$${i}"></div></div>`;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.popout.setDisplayValue(html);
            i = 0;
            var self = this;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = this.label_tokens[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var token1 = _step1.value;
                    if (token1) {
                        var token_close_element = document.getElementById(this.brick_id + "$close$" + i);
                        if (token_close_element) {
                            if (!token_close_element.getAttribute("has-close")) {
                                token_close_element.addEventListener("click", function(e) {
                                    var s = e.target.id.split("$");
                                    var ti = Number(s[s.length - 1]);
                                    if (self.label_tokens != self.values) self.label_tokens.splice(ti, 1);
                                    if (self.value_tokens != self.values) self.value_tokens.splice(ti, 1);
                                    self.values.splice(ti, 1);
                                    self.setValue(self.values, true);
                                    e.stopPropagation();
                                });
                                token_close_element.setAttribute("has-close", "true");
                            }
                        }
                    }
                    i++;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        if (emit) this.cb_emit({
            "@": this.value_tokens,
            "@string": this.value_tokens.join(this.cfg.output_separator || ","),
            "@option_objects": this.values
        });
    }
    cb_initial_cement(cements) {
        if (this.blueprint.contains) {
            var innerHTML = "";
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var cement = cements[i];
                    var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                    innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("cc-tokenfield-edit-entry" + (cement.hidden ? " hidden" : ""), cement, "")}>${brick}</div>`;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var container = document.getElementById(`${this.brick_id}$popout`);
            if (container) container.innerHTML = innerHTML;
        }
    }
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        if (status == "focus") {
            var input = document.getElementById(`${this.brick_id}`);
            if (input) {
                input.focus();
                return true;
            }
        }
    }
    cb_validate() {
        var validates = true;
        var validation_message = "";
        if (this.validation) {
            var input = document.getElementById(`${this.brick_id}$select`);
            if (input) {
                if (this.validation.required && this.value_tokens.length == 0) {
                    validates = false;
                    validation_message = (this.cfg.label || this.cfg.placeholder || "Value") + " is a required field";
                }
                var validation_message_container = document.getElementById(`${this.brick_id}&validation`);
                if (validates) {
                    input.classList.remove("cc-tokenfield-validation-failed");
                    if (validation_message_container) {
                        validation_message_container.style.display = "none";
                        validation_message_container.innerHTML = "";
                    }
                } else {
                    input.classList.add("cc-tokenfield-validation-failed");
                    if (validation_message_container) {
                        validation_message_container.innerHTML = validation_message;
                        validation_message_container.style.display = "block";
                    }
                }
            }
        }
        return validates;
    }
    cb_snapshot() {
        return {
            cfg: {
                value: this.values
            }
        };
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.initialised = false;
        this.value = "";
        this.label = "";
        this.placeholder = "";
        this.validation = null;
        this.value_tokens = [];
        this.label_tokens = [];
        this.values = [];
        this.element = element;
        this.element.innerHTML = `<div id="${this.brick_id}" class='form-element-container cc-tokenfield-container no_click_close'></div>`;
        var self = this;
        this.popout = new (0, _cbPopout.cb_popout)(this.brick_id, true, this.blueprint.ins.cfg, "cc-tokenfield", true, false, function() {
            var input = document.getElementById(self.brick_id + "$input");
            if (input) input.focus();
            self.cb_emit({
                "@popout_opened": true
            });
            var select = document.getElementById(self.brick_id + "$select");
            if (select) select.classList.add("cc-tokenfield-select-open");
        }, function() {
            var select = document.getElementById(self.brick_id + "$select");
            if (select) select.classList.remove("cc-tokenfield-select-open");
            var input = document.getElementById(self.brick_id + "$input");
            if (input) {
                input.classList.remove("cc-tokenfield-validation-failed");
                input.value = "";
            }
            var validation_message_container = document.getElementById(`${self.brick_id}&validation`);
            if (validation_message_container) {
                validation_message_container.innerHTML = "";
                validation_message_container.style.display = "none";
            }
        });
        this.popout.init();
        var edit_html = `<div class="cc-tokenfield-edit-container" id="${this.brick_id}$popout"><input type="text" class="form-element cc-tokenfield-input" id="${this.brick_id}$input" /> <button class="btn cc-tokenfield-add-button" id="${this.brick_id}$add">Add</button></div><div class="cc-tokenfield-validation-message" id="${this.brick_id}&validation" style="display:none"></div>`;
        this.popout.setDropHtml(edit_html);
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_popout":"8UNLF","../../shared-funcs/Tokenfield":"5OZ9Q","../controls/cb_web_util":"jCKPs","../../codebricks-runtime/CBUtil":"1DxvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5OZ9Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tokenfield", ()=>Tokenfield);
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var _cbutil = require("../codebricks-runtime/CBUtil");
var Tokenfield = /** @class */ function() {
    function Tokenfield() {}
    Tokenfield.getTokens = function(value, separators, path) {
        if (typeof value == "string") {
            if (value == "") return [];
            var splitter = new RegExp("[" + (0, _sugarDefault.default).RegExp.escape(separators.join("")) + "]", "g");
            var tokens = value.split(splitter);
            return tokens;
        } else if (Array.isArray(value)) {
            if (value.length > 0) {
                if (typeof value[0] == "object" && path) {
                    var ret = [];
                    for(var _i = 0, value_1 = value; _i < value_1.length; _i++){
                        var v = value_1[_i];
                        ret.push((0, _cbutil.drill)(path, v));
                    }
                    return ret;
                }
            }
            return value;
        } else return [
            "" + value
        ];
    };
    return Tokenfield;
}();

},{"sugar":"7Uk8O","../codebricks-runtime/CBUtil":"1DxvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8yVw4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_unit_webcomponent", ()=>cc_unit_webcomponent);
parcelHelpers.export(exports, "web_cc_unit", ()=>web_cc_unit);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _unit = require("../../shared-funcs/Unit");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_unit_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_unit(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-unit", cc_unit_webcomponent);
class web_cc_unit extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, output, values, ret;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "args") _this.args = cfg;
                if (input == "unit_outs") {
                    keys = Object.keys(cfg);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = keys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            key = _step.value;
                            output = "";
                            if (key != "default") output = key;
                            values = (0, _cbutil.ValueFromSchema)(cfg);
                            _this.context.composition_runners[_this.cid].set_cn_out_data(output, values[key]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                ret = (0, _unit.Unit).PassThrough(input, cfg);
                return [
                    2,
                    ret
                ];
            });
        })();
    }
    cb_initial_cement(cements) {
        var innerHTML = `<div id="${this.brick_id}">`;
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var lop_classes = "";
                    var cement = cements[i];
                    var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                    if (cement && cement.styles) innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(cement.hidden ? " hidden" : "", cement, "")} id="${this.brick_id + "$" + i}">${brick}</div>`;
                    else innerHTML += brick;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        this.element.innerHTML = innerHTML + `</div>`;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var child = document.getElementById(this.brick_id + "$" + child_idx);
        if (child) {
            if (cement && cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        } else {
            var child1 = this.element.querySelector(`[container_id="${this.brick_id}"][idx="${child_idx}"]`);
            if (child1) {
                if (cement && cement.hidden) child1.classList.add("hidden");
                else child1.classList.remove("hidden");
                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child1, cement, "");
            }
        }
    }
    cb_status(status) {
        this.emit_state(status);
    }
    cb_snapshot() {
        if (this.args) {
            if (this.args.snapshot_id) delete this.args.snapshot_id;
            return {
                args: this.args
            };
        }
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.args = undefined;
        this.element = element;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/Unit":"347xf","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"347xf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unit", ()=>Unit);
var Unit = /** @class */ function() {
    function Unit() {}
    Unit.PassThrough = function(input, cfg) {
        var output = input;
        if (output == "default") output = "";
        var ret = {};
        ret["@" + output] = cfg;
        return ret;
    };
    return Unit;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"5Oc3T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_use_webcomponent", ()=>cc_use_webcomponent);
parcelHelpers.export(exports, "web_cc_use", ()=>web_cc_use);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _unit = require("../../shared-funcs/Unit");
var _cbWebUtil = require("../controls/cb_web_util");
class cc_use_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cc_use(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cc-use", cc_use_webcomponent);
class web_cc_use extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var ret, emit;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ret = (0, _unit.Unit).PassThrough(input, cfg);
                        emit = null;
                        if (_this.context.composition_runners[_this.cid].debugging_enabled) {
                            emit = {
                                emitter: _this.brick_id,
                                emit_data: ret,
                                events: []
                            };
                            _this.context.debug_log.emits.push(emit);
                        }
                        _this.last_ins[input] = cfg;
                        return [
                            4,
                            _this.context.composition_runners[_this.cid].run_init_passes(info, _this.blueprint.name, emit)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            ret
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        this.emit_state(status);
    }
    cb_snapshot() {}
    cb_validate() {
        var this_io_name = this.blueprint.contains && this.blueprint.contains[0].name;
        if (this_io_name) {
            var this_io_brick_id = this.context.composition_runners[this.cid].get_brick_ids(this_io_name, this.dc);
            var this_io_ci = this.context.bricks[this_io_brick_id[0]];
            return this_io_ci.validate_sources("");
        }
        return true;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.last_ins = {};
        this.element = element;
        var innerHTML = `<div id="${this.brick_id}">`;
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                    innerHTML += brick;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        this.element.innerHTML = innerHTML + "</div>";
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/Unit":"347xf","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"1Y5rz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cci_modal_webcomponent", ()=>cci_modal_webcomponent);
parcelHelpers.export(exports, "web_cci_modal", ()=>web_cci_modal);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbTooltip = require("../controls/cb_tooltip");
var _cbWebUtil = require("../controls/cb_web_util");
class cci_modal_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var ins = this.getAttribute("ins");
            this.ci = new web_cci_modal(context, cid, name, dc, Number(idx), container_id, this, ins);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cci-modal", cci_modal_webcomponent);
class web_cci_modal extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var modal, self, cancel, ok, title_element, cancel_button, ok_button, buttons_container, x, modal_body, modal_foter;
            return (0, _tsGenerator._)(this, function(_state) {
                _this.show_loading(false);
                if (input == "cfg") {
                    _this.cfg = cfg;
                    modal = document.getElementById(_this.brick_id);
                    if (!_this.initialized) {
                        _this.initialized = true;
                        self = _this;
                        if (cfg.easy_close) window.onclick = function(event) {
                            if (modal && event.target == modal) self.hide();
                        };
                        cancel = document.getElementById(`cci-modal-cancel_${_this.brick_id}`);
                        if (cancel) cancel.addEventListener("click", function() {
                            self.hide();
                        });
                        ok = document.getElementById(`cci-modal-ok_${_this.brick_id}`);
                        if (ok) ok.addEventListener("click", function() {
                            if (modal) {
                                if (self.validate_sources("")) self.cb_emit({
                                    "@": self.outdata
                                });
                            }
                        });
                    }
                    title_element = document.getElementById(`cci-modal-title_${_this.brick_id}`);
                    if (title_element) title_element.innerHTML = cfg.title;
                    cancel_button = document.getElementById(`cci-modal-cancel_${_this.brick_id}`);
                    if (cancel_button) {
                        if (cfg.cancel_button) {
                            cancel_button.innerHTML = cfg.cancel_button;
                            cancel_button.classList.remove("hidden");
                        } else if (cancel_button) cancel_button.classList.add("hidden");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(cancel_button, cfg, "cancel");
                    }
                    ok_button = document.getElementById(`cci-modal-ok_${_this.brick_id}`);
                    if (ok_button) {
                        if (cfg.ok_button) {
                            ok_button.innerHTML = cfg.ok_button;
                            ok_button.classList.remove("hidden");
                        } else if (ok_button) ok_button.classList.add("hidden");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(ok_button, cfg, "ok");
                    }
                    buttons_container = document.getElementById(`${_this.brick_id}$buttons`);
                    if (buttons_container) {
                        if (cfg.cancel_button || cfg.ok_button) buttons_container.classList.remove("hidden");
                        else buttons_container.classList.add("hidden");
                    }
                    x = document.getElementById(`cci-modal-close_${_this.brick_id}`);
                    if (x) {
                        if (cfg.no_x) x.classList.add("hidden");
                        else x.classList.remove("hidden");
                    }
                    if (modal) {
                        modal_body = modal.querySelector(".cci-modal-body");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(modal_body, cfg, "body");
                        modal_foter = modal.querySelector(".cci-modal-footer");
                        (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(modal_foter, cfg, "footer");
                    }
                } else if (input == "show") _this.show();
                else if (input == "show_no_animate") {
                    if (cfg) _this.show(true, false);
                } else if (input == "hide") _this.hide();
                else if (input == "data") _this.outdata = cfg;
                return [
                    2
                ];
            });
        })();
    }
    show() {
        var push_stack = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, animate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _a, _b;
        (0, _cbTooltip.cb_tooltip).hide();
        window.cb_modal_stack = window.cb_modal_stack || [];
        if (window.cb_modal_stack.length > 0) {
            var open_modal = window.cb_modal_stack[window.cb_modal_stack.length - 1];
            if (open_modal.brick_id == this.brick_id) return;
            open_modal.hide(false);
        }
        if (push_stack) {
            var open_modal1 = null;
            if (window.cb_modal_stack.length > 0) open_modal1 = window.cb_modal_stack[window.cb_modal_stack.length - 1];
            if (open_modal1 != this) window.cb_modal_stack.push(this);
        }
        var modal = document.getElementById(this.brick_id);
        if (modal) {
            if (animate) (_a = modal.firstElementChild) === null || _a === void 0 || _a.classList.add("cci-modal-animate");
            else (_b = modal.firstElementChild) === null || _b === void 0 || _b.classList.remove("cci-modal-animate");
            modal.style.display = "flex";
        }
        if (push_stack) {
            var container = document.getElementById(this.brick_id + "$body");
            if (container) container.scrollTop = 0;
        }
    }
    hide() {
        var pop_stack = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, close_all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var modal = document.getElementById(this.brick_id);
        if (modal) modal.style.display = "none";
        if (close_all) while(window.cb_modal_stack.length > 0){
            var pop_modal = window.cb_modal_stack[window.cb_modal_stack.length - 1];
            pop_modal.hide(false, false);
            window.cb_modal_stack.pop();
        }
        else if (pop_stack) {
            window.cb_modal_stack = window.cb_modal_stack || [];
            if (window.cb_modal_stack.length > 0) {
                var pop_modal1 = window.cb_modal_stack[window.cb_modal_stack.length - 1];
                if (pop_modal1 == this) window.cb_modal_stack.pop();
                if (window.cb_modal_stack.length > 0) {
                    var open_modal = window.cb_modal_stack[window.cb_modal_stack.length - 1];
                    open_modal.show(false, false);
                }
            }
        }
    }
    show_loading(show) {
        var _a;
        var modal = document.getElementById(this.brick_id + "$modal");
        if (modal) {
            if (show) {
                var spinner = document.getElementById(this.brick_id + "$spinner");
                if (spinner) spinner.setAttribute("data-loading-message", ((_a = this.cfg) === null || _a === void 0 ? void 0 : _a.loading_message) || "");
                modal === null || modal === void 0 || modal.classList.add("cci-modal-loading");
            } else modal === null || modal === void 0 || modal.classList.remove("cci-modal-loading");
        }
    }
    cb_initial_cement(cements) {
        var header_content = "";
        var footer_content = "";
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var prefix = sub.type.split("-")[0];
                    var component = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i);
                    if (prefix.indexOf("i") == -1 && prefix[0] != "s") component = `<div id="${this.brick_id}$${i}" class="child-hidden">` + component + `</div>`;
                    else component = `<div style="position:absolute">` + component + `</div>`;
                    var section = "body";
                    if (sub.cement) section = sub.cement.section;
                    if (section == "header") header_content += component;
                    else if (section == "footer") footer_content += component;
                    else this.body_content += component;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var cfg = this.blueprint.ins.cfg;
        var buttons = "";
        buttons += `<div id="${this.brick_id}$buttons" class="cci-modal-buttons hidden">`;
        buttons += ` <button class="btn btn-secondary cci-modal-cancel hidden" id="cci-modal-cancel_${this.brick_id}"></button>`;
        buttons += ` <button class="btn btn-primary cci-modal-ok hidden" id="cci-modal-ok_${this.brick_id}"></button>`;
        buttons += "</div>";
        var footer = `<div class="cci-modal-footer" id="${this.brick_id}$footer">` + footer_content + buttons + "</div>";
        var html = `<div class="cci-modal cci-modal-${(cfg.width || "auto").toLowerCase()}" id="${this.brick_id}$modal">
                <div class="cci-modal-header">
                    <span class="cci-modal-close" id="cci-modal-close_${this.brick_id}">&times;</span>
                    <span id="cci-modal-title_${this.brick_id}"></span>
                    ${header_content}
                </div>
                <div class="cci-modal-body" id="${this.brick_id}$body">
                    ${this.body_content}
                </div>
                <div id="${this.brick_id}$spinner" class="cci-modal-loader"></div>
                ${footer}
            </div>`;
        var modal = document.getElementById(this.brick_id);
        if (modal) modal.innerHTML = html;
        var self = this;
        var x = document.getElementById(`cci-modal-close_${this.brick_id}`);
        if (x) x.addEventListener("click", function(event) {
            self.hide(true, true);
        });
        for(var child_idx in cements){
            var child = document.getElementById(this.brick_id + "$" + child_idx);
            var cement = cements[child_idx];
            if (child) {
                if (cement && cement.hidden) child.classList.add("child-hidden");
                else child.classList.remove("child-hidden");
                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
            }
        }
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var child = document.getElementById(this.brick_id + "$" + child_idx);
        if (child) {
            if (cement && cement.hidden) child.classList.add("child-hidden");
            else child.classList.remove("child-hidden");
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        }
    }
    cb_status(status) {
        if (status == "loading") this.show_loading(true);
        else this.show_loading(false);
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element, standalone_ins){
        super(context, cid, name, dc, idx, container_id, standalone_ins);
        this.body_content = "";
        this.initialized = false;
        this.element = element;
        if (cid == undefined) {
            this.blueprint.name = element.id;
            this.brick_id = element.id + "_brick";
            window.so_bricks = window.so_bricks || {};
            window.so_bricks[this.brick_id] = this;
            this.body_content = element.innerHTML;
        }
        var html = `<div id="${this.brick_id}" class="cci-modal-background">
        </div>`;
        this.element.innerHTML = html;
        var self = this;
        this.init_cement();
        if (cid == undefined) {
            setTimeout(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                var _tmp, _tmp1, _i, input, ret;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = [];
                            for(_tmp1 in self.blueprint.ins)_tmp.push(_tmp1);
                            _i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(_i < _tmp.length)) return [
                                3,
                                4
                            ];
                            input = _tmp[_i];
                            return [
                                4,
                                self.cb_event(input, self.blueprint.ins[input], {})
                            ];
                        case 2:
                            ret = _state.sent();
                            _state.label = 3;
                        case 3:
                            _i++;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }), 0);
            return;
        }
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_tooltip":"wtPnN","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"6RDfR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_layout_grid_webcomponent", ()=>cd_layout_grid_webcomponent);
parcelHelpers.export(exports, "web_cd_layout_grid", ()=>web_cd_layout_grid);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cd_layout_grid_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cd_layout_grid(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-layout-grid", cd_layout_grid_webcomponent);
class web_cd_layout_grid extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var slot, container, data, blocks, controls, container1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "hide")) return [
                            3,
                            1
                        ];
                        slot = document.getElementById(_this.brick_id);
                        if (slot) {
                            if (cfg) slot.style.display = "none";
                            else slot.style.display = "flex";
                        }
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!(input == "cfg")) return [
                            3,
                            3
                        ];
                        _this.cfg = cfg;
                        container = document.getElementById(_this.brick_id);
                        if (container) {
                            if (cfg.hidden) container.classList.add("hidden");
                            else container.classList.remove("hidden");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                        }
                        _this.empty_data_message = cfg.empty_data_message;
                        data = cfg.data;
                        _this.data = data;
                        return [
                            4,
                            _this.renderData(data, container)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (input == "edit_mode") {
                            if (cfg) {
                                if (_this.loaded && !_this.edit_mode) _this.enterEditMode();
                                _this.edit_mode = true;
                            } else {
                                if (_this.data) {
                                    blocks = _this.element.querySelectorAll(".cc-layout-grid-cell");
                                    blocks.forEach((draggable)=>{
                                        draggable.removeAttribute("draggable");
                                        draggable.classList.remove("dragndrop-element-draggable");
                                    });
                                    controls = _this.element.querySelectorAll(".dragndrop-element-controls");
                                    controls.forEach((element)=>{
                                        element.remove();
                                    });
                                    container1 = _this.element.querySelector(".cc-layout-grid-container");
                                    if (container1) container1.classList.remove("cc-layout-grid-container-editmode");
                                }
                                _this.edit_mode = false;
                            }
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    renderData(data, container) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var innerHTML, dc_root, row_idx, i, di, d, child_dc, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sub, cement, brick, cols, classes, cement_child_id, prefix, drag_info, _$container;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.flush_dynamic();
                        innerHTML = "";
                        if (container) {
                            if (data && _this.blueprint.contains) {
                                dc_root = (_this.dc || "") + ((0, _cbutil.DC_JOIN) + _this.blueprint.name);
                                data = _this.fillGaps(data);
                                row_idx = 0;
                                i = 0;
                                for(var di in data){
                                    d = data[di];
                                    child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = _this.blueprint.contains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            sub = _step.value;
                                            cement = _this.cements[i] || sub.cement;
                                            brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, _this, i, child_dc);
                                            if (cement) {
                                                cols = d.block_width || cement.width || 12;
                                                classes = "";
                                                classes = "w" + cols;
                                                if (cement && cement.hidden) classes += " hidden";
                                                cement_child_id = _this.brick_id + "$" + row_idx + "$" + i;
                                                prefix = sub.type.split("-")[0];
                                                if (prefix.indexOf("i") == -1 && prefix[0] != "s") {
                                                    drag_info = {
                                                        source_id: _this.brick_id,
                                                        tags: _this.cfg.drag_tags
                                                    };
                                                    innerHTML += `<div class="cc-layout-grid-cell ${classes}" id="${cement_child_id}" cd-data="${(0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(d))}" drag-info="${(0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(drag_info))}"><div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("card cc-layout-grid-item", cement, "")} >${brick}</div></div>`;
                                                    i++;
                                                } else innerHTML += `<div style="position:absolute">` + brick + `</div>`;
                                            } else innerHTML += brick;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    row_idx++;
                                }
                            }
                            innerHTML += `</div>`;
                            _$container = document.getElementById(_this.brick_id);
                            if (_$container) _$container.innerHTML = innerHTML;
                        }
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(data)
                        ];
                    case 1:
                        _state.sent();
                        if (_this.edit_mode) _this.enterEditMode();
                        _this.loaded = true;
                        return [
                            2
                        ];
                }
            });
        })();
    }
    fillGaps(data) {
        var _loop = function(di) {
            var d = data[di];
            var w = d.block_width || 12;
            row_width += w;
            if (row_width == 12) {
                row++;
                row_width = 0;
                row_start = di;
            } else if (row_width > 12) {
                var was_row_width = row_width - w;
                var gap_size = 12 - was_row_width;
                var grow_frac = 12 / was_row_width;
                var squeeze_frac = row_width / 12;
                var max_sqeeze = 0.75;
                var do_grow = grow_frac < squeeze_frac;
                if (!do_grow) {
                    var sort_by_size = data.slice(row_start, di + 1);
                    sort_by_size.sort(function(a, b) {
                        return a.block_width - b.block_width;
                    });
                    var new_row_w = 0;
                    var old_cumulative = 0;
                    for(var e = sort_by_size.length - 1; e > 0; e--){
                        var ew = sort_by_size[e].block_width;
                        var new_w = Math.floor(ew / squeeze_frac);
                        old_cumulative += ew;
                        new_row_w += new_w;
                        sort_by_size[e].block_width = new_w;
                        squeeze_frac = (row_width - old_cumulative) / (12 - new_row_w);
                        if (squeeze_frac < 0.01) break;
                    }
                }
                if (do_grow) {
                    var sort_by_size1 = data.slice(row_start, di);
                    sort_by_size1.sort(function(a, b) {
                        return a.block_width - b.block_width;
                    });
                    var new_row_w1 = 0;
                    var old_cumulative1 = 0;
                    for(var e1 = sort_by_size1.length - 1; e1 > 0; e1--){
                        var ew1 = sort_by_size1[e1].block_width;
                        var new_w1 = Math.ceil(ew1 * grow_frac);
                        old_cumulative1 += ew1;
                        new_row_w1 += new_w1;
                        sort_by_size1[e1].block_width = new_w1;
                        grow_frac = (12 - new_row_w1) / (12 - old_cumulative1);
                        if (grow_frac < 1 || Math.abs(1 - grow_frac) < 0.01) break;
                    }
                    row++;
                    row_width = w;
                    row_start = di;
                }
            }
        };
        var cloned_data = [];
        if (this.edit_mode) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var d = _step.value;
                    cloned_data.push((0, _cbutil.Clone)(d));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            data = cloned_data;
        }
        var row = 0;
        var row_width = 0;
        var row_start = 0;
        for(var di = 0; di < data.length; di++)_loop(di);
        return data;
    }
    enterEditMode() {
        if (!this.data) return;
        this.edit_mode = true;
        var blocks = this.element.querySelectorAll(".cc-layout-grid-cell");
        var position = 0;
        var self = this;
        blocks.forEach((draggable)=>{
            if (draggable.classList.contains("dragndrop-element-draggable")) return;
            draggable.setAttribute("draggable", true);
            draggable.classList.add("dragndrop-element-draggable");
            var controls_html = `<div class="dragndrop-element-controls" position="${position}">
                <div class="dragndrop-element-controls-delete" onclick=""></div>
            </div>`;
            draggable.insertAdjacentHTML("beforeend", controls_html);
            var drag_handle = `<div class="drag-handle"></div>`;
            draggable.insertAdjacentHTML("beforeend", drag_handle);
            var pos = position;
            var del_btn = this.element.querySelector('.dragndrop-element-controls[position="' + position + '"] > .dragndrop-element-controls-delete');
            if (del_btn) del_btn.addEventListener("click", function() {
                self.deleteBlock(pos);
            });
            draggable.addEventListener("mousedown", (e)=>{
                self.drag_target = e.target;
            });
            draggable.addEventListener("dragstart", (e)=>{
                if (!self.drag_target.classList.contains("drag-handle")) {
                    e.preventDefault();
                    return;
                }
                e.dataTransfer.setData("text", e.target.id);
                window.drag_info = {
                    source_id: self.brick_id,
                    tags: self.cfg.drag_tags
                };
                draggable.classList.add("dragging");
            });
            draggable.addEventListener("dragend", ()=>{
                draggable.classList.remove("dragging");
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
            });
            draggable.addEventListener("dragenter", ()=>{
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
                draggable.classList.add("dropzone");
            });
            draggable.addEventListener("dragover", (e)=>{
                if (!self.may_drop()) return;
                e.preventDefault();
                e.stopPropagation();
            });
            position++;
        });
        var container = this.element.querySelector(".cc-layout-grid-container");
        if (container && container.getAttribute("has_drag_handlers") == null) {
            container.setAttribute("has_drag_handlers", "true");
            container.classList.add("cc-layout-grid-container-editmode");
            container.addEventListener("dragover", (e)=>{
                if (!self.may_drop()) return;
                e.preventDefault();
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
            });
            container.addEventListener("drop", (e)=>{
                e.preventDefault();
                e.stopPropagation();
                var data = e.dataTransfer.getData("text");
                var block = document.getElementById(data);
                if (container && block) {
                    var drag_info = JSON.parse((0, _cbWebUtil.CBWebUtil).unescapeHtml(block.getAttribute("drag-info") || ""));
                    var cd_data = JSON.parse((0, _cbWebUtil.CBWebUtil).unescapeHtml(block.getAttribute("cd-data") || ""));
                    if (drag_info.source_id == self.brick_id) {
                        block.classList.remove("dragging");
                        var dropzone = self.element.querySelector(".dropzone");
                        if (dropzone) {
                            var dest_id = dropzone.id;
                            var src_id = data;
                            var dest_idx = Number((0, _cbutil.SplitGetLast)(dest_id, "$"));
                            var src_idx = Number((0, _cbutil.SplitGetLast)(src_id, "$"));
                            (0, _cbutil.array_move)(self.data, src_idx, dest_idx);
                            if (dest_id < src_id) container.insertBefore(block, dropzone);
                            else self.insertAfter(dropzone, block);
                            dropzone.id = src_id;
                            block.id = dest_id;
                            self.saveLayout();
                        } else container.appendChild(block);
                    } else {
                        var dropzone1 = self.element.querySelector(".dropzone");
                        if (dropzone1) {
                            var dest_id1 = dropzone1.id;
                            var dest_idx1 = Number((0, _cbutil.SplitGetLast)(dest_id1, "$"));
                            self.data.splice(dest_idx1, 0, cd_data);
                        } else self.data.push(cd_data);
                        var container1 = document.getElementById(self.brick_id);
                        if (container1) self.renderData(self.data, container1);
                        self.saveLayout();
                    }
                }
                var dropzone2 = self.element.querySelector(".dropzone");
                if (dropzone2) dropzone2.classList.remove("dropzone");
            });
        }
    }
    may_drop() {
        var drag_info = window.drag_info;
        if (drag_info) {
            if (drag_info.source_id == this.brick_id) {
                if (this.cfg.disallow_move) return;
            } else try {
                var intersection = this.cfg.drop_tags.filter(function(n) {
                    return drag_info.tags.indexOf(n) !== -1;
                });
                if (!intersection || intersection.length == 0) return false;
            } catch (err) {
                console.error(err);
                return false;
            }
            return true;
        }
        return false;
    }
    deleteBlock(position) {
        var controls = this.element.querySelector('.dragndrop-element-controls[position="' + position + '"]');
        if (controls && controls.parentElement) {
            this.data.splice(position, 1);
            var container = document.getElementById(this.brick_id);
            if (container) this.renderData(this.data, container);
            this.saveLayout();
        }
    }
    saveLayout() {
        for(var d = 0; d < this.data.length; d++)this.data[d]["Position"] = d;
        this.cb_emit({
            "@data": this.data
        });
    }
    insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    cb_initial_cement(cements) {
        this.cements = cements;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var cement_child_id = this.brick_id + "$" + row_idx + "$" + child_idx;
        var child = document.getElementById(cement_child_id);
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            var item = child.firstElementChild;
            if (item) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(item, cement, "");
        }
    }
    cb_status(status) {
        var container = document.getElementById(this.brick_id);
        if (container) {
            if (status == "loading") container.innerHTML = '<div class="loader loader-loading"></div>';
            else if (container.firstElementChild) {
                container.firstElementChild.classList.remove("loader");
                container.firstElementChild.classList.remove("loader-loading");
            }
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.cements = {};
        this.empty_data_message = "";
        this.grab_offset_x = 0;
        this.grab_offset_y = 0;
        this.edit_mode = false;
        this.loaded = false;
        this.cfg = {};
        this.element = element;
        element.innerHTML = `<div class="cc-layout-grid-container" id="${this.brick_id}"></div>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"iSGY7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_dragndrop_container_webcomponent", ()=>cd_dragndrop_container_webcomponent);
parcelHelpers.export(exports, "web_cd_dragndrop_container", ()=>web_cd_dragndrop_container);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cd_dragndrop_container_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cd_dragndrop_container(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-dragndrop-container", cd_dragndrop_container_webcomponent);
class web_cd_dragndrop_container extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var slot, container, data, blocks, controls, container1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "hide")) return [
                            3,
                            1
                        ];
                        slot = document.getElementById(_this.brick_id);
                        if (slot) {
                            if (cfg) slot.style.display = "none";
                            else slot.style.display = "flex";
                        }
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!(input == "cfg")) return [
                            3,
                            3
                        ];
                        _this.cfg = cfg;
                        container = document.getElementById(_this.brick_id);
                        if (container) {
                            if (cfg.hidden) container.classList.add("hidden");
                            else container.classList.remove("hidden");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "container");
                        }
                        _this.empty_data_message = cfg.empty_data_message;
                        data = cfg.data;
                        _this.data = data;
                        return [
                            4,
                            _this.renderData(data, container)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (input == "edit_mode") {
                            if (cfg) {
                                if (_this.loaded && !_this.edit_mode) _this.enterEditMode();
                                _this.edit_mode = true;
                            } else {
                                if (_this.data) {
                                    blocks = _this.element.querySelectorAll(".dragndrop-element");
                                    blocks.forEach((draggable)=>{
                                        draggable.removeAttribute("draggable");
                                        draggable.classList.remove("dragndrop-element-draggable");
                                    });
                                    controls = _this.element.querySelectorAll(".dragndrop-element-controls");
                                    controls.forEach((element)=>{
                                        element.remove();
                                    });
                                    container1 = _this.element.querySelector(".cd-dragndrop-container");
                                    if (container1) container1.classList.remove("cd-dragndrop-container-editmode");
                                }
                                _this.edit_mode = false;
                            }
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    renderData(data, container) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var innerHTML, dc_root, row_idx, i, di, d, child_dc, child_style_str, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sub, cement, brick, classes, prefix, drag_info;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.flush_dynamic();
                        innerHTML = "";
                        if (container) {
                            if (data && _this.blueprint.contains) {
                                dc_root = (_this.dc || "") + ((0, _cbutil.DC_JOIN) + _this.blueprint.name);
                                row_idx = 0;
                                i = 0;
                                for(var di in data){
                                    d = data[di];
                                    child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
                                    child_style_str = (0, _cbWebUtil.CBWebUtil).GetElementStylesString("", _this.cfg, "child");
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = _this.blueprint.contains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            sub = _step.value;
                                            cement = _this.cements[i] || sub.cement;
                                            brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, _this, i, child_dc);
                                            if (cement) {
                                                classes = "";
                                                if (cement && cement.hidden) classes += " hidden";
                                                prefix = sub.type.split("-")[0];
                                                if (prefix.indexOf("i") == -1 && prefix[0] != "s") {
                                                    drag_info = {
                                                        source_id: _this.brick_id,
                                                        tags: _this.cfg.drag_tags
                                                    };
                                                    innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("dragndrop-element" + classes, cement, "")} id="${_this.brick_id}$${i++}" cd-data="${(0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(d))}" drag-info="${(0, _cbWebUtil.CBWebUtil).escapeHtml(JSON.stringify(drag_info))}"><div ${child_style_str} >${brick}</div></div>`;
                                                } else innerHTML += `<div style="position:absolute">` + brick + `</div>`;
                                            } else innerHTML += brick;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    row_idx++;
                                }
                            }
                            _this.element.innerHTML = `<div class="cd-dragndrop-container" id="${_this.brick_id}">` + innerHTML + `</div>`;
                        }
                        if (!data) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(data)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (_this.edit_mode) _this.enterEditMode();
                        _this.loaded = true;
                        return [
                            2
                        ];
                }
            });
        })();
    }
    enterEditMode() {
        if (!this.data) return;
        this.edit_mode = true;
        var blocks = this.element.querySelectorAll(".dragndrop-element");
        var position = 0;
        var self = this;
        blocks.forEach((draggable)=>{
            draggable.setAttribute("draggable", true);
            draggable.classList.add("dragndrop-element-draggable");
            var controls_html = `<div class="dragndrop-element-controls" position="${position}">
                <div class="dragndrop-element-controls-delete" onclick=""></div>
            </div>`;
            if (self.cfg.allow_delete) draggable.insertAdjacentHTML("beforeend", controls_html);
            var drag_handle = `<div class="drag-handle"></div>`;
            draggable.insertAdjacentHTML("beforeend", drag_handle);
            var pos = position;
            var del_btn = this.element.querySelector('.dragndrop-element-controls[position="' + position + '"] > .dragndrop-element-controls-delete');
            if (del_btn) del_btn.addEventListener("click", function() {
                self.deleteBlock(pos);
            });
            draggable.addEventListener("mousedown", (e)=>{
                self.drag_target = e.target;
            });
            draggable.addEventListener("dragstart", (e)=>{
                if (!self.drag_target.classList.contains("drag-handle")) {
                    e.preventDefault();
                    return;
                }
                e.dataTransfer.setData("text", e.target.id);
                window.drag_info = {
                    source_id: self.brick_id,
                    tags: self.cfg.drag_tags
                };
                draggable.classList.add("dragging");
            });
            draggable.addEventListener("dragend", ()=>{
                draggable.classList.remove("dragging");
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
            });
            draggable.addEventListener("dragenter", ()=>{
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
                draggable.classList.add("dropzone");
            });
            draggable.addEventListener("dragover", (e)=>{
                if (!self.may_drop()) return;
                e.preventDefault();
                e.stopPropagation();
            });
            position++;
        });
        var container = this.element.querySelector(".cd-dragndrop-container");
        if (container) {
            container.classList.add("cd-dragndrop-container-editmode");
            container.addEventListener("dragover", (e)=>{
                if (!self.may_drop()) return;
                e.preventDefault();
                var dropzone = self.element.querySelector(".dropzone");
                if (dropzone) dropzone.classList.remove("dropzone");
            });
            container.addEventListener("drop", (e)=>{
                e.preventDefault();
                e.stopPropagation();
                var data = e.dataTransfer.getData("text");
                var block = document.getElementById(data);
                if (container && block) {
                    var drag_info = JSON.parse((0, _cbWebUtil.CBWebUtil).unescapeHtml(block.getAttribute("drag-info") || ""));
                    var cd_data = JSON.parse((0, _cbWebUtil.CBWebUtil).unescapeHtml(block.getAttribute("cd-data") || ""));
                    if (drag_info.source_id == self.brick_id) {
                        block.classList.remove("dragging");
                        var dropzone = self.element.querySelector(".dropzone");
                        if (dropzone) {
                            var dest_id = dropzone.id;
                            var src_id = data;
                            var dest_idx = Number((0, _cbutil.SplitGetLast)(dest_id, "$"));
                            var src_idx = Number((0, _cbutil.SplitGetLast)(src_id, "$"));
                            (0, _cbutil.array_move)(self.data, src_idx, dest_idx);
                            if (dest_id < src_id) container.insertBefore(block, dropzone);
                            else self.insertAfter(dropzone, block);
                            dropzone.id = src_id;
                            block.id = dest_id;
                        } else container.appendChild(block);
                    } else {
                        var dropzone1 = self.element.querySelector(".dropzone");
                        if (dropzone1) {
                            var dest_id1 = dropzone1.id;
                            var dest_idx1 = Number((0, _cbutil.SplitGetLast)(dest_id1, "$"));
                            self.data.splice(dest_idx1, 0, cd_data);
                        } else self.data.push(cd_data);
                        var container1 = document.getElementById(self.brick_id);
                        if (container1) self.renderData(self.data, container1);
                    }
                    self.saveLayout();
                }
                var dropzone2 = self.element.querySelector(".dropzone");
                if (dropzone2) dropzone2.classList.remove("dropzone");
            });
        }
    }
    may_drop() {
        var drag_info = window.drag_info;
        if (drag_info) {
            if (drag_info.source_id == this.brick_id) {
                if (this.cfg.disallow_move) return;
            } else try {
                var intersection = this.cfg.drop_tags.filter(function(n) {
                    return drag_info.tags.indexOf(n) !== -1;
                });
                if (!intersection || intersection.length == 0) return false;
            } catch (err) {
                console.error(err);
                return false;
            }
            return true;
        }
        return false;
    }
    deleteBlock(position) {
        var controls = this.element.querySelector('.dragndrop-element-controls[position="' + position + '"]');
        if (controls && controls.parentElement) {
            this.data.splice(position, 1);
            var container = document.getElementById(this.brick_id);
            if (container) this.renderData(this.data, container);
            this.saveLayout();
        }
    }
    saveLayout() {
        for(var d = 0; d < this.data.length; d++)this.data[d]["Position"] = d;
        this.cb_emit({
            "@data": this.data
        });
    }
    insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    cb_initial_cement(cements) {
        this.cements = cements;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var child = document.getElementById(this.brick_id + "$" + row_idx);
        if (child && cement) {
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
        }
    }
    cb_status(status) {
        if (status == "loading") {
            var container = document.getElementById(this.brick_id);
            if (container) container.innerHTML = '<div class="loader loader-loading"></div>';
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.cements = {};
        this.empty_data_message = "";
        this.grab_offset_x = 0;
        this.grab_offset_y = 0;
        this.edit_mode = false;
        this.loaded = false;
        this.cfg = {};
        this.element = element;
        this.init_cement();
        element.innerHTML = `<div class="cd-dragndrop-container" id="${this.brick_id}"></div>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"6MmWV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_flexbox_webcomponent", ()=>cd_flexbox_webcomponent);
parcelHelpers.export(exports, "web_cd_flexbox", ()=>web_cd_flexbox);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbWebUtil = require("../controls/cb_web_util");
class cd_flexbox_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cd_flexbox(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-flexbox", cd_flexbox_webcomponent);
class web_cd_flexbox extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var slot, innerHTML, dc_root, row_idx, di, d, i, child_dc, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sub, cement, cement_child_id, brick, hidden, prefix, container, option;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "data")) return [
                            3,
                            3
                        ];
                        _this.flush_dynamic();
                        slot = document.getElementById(_this.brick_id);
                        if (!slot) return [
                            3,
                            2
                        ];
                        innerHTML = "";
                        if (cfg && _this.blueprint.contains) {
                            dc_root = (_this.dc || "") + ((0, _cbutil.DC_JOIN) + _this.blueprint.name);
                            row_idx = 0;
                            for(var di in cfg){
                                d = cfg[di];
                                i = 0;
                                child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = _this.blueprint.contains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        sub = _step.value;
                                        cement = _this.cements[i] || sub.cement;
                                        cement_child_id = _this.brick_id + "$" + row_idx + "$" + i;
                                        brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, _this, i, child_dc);
                                        if (cement) {
                                            hidden = cement.hidden ? ` hidden` : "";
                                            prefix = sub.type.split("-")[0];
                                            if (prefix.indexOf("i") == -1 && prefix[0] != "s") innerHTML += `<div ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString(hidden, cement, "")} id="${cement_child_id}">${brick}</div>`;
                                            else innerHTML += `<div style="position:absolute">` + brick + `</div>`;
                                        } else innerHTML += brick;
                                        i++;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                row_idx++;
                            }
                        }
                        if (innerHTML == "" && _this.empty_data_message) innerHTML = `<div class="empty-state cd-table-empty">${_this.empty_data_message || ""}</div>`;
                        slot.innerHTML = innerHTML;
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(cfg)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (input == "cfg") {
                            container = document.getElementById(_this.brick_id);
                            if (container) {
                                if (cfg.hidden) container.classList.add("hidden");
                                else container.classList.remove("hidden");
                                for(var option in cfg){
                                    if (option == "flex-wrap" && cfg[option]) container.style.flexWrap = cfg["flex-wrap"];
                                    else if (option == "align-items" && cfg[option]) container.style.alignItems = cfg["align-items"];
                                    else if (option == "align-content" && cfg[option]) container.style.alignContent = cfg["align-content"];
                                    else if (option == "flex-direction" && cfg[option]) container.style.flexDirection = cfg["flex-direction"];
                                    else if (option == "justify-content" && cfg[option]) container.style.justifyContent = cfg["justify-content"];
                                    else if (option == "gap" && cfg[option]) container.style.gap = cfg["gap"];
                                }
                                (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "flexbox");
                            }
                            _this.empty_data_message = cfg.empty_data_message;
                            _this.no_loader = cfg.no_loader || false;
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {
        this.cements = cements;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var cement_child_id = this.brick_id + "$" + row_idx + "$" + child_idx;
        var child = document.getElementById(cement_child_id);
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        }
    }
    cb_status(status) {
        var container = document.getElementById(this.brick_id);
        if (container) {
            if (status == "loading" && !this.no_loader) container.innerHTML = '<div class="loader loader-loading"></div>';
            else if (container.firstElementChild) {
                container.firstElementChild.classList.remove("loader");
                container.firstElementChild.classList.remove("loader-loading");
            }
        }
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.empty_data_message = "";
        this.cements = {};
        this.no_loader = false;
        this.element = element;
        element.innerHTML = `<div class="cd-flexbox" id="${this.brick_id}" brick_idx="${this.ci_idx}"></div>`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lsvi1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_pivot_table_webcomponent", ()=>cd_pivot_table_webcomponent);
parcelHelpers.export(exports, "web_cd_pivot_table", ()=>web_cd_pivot_table);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbformatting = require("../../codebricks-runtime/CBFormatting");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbPager = require("../controls/cb_pager");
var _pivotTable = require("../../shared-funcs/PivotTable");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var _cbWebUtil = require("../controls/cb_web_util");
var _cbutil = require("../../codebricks-runtime/CBUtil");
class cd_pivot_table_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cd_pivot_table(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-pivot-table", cd_pivot_table_webcomponent);
class web_cd_pivot_table extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var search_container, top, title, r, cfg_row, c, cfg_col, dc, cfg_col1, footer, search_element, self, search_term, search_close, self1, container;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            2
                        ];
                        if (_this.data && cfg.data && _this.data.length != cfg.data.length) _this.page = 0;
                        _this.data = cfg.data || [];
                        _this.dc_data = _this.data;
                        _this.cfg = cfg;
                        if (_this.cfg.table && _this.cfg.table.page_size !== undefined) _this.page_size = _this.cfg.table.page_size || 12;
                        search_container = document.getElementById(_this.brick_id + "$search_container");
                        if (search_container) {
                            top = document.getElementById(_this.brick_id);
                            if ((!_this.cfg.table || _this.cfg.table && !_this.cfg.table.search || _this.cfg.table && _this.cfg.table.search && !_this.cfg.table.search.hidden) && _this.context.platform != "file") {
                                search_container.classList.remove("hidden");
                                if (top) top.classList.remove("cd-table-nosearch");
                            } else {
                                search_container.classList.add("hidden");
                                if (top) top.classList.add("cd-table-nosearch");
                            }
                        }
                        title = document.getElementById(_this.brick_id + "$title");
                        if (title) {
                            if (_this.cfg.table && _this.cfg.table.title) {
                                title.innerHTML = _this.cfg.table.title;
                                title.classList.remove("hidden");
                            } else title.classList.add("hidden");
                        }
                        _this.rows = [];
                        if (cfg.rows) for(r = 0; r < cfg.rows.length; r++){
                            cfg_row = cfg.rows[r];
                            _this.rows.push({
                                col: cfg_row.column,
                                rename: cfg_row.rename,
                                format: cfg_row.format || "",
                                val: ""
                            });
                        }
                        _this.cols = [];
                        if (cfg.columns) for(c = 0; c < cfg.columns.length; c++){
                            cfg_col = cfg.columns[c];
                            _this.cols.push(cfg_col);
                        }
                        _this.dataCols = [];
                        if (cfg.data_columns) for(dc = 0; dc < cfg.data_columns.length; dc++){
                            cfg_col1 = cfg.data_columns[dc];
                            _this.dataCols.push({
                                col: cfg_col1.column,
                                rename: cfg_col1.rename,
                                format: cfg_col1.format || "",
                                val: ""
                            });
                        }
                        _this.page = 0;
                        _this.start_row = _this.page * _this.page_size;
                        _this.end_row = (_this.page + 1) * _this.page_size;
                        footer = document.getElementById(_this.brick_id + "$footer");
                        if (cfg.table && cfg.table.no_pager || _this.context.platform == "file") {
                            _this.end_row = Number.MAX_VALUE;
                            if (footer) footer.classList.add("hidden");
                        } else if (footer) footer.classList.remove("hidden");
                        return [
                            4,
                            _this.render_data(cfg.data, _this.rows, _this.cols, _this.dataCols)
                        ];
                    case 1:
                        _state.sent();
                        search_element = document.getElementById(_this.brick_id + "$search");
                        if (!_this.initialized) {
                            self = _this;
                            if (search_element) {
                                search_element.addEventListener("input", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                                    return (0, _tsGenerator._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!search_element) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    self.search_changed()
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }));
                                search_term = search_element.value;
                                search_close = document.getElementById(_this.brick_id + "$search_close");
                                if (search_close) {
                                    search_close.style.display = search_term == "" ? "none" : "inline-block";
                                    if (!_this.initialized) {
                                        self1 = _this;
                                        search_close.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                                            var search, search_term;
                                            return (0, _tsGenerator._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        search = document.getElementById(self1.brick_id + "$search");
                                                        search_term = search.value;
                                                        if (!search_term) return [
                                                            3,
                                                            2
                                                        ];
                                                        search.value = "";
                                                        return [
                                                            4,
                                                            self1.search_changed()
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        _state.label = 2;
                                                    case 2:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }));
                                    }
                                }
                            }
                        }
                        if (search_element) search_element.placeholder = _this.cfg.table && _this.cfg.table.search && _this.cfg.table.search.label ? _this.cfg.table.search.label : "Search";
                        _this.initialized = true;
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if (input == "hide") {
                            container = document.getElementById(_this.brick_id);
                            if (container) {
                                if (cfg) container.classList.add("hidden");
                                else container.classList.remove("hidden");
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    search_changed() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _a, search_element, expand_levels, search_term, tree, search_close;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        search_element = document.getElementById(_this.brick_id + "$search");
                        _this.start_row = 0;
                        if (_this.cfg.table && _this.cfg.table.no_pager) ;
                        else _this.end_row = _this.start_row + _this.page_size;
                        expand_levels = 999;
                        search_term = search_element.value;
                        if (search_term == "" && _this.cfg.table.expand_levels !== undefined && _this.cfg.table.expand_levels !== null && !isNaN(_this.cfg.table.expand_levels)) expand_levels = Number(_this.cfg.table.expand_levels);
                        tree = (0, _pivotTable.PivotTable).dataToTreeP(_this.data, _this.rows, _this.cols, _this.dataCols, expand_levels, search_element.value, false, ((_a = _this.context.composition_runners[_this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}, false, _this.cfg && _this.cfg.table && _this.cfg.table.dont_sort_nodes);
                        _this.treedata = tree;
                        return [
                            4,
                            _this.drawTable()
                        ];
                    case 1:
                        _state.sent();
                        _this.setEventHandlers();
                        if (search_term) search_element.classList.add("cd-table-search-active");
                        else search_element.classList.remove("cd-table-search-active");
                        search_close = document.getElementById(_this.brick_id + "$search_close");
                        if (search_close) search_close.style.display = search_term == "" ? "none" : "inline-block";
                        return [
                            2
                        ];
                }
            });
        })();
    }
    render_data(data, rows, cols, dataCols) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _a, nullstr, expand_levels, tree;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        nullstr = null;
                        expand_levels = 999;
                        if (_this.cfg.table.expand_levels !== undefined && _this.cfg.table.expand_levels !== null && !isNaN(_this.cfg.table.expand_levels)) expand_levels = Number(_this.cfg.table.expand_levels);
                        tree = (0, _pivotTable.PivotTable).dataToTreeP(_this.data, rows, cols, dataCols, expand_levels, nullstr, _this.cfg && _this.cfg.table && _this.cfg.table.dont_order_data_cols, ((_a = _this.context.composition_runners[_this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {}, false, _this.cfg && _this.cfg.table && _this.cfg.table.dont_sort_nodes);
                        _this.treedata = tree;
                        return [
                            4,
                            _this.drawTable()
                        ];
                    case 1:
                        _state.sent();
                        _this.setEventHandlers();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {
        this.cements = cements;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
        var child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
        var child = this.element.querySelector('[dc="' + child_dc + '"][idx="' + child_idx + '"][container_id="' + this.brick_id + '"]');
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(child, cement, "");
        }
    }
    cb_status(status) {
        if (status == "loading") {
            var table = document.getElementById(this.brick_id);
            if (table) {
                table.innerHTML = "";
                var self = this;
                setTimeout(function() {
                    self.render_skeleton();
                }, 0);
            }
            var footer = document.getElementById(this.brick_id + "$footer");
            if (footer) footer.style.visibility = "hidden";
        } else {
            var footer1 = document.getElementById(this.brick_id + "$footer");
            if (footer1) footer1.style.visibility = "visible";
            var table1 = document.getElementById(this.brick_id);
            if (table1) table1.classList.remove("cd-table-skeleton");
            var search = document.getElementById(this.brick_id + "$search");
            if (search) search.classList.remove("cd-table-search-skeleton");
        }
    }
    render_skeleton() {
        var skeleton_cols = 0;
        var skeleton_rows = 6;
        if (this.blueprint.ins && this.blueprint.ins.cfg) {
            if (this.blueprint.ins.cfg.rows) skeleton_cols += this.blueprint.ins.cfg.rows.length;
            if (this.blueprint.ins.cfg.columns) skeleton_cols += this.blueprint.ins.cfg.columns.length;
            if (this.blueprint.ins.cfg.data_columns) skeleton_cols += this.blueprint.ins.cfg.data_columns.length;
        }
        var html = "<tr>";
        for(var i = 0; i < skeleton_cols; i++)html += "<th><div></div></th>";
        html += "</tr>";
        for(var r = 0; r < skeleton_rows; r++){
            html += "<tr>";
            for(var i1 = 0; i1 < skeleton_cols; i1++)html += "<td><div></div></td>";
            html += "</tr>";
        }
        var table = document.getElementById(this.brick_id);
        if (table) {
            table.innerHTML = html;
            table.classList.add("cd-table-skeleton");
        }
        var search = document.getElementById(this.brick_id + "$search");
        if (search) search.classList.add("cd-table-search-skeleton");
    }
    drawTable() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var table, data_total_column, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, dac, no_totals, no_pivot_col_names, html;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.flush_dynamic();
                        _this.numrows = 0;
                        table = document.getElementById(_this.brick_id);
                        if (!(_this.treedata && _this.rows && _this.treedata.pivotHeaders)) return [
                            3,
                            3
                        ];
                        data_total_column = false;
                        if (_this.cfg.data_aggregate_columns && _this.cfg.data_aggregate_columns.length > 0) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = _this.cfg.data_aggregate_columns[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    dac = _step.value;
                                    if (dac.type == "Sum") data_total_column = true;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        no_totals = _this.cfg && _this.cfg.table && _this.cfg.table.no_totals;
                        no_pivot_col_names = _this.cfg && _this.cfg.table && _this.cfg.table.no_pivot_col_names;
                        html = _this.treeToHtmlTableP(_this.treedata.tree, _this.rows, _this.treedata.pivotHeaders, !no_pivot_col_names, data_total_column, false, _this.page_size, no_totals, false, _this.cfg && _this.cfg.table && _this.cfg.table.expander_on_single_childs ? _this.cfg.table.expander_on_single_childs : 0);
                        if (table) table.innerHTML = html;
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(_this.dc_data)
                        ];
                    case 1:
                        _state.sent();
                        _this.pages = Math.ceil(_this.numrows / _this.page_size);
                        return [
                            4,
                            _this.pager.setPages(_this.numrows, _this.page_size, _this.page)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        if (table) table.innerHTML = _this.blueprint.ins.cfg.empty_table_message || "No entries.";
                        return [
                            4,
                            _this.pager.setPages(0, _this.page_size, 0)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    setEventHandlers() {
        var self = this;
        var drill_elements = document.getElementsByClassName("cd-pivot-table-drill-" + this.ci_idx);
        for(var i = 0; i < drill_elements.length; i++)drill_elements[i].addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
            var branch, s, node, i;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        branch = this.getAttribute("data-branch");
                        s = branch.split("d");
                        if (!self.treedata) return [
                            3,
                            2
                        ];
                        node = self.treedata.tree;
                        for(i = 0; i < s.length; i++)node = node.children[s[i]];
                        if (!node) return [
                            3,
                            2
                        ];
                        node.open = !node.open;
                        return [
                            4,
                            self.drawTable()
                        ];
                    case 1:
                        _state.sent();
                        self.setEventHandlers();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        }), false);
    }
    cb_pager_evt(goto_page) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.page = goto_page;
                        _this.start_row = _this.page * _this.page_size;
                        _this.end_row = (_this.page + 1) * _this.page_size;
                        return [
                            4,
                            _this.drawTable()
                        ];
                    case 1:
                        _state.sent();
                        _this.setEventHandlers();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    treeToHtmlTableP(root, rows, pivotHeaders, ShowTopHeader, showDataTotalCol, showDataTrend, rowsPerPage, NoTotals, flatTable, ExpandSingleChilds) {
        var ncs = 3;
        if (!ShowTopHeader) ncs = 2;
        var row2empty = true;
        for(var ph = 0; ph < pivotHeaders.length; ph++)if (pivotHeaders[ph].cc) {
            row2empty = false;
            break;
        }
        if (row2empty) ncs--;
        var totalthclass = NoTotals ? "" : "top-total-th";
        root.atrow = 0;
        var html = "<thead><tr>";
        var has_data_cols = this.cfg.data_columns && this.cfg.data_columns.length > 0;
        for(var r = 0; r < root.rowskeys.length; r++){
            var grandtotal = NoTotals || !has_data_cols ? "" : '<div class="viz_top_total">' + (r == 0 ? "&nbsp;" : "&nbsp;") + "</div>";
            html += '<th rowspan="' + ncs + '" class="' + totalthclass + '">' + (root.rowskeys[r].rename || root.rowskeys[r].col) + grandtotal + "</th>";
        }
        var totalTotal = 0;
        if (showDataTotalCol) for(var ph = 0; ph < pivotHeaders.length; ph++)totalTotal += root.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc];
        if (ShowTopHeader) {
            html += this.csths(pivotHeaders, "col");
            html += this.totalAndTrendHeaders(ncs, showDataTotalCol, showDataTrend, totalTotal, flatTable, "");
            html += "</tr><tr>";
        }
        if (!row2empty) {
            html += this.csths(pivotHeaders, "cc");
            if (!ShowTopHeader) html += this.totalAndTrendHeaders(ncs, showDataTotalCol, showDataTrend, totalTotal, flatTable, pivotHeaders[0].frmt);
            html += "</tr><tr>";
        }
        for(var ph = 0; ph < pivotHeaders.length; ph++)if (NoTotals) {
            if (flatTable) html += "<th>" + (pivotHeaders[ph].ren || pivotHeaders[ph].dc) + "</th>";
            else html += "<th>" + (pivotHeaders[ph].ren || pivotHeaders[ph].dc) + "</th>";
        } else {
            var totalstr = this.vizformat(this.limitdecimals(root.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc]), pivotHeaders[ph].frmt);
            var totalstrlen = totalstr.toString().length * 1.5;
            var headingstr = (pivotHeaders[ph].ren || pivotHeaders[ph].dc).replace(" ", "&nbsp;");
            var headingstrlen = headingstr.length;
            if (totalstrlen > headingstrlen) for(var x = 0; x < totalstrlen - headingstrlen + 2; x++)headingstr += "&nbsp;";
            if (flatTable) html += "<th class='top-total-th'>" + headingstr + "<div class='viz_top_total'>" + totalstr + "&nbsp;</div></th>";
            else html += "<th class='top-total-th sorting_'>" + headingstr + "<div class='viz_top_total'>" + totalstr + "&nbsp;</div></th>";
        }
        if (!ShowTopHeader && row2empty) html += this.totalAndTrendHeaders(ncs, showDataTotalCol, showDataTrend, totalTotal, flatTable, "");
        html += "</tr></thead><tbody>";
        var bp = "";
        for(var n = 0; n < root.children.length; n++)html += this.drawRowsP(root, root.children[n], pivotHeaders, 0, n + "", showDataTotalCol, showDataTrend, rowsPerPage, flatTable, ExpandSingleChilds);
        html += "</tbody>";
        return html;
    }
    totalAndTrendHeaders(ncs, showDataTotalCol, showDataTrend, totalTotal, flatTable, frmt) {
        var ret = "";
        if (showDataTotalCol) {
            if (flatTable) ret += '<th rowspan="' + ncs + '"  class="top-total-th">Total<div class="viz_top_total">' + this.vizformat(this.limitdecimals(totalTotal), frmt) + "</div></th>";
            else ret += '<th onclick="' + this.brick_id + '.flatView()" rowspan="' + ncs + '"  class="top-total-th">Total<div class="viz_top_total">' + this.vizformat(this.limitdecimals(totalTotal), frmt) + "</div></th>";
        }
        if (showDataTrend) ret += '<th rowspan="' + ncs + '"  class="top-total-th">Trend<div class="viz_top_total">&nbsp;</div></th>';
        return ret;
    }
    csths(pivotHeaders, valname) {
        if (!this.cols || this.cols.length == 0) return "";
        var ret = "";
        var cs = [];
        for(var ph = 0; ph < pivotHeaders.length; ph++)if (ph == 0 || cs[cs.length - 1].key != pivotHeaders[ph][valname]) cs.push({
            key: pivotHeaders[ph][valname],
            s: 1
        });
        else cs[cs.length - 1].s++;
        for(var c = 0; c < cs.length; c++){
            var val = cs[c].key || "";
            var uspos = val.toString().indexOf("_");
            if (uspos != -1) val = val.substring(uspos + 1);
            ret += "<th colspan='" + cs[c].s + "'>" + val + "</th>";
        }
        return ret;
    }
    drawRowsP(root, node, pivotHeaders, at, bp, showDataTotalCol, showDataTrend, rowsPerPage, flatTable, ExpandSingleChilds) {
        var at1 = 0;
        var html = "<tr>";
        var rows = root.rowskeys;
        var leafVals = "";
        while(at1 < rows.length){
            var is_continuation = at1 < at && root.atrow % rowsPerPage == 0;
            var child = "";
            var val = node.tval;
            if (at1 == at || is_continuation) {
                if (node.format) val = this.vizformat(val, node.format);
                var column = rows[at1].col;
                child = this.makeChild(node.idx, column, val);
            }
            if (at1 == at) {
                if (node.children) {
                    if (node.children.length > 1 || ExpandSingleChilds > at && node.children.length == 1) {
                        if (flatTable) leafVals += "<td>" + (child || val) + "</td>";
                        else if (is_continuation) html += "<td class='pt-continue'>..." + (child || val) + "</td>";
                        else html += "<td>" + (child || val) + "</td>";
                        rows[at1].val = val;
                    } else {
                        if (flatTable) leafVals += "<td>" + (child || val) + "</td>";
                        else if (is_continuation) html += "<td class='pt-continue'>..." + (child || val) + "</td>";
                        else html += "<td>" + (child || val) + "</td>";
                        rows[at1].val = val;
                        node = node.children[0];
                        bp = bp + "d" + 0;
                        at++;
                    }
                } else html += leafVals + "<td>" + (child || val) + "</td>";
            } else {
                if (flatTable) {
                    if (!node.children) html += leafVals + "<td>" + rows[at1].val + "</td>";
                    else if (node.children.length == 1) leafVals += "<td>" + rows[at1].val + "</td>";
                } else if (at1 < at) {
                    if (root.atrow % rowsPerPage == 0) html += "<td class='pt-continue'>..." + (child || rows[at1].val) + "</td>";
                    else html += "<td class='pt-empty'></td>";
                } else if (at1 == at + 1) html += "<td class='pt-expand'><span></span><span data-branch='" + bp + "' " + (node.open ? " class='cd-pivot-table-drill cd-pivot-table-drill-closed cd-pivot-table-drill-" + this.ci_idx + " '></span> " : " class='cd-pivot-table-drill cd-pivot-table-drill-open cd-pivot-table-drill-" + this.ci_idx + " '></span> ") + "</td>";
                else html += "<td class='pt-through'></td>";
            }
            at1++;
        }
        var total = 0;
        var sumclass = "class='td-num'";
        for(var ph = 0; ph < pivotHeaders.length; ph++){
            if (node.children) {
                sumclass = "class='pt-sum'";
                if (flatTable) continue;
            }
            var child1 = "";
            var val1 = this.vizformat(node.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc], pivotHeaders[ph].frmt);
            var column1 = pivotHeaders[ph].col;
            child1 = this.makeChild(node.idx + ph + 1, column1, val1);
            html += "<td " + sumclass + ">" + (child1 || val1) + "</td>";
            if (showDataTotalCol) total += node.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc];
        }
        if (showDataTotalCol && html != "<tr>") html += "<td " + sumclass + ">" + this.vizformat(this.limitdecimals(total), pivotHeaders[0].frmt) + "</td>";
        html += "</tr>";
        if (html == "<tr></tr>") html = "";
        root.atrow++;
        this.numrows++;
        if (this.numrows <= this.start_row || this.numrows > this.end_row) html = "";
        if (node.children && (node.open || flatTable)) for(var c = 0; c < node.children.length; c++)html += this.drawRowsP(root, node.children[c], pivotHeaders, at + 1, bp + "d" + c, showDataTotalCol, showDataTrend, rowsPerPage, flatTable, ExpandSingleChilds);
        return html;
    }
    makeChild(dc_idx, column, val) {
        var child = "";
        if (this.blueprint.contains) {
            var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
            var child_dc = dc_root + (0, _cbutil.DC_JOIN) + dc_idx;
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var cement = this.cements[i] || sub.cement;
                    if (cement && cement.column == column) {
                        if (cement.value == "before") child += val;
                        var hidden = cement && cement.hidden ? ` class="hidden"` : "";
                        var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i, child_dc);
                        child += brick;
                        if (sub.cement.value == "after") child += val;
                    }
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return child;
    }
    limitdecimals(val) {
        return val;
    }
    vizformat(num, format) {
        var _a;
        return (0, _cbformatting.codebricks_format)(num, format, (_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options).value;
    }
    cb_snapshot() {
        var snapshot = {};
        var search = document.getElementById(this.brick_id + "$search");
        if (search) {
            var search_term = search.value;
            if (search_term) (0, _sugarDefault.default).Object.set(snapshot, "cfg.table.search.value", search_term);
        }
        return snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.data = [];
        this.page = 0;
        this.page_size = 8;
        this.pages = 1;
        this.treedata = null;
        this.numrows = 0;
        this.start_row = 0;
        this.end_row = 20;
        this.initialized = false;
        this.dc_data = [];
        this.expander_on_single_childs = 0;
        this.cements = {};
        this.element = element;
        this.cfg = this.blueprint.ins ? this.blueprint.ins.cfg : {};
        this.cfg.table = this.cfg.table || {};
        var search = "";
        if (!this.cfg.table || this.cfg.table && !this.cfg.table.search || this.cfg.table && this.cfg.table.search) search = `<div class="cd-table-search-container${this.cfg.table.search.hidden || this.context.platform == "file" && !this.cfg.table.search.value ? " hidden" : ""}"><input type="text" spellcheck="false" id="${this.brick_id + "$search"}" placeholder="${this.cfg.table && this.cfg.table.search && this.cfg.table.search.label ? this.cfg.table.search.label : "Search"}" class="form-element cd-table-search" /><span class="cd-table-search-close" id="${this.brick_id + "$search_close"}"></span></div>`;
        var title = `<h2 class="cd-table-title hidden" id="${this.brick_id + "$title"}"></h2>`;
        var html = `<div class="cd-table-header"><div><div id="${this.brick_id + "$header"}" class="hidden"></div>` + search + "</div>" + title + `</div>
                    <div id="${this.brick_id}$container" class="cd-table-container">`;
        html += `<table id="${this.brick_id}" class="cd-table"></table>`;
        html += `<div id="${this.brick_id}$empty" class="empty-state cd-table-empty"></div></div>
                    <div id="${this.brick_id + "$footer"}" class="cd-table-footer ${this.cfg.table.no_pager || this.context.platform == "file" ? "hidden" : ""}"></div>`;
        this.element.innerHTML = html;
        var self = this;
        this.pager = new (0, _cbPager.cb_pager)(this.brick_id + "$footer", {}, function() {
            var _ref = (0, _asyncToGenerator._)(function(value) {
                return (0, _tsGenerator._)(this, function(_state) {
                    self.cb_pager_evt(value);
                    return [
                        2
                    ];
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBFormatting":"TabN7","../../codebricks-runtime/CodeBrick":"junyG","../controls/cb_pager":"dC2Kp","../../shared-funcs/PivotTable":"esihi","sugar":"gcIJ7","../controls/cb_web_util":"jCKPs","../../codebricks-runtime/CBUtil":"1DxvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"esihi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PivotTable", ()=>PivotTable);
var _cbformatting = require("../codebricks-runtime/CBFormatting");
var PivotTable = /** @class */ function() {
    function PivotTable() {}
    PivotTable.dataToTreeP = function(data, rows, cols, dataCols, openlevel, searchTerm, DontOrderDataCols, system_options, no_format, dont_sort_nodes) {
        if (no_format === void 0) no_format = false;
        if (dont_sort_nodes === void 0) dont_sort_nodes = false;
        if (!data) return null;
        if (data.length == 0) return data;
        var pivotHeaders = [];
        for(var c = 0; c < cols.length; c++){
            var col = cols[c];
            var colcols = [];
            for(var r = 0; r < data.length; r++){
                var col_val = data[r][col.column];
                var formatted_col_val = no_format ? col_val : (0, _cbformatting.codebricks_format)(col_val, col.format, system_options || {}).value;
                data[r][col.column] = formatted_col_val;
                if (DontOrderDataCols) this.addDistinct(colcols, formatted_col_val);
                else this.addDistinctOrdered(colcols, formatted_col_val);
            }
            for(var cc = 0; cc < colcols.length; cc++)for(var d = 0; d < dataCols.length; d++)//pivotHeaders.push({ col: cols[c], cc: colcols[cc], dc: dataCols[d].col, tmpl: dataCols[d].template ? (dataCols[d].template.replace("{{"+dataCols[d].col+"}}", "<<"+dataCols[d].col+">>")) : "" });
            pivotHeaders.push({
                col: cols[c].column,
                cc: colcols[cc],
                dc: dataCols[d].col,
                ren: dataCols[d].rename,
                frmt: dataCols[d].format,
                col_format: cols[c].format
            });
        }
        if (cols.length == 0) for(var d = 0; d < dataCols.length; d++)pivotHeaders.push({
            col: null,
            cc: undefined,
            dc: dataCols[d].col,
            ren: dataCols[d].rename,
            frmt: dataCols[d].format,
            col_format: cols[c] !== undefined ? cols[c].format : ""
        });
        var root = {
            key: "root",
            val: "All",
            children: [],
            rowskeys: [],
            vals: {}
        };
        //root.rowskeys = [] as PivotTreeNode[];
        //root.vals = {};
        for(var ph = 0; ph < pivotHeaders.length; ph++)root.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc] = 0;
        var row0keys = Object.keys(data[0]);
        for(var r = 0; r < rows.length; r++)if (isNaN(rows[r].col)) root.rowskeys.push(rows[r]);
        else root.rowskeys.push({
            col: row0keys[rows[r].col],
            rename: rows[r].rename,
            format: rows[r].format,
            val: ""
        });
        //console.log("pivotHeaders: "+JSON.stringify(pivotHeaders));
        var searchlc;
        if (searchTerm) searchlc = searchTerm.toLowerCase();
        for(var r = 0; r < data.length; r++){
            var rowBranch = this.getRowBranchP(data[r], rows);
            var inSearch = this.getAddBranchP(root, rowBranch, pivotHeaders, data[r], 0, openlevel, root.rowskeys, searchlc, r, dont_sort_nodes);
            for(var ph = 0; ph < pivotHeaders.length && inSearch; ph++)if (data[r][pivotHeaders[ph].col] == pivotHeaders[ph].cc) //console.log(pivotHeaders[ph].col+"~"+pivotHeaders[ph].cc+"~"+pivotHeaders[ph].dc +" " +root.vals[pivotHeaders[ph].col+"~"+pivotHeaders[ph].cc+"~"+pivotHeaders[ph].dc]+" += "+data[r][pivotHeaders[ph].dc]);
            root.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc] += data[r][pivotHeaders[ph].dc];
        }
        //console.log("tree: "+JSON.stringify(root));
        //this.treeToDCData(root, pivotHeaders);
        return {
            tree: root,
            pivotHeaders: pivotHeaders
        };
    };
    PivotTable.getRowBranchP = function(row, rows) {
        var ret = [];
        var rowkeys = Object.keys(row);
        for(var k = 0; k < rows.length; k++)if (isNaN(rows[k].col)) ret.push(row[rows[k].col] || "");
        else ret.push(row[rowkeys[rows[k].col]] || "");
        return ret;
    };
    PivotTable.getAddBranchP = function(node, branch, pivotHeaders, row, at, openlevel, rows, searchTerm, data_idx, dont_sort_nodes) {
        if (searchTerm) {
            var searchfound = false;
            for(var b = 0; b < branch.length; b++)if (branch[b].toString().toLowerCase().indexOf(searchTerm) != -1) {
                searchfound = true;
                break;
            }
            if (!searchfound) return false;
        }
        var found = null;
        for(var i = 0; i < node.children.length; i++)if (node.children[i].val == branch[at]) found = node.children[i];
        if (found == null) {
            var tval = branch[at];
            // if(rows[at].template) {
            //     tval = Handlebars.render(rows[at].template, row);
            // }
            if (at < branch.length - 1) found = {
                val: branch[at],
                tval: tval,
                vals: {},
                tvals: {},
                children: [],
                open: at < openlevel,
                idx: data_idx,
                format: rows[at].format
            };
            else found = {
                val: branch[at],
                tval: tval,
                vals: {},
                tvals: {},
                open: at < openlevel,
                idx: data_idx,
                format: rows[at].format
            };
            var spliced = false;
            if (!dont_sort_nodes) {
                for(var i = 0; i < node.children.length; i++)if (found.val < node.children[i].val) {
                    node.children.splice(i, 0, found);
                    spliced = true;
                    break;
                }
            }
            if (!spliced) node.children.push(found);
            for(var ph = 0; ph < pivotHeaders.length; ph++)if (row[pivotHeaders[ph].col] == pivotHeaders[ph].cc) found.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc] = row[pivotHeaders[ph].dc];
            else found.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc] = 0;
        } else {
            for(var ph = 0; ph < pivotHeaders.length; ph++)if (row[pivotHeaders[ph].col] == pivotHeaders[ph].cc) found.vals[pivotHeaders[ph].col + "~" + pivotHeaders[ph].cc + "~" + pivotHeaders[ph].dc] += row[pivotHeaders[ph].dc];
        }
        if (at < branch.length - 1) this.getAddBranchP(found, branch, pivotHeaders, row, at + 1, openlevel, rows, searchTerm, data_idx, dont_sort_nodes);
        return true;
    };
    //cut n paste from v2
    PivotTable.groupData = function(data, groupcols, countcols, sumcols) {
        var groupDict = {};
        for(var r = 0; r < data.length; r++){
            var group = "";
            for(var g = 0; g < groupcols.length; g++)group += data[r][groupcols[g]] + "^";
            var grouprow = groupDict[group];
            if (!grouprow) {
                grouprow = {};
                for(var g = 0; g < groupcols.length; g++)grouprow[groupcols[g]] = data[r][groupcols[g]];
                if (countcols) for(var c = 0; c < countcols.length; c++)grouprow[countcols[c]] = 1;
                if (sumcols) for(var s = 0; s < sumcols.length; s++)grouprow[sumcols[s]] = data[r][sumcols[s]];
                groupDict[group] = grouprow;
            } else {
                if (countcols) for(var c = 0; c < countcols.length; c++)grouprow[countcols[c]]++;
                if (sumcols) for(var s = 0; s < sumcols.length; s++)grouprow[sumcols[s]] += data[r][sumcols[s]];
            }
        }
        var keys = Object.keys(groupDict);
        var ret = [];
        for(var k = 0; k < keys.length; k++)ret.push(groupDict[keys[k]]);
        return ret;
    };
    //cut n paste from v2
    PivotTable.dataCol = function(col, dataCols, d, multiHeader) {
        if (dataCols.length == 1 && !multiHeader) return col; //dataCols[0];
        return col + "_" + dataCols[d];
    };
    //cut n paste from v2
    PivotTable.pivotData = function(data, row, col, dataCols, multiHeader) {
        if (data.length == 0) return data;
        var pivotCols = [];
        for(var r_1 = 0; r_1 < data.length; r_1++)for(var d = 0; d < dataCols.length; d++)this.addDistinctOrdered(pivotCols, this.dataCol("" + data[r_1][col], dataCols, d, multiHeader));
        var ret = [];
        var atRow = "-1";
        var r = null;
        var keys = Object.keys(data[0]);
        for(var dr = 0; dr < data.length; dr++){
            var drow = data[dr];
            var rowAdded = false;
            if (drow[row] != atRow) {
                r = this.findRow(ret, row, drow[row]);
                if (r == null) {
                    r = {};
                    atRow = drow[row];
                    for(var k = 0; k < keys.length; k++){
                        var dc = false;
                        for(var d = 0; d < dataCols.length; d++)if (keys[k] == dataCols[d]) {
                            dc = true;
                            break;
                        }
                        if (dc) continue;
                        if (keys[k] != col) r[keys[k]] = drow[keys[k]] || "";
                    }
                    for(var pc = 0; pc < pivotCols.length; pc++){
                        var set = false;
                        for(var d = 0; d < dataCols.length; d++)if (pivotCols[pc] == this.dataCol(drow[col], dataCols, d, multiHeader)) {
                            r[pivotCols[pc]] = drow[dataCols[d]] ? drow[dataCols[d]] : 0;
                            set = true;
                        }
                        if (!set) r[pivotCols[pc]] = 0;
                    }
                    ret.push(r);
                    rowAdded = true;
                } else atRow = drow[row];
            }
            if (!rowAdded) for(var d = 0; d < dataCols.length; d++)r[this.dataCol(drow[col], dataCols, d, multiHeader)] = r[this.dataCol(drow[col], dataCols, d, multiHeader)] + drow[dataCols[d]];
        }
        //console.log("pivoted: "+JSON.stringify(ret));
        return ret;
    };
    //cut n paste from v2
    PivotTable.findRow = function(data, colname, value) {
        for(var r = 0; r < data.length; r++){
            if (data[r][colname] == value) return data[r];
        }
        return null;
    };
    PivotTable.addDistinctOrdered = function(list, v) {
        for(var i = 0; i < list.length; i++){
            if (v == list[i]) return;
            if (this.compareMaybeDate(v, list[i])) {
                list.splice(i, 0, v);
                return;
            }
        }
        list.push(v);
    };
    PivotTable.compareMaybeDate = function(v1, v2) {
        //check if date in form MMM-YY
        if (!v1) v1 = "";
        if (!v2) v2 = "";
        // if (v1.length == 6 && v2.length == 6 && v1[3] == '-' && v2[3] == '-') {
        //     return moment(v1, "MMM-YY") < moment(v2, "MMM-YY");
        // }
        return v1 < v2;
    };
    PivotTable.addDistinct = function(list, v) {
        for(var i = 0; i < list.length; i++){
            if (v == list[i]) return;
        }
        list.push(v);
    };
    PivotTable.orderTree = function(tree, pivotHeaders, orderPHIdx) {
        var val = pivotHeaders[orderPHIdx].col + "~" + pivotHeaders[orderPHIdx].cc + "~" + pivotHeaders[orderPHIdx].dc;
        this.orderChildren(tree, val);
    };
    PivotTable.orderChildren = function(node, val) {
        node.children.sort(function(a, b) {
            return b.vals[val] - a.vals[val];
        });
        for(var c = 0; c < node.children.length; c++)if (node.children[c].children) this.orderChildren(node.children[c], val);
    };
    return PivotTable;
}();

},{"../codebricks-runtime/CBFormatting":"TabN7","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"7dh2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_table_webcomponent", ()=>cd_table_webcomponent);
parcelHelpers.export(exports, "web_cd_table", ()=>web_cd_table);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbformatting = require("../../codebricks-runtime/CBFormatting");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _tagItemParser = require("../../codebricks-runtime/TagItemParser");
var _tagItemResolver = require("../../codebricks-runtime/TagItemResolver");
var _util = require("../../shared-funcs/Util");
var _cbPager = require("../controls/cb_pager");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var _cbWebUtil = require("../controls/cb_web_util");
class cd_table_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cd_table(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-table", cd_table_webcomponent);
class web_cd_table extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var title_element, outer, table, search, header, title, source_dc, this_dc_len, source_dc_split, roidx, idx, before, after;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            2
                        ];
                        _this.page_size = cfg.table && cfg.table.page_size !== undefined ? Number(cfg.table.page_size) : _this.page_size;
                        if (_this.data && cfg.data && _this.data.length != cfg.data.length) _this.page = 0;
                        title_element = document.getElementById(_this.brick_id + "$title");
                        if (title_element) {
                            if (cfg.table && cfg.table.title) {
                                title_element.innerHTML = cfg.table.title;
                                title_element.classList.remove("hidden");
                            } else title_element.classList.add("hidden");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(title_element, cfg.table, "title");
                        }
                        _this.data = cfg.data || [];
                        _this.cfg = cfg;
                        _this.may_stack = cfg.table && cfg.table.responsive;
                        _this.responsive = _this.may_stack;
                        outer = document.getElementById(_this.brick_id + "$outer");
                        if (outer) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(outer, cfg.table, "outer");
                        table = document.getElementById(_this.brick_id);
                        if (table) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(table, cfg.table, "table");
                        search = document.getElementById(_this.brick_id + "$search");
                        if (search) {
                            if (_this.cfg.table && _this.cfg.table.search && (_this.cfg.table.search.value != _this.initial_search || _this.cfg.table.search.value == "")) {
                                search.value = _this.cfg.table.search.value === undefined ? "" : _this.cfg.table.search.value;
                                _this.initial_search = _this.cfg.table.search.value;
                                if (_this.cfg.table.search.focus) search.focus();
                            }
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(search, cfg.table, "search");
                        }
                        header = document.getElementById(_this.brick_id + "$header");
                        if (header) {
                            header.classList.remove("hidden");
                            (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(header, cfg.table, "header");
                        }
                        title = document.getElementById(_this.brick_id + "$title");
                        if (title) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(title, cfg.table, "title");
                        return [
                            4,
                            _this.render_data()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if (input == "rowdata") {
                            if (info.source_brick_id) {
                                source_dc = _this.context.bricks[info.source_brick_id].dc;
                                this_dc_len = _this.dc ? _this.dc.split((0, _cbutil.DC_JOIN)).length : 0;
                                source_dc_split = source_dc.split((0, _cbutil.DC_JOIN));
                                roidx = Number(source_dc_split[this_dc_len + 2]);
                                idx = roidx + _this.page * _this.page_size;
                                before = JSON.stringify(_this.data[idx]);
                                (0, _cbutil.ObjectDeepMerge)(_this.data[idx], cfg);
                                after = JSON.stringify(_this.data[idx]);
                                console.log("rowdata " + idx + " : " + JSON.stringify(cfg));
                                if (before != after) {
                                    _this.cb_emit({
                                        "@": _this.data[idx]
                                    }, source_dc);
                                    _this.cb_emit({
                                        "@rowdata": _this.data
                                    });
                                }
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {
        this.cements = cements;
        var header_contained = "";
        var footer_contained = "";
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var cement = cements[i] || sub.cement;
                    if (!cement || !cement.column || cement.column == "header") {
                        var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i, this.dc || "");
                        header_contained += brick;
                    }
                    if (cement && cement.column == "footer") {
                        var brick1 = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i, this.dc || "");
                        footer_contained += brick1;
                    }
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (header_contained) {
            var header = document.getElementById(this.brick_id + "$header");
            if (header) header.innerHTML = header_contained;
        }
        if (footer_contained) {
            var footer = document.getElementById(this.brick_id + "$footer_content");
            if (footer) footer.innerHTML = footer_contained;
        }
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
        var child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
        var child = this.element.querySelector('td [dc="' + child_dc + '"][idx="' + child_idx + '"][container_id="' + this.brick_id + '"]');
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
        }
    }
    render_data() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var search_term, search, search_close, self, columns, search_data, colnames, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, d, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, k, col_names, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, c1, format, align, idx, sort_name, colid, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, col, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator5, _step5, row, _iterator6, _step6, t, n, display_data, footer, page_start, page_end, i, self1, colid1, col_header;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.flush_dynamic();
                        search_term = "";
                        search = document.getElementById(_this.brick_id + "$search");
                        if (search) {
                            search_term = search.value;
                            if (search_term) search.classList.add("cd-table-search-active");
                            else search.classList.remove("cd-table-search-active");
                            search_close = document.getElementById(_this.brick_id + "$search_close");
                            if (search_close) {
                                search_close.style.display = search_term == "" ? "none" : "inline-block";
                                if (!_this.initialized) {
                                    self = _this;
                                    search_close.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                                        var search, search_term;
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    search = document.getElementById(self.brick_id + "$search");
                                                    search_term = search.value;
                                                    if (!search_term) return [
                                                        3,
                                                        2
                                                    ];
                                                    search.value = "";
                                                    return [
                                                        4,
                                                        self.render_data()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }));
                                }
                            }
                        }
                        columns = _this.cfg.columns;
                        search_data = [];
                        if (search_term) {
                            search_term = search_term.toLowerCase();
                            colnames = [];
                            if (columns && columns.length > 0) {
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = columns[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        c = _step.value;
                                        if (c) colnames.push(c.column);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            } else if (_this.data && _this.data.length > 0) colnames = Object.keys(_this.data[0]);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = _this.data[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    d = _step1.value;
                                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(_iterator2 = colnames[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            k = _step2.value;
                                            if (String(d[k]).toLowerCase().indexOf(search_term) != -1) {
                                                search_data.push(d);
                                                break;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                _iterator2.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        } else search_data = _this.data;
                        if (_this.cfg.table) {
                            if (_this.cfg.table.sort_col_idx !== null && _this.cfg.table.sort_col_idx !== undefined && _this.cfg_sort_col_idx != _this.cfg.table.sort_col_idx) {
                                _this.cfg_sort_col_idx = _this.cfg.table.sort_col_idx;
                                _this.sort_col_idx = _this.cfg.table.sort_col_idx;
                            }
                            if (_this.cfg.table.sort_dir !== null && _this.cfg.table.sort_dir !== undefined && _this.cfg_sort_dir != _this.cfg.table.sort_dir) {
                                _this.cfg_sort_dir = _this.cfg.table.sort_dir;
                                _this.sort_dir = _this.cfg.table.sort_dir;
                            }
                        }
                        if (!columns || columns.length == 0) {
                            columns = [];
                            if (search_data && search_data.length > 0 && search_data[0]) {
                                col_names = Object.keys(search_data[0]);
                                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                try {
                                    for(_iterator3 = col_names[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                        c1 = _step3.value;
                                        format = typeof search_data[0][c1];
                                        align = "";
                                        if (format == "boolean") {
                                            format = "Bool.toYesNo()";
                                            align = "center";
                                        } else if (!isNaN(search_data[0][c1])) {
                                            if (_this.cfg.default_formats && _this.cfg.default_formats.number) format = _this.cfg.default_formats.number || "Number";
                                        } else if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/.test(search_data[0][c1])) {
                                            if (_this.cfg.default_formats && _this.cfg.default_formats.date) format = _this.cfg.default_formats.date || "Date";
                                        }
                                        columns.push({
                                            column: c1,
                                            format: format,
                                            align: align
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                            _iterator3.return();
                                        }
                                    } finally{
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                            }
                        }
                        if ((_this.sort_col_idx || _this.sort_col_idx === 0) && search_data && search_data.length > 0) {
                            idx = 0;
                            sort_name = null;
                            for(var colid in columns){
                                if (idx == _this.sort_col_idx) {
                                    sort_name = columns[colid].column;
                                    break;
                                }
                                idx++;
                            }
                            if (sort_name !== null) {
                                search_data = (0, _cbutil.Clone)(search_data);
                                search_data.sort((a, b)=>{
                                    if (sort_name !== null) {
                                        var dir = _this.sort_dir == "Ascending" ? 1 : -1;
                                        if (typeof a[sort_name] == "string" && typeof b[sort_name] == "string") {
                                            if (a[sort_name].toLowerCase() == b[sort_name].toLowerCase()) return 0;
                                            return a[sort_name].toLowerCase() < b[sort_name].toLowerCase() ? -dir : dir;
                                        } else {
                                            if (a[sort_name] == b[sort_name]) return 0;
                                            return a[sort_name] < b[sort_name] ? -dir : dir;
                                        }
                                    }
                                    return 0;
                                });
                            }
                        }
                        _this.col_totals = [];
                        _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        try {
                            for(_iterator4 = columns[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                col = _step4.value;
                                if (col && col.total) _this.col_totals.push({
                                    col: col.column,
                                    total: 0,
                                    format: col.format
                                });
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                    _iterator4.return();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                        if (_this.col_totals.length > 0) {
                            _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined, _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                            try {
                                for(_iterator5 = search_data[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion6 = true){
                                    row = _step5.value;
                                    try {
                                        for(_iterator6 = _this.col_totals[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion5 = true){
                                            t = _step6.value;
                                            n = row[t.col];
                                            if (!isNaN(n)) t.total += Number(n);
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator6.return != null) {
                                                _iterator6.return();
                                            }
                                        } finally{
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator5.return != null) {
                                        _iterator5.return();
                                    }
                                } finally{
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        }
                        display_data = [];
                        return [
                            4,
                            _this.pager.setPages(search_data.length, _this.page_size, _this.page)
                        ];
                    case 1:
                        _state.sent();
                        footer = document.getElementById(_this.brick_id + "$footer");
                        if (footer) {
                            if (_this.context.platform == "file" || _this.cfg.table.no_pager || search_data.length == 0) footer.classList.add("hidden");
                            else footer.classList.remove("hidden");
                        }
                        page_start = 0;
                        page_end = search_data.length || Object.keys(search_data).length;
                        _this.pages = Math.ceil(search_data.length / _this.page_size);
                        if (_this.page_size > 0) {
                            page_start = _this.page * _this.page_size;
                            page_end = page_start + _this.page_size;
                            if (page_end > search_data.length) page_end = search_data.length;
                        }
                        if (_this.context.platform == "file") display_data = search_data;
                        else for(i = page_start; i < page_end; i++)display_data.push(search_data[i]);
                        _this.visible_data = display_data;
                        if (_this.responsive) _this.render_responsive_table(columns, display_data);
                        else _this.render_table(columns, display_data);
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(display_data)
                        ];
                    case 2:
                        _state.sent();
                        if (!_this.cfg.table || !_this.cfg.table.no_sort) {
                            self1 = _this;
                            for(var colid1 in columns)if (columns[colid1] && !columns[colid1].hidden && !columns[colid1].no_sort) {
                                col_header = document.getElementById(_this.brick_id + "$sort$" + colid1);
                                if (col_header) col_header.addEventListener("click", function() {
                                    var _ref = (0, _asyncToGenerator._)(function(evt) {
                                        var s, col_idx;
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    s = this.id.split("$");
                                                    col_idx = Number(s[s.length - 1]);
                                                    if (self1.sort_col_idx == col_idx) self1.sort_dir = self1.sort_dir == "Ascending" ? "Descending" : "Ascending";
                                                    self1.sort_col_idx = col_idx;
                                                    return [
                                                        4,
                                                        self1.render_data()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(evt) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            }
                        }
                        _this.initialized = true;
                        return [
                            2
                        ];
                }
            });
        })();
    }
    render_table(columns, display_data) {
        var _a, _b, _c, _d, _e, _f;
        var html = "";
        html += '<tr class="cd-table-tr">';
        var numcols = 0;
        var sort_class = "cd-table-sort-none";
        var th_sort_class = "cd-table-th-sort";
        var no_column_header = "";
        if (this.cfg.table) {
            if (this.cfg.table.no_sort) {
                sort_class = "";
                th_sort_class = "";
            }
            if (this.cfg.table.no_column_header) no_column_header = `style="display:none"`;
        }
        var num_visible_cols = 0;
        var total_fr = 0;
        for(var colid in columns)if (columns[colid] && !columns[colid].hidden) {
            num_visible_cols++;
            if (columns[colid].width_fr) total_fr += columns[colid].width_fr;
            else total_fr += 1;
        }
        for(var colid1 in columns)if (columns[colid1] && !columns[colid1].hidden) {
            var heading = typeof columns[colid1].heading != "string" || columns[colid1].heading == "" ? (0, _util.Prettyfy)(columns[colid1].column) : columns[colid1].heading;
            if (heading == " ") heading = "";
            var col_sort_class = sort_class;
            if (Number(colid1) === this.sort_col_idx && sort_class) col_sort_class = "cd-table-sort-" + this.sort_dir;
            if (columns[colid1].no_sort) col_sort_class = "";
            var number_style = "";
            if (!columns[colid1].align) {
                if (columns[colid1].format && columns[colid1].format.toLowerCase().indexOf("number") == 0) number_style += " cd-table-th-num";
                else if (display_data && Array.isArray(display_data) && display_data.length > 0) {
                    var val = display_data[0][columns[colid1].column];
                    var f = (0, _cbformatting.codebricks_format)(val, columns[colid1].format, ((_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {});
                    if (f.type == "number") number_style += " cd-table-th-num";
                }
            }
            var width = "";
            if (columns[colid1].width_fr) {
                var w = 100 / total_fr * columns[colid1].width_fr;
                width = ` width="${w}%"`;
            }
            html += `<th class="cd-table-th ${th_sort_class}${number_style}${columns[colid1].align ? " cd-table-th-" + columns[colid1].align : ""}"${width} id="${this.brick_id}$sort$${colid1}" ${no_column_header}><div class="cd-table-col"><div>` + heading + `</div><div class="${col_sort_class}"></div></div></th>`;
            numcols++;
        }
        html += "</tr>";
        if (this.col_totals.length > 0) {
            html += "<tr>";
            for(var colid2 in columns){
                var col = columns[colid2];
                if (!col || col.hidden) continue;
                var has_total = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.col_totals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ct = _step.value;
                        if (ct.col == col.column) {
                            has_total = true;
                            ct.total = ct.total || 0;
                            var align = columns[colid2].align;
                            var format = "Number";
                            if (ct.total.toFixed(2) == ct.total.toFixed(0) + ".00") format = "Number(0)";
                            var f1 = (0, _cbformatting.codebricks_format)(ct.total, ct.format || format, ((_b = this.context.composition_runners[this.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {});
                            html += ` <td class='cd-table-total${align && align != "auto" ? " text-align-" + align : ""}'>${align && align != "auto" ? `<div class="cd-table-td-${align}">` : ""}${f1.value}${align && align != "auto" ? "</div>" : ""}
                        </td>`;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!has_total) html += "<td class='cd-table-nototal'></td>";
            }
            html += "</tr>";
        }
        var row_idx = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = display_data[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var row = _step1.value;
                html += "<tr>";
                var col_idx = 0;
                for(var colid3 in columns){
                    if (columns[colid3] && !columns[colid3].hidden) {
                        var child = "";
                        var col1 = columns[colid3];
                        var val1 = row[col1.column];
                        if (val1 === undefined || val1 === null) val1 = "";
                        var format_type = "";
                        var align1 = columns[colid3].align || "auto";
                        if (this.blueprint.contains) {
                            var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
                            var child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
                            var i = 0;
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = this.blueprint.contains[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var sub = _step2.value;
                                    var cement = this.cements[i] || sub.cement;
                                    if (cement && (cement.column == col1.column || cement.column === col_idx)) {
                                        if (cement.value == "before") {
                                            var f2 = (0, _cbformatting.codebricks_format)(val1, col1.format, ((_c = this.context.composition_runners[this.cid].compos) === null || _c === void 0 ? void 0 : _c.system_options) || {});
                                            child += f2.value;
                                            format_type = f2.type;
                                        }
                                        var hidden = cement && cement.hidden ? "hidden" : "";
                                        var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i, child_dc, hidden);
                                        child += brick;
                                        if (cement.value == "after") {
                                            var f3 = (0, _cbformatting.codebricks_format)(val1, col1.format, ((_d = this.context.composition_runners[this.cid].compos) === null || _d === void 0 ? void 0 : _d.system_options) || {});
                                            child += f3.value;
                                            format_type = f3.type;
                                        }
                                    }
                                    i++;
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                        if (child === "") {
                            var f4 = (0, _cbformatting.codebricks_format)(val1, col1.format, ((_e = this.context.composition_runners[this.cid].compos) === null || _e === void 0 ? void 0 : _e.system_options) || {});
                            child = f4.value;
                            format_type = f4.type;
                        }
                        var modifier_classes = "";
                        var modifier_styles = "";
                        if (align1 && align1 != "auto") modifier_classes += "cd-table-td-" + align1 + " ";
                        if (col1.highlight_rule) {
                            var tagItem = (0, _tagItemParser.TagItemParser).ParseTagItem(col1.highlight_rule, {
                                i: 0
                            }, "}}");
                            var sod = {};
                            for(var k in row)sod[k] = {
                                "@": {
                                    d: row[k],
                                    r: 0,
                                    s: 0
                                }
                            };
                            var tir = new (0, _tagItemResolver.TagItemResolver)(sod, 0, "", "@", ((_f = this.context.composition_runners[this.cid].compos) === null || _f === void 0 ? void 0 : _f.system_options) || {});
                            var highlight = tir.ResolveTag(tagItem, 0, []);
                            if (highlight) {
                                if (highlight.startsWith("rgb") || highlight.startsWith("hsl") || highlight.startsWith("#") || highlight.startsWith("var")) modifier_styles = ` style="background-color:${highlight}" `;
                                else modifier_classes += highlight;
                            }
                        }
                        html += `<td class="cd-table-td${format_type == "number" && align1 == "auto" ? " cd-table-td-num" : ""}${align1 && align1 != "auto" ? " text-align-" + align1 + " " : ""}" ${modifier_styles}>${modifier_classes ? `<div class="${modifier_classes}">` : ""}${child}${modifier_classes ? "</div>" : ""}</td>`;
                    }
                    col_idx++;
                }
                row_idx++;
                html += "</tr>";
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var empty_element = document.getElementById(this.brick_id + "$empty");
        if (empty_element) {
            if (display_data.length == 0) {
                if (this.cfg.table) {
                    var msg = this.cfg.table.empty_table_message || "No Results";
                    empty_element.innerHTML = msg;
                    empty_element.classList.remove("hidden");
                }
            } else empty_element.classList.add("hidden");
        }
        var table = document.getElementById(this.brick_id);
        if (table) table.innerHTML = html;
    }
    render_responsive_table(columns, display_data) {
        var stacking_levels = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        var _a, _b, _c, _d;
        var numcols = 0;
        for(var colid in columns)if (!columns[colid].hidden) numcols++;
        var render_trs = false;
        var repeats = (0, _sugarDefault.default).Number.ceil(numcols / stacking_levels);
        var html = `<div id="${this.brick_id}" class="cd-table-r" style="grid-template-columns: repeat(${repeats}, minmax(auto, auto))">`;
        if (render_trs) html += '<div class="cd-table-rtr">';
        var sort_class = "cd-table-sort-none";
        var th_sort_class = "cd-table-rth-sort";
        var no_column_header = "";
        if (this.cfg.table) {
            if (this.cfg.table.no_sort) {
                sort_class = "";
                th_sort_class = "";
            }
            if (this.cfg.table.no_column_header) no_column_header = `style="display:none"`;
        }
        var col_idx = 0;
        var stack_idx = 0;
        var sl = 0;
        for(sl = 0; sl < stacking_levels; sl++){
            var col_idx1 = 0;
            var col_in_stack_row = 0;
            for(var colid1 in columns){
                var row_in_stack = stacking_levels == 1 ? 0 : col_idx1 % stacking_levels;
                if (row_in_stack == sl) {
                    if (!columns[colid1].hidden) {
                        var heading = typeof columns[colid1].heading != "string" || columns[colid1].heading == "" ? (0, _util.Prettyfy)(columns[colid1].column) : columns[colid1].heading;
                        if (heading == " ") heading = "";
                        columns[colid1].display_heading = heading;
                        var col_sort_class = columns[colid1].no_sort ? "" : sort_class;
                        if (Number(colid1) === this.sort_col_idx && sort_class && !columns[colid1].no_sort) col_sort_class = "cd-table-sort-" + this.sort_dir;
                        var row_end = "";
                        if (col_idx1 > 0 && stack_idx % repeats == repeats - 1) row_end = " cd-table-r-td-last";
                        var is_row = "";
                        if (row_in_stack == stacking_levels - 1) is_row = " cd-table-r-tr";
                        var stack_class = "";
                        if (stacking_levels > 1) stack_class = "cd-table-r-row" + sl + " ";
                        var side_classes = "";
                        if (sl == 0) side_classes += " cd-table-th-top";
                        if (sl == stacking_levels - 1) side_classes += " cd-table-th-bottom";
                        if (col_in_stack_row == 0) side_classes += " cd-table-th-left";
                        if (col_in_stack_row == repeats - 1) side_classes += " cd-table-th-right";
                        if (columns[colid1].format && columns[colid1].format.toLowerCase().indexOf("number") == 0) side_classes += " cd-table-r-th-num";
                        html += `<div class="cd-table-r-td cd-table-r-th ${stack_class}${th_sort_class}${is_row}${row_end}${side_classes}" ${no_column_header} id="${this.brick_id}$sort$${colid1}"><div class="cd-table-col"><div>` + heading + `</div><div class="${col_sort_class}"></div></div></div>`;
                        col_in_stack_row++;
                    }
                }
                col_idx1++;
            }
        }
        var remainder = (0, _sugarDefault.default).Number.ceil(numcols / stacking_levels) * stacking_levels - numcols;
        for(var r = 0; r < remainder; r++){
            var corner_classes = " cd-table-th-bottom";
            if (r == remainder - 1) corner_classes += " cd-table-th-right";
            html += `<div class="cd-table-r-td cd-table-r-th cd-table-r-row${sl - 1} cd-table-r-tr${corner_classes}"> </div>`;
        }
        if (render_trs) html += "</div>";
        if (this.col_totals.length > 0) {
            if (render_trs) html += '<div class="cd-table-rtr>';
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var col = _step.value;
                    var has_total = false;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = this.col_totals[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var ct = _step1.value;
                            if (ct.col == col.column) {
                                has_total = true;
                                var f = (0, _cbformatting.codebricks_format)(ct.total, ct.format || "Number", ((_a = this.context.composition_runners[this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) || {});
                                html += " <div class='cd-table-rtd cd-table-total'>" + f.value + "</div>";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (!has_total) html += "<div class='cd-table-rtd cd-table-nototal'></div>";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (render_trs) html += "</div>";
        }
        var row_idx = 0;
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = display_data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var row = _step2.value;
                if (render_trs) html += '<div class="cd-table-r-tr">';
                stack_idx = 0;
                sl = 0;
                var odd = "";
                if (stacking_levels > 1 && row_idx % 2 == 1) odd = " cd-table-r-td-odd ";
                for(sl = 0; sl < stacking_levels; sl++){
                    col_idx = 0;
                    for(var colid2 in columns){
                        var row_in_stack1 = stacking_levels == 1 ? 0 : col_idx % stacking_levels;
                        if (row_in_stack1 == sl) {
                            if (!columns[colid2].hidden) {
                                var child = "";
                                var col1 = columns[colid2];
                                var val = row[col1.column];
                                if (val === undefined || val === null) val = "";
                                var format_type = "";
                                if (this.blueprint.contains) {
                                    var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
                                    var child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
                                    var i = 0;
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        for(var _iterator3 = this.blueprint.contains[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var sub = _step3.value;
                                            var cement = this.cements[i] || sub.cement;
                                            if (cement && (cement.column == col1.column || cement.column === col_idx) && !cement.hidden) {
                                                if (cement.value == "before") {
                                                    var f1 = (0, _cbformatting.codebricks_format)(val, col1.format, ((_b = this.context.composition_runners[this.cid].compos) === null || _b === void 0 ? void 0 : _b.system_options) || {});
                                                    child += f1.value;
                                                    format_type = f1.type;
                                                }
                                                child += `<${sub.type} cid="${this.cid}" dc="${child_dc}" name="${sub.name}" idx="${i}" container_id="${this.brick_id}"></${sub.type}>`;
                                                if (cement.value == "after") {
                                                    var f2 = (0, _cbformatting.codebricks_format)(val, col1.format, ((_c = this.context.composition_runners[this.cid].compos) === null || _c === void 0 ? void 0 : _c.system_options) || {});
                                                    child += f2.value;
                                                    format_type = f2.type;
                                                }
                                            }
                                            i++;
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                }
                                if (child === "") {
                                    var f3 = (0, _cbformatting.codebricks_format)(val, col1.format, ((_d = this.context.composition_runners[this.cid].compos) === null || _d === void 0 ? void 0 : _d.system_options) || {});
                                    child = f3.value;
                                    format_type = f3.type;
                                }
                                var row_end1 = "";
                                if (col_idx > 0 && stack_idx % repeats == repeats - 1) row_end1 = " cd-table-r-td-last";
                                var is_row1 = "";
                                if (row_in_stack1 == stacking_levels - 1) is_row1 = " cd-table-r-tr";
                                var stack_class1 = "";
                                stack_class1 = " cd-table-r-row" + sl + " ";
                                var heading1 = "";
                                if (stacking_levels > 1) heading1 = `<span class="cd-table-r-cell-heading">${col1.display_heading}</span>`;
                                html += '<div class="cd-table-r-td ' + is_row1 + row_end1 + stack_class1 + odd + " " + (format_type == "number" ? "cd-table-rtd-num" : "") + '">' + heading1 + child + "</div>";
                            }
                        }
                        col_idx++;
                    }
                }
                var remainder1 = (0, _sugarDefault.default).Number.ceil(numcols / stacking_levels) * stacking_levels - numcols;
                for(var r1 = 0; r1 < remainder1; r1++)html += `<div class="cd-table-r-td cd-table-r-row${sl - 1} cd-table-r-tr${odd}"></div>`;
                row_idx++;
                if (render_trs) html += "</div>";
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        if (display_data.length == 0) {
            var msg = "No Results";
            if (this.cfg.table && this.cfg.table.empty_table_message) msg = this.cfg.table.empty_table_message;
            html += `<div class="empty-state cd-table-empty">${msg}</div>`;
        }
        var table_container = document.getElementById(this.brick_id + "$table_container");
        if (table_container) {
            table_container.innerHTML = html + "</div>";
            var self = this;
            if (this.may_stack) {
                var table = document.getElementById(self.brick_id + "$container");
                if (table) {
                    if (table.scrollWidth > table.offsetWidth) {
                        if (stacking_levels + 1 <= 4) self.render_responsive_table(columns, display_data, stacking_levels + 1);
                    }
                }
            }
        }
    }
    cb_status(status) {
        if (status == "loading") {
            if (this.responsive) {
                var table = document.getElementById(this.brick_id + "$table_container");
                if (table) {
                    table.innerHTML = "";
                    table.classList.add("loading");
                }
            } else {
                var table1 = document.getElementById(this.brick_id);
                if (table1) {
                    table1.innerHTML = "";
                    var self = this;
                    setTimeout(function() {
                        self.render_skeleton();
                    }, 0);
                }
            }
            var empty_element = document.getElementById(this.brick_id + "$empty");
            if (empty_element) empty_element.classList.add("hidden");
            var footer = document.getElementById(this.brick_id + "$footer");
            if (footer) footer.style.visibility = "hidden";
        } else {
            if (this.responsive) {
                var table2 = document.getElementById(this.brick_id + "$table_container");
                if (table2) table2.classList.remove("loading");
            } else {
                var table3 = document.getElementById(this.brick_id);
                if (table3) {
                    table3.classList.remove("cd-table-skeleton");
                    var search = document.getElementById(this.brick_id + "$search");
                    if (search) search.classList.remove("cd-table-search-skeleton");
                }
            }
            var footer1 = document.getElementById(this.brick_id + "$footer");
            if (footer1) footer1.style.visibility = "visible";
        }
    }
    render_skeleton() {
        var skeleton_cols = 4;
        var skeleton_rows = 6;
        if (this.blueprint.ins && this.blueprint.ins.cfg && this.blueprint.ins.cfg.columns) skeleton_cols = this.blueprint.ins.cfg.columns.length;
        var html = "<tr>";
        for(var i = 0; i < skeleton_cols; i++)html += "<th><div></div></th>";
        html += "</tr>";
        for(var r = 0; r < skeleton_rows; r++){
            html += "<tr>";
            for(var i1 = 0; i1 < skeleton_cols; i1++)html += "<td><div></div></td>";
            html += "</tr>";
        }
        var table = document.getElementById(this.brick_id);
        if (table) {
            table.innerHTML = html;
            table.classList.add("cd-table-skeleton");
        }
        var search = document.getElementById(this.brick_id + "$search");
        if (search) search.classList.add("cd-table-search-skeleton");
    }
    cb_pager_evt(goto_page) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.page = goto_page;
                        return [
                            4,
                            _this.render_data()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_snapshot() {
        var snapshot = {};
        var search = document.getElementById(this.brick_id + "$search");
        if (search) {
            var search_term = search.value;
            if (search_term) (0, _sugarDefault.default).Object.set(snapshot, "cfg.table.search.value", search_term);
        }
        return snapshot;
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        var _a, _b, _c;
        super(context, cid, name, dc, idx, container_id);
        this.data = [];
        this.page = 0;
        this.page_size = 8;
        this.pages = 1;
        this.sort_col_idx = null;
        this.sort_dir = "Descending";
        this.cfg_sort_col_idx = null;
        this.cfg_sort_dir = "Descending";
        this.col_totals = [];
        this.initialized = false;
        this.responsive = false;
        this.may_stack = false;
        this.cements = {};
        this.initial_search = "";
        this.element = element;
        this.cfg = this.blueprint.ins ? this.blueprint.ins.cfg : {};
        if (typeof this.cfg == "string") this.cfg = {};
        this.cfg.table = ((_a = this.cfg) === null || _a === void 0 ? void 0 : _a.table) || {};
        var title = "";
        if (this.cfg.table && this.cfg.table.title) title = `<h2 class="cd-table-title hidden" id="${this.brick_id + "$title"}"></h2>`;
        var search = "";
        if (!this.cfg.table || this.cfg.table && !this.cfg.table.search || this.cfg.table && this.cfg.table.search) search = `<div class="cd-table-search-container${((_b = this.cfg.table.search) === null || _b === void 0 ? void 0 : _b.hidden) || this.context.platform == "file" && !((_c = this.cfg.table.search) === null || _c === void 0 ? void 0 : _c.value) ? " hidden" : ""}"><input type="text" spellcheck="false" id="${this.brick_id + "$search"}" placeholder="${this.cfg.table && this.cfg.table.search && this.cfg.table.search.label ? this.cfg.table.search.label : "Search"}" class="form-element cd-table-search" /><span class="cd-table-search-close" id="${this.brick_id + "$search_close"}"></span></div>`;
        if (this.cfg.table.title && this.cfg.table.search.hidden) search = "&nbsp;" + search;
        if (this.cfg.table && this.cfg.table.page_size !== undefined && !isNaN(this.cfg.table.page_size)) this.page_size = this.cfg.table.page_size;
        var html = `<div class="cd-table-header"><div><div id="${this.brick_id + "$header"}" class="hidden"></div>` + search + "</div>" + title + `</div>
                    <div id="${this.brick_id}$container" class="cd-table-container">`;
        if (this.responsive) html += `<div id="${this.brick_id}$table_container" class="cd-table-r-container"></div>`;
        else html += `<table id="${this.brick_id}" class="cd-table"></table>`;
        html += `<div id="${this.brick_id}$empty" class="empty-state cd-table-empty"></div></div>
                    <div id="${this.brick_id + "$footer"}" class="cd-table-footer ${this.cfg.table.no_pager || this.context.platform == "file" ? "hidden" : ""}"><div id="${this.brick_id + "$footer_content"}"></div><div id="${this.brick_id + "$pager"}"></div></div>`;
        this.element.innerHTML = `<div class="cd-table-outer" id="${this.brick_id}$outer">${html}</div>`;
        this.pager = new (0, _cbPager.cb_pager)(this.brick_id + "$pager", {}, function() {
            var _ref = (0, _asyncToGenerator._)(function(value) {
                return (0, _tsGenerator._)(this, function(_state) {
                    self.cb_pager_evt(value);
                    return [
                        2
                    ];
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        var self = this;
        var search_element = document.getElementById(this.brick_id + "$search");
        if (search_element) search_element.addEventListener("input", function() {
            if (search_element) {
                self.page = 0;
                var pg = document.getElementById(`${self.brick_id + "$pg"}`);
                if (pg) pg.innerHTML = String(self.page + 1);
                self.render_data();
            }
        });
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBFormatting":"TabN7","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","../../codebricks-runtime/TagItemParser":"4SXYw","../../codebricks-runtime/TagItemResolver":"jXjc1","../../shared-funcs/Util":"jh939","../controls/cb_pager":"dC2Kp","sugar":"gcIJ7","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2aSoD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cd_tree_webcomponent", ()=>cd_tree_webcomponent);
parcelHelpers.export(exports, "web_cd_tree", ()=>web_cd_tree);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _cbWebUtil = require("../controls/cb_web_util");
class cd_tree_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_cd_tree(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("cd-tree", cd_tree_webcomponent);
class web_cd_tree extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var search_html, self, search_element, search_term, search_close, container, search;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            2
                        ];
                        _this.cfg = cfg;
                        if (!_this.initialized) {
                            _this.initialized = true;
                            search_html = `<div class="cd-tree-search-container${cfg.search && cfg.search.hidden ? " hidden" : ""}"><input type="text" spellcheck="false" id="${_this.brick_id + "$search"}" placeholder="${cfg.search && cfg.search.label ? cfg.search.label : "Search"}" ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("form-element cd-tree-search", cfg, "search")}/><span class="cd-tree-search-close" id="${_this.brick_id + "$search_close"}"></span></div>`;
                            _this.element.innerHTML = search_html + `<div id="${_this.brick_id}" ${(0, _cbWebUtil.CBWebUtil).GetElementStylesString("cd-tree", cfg, "tree")}></div>`;
                            self = _this;
                            search_element = document.getElementById(_this.brick_id + "$search");
                            if (search_element) {
                                if (cfg && cfg.search && (cfg.search.value != _this.initial_search || cfg.search.value == "")) {
                                    search_element.value = cfg.search.value === undefined ? "" : cfg.search.value;
                                    _this.initial_search = cfg.search.value;
                                }
                                search_element.addEventListener("input", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                                    return (0, _tsGenerator._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!search_element) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    self.render(self.cfg)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }));
                                search_term = search_element.value;
                                if (search_term) search_element.classList.add("cd-table-search-active");
                                else search_element.classList.remove("cd-table-search-active");
                                search_close = document.getElementById(_this.brick_id + "$search_close");
                                if (search_close) {
                                    search_close.style.display = search_term == "" ? "none" : "inline-block";
                                    search_close.addEventListener("click", /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                                        var search, search_term;
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    search = document.getElementById(self.brick_id + "$search");
                                                    search_term = search.value;
                                                    if (!search_term) return [
                                                        3,
                                                        2
                                                    ];
                                                    search.value = "";
                                                    return [
                                                        4,
                                                        self.render(self.cfg)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }));
                                }
                            }
                        } else {
                            container = document.getElementById(_this.brick_id);
                            if (container) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(container, cfg, "tree");
                            search = document.getElementById(_this.brick_id + "$search");
                            if (search) (0, _cbWebUtil.CBWebUtil).ApplyElementStyles(search, cfg, "search");
                        }
                        return [
                            4,
                            _this.render(cfg)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    render(cfg) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _loop, recurse_data, search_element, search_term, search_close, data, arr_data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, d, searched, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, d1, tree, self, id;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function(id) {
                            var subMenuExp = document.getElementById(id + "$exp");
                            if (subMenuExp) subMenuExp.addEventListener("click", function(event) {
                                event.preventDefault();
                                var subMenuList = document.getElementById(id + "$ul");
                                var subMenuExp = document.getElementById(id + "$exp");
                                if (subMenuList && subMenuExp) {
                                    if (subMenuList.style.display == "none") {
                                        subMenuExp.classList.remove("c-tree-expander-collapsed");
                                        subMenuExp.classList.add("c-tree-expander-expanded");
                                        subMenuList.style.display = "block";
                                    } else {
                                        subMenuExp.classList.remove("c-tree-expander-expanded");
                                        subMenuExp.classList.add("c-tree-expander-collapsed");
                                        subMenuList.style.display = "none";
                                    }
                                }
                                event.stopPropagation();
                            });
                            var subMenuHeading = document.getElementById(id);
                            if (subMenuHeading) subMenuHeading.addEventListener("click", function(event) {
                                self.cb_emit({
                                    "@": self.handlers[id]
                                });
                            });
                        };
                        _this.flush_dynamic();
                        _this.expand_levels = cfg.expand_levels || 0;
                        recurse_data = {
                            html: "",
                            i: 0
                        };
                        search_element = document.getElementById(_this.brick_id + "$search");
                        if (search_element) {
                            _this.search = search_element.value;
                            search_term = search_element.value;
                            if (search_term) search_element.classList.add("cd-table-search-active");
                            else search_element.classList.remove("cd-table-search-active");
                            search_close = document.getElementById(_this.brick_id + "$search_close");
                            if (search_close) search_close.style.display = search_term == "" ? "none" : "inline-block";
                        }
                        data = cfg.data;
                        if (_this.search) {
                            if (data) {
                                if (Array.isArray(data)) {
                                    arr_data = [];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            d = _step.value;
                                            searched = _this.search_data(cfg, d, _this.search);
                                            if (searched) arr_data.push(searched);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    data = arr_data;
                                } else data = _this.search_data(cfg, data, _this.search);
                            }
                        }
                        _this.row_idx = 0;
                        if (data) {
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            if (Array.isArray(data)) try {
                                for(_iterator1 = data[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    d1 = _step1.value;
                                    _this.render_recurse(recurse_data, cfg, d1, recurse_data.i, true);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            else _this.render_recurse(recurse_data, cfg, data, 1, true);
                        }
                        tree = document.getElementById(_this.brick_id);
                        if (tree) tree.innerHTML = recurse_data.html;
                        self = _this;
                        for(var id in _this.handlers)_loop(id);
                        return [
                            4,
                            _this.send_dynamic_initialisation_events(_this.out_data)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    render_recurse(recurse_data, cfg, data, level) {
        var create_ul = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var id = this.brick_id + "$" + recurse_data.i;
        if (create_ul) {
            recurse_data.html += `<ul id="${id}$ul" class="c-tree-submenu-items" style="display:${this.expand_levels == 0 || level <= this.expand_levels ? "block" : "none"}">`;
            recurse_data.i++;
            id = this.brick_id + "$" + recurse_data.i;
        }
        var children = data;
        if (cfg.child_path) children = (0, _cbutil.drill)(cfg.child_path, data);
        var expander = "";
        if (children && Object.keys(children).length > 0 && !cfg.static) {
            if (this.expand_levels == 0 || level <= this.expand_levels) expander = `<span id="${id}$exp" class="c-tree-expander-expanded"></span>`;
            else expander = `<span id="${id}$exp" class="c-tree-expander-collapsed"></span>`;
        } else expander = `<span class="c-tree-expander"></span>`;
        this.first_ul = false;
        var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
        var child_dc = dc_root + (0, _cbutil.DC_JOIN) + this.row_idx;
        this.out_data[this.row_idx] = data;
        var contained = "";
        if (this.blueprint.contains) {
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sub = _step.value;
                    var cement = this.cements[i] || sub.cement;
                    var brick = (0, _cbWebUtil.CBWebUtil).BrickHtml(sub, this, i, child_dc);
                    if (cement && cement.hidden) contained += `<div class="hidden">${brick}</div>`;
                    else contained += brick;
                    i++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.row_idx++;
        }
        recurse_data.i++;
        recurse_data.html += `<li><div class="c-tree-node">` + expander + " " + contained + `</div>`;
        this.handlers[id] = data;
        var ul = false;
        for(var k in children){
            if (!ul) {
                ul = true;
                recurse_data.html += `<ul id="${id}$ul" class="c-tree-submenu-items" style="display:${this.expand_levels == 0 || level <= this.expand_levels ? "block" : "none"}">`;
            }
            var child = children[k];
            this.render_recurse(recurse_data, cfg, child, level + 1, false);
        }
        recurse_data.html += "</li>";
        if (ul) recurse_data.html += "</ul>";
        if (create_ul) recurse_data.html += "</ul>";
    }
    search_data(cfg, data, search) {
        var ret = {};
        var children = data;
        if (cfg.child_path) children = (0, _cbutil.drill)(cfg.child_path, data);
        var found = false;
        if (cfg && cfg.search && cfg.search.search_property) {
            if (data[cfg.search.search_property].toLowerCase().indexOf(search.toLocaleLowerCase()) != -1) found = true;
        } else for(var prop in data){
            if (typeof data[prop] == "string") {
                if (data[prop].toLowerCase().indexOf(search.toLocaleLowerCase()) != -1) found = true;
            }
        }
        if (found) return data;
        var childs = [];
        for(var k in children){
            var child = children[k];
            var has = this.search_data(cfg, child, search);
            if (has) {
                found = true;
                if (cfg.child_path) childs.push(has);
            }
        }
        if (found) {
            for(var p in data)ret[p] = data[p];
            if (cfg.child_path) ret[cfg.child_path] = childs;
            return ret;
        }
        return null;
    }
    cb_initial_cement(cements) {
        this.cements = cements;
    }
    cb_update_cement(child_idx, cement, row_idx) {
        var dc_root = (this.dc || "") + ((0, _cbutil.DC_JOIN) + this.blueprint.name);
        var child_dc = dc_root + (0, _cbutil.DC_JOIN) + row_idx;
        var child = this.element.querySelector('[dc="' + child_dc + '"][idx="' + child_idx + '"][container_id="' + this.brick_id + '"]');
        if (child) {
            if (cement.hidden) child.classList.add("hidden");
            else child.classList.remove("hidden");
        }
    }
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.listener = false;
        this.handlers = {};
        this.expand_levels = 0;
        this.row_idx = 0;
        this.first_ul = true;
        this.out_data = [];
        this.cements = {};
        this.initial_search = "";
        this.search = "";
        this.cfg = null;
        this.initialized = false;
        this.element = element;
        this.init_cement();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../codebricks-runtime/CBUtil":"1DxvQ","../controls/cb_web_util":"jCKPs","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"2SrO9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_data_webcomponent", ()=>ci_data_webcomponent);
parcelHelpers.export(exports, "web_ci_data", ()=>web_ci_data);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _data = require("../../shared-funcs/Data");
class ci_data_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_data(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-data", ci_data_webcomponent);
class web_ci_data extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var ret;
            return (0, _tsGenerator._)(this, function(_state) {
                _this.save_to_snapshot = cfg.save_to_snapshot || false;
                ret = (0, _data.Data).ProcessDataInput(input, cfg, _this);
                return [
                    2,
                    ret
                ];
            });
        })();
    }
    cb_validate() {
        return this.validate_sources("");
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        this.emit_state(status);
    }
    cb_snapshot() {
        if (this.save_to_snapshot) {
            var snapshot = {
                cfg: {
                    value: this.data
                }
            };
            return snapshot;
        }
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.prev_data = "";
        this.save_to_snapshot = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/Data":"lY2hB","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lY2hB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Data", ()=>Data);
var _cbutil = require("../codebricks-runtime/CBUtil");
var _pivotTable = require("./PivotTable");
var Data = /** @class */ function() {
    function Data() {}
    Data.ProcessDataInput = function(input, cfg, self) {
        if (input == "data") {
            if (cfg.ignore_unchanged || cfg.ingore_unchanged) {
                if (self.prev_data == JSON.stringify(cfg.value)) return;
            }
            self.data = cfg.value;
            //group
            if (cfg.group_by && cfg.group_by.group_cols && cfg.group_by.group_cols.length > 0) self.data = (0, _pivotTable.PivotTable).groupData(self.data, cfg.group_by.group_cols, cfg.group_by.count_cols, cfg.group_by.sum_cols);
            //console.log('Grouped data: '+JSON.stringify(data));
            if (cfg.pivot && cfg.pivot.rows && cfg.pivot.rows.length > 0 && cfg.pivot.columns && cfg.pivot.columns.length > 0 && cfg.pivot.data_columns && cfg.pivot.data_columns.length > 0) self.data = (0, _pivotTable.PivotTable).pivotData(self.data, cfg.pivot.rows[0], cfg.pivot.columns[0], cfg.pivot.data_columns, false);
            if (cfg.transform_props) {
                if (Array.isArray(self.data)) {
                    var pdata = [];
                    var hassobject = false;
                    for(var _i = 0, _a = self.data; _i < _a.length; _i++){
                        var d = _a[_i];
                        if (typeof d == "object") {
                            hassobject = true;
                            var obj = {};
                            for(var p in d){
                                var has_transform = false;
                                for(var _b = 0, _c = cfg.transform_props; _b < _c.length; _b++){
                                    var tp = _c[_b];
                                    if (tp.data_prop == p) {
                                        if (!tp.hide) obj[tp.rename || p] = d[p];
                                        has_transform = true;
                                    }
                                }
                                if (!has_transform) obj[p] = d[p];
                            }
                            pdata.push(obj);
                        }
                    }
                    if (hassobject) self.data = pdata;
                } else if (typeof self.data == "object") {
                    var obj = {};
                    for(var p in self.data){
                        var has_transform = false;
                        for(var _d = 0, _e = cfg.transform_props; _d < _e.length; _d++){
                            var tp = _e[_d];
                            if (tp.data_prop == p) {
                                if (!tp.hide) obj[tp.rename || p] = self.data[p];
                                has_transform = true;
                            }
                        }
                        if (!has_transform) obj[p] = self.data[p];
                    }
                    self.data = obj;
                }
            }
            var dont_emit = false;
            if (cfg.ingore_initial) {
                if (self.prev_data === "") dont_emit = true;
            }
            self.prev_data = JSON.stringify(self.data);
            if (!dont_emit) {
                if (cfg.no_event) self.cb_emit({
                    "@constraint_failed": false,
                    "@": self.data
                }, undefined, true);
                else return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "merge") {
            if (cfg.value !== "") {
                (0, _cbutil.ObjectDeepMerge)(self.data || {}, cfg.value);
                return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "set_property") {
            if (self.data && cfg.value !== "" && cfg.path !== undefined) {
                self.data = (0, _cbutil.DrillSet)(self.data, cfg.path, cfg.value);
                return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "push") {
            if (cfg.value !== "") {
                self.data = self.data || [];
                if (Array.isArray(self.data)) {
                    if (!this.CheckConstraint(self, self.data, cfg.value)) return {
                        "@constraint_failed": true
                    };
                    self.data.push(cfg.value);
                    return {
                        "@constraint_failed": false,
                        "@": self.data
                    };
                }
            }
        } else if (input == "insert") {
            if (cfg.value !== "" && Array.isArray(self.data)) {
                if (!this.CheckConstraint(self, self.data, cfg.value)) return {
                    "@constraint_failed": true
                };
                self.data.splice(cfg.position, 0, cfg.value);
                return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "delete_position") {
            if (cfg.count && Array.isArray(self.data)) {
                self.data.splice(cfg.position, cfg.count);
                return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "delete_where") {
            if (cfg.value !== "" && Array.isArray(self.data)) {
                for(var i = self.data.length; i >= 0; i--){
                    if (cfg.property) {
                        if (typeof self.data[i] == "object" && self.data[i][cfg.property] == cfg.value) self.data.splice(i, 1);
                    } else if (self.data[i] == cfg.value) self.data.splice(i, 1);
                }
                return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "replace_where") {
            if (cfg.value !== "" && Array.isArray(self.data)) {
                for(var i = self.data.length; i >= 0; i--){
                    if (cfg.property) {
                        if (typeof self.data[i] == "object" && self.data[i][cfg.property] == cfg.value) self.data[i] = cfg.new_value;
                    } else if (self.data[i] == cfg.value) self.data[i] = cfg.new_value;
                }
                return {
                    "@constraint_failed": false,
                    "@": self.data
                };
            }
        } else if (input == "unique_constraints") self.unique_constraints = cfg;
    };
    Data.CheckConstraint = function(self, data, value) {
        if (Array.isArray(data)) {
            if (self.unique_constraints && self.unique_constraints.enable) {
                if (self.unique_constraints.check_properties) {
                    var _loop_1 = function _loop_1(property) {
                        if (data.some(function(e) {
                            return e[property] == value[property];
                        })) return {
                            value: false
                        };
                    };
                    for(var _i = 0, _a = self.unique_constraints.check_properties; _i < _a.length; _i++){
                        var property = _a[_i];
                        var state_1 = _loop_1(property);
                        if (typeof state_1 === "object") return state_1.value;
                    }
                } else {
                    if (self.data.includes(value)) return false;
                }
            }
            return true;
        }
    };
    return Data;
}();

},{"../codebricks-runtime/CBUtil":"1DxvQ","./PivotTable":"esihi","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"7G3Z2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_datatransform_webcomponent", ()=>ci_datatransform_webcomponent);
parcelHelpers.export(exports, "web_ci_datatransform", ()=>web_ci_datatransform);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _dataTransform = require("../../shared-funcs/DataTransform");
class ci_datatransform_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_datatransform(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-datatransform", ci_datatransform_webcomponent);
class web_ci_datatransform extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var transform;
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "cfg") {
                    _this.data = cfg.data;
                    transform = cfg.transform;
                    if (transform) {
                        if (transform.column_transforms && transform.column_transforms.length > 0) _this.data = (0, _dataTransform.DataTransform).transformCols(_this.data, transform.column_transforms);
                        if (transform.group_by && transform.group_by.group_columns && transform.group_by.group_columns.length > 0) _this.data = (0, _dataTransform.DataTransform).groupData(_this.data, transform.group_by.group_columns, transform.group_by.count_columns, transform.group_by.sum_columns);
                        if (transform.pivot && transform.pivot.row != "") _this.data = (0, _dataTransform.DataTransform).pivotData(_this.data, transform.pivot.row, transform.pivot.column, transform.pivot.data);
                        if (transform.limit) _this.data = _this.data.slice(0, transform.limit);
                    }
                    return [
                        2,
                        {
                            "@": _this.data
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        this.emit_state(status);
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/DataTransform":"79tRc","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"79tRc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataTransform", ()=>DataTransform);
var DataTransform = /** @class */ function() {
    function DataTransform() {}
    //copied from v2
    DataTransform.pivotData = function(data, row, col, dataCols, multiHeader) {
        if (multiHeader === void 0) multiHeader = false;
        if (data.length == 0) return data;
        var pivotCols = [];
        for(var i = 0; i < data.length; i++)for(var d = 0; d < dataCols.length; d++)DataTransform.addDistinctOrdered(pivotCols, DataTransform.dataCol("" + data[i][col], dataCols, d, multiHeader));
        var ret = [];
        var atRow = "-1";
        var r = null;
        var keys = Object.keys(data[0]);
        for(var dr = 0; dr < data.length; dr++){
            var drow = data[dr];
            var rowAdded = false;
            if (drow[row] != atRow) {
                r = DataTransform.findRow(ret, row, drow[row]);
                if (r == null) {
                    r = {};
                    atRow = drow[row];
                    for(var k = 0; k < keys.length; k++){
                        var dc = false;
                        for(var d = 0; d < dataCols.length; d++)if (keys[k] == dataCols[d]) {
                            dc = true;
                            break;
                        }
                        if (dc) continue;
                        if (keys[k] != col) r[keys[k]] = drow[keys[k]] || "";
                    }
                    for(var pc = 0; pc < pivotCols.length; pc++){
                        var set = false;
                        for(var d = 0; d < dataCols.length; d++)if (pivotCols[pc] == DataTransform.dataCol(drow[col], dataCols, d, multiHeader)) {
                            r[pivotCols[pc]] = drow[dataCols[d]] ? drow[dataCols[d]] : 0;
                            set = true;
                        }
                        if (!set) r[pivotCols[pc]] = 0;
                    }
                    ret.push(r);
                    rowAdded = true;
                } else atRow = drow[row];
            }
            if (!rowAdded) for(var d = 0; d < dataCols.length; d++)r[DataTransform.dataCol(drow[col], dataCols, d, multiHeader)] = r[DataTransform.dataCol(drow[col], dataCols, d, multiHeader)] + drow[dataCols[d]];
        }
        //console.log("pivoted: "+JSON.stringify(ret));
        return ret;
    };
    DataTransform.groupData = function(data, groupcols, countcols, sumcols) {
        var groupDict = {};
        for(var r = 0; r < data.length; r++){
            var group = "";
            for(var g = 0; g < groupcols.length; g++)group += data[r][groupcols[g]] + "^";
            var grouprow = groupDict[group];
            if (!grouprow) {
                grouprow = {};
                for(var g = 0; g < groupcols.length; g++)grouprow[groupcols[g]] = data[r][groupcols[g]];
                for(var c = 0; c < countcols.length; c++)grouprow[countcols[c]] = 1;
                for(var s = 0; s < sumcols.length; s++)grouprow[sumcols[s]] = data[r][sumcols[s]];
                groupDict[group] = grouprow;
            } else {
                for(var c = 0; c < countcols.length; c++)grouprow[countcols[c]]++;
                for(var s = 0; s < sumcols.length; s++)grouprow[sumcols[s]] += data[r][sumcols[s]];
            }
        }
        var keys = Object.keys(groupDict);
        var ret = [];
        for(var k = 0; k < keys.length; k++)ret.push(groupDict[keys[k]]);
        return ret;
    };
    DataTransform.transformCols = function(data, coltransforms) {
        if (data.length == 0) return data;
        var ret = [];
        var ikeys = Object.keys(data[0]);
        var okeys = [];
        for(var k = 0; k < ikeys.length; k++){
            var found = false;
            for(var t = 0; t < coltransforms.length; t++)if (ikeys[k] == coltransforms[t].property) {
                if (!coltransforms[t].hidden) okeys.push({
                    s: ikeys[k],
                    d: coltransforms[t].rename || ikeys[k]
                });
                found = true;
                break;
            }
            if (!found) okeys.push({
                s: ikeys[k],
                d: ikeys[k]
            });
        }
        for(var r = 0; r < data.length; r++){
            var row = {};
            for(var k = 0; k < okeys.length; k++)row[okeys[k].d] = data[r][okeys[k].s];
            ret.push(row);
        }
        return ret;
    };
    DataTransform.dataCol = function(col, dataCols, d, multiHeader) {
        if (dataCols.length == 1 && !multiHeader) return col; //dataCols[0];
        return col + "_" + dataCols[d];
    };
    DataTransform.addDistinctOrdered = function(list, v) {
        for(var i = 0; i < list.length; i++){
            if (v == list[i]) return;
            if (DataTransform.compareMaybeDate(v, list[i])) {
                list.splice(i, 0, v);
                return;
            }
        }
        list.push(v);
    };
    DataTransform.compareMaybeDate = function(v1, v2) {
        //check if date in form MMM-YY
        if (!v1) v1 = "";
        if (!v2) v2 = "";
        // if (v1.length == 6 && v2.length == 6 && v1[3] == '-' && v2[3] == '-') {
        //     return moment(v1, "MMM-YY") < moment(v2, "MMM-YY");
        // }
        return v1 < v2;
    };
    DataTransform.addDistinct = function(list, v) {
        for(var i = 0; i < list.length; i++){
            if (v == list[i]) return;
        }
        list.push(v);
    };
    DataTransform.findRow = function(data, colname, value) {
        for(var r = 0; r < data.length; r++){
            if (data[r][colname] == value) return data[r];
        }
        return null;
    };
    return DataTransform;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"72vRO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_fetch_webcomponent", ()=>ci_fetch_webcomponent);
parcelHelpers.export(exports, "web_ci_fetch", ()=>web_ci_fetch);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class ci_fetch_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_fetch(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-fetch", ci_fetch_webcomponent);
class web_ci_fetch extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var request, res_data, method, options, uri, res, body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            3
                        ];
                        _this.emit_state("loading");
                        request = cfg;
                        method = (request.http_method || "GET").toUpperCase();
                        options = {
                            method
                        };
                        uri = request.url;
                        if (request.headers) options.headers = request.headers;
                        if (request.auth_type == "basic") {
                            options.headers = options.headers || {};
                            options.headers["Authorization"] = "Basic " + btoa(unescape(encodeURIComponent(request.auth_username + ":" + request.auth_secret)));
                        }
                        if (request.body) {
                            if (typeof request.body == "object") options.body = JSON.stringify(request.body);
                            else options.body = request.body;
                        }
                        options.credentials = "include";
                        return [
                            4,
                            fetch(uri, options)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        if (body === "") return [
                            2
                        ];
                        try {
                            res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        _this.emit_state("");
                        return [
                            2,
                            {
                                "@": {
                                    body: res_data,
                                    code: res.status
                                }
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"aZEcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_funnel_webcomponent", ()=>ci_funnel_webcomponent);
parcelHelpers.export(exports, "web_ci_funnel", ()=>web_ci_funnel);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class ci_funnel_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_funnel(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-funnel", ci_funnel_webcomponent);
class web_ci_funnel extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                if (input == "data") {
                    if (info && info.source_idx !== undefined) {
                        _this.data[info.source_idx] = cfg;
                        _this.cb_emit_deferred({
                            "@": _this.data
                        });
                    }
                } else if (input == "clear") _this.data = [];
                return [
                    2
                ];
            });
        })();
    }
    cb_validate() {
        return this.validate_sources("");
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        status;
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.data = [];
        this.max_idx = 0;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"lffyJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_global_event_webcomponent", ()=>ci_global_event_webcomponent);
parcelHelpers.export(exports, "web_ci_global_event", ()=>web_ci_global_event);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _globalEvent = require("../../shared-funcs/GlobalEvent");
class ci_global_event_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_global_event(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-global-event", ci_global_event_webcomponent);
class web_ci_global_event extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                (0, _globalEvent.GlobalEvent).HandleEvent(input, cfg, _this);
                return [
                    2
                ];
            });
        })();
    }
    cb_validate() {
        return this.validate_sources("");
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        this.emit_state(status);
    }
    cb_snapshot() {}
    cb_unload() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var self, event_name, fun, i, gfun;
            return (0, _tsGenerator._)(this, function(_state) {
                self = _this;
                for(var event_name in self.listening){
                    fun = self.listening[event_name];
                    for(i = window.codebricks_context.global_event_listeners[event_name].length - 1; i >= 0; i--){
                        gfun = window.codebricks_context.global_event_listeners[event_name][i];
                        if (fun == gfun) window.codebricks_context.global_event_listeners[event_name].splice(i, 1);
                    }
                }
                return [
                    2
                ];
            });
        })();
    }
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.listening = {};
        this.element = element;
        (0, _globalEvent.GlobalEvent).CreateHandler();
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/GlobalEvent":"dx2LC","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"dx2LC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalEvent", ()=>GlobalEvent);
var _cbutil = require("../codebricks-runtime/CBUtil");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var GlobalEvent = /** @class */ function() {
    function GlobalEvent() {}
    GlobalEvent.CreateHandler = function() {
        if (!window.ci_global_event_send) window.ci_global_event_send = function(event_name, event_data) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, handler;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            window.ci_global_event_data = window.ci_global_event_data || {};
                            window.ci_global_event_data[event_name] = (0, _cbutil.Clone)(event_data);
                            if (!(window.codebricks_context.global_event_listeners && window.codebricks_context.global_event_listeners[event_name])) return [
                                3 /*break*/ ,
                                4
                            ];
                            _i = 0, _a = window.codebricks_context.global_event_listeners[event_name];
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            handler = _a[_i];
                            //console.log("ci_global_event_send call handler " +event_name+" "+JSON.stringify(event_data));
                            return [
                                4 /*yield*/ ,
                                handler(event_data)
                            ];
                        case 2:
                            //console.log("ci_global_event_send call handler " +event_name+" "+JSON.stringify(event_data));
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    GlobalEvent.HandleEvent = function(input, cfg, owner) {
        return __awaiter(this, void 0, void 0, function() {
            var self, _loop_1, _i, cfg_1, event_name, state_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(input == "send")) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!(cfg && cfg.event_name)) return [
                            3 /*break*/ ,
                            2
                        ];
                        //console.log("ci-global-event "+this.brick_id+" global-send "+info.source+"->"+ cfg.event_name);
                        return [
                            4 /*yield*/ ,
                            window.ci_global_event_send(cfg.event_name, cfg.event_data)
                        ];
                    case 1:
                        //console.log("ci-global-event "+this.brick_id+" global-send "+info.source+"->"+ cfg.event_name);
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        if (input == "listen") {
                            if (cfg && Array.isArray(cfg)) {
                                window.codebricks_context.global_event_listeners = window.codebricks_context.global_event_listeners || {};
                                self = this;
                                _loop_1 = function _loop_1(event_name) {
                                    window.codebricks_context.global_event_listeners[event_name] = window.codebricks_context.global_event_listeners[event_name] || [];
                                    if (owner.listening[event_name]) return "continue";
                                    //console.log("ci-global-event "+this.brick_id+" register listen "+info.source+"->"+ event_name);
                                    var event_name_c = event_name;
                                    owner.listening[event_name] = function(data) {
                                        return __awaiter(this, void 0, void 0, function() {
                                            var emit_data;
                                            return __generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        emit_data = {};
                                                        emit_data["@" + event_name_c] = data;
                                                        //console.log("ci-global-event "+self.brick_id+" handler_run "+info.source_brick_id+"->"+event_name_c+ " "+JSON.stringify(emit_data));
                                                        return [
                                                            4 /*yield*/ ,
                                                            owner.cb_emit(emit_data)
                                                        ];
                                                    case 1:
                                                        //console.log("ci-global-event "+self.brick_id+" handler_run "+info.source_brick_id+"->"+event_name_c+ " "+JSON.stringify(emit_data));
                                                        _a.sent();
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    };
                                    window.codebricks_context.global_event_listeners[event_name_c].push(owner.listening[event_name]);
                                    //If event has finred, and someone subscribes after that, they must get the event when they subscribe. This solves race conditions.
                                    if (window.ci_global_event_data && window.ci_global_event_data[event_name]) {
                                        var emit_data = {};
                                        emit_data["@" + event_name_c] = window.ci_global_event_data[event_name];
                                        return {
                                            value: emit_data
                                        };
                                    }
                                };
                                for(_i = 0, cfg_1 = cfg; _i < cfg_1.length; _i++){
                                    event_name = cfg_1[_i];
                                    state_1 = _loop_1(event_name);
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                }
                            }
                        }
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return GlobalEvent;
}();

},{"../codebricks-runtime/CBUtil":"1DxvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"4PVne":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_periodic_webcomponent", ()=>ci_periodic_webcomponent);
parcelHelpers.export(exports, "web_ci_periodc", ()=>web_ci_periodc);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class ci_periodic_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_periodc(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-periodic", ci_periodic_webcomponent);
class web_ci_periodc extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                _this.cfg = cfg;
                if (!cfg.disabled && cfg.period_ms && !_this.waiting) _this.repeat();
                if (cfg.run_initially && !_this.initialized) {
                    _this.initialized = true;
                    return [
                        2,
                        {
                            "@": cfg.value
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }
    repeat() {
        this.waiting = false;
        if (this.cfg.disabled || !this.cfg.period_ms) return;
        var self = this;
        setTimeout(function() {
            if (self.cfg.disabled) return;
            self.cb_emit({
                "@": self.cfg.value
            });
            self.cfg.runs++;
            if (self.cfg.limit_repeats) {
                if (self.runs >= self.cfg.limit_repeats) return;
            }
            self.repeat();
        }, self.cfg.period_ms);
        this.waiting = true;
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.runs = 0;
        this.waiting = false;
        this.initialized = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"g6h51":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_redirect_webcomponent", ()=>ci_redirect_webcomponent);
parcelHelpers.export(exports, "web_ci_redirect", ()=>web_ci_redirect);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class ci_redirect_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_redirect(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-redirect", ci_redirect_webcomponent);
class web_ci_redirect extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var p_count, k, options, uri, res, body, res_data, err, prefix;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            6
                        ];
                        _this.link_comp = cfg.target;
                        _this.fallback_url_if_404 = cfg.fallback_url_if_404;
                        _this.querystring = "";
                        p_count = 0;
                        if (cfg.parameters) {
                            if (typeof cfg.parameters == "object") for(var k in cfg.parameters){
                                if (p_count == 0) _this.querystring = "?";
                                else _this.querystring += "&";
                                _this.querystring += k + "=" + cfg.parameters[k];
                                p_count++;
                            }
                        }
                        if (cfg.new_tab) _this.new_tab = true;
                        _this.emit_state("loading");
                        if (!_this.fallback_url_if_404) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        options = {
                            method: "GET"
                        };
                        uri = "/cb_api/auth/has_access/" + _this.link_comp;
                        options.credentials = "include";
                        return [
                            4,
                            fetch(uri, options)
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 3:
                        body = _state.sent();
                        res_data = JSON.parse(body);
                        if (!res_data.success) {
                            window.location = `/${_this.fallback_url_if_404}`;
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error(_this.blueprint.name + ": fallback_url_if_404 failed: " + err + "; " + err.stack);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        prefix = "/";
                        if (_this.link_comp && (_this.link_comp[0] == "/" || _this.link_comp.indexOf("://") != -1)) prefix = "";
                        if (_this.new_tab) window.open(`${prefix}${_this.link_comp}${_this.querystring}`, "_blank");
                        else {
                            document.body.classList.add("ci-redirect-loading");
                            window.location = `${prefix}${_this.link_comp}${_this.querystring}`;
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.link_comp = "";
        this.fallback_url_if_404 = "";
        this.querystring = "";
        this.new_tab = false;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"7lIyg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_script_js_webcomponent", ()=>ci_script_js_webcomponent);
parcelHelpers.export(exports, "web_ci_script_js", ()=>web_ci_script_js);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class ci_script_js_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_script_js(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-script-js", ci_script_js_webcomponent);
class web_ci_script_js extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var js, func, cid, cb, res, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            4
                        ];
                        js = cfg.function;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        func = eval("(" + js + ")");
                        cid = _this.cid;
                        cb = {
                            brick_event: function() {
                                var _ref = (0, _asyncToGenerator._)(function(brick_name, input, cfg) {
                                    var brick_brick_id;
                                    return (0, _tsGenerator._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                brick_brick_id = "cb" + cid + "_" + brick_name;
                                                return [
                                                    4,
                                                    globalThis.codebricks_context.bricks[brick_brick_id].cb_event(input, cfg, cfg)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(brick_name, input, cfg) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        };
                        return [
                            4,
                            func(cfg.params, cb)
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            2,
                            {
                                "@": res
                            }
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("ci-script-js " + _this.brick_id + ": " + err + " " + js + "; " + err.stack);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    cb_validate() {
        return this.validate_sources("");
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {
        this.emit_state(status);
    }
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"8G8Gh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ci_snapshot_webcomponent", ()=>ci_snapshot_webcomponent);
parcelHelpers.export(exports, "web_ci_snapshot", ()=>web_ci_snapshot);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbutil = require("../../codebricks-runtime/CBUtil");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
class ci_snapshot_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            this.ci = new web_ci_snapshot(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("ci-snapshot", ci_snapshot_webcomponent);
class web_ci_snapshot extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var _a, _b, _c, snapshot_name, container_brick_name, container_brick, snapshot_composition, snapshots, b, codebrick, s, slug, snapshot_post_obj, snapshot_type, res;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(input == "cfg")) return [
                            3,
                            3
                        ];
                        snapshot_name = cfg["snapshot_name"] || "Export";
                        container_brick_name = cfg["container_brick"];
                        container_brick = _this.context.compositions[_this.cid];
                        snapshot_composition = location.pathname.substring(1) || ((_b = (_a = _this.context.composition_runners[_this.cid].compos) === null || _a === void 0 ? void 0 : _a.system_options) === null || _b === void 0 ? void 0 : _b.home_composition) || ((_c = _this.context.composition_runners[_this.cid].compos) === null || _c === void 0 ? void 0 : _c.composition) || "home";
                        snapshot_composition = snapshot_composition.split("?")[0];
                        if (snapshot_composition == "editor") snapshot_composition = container_brick.composition;
                        snapshots = {};
                        if (container_brick_name) {
                            b = _this.find_blueprint(_this.context.compositions[_this.cid], container_brick_name);
                            if (b.name != container_brick.name) {
                                container_brick = (0, _cbutil.Clone)(container_brick);
                                container_brick.contains = [
                                    b
                                ];
                                codebrick = _this.find_codebrick(container_brick_name);
                                if (codebrick && codebrick.blueprint.type == "cc-use") snapshots[container_brick_name] = codebrick.last_ins || {};
                            }
                        }
                        if (!container_brick) return [
                            3,
                            2
                        ];
                        _this.take_snapshots(snapshots, container_brick);
                        s = window.location.pathname.split("/");
                        slug = s[s.length - 1];
                        snapshots[container_brick.name].args = snapshots[container_brick.name].args || {};
                        snapshots[container_brick.name].args.slug = slug;
                        snapshot_post_obj = {
                            snapshot_name: snapshot_name,
                            snapshot: snapshots,
                            container_brick_name: container_brick_name,
                            timezone_offset: _this.context.timezone_offset
                        };
                        if (cfg.base_snapshot_id) snapshot_post_obj.base_snapshot_id = cfg.base_snapshot_id;
                        snapshot_type = "temp";
                        if (cfg.snapshot_type == "Saved") snapshot_type = "saved";
                        if (_this.context.composition_runners[_this.cid].debugging_enabled) snapshot_post_obj.debugging_enabled = true;
                        return [
                            4,
                            _this.api_request(snapshot_composition, snapshot_post_obj, snapshot_type)
                        ];
                    case 1:
                        res = _state.sent();
                        res.passthrough_data = cfg.passthrough_data;
                        return [
                            2,
                            {
                                "@": res
                            }
                        ];
                    case 2:
                        console.error("c-snapshot: Container brick " + container_brick_name + " not found.");
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    take_snapshots(snapshots, blueprint) {
        var ci = this.get_brick_by_name(blueprint.name);
        if (ci) {
            var ss = ci.cb_snapshot();
            if (ss && Object.keys(ss).length > 0) snapshots[blueprint.name] = ss;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (blueprint.contains) try {
            for(var _iterator = blueprint.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var b = _step.value;
                this.take_snapshots(snapshots, b);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    get_brick_by_name(name) {
        var ci = this.context.bricks["cb" + this.cid + "_" + name];
        return ci;
    }
    find_blueprint(at, name) {
        if (at.name == name) return at;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (at.contains) try {
            for(var _iterator = at.contains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                var b = this.find_blueprint(c, name);
                if (b) return b;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    }
    find_codebrick(name) {
        for(var brickId in window.codebricks_context.bricks){
            var brick = window.codebricks_context.bricks[brickId];
            if (brick.blueprint.name == name) return brick;
        }
        return null;
    }
    api_request(composition_name, snapshot_post_obj, snapshot_type) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var res_data, method, options, uri, res, body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.emit_state("loading");
                        method = "POST";
                        options = {
                            method
                        };
                        uri = "/cb_api/cb/" + snapshot_type + "_snapshot/" + composition_name;
                        options.body = JSON.stringify(snapshot_post_obj);
                        options.credentials = "include";
                        options.headers = {
                            "Content-Type": "application/json"
                        };
                        return [
                            4,
                            fetch(uri, options)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        try {
                            res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        _this.emit_state("");
                        return [
                            2,
                            res_data
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CBUtil":"1DxvQ","../../codebricks-runtime/CodeBrick":"junyG","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"eJkQR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sc_use_webcomponent", ()=>sc_use_webcomponent);
parcelHelpers.export(exports, "web_sc_use", ()=>web_sc_use);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _codeBrick = require("../../codebricks-runtime/CodeBrick");
var _suse = require("../../shared-funcs/SUse");
class sc_use_webcomponent extends HTMLElement {
    connectedCallback() {
        if (!this.ci) {
            var context = globalThis.codebricks_context;
            var cid = this.getAttribute("cid");
            var name = this.getAttribute("name");
            var dc = this.getAttribute("dc");
            var idx = this.getAttribute("idx");
            var container_id = this.getAttribute("container_id");
            var nsid = this.getAttribute("nsid");
            this.ci = new web_sc_use(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if (this.ci) this.ci.destructor();
    }
    constructor(){
        super();
    }
}
customElements.define("sc-use", sc_use_webcomponent);
class web_sc_use extends (0, _codeBrick.CodeBrick) {
    cb_event(input, cfg, info) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var odata, tag_vals, in_leaves, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, leaf, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, part, res_data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.emit_state("loading");
                        odata = (0, _suse.SUse).GetSUseParams(_this, input);
                        tag_vals = [];
                        if (_this.parsed_ins && _this.parsed_ins[input]) {
                            in_leaves = _this.parsed_ins[input];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = in_leaves.leaves[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    leaf = _step.value;
                                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(_iterator1 = leaf.parts[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            part = _step1.value;
                                            if (part.tag) tag_vals.push(part.tag.val);
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return [
                            4,
                            _this.api_request(odata, info, input, tag_vals)
                        ];
                    case 1:
                        res_data = _state.sent();
                        _this.emit_state("");
                        if (res_data && res_data.success === false) console.error(_this.blueprint.name + " emit response " + JSON.stringify(res_data));
                        return [
                            2,
                            res_data
                        ];
                }
            });
        })();
    }
    api_request(odata, info, input, tag_vals) {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var res_data, method, options, uri, post_body, res, respseq, body;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        method = "POST";
                        options = {
                            method
                        };
                        uri = "/cb_api/cb/sc-use";
                        _this.reqseq++;
                        post_body = {
                            composition: _this.context.compositions[_this.cid].composition,
                            unit_path: _this.blueprint.name,
                            odata: odata,
                            source: info.source,
                            source_output: info.source_output,
                            input: input,
                            tag_vals: tag_vals,
                            timezone_offset: _this.context.timezone_offset,
                            reqseq: _this.reqseq
                        };
                        if (_this.context.composition_runners[_this.cid].debugging_enabled) post_body.debugging_enabled = _this.context.composition_runners[_this.cid].debugging_enabled;
                        options.body = JSON.stringify(post_body);
                        options.credentials = "include";
                        options.headers = {
                            "Content-Type": "application/json"
                        };
                        return [
                            4,
                            fetch(uri, options)
                        ];
                    case 1:
                        res = _state.sent();
                        respseq = res.headers.get("respseq");
                        if (respseq) {
                            if (Number(respseq) < _this.reqseq) return [
                                2
                            ];
                        }
                        return [
                            4,
                            res.text()
                        ];
                    case 2:
                        body = _state.sent();
                        if (body === "") return [
                            2
                        ];
                        try {
                            res_data = JSON.parse(body);
                        } catch (err) {
                            res_data = body;
                        }
                        return [
                            2,
                            res_data
                        ];
                }
            });
        })();
    }
    cb_initial_cement(cements) {}
    cb_update_cement(child_idx, cement, row_idx) {}
    cb_status(status) {}
    cb_snapshot() {}
    constructor(context, cid, name, dc, idx, container_id, element){
        super(context, cid, name, dc, idx, container_id);
        this.reqseq = 0;
        this.element = element;
    }
}

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../../codebricks-runtime/CodeBrick":"junyG","../../shared-funcs/SUse":"fbS6h","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jcIod":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "web_composition_reader", ()=>web_composition_reader);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _cbcompositionRunner = require("../codebricks-runtime/CBCompositionRunner");
var _sugar = require("sugar");
var _sugarDefault = parcelHelpers.interopDefault(_sugar);
var _cbutil = require("../codebricks-runtime/CBUtil");
var _exportFuncs = require("../shared-funcs/ExportFuncs");
var _inlineStyleProcessor = require("./controls/InlineStyleProcessor");
window.Sugar = (0, _sugarDefault.default);
class web_composition_reader extends HTMLElement {
    connectedCallback() {
        var _this = this;
        return (0, _asyncToGenerator._)(function() {
            var composition, self, urlParams, compos, context, logevents, snapshot_id, slug, home_slug, slot;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        CKEDITOR.disableAutoInline = true;
                        _this.innerHTML = `<div></div>`;
                        composition = _this.getAttribute("composition");
                        self = _this;
                        urlParams = _this.getUrlParams();
                        compos = window.codebricks;
                        context = globalThis.codebricks_context;
                        if (context) delete context.compositions[self.composition_id];
                        globalThis.codebricks_context = globalThis.codebricks_context || {};
                        logevents = sessionStorage.getItem("logevents");
                        if (logevents) globalThis.codebricks_context.logevents = true;
                        window.autoid = window.autoid || 0;
                        self.rtcn = new (0, _cbcompositionRunner.CBCompositionRunner)(composition, globalThis.codebricks_context, undefined);
                        window.enable_debugging = function() {
                            if (sessionStorage) {
                                sessionStorage.setItem("enable_debugging", "yes");
                                if (self.rtcn) self.rtcn.debugging_enabled = true;
                                console.log("debugging enabled");
                            }
                        };
                        compos.ins = compos.ins || {};
                        self.rtcn.debugging_enabled = sessionStorage.getItem("enable_debugging") == "yes";
                        self.rtcn.context.platform = compos.platform || "web";
                        if (compos.snapshot && compos.snapshot.snapshot) {
                            (0, _exportFuncs.ExportFuncs).ApplyBrickSnapshots(compos, compos.snapshot.snapshot);
                            snapshot_id = urlParams.snapshot_id;
                            slug = urlParams.slug;
                            urlParams = compos.ins.args || {};
                            if (snapshot_id) urlParams.snapshot_id = snapshot_id;
                            if (slug) urlParams.slug = slug;
                        }
                        self.rtcn.context.timezone_offset = new Date().getTimezoneOffset();
                        if (compos.snapshot && compos.snapshot.timezone_offset !== undefined) {
                            self.rtcn.context.timezone_offset = compos.snapshot.timezone_offset;
                            compos.system_options.timezone_offset = compos.snapshot.timezone_offset;
                        }
                        compos.ins.default = compos.ins.default || {};
                        (0, _cbutil.ObjectDeepMerge)(compos.ins.default, urlParams);
                        (0, _inlineStyleProcessor.setupInlineStyleProcessing)("inline-class");
                        self.rtcn.init_composition(compos, urlParams);
                        compos.ins.args = compos.ins.args || {};
                        home_slug = compos.ins.args.slug;
                        (0, _cbutil.ObjectDeepMerge)(compos.ins.args, urlParams);
                        if (home_slug) compos.ins.args.slug = home_slug;
                        slot = self.querySelector("div");
                        if (slot) slot.innerHTML = `<${compos.type} cid="${self.rtcn.cid}" name="${compos.name}"></${compos.type}>`;
                        if (window.localStorage.getItem("cb_locale")) compos.system_options.locale = window.localStorage.getItem("cb_locale");
                        return [
                            4,
                            self.rtcn.send_initialisation_events(null)
                        ];
                    case 1:
                        _state.sent();
                        console.log(`Total Processing time: ${window.totalProcessNode}ms`);
                        console.log(`Total Inject Styles time: ${window.totalInjectStyles}ms`);
                        return [
                            2
                        ];
                }
            });
        })();
    }
    getUrlParams() {
        var urlParams = {};
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
        }, query = window.location.search.substring(1);
        while(match = search.exec(query))if (decode(match[1]) in urlParams) {
            if (!Array.isArray(urlParams[decode(match[1])])) urlParams[decode(match[1])] = [
                urlParams[decode(match[1])]
            ];
            urlParams[decode(match[1])].push(decode(match[2]));
        } else urlParams[decode(match[1])] = decode(match[2]);
        if (!urlParams.slug) {
            var s = window.location.pathname.split("/");
            var slug = s[s.length - 1];
            urlParams.slug = slug;
        }
        return urlParams;
    }
    disconnectedCallback() {}
    adoptedCallback() {}
    constructor(){
        super();
        this.composition_id = "_";
    }
}
customElements.define("cb-composition-reader", web_composition_reader);

},{"@swc/helpers/_/_async_to_generator":"f9EWQ","@swc/helpers/_/_ts_generator":"aYhQI","../codebricks-runtime/CBCompositionRunner":"lpTA2","sugar":"gcIJ7","../codebricks-runtime/CBUtil":"1DxvQ","../shared-funcs/ExportFuncs":"zlXWx","./controls/InlineStyleProcessor":"jVGPm","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"jVGPm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setupInlineStyleProcessing", ()=>setupInlineStyleProcessing);
class InlineStyleProcessor {
    processNode(element) {
        var rules = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        performance.mark("processStart");
        if (rules == null) {
            var inlineClass = element.getAttribute("inline-class");
            if (!inlineClass) return [];
            rules = this.parseInlineClass(inlineClass);
        }
        var addedClasses = this.rulesToStyles(rules);
        element.classList.add(...addedClasses);
        element.removeAttribute("inline-class");
        performance.mark("processEnd");
        performance.measure("processingTime", "processStart", "processEnd");
        var measure = performance.getEntriesByName("processingTime")[0];
        window.totalProcessNode += measure.duration;
        return addedClasses;
    }
    rulesToStyles() {
        var rules = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        if (!rules) return [];
        var addedClasses = [];
        rules.forEach((rule)=>{
            if (!rule.styles || rule.styles.indexOf(":") == -1) return;
            var ruleStr = `${rule.selector} {${rule.styles}}`;
            if (this.has_rules[ruleStr]) addedClasses.push(this.has_rules[ruleStr]);
            else {
                var className = `${this.rootId}-${this.classCounter}`;
                addedClasses.push(className);
                this.has_rules[ruleStr] = className;
                if (!this.styleElement) return;
                var styleSheet = this.styleElement.sheet;
                if (!styleSheet) return addedClasses;
                if (rule.selector.startsWith("sm")) this.insertRule(styleSheet, `.${className}${rule.selector.substring(2)} {${rule.styles}}`, "(min-width: 640px)", []);
                else if (rule.selector.startsWith("md")) this.insertRule(styleSheet, `.${className}${rule.selector.substring(2)} {${rule.styles}}`, "(min-width: 768px)", [
                    "640px"
                ]);
                else if (rule.selector.startsWith("lg")) this.insertRule(styleSheet, `.${className}${rule.selector.substring(2)} {${rule.styles}}`, "(min-width: 1024px)", [
                    "640px",
                    "768px"
                ]);
                else if (rule.selector.startsWith("xl")) this.insertRule(styleSheet, `.${className}${rule.selector.substring(2)} {${rule.styles}}`, "(min-width: 1280px)", [
                    "640px",
                    "768px",
                    "1024px"
                ]);
                else if (rule.selector.startsWith("2xl")) this.insertRule(styleSheet, `.${className}${rule.selector.substring(3)} {${rule.styles}}`, "(min-width: 1536px)", [
                    "640px",
                    "768px",
                    "1024px",
                    "1280px"
                ]);
                else this.insertRule(styleSheet, `.${className}${rule.selector} {${rule.styles}}`, "", []);
                this.classCounter++;
            }
        });
        return addedClasses;
    }
    insertRule(styleSheet, rule, insertInto, insertAfter) {
        for(var i = styleSheet.cssRules.length - 1; i >= 0; i--){
            var cssRule = styleSheet.cssRules[i];
            if (!cssRule.conditionText) {
                if (insertInto) styleSheet.insertRule(`@media ${insertInto} {${rule}}`, i + 1);
                else styleSheet.insertRule(rule, i + 1);
                return;
            }
            if (cssRule.conditionText == insertInto) {
                styleSheet.insertRule(`@media ${insertInto} {${rule}}`, i + 1);
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = insertAfter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var check = _step.value;
                    if (cssRule.conditionText.indexOf(check) != -1) {
                        if (insertInto) styleSheet.insertRule(`@media ${insertInto} {${rule}}`, i + 1);
                        else styleSheet.insertRule(rule, i + 1);
                        return;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (insertInto) styleSheet.insertRule(`@media ${insertInto} {${rule}}`);
        else styleSheet.insertRule(rule);
    }
    parseInlineClass(inlineClass) {
        var rules = [];
        var match;
        while((match = InlineStyleProcessor.ruleRegex.exec(inlineClass)) !== null)rules.push({
            selector: match[1].trim(),
            styles: match[2].trim()
        });
        return rules;
    }
    processContainer(container) {
        if (container) {
            var elements = container.querySelectorAll("[inline-class]");
            elements.forEach((element)=>{
                window.inlineClassProcessor.processNode(element);
            });
        }
        return container.innerHTML;
    }
    constructor(rootId){
        this.has_rules = {};
        this.queueId = 0;
        this.classCounter = 1;
        this.styleElement = null;
        this.rootId = rootId;
        if (!this.styleElement) {
            this.styleElement = document.createElement("style");
            this.styleElement.id = "inline-classes";
            document.head.appendChild(this.styleElement);
        }
    }
}
InlineStyleProcessor.ruleRegex = /\((.*?)\{(.*?)\}\)/g;
function setupInlineStyleProcessing(rootId) {
    window.inlineClassProcessor = new InlineStyleProcessor(rootId);
    window.totalProcessNode = 0;
    window.totalInjectStyles = 0;
    var processExisting = ()=>{
        performance.mark("processStart");
        var elements = document.querySelectorAll("[inline-class]");
        elements.forEach((element)=>{
            window.inlineClassProcessor.processNode(element);
        });
        performance.mark("processEnd");
        performance.measure("processingTime", "processStart", "processEnd");
        var measure = performance.getEntriesByName("processingTime")[0];
        console.log(`Processing time: ${measure.duration}ms`);
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", processExisting);
    else processExisting();
    return {
        inlineClassProcessor: window.inlineClassProcessor
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}],"hLQKi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "web_composition_loader", ()=>web_composition_loader);
var _cbcompositionRunner = require("../codebricks-runtime/CBCompositionRunner");
var _cbutil = require("../codebricks-runtime/CBUtil");
var _exportFuncs = require("../shared-funcs/ExportFuncs");
class web_composition_loader extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `<div></div>`;
        var composition = this.getAttribute("composition");
        if (composition == "null") return;
        var self = this;
        var urlParams = this.getUrlParams();
        if (composition) fetch("/cb_api/cb/composition/" + composition, {
            mode: "cors",
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function(response) {
            if (response.status !== 200) {
                console.log("Error fetching composition json. Status Code: " + response.status);
                return;
            }
            response.json().then(function(compos) {
                var context = globalThis.codebricks_context;
                if (context) delete context.compositions[self.composition_id];
                self.rtcn = new (0, _cbcompositionRunner.CBCompositionRunner)(composition, globalThis.codebricks_context, undefined);
                self.rtcn.context.platform = compos.platform || "web";
                if (compos.snapshot && compos.snapshot.snapshot) (0, _exportFuncs.ExportFuncs).ApplyBrickSnapshots(compos, compos.snapshot.snapshot);
                self.rtcn.context.timezone_offset = new Date().getTimezoneOffset();
                if (compos.snapshot && compos.snapshot.timezone_offset !== undefined) self.rtcn.context.timezone_offset = compos.snapshot.timezone_offset;
                compos.ins = compos.ins || {};
                if (compos.snapshot && compos.snapshot.snapshot) (0, _exportFuncs.ExportFuncs).ApplyBrickSnapshots(compos, compos.snapshot.snapshot);
                self.rtcn.init_composition(compos, urlParams);
                compos.ins = compos.ins || {};
                compos.ins.args = compos.ins.args || {};
                var home_slug = compos.ins.args.slug;
                (0, _cbutil.ObjectDeepMerge)(compos.ins.args, urlParams);
                if (home_slug) compos.ins.args.slug = home_slug;
                var slot = self.querySelector("div");
                if (slot) slot.innerHTML = `<${compos.type} cid="${self.rtcn.cid}" name="${compos.name}"></${compos.type}>`;
                if (window.localStorage.getItem("cb_locale")) compos.system_options.locale = window.localStorage.getItem("cb_locale");
                self.rtcn.send_initialisation_events(null);
            });
        }).catch(function(err) {
            console.log("Fetch Error :-S", err);
        });
    }
    getUrlParams() {
        var urlParams = {};
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
        }, query = window.location.search.substring(1);
        while(match = search.exec(query))if (decode(match[1]) in urlParams) {
            if (!Array.isArray(urlParams[decode(match[1])])) urlParams[decode(match[1])] = [
                urlParams[decode(match[1])]
            ];
            urlParams[decode(match[1])].push(decode(match[2]));
        } else urlParams[decode(match[1])] = decode(match[2]);
        if (!urlParams.slug) {
            var s = window.location.pathname.split("/");
            var slug = s[s.length - 1];
            urlParams.slug = slug;
        }
        return urlParams;
    }
    disconnectedCallback() {}
    adoptedCallback() {}
    constructor(){
        super();
        this.composition_id = "_";
    }
}
customElements.define("cb-composition-loader", web_composition_loader);

},{"../codebricks-runtime/CBCompositionRunner":"lpTA2","../codebricks-runtime/CBUtil":"1DxvQ","../shared-funcs/ExportFuncs":"zlXWx","@parcel/transformer-js/src/esmodule-helpers.js":"lGPoz"}]},["5JUbL"], "5JUbL", "parcelRequire94c2")

//# sourceMappingURL=composition.d58dd0b7.js.map
